(function() {
    "use strict";
    var __webpack_modules__ = {
        351: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, l1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AssistiveMmlHandler = e1.AssistiveMmlMathDocumentMixin = e1.AssistiveMmlMathItemMixin = e1.LimitedMmlVisitor = void 0;
            var c1 = r1(4474), u1 = r1(9259), p1 = r1(7233), h1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.getAttributes = function(e1) {
                    return t1.prototype.getAttributes.call(this, e1).replace(/ ?id=".*?"/, "");
                }, e1;
            }(u1.SerializedMmlVisitor);
            function f1(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return o1(e1, t1), e1.prototype.assistiveMml = function(t1, e1) {
                        if (void 0 === e1 && (e1 = !1), !(this.state() >= c1.STATE.ASSISTIVEMML)) {
                            if (!this.isEscaped && (t1.options.enableAssistiveMml || e1)) {
                                var r1 = t1.adaptor, n1 = t1.toMML(this.root).replace(/\n */g, "").replace(/<!--.*?-->/g, ""), o1 = r1.firstChild(r1.body(r1.parse(n1, "text/html"))), i1 = r1.node("mjx-assistive-mml", {
                                    unselectable: "on",
                                    display: this.display ? "block" : "inline"
                                }, [
                                    o1
                                ]);
                                r1.setAttribute(r1.firstChild(this.typesetRoot), "aria-hidden", "true"), r1.setStyle(this.typesetRoot, "position", "relative"), r1.append(this.typesetRoot, i1);
                            }
                            this.state(c1.STATE.ASSISTIVEMML);
                        }
                    }, e1;
                }(t1);
            }
            function d1(t1) {
                var e1;
                return e1 = function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, a1([], s1(e1), !1)) || this, o1 = n1.constructor, i1 = o1.ProcessBits;
                        return i1.has("assistive-mml") || i1.allocate("assistive-mml"), n1.visitor = new h1(n1.mmlFactory), n1.options.MathItem = f1(n1.options.MathItem), "addStyles" in n1 && n1.addStyles(o1.assistiveStyles), n1;
                    }
                    return o1(e1, t1), e1.prototype.toMML = function(t1) {
                        return this.visitor.visitTree(t1);
                    }, e1.prototype.assistiveMml = function() {
                        var t1, e1;
                        if (!this.processed.isSet("assistive-mml")) {
                            try {
                                for(var r1 = l1(this.math), n1 = r1.next(); !n1.done; n1 = r1.next())n1.value.assistiveMml(this);
                            } catch (e1) {
                                t1 = {
                                    error: e1
                                };
                            } finally{
                                try {
                                    n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                                } finally{
                                    if (t1) throw t1.error;
                                }
                            }
                            this.processed.set("assistive-mml");
                        }
                        return this;
                    }, e1.prototype.state = function(e1, r1) {
                        return void 0 === r1 && (r1 = !1), t1.prototype.state.call(this, e1, r1), e1 < c1.STATE.ASSISTIVEMML && this.processed.clear("assistive-mml"), this;
                    }, e1;
                }(t1), e1.OPTIONS = i1(i1({}, t1.OPTIONS), {
                    enableAssistiveMml: !0,
                    renderActions: (0, p1.expandable)(i1(i1({}, t1.OPTIONS.renderActions), {
                        assistiveMml: [
                            c1.STATE.ASSISTIVEMML
                        ]
                    }))
                }), e1.assistiveStyles = {
                    "mjx-assistive-mml": {
                        position: "absolute !important",
                        top: "0px",
                        left: "0px",
                        clip: "rect(1px, 1px, 1px, 1px)",
                        padding: "1px 0px 0px 0px !important",
                        border: "0px !important",
                        display: "block !important",
                        width: "auto !important",
                        overflow: "hidden !important",
                        "-webkit-touch-callout": "none",
                        "-webkit-user-select": "none",
                        "-khtml-user-select": "none",
                        "-moz-user-select": "none",
                        "-ms-user-select": "none",
                        "user-select": "none"
                    },
                    'mjx-assistive-mml[display="block"]': {
                        width: "100% !important"
                    }
                }, e1;
            }
            e1.LimitedMmlVisitor = h1, (0, c1.newState)("ASSISTIVEMML", 153), e1.AssistiveMmlMathItemMixin = f1, e1.AssistiveMmlMathDocumentMixin = d1, e1.AssistiveMmlHandler = function(t1) {
                return t1.documentClass = d1(t1.documentClass), t1;
            };
        },
        5282: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var r1 = new Map;
            e1.default = r1;
        },
        5445: function(t1, e1, r1) {
            var n1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), o1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), i1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && n1(e1, t1, r1);
                return o1(e1, t1), e1;
            }, s1 = this && this.__awaiter || function(t1, e1, r1, n1) {
                return new (r1 || (r1 = Promise))(function(o1, i1) {
                    function s1(t1) {
                        try {
                            l1(n1.next(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function a1(t1) {
                        try {
                            l1(n1.throw(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function l1(t1) {
                        var e1;
                        t1.done ? o1(t1.value) : (e1 = t1.value, e1 instanceof r1 ? e1 : new r1(function(t1) {
                            t1(e1);
                        })).then(s1, a1);
                    }
                    l1((n1 = n1.apply(t1, e1 || [])).next());
                });
            }, a1 = this && this.__generator || function(t1, e1) {
                var r1, n1, o1, i1, s1 = {
                    label: 0,
                    sent: function() {
                        if (1 & o1[0]) throw o1[1];
                        return o1[1];
                    },
                    trys: [],
                    ops: []
                };
                return i1 = {
                    next: a1(0),
                    throw: a1(1),
                    return: a1(2)
                }, "function" == typeof Symbol && (i1[Symbol.iterator] = function() {
                    return this;
                }), i1;
                function a1(i1) {
                    return function(a1) {
                        return function(i1) {
                            if (r1) throw new TypeError("Generator is already executing.");
                            for(; s1;)try {
                                if (r1 = 1, n1 && (o1 = 2 & i1[0] ? n1.return : i1[0] ? n1.throw || ((o1 = n1.return) && o1.call(n1), 0) : n1.next) && !(o1 = o1.call(n1, i1[1])).done) return o1;
                                switch(n1 = 0, o1 && (i1 = [
                                    2 & i1[0],
                                    o1.value
                                ]), i1[0]){
                                    case 0:
                                    case 1:
                                        o1 = i1;
                                        break;
                                    case 4:
                                        return s1.label++, {
                                            value: i1[1],
                                            done: !1
                                        };
                                    case 5:
                                        s1.label++, n1 = i1[1], i1 = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        i1 = s1.ops.pop(), s1.trys.pop();
                                        continue;
                                    default:
                                        if (!(o1 = s1.trys, (o1 = o1.length > 0 && o1[o1.length - 1]) || 6 !== i1[0] && 2 !== i1[0])) {
                                            s1 = 0;
                                            continue;
                                        }
                                        if (3 === i1[0] && (!o1 || i1[1] > o1[0] && i1[1] < o1[3])) {
                                            s1.label = i1[1];
                                            break;
                                        }
                                        if (6 === i1[0] && s1.label < o1[1]) {
                                            s1.label = o1[1], o1 = i1;
                                            break;
                                        }
                                        if (o1 && s1.label < o1[2]) {
                                            s1.label = o1[2], s1.ops.push(i1);
                                            break;
                                        }
                                        o1[2] && s1.ops.pop(), s1.trys.pop();
                                        continue;
                                }
                                i1 = e1.call(t1, s1);
                            } catch (t1) {
                                i1 = [
                                    6,
                                    t1
                                ], n1 = 0;
                            } finally{
                                r1 = o1 = 0;
                            }
                            if (5 & i1[0]) throw i1[1];
                            return {
                                value: i1[0] ? i1[1] : void 0,
                                done: !0
                            };
                        }([
                            i1,
                            a1
                        ]);
                    };
                }
            }, l1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sreReady = e1.Sre = void 0;
            var c1, u1 = i1(r1(2998)), p1 = i1(r1(3362)), h1 = i1(r1(9552)), f1 = i1(r1(4440)), d1 = l1(r1(5897)), m1 = r1(8504), y1 = i1(r1(3090)), g1 = r1(1377), b1 = l1(r1(5282));
            !function(t1) {
                t1.locales = g1.Variables.LOCALES, t1.sreReady = u1.engineReady, t1.setupEngine = u1.setupEngine, t1.engineSetup = u1.engineSetup, t1.toEnriched = u1.toEnriched, t1.toSpeech = u1.toSpeech, t1.clearspeakPreferences = m1.ClearspeakPreferences, t1.getHighlighter = y1.highlighter, t1.getSpeechGenerator = h1.generator, t1.getWalker = p1.walker, t1.clearspeakStyle = function() {
                    return f1.DOMAIN_TO_STYLES.clearspeak;
                }, t1.preloadLocales = function(t1) {
                    return s1(this, void 0, void 0, function() {
                        var e1;
                        return a1(this, function(r1) {
                            return [
                                2,
                                (e1 = b1.default.get(t1)) ? new Promise(function(t1, r1) {
                                    return t1(JSON.stringify(e1));
                                }) : u1.localeLoader()(t1)
                            ];
                        });
                    });
                };
            }(c1 = e1.Sre || (e1.Sre = {})), e1.sreReady = c1.sreReady, d1.default.getInstance().delay = !0, e1.default = c1;
        },
        444: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HTMLAdaptor = void 0;
            var s1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this, e1.document) || this;
                    return r1.window = e1, r1.parser = new e1.DOMParser, r1;
                }
                return o1(e1, t1), e1.prototype.parse = function(t1, e1) {
                    return void 0 === e1 && (e1 = "text/html"), this.parser.parseFromString(t1, e1);
                }, e1.prototype.create = function(t1, e1) {
                    return e1 ? this.document.createElementNS(e1, t1) : this.document.createElement(t1);
                }, e1.prototype.text = function(t1) {
                    return this.document.createTextNode(t1);
                }, e1.prototype.head = function(t1) {
                    return t1.head || t1;
                }, e1.prototype.body = function(t1) {
                    return t1.body || t1;
                }, e1.prototype.root = function(t1) {
                    return t1.documentElement || t1;
                }, e1.prototype.doctype = function(t1) {
                    return t1.doctype ? "<!DOCTYPE ".concat(t1.doctype.name, ">") : "";
                }, e1.prototype.tags = function(t1, e1, r1) {
                    void 0 === r1 && (r1 = null);
                    var n1 = r1 ? t1.getElementsByTagNameNS(r1, e1) : t1.getElementsByTagName(e1);
                    return Array.from(n1);
                }, e1.prototype.getElements = function(t1, e1) {
                    var r1, n1, o1 = [];
                    try {
                        for(var s1 = i1(t1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            "string" == typeof l1 ? o1 = o1.concat(Array.from(this.document.querySelectorAll(l1))) : Array.isArray(l1) || l1 instanceof this.window.NodeList || l1 instanceof this.window.HTMLCollection ? o1 = o1.concat(Array.from(l1)) : o1.push(l1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = s1.return) && n1.call(s1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return o1;
                }, e1.prototype.contains = function(t1, e1) {
                    return t1.contains(e1);
                }, e1.prototype.parent = function(t1) {
                    return t1.parentNode;
                }, e1.prototype.append = function(t1, e1) {
                    return t1.appendChild(e1);
                }, e1.prototype.insert = function(t1, e1) {
                    return this.parent(e1).insertBefore(t1, e1);
                }, e1.prototype.remove = function(t1) {
                    return this.parent(t1).removeChild(t1);
                }, e1.prototype.replace = function(t1, e1) {
                    return this.parent(e1).replaceChild(t1, e1);
                }, e1.prototype.clone = function(t1) {
                    return t1.cloneNode(!0);
                }, e1.prototype.split = function(t1, e1) {
                    return t1.splitText(e1);
                }, e1.prototype.next = function(t1) {
                    return t1.nextSibling;
                }, e1.prototype.previous = function(t1) {
                    return t1.previousSibling;
                }, e1.prototype.firstChild = function(t1) {
                    return t1.firstChild;
                }, e1.prototype.lastChild = function(t1) {
                    return t1.lastChild;
                }, e1.prototype.childNodes = function(t1) {
                    return Array.from(t1.childNodes);
                }, e1.prototype.childNode = function(t1, e1) {
                    return t1.childNodes[e1];
                }, e1.prototype.kind = function(t1) {
                    var e1 = t1.nodeType;
                    return 1 === e1 || 3 === e1 || 8 === e1 ? t1.nodeName.toLowerCase() : "";
                }, e1.prototype.value = function(t1) {
                    return t1.nodeValue || "";
                }, e1.prototype.textContent = function(t1) {
                    return t1.textContent;
                }, e1.prototype.innerHTML = function(t1) {
                    return t1.innerHTML;
                }, e1.prototype.outerHTML = function(t1) {
                    return t1.outerHTML;
                }, e1.prototype.serializeXML = function(t1) {
                    return (new this.window.XMLSerializer).serializeToString(t1);
                }, e1.prototype.setAttribute = function(t1, e1, r1, n1) {
                    return void 0 === n1 && (n1 = null), n1 ? (e1 = n1.replace(/.*\//, "") + ":" + e1.replace(/^.*:/, ""), t1.setAttributeNS(n1, e1, r1)) : t1.setAttribute(e1, r1);
                }, e1.prototype.getAttribute = function(t1, e1) {
                    return t1.getAttribute(e1);
                }, e1.prototype.removeAttribute = function(t1, e1) {
                    return t1.removeAttribute(e1);
                }, e1.prototype.hasAttribute = function(t1, e1) {
                    return t1.hasAttribute(e1);
                }, e1.prototype.allAttributes = function(t1) {
                    return Array.from(t1.attributes).map(function(t1) {
                        return {
                            name: t1.name,
                            value: t1.value
                        };
                    });
                }, e1.prototype.addClass = function(t1, e1) {
                    t1.classList ? t1.classList.add(e1) : t1.className = (t1.className + " " + e1).trim();
                }, e1.prototype.removeClass = function(t1, e1) {
                    t1.classList ? t1.classList.remove(e1) : t1.className = t1.className.split(/ /).filter(function(t1) {
                        return t1 !== e1;
                    }).join(" ");
                }, e1.prototype.hasClass = function(t1, e1) {
                    return t1.classList ? t1.classList.contains(e1) : t1.className.split(/ /).indexOf(e1) >= 0;
                }, e1.prototype.setStyle = function(t1, e1, r1) {
                    t1.style[e1] = r1;
                }, e1.prototype.getStyle = function(t1, e1) {
                    return t1.style[e1];
                }, e1.prototype.allStyles = function(t1) {
                    return t1.style.cssText;
                }, e1.prototype.insertRules = function(t1, e1) {
                    var r1, n1;
                    try {
                        for(var o1 = i1(e1.reverse()), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            try {
                                t1.sheet.insertRule(a1, 0);
                            } catch (t1) {
                                console.warn("MathJax: can't insert css rule '".concat(a1, "': ").concat(t1.message));
                            }
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, e1.prototype.fontSize = function(t1) {
                    var e1 = this.window.getComputedStyle(t1);
                    return parseFloat(e1.fontSize);
                }, e1.prototype.fontFamily = function(t1) {
                    return this.window.getComputedStyle(t1).fontFamily || "";
                }, e1.prototype.nodeSize = function(t1, e1, r1) {
                    if (void 0 === e1 && (e1 = 1), void 0 === r1 && (r1 = !1), r1 && t1.getBBox) {
                        var n1 = t1.getBBox();
                        return [
                            n1.width / e1,
                            n1.height / e1
                        ];
                    }
                    return [
                        t1.offsetWidth / e1,
                        t1.offsetHeight / e1
                    ];
                }, e1.prototype.nodeBBox = function(t1) {
                    var e1 = t1.getBoundingClientRect();
                    return {
                        left: e1.left,
                        right: e1.right,
                        top: e1.top,
                        bottom: e1.bottom
                    };
                }, e1;
            }(r1(5009).AbstractDOMAdaptor);
            e1.HTMLAdaptor = s1;
        },
        6191: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.browserAdaptor = void 0;
            var n1 = r1(444);
            e1.browserAdaptor = function() {
                return new n1.HTMLAdaptor(window);
            };
        },
        9515: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MathJax = e1.combineWithMathJax = e1.combineDefaults = e1.combineConfig = e1.isObject = void 0;
            var o1 = r1(3282);
            function i1(t1) {
                return "object" == typeof t1 && null !== t1;
            }
            function s1(t1, e1) {
                var r1, o1;
                try {
                    for(var a1 = n1(Object.keys(e1)), l1 = a1.next(); !l1.done; l1 = a1.next()){
                        var c1 = l1.value;
                        "__esModule" !== c1 && (!i1(t1[c1]) || !i1(e1[c1]) || e1[c1] instanceof Promise ? null !== e1[c1] && void 0 !== e1[c1] && (t1[c1] = e1[c1]) : s1(t1[c1], e1[c1]));
                    }
                } catch (t1) {
                    r1 = {
                        error: t1
                    };
                } finally{
                    try {
                        l1 && !l1.done && (o1 = a1.return) && o1.call(a1);
                    } finally{
                        if (r1) throw r1.error;
                    }
                }
                return t1;
            }
            e1.isObject = i1, e1.combineConfig = s1, e1.combineDefaults = function t1(e1, r1, o1) {
                var s1, a1;
                e1[r1] || (e1[r1] = {}), e1 = e1[r1];
                try {
                    for(var l1 = n1(Object.keys(o1)), c1 = l1.next(); !c1.done; c1 = l1.next()){
                        var u1 = c1.value;
                        i1(e1[u1]) && i1(o1[u1]) ? t1(e1, u1, o1[u1]) : null == e1[u1] && null != o1[u1] && (e1[u1] = o1[u1]);
                    }
                } catch (t1) {
                    s1 = {
                        error: t1
                    };
                } finally{
                    try {
                        c1 && !c1.done && (a1 = l1.return) && a1.call(l1);
                    } finally{
                        if (s1) throw s1.error;
                    }
                }
                return e1;
            }, e1.combineWithMathJax = function(t1) {
                return s1(e1.MathJax, t1);
            }, void 0 === r1.g.MathJax && (r1.g.MathJax = {}), r1.g.MathJax.version || (r1.g.MathJax = {
                version: o1.VERSION,
                _: {},
                config: r1.g.MathJax
            }), e1.MathJax = r1.g.MathJax;
        },
        235: function(t1, e1, r1) {
            var n1, o1, i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CONFIG = e1.MathJax = e1.Loader = e1.PathFilters = e1.PackageError = e1.Package = void 0;
            var s1 = r1(9515), a1 = r1(265), l1 = r1(265);
            Object.defineProperty(e1, "Package", {
                enumerable: !0,
                get: function() {
                    return l1.Package;
                }
            }), Object.defineProperty(e1, "PackageError", {
                enumerable: !0,
                get: function() {
                    return l1.PackageError;
                }
            });
            var c1, u1 = r1(7525);
            if (e1.PathFilters = {
                source: function(t1) {
                    return e1.CONFIG.source.hasOwnProperty(t1.name) && (t1.name = e1.CONFIG.source[t1.name]), !0;
                },
                normalize: function(t1) {
                    var e1 = t1.name;
                    return e1.match(/^(?:[a-z]+:\/)?\/|[a-z]:\\|\[/i) || (t1.name = "[mathjax]/" + e1.replace(/^\.\//, "")), t1.addExtension && !e1.match(/\.[^\/]+$/) && (t1.name += ".js"), !0;
                },
                prefix: function(t1) {
                    for(var r1; (r1 = t1.name.match(/^\[([^\]]*)\]/)) && e1.CONFIG.paths.hasOwnProperty(r1[1]);)t1.name = e1.CONFIG.paths[r1[1]] + t1.name.substr(r1[0].length);
                    return !0;
                }
            }, function(t1) {
                var r1 = s1.MathJax.version;
                t1.versions = new Map, t1.ready = function() {
                    for(var t1, e1, r1 = [], n1 = 0; n1 < arguments.length; n1++)r1[n1] = arguments[n1];
                    0 === r1.length && (r1 = Array.from(a1.Package.packages.keys()));
                    var o1 = [];
                    try {
                        for(var s1 = i1(r1), l1 = s1.next(); !l1.done; l1 = s1.next()){
                            var c1 = l1.value, u1 = a1.Package.packages.get(c1) || new a1.Package(c1, !0);
                            o1.push(u1.promise);
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (e1 = s1.return) && e1.call(s1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return Promise.all(o1);
                }, t1.load = function() {
                    for(var r1, n1, o1 = [], s1 = 0; s1 < arguments.length; s1++)o1[s1] = arguments[s1];
                    if (0 === o1.length) return Promise.resolve();
                    var l1 = [], c1 = function(r1) {
                        var n1 = a1.Package.packages.get(r1);
                        n1 || (n1 = new a1.Package(r1)).provides(e1.CONFIG.provides[r1]), n1.checkNoLoad(), l1.push(n1.promise.then(function() {
                            e1.CONFIG.versionWarnings && n1.isLoaded && !t1.versions.has(a1.Package.resolvePath(r1)) && console.warn("No version information available for component ".concat(r1));
                        }));
                    };
                    try {
                        for(var u1 = i1(o1), p1 = u1.next(); !p1.done; p1 = u1.next()){
                            var h1 = p1.value;
                            c1(h1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (n1 = u1.return) && n1.call(u1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return a1.Package.loadAll(), Promise.all(l1);
                }, t1.preLoad = function() {
                    for(var t1, r1, n1 = [], o1 = 0; o1 < arguments.length; o1++)n1[o1] = arguments[o1];
                    try {
                        for(var s1 = i1(n1), l1 = s1.next(); !l1.done; l1 = s1.next()){
                            var c1 = l1.value, u1 = a1.Package.packages.get(c1);
                            u1 || (u1 = new a1.Package(c1, !0)).provides(e1.CONFIG.provides[c1]), u1.loaded();
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (r1 = s1.return) && r1.call(s1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, t1.defaultReady = function() {
                    void 0 !== e1.MathJax.startup && e1.MathJax.config.startup.ready();
                }, t1.getRoot = function() {
                    var t1 = "//../../es5";
                    if ("undefined" != typeof document) {
                        var e1 = document.currentScript || document.getElementById("MathJax-script");
                        e1 && (t1 = e1.src.replace(/\/[^\/]*$/, ""));
                    }
                    return t1;
                }, t1.checkVersion = function(n1, o1, i1) {
                    return t1.versions.set(a1.Package.resolvePath(n1), r1), !(!e1.CONFIG.versionWarnings || o1 === r1) && (console.warn("Component ".concat(n1, " uses ").concat(o1, " of MathJax; version in use is ").concat(r1)), !0);
                }, t1.pathFilters = new u1.FunctionList, t1.pathFilters.add(e1.PathFilters.source, 0), t1.pathFilters.add(e1.PathFilters.normalize, 10), t1.pathFilters.add(e1.PathFilters.prefix, 20);
            }(c1 = e1.Loader || (e1.Loader = {})), e1.MathJax = s1.MathJax, void 0 === e1.MathJax.loader) {
                (0, s1.combineDefaults)(e1.MathJax.config, "loader", {
                    paths: {
                        mathjax: c1.getRoot()
                    },
                    source: {},
                    dependencies: {},
                    provides: {},
                    load: [],
                    ready: c1.defaultReady.bind(c1),
                    failed: function(t1) {
                        return console.log("MathJax(".concat(t1.package || "?", "): ").concat(t1.message));
                    },
                    require: null,
                    pathFilters: [],
                    versionWarnings: !0
                }), (0, s1.combineWithMathJax)({
                    loader: c1
                });
                try {
                    for(var p1 = i1(e1.MathJax.config.loader.pathFilters), h1 = p1.next(); !h1.done; h1 = p1.next()){
                        var f1 = h1.value;
                        Array.isArray(f1) ? c1.pathFilters.add(f1[0], f1[1]) : c1.pathFilters.add(f1);
                    }
                } catch (t1) {
                    n1 = {
                        error: t1
                    };
                } finally{
                    try {
                        h1 && !h1.done && (o1 = p1.return) && o1.call(p1);
                    } finally{
                        if (n1) throw n1.error;
                    }
                }
            }
            e1.CONFIG = e1.MathJax.config.loader;
        },
        265: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Package = e1.PackageError = void 0;
            var l1 = r1(235), c1 = function(t1) {
                function e1(e1, r1) {
                    var n1 = t1.call(this, e1) || this;
                    return n1.package = r1, n1;
                }
                return o1(e1, t1), e1;
            }(Error);
            e1.PackageError = c1;
            var u1 = function() {
                function t1(e1, r1) {
                    void 0 === r1 && (r1 = !1), this.isLoaded = !1, this.isLoading = !1, this.hasFailed = !1, this.dependents = [], this.dependencies = [], this.dependencyCount = 0, this.provided = [], this.name = e1, this.noLoad = r1, t1.packages.set(e1, this), this.promise = this.makePromise(this.makeDependencies());
                }
                return Object.defineProperty(t1.prototype, "canLoad", {
                    get: function() {
                        return 0 === this.dependencyCount && !this.noLoad && !this.isLoading && !this.hasFailed;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.resolvePath = function(t1, e1) {
                    void 0 === e1 && (e1 = !0);
                    var r1 = {
                        name: t1,
                        original: t1,
                        addExtension: e1
                    };
                    return l1.Loader.pathFilters.execute(r1), r1.name;
                }, t1.loadAll = function() {
                    var t1, e1;
                    try {
                        for(var r1 = i1(this.packages.values()), n1 = r1.next(); !n1.done; n1 = r1.next()){
                            var o1 = n1.value;
                            o1.canLoad && o1.load();
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, t1.prototype.makeDependencies = function() {
                    var e1, r1, n1 = [], o1 = t1.packages, c1 = this.noLoad, u1 = this.name, p1 = [];
                    l1.CONFIG.dependencies.hasOwnProperty(u1) ? p1.push.apply(p1, a1([], s1(l1.CONFIG.dependencies[u1]), !1)) : "core" !== u1 && p1.push("core");
                    try {
                        for(var h1 = i1(p1), f1 = h1.next(); !f1.done; f1 = h1.next()){
                            var d1 = f1.value, m1 = o1.get(d1) || new t1(d1, c1);
                            this.dependencies.indexOf(m1) < 0 && (m1.addDependent(this, c1), this.dependencies.push(m1), m1.isLoaded || (this.dependencyCount++, n1.push(m1.promise)));
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            f1 && !f1.done && (r1 = h1.return) && r1.call(h1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return n1;
                }, t1.prototype.makePromise = function(t1) {
                    var e1 = this, r1 = new Promise(function(t1, r1) {
                        e1.resolve = t1, e1.reject = r1;
                    }), n1 = l1.CONFIG[this.name] || {};
                    return n1.ready && (r1 = r1.then(function(t1) {
                        return n1.ready(e1.name);
                    })), t1.length && (t1.push(r1), r1 = Promise.all(t1).then(function(t1) {
                        return t1.join(", ");
                    })), n1.failed && r1.catch(function(t1) {
                        return n1.failed(new c1(t1, e1.name));
                    }), r1;
                }, t1.prototype.load = function() {
                    if (!this.isLoaded && !this.isLoading && !this.noLoad) {
                        this.isLoading = !0;
                        var e1 = t1.resolvePath(this.name);
                        l1.CONFIG.require ? this.loadCustom(e1) : this.loadScript(e1);
                    }
                }, t1.prototype.loadCustom = function(t1) {
                    var e1 = this;
                    try {
                        var r1 = l1.CONFIG.require(t1);
                        r1 instanceof Promise ? r1.then(function() {
                            return e1.checkLoad();
                        }).catch(function(r1) {
                            return e1.failed("Can't load \"" + t1 + '"\n' + r1.message.trim());
                        }) : this.checkLoad();
                    } catch (t1) {
                        this.failed(t1.message);
                    }
                }, t1.prototype.loadScript = function(t1) {
                    var e1 = this, r1 = document.createElement("script");
                    r1.src = t1, r1.charset = "UTF-8", r1.onload = function(t1) {
                        return e1.checkLoad();
                    }, r1.onerror = function(r1) {
                        return e1.failed("Can't load \"" + t1 + '"');
                    }, document.head.appendChild(r1);
                }, t1.prototype.loaded = function() {
                    var t1, e1, r1, n1;
                    this.isLoaded = !0, this.isLoading = !1;
                    try {
                        for(var o1 = i1(this.dependents), s1 = o1.next(); !s1.done; s1 = o1.next())s1.value.requirementSatisfied();
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    try {
                        for(var a1 = i1(this.provided), l1 = a1.next(); !l1.done; l1 = a1.next())l1.value.loaded();
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (n1 = a1.return) && n1.call(a1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    this.resolve(this.name);
                }, t1.prototype.failed = function(t1) {
                    this.hasFailed = !0, this.isLoading = !1, this.reject(new c1(t1, this.name));
                }, t1.prototype.checkLoad = function() {
                    var t1 = this;
                    ((l1.CONFIG[this.name] || {}).checkReady || function() {
                        return Promise.resolve();
                    })().then(function() {
                        return t1.loaded();
                    }).catch(function(e1) {
                        return t1.failed(e1);
                    });
                }, t1.prototype.requirementSatisfied = function() {
                    this.dependencyCount && (this.dependencyCount--, this.canLoad && this.load());
                }, t1.prototype.provides = function(e1) {
                    var r1, n1;
                    void 0 === e1 && (e1 = []);
                    try {
                        for(var o1 = i1(e1), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value, c1 = t1.packages.get(a1);
                            c1 || (l1.CONFIG.dependencies[a1] || (l1.CONFIG.dependencies[a1] = []), l1.CONFIG.dependencies[a1].push(a1), (c1 = new t1(a1, !0)).isLoading = !0), this.provided.push(c1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, t1.prototype.addDependent = function(t1, e1) {
                    this.dependents.push(t1), e1 || this.checkNoLoad();
                }, t1.prototype.checkNoLoad = function() {
                    var t1, e1;
                    if (this.noLoad) {
                        this.noLoad = !1;
                        try {
                            for(var r1 = i1(this.dependencies), n1 = r1.next(); !n1.done; n1 = r1.next())n1.value.checkNoLoad();
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }
                }, t1.packages = new Map, t1;
            }();
            e1.Package = u1;
        },
        2388: function(t1, e1, r1) {
            var n1 = this && this.__assign || function() {
                return n1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, n1.apply(this, arguments);
            }, o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CONFIG = e1.MathJax = e1.Startup = void 0;
            var a1, l1 = r1(9515), c1 = r1(8666), u1 = r1(7233);
            !function(t1) {
                var a1, l1, u1 = new c1.PrioritizedList;
                function h1(e1) {
                    return a1.visitTree(e1, t1.document);
                }
                function f1() {
                    a1 = new e1.MathJax._.core.MmlTree.SerializedMmlVisitor.SerializedMmlVisitor, l1 = e1.MathJax._.mathjax.mathjax, t1.input = v1(), t1.output = _1(), t1.adaptor = S1(), t1.handler && l1.handlers.unregister(t1.handler), t1.handler = O1(), t1.handler && (l1.handlers.register(t1.handler), t1.document = M1());
                }
                function d1() {
                    var e1, r1;
                    t1.input && t1.output && m1();
                    var n1 = t1.output ? t1.output.name.toLowerCase() : "";
                    try {
                        for(var i1 = o1(t1.input), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value, l1 = a1.name.toLowerCase();
                            g1(l1, a1), b1(l1, a1), t1.output && y1(l1, n1, a1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }
                function m1() {
                    e1.MathJax.typeset = function(e1) {
                        void 0 === e1 && (e1 = null), t1.document.options.elements = e1, t1.document.reset(), t1.document.render();
                    }, e1.MathJax.typesetPromise = function(e1) {
                        return void 0 === e1 && (e1 = null), t1.document.options.elements = e1, t1.document.reset(), l1.handleRetriesFor(function() {
                            t1.document.render();
                        });
                    }, e1.MathJax.typesetClear = function(e1) {
                        void 0 === e1 && (e1 = null), e1 ? t1.document.clearMathItemsWithin(e1) : t1.document.clear();
                    };
                }
                function y1(r1, n1, o1) {
                    var i1 = r1 + "2" + n1;
                    e1.MathJax[i1] = function(e1, r1) {
                        return void 0 === r1 && (r1 = {}), r1.format = o1.name, t1.document.convert(e1, r1);
                    }, e1.MathJax[i1 + "Promise"] = function(e1, r1) {
                        return void 0 === r1 && (r1 = {}), r1.format = o1.name, l1.handleRetriesFor(function() {
                            return t1.document.convert(e1, r1);
                        });
                    }, e1.MathJax[n1 + "Stylesheet"] = function() {
                        return t1.output.styleSheet(t1.document);
                    }, "getMetricsFor" in t1.output && (e1.MathJax.getMetricsFor = function(e1, r1) {
                        return t1.output.getMetricsFor(e1, r1);
                    });
                }
                function g1(r1, n1) {
                    var o1 = e1.MathJax._.core.MathItem.STATE;
                    e1.MathJax[r1 + "2mml"] = function(e1, r1) {
                        return void 0 === r1 && (r1 = {}), r1.end = o1.CONVERT, r1.format = n1.name, h1(t1.document.convert(e1, r1));
                    }, e1.MathJax[r1 + "2mmlPromise"] = function(e1, r1) {
                        return void 0 === r1 && (r1 = {}), r1.end = o1.CONVERT, r1.format = n1.name, l1.handleRetriesFor(function() {
                            return h1(t1.document.convert(e1, r1));
                        });
                    };
                }
                function b1(t1, r1) {
                    e1.MathJax[t1 + "Reset"] = function() {
                        for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1[e1] = arguments[e1];
                        return r1.reset.apply(r1, s1([], i1(t1), !1));
                    };
                }
                function v1() {
                    var r1, n1, i1 = [];
                    try {
                        for(var s1 = o1(e1.CONFIG.input), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value, c1 = t1.constructors[l1];
                            if (!c1) throw Error('Input Jax "' + l1 + '" is not defined (has it been loaded?)');
                            i1.push(new c1(e1.MathJax.config[l1]));
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = s1.return) && n1.call(s1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return i1;
                }
                function _1() {
                    var r1 = e1.CONFIG.output;
                    if (!r1) return null;
                    var n1 = t1.constructors[r1];
                    if (!n1) throw Error('Output Jax "' + r1 + '" is not defined (has it been loaded?)');
                    return new n1(e1.MathJax.config[r1]);
                }
                function S1() {
                    var r1 = e1.CONFIG.adaptor;
                    if (!r1 || "none" === r1) return null;
                    var n1 = t1.constructors[r1];
                    if (!n1) throw Error('DOMAdaptor "' + r1 + '" is not defined (has it been loaded?)');
                    return n1(e1.MathJax.config[r1]);
                }
                function O1() {
                    var r1, n1, i1 = e1.CONFIG.handler;
                    if (!i1 || "none" === i1 || !t1.adaptor) return null;
                    var s1 = t1.constructors[i1];
                    if (!s1) throw Error('Handler "' + i1 + '" is not defined (has it been loaded?)');
                    var a1 = new s1(t1.adaptor, 5);
                    try {
                        for(var l1 = o1(u1), c1 = l1.next(); !c1.done; c1 = l1.next())a1 = c1.value.item(a1);
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (n1 = l1.return) && n1.call(l1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return a1;
                }
                function M1(r1) {
                    return void 0 === r1 && (r1 = null), l1.document(r1 || e1.CONFIG.document, n1(n1({}, e1.MathJax.config.options), {
                        InputJax: t1.input,
                        OutputJax: t1.output
                    }));
                }
                t1.constructors = {}, t1.input = [], t1.output = null, t1.handler = null, t1.adaptor = null, t1.elements = null, t1.document = null, t1.promise = new Promise(function(e1, r1) {
                    t1.promiseResolve = e1, t1.promiseReject = r1;
                }), t1.pagePromise = new Promise(function(t1, e1) {
                    var n1 = r1.g.document;
                    if (n1 && n1.readyState && "complete" !== n1.readyState && "interactive" !== n1.readyState) {
                        var o1 = function() {
                            return t1();
                        };
                        n1.defaultView.addEventListener("load", o1, !0), n1.defaultView.addEventListener("DOMContentLoaded", o1, !0);
                    } else t1();
                }), t1.toMML = h1, t1.registerConstructor = function(e1, r1) {
                    t1.constructors[e1] = r1;
                }, t1.useHandler = function(t1, r1) {
                    void 0 === r1 && (r1 = !1), e1.CONFIG.handler && !r1 || (e1.CONFIG.handler = t1);
                }, t1.useAdaptor = function(t1, r1) {
                    void 0 === r1 && (r1 = !1), e1.CONFIG.adaptor && !r1 || (e1.CONFIG.adaptor = t1);
                }, t1.useInput = function(t1, r1) {
                    void 0 === r1 && (r1 = !1), p1 && !r1 || e1.CONFIG.input.push(t1);
                }, t1.useOutput = function(t1, r1) {
                    void 0 === r1 && (r1 = !1), e1.CONFIG.output && !r1 || (e1.CONFIG.output = t1);
                }, t1.extendHandler = function(t1, e1) {
                    void 0 === e1 && (e1 = 10), u1.add(t1, e1);
                }, t1.defaultReady = function() {
                    f1(), d1(), t1.pagePromise.then(function() {
                        return e1.CONFIG.pageReady();
                    }).then(function() {
                        return t1.promiseResolve();
                    }).catch(function(e1) {
                        return t1.promiseReject(e1);
                    });
                }, t1.defaultPageReady = function() {
                    return e1.CONFIG.typeset && e1.MathJax.typesetPromise ? e1.MathJax.typesetPromise(e1.CONFIG.elements) : Promise.resolve();
                }, t1.getComponents = f1, t1.makeMethods = d1, t1.makeTypesetMethods = m1, t1.makeOutputMethods = y1, t1.makeMmlMethods = g1, t1.makeResetMethod = b1, t1.getInputJax = v1, t1.getOutputJax = _1, t1.getAdaptor = S1, t1.getHandler = O1, t1.getDocument = M1;
            }(a1 = e1.Startup || (e1.Startup = {})), e1.MathJax = l1.MathJax, void 0 === e1.MathJax._.startup && ((0, l1.combineDefaults)(e1.MathJax.config, "startup", {
                input: [],
                output: "",
                handler: null,
                adaptor: null,
                document: "undefined" == typeof document ? "" : document,
                elements: null,
                typeset: !0,
                ready: a1.defaultReady.bind(a1),
                pageReady: a1.defaultPageReady.bind(a1)
            }), (0, l1.combineWithMathJax)({
                startup: a1,
                options: {}
            }), e1.MathJax.config.startup.invalidOption && (u1.OPTIONS.invalidOption = e1.MathJax.config.startup.invalidOption), e1.MathJax.config.startup.optionError && (u1.OPTIONS.optionError = e1.MathJax.config.startup.optionError)), e1.CONFIG = e1.MathJax.config.startup;
            var p1 = 0 !== e1.CONFIG.input.length;
        },
        3282: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.VERSION = void 0, e1.VERSION = "3.2.2";
        },
        5009: function(t1, e1) {
            var r1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractDOMAdaptor = void 0;
            var n1 = function() {
                function t1(t1) {
                    void 0 === t1 && (t1 = null), this.document = t1;
                }
                return t1.prototype.node = function(t1, e1, n1, o1) {
                    var i1, s1;
                    void 0 === e1 && (e1 = {}), void 0 === n1 && (n1 = []);
                    var a1 = this.create(t1, o1);
                    this.setAttributes(a1, e1);
                    try {
                        for(var l1 = r1(n1), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value;
                            this.append(a1, u1);
                        }
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (s1 = l1.return) && s1.call(l1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                    return a1;
                }, t1.prototype.setAttributes = function(t1, e1) {
                    var n1, o1, i1, s1, a1, l1;
                    if (e1.style && "string" != typeof e1.style) try {
                        for(var c1 = r1(Object.keys(e1.style)), u1 = c1.next(); !u1.done; u1 = c1.next()){
                            var p1 = u1.value;
                            this.setStyle(t1, p1.replace(/-([a-z])/g, function(t1, e1) {
                                return e1.toUpperCase();
                            }), e1.style[p1]);
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (o1 = c1.return) && o1.call(c1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                    if (e1.properties) try {
                        for(var h1 = r1(Object.keys(e1.properties)), f1 = h1.next(); !f1.done; f1 = h1.next())t1[p1 = f1.value] = e1.properties[p1];
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            f1 && !f1.done && (s1 = h1.return) && s1.call(h1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                    try {
                        for(var d1 = r1(Object.keys(e1)), m1 = d1.next(); !m1.done; m1 = d1.next())"style" === (p1 = m1.value) && "string" != typeof e1.style || "properties" === p1 || this.setAttribute(t1, p1, e1[p1]);
                    } catch (t1) {
                        a1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            m1 && !m1.done && (l1 = d1.return) && l1.call(d1);
                        } finally{
                            if (a1) throw a1.error;
                        }
                    }
                }, t1.prototype.replace = function(t1, e1) {
                    return this.insert(t1, e1), this.remove(e1), e1;
                }, t1.prototype.childNode = function(t1, e1) {
                    return this.childNodes(t1)[e1];
                }, t1.prototype.allClasses = function(t1) {
                    var e1 = this.getAttribute(t1, "class");
                    return e1 ? e1.replace(/  +/g, " ").replace(/^ /, "").replace(/ $/, "").split(/ /) : [];
                }, t1;
            }();
            e1.AbstractDOMAdaptor = n1;
        },
        3494: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractFindMath = void 0;
            var n1 = r1(7233), o1 = function() {
                function t1(t1) {
                    var e1 = this.constructor;
                    this.options = (0, n1.userOptions)((0, n1.defaultOptions)({}, e1.OPTIONS), t1);
                }
                return t1.OPTIONS = {}, t1;
            }();
            e1.AbstractFindMath = o1;
        },
        3670: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractHandler = void 0;
            var i1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1;
            }(r1(5722).AbstractMathDocument), s1 = function() {
                function t1(t1, e1) {
                    void 0 === e1 && (e1 = 5), this.documentClass = i1, this.adaptor = t1, this.priority = e1;
                }
                return Object.defineProperty(t1.prototype, "name", {
                    get: function() {
                        return this.constructor.NAME;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.handlesDocument = function(t1) {
                    return !1;
                }, t1.prototype.create = function(t1, e1) {
                    return new this.documentClass(t1, this.adaptor, e1);
                }, t1.NAME = "generic", t1;
            }();
            e1.AbstractHandler = s1;
        },
        805: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HandlerList = void 0;
            var s1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.register = function(t1) {
                    return this.add(t1, t1.priority);
                }, e1.prototype.unregister = function(t1) {
                    this.remove(t1);
                }, e1.prototype.handlesDocument = function(t1) {
                    var e1, r1;
                    try {
                        for(var n1 = i1(this), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var s1 = o1.value.item;
                            if (s1.handlesDocument(t1)) return s1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    throw new Error("Can't find handler for document");
                }, e1.prototype.document = function(t1, e1) {
                    return void 0 === e1 && (e1 = null), this.handlesDocument(t1).create(t1, e1);
                }, e1;
            }(r1(8666).PrioritizedList);
            e1.HandlerList = s1;
        },
        9206: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractInputJax = void 0;
            var n1 = r1(7233), o1 = r1(7525), i1 = function() {
                function t1(t1) {
                    void 0 === t1 && (t1 = {}), this.adaptor = null, this.mmlFactory = null;
                    var e1 = this.constructor;
                    this.options = (0, n1.userOptions)((0, n1.defaultOptions)({}, e1.OPTIONS), t1), this.preFilters = new o1.FunctionList, this.postFilters = new o1.FunctionList;
                }
                return Object.defineProperty(t1.prototype, "name", {
                    get: function() {
                        return this.constructor.NAME;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.setAdaptor = function(t1) {
                    this.adaptor = t1;
                }, t1.prototype.setMmlFactory = function(t1) {
                    this.mmlFactory = t1;
                }, t1.prototype.initialize = function() {}, t1.prototype.reset = function() {
                    for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1[e1] = arguments[e1];
                }, Object.defineProperty(t1.prototype, "processStrings", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.findMath = function(t1, e1) {
                    return [];
                }, t1.prototype.executeFilters = function(t1, e1, r1, n1) {
                    var o1 = {
                        math: e1,
                        document: r1,
                        data: n1
                    };
                    return t1.execute(o1), o1.data;
                }, t1.NAME = "generic", t1.OPTIONS = {}, t1;
            }();
            e1.AbstractInputJax = i1;
        },
        5722: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractMathDocument = e1.resetAllOptions = e1.resetOptions = e1.RenderList = void 0;
            var l1 = r1(7233), c1 = r1(9206), u1 = r1(2975), p1 = r1(9e3), h1 = r1(4474), f1 = r1(3909), d1 = r1(6751), m1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.create = function(t1) {
                    var e1, r1, n1 = new this;
                    try {
                        for(var o1 = i1(Object.keys(t1)), a1 = o1.next(); !a1.done; a1 = o1.next()){
                            var l1 = a1.value, c1 = s1(this.action(l1, t1[l1]), 2), u1 = c1[0], p1 = c1[1];
                            p1 && n1.add(u1, p1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return n1;
                }, e1.action = function(t1, e1) {
                    var r1, n1, o1, i1, a1, l1, c1 = !0, u1 = e1[0];
                    if (1 === e1.length || "boolean" == typeof e1[1]) 2 === e1.length && (c1 = e1[1]), a1 = (r1 = s1(this.methodActions(t1), 2))[0], l1 = r1[1];
                    else if ("string" == typeof e1[1]) {
                        if ("string" == typeof e1[2]) {
                            4 === e1.length && (c1 = e1[3]);
                            var p1 = s1(e1.slice(1), 2), h1 = p1[0], f1 = p1[1];
                            a1 = (n1 = s1(this.methodActions(h1, f1), 2))[0], l1 = n1[1];
                        } else 3 === e1.length && (c1 = e1[2]), a1 = (o1 = s1(this.methodActions(e1[1]), 2))[0], l1 = o1[1];
                    } else 4 === e1.length && (c1 = e1[3]), a1 = (i1 = s1(e1.slice(1), 2))[0], l1 = i1[1];
                    return [
                        {
                            id: t1,
                            renderDoc: a1,
                            renderMath: l1,
                            convert: c1
                        },
                        u1
                    ];
                }, e1.methodActions = function(t1, e1) {
                    return void 0 === e1 && (e1 = t1), [
                        function(e1) {
                            return t1 && e1[t1](), !1;
                        },
                        function(t1, r1) {
                            return e1 && t1[e1](r1), !1;
                        }
                    ];
                }, e1.prototype.renderDoc = function(t1, e1) {
                    var r1, n1;
                    void 0 === e1 && (e1 = h1.STATE.UNPROCESSED);
                    try {
                        for(var o1 = i1(this.items), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            if (a1.priority >= e1 && a1.item.renderDoc(t1)) return;
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, e1.prototype.renderMath = function(t1, e1, r1) {
                    var n1, o1;
                    void 0 === r1 && (r1 = h1.STATE.UNPROCESSED);
                    try {
                        for(var s1 = i1(this.items), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            if (l1.priority >= r1 && l1.item.renderMath(t1, e1)) return;
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }, e1.prototype.renderConvert = function(t1, e1, r1) {
                    var n1, o1;
                    void 0 === r1 && (r1 = h1.STATE.LAST);
                    try {
                        for(var s1 = i1(this.items), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            if (l1.priority > r1) return;
                            if (l1.item.convert && l1.item.renderMath(t1, e1)) return;
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }, e1.prototype.findID = function(t1) {
                    var e1, r1;
                    try {
                        for(var n1 = i1(this.items), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var s1 = o1.value;
                            if (s1.item.id === t1) return s1.item;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return null;
                }, e1;
            }(r1(8666).PrioritizedList);
            e1.RenderList = m1, e1.resetOptions = {
                all: !1,
                processed: !1,
                inputJax: null,
                outputJax: null
            }, e1.resetAllOptions = {
                all: !0,
                processed: !0,
                inputJax: [],
                outputJax: []
            };
            var y1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.compile = function(t1) {
                    return null;
                }, e1;
            }(c1.AbstractInputJax), g1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.typeset = function(t1, e1) {
                    return void 0 === e1 && (e1 = null), null;
                }, e1.prototype.escaped = function(t1, e1) {
                    return null;
                }, e1;
            }(u1.AbstractOutputJax), b1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1;
            }(p1.AbstractMathList), v1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1;
            }(h1.AbstractMathItem), _1 = function() {
                function t1(e1, r1, n1) {
                    var o1 = this, i1 = this.constructor;
                    this.document = e1, this.options = (0, l1.userOptions)((0, l1.defaultOptions)({}, i1.OPTIONS), n1), this.math = new (this.options.MathList || b1), this.renderActions = m1.create(this.options.renderActions), this.processed = new t1.ProcessBits, this.outputJax = this.options.OutputJax || new g1;
                    var s1 = this.options.InputJax || [
                        new y1
                    ];
                    Array.isArray(s1) || (s1 = [
                        s1
                    ]), this.inputJax = s1, this.adaptor = r1, this.outputJax.setAdaptor(r1), this.inputJax.map(function(t1) {
                        return t1.setAdaptor(r1);
                    }), this.mmlFactory = this.options.MmlFactory || new f1.MmlFactory, this.inputJax.map(function(t1) {
                        return t1.setMmlFactory(o1.mmlFactory);
                    }), this.outputJax.initialize(), this.inputJax.map(function(t1) {
                        return t1.initialize();
                    });
                }
                return Object.defineProperty(t1.prototype, "kind", {
                    get: function() {
                        return this.constructor.KIND;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.addRenderAction = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    var n1 = s1(m1.action(t1, e1), 2), o1 = n1[0], i1 = n1[1];
                    this.renderActions.add(o1, i1);
                }, t1.prototype.removeRenderAction = function(t1) {
                    var e1 = this.renderActions.findID(t1);
                    e1 && this.renderActions.remove(e1);
                }, t1.prototype.render = function() {
                    return this.renderActions.renderDoc(this), this;
                }, t1.prototype.rerender = function(t1) {
                    return void 0 === t1 && (t1 = h1.STATE.RERENDER), this.state(t1 - 1), this.render(), this;
                }, t1.prototype.convert = function(t1, e1) {
                    void 0 === e1 && (e1 = {});
                    var r1 = (0, l1.userOptions)({
                        format: this.inputJax[0].name,
                        display: !0,
                        end: h1.STATE.LAST,
                        em: 16,
                        ex: 8,
                        containerWidth: null,
                        lineWidth: 1e6,
                        scale: 1,
                        family: ""
                    }, e1), n1 = r1.format, o1 = r1.display, i1 = r1.end, s1 = r1.ex, a1 = r1.em, c1 = r1.containerWidth, u1 = r1.lineWidth, p1 = r1.scale, f1 = r1.family;
                    null === c1 && (c1 = 80 * s1);
                    var d1 = this.inputJax.reduce(function(t1, e1) {
                        return e1.name === n1 ? e1 : t1;
                    }, null), m1 = new this.options.MathItem(t1, d1, o1);
                    return m1.start.node = this.adaptor.body(this.document), m1.setMetrics(a1, s1, c1, u1, p1), this.outputJax.options.mtextInheritFont && (m1.outputData.mtextFamily = f1), this.outputJax.options.merrorInheritFont && (m1.outputData.merrorFamily = f1), m1.convert(this, i1), m1.typesetRoot || m1.root;
                }, t1.prototype.findMath = function(t1) {
                    return void 0 === t1 && (t1 = null), this.processed.set("findMath"), this;
                }, t1.prototype.compile = function() {
                    var t1, e1, r1, n1;
                    if (!this.processed.isSet("compile")) {
                        var o1 = [];
                        try {
                            for(var s1 = i1(this.math), a1 = s1.next(); !a1.done; a1 = s1.next()){
                                var l1 = a1.value;
                                this.compileMath(l1), void 0 !== l1.inputData.recompile && o1.push(l1);
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (e1 = s1.return) && e1.call(s1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        try {
                            for(var c1 = i1(o1), u1 = c1.next(); !u1.done; u1 = c1.next()){
                                var p1 = (l1 = u1.value).inputData.recompile;
                                l1.state(p1.state), l1.inputData.recompile = p1, this.compileMath(l1);
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                u1 && !u1.done && (n1 = c1.return) && n1.call(c1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                        this.processed.set("compile");
                    }
                    return this;
                }, t1.prototype.compileMath = function(t1) {
                    try {
                        t1.compile(this);
                    } catch (e1) {
                        if (e1.retry || e1.restart) throw e1;
                        this.options.compileError(this, t1, e1), t1.inputData.error = e1;
                    }
                }, t1.prototype.compileError = function(t1, e1) {
                    t1.root = this.mmlFactory.create("math", null, [
                        this.mmlFactory.create("merror", {
                            "data-mjx-error": e1.message,
                            title: e1.message
                        }, [
                            this.mmlFactory.create("mtext", null, [
                                this.mmlFactory.create("text").setText("Math input error")
                            ])
                        ])
                    ]), t1.display && t1.root.attributes.set("display", "block"), t1.inputData.error = e1.message;
                }, t1.prototype.typeset = function() {
                    var t1, e1;
                    if (!this.processed.isSet("typeset")) {
                        try {
                            for(var r1 = i1(this.math), n1 = r1.next(); !n1.done; n1 = r1.next()){
                                var o1 = n1.value;
                                try {
                                    o1.typeset(this);
                                } catch (t1) {
                                    if (t1.retry || t1.restart) throw t1;
                                    this.options.typesetError(this, o1, t1), o1.outputData.error = t1;
                                }
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        this.processed.set("typeset");
                    }
                    return this;
                }, t1.prototype.typesetError = function(t1, e1) {
                    t1.typesetRoot = this.adaptor.node("mjx-container", {
                        class: "MathJax mjx-output-error",
                        jax: this.outputJax.name
                    }, [
                        this.adaptor.node("span", {
                            "data-mjx-error": e1.message,
                            title: e1.message,
                            style: {
                                color: "red",
                                "background-color": "yellow",
                                "line-height": "normal"
                            }
                        }, [
                            this.adaptor.text("Math output error")
                        ])
                    ]), t1.display && this.adaptor.setAttributes(t1.typesetRoot, {
                        style: {
                            display: "block",
                            margin: "1em 0",
                            "text-align": "center"
                        }
                    }), t1.outputData.error = e1.message;
                }, t1.prototype.getMetrics = function() {
                    return this.processed.isSet("getMetrics") || (this.outputJax.getMetrics(this), this.processed.set("getMetrics")), this;
                }, t1.prototype.updateDocument = function() {
                    var t1, e1;
                    if (!this.processed.isSet("updateDocument")) {
                        try {
                            for(var r1 = i1(this.math.reversed()), n1 = r1.next(); !n1.done; n1 = r1.next())n1.value.updateDocument(this);
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        this.processed.set("updateDocument");
                    }
                    return this;
                }, t1.prototype.removeFromDocument = function(t1) {
                    return void 0 === t1 && (t1 = !1), this;
                }, t1.prototype.state = function(t1, e1) {
                    var r1, n1;
                    void 0 === e1 && (e1 = !1);
                    try {
                        for(var o1 = i1(this.math), s1 = o1.next(); !s1.done; s1 = o1.next())s1.value.state(t1, e1);
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return t1 < h1.STATE.INSERTED && this.processed.clear("updateDocument"), t1 < h1.STATE.TYPESET && (this.processed.clear("typeset"), this.processed.clear("getMetrics")), t1 < h1.STATE.COMPILED && this.processed.clear("compile"), this;
                }, t1.prototype.reset = function(t1) {
                    var r1;
                    return void 0 === t1 && (t1 = {
                        processed: !0
                    }), (t1 = (0, l1.userOptions)(Object.assign({}, e1.resetOptions), t1)).all && Object.assign(t1, e1.resetAllOptions), t1.processed && this.processed.reset(), t1.inputJax && this.inputJax.forEach(function(e1) {
                        return e1.reset.apply(e1, a1([], s1(t1.inputJax), !1));
                    }), t1.outputJax && (r1 = this.outputJax).reset.apply(r1, a1([], s1(t1.outputJax), !1)), this;
                }, t1.prototype.clear = function() {
                    return this.reset(), this.math.clear(), this;
                }, t1.prototype.concat = function(t1) {
                    return this.math.merge(t1), this;
                }, t1.prototype.clearMathItemsWithin = function(t1) {
                    var e1, r1 = this.getMathItemsWithin(t1);
                    return (e1 = this.math).remove.apply(e1, a1([], s1(r1), !1)), r1;
                }, t1.prototype.getMathItemsWithin = function(t1) {
                    var e1, r1, n1, o1;
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    var s1 = this.adaptor, a1 = [], l1 = s1.getElements(t1, this.document);
                    try {
                        t: for(var c1 = i1(this.math), u1 = c1.next(); !u1.done; u1 = c1.next()){
                            var p1 = u1.value;
                            try {
                                for(var h1 = (n1 = void 0, i1(l1)), f1 = h1.next(); !f1.done; f1 = h1.next()){
                                    var d1 = f1.value;
                                    if (p1.start.node && s1.contains(d1, p1.start.node)) {
                                        a1.push(p1);
                                        continue t;
                                    }
                                }
                            } catch (t1) {
                                n1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    f1 && !f1.done && (o1 = h1.return) && o1.call(h1);
                                } finally{
                                    if (n1) throw n1.error;
                                }
                            }
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (r1 = c1.return) && r1.call(c1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return a1;
                }, t1.KIND = "MathDocument", t1.OPTIONS = {
                    OutputJax: null,
                    InputJax: null,
                    MmlFactory: null,
                    MathList: b1,
                    MathItem: v1,
                    compileError: function(t1, e1, r1) {
                        t1.compileError(e1, r1);
                    },
                    typesetError: function(t1, e1, r1) {
                        t1.typesetError(e1, r1);
                    },
                    renderActions: (0, l1.expandable)({
                        find: [
                            h1.STATE.FINDMATH,
                            "findMath",
                            "",
                            !1
                        ],
                        compile: [
                            h1.STATE.COMPILED
                        ],
                        metrics: [
                            h1.STATE.METRICS,
                            "getMetrics",
                            "",
                            !1
                        ],
                        typeset: [
                            h1.STATE.TYPESET
                        ],
                        update: [
                            h1.STATE.INSERTED,
                            "updateDocument",
                            !1
                        ]
                    })
                }, t1.ProcessBits = (0, d1.BitFieldClass)("findMath", "compile", "getMetrics", "typeset", "updateDocument"), t1;
            }();
            e1.AbstractMathDocument = _1;
        },
        4474: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.newState = e1.STATE = e1.AbstractMathItem = e1.protoItem = void 0, e1.protoItem = function(t1, e1, r1, n1, o1, i1, s1) {
                return void 0 === s1 && (s1 = null), {
                    open: t1,
                    math: e1,
                    close: r1,
                    n: n1,
                    start: {
                        n: o1
                    },
                    end: {
                        n: i1
                    },
                    display: s1
                };
            };
            var r1 = function() {
                function t1(t1, r1, n1, o1, i1) {
                    void 0 === n1 && (n1 = !0), void 0 === o1 && (o1 = {
                        i: 0,
                        n: 0,
                        delim: ""
                    }), void 0 === i1 && (i1 = {
                        i: 0,
                        n: 0,
                        delim: ""
                    }), this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {}, this._state = e1.STATE.UNPROCESSED, this.math = t1, this.inputJax = r1, this.display = n1, this.start = o1, this.end = i1, this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {};
                }
                return Object.defineProperty(t1.prototype, "isEscaped", {
                    get: function() {
                        return null === this.display;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.render = function(t1) {
                    t1.renderActions.renderMath(this, t1);
                }, t1.prototype.rerender = function(t1, r1) {
                    void 0 === r1 && (r1 = e1.STATE.RERENDER), this.state() >= r1 && this.state(r1 - 1), t1.renderActions.renderMath(this, t1, r1);
                }, t1.prototype.convert = function(t1, r1) {
                    void 0 === r1 && (r1 = e1.STATE.LAST), t1.renderActions.renderConvert(this, t1, r1);
                }, t1.prototype.compile = function(t1) {
                    this.state() < e1.STATE.COMPILED && (this.root = this.inputJax.compile(this, t1), this.state(e1.STATE.COMPILED));
                }, t1.prototype.typeset = function(t1) {
                    this.state() < e1.STATE.TYPESET && (this.typesetRoot = t1.outputJax[this.isEscaped ? "escaped" : "typeset"](this, t1), this.state(e1.STATE.TYPESET));
                }, t1.prototype.updateDocument = function(t1) {}, t1.prototype.removeFromDocument = function(t1) {
                    void 0 === t1 && (t1 = !1);
                }, t1.prototype.setMetrics = function(t1, e1, r1, n1, o1) {
                    this.metrics = {
                        em: t1,
                        ex: e1,
                        containerWidth: r1,
                        lineWidth: n1,
                        scale: o1
                    };
                }, t1.prototype.state = function(t1, r1) {
                    return void 0 === t1 && (t1 = null), void 0 === r1 && (r1 = !1), null != t1 && (t1 < e1.STATE.INSERTED && this._state >= e1.STATE.INSERTED && this.removeFromDocument(r1), t1 < e1.STATE.TYPESET && this._state >= e1.STATE.TYPESET && (this.outputData = {}), t1 < e1.STATE.COMPILED && this._state >= e1.STATE.COMPILED && (this.inputData = {}), this._state = t1), this._state;
                }, t1.prototype.reset = function(t1) {
                    void 0 === t1 && (t1 = !1), this.state(e1.STATE.UNPROCESSED, t1);
                }, t1;
            }();
            e1.AbstractMathItem = r1, e1.STATE = {
                UNPROCESSED: 0,
                FINDMATH: 10,
                COMPILED: 20,
                CONVERT: 100,
                METRICS: 110,
                RERENDER: 125,
                TYPESET: 150,
                INSERTED: 200,
                LAST: 1e4
            }, e1.newState = function(t1, r1) {
                if (t1 in e1.STATE) throw Error("State " + t1 + " already exists");
                e1.STATE[t1] = r1;
            };
        },
        9e3: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractMathList = void 0;
            var i1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.isBefore = function(t1, e1) {
                    return t1.start.i < e1.start.i || t1.start.i === e1.start.i && t1.start.n < e1.start.n;
                }, e1;
            }(r1(103).LinkedList);
            e1.AbstractMathList = i1;
        },
        91: function(t1, e1) {
            var r1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Attributes = e1.INHERIT = void 0, e1.INHERIT = "_inherit_";
            var n1 = function() {
                function t1(t1, e1) {
                    this.global = e1, this.defaults = Object.create(e1), this.inherited = Object.create(this.defaults), this.attributes = Object.create(this.inherited), Object.assign(this.defaults, t1);
                }
                return t1.prototype.set = function(t1, e1) {
                    this.attributes[t1] = e1;
                }, t1.prototype.setList = function(t1) {
                    Object.assign(this.attributes, t1);
                }, t1.prototype.get = function(t1) {
                    var r1 = this.attributes[t1];
                    return r1 === e1.INHERIT && (r1 = this.global[t1]), r1;
                }, t1.prototype.getExplicit = function(t1) {
                    if (this.attributes.hasOwnProperty(t1)) return this.attributes[t1];
                }, t1.prototype.getList = function() {
                    for(var t1, e1, n1 = [], o1 = 0; o1 < arguments.length; o1++)n1[o1] = arguments[o1];
                    var i1 = {};
                    try {
                        for(var s1 = r1(n1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            i1[l1] = this.get(l1);
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (e1 = s1.return) && e1.call(s1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return i1;
                }, t1.prototype.setInherited = function(t1, e1) {
                    this.inherited[t1] = e1;
                }, t1.prototype.getInherited = function(t1) {
                    return this.inherited[t1];
                }, t1.prototype.getDefault = function(t1) {
                    return this.defaults[t1];
                }, t1.prototype.isSet = function(t1) {
                    return this.attributes.hasOwnProperty(t1) || this.inherited.hasOwnProperty(t1);
                }, t1.prototype.hasDefault = function(t1) {
                    return t1 in this.defaults;
                }, t1.prototype.getExplicitNames = function() {
                    return Object.keys(this.attributes);
                }, t1.prototype.getInheritedNames = function() {
                    return Object.keys(this.inherited);
                }, t1.prototype.getDefaultNames = function() {
                    return Object.keys(this.defaults);
                }, t1.prototype.getGlobalNames = function() {
                    return Object.keys(this.global);
                }, t1.prototype.getAllAttributes = function() {
                    return this.attributes;
                }, t1.prototype.getAllInherited = function() {
                    return this.inherited;
                }, t1.prototype.getAllDefaults = function() {
                    return this.defaults;
                }, t1.prototype.getAllGlobals = function() {
                    return this.global;
                }, t1;
            }();
            e1.Attributes = n1;
        },
        6336: function(t1, e1, r1) {
            var n1;
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MML = void 0;
            var o1 = r1(9007), i1 = r1(3233), s1 = r1(450), a1 = r1(3050), l1 = r1(2756), c1 = r1(4770), u1 = r1(6030), p1 = r1(7265), h1 = r1(9878), f1 = r1(6850), d1 = r1(7131), m1 = r1(6145), y1 = r1(1314), g1 = r1(1581), b1 = r1(7238), v1 = r1(5741), _1 = r1(5410), S1 = r1(6661), O1 = r1(9145), M1 = r1(4461), x1 = r1(5184), E1 = r1(6405), A1 = r1(1349), C1 = r1(5022), T1 = r1(4359), N1 = r1(142), w1 = r1(7590), L1 = r1(3985), I1 = r1(9102), P1 = r1(3948), R1 = r1(1334);
            e1.MML = ((n1 = {})[i1.MmlMath.prototype.kind] = i1.MmlMath, n1[s1.MmlMi.prototype.kind] = s1.MmlMi, n1[a1.MmlMn.prototype.kind] = a1.MmlMn, n1[l1.MmlMo.prototype.kind] = l1.MmlMo, n1[c1.MmlMtext.prototype.kind] = c1.MmlMtext, n1[u1.MmlMspace.prototype.kind] = u1.MmlMspace, n1[p1.MmlMs.prototype.kind] = p1.MmlMs, n1[h1.MmlMrow.prototype.kind] = h1.MmlMrow, n1[h1.MmlInferredMrow.prototype.kind] = h1.MmlInferredMrow, n1[f1.MmlMfrac.prototype.kind] = f1.MmlMfrac, n1[d1.MmlMsqrt.prototype.kind] = d1.MmlMsqrt, n1[m1.MmlMroot.prototype.kind] = m1.MmlMroot, n1[y1.MmlMstyle.prototype.kind] = y1.MmlMstyle, n1[g1.MmlMerror.prototype.kind] = g1.MmlMerror, n1[b1.MmlMpadded.prototype.kind] = b1.MmlMpadded, n1[v1.MmlMphantom.prototype.kind] = v1.MmlMphantom, n1[_1.MmlMfenced.prototype.kind] = _1.MmlMfenced, n1[S1.MmlMenclose.prototype.kind] = S1.MmlMenclose, n1[O1.MmlMaction.prototype.kind] = O1.MmlMaction, n1[M1.MmlMsub.prototype.kind] = M1.MmlMsub, n1[M1.MmlMsup.prototype.kind] = M1.MmlMsup, n1[M1.MmlMsubsup.prototype.kind] = M1.MmlMsubsup, n1[x1.MmlMunder.prototype.kind] = x1.MmlMunder, n1[x1.MmlMover.prototype.kind] = x1.MmlMover, n1[x1.MmlMunderover.prototype.kind] = x1.MmlMunderover, n1[E1.MmlMmultiscripts.prototype.kind] = E1.MmlMmultiscripts, n1[E1.MmlMprescripts.prototype.kind] = E1.MmlMprescripts, n1[E1.MmlNone.prototype.kind] = E1.MmlNone, n1[A1.MmlMtable.prototype.kind] = A1.MmlMtable, n1[C1.MmlMlabeledtr.prototype.kind] = C1.MmlMlabeledtr, n1[C1.MmlMtr.prototype.kind] = C1.MmlMtr, n1[T1.MmlMtd.prototype.kind] = T1.MmlMtd, n1[N1.MmlMaligngroup.prototype.kind] = N1.MmlMaligngroup, n1[w1.MmlMalignmark.prototype.kind] = w1.MmlMalignmark, n1[L1.MmlMglyph.prototype.kind] = L1.MmlMglyph, n1[I1.MmlSemantics.prototype.kind] = I1.MmlSemantics, n1[I1.MmlAnnotation.prototype.kind] = I1.MmlAnnotation, n1[I1.MmlAnnotationXML.prototype.kind] = I1.MmlAnnotationXML, n1[P1.TeXAtom.prototype.kind] = P1.TeXAtom, n1[R1.MathChoice.prototype.kind] = R1.MathChoice, n1[o1.TextNode.prototype.kind] = o1.TextNode, n1[o1.XMLNode.prototype.kind] = o1.XMLNode, n1);
        },
        1759: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MathMLVisitor = void 0;
            var s1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.document = null, e1;
                }
                return o1(e1, t1), e1.prototype.visitTree = function(t1, e1) {
                    this.document = e1;
                    var r1 = e1.createElement("top");
                    return this.visitNode(t1, r1), this.document = null, r1.firstChild;
                }, e1.prototype.visitTextNode = function(t1, e1) {
                    e1.appendChild(this.document.createTextNode(t1.getText()));
                }, e1.prototype.visitXMLNode = function(t1, e1) {
                    e1.appendChild(t1.getXML().cloneNode(!0));
                }, e1.prototype.visitInferredMrowNode = function(t1, e1) {
                    var r1, n1;
                    try {
                        for(var o1 = i1(t1.childNodes), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            this.visitNode(a1, e1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, e1.prototype.visitDefault = function(t1, e1) {
                    var r1, n1, o1 = this.document.createElement(t1.kind);
                    this.addAttributes(t1, o1);
                    try {
                        for(var s1 = i1(t1.childNodes), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            this.visitNode(l1, o1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = s1.return) && n1.call(s1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    e1.appendChild(o1);
                }, e1.prototype.addAttributes = function(t1, e1) {
                    var r1, n1, o1 = t1.attributes, s1 = o1.getExplicitNames();
                    try {
                        for(var a1 = i1(s1), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value;
                            e1.setAttribute(c1, o1.getExplicit(c1).toString());
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (n1 = a1.return) && n1.call(a1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, e1;
            }(r1(6325).MmlVisitor);
            e1.MathMLVisitor = s1;
        },
        3909: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlFactory = void 0;
            var i1 = r1(7860), s1 = r1(6336), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "MML", {
                    get: function() {
                        return this.node;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaultNodes = s1.MML, e1;
            }(i1.AbstractNodeFactory);
            e1.MmlFactory = a1;
        },
        9007: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, a1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.XMLNode = e1.TextNode = e1.AbstractMmlEmptyNode = e1.AbstractMmlBaseNode = e1.AbstractMmlLayoutNode = e1.AbstractMmlTokenNode = e1.AbstractMmlNode = e1.indentAttributes = e1.TEXCLASSNAMES = e1.TEXCLASS = void 0;
            var l1 = r1(91), c1 = r1(4596);
            e1.TEXCLASS = {
                ORD: 0,
                OP: 1,
                BIN: 2,
                REL: 3,
                OPEN: 4,
                CLOSE: 5,
                PUNCT: 6,
                INNER: 7,
                VCENTER: 8,
                NONE: -1
            }, e1.TEXCLASSNAMES = [
                "ORD",
                "OP",
                "BIN",
                "REL",
                "OPEN",
                "CLOSE",
                "PUNCT",
                "INNER",
                "VCENTER"
            ];
            var u1 = [
                "",
                "thinmathspace",
                "mediummathspace",
                "thickmathspace"
            ], p1 = [
                [
                    0,
                    -1,
                    2,
                    3,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    -1,
                    -1,
                    0,
                    3,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    2,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2
                ],
                [
                    3,
                    3,
                    0,
                    0,
                    3,
                    0,
                    0,
                    3
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    -1,
                    2,
                    3,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    -1,
                    2,
                    3,
                    1,
                    0,
                    1,
                    1
                ]
            ];
            e1.indentAttributes = [
                "indentalign",
                "indentalignfirst",
                "indentshift",
                "indentshiftfirst"
            ];
            var h1 = function(t1) {
                function r1(e1, r1, n1) {
                    void 0 === r1 && (r1 = {}), void 0 === n1 && (n1 = []);
                    var o1 = t1.call(this, e1) || this;
                    return o1.prevClass = null, o1.prevLevel = null, o1.texclass = null, o1.arity < 0 && (o1.childNodes = [
                        e1.create("inferredMrow")
                    ], o1.childNodes[0].parent = o1), o1.setChildren(n1), o1.attributes = new l1.Attributes(e1.getNodeClass(o1.kind).defaults, e1.getNodeClass("math").defaults), o1.attributes.setList(r1), o1;
                }
                return o1(r1, t1), r1.prototype.copy = function(t1) {
                    var e1, r1, n1, o1;
                    void 0 === t1 && (t1 = !1);
                    var a1 = this.factory.create(this.kind);
                    if (a1.properties = i1({}, this.properties), this.attributes) {
                        var l1 = this.attributes.getAllAttributes();
                        try {
                            for(var c1 = s1(Object.keys(l1)), u1 = c1.next(); !u1.done; u1 = c1.next()){
                                var p1 = u1.value;
                                ("id" !== p1 || t1) && a1.attributes.set(p1, l1[p1]);
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                u1 && !u1.done && (r1 = c1.return) && r1.call(c1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                    }
                    if (this.childNodes && this.childNodes.length) {
                        var h1 = this.childNodes;
                        1 === h1.length && h1[0].isInferred && (h1 = h1[0].childNodes);
                        try {
                            for(var f1 = s1(h1), d1 = f1.next(); !d1.done; d1 = f1.next()){
                                var m1 = d1.value;
                                m1 ? a1.appendChild(m1.copy()) : a1.childNodes.push(null);
                            }
                        } catch (t1) {
                            n1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                d1 && !d1.done && (o1 = f1.return) && o1.call(f1);
                            } finally{
                                if (n1) throw n1.error;
                            }
                        }
                    }
                    return a1;
                }, Object.defineProperty(r1.prototype, "texClass", {
                    get: function() {
                        return this.texclass;
                    },
                    set: function(t1) {
                        this.texclass = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "isToken", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "isEmbellished", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "isSpacelike", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "linebreakContainer", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "hasNewLine", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "arity", {
                    get: function() {
                        return 1 / 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "isInferred", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "Parent", {
                    get: function() {
                        for(var t1 = this.parent; t1 && t1.notParent;)t1 = t1.Parent;
                        return t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "notParent", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), r1.prototype.setChildren = function(e1) {
                    return this.arity < 0 ? this.childNodes[0].setChildren(e1) : t1.prototype.setChildren.call(this, e1);
                }, r1.prototype.appendChild = function(e1) {
                    var r1, n1, o1 = this;
                    if (this.arity < 0) return this.childNodes[0].appendChild(e1), e1;
                    if (e1.isInferred) {
                        if (this.arity === 1 / 0) return e1.childNodes.forEach(function(e1) {
                            return t1.prototype.appendChild.call(o1, e1);
                        }), e1;
                        var i1 = e1;
                        (e1 = this.factory.create("mrow")).setChildren(i1.childNodes), e1.attributes = i1.attributes;
                        try {
                            for(var a1 = s1(i1.getPropertyNames()), l1 = a1.next(); !l1.done; l1 = a1.next()){
                                var c1 = l1.value;
                                e1.setProperty(c1, i1.getProperty(c1));
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                l1 && !l1.done && (n1 = a1.return) && n1.call(a1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                    }
                    return t1.prototype.appendChild.call(this, e1);
                }, r1.prototype.replaceChild = function(e1, r1) {
                    return this.arity < 0 ? (this.childNodes[0].replaceChild(e1, r1), e1) : t1.prototype.replaceChild.call(this, e1, r1);
                }, r1.prototype.core = function() {
                    return this;
                }, r1.prototype.coreMO = function() {
                    return this;
                }, r1.prototype.coreIndex = function() {
                    return 0;
                }, r1.prototype.childPosition = function() {
                    for(var t1, e1, r1 = this, n1 = r1.parent; n1 && n1.notParent;)r1 = n1, n1 = n1.parent;
                    if (n1) {
                        var o1 = 0;
                        try {
                            for(var i1 = s1(n1.childNodes), a1 = i1.next(); !a1.done; a1 = i1.next()){
                                if (a1.value === r1) return o1;
                                o1++;
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (e1 = i1.return) && e1.call(i1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }
                    return null;
                }, r1.prototype.setTeXclass = function(t1) {
                    return this.getPrevClass(t1), null != this.texClass ? this : t1;
                }, r1.prototype.updateTeXclass = function(t1) {
                    t1 && (this.prevClass = t1.prevClass, this.prevLevel = t1.prevLevel, t1.prevClass = t1.prevLevel = null, this.texClass = t1.texClass);
                }, r1.prototype.getPrevClass = function(t1) {
                    t1 && (this.prevClass = t1.texClass, this.prevLevel = t1.attributes.get("scriptlevel"));
                }, r1.prototype.texSpacing = function() {
                    var t1 = null != this.prevClass ? this.prevClass : e1.TEXCLASS.NONE, r1 = this.texClass || e1.TEXCLASS.ORD;
                    if (t1 === e1.TEXCLASS.NONE || r1 === e1.TEXCLASS.NONE) return "";
                    t1 === e1.TEXCLASS.VCENTER && (t1 = e1.TEXCLASS.ORD), r1 === e1.TEXCLASS.VCENTER && (r1 = e1.TEXCLASS.ORD);
                    var n1 = p1[t1][r1];
                    return (this.prevLevel > 0 || this.attributes.get("scriptlevel") > 0) && n1 >= 0 ? "" : u1[Math.abs(n1)];
                }, r1.prototype.hasSpacingAttributes = function() {
                    return this.isEmbellished && this.coreMO().hasSpacingAttributes();
                }, r1.prototype.setInheritedAttributes = function(t1, e1, n1, o1) {
                    var i1, l1;
                    void 0 === t1 && (t1 = {}), void 0 === e1 && (e1 = !1), void 0 === n1 && (n1 = 0), void 0 === o1 && (o1 = !1);
                    var c1 = this.attributes.getAllDefaults();
                    try {
                        for(var u1 = s1(Object.keys(t1)), p1 = u1.next(); !p1.done; p1 = u1.next()){
                            var h1 = p1.value;
                            if (c1.hasOwnProperty(h1) || r1.alwaysInherit.hasOwnProperty(h1)) {
                                var f1 = a1(t1[h1], 2), d1 = f1[0], m1 = f1[1];
                                ((r1.noInherit[d1] || {})[this.kind] || {})[h1] || this.attributes.setInherited(h1, m1);
                            }
                        }
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (l1 = u1.return) && l1.call(u1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                    void 0 === this.attributes.getExplicit("displaystyle") && this.attributes.setInherited("displaystyle", e1), void 0 === this.attributes.getExplicit("scriptlevel") && this.attributes.setInherited("scriptlevel", n1), o1 && this.setProperty("texprimestyle", o1);
                    var y1 = this.arity;
                    if (y1 >= 0 && y1 !== 1 / 0 && (1 === y1 && 0 === this.childNodes.length || 1 !== y1 && this.childNodes.length !== y1)) {
                        if (y1 < this.childNodes.length) this.childNodes = this.childNodes.slice(0, y1);
                        else for(; this.childNodes.length < y1;)this.appendChild(this.factory.create("mrow"));
                    }
                    this.setChildInheritedAttributes(t1, e1, n1, o1);
                }, r1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1, i1;
                    try {
                        for(var a1 = s1(this.childNodes), l1 = a1.next(); !l1.done; l1 = a1.next())l1.value.setInheritedAttributes(t1, e1, r1, n1);
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (i1 = a1.return) && i1.call(a1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                }, r1.prototype.addInheritedAttributes = function(t1, e1) {
                    var r1, n1, o1 = i1({}, t1);
                    try {
                        for(var a1 = s1(Object.keys(e1)), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value;
                            "displaystyle" !== c1 && "scriptlevel" !== c1 && "style" !== c1 && (o1[c1] = [
                                this.kind,
                                e1[c1]
                            ]);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (n1 = a1.return) && n1.call(a1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return o1;
                }, r1.prototype.inheritAttributesFrom = function(t1) {
                    var e1 = t1.attributes, r1 = e1.get("displaystyle"), n1 = e1.get("scriptlevel"), o1 = e1.isSet("mathsize") ? {
                        mathsize: [
                            "math",
                            e1.get("mathsize")
                        ]
                    } : {}, i1 = t1.getProperty("texprimestyle") || !1;
                    this.setInheritedAttributes(o1, r1, n1, i1);
                }, r1.prototype.verifyTree = function(t1) {
                    if (void 0 === t1 && (t1 = null), null !== t1) {
                        this.verifyAttributes(t1);
                        var e1 = this.arity;
                        t1.checkArity && e1 >= 0 && e1 !== 1 / 0 && (1 === e1 && 0 === this.childNodes.length || 1 !== e1 && this.childNodes.length !== e1) && this.mError('Wrong number of children for "' + this.kind + '" node', t1, !0), this.verifyChildren(t1);
                    }
                }, r1.prototype.verifyAttributes = function(t1) {
                    var e1, r1;
                    if (t1.checkAttributes) {
                        var n1 = this.attributes, o1 = [];
                        try {
                            for(var i1 = s1(n1.getExplicitNames()), a1 = i1.next(); !a1.done; a1 = i1.next()){
                                var l1 = a1.value;
                                "data-" === l1.substr(0, 5) || void 0 !== n1.getDefault(l1) || l1.match(/^(?:class|style|id|(?:xlink:)?href)$/) || o1.push(l1);
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (r1 = i1.return) && r1.call(i1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                        o1.length && this.mError("Unknown attributes for " + this.kind + " node: " + o1.join(", "), t1);
                    }
                }, r1.prototype.verifyChildren = function(t1) {
                    var e1, r1;
                    try {
                        for(var n1 = s1(this.childNodes), o1 = n1.next(); !o1.done; o1 = n1.next())o1.value.verifyTree(t1);
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, r1.prototype.mError = function(t1, e1, r1) {
                    if (void 0 === r1 && (r1 = !1), this.parent && this.parent.isKind("merror")) return null;
                    var n1 = this.factory.create("merror");
                    if (n1.attributes.set("data-mjx-message", t1), e1.fullErrors || r1) {
                        var o1 = this.factory.create("mtext"), i1 = this.factory.create("text");
                        i1.setText(e1.fullErrors ? t1 : this.kind), o1.appendChild(i1), n1.appendChild(o1), this.parent.replaceChild(n1, this);
                    } else this.parent.replaceChild(n1, this), n1.appendChild(this);
                    return n1;
                }, r1.defaults = {
                    mathbackground: l1.INHERIT,
                    mathcolor: l1.INHERIT,
                    mathsize: l1.INHERIT,
                    dir: l1.INHERIT
                }, r1.noInherit = {
                    mstyle: {
                        mpadded: {
                            width: !0,
                            height: !0,
                            depth: !0,
                            lspace: !0,
                            voffset: !0
                        },
                        mtable: {
                            width: !0,
                            height: !0,
                            depth: !0,
                            align: !0
                        }
                    },
                    maligngroup: {
                        mrow: {
                            groupalign: !0
                        },
                        mtable: {
                            groupalign: !0
                        }
                    }
                }, r1.alwaysInherit = {
                    scriptminsize: !0,
                    scriptsizemultiplier: !0
                }, r1.verifyDefaults = {
                    checkArity: !0,
                    checkAttributes: !1,
                    fullErrors: !1,
                    fixMmultiscripts: !0,
                    fixMtables: !0
                }, r1;
            }(c1.AbstractNode);
            e1.AbstractMmlNode = h1;
            var f1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "isToken", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.getText = function() {
                    var t1, e1, r1 = "";
                    try {
                        for(var n1 = s1(this.childNodes), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value;
                            i1 instanceof g1 && (r1 += i1.getText());
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return r1;
                }, e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1, i1;
                    try {
                        for(var a1 = s1(this.childNodes), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value;
                            c1 instanceof h1 && c1.setInheritedAttributes(t1, e1, r1, n1);
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (i1 = a1.return) && i1.call(a1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                }, e1.prototype.walkTree = function(t1, e1) {
                    var r1, n1;
                    t1(this, e1);
                    try {
                        for(var o1 = s1(this.childNodes), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var a1 = i1.value;
                            a1 instanceof h1 && a1.walkTree(t1, e1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return e1;
                }, e1.defaults = i1(i1({}, h1.defaults), {
                    mathvariant: "normal",
                    mathsize: l1.INHERIT
                }), e1;
            }(h1);
            e1.AbstractMmlTokenNode = f1;
            var d1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "isSpacelike", {
                    get: function() {
                        return this.childNodes[0].isSpacelike;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isEmbellished", {
                    get: function() {
                        return this.childNodes[0].isEmbellished;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return -1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.core = function() {
                    return this.childNodes[0];
                }, e1.prototype.coreMO = function() {
                    return this.childNodes[0].coreMO();
                }, e1.prototype.setTeXclass = function(t1) {
                    return t1 = this.childNodes[0].setTeXclass(t1), this.updateTeXclass(this.childNodes[0]), t1;
                }, e1.defaults = h1.defaults, e1;
            }(h1);
            e1.AbstractMmlLayoutNode = d1;
            var m1 = function(t1) {
                function r1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(r1, t1), Object.defineProperty(r1.prototype, "isEmbellished", {
                    get: function() {
                        return this.childNodes[0].isEmbellished;
                    },
                    enumerable: !1,
                    configurable: !0
                }), r1.prototype.core = function() {
                    return this.childNodes[0];
                }, r1.prototype.coreMO = function() {
                    return this.childNodes[0].coreMO();
                }, r1.prototype.setTeXclass = function(t1) {
                    var r1, n1;
                    this.getPrevClass(t1), this.texClass = e1.TEXCLASS.ORD;
                    var o1 = this.childNodes[0];
                    o1 ? this.isEmbellished || o1.isKind("mi") ? (t1 = o1.setTeXclass(t1), this.updateTeXclass(this.core())) : (o1.setTeXclass(null), t1 = this) : t1 = this;
                    try {
                        for(var i1 = s1(this.childNodes.slice(1)), a1 = i1.next(); !a1.done; a1 = i1.next()){
                            var l1 = a1.value;
                            l1 && l1.setTeXclass(null);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = i1.return) && n1.call(i1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return t1;
                }, r1.defaults = h1.defaults, r1;
            }(h1);
            e1.AbstractMmlBaseNode = m1;
            var y1 = function(t1) {
                function r1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(r1, t1), Object.defineProperty(r1.prototype, "isToken", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "isEmbellished", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "isSpacelike", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "linebreakContainer", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "hasNewLine", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "arity", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "isInferred", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "notParent", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "Parent", {
                    get: function() {
                        return this.parent;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "texClass", {
                    get: function() {
                        return e1.TEXCLASS.NONE;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "prevClass", {
                    get: function() {
                        return e1.TEXCLASS.NONE;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(r1.prototype, "prevLevel", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), r1.prototype.hasSpacingAttributes = function() {
                    return !1;
                }, Object.defineProperty(r1.prototype, "attributes", {
                    get: function() {
                        return null;
                    },
                    enumerable: !1,
                    configurable: !0
                }), r1.prototype.core = function() {
                    return this;
                }, r1.prototype.coreMO = function() {
                    return this;
                }, r1.prototype.coreIndex = function() {
                    return 0;
                }, r1.prototype.childPosition = function() {
                    return 0;
                }, r1.prototype.setTeXclass = function(t1) {
                    return t1;
                }, r1.prototype.texSpacing = function() {
                    return "";
                }, r1.prototype.setInheritedAttributes = function(t1, e1, r1, n1) {}, r1.prototype.inheritAttributesFrom = function(t1) {}, r1.prototype.verifyTree = function(t1) {}, r1.prototype.mError = function(t1, e1, r1) {
                    return void 0 === r1 && (r1 = !1), null;
                }, r1;
            }(c1.AbstractEmptyNode);
            e1.AbstractMmlEmptyNode = y1;
            var g1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.text = "", e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "text";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.getText = function() {
                    return this.text;
                }, e1.prototype.setText = function(t1) {
                    return this.text = t1, this;
                }, e1.prototype.copy = function() {
                    return this.factory.create(this.kind).setText(this.getText());
                }, e1.prototype.toString = function() {
                    return this.text;
                }, e1;
            }(y1);
            e1.TextNode = g1;
            var b1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.xml = null, e1.adaptor = null, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "XML";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.getXML = function() {
                    return this.xml;
                }, e1.prototype.setXML = function(t1, e1) {
                    return void 0 === e1 && (e1 = null), this.xml = t1, this.adaptor = e1, this;
                }, e1.prototype.getSerializedXML = function() {
                    return this.adaptor.serializeXML(this.xml);
                }, e1.prototype.copy = function() {
                    return this.factory.create(this.kind).setXML(this.adaptor.clone(this.xml));
                }, e1.prototype.toString = function() {
                    return "XML data";
                }, e1;
            }(y1);
            e1.XMLNode = b1;
        },
        3948: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TeXAtom = void 0;
            var s1 = r1(9007), a1 = r1(2756), l1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1 = t1.call(this, e1, r1, n1) || this;
                    return o1.texclass = s1.TEXCLASS.ORD, o1.setProperty("texClass", o1.texClass), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "TeXAtom";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return -1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "notParent", {
                    get: function() {
                        return this.childNodes[0] && 1 === this.childNodes[0].childNodes.length;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setTeXclass = function(t1) {
                    return this.childNodes[0].setTeXclass(null), this.adjustTeXclass(t1);
                }, e1.prototype.adjustTeXclass = function(t1) {
                    return t1;
                }, e1.defaults = i1({}, s1.AbstractMmlBaseNode.defaults), e1;
            }(s1.AbstractMmlBaseNode);
            e1.TeXAtom = l1, l1.prototype.adjustTeXclass = a1.MmlMo.prototype.adjustTeXclass;
        },
        9145: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMaction = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "maction";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "selected", {
                    get: function() {
                        var t1 = this.attributes.get("selection"), e1 = Math.max(1, Math.min(this.childNodes.length, t1)) - 1;
                        return this.childNodes[e1] || this.factory.create("mrow");
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isEmbellished", {
                    get: function() {
                        return this.selected.isEmbellished;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isSpacelike", {
                    get: function() {
                        return this.selected.isSpacelike;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.core = function() {
                    return this.selected.core();
                }, e1.prototype.coreMO = function() {
                    return this.selected.coreMO();
                }, e1.prototype.verifyAttributes = function(e1) {
                    (t1.prototype.verifyAttributes.call(this, e1), "toggle" !== this.attributes.get("actiontype") && void 0 !== this.attributes.getExplicit("selection")) && delete this.attributes.getAllAttributes().selection;
                }, e1.prototype.setTeXclass = function(t1) {
                    "tooltip" === this.attributes.get("actiontype") && this.childNodes[1] && this.childNodes[1].setTeXclass(null);
                    var e1 = this.selected;
                    return t1 = e1.setTeXclass(t1), this.updateTeXclass(e1), t1;
                }, e1.prototype.nextToggleSelection = function() {
                    var t1 = Math.max(1, this.attributes.get("selection") + 1);
                    t1 > this.childNodes.length && (t1 = 1), this.attributes.set("selection", t1);
                }, e1.defaults = i1(i1({}, s1.AbstractMmlNode.defaults), {
                    actiontype: "toggle",
                    selection: 1
                }), e1;
            }(s1.AbstractMmlNode);
            e1.MmlMaction = a1;
        },
        142: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMaligngroup = void 0;
            var s1 = r1(9007), a1 = r1(91), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "maligngroup";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isSpacelike", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function(e1, r1, n1, o1) {
                    e1 = this.addInheritedAttributes(e1, this.attributes.getAllAttributes()), t1.prototype.setChildInheritedAttributes.call(this, e1, r1, n1, o1);
                }, e1.defaults = i1(i1({}, s1.AbstractMmlLayoutNode.defaults), {
                    groupalign: a1.INHERIT
                }), e1;
            }(s1.AbstractMmlLayoutNode);
            e1.MmlMaligngroup = l1;
        },
        7590: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMalignmark = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "malignmark";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isSpacelike", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1(i1({}, s1.AbstractMmlNode.defaults), {
                    edge: "left"
                }), e1;
            }(s1.AbstractMmlNode);
            e1.MmlMalignmark = a1;
        },
        3233: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMath = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "math";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function(e1, r1, n1, o1) {
                    "display" === this.attributes.get("mode") && this.attributes.setInherited("display", "block"), e1 = this.addInheritedAttributes(e1, this.attributes.getAllAttributes()), r1 = !!this.attributes.get("displaystyle") || !this.attributes.get("displaystyle") && "block" === this.attributes.get("display"), this.attributes.setInherited("displaystyle", r1), n1 = this.attributes.get("scriptlevel") || this.constructor.defaults.scriptlevel, t1.prototype.setChildInheritedAttributes.call(this, e1, r1, n1, o1);
                }, e1.defaults = i1(i1({}, s1.AbstractMmlLayoutNode.defaults), {
                    mathvariant: "normal",
                    mathsize: "normal",
                    mathcolor: "",
                    mathbackground: "transparent",
                    dir: "ltr",
                    scriptlevel: 0,
                    displaystyle: !1,
                    display: "inline",
                    maxwidth: "",
                    overflow: "linebreak",
                    altimg: "",
                    "altimg-width": "",
                    "altimg-height": "",
                    "altimg-valign": "",
                    alttext: "",
                    cdgroup: "",
                    scriptsizemultiplier: 1 / Math.sqrt(2),
                    scriptminsize: "8px",
                    infixlinebreakstyle: "before",
                    lineleading: "1ex",
                    linebreakmultchar: "⁢",
                    indentshift: "auto",
                    indentalign: "auto",
                    indenttarget: "",
                    indentalignfirst: "indentalign",
                    indentshiftfirst: "indentshift",
                    indentalignlast: "indentalign",
                    indentshiftlast: "indentshift"
                }), e1;
            }(s1.AbstractMmlLayoutNode);
            e1.MmlMath = a1;
        },
        1334: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MathChoice = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "MathChoice";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 4;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "notParent", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1 = e1 ? 0 : Math.max(0, Math.min(r1, 2)) + 1, i1 = this.childNodes[o1] || this.factory.create("mrow");
                    this.parent.replaceChild(i1, this), i1.setInheritedAttributes(t1, e1, r1, n1);
                }, e1.defaults = i1({}, s1.AbstractMmlBaseNode.defaults), e1;
            }(s1.AbstractMmlBaseNode);
            e1.MathChoice = a1;
        },
        6661: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMenclose = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "menclose";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return -1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContininer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setTeXclass = function(t1) {
                    return t1 = this.childNodes[0].setTeXclass(t1), this.updateTeXclass(this.childNodes[0]), t1;
                }, e1.defaults = i1(i1({}, s1.AbstractMmlNode.defaults), {
                    notation: "longdiv"
                }), e1;
            }(s1.AbstractMmlNode);
            e1.MmlMenclose = a1;
        },
        1581: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMerror = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "merror";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return -1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, s1.AbstractMmlNode.defaults), e1;
            }(s1.AbstractMmlNode);
            e1.MmlMerror = a1;
        },
        5410: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMfenced = void 0;
            var a1 = r1(9007), l1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = a1.TEXCLASS.INNER, e1.separators = [], e1.open = null, e1.close = null, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mfenced";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setTeXclass = function(t1) {
                    this.getPrevClass(t1), this.open && (t1 = this.open.setTeXclass(t1)), this.childNodes[0] && (t1 = this.childNodes[0].setTeXclass(t1));
                    for(var e1 = 1, r1 = this.childNodes.length; e1 < r1; e1++)this.separators[e1 - 1] && (t1 = this.separators[e1 - 1].setTeXclass(t1)), this.childNodes[e1] && (t1 = this.childNodes[e1].setTeXclass(t1));
                    return this.close && (t1 = this.close.setTeXclass(t1)), this.updateTeXclass(this.open), t1;
                }, e1.prototype.setChildInheritedAttributes = function(e1, r1, n1, o1) {
                    var i1, a1;
                    this.addFakeNodes();
                    try {
                        for(var l1 = s1([
                            this.open,
                            this.close
                        ].concat(this.separators)), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value;
                            u1 && u1.setInheritedAttributes(e1, r1, n1, o1);
                        }
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (a1 = l1.return) && a1.call(l1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                    t1.prototype.setChildInheritedAttributes.call(this, e1, r1, n1, o1);
                }, e1.prototype.addFakeNodes = function() {
                    var t1, e1, r1 = this.attributes.getList("open", "close", "separators"), n1 = r1.open, o1 = r1.close, i1 = r1.separators;
                    if (n1 = n1.replace(/[ \t\n\r]/g, ""), o1 = o1.replace(/[ \t\n\r]/g, ""), i1 = i1.replace(/[ \t\n\r]/g, ""), n1 && (this.open = this.fakeNode(n1, {
                        fence: !0,
                        form: "prefix"
                    }, a1.TEXCLASS.OPEN)), i1) {
                        for(; i1.length < this.childNodes.length - 1;)i1 += i1.charAt(i1.length - 1);
                        var l1 = 0;
                        try {
                            for(var c1 = s1(this.childNodes.slice(1)), u1 = c1.next(); !u1.done; u1 = c1.next())u1.value && this.separators.push(this.fakeNode(i1.charAt(l1++)));
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                u1 && !u1.done && (e1 = c1.return) && e1.call(c1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }
                    o1 && (this.close = this.fakeNode(o1, {
                        fence: !0,
                        form: "postfix"
                    }, a1.TEXCLASS.CLOSE));
                }, e1.prototype.fakeNode = function(t1, e1, r1) {
                    void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = null);
                    var n1 = this.factory.create("text").setText(t1), o1 = this.factory.create("mo", e1, [
                        n1
                    ]);
                    return o1.texClass = r1, o1.parent = this, o1;
                }, e1.defaults = i1(i1({}, a1.AbstractMmlNode.defaults), {
                    open: "(",
                    close: ")",
                    separators: ","
                }), e1;
            }(a1.AbstractMmlNode);
            e1.MmlMfenced = l1;
        },
        6850: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMfrac = void 0;
            var a1 = r1(9007), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mfrac";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setTeXclass = function(t1) {
                    var e1, r1;
                    this.getPrevClass(t1);
                    try {
                        for(var n1 = s1(this.childNodes), o1 = n1.next(); !o1.done; o1 = n1.next())o1.value.setTeXclass(null);
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return this;
                }, e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    (!e1 || r1 > 0) && r1++, this.childNodes[0].setInheritedAttributes(t1, !1, r1, n1), this.childNodes[1].setInheritedAttributes(t1, !1, r1, !0);
                }, e1.defaults = i1(i1({}, a1.AbstractMmlBaseNode.defaults), {
                    linethickness: "medium",
                    numalign: "center",
                    denomalign: "center",
                    bevelled: !1
                }), e1;
            }(a1.AbstractMmlBaseNode);
            e1.MmlMfrac = l1;
        },
        3985: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMglyph = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mglyph";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.verifyAttributes = function(e1) {
                    var r1 = this.attributes.getList("src", "fontfamily", "index"), n1 = r1.src, o1 = r1.fontfamily, i1 = r1.index;
                    "" !== n1 || "" !== o1 && "" !== i1 ? t1.prototype.verifyAttributes.call(this, e1) : this.mError("mglyph must have either src or fontfamily and index attributes", e1, !0);
                }, e1.defaults = i1(i1({}, s1.AbstractMmlTokenNode.defaults), {
                    alt: "",
                    src: "",
                    index: "",
                    width: "auto",
                    height: "auto",
                    valign: "0em"
                }), e1;
            }(s1.AbstractMmlTokenNode);
            e1.MmlMglyph = a1;
        },
        450: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMi = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mi";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setInheritedAttributes = function(r1, n1, o1, i1) {
                    void 0 === r1 && (r1 = {}), void 0 === n1 && (n1 = !1), void 0 === o1 && (o1 = 0), void 0 === i1 && (i1 = !1), t1.prototype.setInheritedAttributes.call(this, r1, n1, o1, i1), this.getText().match(e1.singleCharacter) && !r1.mathvariant && this.attributes.setInherited("mathvariant", "italic");
                }, e1.prototype.setTeXclass = function(t1) {
                    this.getPrevClass(t1);
                    var r1 = this.getText();
                    return r1.length > 1 && r1.match(e1.operatorName) && "normal" === this.attributes.get("mathvariant") && void 0 === this.getProperty("autoOP") && void 0 === this.getProperty("texClass") && (this.texClass = s1.TEXCLASS.OP, this.setProperty("autoOP", !0)), this;
                }, e1.defaults = i1({}, s1.AbstractMmlTokenNode.defaults), e1.operatorName = /^[a-z][a-z0-9]*$/i, e1.singleCharacter = /^[\uD800-\uDBFF]?.[\u0300-\u036F\u1AB0-\u1ABE\u1DC0-\u1DFF\u20D0-\u20EF]*$/, e1;
            }(s1.AbstractMmlTokenNode);
            e1.MmlMi = a1;
        },
        6405: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlNone = e1.MmlMprescripts = e1.MmlMmultiscripts = void 0;
            var s1 = r1(9007), a1 = r1(4461), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mmultiscripts";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    this.childNodes[0].setInheritedAttributes(t1, e1, r1, n1);
                    for(var o1 = !1, i1 = 1, s1 = 0; i1 < this.childNodes.length; i1++){
                        var a1 = this.childNodes[i1];
                        if (a1.isKind("mprescripts")) {
                            if (!o1 && (o1 = !0, i1 % 2 == 0)) {
                                var l1 = this.factory.create("mrow");
                                this.childNodes.splice(i1, 0, l1), l1.parent = this, i1++;
                            }
                        } else {
                            var c1 = n1 || s1 % 2 == 0;
                            a1.setInheritedAttributes(t1, !1, r1 + 1, c1), s1++;
                        }
                    }
                    this.childNodes.length % 2 == (o1 ? 1 : 0) && (this.appendChild(this.factory.create("mrow")), this.childNodes[this.childNodes.length - 1].setInheritedAttributes(t1, !1, r1 + 1, n1));
                }, e1.prototype.verifyChildren = function(e1) {
                    for(var r1 = !1, n1 = e1.fixMmultiscripts, o1 = 0; o1 < this.childNodes.length; o1++){
                        var i1 = this.childNodes[o1];
                        i1.isKind("mprescripts") && (r1 ? i1.mError(i1.kind + " can only appear once in " + this.kind, e1, !0) : (r1 = !0, o1 % 2 != 0 || n1 || this.mError("There must be an equal number of prescripts of each type", e1)));
                    }
                    this.childNodes.length % 2 != (r1 ? 1 : 0) || n1 || this.mError("There must be an equal number of scripts of each type", e1), t1.prototype.verifyChildren.call(this, e1);
                }, e1.defaults = i1({}, a1.MmlMsubsup.defaults), e1;
            }(a1.MmlMsubsup);
            e1.MmlMmultiscripts = l1;
            var c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mprescripts";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.verifyTree = function(e1) {
                    t1.prototype.verifyTree.call(this, e1), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", e1, !0);
                }, e1.defaults = i1({}, s1.AbstractMmlNode.defaults), e1;
            }(s1.AbstractMmlNode);
            e1.MmlMprescripts = c1;
            var u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "none";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.verifyTree = function(e1) {
                    t1.prototype.verifyTree.call(this, e1), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", e1, !0);
                }, e1.defaults = i1({}, s1.AbstractMmlNode.defaults), e1;
            }(s1.AbstractMmlNode);
            e1.MmlNone = u1;
        },
        3050: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMn = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mn";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, s1.AbstractMmlTokenNode.defaults), e1;
            }(s1.AbstractMmlTokenNode);
            e1.MmlMn = a1;
        },
        2756: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMo = void 0;
            var l1 = r1(9007), c1 = r1(4082), u1 = r1(505), p1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1._texClass = null, e1.lspace = 5 / 18, e1.rspace = 5 / 18, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "texClass", {
                    get: function() {
                        if (null === this._texClass) {
                            var t1 = this.getText(), e1 = s1(this.handleExplicitForm(this.getForms()), 3), r1 = e1[0], n1 = e1[1], o1 = e1[2], i1 = this.constructor.OPTABLE, a1 = i1[r1][t1] || i1[n1][t1] || i1[o1][t1];
                            return a1 ? a1[2] : l1.TEXCLASS.REL;
                        }
                        return this._texClass;
                    },
                    set: function(t1) {
                        this._texClass = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mo";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isEmbellished", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "hasNewLine", {
                    get: function() {
                        return "newline" === this.attributes.get("linebreak");
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.coreParent = function() {
                    for(var t1 = this, e1 = this, r1 = this.factory.getNodeClass("math"); e1 && e1.isEmbellished && e1.coreMO() === this && !(e1 instanceof r1);)t1 = e1, e1 = e1.parent;
                    return t1;
                }, e1.prototype.coreText = function(t1) {
                    if (!t1) return "";
                    if (t1.isEmbellished) return t1.coreMO().getText();
                    for(; ((t1.isKind("mrow") || t1.isKind("TeXAtom") && t1.texClass !== l1.TEXCLASS.VCENTER || t1.isKind("mstyle") || t1.isKind("mphantom")) && 1 === t1.childNodes.length || t1.isKind("munderover")) && t1.childNodes[0];)t1 = t1.childNodes[0];
                    return t1.isToken ? t1.getText() : "";
                }, e1.prototype.hasSpacingAttributes = function() {
                    return this.attributes.isSet("lspace") || this.attributes.isSet("rspace");
                }, Object.defineProperty(e1.prototype, "isAccent", {
                    get: function() {
                        var t1 = !1, e1 = this.coreParent().parent;
                        if (e1) {
                            var r1 = e1.isKind("mover") ? e1.childNodes[e1.over].coreMO() ? "accent" : "" : e1.isKind("munder") ? e1.childNodes[e1.under].coreMO() ? "accentunder" : "" : e1.isKind("munderover") ? this === e1.childNodes[e1.over].coreMO() ? "accent" : this === e1.childNodes[e1.under].coreMO() ? "accentunder" : "" : "";
                            if (r1) t1 = void 0 !== e1.attributes.getExplicit(r1) ? t1 : this.attributes.get("accent");
                        }
                        return t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setTeXclass = function(t1) {
                    var e1 = this.attributes.getList("form", "fence"), r1 = e1.form, n1 = e1.fence;
                    return void 0 === this.getProperty("texClass") && (this.attributes.isSet("lspace") || this.attributes.isSet("rspace")) ? null : (n1 && this.texClass === l1.TEXCLASS.REL && ("prefix" === r1 && (this.texClass = l1.TEXCLASS.OPEN), "postfix" === r1 && (this.texClass = l1.TEXCLASS.CLOSE)), this.adjustTeXclass(t1));
                }, e1.prototype.adjustTeXclass = function(t1) {
                    var e1 = this.texClass, r1 = this.prevClass;
                    if (e1 === l1.TEXCLASS.NONE) return t1;
                    if (t1 ? (!t1.getProperty("autoOP") || e1 !== l1.TEXCLASS.BIN && e1 !== l1.TEXCLASS.REL || (r1 = t1.texClass = l1.TEXCLASS.ORD), r1 = this.prevClass = t1.texClass || l1.TEXCLASS.ORD, this.prevLevel = this.attributes.getInherited("scriptlevel")) : r1 = this.prevClass = l1.TEXCLASS.NONE, e1 !== l1.TEXCLASS.BIN || r1 !== l1.TEXCLASS.NONE && r1 !== l1.TEXCLASS.BIN && r1 !== l1.TEXCLASS.OP && r1 !== l1.TEXCLASS.REL && r1 !== l1.TEXCLASS.OPEN && r1 !== l1.TEXCLASS.PUNCT) {
                        if (r1 !== l1.TEXCLASS.BIN || e1 !== l1.TEXCLASS.REL && e1 !== l1.TEXCLASS.CLOSE && e1 !== l1.TEXCLASS.PUNCT) {
                            if (e1 === l1.TEXCLASS.BIN) {
                                for(var n1 = this, o1 = this.parent; o1 && o1.parent && o1.isEmbellished && (1 === o1.childNodes.length || !o1.isKind("mrow") && o1.core() === n1);)n1 = o1, o1 = o1.parent;
                                o1.childNodes[o1.childNodes.length - 1] === n1 && (this.texClass = l1.TEXCLASS.ORD);
                            }
                        } else t1.texClass = this.prevClass = l1.TEXCLASS.ORD;
                    } else this.texClass = l1.TEXCLASS.ORD;
                    return this;
                }, e1.prototype.setInheritedAttributes = function(e1, r1, n1, o1) {
                    void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = !1), void 0 === n1 && (n1 = 0), void 0 === o1 && (o1 = !1), t1.prototype.setInheritedAttributes.call(this, e1, r1, n1, o1);
                    var i1 = this.getText();
                    this.checkOperatorTable(i1), this.checkPseudoScripts(i1), this.checkPrimes(i1), this.checkMathAccent(i1);
                }, e1.prototype.checkOperatorTable = function(t1) {
                    var e1, r1, n1 = s1(this.handleExplicitForm(this.getForms()), 3), o1 = n1[0], i1 = n1[1], l1 = n1[2];
                    this.attributes.setInherited("form", o1);
                    var u1 = this.constructor.OPTABLE, p1 = u1[o1][t1] || u1[i1][t1] || u1[l1][t1];
                    if (p1) {
                        void 0 === this.getProperty("texClass") && (this.texClass = p1[2]);
                        try {
                            for(var h1 = a1(Object.keys(p1[3] || {})), f1 = h1.next(); !f1.done; f1 = h1.next()){
                                var d1 = f1.value;
                                this.attributes.setInherited(d1, p1[3][d1]);
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                f1 && !f1.done && (r1 = h1.return) && r1.call(h1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                        this.lspace = (p1[0] + 1) / 18, this.rspace = (p1[1] + 1) / 18;
                    } else {
                        var m1 = (0, c1.getRange)(t1);
                        if (m1) {
                            void 0 === this.getProperty("texClass") && (this.texClass = m1[2]);
                            var y1 = this.constructor.MMLSPACING[m1[2]];
                            this.lspace = (y1[0] + 1) / 18, this.rspace = (y1[1] + 1) / 18;
                        }
                    }
                }, e1.prototype.getForms = function() {
                    for(var t1 = this, e1 = this.parent, r1 = this.Parent; r1 && r1.isEmbellished;)t1 = e1, e1 = r1.parent, r1 = r1.Parent;
                    if (e1 && e1.isKind("mrow") && 1 !== e1.nonSpaceLength()) {
                        if (e1.firstNonSpace() === t1) return [
                            "prefix",
                            "infix",
                            "postfix"
                        ];
                        if (e1.lastNonSpace() === t1) return [
                            "postfix",
                            "infix",
                            "prefix"
                        ];
                    }
                    return [
                        "infix",
                        "prefix",
                        "postfix"
                    ];
                }, e1.prototype.handleExplicitForm = function(t1) {
                    if (this.attributes.isSet("form")) {
                        var e1 = this.attributes.get("form");
                        t1 = [
                            e1
                        ].concat(t1.filter(function(t1) {
                            return t1 !== e1;
                        }));
                    }
                    return t1;
                }, e1.prototype.checkPseudoScripts = function(t1) {
                    var e1 = this.constructor.pseudoScripts;
                    if (t1.match(e1)) {
                        var r1 = this.coreParent().Parent, n1 = !r1 || !(r1.isKind("msubsup") && !r1.isKind("msub"));
                        this.setProperty("pseudoscript", n1), n1 && (this.attributes.setInherited("lspace", 0), this.attributes.setInherited("rspace", 0));
                    }
                }, e1.prototype.checkPrimes = function(t1) {
                    var e1 = this.constructor.primes;
                    if (t1.match(e1)) {
                        var r1 = this.constructor.remapPrimes, n1 = (0, u1.unicodeString)((0, u1.unicodeChars)(t1).map(function(t1) {
                            return r1[t1];
                        }));
                        this.setProperty("primes", n1);
                    }
                }, e1.prototype.checkMathAccent = function(t1) {
                    var e1 = this.Parent;
                    if (void 0 === this.getProperty("mathaccent") && e1 && e1.isKind("munderover")) {
                        var r1 = e1.childNodes[0];
                        if (!r1.isEmbellished || r1.coreMO() !== this) {
                            var n1 = this.constructor.mathaccents;
                            t1.match(n1) && this.setProperty("mathaccent", !0);
                        }
                    }
                }, e1.defaults = i1(i1({}, l1.AbstractMmlTokenNode.defaults), {
                    form: "infix",
                    fence: !1,
                    separator: !1,
                    lspace: "thickmathspace",
                    rspace: "thickmathspace",
                    stretchy: !1,
                    symmetric: !1,
                    maxsize: "infinity",
                    minsize: "0em",
                    largeop: !1,
                    movablelimits: !1,
                    accent: !1,
                    linebreak: "auto",
                    lineleading: "1ex",
                    linebreakstyle: "before",
                    indentalign: "auto",
                    indentshift: "0",
                    indenttarget: "",
                    indentalignfirst: "indentalign",
                    indentshiftfirst: "indentshift",
                    indentalignlast: "indentalign",
                    indentshiftlast: "indentshift"
                }), e1.MMLSPACING = c1.MMLSPACING, e1.OPTABLE = c1.OPTABLE, e1.pseudoScripts = new RegExp([
                    "^[\"'*`",
                    "\xaa",
                    "\xb0",
                    "\xb2-\xb4",
                    "\xb9",
                    "\xba",
                    "‘-‟",
                    "′-‷⁗",
                    "⁰ⁱ",
                    "⁴-ⁿ",
                    "₀-₎",
                    "]+$"
                ].join("")), e1.primes = new RegExp([
                    "^[\"'`",
                    "‘-‟",
                    "]+$"
                ].join("")), e1.remapPrimes = {
                    34: 8243,
                    39: 8242,
                    96: 8245,
                    8216: 8245,
                    8217: 8242,
                    8218: 8242,
                    8219: 8245,
                    8220: 8246,
                    8221: 8243,
                    8222: 8243,
                    8223: 8246
                }, e1.mathaccents = new RegExp([
                    "^[",
                    "\xb4́ˊ",
                    "`̀ˋ",
                    "\xa8̈",
                    "~̃˜",
                    "\xaf̄ˉ",
                    "˘̆",
                    "ˇ̌",
                    "^̂ˆ",
                    "→⃗",
                    "˙̇",
                    "˚̊",
                    "⃛",
                    "⃜",
                    "]$"
                ].join("")), e1;
            }(l1.AbstractMmlTokenNode);
            e1.MmlMo = p1;
        },
        7238: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMpadded = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mpadded";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1(i1({}, s1.AbstractMmlLayoutNode.defaults), {
                    width: "",
                    height: "",
                    depth: "",
                    lspace: 0,
                    voffset: 0
                }), e1;
            }(s1.AbstractMmlLayoutNode);
            e1.MmlMpadded = a1;
        },
        5741: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMphantom = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mphantom";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, s1.AbstractMmlLayoutNode.defaults), e1;
            }(s1.AbstractMmlLayoutNode);
            e1.MmlMphantom = a1;
        },
        6145: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMroot = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mroot";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setTeXclass = function(t1) {
                    return this.getPrevClass(t1), this.childNodes[0].setTeXclass(null), this.childNodes[1].setTeXclass(null), this;
                }, e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    this.childNodes[0].setInheritedAttributes(t1, e1, r1, !0), this.childNodes[1].setInheritedAttributes(t1, !1, r1 + 2, n1);
                }, e1.defaults = i1({}, s1.AbstractMmlNode.defaults), e1;
            }(s1.AbstractMmlNode);
            e1.MmlMroot = a1;
        },
        9878: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlInferredMrow = e1.MmlMrow = void 0;
            var a1 = r1(9007), l1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1._core = null, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mrow";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isSpacelike", {
                    get: function() {
                        var t1, e1;
                        try {
                            for(var r1 = s1(this.childNodes), n1 = r1.next(); !n1.done; n1 = r1.next()){
                                if (!n1.value.isSpacelike) return !1;
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isEmbellished", {
                    get: function() {
                        var t1, e1, r1 = !1, n1 = 0;
                        try {
                            for(var o1 = s1(this.childNodes), i1 = o1.next(); !i1.done; i1 = o1.next()){
                                var a1 = i1.value;
                                if (a1) {
                                    if (a1.isEmbellished) {
                                        if (r1) return !1;
                                        r1 = !0, this._core = n1;
                                    } else if (!a1.isSpacelike) return !1;
                                }
                                n1++;
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                i1 && !i1.done && (e1 = o1.return) && e1.call(o1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        return r1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.core = function() {
                    return this.isEmbellished && null != this._core ? this.childNodes[this._core] : this;
                }, e1.prototype.coreMO = function() {
                    return this.isEmbellished && null != this._core ? this.childNodes[this._core].coreMO() : this;
                }, e1.prototype.nonSpaceLength = function() {
                    var t1, e1, r1 = 0;
                    try {
                        for(var n1 = s1(this.childNodes), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value;
                            i1 && !i1.isSpacelike && r1++;
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return r1;
                }, e1.prototype.firstNonSpace = function() {
                    var t1, e1;
                    try {
                        for(var r1 = s1(this.childNodes), n1 = r1.next(); !n1.done; n1 = r1.next()){
                            var o1 = n1.value;
                            if (o1 && !o1.isSpacelike) return o1;
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return null;
                }, e1.prototype.lastNonSpace = function() {
                    for(var t1 = this.childNodes.length; --t1 >= 0;){
                        var e1 = this.childNodes[t1];
                        if (e1 && !e1.isSpacelike) return e1;
                    }
                    return null;
                }, e1.prototype.setTeXclass = function(t1) {
                    var e1, r1, n1, o1;
                    if (null != this.getProperty("open") || null != this.getProperty("close")) {
                        this.getPrevClass(t1), t1 = null;
                        try {
                            for(var i1 = s1(this.childNodes), l1 = i1.next(); !l1.done; l1 = i1.next())t1 = l1.value.setTeXclass(t1);
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                l1 && !l1.done && (r1 = i1.return) && r1.call(i1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                        null == this.texClass && (this.texClass = a1.TEXCLASS.INNER);
                    } else {
                        try {
                            for(var c1 = s1(this.childNodes), u1 = c1.next(); !u1.done; u1 = c1.next())t1 = u1.value.setTeXclass(t1);
                        } catch (t1) {
                            n1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                u1 && !u1.done && (o1 = c1.return) && o1.call(c1);
                            } finally{
                                if (n1) throw n1.error;
                            }
                        }
                        this.childNodes[0] && this.updateTeXclass(this.childNodes[0]);
                    }
                    return t1;
                }, e1.defaults = i1({}, a1.AbstractMmlNode.defaults), e1;
            }(a1.AbstractMmlNode);
            e1.MmlMrow = l1;
            var c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "inferredMrow";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isInferred", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "notParent", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.toString = function() {
                    return "[" + this.childNodes.join(",") + "]";
                }, e1.defaults = l1.defaults, e1;
            }(l1);
            e1.MmlInferredMrow = c1;
        },
        7265: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMs = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "ms";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1(i1({}, s1.AbstractMmlTokenNode.defaults), {
                    lquote: '"',
                    rquote: '"'
                }), e1;
            }(s1.AbstractMmlTokenNode);
            e1.MmlMs = a1;
        },
        6030: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMspace = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.NONE, e1;
                }
                return o1(e1, t1), e1.prototype.setTeXclass = function(t1) {
                    return t1;
                }, Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mspace";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isSpacelike", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "hasNewline", {
                    get: function() {
                        var t1 = this.attributes;
                        return null == t1.getExplicit("width") && null == t1.getExplicit("height") && null == t1.getExplicit("depth") && "newline" === t1.get("linebreak");
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1(i1({}, s1.AbstractMmlTokenNode.defaults), {
                    width: "0em",
                    height: "0ex",
                    depth: "0ex",
                    linebreak: "auto"
                }), e1;
            }(s1.AbstractMmlTokenNode);
            e1.MmlMspace = a1;
        },
        7131: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMsqrt = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "msqrt";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return -1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setTeXclass = function(t1) {
                    return this.getPrevClass(t1), this.childNodes[0].setTeXclass(null), this;
                }, e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    this.childNodes[0].setInheritedAttributes(t1, e1, r1, !0);
                }, e1.defaults = i1({}, s1.AbstractMmlNode.defaults), e1;
            }(s1.AbstractMmlNode);
            e1.MmlMsqrt = a1;
        },
        1314: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMstyle = void 0;
            var s1 = r1(9007), a1 = r1(91), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mstyle";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "notParent", {
                    get: function() {
                        return this.childNodes[0] && 1 === this.childNodes[0].childNodes.length;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1 = this.attributes.getExplicit("scriptlevel");
                    null != o1 && ((o1 = o1.toString()).match(/^\s*[-+]/) ? r1 += parseInt(o1) : r1 = parseInt(o1), n1 = !1);
                    var i1 = this.attributes.getExplicit("displaystyle");
                    null != i1 && (e1 = !0 === i1, n1 = !1);
                    var s1 = this.attributes.getExplicit("data-cramped");
                    null != s1 && (n1 = s1), t1 = this.addInheritedAttributes(t1, this.attributes.getAllAttributes()), this.childNodes[0].setInheritedAttributes(t1, e1, r1, n1);
                }, e1.defaults = i1(i1({}, s1.AbstractMmlLayoutNode.defaults), {
                    scriptlevel: a1.INHERIT,
                    displaystyle: a1.INHERIT,
                    scriptsizemultiplier: 1 / Math.sqrt(2),
                    scriptminsize: "8px",
                    mathbackground: a1.INHERIT,
                    mathcolor: a1.INHERIT,
                    dir: a1.INHERIT,
                    infixlinebreakstyle: "before"
                }), e1;
            }(s1.AbstractMmlLayoutNode);
            e1.MmlMstyle = l1;
        },
        4461: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMsup = e1.MmlMsub = e1.MmlMsubsup = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "msubsup";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 3;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "base", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "sub", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "sup", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1 = this.childNodes;
                    o1[0].setInheritedAttributes(t1, e1, r1, n1), o1[1].setInheritedAttributes(t1, !1, r1 + 1, n1 || 1 === this.sub), o1[2] && o1[2].setInheritedAttributes(t1, !1, r1 + 1, n1 || 2 === this.sub);
                }, e1.defaults = i1(i1({}, s1.AbstractMmlBaseNode.defaults), {
                    subscriptshift: "",
                    superscriptshift: ""
                }), e1;
            }(s1.AbstractMmlBaseNode);
            e1.MmlMsubsup = a1;
            var l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "msub";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, a1.defaults), e1;
            }(a1);
            e1.MmlMsub = l1;
            var c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "msup";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "sup", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "sub", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, a1.defaults), e1;
            }(a1);
            e1.MmlMsup = c1;
        },
        1349: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMtable = void 0;
            var a1 = r1(9007), l1 = r1(505), c1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.properties = {
                        useHeight: !0
                    }, e1.texclass = a1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mtable";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setInheritedAttributes = function(e1, r1, n1, o1) {
                    var i1, l1;
                    try {
                        for(var c1 = s1(a1.indentAttributes), u1 = c1.next(); !u1.done; u1 = c1.next()){
                            var p1 = u1.value;
                            e1[p1] && this.attributes.setInherited(p1, e1[p1][1]), void 0 !== this.attributes.getExplicit(p1) && delete this.attributes.getAllAttributes()[p1];
                        }
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (l1 = c1.return) && l1.call(c1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                    t1.prototype.setInheritedAttributes.call(this, e1, r1, n1, o1);
                }, e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1, i1, a1, c1;
                    try {
                        for(var u1 = s1(this.childNodes), p1 = u1.next(); !p1.done; p1 = u1.next())(y1 = p1.value).isKind("mtr") || this.replaceChild(this.factory.create("mtr"), y1).appendChild(y1);
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (i1 = u1.return) && i1.call(u1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    r1 = this.getProperty("scriptlevel") || r1, e1 = !(!this.attributes.getExplicit("displaystyle") && !this.attributes.getDefault("displaystyle")), t1 = this.addInheritedAttributes(t1, {
                        columnalign: this.attributes.get("columnalign"),
                        rowalign: "center"
                    });
                    var h1 = this.attributes.getExplicit("data-cramped"), f1 = (0, l1.split)(this.attributes.get("rowalign"));
                    try {
                        for(var d1 = s1(this.childNodes), m1 = d1.next(); !m1.done; m1 = d1.next()){
                            var y1 = m1.value;
                            t1.rowalign[1] = f1.shift() || t1.rowalign[1], y1.setInheritedAttributes(t1, e1, r1, !!h1);
                        }
                    } catch (t1) {
                        a1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            m1 && !m1.done && (c1 = d1.return) && c1.call(d1);
                        } finally{
                            if (a1) throw a1.error;
                        }
                    }
                }, e1.prototype.verifyChildren = function(e1) {
                    for(var r1 = null, n1 = this.factory, o1 = 0; o1 < this.childNodes.length; o1++){
                        var i1 = this.childNodes[o1];
                        if (i1.isKind("mtr")) r1 = null;
                        else {
                            var s1 = i1.isKind("mtd");
                            if (r1 ? (this.removeChild(i1), o1--) : r1 = this.replaceChild(n1.create("mtr"), i1), r1.appendChild(s1 ? i1 : n1.create("mtd", {}, [
                                i1
                            ])), !e1.fixMtables) {
                                i1.parent.removeChild(i1), i1.parent = this, s1 && r1.appendChild(n1.create("mtd"));
                                var a1 = i1.mError("Children of " + this.kind + " must be mtr or mlabeledtr", e1, s1);
                                r1.childNodes[r1.childNodes.length - 1].appendChild(a1);
                            }
                        }
                    }
                    t1.prototype.verifyChildren.call(this, e1);
                }, e1.prototype.setTeXclass = function(t1) {
                    var e1, r1;
                    this.getPrevClass(t1);
                    try {
                        for(var n1 = s1(this.childNodes), o1 = n1.next(); !o1.done; o1 = n1.next())o1.value.setTeXclass(null);
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return this;
                }, e1.defaults = i1(i1({}, a1.AbstractMmlNode.defaults), {
                    align: "axis",
                    rowalign: "baseline",
                    columnalign: "center",
                    groupalign: "{left}",
                    alignmentscope: !0,
                    columnwidth: "auto",
                    width: "auto",
                    rowspacing: "1ex",
                    columnspacing: ".8em",
                    rowlines: "none",
                    columnlines: "none",
                    frame: "none",
                    framespacing: "0.4em 0.5ex",
                    equalrows: !1,
                    equalcolumns: !1,
                    displaystyle: !1,
                    side: "right",
                    minlabelspacing: "0.8em"
                }), e1;
            }(a1.AbstractMmlNode);
            e1.MmlMtable = c1;
        },
        4359: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMtd = void 0;
            var s1 = r1(9007), a1 = r1(91), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mtd";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return -1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.verifyChildren = function(e1) {
                    !this.parent || this.parent.isKind("mtr") ? t1.prototype.verifyChildren.call(this, e1) : this.mError(this.kind + " can only be a child of an mtr or mlabeledtr", e1, !0);
                }, e1.prototype.setTeXclass = function(t1) {
                    return this.getPrevClass(t1), this.childNodes[0].setTeXclass(null), this;
                }, e1.defaults = i1(i1({}, s1.AbstractMmlBaseNode.defaults), {
                    rowspan: 1,
                    columnspan: 1,
                    rowalign: a1.INHERIT,
                    columnalign: a1.INHERIT,
                    groupalign: a1.INHERIT
                }), e1;
            }(s1.AbstractMmlBaseNode);
            e1.MmlMtd = l1;
        },
        4770: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMtext = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.texclass = s1.TEXCLASS.ORD, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mtext";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isSpacelike", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, s1.AbstractMmlTokenNode.defaults), e1;
            }(s1.AbstractMmlTokenNode);
            e1.MmlMtext = a1;
        },
        5022: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMlabeledtr = e1.MmlMtr = void 0;
            var a1 = r1(9007), l1 = r1(91), c1 = r1(505), u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mtr";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1, i1, a1, l1;
                    try {
                        for(var u1 = s1(this.childNodes), p1 = u1.next(); !p1.done; p1 = u1.next())(m1 = p1.value).isKind("mtd") || this.replaceChild(this.factory.create("mtd"), m1).appendChild(m1);
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (i1 = u1.return) && i1.call(u1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    var h1 = (0, c1.split)(this.attributes.get("columnalign"));
                    1 === this.arity && h1.unshift(this.parent.attributes.get("side")), t1 = this.addInheritedAttributes(t1, {
                        rowalign: this.attributes.get("rowalign"),
                        columnalign: "center"
                    });
                    try {
                        for(var f1 = s1(this.childNodes), d1 = f1.next(); !d1.done; d1 = f1.next()){
                            var m1 = d1.value;
                            t1.columnalign[1] = h1.shift() || t1.columnalign[1], m1.setInheritedAttributes(t1, e1, r1, n1);
                        }
                    } catch (t1) {
                        a1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            d1 && !d1.done && (l1 = f1.return) && l1.call(f1);
                        } finally{
                            if (a1) throw a1.error;
                        }
                    }
                }, e1.prototype.verifyChildren = function(e1) {
                    var r1, n1;
                    if (!this.parent || this.parent.isKind("mtable")) {
                        try {
                            for(var o1 = s1(this.childNodes), i1 = o1.next(); !i1.done; i1 = o1.next()){
                                var a1 = i1.value;
                                if (!a1.isKind("mtd")) this.replaceChild(this.factory.create("mtd"), a1).appendChild(a1), e1.fixMtables || a1.mError("Children of " + this.kind + " must be mtd", e1);
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                        t1.prototype.verifyChildren.call(this, e1);
                    } else this.mError(this.kind + " can only be a child of an mtable", e1, !0);
                }, e1.prototype.setTeXclass = function(t1) {
                    var e1, r1;
                    this.getPrevClass(t1);
                    try {
                        for(var n1 = s1(this.childNodes), o1 = n1.next(); !o1.done; o1 = n1.next())o1.value.setTeXclass(null);
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return this;
                }, e1.defaults = i1(i1({}, a1.AbstractMmlNode.defaults), {
                    rowalign: l1.INHERIT,
                    columnalign: l1.INHERIT,
                    groupalign: l1.INHERIT
                }), e1;
            }(a1.AbstractMmlNode);
            e1.MmlMtr = u1;
            var p1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mlabeledtr";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(u1);
            e1.MmlMlabeledtr = p1;
        },
        5184: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlMover = e1.MmlMunder = e1.MmlMunderover = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "munderover";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 3;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "base", {
                    get: function() {
                        return 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "under", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "over", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "linebreakContainer", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function(t1, e1, r1, n1) {
                    var o1 = this.childNodes;
                    o1[0].setInheritedAttributes(t1, e1, r1, n1 || !!o1[this.over]);
                    var i1 = !(e1 || !o1[0].coreMO().attributes.get("movablelimits")), s1 = this.constructor.ACCENTS;
                    o1[1].setInheritedAttributes(t1, !1, this.getScriptlevel(s1[1], i1, r1), n1 || 1 === this.under), this.setInheritedAccent(1, s1[1], e1, r1, n1, i1), o1[2] && (o1[2].setInheritedAttributes(t1, !1, this.getScriptlevel(s1[2], i1, r1), n1 || 2 === this.under), this.setInheritedAccent(2, s1[2], e1, r1, n1, i1));
                }, e1.prototype.getScriptlevel = function(t1, e1, r1) {
                    return !e1 && this.attributes.get(t1) || r1++, r1;
                }, e1.prototype.setInheritedAccent = function(t1, e1, r1, n1, o1, i1) {
                    var s1 = this.childNodes[t1];
                    if (null == this.attributes.getExplicit(e1) && s1.isEmbellished) {
                        var a1 = s1.coreMO().attributes.get("accent");
                        this.attributes.setInherited(e1, a1), a1 !== this.attributes.getDefault(e1) && s1.setInheritedAttributes({}, r1, this.getScriptlevel(e1, i1, n1), o1);
                    }
                }, e1.defaults = i1(i1({}, s1.AbstractMmlBaseNode.defaults), {
                    accent: !1,
                    accentunder: !1,
                    align: "center"
                }), e1.ACCENTS = [
                    "",
                    "accentunder",
                    "accent"
                ], e1;
            }(s1.AbstractMmlBaseNode);
            e1.MmlMunderover = a1;
            var l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "munder";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, a1.defaults), e1;
            }(a1);
            e1.MmlMunder = l1;
            var c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mover";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "over", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "under", {
                    get: function() {
                        return 2;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, a1.defaults), e1.ACCENTS = [
                    "",
                    "accent",
                    "accentunder"
                ], e1;
            }(a1);
            e1.MmlMover = c1;
        },
        9102: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlAnnotation = e1.MmlAnnotationXML = e1.MmlSemantics = void 0;
            var s1 = r1(9007), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "semantics";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "arity", {
                    get: function() {
                        return 1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "notParent", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1(i1({}, s1.AbstractMmlBaseNode.defaults), {
                    definitionUrl: null,
                    encoding: null
                }), e1;
            }(s1.AbstractMmlBaseNode);
            e1.MmlSemantics = a1;
            var l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "annotation-xml";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.setChildInheritedAttributes = function() {}, e1.defaults = i1(i1({}, s1.AbstractMmlNode.defaults), {
                    definitionUrl: null,
                    encoding: null,
                    cd: "mathmlkeys",
                    name: "",
                    src: null
                }), e1;
            }(s1.AbstractMmlNode);
            e1.MmlAnnotationXML = l1;
            var c1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.properties = {
                        isChars: !0
                    }, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "annotation";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaults = i1({}, l1.defaults), e1;
            }(l1);
            e1.MmlAnnotation = c1;
        },
        6325: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlVisitor = void 0;
            var i1 = r1(3909), s1 = function(t1) {
                function e1(e1) {
                    return void 0 === e1 && (e1 = null), e1 || (e1 = new i1.MmlFactory), t1.call(this, e1) || this;
                }
                return o1(e1, t1), e1.prototype.visitTextNode = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                }, e1.prototype.visitXMLNode = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                }, e1;
            }(r1(8823).AbstractVisitor);
            e1.MmlVisitor = s1;
        },
        4082: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.OPTABLE = e1.MMLSPACING = e1.getRange = e1.RANGES = e1.MO = e1.OPDEF = void 0;
            var o1 = r1(9007);
            function i1(t1, e1, r1, n1) {
                return void 0 === r1 && (r1 = o1.TEXCLASS.BIN), void 0 === n1 && (n1 = null), [
                    t1,
                    e1,
                    r1,
                    n1
                ];
            }
            e1.OPDEF = i1, e1.MO = {
                ORD: i1(0, 0, o1.TEXCLASS.ORD),
                ORD11: i1(1, 1, o1.TEXCLASS.ORD),
                ORD21: i1(2, 1, o1.TEXCLASS.ORD),
                ORD02: i1(0, 2, o1.TEXCLASS.ORD),
                ORD55: i1(5, 5, o1.TEXCLASS.ORD),
                NONE: i1(0, 0, o1.TEXCLASS.NONE),
                OP: i1(1, 2, o1.TEXCLASS.OP, {
                    largeop: !0,
                    movablelimits: !0,
                    symmetric: !0
                }),
                OPFIXED: i1(1, 2, o1.TEXCLASS.OP, {
                    largeop: !0,
                    movablelimits: !0
                }),
                INTEGRAL: i1(0, 1, o1.TEXCLASS.OP, {
                    largeop: !0,
                    symmetric: !0
                }),
                INTEGRAL2: i1(1, 2, o1.TEXCLASS.OP, {
                    largeop: !0,
                    symmetric: !0
                }),
                BIN3: i1(3, 3, o1.TEXCLASS.BIN),
                BIN4: i1(4, 4, o1.TEXCLASS.BIN),
                BIN01: i1(0, 1, o1.TEXCLASS.BIN),
                BIN5: i1(5, 5, o1.TEXCLASS.BIN),
                TALLBIN: i1(4, 4, o1.TEXCLASS.BIN, {
                    stretchy: !0
                }),
                BINOP: i1(4, 4, o1.TEXCLASS.BIN, {
                    largeop: !0,
                    movablelimits: !0
                }),
                REL: i1(5, 5, o1.TEXCLASS.REL),
                REL1: i1(1, 1, o1.TEXCLASS.REL, {
                    stretchy: !0
                }),
                REL4: i1(4, 4, o1.TEXCLASS.REL),
                RELSTRETCH: i1(5, 5, o1.TEXCLASS.REL, {
                    stretchy: !0
                }),
                RELACCENT: i1(5, 5, o1.TEXCLASS.REL, {
                    accent: !0
                }),
                WIDEREL: i1(5, 5, o1.TEXCLASS.REL, {
                    accent: !0,
                    stretchy: !0
                }),
                OPEN: i1(0, 0, o1.TEXCLASS.OPEN, {
                    fence: !0,
                    stretchy: !0,
                    symmetric: !0
                }),
                CLOSE: i1(0, 0, o1.TEXCLASS.CLOSE, {
                    fence: !0,
                    stretchy: !0,
                    symmetric: !0
                }),
                INNER: i1(0, 0, o1.TEXCLASS.INNER),
                PUNCT: i1(0, 3, o1.TEXCLASS.PUNCT),
                ACCENT: i1(0, 0, o1.TEXCLASS.ORD, {
                    accent: !0
                }),
                WIDEACCENT: i1(0, 0, o1.TEXCLASS.ORD, {
                    accent: !0,
                    stretchy: !0
                })
            }, e1.RANGES = [
                [
                    32,
                    127,
                    o1.TEXCLASS.REL,
                    "mo"
                ],
                [
                    160,
                    191,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    192,
                    591,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    688,
                    879,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    880,
                    6688,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    6832,
                    6911,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    6912,
                    7615,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    7616,
                    7679,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    7680,
                    8191,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    8192,
                    8303,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    8304,
                    8351,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    8448,
                    8527,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    8528,
                    8591,
                    o1.TEXCLASS.ORD,
                    "mn"
                ],
                [
                    8592,
                    8703,
                    o1.TEXCLASS.REL,
                    "mo"
                ],
                [
                    8704,
                    8959,
                    o1.TEXCLASS.BIN,
                    "mo"
                ],
                [
                    8960,
                    9215,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    9312,
                    9471,
                    o1.TEXCLASS.ORD,
                    "mn"
                ],
                [
                    9472,
                    10223,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    10224,
                    10239,
                    o1.TEXCLASS.REL,
                    "mo"
                ],
                [
                    10240,
                    10495,
                    o1.TEXCLASS.ORD,
                    "mtext"
                ],
                [
                    10496,
                    10623,
                    o1.TEXCLASS.REL,
                    "mo"
                ],
                [
                    10624,
                    10751,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    10752,
                    11007,
                    o1.TEXCLASS.BIN,
                    "mo"
                ],
                [
                    11008,
                    11055,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    11056,
                    11087,
                    o1.TEXCLASS.REL,
                    "mo"
                ],
                [
                    11088,
                    11263,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    11264,
                    11744,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    11776,
                    11903,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    11904,
                    12255,
                    o1.TEXCLASS.ORD,
                    "mi",
                    "normal"
                ],
                [
                    12272,
                    12351,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    12352,
                    42143,
                    o1.TEXCLASS.ORD,
                    "mi",
                    "normal"
                ],
                [
                    42192,
                    43055,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    43056,
                    43071,
                    o1.TEXCLASS.ORD,
                    "mn"
                ],
                [
                    43072,
                    55295,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    63744,
                    64255,
                    o1.TEXCLASS.ORD,
                    "mi",
                    "normal"
                ],
                [
                    64256,
                    65023,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    65024,
                    65135,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    65136,
                    65791,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    65792,
                    65935,
                    o1.TEXCLASS.ORD,
                    "mn"
                ],
                [
                    65936,
                    74751,
                    o1.TEXCLASS.ORD,
                    "mi",
                    "normal"
                ],
                [
                    74752,
                    74879,
                    o1.TEXCLASS.ORD,
                    "mn"
                ],
                [
                    74880,
                    113823,
                    o1.TEXCLASS.ORD,
                    "mi",
                    "normal"
                ],
                [
                    113824,
                    119391,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    119648,
                    119679,
                    o1.TEXCLASS.ORD,
                    "mn"
                ],
                [
                    119808,
                    120781,
                    o1.TEXCLASS.ORD,
                    "mi"
                ],
                [
                    120782,
                    120831,
                    o1.TEXCLASS.ORD,
                    "mn"
                ],
                [
                    122624,
                    129023,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    129024,
                    129279,
                    o1.TEXCLASS.REL,
                    "mo"
                ],
                [
                    129280,
                    129535,
                    o1.TEXCLASS.ORD,
                    "mo"
                ],
                [
                    131072,
                    195103,
                    o1.TEXCLASS.ORD,
                    "mi",
                    "normnal"
                ]
            ], e1.getRange = function(t1) {
                var r1, o1, i1 = t1.codePointAt(0);
                try {
                    for(var s1 = n1(e1.RANGES), a1 = s1.next(); !a1.done; a1 = s1.next()){
                        var l1 = a1.value;
                        if (i1 <= l1[1]) {
                            if (i1 >= l1[0]) return l1;
                            break;
                        }
                    }
                } catch (t1) {
                    r1 = {
                        error: t1
                    };
                } finally{
                    try {
                        a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                    } finally{
                        if (r1) throw r1.error;
                    }
                }
                return null;
            }, e1.MMLSPACING = [
                [
                    0,
                    0
                ],
                [
                    1,
                    2
                ],
                [
                    3,
                    3
                ],
                [
                    4,
                    4
                ],
                [
                    0,
                    0
                ],
                [
                    0,
                    0
                ],
                [
                    0,
                    3
                ]
            ], e1.OPTABLE = {
                prefix: {
                    "(": e1.MO.OPEN,
                    "+": e1.MO.BIN01,
                    "-": e1.MO.BIN01,
                    "[": e1.MO.OPEN,
                    "{": e1.MO.OPEN,
                    "|": e1.MO.OPEN,
                    "||": [
                        0,
                        0,
                        o1.TEXCLASS.BIN,
                        {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0
                        }
                    ],
                    "|||": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0
                        }
                    ],
                    "\xac": e1.MO.ORD21,
                    "\xb1": e1.MO.BIN01,
                    "‖": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0
                        }
                    ],
                    "‘": [
                        0,
                        0,
                        o1.TEXCLASS.OPEN,
                        {
                            fence: !0
                        }
                    ],
                    "“": [
                        0,
                        0,
                        o1.TEXCLASS.OPEN,
                        {
                            fence: !0
                        }
                    ],
                    "ⅅ": e1.MO.ORD21,
                    "ⅆ": i1(2, 0, o1.TEXCLASS.ORD),
                    "∀": e1.MO.ORD21,
                    "∂": e1.MO.ORD21,
                    "∃": e1.MO.ORD21,
                    "∄": e1.MO.ORD21,
                    "∇": e1.MO.ORD21,
                    "∏": e1.MO.OP,
                    "∐": e1.MO.OP,
                    "∑": e1.MO.OP,
                    "−": e1.MO.BIN01,
                    "∓": e1.MO.BIN01,
                    "√": [
                        1,
                        1,
                        o1.TEXCLASS.ORD,
                        {
                            stretchy: !0
                        }
                    ],
                    "∛": e1.MO.ORD11,
                    "∜": e1.MO.ORD11,
                    "∠": e1.MO.ORD,
                    "∡": e1.MO.ORD,
                    "∢": e1.MO.ORD,
                    "∫": e1.MO.INTEGRAL,
                    "∬": e1.MO.INTEGRAL,
                    "∭": e1.MO.INTEGRAL,
                    "∮": e1.MO.INTEGRAL,
                    "∯": e1.MO.INTEGRAL,
                    "∰": e1.MO.INTEGRAL,
                    "∱": e1.MO.INTEGRAL,
                    "∲": e1.MO.INTEGRAL,
                    "∳": e1.MO.INTEGRAL,
                    "⋀": e1.MO.OP,
                    "⋁": e1.MO.OP,
                    "⋂": e1.MO.OP,
                    "⋃": e1.MO.OP,
                    "⌈": e1.MO.OPEN,
                    "⌊": e1.MO.OPEN,
                    "〈": e1.MO.OPEN,
                    "❲": e1.MO.OPEN,
                    "⟦": e1.MO.OPEN,
                    "⟨": e1.MO.OPEN,
                    "⟪": e1.MO.OPEN,
                    "⟬": e1.MO.OPEN,
                    "⟮": e1.MO.OPEN,
                    "⦀": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0
                        }
                    ],
                    "⦃": e1.MO.OPEN,
                    "⦅": e1.MO.OPEN,
                    "⦇": e1.MO.OPEN,
                    "⦉": e1.MO.OPEN,
                    "⦋": e1.MO.OPEN,
                    "⦍": e1.MO.OPEN,
                    "⦏": e1.MO.OPEN,
                    "⦑": e1.MO.OPEN,
                    "⦓": e1.MO.OPEN,
                    "⦕": e1.MO.OPEN,
                    "⦗": e1.MO.OPEN,
                    "⧼": e1.MO.OPEN,
                    "⨀": e1.MO.OP,
                    "⨁": e1.MO.OP,
                    "⨂": e1.MO.OP,
                    "⨃": e1.MO.OP,
                    "⨄": e1.MO.OP,
                    "⨅": e1.MO.OP,
                    "⨆": e1.MO.OP,
                    "⨇": e1.MO.OP,
                    "⨈": e1.MO.OP,
                    "⨉": e1.MO.OP,
                    "⨊": e1.MO.OP,
                    "⨋": e1.MO.INTEGRAL2,
                    "⨌": e1.MO.INTEGRAL,
                    "⨍": e1.MO.INTEGRAL2,
                    "⨎": e1.MO.INTEGRAL2,
                    "⨏": e1.MO.INTEGRAL2,
                    "⨐": e1.MO.OP,
                    "⨑": e1.MO.OP,
                    "⨒": e1.MO.OP,
                    "⨓": e1.MO.OP,
                    "⨔": e1.MO.OP,
                    "⨕": e1.MO.INTEGRAL2,
                    "⨖": e1.MO.INTEGRAL2,
                    "⨗": e1.MO.INTEGRAL2,
                    "⨘": e1.MO.INTEGRAL2,
                    "⨙": e1.MO.INTEGRAL2,
                    "⨚": e1.MO.INTEGRAL2,
                    "⨛": e1.MO.INTEGRAL2,
                    "⨜": e1.MO.INTEGRAL2,
                    "⫼": e1.MO.OP,
                    "⫿": e1.MO.OP
                },
                postfix: {
                    "!!": i1(1, 0),
                    "!": [
                        1,
                        0,
                        o1.TEXCLASS.CLOSE,
                        null
                    ],
                    '"': e1.MO.ACCENT,
                    "&": e1.MO.ORD,
                    ")": e1.MO.CLOSE,
                    "++": i1(0, 0),
                    "--": i1(0, 0),
                    "..": i1(0, 0),
                    "...": e1.MO.ORD,
                    "'": e1.MO.ACCENT,
                    "]": e1.MO.CLOSE,
                    "^": e1.MO.WIDEACCENT,
                    _: e1.MO.WIDEACCENT,
                    "`": e1.MO.ACCENT,
                    "|": e1.MO.CLOSE,
                    "}": e1.MO.CLOSE,
                    "~": e1.MO.WIDEACCENT,
                    "||": [
                        0,
                        0,
                        o1.TEXCLASS.BIN,
                        {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0
                        }
                    ],
                    "|||": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0
                        }
                    ],
                    "\xa8": e1.MO.ACCENT,
                    "\xaa": e1.MO.ACCENT,
                    "\xaf": e1.MO.WIDEACCENT,
                    "\xb0": e1.MO.ORD,
                    "\xb2": e1.MO.ACCENT,
                    "\xb3": e1.MO.ACCENT,
                    "\xb4": e1.MO.ACCENT,
                    "\xb8": e1.MO.ACCENT,
                    "\xb9": e1.MO.ACCENT,
                    "\xba": e1.MO.ACCENT,
                    "ˆ": e1.MO.WIDEACCENT,
                    "ˇ": e1.MO.WIDEACCENT,
                    "ˉ": e1.MO.WIDEACCENT,
                    "ˊ": e1.MO.ACCENT,
                    "ˋ": e1.MO.ACCENT,
                    "ˍ": e1.MO.WIDEACCENT,
                    "˘": e1.MO.ACCENT,
                    "˙": e1.MO.ACCENT,
                    "˚": e1.MO.ACCENT,
                    "˜": e1.MO.WIDEACCENT,
                    "˝": e1.MO.ACCENT,
                    "˷": e1.MO.WIDEACCENT,
                    "̂": e1.MO.WIDEACCENT,
                    "̑": e1.MO.ACCENT,
                    "϶": e1.MO.REL,
                    "‖": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0
                        }
                    ],
                    "’": [
                        0,
                        0,
                        o1.TEXCLASS.CLOSE,
                        {
                            fence: !0
                        }
                    ],
                    "‚": e1.MO.ACCENT,
                    "‛": e1.MO.ACCENT,
                    "”": [
                        0,
                        0,
                        o1.TEXCLASS.CLOSE,
                        {
                            fence: !0
                        }
                    ],
                    "„": e1.MO.ACCENT,
                    "‟": e1.MO.ACCENT,
                    "′": e1.MO.ORD,
                    "″": e1.MO.ACCENT,
                    "‴": e1.MO.ACCENT,
                    "‵": e1.MO.ACCENT,
                    "‶": e1.MO.ACCENT,
                    "‷": e1.MO.ACCENT,
                    "‾": e1.MO.WIDEACCENT,
                    "⁗": e1.MO.ACCENT,
                    "⃛": e1.MO.ACCENT,
                    "⃜": e1.MO.ACCENT,
                    "⌉": e1.MO.CLOSE,
                    "⌋": e1.MO.CLOSE,
                    "〉": e1.MO.CLOSE,
                    "⎴": e1.MO.WIDEACCENT,
                    "⎵": e1.MO.WIDEACCENT,
                    "⏜": e1.MO.WIDEACCENT,
                    "⏝": e1.MO.WIDEACCENT,
                    "⏞": e1.MO.WIDEACCENT,
                    "⏟": e1.MO.WIDEACCENT,
                    "⏠": e1.MO.WIDEACCENT,
                    "⏡": e1.MO.WIDEACCENT,
                    "■": e1.MO.BIN3,
                    "□": e1.MO.BIN3,
                    "▪": e1.MO.BIN3,
                    "▫": e1.MO.BIN3,
                    "▭": e1.MO.BIN3,
                    "▮": e1.MO.BIN3,
                    "▯": e1.MO.BIN3,
                    "▰": e1.MO.BIN3,
                    "▱": e1.MO.BIN3,
                    "▲": e1.MO.BIN4,
                    "▴": e1.MO.BIN4,
                    "▶": e1.MO.BIN4,
                    "▷": e1.MO.BIN4,
                    "▸": e1.MO.BIN4,
                    "▼": e1.MO.BIN4,
                    "▾": e1.MO.BIN4,
                    "◀": e1.MO.BIN4,
                    "◁": e1.MO.BIN4,
                    "◂": e1.MO.BIN4,
                    "◄": e1.MO.BIN4,
                    "◅": e1.MO.BIN4,
                    "◆": e1.MO.BIN4,
                    "◇": e1.MO.BIN4,
                    "◈": e1.MO.BIN4,
                    "◉": e1.MO.BIN4,
                    "◌": e1.MO.BIN4,
                    "◍": e1.MO.BIN4,
                    "◎": e1.MO.BIN4,
                    "●": e1.MO.BIN4,
                    "◖": e1.MO.BIN4,
                    "◗": e1.MO.BIN4,
                    "◦": e1.MO.BIN4,
                    "♭": e1.MO.ORD02,
                    "♮": e1.MO.ORD02,
                    "♯": e1.MO.ORD02,
                    "❳": e1.MO.CLOSE,
                    "⟧": e1.MO.CLOSE,
                    "⟩": e1.MO.CLOSE,
                    "⟫": e1.MO.CLOSE,
                    "⟭": e1.MO.CLOSE,
                    "⟯": e1.MO.CLOSE,
                    "⦀": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0
                        }
                    ],
                    "⦄": e1.MO.CLOSE,
                    "⦆": e1.MO.CLOSE,
                    "⦈": e1.MO.CLOSE,
                    "⦊": e1.MO.CLOSE,
                    "⦌": e1.MO.CLOSE,
                    "⦎": e1.MO.CLOSE,
                    "⦐": e1.MO.CLOSE,
                    "⦒": e1.MO.CLOSE,
                    "⦔": e1.MO.CLOSE,
                    "⦖": e1.MO.CLOSE,
                    "⦘": e1.MO.CLOSE,
                    "⧽": e1.MO.CLOSE
                },
                infix: {
                    "!=": e1.MO.BIN4,
                    "#": e1.MO.ORD,
                    $: e1.MO.ORD,
                    "%": [
                        3,
                        3,
                        o1.TEXCLASS.ORD,
                        null
                    ],
                    "&&": e1.MO.BIN4,
                    "": e1.MO.ORD,
                    "*": e1.MO.BIN3,
                    "**": i1(1, 1),
                    "*=": e1.MO.BIN4,
                    "+": e1.MO.BIN4,
                    "+=": e1.MO.BIN4,
                    ",": [
                        0,
                        3,
                        o1.TEXCLASS.PUNCT,
                        {
                            linebreakstyle: "after",
                            separator: !0
                        }
                    ],
                    "-": e1.MO.BIN4,
                    "-=": e1.MO.BIN4,
                    "->": e1.MO.BIN5,
                    ".": [
                        0,
                        3,
                        o1.TEXCLASS.PUNCT,
                        {
                            separator: !0
                        }
                    ],
                    "/": e1.MO.ORD11,
                    "//": i1(1, 1),
                    "/=": e1.MO.BIN4,
                    ":": [
                        1,
                        2,
                        o1.TEXCLASS.REL,
                        null
                    ],
                    ":=": e1.MO.BIN4,
                    ";": [
                        0,
                        3,
                        o1.TEXCLASS.PUNCT,
                        {
                            linebreakstyle: "after",
                            separator: !0
                        }
                    ],
                    "<": e1.MO.REL,
                    "<=": e1.MO.BIN5,
                    "<>": i1(1, 1),
                    "=": e1.MO.REL,
                    "==": e1.MO.BIN4,
                    ">": e1.MO.REL,
                    ">=": e1.MO.BIN5,
                    "?": [
                        1,
                        1,
                        o1.TEXCLASS.CLOSE,
                        null
                    ],
                    "@": e1.MO.ORD11,
                    "\\": e1.MO.ORD,
                    "^": e1.MO.ORD11,
                    _: e1.MO.ORD11,
                    "|": [
                        2,
                        2,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0
                        }
                    ],
                    "||": [
                        2,
                        2,
                        o1.TEXCLASS.BIN,
                        {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0
                        }
                    ],
                    "|||": [
                        2,
                        2,
                        o1.TEXCLASS.ORD,
                        {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0
                        }
                    ],
                    "\xb1": e1.MO.BIN4,
                    "\xb7": e1.MO.BIN4,
                    "\xd7": e1.MO.BIN4,
                    "\xf7": e1.MO.BIN4,
                    "ʹ": e1.MO.ORD,
                    "̀": e1.MO.ACCENT,
                    "́": e1.MO.ACCENT,
                    "̃": e1.MO.WIDEACCENT,
                    "̄": e1.MO.ACCENT,
                    "̆": e1.MO.ACCENT,
                    "̇": e1.MO.ACCENT,
                    "̈": e1.MO.ACCENT,
                    "̌": e1.MO.ACCENT,
                    "̲": e1.MO.WIDEACCENT,
                    "̸": e1.MO.REL4,
                    "―": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            stretchy: !0
                        }
                    ],
                    "‗": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            stretchy: !0
                        }
                    ],
                    "†": e1.MO.BIN3,
                    "‡": e1.MO.BIN3,
                    "•": e1.MO.BIN4,
                    "…": e1.MO.INNER,
                    "⁃": e1.MO.BIN4,
                    "⁄": e1.MO.TALLBIN,
                    "⁡": e1.MO.NONE,
                    "⁢": e1.MO.NONE,
                    "⁣": [
                        0,
                        0,
                        o1.TEXCLASS.NONE,
                        {
                            linebreakstyle: "after",
                            separator: !0
                        }
                    ],
                    "⁤": e1.MO.NONE,
                    "⃗": e1.MO.ACCENT,
                    "ℑ": e1.MO.ORD,
                    "ℓ": e1.MO.ORD,
                    "℘": e1.MO.ORD,
                    "ℜ": e1.MO.ORD,
                    "←": e1.MO.WIDEREL,
                    "↑": e1.MO.RELSTRETCH,
                    "→": e1.MO.WIDEREL,
                    "↓": e1.MO.RELSTRETCH,
                    "↔": e1.MO.WIDEREL,
                    "↕": e1.MO.RELSTRETCH,
                    "↖": e1.MO.RELSTRETCH,
                    "↗": e1.MO.RELSTRETCH,
                    "↘": e1.MO.RELSTRETCH,
                    "↙": e1.MO.RELSTRETCH,
                    "↚": e1.MO.RELACCENT,
                    "↛": e1.MO.RELACCENT,
                    "↜": e1.MO.WIDEREL,
                    "↝": e1.MO.WIDEREL,
                    "↞": e1.MO.WIDEREL,
                    "↟": e1.MO.WIDEREL,
                    "↠": e1.MO.WIDEREL,
                    "↡": e1.MO.RELSTRETCH,
                    "↢": e1.MO.WIDEREL,
                    "↣": e1.MO.WIDEREL,
                    "↤": e1.MO.WIDEREL,
                    "↥": e1.MO.RELSTRETCH,
                    "↦": e1.MO.WIDEREL,
                    "↧": e1.MO.RELSTRETCH,
                    "↨": e1.MO.RELSTRETCH,
                    "↩": e1.MO.WIDEREL,
                    "↪": e1.MO.WIDEREL,
                    "↫": e1.MO.WIDEREL,
                    "↬": e1.MO.WIDEREL,
                    "↭": e1.MO.WIDEREL,
                    "↮": e1.MO.RELACCENT,
                    "↯": e1.MO.RELSTRETCH,
                    "↰": e1.MO.RELSTRETCH,
                    "↱": e1.MO.RELSTRETCH,
                    "↲": e1.MO.RELSTRETCH,
                    "↳": e1.MO.RELSTRETCH,
                    "↴": e1.MO.RELSTRETCH,
                    "↵": e1.MO.RELSTRETCH,
                    "↶": e1.MO.RELACCENT,
                    "↷": e1.MO.RELACCENT,
                    "↸": e1.MO.REL,
                    "↹": e1.MO.WIDEREL,
                    "↺": e1.MO.REL,
                    "↻": e1.MO.REL,
                    "↼": e1.MO.WIDEREL,
                    "↽": e1.MO.WIDEREL,
                    "↾": e1.MO.RELSTRETCH,
                    "↿": e1.MO.RELSTRETCH,
                    "⇀": e1.MO.WIDEREL,
                    "⇁": e1.MO.WIDEREL,
                    "⇂": e1.MO.RELSTRETCH,
                    "⇃": e1.MO.RELSTRETCH,
                    "⇄": e1.MO.WIDEREL,
                    "⇅": e1.MO.RELSTRETCH,
                    "⇆": e1.MO.WIDEREL,
                    "⇇": e1.MO.WIDEREL,
                    "⇈": e1.MO.RELSTRETCH,
                    "⇉": e1.MO.WIDEREL,
                    "⇊": e1.MO.RELSTRETCH,
                    "⇋": e1.MO.WIDEREL,
                    "⇌": e1.MO.WIDEREL,
                    "⇍": e1.MO.RELACCENT,
                    "⇎": e1.MO.RELACCENT,
                    "⇏": e1.MO.RELACCENT,
                    "⇐": e1.MO.WIDEREL,
                    "⇑": e1.MO.RELSTRETCH,
                    "⇒": e1.MO.WIDEREL,
                    "⇓": e1.MO.RELSTRETCH,
                    "⇔": e1.MO.WIDEREL,
                    "⇕": e1.MO.RELSTRETCH,
                    "⇖": e1.MO.RELSTRETCH,
                    "⇗": e1.MO.RELSTRETCH,
                    "⇘": e1.MO.RELSTRETCH,
                    "⇙": e1.MO.RELSTRETCH,
                    "⇚": e1.MO.WIDEREL,
                    "⇛": e1.MO.WIDEREL,
                    "⇜": e1.MO.WIDEREL,
                    "⇝": e1.MO.WIDEREL,
                    "⇞": e1.MO.REL,
                    "⇟": e1.MO.REL,
                    "⇠": e1.MO.WIDEREL,
                    "⇡": e1.MO.RELSTRETCH,
                    "⇢": e1.MO.WIDEREL,
                    "⇣": e1.MO.RELSTRETCH,
                    "⇤": e1.MO.WIDEREL,
                    "⇥": e1.MO.WIDEREL,
                    "⇦": e1.MO.WIDEREL,
                    "⇧": e1.MO.RELSTRETCH,
                    "⇨": e1.MO.WIDEREL,
                    "⇩": e1.MO.RELSTRETCH,
                    "⇪": e1.MO.RELSTRETCH,
                    "⇫": e1.MO.RELSTRETCH,
                    "⇬": e1.MO.RELSTRETCH,
                    "⇭": e1.MO.RELSTRETCH,
                    "⇮": e1.MO.RELSTRETCH,
                    "⇯": e1.MO.RELSTRETCH,
                    "⇰": e1.MO.WIDEREL,
                    "⇱": e1.MO.REL,
                    "⇲": e1.MO.REL,
                    "⇳": e1.MO.RELSTRETCH,
                    "⇴": e1.MO.RELACCENT,
                    "⇵": e1.MO.RELSTRETCH,
                    "⇶": e1.MO.WIDEREL,
                    "⇷": e1.MO.RELACCENT,
                    "⇸": e1.MO.RELACCENT,
                    "⇹": e1.MO.RELACCENT,
                    "⇺": e1.MO.RELACCENT,
                    "⇻": e1.MO.RELACCENT,
                    "⇼": e1.MO.RELACCENT,
                    "⇽": e1.MO.WIDEREL,
                    "⇾": e1.MO.WIDEREL,
                    "⇿": e1.MO.WIDEREL,
                    "∁": i1(1, 2, o1.TEXCLASS.ORD),
                    "∅": e1.MO.ORD,
                    "∆": e1.MO.BIN3,
                    "∈": e1.MO.REL,
                    "∉": e1.MO.REL,
                    "∊": e1.MO.REL,
                    "∋": e1.MO.REL,
                    "∌": e1.MO.REL,
                    "∍": e1.MO.REL,
                    "∎": e1.MO.BIN3,
                    "−": e1.MO.BIN4,
                    "∓": e1.MO.BIN4,
                    "∔": e1.MO.BIN4,
                    "∕": e1.MO.TALLBIN,
                    "∖": e1.MO.BIN4,
                    "∗": e1.MO.BIN4,
                    "∘": e1.MO.BIN4,
                    "∙": e1.MO.BIN4,
                    "∝": e1.MO.REL,
                    "∞": e1.MO.ORD,
                    "∟": e1.MO.REL,
                    "∣": e1.MO.REL,
                    "∤": e1.MO.REL,
                    "∥": e1.MO.REL,
                    "∦": e1.MO.REL,
                    "∧": e1.MO.BIN4,
                    "∨": e1.MO.BIN4,
                    "∩": e1.MO.BIN4,
                    "∪": e1.MO.BIN4,
                    "∴": e1.MO.REL,
                    "∵": e1.MO.REL,
                    "∶": e1.MO.REL,
                    "∷": e1.MO.REL,
                    "∸": e1.MO.BIN4,
                    "∹": e1.MO.REL,
                    "∺": e1.MO.BIN4,
                    "∻": e1.MO.REL,
                    "∼": e1.MO.REL,
                    "∽": e1.MO.REL,
                    "∽̱": e1.MO.BIN3,
                    "∾": e1.MO.REL,
                    "∿": e1.MO.BIN3,
                    "≀": e1.MO.BIN4,
                    "≁": e1.MO.REL,
                    "≂": e1.MO.REL,
                    "≂̸": e1.MO.REL,
                    "≃": e1.MO.REL,
                    "≄": e1.MO.REL,
                    "≅": e1.MO.REL,
                    "≆": e1.MO.REL,
                    "≇": e1.MO.REL,
                    "≈": e1.MO.REL,
                    "≉": e1.MO.REL,
                    "≊": e1.MO.REL,
                    "≋": e1.MO.REL,
                    "≌": e1.MO.REL,
                    "≍": e1.MO.REL,
                    "≎": e1.MO.REL,
                    "≎̸": e1.MO.REL,
                    "≏": e1.MO.REL,
                    "≏̸": e1.MO.REL,
                    "≐": e1.MO.REL,
                    "≑": e1.MO.REL,
                    "≒": e1.MO.REL,
                    "≓": e1.MO.REL,
                    "≔": e1.MO.REL,
                    "≕": e1.MO.REL,
                    "≖": e1.MO.REL,
                    "≗": e1.MO.REL,
                    "≘": e1.MO.REL,
                    "≙": e1.MO.REL,
                    "≚": e1.MO.REL,
                    "≛": e1.MO.REL,
                    "≜": e1.MO.REL,
                    "≝": e1.MO.REL,
                    "≞": e1.MO.REL,
                    "≟": e1.MO.REL,
                    "≠": e1.MO.REL,
                    "≡": e1.MO.REL,
                    "≢": e1.MO.REL,
                    "≣": e1.MO.REL,
                    "≤": e1.MO.REL,
                    "≥": e1.MO.REL,
                    "≦": e1.MO.REL,
                    "≦̸": e1.MO.REL,
                    "≧": e1.MO.REL,
                    "≨": e1.MO.REL,
                    "≩": e1.MO.REL,
                    "≪": e1.MO.REL,
                    "≪̸": e1.MO.REL,
                    "≫": e1.MO.REL,
                    "≫̸": e1.MO.REL,
                    "≬": e1.MO.REL,
                    "≭": e1.MO.REL,
                    "≮": e1.MO.REL,
                    "≯": e1.MO.REL,
                    "≰": e1.MO.REL,
                    "≱": e1.MO.REL,
                    "≲": e1.MO.REL,
                    "≳": e1.MO.REL,
                    "≴": e1.MO.REL,
                    "≵": e1.MO.REL,
                    "≶": e1.MO.REL,
                    "≷": e1.MO.REL,
                    "≸": e1.MO.REL,
                    "≹": e1.MO.REL,
                    "≺": e1.MO.REL,
                    "≻": e1.MO.REL,
                    "≼": e1.MO.REL,
                    "≽": e1.MO.REL,
                    "≾": e1.MO.REL,
                    "≿": e1.MO.REL,
                    "≿̸": e1.MO.REL,
                    "⊀": e1.MO.REL,
                    "⊁": e1.MO.REL,
                    "⊂": e1.MO.REL,
                    "⊂⃒": e1.MO.REL,
                    "⊃": e1.MO.REL,
                    "⊃⃒": e1.MO.REL,
                    "⊄": e1.MO.REL,
                    "⊅": e1.MO.REL,
                    "⊆": e1.MO.REL,
                    "⊇": e1.MO.REL,
                    "⊈": e1.MO.REL,
                    "⊉": e1.MO.REL,
                    "⊊": e1.MO.REL,
                    "⊋": e1.MO.REL,
                    "⊌": e1.MO.BIN4,
                    "⊍": e1.MO.BIN4,
                    "⊎": e1.MO.BIN4,
                    "⊏": e1.MO.REL,
                    "⊏̸": e1.MO.REL,
                    "⊐": e1.MO.REL,
                    "⊐̸": e1.MO.REL,
                    "⊑": e1.MO.REL,
                    "⊒": e1.MO.REL,
                    "⊓": e1.MO.BIN4,
                    "⊔": e1.MO.BIN4,
                    "⊕": e1.MO.BIN4,
                    "⊖": e1.MO.BIN4,
                    "⊗": e1.MO.BIN4,
                    "⊘": e1.MO.BIN4,
                    "⊙": e1.MO.BIN4,
                    "⊚": e1.MO.BIN4,
                    "⊛": e1.MO.BIN4,
                    "⊜": e1.MO.BIN4,
                    "⊝": e1.MO.BIN4,
                    "⊞": e1.MO.BIN4,
                    "⊟": e1.MO.BIN4,
                    "⊠": e1.MO.BIN4,
                    "⊡": e1.MO.BIN4,
                    "⊢": e1.MO.REL,
                    "⊣": e1.MO.REL,
                    "⊤": e1.MO.ORD55,
                    "⊥": e1.MO.REL,
                    "⊦": e1.MO.REL,
                    "⊧": e1.MO.REL,
                    "⊨": e1.MO.REL,
                    "⊩": e1.MO.REL,
                    "⊪": e1.MO.REL,
                    "⊫": e1.MO.REL,
                    "⊬": e1.MO.REL,
                    "⊭": e1.MO.REL,
                    "⊮": e1.MO.REL,
                    "⊯": e1.MO.REL,
                    "⊰": e1.MO.REL,
                    "⊱": e1.MO.REL,
                    "⊲": e1.MO.REL,
                    "⊳": e1.MO.REL,
                    "⊴": e1.MO.REL,
                    "⊵": e1.MO.REL,
                    "⊶": e1.MO.REL,
                    "⊷": e1.MO.REL,
                    "⊸": e1.MO.REL,
                    "⊹": e1.MO.REL,
                    "⊺": e1.MO.BIN4,
                    "⊻": e1.MO.BIN4,
                    "⊼": e1.MO.BIN4,
                    "⊽": e1.MO.BIN4,
                    "⊾": e1.MO.BIN3,
                    "⊿": e1.MO.BIN3,
                    "⋄": e1.MO.BIN4,
                    "⋅": e1.MO.BIN4,
                    "⋆": e1.MO.BIN4,
                    "⋇": e1.MO.BIN4,
                    "⋈": e1.MO.REL,
                    "⋉": e1.MO.BIN4,
                    "⋊": e1.MO.BIN4,
                    "⋋": e1.MO.BIN4,
                    "⋌": e1.MO.BIN4,
                    "⋍": e1.MO.REL,
                    "⋎": e1.MO.BIN4,
                    "⋏": e1.MO.BIN4,
                    "⋐": e1.MO.REL,
                    "⋑": e1.MO.REL,
                    "⋒": e1.MO.BIN4,
                    "⋓": e1.MO.BIN4,
                    "⋔": e1.MO.REL,
                    "⋕": e1.MO.REL,
                    "⋖": e1.MO.REL,
                    "⋗": e1.MO.REL,
                    "⋘": e1.MO.REL,
                    "⋙": e1.MO.REL,
                    "⋚": e1.MO.REL,
                    "⋛": e1.MO.REL,
                    "⋜": e1.MO.REL,
                    "⋝": e1.MO.REL,
                    "⋞": e1.MO.REL,
                    "⋟": e1.MO.REL,
                    "⋠": e1.MO.REL,
                    "⋡": e1.MO.REL,
                    "⋢": e1.MO.REL,
                    "⋣": e1.MO.REL,
                    "⋤": e1.MO.REL,
                    "⋥": e1.MO.REL,
                    "⋦": e1.MO.REL,
                    "⋧": e1.MO.REL,
                    "⋨": e1.MO.REL,
                    "⋩": e1.MO.REL,
                    "⋪": e1.MO.REL,
                    "⋫": e1.MO.REL,
                    "⋬": e1.MO.REL,
                    "⋭": e1.MO.REL,
                    "⋮": e1.MO.ORD55,
                    "⋯": e1.MO.INNER,
                    "⋰": e1.MO.REL,
                    "⋱": [
                        5,
                        5,
                        o1.TEXCLASS.INNER,
                        null
                    ],
                    "⋲": e1.MO.REL,
                    "⋳": e1.MO.REL,
                    "⋴": e1.MO.REL,
                    "⋵": e1.MO.REL,
                    "⋶": e1.MO.REL,
                    "⋷": e1.MO.REL,
                    "⋸": e1.MO.REL,
                    "⋹": e1.MO.REL,
                    "⋺": e1.MO.REL,
                    "⋻": e1.MO.REL,
                    "⋼": e1.MO.REL,
                    "⋽": e1.MO.REL,
                    "⋾": e1.MO.REL,
                    "⋿": e1.MO.REL,
                    "⌅": e1.MO.BIN3,
                    "⌆": e1.MO.BIN3,
                    "⌢": e1.MO.REL4,
                    "⌣": e1.MO.REL4,
                    "〈": e1.MO.OPEN,
                    "〉": e1.MO.CLOSE,
                    "⎪": e1.MO.ORD,
                    "⎯": [
                        0,
                        0,
                        o1.TEXCLASS.ORD,
                        {
                            stretchy: !0
                        }
                    ],
                    "⎰": e1.MO.OPEN,
                    "⎱": e1.MO.CLOSE,
                    "─": e1.MO.ORD,
                    "△": e1.MO.BIN4,
                    "▵": e1.MO.BIN4,
                    "▹": e1.MO.BIN4,
                    "▽": e1.MO.BIN4,
                    "▿": e1.MO.BIN4,
                    "◃": e1.MO.BIN4,
                    "◯": e1.MO.BIN3,
                    "♠": e1.MO.ORD,
                    "♡": e1.MO.ORD,
                    "♢": e1.MO.ORD,
                    "♣": e1.MO.ORD,
                    "❘": e1.MO.REL,
                    "⟰": e1.MO.RELSTRETCH,
                    "⟱": e1.MO.RELSTRETCH,
                    "⟵": e1.MO.WIDEREL,
                    "⟶": e1.MO.WIDEREL,
                    "⟷": e1.MO.WIDEREL,
                    "⟸": e1.MO.WIDEREL,
                    "⟹": e1.MO.WIDEREL,
                    "⟺": e1.MO.WIDEREL,
                    "⟻": e1.MO.WIDEREL,
                    "⟼": e1.MO.WIDEREL,
                    "⟽": e1.MO.WIDEREL,
                    "⟾": e1.MO.WIDEREL,
                    "⟿": e1.MO.WIDEREL,
                    "⤀": e1.MO.RELACCENT,
                    "⤁": e1.MO.RELACCENT,
                    "⤂": e1.MO.RELACCENT,
                    "⤃": e1.MO.RELACCENT,
                    "⤄": e1.MO.RELACCENT,
                    "⤅": e1.MO.RELACCENT,
                    "⤆": e1.MO.RELACCENT,
                    "⤇": e1.MO.RELACCENT,
                    "⤈": e1.MO.REL,
                    "⤉": e1.MO.REL,
                    "⤊": e1.MO.RELSTRETCH,
                    "⤋": e1.MO.RELSTRETCH,
                    "⤌": e1.MO.WIDEREL,
                    "⤍": e1.MO.WIDEREL,
                    "⤎": e1.MO.WIDEREL,
                    "⤏": e1.MO.WIDEREL,
                    "⤐": e1.MO.WIDEREL,
                    "⤑": e1.MO.RELACCENT,
                    "⤒": e1.MO.RELSTRETCH,
                    "⤓": e1.MO.RELSTRETCH,
                    "⤔": e1.MO.RELACCENT,
                    "⤕": e1.MO.RELACCENT,
                    "⤖": e1.MO.RELACCENT,
                    "⤗": e1.MO.RELACCENT,
                    "⤘": e1.MO.RELACCENT,
                    "⤙": e1.MO.RELACCENT,
                    "⤚": e1.MO.RELACCENT,
                    "⤛": e1.MO.RELACCENT,
                    "⤜": e1.MO.RELACCENT,
                    "⤝": e1.MO.RELACCENT,
                    "⤞": e1.MO.RELACCENT,
                    "⤟": e1.MO.RELACCENT,
                    "⤠": e1.MO.RELACCENT,
                    "⤡": e1.MO.RELSTRETCH,
                    "⤢": e1.MO.RELSTRETCH,
                    "⤣": e1.MO.REL,
                    "⤤": e1.MO.REL,
                    "⤥": e1.MO.REL,
                    "⤦": e1.MO.REL,
                    "⤧": e1.MO.REL,
                    "⤨": e1.MO.REL,
                    "⤩": e1.MO.REL,
                    "⤪": e1.MO.REL,
                    "⤫": e1.MO.REL,
                    "⤬": e1.MO.REL,
                    "⤭": e1.MO.REL,
                    "⤮": e1.MO.REL,
                    "⤯": e1.MO.REL,
                    "⤰": e1.MO.REL,
                    "⤱": e1.MO.REL,
                    "⤲": e1.MO.REL,
                    "⤳": e1.MO.RELACCENT,
                    "⤴": e1.MO.REL,
                    "⤵": e1.MO.REL,
                    "⤶": e1.MO.REL,
                    "⤷": e1.MO.REL,
                    "⤸": e1.MO.REL,
                    "⤹": e1.MO.REL,
                    "⤺": e1.MO.RELACCENT,
                    "⤻": e1.MO.RELACCENT,
                    "⤼": e1.MO.RELACCENT,
                    "⤽": e1.MO.RELACCENT,
                    "⤾": e1.MO.REL,
                    "⤿": e1.MO.REL,
                    "⥀": e1.MO.REL,
                    "⥁": e1.MO.REL,
                    "⥂": e1.MO.RELACCENT,
                    "⥃": e1.MO.RELACCENT,
                    "⥄": e1.MO.RELACCENT,
                    "⥅": e1.MO.RELACCENT,
                    "⥆": e1.MO.RELACCENT,
                    "⥇": e1.MO.RELACCENT,
                    "⥈": e1.MO.RELACCENT,
                    "⥉": e1.MO.REL,
                    "⥊": e1.MO.RELACCENT,
                    "⥋": e1.MO.RELACCENT,
                    "⥌": e1.MO.REL,
                    "⥍": e1.MO.REL,
                    "⥎": e1.MO.WIDEREL,
                    "⥏": e1.MO.RELSTRETCH,
                    "⥐": e1.MO.WIDEREL,
                    "⥑": e1.MO.RELSTRETCH,
                    "⥒": e1.MO.WIDEREL,
                    "⥓": e1.MO.WIDEREL,
                    "⥔": e1.MO.RELSTRETCH,
                    "⥕": e1.MO.RELSTRETCH,
                    "⥖": e1.MO.RELSTRETCH,
                    "⥗": e1.MO.RELSTRETCH,
                    "⥘": e1.MO.RELSTRETCH,
                    "⥙": e1.MO.RELSTRETCH,
                    "⥚": e1.MO.WIDEREL,
                    "⥛": e1.MO.WIDEREL,
                    "⥜": e1.MO.RELSTRETCH,
                    "⥝": e1.MO.RELSTRETCH,
                    "⥞": e1.MO.WIDEREL,
                    "⥟": e1.MO.WIDEREL,
                    "⥠": e1.MO.RELSTRETCH,
                    "⥡": e1.MO.RELSTRETCH,
                    "⥢": e1.MO.RELACCENT,
                    "⥣": e1.MO.REL,
                    "⥤": e1.MO.RELACCENT,
                    "⥥": e1.MO.REL,
                    "⥦": e1.MO.RELACCENT,
                    "⥧": e1.MO.RELACCENT,
                    "⥨": e1.MO.RELACCENT,
                    "⥩": e1.MO.RELACCENT,
                    "⥪": e1.MO.RELACCENT,
                    "⥫": e1.MO.RELACCENT,
                    "⥬": e1.MO.RELACCENT,
                    "⥭": e1.MO.RELACCENT,
                    "⥮": e1.MO.RELSTRETCH,
                    "⥯": e1.MO.RELSTRETCH,
                    "⥰": e1.MO.RELACCENT,
                    "⥱": e1.MO.RELACCENT,
                    "⥲": e1.MO.RELACCENT,
                    "⥳": e1.MO.RELACCENT,
                    "⥴": e1.MO.RELACCENT,
                    "⥵": e1.MO.RELACCENT,
                    "⥶": e1.MO.RELACCENT,
                    "⥷": e1.MO.RELACCENT,
                    "⥸": e1.MO.RELACCENT,
                    "⥹": e1.MO.RELACCENT,
                    "⥺": e1.MO.RELACCENT,
                    "⥻": e1.MO.RELACCENT,
                    "⥼": e1.MO.RELACCENT,
                    "⥽": e1.MO.RELACCENT,
                    "⥾": e1.MO.REL,
                    "⥿": e1.MO.REL,
                    "⦁": e1.MO.BIN3,
                    "⦂": e1.MO.BIN3,
                    "⦙": e1.MO.BIN3,
                    "⦚": e1.MO.BIN3,
                    "⦛": e1.MO.BIN3,
                    "⦜": e1.MO.BIN3,
                    "⦝": e1.MO.BIN3,
                    "⦞": e1.MO.BIN3,
                    "⦟": e1.MO.BIN3,
                    "⦠": e1.MO.BIN3,
                    "⦡": e1.MO.BIN3,
                    "⦢": e1.MO.BIN3,
                    "⦣": e1.MO.BIN3,
                    "⦤": e1.MO.BIN3,
                    "⦥": e1.MO.BIN3,
                    "⦦": e1.MO.BIN3,
                    "⦧": e1.MO.BIN3,
                    "⦨": e1.MO.BIN3,
                    "⦩": e1.MO.BIN3,
                    "⦪": e1.MO.BIN3,
                    "⦫": e1.MO.BIN3,
                    "⦬": e1.MO.BIN3,
                    "⦭": e1.MO.BIN3,
                    "⦮": e1.MO.BIN3,
                    "⦯": e1.MO.BIN3,
                    "⦰": e1.MO.BIN3,
                    "⦱": e1.MO.BIN3,
                    "⦲": e1.MO.BIN3,
                    "⦳": e1.MO.BIN3,
                    "⦴": e1.MO.BIN3,
                    "⦵": e1.MO.BIN3,
                    "⦶": e1.MO.BIN4,
                    "⦷": e1.MO.BIN4,
                    "⦸": e1.MO.BIN4,
                    "⦹": e1.MO.BIN4,
                    "⦺": e1.MO.BIN4,
                    "⦻": e1.MO.BIN4,
                    "⦼": e1.MO.BIN4,
                    "⦽": e1.MO.BIN4,
                    "⦾": e1.MO.BIN4,
                    "⦿": e1.MO.BIN4,
                    "⧀": e1.MO.REL,
                    "⧁": e1.MO.REL,
                    "⧂": e1.MO.BIN3,
                    "⧃": e1.MO.BIN3,
                    "⧄": e1.MO.BIN4,
                    "⧅": e1.MO.BIN4,
                    "⧆": e1.MO.BIN4,
                    "⧇": e1.MO.BIN4,
                    "⧈": e1.MO.BIN4,
                    "⧉": e1.MO.BIN3,
                    "⧊": e1.MO.BIN3,
                    "⧋": e1.MO.BIN3,
                    "⧌": e1.MO.BIN3,
                    "⧍": e1.MO.BIN3,
                    "⧎": e1.MO.REL,
                    "⧏": e1.MO.REL,
                    "⧏̸": e1.MO.REL,
                    "⧐": e1.MO.REL,
                    "⧐̸": e1.MO.REL,
                    "⧑": e1.MO.REL,
                    "⧒": e1.MO.REL,
                    "⧓": e1.MO.REL,
                    "⧔": e1.MO.REL,
                    "⧕": e1.MO.REL,
                    "⧖": e1.MO.BIN4,
                    "⧗": e1.MO.BIN4,
                    "⧘": e1.MO.BIN3,
                    "⧙": e1.MO.BIN3,
                    "⧛": e1.MO.BIN3,
                    "⧜": e1.MO.BIN3,
                    "⧝": e1.MO.BIN3,
                    "⧞": e1.MO.REL,
                    "⧟": e1.MO.BIN3,
                    "⧠": e1.MO.BIN3,
                    "⧡": e1.MO.REL,
                    "⧢": e1.MO.BIN4,
                    "⧣": e1.MO.REL,
                    "⧤": e1.MO.REL,
                    "⧥": e1.MO.REL,
                    "⧦": e1.MO.REL,
                    "⧧": e1.MO.BIN3,
                    "⧨": e1.MO.BIN3,
                    "⧩": e1.MO.BIN3,
                    "⧪": e1.MO.BIN3,
                    "⧫": e1.MO.BIN3,
                    "⧬": e1.MO.BIN3,
                    "⧭": e1.MO.BIN3,
                    "⧮": e1.MO.BIN3,
                    "⧯": e1.MO.BIN3,
                    "⧰": e1.MO.BIN3,
                    "⧱": e1.MO.BIN3,
                    "⧲": e1.MO.BIN3,
                    "⧳": e1.MO.BIN3,
                    "⧴": e1.MO.REL,
                    "⧵": e1.MO.BIN4,
                    "⧶": e1.MO.BIN4,
                    "⧷": e1.MO.BIN4,
                    "⧸": e1.MO.BIN3,
                    "⧹": e1.MO.BIN3,
                    "⧺": e1.MO.BIN3,
                    "⧻": e1.MO.BIN3,
                    "⧾": e1.MO.BIN4,
                    "⧿": e1.MO.BIN4,
                    "⨝": e1.MO.BIN3,
                    "⨞": e1.MO.BIN3,
                    "⨟": e1.MO.BIN3,
                    "⨠": e1.MO.BIN3,
                    "⨡": e1.MO.BIN3,
                    "⨢": e1.MO.BIN4,
                    "⨣": e1.MO.BIN4,
                    "⨤": e1.MO.BIN4,
                    "⨥": e1.MO.BIN4,
                    "⨦": e1.MO.BIN4,
                    "⨧": e1.MO.BIN4,
                    "⨨": e1.MO.BIN4,
                    "⨩": e1.MO.BIN4,
                    "⨪": e1.MO.BIN4,
                    "⨫": e1.MO.BIN4,
                    "⨬": e1.MO.BIN4,
                    "⨭": e1.MO.BIN4,
                    "⨮": e1.MO.BIN4,
                    "⨯": e1.MO.BIN4,
                    "⨰": e1.MO.BIN4,
                    "⨱": e1.MO.BIN4,
                    "⨲": e1.MO.BIN4,
                    "⨳": e1.MO.BIN4,
                    "⨴": e1.MO.BIN4,
                    "⨵": e1.MO.BIN4,
                    "⨶": e1.MO.BIN4,
                    "⨷": e1.MO.BIN4,
                    "⨸": e1.MO.BIN4,
                    "⨹": e1.MO.BIN4,
                    "⨺": e1.MO.BIN4,
                    "⨻": e1.MO.BIN4,
                    "⨼": e1.MO.BIN4,
                    "⨽": e1.MO.BIN4,
                    "⨾": e1.MO.BIN4,
                    "⨿": e1.MO.BIN4,
                    "⩀": e1.MO.BIN4,
                    "⩁": e1.MO.BIN4,
                    "⩂": e1.MO.BIN4,
                    "⩃": e1.MO.BIN4,
                    "⩄": e1.MO.BIN4,
                    "⩅": e1.MO.BIN4,
                    "⩆": e1.MO.BIN4,
                    "⩇": e1.MO.BIN4,
                    "⩈": e1.MO.BIN4,
                    "⩉": e1.MO.BIN4,
                    "⩊": e1.MO.BIN4,
                    "⩋": e1.MO.BIN4,
                    "⩌": e1.MO.BIN4,
                    "⩍": e1.MO.BIN4,
                    "⩎": e1.MO.BIN4,
                    "⩏": e1.MO.BIN4,
                    "⩐": e1.MO.BIN4,
                    "⩑": e1.MO.BIN4,
                    "⩒": e1.MO.BIN4,
                    "⩓": e1.MO.BIN4,
                    "⩔": e1.MO.BIN4,
                    "⩕": e1.MO.BIN4,
                    "⩖": e1.MO.BIN4,
                    "⩗": e1.MO.BIN4,
                    "⩘": e1.MO.BIN4,
                    "⩙": e1.MO.REL,
                    "⩚": e1.MO.BIN4,
                    "⩛": e1.MO.BIN4,
                    "⩜": e1.MO.BIN4,
                    "⩝": e1.MO.BIN4,
                    "⩞": e1.MO.BIN4,
                    "⩟": e1.MO.BIN4,
                    "⩠": e1.MO.BIN4,
                    "⩡": e1.MO.BIN4,
                    "⩢": e1.MO.BIN4,
                    "⩣": e1.MO.BIN4,
                    "⩤": e1.MO.BIN4,
                    "⩥": e1.MO.BIN4,
                    "⩦": e1.MO.REL,
                    "⩧": e1.MO.REL,
                    "⩨": e1.MO.REL,
                    "⩩": e1.MO.REL,
                    "⩪": e1.MO.REL,
                    "⩫": e1.MO.REL,
                    "⩬": e1.MO.REL,
                    "⩭": e1.MO.REL,
                    "⩮": e1.MO.REL,
                    "⩯": e1.MO.REL,
                    "⩰": e1.MO.REL,
                    "⩱": e1.MO.BIN4,
                    "⩲": e1.MO.BIN4,
                    "⩳": e1.MO.REL,
                    "⩴": e1.MO.REL,
                    "⩵": e1.MO.REL,
                    "⩶": e1.MO.REL,
                    "⩷": e1.MO.REL,
                    "⩸": e1.MO.REL,
                    "⩹": e1.MO.REL,
                    "⩺": e1.MO.REL,
                    "⩻": e1.MO.REL,
                    "⩼": e1.MO.REL,
                    "⩽": e1.MO.REL,
                    "⩽̸": e1.MO.REL,
                    "⩾": e1.MO.REL,
                    "⩾̸": e1.MO.REL,
                    "⩿": e1.MO.REL,
                    "⪀": e1.MO.REL,
                    "⪁": e1.MO.REL,
                    "⪂": e1.MO.REL,
                    "⪃": e1.MO.REL,
                    "⪄": e1.MO.REL,
                    "⪅": e1.MO.REL,
                    "⪆": e1.MO.REL,
                    "⪇": e1.MO.REL,
                    "⪈": e1.MO.REL,
                    "⪉": e1.MO.REL,
                    "⪊": e1.MO.REL,
                    "⪋": e1.MO.REL,
                    "⪌": e1.MO.REL,
                    "⪍": e1.MO.REL,
                    "⪎": e1.MO.REL,
                    "⪏": e1.MO.REL,
                    "⪐": e1.MO.REL,
                    "⪑": e1.MO.REL,
                    "⪒": e1.MO.REL,
                    "⪓": e1.MO.REL,
                    "⪔": e1.MO.REL,
                    "⪕": e1.MO.REL,
                    "⪖": e1.MO.REL,
                    "⪗": e1.MO.REL,
                    "⪘": e1.MO.REL,
                    "⪙": e1.MO.REL,
                    "⪚": e1.MO.REL,
                    "⪛": e1.MO.REL,
                    "⪜": e1.MO.REL,
                    "⪝": e1.MO.REL,
                    "⪞": e1.MO.REL,
                    "⪟": e1.MO.REL,
                    "⪠": e1.MO.REL,
                    "⪡": e1.MO.REL,
                    "⪡̸": e1.MO.REL,
                    "⪢": e1.MO.REL,
                    "⪢̸": e1.MO.REL,
                    "⪣": e1.MO.REL,
                    "⪤": e1.MO.REL,
                    "⪥": e1.MO.REL,
                    "⪦": e1.MO.REL,
                    "⪧": e1.MO.REL,
                    "⪨": e1.MO.REL,
                    "⪩": e1.MO.REL,
                    "⪪": e1.MO.REL,
                    "⪫": e1.MO.REL,
                    "⪬": e1.MO.REL,
                    "⪭": e1.MO.REL,
                    "⪮": e1.MO.REL,
                    "⪯": e1.MO.REL,
                    "⪯̸": e1.MO.REL,
                    "⪰": e1.MO.REL,
                    "⪰̸": e1.MO.REL,
                    "⪱": e1.MO.REL,
                    "⪲": e1.MO.REL,
                    "⪳": e1.MO.REL,
                    "⪴": e1.MO.REL,
                    "⪵": e1.MO.REL,
                    "⪶": e1.MO.REL,
                    "⪷": e1.MO.REL,
                    "⪸": e1.MO.REL,
                    "⪹": e1.MO.REL,
                    "⪺": e1.MO.REL,
                    "⪻": e1.MO.REL,
                    "⪼": e1.MO.REL,
                    "⪽": e1.MO.REL,
                    "⪾": e1.MO.REL,
                    "⪿": e1.MO.REL,
                    "⫀": e1.MO.REL,
                    "⫁": e1.MO.REL,
                    "⫂": e1.MO.REL,
                    "⫃": e1.MO.REL,
                    "⫄": e1.MO.REL,
                    "⫅": e1.MO.REL,
                    "⫆": e1.MO.REL,
                    "⫇": e1.MO.REL,
                    "⫈": e1.MO.REL,
                    "⫉": e1.MO.REL,
                    "⫊": e1.MO.REL,
                    "⫋": e1.MO.REL,
                    "⫌": e1.MO.REL,
                    "⫍": e1.MO.REL,
                    "⫎": e1.MO.REL,
                    "⫏": e1.MO.REL,
                    "⫐": e1.MO.REL,
                    "⫑": e1.MO.REL,
                    "⫒": e1.MO.REL,
                    "⫓": e1.MO.REL,
                    "⫔": e1.MO.REL,
                    "⫕": e1.MO.REL,
                    "⫖": e1.MO.REL,
                    "⫗": e1.MO.REL,
                    "⫘": e1.MO.REL,
                    "⫙": e1.MO.REL,
                    "⫚": e1.MO.REL,
                    "⫛": e1.MO.REL,
                    "⫝": e1.MO.REL,
                    "⫝̸": e1.MO.REL,
                    "⫞": e1.MO.REL,
                    "⫟": e1.MO.REL,
                    "⫠": e1.MO.REL,
                    "⫡": e1.MO.REL,
                    "⫢": e1.MO.REL,
                    "⫣": e1.MO.REL,
                    "⫤": e1.MO.REL,
                    "⫥": e1.MO.REL,
                    "⫦": e1.MO.REL,
                    "⫧": e1.MO.REL,
                    "⫨": e1.MO.REL,
                    "⫩": e1.MO.REL,
                    "⫪": e1.MO.REL,
                    "⫫": e1.MO.REL,
                    "⫬": e1.MO.REL,
                    "⫭": e1.MO.REL,
                    "⫮": e1.MO.REL,
                    "⫯": e1.MO.REL,
                    "⫰": e1.MO.REL,
                    "⫱": e1.MO.REL,
                    "⫲": e1.MO.REL,
                    "⫳": e1.MO.REL,
                    "⫴": e1.MO.BIN4,
                    "⫵": e1.MO.BIN4,
                    "⫶": e1.MO.BIN4,
                    "⫷": e1.MO.REL,
                    "⫸": e1.MO.REL,
                    "⫹": e1.MO.REL,
                    "⫺": e1.MO.REL,
                    "⫻": e1.MO.BIN4,
                    "⫽": e1.MO.BIN4,
                    "⫾": e1.MO.BIN3,
                    "⭅": e1.MO.RELSTRETCH,
                    "⭆": e1.MO.RELSTRETCH,
                    "〈": e1.MO.OPEN,
                    "〉": e1.MO.CLOSE,
                    "︷": e1.MO.WIDEACCENT,
                    "︸": e1.MO.WIDEACCENT
                }
            }, e1.OPTABLE.infix["^"] = e1.MO.WIDEREL, e1.OPTABLE.infix._ = e1.MO.WIDEREL, e1.OPTABLE.infix["⫝̸"] = e1.MO.REL;
        },
        9259: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SerializedMmlVisitor = e1.toEntity = e1.DATAMJX = void 0;
            var a1 = r1(6325), l1 = r1(9007), c1 = r1(450);
            e1.DATAMJX = "data-mjx-";
            e1.toEntity = function(t1) {
                return "&#x" + t1.codePointAt(0).toString(16).toUpperCase() + ";";
            };
            var u1 = function(t1) {
                function r1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(r1, t1), r1.prototype.visitTree = function(t1) {
                    return this.visitNode(t1, "");
                }, r1.prototype.visitTextNode = function(t1, e1) {
                    return this.quoteHTML(t1.getText());
                }, r1.prototype.visitXMLNode = function(t1, e1) {
                    return e1 + t1.getSerializedXML();
                }, r1.prototype.visitInferredMrowNode = function(t1, e1) {
                    var r1, n1, o1 = [];
                    try {
                        for(var s1 = i1(t1.childNodes), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            o1.push(this.visitNode(l1, e1));
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = s1.return) && n1.call(s1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return o1.join("\n");
                }, r1.prototype.visitTeXAtomNode = function(t1, e1) {
                    var r1 = this.childNodeMml(t1, e1 + "  ", "\n");
                    return e1 + "<mrow" + this.getAttributes(t1) + ">" + (r1.match(/\S/) ? "\n" + r1 + e1 : "") + "</mrow>";
                }, r1.prototype.visitAnnotationNode = function(t1, e1) {
                    return e1 + "<annotation" + this.getAttributes(t1) + ">" + this.childNodeMml(t1, "", "") + "</annotation>";
                }, r1.prototype.visitDefault = function(t1, e1) {
                    var r1 = t1.kind, n1 = s1(t1.isToken || 0 === t1.childNodes.length ? [
                        "",
                        ""
                    ] : [
                        "\n",
                        e1
                    ], 2), o1 = n1[0], i1 = n1[1], a1 = this.childNodeMml(t1, e1 + "  ", o1);
                    return e1 + "<" + r1 + this.getAttributes(t1) + ">" + (a1.match(/\S/) ? o1 + a1 + i1 : "") + "</" + r1 + ">";
                }, r1.prototype.childNodeMml = function(t1, e1, r1) {
                    var n1, o1, s1 = "";
                    try {
                        for(var a1 = i1(t1.childNodes), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value;
                            s1 += this.visitNode(c1, e1) + r1;
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (o1 = a1.return) && o1.call(a1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                    return s1;
                }, r1.prototype.getAttributes = function(t1) {
                    var e1, r1, n1 = [], o1 = this.constructor.defaultAttributes[t1.kind] || {}, s1 = Object.assign({}, o1, this.getDataAttributes(t1), t1.attributes.getAllAttributes()), a1 = this.constructor.variants;
                    s1.hasOwnProperty("mathvariant") && a1.hasOwnProperty(s1.mathvariant) && (s1.mathvariant = a1[s1.mathvariant]);
                    try {
                        for(var l1 = i1(Object.keys(s1)), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value, p1 = String(s1[u1]);
                            void 0 !== p1 && n1.push(u1 + '="' + this.quoteHTML(p1) + '"');
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (r1 = l1.return) && r1.call(l1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return n1.length ? " " + n1.join(" ") : "";
                }, r1.prototype.getDataAttributes = function(t1) {
                    var e1 = {}, r1 = t1.attributes.getExplicit("mathvariant"), n1 = this.constructor.variants;
                    r1 && n1.hasOwnProperty(r1) && this.setDataAttribute(e1, "variant", r1), t1.getProperty("variantForm") && this.setDataAttribute(e1, "alternate", "1"), t1.getProperty("pseudoscript") && this.setDataAttribute(e1, "pseudoscript", "true"), !1 === t1.getProperty("autoOP") && this.setDataAttribute(e1, "auto-op", "false");
                    var o1 = t1.getProperty("scriptalign");
                    o1 && this.setDataAttribute(e1, "script-align", o1);
                    var i1 = t1.getProperty("texClass");
                    if (void 0 !== i1) {
                        var s1 = !0;
                        if (i1 === l1.TEXCLASS.OP && t1.isKind("mi")) {
                            var a1 = t1.getText();
                            s1 = !(a1.length > 1 && a1.match(c1.MmlMi.operatorName));
                        }
                        s1 && this.setDataAttribute(e1, "texclass", i1 < 0 ? "NONE" : l1.TEXCLASSNAMES[i1]);
                    }
                    return t1.getProperty("scriptlevel") && !1 === t1.getProperty("useHeight") && this.setDataAttribute(e1, "smallmatrix", "true"), e1;
                }, r1.prototype.setDataAttribute = function(t1, r1, n1) {
                    t1[e1.DATAMJX + r1] = n1;
                }, r1.prototype.quoteHTML = function(t1) {
                    return t1.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/[\uD800-\uDBFF]./g, e1.toEntity).replace(/[\u0080-\uD7FF\uE000-\uFFFF]/g, e1.toEntity);
                }, r1.variants = {
                    "-tex-calligraphic": "script",
                    "-tex-bold-calligraphic": "bold-script",
                    "-tex-oldstyle": "normal",
                    "-tex-bold-oldstyle": "bold",
                    "-tex-mathit": "italic"
                }, r1.defaultAttributes = {
                    math: {
                        xmlns: "http://www.w3.org/1998/Math/MathML"
                    }
                }, r1;
            }(a1.MmlVisitor);
            e1.SerializedMmlVisitor = u1;
        },
        2975: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractOutputJax = void 0;
            var n1 = r1(7233), o1 = r1(7525), i1 = function() {
                function t1(t1) {
                    void 0 === t1 && (t1 = {}), this.adaptor = null;
                    var e1 = this.constructor;
                    this.options = (0, n1.userOptions)((0, n1.defaultOptions)({}, e1.OPTIONS), t1), this.postFilters = new o1.FunctionList;
                }
                return Object.defineProperty(t1.prototype, "name", {
                    get: function() {
                        return this.constructor.NAME;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.setAdaptor = function(t1) {
                    this.adaptor = t1;
                }, t1.prototype.initialize = function() {}, t1.prototype.reset = function() {
                    for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1[e1] = arguments[e1];
                }, t1.prototype.getMetrics = function(t1) {}, t1.prototype.styleSheet = function(t1) {
                    return null;
                }, t1.prototype.pageElements = function(t1) {
                    return null;
                }, t1.prototype.executeFilters = function(t1, e1, r1, n1) {
                    var o1 = {
                        math: e1,
                        document: r1,
                        data: n1
                    };
                    return t1.execute(o1), o1.data;
                }, t1.NAME = "generic", t1.OPTIONS = {}, t1;
            }();
            e1.AbstractOutputJax = i1;
        },
        4574: function(t1, e1) {
            var r1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractFactory = void 0;
            var i1 = function() {
                function t1(t1) {
                    var e1, n1;
                    void 0 === t1 && (t1 = null), this.defaultKind = "unknown", this.nodeMap = new Map, this.node = {}, null === t1 && (t1 = this.constructor.defaultNodes);
                    try {
                        for(var o1 = r1(Object.keys(t1)), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value;
                            this.setNodeClass(s1, t1[s1]);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }
                return t1.prototype.create = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    return (this.node[t1] || this.node[this.defaultKind]).apply(void 0, o1([], n1(e1), !1));
                }, t1.prototype.setNodeClass = function(t1, e1) {
                    this.nodeMap.set(t1, e1);
                    var r1 = this, i1 = this.nodeMap.get(t1);
                    this.node[t1] = function() {
                        for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1[e1] = arguments[e1];
                        return new (i1.bind.apply(i1, o1([
                            void 0,
                            r1
                        ], n1(t1), !1)));
                    };
                }, t1.prototype.getNodeClass = function(t1) {
                    return this.nodeMap.get(t1);
                }, t1.prototype.deleteNodeClass = function(t1) {
                    this.nodeMap.delete(t1), delete this.node[t1];
                }, t1.prototype.nodeIsKind = function(t1, e1) {
                    return t1 instanceof this.getNodeClass(e1);
                }, t1.prototype.getKinds = function() {
                    return Array.from(this.nodeMap.keys());
                }, t1.defaultNodes = {}, t1;
            }();
            e1.AbstractFactory = i1;
        },
        4596: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__assign || function() {
                return o1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, o1.apply(this, arguments);
            }, i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractEmptyNode = e1.AbstractNode = void 0;
            var s1 = function() {
                function t1(t1, e1, r1) {
                    var n1, o1;
                    void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = []), this.factory = t1, this.parent = null, this.properties = {}, this.childNodes = [];
                    try {
                        for(var s1 = i1(Object.keys(e1)), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            this.setProperty(l1, e1[l1]);
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                    r1.length && this.setChildren(r1);
                }
                return Object.defineProperty(t1.prototype, "kind", {
                    get: function() {
                        return "unknown";
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.setProperty = function(t1, e1) {
                    this.properties[t1] = e1;
                }, t1.prototype.getProperty = function(t1) {
                    return this.properties[t1];
                }, t1.prototype.getPropertyNames = function() {
                    return Object.keys(this.properties);
                }, t1.prototype.getAllProperties = function() {
                    return this.properties;
                }, t1.prototype.removeProperty = function() {
                    for(var t1, e1, r1 = [], n1 = 0; n1 < arguments.length; n1++)r1[n1] = arguments[n1];
                    try {
                        for(var o1 = i1(r1), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            delete this.properties[a1];
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, t1.prototype.isKind = function(t1) {
                    return this.factory.nodeIsKind(this, t1);
                }, t1.prototype.setChildren = function(t1) {
                    var e1, r1;
                    this.childNodes = [];
                    try {
                        for(var n1 = i1(t1), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var s1 = o1.value;
                            this.appendChild(s1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.appendChild = function(t1) {
                    return this.childNodes.push(t1), t1.parent = this, t1;
                }, t1.prototype.replaceChild = function(t1, e1) {
                    var r1 = this.childIndex(e1);
                    return null !== r1 && (this.childNodes[r1] = t1, t1.parent = this, e1.parent = null), t1;
                }, t1.prototype.removeChild = function(t1) {
                    var e1 = this.childIndex(t1);
                    return null !== e1 && (this.childNodes.splice(e1, 1), t1.parent = null), t1;
                }, t1.prototype.childIndex = function(t1) {
                    var e1 = this.childNodes.indexOf(t1);
                    return -1 === e1 ? null : e1;
                }, t1.prototype.copy = function() {
                    var t1, e1, r1 = this.factory.create(this.kind);
                    r1.properties = o1({}, this.properties);
                    try {
                        for(var n1 = i1(this.childNodes || []), s1 = n1.next(); !s1.done; s1 = n1.next()){
                            var a1 = s1.value;
                            a1 && r1.appendChild(a1.copy());
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (e1 = n1.return) && e1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return r1;
                }, t1.prototype.findNodes = function(t1) {
                    var e1 = [];
                    return this.walkTree(function(r1) {
                        r1.isKind(t1) && e1.push(r1);
                    }), e1;
                }, t1.prototype.walkTree = function(t1, e1) {
                    var r1, n1;
                    t1(this, e1);
                    try {
                        for(var o1 = i1(this.childNodes), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            a1 && a1.walkTree(t1, e1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return e1;
                }, t1.prototype.toString = function() {
                    return this.kind + "(" + this.childNodes.join(",") + ")";
                }, t1;
            }();
            e1.AbstractNode = s1;
            var a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return n1(e1, t1), e1.prototype.setChildren = function(t1) {}, e1.prototype.appendChild = function(t1) {
                    return t1;
                }, e1.prototype.replaceChild = function(t1, e1) {
                    return e1;
                }, e1.prototype.childIndex = function(t1) {
                    return null;
                }, e1.prototype.walkTree = function(t1, e1) {
                    return t1(this, e1), e1;
                }, e1.prototype.toString = function() {
                    return this.kind;
                }, e1;
            }(s1);
            e1.AbstractEmptyNode = a1;
        },
        7860: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractNodeFactory = void 0;
            var i1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.create = function(t1, e1, r1) {
                    return void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = []), this.node[t1](e1, r1);
                }, e1;
            }(r1(4574).AbstractFactory);
            e1.AbstractNodeFactory = i1;
        },
        8823: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractVisitor = void 0;
            var s1 = r1(4596), a1 = function() {
                function t1(e1) {
                    var r1, o1;
                    this.nodeHandlers = new Map;
                    try {
                        for(var i1 = n1(e1.getKinds()), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value, l1 = this[t1.methodName(a1)];
                            l1 && this.nodeHandlers.set(a1, l1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (o1 = i1.return) && o1.call(i1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }
                return t1.methodName = function(t1) {
                    return "visit" + (t1.charAt(0).toUpperCase() + t1.substr(1)).replace(/[^a-z0-9_]/gi, "_") + "Node";
                }, t1.prototype.visitTree = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    return this.visitNode.apply(this, i1([
                        t1
                    ], o1(e1), !1));
                }, t1.prototype.visitNode = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    var n1 = this.nodeHandlers.get(t1.kind) || this.visitDefault;
                    return n1.call.apply(n1, i1([
                        this,
                        t1
                    ], o1(e1), !1));
                }, t1.prototype.visitDefault = function(t1) {
                    for(var e1, r1, a1 = [], l1 = 1; l1 < arguments.length; l1++)a1[l1 - 1] = arguments[l1];
                    if (t1 instanceof s1.AbstractNode) try {
                        for(var c1 = n1(t1.childNodes), u1 = c1.next(); !u1.done; u1 = c1.next()){
                            var p1 = u1.value;
                            this.visitNode.apply(this, i1([
                                p1
                            ], o1(a1), !1));
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (r1 = c1.return) && r1.call(c1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.setNodeHandler = function(t1, e1) {
                    this.nodeHandlers.set(t1, e1);
                }, t1.prototype.removeNodeHandler = function(t1) {
                    this.nodeHandlers.delete(t1);
                }, t1;
            }();
            e1.AbstractVisitor = a1;
        },
        8912: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractWrapper = void 0;
            var r1 = function() {
                function t1(t1, e1) {
                    this.factory = t1, this.node = e1;
                }
                return Object.defineProperty(t1.prototype, "kind", {
                    get: function() {
                        return this.node.kind;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.wrap = function(t1) {
                    return this.factory.wrap(t1);
                }, t1;
            }();
            e1.AbstractWrapper = r1;
        },
        3811: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractWrapperFactory = void 0;
            var a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.wrap = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    return this.create.apply(this, s1([
                        t1.kind,
                        t1
                    ], i1(e1), !1));
                }, e1;
            }(r1(4574).AbstractFactory);
            e1.AbstractWrapperFactory = a1;
        },
        6272: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.RegisterHTMLHandler = void 0;
            var n1 = r1(5713), o1 = r1(3726);
            e1.RegisterHTMLHandler = function(t1) {
                var e1 = new o1.HTMLHandler(t1);
                return n1.mathjax.handlers.register(e1), e1;
            };
        },
        3683: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HTMLDocument = void 0;
            var l1 = r1(5722), c1 = r1(7233), u1 = r1(3363), p1 = r1(3335), h1 = r1(5138), f1 = r1(4474), d1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1 = this, i1 = s1((0, c1.separateOptions)(n1, h1.HTMLDomStrings.OPTIONS), 2), a1 = i1[0], l1 = i1[1];
                    return (o1 = t1.call(this, e1, r1, a1) || this).domStrings = o1.options.DomStrings || new h1.HTMLDomStrings(l1), o1.domStrings.adaptor = r1, o1.styles = [], o1;
                }
                return o1(e1, t1), e1.prototype.findPosition = function(t1, e1, r1, n1) {
                    var o1, i1, l1 = this.adaptor;
                    try {
                        for(var c1 = a1(n1[t1]), u1 = c1.next(); !u1.done; u1 = c1.next()){
                            var p1 = u1.value, h1 = s1(p1, 2), f1 = h1[0], d1 = h1[1];
                            if (e1 <= d1 && "#text" === l1.kind(f1)) return {
                                node: f1,
                                n: Math.max(e1, 0),
                                delim: r1
                            };
                            e1 -= d1;
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (i1 = c1.return) && i1.call(c1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    return {
                        node: null,
                        n: 0,
                        delim: r1
                    };
                }, e1.prototype.mathItem = function(t1, e1, r1) {
                    var n1 = t1.math, o1 = this.findPosition(t1.n, t1.start.n, t1.open, r1), i1 = this.findPosition(t1.n, t1.end.n, t1.close, r1);
                    return new this.options.MathItem(n1, e1, t1.display, o1, i1);
                }, e1.prototype.findMath = function(t1) {
                    var e1, r1, n1, o1, i1, l1, u1, p1, h1;
                    if (!this.processed.isSet("findMath")) {
                        this.adaptor.document = this.document, t1 = (0, c1.userOptions)({
                            elements: this.options.elements || [
                                this.adaptor.body(this.document)
                            ]
                        }, t1);
                        try {
                            for(var f1 = a1(this.adaptor.getElements(t1.elements, this.document)), d1 = f1.next(); !d1.done; d1 = f1.next()){
                                var m1 = d1.value, y1 = s1([
                                    null,
                                    null
                                ], 2), g1 = y1[0], b1 = y1[1];
                                try {
                                    for(var v1 = (n1 = void 0, a1(this.inputJax)), _1 = v1.next(); !_1.done; _1 = v1.next()){
                                        var S1 = _1.value, O1 = new this.options.MathList;
                                        if (S1.processStrings) {
                                            null === g1 && (g1 = (i1 = s1(this.domStrings.find(m1), 2))[0], b1 = i1[1]);
                                            try {
                                                for(var M1 = (l1 = void 0, a1(S1.findMath(g1))), x1 = M1.next(); !x1.done; x1 = M1.next()){
                                                    var E1 = x1.value;
                                                    O1.push(this.mathItem(E1, S1, b1));
                                                }
                                            } catch (t1) {
                                                l1 = {
                                                    error: t1
                                                };
                                            } finally{
                                                try {
                                                    x1 && !x1.done && (u1 = M1.return) && u1.call(M1);
                                                } finally{
                                                    if (l1) throw l1.error;
                                                }
                                            }
                                        } else try {
                                            for(var A1 = (p1 = void 0, a1(S1.findMath(m1))), C1 = A1.next(); !C1.done; C1 = A1.next()){
                                                E1 = C1.value;
                                                var T1 = new this.options.MathItem(E1.math, S1, E1.display, E1.start, E1.end);
                                                O1.push(T1);
                                            }
                                        } catch (t1) {
                                            p1 = {
                                                error: t1
                                            };
                                        } finally{
                                            try {
                                                C1 && !C1.done && (h1 = A1.return) && h1.call(A1);
                                            } finally{
                                                if (p1) throw p1.error;
                                            }
                                        }
                                        this.math.merge(O1);
                                    }
                                } catch (t1) {
                                    n1 = {
                                        error: t1
                                    };
                                } finally{
                                    try {
                                        _1 && !_1.done && (o1 = v1.return) && o1.call(v1);
                                    } finally{
                                        if (n1) throw n1.error;
                                    }
                                }
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                d1 && !d1.done && (r1 = f1.return) && r1.call(f1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                        this.processed.set("findMath");
                    }
                    return this;
                }, e1.prototype.updateDocument = function() {
                    return this.processed.isSet("updateDocument") || (this.addPageElements(), this.addStyleSheet(), t1.prototype.updateDocument.call(this), this.processed.set("updateDocument")), this;
                }, e1.prototype.addPageElements = function() {
                    var t1 = this.adaptor.body(this.document), e1 = this.documentPageElements();
                    e1 && this.adaptor.append(t1, e1);
                }, e1.prototype.addStyleSheet = function() {
                    var t1 = this.documentStyleSheet(), e1 = this.adaptor;
                    if (t1 && !e1.parent(t1)) {
                        var r1 = e1.head(this.document), n1 = this.findSheet(r1, e1.getAttribute(t1, "id"));
                        n1 ? e1.replace(t1, n1) : e1.append(r1, t1);
                    }
                }, e1.prototype.findSheet = function(t1, e1) {
                    var r1, n1;
                    if (e1) try {
                        for(var o1 = a1(this.adaptor.tags(t1, "style")), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value;
                            if (this.adaptor.getAttribute(s1, "id") === e1) return s1;
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return null;
                }, e1.prototype.removeFromDocument = function(t1) {
                    var e1, r1;
                    if (void 0 === t1 && (t1 = !1), this.processed.isSet("updateDocument")) try {
                        for(var n1 = a1(this.math), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value;
                            i1.state() >= f1.STATE.INSERTED && i1.state(f1.STATE.TYPESET, t1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return this.processed.clear("updateDocument"), this;
                }, e1.prototype.documentStyleSheet = function() {
                    return this.outputJax.styleSheet(this);
                }, e1.prototype.documentPageElements = function() {
                    return this.outputJax.pageElements(this);
                }, e1.prototype.addStyles = function(t1) {
                    this.styles.push(t1);
                }, e1.prototype.getStyles = function() {
                    return this.styles;
                }, e1.KIND = "HTML", e1.OPTIONS = i1(i1({}, l1.AbstractMathDocument.OPTIONS), {
                    renderActions: (0, c1.expandable)(i1(i1({}, l1.AbstractMathDocument.OPTIONS.renderActions), {
                        styles: [
                            f1.STATE.INSERTED + 1,
                            "",
                            "updateStyleSheet",
                            !1
                        ]
                    })),
                    MathList: p1.HTMLMathList,
                    MathItem: u1.HTMLMathItem,
                    DomStrings: null
                }), e1;
            }(l1.AbstractMathDocument);
            e1.HTMLDocument = d1;
        },
        5138: function(t1, e1, r1) {
            var n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HTMLDomStrings = void 0;
            var o1 = r1(7233), i1 = function() {
                function t1(t1) {
                    void 0 === t1 && (t1 = null);
                    var e1 = this.constructor;
                    this.options = (0, o1.userOptions)((0, o1.defaultOptions)({}, e1.OPTIONS), t1), this.init(), this.getPatterns();
                }
                return t1.prototype.init = function() {
                    this.strings = [], this.string = "", this.snodes = [], this.nodes = [], this.stack = [];
                }, t1.prototype.getPatterns = function() {
                    var t1 = (0, o1.makeArray)(this.options.skipHtmlTags), e1 = (0, o1.makeArray)(this.options.ignoreHtmlClass), r1 = (0, o1.makeArray)(this.options.processHtmlClass);
                    this.skipHtmlTags = new RegExp("^(?:" + t1.join("|") + ")$", "i"), this.ignoreHtmlClass = new RegExp("(?:^| )(?:" + e1.join("|") + ")(?: |$)"), this.processHtmlClass = new RegExp("(?:^| )(?:" + r1 + ")(?: |$)");
                }, t1.prototype.pushString = function() {
                    this.string.match(/\S/) && (this.strings.push(this.string), this.nodes.push(this.snodes)), this.string = "", this.snodes = [];
                }, t1.prototype.extendString = function(t1, e1) {
                    this.snodes.push([
                        t1,
                        e1.length
                    ]), this.string += e1;
                }, t1.prototype.handleText = function(t1, e1) {
                    return e1 || this.extendString(t1, this.adaptor.value(t1)), this.adaptor.next(t1);
                }, t1.prototype.handleTag = function(t1, e1) {
                    if (!e1) {
                        var r1 = this.options.includeHtmlTags[this.adaptor.kind(t1)];
                        this.extendString(t1, r1);
                    }
                    return this.adaptor.next(t1);
                }, t1.prototype.handleContainer = function(t1, e1) {
                    this.pushString();
                    var r1 = this.adaptor.getAttribute(t1, "class") || "", n1 = this.adaptor.kind(t1) || "", o1 = this.processHtmlClass.exec(r1), i1 = t1;
                    return !this.adaptor.firstChild(t1) || this.adaptor.getAttribute(t1, "data-MJX") || !o1 && this.skipHtmlTags.exec(n1) ? i1 = this.adaptor.next(t1) : (this.adaptor.next(t1) && this.stack.push([
                        this.adaptor.next(t1),
                        e1
                    ]), i1 = this.adaptor.firstChild(t1), e1 = (e1 || this.ignoreHtmlClass.exec(r1)) && !o1), [
                        i1,
                        e1
                    ];
                }, t1.prototype.handleOther = function(t1, e1) {
                    return this.pushString(), this.adaptor.next(t1);
                }, t1.prototype.find = function(t1) {
                    var e1, r1;
                    this.init();
                    for(var o1 = this.adaptor.next(t1), i1 = !1, s1 = this.options.includeHtmlTags; t1 && t1 !== o1;){
                        var a1 = this.adaptor.kind(t1);
                        "#text" === a1 ? t1 = this.handleText(t1, i1) : s1.hasOwnProperty(a1) ? t1 = this.handleTag(t1, i1) : a1 ? (t1 = (e1 = n1(this.handleContainer(t1, i1), 2))[0], i1 = e1[1]) : t1 = this.handleOther(t1, i1), !t1 && this.stack.length && (this.pushString(), t1 = (r1 = n1(this.stack.pop(), 2))[0], i1 = r1[1]);
                    }
                    this.pushString();
                    var l1 = [
                        this.strings,
                        this.nodes
                    ];
                    return this.init(), l1;
                }, t1.OPTIONS = {
                    skipHtmlTags: [
                        "script",
                        "noscript",
                        "style",
                        "textarea",
                        "pre",
                        "code",
                        "annotation",
                        "annotation-xml"
                    ],
                    includeHtmlTags: {
                        br: "\n",
                        wbr: "",
                        "#comment": ""
                    },
                    ignoreHtmlClass: "mathjax_ignore",
                    processHtmlClass: "mathjax_process"
                }, t1;
            }();
            e1.HTMLDomStrings = i1;
        },
        3726: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HTMLHandler = void 0;
            var i1 = r1(3670), s1 = r1(3683), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.documentClass = s1.HTMLDocument, e1;
                }
                return o1(e1, t1), e1.prototype.handlesDocument = function(t1) {
                    var e1 = this.adaptor;
                    if ("string" == typeof t1) try {
                        t1 = e1.parse(t1, "text/html");
                    } catch (t1) {}
                    return t1 instanceof e1.window.Document || t1 instanceof e1.window.HTMLElement || t1 instanceof e1.window.DocumentFragment;
                }, e1.prototype.create = function(e1, r1) {
                    var n1 = this.adaptor;
                    if ("string" == typeof e1) e1 = n1.parse(e1, "text/html");
                    else if (e1 instanceof n1.window.HTMLElement || e1 instanceof n1.window.DocumentFragment) {
                        var o1 = e1;
                        e1 = n1.parse("", "text/html"), n1.append(n1.body(e1), o1);
                    }
                    return t1.prototype.create.call(this, e1, r1);
                }, e1;
            }(i1.AbstractHandler);
            e1.HTMLHandler = a1;
        },
        3363: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HTMLMathItem = void 0;
            var i1 = r1(4474), s1 = function(t1) {
                function e1(e1, r1, n1, o1, i1) {
                    return void 0 === n1 && (n1 = !0), void 0 === o1 && (o1 = {
                        node: null,
                        n: 0,
                        delim: ""
                    }), void 0 === i1 && (i1 = {
                        node: null,
                        n: 0,
                        delim: ""
                    }), t1.call(this, e1, r1, n1, o1, i1) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "adaptor", {
                    get: function() {
                        return this.inputJax.adaptor;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.updateDocument = function(t1) {
                    if (this.state() < i1.STATE.INSERTED) {
                        if (this.inputJax.processStrings) {
                            var e1 = this.start.node;
                            if (e1 === this.end.node) this.end.n && this.end.n < this.adaptor.value(this.end.node).length && this.adaptor.split(this.end.node, this.end.n), this.start.n && (e1 = this.adaptor.split(this.start.node, this.start.n)), this.adaptor.replace(this.typesetRoot, e1);
                            else {
                                for(this.start.n && (e1 = this.adaptor.split(e1, this.start.n)); e1 !== this.end.node;){
                                    var r1 = this.adaptor.next(e1);
                                    this.adaptor.remove(e1), e1 = r1;
                                }
                                this.adaptor.insert(this.typesetRoot, e1), this.end.n < this.adaptor.value(e1).length && this.adaptor.split(e1, this.end.n), this.adaptor.remove(e1);
                            }
                        } else this.adaptor.replace(this.typesetRoot, this.start.node);
                        this.start.node = this.end.node = this.typesetRoot, this.start.n = this.end.n = 0, this.state(i1.STATE.INSERTED);
                    }
                }, e1.prototype.updateStyleSheet = function(t1) {
                    t1.addStyleSheet();
                }, e1.prototype.removeFromDocument = function(t1) {
                    if (void 0 === t1 && (t1 = !1), this.state() >= i1.STATE.TYPESET) {
                        var e1 = this.adaptor, r1 = this.start.node, n1 = e1.text("");
                        if (t1) {
                            var o1 = this.start.delim + this.math + this.end.delim;
                            if (this.inputJax.processStrings) n1 = e1.text(o1);
                            else {
                                var s1 = e1.parse(o1, "text/html");
                                n1 = e1.firstChild(e1.body(s1));
                            }
                        }
                        e1.parent(r1) && e1.replace(n1, r1), this.start.node = this.end.node = n1, this.start.n = this.end.n = 0;
                    }
                }, e1;
            }(i1.AbstractMathItem);
            e1.HTMLMathItem = s1;
        },
        3335: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HTMLMathList = void 0;
            var i1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1;
            }(r1(9e3).AbstractMathList);
            e1.HTMLMathList = i1;
        },
        8462: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TeX = void 0;
            var l1 = r1(9206), c1 = r1(7233), u1 = r1(7073), p1 = a1(r1(4676)), h1 = a1(r1(1256)), f1 = a1(r1(8417)), d1 = a1(r1(3971)), m1 = a1(r1(8562)), y1 = r1(6521), g1 = r1(9899);
            r1(2942);
            var b1 = function(t1) {
                function e1(r1) {
                    void 0 === r1 && (r1 = {});
                    var n1 = this, o1 = s1((0, c1.separateOptions)(r1, e1.OPTIONS, u1.FindTeX.OPTIONS), 3), i1 = o1[0], a1 = o1[1], l1 = o1[2];
                    (n1 = t1.call(this, a1) || this).findTeX = n1.options.FindTeX || new u1.FindTeX(l1);
                    var h1 = n1.options.packages, f1 = n1.configuration = e1.configure(h1), d1 = n1._parseOptions = new m1.default(f1, [
                        n1.options,
                        y1.TagsFactory.OPTIONS
                    ]);
                    return (0, c1.userOptions)(d1.options, i1), f1.config(n1), e1.tags(d1, f1), n1.postFilters.add(p1.default.cleanSubSup, -6), n1.postFilters.add(p1.default.setInherited, -5), n1.postFilters.add(p1.default.moveLimits, -4), n1.postFilters.add(p1.default.cleanStretchy, -3), n1.postFilters.add(p1.default.cleanAttributes, -2), n1.postFilters.add(p1.default.combineRelations, -1), n1;
                }
                return o1(e1, t1), e1.configure = function(t1) {
                    var e1 = new g1.ParserConfiguration(t1, [
                        "tex"
                    ]);
                    return e1.init(), e1;
                }, e1.tags = function(t1, e1) {
                    y1.TagsFactory.addTags(e1.tags), y1.TagsFactory.setDefault(t1.options.tags), t1.tags = y1.TagsFactory.getDefault(), t1.tags.configuration = t1;
                }, e1.prototype.setMmlFactory = function(e1) {
                    t1.prototype.setMmlFactory.call(this, e1), this._parseOptions.nodeFactory.setMmlFactory(e1);
                }, Object.defineProperty(e1.prototype, "parseOptions", {
                    get: function() {
                        return this._parseOptions;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.reset = function(t1) {
                    void 0 === t1 && (t1 = 0), this.parseOptions.tags.reset(t1);
                }, e1.prototype.compile = function(t1, e1) {
                    this.parseOptions.clear(), this.executeFilters(this.preFilters, t1, e1, this.parseOptions);
                    var r1, n1, o1 = t1.display;
                    this.latex = t1.math, this.parseOptions.tags.startEquation(t1);
                    try {
                        var i1 = new f1.default(this.latex, {
                            display: o1,
                            isInner: !1
                        }, this.parseOptions);
                        r1 = i1.mml(), n1 = i1.stack.global;
                    } catch (t1) {
                        if (!(t1 instanceof d1.default)) throw t1;
                        this.parseOptions.error = !0, r1 = this.options.formatError(this, t1);
                    }
                    return r1 = this.parseOptions.nodeFactory.create("node", "math", [
                        r1
                    ]), (null == n1 ? void 0 : n1.indentalign) && h1.default.setAttribute(r1, "indentalign", n1.indentalign), o1 && h1.default.setAttribute(r1, "display", "block"), this.parseOptions.tags.finishEquation(t1), this.parseOptions.root = r1, this.executeFilters(this.postFilters, t1, e1, this.parseOptions), this.mathNode = this.parseOptions.root, this.mathNode;
                }, e1.prototype.findMath = function(t1) {
                    return this.findTeX.findMath(t1);
                }, e1.prototype.formatError = function(t1) {
                    var e1 = t1.message.replace(/\n.*/, "");
                    return this.parseOptions.nodeFactory.create("error", e1, t1.id, this.latex);
                }, e1.NAME = "TeX", e1.OPTIONS = i1(i1({}, l1.AbstractInputJax.OPTIONS), {
                    FindTeX: null,
                    packages: [
                        "base"
                    ],
                    digits: /^(?:[0-9]+(?:\{,\}[0-9]{3})*(?:\.[0-9]*)?|\.[0-9]+)/,
                    maxBuffer: 5120,
                    formatError: function(t1, e1) {
                        return t1.formatError(e1);
                    }
                }), e1;
            }(l1.AbstractInputJax);
            e1.TeX = b1;
        },
        9899: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ParserConfiguration = e1.ConfigurationHandler = e1.Configuration = void 0;
            var i1, s1 = r1(7233), a1 = r1(2947), l1 = r1(7525), c1 = r1(8666), u1 = r1(6521), p1 = function() {
                function t1(t1, e1, r1, n1, o1, i1, s1, a1, l1, c1, u1, p1, h1) {
                    void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = {}), void 0 === n1 && (n1 = {}), void 0 === o1 && (o1 = {}), void 0 === i1 && (i1 = {}), void 0 === s1 && (s1 = {}), void 0 === a1 && (a1 = []), void 0 === l1 && (l1 = []), void 0 === c1 && (c1 = null), void 0 === u1 && (u1 = null), this.name = t1, this.handler = e1, this.fallback = r1, this.items = n1, this.tags = o1, this.options = i1, this.nodes = s1, this.preprocessors = a1, this.postprocessors = l1, this.initMethod = c1, this.configMethod = u1, this.priority = p1, this.parser = h1, this.handler = Object.assign({
                        character: [],
                        delimiter: [],
                        macro: [],
                        environment: []
                    }, e1);
                }
                return t1.makeProcessor = function(t1, e1) {
                    return Array.isArray(t1) ? t1 : [
                        t1,
                        e1
                    ];
                }, t1._create = function(e1, r1) {
                    var n1 = this;
                    void 0 === r1 && (r1 = {});
                    var o1 = r1.priority || c1.PrioritizedList.DEFAULTPRIORITY, i1 = r1.init ? this.makeProcessor(r1.init, o1) : null, s1 = r1.config ? this.makeProcessor(r1.config, o1) : null, a1 = (r1.preprocessors || []).map(function(t1) {
                        return n1.makeProcessor(t1, o1);
                    }), l1 = (r1.postprocessors || []).map(function(t1) {
                        return n1.makeProcessor(t1, o1);
                    }), u1 = r1.parser || "tex";
                    return new t1(e1, r1.handler || {}, r1.fallback || {}, r1.items || {}, r1.tags || {}, r1.options || {}, r1.nodes || {}, a1, l1, i1, s1, o1, u1);
                }, t1.create = function(e1, r1) {
                    void 0 === r1 && (r1 = {});
                    var n1 = t1._create(e1, r1);
                    return i1.set(e1, n1), n1;
                }, t1.local = function(e1) {
                    return void 0 === e1 && (e1 = {}), t1._create("", e1);
                }, Object.defineProperty(t1.prototype, "init", {
                    get: function() {
                        return this.initMethod ? this.initMethod[0] : null;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "config", {
                    get: function() {
                        return this.configMethod ? this.configMethod[0] : null;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1;
            }();
            e1.Configuration = p1, function(t1) {
                var e1 = new Map;
                t1.set = function(t1, r1) {
                    e1.set(t1, r1);
                }, t1.get = function(t1) {
                    return e1.get(t1);
                }, t1.keys = function() {
                    return e1.keys();
                };
            }(i1 = e1.ConfigurationHandler || (e1.ConfigurationHandler = {}));
            var h1 = function() {
                function t1(t1, e1) {
                    var r1, o1, i1, s1;
                    void 0 === e1 && (e1 = [
                        "tex"
                    ]), this.initMethod = new l1.FunctionList, this.configMethod = new l1.FunctionList, this.configurations = new c1.PrioritizedList, this.parsers = [], this.handlers = new a1.SubHandlers, this.items = {}, this.tags = {}, this.options = {}, this.nodes = {}, this.parsers = e1;
                    try {
                        for(var u1 = n1(t1.slice().reverse()), p1 = u1.next(); !p1.done; p1 = u1.next()){
                            var h1 = p1.value;
                            this.addPackage(h1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (o1 = u1.return) && o1.call(u1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    try {
                        for(var f1 = n1(this.configurations), d1 = f1.next(); !d1.done; d1 = f1.next()){
                            var m1 = d1.value, y1 = m1.item, g1 = m1.priority;
                            this.append(y1, g1);
                        }
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            d1 && !d1.done && (s1 = f1.return) && s1.call(f1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                }
                return t1.prototype.init = function() {
                    this.initMethod.execute(this);
                }, t1.prototype.config = function(t1) {
                    var e1, r1;
                    this.configMethod.execute(this, t1);
                    try {
                        for(var o1 = n1(this.configurations), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value;
                            this.addFilters(t1, s1.item);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.addPackage = function(t1) {
                    var e1 = "string" == typeof t1 ? t1 : t1[0], r1 = this.getPackage(e1);
                    r1 && this.configurations.add(r1, "string" == typeof t1 ? r1.priority : t1[1]);
                }, t1.prototype.add = function(t1, e1, r1) {
                    var o1, i1;
                    void 0 === r1 && (r1 = {});
                    var a1 = this.getPackage(t1);
                    this.append(a1), this.configurations.add(a1, a1.priority), this.init();
                    var l1 = e1.parseOptions;
                    l1.nodeFactory.setCreators(a1.nodes);
                    try {
                        for(var c1 = n1(Object.keys(a1.items)), p1 = c1.next(); !p1.done; p1 = c1.next()){
                            var h1 = p1.value;
                            l1.itemFactory.setNodeClass(h1, a1.items[h1]);
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (i1 = c1.return) && i1.call(c1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    u1.TagsFactory.addTags(a1.tags), (0, s1.defaultOptions)(l1.options, a1.options), (0, s1.userOptions)(l1.options, r1), this.addFilters(e1, a1), a1.config && a1.config(this, e1);
                }, t1.prototype.getPackage = function(t1) {
                    var e1 = i1.get(t1);
                    if (e1 && this.parsers.indexOf(e1.parser) < 0) throw Error("Package ".concat(t1, " doesn't target the proper parser"));
                    return e1;
                }, t1.prototype.append = function(t1, e1) {
                    e1 = e1 || t1.priority, t1.initMethod && this.initMethod.add(t1.initMethod[0], t1.initMethod[1]), t1.configMethod && this.configMethod.add(t1.configMethod[0], t1.configMethod[1]), this.handlers.add(t1.handler, t1.fallback, e1), Object.assign(this.items, t1.items), Object.assign(this.tags, t1.tags), (0, s1.defaultOptions)(this.options, t1.options), Object.assign(this.nodes, t1.nodes);
                }, t1.prototype.addFilters = function(t1, e1) {
                    var r1, i1, s1, a1;
                    try {
                        for(var l1 = n1(e1.preprocessors), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = o1(c1.value, 2), p1 = u1[0], h1 = u1[1];
                            t1.preFilters.add(p1, h1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (i1 = l1.return) && i1.call(l1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    try {
                        for(var f1 = n1(e1.postprocessors), d1 = f1.next(); !d1.done; d1 = f1.next()){
                            var m1 = o1(d1.value, 2), y1 = m1[0];
                            h1 = m1[1];
                            t1.postFilters.add(y1, h1);
                        }
                    } catch (t1) {
                        s1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            d1 && !d1.done && (a1 = f1.return) && a1.call(f1);
                        } finally{
                            if (s1) throw s1.error;
                        }
                    }
                }, t1;
            }();
            e1.ParserConfiguration = h1;
        },
        4676: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var i1, s1 = r1(9007), a1 = o1(r1(1256));
            !function(t1) {
                t1.cleanStretchy = function(t1) {
                    var e1, r1, o1 = t1.data;
                    try {
                        for(var i1 = n1(o1.getList("fixStretchy")), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var l1 = s1.value;
                            if (a1.default.getProperty(l1, "fixStretchy")) {
                                var c1 = a1.default.getForm(l1);
                                c1 && c1[3] && c1[3].stretchy && a1.default.setAttribute(l1, "stretchy", !1);
                                var u1 = l1.parent;
                                if (!(a1.default.getTexClass(l1) || c1 && c1[2])) {
                                    var p1 = o1.nodeFactory.create("node", "TeXAtom", [
                                        l1
                                    ]);
                                    u1.replaceChild(p1, l1), p1.inheritAttributesFrom(l1);
                                }
                                a1.default.removeProperties(l1, "fixStretchy");
                            }
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.cleanAttributes = function(t1) {
                    t1.data.root.walkTree(function(t1, e1) {
                        var r1, o1, i1 = t1.attributes;
                        if (i1) {
                            var s1 = new Set((i1.get("mjx-keep-attrs") || "").split(/ /));
                            delete i1.getAllAttributes()["mjx-keep-attrs"];
                            try {
                                for(var a1 = n1(i1.getExplicitNames()), l1 = a1.next(); !l1.done; l1 = a1.next()){
                                    var c1 = l1.value;
                                    s1.has(c1) || i1.attributes[c1] !== t1.attributes.getInherited(c1) || delete i1.attributes[c1];
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    l1 && !l1.done && (o1 = a1.return) && o1.call(a1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                        }
                    }, {});
                }, t1.combineRelations = function(t1) {
                    var o1, i1, l1, c1, u1 = [];
                    try {
                        for(var p1 = n1(t1.data.getList("mo")), h1 = p1.next(); !h1.done; h1 = p1.next()){
                            var f1 = h1.value;
                            if (!f1.getProperty("relationsCombined") && f1.parent && (!f1.parent || a1.default.isType(f1.parent, "mrow")) && a1.default.getTexClass(f1) === s1.TEXCLASS.REL) {
                                for(var d1 = f1.parent, m1 = void 0, y1 = d1.childNodes, g1 = y1.indexOf(f1) + 1, b1 = a1.default.getProperty(f1, "variantForm"); g1 < y1.length && (m1 = y1[g1]) && a1.default.isType(m1, "mo") && a1.default.getTexClass(m1) === s1.TEXCLASS.REL;){
                                    if (b1 !== a1.default.getProperty(m1, "variantForm") || !r1(f1, m1)) {
                                        null == f1.attributes.getExplicit("rspace") && a1.default.setAttribute(f1, "rspace", "0pt"), null == m1.attributes.getExplicit("lspace") && a1.default.setAttribute(m1, "lspace", "0pt");
                                        break;
                                    }
                                    a1.default.appendChildren(f1, a1.default.getChildren(m1)), e1([
                                        "stretchy",
                                        "rspace"
                                    ], f1, m1);
                                    try {
                                        for(var v1 = (l1 = void 0, n1(m1.getPropertyNames())), _1 = v1.next(); !_1.done; _1 = v1.next()){
                                            var S1 = _1.value;
                                            f1.setProperty(S1, m1.getProperty(S1));
                                        }
                                    } catch (t1) {
                                        l1 = {
                                            error: t1
                                        };
                                    } finally{
                                        try {
                                            _1 && !_1.done && (c1 = v1.return) && c1.call(v1);
                                        } finally{
                                            if (l1) throw l1.error;
                                        }
                                    }
                                    y1.splice(g1, 1), u1.push(m1), m1.parent = null, m1.setProperty("relationsCombined", !0);
                                }
                                f1.attributes.setInherited("form", f1.getForms()[0]);
                            }
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            h1 && !h1.done && (i1 = p1.return) && i1.call(p1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    t1.data.removeFromList("mo", u1);
                };
                var e1 = function(t1, e1, r1) {
                    var n1 = e1.attributes, o1 = r1.attributes;
                    t1.forEach(function(t1) {
                        var e1 = o1.getExplicit(t1);
                        null != e1 && n1.set(t1, e1);
                    });
                }, r1 = function(t1, e1) {
                    var r1, o1, i1 = function(t1, e1) {
                        return t1.getExplicitNames().filter(function(r1) {
                            return r1 !== e1 && ("stretchy" !== r1 || t1.getExplicit("stretchy"));
                        });
                    }, s1 = t1.attributes, a1 = e1.attributes, l1 = i1(s1, "lspace"), c1 = i1(a1, "rspace");
                    if (l1.length !== c1.length) return !1;
                    try {
                        for(var u1 = n1(l1), p1 = u1.next(); !p1.done; p1 = u1.next()){
                            var h1 = p1.value;
                            if (s1.getExplicit(h1) !== a1.getExplicit(h1)) return !1;
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (o1 = u1.return) && o1.call(u1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    return !0;
                }, o1 = function(t1, e1, r1) {
                    var o1, i1, s1 = [];
                    try {
                        for(var l1 = n1(t1.getList("m" + e1 + r1)), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value, p1 = u1.childNodes;
                            if (!p1[u1[e1]] || !p1[u1[r1]]) {
                                var h1 = u1.parent, f1 = p1[u1[e1]] ? t1.nodeFactory.create("node", "m" + e1, [
                                    p1[u1.base],
                                    p1[u1[e1]]
                                ]) : t1.nodeFactory.create("node", "m" + r1, [
                                    p1[u1.base],
                                    p1[u1[r1]]
                                ]);
                                a1.default.copyAttributes(u1, f1), h1 ? h1.replaceChild(f1, u1) : t1.root = f1, s1.push(u1);
                            }
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (i1 = l1.return) && i1.call(l1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    t1.removeFromList("m" + e1 + r1, s1);
                };
                t1.cleanSubSup = function(t1) {
                    var e1 = t1.data;
                    e1.error || (o1(e1, "sub", "sup"), o1(e1, "under", "over"));
                };
                var i1 = function(t1, e1, r1) {
                    var o1, i1, s1 = [];
                    try {
                        for(var l1 = n1(t1.getList(e1)), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value;
                            if (!u1.attributes.get("displaystyle")) {
                                var p1 = u1.childNodes[u1.base], h1 = p1.coreMO();
                                if (p1.getProperty("movablelimits") && !h1.attributes.getExplicit("movablelimits")) {
                                    var f1 = t1.nodeFactory.create("node", r1, u1.childNodes);
                                    a1.default.copyAttributes(u1, f1), u1.parent ? u1.parent.replaceChild(f1, u1) : t1.root = f1, s1.push(u1);
                                }
                            }
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (i1 = l1.return) && i1.call(l1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    t1.removeFromList(e1, s1);
                };
                t1.moveLimits = function(t1) {
                    var e1 = t1.data;
                    i1(e1, "munderover", "msubsup"), i1(e1, "munder", "msub"), i1(e1, "mover", "msup");
                }, t1.setInherited = function(t1) {
                    t1.data.root.setInheritedAttributes({}, t1.math.display, 0, !1);
                };
            }(i1 || (i1 = {})), e1.default = i1;
        },
        7073: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.FindTeX = void 0;
            var s1 = r1(3494), a1 = r1(505), l1 = r1(4474), c1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this, e1) || this;
                    return r1.getPatterns(), r1;
                }
                return o1(e1, t1), e1.prototype.getPatterns = function() {
                    var t1 = this, e1 = this.options, r1 = [], n1 = [], o1 = [];
                    this.end = {}, this.env = this.sub = 0;
                    var i1 = 1;
                    e1.inlineMath.forEach(function(e1) {
                        return t1.addPattern(r1, e1, !1);
                    }), e1.displayMath.forEach(function(e1) {
                        return t1.addPattern(r1, e1, !0);
                    }), r1.length && n1.push(r1.sort(a1.sortLength).join("|")), e1.processEnvironments && (n1.push("\\\\begin\\s*\\{([^}]*)\\}"), this.env = i1, i1++), e1.processEscapes && o1.push("\\\\([\\\\$])"), e1.processRefs && o1.push("(\\\\(?:eq)?ref\\s*\\{[^}]*\\})"), o1.length && (n1.push("(" + o1.join("|") + ")"), this.sub = i1), this.start = new RegExp(n1.join("|"), "g"), this.hasPatterns = n1.length > 0;
                }, e1.prototype.addPattern = function(t1, e1, r1) {
                    var n1 = i1(e1, 2), o1 = n1[0], s1 = n1[1];
                    t1.push((0, a1.quotePattern)(o1)), this.end[o1] = [
                        s1,
                        r1,
                        this.endPattern(s1)
                    ];
                }, e1.prototype.endPattern = function(t1, e1) {
                    return new RegExp((e1 || (0, a1.quotePattern)(t1)) + "|\\\\(?:[a-zA-Z]|.)|[{}]", "g");
                }, e1.prototype.findEnd = function(t1, e1, r1, n1) {
                    for(var o1, s1 = i1(n1, 3), a1 = s1[0], c1 = s1[1], u1 = s1[2], p1 = u1.lastIndex = r1.index + r1[0].length, h1 = 0; o1 = u1.exec(t1);){
                        if ((o1[1] || o1[0]) === a1 && 0 === h1) return (0, l1.protoItem)(r1[0], t1.substr(p1, o1.index - p1), o1[0], e1, r1.index, o1.index + o1[0].length, c1);
                        "{" === o1[0] ? h1++ : "}" === o1[0] && h1 && h1--;
                    }
                    return null;
                }, e1.prototype.findMathInString = function(t1, e1, r1) {
                    var n1, o1;
                    for(this.start.lastIndex = 0; n1 = this.start.exec(r1);){
                        if (void 0 !== n1[this.env] && this.env) {
                            var i1 = "\\\\end\\s*(\\{" + (0, a1.quotePattern)(n1[this.env]) + "\\})";
                            (o1 = this.findEnd(r1, e1, n1, [
                                "{" + n1[this.env] + "}",
                                !0,
                                this.endPattern(null, i1)
                            ])) && (o1.math = o1.open + o1.math + o1.close, o1.open = o1.close = "");
                        } else if (void 0 !== n1[this.sub] && this.sub) {
                            var s1 = n1[this.sub];
                            i1 = n1.index + n1[this.sub].length;
                            o1 = 2 === s1.length ? (0, l1.protoItem)("", s1.substr(1), "", e1, n1.index, i1) : (0, l1.protoItem)("", s1, "", e1, n1.index, i1, !1);
                        } else o1 = this.findEnd(r1, e1, n1, this.end[n1[0]]);
                        o1 && (t1.push(o1), this.start.lastIndex = o1.end.n);
                    }
                }, e1.prototype.findMath = function(t1) {
                    var e1 = [];
                    if (this.hasPatterns) for(var r1 = 0, n1 = t1.length; r1 < n1; r1++)this.findMathInString(e1, r1, t1[r1]);
                    return e1;
                }, e1.OPTIONS = {
                    inlineMath: [
                        [
                            "\\(",
                            "\\)"
                        ]
                    ],
                    displayMath: [
                        [
                            "$$",
                            "$$"
                        ],
                        [
                            "\\[",
                            "\\]"
                        ]
                    ],
                    processEscapes: !0,
                    processEnvironments: !0,
                    processRefs: !0
                }, e1;
            }(s1.AbstractFindMath);
            e1.FindTeX = c1;
        },
        2947: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SubHandlers = e1.SubHandler = e1.MapHandler = void 0;
            var i1, s1 = r1(8666), a1 = r1(7525);
            !function(t1) {
                var e1 = new Map;
                t1.register = function(t1) {
                    e1.set(t1.name, t1);
                }, t1.getMap = function(t1) {
                    return e1.get(t1);
                };
            }(i1 = e1.MapHandler || (e1.MapHandler = {}));
            var l1 = function() {
                function t1() {
                    this._configuration = new s1.PrioritizedList, this._fallback = new a1.FunctionList;
                }
                return t1.prototype.add = function(t1, e1, r1) {
                    var o1, a1;
                    void 0 === r1 && (r1 = s1.PrioritizedList.DEFAULTPRIORITY);
                    try {
                        for(var l1 = n1(t1.slice().reverse()), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value, p1 = i1.getMap(u1);
                            if (!p1) return void this.warn("Configuration " + u1 + " not found! Omitted.");
                            this._configuration.add(p1, r1);
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (a1 = l1.return) && a1.call(l1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    e1 && this._fallback.add(e1, r1);
                }, t1.prototype.parse = function(t1) {
                    var e1, r1;
                    try {
                        for(var i1 = n1(this._configuration), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value.item.parse(t1);
                            if (a1) return a1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    var l1 = o1(t1, 2), c1 = l1[0], u1 = l1[1];
                    Array.from(this._fallback)[0].item(c1, u1);
                }, t1.prototype.lookup = function(t1) {
                    var e1 = this.applicable(t1);
                    return e1 ? e1.lookup(t1) : null;
                }, t1.prototype.contains = function(t1) {
                    return !!this.applicable(t1);
                }, t1.prototype.toString = function() {
                    var t1, e1, r1 = [];
                    try {
                        for(var o1 = n1(this._configuration), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value.item;
                            r1.push(s1.name);
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return r1.join(", ");
                }, t1.prototype.applicable = function(t1) {
                    var e1, r1;
                    try {
                        for(var o1 = n1(this._configuration), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value.item;
                            if (s1.contains(t1)) return s1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return null;
                }, t1.prototype.retrieve = function(t1) {
                    var e1, r1;
                    try {
                        for(var o1 = n1(this._configuration), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value.item;
                            if (s1.name === t1) return s1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return null;
                }, t1.prototype.warn = function(t1) {
                    console.log("TexParser Warning: " + t1);
                }, t1;
            }();
            e1.SubHandler = l1;
            var c1 = function() {
                function t1() {
                    this.map = new Map;
                }
                return t1.prototype.add = function(t1, e1, r1) {
                    var o1, i1;
                    void 0 === r1 && (r1 = s1.PrioritizedList.DEFAULTPRIORITY);
                    try {
                        for(var a1 = n1(Object.keys(t1)), c1 = a1.next(); !c1.done; c1 = a1.next()){
                            var u1 = c1.value, p1 = this.get(u1);
                            p1 || (p1 = new l1, this.set(u1, p1)), p1.add(t1[u1], e1[u1], r1);
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (i1 = a1.return) && i1.call(a1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                }, t1.prototype.set = function(t1, e1) {
                    this.map.set(t1, e1);
                }, t1.prototype.get = function(t1) {
                    return this.map.get(t1);
                }, t1.prototype.retrieve = function(t1) {
                    var e1, r1;
                    try {
                        for(var o1 = n1(this.map.values()), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value.retrieve(t1);
                            if (s1) return s1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return null;
                }, t1.prototype.keys = function() {
                    return this.map.keys();
                }, t1;
            }();
            e1.SubHandlers = c1;
        },
        8929: function(t1, e1, r1) {
            var n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, i1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.NodeFactory = void 0;
            var s1 = i1(r1(1256)), a1 = function() {
                function t1() {
                    this.mmlFactory = null, this.factory = {
                        node: t1.createNode,
                        token: t1.createToken,
                        text: t1.createText,
                        error: t1.createError
                    };
                }
                return t1.createNode = function(t1, e1, r1, n1, o1) {
                    void 0 === r1 && (r1 = []), void 0 === n1 && (n1 = {});
                    var i1 = t1.mmlFactory.create(e1);
                    return i1.setChildren(r1), o1 && i1.appendChild(o1), s1.default.setProperties(i1, n1), i1;
                }, t1.createToken = function(t1, e1, r1, n1) {
                    void 0 === r1 && (r1 = {}), void 0 === n1 && (n1 = "");
                    var o1 = t1.create("text", n1);
                    return t1.create("node", e1, [], r1, o1);
                }, t1.createText = function(t1, e1) {
                    return null == e1 ? null : t1.mmlFactory.create("text").setText(e1);
                }, t1.createError = function(t1, e1) {
                    var r1 = t1.create("text", e1), n1 = t1.create("node", "mtext", [], {}, r1);
                    return t1.create("node", "merror", [
                        n1
                    ], {
                        "data-mjx-error": e1
                    });
                }, t1.prototype.setMmlFactory = function(t1) {
                    this.mmlFactory = t1;
                }, t1.prototype.set = function(t1, e1) {
                    this.factory[t1] = e1;
                }, t1.prototype.setCreators = function(t1) {
                    for(var e1 in t1)this.set(e1, t1[e1]);
                }, t1.prototype.create = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    var i1 = this.factory[t1] || this.factory.node, s1 = i1.apply(void 0, o1([
                        this,
                        e1[0]
                    ], n1(e1.slice(1)), !1));
                    return "node" === t1 && this.configuration.addNode(e1[0], s1), s1;
                }, t1.prototype.get = function(t1) {
                    return this.factory[t1];
                }, t1;
            }();
            e1.NodeFactory = a1;
        },
        1256: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var s1, a1 = r1(9007), l1 = r1(2756);
            !function(t1) {
                var e1 = new Map([
                    [
                        "autoOP",
                        !0
                    ],
                    [
                        "fnOP",
                        !0
                    ],
                    [
                        "movesupsub",
                        !0
                    ],
                    [
                        "subsupOK",
                        !0
                    ],
                    [
                        "texprimestyle",
                        !0
                    ],
                    [
                        "useHeight",
                        !0
                    ],
                    [
                        "variantForm",
                        !0
                    ],
                    [
                        "withDelims",
                        !0
                    ],
                    [
                        "mathaccent",
                        !0
                    ],
                    [
                        "open",
                        !0
                    ],
                    [
                        "close",
                        !0
                    ]
                ]);
                function r1(t1, r1) {
                    var o1, i1;
                    try {
                        for(var s1 = n1(Object.keys(r1)), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value, c1 = r1[l1];
                            "texClass" === l1 ? (t1.texClass = c1, t1.setProperty(l1, c1)) : "movablelimits" === l1 ? (t1.setProperty("movablelimits", c1), (t1.isKind("mo") || t1.isKind("mstyle")) && t1.attributes.set("movablelimits", c1)) : "inferred" === l1 || (e1.has(l1) ? t1.setProperty(l1, c1) : t1.attributes.set(l1, c1));
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (i1 = s1.return) && i1.call(s1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                }
                function s1(t1, e1, r1) {
                    t1.childNodes[e1] = r1, r1 && (r1.parent = t1);
                }
                function c1(t1, e1) {
                    return t1.isKind(e1);
                }
                t1.createEntity = function(t1) {
                    return String.fromCodePoint(parseInt(t1, 16));
                }, t1.getChildren = function(t1) {
                    return t1.childNodes;
                }, t1.getText = function(t1) {
                    return t1.getText();
                }, t1.appendChildren = function(t1, e1) {
                    var r1, o1;
                    try {
                        for(var i1 = n1(e1), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value;
                            t1.appendChild(a1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (o1 = i1.return) && o1.call(i1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, t1.setAttribute = function(t1, e1, r1) {
                    t1.attributes.set(e1, r1);
                }, t1.setProperty = function(t1, e1, r1) {
                    t1.setProperty(e1, r1);
                }, t1.setProperties = r1, t1.getProperty = function(t1, e1) {
                    return t1.getProperty(e1);
                }, t1.getAttribute = function(t1, e1) {
                    return t1.attributes.get(e1);
                }, t1.removeProperties = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    t1.removeProperty.apply(t1, i1([], o1(e1), !1));
                }, t1.getChildAt = function(t1, e1) {
                    return t1.childNodes[e1];
                }, t1.setChild = s1, t1.copyChildren = function(t1, e1) {
                    for(var r1 = t1.childNodes, n1 = 0; n1 < r1.length; n1++)s1(e1, n1, r1[n1]);
                }, t1.copyAttributes = function(t1, e1) {
                    e1.attributes = t1.attributes, r1(e1, t1.getAllProperties());
                }, t1.isType = c1, t1.isEmbellished = function(t1) {
                    return t1.isEmbellished;
                }, t1.getTexClass = function(t1) {
                    return t1.texClass;
                }, t1.getCoreMO = function(t1) {
                    return t1.coreMO();
                }, t1.isNode = function(t1) {
                    return t1 instanceof a1.AbstractMmlNode || t1 instanceof a1.AbstractMmlEmptyNode;
                }, t1.isInferred = function(t1) {
                    return t1.isInferred;
                }, t1.getForm = function(t1) {
                    var e1, r1;
                    if (!c1(t1, "mo")) return null;
                    var o1 = t1, i1 = o1.getForms();
                    try {
                        for(var s1 = n1(i1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var u1 = a1.value, p1 = l1.MmlMo.OPTABLE[u1][o1.getText()];
                            if (p1) return p1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (r1 = s1.return) && r1.call(s1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return null;
                };
            }(s1 || (s1 = {})), e1.default = s1;
        },
        5450: function(t1, e1, r1) {
            var n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, i1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var s1, a1 = i1(r1(1256)), l1 = r1(8317), c1 = i1(r1(1130));
            !function(t1) {
                t1.variable = function(t1, e1) {
                    var r1 = c1.default.getFontDef(t1), n1 = t1.stack.env;
                    n1.multiLetterIdentifiers && "" !== n1.font && (e1 = t1.string.substr(t1.i - 1).match(n1.multiLetterIdentifiers)[0], t1.i += e1.length - 1, r1.mathvariant === l1.TexConstant.Variant.NORMAL && n1.noAutoOP && e1.length > 1 && (r1.autoOP = !1));
                    var o1 = t1.create("token", "mi", r1, e1);
                    t1.Push(o1);
                }, t1.digit = function(t1, e1) {
                    var r1, n1 = t1.configuration.options.digits, o1 = t1.string.slice(t1.i - 1).match(n1), i1 = c1.default.getFontDef(t1);
                    o1 ? (r1 = t1.create("token", "mn", i1, o1[0].replace(/[{}]/g, "")), t1.i += o1[0].length - 1) : r1 = t1.create("token", "mo", i1, e1), t1.Push(r1);
                }, t1.controlSequence = function(t1, e1) {
                    var r1 = t1.GetCS();
                    t1.parse("macro", [
                        t1,
                        r1
                    ]);
                }, t1.mathchar0mi = function(t1, e1) {
                    var r1 = e1.attributes || {
                        mathvariant: l1.TexConstant.Variant.ITALIC
                    }, n1 = t1.create("token", "mi", r1, e1.char);
                    t1.Push(n1);
                }, t1.mathchar0mo = function(t1, e1) {
                    var r1 = e1.attributes || {};
                    r1.stretchy = !1;
                    var n1 = t1.create("token", "mo", r1, e1.char);
                    a1.default.setProperty(n1, "fixStretchy", !0), t1.configuration.addNode("fixStretchy", n1), t1.Push(n1);
                }, t1.mathchar7 = function(t1, e1) {
                    var r1 = e1.attributes || {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    };
                    t1.stack.env.font && (r1.mathvariant = t1.stack.env.font);
                    var n1 = t1.create("token", "mi", r1, e1.char);
                    t1.Push(n1);
                }, t1.delimiter = function(t1, e1) {
                    var r1 = e1.attributes || {};
                    r1 = Object.assign({
                        fence: !1,
                        stretchy: !1
                    }, r1);
                    var n1 = t1.create("token", "mo", r1, e1.char);
                    t1.Push(n1);
                }, t1.environment = function(t1, e1, r1, i1) {
                    var s1 = i1[0], a1 = t1.itemFactory.create("begin").setProperties({
                        name: e1,
                        end: s1
                    });
                    a1 = r1.apply(void 0, o1([
                        t1,
                        a1
                    ], n1(i1.slice(1)), !1)), t1.Push(a1);
                };
            }(s1 || (s1 = {})), e1.default = s1;
        },
        8562: function(t1, e1, r1) {
            var n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var a1 = s1(r1(5453)), l1 = r1(8929), c1 = s1(r1(1256)), u1 = r1(7233), p1 = function() {
                function t1(t1, e1) {
                    void 0 === e1 && (e1 = []), this.options = {}, this.packageData = new Map, this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.handlers = t1.handlers, this.nodeFactory = new l1.NodeFactory, this.nodeFactory.configuration = this, this.nodeFactory.setCreators(t1.nodes), this.itemFactory = new a1.default(t1.items), this.itemFactory.configuration = this, u1.defaultOptions.apply(void 0, o1([
                        this.options
                    ], n1(e1), !1)), (0, u1.defaultOptions)(this.options, t1.options);
                }
                return t1.prototype.pushParser = function(t1) {
                    this.parsers.unshift(t1);
                }, t1.prototype.popParser = function() {
                    this.parsers.shift();
                }, Object.defineProperty(t1.prototype, "parser", {
                    get: function() {
                        return this.parsers[0];
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.clear = function() {
                    this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.tags.resetTag();
                }, t1.prototype.addNode = function(t1, e1) {
                    var r1 = this.nodeLists[t1];
                    if (r1 || (r1 = this.nodeLists[t1] = []), r1.push(e1), e1.kind !== t1) {
                        var n1 = c1.default.getProperty(e1, "in-lists") || "", o1 = (n1 ? n1.split(/,/) : []).concat(t1).join(",");
                        c1.default.setProperty(e1, "in-lists", o1);
                    }
                }, t1.prototype.getList = function(t1) {
                    var e1, r1, n1 = this.nodeLists[t1] || [], o1 = [];
                    try {
                        for(var s1 = i1(n1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            this.inTree(l1) && o1.push(l1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (r1 = s1.return) && r1.call(s1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return this.nodeLists[t1] = o1, o1;
                }, t1.prototype.removeFromList = function(t1, e1) {
                    var r1, n1, o1 = this.nodeLists[t1] || [];
                    try {
                        for(var s1 = i1(e1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value, c1 = o1.indexOf(l1);
                            c1 >= 0 && o1.splice(c1, 1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = s1.return) && n1.call(s1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, t1.prototype.inTree = function(t1) {
                    for(; t1 && t1 !== this.root;)t1 = t1.parent;
                    return !!t1;
                }, t1;
            }();
            e1.default = p1;
        },
        1130: function(t1, e1, r1) {
            var n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, i1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var s1, a1 = r1(9007), l1 = i1(r1(1256)), c1 = i1(r1(8417)), u1 = i1(r1(3971)), p1 = r1(5368);
            !function(t1) {
                var e1 = 7.2, r1 = {
                    em: function(t1) {
                        return t1;
                    },
                    ex: function(t1) {
                        return .43 * t1;
                    },
                    pt: function(t1) {
                        return t1 / 10;
                    },
                    pc: function(t1) {
                        return 1.2 * t1;
                    },
                    px: function(t1) {
                        return t1 * e1 / 72;
                    },
                    in: function(t1) {
                        return t1 * e1;
                    },
                    cm: function(t1) {
                        return t1 * e1 / 2.54;
                    },
                    mm: function(t1) {
                        return t1 * e1 / 25.4;
                    },
                    mu: function(t1) {
                        return t1 / 18;
                    }
                }, i1 = "([-+]?([.,]\\d+|\\d+([.,]\\d*)?))", s1 = "(pt|em|ex|mu|px|mm|cm|in|pc)", h1 = RegExp("^\\s*" + i1 + "\\s*" + s1 + "\\s*$"), f1 = RegExp("^\\s*" + i1 + "\\s*" + s1 + " ?");
                function d1(t1, e1) {
                    void 0 === e1 && (e1 = !1);
                    var o1 = t1.match(e1 ? f1 : h1);
                    return o1 ? function(t1) {
                        var e1 = n1(t1, 3), o1 = e1[0], i1 = e1[1], s1 = e1[2];
                        if ("mu" !== i1) return [
                            o1,
                            i1,
                            s1
                        ];
                        return [
                            m1(r1[i1](parseFloat(o1 || "1"))).slice(0, -2),
                            "em",
                            s1
                        ];
                    }([
                        o1[1].replace(/,/, "."),
                        o1[4],
                        o1[0].length
                    ]) : [
                        null,
                        null,
                        0
                    ];
                }
                function m1(t1) {
                    return Math.abs(t1) < 6e-4 ? "0em" : t1.toFixed(3).replace(/\.?0+$/, "") + "em";
                }
                function y1(t1, e1, r1) {
                    "{" !== e1 && "}" !== e1 || (e1 = "\\" + e1);
                    var n1 = "{\\bigg" + r1 + " " + e1 + "}", o1 = "{\\big" + r1 + " " + e1 + "}";
                    return new c1.default("\\mathchoice" + n1 + o1 + o1 + o1, {}, t1).mml();
                }
                function g1(t1, e1, r1) {
                    e1 = e1.replace(/^\s+/, p1.entities.nbsp).replace(/\s+$/, p1.entities.nbsp);
                    var n1 = t1.create("text", e1);
                    return t1.create("node", "mtext", [], r1, n1);
                }
                function b1(t1, e1, r1) {
                    if (r1.match(/^[a-z]/i) && e1.match(/(^|[^\\])(\\\\)*\\[a-z]+$/i) && (e1 += " "), e1.length + r1.length > t1.configuration.options.maxBuffer) throw new u1.default("MaxBufferSize", "MathJax internal buffer size exceeded; is there a recursive macro call?");
                    return e1 + r1;
                }
                function v1(t1, e1) {
                    for(; e1 > 0;)t1 = t1.trim().slice(1, -1), e1--;
                    return t1.trim();
                }
                function _1(t1, e1) {
                    for(var r1 = t1.length, n1 = 0, o1 = "", i1 = 0, s1 = 0, a1 = !0, l1 = !1; i1 < r1;){
                        var c1 = t1[i1++];
                        switch(c1){
                            case " ":
                                break;
                            case "{":
                                a1 ? s1++ : (l1 = !1, s1 > n1 && (s1 = n1)), n1++;
                                break;
                            case "}":
                                n1 && n1--, (a1 || l1) && (s1--, l1 = !0), a1 = !1;
                                break;
                            default:
                                if (!n1 && -1 !== e1.indexOf(c1)) return [
                                    l1 ? "true" : v1(o1, s1),
                                    c1,
                                    t1.slice(i1)
                                ];
                                a1 = !1, l1 = !1;
                        }
                        o1 += c1;
                    }
                    if (n1) throw new u1.default("ExtraOpenMissingClose", "Extra open brace or missing close brace");
                    return [
                        l1 ? "true" : v1(o1, s1),
                        "",
                        t1.slice(i1)
                    ];
                }
                t1.matchDimen = d1, t1.dimen2em = function(t1) {
                    var e1 = n1(d1(t1), 2), o1 = e1[0], i1 = e1[1], s1 = parseFloat(o1 || "1"), a1 = r1[i1];
                    return a1 ? a1(s1) : 0;
                }, t1.Em = m1, t1.cols = function() {
                    for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1[e1] = arguments[e1];
                    return t1.map(function(t1) {
                        return m1(t1);
                    }).join(" ");
                }, t1.fenced = function(t1, e1, r1, n1, o1, i1) {
                    void 0 === o1 && (o1 = ""), void 0 === i1 && (i1 = "");
                    var s1, u1 = t1.nodeFactory, p1 = u1.create("node", "mrow", [], {
                        open: e1,
                        close: n1,
                        texClass: a1.TEXCLASS.INNER
                    });
                    if (o1) s1 = new c1.default("\\" + o1 + "l" + e1, t1.parser.stack.env, t1).mml();
                    else {
                        var h1 = u1.create("text", e1);
                        s1 = u1.create("node", "mo", [], {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0,
                            texClass: a1.TEXCLASS.OPEN
                        }, h1);
                    }
                    if (l1.default.appendChildren(p1, [
                        s1,
                        r1
                    ]), o1) s1 = new c1.default("\\" + o1 + "r" + n1, t1.parser.stack.env, t1).mml();
                    else {
                        var f1 = u1.create("text", n1);
                        s1 = u1.create("node", "mo", [], {
                            fence: !0,
                            stretchy: !0,
                            symmetric: !0,
                            texClass: a1.TEXCLASS.CLOSE
                        }, f1);
                    }
                    return i1 && s1.attributes.set("mathcolor", i1), l1.default.appendChildren(p1, [
                        s1
                    ]), p1;
                }, t1.fixedFence = function(t1, e1, r1, n1) {
                    var o1 = t1.nodeFactory.create("node", "mrow", [], {
                        open: e1,
                        close: n1,
                        texClass: a1.TEXCLASS.ORD
                    });
                    return e1 && l1.default.appendChildren(o1, [
                        y1(t1, e1, "l")
                    ]), l1.default.isType(r1, "mrow") ? l1.default.appendChildren(o1, l1.default.getChildren(r1)) : l1.default.appendChildren(o1, [
                        r1
                    ]), n1 && l1.default.appendChildren(o1, [
                        y1(t1, n1, "r")
                    ]), o1;
                }, t1.mathPalette = y1, t1.fixInitialMO = function(t1, e1) {
                    for(var r1 = 0, n1 = e1.length; r1 < n1; r1++){
                        var o1 = e1[r1];
                        if (o1 && !l1.default.isType(o1, "mspace") && (!l1.default.isType(o1, "TeXAtom") || l1.default.getChildren(o1)[0] && l1.default.getChildren(l1.default.getChildren(o1)[0]).length)) {
                            if (l1.default.isEmbellished(o1) || l1.default.isType(o1, "TeXAtom") && l1.default.getTexClass(o1) === a1.TEXCLASS.REL) {
                                var i1 = t1.nodeFactory.create("node", "mi");
                                e1.unshift(i1);
                            }
                            break;
                        }
                    }
                }, t1.internalMath = function(t1, e1, r1, n1) {
                    if (t1.configuration.options.internalMath) return t1.configuration.options.internalMath(t1, e1, r1, n1);
                    var o1, i1, s1 = n1 || t1.stack.env.font, a1 = s1 ? {
                        mathvariant: s1
                    } : {}, l1 = [], p1 = 0, h1 = 0, f1 = "", d1 = 0;
                    if (e1.match(/\\?[${}\\]|\\\(|\\(eq)?ref\s*\{/)) {
                        for(; p1 < e1.length;)if ("$" === (o1 = e1.charAt(p1++))) "$" === f1 && 0 === d1 ? (i1 = t1.create("node", "TeXAtom", [
                            new c1.default(e1.slice(h1, p1 - 1), {}, t1.configuration).mml()
                        ]), l1.push(i1), f1 = "", h1 = p1) : "" === f1 && (h1 < p1 - 1 && l1.push(g1(t1, e1.slice(h1, p1 - 1), a1)), f1 = "$", h1 = p1);
                        else if ("{" === o1 && "" !== f1) d1++;
                        else if ("}" === o1) {
                            if ("}" === f1 && 0 === d1) {
                                var m1 = new c1.default(e1.slice(h1, p1), {}, t1.configuration).mml();
                                i1 = t1.create("node", "TeXAtom", [
                                    m1
                                ], a1), l1.push(i1), f1 = "", h1 = p1;
                            } else "" !== f1 && d1 && d1--;
                        } else if ("\\" === o1) {
                            if ("" === f1 && e1.substr(p1).match(/^(eq)?ref\s*\{/)) {
                                var y1 = RegExp["$&"].length;
                                h1 < p1 - 1 && l1.push(g1(t1, e1.slice(h1, p1 - 1), a1)), f1 = "}", h1 = p1 - 1, p1 += y1;
                            } else "(" === (o1 = e1.charAt(p1++)) && "" === f1 ? (h1 < p1 - 2 && l1.push(g1(t1, e1.slice(h1, p1 - 2), a1)), f1 = ")", h1 = p1) : ")" === o1 && ")" === f1 && 0 === d1 ? (i1 = t1.create("node", "TeXAtom", [
                                new c1.default(e1.slice(h1, p1 - 2), {}, t1.configuration).mml()
                            ]), l1.push(i1), f1 = "", h1 = p1) : o1.match(/[${}\\]/) && "" === f1 && (p1--, e1 = e1.substr(0, p1 - 1) + e1.substr(p1));
                        }
                        if ("" !== f1) throw new u1.default("MathNotTerminated", "Math not terminated in text box");
                    }
                    return h1 < e1.length && l1.push(g1(t1, e1.slice(h1), a1)), null != r1 ? l1 = [
                        t1.create("node", "mstyle", l1, {
                            displaystyle: !1,
                            scriptlevel: r1
                        })
                    ] : l1.length > 1 && (l1 = [
                        t1.create("node", "mrow", l1)
                    ]), l1;
                }, t1.internalText = g1, t1.underOver = function(e1, r1, n1, o1, i1) {
                    if (t1.checkMovableLimits(r1), l1.default.isType(r1, "munderover") && l1.default.isEmbellished(r1)) {
                        l1.default.setProperties(l1.default.getCoreMO(r1), {
                            lspace: 0,
                            rspace: 0
                        });
                        var s1 = e1.create("node", "mo", [], {
                            rspace: 0
                        });
                        r1 = e1.create("node", "mrow", [
                            s1,
                            r1
                        ]);
                    }
                    var c1 = e1.create("node", "munderover", [
                        r1
                    ]);
                    l1.default.setChild(c1, "over" === o1 ? c1.over : c1.under, n1);
                    var u1 = c1;
                    return i1 && (u1 = e1.create("node", "TeXAtom", [
                        c1
                    ], {
                        texClass: a1.TEXCLASS.OP,
                        movesupsub: !0
                    })), l1.default.setProperty(u1, "subsupOK", !0), u1;
                }, t1.checkMovableLimits = function(t1) {
                    var e1 = l1.default.isType(t1, "mo") ? l1.default.getForm(t1) : null;
                    (l1.default.getProperty(t1, "movablelimits") || e1 && e1[3] && e1[3].movablelimits) && l1.default.setProperties(t1, {
                        movablelimits: !1
                    });
                }, t1.trimSpaces = function(t1) {
                    if ("string" != typeof t1) return t1;
                    var e1 = t1.trim();
                    return e1.match(/\\$/) && t1.match(/ $/) && (e1 += " "), e1;
                }, t1.setArrayAlign = function(e1, r1) {
                    return "t" === (r1 = t1.trimSpaces(r1 || "")) ? e1.arraydef.align = "baseline 1" : "b" === r1 ? e1.arraydef.align = "baseline -1" : "c" === r1 ? e1.arraydef.align = "axis" : r1 && (e1.arraydef.align = r1), e1;
                }, t1.substituteArgs = function(t1, e1, r1) {
                    for(var n1 = "", o1 = "", i1 = 0; i1 < r1.length;){
                        var s1 = r1.charAt(i1++);
                        if ("\\" === s1) n1 += s1 + r1.charAt(i1++);
                        else if ("#" === s1) {
                            if ("#" === (s1 = r1.charAt(i1++))) n1 += s1;
                            else {
                                if (!s1.match(/[1-9]/) || parseInt(s1, 10) > e1.length) throw new u1.default("IllegalMacroParam", "Illegal macro parameter reference");
                                o1 = b1(t1, b1(t1, o1, n1), e1[parseInt(s1, 10) - 1]), n1 = "";
                            }
                        } else n1 += s1;
                    }
                    return b1(t1, o1, n1);
                }, t1.addArgs = b1, t1.checkMaxMacros = function(t1, e1) {
                    if (void 0 === e1 && (e1 = !0), !(++t1.macroCount <= t1.configuration.options.maxMacros)) throw e1 ? new u1.default("MaxMacroSub1", "MathJax maximum macro substitution count exceeded; is here a recursive macro call?") : new u1.default("MaxMacroSub2", "MathJax maximum substitution count exceeded; is there a recursive latex environment?");
                }, t1.checkEqnEnv = function(t1) {
                    if (t1.stack.global.eqnenv) throw new u1.default("ErroneousNestingEq", "Erroneous nesting of equation structures");
                    t1.stack.global.eqnenv = !0;
                }, t1.copyNode = function(t1, e1) {
                    var r1 = t1.copy(), n1 = e1.configuration;
                    return r1.walkTree(function(t1) {
                        var e1, r1;
                        n1.addNode(t1.kind, t1);
                        var i1 = (t1.getProperty("in-lists") || "").split(/,/);
                        try {
                            for(var s1 = o1(i1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                                var l1 = a1.value;
                                l1 && n1.addNode(l1, t1);
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (r1 = s1.return) && r1.call(s1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                    }), r1;
                }, t1.MmlFilterAttribute = function(t1, e1, r1) {
                    return r1;
                }, t1.getFontDef = function(t1) {
                    var e1 = t1.stack.env.font;
                    return e1 ? {
                        mathvariant: e1
                    } : {};
                }, t1.keyvalOptions = function(t1, e1, r1) {
                    var i1, s1;
                    void 0 === e1 && (e1 = null), void 0 === r1 && (r1 = !1);
                    var a1 = function(t1) {
                        var e1, r1, o1, i1, s1, a1 = {}, l1 = t1;
                        for(; l1;)i1 = (e1 = n1(_1(l1, [
                            "=",
                            ","
                        ]), 3))[0], o1 = e1[1], l1 = e1[2], "=" === o1 ? (s1 = (r1 = n1(_1(l1, [
                            ","
                        ]), 3))[0], o1 = r1[1], l1 = r1[2], s1 = "false" === s1 || "true" === s1 ? JSON.parse(s1) : s1, a1[i1] = s1) : i1 && (a1[i1] = !0);
                        return a1;
                    }(t1);
                    if (e1) try {
                        for(var l1 = o1(Object.keys(a1)), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var p1 = c1.value;
                            if (!e1.hasOwnProperty(p1)) {
                                if (r1) throw new u1.default("InvalidOption", "Invalid option: %1", p1);
                                delete a1[p1];
                            }
                        }
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (s1 = l1.return) && s1.call(l1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                    return a1;
                };
            }(s1 || (s1 = {})), e1.default = s1;
        },
        9497: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var a1 = s1(r1(1256)), l1 = function() {
                function t1(t1, e1, r1) {
                    this._factory = t1, this._env = e1, this.global = {}, this.stack = [], this.global = {
                        isInner: r1
                    }, this.stack = [
                        this._factory.create("start", this.global)
                    ], e1 && (this.stack[0].env = e1), this.env = this.stack[0].env;
                }
                return Object.defineProperty(t1.prototype, "env", {
                    get: function() {
                        return this._env;
                    },
                    set: function(t1) {
                        this._env = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.Push = function() {
                    for(var t1, e1, r1 = [], s1 = 0; s1 < arguments.length; s1++)r1[s1] = arguments[s1];
                    try {
                        for(var l1 = n1(r1), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value;
                            if (u1) {
                                var p1 = a1.default.isNode(u1) ? this._factory.create("mml", u1) : u1;
                                p1.global = this.global;
                                var h1 = o1(this.stack.length ? this.Top().checkItem(p1) : [
                                    null,
                                    !0
                                ], 2), f1 = h1[0], d1 = h1[1];
                                d1 && (f1 ? (this.Pop(), this.Push.apply(this, i1([], o1(f1), !1))) : (this.stack.push(p1), p1.env ? (p1.copyEnv && Object.assign(p1.env, this.env), this.env = p1.env) : p1.env = this.env));
                            }
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (e1 = l1.return) && e1.call(l1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, t1.prototype.Pop = function() {
                    var t1 = this.stack.pop();
                    return t1.isOpen || delete t1.env, this.env = this.stack.length ? this.Top().env : {}, t1;
                }, t1.prototype.Top = function(t1) {
                    return void 0 === t1 && (t1 = 1), this.stack.length < t1 ? null : this.stack[this.stack.length - t1];
                }, t1.prototype.Prev = function(t1) {
                    var e1 = this.Top();
                    return t1 ? e1.First : e1.Pop();
                }, t1.prototype.toString = function() {
                    return "stack[\n  " + this.stack.join("\n  ") + "\n]";
                }, t1;
            }();
            e1.default = l1;
        },
        8292: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, l1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BaseItem = e1.MmlStack = void 0;
            var c1 = l1(r1(3971)), u1 = function() {
                function t1(t1) {
                    this._nodes = t1;
                }
                return Object.defineProperty(t1.prototype, "nodes", {
                    get: function() {
                        return this._nodes;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.Push = function() {
                    for(var t1, e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                    (t1 = this._nodes).push.apply(t1, s1([], i1(e1), !1));
                }, t1.prototype.Pop = function() {
                    return this._nodes.pop();
                }, Object.defineProperty(t1.prototype, "First", {
                    get: function() {
                        return this._nodes[this.Size() - 1];
                    },
                    set: function(t1) {
                        this._nodes[this.Size() - 1] = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "Last", {
                    get: function() {
                        return this._nodes[0];
                    },
                    set: function(t1) {
                        this._nodes[0] = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.Peek = function(t1) {
                    return null == t1 && (t1 = 1), this._nodes.slice(this.Size() - t1);
                }, t1.prototype.Size = function() {
                    return this._nodes.length;
                }, t1.prototype.Clear = function() {
                    this._nodes = [];
                }, t1.prototype.toMml = function(t1, e1) {
                    return void 0 === t1 && (t1 = !0), 1 !== this._nodes.length || e1 ? this.create("node", t1 ? "inferredMrow" : "mrow", this._nodes, {}) : this.First;
                }, t1.prototype.create = function(t1) {
                    for(var e1, r1 = [], n1 = 1; n1 < arguments.length; n1++)r1[n1 - 1] = arguments[n1];
                    return (e1 = this.factory.configuration.nodeFactory).create.apply(e1, s1([
                        t1
                    ], i1(r1), !1));
                }, t1;
            }();
            e1.MmlStack = u1;
            var p1 = function(t1) {
                function e1(e1) {
                    for(var r1 = [], n1 = 1; n1 < arguments.length; n1++)r1[n1 - 1] = arguments[n1];
                    var o1 = t1.call(this, r1) || this;
                    return o1.factory = e1, o1.global = {}, o1._properties = {}, o1.isOpen && (o1._env = {}), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "base";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "env", {
                    get: function() {
                        return this._env;
                    },
                    set: function(t1) {
                        this._env = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "copyEnv", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.getProperty = function(t1) {
                    return this._properties[t1];
                }, e1.prototype.setProperty = function(t1, e1) {
                    return this._properties[t1] = e1, this;
                }, Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isFinal", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.isKind = function(t1) {
                    return t1 === this.kind;
                }, e1.prototype.checkItem = function(t1) {
                    if (t1.isKind("over") && this.isOpen && (t1.setProperty("num", this.toMml(!1)), this.Clear()), t1.isKind("cell") && this.isOpen) {
                        if (t1.getProperty("linebreak")) return e1.fail;
                        throw new c1.default("Misplaced", "Misplaced %1", t1.getName());
                    }
                    if (t1.isClose && this.getErrors(t1.kind)) {
                        var r1 = i1(this.getErrors(t1.kind), 2), n1 = r1[0], o1 = r1[1];
                        throw new c1.default(n1, o1, t1.getName());
                    }
                    return t1.isFinal ? (this.Push(t1.First), e1.fail) : e1.success;
                }, e1.prototype.clearEnv = function() {
                    var t1, e1;
                    try {
                        for(var r1 = a1(Object.keys(this.env)), n1 = r1.next(); !n1.done; n1 = r1.next()){
                            var o1 = n1.value;
                            delete this.env[o1];
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.prototype.setProperties = function(t1) {
                    return Object.assign(this._properties, t1), this;
                }, e1.prototype.getName = function() {
                    return this.getProperty("name");
                }, e1.prototype.toString = function() {
                    return this.kind + "[" + this.nodes.join("; ") + "]";
                }, e1.prototype.getErrors = function(t1) {
                    return (this.constructor.errors || {})[t1] || e1.errors[t1];
                }, e1.fail = [
                    null,
                    !1
                ], e1.success = [
                    null,
                    !0
                ], e1.errors = {
                    end: [
                        "MissingBeginExtraEnd",
                        "Missing \\begin{%1} or extra \\end{%1}"
                    ],
                    close: [
                        "ExtraCloseMissingOpen",
                        "Extra close brace or missing open brace"
                    ],
                    right: [
                        "MissingLeftExtraRight",
                        "Missing \\left or extra \\right"
                    ],
                    middle: [
                        "ExtraMiddle",
                        "Extra \\middle"
                    ]
                }, e1;
            }(u1);
            e1.BaseItem = p1;
        },
        5453: function(t1, e1, r1) {
            var n1, o1, i1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var s1 = r1(8292), a1 = r1(4574), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return i1(e1, t1), e1;
            }(s1.BaseItem), c1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.defaultKind = "dummy", e1.configuration = null, e1;
                }
                return i1(e1, t1), e1.DefaultStackItems = ((o1 = {})[l1.prototype.kind] = l1, o1), e1;
            }(a1.AbstractFactory);
            e1.default = c1;
        },
        8803: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Macro = e1.Symbol = void 0;
            var r1 = function() {
                function t1(t1, e1, r1) {
                    this._symbol = t1, this._char = e1, this._attributes = r1;
                }
                return Object.defineProperty(t1.prototype, "symbol", {
                    get: function() {
                        return this._symbol;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "char", {
                    get: function() {
                        return this._char;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "attributes", {
                    get: function() {
                        return this._attributes;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1;
            }();
            e1.Symbol = r1;
            var n1 = function() {
                function t1(t1, e1, r1) {
                    void 0 === r1 && (r1 = []), this._symbol = t1, this._func = e1, this._args = r1;
                }
                return Object.defineProperty(t1.prototype, "symbol", {
                    get: function() {
                        return this._symbol;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "func", {
                    get: function() {
                        return this._func;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "args", {
                    get: function() {
                        return this._args;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1;
            }();
            e1.Macro = n1;
        },
        9140: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, a1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.EnvironmentMap = e1.CommandMap = e1.MacroMap = e1.DelimiterMap = e1.CharacterMap = e1.AbstractParseMap = e1.RegExpMap = e1.AbstractSymbolMap = e1.parseResult = void 0;
            var l1 = r1(8803), c1 = r1(2947);
            function u1(t1) {
                return void 0 === t1 || t1;
            }
            e1.parseResult = u1;
            var p1 = function() {
                function t1(t1, e1) {
                    this._name = t1, this._parser = e1, c1.MapHandler.register(this);
                }
                return Object.defineProperty(t1.prototype, "name", {
                    get: function() {
                        return this._name;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.parserFor = function(t1) {
                    return this.contains(t1) ? this.parser : null;
                }, t1.prototype.parse = function(t1) {
                    var e1 = i1(t1, 2), r1 = e1[0], n1 = e1[1], o1 = this.parserFor(n1), s1 = this.lookup(n1);
                    return o1 && s1 ? u1(o1(r1, s1)) : null;
                }, Object.defineProperty(t1.prototype, "parser", {
                    get: function() {
                        return this._parser;
                    },
                    set: function(t1) {
                        this._parser = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1;
            }();
            e1.AbstractSymbolMap = p1;
            var h1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1 = t1.call(this, e1, r1) || this;
                    return o1._regExp = n1, o1;
                }
                return o1(e1, t1), e1.prototype.contains = function(t1) {
                    return this._regExp.test(t1);
                }, e1.prototype.lookup = function(t1) {
                    return this.contains(t1) ? t1 : null;
                }, e1;
            }(p1);
            e1.RegExpMap = h1;
            var f1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.map = new Map, e1;
                }
                return o1(e1, t1), e1.prototype.lookup = function(t1) {
                    return this.map.get(t1);
                }, e1.prototype.contains = function(t1) {
                    return this.map.has(t1);
                }, e1.prototype.add = function(t1, e1) {
                    this.map.set(t1, e1);
                }, e1.prototype.remove = function(t1) {
                    this.map.delete(t1);
                }, e1;
            }(p1);
            e1.AbstractParseMap = f1;
            var d1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1, a1, c1 = t1.call(this, e1, r1) || this;
                    try {
                        for(var u1 = s1(Object.keys(n1)), p1 = u1.next(); !p1.done; p1 = u1.next()){
                            var h1 = p1.value, f1 = n1[h1], d1 = i1("string" == typeof f1 ? [
                                f1,
                                null
                            ] : f1, 2), m1 = d1[0], y1 = d1[1], g1 = new l1.Symbol(h1, m1, y1);
                            c1.add(h1, g1);
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (a1 = u1.return) && a1.call(u1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    return c1;
                }
                return o1(e1, t1), e1;
            }(f1);
            e1.CharacterMap = d1;
            var m1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.parse = function(e1) {
                    var r1 = i1(e1, 2), n1 = r1[0], o1 = r1[1];
                    return t1.prototype.parse.call(this, [
                        n1,
                        "\\" + o1
                    ]);
                }, e1;
            }(d1);
            e1.DelimiterMap = m1;
            var y1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1, a1, c1 = t1.call(this, e1, null) || this;
                    try {
                        for(var u1 = s1(Object.keys(r1)), p1 = u1.next(); !p1.done; p1 = u1.next()){
                            var h1 = p1.value, f1 = r1[h1], d1 = i1("string" == typeof f1 ? [
                                f1
                            ] : f1), m1 = d1[0], y1 = d1.slice(1), g1 = new l1.Macro(h1, n1[m1], y1);
                            c1.add(h1, g1);
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (a1 = u1.return) && a1.call(u1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                    return c1;
                }
                return o1(e1, t1), e1.prototype.parserFor = function(t1) {
                    var e1 = this.lookup(t1);
                    return e1 ? e1.func : null;
                }, e1.prototype.parse = function(t1) {
                    var e1 = i1(t1, 2), r1 = e1[0], n1 = e1[1], o1 = this.lookup(n1), s1 = this.parserFor(n1);
                    return o1 && s1 ? u1(s1.apply(void 0, a1([
                        r1,
                        o1.symbol
                    ], i1(o1.args), !1))) : null;
                }, e1;
            }(f1);
            e1.MacroMap = y1;
            var g1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.parse = function(t1) {
                    var e1 = i1(t1, 2), r1 = e1[0], n1 = e1[1], o1 = this.lookup(n1), s1 = this.parserFor(n1);
                    if (!o1 || !s1) return null;
                    var l1 = r1.currentCS;
                    r1.currentCS = "\\" + n1;
                    var c1 = s1.apply(void 0, a1([
                        r1,
                        "\\" + o1.symbol
                    ], i1(o1.args), !1));
                    return r1.currentCS = l1, u1(c1);
                }, e1;
            }(y1);
            e1.CommandMap = g1;
            var b1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    var i1 = t1.call(this, e1, n1, o1) || this;
                    return i1.parser = r1, i1;
                }
                return o1(e1, t1), e1.prototype.parse = function(t1) {
                    var e1 = i1(t1, 2), r1 = e1[0], n1 = e1[1], o1 = this.lookup(n1), s1 = this.parserFor(n1);
                    return o1 && s1 ? u1(this.parser(r1, o1.symbol, s1, o1.args)) : null;
                }, e1;
            }(y1);
            e1.EnvironmentMap = b1;
        },
        6521: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TagsFactory = e1.AllTags = e1.NoTags = e1.AbstractTags = e1.TagInfo = e1.Label = void 0;
            var a1 = s1(r1(8417)), l1 = function(t1, e1) {
                void 0 === t1 && (t1 = "???"), void 0 === e1 && (e1 = ""), this.tag = t1, this.id = e1;
            };
            e1.Label = l1;
            var c1 = function(t1, e1, r1, n1, o1, i1, s1, a1) {
                void 0 === t1 && (t1 = ""), void 0 === e1 && (e1 = !1), void 0 === r1 && (r1 = !1), void 0 === n1 && (n1 = null), void 0 === o1 && (o1 = ""), void 0 === i1 && (i1 = ""), void 0 === s1 && (s1 = !1), void 0 === a1 && (a1 = ""), this.env = t1, this.taggable = e1, this.defaultTags = r1, this.tag = n1, this.tagId = o1, this.tagFormat = i1, this.noTag = s1, this.labelId = a1;
            };
            e1.TagInfo = c1;
            var u1 = function() {
                function t1() {
                    this.counter = 0, this.allCounter = 0, this.configuration = null, this.ids = {}, this.allIds = {}, this.labels = {}, this.allLabels = {}, this.redo = !1, this.refUpdate = !1, this.currentTag = new c1, this.history = [], this.stack = [], this.enTag = function(t1, e1) {
                        var r1 = this.configuration.nodeFactory, n1 = r1.create("node", "mtd", [
                            t1
                        ]), o1 = r1.create("node", "mlabeledtr", [
                            e1,
                            n1
                        ]);
                        return r1.create("node", "mtable", [
                            o1
                        ], {
                            side: this.configuration.options.tagSide,
                            minlabelspacing: this.configuration.options.tagIndent,
                            displaystyle: !0
                        });
                    };
                }
                return t1.prototype.start = function(t1, e1, r1) {
                    this.currentTag && this.stack.push(this.currentTag), this.currentTag = new c1(t1, e1, r1);
                }, Object.defineProperty(t1.prototype, "env", {
                    get: function() {
                        return this.currentTag.env;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.end = function() {
                    this.history.push(this.currentTag), this.currentTag = this.stack.pop();
                }, t1.prototype.tag = function(t1, e1) {
                    this.currentTag.tag = t1, this.currentTag.tagFormat = e1 ? t1 : this.formatTag(t1), this.currentTag.noTag = !1;
                }, t1.prototype.notag = function() {
                    this.tag("", !0), this.currentTag.noTag = !0;
                }, Object.defineProperty(t1.prototype, "noTag", {
                    get: function() {
                        return this.currentTag.noTag;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "label", {
                    get: function() {
                        return this.currentTag.labelId;
                    },
                    set: function(t1) {
                        this.currentTag.labelId = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.formatUrl = function(t1, e1) {
                    return e1 + "#" + encodeURIComponent(t1);
                }, t1.prototype.formatTag = function(t1) {
                    return "(" + t1 + ")";
                }, t1.prototype.formatId = function(t1) {
                    return "mjx-eqn:" + t1.replace(/\s/g, "_");
                }, t1.prototype.formatNumber = function(t1) {
                    return t1.toString();
                }, t1.prototype.autoTag = function() {
                    null == this.currentTag.tag && (this.counter++, this.tag(this.formatNumber(this.counter), !1));
                }, t1.prototype.clearTag = function() {
                    this.label = "", this.tag(null, !0), this.currentTag.tagId = "";
                }, t1.prototype.getTag = function(t1) {
                    if (void 0 === t1 && (t1 = !1), t1) return this.autoTag(), this.makeTag();
                    var e1 = this.currentTag;
                    return e1.taggable && !e1.noTag && (e1.defaultTags && this.autoTag(), e1.tag) ? this.makeTag() : null;
                }, t1.prototype.resetTag = function() {
                    this.history = [], this.redo = !1, this.refUpdate = !1, this.clearTag();
                }, t1.prototype.reset = function(t1) {
                    void 0 === t1 && (t1 = 0), this.resetTag(), this.counter = this.allCounter = t1, this.allLabels = {}, this.allIds = {};
                }, t1.prototype.startEquation = function(t1) {
                    this.history = [], this.stack = [], this.clearTag(), this.currentTag = new c1("", void 0, void 0), this.labels = {}, this.ids = {}, this.counter = this.allCounter, this.redo = !1;
                    var e1 = t1.inputData.recompile;
                    e1 && (this.refUpdate = !0, this.counter = e1.counter);
                }, t1.prototype.finishEquation = function(t1) {
                    this.redo && (t1.inputData.recompile = {
                        state: t1.state(),
                        counter: this.allCounter
                    }), this.refUpdate || (this.allCounter = this.counter), Object.assign(this.allIds, this.ids), Object.assign(this.allLabels, this.labels);
                }, t1.prototype.finalize = function(t1, e1) {
                    if (!e1.display || this.currentTag.env || null == this.currentTag.tag) return t1;
                    var r1 = this.makeTag();
                    return this.enTag(t1, r1);
                }, t1.prototype.makeId = function() {
                    this.currentTag.tagId = this.formatId(this.configuration.options.useLabelIds && this.label || this.currentTag.tag);
                }, t1.prototype.makeTag = function() {
                    this.makeId(), this.label && (this.labels[this.label] = new l1(this.currentTag.tag, this.currentTag.tagId));
                    var t1 = new a1.default("\\text{" + this.currentTag.tagFormat + "}", {}, this.configuration).mml();
                    return this.configuration.nodeFactory.create("node", "mtd", [
                        t1
                    ], {
                        id: this.currentTag.tagId
                    });
                }, t1;
            }();
            e1.AbstractTags = u1;
            var p1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.autoTag = function() {}, e1.prototype.getTag = function() {
                    return this.currentTag.tag ? t1.prototype.getTag.call(this) : null;
                }, e1;
            }(u1);
            e1.NoTags = p1;
            var h1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.finalize = function(t1, e1) {
                    if (!e1.display || this.history.find(function(t1) {
                        return t1.taggable;
                    })) return t1;
                    var r1 = this.getTag(!0);
                    return this.enTag(t1, r1);
                }, e1;
            }(u1);
            e1.AllTags = h1, function(t1) {
                var e1 = new Map([
                    [
                        "none",
                        p1
                    ],
                    [
                        "all",
                        h1
                    ]
                ]), r1 = "none";
                t1.OPTIONS = {
                    tags: r1,
                    tagSide: "right",
                    tagIndent: "0.8em",
                    useLabelIds: !0,
                    ignoreDuplicateLabels: !1
                }, t1.add = function(t1, r1) {
                    e1.set(t1, r1);
                }, t1.addTags = function(e1) {
                    var r1, n1;
                    try {
                        for(var o1 = i1(Object.keys(e1)), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            t1.add(a1, e1[a1]);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, t1.create = function(t1) {
                    var n1 = e1.get(t1) || e1.get(r1);
                    if (!n1) throw Error("Unknown tags class");
                    return new n1;
                }, t1.setDefault = function(t1) {
                    r1 = t1;
                }, t1.getDefault = function() {
                    return t1.create(r1);
                };
            }(e1.TagsFactory || (e1.TagsFactory = {}));
        },
        8317: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TexConstant = void 0, function(t1) {
                t1.Variant = {
                    NORMAL: "normal",
                    BOLD: "bold",
                    ITALIC: "italic",
                    BOLDITALIC: "bold-italic",
                    DOUBLESTRUCK: "double-struck",
                    FRAKTUR: "fraktur",
                    BOLDFRAKTUR: "bold-fraktur",
                    SCRIPT: "script",
                    BOLDSCRIPT: "bold-script",
                    SANSSERIF: "sans-serif",
                    BOLDSANSSERIF: "bold-sans-serif",
                    SANSSERIFITALIC: "sans-serif-italic",
                    SANSSERIFBOLDITALIC: "sans-serif-bold-italic",
                    MONOSPACE: "monospace",
                    INITIAL: "inital",
                    TAILED: "tailed",
                    LOOPED: "looped",
                    STRETCHED: "stretched",
                    CALLIGRAPHIC: "-tex-calligraphic",
                    BOLDCALLIGRAPHIC: "-tex-bold-calligraphic",
                    OLDSTYLE: "-tex-oldstyle",
                    BOLDOLDSTYLE: "-tex-bold-oldstyle",
                    MATHITALIC: "-tex-mathit"
                }, t1.Form = {
                    PREFIX: "prefix",
                    INFIX: "infix",
                    POSTFIX: "postfix"
                }, t1.LineBreak = {
                    AUTO: "auto",
                    NEWLINE: "newline",
                    NOBREAK: "nobreak",
                    GOODBREAK: "goodbreak",
                    BADBREAK: "badbreak"
                }, t1.LineBreakStyle = {
                    BEFORE: "before",
                    AFTER: "after",
                    DUPLICATE: "duplicate",
                    INFIXLINBREAKSTYLE: "infixlinebreakstyle"
                }, t1.IndentAlign = {
                    LEFT: "left",
                    CENTER: "center",
                    RIGHT: "right",
                    AUTO: "auto",
                    ID: "id",
                    INDENTALIGN: "indentalign"
                }, t1.IndentShift = {
                    INDENTSHIFT: "indentshift"
                }, t1.LineThickness = {
                    THIN: "thin",
                    MEDIUM: "medium",
                    THICK: "thick"
                }, t1.Notation = {
                    LONGDIV: "longdiv",
                    ACTUARIAL: "actuarial",
                    PHASORANGLE: "phasorangle",
                    RADICAL: "radical",
                    BOX: "box",
                    ROUNDEDBOX: "roundedbox",
                    CIRCLE: "circle",
                    LEFT: "left",
                    RIGHT: "right",
                    TOP: "top",
                    BOTTOM: "bottom",
                    UPDIAGONALSTRIKE: "updiagonalstrike",
                    DOWNDIAGONALSTRIKE: "downdiagonalstrike",
                    VERTICALSTRIKE: "verticalstrike",
                    HORIZONTALSTRIKE: "horizontalstrike",
                    NORTHEASTARROW: "northeastarrow",
                    MADRUWB: "madruwb",
                    UPDIAGONALARROW: "updiagonalarrow"
                }, t1.Align = {
                    TOP: "top",
                    BOTTOM: "bottom",
                    CENTER: "center",
                    BASELINE: "baseline",
                    AXIS: "axis",
                    LEFT: "left",
                    RIGHT: "right"
                }, t1.Lines = {
                    NONE: "none",
                    SOLID: "solid",
                    DASHED: "dashed"
                }, t1.Side = {
                    LEFT: "left",
                    RIGHT: "right",
                    LEFTOVERLAP: "leftoverlap",
                    RIGHTOVERLAP: "rightoverlap"
                }, t1.Width = {
                    AUTO: "auto",
                    FIT: "fit"
                }, t1.Actiontype = {
                    TOGGLE: "toggle",
                    STATUSLINE: "statusline",
                    TOOLTIP: "tooltip",
                    INPUT: "input"
                }, t1.Overflow = {
                    LINBREAK: "linebreak",
                    SCROLL: "scroll",
                    ELIDE: "elide",
                    TRUNCATE: "truncate",
                    SCALE: "scale"
                }, t1.Unit = {
                    EM: "em",
                    EX: "ex",
                    PX: "px",
                    IN: "in",
                    CM: "cm",
                    MM: "mm",
                    PT: "pt",
                    PC: "pc"
                };
            }(e1.TexConstant || (e1.TexConstant = {}));
        },
        3971: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var r1 = function() {
                function t1(e1, r1) {
                    for(var n1 = [], o1 = 2; o1 < arguments.length; o1++)n1[o1 - 2] = arguments[o1];
                    this.id = e1, this.message = t1.processString(r1, n1);
                }
                return t1.processString = function(e1, r1) {
                    for(var n1 = e1.split(t1.pattern), o1 = 1, i1 = n1.length; o1 < i1; o1 += 2){
                        var s1 = n1[o1].charAt(0);
                        if (s1 >= "0" && s1 <= "9") n1[o1] = r1[parseInt(n1[o1], 10) - 1], "number" == typeof n1[o1] && (n1[o1] = n1[o1].toString());
                        else if ("{" === s1) {
                            if ((s1 = n1[o1].substr(1)) >= "0" && s1 <= "9") n1[o1] = r1[parseInt(n1[o1].substr(1, n1[o1].length - 2), 10) - 1], "number" == typeof n1[o1] && (n1[o1] = n1[o1].toString());
                            else n1[o1].match(/^\{([a-z]+):%(\d+)\|(.*)\}$/) && (n1[o1] = "%" + n1[o1]);
                        }
                        null == n1[o1] && (n1[o1] = "???");
                    }
                    return n1.join("");
                }, t1.pattern = /%(\d+|\{\d+\}|\{[a-z]+:\%\d+(?:\|(?:%\{\d+\}|%.|[^\}])*)+\}|.)/g, t1;
            }();
            e1.default = r1;
        },
        8417: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var a1 = s1(r1(1130)), l1 = s1(r1(9497)), c1 = s1(r1(3971)), u1 = r1(9007), p1 = function() {
                function t1(t1, e1, r1) {
                    var o1, i1;
                    this._string = t1, this.configuration = r1, this.macroCount = 0, this.i = 0, this.currentCS = "";
                    var s1, a1 = e1.hasOwnProperty("isInner"), c1 = e1.isInner;
                    if (delete e1.isInner, e1) {
                        s1 = {};
                        try {
                            for(var u1 = n1(Object.keys(e1)), p1 = u1.next(); !p1.done; p1 = u1.next()){
                                var h1 = p1.value;
                                s1[h1] = e1[h1];
                            }
                        } catch (t1) {
                            o1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                p1 && !p1.done && (i1 = u1.return) && i1.call(u1);
                            } finally{
                                if (o1) throw o1.error;
                            }
                        }
                    }
                    this.configuration.pushParser(this), this.stack = new l1.default(this.itemFactory, s1, !a1 || c1), this.Parse(), this.Push(this.itemFactory.create("stop"));
                }
                return Object.defineProperty(t1.prototype, "options", {
                    get: function() {
                        return this.configuration.options;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "itemFactory", {
                    get: function() {
                        return this.configuration.itemFactory;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "tags", {
                    get: function() {
                        return this.configuration.tags;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "string", {
                    get: function() {
                        return this._string;
                    },
                    set: function(t1) {
                        this._string = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.parse = function(t1, e1) {
                    return this.configuration.handlers.get(t1).parse(e1);
                }, t1.prototype.lookup = function(t1, e1) {
                    return this.configuration.handlers.get(t1).lookup(e1);
                }, t1.prototype.contains = function(t1, e1) {
                    return this.configuration.handlers.get(t1).contains(e1);
                }, t1.prototype.toString = function() {
                    var t1, e1, r1 = "";
                    try {
                        for(var o1 = n1(Array.from(this.configuration.handlers.keys())), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value;
                            r1 += s1 + ": " + this.configuration.handlers.get(s1) + "\n";
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return r1;
                }, t1.prototype.Parse = function() {
                    for(var t1; this.i < this.string.length;)t1 = this.getCodePoint(), this.i += t1.length, this.parse("character", [
                        this,
                        t1
                    ]);
                }, t1.prototype.Push = function(t1) {
                    t1 instanceof u1.AbstractMmlNode && t1.isInferred ? this.PushAll(t1.childNodes) : this.stack.Push(t1);
                }, t1.prototype.PushAll = function(t1) {
                    var e1, r1;
                    try {
                        for(var o1 = n1(t1), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value;
                            this.stack.Push(s1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.mml = function() {
                    if (!this.stack.Top().isKind("mml")) return null;
                    var t1 = this.stack.Top().First;
                    return this.configuration.popParser(), t1;
                }, t1.prototype.convertDelimiter = function(t1) {
                    var e1 = this.lookup("delimiter", t1);
                    return e1 ? e1.char : null;
                }, t1.prototype.getCodePoint = function() {
                    var t1 = this.string.codePointAt(this.i);
                    return void 0 === t1 ? "" : String.fromCodePoint(t1);
                }, t1.prototype.nextIsSpace = function() {
                    return !!this.string.charAt(this.i).match(/\s/);
                }, t1.prototype.GetNext = function() {
                    for(; this.nextIsSpace();)this.i++;
                    return this.getCodePoint();
                }, t1.prototype.GetCS = function() {
                    var t1 = this.string.slice(this.i).match(/^(([a-z]+) ?|[\uD800-\uDBFF].|.)/i);
                    return t1 ? (this.i += t1[0].length, t1[2] || t1[1]) : (this.i++, " ");
                }, t1.prototype.GetArgument = function(t1, e1) {
                    switch(this.GetNext()){
                        case "":
                            if (!e1) throw new c1.default("MissingArgFor", "Missing argument for %1", this.currentCS);
                            return null;
                        case "}":
                            if (!e1) throw new c1.default("ExtraCloseMissingOpen", "Extra close brace or missing open brace");
                            return null;
                        case "\\":
                            return this.i++, "\\" + this.GetCS();
                        case "{":
                            for(var r1 = ++this.i, n1 = 1; this.i < this.string.length;)switch(this.string.charAt(this.i++)){
                                case "\\":
                                    this.i++;
                                    break;
                                case "{":
                                    n1++;
                                    break;
                                case "}":
                                    if (0 == --n1) return this.string.slice(r1, this.i - 1);
                            }
                            throw new c1.default("MissingCloseBrace", "Missing close brace");
                    }
                    var o1 = this.getCodePoint();
                    return this.i += o1.length, o1;
                }, t1.prototype.GetBrackets = function(t1, e1) {
                    if ("[" !== this.GetNext()) return e1;
                    for(var r1 = ++this.i, n1 = 0; this.i < this.string.length;)switch(this.string.charAt(this.i++)){
                        case "{":
                            n1++;
                            break;
                        case "\\":
                            this.i++;
                            break;
                        case "}":
                            if (n1-- <= 0) throw new c1.default("ExtraCloseLooking", "Extra close brace while looking for %1", "']'");
                            break;
                        case "]":
                            if (0 === n1) return this.string.slice(r1, this.i - 1);
                    }
                    throw new c1.default("MissingCloseBracket", "Could not find closing ']' for argument to %1", this.currentCS);
                }, t1.prototype.GetDelimiter = function(t1, e1) {
                    var r1 = this.GetNext();
                    if (this.i += r1.length, this.i <= this.string.length && ("\\" === r1 ? r1 += this.GetCS() : "{" === r1 && e1 && (this.i--, r1 = this.GetArgument(t1).trim()), this.contains("delimiter", r1))) return this.convertDelimiter(r1);
                    throw new c1.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
                }, t1.prototype.GetDimen = function(t1) {
                    if ("{" === this.GetNext()) {
                        var e1 = this.GetArgument(t1), r1 = o1(a1.default.matchDimen(e1), 2), n1 = r1[0], i1 = r1[1];
                        if (n1) return n1 + i1;
                    } else {
                        e1 = this.string.slice(this.i);
                        var s1 = o1(a1.default.matchDimen(e1, !0), 3), l1 = (n1 = s1[0], i1 = s1[1], s1[2]);
                        if (n1) return this.i += l1, n1 + i1;
                    }
                    throw new c1.default("MissingDimOrUnits", "Missing dimension or its units for %1", this.currentCS);
                }, t1.prototype.GetUpTo = function(t1, e1) {
                    for(; this.nextIsSpace();)this.i++;
                    for(var r1 = this.i, n1 = 0; this.i < this.string.length;){
                        var o1 = this.i, i1 = this.GetNext();
                        switch(this.i += i1.length, i1){
                            case "\\":
                                i1 += this.GetCS();
                                break;
                            case "{":
                                n1++;
                                break;
                            case "}":
                                if (0 === n1) throw new c1.default("ExtraCloseLooking", "Extra close brace while looking for %1", e1);
                                n1--;
                        }
                        if (0 === n1 && i1 === e1) return this.string.slice(r1, o1);
                    }
                    throw new c1.default("TokenNotFoundForCommand", "Could not find %1 for %2", e1, this.currentCS);
                }, t1.prototype.ParseArg = function(e1) {
                    return new t1(this.GetArgument(e1), this.stack.env, this.configuration).mml();
                }, t1.prototype.ParseUpTo = function(e1, r1) {
                    return new t1(this.GetUpTo(e1, r1), this.stack.env, this.configuration).mml();
                }, t1.prototype.GetDelimiterArg = function(t1) {
                    var e1 = a1.default.trimSpaces(this.GetArgument(t1));
                    if ("" === e1) return null;
                    if (this.contains("delimiter", e1)) return e1;
                    throw new c1.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
                }, t1.prototype.GetStar = function() {
                    var t1 = "*" === this.GetNext();
                    return t1 && this.i++, t1;
                }, t1.prototype.create = function(t1) {
                    for(var e1, r1 = [], n1 = 1; n1 < arguments.length; n1++)r1[n1 - 1] = arguments[n1];
                    return (e1 = this.configuration.nodeFactory).create.apply(e1, i1([
                        t1
                    ], o1(r1), !1));
                }, t1;
            }();
            e1.default = p1;
        },
        8021: function(t1, e1, r1) {
            var n1, o1, i1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AmsConfiguration = e1.AmsTags = void 0;
            var s1 = r1(9899), a1 = r1(2790), l1 = r1(6521), c1 = r1(4387);
            r1(7379);
            var u1 = r1(9140), p1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return i1(e1, t1), e1;
            }(l1.AbstractTags);
            e1.AmsTags = p1;
            e1.AmsConfiguration = s1.Configuration.create("ams", {
                handler: {
                    character: [
                        "AMSmath-operatorLetter"
                    ],
                    delimiter: [
                        "AMSsymbols-delimiter",
                        "AMSmath-delimiter"
                    ],
                    macro: [
                        "AMSsymbols-mathchar0mi",
                        "AMSsymbols-mathchar0mo",
                        "AMSsymbols-delimiter",
                        "AMSsymbols-macros",
                        "AMSmath-mathchar0mo",
                        "AMSmath-macros",
                        "AMSmath-delimiter"
                    ],
                    environment: [
                        "AMSmath-environment"
                    ]
                },
                items: (o1 = {}, o1[a1.MultlineItem.prototype.kind] = a1.MultlineItem, o1[a1.FlalignItem.prototype.kind] = a1.FlalignItem, o1),
                tags: {
                    ams: p1
                },
                init: function(t1) {
                    new u1.CommandMap(c1.NEW_OPS, {}, {}), t1.append(s1.Configuration.local({
                        handler: {
                            macro: [
                                c1.NEW_OPS
                            ]
                        },
                        priority: -1
                    }));
                },
                config: function(t1, e1) {
                    e1.parseOptions.options.multlineWidth && (e1.parseOptions.options.ams.multlineWidth = e1.parseOptions.options.multlineWidth), delete e1.parseOptions.options.multlineWidth;
                },
                options: {
                    multlineWidth: "",
                    ams: {
                        multlineWidth: "100%",
                        multlineIndent: "1em"
                    }
                }
            });
        },
        2790: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.FlalignItem = e1.MultlineItem = void 0;
            var a1 = r1(1181), l1 = s1(r1(1130)), c1 = s1(r1(1256)), u1 = s1(r1(3971)), p1 = r1(8317), h1 = function(t1) {
                function e1(e1) {
                    for(var r1 = [], n1 = 1; n1 < arguments.length; n1++)r1[n1 - 1] = arguments[n1];
                    var o1 = t1.call(this, e1) || this;
                    return o1.factory.configuration.tags.start("multline", !0, r1[0]), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "multline";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.EndEntry = function() {
                    this.table.length && l1.default.fixInitialMO(this.factory.configuration, this.nodes);
                    var t1 = this.getProperty("shove"), e1 = this.create("node", "mtd", this.nodes, t1 ? {
                        columnalign: t1
                    } : {});
                    this.setProperty("shove", null), this.row.push(e1), this.Clear();
                }, e1.prototype.EndRow = function() {
                    if (1 !== this.row.length) throw new u1.default("MultlineRowsOneCol", "The rows within the %1 environment must have exactly one column", "multline");
                    var t1 = this.create("node", "mtr", this.row);
                    this.table.push(t1), this.row = [];
                }, e1.prototype.EndTable = function() {
                    if (t1.prototype.EndTable.call(this), this.table.length) {
                        var e1 = this.table.length - 1, r1 = -1;
                        c1.default.getAttribute(c1.default.getChildren(this.table[0])[0], "columnalign") || c1.default.setAttribute(c1.default.getChildren(this.table[0])[0], "columnalign", p1.TexConstant.Align.LEFT), c1.default.getAttribute(c1.default.getChildren(this.table[e1])[0], "columnalign") || c1.default.setAttribute(c1.default.getChildren(this.table[e1])[0], "columnalign", p1.TexConstant.Align.RIGHT);
                        var n1 = this.factory.configuration.tags.getTag();
                        if (n1) {
                            r1 = this.arraydef.side === p1.TexConstant.Align.LEFT ? 0 : this.table.length - 1;
                            var o1 = this.table[r1], i1 = this.create("node", "mlabeledtr", [
                                n1
                            ].concat(c1.default.getChildren(o1)));
                            c1.default.copyAttributes(o1, i1), this.table[r1] = i1;
                        }
                    }
                    this.factory.configuration.tags.end();
                }, e1;
            }(a1.ArrayItem);
            e1.MultlineItem = h1;
            var f1 = function(t1) {
                function e1(e1, r1, n1, o1, i1) {
                    var s1 = t1.call(this, e1) || this;
                    return s1.name = r1, s1.numbered = n1, s1.padded = o1, s1.center = i1, s1.factory.configuration.tags.start(r1, n1, n1), s1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "flalign";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.EndEntry = function() {
                    t1.prototype.EndEntry.call(this);
                    var e1 = this.getProperty("xalignat");
                    if (e1 && this.row.length > e1) throw new u1.default("XalignOverflow", "Extra %1 in row of %2", "&", this.name);
                }, e1.prototype.EndRow = function() {
                    for(var e1, r1 = this.row, n1 = this.getProperty("xalignat"); r1.length < n1;)r1.push(this.create("node", "mtd"));
                    for(this.row = [], this.padded && this.row.push(this.create("node", "mtd")); e1 = r1.shift();)this.row.push(e1), (e1 = r1.shift()) && this.row.push(e1), (r1.length || this.padded) && this.row.push(this.create("node", "mtd"));
                    this.row.length > this.maxrow && (this.maxrow = this.row.length), t1.prototype.EndRow.call(this);
                    var o1 = this.table[this.table.length - 1];
                    if (this.getProperty("zeroWidthLabel") && o1.isKind("mlabeledtr")) {
                        var s1 = c1.default.getChildren(o1)[0], a1 = this.factory.configuration.options.tagSide, l1 = i1({
                            width: 0
                        }, "right" === a1 ? {
                            lspace: "-1width"
                        } : {}), u1 = this.create("node", "mpadded", c1.default.getChildren(s1), l1);
                        s1.setChildren([
                            u1
                        ]);
                    }
                }, e1.prototype.EndTable = function() {
                    (t1.prototype.EndTable.call(this), this.center) && this.maxrow <= 2 && (delete this.arraydef.width, delete this.global.indentalign);
                }, e1;
            }(a1.EqnArrayItem);
            e1.FlalignItem = f1;
        },
        7379: function(t1, e1, r1) {
            var n1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), o1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), i1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && n1(e1, t1, r1);
                return o1(e1, t1), e1;
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var a1 = r1(4387), l1 = i1(r1(9140)), c1 = r1(8317), u1 = s1(r1(5450)), p1 = s1(r1(1130)), h1 = r1(9007), f1 = r1(6010);
            new l1.CharacterMap("AMSmath-mathchar0mo", u1.default.mathchar0mo, {
                iiiint: [
                    "⨌",
                    {
                        texClass: h1.TEXCLASS.OP
                    }
                ]
            }), new l1.RegExpMap("AMSmath-operatorLetter", a1.AmsMethods.operatorLetter, /[-*]/i), new l1.CommandMap("AMSmath-macros", {
                mathring: [
                    "Accent",
                    "02DA"
                ],
                nobreakspace: "Tilde",
                negmedspace: [
                    "Spacer",
                    f1.MATHSPACE.negativemediummathspace
                ],
                negthickspace: [
                    "Spacer",
                    f1.MATHSPACE.negativethickmathspace
                ],
                idotsint: [
                    "MultiIntegral",
                    "\\int\\cdots\\int"
                ],
                dddot: [
                    "Accent",
                    "20DB"
                ],
                ddddot: [
                    "Accent",
                    "20DC"
                ],
                sideset: "SideSet",
                boxed: [
                    "Macro",
                    "\\fbox{$\\displaystyle{#1}$}",
                    1
                ],
                tag: "HandleTag",
                notag: "HandleNoTag",
                eqref: [
                    "HandleRef",
                    !0
                ],
                substack: [
                    "Macro",
                    "\\begin{subarray}{c}#1\\end{subarray}",
                    1
                ],
                injlim: [
                    "NamedOp",
                    "inj&thinsp;lim"
                ],
                projlim: [
                    "NamedOp",
                    "proj&thinsp;lim"
                ],
                varliminf: [
                    "Macro",
                    "\\mathop{\\underline{\\mmlToken{mi}{lim}}}"
                ],
                varlimsup: [
                    "Macro",
                    "\\mathop{\\overline{\\mmlToken{mi}{lim}}}"
                ],
                varinjlim: [
                    "Macro",
                    "\\mathop{\\underrightarrow{\\mmlToken{mi}{lim}}}"
                ],
                varprojlim: [
                    "Macro",
                    "\\mathop{\\underleftarrow{\\mmlToken{mi}{lim}}}"
                ],
                DeclareMathOperator: "HandleDeclareOp",
                operatorname: "HandleOperatorName",
                genfrac: "Genfrac",
                frac: [
                    "Genfrac",
                    "",
                    "",
                    "",
                    ""
                ],
                tfrac: [
                    "Genfrac",
                    "",
                    "",
                    "",
                    "1"
                ],
                dfrac: [
                    "Genfrac",
                    "",
                    "",
                    "",
                    "0"
                ],
                binom: [
                    "Genfrac",
                    "(",
                    ")",
                    "0",
                    ""
                ],
                tbinom: [
                    "Genfrac",
                    "(",
                    ")",
                    "0",
                    "1"
                ],
                dbinom: [
                    "Genfrac",
                    "(",
                    ")",
                    "0",
                    "0"
                ],
                cfrac: "CFrac",
                shoveleft: [
                    "HandleShove",
                    c1.TexConstant.Align.LEFT
                ],
                shoveright: [
                    "HandleShove",
                    c1.TexConstant.Align.RIGHT
                ],
                xrightarrow: [
                    "xArrow",
                    8594,
                    5,
                    10
                ],
                xleftarrow: [
                    "xArrow",
                    8592,
                    10,
                    5
                ]
            }, a1.AmsMethods), new l1.EnvironmentMap("AMSmath-environment", u1.default.environment, {
                "equation*": [
                    "Equation",
                    null,
                    !1
                ],
                "eqnarray*": [
                    "EqnArray",
                    null,
                    !1,
                    !0,
                    "rcl",
                    p1.default.cols(0, f1.MATHSPACE.thickmathspace),
                    ".5em"
                ],
                align: [
                    "EqnArray",
                    null,
                    !0,
                    !0,
                    "rl",
                    p1.default.cols(0, 2)
                ],
                "align*": [
                    "EqnArray",
                    null,
                    !1,
                    !0,
                    "rl",
                    p1.default.cols(0, 2)
                ],
                multline: [
                    "Multline",
                    null,
                    !0
                ],
                "multline*": [
                    "Multline",
                    null,
                    !1
                ],
                split: [
                    "EqnArray",
                    null,
                    !1,
                    !1,
                    "rl",
                    p1.default.cols(0)
                ],
                gather: [
                    "EqnArray",
                    null,
                    !0,
                    !0,
                    "c"
                ],
                "gather*": [
                    "EqnArray",
                    null,
                    !1,
                    !0,
                    "c"
                ],
                alignat: [
                    "AlignAt",
                    null,
                    !0,
                    !0
                ],
                "alignat*": [
                    "AlignAt",
                    null,
                    !1,
                    !0
                ],
                alignedat: [
                    "AlignAt",
                    null,
                    !1,
                    !1
                ],
                aligned: [
                    "AmsEqnArray",
                    null,
                    null,
                    null,
                    "rl",
                    p1.default.cols(0, 2),
                    ".5em",
                    "D"
                ],
                gathered: [
                    "AmsEqnArray",
                    null,
                    null,
                    null,
                    "c",
                    null,
                    ".5em",
                    "D"
                ],
                xalignat: [
                    "XalignAt",
                    null,
                    !0,
                    !0
                ],
                "xalignat*": [
                    "XalignAt",
                    null,
                    !1,
                    !0
                ],
                xxalignat: [
                    "XalignAt",
                    null,
                    !1,
                    !1
                ],
                flalign: [
                    "FlalignArray",
                    null,
                    !0,
                    !1,
                    !0,
                    "rlc",
                    "auto auto fit"
                ],
                "flalign*": [
                    "FlalignArray",
                    null,
                    !1,
                    !1,
                    !0,
                    "rlc",
                    "auto auto fit"
                ],
                subarray: [
                    "Array",
                    null,
                    null,
                    null,
                    null,
                    p1.default.cols(0),
                    "0.1em",
                    "S",
                    1
                ],
                smallmatrix: [
                    "Array",
                    null,
                    null,
                    null,
                    "c",
                    p1.default.cols(1 / 3),
                    ".2em",
                    "S",
                    1
                ],
                matrix: [
                    "Array",
                    null,
                    null,
                    null,
                    "c"
                ],
                pmatrix: [
                    "Array",
                    null,
                    "(",
                    ")",
                    "c"
                ],
                bmatrix: [
                    "Array",
                    null,
                    "[",
                    "]",
                    "c"
                ],
                Bmatrix: [
                    "Array",
                    null,
                    "\\{",
                    "\\}",
                    "c"
                ],
                vmatrix: [
                    "Array",
                    null,
                    "\\vert",
                    "\\vert",
                    "c"
                ],
                Vmatrix: [
                    "Array",
                    null,
                    "\\Vert",
                    "\\Vert",
                    "c"
                ],
                cases: [
                    "Array",
                    null,
                    "\\{",
                    ".",
                    "ll",
                    null,
                    ".2em",
                    "T"
                ]
            }, a1.AmsMethods), new l1.DelimiterMap("AMSmath-delimiter", u1.default.delimiter, {
                "\\lvert": [
                    "|",
                    {
                        texClass: h1.TEXCLASS.OPEN
                    }
                ],
                "\\rvert": [
                    "|",
                    {
                        texClass: h1.TEXCLASS.CLOSE
                    }
                ],
                "\\lVert": [
                    "‖",
                    {
                        texClass: h1.TEXCLASS.OPEN
                    }
                ],
                "\\rVert": [
                    "‖",
                    {
                        texClass: h1.TEXCLASS.CLOSE
                    }
                ]
            }), new l1.CharacterMap("AMSsymbols-mathchar0mi", u1.default.mathchar0mi, {
                digamma: "ϝ",
                varkappa: "ϰ",
                varGamma: [
                    "Γ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varDelta: [
                    "Δ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varTheta: [
                    "Θ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varLambda: [
                    "Λ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varXi: [
                    "Ξ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varPi: [
                    "Π",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varSigma: [
                    "Σ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varUpsilon: [
                    "Υ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varPhi: [
                    "Φ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varPsi: [
                    "Ψ",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                varOmega: [
                    "Ω",
                    {
                        mathvariant: c1.TexConstant.Variant.ITALIC
                    }
                ],
                beth: "ℶ",
                gimel: "ℷ",
                daleth: "ℸ",
                backprime: [
                    "‵",
                    {
                        variantForm: !0
                    }
                ],
                hslash: "ℏ",
                varnothing: [
                    "∅",
                    {
                        variantForm: !0
                    }
                ],
                blacktriangle: "▴",
                triangledown: [
                    "▽",
                    {
                        variantForm: !0
                    }
                ],
                blacktriangledown: "▾",
                square: "◻",
                Box: "◻",
                blacksquare: "◼",
                lozenge: "◊",
                Diamond: "◊",
                blacklozenge: "⧫",
                circledS: [
                    "Ⓢ",
                    {
                        mathvariant: c1.TexConstant.Variant.NORMAL
                    }
                ],
                bigstar: "★",
                sphericalangle: "∢",
                measuredangle: "∡",
                nexists: "∄",
                complement: "∁",
                mho: "℧",
                eth: [
                    "\xf0",
                    {
                        mathvariant: c1.TexConstant.Variant.NORMAL
                    }
                ],
                Finv: "Ⅎ",
                diagup: "╱",
                Game: "⅁",
                diagdown: "╲",
                Bbbk: [
                    "k",
                    {
                        mathvariant: c1.TexConstant.Variant.DOUBLESTRUCK
                    }
                ],
                yen: "\xa5",
                circledR: "\xae",
                checkmark: "✓",
                maltese: "✠"
            }), new l1.CharacterMap("AMSsymbols-mathchar0mo", u1.default.mathchar0mo, {
                dotplus: "∔",
                ltimes: "⋉",
                smallsetminus: [
                    "∖",
                    {
                        variantForm: !0
                    }
                ],
                rtimes: "⋊",
                Cap: "⋒",
                doublecap: "⋒",
                leftthreetimes: "⋋",
                Cup: "⋓",
                doublecup: "⋓",
                rightthreetimes: "⋌",
                barwedge: "⊼",
                curlywedge: "⋏",
                veebar: "⊻",
                curlyvee: "⋎",
                doublebarwedge: "⩞",
                boxminus: "⊟",
                circleddash: "⊝",
                boxtimes: "⊠",
                circledast: "⊛",
                boxdot: "⊡",
                circledcirc: "⊚",
                boxplus: "⊞",
                centerdot: [
                    "⋅",
                    {
                        variantForm: !0
                    }
                ],
                divideontimes: "⋇",
                intercal: "⊺",
                leqq: "≦",
                geqq: "≧",
                leqslant: "⩽",
                geqslant: "⩾",
                eqslantless: "⪕",
                eqslantgtr: "⪖",
                lesssim: "≲",
                gtrsim: "≳",
                lessapprox: "⪅",
                gtrapprox: "⪆",
                approxeq: "≊",
                lessdot: "⋖",
                gtrdot: "⋗",
                lll: "⋘",
                llless: "⋘",
                ggg: "⋙",
                gggtr: "⋙",
                lessgtr: "≶",
                gtrless: "≷",
                lesseqgtr: "⋚",
                gtreqless: "⋛",
                lesseqqgtr: "⪋",
                gtreqqless: "⪌",
                doteqdot: "≑",
                Doteq: "≑",
                eqcirc: "≖",
                risingdotseq: "≓",
                circeq: "≗",
                fallingdotseq: "≒",
                triangleq: "≜",
                backsim: "∽",
                thicksim: [
                    "∼",
                    {
                        variantForm: !0
                    }
                ],
                backsimeq: "⋍",
                thickapprox: [
                    "≈",
                    {
                        variantForm: !0
                    }
                ],
                subseteqq: "⫅",
                supseteqq: "⫆",
                Subset: "⋐",
                Supset: "⋑",
                sqsubset: "⊏",
                sqsupset: "⊐",
                preccurlyeq: "≼",
                succcurlyeq: "≽",
                curlyeqprec: "⋞",
                curlyeqsucc: "⋟",
                precsim: "≾",
                succsim: "≿",
                precapprox: "⪷",
                succapprox: "⪸",
                vartriangleleft: "⊲",
                lhd: "⊲",
                vartriangleright: "⊳",
                rhd: "⊳",
                trianglelefteq: "⊴",
                unlhd: "⊴",
                trianglerighteq: "⊵",
                unrhd: "⊵",
                vDash: [
                    "⊨",
                    {
                        variantForm: !0
                    }
                ],
                Vdash: "⊩",
                Vvdash: "⊪",
                smallsmile: [
                    "⌣",
                    {
                        variantForm: !0
                    }
                ],
                shortmid: [
                    "∣",
                    {
                        variantForm: !0
                    }
                ],
                smallfrown: [
                    "⌢",
                    {
                        variantForm: !0
                    }
                ],
                shortparallel: [
                    "∥",
                    {
                        variantForm: !0
                    }
                ],
                bumpeq: "≏",
                between: "≬",
                Bumpeq: "≎",
                pitchfork: "⋔",
                varpropto: [
                    "∝",
                    {
                        variantForm: !0
                    }
                ],
                backepsilon: "∍",
                blacktriangleleft: "◂",
                blacktriangleright: "▸",
                therefore: "∴",
                because: "∵",
                eqsim: "≂",
                vartriangle: [
                    "△",
                    {
                        variantForm: !0
                    }
                ],
                Join: "⋈",
                nless: "≮",
                ngtr: "≯",
                nleq: "≰",
                ngeq: "≱",
                nleqslant: [
                    "⪇",
                    {
                        variantForm: !0
                    }
                ],
                ngeqslant: [
                    "⪈",
                    {
                        variantForm: !0
                    }
                ],
                nleqq: [
                    "≰",
                    {
                        variantForm: !0
                    }
                ],
                ngeqq: [
                    "≱",
                    {
                        variantForm: !0
                    }
                ],
                lneq: "⪇",
                gneq: "⪈",
                lneqq: "≨",
                gneqq: "≩",
                lvertneqq: [
                    "≨",
                    {
                        variantForm: !0
                    }
                ],
                gvertneqq: [
                    "≩",
                    {
                        variantForm: !0
                    }
                ],
                lnsim: "⋦",
                gnsim: "⋧",
                lnapprox: "⪉",
                gnapprox: "⪊",
                nprec: "⊀",
                nsucc: "⊁",
                npreceq: [
                    "⋠",
                    {
                        variantForm: !0
                    }
                ],
                nsucceq: [
                    "⋡",
                    {
                        variantForm: !0
                    }
                ],
                precneqq: "⪵",
                succneqq: "⪶",
                precnsim: "⋨",
                succnsim: "⋩",
                precnapprox: "⪹",
                succnapprox: "⪺",
                nsim: "≁",
                ncong: "≇",
                nshortmid: [
                    "∤",
                    {
                        variantForm: !0
                    }
                ],
                nshortparallel: [
                    "∦",
                    {
                        variantForm: !0
                    }
                ],
                nmid: "∤",
                nparallel: "∦",
                nvdash: "⊬",
                nvDash: "⊭",
                nVdash: "⊮",
                nVDash: "⊯",
                ntriangleleft: "⋪",
                ntriangleright: "⋫",
                ntrianglelefteq: "⋬",
                ntrianglerighteq: "⋭",
                nsubseteq: "⊈",
                nsupseteq: "⊉",
                nsubseteqq: [
                    "⊈",
                    {
                        variantForm: !0
                    }
                ],
                nsupseteqq: [
                    "⊉",
                    {
                        variantForm: !0
                    }
                ],
                subsetneq: "⊊",
                supsetneq: "⊋",
                varsubsetneq: [
                    "⊊",
                    {
                        variantForm: !0
                    }
                ],
                varsupsetneq: [
                    "⊋",
                    {
                        variantForm: !0
                    }
                ],
                subsetneqq: "⫋",
                supsetneqq: "⫌",
                varsubsetneqq: [
                    "⫋",
                    {
                        variantForm: !0
                    }
                ],
                varsupsetneqq: [
                    "⫌",
                    {
                        variantForm: !0
                    }
                ],
                leftleftarrows: "⇇",
                rightrightarrows: "⇉",
                leftrightarrows: "⇆",
                rightleftarrows: "⇄",
                Lleftarrow: "⇚",
                Rrightarrow: "⇛",
                twoheadleftarrow: "↞",
                twoheadrightarrow: "↠",
                leftarrowtail: "↢",
                rightarrowtail: "↣",
                looparrowleft: "↫",
                looparrowright: "↬",
                leftrightharpoons: "⇋",
                rightleftharpoons: [
                    "⇌",
                    {
                        variantForm: !0
                    }
                ],
                curvearrowleft: "↶",
                curvearrowright: "↷",
                circlearrowleft: "↺",
                circlearrowright: "↻",
                Lsh: "↰",
                Rsh: "↱",
                upuparrows: "⇈",
                downdownarrows: "⇊",
                upharpoonleft: "↿",
                upharpoonright: "↾",
                downharpoonleft: "⇃",
                restriction: "↾",
                multimap: "⊸",
                downharpoonright: "⇂",
                leftrightsquigarrow: "↭",
                rightsquigarrow: "⇝",
                leadsto: "⇝",
                dashrightarrow: "⇢",
                dashleftarrow: "⇠",
                nleftarrow: "↚",
                nrightarrow: "↛",
                nLeftarrow: "⇍",
                nRightarrow: "⇏",
                nleftrightarrow: "↮",
                nLeftrightarrow: "⇎"
            }), new l1.DelimiterMap("AMSsymbols-delimiter", u1.default.delimiter, {
                "\\ulcorner": "⌜",
                "\\urcorner": "⌝",
                "\\llcorner": "⌞",
                "\\lrcorner": "⌟"
            }), new l1.CommandMap("AMSsymbols-macros", {
                implies: [
                    "Macro",
                    "\\;\\Longrightarrow\\;"
                ],
                impliedby: [
                    "Macro",
                    "\\;\\Longleftarrow\\;"
                ]
            }, a1.AmsMethods);
        },
        4387: function(t1, e1, r1) {
            var n1 = this && this.__assign || function() {
                return n1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, n1.apply(this, arguments);
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.NEW_OPS = e1.AmsMethods = void 0;
            var s1 = i1(r1(1130)), a1 = i1(r1(5450)), l1 = i1(r1(1256)), c1 = r1(8317), u1 = i1(r1(8417)), p1 = i1(r1(3971)), h1 = r1(8803), f1 = i1(r1(7693)), d1 = r1(9007);
            function m1(t1) {
                if (!t1 || t1.isInferred && 0 === t1.childNodes.length) return [
                    null,
                    null
                ];
                if (t1.isKind("msubsup") && y1(t1)) return [
                    t1,
                    null
                ];
                var e1 = l1.default.getChildAt(t1, 0);
                return t1.isInferred && e1 && y1(e1) ? (t1.childNodes.splice(0, 1), [
                    e1,
                    t1
                ]) : [
                    null,
                    t1
                ];
            }
            function y1(t1) {
                var e1 = t1.childNodes[0];
                return e1 && e1.isKind("mi") && "" === e1.getText();
            }
            e1.AmsMethods = {}, e1.AmsMethods.AmsEqnArray = function(t1, e1, r1, n1, o1, i1, a1) {
                var l1 = t1.GetBrackets("\\begin{" + e1.getName() + "}"), c1 = f1.default.EqnArray(t1, e1, r1, n1, o1, i1, a1);
                return s1.default.setArrayAlign(c1, l1);
            }, e1.AmsMethods.AlignAt = function(t1, r1, n1, o1) {
                var i1, a1, l1 = r1.getName(), c1 = "", u1 = [];
                if (o1 || (a1 = t1.GetBrackets("\\begin{" + l1 + "}")), (i1 = t1.GetArgument("\\begin{" + l1 + "}")).match(/[^0-9]/)) throw new p1.default("PositiveIntegerArg", "Argument to %1 must me a positive integer", "\\begin{" + l1 + "}");
                for(var h1 = parseInt(i1, 10); h1 > 0;)c1 += "rl", u1.push("0em 0em"), h1--;
                var f1 = u1.join(" ");
                if (o1) return e1.AmsMethods.EqnArray(t1, r1, n1, o1, c1, f1);
                var d1 = e1.AmsMethods.EqnArray(t1, r1, n1, o1, c1, f1);
                return s1.default.setArrayAlign(d1, a1);
            }, e1.AmsMethods.Multline = function(t1, e1, r1) {
                t1.Push(e1), s1.default.checkEqnEnv(t1);
                var n1 = t1.itemFactory.create("multline", r1, t1.stack);
                return n1.arraydef = {
                    displaystyle: !0,
                    rowspacing: ".5em",
                    columnspacing: "100%",
                    width: t1.options.ams.multlineWidth,
                    side: t1.options.tagSide,
                    minlabelspacing: t1.options.tagIndent,
                    framespacing: t1.options.ams.multlineIndent + " 0",
                    frame: "",
                    "data-width-includes-label": !0
                }, n1;
            }, e1.AmsMethods.XalignAt = function(t1, r1, n1, o1) {
                var i1 = t1.GetArgument("\\begin{" + r1.getName() + "}");
                if (i1.match(/[^0-9]/)) throw new p1.default("PositiveIntegerArg", "Argument to %1 must me a positive integer", "\\begin{" + r1.getName() + "}");
                var s1 = o1 ? "crl" : "rlc", a1 = o1 ? "fit auto auto" : "auto auto fit", l1 = e1.AmsMethods.FlalignArray(t1, r1, n1, o1, !1, s1, a1, !0);
                return l1.setProperty("xalignat", 2 * parseInt(i1)), l1;
            }, e1.AmsMethods.FlalignArray = function(t1, e1, r1, n1, o1, i1, a1, l1) {
                void 0 === l1 && (l1 = !1), t1.Push(e1), s1.default.checkEqnEnv(t1), i1 = i1.split("").join(" ").replace(/r/g, "right").replace(/l/g, "left").replace(/c/g, "center");
                var c1 = t1.itemFactory.create("flalign", e1.getName(), r1, n1, o1, t1.stack);
                return c1.arraydef = {
                    width: "100%",
                    displaystyle: !0,
                    columnalign: i1,
                    columnspacing: "0em",
                    columnwidth: a1,
                    rowspacing: "3pt",
                    side: t1.options.tagSide,
                    minlabelspacing: l1 ? "0" : t1.options.tagIndent,
                    "data-width-includes-label": !0
                }, c1.setProperty("zeroWidthLabel", l1), c1;
            }, e1.NEW_OPS = "ams-declare-ops", e1.AmsMethods.HandleDeclareOp = function(t1, r1) {
                var n1 = t1.GetStar() ? "*" : "", o1 = s1.default.trimSpaces(t1.GetArgument(r1));
                "\\" === o1.charAt(0) && (o1 = o1.substr(1));
                var i1 = t1.GetArgument(r1);
                t1.configuration.handlers.retrieve(e1.NEW_OPS).add(o1, new h1.Macro(o1, e1.AmsMethods.Macro, [
                    "\\operatorname".concat(n1, "{").concat(i1, "}")
                ]));
            }, e1.AmsMethods.HandleOperatorName = function(t1, e1) {
                var r1 = t1.GetStar(), o1 = s1.default.trimSpaces(t1.GetArgument(e1)), i1 = new u1.default(o1, n1(n1({}, t1.stack.env), {
                    font: c1.TexConstant.Variant.NORMAL,
                    multiLetterIdentifiers: /^[-*a-z]+/i,
                    operatorLetters: !0
                }), t1.configuration).mml();
                if (i1.isKind("mi") || (i1 = t1.create("node", "TeXAtom", [
                    i1
                ])), l1.default.setProperties(i1, {
                    movesupsub: r1,
                    movablelimits: !0,
                    texClass: d1.TEXCLASS.OP
                }), !r1) {
                    var a1 = t1.GetNext(), p1 = t1.i;
                    "\\" === a1 && ++t1.i && "limits" !== t1.GetCS() && (t1.i = p1);
                }
                t1.Push(i1);
            }, e1.AmsMethods.SideSet = function(t1, e1) {
                var r1 = o1(m1(t1.ParseArg(e1)), 2), n1 = r1[0], i1 = r1[1], a1 = o1(m1(t1.ParseArg(e1)), 2), c1 = a1[0], u1 = a1[1], p1 = t1.ParseArg(e1), h1 = p1;
                n1 && (i1 ? n1.replaceChild(t1.create("node", "mphantom", [
                    t1.create("node", "mpadded", [
                        s1.default.copyNode(p1, t1)
                    ], {
                        width: 0
                    })
                ]), l1.default.getChildAt(n1, 0)) : (h1 = t1.create("node", "mmultiscripts", [
                    p1
                ]), c1 && l1.default.appendChildren(h1, [
                    l1.default.getChildAt(c1, 1) || t1.create("node", "none"),
                    l1.default.getChildAt(c1, 2) || t1.create("node", "none")
                ]), l1.default.setProperty(h1, "scriptalign", "left"), l1.default.appendChildren(h1, [
                    t1.create("node", "mprescripts"),
                    l1.default.getChildAt(n1, 1) || t1.create("node", "none"),
                    l1.default.getChildAt(n1, 2) || t1.create("node", "none")
                ]))), c1 && h1 === p1 && (c1.replaceChild(p1, l1.default.getChildAt(c1, 0)), h1 = c1);
                var f1 = t1.create("node", "TeXAtom", [], {
                    texClass: d1.TEXCLASS.OP,
                    movesupsub: !0,
                    movablelimits: !0
                });
                i1 && (n1 && f1.appendChild(n1), f1.appendChild(i1)), f1.appendChild(h1), u1 && f1.appendChild(u1), t1.Push(f1);
            }, e1.AmsMethods.operatorLetter = function(t1, e1) {
                return !!t1.stack.env.operatorLetters && a1.default.variable(t1, e1);
            }, e1.AmsMethods.MultiIntegral = function(t1, e1, r1) {
                var n1 = t1.GetNext();
                if ("\\" === n1) {
                    var o1 = t1.i;
                    n1 = t1.GetArgument(e1), t1.i = o1, "\\limits" === n1 && (r1 = "\\idotsint" === e1 ? "\\!\\!\\mathop{\\,\\," + r1 + "}" : "\\!\\!\\!\\mathop{\\,\\,\\," + r1 + "}");
                }
                t1.string = r1 + " " + t1.string.slice(t1.i), t1.i = 0;
            }, e1.AmsMethods.xArrow = function(t1, e1, r1, n1, o1) {
                var i1 = {
                    width: "+" + s1.default.Em((n1 + o1) / 18),
                    lspace: s1.default.Em(n1 / 18)
                }, a1 = t1.GetBrackets(e1), c1 = t1.ParseArg(e1), p1 = t1.create("node", "mspace", [], {
                    depth: ".25em"
                }), h1 = t1.create("token", "mo", {
                    stretchy: !0,
                    texClass: d1.TEXCLASS.REL
                }, String.fromCodePoint(r1));
                h1 = t1.create("node", "mstyle", [
                    h1
                ], {
                    scriptlevel: 0
                });
                var f1 = t1.create("node", "munderover", [
                    h1
                ]), m1 = t1.create("node", "mpadded", [
                    c1,
                    p1
                ], i1);
                if (l1.default.setAttribute(m1, "voffset", "-.2em"), l1.default.setAttribute(m1, "height", "-.2em"), l1.default.setChild(f1, f1.over, m1), a1) {
                    var y1 = new u1.default(a1, t1.stack.env, t1.configuration).mml(), g1 = t1.create("node", "mspace", [], {
                        height: ".75em"
                    });
                    m1 = t1.create("node", "mpadded", [
                        y1,
                        g1
                    ], i1), l1.default.setAttribute(m1, "voffset", ".15em"), l1.default.setAttribute(m1, "depth", "-.15em"), l1.default.setChild(f1, f1.under, m1);
                }
                l1.default.setProperty(f1, "subsupOK", !0), t1.Push(f1);
            }, e1.AmsMethods.HandleShove = function(t1, e1, r1) {
                var n1 = t1.stack.Top();
                if ("multline" !== n1.kind) throw new p1.default("CommandOnlyAllowedInEnv", "%1 only allowed in %2 environment", t1.currentCS, "multline");
                if (n1.Size()) throw new p1.default("CommandAtTheBeginingOfLine", "%1 must come at the beginning of the line", t1.currentCS);
                n1.setProperty("shove", r1);
            }, e1.AmsMethods.CFrac = function(t1, e1) {
                var r1 = s1.default.trimSpaces(t1.GetBrackets(e1, "")), n1 = t1.GetArgument(e1), o1 = t1.GetArgument(e1), i1 = {
                    l: c1.TexConstant.Align.LEFT,
                    r: c1.TexConstant.Align.RIGHT,
                    "": ""
                }, a1 = new u1.default("\\strut\\textstyle{" + n1 + "}", t1.stack.env, t1.configuration).mml(), h1 = new u1.default("\\strut\\textstyle{" + o1 + "}", t1.stack.env, t1.configuration).mml(), f1 = t1.create("node", "mfrac", [
                    a1,
                    h1
                ]);
                if (null == (r1 = i1[r1])) throw new p1.default("IllegalAlign", "Illegal alignment specified in %1", t1.currentCS);
                r1 && l1.default.setProperties(f1, {
                    numalign: r1,
                    denomalign: r1
                }), t1.Push(f1);
            }, e1.AmsMethods.Genfrac = function(t1, e1, r1, n1, o1, i1) {
                null == r1 && (r1 = t1.GetDelimiterArg(e1)), null == n1 && (n1 = t1.GetDelimiterArg(e1)), null == o1 && (o1 = t1.GetArgument(e1)), null == i1 && (i1 = s1.default.trimSpaces(t1.GetArgument(e1)));
                var a1 = t1.ParseArg(e1), c1 = t1.ParseArg(e1), u1 = t1.create("node", "mfrac", [
                    a1,
                    c1
                ]);
                if ("" !== o1 && l1.default.setAttribute(u1, "linethickness", o1), (r1 || n1) && (l1.default.setProperty(u1, "withDelims", !0), u1 = s1.default.fixedFence(t1.configuration, r1, u1, n1)), "" !== i1) {
                    var h1 = parseInt(i1, 10), f1 = [
                        "D",
                        "T",
                        "S",
                        "SS"
                    ][h1];
                    if (null == f1) throw new p1.default("BadMathStyleFor", "Bad math style for %1", t1.currentCS);
                    u1 = t1.create("node", "mstyle", [
                        u1
                    ]), "D" === f1 ? l1.default.setProperties(u1, {
                        displaystyle: !0,
                        scriptlevel: 0
                    }) : l1.default.setProperties(u1, {
                        displaystyle: !1,
                        scriptlevel: h1 - 1
                    });
                }
                t1.Push(u1);
            }, e1.AmsMethods.HandleTag = function(t1, e1) {
                if (!t1.tags.currentTag.taggable && t1.tags.env) throw new p1.default("CommandNotAllowedInEnv", "%1 not allowed in %2 environment", t1.currentCS, t1.tags.env);
                if (t1.tags.currentTag.tag) throw new p1.default("MultipleCommand", "Multiple %1", t1.currentCS);
                var r1 = t1.GetStar(), n1 = s1.default.trimSpaces(t1.GetArgument(e1));
                t1.tags.tag(n1, r1);
            }, e1.AmsMethods.HandleNoTag = f1.default.HandleNoTag, e1.AmsMethods.HandleRef = f1.default.HandleRef, e1.AmsMethods.Macro = f1.default.Macro, e1.AmsMethods.Accent = f1.default.Accent, e1.AmsMethods.Tilde = f1.default.Tilde, e1.AmsMethods.Array = f1.default.Array, e1.AmsMethods.Spacer = f1.default.Spacer, e1.AmsMethods.NamedOp = f1.default.NamedOp, e1.AmsMethods.EqnArray = f1.default.EqnArray, e1.AmsMethods.Equation = f1.default.Equation;
        },
        1275: function(t1, e1, r1) {
            var n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AutoloadConfiguration = void 0;
            var i1 = r1(9899), s1 = r1(9140), a1 = r1(8803), l1 = r1(7741), c1 = r1(265), u1 = r1(7233);
            function p1(t1, e1, r1, i1) {
                var s1, a1, u1, p1;
                if (c1.Package.packages.has(t1.options.require.prefix + r1)) {
                    var d1 = t1.options.autoload[r1], m1 = n1(2 === d1.length && Array.isArray(d1[0]) ? d1 : [
                        d1,
                        []
                    ], 2), y1 = m1[0], g1 = m1[1];
                    try {
                        for(var b1 = o1(y1), v1 = b1.next(); !v1.done; v1 = b1.next()){
                            var _1 = v1.value;
                            h1.remove(_1);
                        }
                    } catch (t1) {
                        s1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            v1 && !v1.done && (a1 = b1.return) && a1.call(b1);
                        } finally{
                            if (s1) throw s1.error;
                        }
                    }
                    try {
                        for(var S1 = o1(g1), O1 = S1.next(); !O1.done; O1 = S1.next()){
                            var M1 = O1.value;
                            f1.remove(M1);
                        }
                    } catch (t1) {
                        u1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            O1 && !O1.done && (p1 = S1.return) && p1.call(S1);
                        } finally{
                            if (u1) throw u1.error;
                        }
                    }
                    t1.string = (i1 ? e1 + " " : "\\begin{" + e1.slice(1) + "}") + t1.string.slice(t1.i), t1.i = 0;
                }
                (0, l1.RequireLoad)(t1, r1);
            }
            var h1 = new s1.CommandMap("autoload-macros", {}, {}), f1 = new s1.CommandMap("autoload-environments", {}, {});
            e1.AutoloadConfiguration = i1.Configuration.create("autoload", {
                handler: {
                    macro: [
                        "autoload-macros"
                    ],
                    environment: [
                        "autoload-environments"
                    ]
                },
                options: {
                    autoload: (0, u1.expandable)({
                        action: [
                            "toggle",
                            "mathtip",
                            "texttip"
                        ],
                        amscd: [
                            [],
                            [
                                "CD"
                            ]
                        ],
                        bbox: [
                            "bbox"
                        ],
                        boldsymbol: [
                            "boldsymbol"
                        ],
                        braket: [
                            "bra",
                            "ket",
                            "braket",
                            "set",
                            "Bra",
                            "Ket",
                            "Braket",
                            "Set",
                            "ketbra",
                            "Ketbra"
                        ],
                        bussproofs: [
                            [],
                            [
                                "prooftree"
                            ]
                        ],
                        cancel: [
                            "cancel",
                            "bcancel",
                            "xcancel",
                            "cancelto"
                        ],
                        color: [
                            "color",
                            "definecolor",
                            "textcolor",
                            "colorbox",
                            "fcolorbox"
                        ],
                        enclose: [
                            "enclose"
                        ],
                        extpfeil: [
                            "xtwoheadrightarrow",
                            "xtwoheadleftarrow",
                            "xmapsto",
                            "xlongequal",
                            "xtofrom",
                            "Newextarrow"
                        ],
                        html: [
                            "href",
                            "class",
                            "style",
                            "cssId"
                        ],
                        mhchem: [
                            "ce",
                            "pu"
                        ],
                        newcommand: [
                            "newcommand",
                            "renewcommand",
                            "newenvironment",
                            "renewenvironment",
                            "def",
                            "let"
                        ],
                        unicode: [
                            "unicode"
                        ],
                        verb: [
                            "verb"
                        ]
                    })
                },
                config: function(t1, e1) {
                    var r1, i1, s1, c1, u1, d1, m1 = e1.parseOptions, y1 = m1.handlers.get("macro"), g1 = m1.handlers.get("environment"), b1 = m1.options.autoload;
                    m1.packageData.set("autoload", {
                        Autoload: p1
                    });
                    try {
                        for(var v1 = o1(Object.keys(b1)), _1 = v1.next(); !_1.done; _1 = v1.next()){
                            var S1 = _1.value, O1 = b1[S1], M1 = n1(2 === O1.length && Array.isArray(O1[0]) ? O1 : [
                                O1,
                                []
                            ], 2), x1 = M1[0], E1 = M1[1];
                            try {
                                for(var A1 = (s1 = void 0, o1(x1)), C1 = A1.next(); !C1.done; C1 = A1.next()){
                                    var T1 = C1.value;
                                    y1.lookup(T1) && "color" !== T1 || h1.add(T1, new a1.Macro(T1, p1, [
                                        S1,
                                        !0
                                    ]));
                                }
                            } catch (t1) {
                                s1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    C1 && !C1.done && (c1 = A1.return) && c1.call(A1);
                                } finally{
                                    if (s1) throw s1.error;
                                }
                            }
                            try {
                                for(var N1 = (u1 = void 0, o1(E1)), w1 = N1.next(); !w1.done; w1 = N1.next()){
                                    var L1 = w1.value;
                                    g1.lookup(L1) || f1.add(L1, new a1.Macro(L1, p1, [
                                        S1,
                                        !1
                                    ]));
                                }
                            } catch (t1) {
                                u1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    w1 && !w1.done && (d1 = N1.return) && d1.call(N1);
                                } finally{
                                    if (u1) throw u1.error;
                                }
                            }
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            _1 && !_1.done && (i1 = v1.return) && i1.call(v1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    m1.packageData.get("require") || l1.RequireConfiguration.config(t1, e1);
                },
                init: function(t1) {
                    t1.options.require || (0, u1.defaultOptions)(t1.options, l1.RequireConfiguration.options);
                },
                priority: 10
            });
        },
        2942: function(t1, e1, r1) {
            var n1, o1, i1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), s1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), a1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), l1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && s1(e1, t1, r1);
                return a1(e1, t1), e1;
            }, c1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, u1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BaseConfiguration = e1.BaseTags = e1.Other = void 0;
            var p1 = r1(9899), h1 = r1(2947), f1 = u1(r1(3971)), d1 = u1(r1(1256)), m1 = r1(9140), y1 = l1(r1(1181)), g1 = r1(6521);
            r1(1267);
            var b1 = r1(4082);
            function v1(t1, e1) {
                var r1 = t1.stack.env.font ? {
                    mathvariant: t1.stack.env.font
                } : {}, n1 = h1.MapHandler.getMap("remap").lookup(e1), o1 = (0, b1.getRange)(e1), i1 = o1 ? o1[3] : "mo", s1 = t1.create("token", i1, r1, n1 ? n1.char : e1);
                o1[4] && s1.attributes.set("mathvariant", o1[4]), "mo" === i1 && (d1.default.setProperty(s1, "fixStretchy", !0), t1.configuration.addNode("fixStretchy", s1)), t1.Push(s1);
            }
            new m1.CharacterMap("remap", null, {
                "-": "−",
                "*": "∗",
                "`": "‘"
            }), e1.Other = v1;
            var _1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return i1(e1, t1), e1;
            }(g1.AbstractTags);
            e1.BaseTags = _1, e1.BaseConfiguration = p1.Configuration.create("base", {
                handler: {
                    character: [
                        "command",
                        "special",
                        "letter",
                        "digit"
                    ],
                    delimiter: [
                        "delimiter"
                    ],
                    macro: [
                        "delimiter",
                        "macros",
                        "mathchar0mi",
                        "mathchar0mo",
                        "mathchar7"
                    ],
                    environment: [
                        "environment"
                    ]
                },
                fallback: {
                    character: v1,
                    macro: function(t1, e1) {
                        throw new f1.default("UndefinedControlSequence", "Undefined control sequence %1", "\\" + e1);
                    },
                    environment: function(t1, e1) {
                        throw new f1.default("UnknownEnv", "Unknown environment '%1'", e1);
                    }
                },
                items: (o1 = {}, o1[y1.StartItem.prototype.kind] = y1.StartItem, o1[y1.StopItem.prototype.kind] = y1.StopItem, o1[y1.OpenItem.prototype.kind] = y1.OpenItem, o1[y1.CloseItem.prototype.kind] = y1.CloseItem, o1[y1.PrimeItem.prototype.kind] = y1.PrimeItem, o1[y1.SubsupItem.prototype.kind] = y1.SubsupItem, o1[y1.OverItem.prototype.kind] = y1.OverItem, o1[y1.LeftItem.prototype.kind] = y1.LeftItem, o1[y1.Middle.prototype.kind] = y1.Middle, o1[y1.RightItem.prototype.kind] = y1.RightItem, o1[y1.BeginItem.prototype.kind] = y1.BeginItem, o1[y1.EndItem.prototype.kind] = y1.EndItem, o1[y1.StyleItem.prototype.kind] = y1.StyleItem, o1[y1.PositionItem.prototype.kind] = y1.PositionItem, o1[y1.CellItem.prototype.kind] = y1.CellItem, o1[y1.MmlItem.prototype.kind] = y1.MmlItem, o1[y1.FnItem.prototype.kind] = y1.FnItem, o1[y1.NotItem.prototype.kind] = y1.NotItem, o1[y1.NonscriptItem.prototype.kind] = y1.NonscriptItem, o1[y1.DotsItem.prototype.kind] = y1.DotsItem, o1[y1.ArrayItem.prototype.kind] = y1.ArrayItem, o1[y1.EqnArrayItem.prototype.kind] = y1.EqnArrayItem, o1[y1.EquationItem.prototype.kind] = y1.EquationItem, o1),
                options: {
                    maxMacros: 1e3,
                    baseURL: "undefined" == typeof document || 0 === document.getElementsByTagName("base").length ? "" : String(document.location).replace(/#.*$/, "")
                },
                tags: {
                    base: _1
                },
                postprocessors: [
                    [
                        function(t1) {
                            var e1, r1, n1 = t1.data;
                            try {
                                for(var o1 = c1(n1.getList("nonscript")), i1 = o1.next(); !i1.done; i1 = o1.next()){
                                    var s1 = i1.value;
                                    if (s1.attributes.get("scriptlevel") > 0) {
                                        var a1 = s1.parent;
                                        if (a1.childNodes.splice(a1.childIndex(s1), 1), n1.removeFromList(s1.kind, [
                                            s1
                                        ]), s1.isKind("mrow")) {
                                            var l1 = s1.childNodes[0];
                                            n1.removeFromList("mstyle", [
                                                l1
                                            ]), n1.removeFromList("mspace", l1.childNodes[0].childNodes);
                                        }
                                    } else s1.isKind("mrow") && (s1.parent.replaceChild(s1.childNodes[0], s1), n1.removeFromList("mrow", [
                                        s1
                                    ]));
                                }
                            } catch (t1) {
                                e1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    i1 && !i1.done && (r1 = o1.return) && r1.call(o1);
                                } finally{
                                    if (e1) throw e1.error;
                                }
                            }
                        },
                        -4
                    ]
                ]
            });
        },
        1181: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, a1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.EquationItem = e1.EqnArrayItem = e1.ArrayItem = e1.DotsItem = e1.NonscriptItem = e1.NotItem = e1.FnItem = e1.MmlItem = e1.CellItem = e1.PositionItem = e1.StyleItem = e1.EndItem = e1.BeginItem = e1.RightItem = e1.Middle = e1.LeftItem = e1.OverItem = e1.SubsupItem = e1.PrimeItem = e1.CloseItem = e1.OpenItem = e1.StopItem = e1.StartItem = void 0;
            var l1 = r1(2947), c1 = r1(5368), u1 = r1(9007), p1 = a1(r1(3971)), h1 = a1(r1(1130)), f1 = a1(r1(1256)), d1 = r1(8292), m1 = function(t1) {
                function e1(e1, r1) {
                    var n1 = t1.call(this, e1) || this;
                    return n1.global = r1, n1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "start";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("stop")) {
                        var r1 = this.toMml();
                        return this.global.isInner || (r1 = this.factory.configuration.tags.finalize(r1, this.env)), [
                            [
                                this.factory.create("mml", r1)
                            ],
                            !0
                        ];
                    }
                    return t1.prototype.checkItem.call(this, e1);
                }, e1;
            }(d1.BaseItem);
            e1.StartItem = m1;
            var y1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "stop";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(d1.BaseItem);
            e1.StopItem = y1;
            var g1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "open";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("close")) {
                        var r1 = this.toMml(), n1 = this.create("node", "TeXAtom", [
                            r1
                        ]);
                        return [
                            [
                                this.factory.create("mml", n1)
                            ],
                            !0
                        ];
                    }
                    return t1.prototype.checkItem.call(this, e1);
                }, e1.errors = Object.assign(Object.create(d1.BaseItem.errors), {
                    stop: [
                        "ExtraOpenMissingClose",
                        "Extra open brace or missing close brace"
                    ]
                }), e1;
            }(d1.BaseItem);
            e1.OpenItem = g1;
            var b1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "close";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(d1.BaseItem);
            e1.CloseItem = b1;
            var v1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "prime";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(t1) {
                    var e1 = i1(this.Peek(2), 2), r1 = e1[0], n1 = e1[1];
                    return !f1.default.isType(r1, "msubsup") || f1.default.isType(r1, "msup") ? [
                        [
                            this.create("node", "msup", [
                                r1,
                                n1
                            ]),
                            t1
                        ],
                        !0
                    ] : (f1.default.setChild(r1, r1.sup, n1), [
                        [
                            r1,
                            t1
                        ],
                        !0
                    ]);
                }, e1;
            }(d1.BaseItem);
            e1.PrimeItem = v1;
            var _1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "subsup";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("open") || e1.isKind("left")) return d1.BaseItem.success;
                    var r1 = this.First, n1 = this.getProperty("position");
                    if (e1.isKind("mml")) {
                        if (this.getProperty("primes")) {
                            if (2 !== n1) f1.default.setChild(r1, 2, this.getProperty("primes"));
                            else {
                                f1.default.setProperty(this.getProperty("primes"), "variantForm", !0);
                                var o1 = this.create("node", "mrow", [
                                    this.getProperty("primes"),
                                    e1.First
                                ]);
                                e1.First = o1;
                            }
                        }
                        return f1.default.setChild(r1, n1, e1.First), null != this.getProperty("movesupsub") && f1.default.setProperty(r1, "movesupsub", this.getProperty("movesupsub")), [
                            [
                                this.factory.create("mml", r1)
                            ],
                            !0
                        ];
                    }
                    if (t1.prototype.checkItem.call(this, e1)[1]) {
                        var a1 = this.getErrors([
                            "",
                            "sub",
                            "sup"
                        ][n1]);
                        throw new (p1.default.bind.apply(p1.default, s1([
                            void 0,
                            a1[0],
                            a1[1]
                        ], i1(a1.splice(2)), !1)));
                    }
                    return null;
                }, e1.errors = Object.assign(Object.create(d1.BaseItem.errors), {
                    stop: [
                        "MissingScript",
                        "Missing superscript or subscript argument"
                    ],
                    sup: [
                        "MissingOpenForSup",
                        "Missing open brace for superscript"
                    ],
                    sub: [
                        "MissingOpenForSub",
                        "Missing open brace for subscript"
                    ]
                }), e1;
            }(d1.BaseItem);
            e1.SubsupItem = _1;
            var S1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this, e1) || this;
                    return r1.setProperty("name", "\\over"), r1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "over";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("over")) throw new p1.default("AmbiguousUseOf", "Ambiguous use of %1", e1.getName());
                    if (e1.isClose) {
                        var r1 = this.create("node", "mfrac", [
                            this.getProperty("num"),
                            this.toMml(!1)
                        ]);
                        return null != this.getProperty("thickness") && f1.default.setAttribute(r1, "linethickness", this.getProperty("thickness")), (this.getProperty("open") || this.getProperty("close")) && (f1.default.setProperty(r1, "withDelims", !0), r1 = h1.default.fixedFence(this.factory.configuration, this.getProperty("open"), r1, this.getProperty("close"))), [
                            [
                                this.factory.create("mml", r1),
                                e1
                            ],
                            !0
                        ];
                    }
                    return t1.prototype.checkItem.call(this, e1);
                }, e1.prototype.toString = function() {
                    return "over[" + this.getProperty("num") + " / " + this.nodes.join("; ") + "]";
                }, e1;
            }(d1.BaseItem);
            e1.OverItem = S1;
            var O1 = function(t1) {
                function e1(e1, r1) {
                    var n1 = t1.call(this, e1) || this;
                    return n1.setProperty("delim", r1), n1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "left";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("right")) return [
                        [
                            this.factory.create("mml", h1.default.fenced(this.factory.configuration, this.getProperty("delim"), this.toMml(), e1.getProperty("delim"), "", e1.getProperty("color")))
                        ],
                        !0
                    ];
                    if (e1.isKind("middle")) {
                        var r1 = {
                            stretchy: !0
                        };
                        return e1.getProperty("color") && (r1.mathcolor = e1.getProperty("color")), this.Push(this.create("node", "TeXAtom", [], {
                            texClass: u1.TEXCLASS.CLOSE
                        }), this.create("token", "mo", r1, e1.getProperty("delim")), this.create("node", "TeXAtom", [], {
                            texClass: u1.TEXCLASS.OPEN
                        })), this.env = {}, [
                            [
                                this
                            ],
                            !0
                        ];
                    }
                    return t1.prototype.checkItem.call(this, e1);
                }, e1.errors = Object.assign(Object.create(d1.BaseItem.errors), {
                    stop: [
                        "ExtraLeftMissingRight",
                        "Extra \\left or missing \\right"
                    ]
                }), e1;
            }(d1.BaseItem);
            e1.LeftItem = O1;
            var M1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1 = t1.call(this, e1) || this;
                    return o1.setProperty("delim", r1), n1 && o1.setProperty("color", n1), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "middle";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(d1.BaseItem);
            e1.Middle = M1;
            var x1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1 = t1.call(this, e1) || this;
                    return o1.setProperty("delim", r1), n1 && o1.setProperty("color", n1), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "right";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(d1.BaseItem);
            e1.RightItem = x1;
            var E1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "begin";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("end")) {
                        if (e1.getName() !== this.getName()) throw new p1.default("EnvBadEnd", "\\begin{%1} ended with \\end{%2}", this.getName(), e1.getName());
                        return this.getProperty("end") ? d1.BaseItem.fail : [
                            [
                                this.factory.create("mml", this.toMml())
                            ],
                            !0
                        ];
                    }
                    if (e1.isKind("stop")) throw new p1.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
                    return t1.prototype.checkItem.call(this, e1);
                }, e1;
            }(d1.BaseItem);
            e1.BeginItem = E1;
            var A1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "end";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(d1.BaseItem);
            e1.EndItem = A1;
            var C1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "style";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (!e1.isClose) return t1.prototype.checkItem.call(this, e1);
                    var r1 = this.create("node", "mstyle", this.nodes, this.getProperty("styles"));
                    return [
                        [
                            this.factory.create("mml", r1),
                            e1
                        ],
                        !0
                    ];
                }, e1;
            }(d1.BaseItem);
            e1.StyleItem = C1;
            var T1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "position";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isClose) throw new p1.default("MissingBoxFor", "Missing box for %1", this.getName());
                    if (e1.isFinal) {
                        var r1 = e1.toMml();
                        switch(this.getProperty("move")){
                            case "vertical":
                                return r1 = this.create("node", "mpadded", [
                                    r1
                                ], {
                                    height: this.getProperty("dh"),
                                    depth: this.getProperty("dd"),
                                    voffset: this.getProperty("dh")
                                }), [
                                    [
                                        this.factory.create("mml", r1)
                                    ],
                                    !0
                                ];
                            case "horizontal":
                                return [
                                    [
                                        this.factory.create("mml", this.getProperty("left")),
                                        e1,
                                        this.factory.create("mml", this.getProperty("right"))
                                    ],
                                    !0
                                ];
                        }
                    }
                    return t1.prototype.checkItem.call(this, e1);
                }, e1;
            }(d1.BaseItem);
            e1.PositionItem = T1;
            var N1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "cell";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isClose", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(d1.BaseItem);
            e1.CellItem = N1;
            var w1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "isFinal", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "mml";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1;
            }(d1.BaseItem);
            e1.MmlItem = w1;
            var L1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "fn";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    var r1 = this.First;
                    if (r1) {
                        if (e1.isOpen) return d1.BaseItem.success;
                        if (!e1.isKind("fn")) {
                            var n1 = e1.First;
                            if (!e1.isKind("mml") || !n1) return [
                                [
                                    r1,
                                    e1
                                ],
                                !0
                            ];
                            if (f1.default.isType(n1, "mstyle") && n1.childNodes.length && f1.default.isType(n1.childNodes[0].childNodes[0], "mspace") || f1.default.isType(n1, "mspace")) return [
                                [
                                    r1,
                                    e1
                                ],
                                !0
                            ];
                            f1.default.isEmbellished(n1) && (n1 = f1.default.getCoreMO(n1));
                            var o1 = f1.default.getForm(n1);
                            if (null != o1 && [
                                0,
                                0,
                                1,
                                1,
                                0,
                                1,
                                1,
                                0,
                                0,
                                0
                            ][o1[2]]) return [
                                [
                                    r1,
                                    e1
                                ],
                                !0
                            ];
                        }
                        var i1 = this.create("token", "mo", {
                            texClass: u1.TEXCLASS.NONE
                        }, c1.entities.ApplyFunction);
                        return [
                            [
                                r1,
                                i1,
                                e1
                            ],
                            !0
                        ];
                    }
                    return t1.prototype.checkItem.apply(this, arguments);
                }, e1;
            }(d1.BaseItem);
            e1.FnItem = L1;
            var I1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.remap = l1.MapHandler.getMap("not_remap"), e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "not";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(t1) {
                    var e1, r1, n1;
                    if (t1.isKind("open") || t1.isKind("left")) return d1.BaseItem.success;
                    if (t1.isKind("mml") && (f1.default.isType(t1.First, "mo") || f1.default.isType(t1.First, "mi") || f1.default.isType(t1.First, "mtext")) && (e1 = t1.First, 1 === (r1 = f1.default.getText(e1)).length && !f1.default.getProperty(e1, "movesupsub") && 1 === f1.default.getChildren(e1).length)) return this.remap.contains(r1) ? (n1 = this.create("text", this.remap.lookup(r1).char), f1.default.setChild(e1, 0, n1)) : (n1 = this.create("text", "̸"), f1.default.appendChildren(e1, [
                        n1
                    ])), [
                        [
                            t1
                        ],
                        !0
                    ];
                    n1 = this.create("text", "⧸");
                    var o1 = this.create("node", "mtext", [], {}, n1), i1 = this.create("node", "mpadded", [
                        o1
                    ], {
                        width: 0
                    });
                    return [
                        [
                            e1 = this.create("node", "TeXAtom", [
                                i1
                            ], {
                                texClass: u1.TEXCLASS.REL
                            }),
                            t1
                        ],
                        !0
                    ];
                }, e1;
            }(d1.BaseItem);
            e1.NotItem = I1;
            var P1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "nonscript";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(t1) {
                    if (t1.isKind("mml") && 1 === t1.Size()) {
                        var e1 = t1.First;
                        if (e1.isKind("mstyle") && e1.notParent && (e1 = f1.default.getChildren(f1.default.getChildren(e1)[0])[0]), e1.isKind("mspace")) {
                            if (e1 !== t1.First) {
                                var r1 = this.create("node", "mrow", [
                                    t1.Pop()
                                ]);
                                t1.Push(r1);
                            }
                            this.factory.configuration.addNode("nonscript", t1.First);
                        }
                    }
                    return [
                        [
                            t1
                        ],
                        !0
                    ];
                }, e1;
            }(d1.BaseItem);
            e1.NonscriptItem = P1;
            var R1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "dots";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(t1) {
                    if (t1.isKind("open") || t1.isKind("left")) return d1.BaseItem.success;
                    var e1 = this.getProperty("ldots"), r1 = t1.First;
                    if (t1.isKind("mml") && f1.default.isEmbellished(r1)) {
                        var n1 = f1.default.getTexClass(f1.default.getCoreMO(r1));
                        n1 !== u1.TEXCLASS.BIN && n1 !== u1.TEXCLASS.REL || (e1 = this.getProperty("cdots"));
                    }
                    return [
                        [
                            e1,
                            t1
                        ],
                        !0
                    ];
                }, e1;
            }(d1.BaseItem);
            e1.DotsItem = R1;
            var k1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.table = [], e1.row = [], e1.frame = [], e1.hfill = [], e1.arraydef = {}, e1.dashed = !1, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "array";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "copyEnv", {
                    get: function() {
                        return !1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isClose && !e1.isKind("over")) {
                        if (e1.getProperty("isEntry")) return this.EndEntry(), this.clearEnv(), d1.BaseItem.fail;
                        if (e1.getProperty("isCR")) return this.EndEntry(), this.EndRow(), this.clearEnv(), d1.BaseItem.fail;
                        this.EndTable(), this.clearEnv();
                        var r1 = this.factory.create("mml", this.createMml());
                        if (this.getProperty("requireClose")) {
                            if (e1.isKind("close")) return [
                                [
                                    r1
                                ],
                                !0
                            ];
                            throw new p1.default("MissingCloseBrace", "Missing close brace");
                        }
                        return [
                            [
                                r1,
                                e1
                            ],
                            !0
                        ];
                    }
                    return t1.prototype.checkItem.call(this, e1);
                }, e1.prototype.createMml = function() {
                    var t1 = this.arraydef.scriptlevel;
                    delete this.arraydef.scriptlevel;
                    var e1 = this.create("node", "mtable", this.table, this.arraydef);
                    return t1 && e1.setProperty("scriptlevel", t1), 4 === this.frame.length ? f1.default.setAttribute(e1, "frame", this.dashed ? "dashed" : "solid") : this.frame.length && (this.arraydef.rowlines && (this.arraydef.rowlines = this.arraydef.rowlines.replace(/none( none)+$/, "none")), f1.default.setAttribute(e1, "frame", ""), e1 = this.create("node", "menclose", [
                        e1
                    ], {
                        notation: this.frame.join(" ")
                    }), "none" === (this.arraydef.columnlines || "none") && "none" === (this.arraydef.rowlines || "none") || f1.default.setAttribute(e1, "data-padding", 0)), (this.getProperty("open") || this.getProperty("close")) && (e1 = h1.default.fenced(this.factory.configuration, this.getProperty("open"), e1, this.getProperty("close"))), e1;
                }, e1.prototype.EndEntry = function() {
                    var t1 = this.create("node", "mtd", this.nodes);
                    this.hfill.length && (0 === this.hfill[0] && f1.default.setAttribute(t1, "columnalign", "right"), this.hfill[this.hfill.length - 1] === this.Size() && f1.default.setAttribute(t1, "columnalign", f1.default.getAttribute(t1, "columnalign") ? "center" : "left")), this.row.push(t1), this.Clear(), this.hfill = [];
                }, e1.prototype.EndRow = function() {
                    var t1;
                    this.getProperty("isNumbered") && 3 === this.row.length ? (this.row.unshift(this.row.pop()), t1 = this.create("node", "mlabeledtr", this.row)) : t1 = this.create("node", "mtr", this.row), this.table.push(t1), this.row = [];
                }, e1.prototype.EndTable = function() {
                    (this.Size() || this.row.length) && (this.EndEntry(), this.EndRow()), this.checkLines();
                }, e1.prototype.checkLines = function() {
                    if (this.arraydef.rowlines) {
                        var t1 = this.arraydef.rowlines.split(/ /);
                        t1.length === this.table.length ? (this.frame.push("bottom"), t1.pop(), this.arraydef.rowlines = t1.join(" ")) : t1.length < this.table.length - 1 && (this.arraydef.rowlines += " none");
                    }
                    if (this.getProperty("rowspacing")) {
                        for(var e1 = this.arraydef.rowspacing.split(/ /); e1.length < this.table.length;)e1.push(this.getProperty("rowspacing") + "em");
                        this.arraydef.rowspacing = e1.join(" ");
                    }
                }, e1.prototype.addRowSpacing = function(t1) {
                    if (this.arraydef.rowspacing) {
                        var e1 = this.arraydef.rowspacing.split(/ /);
                        if (!this.getProperty("rowspacing")) {
                            var r1 = h1.default.dimen2em(e1[0]);
                            this.setProperty("rowspacing", r1);
                        }
                        for(var n1 = this.getProperty("rowspacing"); e1.length < this.table.length;)e1.push(h1.default.Em(n1));
                        e1[this.table.length - 1] = h1.default.Em(Math.max(0, n1 + h1.default.dimen2em(t1))), this.arraydef.rowspacing = e1.join(" ");
                    }
                }, e1;
            }(d1.BaseItem);
            e1.ArrayItem = k1;
            var j1 = function(t1) {
                function e1(e1) {
                    for(var r1 = [], n1 = 1; n1 < arguments.length; n1++)r1[n1 - 1] = arguments[n1];
                    var o1 = t1.call(this, e1) || this;
                    return o1.maxrow = 0, o1.factory.configuration.tags.start(r1[0], r1[2], r1[1]), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "eqnarray";
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.EndEntry = function() {
                    this.row.length && h1.default.fixInitialMO(this.factory.configuration, this.nodes);
                    var t1 = this.create("node", "mtd", this.nodes);
                    this.row.push(t1), this.Clear();
                }, e1.prototype.EndRow = function() {
                    this.row.length > this.maxrow && (this.maxrow = this.row.length);
                    var t1 = "mtr", e1 = this.factory.configuration.tags.getTag();
                    e1 && (this.row = [
                        e1
                    ].concat(this.row), t1 = "mlabeledtr"), this.factory.configuration.tags.clearTag();
                    var r1 = this.create("node", t1, this.row);
                    this.table.push(r1), this.row = [];
                }, e1.prototype.EndTable = function() {
                    t1.prototype.EndTable.call(this), this.factory.configuration.tags.end(), this.extendArray("columnalign", this.maxrow), this.extendArray("columnwidth", this.maxrow), this.extendArray("columnspacing", this.maxrow - 1);
                }, e1.prototype.extendArray = function(t1, e1) {
                    if (this.arraydef[t1]) {
                        var r1 = this.arraydef[t1].split(/ /), n1 = s1([], i1(r1), !1);
                        if (n1.length > 1) {
                            for(; n1.length < e1;)n1.push.apply(n1, s1([], i1(r1), !1));
                            this.arraydef[t1] = n1.slice(0, e1).join(" ");
                        }
                    }
                }, e1;
            }(k1);
            e1.EqnArrayItem = j1;
            var B1 = function(t1) {
                function e1(e1) {
                    for(var r1 = [], n1 = 1; n1 < arguments.length; n1++)r1[n1 - 1] = arguments[n1];
                    var o1 = t1.call(this, e1) || this;
                    return o1.factory.configuration.tags.start("equation", !0, r1[0]), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "equation";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("end")) {
                        var r1 = this.toMml(), n1 = this.factory.configuration.tags.getTag();
                        return this.factory.configuration.tags.end(), [
                            [
                                n1 ? this.factory.configuration.tags.enTag(r1, n1) : r1,
                                e1
                            ],
                            !0
                        ];
                    }
                    if (e1.isKind("stop")) throw new p1.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
                    return t1.prototype.checkItem.call(this, e1);
                }, e1;
            }(d1.BaseItem);
            e1.EquationItem = B1;
        },
        1267: function(t1, e1, r1) {
            var n1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), o1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), i1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && n1(e1, t1, r1);
                return o1(e1, t1), e1;
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var a1 = i1(r1(9140)), l1 = r1(8317), c1 = s1(r1(7693)), u1 = s1(r1(5450)), p1 = s1(r1(1130)), h1 = r1(9007), f1 = r1(6010);
            new a1.RegExpMap("letter", u1.default.variable, /[a-z]/i), new a1.RegExpMap("digit", u1.default.digit, /[0-9.,]/), new a1.RegExpMap("command", u1.default.controlSequence, /^\\/), new a1.MacroMap("special", {
                "{": "Open",
                "}": "Close",
                "~": "Tilde",
                "^": "Superscript",
                _: "Subscript",
                " ": "Space",
                "	": "Space",
                "\r": "Space",
                "\n": "Space",
                "'": "Prime",
                "%": "Comment",
                "&": "Entry",
                "#": "Hash",
                "\xa0": "Space",
                "’": "Prime"
            }, c1.default), new a1.CharacterMap("mathchar0mi", u1.default.mathchar0mi, {
                alpha: "α",
                beta: "β",
                gamma: "γ",
                delta: "δ",
                epsilon: "ϵ",
                zeta: "ζ",
                eta: "η",
                theta: "θ",
                iota: "ι",
                kappa: "κ",
                lambda: "λ",
                mu: "μ",
                nu: "ν",
                xi: "ξ",
                omicron: "ο",
                pi: "π",
                rho: "ρ",
                sigma: "σ",
                tau: "τ",
                upsilon: "υ",
                phi: "ϕ",
                chi: "χ",
                psi: "ψ",
                omega: "ω",
                varepsilon: "ε",
                vartheta: "ϑ",
                varpi: "ϖ",
                varrho: "ϱ",
                varsigma: "ς",
                varphi: "φ",
                S: [
                    "\xa7",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                aleph: [
                    "ℵ",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                hbar: [
                    "ℏ",
                    {
                        variantForm: !0
                    }
                ],
                imath: "ı",
                jmath: "ȷ",
                ell: "ℓ",
                wp: [
                    "℘",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                Re: [
                    "ℜ",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                Im: [
                    "ℑ",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                partial: [
                    "∂",
                    {
                        mathvariant: l1.TexConstant.Variant.ITALIC
                    }
                ],
                infty: [
                    "∞",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                prime: [
                    "′",
                    {
                        variantForm: !0
                    }
                ],
                emptyset: [
                    "∅",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                nabla: [
                    "∇",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                top: [
                    "⊤",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                bot: [
                    "⊥",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                angle: [
                    "∠",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                triangle: [
                    "△",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                backslash: [
                    "∖",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                forall: [
                    "∀",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                exists: [
                    "∃",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                neg: [
                    "\xac",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                lnot: [
                    "\xac",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                flat: [
                    "♭",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                natural: [
                    "♮",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                sharp: [
                    "♯",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                clubsuit: [
                    "♣",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                diamondsuit: [
                    "♢",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                heartsuit: [
                    "♡",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ],
                spadesuit: [
                    "♠",
                    {
                        mathvariant: l1.TexConstant.Variant.NORMAL
                    }
                ]
            }), new a1.CharacterMap("mathchar0mo", u1.default.mathchar0mo, {
                surd: "√",
                coprod: [
                    "∐",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                bigvee: [
                    "⋁",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                bigwedge: [
                    "⋀",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                biguplus: [
                    "⨄",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                bigcap: [
                    "⋂",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                bigcup: [
                    "⋃",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                int: [
                    "∫",
                    {
                        texClass: h1.TEXCLASS.OP
                    }
                ],
                intop: [
                    "∫",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0,
                        movablelimits: !0
                    }
                ],
                iint: [
                    "∬",
                    {
                        texClass: h1.TEXCLASS.OP
                    }
                ],
                iiint: [
                    "∭",
                    {
                        texClass: h1.TEXCLASS.OP
                    }
                ],
                prod: [
                    "∏",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                sum: [
                    "∑",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                bigotimes: [
                    "⨂",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                bigoplus: [
                    "⨁",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                bigodot: [
                    "⨀",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                oint: [
                    "∮",
                    {
                        texClass: h1.TEXCLASS.OP
                    }
                ],
                bigsqcup: [
                    "⨆",
                    {
                        texClass: h1.TEXCLASS.OP,
                        movesupsub: !0
                    }
                ],
                smallint: [
                    "∫",
                    {
                        largeop: !1
                    }
                ],
                triangleleft: "◃",
                triangleright: "▹",
                bigtriangleup: "△",
                bigtriangledown: "▽",
                wedge: "∧",
                land: "∧",
                vee: "∨",
                lor: "∨",
                cap: "∩",
                cup: "∪",
                ddagger: "‡",
                dagger: "†",
                sqcap: "⊓",
                sqcup: "⊔",
                uplus: "⊎",
                amalg: "⨿",
                diamond: "⋄",
                bullet: "∙",
                wr: "≀",
                div: "\xf7",
                divsymbol: "\xf7",
                odot: [
                    "⊙",
                    {
                        largeop: !1
                    }
                ],
                oslash: [
                    "⊘",
                    {
                        largeop: !1
                    }
                ],
                otimes: [
                    "⊗",
                    {
                        largeop: !1
                    }
                ],
                ominus: [
                    "⊖",
                    {
                        largeop: !1
                    }
                ],
                oplus: [
                    "⊕",
                    {
                        largeop: !1
                    }
                ],
                mp: "∓",
                pm: "\xb1",
                circ: "∘",
                bigcirc: "◯",
                setminus: "∖",
                cdot: "⋅",
                ast: "∗",
                times: "\xd7",
                star: "⋆",
                propto: "∝",
                sqsubseteq: "⊑",
                sqsupseteq: "⊒",
                parallel: "∥",
                mid: "∣",
                dashv: "⊣",
                vdash: "⊢",
                leq: "≤",
                le: "≤",
                geq: "≥",
                ge: "≥",
                lt: "<",
                gt: ">",
                succ: "≻",
                prec: "≺",
                approx: "≈",
                succeq: "⪰",
                preceq: "⪯",
                supset: "⊃",
                subset: "⊂",
                supseteq: "⊇",
                subseteq: "⊆",
                in: "∈",
                ni: "∋",
                notin: "∉",
                owns: "∋",
                gg: "≫",
                ll: "≪",
                sim: "∼",
                simeq: "≃",
                perp: "⊥",
                equiv: "≡",
                asymp: "≍",
                smile: "⌣",
                frown: "⌢",
                ne: "≠",
                neq: "≠",
                cong: "≅",
                doteq: "≐",
                bowtie: "⋈",
                models: "⊨",
                notChar: "⧸",
                Leftrightarrow: "⇔",
                Leftarrow: "⇐",
                Rightarrow: "⇒",
                leftrightarrow: "↔",
                leftarrow: "←",
                gets: "←",
                rightarrow: "→",
                to: [
                    "→",
                    {
                        accent: !1
                    }
                ],
                mapsto: "↦",
                leftharpoonup: "↼",
                leftharpoondown: "↽",
                rightharpoonup: "⇀",
                rightharpoondown: "⇁",
                nearrow: "↗",
                searrow: "↘",
                nwarrow: "↖",
                swarrow: "↙",
                rightleftharpoons: "⇌",
                hookrightarrow: "↪",
                hookleftarrow: "↩",
                longleftarrow: "⟵",
                Longleftarrow: "⟸",
                longrightarrow: "⟶",
                Longrightarrow: "⟹",
                Longleftrightarrow: "⟺",
                longleftrightarrow: "⟷",
                longmapsto: "⟼",
                ldots: "…",
                cdots: "⋯",
                vdots: "⋮",
                ddots: "⋱",
                dotsc: "…",
                dotsb: "⋯",
                dotsm: "⋯",
                dotsi: "⋯",
                dotso: "…",
                ldotp: [
                    ".",
                    {
                        texClass: h1.TEXCLASS.PUNCT
                    }
                ],
                cdotp: [
                    "⋅",
                    {
                        texClass: h1.TEXCLASS.PUNCT
                    }
                ],
                colon: [
                    ":",
                    {
                        texClass: h1.TEXCLASS.PUNCT
                    }
                ]
            }), new a1.CharacterMap("mathchar7", u1.default.mathchar7, {
                Gamma: "Γ",
                Delta: "Δ",
                Theta: "Θ",
                Lambda: "Λ",
                Xi: "Ξ",
                Pi: "Π",
                Sigma: "Σ",
                Upsilon: "Υ",
                Phi: "Φ",
                Psi: "Ψ",
                Omega: "Ω",
                _: "_",
                "#": "#",
                $: "$",
                "%": "%",
                "&": "&",
                And: "&"
            }), new a1.DelimiterMap("delimiter", u1.default.delimiter, {
                "(": "(",
                ")": ")",
                "[": "[",
                "]": "]",
                "<": "⟨",
                ">": "⟩",
                "\\lt": "⟨",
                "\\gt": "⟩",
                "/": "/",
                "|": [
                    "|",
                    {
                        texClass: h1.TEXCLASS.ORD
                    }
                ],
                ".": "",
                "\\\\": "\\",
                "\\lmoustache": "⎰",
                "\\rmoustache": "⎱",
                "\\lgroup": "⟮",
                "\\rgroup": "⟯",
                "\\arrowvert": "⏐",
                "\\Arrowvert": "‖",
                "\\bracevert": "⎪",
                "\\Vert": [
                    "‖",
                    {
                        texClass: h1.TEXCLASS.ORD
                    }
                ],
                "\\|": [
                    "‖",
                    {
                        texClass: h1.TEXCLASS.ORD
                    }
                ],
                "\\vert": [
                    "|",
                    {
                        texClass: h1.TEXCLASS.ORD
                    }
                ],
                "\\uparrow": "↑",
                "\\downarrow": "↓",
                "\\updownarrow": "↕",
                "\\Uparrow": "⇑",
                "\\Downarrow": "⇓",
                "\\Updownarrow": "⇕",
                "\\backslash": "\\",
                "\\rangle": "⟩",
                "\\langle": "⟨",
                "\\rbrace": "}",
                "\\lbrace": "{",
                "\\}": "}",
                "\\{": "{",
                "\\rceil": "⌉",
                "\\lceil": "⌈",
                "\\rfloor": "⌋",
                "\\lfloor": "⌊",
                "\\lbrack": "[",
                "\\rbrack": "]"
            }), new a1.CommandMap("macros", {
                displaystyle: [
                    "SetStyle",
                    "D",
                    !0,
                    0
                ],
                textstyle: [
                    "SetStyle",
                    "T",
                    !1,
                    0
                ],
                scriptstyle: [
                    "SetStyle",
                    "S",
                    !1,
                    1
                ],
                scriptscriptstyle: [
                    "SetStyle",
                    "SS",
                    !1,
                    2
                ],
                rm: [
                    "SetFont",
                    l1.TexConstant.Variant.NORMAL
                ],
                mit: [
                    "SetFont",
                    l1.TexConstant.Variant.ITALIC
                ],
                oldstyle: [
                    "SetFont",
                    l1.TexConstant.Variant.OLDSTYLE
                ],
                cal: [
                    "SetFont",
                    l1.TexConstant.Variant.CALLIGRAPHIC
                ],
                it: [
                    "SetFont",
                    l1.TexConstant.Variant.MATHITALIC
                ],
                bf: [
                    "SetFont",
                    l1.TexConstant.Variant.BOLD
                ],
                bbFont: [
                    "SetFont",
                    l1.TexConstant.Variant.DOUBLESTRUCK
                ],
                scr: [
                    "SetFont",
                    l1.TexConstant.Variant.SCRIPT
                ],
                frak: [
                    "SetFont",
                    l1.TexConstant.Variant.FRAKTUR
                ],
                sf: [
                    "SetFont",
                    l1.TexConstant.Variant.SANSSERIF
                ],
                tt: [
                    "SetFont",
                    l1.TexConstant.Variant.MONOSPACE
                ],
                mathrm: [
                    "MathFont",
                    l1.TexConstant.Variant.NORMAL
                ],
                mathup: [
                    "MathFont",
                    l1.TexConstant.Variant.NORMAL
                ],
                mathnormal: [
                    "MathFont",
                    ""
                ],
                mathbf: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLD
                ],
                mathbfup: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLD
                ],
                mathit: [
                    "MathFont",
                    l1.TexConstant.Variant.MATHITALIC
                ],
                mathbfit: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDITALIC
                ],
                mathbb: [
                    "MathFont",
                    l1.TexConstant.Variant.DOUBLESTRUCK
                ],
                Bbb: [
                    "MathFont",
                    l1.TexConstant.Variant.DOUBLESTRUCK
                ],
                mathfrak: [
                    "MathFont",
                    l1.TexConstant.Variant.FRAKTUR
                ],
                mathbffrak: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDFRAKTUR
                ],
                mathscr: [
                    "MathFont",
                    l1.TexConstant.Variant.SCRIPT
                ],
                mathbfscr: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDSCRIPT
                ],
                mathsf: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIF
                ],
                mathsfup: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIF
                ],
                mathbfsf: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDSANSSERIF
                ],
                mathbfsfup: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDSANSSERIF
                ],
                mathsfit: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIFITALIC
                ],
                mathbfsfit: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIFBOLDITALIC
                ],
                mathtt: [
                    "MathFont",
                    l1.TexConstant.Variant.MONOSPACE
                ],
                mathcal: [
                    "MathFont",
                    l1.TexConstant.Variant.CALLIGRAPHIC
                ],
                mathbfcal: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDCALLIGRAPHIC
                ],
                symrm: [
                    "MathFont",
                    l1.TexConstant.Variant.NORMAL
                ],
                symup: [
                    "MathFont",
                    l1.TexConstant.Variant.NORMAL
                ],
                symnormal: [
                    "MathFont",
                    ""
                ],
                symbf: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLD
                ],
                symbfup: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLD
                ],
                symit: [
                    "MathFont",
                    l1.TexConstant.Variant.ITALIC
                ],
                symbfit: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDITALIC
                ],
                symbb: [
                    "MathFont",
                    l1.TexConstant.Variant.DOUBLESTRUCK
                ],
                symfrak: [
                    "MathFont",
                    l1.TexConstant.Variant.FRAKTUR
                ],
                symbffrak: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDFRAKTUR
                ],
                symscr: [
                    "MathFont",
                    l1.TexConstant.Variant.SCRIPT
                ],
                symbfscr: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDSCRIPT
                ],
                symsf: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIF
                ],
                symsfup: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIF
                ],
                symbfsf: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDSANSSERIF
                ],
                symbfsfup: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDSANSSERIF
                ],
                symsfit: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIFITALIC
                ],
                symbfsfit: [
                    "MathFont",
                    l1.TexConstant.Variant.SANSSERIFBOLDITALIC
                ],
                symtt: [
                    "MathFont",
                    l1.TexConstant.Variant.MONOSPACE
                ],
                symcal: [
                    "MathFont",
                    l1.TexConstant.Variant.CALLIGRAPHIC
                ],
                symbfcal: [
                    "MathFont",
                    l1.TexConstant.Variant.BOLDCALLIGRAPHIC
                ],
                textrm: [
                    "HBox",
                    null,
                    l1.TexConstant.Variant.NORMAL
                ],
                textup: [
                    "HBox",
                    null,
                    l1.TexConstant.Variant.NORMAL
                ],
                textnormal: [
                    "HBox"
                ],
                textit: [
                    "HBox",
                    null,
                    l1.TexConstant.Variant.ITALIC
                ],
                textbf: [
                    "HBox",
                    null,
                    l1.TexConstant.Variant.BOLD
                ],
                textsf: [
                    "HBox",
                    null,
                    l1.TexConstant.Variant.SANSSERIF
                ],
                texttt: [
                    "HBox",
                    null,
                    l1.TexConstant.Variant.MONOSPACE
                ],
                tiny: [
                    "SetSize",
                    .5
                ],
                Tiny: [
                    "SetSize",
                    .6
                ],
                scriptsize: [
                    "SetSize",
                    .7
                ],
                small: [
                    "SetSize",
                    .85
                ],
                normalsize: [
                    "SetSize",
                    1
                ],
                large: [
                    "SetSize",
                    1.2
                ],
                Large: [
                    "SetSize",
                    1.44
                ],
                LARGE: [
                    "SetSize",
                    1.73
                ],
                huge: [
                    "SetSize",
                    2.07
                ],
                Huge: [
                    "SetSize",
                    2.49
                ],
                arcsin: "NamedFn",
                arccos: "NamedFn",
                arctan: "NamedFn",
                arg: "NamedFn",
                cos: "NamedFn",
                cosh: "NamedFn",
                cot: "NamedFn",
                coth: "NamedFn",
                csc: "NamedFn",
                deg: "NamedFn",
                det: "NamedOp",
                dim: "NamedFn",
                exp: "NamedFn",
                gcd: "NamedOp",
                hom: "NamedFn",
                inf: "NamedOp",
                ker: "NamedFn",
                lg: "NamedFn",
                lim: "NamedOp",
                liminf: [
                    "NamedOp",
                    "lim&thinsp;inf"
                ],
                limsup: [
                    "NamedOp",
                    "lim&thinsp;sup"
                ],
                ln: "NamedFn",
                log: "NamedFn",
                max: "NamedOp",
                min: "NamedOp",
                Pr: "NamedOp",
                sec: "NamedFn",
                sin: "NamedFn",
                sinh: "NamedFn",
                sup: "NamedOp",
                tan: "NamedFn",
                tanh: "NamedFn",
                limits: [
                    "Limits",
                    1
                ],
                nolimits: [
                    "Limits",
                    0
                ],
                overline: [
                    "UnderOver",
                    "2015"
                ],
                underline: [
                    "UnderOver",
                    "2015"
                ],
                overbrace: [
                    "UnderOver",
                    "23DE",
                    1
                ],
                underbrace: [
                    "UnderOver",
                    "23DF",
                    1
                ],
                overparen: [
                    "UnderOver",
                    "23DC"
                ],
                underparen: [
                    "UnderOver",
                    "23DD"
                ],
                overrightarrow: [
                    "UnderOver",
                    "2192"
                ],
                underrightarrow: [
                    "UnderOver",
                    "2192"
                ],
                overleftarrow: [
                    "UnderOver",
                    "2190"
                ],
                underleftarrow: [
                    "UnderOver",
                    "2190"
                ],
                overleftrightarrow: [
                    "UnderOver",
                    "2194"
                ],
                underleftrightarrow: [
                    "UnderOver",
                    "2194"
                ],
                overset: "Overset",
                underset: "Underset",
                overunderset: "Overunderset",
                stackrel: [
                    "Macro",
                    "\\mathrel{\\mathop{#2}\\limits^{#1}}",
                    2
                ],
                stackbin: [
                    "Macro",
                    "\\mathbin{\\mathop{#2}\\limits^{#1}}",
                    2
                ],
                over: "Over",
                overwithdelims: "Over",
                atop: "Over",
                atopwithdelims: "Over",
                above: "Over",
                abovewithdelims: "Over",
                brace: [
                    "Over",
                    "{",
                    "}"
                ],
                brack: [
                    "Over",
                    "[",
                    "]"
                ],
                choose: [
                    "Over",
                    "(",
                    ")"
                ],
                frac: "Frac",
                sqrt: "Sqrt",
                root: "Root",
                uproot: [
                    "MoveRoot",
                    "upRoot"
                ],
                leftroot: [
                    "MoveRoot",
                    "leftRoot"
                ],
                left: "LeftRight",
                right: "LeftRight",
                middle: "LeftRight",
                llap: "Lap",
                rlap: "Lap",
                raise: "RaiseLower",
                lower: "RaiseLower",
                moveleft: "MoveLeftRight",
                moveright: "MoveLeftRight",
                ",": [
                    "Spacer",
                    f1.MATHSPACE.thinmathspace
                ],
                ":": [
                    "Spacer",
                    f1.MATHSPACE.mediummathspace
                ],
                ">": [
                    "Spacer",
                    f1.MATHSPACE.mediummathspace
                ],
                ";": [
                    "Spacer",
                    f1.MATHSPACE.thickmathspace
                ],
                "!": [
                    "Spacer",
                    f1.MATHSPACE.negativethinmathspace
                ],
                enspace: [
                    "Spacer",
                    .5
                ],
                quad: [
                    "Spacer",
                    1
                ],
                qquad: [
                    "Spacer",
                    2
                ],
                thinspace: [
                    "Spacer",
                    f1.MATHSPACE.thinmathspace
                ],
                negthinspace: [
                    "Spacer",
                    f1.MATHSPACE.negativethinmathspace
                ],
                hskip: "Hskip",
                hspace: "Hskip",
                kern: "Hskip",
                mskip: "Hskip",
                mspace: "Hskip",
                mkern: "Hskip",
                rule: "rule",
                Rule: [
                    "Rule"
                ],
                Space: [
                    "Rule",
                    "blank"
                ],
                nonscript: "Nonscript",
                big: [
                    "MakeBig",
                    h1.TEXCLASS.ORD,
                    .85
                ],
                Big: [
                    "MakeBig",
                    h1.TEXCLASS.ORD,
                    1.15
                ],
                bigg: [
                    "MakeBig",
                    h1.TEXCLASS.ORD,
                    1.45
                ],
                Bigg: [
                    "MakeBig",
                    h1.TEXCLASS.ORD,
                    1.75
                ],
                bigl: [
                    "MakeBig",
                    h1.TEXCLASS.OPEN,
                    .85
                ],
                Bigl: [
                    "MakeBig",
                    h1.TEXCLASS.OPEN,
                    1.15
                ],
                biggl: [
                    "MakeBig",
                    h1.TEXCLASS.OPEN,
                    1.45
                ],
                Biggl: [
                    "MakeBig",
                    h1.TEXCLASS.OPEN,
                    1.75
                ],
                bigr: [
                    "MakeBig",
                    h1.TEXCLASS.CLOSE,
                    .85
                ],
                Bigr: [
                    "MakeBig",
                    h1.TEXCLASS.CLOSE,
                    1.15
                ],
                biggr: [
                    "MakeBig",
                    h1.TEXCLASS.CLOSE,
                    1.45
                ],
                Biggr: [
                    "MakeBig",
                    h1.TEXCLASS.CLOSE,
                    1.75
                ],
                bigm: [
                    "MakeBig",
                    h1.TEXCLASS.REL,
                    .85
                ],
                Bigm: [
                    "MakeBig",
                    h1.TEXCLASS.REL,
                    1.15
                ],
                biggm: [
                    "MakeBig",
                    h1.TEXCLASS.REL,
                    1.45
                ],
                Biggm: [
                    "MakeBig",
                    h1.TEXCLASS.REL,
                    1.75
                ],
                mathord: [
                    "TeXAtom",
                    h1.TEXCLASS.ORD
                ],
                mathop: [
                    "TeXAtom",
                    h1.TEXCLASS.OP
                ],
                mathopen: [
                    "TeXAtom",
                    h1.TEXCLASS.OPEN
                ],
                mathclose: [
                    "TeXAtom",
                    h1.TEXCLASS.CLOSE
                ],
                mathbin: [
                    "TeXAtom",
                    h1.TEXCLASS.BIN
                ],
                mathrel: [
                    "TeXAtom",
                    h1.TEXCLASS.REL
                ],
                mathpunct: [
                    "TeXAtom",
                    h1.TEXCLASS.PUNCT
                ],
                mathinner: [
                    "TeXAtom",
                    h1.TEXCLASS.INNER
                ],
                vcenter: [
                    "TeXAtom",
                    h1.TEXCLASS.VCENTER
                ],
                buildrel: "BuildRel",
                hbox: [
                    "HBox",
                    0
                ],
                text: "HBox",
                mbox: [
                    "HBox",
                    0
                ],
                fbox: "FBox",
                boxed: [
                    "Macro",
                    "\\fbox{$\\displaystyle{#1}$}",
                    1
                ],
                framebox: "FrameBox",
                strut: "Strut",
                mathstrut: [
                    "Macro",
                    "\\vphantom{(}"
                ],
                phantom: "Phantom",
                vphantom: [
                    "Phantom",
                    1,
                    0
                ],
                hphantom: [
                    "Phantom",
                    0,
                    1
                ],
                smash: "Smash",
                acute: [
                    "Accent",
                    "00B4"
                ],
                grave: [
                    "Accent",
                    "0060"
                ],
                ddot: [
                    "Accent",
                    "00A8"
                ],
                tilde: [
                    "Accent",
                    "007E"
                ],
                bar: [
                    "Accent",
                    "00AF"
                ],
                breve: [
                    "Accent",
                    "02D8"
                ],
                check: [
                    "Accent",
                    "02C7"
                ],
                hat: [
                    "Accent",
                    "005E"
                ],
                vec: [
                    "Accent",
                    "2192"
                ],
                dot: [
                    "Accent",
                    "02D9"
                ],
                widetilde: [
                    "Accent",
                    "007E",
                    1
                ],
                widehat: [
                    "Accent",
                    "005E",
                    1
                ],
                matrix: "Matrix",
                array: "Matrix",
                pmatrix: [
                    "Matrix",
                    "(",
                    ")"
                ],
                cases: [
                    "Matrix",
                    "{",
                    "",
                    "left left",
                    null,
                    ".1em",
                    null,
                    !0
                ],
                eqalign: [
                    "Matrix",
                    null,
                    null,
                    "right left",
                    (0, f1.em)(f1.MATHSPACE.thickmathspace),
                    ".5em",
                    "D"
                ],
                displaylines: [
                    "Matrix",
                    null,
                    null,
                    "center",
                    null,
                    ".5em",
                    "D"
                ],
                cr: "Cr",
                "\\": "CrLaTeX",
                newline: [
                    "CrLaTeX",
                    !0
                ],
                hline: [
                    "HLine",
                    "solid"
                ],
                hdashline: [
                    "HLine",
                    "dashed"
                ],
                eqalignno: [
                    "Matrix",
                    null,
                    null,
                    "right left",
                    (0, f1.em)(f1.MATHSPACE.thickmathspace),
                    ".5em",
                    "D",
                    null,
                    "right"
                ],
                leqalignno: [
                    "Matrix",
                    null,
                    null,
                    "right left",
                    (0, f1.em)(f1.MATHSPACE.thickmathspace),
                    ".5em",
                    "D",
                    null,
                    "left"
                ],
                hfill: "HFill",
                hfil: "HFill",
                hfilll: "HFill",
                bmod: [
                    "Macro",
                    '\\mmlToken{mo}[lspace="thickmathspace" rspace="thickmathspace"]{mod}'
                ],
                pmod: [
                    "Macro",
                    "\\pod{\\mmlToken{mi}{mod}\\kern 6mu #1}",
                    1
                ],
                mod: [
                    "Macro",
                    "\\mathchoice{\\kern18mu}{\\kern12mu}{\\kern12mu}{\\kern12mu}\\mmlToken{mi}{mod}\\,\\,#1",
                    1
                ],
                pod: [
                    "Macro",
                    "\\mathchoice{\\kern18mu}{\\kern8mu}{\\kern8mu}{\\kern8mu}(#1)",
                    1
                ],
                iff: [
                    "Macro",
                    "\\;\\Longleftrightarrow\\;"
                ],
                skew: [
                    "Macro",
                    "{{#2{#3\\mkern#1mu}\\mkern-#1mu}{}}",
                    3
                ],
                pmb: [
                    "Macro",
                    "\\rlap{#1}\\kern1px{#1}",
                    1
                ],
                TeX: [
                    "Macro",
                    "T\\kern-.14em\\lower.5ex{E}\\kern-.115em X"
                ],
                LaTeX: [
                    "Macro",
                    "L\\kern-.325em\\raise.21em{\\scriptstyle{A}}\\kern-.17em\\TeX"
                ],
                " ": [
                    "Macro",
                    "\\text{ }"
                ],
                not: "Not",
                dots: "Dots",
                space: "Tilde",
                "\xa0": "Tilde",
                begin: "BeginEnd",
                end: "BeginEnd",
                label: "HandleLabel",
                ref: "HandleRef",
                nonumber: "HandleNoTag",
                mathchoice: "MathChoice",
                mmlToken: "MmlToken"
            }, c1.default), new a1.EnvironmentMap("environment", u1.default.environment, {
                array: [
                    "AlignedArray"
                ],
                equation: [
                    "Equation",
                    null,
                    !0
                ],
                eqnarray: [
                    "EqnArray",
                    null,
                    !0,
                    !0,
                    "rcl",
                    p1.default.cols(0, f1.MATHSPACE.thickmathspace),
                    ".5em"
                ]
            }, c1.default), new a1.CharacterMap("not_remap", null, {
                "←": "↚",
                "→": "↛",
                "↔": "↮",
                "⇐": "⇍",
                "⇒": "⇏",
                "⇔": "⇎",
                "∈": "∉",
                "∋": "∌",
                "∣": "∤",
                "∥": "∦",
                "∼": "≁",
                "~": "≁",
                "≃": "≄",
                "≅": "≇",
                "≈": "≉",
                "≍": "≭",
                "=": "≠",
                "≡": "≢",
                "<": "≮",
                ">": "≯",
                "≤": "≰",
                "≥": "≱",
                "≲": "≴",
                "≳": "≵",
                "≶": "≸",
                "≷": "≹",
                "≺": "⊀",
                "≻": "⊁",
                "⊂": "⊄",
                "⊃": "⊅",
                "⊆": "⊈",
                "⊇": "⊉",
                "⊢": "⊬",
                "⊨": "⊭",
                "⊩": "⊮",
                "⊫": "⊯",
                "≼": "⋠",
                "≽": "⋡",
                "⊑": "⋢",
                "⊒": "⋣",
                "⊲": "⋪",
                "⊳": "⋫",
                "⊴": "⋬",
                "⊵": "⋭",
                "∃": "∄"
            });
        },
        7693: function(t1, e1, r1) {
            var n1 = this && this.__assign || function() {
                return n1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, n1.apply(this, arguments);
            }, o1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), i1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), s1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && o1(e1, t1, r1);
                return i1(e1, t1), e1;
            }, a1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, l1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var c1 = s1(r1(1181)), u1 = l1(r1(1256)), p1 = l1(r1(3971)), h1 = l1(r1(8417)), f1 = r1(8317), d1 = l1(r1(1130)), m1 = r1(9007), y1 = r1(6521), g1 = r1(6010), b1 = r1(5368), v1 = r1(7233), _1 = {}, S1 = {
                fontfamily: 1,
                fontsize: 1,
                fontweight: 1,
                fontstyle: 1,
                color: 1,
                background: 1,
                id: 1,
                class: 1,
                href: 1,
                style: 1
            };
            function O1(t1, e1) {
                var r1 = t1.stack.env, n1 = r1.inRoot;
                r1.inRoot = !0;
                var o1 = new h1.default(e1, r1, t1.configuration), i1 = o1.mml(), s1 = o1.stack.global;
                if (s1.leftRoot || s1.upRoot) {
                    var a1 = {};
                    s1.leftRoot && (a1.width = s1.leftRoot), s1.upRoot && (a1.voffset = s1.upRoot, a1.height = s1.upRoot), i1 = t1.create("node", "mpadded", [
                        i1
                    ], a1);
                }
                return r1.inRoot = n1, i1;
            }
            _1.Open = function(t1, e1) {
                t1.Push(t1.itemFactory.create("open"));
            }, _1.Close = function(t1, e1) {
                t1.Push(t1.itemFactory.create("close"));
            }, _1.Tilde = function(t1, e1) {
                t1.Push(t1.create("token", "mtext", {}, b1.entities.nbsp));
            }, _1.Space = function(t1, e1) {}, _1.Superscript = function(t1, e1) {
                var r1, n1, o1;
                t1.GetNext().match(/\d/) && (t1.string = t1.string.substr(0, t1.i + 1) + " " + t1.string.substr(t1.i + 1));
                var i1 = t1.stack.Top();
                i1.isKind("prime") ? (o1 = (r1 = a1(i1.Peek(2), 2))[0], n1 = r1[1], t1.stack.Pop()) : (o1 = t1.stack.Prev()) || (o1 = t1.create("token", "mi", {}, ""));
                var s1 = u1.default.getProperty(o1, "movesupsub"), l1 = u1.default.isType(o1, "msubsup") ? o1.sup : o1.over;
                if (u1.default.isType(o1, "msubsup") && !u1.default.isType(o1, "msup") && u1.default.getChildAt(o1, o1.sup) || u1.default.isType(o1, "munderover") && !u1.default.isType(o1, "mover") && u1.default.getChildAt(o1, o1.over) && !u1.default.getProperty(o1, "subsupOK")) throw new p1.default("DoubleExponent", "Double exponent: use braces to clarify");
                u1.default.isType(o1, "msubsup") && !u1.default.isType(o1, "msup") || (s1 ? ((!u1.default.isType(o1, "munderover") || u1.default.isType(o1, "mover") || u1.default.getChildAt(o1, o1.over)) && (o1 = t1.create("node", "munderover", [
                    o1
                ], {
                    movesupsub: !0
                })), l1 = o1.over) : l1 = (o1 = t1.create("node", "msubsup", [
                    o1
                ])).sup), t1.Push(t1.itemFactory.create("subsup", o1).setProperties({
                    position: l1,
                    primes: n1,
                    movesupsub: s1
                }));
            }, _1.Subscript = function(t1, e1) {
                var r1, n1, o1;
                t1.GetNext().match(/\d/) && (t1.string = t1.string.substr(0, t1.i + 1) + " " + t1.string.substr(t1.i + 1));
                var i1 = t1.stack.Top();
                i1.isKind("prime") ? (o1 = (r1 = a1(i1.Peek(2), 2))[0], n1 = r1[1], t1.stack.Pop()) : (o1 = t1.stack.Prev()) || (o1 = t1.create("token", "mi", {}, ""));
                var s1 = u1.default.getProperty(o1, "movesupsub"), l1 = u1.default.isType(o1, "msubsup") ? o1.sub : o1.under;
                if (u1.default.isType(o1, "msubsup") && !u1.default.isType(o1, "msup") && u1.default.getChildAt(o1, o1.sub) || u1.default.isType(o1, "munderover") && !u1.default.isType(o1, "mover") && u1.default.getChildAt(o1, o1.under) && !u1.default.getProperty(o1, "subsupOK")) throw new p1.default("DoubleSubscripts", "Double subscripts: use braces to clarify");
                u1.default.isType(o1, "msubsup") && !u1.default.isType(o1, "msup") || (s1 ? ((!u1.default.isType(o1, "munderover") || u1.default.isType(o1, "mover") || u1.default.getChildAt(o1, o1.under)) && (o1 = t1.create("node", "munderover", [
                    o1
                ], {
                    movesupsub: !0
                })), l1 = o1.under) : l1 = (o1 = t1.create("node", "msubsup", [
                    o1
                ])).sub), t1.Push(t1.itemFactory.create("subsup", o1).setProperties({
                    position: l1,
                    primes: n1,
                    movesupsub: s1
                }));
            }, _1.Prime = function(t1, e1) {
                var r1 = t1.stack.Prev();
                if (r1 || (r1 = t1.create("node", "mi")), u1.default.isType(r1, "msubsup") && !u1.default.isType(r1, "msup") && u1.default.getChildAt(r1, r1.sup)) throw new p1.default("DoubleExponentPrime", "Prime causes double exponent: use braces to clarify");
                var n1 = "";
                t1.i--;
                do n1 += b1.entities.prime, t1.i++, e1 = t1.GetNext();
                while ("'" === e1 || e1 === b1.entities.rsquo);
                n1 = [
                    "",
                    "′",
                    "″",
                    "‴",
                    "⁗"
                ][n1.length] || n1;
                var o1 = t1.create("token", "mo", {
                    variantForm: !0
                }, n1);
                t1.Push(t1.itemFactory.create("prime", r1, o1));
            }, _1.Comment = function(t1, e1) {
                for(; t1.i < t1.string.length && "\n" !== t1.string.charAt(t1.i);)t1.i++;
            }, _1.Hash = function(t1, e1) {
                throw new p1.default("CantUseHash1", "You can't use 'macro parameter character #' in math mode");
            }, _1.MathFont = function(t1, e1, r1) {
                var o1 = t1.GetArgument(e1), i1 = new h1.default(o1, n1(n1({}, t1.stack.env), {
                    font: r1,
                    multiLetterIdentifiers: /^[a-zA-Z]+/,
                    noAutoOP: !0
                }), t1.configuration).mml();
                t1.Push(t1.create("node", "TeXAtom", [
                    i1
                ]));
            }, _1.SetFont = function(t1, e1, r1) {
                t1.stack.env.font = r1;
            }, _1.SetStyle = function(t1, e1, r1, n1, o1) {
                t1.stack.env.style = r1, t1.stack.env.level = o1, t1.Push(t1.itemFactory.create("style").setProperty("styles", {
                    displaystyle: n1,
                    scriptlevel: o1
                }));
            }, _1.SetSize = function(t1, e1, r1) {
                t1.stack.env.size = r1, t1.Push(t1.itemFactory.create("style").setProperty("styles", {
                    mathsize: (0, g1.em)(r1)
                }));
            }, _1.Spacer = function(t1, e1, r1) {
                var n1 = t1.create("node", "mspace", [], {
                    width: (0, g1.em)(r1)
                }), o1 = t1.create("node", "mstyle", [
                    n1
                ], {
                    scriptlevel: 0
                });
                t1.Push(o1);
            }, _1.LeftRight = function(t1, e1) {
                var r1 = e1.substr(1);
                t1.Push(t1.itemFactory.create(r1, t1.GetDelimiter(e1), t1.stack.env.color));
            }, _1.NamedFn = function(t1, e1, r1) {
                r1 || (r1 = e1.substr(1));
                var n1 = t1.create("token", "mi", {
                    texClass: m1.TEXCLASS.OP
                }, r1);
                t1.Push(t1.itemFactory.create("fn", n1));
            }, _1.NamedOp = function(t1, e1, r1) {
                r1 || (r1 = e1.substr(1)), r1 = r1.replace(/&thinsp;/, " ");
                var n1 = t1.create("token", "mo", {
                    movablelimits: !0,
                    movesupsub: !0,
                    form: f1.TexConstant.Form.PREFIX,
                    texClass: m1.TEXCLASS.OP
                }, r1);
                t1.Push(n1);
            }, _1.Limits = function(t1, e1, r1) {
                var n1 = t1.stack.Prev(!0);
                if (!n1 || u1.default.getTexClass(u1.default.getCoreMO(n1)) !== m1.TEXCLASS.OP && null == u1.default.getProperty(n1, "movesupsub")) throw new p1.default("MisplacedLimits", "%1 is allowed only on operators", t1.currentCS);
                var o1, i1 = t1.stack.Top();
                u1.default.isType(n1, "munderover") && !r1 ? (o1 = t1.create("node", "msubsup"), u1.default.copyChildren(n1, o1), n1 = i1.Last = o1) : u1.default.isType(n1, "msubsup") && r1 && (o1 = t1.create("node", "munderover"), u1.default.copyChildren(n1, o1), n1 = i1.Last = o1), u1.default.setProperty(n1, "movesupsub", !!r1), u1.default.setProperties(u1.default.getCoreMO(n1), {
                    movablelimits: !1
                }), (u1.default.getAttribute(n1, "movablelimits") || u1.default.getProperty(n1, "movablelimits")) && u1.default.setProperties(n1, {
                    movablelimits: !1
                });
            }, _1.Over = function(t1, e1, r1, n1) {
                var o1 = t1.itemFactory.create("over").setProperty("name", t1.currentCS);
                r1 || n1 ? (o1.setProperty("open", r1), o1.setProperty("close", n1)) : e1.match(/withdelims$/) && (o1.setProperty("open", t1.GetDelimiter(e1)), o1.setProperty("close", t1.GetDelimiter(e1))), e1.match(/^\\above/) ? o1.setProperty("thickness", t1.GetDimen(e1)) : (e1.match(/^\\atop/) || r1 || n1) && o1.setProperty("thickness", 0), t1.Push(o1);
            }, _1.Frac = function(t1, e1) {
                var r1 = t1.ParseArg(e1), n1 = t1.ParseArg(e1), o1 = t1.create("node", "mfrac", [
                    r1,
                    n1
                ]);
                t1.Push(o1);
            }, _1.Sqrt = function(t1, e1) {
                var r1 = t1.GetBrackets(e1), n1 = t1.GetArgument(e1);
                "\\frac" === n1 && (n1 += "{" + t1.GetArgument(n1) + "}{" + t1.GetArgument(n1) + "}");
                var o1 = new h1.default(n1, t1.stack.env, t1.configuration).mml();
                o1 = r1 ? t1.create("node", "mroot", [
                    o1,
                    O1(t1, r1)
                ]) : t1.create("node", "msqrt", [
                    o1
                ]), t1.Push(o1);
            }, _1.Root = function(t1, e1) {
                var r1 = t1.GetUpTo(e1, "\\of"), n1 = t1.ParseArg(e1), o1 = t1.create("node", "mroot", [
                    n1,
                    O1(t1, r1)
                ]);
                t1.Push(o1);
            }, _1.MoveRoot = function(t1, e1, r1) {
                if (!t1.stack.env.inRoot) throw new p1.default("MisplacedMoveRoot", "%1 can appear only within a root", t1.currentCS);
                if (t1.stack.global[r1]) throw new p1.default("MultipleMoveRoot", "Multiple use of %1", t1.currentCS);
                var n1 = t1.GetArgument(e1);
                if (!n1.match(/-?[0-9]+/)) throw new p1.default("IntegerArg", "The argument to %1 must be an integer", t1.currentCS);
                "-" !== (n1 = parseInt(n1, 10) / 15 + "em").substr(0, 1) && (n1 = "+" + n1), t1.stack.global[r1] = n1;
            }, _1.Accent = function(t1, e1, r1, o1) {
                var i1 = t1.ParseArg(e1), s1 = n1(n1({}, d1.default.getFontDef(t1)), {
                    accent: !0,
                    mathaccent: !0
                }), a1 = u1.default.createEntity(r1), l1 = t1.create("token", "mo", s1, a1);
                u1.default.setAttribute(l1, "stretchy", !!o1);
                var c1 = u1.default.isEmbellished(i1) ? u1.default.getCoreMO(i1) : i1;
                (u1.default.isType(c1, "mo") || u1.default.getProperty(c1, "movablelimits")) && u1.default.setProperties(c1, {
                    movablelimits: !1
                });
                var p1 = t1.create("node", "munderover");
                u1.default.setChild(p1, 0, i1), u1.default.setChild(p1, 1, null), u1.default.setChild(p1, 2, l1);
                var h1 = t1.create("node", "TeXAtom", [
                    p1
                ]);
                t1.Push(h1);
            }, _1.UnderOver = function(t1, e1, r1, n1) {
                var o1 = u1.default.createEntity(r1), i1 = t1.create("token", "mo", {
                    stretchy: !0,
                    accent: !0
                }, o1), s1 = "o" === e1.charAt(1) ? "over" : "under", a1 = t1.ParseArg(e1);
                t1.Push(d1.default.underOver(t1, a1, i1, s1, n1));
            }, _1.Overset = function(t1, e1) {
                var r1 = t1.ParseArg(e1), n1 = t1.ParseArg(e1);
                d1.default.checkMovableLimits(n1), r1.isKind("mo") && u1.default.setAttribute(r1, "accent", !1);
                var o1 = t1.create("node", "mover", [
                    n1,
                    r1
                ]);
                t1.Push(o1);
            }, _1.Underset = function(t1, e1) {
                var r1 = t1.ParseArg(e1), n1 = t1.ParseArg(e1);
                d1.default.checkMovableLimits(n1), r1.isKind("mo") && u1.default.setAttribute(r1, "accent", !1);
                var o1 = t1.create("node", "munder", [
                    n1,
                    r1
                ], {
                    accentunder: !1
                });
                t1.Push(o1);
            }, _1.Overunderset = function(t1, e1) {
                var r1 = t1.ParseArg(e1), n1 = t1.ParseArg(e1), o1 = t1.ParseArg(e1);
                d1.default.checkMovableLimits(o1), r1.isKind("mo") && u1.default.setAttribute(r1, "accent", !1), n1.isKind("mo") && u1.default.setAttribute(n1, "accent", !1);
                var i1 = t1.create("node", "munderover", [
                    o1,
                    n1,
                    r1
                ], {
                    accent: !1,
                    accentunder: !1
                });
                t1.Push(i1);
            }, _1.TeXAtom = function(t1, e1, r1) {
                var n1, o1, i1, s1 = {
                    texClass: r1
                };
                if (r1 === m1.TEXCLASS.OP) {
                    s1.movesupsub = s1.movablelimits = !0;
                    var a1 = t1.GetArgument(e1), l1 = a1.match(/^\s*\\rm\s+([a-zA-Z0-9 ]+)$/);
                    l1 ? (s1.mathvariant = f1.TexConstant.Variant.NORMAL, o1 = t1.create("token", "mi", s1, l1[1])) : (i1 = new h1.default(a1, t1.stack.env, t1.configuration).mml(), o1 = t1.create("node", "TeXAtom", [
                        i1
                    ], s1)), n1 = t1.itemFactory.create("fn", o1);
                } else i1 = t1.ParseArg(e1), n1 = t1.create("node", "TeXAtom", [
                    i1
                ], s1);
                t1.Push(n1);
            }, _1.MmlToken = function(t1, e1) {
                var r1, n1 = t1.GetArgument(e1), o1 = t1.GetBrackets(e1, "").replace(/^\s+/, ""), i1 = t1.GetArgument(e1), s1 = {}, a1 = [];
                try {
                    r1 = t1.create("node", n1);
                } catch (t1) {
                    r1 = null;
                }
                if (!r1 || !r1.isToken) throw new p1.default("NotMathMLToken", "%1 is not a token element", n1);
                for(; "" !== o1;){
                    var l1 = o1.match(/^([a-z]+)\s*=\s*('[^']*'|"[^"]*"|[^ ,]*)\s*,?\s*/i);
                    if (!l1) throw new p1.default("InvalidMathMLAttr", "Invalid MathML attribute: %1", o1);
                    if (!r1.attributes.hasDefault(l1[1]) && !S1[l1[1]]) throw new p1.default("UnknownAttrForElement", "%1 is not a recognized attribute for %2", l1[1], n1);
                    var c1 = d1.default.MmlFilterAttribute(t1, l1[1], l1[2].replace(/^(['"])(.*)\1$/, "$2"));
                    c1 && ("true" === c1.toLowerCase() ? c1 = !0 : "false" === c1.toLowerCase() && (c1 = !1), s1[l1[1]] = c1, a1.push(l1[1])), o1 = o1.substr(l1[0].length);
                }
                a1.length && (s1["mjx-keep-attrs"] = a1.join(" "));
                var h1 = t1.create("text", i1);
                r1.appendChild(h1), u1.default.setProperties(r1, s1), t1.Push(r1);
            }, _1.Strut = function(t1, e1) {
                var r1 = t1.create("node", "mrow"), n1 = t1.create("node", "mpadded", [
                    r1
                ], {
                    height: "8.6pt",
                    depth: "3pt",
                    width: 0
                });
                t1.Push(n1);
            }, _1.Phantom = function(t1, e1, r1, n1) {
                var o1 = t1.create("node", "mphantom", [
                    t1.ParseArg(e1)
                ]);
                (r1 || n1) && (o1 = t1.create("node", "mpadded", [
                    o1
                ]), n1 && (u1.default.setAttribute(o1, "height", 0), u1.default.setAttribute(o1, "depth", 0)), r1 && u1.default.setAttribute(o1, "width", 0));
                var i1 = t1.create("node", "TeXAtom", [
                    o1
                ]);
                t1.Push(i1);
            }, _1.Smash = function(t1, e1) {
                var r1 = d1.default.trimSpaces(t1.GetBrackets(e1, "")), n1 = t1.create("node", "mpadded", [
                    t1.ParseArg(e1)
                ]);
                switch(r1){
                    case "b":
                        u1.default.setAttribute(n1, "depth", 0);
                        break;
                    case "t":
                        u1.default.setAttribute(n1, "height", 0);
                        break;
                    default:
                        u1.default.setAttribute(n1, "height", 0), u1.default.setAttribute(n1, "depth", 0);
                }
                var o1 = t1.create("node", "TeXAtom", [
                    n1
                ]);
                t1.Push(o1);
            }, _1.Lap = function(t1, e1) {
                var r1 = t1.create("node", "mpadded", [
                    t1.ParseArg(e1)
                ], {
                    width: 0
                });
                "\\llap" === e1 && u1.default.setAttribute(r1, "lspace", "-1width");
                var n1 = t1.create("node", "TeXAtom", [
                    r1
                ]);
                t1.Push(n1);
            }, _1.RaiseLower = function(t1, e1) {
                var r1 = t1.GetDimen(e1), n1 = t1.itemFactory.create("position").setProperties({
                    name: t1.currentCS,
                    move: "vertical"
                });
                "-" === r1.charAt(0) && (r1 = r1.slice(1), e1 = "raise" === e1.substr(1) ? "\\lower" : "\\raise"), "\\lower" === e1 ? (n1.setProperty("dh", "-" + r1), n1.setProperty("dd", "+" + r1)) : (n1.setProperty("dh", "+" + r1), n1.setProperty("dd", "-" + r1)), t1.Push(n1);
            }, _1.MoveLeftRight = function(t1, e1) {
                var r1 = t1.GetDimen(e1), n1 = "-" === r1.charAt(0) ? r1.slice(1) : "-" + r1;
                if ("\\moveleft" === e1) {
                    var o1 = r1;
                    r1 = n1, n1 = o1;
                }
                t1.Push(t1.itemFactory.create("position").setProperties({
                    name: t1.currentCS,
                    move: "horizontal",
                    left: t1.create("node", "mspace", [], {
                        width: r1
                    }),
                    right: t1.create("node", "mspace", [], {
                        width: n1
                    })
                }));
            }, _1.Hskip = function(t1, e1) {
                var r1 = t1.create("node", "mspace", [], {
                    width: t1.GetDimen(e1)
                });
                t1.Push(r1);
            }, _1.Nonscript = function(t1, e1) {
                t1.Push(t1.itemFactory.create("nonscript"));
            }, _1.Rule = function(t1, e1, r1) {
                var n1 = {
                    width: t1.GetDimen(e1),
                    height: t1.GetDimen(e1),
                    depth: t1.GetDimen(e1)
                };
                "blank" !== r1 && (n1.mathbackground = t1.stack.env.color || "black");
                var o1 = t1.create("node", "mspace", [], n1);
                t1.Push(o1);
            }, _1.rule = function(t1, e1) {
                var r1 = t1.GetBrackets(e1), n1 = t1.GetDimen(e1), o1 = t1.GetDimen(e1), i1 = t1.create("node", "mspace", [], {
                    width: n1,
                    height: o1,
                    mathbackground: t1.stack.env.color || "black"
                });
                r1 && (i1 = t1.create("node", "mpadded", [
                    i1
                ], {
                    voffset: r1
                }), r1.match(/^\-/) ? (u1.default.setAttribute(i1, "height", r1), u1.default.setAttribute(i1, "depth", "+" + r1.substr(1))) : u1.default.setAttribute(i1, "height", "+" + r1)), t1.Push(i1);
            }, _1.MakeBig = function(t1, e1, r1, n1) {
                var o1 = String(n1 *= 1.411764705882353).replace(/(\.\d\d\d).+/, "$1") + "em", i1 = t1.GetDelimiter(e1, !0), s1 = t1.create("token", "mo", {
                    minsize: o1,
                    maxsize: o1,
                    fence: !0,
                    stretchy: !0,
                    symmetric: !0
                }, i1), a1 = t1.create("node", "TeXAtom", [
                    s1
                ], {
                    texClass: r1
                });
                t1.Push(a1);
            }, _1.BuildRel = function(t1, e1) {
                var r1 = t1.ParseUpTo(e1, "\\over"), n1 = t1.ParseArg(e1), o1 = t1.create("node", "munderover");
                u1.default.setChild(o1, 0, n1), u1.default.setChild(o1, 1, null), u1.default.setChild(o1, 2, r1);
                var i1 = t1.create("node", "TeXAtom", [
                    o1
                ], {
                    texClass: m1.TEXCLASS.REL
                });
                t1.Push(i1);
            }, _1.HBox = function(t1, e1, r1, n1) {
                t1.PushAll(d1.default.internalMath(t1, t1.GetArgument(e1), r1, n1));
            }, _1.FBox = function(t1, e1) {
                var r1 = d1.default.internalMath(t1, t1.GetArgument(e1)), n1 = t1.create("node", "menclose", r1, {
                    notation: "box"
                });
                t1.Push(n1);
            }, _1.FrameBox = function(t1, e1) {
                var r1 = t1.GetBrackets(e1), n1 = t1.GetBrackets(e1) || "c", o1 = d1.default.internalMath(t1, t1.GetArgument(e1));
                r1 && (o1 = [
                    t1.create("node", "mpadded", o1, {
                        width: r1,
                        "data-align": (0, v1.lookup)(n1, {
                            l: "left",
                            r: "right"
                        }, "center")
                    })
                ]);
                var i1 = t1.create("node", "TeXAtom", [
                    t1.create("node", "menclose", o1, {
                        notation: "box"
                    })
                ], {
                    texClass: m1.TEXCLASS.ORD
                });
                t1.Push(i1);
            }, _1.Not = function(t1, e1) {
                t1.Push(t1.itemFactory.create("not"));
            }, _1.Dots = function(t1, e1) {
                var r1 = u1.default.createEntity("2026"), n1 = u1.default.createEntity("22EF"), o1 = t1.create("token", "mo", {
                    stretchy: !1
                }, r1), i1 = t1.create("token", "mo", {
                    stretchy: !1
                }, n1);
                t1.Push(t1.itemFactory.create("dots").setProperties({
                    ldots: o1,
                    cdots: i1
                }));
            }, _1.Matrix = function(t1, e1, r1, n1, o1, i1, s1, a1, l1, c1) {
                var u1 = t1.GetNext();
                if ("" === u1) throw new p1.default("MissingArgFor", "Missing argument for %1", t1.currentCS);
                "{" === u1 ? t1.i++ : (t1.string = u1 + "}" + t1.string.slice(t1.i + 1), t1.i = 0);
                var h1 = t1.itemFactory.create("array").setProperty("requireClose", !0);
                h1.arraydef = {
                    rowspacing: s1 || "4pt",
                    columnspacing: i1 || "1em"
                }, l1 && h1.setProperty("isCases", !0), c1 && (h1.setProperty("isNumbered", !0), h1.arraydef.side = c1), (r1 || n1) && (h1.setProperty("open", r1), h1.setProperty("close", n1)), "D" === a1 && (h1.arraydef.displaystyle = !0), null != o1 && (h1.arraydef.columnalign = o1), t1.Push(h1);
            }, _1.Entry = function(t1, e1) {
                t1.Push(t1.itemFactory.create("cell").setProperties({
                    isEntry: !0,
                    name: e1
                }));
                var r1 = t1.stack.Top(), n1 = r1.getProperty("casesEnv");
                if (r1.getProperty("isCases") || n1) {
                    for(var o1 = t1.string, i1 = 0, s1 = -1, a1 = t1.i, l1 = o1.length, c1 = n1 ? new RegExp("^\\\\end\\s*\\{".concat(n1.replace(/\*/, "\\*"), "\\}")) : null; a1 < l1;){
                        var u1 = o1.charAt(a1);
                        if ("{" === u1) i1++, a1++;
                        else if ("}" === u1) 0 === i1 ? l1 = 0 : (0 === --i1 && s1 < 0 && (s1 = a1 - t1.i), a1++);
                        else {
                            if ("&" === u1 && 0 === i1) throw new p1.default("ExtraAlignTab", "Extra alignment tab in \\cases text");
                            if ("\\" === u1) {
                                var h1 = o1.substr(a1);
                                h1.match(/^((\\cr)[^a-zA-Z]|\\\\)/) || c1 && h1.match(c1) ? l1 = 0 : a1 += 2;
                            } else a1++;
                        }
                    }
                    var f1 = o1.substr(t1.i, a1 - t1.i);
                    if (!f1.match(/^\s*\\text[^a-zA-Z]/) || s1 !== f1.replace(/\s+$/, "").length - 1) {
                        var m1 = d1.default.internalMath(t1, d1.default.trimSpaces(f1), 0);
                        t1.PushAll(m1), t1.i = a1;
                    }
                }
            }, _1.Cr = function(t1, e1) {
                t1.Push(t1.itemFactory.create("cell").setProperties({
                    isCR: !0,
                    name: e1
                }));
            }, _1.CrLaTeX = function(t1, e1, r1) {
                var n1;
                if (void 0 === r1 && (r1 = !1), !r1 && ("*" === t1.string.charAt(t1.i) && t1.i++, "[" === t1.string.charAt(t1.i))) {
                    var o1 = t1.GetBrackets(e1, ""), i1 = a1(d1.default.matchDimen(o1), 2), s1 = i1[0], l1 = i1[1];
                    if (o1 && !s1) throw new p1.default("BracketMustBeDimension", "Bracket argument to %1 must be a dimension", t1.currentCS);
                    n1 = s1 + l1;
                }
                t1.Push(t1.itemFactory.create("cell").setProperties({
                    isCR: !0,
                    name: e1,
                    linebreak: !0
                }));
                var u1, h1 = t1.stack.Top();
                h1 instanceof c1.ArrayItem ? n1 && h1.addRowSpacing(n1) : (n1 && (u1 = t1.create("node", "mspace", [], {
                    depth: n1
                }), t1.Push(u1)), u1 = t1.create("node", "mspace", [], {
                    linebreak: f1.TexConstant.LineBreak.NEWLINE
                }), t1.Push(u1));
            }, _1.HLine = function(t1, e1, r1) {
                null == r1 && (r1 = "solid");
                var n1 = t1.stack.Top();
                if (!(n1 instanceof c1.ArrayItem) || n1.Size()) throw new p1.default("Misplaced", "Misplaced %1", t1.currentCS);
                if (n1.table.length) {
                    for(var o1 = n1.arraydef.rowlines ? n1.arraydef.rowlines.split(/ /) : []; o1.length < n1.table.length;)o1.push("none");
                    o1[n1.table.length - 1] = r1, n1.arraydef.rowlines = o1.join(" ");
                } else n1.frame.push("top");
            }, _1.HFill = function(t1, e1) {
                var r1 = t1.stack.Top();
                if (!(r1 instanceof c1.ArrayItem)) throw new p1.default("UnsupportedHFill", "Unsupported use of %1", t1.currentCS);
                r1.hfill.push(r1.Size());
            }, _1.BeginEnd = function(t1, e1) {
                var r1 = t1.GetArgument(e1);
                if (r1.match(/\\/i)) throw new p1.default("InvalidEnv", "Invalid environment name '%1'", r1);
                var n1 = t1.configuration.handlers.get("environment").lookup(r1);
                if (n1 && "\\end" === e1) {
                    if (!n1.args[0]) {
                        var o1 = t1.itemFactory.create("end").setProperty("name", r1);
                        return void t1.Push(o1);
                    }
                    t1.stack.env.closing = r1;
                }
                d1.default.checkMaxMacros(t1, !1), t1.parse("environment", [
                    t1,
                    r1
                ]);
            }, _1.Array = function(t1, e1, r1, n1, o1, i1, s1, a1, l1) {
                o1 || (o1 = t1.GetArgument("\\begin{" + e1.getName() + "}"));
                var c1 = ("c" + o1).replace(/[^clr|:]/g, "").replace(/[^|:]([|:])+/g, "$1");
                o1 = (o1 = o1.replace(/[^clr]/g, "").split("").join(" ")).replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
                var u1 = t1.itemFactory.create("array");
                return u1.arraydef = {
                    columnalign: o1,
                    columnspacing: i1 || "1em",
                    rowspacing: s1 || "4pt"
                }, c1.match(/[|:]/) && (c1.charAt(0).match(/[|:]/) && (u1.frame.push("left"), u1.dashed = ":" === c1.charAt(0)), c1.charAt(c1.length - 1).match(/[|:]/) && u1.frame.push("right"), c1 = c1.substr(1, c1.length - 2), u1.arraydef.columnlines = c1.split("").join(" ").replace(/[^|: ]/g, "none").replace(/\|/g, "solid").replace(/:/g, "dashed")), r1 && u1.setProperty("open", t1.convertDelimiter(r1)), n1 && u1.setProperty("close", t1.convertDelimiter(n1)), "'" === (a1 || "").charAt(1) && (u1.arraydef["data-cramped"] = !0, a1 = a1.charAt(0)), "D" === a1 ? u1.arraydef.displaystyle = !0 : a1 && (u1.arraydef.displaystyle = !1), "S" === a1 && (u1.arraydef.scriptlevel = 1), l1 && (u1.arraydef.useHeight = !1), t1.Push(e1), u1;
            }, _1.AlignedArray = function(t1, e1) {
                var r1 = t1.GetBrackets("\\begin{" + e1.getName() + "}"), n1 = _1.Array(t1, e1);
                return d1.default.setArrayAlign(n1, r1);
            }, _1.Equation = function(t1, e1, r1) {
                return t1.Push(e1), d1.default.checkEqnEnv(t1), t1.itemFactory.create("equation", r1).setProperty("name", e1.getName());
            }, _1.EqnArray = function(t1, e1, r1, n1, o1, i1) {
                t1.Push(e1), n1 && d1.default.checkEqnEnv(t1), o1 = (o1 = o1.replace(/[^clr]/g, "").split("").join(" ")).replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
                var s1 = t1.itemFactory.create("eqnarray", e1.getName(), r1, n1, t1.stack.global);
                return s1.arraydef = {
                    displaystyle: !0,
                    columnalign: o1,
                    columnspacing: i1 || "1em",
                    rowspacing: "3pt",
                    side: t1.options.tagSide,
                    minlabelspacing: t1.options.tagIndent
                }, s1;
            }, _1.HandleNoTag = function(t1, e1) {
                t1.tags.notag();
            }, _1.HandleLabel = function(t1, e1) {
                var r1 = t1.GetArgument(e1);
                if ("" !== r1 && !t1.tags.refUpdate) {
                    if (t1.tags.label) throw new p1.default("MultipleCommand", "Multiple %1", t1.currentCS);
                    if (t1.tags.label = r1, (t1.tags.allLabels[r1] || t1.tags.labels[r1]) && !t1.options.ignoreDuplicateLabels) throw new p1.default("MultipleLabel", "Label '%1' multiply defined", r1);
                    t1.tags.labels[r1] = new y1.Label;
                }
            }, _1.HandleRef = function(t1, e1, r1) {
                var n1 = t1.GetArgument(e1), o1 = t1.tags.allLabels[n1] || t1.tags.labels[n1];
                o1 || (t1.tags.refUpdate || (t1.tags.redo = !0), o1 = new y1.Label);
                var i1 = o1.tag;
                r1 && (i1 = t1.tags.formatTag(i1));
                var s1 = t1.create("node", "mrow", d1.default.internalMath(t1, i1), {
                    href: t1.tags.formatUrl(o1.id, t1.options.baseURL),
                    class: "MathJax_ref"
                });
                t1.Push(s1);
            }, _1.Macro = function(t1, e1, r1, n1, o1) {
                if (n1) {
                    var i1 = [];
                    if (null != o1) {
                        var s1 = t1.GetBrackets(e1);
                        i1.push(null == s1 ? o1 : s1);
                    }
                    for(var a1 = i1.length; a1 < n1; a1++)i1.push(t1.GetArgument(e1));
                    r1 = d1.default.substituteArgs(t1, i1, r1);
                }
                t1.string = d1.default.addArgs(t1, r1, t1.string.slice(t1.i)), t1.i = 0, d1.default.checkMaxMacros(t1);
            }, _1.MathChoice = function(t1, e1) {
                var r1 = t1.ParseArg(e1), n1 = t1.ParseArg(e1), o1 = t1.ParseArg(e1), i1 = t1.ParseArg(e1);
                t1.Push(t1.create("node", "MathChoice", [
                    r1,
                    n1,
                    o1,
                    i1
                ]));
            }, e1.default = _1;
        },
        8458: function(t1, e1, r1) {
            var n1, o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, i1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ConfigMacrosConfiguration = void 0;
            var s1 = r1(9899), a1 = r1(7233), l1 = r1(9140), c1 = i1(r1(5450)), u1 = r1(8803), p1 = i1(r1(1110)), h1 = r1(6793), f1 = "configmacros-map", d1 = "configmacros-env-map";
            e1.ConfigMacrosConfiguration = s1.Configuration.create("configmacros", {
                init: function(t1) {
                    new l1.CommandMap(f1, {}, {}), new l1.EnvironmentMap(d1, c1.default.environment, {}, {}), t1.append(s1.Configuration.local({
                        handler: {
                            macro: [
                                f1
                            ],
                            environment: [
                                d1
                            ]
                        },
                        priority: 3
                    }));
                },
                config: function(t1, e1) {
                    !function(t1) {
                        var e1, r1, n1 = t1.parseOptions.handlers.retrieve(f1), i1 = t1.parseOptions.options.macros;
                        try {
                            for(var s1 = o1(Object.keys(i1)), a1 = s1.next(); !a1.done; a1 = s1.next()){
                                var l1 = a1.value, c1 = "string" == typeof i1[l1] ? [
                                    i1[l1]
                                ] : i1[l1], h1 = Array.isArray(c1[2]) ? new u1.Macro(l1, p1.default.MacroWithTemplate, c1.slice(0, 2).concat(c1[2])) : new u1.Macro(l1, p1.default.Macro, c1);
                                n1.add(l1, h1);
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (r1 = s1.return) && r1.call(s1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                    }(e1), function(t1) {
                        var e1, r1, n1 = t1.parseOptions.handlers.retrieve(d1), i1 = t1.parseOptions.options.environments;
                        try {
                            for(var s1 = o1(Object.keys(i1)), a1 = s1.next(); !a1.done; a1 = s1.next()){
                                var l1 = a1.value;
                                n1.add(l1, new u1.Macro(l1, p1.default.BeginEnv, [
                                    !0
                                ].concat(i1[l1])));
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (r1 = s1.return) && r1.call(s1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                    }(e1);
                },
                items: (n1 = {}, n1[h1.BeginEnvItem.prototype.kind] = h1.BeginEnvItem, n1),
                options: {
                    macros: (0, a1.expandable)({}),
                    environments: (0, a1.expandable)({})
                }
            });
        },
        1496: function(t1, e1, r1) {
            var n1, o1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), i1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), s1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && o1(e1, t1, r1);
                return i1(e1, t1), e1;
            }, a1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.NewcommandConfiguration = void 0;
            var l1 = r1(9899), c1 = r1(6793), u1 = a1(r1(5579));
            r1(5117);
            var p1 = a1(r1(5450)), h1 = s1(r1(9140));
            e1.NewcommandConfiguration = l1.Configuration.create("newcommand", {
                handler: {
                    macro: [
                        "Newcommand-macros"
                    ]
                },
                items: (n1 = {}, n1[c1.BeginEnvItem.prototype.kind] = c1.BeginEnvItem, n1),
                options: {
                    maxMacros: 1e3
                },
                init: function(t1) {
                    new h1.DelimiterMap(u1.default.NEW_DELIMITER, p1.default.delimiter, {}), new h1.CommandMap(u1.default.NEW_COMMAND, {}, {}), new h1.EnvironmentMap(u1.default.NEW_ENVIRONMENT, p1.default.environment, {}, {}), t1.append(l1.Configuration.local({
                        handler: {
                            character: [],
                            delimiter: [
                                u1.default.NEW_DELIMITER
                            ],
                            macro: [
                                u1.default.NEW_DELIMITER,
                                u1.default.NEW_COMMAND
                            ],
                            environment: [
                                u1.default.NEW_ENVIRONMENT
                            ]
                        },
                        priority: -1
                    }));
                }
            });
        },
        6793: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BeginEnvItem = void 0;
            var s1 = i1(r1(3971)), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "kind", {
                    get: function() {
                        return "beginEnv";
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "isOpen", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.checkItem = function(e1) {
                    if (e1.isKind("end")) {
                        if (e1.getName() !== this.getName()) throw new s1.default("EnvBadEnd", "\\begin{%1} ended with \\end{%2}", this.getName(), e1.getName());
                        return [
                            [
                                this.factory.create("mml", this.toMml())
                            ],
                            !0
                        ];
                    }
                    if (e1.isKind("stop")) throw new s1.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
                    return t1.prototype.checkItem.call(this, e1);
                }, e1;
            }(r1(8292).BaseItem);
            e1.BeginEnvItem = a1;
        },
        5117: function(t1, e1, r1) {
            var n1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var o1 = n1(r1(1110));
            new (r1(9140)).CommandMap("Newcommand-macros", {
                newcommand: "NewCommand",
                renewcommand: "NewCommand",
                newenvironment: "NewEnvironment",
                renewenvironment: "NewEnvironment",
                def: "MacroDef",
                let: "Let"
            }, o1.default);
        },
        1110: function(t1, e1, r1) {
            var n1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), o1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), i1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && n1(e1, t1, r1);
                return o1(e1, t1), e1;
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var a1 = s1(r1(3971)), l1 = i1(r1(9140)), c1 = s1(r1(7693)), u1 = s1(r1(1130)), p1 = s1(r1(5579)), h1 = {
                NewCommand: function(t1, e1) {
                    var r1 = p1.default.GetCsNameArgument(t1, e1), n1 = p1.default.GetArgCount(t1, e1), o1 = t1.GetBrackets(e1), i1 = t1.GetArgument(e1);
                    p1.default.addMacro(t1, r1, h1.Macro, [
                        i1,
                        n1,
                        o1
                    ]);
                },
                NewEnvironment: function(t1, e1) {
                    var r1 = u1.default.trimSpaces(t1.GetArgument(e1)), n1 = p1.default.GetArgCount(t1, e1), o1 = t1.GetBrackets(e1), i1 = t1.GetArgument(e1), s1 = t1.GetArgument(e1);
                    p1.default.addEnvironment(t1, r1, h1.BeginEnv, [
                        !0,
                        i1,
                        s1,
                        n1,
                        o1
                    ]);
                },
                MacroDef: function(t1, e1) {
                    var r1 = p1.default.GetCSname(t1, e1), n1 = p1.default.GetTemplate(t1, e1, "\\" + r1), o1 = t1.GetArgument(e1);
                    n1 instanceof Array ? p1.default.addMacro(t1, r1, h1.MacroWithTemplate, [
                        o1
                    ].concat(n1)) : p1.default.addMacro(t1, r1, h1.Macro, [
                        o1,
                        n1
                    ]);
                },
                Let: function(t1, e1) {
                    var r1 = p1.default.GetCSname(t1, e1), n1 = t1.GetNext();
                    "=" === n1 && (t1.i++, n1 = t1.GetNext());
                    var o1 = t1.configuration.handlers;
                    if ("\\" !== n1) {
                        t1.i++;
                        var i1 = o1.get("delimiter").lookup(n1);
                        i1 ? p1.default.addDelimiter(t1, "\\" + r1, i1.char, i1.attributes) : p1.default.addMacro(t1, r1, h1.Macro, [
                            n1
                        ]);
                    } else {
                        e1 = p1.default.GetCSname(t1, e1);
                        var s1 = o1.get("delimiter").lookup("\\" + e1);
                        if (s1) return void p1.default.addDelimiter(t1, "\\" + r1, s1.char, s1.attributes);
                        var a1 = o1.get("macro").applicable(e1);
                        if (!a1) return;
                        if (a1 instanceof l1.MacroMap) {
                            var c1 = a1.lookup(e1);
                            return void p1.default.addMacro(t1, r1, c1.func, c1.args, c1.symbol);
                        }
                        s1 = a1.lookup(e1);
                        var u1 = p1.default.disassembleSymbol(r1, s1);
                        p1.default.addMacro(t1, r1, function(t1, e1) {
                            for(var r1 = [], n1 = 2; n1 < arguments.length; n1++)r1[n1 - 2] = arguments[n1];
                            var o1 = p1.default.assembleSymbol(r1);
                            return a1.parser(t1, o1);
                        }, u1);
                    }
                },
                MacroWithTemplate: function(t1, e1, r1, n1) {
                    for(var o1 = [], i1 = 4; i1 < arguments.length; i1++)o1[i1 - 4] = arguments[i1];
                    var s1 = parseInt(n1, 10);
                    if (s1) {
                        var l1 = [];
                        if (t1.GetNext(), o1[0] && !p1.default.MatchParam(t1, o1[0])) throw new a1.default("MismatchUseDef", "Use of %1 doesn't match its definition", e1);
                        for(var c1 = 0; c1 < s1; c1++)l1.push(p1.default.GetParameter(t1, e1, o1[c1 + 1]));
                        r1 = u1.default.substituteArgs(t1, l1, r1);
                    }
                    t1.string = u1.default.addArgs(t1, r1, t1.string.slice(t1.i)), t1.i = 0, u1.default.checkMaxMacros(t1);
                },
                BeginEnv: function(t1, e1, r1, n1, o1, i1) {
                    if (e1.getProperty("end") && t1.stack.env.closing === e1.getName()) {
                        delete t1.stack.env.closing;
                        var s1 = t1.string.slice(t1.i);
                        return t1.string = n1, t1.i = 0, t1.Parse(), t1.string = s1, t1.i = 0, t1.itemFactory.create("end").setProperty("name", e1.getName());
                    }
                    if (o1) {
                        var a1 = [];
                        if (null != i1) {
                            var l1 = t1.GetBrackets("\\begin{" + e1.getName() + "}");
                            a1.push(null == l1 ? i1 : l1);
                        }
                        for(var c1 = a1.length; c1 < o1; c1++)a1.push(t1.GetArgument("\\begin{" + e1.getName() + "}"));
                        r1 = u1.default.substituteArgs(t1, a1, r1), n1 = u1.default.substituteArgs(t1, [], n1);
                    }
                    return t1.string = u1.default.addArgs(t1, r1, t1.string.slice(t1.i)), t1.i = 0, t1.itemFactory.create("beginEnv").setProperty("name", e1.getName());
                }
            };
            h1.Macro = c1.default.Macro, e1.default = h1;
        },
        5579: function(t1, e1, r1) {
            var n1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var o1, i1 = n1(r1(1130)), s1 = n1(r1(3971)), a1 = r1(8803);
            !function(t1) {
                function e1(t1, e1) {
                    return t1.string.substr(t1.i, e1.length) !== e1 || e1.match(/\\[a-z]+$/i) && t1.string.charAt(t1.i + e1.length).match(/[a-z]/i) ? 0 : (t1.i += e1.length, 1);
                }
                t1.disassembleSymbol = function(t1, e1) {
                    var r1 = [
                        t1,
                        e1.char
                    ];
                    if (e1.attributes) for(var n1 in e1.attributes)r1.push(n1), r1.push(e1.attributes[n1]);
                    return r1;
                }, t1.assembleSymbol = function(t1) {
                    for(var e1 = t1[0], r1 = t1[1], n1 = {}, o1 = 2; o1 < t1.length; o1 += 2)n1[t1[o1]] = t1[o1 + 1];
                    return new a1.Symbol(e1, r1, n1);
                }, t1.GetCSname = function(t1, e1) {
                    if ("\\" !== t1.GetNext()) throw new s1.default("MissingCS", "%1 must be followed by a control sequence", e1);
                    return i1.default.trimSpaces(t1.GetArgument(e1)).substr(1);
                }, t1.GetCsNameArgument = function(t1, e1) {
                    var r1 = i1.default.trimSpaces(t1.GetArgument(e1));
                    if ("\\" === r1.charAt(0) && (r1 = r1.substr(1)), !r1.match(/^(.|[a-z]+)$/i)) throw new s1.default("IllegalControlSequenceName", "Illegal control sequence name for %1", e1);
                    return r1;
                }, t1.GetArgCount = function(t1, e1) {
                    var r1 = t1.GetBrackets(e1);
                    if (r1 && !(r1 = i1.default.trimSpaces(r1)).match(/^[0-9]+$/)) throw new s1.default("IllegalParamNumber", "Illegal number of parameters specified in %1", e1);
                    return r1;
                }, t1.GetTemplate = function(t1, e1, r1) {
                    for(var n1 = t1.GetNext(), o1 = [], i1 = 0, a1 = t1.i; t1.i < t1.string.length;){
                        if ("#" === (n1 = t1.GetNext())) {
                            if (a1 !== t1.i && (o1[i1] = t1.string.substr(a1, t1.i - a1)), !(n1 = t1.string.charAt(++t1.i)).match(/^[1-9]$/)) throw new s1.default("CantUseHash2", "Illegal use of # in template for %1", r1);
                            if (parseInt(n1) !== ++i1) throw new s1.default("SequentialParam", "Parameters for %1 must be numbered sequentially", r1);
                            a1 = t1.i + 1;
                        } else if ("{" === n1) return a1 !== t1.i && (o1[i1] = t1.string.substr(a1, t1.i - a1)), o1.length > 0 ? [
                            i1.toString()
                        ].concat(o1) : i1;
                        t1.i++;
                    }
                    throw new s1.default("MissingReplacementString", "Missing replacement string for definition of %1", e1);
                }, t1.GetParameter = function(t1, r1, n1) {
                    if (null == n1) return t1.GetArgument(r1);
                    for(var o1 = t1.i, i1 = 0, a1 = 0; t1.i < t1.string.length;){
                        var l1 = t1.string.charAt(t1.i);
                        if ("{" === l1) t1.i === o1 && (a1 = 1), t1.GetArgument(r1), i1 = t1.i - o1;
                        else {
                            if (e1(t1, n1)) return a1 && (o1++, i1 -= 2), t1.string.substr(o1, i1);
                            if ("\\" === l1) {
                                t1.i++, i1++, a1 = 0;
                                var c1 = t1.string.substr(t1.i).match(/[a-z]+|./i);
                                c1 && (t1.i += c1[0].length, i1 = t1.i - o1);
                            } else t1.i++, i1++, a1 = 0;
                        }
                    }
                    throw new s1.default("RunawayArgument", "Runaway argument for %1?", r1);
                }, t1.MatchParam = e1, t1.addDelimiter = function(e1, r1, n1, o1) {
                    e1.configuration.handlers.retrieve(t1.NEW_DELIMITER).add(r1, new a1.Symbol(r1, n1, o1));
                }, t1.addMacro = function(e1, r1, n1, o1, i1) {
                    void 0 === i1 && (i1 = ""), e1.configuration.handlers.retrieve(t1.NEW_COMMAND).add(r1, new a1.Macro(i1 || r1, n1, o1));
                }, t1.addEnvironment = function(e1, r1, n1, o1) {
                    e1.configuration.handlers.retrieve(t1.NEW_ENVIRONMENT).add(r1, new a1.Macro(r1, n1, o1));
                }, t1.NEW_DELIMITER = "new-Delimiter", t1.NEW_COMMAND = "new-Command", t1.NEW_ENVIRONMENT = "new-Environment";
            }(o1 || (o1 = {})), e1.default = o1;
        },
        4898: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.NoUndefinedConfiguration = void 0;
            var o1 = r1(9899);
            e1.NoUndefinedConfiguration = o1.Configuration.create("noundefined", {
                fallback: {
                    macro: function(t1, e1) {
                        var r1, o1, i1 = t1.create("text", "\\" + e1), s1 = t1.options.noundefined || {}, a1 = {};
                        try {
                            for(var l1 = n1([
                                "color",
                                "background",
                                "size"
                            ]), c1 = l1.next(); !c1.done; c1 = l1.next()){
                                var u1 = c1.value;
                                s1[u1] && (a1["math" + u1] = s1[u1]);
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                c1 && !c1.done && (o1 = l1.return) && o1.call(l1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                        t1.Push(t1.create("node", "mtext", [], a1, i1));
                    }
                },
                options: {
                    noundefined: {
                        color: "red",
                        background: "",
                        size: ""
                    }
                },
                priority: 3
            });
        },
        7741: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, s1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.RequireConfiguration = e1.options = e1.RequireMethods = e1.RequireLoad = void 0;
            var a1 = r1(9899), l1 = r1(9140), c1 = s1(r1(3971)), u1 = r1(9515), p1 = r1(265), h1 = r1(235), f1 = r1(5713), d1 = r1(7233), m1 = u1.MathJax.config;
            function y1(t1, e1) {
                var r1, o1 = t1.parseOptions.options.require, i1 = t1.parseOptions.packageData.get("require").required, s1 = e1.substr(o1.prefix.length);
                if (i1.indexOf(s1) < 0) {
                    i1.push(s1), function(t1, e1) {
                        var r1, o1;
                        void 0 === e1 && (e1 = []);
                        var i1 = t1.parseOptions.options.require.prefix;
                        try {
                            for(var s1 = n1(e1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                                var l1 = a1.value;
                                l1.substr(0, i1.length) === i1 && y1(t1, l1);
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                    }(t1, h1.CONFIG.dependencies[e1]);
                    var l1 = a1.ConfigurationHandler.get(s1);
                    if (l1) {
                        var c1 = m1[e1] || {};
                        l1.options && 1 === Object.keys(l1.options).length && l1.options[s1] && ((r1 = {})[s1] = c1, c1 = r1), t1.configuration.add(s1, t1, c1);
                        var u1 = t1.parseOptions.packageData.get("require").configured;
                        l1.preprocessors.length && !u1.has(s1) && (u1.set(s1, !0), f1.mathjax.retryAfter(Promise.resolve()));
                    }
                }
            }
            function g1(t1, e1) {
                var r1 = t1.options.require, n1 = r1.allow, o1 = ("[" === e1.substr(0, 1) ? "" : r1.prefix) + e1;
                if (!(n1.hasOwnProperty(o1) ? n1[o1] : n1.hasOwnProperty(e1) ? n1[e1] : r1.defaultAllow)) throw new c1.default("BadRequire", 'Extension "%1" is not allowed to be loaded', o1);
                p1.Package.packages.has(o1) ? y1(t1.configuration.packageData.get("require").jax, o1) : f1.mathjax.retryAfter(h1.Loader.load(o1));
            }
            e1.RequireLoad = g1, e1.RequireMethods = {
                Require: function(t1, e1) {
                    var r1 = t1.GetArgument(e1);
                    if (r1.match(/[^_a-zA-Z0-9]/) || "" === r1) throw new c1.default("BadPackageName", "Argument for %1 is not a valid package name", e1);
                    g1(t1, r1);
                }
            }, e1.options = {
                require: {
                    allow: (0, d1.expandable)({
                        base: !1,
                        "all-packages": !1,
                        autoload: !1,
                        configmacros: !1,
                        tagformat: !1,
                        setoptions: !1
                    }),
                    defaultAllow: !0,
                    prefix: "tex"
                }
            }, new l1.CommandMap("require", {
                require: "Require"
            }, e1.RequireMethods), e1.RequireConfiguration = a1.Configuration.create("require", {
                handler: {
                    macro: [
                        "require"
                    ]
                },
                config: function(t1, e1) {
                    e1.parseOptions.packageData.set("require", {
                        jax: e1,
                        required: i1([], o1(e1.options.packages), !1),
                        configured: new Map
                    });
                    var r1 = e1.parseOptions.options.require, n1 = r1.prefix;
                    if (n1.match(/[^_a-zA-Z0-9]/)) throw Error("Illegal characters used in \\require prefix");
                    h1.CONFIG.paths[n1] || (h1.CONFIG.paths[n1] = "[mathjax]/input/tex/extensions"), r1.prefix = "[" + n1 + "]/";
                },
                options: e1.options
            });
        },
        5713: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.mathjax = void 0;
            var n1 = r1(3282), o1 = r1(805), i1 = r1(4542);
            e1.mathjax = {
                version: n1.VERSION,
                handlers: new o1.HandlerList,
                document: function(t1, r1) {
                    return e1.mathjax.handlers.document(t1, r1);
                },
                handleRetriesFor: i1.handleRetriesFor,
                retryAfter: i1.retryAfter,
                asyncLoad: null
            };
        },
        50: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), a1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), l1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && s1(e1, t1, r1);
                return a1(e1, t1), e1;
            }, c1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTML = void 0;
            var u1 = r1(3055), p1 = r1(4139), h1 = r1(9261), f1 = r1(6797), d1 = r1(2760), m1 = l1(r1(6010)), y1 = r1(505), g1 = function(t1) {
                function e1(e1) {
                    void 0 === e1 && (e1 = null);
                    var r1 = t1.call(this, e1, h1.CHTMLWrapperFactory, d1.TeXFont) || this;
                    return r1.chtmlStyles = null, r1.font.adaptiveCSS(r1.options.adaptiveCSS), r1.wrapperUsage = new f1.Usage, r1;
                }
                return o1(e1, t1), e1.prototype.escaped = function(t1, e1) {
                    return this.setDocument(e1), this.html("span", {}, [
                        this.text(t1.math)
                    ]);
                }, e1.prototype.styleSheet = function(r1) {
                    if (this.chtmlStyles) {
                        if (this.options.adaptiveCSS) {
                            var n1 = new p1.CssStyles;
                            this.addWrapperStyles(n1), this.updateFontStyles(n1), this.adaptor.insertRules(this.chtmlStyles, n1.getStyleRules());
                        }
                        return this.chtmlStyles;
                    }
                    var o1 = this.chtmlStyles = t1.prototype.styleSheet.call(this, r1);
                    return this.adaptor.setAttribute(o1, "id", e1.STYLESHEETID), this.wrapperUsage.update(), o1;
                }, e1.prototype.updateFontStyles = function(t1) {
                    t1.addStyles(this.font.updateStyles({}));
                }, e1.prototype.addWrapperStyles = function(e1) {
                    var r1, n1;
                    if (this.options.adaptiveCSS) try {
                        for(var o1 = c1(this.wrapperUsage.update()), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value, a1 = this.factory.getNodeClass(s1);
                            a1 && this.addClassStyles(a1, e1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    else t1.prototype.addWrapperStyles.call(this, e1);
                }, e1.prototype.addClassStyles = function(e1, r1) {
                    var n1, o1 = e1;
                    o1.autoStyle && "unknown" !== o1.kind && r1.addStyles(((n1 = {})["mjx-" + o1.kind] = {
                        display: "inline-block",
                        "text-align": "left"
                    }, n1)), this.wrapperUsage.add(o1.kind), t1.prototype.addClassStyles.call(this, e1, r1);
                }, e1.prototype.processMath = function(t1, e1) {
                    this.factory.wrap(t1).toCHTML(e1);
                }, e1.prototype.clearCache = function() {
                    this.cssStyles.clear(), this.font.clearCache(), this.wrapperUsage.clear(), this.chtmlStyles = null;
                }, e1.prototype.reset = function() {
                    this.clearCache();
                }, e1.prototype.unknownText = function(t1, e1, r1) {
                    void 0 === r1 && (r1 = null);
                    var n1 = {}, o1 = 100 / this.math.metrics.scale;
                    if (100 !== o1 && (n1["font-size"] = this.fixed(o1, 1) + "%", n1.padding = m1.em(75 / o1) + " 0 " + m1.em(20 / o1) + " 0"), "-explicitFont" !== e1) {
                        var i1 = (0, y1.unicodeChars)(t1);
                        (1 !== i1.length || i1[0] < 119808 || i1[0] > 120831) && this.cssFontStyles(this.font.getCssFont(e1), n1);
                    }
                    if (null !== r1) {
                        var s1 = this.math.metrics;
                        n1.width = Math.round(r1 * s1.em * s1.scale) + "px";
                    }
                    return this.html("mjx-utext", {
                        variant: e1,
                        style: n1
                    }, [
                        this.text(t1)
                    ]);
                }, e1.prototype.measureTextNode = function(t1) {
                    var e1 = this.adaptor, r1 = e1.clone(t1);
                    e1.setStyle(r1, "font-family", e1.getStyle(r1, "font-family").replace(/MJXZERO, /g, ""));
                    var n1 = this.html("mjx-measure-text", {
                        style: {
                            position: "absolute",
                            "white-space": "nowrap"
                        }
                    }, [
                        r1
                    ]);
                    e1.append(e1.parent(this.math.start.node), this.container), e1.append(this.container, n1);
                    var o1 = e1.nodeSize(r1, this.math.metrics.em)[0] / this.math.metrics.scale;
                    return e1.remove(this.container), e1.remove(n1), {
                        w: o1,
                        h: .75,
                        d: .2
                    };
                }, e1.NAME = "CHTML", e1.OPTIONS = i1(i1({}, u1.CommonOutputJax.OPTIONS), {
                    adaptiveCSS: !0,
                    matchFontHeight: !0
                }), e1.commonStyles = {
                    'mjx-container[jax="CHTML"]': {
                        "line-height": 0
                    },
                    'mjx-container [space="1"]': {
                        "margin-left": ".111em"
                    },
                    'mjx-container [space="2"]': {
                        "margin-left": ".167em"
                    },
                    'mjx-container [space="3"]': {
                        "margin-left": ".222em"
                    },
                    'mjx-container [space="4"]': {
                        "margin-left": ".278em"
                    },
                    'mjx-container [space="5"]': {
                        "margin-left": ".333em"
                    },
                    'mjx-container [rspace="1"]': {
                        "margin-right": ".111em"
                    },
                    'mjx-container [rspace="2"]': {
                        "margin-right": ".167em"
                    },
                    'mjx-container [rspace="3"]': {
                        "margin-right": ".222em"
                    },
                    'mjx-container [rspace="4"]': {
                        "margin-right": ".278em"
                    },
                    'mjx-container [rspace="5"]': {
                        "margin-right": ".333em"
                    },
                    'mjx-container [size="s"]': {
                        "font-size": "70.7%"
                    },
                    'mjx-container [size="ss"]': {
                        "font-size": "50%"
                    },
                    'mjx-container [size="Tn"]': {
                        "font-size": "60%"
                    },
                    'mjx-container [size="sm"]': {
                        "font-size": "85%"
                    },
                    'mjx-container [size="lg"]': {
                        "font-size": "120%"
                    },
                    'mjx-container [size="Lg"]': {
                        "font-size": "144%"
                    },
                    'mjx-container [size="LG"]': {
                        "font-size": "173%"
                    },
                    'mjx-container [size="hg"]': {
                        "font-size": "207%"
                    },
                    'mjx-container [size="HG"]': {
                        "font-size": "249%"
                    },
                    'mjx-container [width="full"]': {
                        width: "100%"
                    },
                    "mjx-box": {
                        display: "inline-block"
                    },
                    "mjx-block": {
                        display: "block"
                    },
                    "mjx-itable": {
                        display: "inline-table"
                    },
                    "mjx-row": {
                        display: "table-row"
                    },
                    "mjx-row > *": {
                        display: "table-cell"
                    },
                    "mjx-mtext": {
                        display: "inline-block"
                    },
                    "mjx-mstyle": {
                        display: "inline-block"
                    },
                    "mjx-merror": {
                        display: "inline-block",
                        color: "red",
                        "background-color": "yellow"
                    },
                    "mjx-mphantom": {
                        visibility: "hidden"
                    },
                    "_::-webkit-full-page-media, _:future, :root mjx-container": {
                        "will-change": "opacity"
                    }
                }, e1.STYLESHEETID = "MJX-CHTML-styles", e1;
            }(u1.CommonOutputJax);
            e1.CHTML = g1;
        },
        8042: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), a1 = this && this.__exportStar || function(t1, e1) {
                for(var r1 in t1)"default" === r1 || Object.prototype.hasOwnProperty.call(e1, r1) || s1(e1, t1, r1);
            }, l1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, c1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AddCSS = e1.CHTMLFontData = void 0;
            var u1 = r1(5884), p1 = r1(6797), h1 = r1(6010);
            a1(r1(5884), e1);
            var f1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.charUsage = new p1.Usage, e1.delimUsage = new p1.Usage, e1;
                }
                return o1(e1, t1), e1.charOptions = function(e1, r1) {
                    return t1.charOptions.call(this, e1, r1);
                }, e1.prototype.adaptiveCSS = function(t1) {
                    this.options.adaptiveCSS = t1;
                }, e1.prototype.clearCache = function() {
                    this.options.adaptiveCSS && (this.charUsage.clear(), this.delimUsage.clear());
                }, e1.prototype.createVariant = function(e1, r1, n1) {
                    void 0 === r1 && (r1 = null), void 0 === n1 && (n1 = null), t1.prototype.createVariant.call(this, e1, r1, n1);
                    var o1 = this.constructor;
                    this.variant[e1].classes = o1.defaultVariantClasses[e1], this.variant[e1].letter = o1.defaultVariantLetters[e1];
                }, e1.prototype.defineChars = function(r1, n1) {
                    var o1, i1;
                    t1.prototype.defineChars.call(this, r1, n1);
                    var s1 = this.variant[r1].letter;
                    try {
                        for(var a1 = l1(Object.keys(n1)), c1 = a1.next(); !c1.done; c1 = a1.next()){
                            var u1 = c1.value, p1 = e1.charOptions(n1, parseInt(u1));
                            void 0 === p1.f && (p1.f = s1);
                        }
                    } catch (t1) {
                        o1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (i1 = a1.return) && i1.call(a1);
                        } finally{
                            if (o1) throw o1.error;
                        }
                    }
                }, Object.defineProperty(e1.prototype, "styles", {
                    get: function() {
                        var t1 = this.constructor, e1 = i1({}, t1.defaultStyles);
                        return this.addFontURLs(e1, t1.defaultFonts, this.options.fontURL), this.options.adaptiveCSS ? this.updateStyles(e1) : this.allStyles(e1), e1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.updateStyles = function(t1) {
                    var e1, r1, n1, o1;
                    try {
                        for(var i1 = l1(this.delimUsage.update()), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value;
                            this.addDelimiterStyles(t1, a1, this.delimiters[a1]);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    try {
                        for(var u1 = l1(this.charUsage.update()), p1 = u1.next(); !p1.done; p1 = u1.next()){
                            var h1 = c1(p1.value, 2), f1 = h1[0], d1 = (a1 = h1[1], this.variant[f1]);
                            this.addCharStyles(t1, d1.letter, a1, d1.chars[a1]);
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            p1 && !p1.done && (o1 = u1.return) && o1.call(u1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                    return t1;
                }, e1.prototype.allStyles = function(t1) {
                    var e1, r1, n1, o1, i1, s1;
                    try {
                        for(var a1 = l1(Object.keys(this.delimiters)), c1 = a1.next(); !c1.done; c1 = a1.next()){
                            var u1 = c1.value, p1 = parseInt(u1);
                            this.addDelimiterStyles(t1, p1, this.delimiters[p1]);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (r1 = a1.return) && r1.call(a1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    try {
                        for(var h1 = l1(Object.keys(this.variant)), f1 = h1.next(); !f1.done; f1 = h1.next()){
                            var d1 = f1.value, m1 = this.variant[d1], y1 = m1.letter;
                            try {
                                for(var g1 = (i1 = void 0, l1(Object.keys(m1.chars))), b1 = g1.next(); !b1.done; b1 = g1.next()){
                                    u1 = b1.value, p1 = parseInt(u1);
                                    var v1 = m1.chars[p1];
                                    (v1[3] || {}).smp || (v1.length < 4 && (v1[3] = {}), this.addCharStyles(t1, y1, p1, v1));
                                }
                            } catch (t1) {
                                i1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    b1 && !b1.done && (s1 = g1.return) && s1.call(g1);
                                } finally{
                                    if (i1) throw i1.error;
                                }
                            }
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            f1 && !f1.done && (o1 = h1.return) && o1.call(h1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }, e1.prototype.addFontURLs = function(t1, e1, r1) {
                    var n1, o1;
                    try {
                        for(var s1 = l1(Object.keys(e1)), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var c1 = a1.value, u1 = i1({}, e1[c1]);
                            u1.src = u1.src.replace(/%%URL%%/, r1), t1[c1] = u1;
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }, e1.prototype.addDelimiterStyles = function(t1, e1, r1) {
                    var n1 = this.charSelector(e1);
                    r1.c && r1.c !== e1 && (t1[".mjx-stretched mjx-c" + (n1 = this.charSelector(r1.c)) + "::before"] = {
                        content: this.charContent(r1.c)
                    }), r1.stretch && (1 === r1.dir ? this.addDelimiterVStyles(t1, n1, r1) : this.addDelimiterHStyles(t1, n1, r1));
                }, e1.prototype.addDelimiterVStyles = function(t1, e1, r1) {
                    var n1 = r1.HDW, o1 = c1(r1.stretch, 4), i1 = o1[0], s1 = o1[1], a1 = o1[2], l1 = o1[3], u1 = this.addDelimiterVPart(t1, e1, "beg", i1, n1);
                    this.addDelimiterVPart(t1, e1, "ext", s1, n1);
                    var p1 = this.addDelimiterVPart(t1, e1, "end", a1, n1), h1 = {};
                    if (l1) {
                        var f1 = this.addDelimiterVPart(t1, e1, "mid", l1, n1);
                        h1.height = "50%", t1["mjx-stretchy-v" + e1 + " > mjx-mid"] = {
                            "margin-top": this.em(-f1 / 2),
                            "margin-bottom": this.em(-f1 / 2)
                        };
                    }
                    u1 && (h1["border-top-width"] = this.em0(u1 - .03)), p1 && (h1["border-bottom-width"] = this.em0(p1 - .03), t1["mjx-stretchy-v" + e1 + " > mjx-end"] = {
                        "margin-top": this.em(-p1)
                    }), Object.keys(h1).length && (t1["mjx-stretchy-v" + e1 + " > mjx-ext"] = h1);
                }, e1.prototype.addDelimiterVPart = function(t1, e1, r1, n1, o1) {
                    if (!n1) return 0;
                    var i1 = this.getDelimiterData(n1), s1 = (o1[2] - i1[2]) / 2, a1 = {
                        content: this.charContent(n1)
                    };
                    return "ext" !== r1 ? a1.padding = this.padding(i1, s1) : (a1.width = this.em0(o1[2]), s1 && (a1["padding-left"] = this.em0(s1))), t1["mjx-stretchy-v" + e1 + " mjx-" + r1 + " mjx-c::before"] = a1, i1[0] + i1[1];
                }, e1.prototype.addDelimiterHStyles = function(t1, e1, r1) {
                    var n1 = c1(r1.stretch, 4), o1 = n1[0], i1 = n1[1], s1 = n1[2], a1 = n1[3], l1 = r1.HDW;
                    this.addDelimiterHPart(t1, e1, "beg", o1, l1), this.addDelimiterHPart(t1, e1, "ext", i1, l1), this.addDelimiterHPart(t1, e1, "end", s1, l1), a1 && (this.addDelimiterHPart(t1, e1, "mid", a1, l1), t1["mjx-stretchy-h" + e1 + " > mjx-ext"] = {
                        width: "50%"
                    });
                }, e1.prototype.addDelimiterHPart = function(t1, e1, r1, n1, o1) {
                    if (n1) {
                        var i1 = this.getDelimiterData(n1)[3], s1 = {
                            content: i1 && i1.c ? '"' + i1.c + '"' : this.charContent(n1)
                        };
                        s1.padding = this.padding(o1, 0, -o1[2]), t1["mjx-stretchy-h" + e1 + " mjx-" + r1 + " mjx-c::before"] = s1;
                    }
                }, e1.prototype.addCharStyles = function(t1, e1, r1, n1) {
                    var o1 = n1[3], i1 = void 0 !== o1.f ? o1.f : e1;
                    t1["mjx-c" + this.charSelector(r1) + (i1 ? ".TEX-" + i1 : "") + "::before"] = {
                        padding: this.padding(n1, 0, o1.ic || 0),
                        content: null != o1.c ? '"' + o1.c + '"' : this.charContent(r1)
                    };
                }, e1.prototype.getDelimiterData = function(t1) {
                    return this.getChar("-smallop", t1);
                }, e1.prototype.em = function(t1) {
                    return (0, h1.em)(t1);
                }, e1.prototype.em0 = function(t1) {
                    return (0, h1.em)(Math.max(0, t1));
                }, e1.prototype.padding = function(t1, e1, r1) {
                    var n1 = c1(t1, 3), o1 = n1[0], i1 = n1[1];
                    return void 0 === e1 && (e1 = 0), void 0 === r1 && (r1 = 0), [
                        o1,
                        n1[2] + r1,
                        i1,
                        e1
                    ].map(this.em0).join(" ");
                }, e1.prototype.charContent = function(t1) {
                    return '"' + (t1 >= 32 && t1 <= 126 && 34 !== t1 && 39 !== t1 && 92 !== t1 ? String.fromCharCode(t1) : "\\" + t1.toString(16).toUpperCase()) + '"';
                }, e1.prototype.charSelector = function(t1) {
                    return ".mjx-c" + t1.toString(16).toUpperCase();
                }, e1.OPTIONS = i1(i1({}, u1.FontData.OPTIONS), {
                    fontURL: "js/output/chtml/fonts/tex-woff-v2"
                }), e1.JAX = "CHTML", e1.defaultVariantClasses = {}, e1.defaultVariantLetters = {}, e1.defaultStyles = {
                    "mjx-c::before": {
                        display: "block",
                        width: 0
                    }
                }, e1.defaultFonts = {
                    "@font-face /* 0 */": {
                        "font-family": "MJXZERO",
                        src: 'url("%%URL%%/MathJax_Zero.woff") format("woff")'
                    }
                }, e1;
            }(u1.FontData);
            e1.CHTMLFontData = f1, e1.AddCSS = function(t1, e1) {
                var r1, n1;
                try {
                    for(var o1 = l1(Object.keys(e1)), i1 = o1.next(); !i1.done; i1 = o1.next()){
                        var s1 = i1.value, a1 = parseInt(s1);
                        Object.assign(u1.FontData.charOptions(t1, a1), e1[a1]);
                    }
                } catch (t1) {
                    r1 = {
                        error: t1
                    };
                } finally{
                    try {
                        i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                    } finally{
                        if (r1) throw r1.error;
                    }
                }
                return t1;
            };
        },
        8270: function(t1, e1, r1) {
            var n1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), o1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), i1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && n1(e1, t1, r1);
                return o1(e1, t1), e1;
            }, s1 = this && this.__exportStar || function(t1, e1) {
                for(var r1 in t1)"default" === r1 || Object.prototype.hasOwnProperty.call(e1, r1) || n1(e1, t1, r1);
            }, a1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Arrow = e1.DiagonalArrow = e1.DiagonalStrike = e1.Border2 = e1.Border = e1.RenderElement = void 0;
            var l1 = i1(r1(5552));
            s1(r1(5552), e1);
            e1.RenderElement = function(t1, e1) {
                return void 0 === e1 && (e1 = ""), function(r1, n1) {
                    var o1 = r1.adjustBorder(r1.html("mjx-" + t1));
                    if (e1) {
                        var i1 = r1.getOffset(e1);
                        if (r1.thickness !== l1.THICKNESS || i1) {
                            var s1 = "translate".concat(e1, "(").concat(r1.em(r1.thickness / 2 - i1), ")");
                            r1.adaptor.setStyle(o1, "transform", s1);
                        }
                    }
                    r1.adaptor.append(r1.chtml, o1);
                };
            };
            e1.Border = function(t1) {
                return l1.CommonBorder(function(e1, r1) {
                    e1.adaptor.setStyle(r1, "border-" + t1, e1.em(e1.thickness) + " solid");
                })(t1);
            };
            e1.Border2 = function(t1, e1, r1) {
                return l1.CommonBorder2(function(t1, n1) {
                    var o1 = t1.em(t1.thickness) + " solid";
                    t1.adaptor.setStyle(n1, "border-" + e1, o1), t1.adaptor.setStyle(n1, "border-" + r1, o1);
                })(t1, e1, r1);
            };
            e1.DiagonalStrike = function(t1, e1) {
                return l1.CommonDiagonalStrike(function(t1) {
                    return function(r1, n1) {
                        var o1 = r1.getBBox(), i1 = o1.w, s1 = o1.h, l1 = o1.d, c1 = a1(r1.getArgMod(i1, s1 + l1), 2), u1 = c1[0], p1 = c1[1], h1 = e1 * r1.thickness / 2, f1 = r1.adjustBorder(r1.html(t1, {
                            style: {
                                width: r1.em(p1),
                                transform: "rotate(" + r1.fixed(-e1 * u1) + "rad) translateY(" + h1 + "em)"
                            }
                        }));
                        r1.adaptor.append(r1.chtml, f1);
                    };
                })(t1);
            };
            e1.DiagonalArrow = function(t1) {
                return l1.CommonDiagonalArrow(function(t1, e1) {
                    t1.adaptor.append(t1.chtml, e1);
                })(t1);
            };
            e1.Arrow = function(t1) {
                return l1.CommonArrow(function(t1, e1) {
                    t1.adaptor.append(t1.chtml, e1);
                })(t1);
            };
        },
        6797: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Usage = void 0;
            var r1 = function() {
                function t1() {
                    this.used = new Set, this.needsUpdate = [];
                }
                return t1.prototype.add = function(t1) {
                    var e1 = JSON.stringify(t1);
                    this.used.has(e1) || this.needsUpdate.push(t1), this.used.add(e1);
                }, t1.prototype.has = function(t1) {
                    return this.used.has(JSON.stringify(t1));
                }, t1.prototype.clear = function() {
                    this.used.clear(), this.needsUpdate = [];
                }, t1.prototype.update = function() {
                    var t1 = this.needsUpdate;
                    return this.needsUpdate = [], t1;
                }, t1;
            }();
            e1.Usage = r1;
        },
        5355: function(t1, e1, r1) {
            var n1, o1, i1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), s1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), a1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), l1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && s1(e1, t1, r1);
                return a1(e1, t1), e1;
            }, c1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, u1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLWrapper = e1.SPACE = e1.FONTSIZE = void 0;
            var p1 = l1(r1(6010)), h1 = r1(7519), f1 = r1(6469);
            e1.FONTSIZE = {
                "70.7%": "s",
                "70%": "s",
                "50%": "ss",
                "60%": "Tn",
                "85%": "sm",
                "120%": "lg",
                "144%": "Lg",
                "173%": "LG",
                "207%": "hg",
                "249%": "HG"
            }, e1.SPACE = ((o1 = {})[p1.em(2 / 18)] = "1", o1[p1.em(3 / 18)] = "2", o1[p1.em(4 / 18)] = "3", o1[p1.em(5 / 18)] = "4", o1[p1.em(6 / 18)] = "5", o1);
            var d1 = function(t1) {
                function r1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.chtml = null, e1;
                }
                return i1(r1, t1), r1.prototype.toCHTML = function(t1) {
                    var e1, r1, n1 = this.standardCHTMLnode(t1);
                    try {
                        for(var o1 = c1(this.childNodes), i1 = o1.next(); !i1.done; i1 = o1.next())i1.value.toCHTML(n1);
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, r1.prototype.standardCHTMLnode = function(t1) {
                    this.markUsed();
                    var e1 = this.createCHTMLnode(t1);
                    return this.handleStyles(), this.handleVariant(), this.handleScale(), this.handleColor(), this.handleSpace(), this.handleAttributes(), this.handlePWidth(), e1;
                }, r1.prototype.markUsed = function() {
                    this.jax.wrapperUsage.add(this.kind);
                }, r1.prototype.createCHTMLnode = function(t1) {
                    var e1 = this.node.attributes.get("href");
                    return e1 && (t1 = this.adaptor.append(t1, this.html("a", {
                        href: e1
                    }))), this.chtml = this.adaptor.append(t1, this.html("mjx-" + this.node.kind)), this.chtml;
                }, r1.prototype.handleStyles = function() {
                    if (this.styles) {
                        var t1 = this.styles.cssText;
                        if (t1) {
                            this.adaptor.setAttribute(this.chtml, "style", t1);
                            var e1 = this.styles.get("font-family");
                            e1 && this.adaptor.setStyle(this.chtml, "font-family", "MJXZERO, " + e1);
                        }
                    }
                }, r1.prototype.handleVariant = function() {
                    this.node.isToken && "-explicitFont" !== this.variant && this.adaptor.setAttribute(this.chtml, "class", (this.font.getVariant(this.variant) || this.font.getVariant("normal")).classes);
                }, r1.prototype.handleScale = function() {
                    this.setScale(this.chtml, this.bbox.rscale);
                }, r1.prototype.setScale = function(t1, r1) {
                    var n1 = Math.abs(r1 - 1) < .001 ? 1 : r1;
                    if (t1 && 1 !== n1) {
                        var o1 = this.percent(n1);
                        e1.FONTSIZE[o1] ? this.adaptor.setAttribute(t1, "size", e1.FONTSIZE[o1]) : this.adaptor.setStyle(t1, "fontSize", o1);
                    }
                    return t1;
                }, r1.prototype.handleSpace = function() {
                    var t1, r1;
                    try {
                        for(var n1 = c1([
                            [
                                this.bbox.L,
                                "space",
                                "marginLeft"
                            ],
                            [
                                this.bbox.R,
                                "rspace",
                                "marginRight"
                            ]
                        ]), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value, s1 = u1(i1, 3), a1 = s1[0], l1 = s1[1], p1 = s1[2];
                            if (a1) {
                                var h1 = this.em(a1);
                                e1.SPACE[h1] ? this.adaptor.setAttribute(this.chtml, l1, e1.SPACE[h1]) : this.adaptor.setStyle(this.chtml, p1, h1);
                            }
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, r1.prototype.handleColor = function() {
                    var t1 = this.node.attributes, e1 = t1.getExplicit("mathcolor"), r1 = t1.getExplicit("color"), n1 = t1.getExplicit("mathbackground"), o1 = t1.getExplicit("background");
                    (e1 || r1) && this.adaptor.setStyle(this.chtml, "color", e1 || r1), (n1 || o1) && this.adaptor.setStyle(this.chtml, "backgroundColor", n1 || o1);
                }, r1.prototype.handleAttributes = function() {
                    var t1, e1, n1, o1, i1 = this.node.attributes, s1 = i1.getAllDefaults(), a1 = r1.skipAttributes;
                    try {
                        for(var l1 = c1(i1.getExplicitNames()), u1 = l1.next(); !u1.done; u1 = l1.next()){
                            var p1 = u1.value;
                            !1 !== a1[p1] && (p1 in s1 || a1[p1] || this.adaptor.hasAttribute(this.chtml, p1)) || this.adaptor.setAttribute(this.chtml, p1, i1.getExplicit(p1));
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (e1 = l1.return) && e1.call(l1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    if (i1.get("class")) {
                        var h1 = i1.get("class").trim().split(/ +/);
                        try {
                            for(var f1 = c1(h1), d1 = f1.next(); !d1.done; d1 = f1.next()){
                                var m1 = d1.value;
                                this.adaptor.addClass(this.chtml, m1);
                            }
                        } catch (t1) {
                            n1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                d1 && !d1.done && (o1 = f1.return) && o1.call(f1);
                            } finally{
                                if (n1) throw n1.error;
                            }
                        }
                    }
                }, r1.prototype.handlePWidth = function() {
                    this.bbox.pwidth && (this.bbox.pwidth === f1.BBox.fullWidth ? this.adaptor.setAttribute(this.chtml, "width", "full") : this.adaptor.setStyle(this.chtml, "width", this.bbox.pwidth));
                }, r1.prototype.setIndent = function(t1, e1, r1) {
                    var n1 = this.adaptor;
                    if ("center" === e1 || "left" === e1) {
                        var o1 = this.getBBox().L;
                        n1.setStyle(t1, "margin-left", this.em(r1 + o1));
                    }
                    if ("center" === e1 || "right" === e1) {
                        var i1 = this.getBBox().R;
                        n1.setStyle(t1, "margin-right", this.em(-r1 + i1));
                    }
                }, r1.prototype.drawBBox = function() {
                    var t1 = this.getBBox(), e1 = t1.w, r1 = t1.h, n1 = t1.d, o1 = t1.R, i1 = this.html("mjx-box", {
                        style: {
                            opacity: .25,
                            "margin-left": this.em(-e1 - o1)
                        }
                    }, [
                        this.html("mjx-box", {
                            style: {
                                height: this.em(r1),
                                width: this.em(e1),
                                "background-color": "red"
                            }
                        }),
                        this.html("mjx-box", {
                            style: {
                                height: this.em(n1),
                                width: this.em(e1),
                                "margin-left": this.em(-e1),
                                "vertical-align": this.em(-n1),
                                "background-color": "green"
                            }
                        })
                    ]), s1 = this.chtml || this.parent.chtml, a1 = this.adaptor.getAttribute(s1, "size");
                    a1 && this.adaptor.setAttribute(i1, "size", a1);
                    var l1 = this.adaptor.getStyle(s1, "fontSize");
                    l1 && this.adaptor.setStyle(i1, "fontSize", l1), this.adaptor.append(this.adaptor.parent(s1), i1), this.adaptor.setStyle(s1, "backgroundColor", "#FFEE00");
                }, r1.prototype.html = function(t1, e1, r1) {
                    return void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = []), this.jax.html(t1, e1, r1);
                }, r1.prototype.text = function(t1) {
                    return this.jax.text(t1);
                }, r1.prototype.char = function(t1) {
                    return this.font.charSelector(t1).substr(1);
                }, r1.kind = "unknown", r1.autoStyle = !0, r1;
            }(h1.CommonWrapper);
            e1.CHTMLWrapper = d1;
        },
        9261: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLWrapperFactory = void 0;
            var i1 = r1(4420), s1 = r1(9086), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.defaultNodes = s1.CHTMLWrappers, e1;
            }(i1.CommonWrapperFactory);
            e1.CHTMLWrapperFactory = a1;
        },
        9086: function(t1, e1, r1) {
            var n1;
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLWrappers = void 0;
            var o1 = r1(5355), i1 = r1(804), s1 = r1(1653), a1 = r1(6287), l1 = r1(6460), c1 = r1(4597), u1 = r1(1259), p1 = r1(2970), h1 = r1(5964), f1 = r1(8147), d1 = r1(4798), m1 = r1(2275), y1 = r1(9063), g1 = r1(5610), b1 = r1(8776), v1 = r1(4300), _1 = r1(6590), S1 = r1(6781), O1 = r1(8002), M1 = r1(3571), x1 = r1(7056), E1 = r1(8102), A1 = r1(6911), C1 = r1(421), T1 = r1(95), N1 = r1(1148);
            e1.CHTMLWrappers = ((n1 = {})[i1.CHTMLmath.kind] = i1.CHTMLmath, n1[d1.CHTMLmrow.kind] = d1.CHTMLmrow, n1[d1.CHTMLinferredMrow.kind] = d1.CHTMLinferredMrow, n1[s1.CHTMLmi.kind] = s1.CHTMLmi, n1[a1.CHTMLmo.kind] = a1.CHTMLmo, n1[l1.CHTMLmn.kind] = l1.CHTMLmn, n1[c1.CHTMLms.kind] = c1.CHTMLms, n1[u1.CHTMLmtext.kind] = u1.CHTMLmtext, n1[p1.CHTMLmspace.kind] = p1.CHTMLmspace, n1[h1.CHTMLmpadded.kind] = h1.CHTMLmpadded, n1[f1.CHTMLmenclose.kind] = f1.CHTMLmenclose, n1[y1.CHTMLmfrac.kind] = y1.CHTMLmfrac, n1[g1.CHTMLmsqrt.kind] = g1.CHTMLmsqrt, n1[b1.CHTMLmroot.kind] = b1.CHTMLmroot, n1[v1.CHTMLmsub.kind] = v1.CHTMLmsub, n1[v1.CHTMLmsup.kind] = v1.CHTMLmsup, n1[v1.CHTMLmsubsup.kind] = v1.CHTMLmsubsup, n1[_1.CHTMLmunder.kind] = _1.CHTMLmunder, n1[_1.CHTMLmover.kind] = _1.CHTMLmover, n1[_1.CHTMLmunderover.kind] = _1.CHTMLmunderover, n1[S1.CHTMLmmultiscripts.kind] = S1.CHTMLmmultiscripts, n1[m1.CHTMLmfenced.kind] = m1.CHTMLmfenced, n1[O1.CHTMLmtable.kind] = O1.CHTMLmtable, n1[M1.CHTMLmtr.kind] = M1.CHTMLmtr, n1[M1.CHTMLmlabeledtr.kind] = M1.CHTMLmlabeledtr, n1[x1.CHTMLmtd.kind] = x1.CHTMLmtd, n1[E1.CHTMLmaction.kind] = E1.CHTMLmaction, n1[A1.CHTMLmglyph.kind] = A1.CHTMLmglyph, n1[C1.CHTMLsemantics.kind] = C1.CHTMLsemantics, n1[C1.CHTMLannotation.kind] = C1.CHTMLannotation, n1[C1.CHTMLannotationXML.kind] = C1.CHTMLannotationXML, n1[C1.CHTMLxml.kind] = C1.CHTMLxml, n1[T1.CHTMLTeXAtom.kind] = T1.CHTMLTeXAtom, n1[N1.CHTMLTextNode.kind] = N1.CHTMLTextNode, n1[o1.CHTMLWrapper.kind] = o1.CHTMLWrapper, n1);
        },
        95: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLTeXAtom = void 0;
            var i1 = r1(5355), s1 = r1(9800), a1 = r1(3948), l1 = r1(9007), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    if (t1.prototype.toCHTML.call(this, e1), this.adaptor.setAttribute(this.chtml, "texclass", l1.TEXCLASSNAMES[this.node.texClass]), this.node.texClass === l1.TEXCLASS.VCENTER) {
                        var r1 = this.childNodes[0].getBBox(), n1 = r1.h, o1 = (n1 + r1.d) / 2 + this.font.params.axis_height - n1;
                        this.adaptor.setStyle(this.chtml, "verticalAlign", this.em(o1));
                    }
                }, e1.kind = a1.TeXAtom.prototype.kind, e1;
            }((0, s1.CommonTeXAtomMixin)(i1.CHTMLWrapper));
            e1.CHTMLTeXAtom = c1;
        },
        1148: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLTextNode = void 0;
            var s1 = r1(9007), a1 = r1(5355), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1, r1;
                    this.markUsed();
                    var n1 = this.adaptor, o1 = this.parent.variant, s1 = this.node.getText();
                    if (0 !== s1.length) {
                        if ("-explicitFont" === o1) n1.append(t1, this.jax.unknownText(s1, o1, this.getBBox().w));
                        else {
                            var a1 = this.remappedText(s1, o1);
                            try {
                                for(var l1 = i1(a1), c1 = l1.next(); !c1.done; c1 = l1.next()){
                                    var u1 = c1.value, p1 = this.getVariantChar(o1, u1)[3], h1 = p1.f ? " TEX-" + p1.f : "", f1 = p1.unknown ? this.jax.unknownText(String.fromCodePoint(u1), o1) : this.html("mjx-c", {
                                        class: this.char(u1) + h1
                                    });
                                    n1.append(t1, f1), !p1.unknown && this.font.charUsage.add([
                                        o1,
                                        u1
                                    ]);
                                }
                            } catch (t1) {
                                e1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    c1 && !c1.done && (r1 = l1.return) && r1.call(l1);
                                } finally{
                                    if (e1) throw e1.error;
                                }
                            }
                        }
                    }
                }, e1.kind = s1.TextNode.prototype.kind, e1.autoStyle = !1, e1.styles = {
                    "mjx-c": {
                        display: "inline-block"
                    },
                    "mjx-utext": {
                        display: "inline-block",
                        padding: ".75em 0 .2em 0"
                    }
                }, e1;
            }((0, r1(1160).CommonTextNodeMixin)(a1.CHTMLWrapper));
            e1.CHTMLTextNode = l1;
        },
        8102: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmaction = void 0;
            var i1 = r1(5355), s1 = r1(1956), a1 = r1(1956), l1 = r1(9145), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1 = this.standardCHTMLnode(t1);
                    this.selected.toCHTML(e1), this.action(this, this.data);
                }, e1.prototype.setEventHandler = function(t1, e1) {
                    this.chtml.addEventListener(t1, e1);
                }, e1.kind = l1.MmlMaction.prototype.kind, e1.styles = {
                    "mjx-maction": {
                        position: "relative"
                    },
                    "mjx-maction > mjx-tool": {
                        display: "none",
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        width: 0,
                        height: 0,
                        "z-index": 500
                    },
                    "mjx-tool > mjx-tip": {
                        display: "inline-block",
                        padding: ".2em",
                        border: "1px solid #888",
                        "font-size": "70%",
                        "background-color": "#F8F8F8",
                        color: "black",
                        "box-shadow": "2px 2px 5px #AAAAAA"
                    },
                    "mjx-maction[toggle]": {
                        cursor: "pointer"
                    },
                    "mjx-status": {
                        display: "block",
                        position: "fixed",
                        left: "1em",
                        bottom: "1em",
                        "min-width": "25%",
                        padding: ".2em .4em",
                        border: "1px solid #888",
                        "font-size": "90%",
                        "background-color": "#F8F8F8",
                        color: "black"
                    }
                }, e1.actions = new Map([
                    [
                        "toggle",
                        [
                            function(t1, e1) {
                                t1.adaptor.setAttribute(t1.chtml, "toggle", t1.node.attributes.get("selection"));
                                var r1 = t1.factory.jax.math, n1 = t1.factory.jax.document, o1 = t1.node;
                                t1.setEventHandler("click", function(t1) {
                                    r1.end.node || (r1.start.node = r1.end.node = r1.typesetRoot, r1.start.n = r1.end.n = 0), o1.nextToggleSelection(), r1.rerender(n1), t1.stopPropagation();
                                });
                            },
                            {}
                        ]
                    ],
                    [
                        "tooltip",
                        [
                            function(t1, e1) {
                                var r1 = t1.childNodes[1];
                                if (r1) {
                                    if (r1.node.isKind("mtext")) {
                                        var n1 = r1.node.getText();
                                        t1.adaptor.setAttribute(t1.chtml, "title", n1);
                                    } else {
                                        var o1 = t1.adaptor, i1 = o1.append(t1.chtml, t1.html("mjx-tool", {
                                            style: {
                                                bottom: t1.em(-t1.dy),
                                                right: t1.em(-t1.dx)
                                            }
                                        }, [
                                            t1.html("mjx-tip")
                                        ]));
                                        r1.toCHTML(o1.firstChild(i1)), t1.setEventHandler("mouseover", function(r1) {
                                            e1.stopTimers(t1, e1);
                                            var n1 = setTimeout(function() {
                                                return o1.setStyle(i1, "display", "block");
                                            }, e1.postDelay);
                                            e1.hoverTimer.set(t1, n1), r1.stopPropagation();
                                        }), t1.setEventHandler("mouseout", function(r1) {
                                            e1.stopTimers(t1, e1);
                                            var n1 = setTimeout(function() {
                                                return o1.setStyle(i1, "display", "");
                                            }, e1.clearDelay);
                                            e1.clearTimer.set(t1, n1), r1.stopPropagation();
                                        });
                                    }
                                }
                            },
                            a1.TooltipData
                        ]
                    ],
                    [
                        "statusline",
                        [
                            function(t1, e1) {
                                var r1 = t1.childNodes[1];
                                if (r1 && r1.node.isKind("mtext")) {
                                    var n1 = t1.adaptor, o1 = r1.node.getText();
                                    n1.setAttribute(t1.chtml, "statusline", o1), t1.setEventHandler("mouseover", function(r1) {
                                        if (null === e1.status) {
                                            var i1 = n1.body(n1.document);
                                            e1.status = n1.append(i1, t1.html("mjx-status", {}, [
                                                t1.text(o1)
                                            ]));
                                        }
                                        r1.stopPropagation();
                                    }), t1.setEventHandler("mouseout", function(t1) {
                                        e1.status && (n1.remove(e1.status), e1.status = null), t1.stopPropagation();
                                    });
                                }
                            },
                            {
                                status: null
                            }
                        ]
                    ]
                ]), e1;
            }((0, s1.CommonMactionMixin)(i1.CHTMLWrapper));
            e1.CHTMLmaction = c1;
        },
        804: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmath = void 0;
            var s1 = r1(5355), a1 = r1(7490), l1 = r1(3233), c1 = r1(6469), u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    t1.prototype.toCHTML.call(this, e1);
                    var r1 = this.chtml, n1 = this.adaptor;
                    "block" === this.node.attributes.get("display") ? (n1.setAttribute(r1, "display", "true"), n1.setAttribute(e1, "display", "true"), this.handleDisplay(e1)) : this.handleInline(e1), n1.addClass(r1, "MJX-TEX");
                }, e1.prototype.handleDisplay = function(t1) {
                    var e1 = this.adaptor, r1 = i1(this.getAlignShift(), 2), n1 = r1[0], o1 = r1[1];
                    if ("center" !== n1 && e1.setAttribute(t1, "justify", n1), this.bbox.pwidth === c1.BBox.fullWidth) {
                        if (e1.setAttribute(t1, "width", "full"), this.jax.table) {
                            var s1 = this.jax.table.getOuterBBox(), a1 = s1.L, l1 = s1.w, u1 = s1.R;
                            "right" === n1 ? u1 = Math.max(u1 || -o1, -o1) : "left" === n1 ? a1 = Math.max(a1 || o1, o1) : "center" === n1 && (l1 += 2 * Math.abs(o1));
                            var p1 = this.em(Math.max(0, a1 + l1 + u1));
                            e1.setStyle(t1, "min-width", p1), e1.setStyle(this.jax.table.chtml, "min-width", p1);
                        }
                    } else this.setIndent(this.chtml, n1, o1);
                }, e1.prototype.handleInline = function(t1) {
                    var e1 = this.adaptor, r1 = e1.getStyle(this.chtml, "margin-right");
                    r1 && (e1.setStyle(this.chtml, "margin-right", ""), e1.setStyle(t1, "margin-right", r1), e1.setStyle(t1, "width", "0"));
                }, e1.prototype.setChildPWidths = function(e1, r1, n1) {
                    return void 0 === r1 && (r1 = null), void 0 === n1 && (n1 = !0), !!this.parent && t1.prototype.setChildPWidths.call(this, e1, r1, n1);
                }, e1.kind = l1.MmlMath.prototype.kind, e1.styles = {
                    "mjx-math": {
                        "line-height": 0,
                        "text-align": "left",
                        "text-indent": 0,
                        "font-style": "normal",
                        "font-weight": "normal",
                        "font-size": "100%",
                        "font-size-adjust": "none",
                        "letter-spacing": "normal",
                        "border-collapse": "collapse",
                        "word-wrap": "normal",
                        "word-spacing": "normal",
                        "white-space": "nowrap",
                        direction: "ltr",
                        padding: "1px 0"
                    },
                    'mjx-container[jax="CHTML"][display="true"]': {
                        display: "block",
                        "text-align": "center",
                        margin: "1em 0"
                    },
                    'mjx-container[jax="CHTML"][display="true"][width="full"]': {
                        display: "flex"
                    },
                    'mjx-container[jax="CHTML"][display="true"] mjx-math': {
                        padding: 0
                    },
                    'mjx-container[jax="CHTML"][justify="left"]': {
                        "text-align": "left"
                    },
                    'mjx-container[jax="CHTML"][justify="right"]': {
                        "text-align": "right"
                    }
                }, e1;
            }((0, a1.CommonMathMixin)(s1.CHTMLWrapper));
            e1.CHTMLmath = u1;
        },
        8147: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), s1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), a1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && i1(e1, t1, r1);
                return s1(e1, t1), e1;
            }, l1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, c1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmenclose = void 0;
            var u1 = r1(5355), p1 = r1(7313), h1 = a1(r1(8270)), f1 = r1(6661), d1 = r1(6010);
            function m1(t1, e1) {
                return Math.atan2(t1, e1).toFixed(3).replace(/\.?0+$/, "");
            }
            var y1 = m1(h1.ARROWDX, h1.ARROWY), g1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1, r1, n1, o1, i1 = this.adaptor, s1 = this.standardCHTMLnode(t1), a1 = i1.append(s1, this.html("mjx-box"));
                    this.renderChild ? this.renderChild(this, a1) : this.childNodes[0].toCHTML(a1);
                    try {
                        for(var c1 = l1(Object.keys(this.notations)), u1 = c1.next(); !u1.done; u1 = c1.next()){
                            var p1 = u1.value, f1 = this.notations[p1];
                            !f1.renderChild && f1.renderer(this, a1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (r1 = c1.return) && r1.call(c1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    var d1 = this.getPadding();
                    try {
                        for(var m1 = l1(h1.sideNames), y1 = m1.next(); !y1.done; y1 = m1.next()){
                            var g1 = y1.value, b1 = h1.sideIndex[g1];
                            d1[b1] > 0 && i1.setStyle(a1, "padding-" + g1, this.em(d1[b1]));
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            y1 && !y1.done && (o1 = m1.return) && o1.call(m1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }, e1.prototype.arrow = function(t1, e1, r1, n1, o1) {
                    void 0 === n1 && (n1 = ""), void 0 === o1 && (o1 = 0);
                    var i1 = this.getBBox().w, s1 = {
                        width: this.em(t1)
                    };
                    i1 !== t1 && (s1.left = this.em((i1 - t1) / 2)), e1 && (s1.transform = "rotate(" + this.fixed(e1) + "rad)");
                    var a1 = this.html("mjx-arrow", {
                        style: s1
                    }, [
                        this.html("mjx-aline"),
                        this.html("mjx-rthead"),
                        this.html("mjx-rbhead")
                    ]);
                    return r1 && (this.adaptor.append(a1, this.html("mjx-lthead")), this.adaptor.append(a1, this.html("mjx-lbhead")), this.adaptor.setAttribute(a1, "double", "true")), this.adjustArrow(a1, r1), this.moveArrow(a1, n1, o1), a1;
                }, e1.prototype.adjustArrow = function(t1, e1) {
                    var r1 = this, n1 = this.thickness, o1 = this.arrowhead;
                    if (o1.x !== h1.ARROWX || o1.y !== h1.ARROWY || o1.dx !== h1.ARROWDX || n1 !== h1.THICKNESS) {
                        var i1 = c1([
                            n1 * o1.x,
                            n1 * o1.y
                        ].map(function(t1) {
                            return r1.em(t1);
                        }), 2), s1 = i1[0], a1 = i1[1], l1 = m1(o1.dx, o1.y), u1 = c1(this.adaptor.childNodes(t1), 5), p1 = u1[0], f1 = u1[1], d1 = u1[2], y1 = u1[3], g1 = u1[4];
                        this.adjustHead(f1, [
                            a1,
                            "0",
                            "1px",
                            s1
                        ], l1), this.adjustHead(d1, [
                            "1px",
                            "0",
                            a1,
                            s1
                        ], "-" + l1), this.adjustHead(y1, [
                            a1,
                            s1,
                            "1px",
                            "0"
                        ], "-" + l1), this.adjustHead(g1, [
                            "1px",
                            s1,
                            a1,
                            "0"
                        ], l1), this.adjustLine(p1, n1, o1.x, e1);
                    }
                }, e1.prototype.adjustHead = function(t1, e1, r1) {
                    t1 && (this.adaptor.setStyle(t1, "border-width", e1.join(" ")), this.adaptor.setStyle(t1, "transform", "skewX(" + r1 + "rad)"));
                }, e1.prototype.adjustLine = function(t1, e1, r1, n1) {
                    this.adaptor.setStyle(t1, "borderTop", this.em(e1) + " solid"), this.adaptor.setStyle(t1, "top", this.em(-e1 / 2)), this.adaptor.setStyle(t1, "right", this.em(e1 * (r1 - 1))), n1 && this.adaptor.setStyle(t1, "left", this.em(e1 * (r1 - 1)));
                }, e1.prototype.moveArrow = function(t1, e1, r1) {
                    if (r1) {
                        var n1 = this.adaptor.getStyle(t1, "transform");
                        this.adaptor.setStyle(t1, "transform", "translate".concat(e1, "(").concat(this.em(-r1), ")").concat(n1 ? " " + n1 : ""));
                    }
                }, e1.prototype.adjustBorder = function(t1) {
                    return this.thickness !== h1.THICKNESS && this.adaptor.setStyle(t1, "borderWidth", this.em(this.thickness)), t1;
                }, e1.prototype.adjustThickness = function(t1) {
                    return this.thickness !== h1.THICKNESS && this.adaptor.setStyle(t1, "strokeWidth", this.fixed(this.thickness)), t1;
                }, e1.prototype.fixed = function(t1, e1) {
                    return void 0 === e1 && (e1 = 3), Math.abs(t1) < 6e-4 ? "0" : t1.toFixed(e1).replace(/\.?0+$/, "");
                }, e1.prototype.em = function(e1) {
                    return t1.prototype.em.call(this, e1);
                }, e1.kind = f1.MmlMenclose.prototype.kind, e1.styles = {
                    "mjx-menclose": {
                        position: "relative"
                    },
                    "mjx-menclose > mjx-dstrike": {
                        display: "inline-block",
                        left: 0,
                        top: 0,
                        position: "absolute",
                        "border-top": h1.SOLID,
                        "transform-origin": "top left"
                    },
                    "mjx-menclose > mjx-ustrike": {
                        display: "inline-block",
                        left: 0,
                        bottom: 0,
                        position: "absolute",
                        "border-top": h1.SOLID,
                        "transform-origin": "bottom left"
                    },
                    "mjx-menclose > mjx-hstrike": {
                        "border-top": h1.SOLID,
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: "50%",
                        transform: "translateY(" + (0, d1.em)(h1.THICKNESS / 2) + ")"
                    },
                    "mjx-menclose > mjx-vstrike": {
                        "border-left": h1.SOLID,
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        right: "50%",
                        transform: "translateX(" + (0, d1.em)(h1.THICKNESS / 2) + ")"
                    },
                    "mjx-menclose > mjx-rbox": {
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        border: h1.SOLID,
                        "border-radius": (0, d1.em)(h1.THICKNESS + h1.PADDING)
                    },
                    "mjx-menclose > mjx-cbox": {
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        border: h1.SOLID,
                        "border-radius": "50%"
                    },
                    "mjx-menclose > mjx-arrow": {
                        position: "absolute",
                        left: 0,
                        bottom: "50%",
                        height: 0,
                        width: 0
                    },
                    "mjx-menclose > mjx-arrow > *": {
                        display: "block",
                        position: "absolute",
                        "transform-origin": "bottom",
                        "border-left": (0, d1.em)(h1.THICKNESS * h1.ARROWX) + " solid",
                        "border-right": 0,
                        "box-sizing": "border-box"
                    },
                    "mjx-menclose > mjx-arrow > mjx-aline": {
                        left: 0,
                        top: (0, d1.em)(-h1.THICKNESS / 2),
                        right: (0, d1.em)(h1.THICKNESS * (h1.ARROWX - 1)),
                        height: 0,
                        "border-top": (0, d1.em)(h1.THICKNESS) + " solid",
                        "border-left": 0
                    },
                    "mjx-menclose > mjx-arrow[double] > mjx-aline": {
                        left: (0, d1.em)(h1.THICKNESS * (h1.ARROWX - 1)),
                        height: 0
                    },
                    "mjx-menclose > mjx-arrow > mjx-rthead": {
                        transform: "skewX(" + y1 + "rad)",
                        right: 0,
                        bottom: "-1px",
                        "border-bottom": "1px solid transparent",
                        "border-top": (0, d1.em)(h1.THICKNESS * h1.ARROWY) + " solid transparent"
                    },
                    "mjx-menclose > mjx-arrow > mjx-rbhead": {
                        transform: "skewX(-" + y1 + "rad)",
                        "transform-origin": "top",
                        right: 0,
                        top: "-1px",
                        "border-top": "1px solid transparent",
                        "border-bottom": (0, d1.em)(h1.THICKNESS * h1.ARROWY) + " solid transparent"
                    },
                    "mjx-menclose > mjx-arrow > mjx-lthead": {
                        transform: "skewX(-" + y1 + "rad)",
                        left: 0,
                        bottom: "-1px",
                        "border-left": 0,
                        "border-right": (0, d1.em)(h1.THICKNESS * h1.ARROWX) + " solid",
                        "border-bottom": "1px solid transparent",
                        "border-top": (0, d1.em)(h1.THICKNESS * h1.ARROWY) + " solid transparent"
                    },
                    "mjx-menclose > mjx-arrow > mjx-lbhead": {
                        transform: "skewX(" + y1 + "rad)",
                        "transform-origin": "top",
                        left: 0,
                        top: "-1px",
                        "border-left": 0,
                        "border-right": (0, d1.em)(h1.THICKNESS * h1.ARROWX) + " solid",
                        "border-top": "1px solid transparent",
                        "border-bottom": (0, d1.em)(h1.THICKNESS * h1.ARROWY) + " solid transparent"
                    },
                    "mjx-menclose > dbox": {
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: (0, d1.em)(-1.5 * h1.PADDING),
                        width: (0, d1.em)(3 * h1.PADDING),
                        border: (0, d1.em)(h1.THICKNESS) + " solid",
                        "border-radius": "50%",
                        "clip-path": "inset(0 0 0 " + (0, d1.em)(1.5 * h1.PADDING) + ")",
                        "box-sizing": "border-box"
                    }
                }, e1.notations = new Map([
                    h1.Border("top"),
                    h1.Border("right"),
                    h1.Border("bottom"),
                    h1.Border("left"),
                    h1.Border2("actuarial", "top", "right"),
                    h1.Border2("madruwb", "bottom", "right"),
                    h1.DiagonalStrike("up", 1),
                    h1.DiagonalStrike("down", -1),
                    [
                        "horizontalstrike",
                        {
                            renderer: h1.RenderElement("hstrike", "Y"),
                            bbox: function(t1) {
                                return [
                                    0,
                                    t1.padding,
                                    0,
                                    t1.padding
                                ];
                            }
                        }
                    ],
                    [
                        "verticalstrike",
                        {
                            renderer: h1.RenderElement("vstrike", "X"),
                            bbox: function(t1) {
                                return [
                                    t1.padding,
                                    0,
                                    t1.padding,
                                    0
                                ];
                            }
                        }
                    ],
                    [
                        "box",
                        {
                            renderer: function(t1, e1) {
                                t1.adaptor.setStyle(e1, "border", t1.em(t1.thickness) + " solid");
                            },
                            bbox: h1.fullBBox,
                            border: h1.fullBorder,
                            remove: "left right top bottom"
                        }
                    ],
                    [
                        "roundedbox",
                        {
                            renderer: h1.RenderElement("rbox"),
                            bbox: h1.fullBBox
                        }
                    ],
                    [
                        "circle",
                        {
                            renderer: h1.RenderElement("cbox"),
                            bbox: h1.fullBBox
                        }
                    ],
                    [
                        "phasorangle",
                        {
                            renderer: function(t1, e1) {
                                var r1 = t1.getBBox(), n1 = r1.h, o1 = r1.d, i1 = c1(t1.getArgMod(1.75 * t1.padding, n1 + o1), 2), s1 = i1[0], a1 = i1[1], l1 = t1.thickness * Math.sin(s1) * .9;
                                t1.adaptor.setStyle(e1, "border-bottom", t1.em(t1.thickness) + " solid");
                                var u1 = t1.adjustBorder(t1.html("mjx-ustrike", {
                                    style: {
                                        width: t1.em(a1),
                                        transform: "translateX(" + t1.em(l1) + ") rotate(" + t1.fixed(-s1) + "rad)"
                                    }
                                }));
                                t1.adaptor.append(t1.chtml, u1);
                            },
                            bbox: function(t1) {
                                var e1 = t1.padding / 2, r1 = t1.thickness;
                                return [
                                    2 * e1,
                                    e1,
                                    e1 + r1,
                                    3 * e1 + r1
                                ];
                            },
                            border: function(t1) {
                                return [
                                    0,
                                    0,
                                    t1.thickness,
                                    0
                                ];
                            },
                            remove: "bottom"
                        }
                    ],
                    h1.Arrow("up"),
                    h1.Arrow("down"),
                    h1.Arrow("left"),
                    h1.Arrow("right"),
                    h1.Arrow("updown"),
                    h1.Arrow("leftright"),
                    h1.DiagonalArrow("updiagonal"),
                    h1.DiagonalArrow("northeast"),
                    h1.DiagonalArrow("southeast"),
                    h1.DiagonalArrow("northwest"),
                    h1.DiagonalArrow("southwest"),
                    h1.DiagonalArrow("northeastsouthwest"),
                    h1.DiagonalArrow("northwestsoutheast"),
                    [
                        "longdiv",
                        {
                            renderer: function(t1, e1) {
                                var r1 = t1.adaptor;
                                r1.setStyle(e1, "border-top", t1.em(t1.thickness) + " solid");
                                var n1 = r1.append(t1.chtml, t1.html("dbox")), o1 = t1.thickness, i1 = t1.padding;
                                o1 !== h1.THICKNESS && r1.setStyle(n1, "border-width", t1.em(o1)), i1 !== h1.PADDING && (r1.setStyle(n1, "left", t1.em(-1.5 * i1)), r1.setStyle(n1, "width", t1.em(3 * i1)), r1.setStyle(n1, "clip-path", "inset(0 0 0 " + t1.em(1.5 * i1) + ")"));
                            },
                            bbox: function(t1) {
                                var e1 = t1.padding, r1 = t1.thickness;
                                return [
                                    e1 + r1,
                                    e1,
                                    e1,
                                    2 * e1 + r1 / 2
                                ];
                            }
                        }
                    ],
                    [
                        "radical",
                        {
                            renderer: function(t1, e1) {
                                t1.msqrt.toCHTML(e1);
                                var r1 = t1.sqrtTRBL();
                                t1.adaptor.setStyle(t1.msqrt.chtml, "margin", r1.map(function(e1) {
                                    return t1.em(-e1);
                                }).join(" "));
                            },
                            init: function(t1) {
                                t1.msqrt = t1.createMsqrt(t1.childNodes[0]);
                            },
                            bbox: function(t1) {
                                return t1.sqrtTRBL();
                            },
                            renderChild: !0
                        }
                    ]
                ]), e1;
            }((0, p1.CommonMencloseMixin)(u1.CHTMLWrapper));
            e1.CHTMLmenclose = g1;
        },
        2275: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmfenced = void 0;
            var i1 = r1(5355), s1 = r1(7555), a1 = r1(5410), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1 = this.standardCHTMLnode(t1);
                    this.mrow.toCHTML(e1);
                }, e1.kind = a1.MmlMfenced.prototype.kind, e1;
            }((0, s1.CommonMfencedMixin)(i1.CHTMLWrapper));
            e1.CHTMLmfenced = l1;
        },
        9063: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmfrac = void 0;
            var s1 = r1(5355), a1 = r1(2688), l1 = r1(6850), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    this.standardCHTMLnode(t1);
                    var e1 = this.node.attributes.getList("linethickness", "bevelled"), r1 = e1.linethickness, n1 = e1.bevelled, o1 = this.isDisplay();
                    if (n1) this.makeBevelled(o1);
                    else {
                        var i1 = this.length2em(String(r1), .06);
                        0 === i1 ? this.makeAtop(o1) : this.makeFraction(o1, i1);
                    }
                }, e1.prototype.makeFraction = function(t1, e1) {
                    var r1, n1, o1 = this.node.attributes.getList("numalign", "denomalign"), s1 = o1.numalign, a1 = o1.denomalign, l1 = t1 ? {
                        type: "d"
                    } : {}, c1 = this.node.getProperty("withDelims") ? i1(i1({}, l1), {
                        delims: "true"
                    }) : i1({}, l1), u1 = "center" !== s1 ? {
                        align: s1
                    } : {}, p1 = "center" !== a1 ? {
                        align: a1
                    } : {}, h1 = i1({}, l1), f1 = i1({}, l1), d1 = this.font.params;
                    if (.06 !== e1) {
                        var m1 = d1.axis_height, y1 = this.em(e1), g1 = this.getTUV(t1, e1), b1 = g1.T, v1 = g1.u, _1 = g1.v, S1 = (t1 ? this.em(3 * e1) : y1) + " -.1em";
                        l1.style = {
                            height: y1,
                            "border-top": y1 + " solid",
                            margin: S1
                        };
                        var O1 = this.em(Math.max(0, v1));
                        f1.style = {
                            height: O1,
                            "vertical-align": "-" + O1
                        }, h1.style = {
                            height: this.em(Math.max(0, _1))
                        }, c1.style = {
                            "vertical-align": this.em(m1 - b1)
                        };
                    }
                    this.adaptor.append(this.chtml, this.html("mjx-frac", c1, [
                        r1 = this.html("mjx-num", u1, [
                            this.html("mjx-nstrut", f1)
                        ]),
                        this.html("mjx-dbox", {}, [
                            this.html("mjx-dtable", {}, [
                                this.html("mjx-line", l1),
                                this.html("mjx-row", {}, [
                                    n1 = this.html("mjx-den", p1, [
                                        this.html("mjx-dstrut", h1)
                                    ])
                                ])
                            ])
                        ])
                    ])), this.childNodes[0].toCHTML(r1), this.childNodes[1].toCHTML(n1);
                }, e1.prototype.makeAtop = function(t1) {
                    var e1, r1, n1 = this.node.attributes.getList("numalign", "denomalign"), o1 = n1.numalign, s1 = n1.denomalign, a1 = t1 ? {
                        type: "d",
                        atop: !0
                    } : {
                        atop: !0
                    }, l1 = this.node.getProperty("withDelims") ? i1(i1({}, a1), {
                        delims: !0
                    }) : i1({}, a1), c1 = "center" !== o1 ? {
                        align: o1
                    } : {}, u1 = "center" !== s1 ? {
                        align: s1
                    } : {}, p1 = this.getUVQ(t1), h1 = p1.v, f1 = p1.q;
                    c1.style = {
                        "padding-bottom": this.em(f1)
                    }, l1.style = {
                        "vertical-align": this.em(-h1)
                    }, this.adaptor.append(this.chtml, this.html("mjx-frac", l1, [
                        e1 = this.html("mjx-num", c1),
                        r1 = this.html("mjx-den", u1)
                    ])), this.childNodes[0].toCHTML(e1), this.childNodes[1].toCHTML(r1);
                }, e1.prototype.makeBevelled = function(t1) {
                    var e1 = this.adaptor;
                    e1.setAttribute(this.chtml, "bevelled", "ture");
                    var r1 = e1.append(this.chtml, this.html("mjx-num"));
                    this.childNodes[0].toCHTML(r1), this.bevel.toCHTML(this.chtml);
                    var n1 = e1.append(this.chtml, this.html("mjx-den"));
                    this.childNodes[1].toCHTML(n1);
                    var o1 = this.getBevelData(t1), i1 = o1.u, s1 = o1.v, a1 = o1.delta, l1 = o1.nbox, c1 = o1.dbox;
                    i1 && e1.setStyle(r1, "verticalAlign", this.em(i1 / l1.scale)), s1 && e1.setStyle(n1, "verticalAlign", this.em(s1 / c1.scale));
                    var u1 = this.em(-a1 / 2);
                    e1.setStyle(this.bevel.chtml, "marginLeft", u1), e1.setStyle(this.bevel.chtml, "marginRight", u1);
                }, e1.kind = l1.MmlMfrac.prototype.kind, e1.styles = {
                    "mjx-frac": {
                        display: "inline-block",
                        "vertical-align": "0.17em",
                        padding: "0 .22em"
                    },
                    'mjx-frac[type="d"]': {
                        "vertical-align": ".04em"
                    },
                    "mjx-frac[delims]": {
                        padding: "0 .1em"
                    },
                    "mjx-frac[atop]": {
                        padding: "0 .12em"
                    },
                    "mjx-frac[atop][delims]": {
                        padding: "0"
                    },
                    "mjx-dtable": {
                        display: "inline-table",
                        width: "100%"
                    },
                    "mjx-dtable > *": {
                        "font-size": "2000%"
                    },
                    "mjx-dbox": {
                        display: "block",
                        "font-size": "5%"
                    },
                    "mjx-num": {
                        display: "block",
                        "text-align": "center"
                    },
                    "mjx-den": {
                        display: "block",
                        "text-align": "center"
                    },
                    "mjx-mfrac[bevelled] > mjx-num": {
                        display: "inline-block"
                    },
                    "mjx-mfrac[bevelled] > mjx-den": {
                        display: "inline-block"
                    },
                    'mjx-den[align="right"], mjx-num[align="right"]': {
                        "text-align": "right"
                    },
                    'mjx-den[align="left"], mjx-num[align="left"]': {
                        "text-align": "left"
                    },
                    "mjx-nstrut": {
                        display: "inline-block",
                        height: ".054em",
                        width: 0,
                        "vertical-align": "-.054em"
                    },
                    'mjx-nstrut[type="d"]': {
                        height: ".217em",
                        "vertical-align": "-.217em"
                    },
                    "mjx-dstrut": {
                        display: "inline-block",
                        height: ".505em",
                        width: 0
                    },
                    'mjx-dstrut[type="d"]': {
                        height: ".726em"
                    },
                    "mjx-line": {
                        display: "block",
                        "box-sizing": "border-box",
                        "min-height": "1px",
                        height: ".06em",
                        "border-top": ".06em solid",
                        margin: ".06em -.1em",
                        overflow: "hidden"
                    },
                    'mjx-line[type="d"]': {
                        margin: ".18em -.1em"
                    }
                }, e1;
            }((0, a1.CommonMfracMixin)(s1.CHTMLWrapper));
            e1.CHTMLmfrac = c1;
        },
        6911: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmglyph = void 0;
            var i1 = r1(5355), s1 = r1(5636), a1 = r1(3985), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1 = this.standardCHTMLnode(t1);
                    if (this.charWrapper) this.charWrapper.toCHTML(e1);
                    else {
                        var r1 = this.node.attributes.getList("src", "alt"), n1 = r1.src, o1 = r1.alt, i1 = {
                            width: this.em(this.width),
                            height: this.em(this.height)
                        };
                        this.valign && (i1.verticalAlign = this.em(this.valign));
                        var s1 = this.html("img", {
                            src: n1,
                            style: i1,
                            alt: o1,
                            title: o1
                        });
                        this.adaptor.append(e1, s1);
                    }
                }, e1.kind = a1.MmlMglyph.prototype.kind, e1.styles = {
                    "mjx-mglyph > img": {
                        display: "inline-block",
                        border: 0,
                        padding: 0
                    }
                }, e1;
            }((0, s1.CommonMglyphMixin)(i1.CHTMLWrapper));
            e1.CHTMLmglyph = l1;
        },
        1653: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmi = void 0;
            var i1 = r1(5355), s1 = r1(5723), a1 = r1(450), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = a1.MmlMi.prototype.kind, e1;
            }((0, s1.CommonMiMixin)(i1.CHTMLWrapper));
            e1.CHTMLmi = l1;
        },
        6781: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmmultiscripts = void 0;
            var s1 = r1(4300), a1 = r1(8009), l1 = r1(6405), c1 = r1(505), u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1 = this.standardCHTMLnode(t1), r1 = this.scriptData, n1 = this.node.getProperty("scriptalign") || "right left", o1 = i1((0, c1.split)(n1 + " " + n1), 2), s1 = o1[0], a1 = o1[1], l1 = this.combinePrePost(r1.sub, r1.psub), u1 = this.combinePrePost(r1.sup, r1.psup), p1 = i1(this.getUVQ(l1, u1), 2), h1 = p1[0], f1 = p1[1];
                    if (r1.numPrescripts) {
                        var d1 = this.addScripts(h1, -f1, !0, r1.psub, r1.psup, this.firstPrescript, r1.numPrescripts);
                        "right" !== s1 && this.adaptor.setAttribute(d1, "script-align", s1);
                    }
                    if (this.childNodes[0].toCHTML(e1), r1.numScripts) {
                        d1 = this.addScripts(h1, -f1, !1, r1.sub, r1.sup, 1, r1.numScripts);
                        "left" !== a1 && this.adaptor.setAttribute(d1, "script-align", a1);
                    }
                }, e1.prototype.addScripts = function(t1, e1, r1, n1, o1, i1, s1) {
                    for(var a1 = this.adaptor, l1 = t1 - o1.d + (e1 - n1.h), c1 = t1 < 0 && 0 === e1 ? n1.h + t1 : t1, u1 = l1 > 0 ? {
                        style: {
                            height: this.em(l1)
                        }
                    } : {}, p1 = c1 ? {
                        style: {
                            "vertical-align": this.em(c1)
                        }
                    } : {}, h1 = this.html("mjx-row"), f1 = this.html("mjx-row", u1), d1 = this.html("mjx-row"), m1 = "mjx-" + (r1 ? "pre" : "") + "scripts", y1 = i1 + 2 * s1; i1 < y1;)this.childNodes[i1++].toCHTML(a1.append(d1, this.html("mjx-cell"))), this.childNodes[i1++].toCHTML(a1.append(h1, this.html("mjx-cell")));
                    return a1.append(this.chtml, this.html(m1, p1, [
                        h1,
                        f1,
                        d1
                    ]));
                }, e1.kind = l1.MmlMmultiscripts.prototype.kind, e1.styles = {
                    "mjx-prescripts": {
                        display: "inline-table",
                        "padding-left": ".05em"
                    },
                    "mjx-scripts": {
                        display: "inline-table",
                        "padding-right": ".05em"
                    },
                    "mjx-prescripts > mjx-row > mjx-cell": {
                        "text-align": "right"
                    },
                    '[script-align="left"] > mjx-row > mjx-cell': {
                        "text-align": "left"
                    },
                    '[script-align="center"] > mjx-row > mjx-cell': {
                        "text-align": "center"
                    },
                    '[script-align="right"] > mjx-row > mjx-cell': {
                        "text-align": "right"
                    }
                }, e1;
            }((0, a1.CommonMmultiscriptsMixin)(s1.CHTMLmsubsup));
            e1.CHTMLmmultiscripts = u1;
        },
        6460: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmn = void 0;
            var i1 = r1(5355), s1 = r1(5023), a1 = r1(3050), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = a1.MmlMn.prototype.kind, e1;
            }((0, s1.CommonMnMixin)(i1.CHTMLWrapper));
            e1.CHTMLmn = l1;
        },
        6287: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmo = void 0;
            var s1 = r1(5355), a1 = r1(7096), l1 = r1(2756), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1, r1, n1 = this.node.attributes, o1 = n1.get("symmetric") && 2 !== this.stretch.dir, s1 = 0 !== this.stretch.dir;
                    s1 && null === this.size && this.getStretchedVariant([]);
                    var a1 = this.standardCHTMLnode(t1);
                    if (s1 && this.size < 0) this.stretchHTML(a1);
                    else {
                        if (o1 || n1.get("largeop")) {
                            var l1 = this.em(this.getCenterOffset());
                            "0" !== l1 && this.adaptor.setStyle(a1, "verticalAlign", l1);
                        }
                        this.node.getProperty("mathaccent") && (this.adaptor.setStyle(a1, "width", "0"), this.adaptor.setStyle(a1, "margin-left", this.em(this.getAccentOffset())));
                        try {
                            for(var c1 = i1(this.childNodes), u1 = c1.next(); !u1.done; u1 = c1.next())u1.value.toCHTML(a1);
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                u1 && !u1.done && (r1 = c1.return) && r1.call(c1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                    }
                }, e1.prototype.stretchHTML = function(t1) {
                    var e1 = this.getText().codePointAt(0);
                    this.font.delimUsage.add(e1), this.childNodes[0].markUsed();
                    var r1 = this.stretch, n1 = r1.stretch, o1 = [];
                    n1[0] && o1.push(this.html("mjx-beg", {}, [
                        this.html("mjx-c")
                    ])), o1.push(this.html("mjx-ext", {}, [
                        this.html("mjx-c")
                    ])), 4 === n1.length && o1.push(this.html("mjx-mid", {}, [
                        this.html("mjx-c")
                    ]), this.html("mjx-ext", {}, [
                        this.html("mjx-c")
                    ])), n1[2] && o1.push(this.html("mjx-end", {}, [
                        this.html("mjx-c")
                    ]));
                    var i1 = {}, s1 = this.bbox, l1 = s1.h, c1 = s1.d, u1 = s1.w;
                    1 === r1.dir ? (o1.push(this.html("mjx-mark")), i1.height = this.em(l1 + c1), i1.verticalAlign = this.em(-c1)) : i1.width = this.em(u1);
                    var p1 = a1.DirectionVH[r1.dir], h1 = {
                        class: this.char(r1.c || e1),
                        style: i1
                    }, f1 = this.html("mjx-stretchy-" + p1, h1, o1);
                    this.adaptor.append(t1, f1);
                }, e1.kind = l1.MmlMo.prototype.kind, e1.styles = {
                    "mjx-stretchy-h": {
                        display: "inline-table",
                        width: "100%"
                    },
                    "mjx-stretchy-h > *": {
                        display: "table-cell",
                        width: 0
                    },
                    "mjx-stretchy-h > * > mjx-c": {
                        display: "inline-block",
                        transform: "scalex(1.0000001)"
                    },
                    "mjx-stretchy-h > * > mjx-c::before": {
                        display: "inline-block",
                        width: "initial"
                    },
                    "mjx-stretchy-h > mjx-ext": {
                        "/* IE */ overflow": "hidden",
                        "/* others */ overflow": "clip visible",
                        width: "100%"
                    },
                    "mjx-stretchy-h > mjx-ext > mjx-c::before": {
                        transform: "scalex(500)"
                    },
                    "mjx-stretchy-h > mjx-ext > mjx-c": {
                        width: 0
                    },
                    "mjx-stretchy-h > mjx-beg > mjx-c": {
                        "margin-right": "-.1em"
                    },
                    "mjx-stretchy-h > mjx-end > mjx-c": {
                        "margin-left": "-.1em"
                    },
                    "mjx-stretchy-v": {
                        display: "inline-block"
                    },
                    "mjx-stretchy-v > *": {
                        display: "block"
                    },
                    "mjx-stretchy-v > mjx-beg": {
                        height: 0
                    },
                    "mjx-stretchy-v > mjx-end > mjx-c": {
                        display: "block"
                    },
                    "mjx-stretchy-v > * > mjx-c": {
                        transform: "scaley(1.0000001)",
                        "transform-origin": "left center",
                        overflow: "hidden"
                    },
                    "mjx-stretchy-v > mjx-ext": {
                        display: "block",
                        height: "100%",
                        "box-sizing": "border-box",
                        border: "0px solid transparent",
                        "/* IE */ overflow": "hidden",
                        "/* others */ overflow": "visible clip"
                    },
                    "mjx-stretchy-v > mjx-ext > mjx-c::before": {
                        width: "initial",
                        "box-sizing": "border-box"
                    },
                    "mjx-stretchy-v > mjx-ext > mjx-c": {
                        transform: "scaleY(500) translateY(.075em)",
                        overflow: "visible"
                    },
                    "mjx-mark": {
                        display: "inline-block",
                        height: "0px"
                    }
                }, e1;
            }((0, a1.CommonMoMixin)(s1.CHTMLWrapper));
            e1.CHTMLmo = c1;
        },
        5964: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmpadded = void 0;
            var a1 = r1(5355), l1 = r1(6898), c1 = r1(7238), u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1, r1, n1 = this.standardCHTMLnode(t1), o1 = [], a1 = {}, l1 = i1(this.getDimens(), 9), c1 = l1[2], u1 = l1[3], p1 = l1[4], h1 = l1[5], f1 = l1[6], d1 = l1[7], m1 = l1[8];
                    if (h1 && (a1.width = this.em(c1 + h1)), (u1 || p1) && (a1.margin = this.em(u1) + " 0 " + this.em(p1)), f1 + m1 || d1) {
                        a1.position = "relative";
                        var y1 = this.html("mjx-rbox", {
                            style: {
                                left: this.em(f1 + m1),
                                top: this.em(-d1),
                                "max-width": a1.width
                            }
                        });
                        f1 + m1 && this.childNodes[0].getBBox().pwidth && (this.adaptor.setAttribute(y1, "width", "full"), this.adaptor.setStyle(y1, "left", this.em(f1))), o1.push(y1);
                    }
                    n1 = this.adaptor.append(n1, this.html("mjx-block", {
                        style: a1
                    }, o1));
                    try {
                        for(var g1 = s1(this.childNodes), b1 = g1.next(); !b1.done; b1 = g1.next())b1.value.toCHTML(o1[0] || n1);
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            b1 && !b1.done && (r1 = g1.return) && r1.call(g1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, e1.kind = c1.MmlMpadded.prototype.kind, e1.styles = {
                    "mjx-mpadded": {
                        display: "inline-block"
                    },
                    "mjx-rbox": {
                        display: "inline-block",
                        position: "relative"
                    }
                }, e1;
            }((0, l1.CommonMpaddedMixin)(a1.CHTMLWrapper));
            e1.CHTMLmpadded = u1;
        },
        8776: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmroot = void 0;
            var s1 = r1(5610), a1 = r1(6991), l1 = r1(6145), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.addRoot = function(t1, e1, r1, n1) {
                    e1.toCHTML(t1);
                    var o1 = i1(this.getRootDimens(r1, n1), 3), s1 = o1[0], a1 = o1[1], l1 = o1[2];
                    this.adaptor.setStyle(t1, "verticalAlign", this.em(a1)), this.adaptor.setStyle(t1, "width", this.em(s1)), l1 && this.adaptor.setStyle(this.adaptor.firstChild(t1), "paddingLeft", this.em(l1));
                }, e1.kind = l1.MmlMroot.prototype.kind, e1;
            }((0, a1.CommonMrootMixin)(s1.CHTMLmsqrt));
            e1.CHTMLmroot = c1;
        },
        4798: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLinferredMrow = e1.CHTMLmrow = void 0;
            var s1 = r1(5355), a1 = r1(8411), l1 = r1(8411), c1 = r1(9878), u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1, r1, n1 = this.node.isInferred ? this.chtml = t1 : this.standardCHTMLnode(t1), o1 = !1;
                    try {
                        for(var s1 = i1(this.childNodes), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            l1.toCHTML(n1), l1.bbox.w < 0 && (o1 = !0);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (r1 = s1.return) && r1.call(s1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    if (o1) {
                        var c1 = this.getBBox().w;
                        c1 && (this.adaptor.setStyle(n1, "width", this.em(Math.max(0, c1))), c1 < 0 && this.adaptor.setStyle(n1, "marginRight", this.em(c1)));
                    }
                }, e1.kind = c1.MmlMrow.prototype.kind, e1;
            }((0, a1.CommonMrowMixin)(s1.CHTMLWrapper));
            e1.CHTMLmrow = u1;
            var p1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = c1.MmlInferredMrow.prototype.kind, e1;
            }((0, l1.CommonInferredMrowMixin)(u1));
            e1.CHTMLinferredMrow = p1;
        },
        4597: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLms = void 0;
            var i1 = r1(5355), s1 = r1(4126), a1 = r1(7265), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = a1.MmlMs.prototype.kind, e1;
            }((0, s1.CommonMsMixin)(i1.CHTMLWrapper));
            e1.CHTMLms = l1;
        },
        2970: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmspace = void 0;
            var i1 = r1(5355), s1 = r1(258), a1 = r1(6030), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1 = this.standardCHTMLnode(t1), r1 = this.getBBox(), n1 = r1.w, o1 = r1.h, i1 = r1.d;
                    n1 < 0 && (this.adaptor.setStyle(e1, "marginRight", this.em(n1)), n1 = 0), n1 && this.adaptor.setStyle(e1, "width", this.em(n1)), (o1 = Math.max(0, o1 + i1)) && this.adaptor.setStyle(e1, "height", this.em(Math.max(0, o1))), i1 && this.adaptor.setStyle(e1, "verticalAlign", this.em(-i1));
                }, e1.kind = a1.MmlMspace.prototype.kind, e1;
            }((0, s1.CommonMspaceMixin)(i1.CHTMLWrapper));
            e1.CHTMLmspace = l1;
        },
        5610: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmsqrt = void 0;
            var s1 = r1(5355), a1 = r1(4093), l1 = r1(7131), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1, r1, n1, o1, s1 = this.childNodes[this.surd], a1 = this.childNodes[this.base], l1 = s1.getBBox(), c1 = a1.getOuterBBox(), u1 = i1(this.getPQ(l1), 2)[1], p1 = this.font.params.rule_thickness, h1 = c1.h + u1 + p1, f1 = this.standardCHTMLnode(t1);
                    null != this.root && (n1 = this.adaptor.append(f1, this.html("mjx-root")), o1 = this.childNodes[this.root]);
                    var d1 = this.adaptor.append(f1, this.html("mjx-sqrt", {}, [
                        e1 = this.html("mjx-surd"),
                        r1 = this.html("mjx-box", {
                            style: {
                                paddingTop: this.em(u1)
                            }
                        })
                    ]));
                    this.addRoot(n1, o1, l1, h1), s1.toCHTML(e1), a1.toCHTML(r1), s1.size < 0 && this.adaptor.addClass(d1, "mjx-tall");
                }, e1.prototype.addRoot = function(t1, e1, r1, n1) {}, e1.kind = l1.MmlMsqrt.prototype.kind, e1.styles = {
                    "mjx-root": {
                        display: "inline-block",
                        "white-space": "nowrap"
                    },
                    "mjx-surd": {
                        display: "inline-block",
                        "vertical-align": "top"
                    },
                    "mjx-sqrt": {
                        display: "inline-block",
                        "padding-top": ".07em"
                    },
                    "mjx-sqrt > mjx-box": {
                        "border-top": ".07em solid"
                    },
                    "mjx-sqrt.mjx-tall > mjx-box": {
                        "padding-left": ".3em",
                        "margin-left": "-.3em"
                    }
                }, e1;
            }((0, a1.CommonMsqrtMixin)(s1.CHTMLWrapper));
            e1.CHTMLmsqrt = c1;
        },
        4300: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmsubsup = e1.CHTMLmsup = e1.CHTMLmsub = void 0;
            var s1 = r1(8650), a1 = r1(905), l1 = r1(905), c1 = r1(905), u1 = r1(4461), p1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = u1.MmlMsub.prototype.kind, e1;
            }((0, a1.CommonMsubMixin)(s1.CHTMLscriptbase));
            e1.CHTMLmsub = p1;
            var h1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = u1.MmlMsup.prototype.kind, e1;
            }((0, l1.CommonMsupMixin)(s1.CHTMLscriptbase));
            e1.CHTMLmsup = h1;
            var f1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1 = this.adaptor, r1 = this.standardCHTMLnode(t1), n1 = i1([
                        this.baseChild,
                        this.supChild,
                        this.subChild
                    ], 3), o1 = n1[0], s1 = n1[1], a1 = n1[2], l1 = i1(this.getUVQ(), 3), c1 = l1[1], u1 = l1[2], p1 = {
                        "vertical-align": this.em(c1)
                    };
                    o1.toCHTML(r1);
                    var h1 = e1.append(r1, this.html("mjx-script", {
                        style: p1
                    }));
                    s1.toCHTML(h1), e1.append(h1, this.html("mjx-spacer", {
                        style: {
                            "margin-top": this.em(u1)
                        }
                    })), a1.toCHTML(h1);
                    var f1 = this.getAdjustedIc();
                    f1 && e1.setStyle(s1.chtml, "marginLeft", this.em(f1 / s1.bbox.rscale)), this.baseRemoveIc && e1.setStyle(h1, "marginLeft", this.em(-this.baseIc));
                }, e1.kind = u1.MmlMsubsup.prototype.kind, e1.styles = {
                    "mjx-script": {
                        display: "inline-block",
                        "padding-right": ".05em",
                        "padding-left": ".033em"
                    },
                    "mjx-script > mjx-spacer": {
                        display: "block"
                    }
                }, e1;
            }((0, c1.CommonMsubsupMixin)(s1.CHTMLscriptbase));
            e1.CHTMLmsubsup = f1;
        },
        8002: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmtable = void 0;
            var a1 = r1(5355), l1 = r1(6237), c1 = r1(1349), u1 = r1(505), p1 = function(t1) {
                function e1(e1, r1, n1) {
                    void 0 === n1 && (n1 = null);
                    var o1 = t1.call(this, e1, r1, n1) || this;
                    return o1.itable = o1.html("mjx-itable"), o1.labels = o1.html("mjx-itable"), o1;
                }
                return o1(e1, t1), e1.prototype.getAlignShift = function() {
                    var e1 = t1.prototype.getAlignShift.call(this);
                    return this.isTop || (e1[1] = 0), e1;
                }, e1.prototype.toCHTML = function(t1) {
                    var e1, r1, n1 = this.standardCHTMLnode(t1);
                    this.adaptor.append(n1, this.html("mjx-table", {}, [
                        this.itable
                    ]));
                    try {
                        for(var o1 = i1(this.childNodes), s1 = o1.next(); !s1.done; s1 = o1.next())s1.value.toCHTML(this.itable);
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    this.padRows(), this.handleColumnSpacing(), this.handleColumnLines(), this.handleColumnWidths(), this.handleRowSpacing(), this.handleRowLines(), this.handleRowHeights(), this.handleFrame(), this.handleWidth(), this.handleLabels(), this.handleAlign(), this.handleJustify(), this.shiftColor();
                }, e1.prototype.shiftColor = function() {
                    var t1 = this.adaptor, e1 = t1.getStyle(this.chtml, "backgroundColor");
                    e1 && (t1.setStyle(this.chtml, "backgroundColor", ""), t1.setStyle(this.itable, "backgroundColor", e1));
                }, e1.prototype.padRows = function() {
                    var t1, e1, r1 = this.adaptor;
                    try {
                        for(var n1 = i1(r1.childNodes(this.itable)), o1 = n1.next(); !o1.done; o1 = n1.next())for(var s1 = o1.value; r1.childNodes(s1).length < this.numCols;)r1.append(s1, this.html("mjx-mtd", {
                            extra: !0
                        }));
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.prototype.handleColumnSpacing = function() {
                    var t1, e1, r1, n1, o1 = this.childNodes[0] ? 1 / this.childNodes[0].getBBox().rscale : 1, s1 = this.getEmHalfSpacing(this.fSpace[0], this.cSpace, o1), a1 = this.frame;
                    try {
                        for(var l1 = i1(this.tableRows), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value, p1 = 0;
                            try {
                                for(var h1 = (r1 = void 0, i1(u1.tableCells)), f1 = h1.next(); !f1.done; f1 = h1.next()){
                                    var d1 = f1.value, m1 = s1[p1++], y1 = s1[p1], g1 = d1 ? d1.chtml : this.adaptor.childNodes(u1.chtml)[p1];
                                    (p1 > 1 && "0.4em" !== m1 || a1 && 1 === p1) && this.adaptor.setStyle(g1, "paddingLeft", m1), (p1 < this.numCols && "0.4em" !== y1 || a1 && p1 === this.numCols) && this.adaptor.setStyle(g1, "paddingRight", y1);
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    f1 && !f1.done && (n1 = h1.return) && n1.call(h1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (e1 = l1.return) && e1.call(l1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.prototype.handleColumnLines = function() {
                    var t1, e1, r1, n1;
                    if ("none" !== this.node.attributes.get("columnlines")) {
                        var o1 = this.getColumnAttributes("columnlines");
                        try {
                            for(var s1 = i1(this.childNodes), a1 = s1.next(); !a1.done; a1 = s1.next()){
                                var l1 = a1.value, c1 = 0;
                                try {
                                    for(var u1 = (r1 = void 0, i1(this.adaptor.childNodes(l1.chtml).slice(1))), p1 = u1.next(); !p1.done; p1 = u1.next()){
                                        var h1 = p1.value, f1 = o1[c1++];
                                        "none" !== f1 && this.adaptor.setStyle(h1, "borderLeft", ".07em " + f1);
                                    }
                                } catch (t1) {
                                    r1 = {
                                        error: t1
                                    };
                                } finally{
                                    try {
                                        p1 && !p1.done && (n1 = u1.return) && n1.call(u1);
                                    } finally{
                                        if (r1) throw r1.error;
                                    }
                                }
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (e1 = s1.return) && e1.call(s1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }
                }, e1.prototype.handleColumnWidths = function() {
                    var t1, e1, r1, n1;
                    try {
                        for(var o1 = i1(this.childNodes), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value, l1 = 0;
                            try {
                                for(var c1 = (r1 = void 0, i1(this.adaptor.childNodes(a1.chtml))), u1 = c1.next(); !u1.done; u1 = c1.next()){
                                    var p1 = u1.value, h1 = this.cWidths[l1++];
                                    if (null !== h1) {
                                        var f1 = "number" == typeof h1 ? this.em(h1) : h1;
                                        this.adaptor.setStyle(p1, "width", f1), this.adaptor.setStyle(p1, "maxWidth", f1), this.adaptor.setStyle(p1, "minWidth", f1);
                                    }
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    u1 && !u1.done && (n1 = c1.return) && n1.call(c1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.prototype.handleRowSpacing = function() {
                    var t1, e1, r1, n1, o1 = this.childNodes[0] ? 1 / this.childNodes[0].getBBox().rscale : 1, s1 = this.getEmHalfSpacing(this.fSpace[1], this.rSpace, o1), a1 = this.frame, l1 = 0;
                    try {
                        for(var c1 = i1(this.childNodes), u1 = c1.next(); !u1.done; u1 = c1.next()){
                            var p1 = u1.value, h1 = s1[l1++], f1 = s1[l1];
                            try {
                                for(var d1 = (r1 = void 0, i1(p1.childNodes)), m1 = d1.next(); !m1.done; m1 = d1.next()){
                                    var y1 = m1.value;
                                    (l1 > 1 && "0.215em" !== h1 || a1 && 1 === l1) && this.adaptor.setStyle(y1.chtml, "paddingTop", h1), (l1 < this.numRows && "0.215em" !== f1 || a1 && l1 === this.numRows) && this.adaptor.setStyle(y1.chtml, "paddingBottom", f1);
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    m1 && !m1.done && (n1 = d1.return) && n1.call(d1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            u1 && !u1.done && (e1 = c1.return) && e1.call(c1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.prototype.handleRowLines = function() {
                    var t1, e1, r1, n1;
                    if ("none" !== this.node.attributes.get("rowlines")) {
                        var o1 = this.getRowAttributes("rowlines"), s1 = 0;
                        try {
                            for(var a1 = i1(this.childNodes.slice(1)), l1 = a1.next(); !l1.done; l1 = a1.next()){
                                var c1 = l1.value, u1 = o1[s1++];
                                if ("none" !== u1) try {
                                    for(var p1 = (r1 = void 0, i1(this.adaptor.childNodes(c1.chtml))), h1 = p1.next(); !h1.done; h1 = p1.next()){
                                        var f1 = h1.value;
                                        this.adaptor.setStyle(f1, "borderTop", ".07em " + u1);
                                    }
                                } catch (t1) {
                                    r1 = {
                                        error: t1
                                    };
                                } finally{
                                    try {
                                        h1 && !h1.done && (n1 = p1.return) && n1.call(p1);
                                    } finally{
                                        if (r1) throw r1.error;
                                    }
                                }
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                l1 && !l1.done && (e1 = a1.return) && e1.call(a1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }
                }, e1.prototype.handleRowHeights = function() {
                    this.node.attributes.get("equalrows") && this.handleEqualRows();
                }, e1.prototype.handleEqualRows = function() {
                    for(var t1 = this.getRowHalfSpacing(), e1 = this.getTableData(), r1 = e1.H, n1 = e1.D, o1 = e1.NH, i1 = e1.ND, s1 = this.getEqualRowHeight(), a1 = 0; a1 < this.numRows; a1++){
                        var l1 = this.childNodes[a1];
                        this.setRowHeight(l1, s1 + t1[a1] + t1[a1 + 1] + this.rLines[a1]), s1 !== o1[a1] + i1[a1] && this.setRowBaseline(l1, s1, (s1 - r1[a1] + n1[a1]) / 2);
                    }
                }, e1.prototype.setRowHeight = function(t1, e1) {
                    this.adaptor.setStyle(t1.chtml, "height", this.em(e1));
                }, e1.prototype.setRowBaseline = function(t1, e1, r1) {
                    var n1, o1, s1 = t1.node.attributes.get("rowalign");
                    try {
                        for(var a1 = i1(t1.childNodes), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value;
                            if (this.setCellBaseline(c1, s1, e1, r1)) break;
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (o1 = a1.return) && o1.call(a1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }, e1.prototype.setCellBaseline = function(t1, e1, r1, n1) {
                    var o1 = t1.node.attributes.get("rowalign");
                    if ("baseline" === o1 || "axis" === o1) {
                        var i1 = this.adaptor, s1 = i1.lastChild(t1.chtml);
                        i1.setStyle(s1, "height", this.em(r1)), i1.setStyle(s1, "verticalAlign", this.em(-n1));
                        var a1 = t1.parent;
                        if (!(a1.node.isKind("mlabeledtr") && t1 === a1.childNodes[0] || "baseline" !== e1 && "axis" !== e1)) return !0;
                    }
                    return !1;
                }, e1.prototype.handleFrame = function() {
                    this.frame && this.fLine && this.adaptor.setStyle(this.itable, "border", ".07em " + this.node.attributes.get("frame"));
                }, e1.prototype.handleWidth = function() {
                    var t1 = this.adaptor, e1 = this.getBBox(), r1 = e1.w, n1 = e1.L, o1 = e1.R;
                    t1.setStyle(this.chtml, "minWidth", this.em(n1 + r1 + o1));
                    var i1 = this.node.attributes.get("width");
                    if ((0, u1.isPercent)(i1)) t1.setStyle(this.chtml, "width", ""), t1.setAttribute(this.chtml, "width", "full");
                    else if (!this.hasLabels) {
                        if ("auto" === i1) return;
                        i1 = this.em(this.length2em(i1) + 2 * this.fLine);
                    }
                    var s1 = t1.firstChild(this.chtml);
                    if (t1.setStyle(s1, "width", i1), t1.setStyle(s1, "minWidth", this.em(r1)), n1 || o1) {
                        t1.setStyle(this.chtml, "margin", "");
                        var a1 = this.node.attributes.get("data-width-includes-label") ? "padding" : "margin";
                        n1 === o1 ? t1.setStyle(s1, a1, "0 " + this.em(o1)) : t1.setStyle(s1, a1, "0 " + this.em(o1) + " 0 " + this.em(n1));
                    }
                    t1.setAttribute(this.itable, "width", "full");
                }, e1.prototype.handleAlign = function() {
                    var t1 = s1(this.getAlignmentRow(), 2), e1 = t1[0], r1 = t1[1];
                    if (null === r1) "axis" !== e1 && this.adaptor.setAttribute(this.chtml, "align", e1);
                    else {
                        var n1 = this.getVerticalPosition(r1, e1);
                        this.adaptor.setAttribute(this.chtml, "align", "top"), this.adaptor.setStyle(this.chtml, "verticalAlign", this.em(n1));
                    }
                }, e1.prototype.handleJustify = function() {
                    var t1 = this.getAlignShift()[0];
                    "center" !== t1 && this.adaptor.setAttribute(this.chtml, "justify", t1);
                }, e1.prototype.handleLabels = function() {
                    if (this.hasLabels) {
                        var t1 = this.labels, e1 = this.node.attributes, r1 = this.adaptor, n1 = e1.get("side");
                        r1.setAttribute(this.chtml, "side", n1), r1.setAttribute(t1, "align", n1), r1.setStyle(t1, n1, "0");
                        var o1 = s1(this.addLabelPadding(n1), 2), i1 = o1[0], a1 = o1[1];
                        if (a1) {
                            var l1 = r1.firstChild(this.chtml);
                            this.setIndent(l1, i1, a1);
                        }
                        this.updateRowHeights(), this.addLabelSpacing();
                    }
                }, e1.prototype.addLabelPadding = function(t1) {
                    var e1 = s1(this.getPadAlignShift(t1), 3), r1 = e1[1], n1 = e1[2], o1 = {};
                    if ("right" === t1 && !this.node.attributes.get("data-width-includes-label")) {
                        var i1 = this.node.attributes.get("width"), a1 = this.getBBox(), l1 = a1.w, c1 = a1.L, p1 = a1.R;
                        o1.style = {
                            width: (0, u1.isPercent)(i1) ? "calc(" + i1 + " + " + this.em(c1 + p1) + ")" : this.em(c1 + l1 + p1)
                        };
                    }
                    return this.adaptor.append(this.chtml, this.html("mjx-labels", o1, [
                        this.labels
                    ])), [
                        r1,
                        n1
                    ];
                }, e1.prototype.updateRowHeights = function() {
                    for(var t1 = this.getTableData(), e1 = t1.H, r1 = t1.D, n1 = t1.NH, o1 = t1.ND, i1 = this.getRowHalfSpacing(), s1 = 0; s1 < this.numRows; s1++){
                        var a1 = this.childNodes[s1];
                        this.setRowHeight(a1, e1[s1] + r1[s1] + i1[s1] + i1[s1 + 1] + this.rLines[s1]), e1[s1] !== n1[s1] || r1[s1] !== o1[s1] ? this.setRowBaseline(a1, e1[s1] + r1[s1], r1[s1]) : a1.node.isKind("mlabeledtr") && this.setCellBaseline(a1.childNodes[0], "", e1[s1] + r1[s1], r1[s1]);
                    }
                }, e1.prototype.addLabelSpacing = function() {
                    for(var t1 = this.adaptor, e1 = this.node.attributes.get("equalrows"), r1 = this.getTableData(), n1 = r1.H, o1 = r1.D, i1 = e1 ? this.getEqualRowHeight() : 0, s1 = this.getRowHalfSpacing(), a1 = this.fLine, l1 = t1.firstChild(this.labels), c1 = 0; c1 < this.numRows; c1++)this.childNodes[c1].node.isKind("mlabeledtr") ? (a1 && t1.insert(this.html("mjx-mtr", {
                        style: {
                            height: this.em(a1)
                        }
                    }), l1), t1.setStyle(l1, "height", this.em((e1 ? i1 : n1[c1] + o1[c1]) + s1[c1] + s1[c1 + 1])), l1 = t1.next(l1), a1 = this.rLines[c1]) : a1 += s1[c1] + (e1 ? i1 : n1[c1] + o1[c1]) + s1[c1 + 1] + this.rLines[c1];
                }, e1.kind = c1.MmlMtable.prototype.kind, e1.styles = {
                    "mjx-mtable": {
                        "vertical-align": ".25em",
                        "text-align": "center",
                        position: "relative",
                        "box-sizing": "border-box",
                        "border-spacing": 0,
                        "border-collapse": "collapse"
                    },
                    'mjx-mstyle[size="s"] mjx-mtable': {
                        "vertical-align": ".354em"
                    },
                    "mjx-labels": {
                        position: "absolute",
                        left: 0,
                        top: 0
                    },
                    "mjx-table": {
                        display: "inline-block",
                        "vertical-align": "-.5ex",
                        "box-sizing": "border-box"
                    },
                    "mjx-table > mjx-itable": {
                        "vertical-align": "middle",
                        "text-align": "left",
                        "box-sizing": "border-box"
                    },
                    "mjx-labels > mjx-itable": {
                        position: "absolute",
                        top: 0
                    },
                    'mjx-mtable[justify="left"]': {
                        "text-align": "left"
                    },
                    'mjx-mtable[justify="right"]': {
                        "text-align": "right"
                    },
                    'mjx-mtable[justify="left"][side="left"]': {
                        "padding-right": "0 ! important"
                    },
                    'mjx-mtable[justify="left"][side="right"]': {
                        "padding-left": "0 ! important"
                    },
                    'mjx-mtable[justify="right"][side="left"]': {
                        "padding-right": "0 ! important"
                    },
                    'mjx-mtable[justify="right"][side="right"]': {
                        "padding-left": "0 ! important"
                    },
                    "mjx-mtable[align]": {
                        "vertical-align": "baseline"
                    },
                    'mjx-mtable[align="top"] > mjx-table': {
                        "vertical-align": "top"
                    },
                    'mjx-mtable[align="bottom"] > mjx-table': {
                        "vertical-align": "bottom"
                    },
                    'mjx-mtable[side="right"] mjx-labels': {
                        "min-width": "100%"
                    }
                }, e1;
            }((0, l1.CommonMtableMixin)(a1.CHTMLWrapper));
            e1.CHTMLmtable = p1;
        },
        7056: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmtd = void 0;
            var i1 = r1(5355), s1 = r1(5164), a1 = r1(4359), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    t1.prototype.toCHTML.call(this, e1);
                    var r1 = this.node.attributes.get("rowalign"), n1 = this.node.attributes.get("columnalign");
                    r1 !== this.parent.node.attributes.get("rowalign") && this.adaptor.setAttribute(this.chtml, "rowalign", r1), "center" === n1 || "mlabeledtr" === this.parent.kind && this === this.parent.childNodes[0] && n1 === this.parent.parent.node.attributes.get("side") || this.adaptor.setStyle(this.chtml, "textAlign", n1), this.parent.parent.node.getProperty("useHeight") && this.adaptor.append(this.chtml, this.html("mjx-tstrut"));
                }, e1.kind = a1.MmlMtd.prototype.kind, e1.styles = {
                    "mjx-mtd": {
                        display: "table-cell",
                        "text-align": "center",
                        padding: ".215em .4em"
                    },
                    "mjx-mtd:first-child": {
                        "padding-left": 0
                    },
                    "mjx-mtd:last-child": {
                        "padding-right": 0
                    },
                    "mjx-mtable > * > mjx-itable > *:first-child > mjx-mtd": {
                        "padding-top": 0
                    },
                    "mjx-mtable > * > mjx-itable > *:last-child > mjx-mtd": {
                        "padding-bottom": 0
                    },
                    "mjx-tstrut": {
                        display: "inline-block",
                        height: "1em",
                        "vertical-align": "-.25em"
                    },
                    'mjx-labels[align="left"] > mjx-mtr > mjx-mtd': {
                        "text-align": "left"
                    },
                    'mjx-labels[align="right"] > mjx-mtr > mjx-mtd': {
                        "text-align": "right"
                    },
                    "mjx-mtd[extra]": {
                        padding: 0
                    },
                    'mjx-mtd[rowalign="top"]': {
                        "vertical-align": "top"
                    },
                    'mjx-mtd[rowalign="center"]': {
                        "vertical-align": "middle"
                    },
                    'mjx-mtd[rowalign="bottom"]': {
                        "vertical-align": "bottom"
                    },
                    'mjx-mtd[rowalign="baseline"]': {
                        "vertical-align": "baseline"
                    },
                    'mjx-mtd[rowalign="axis"]': {
                        "vertical-align": ".25em"
                    }
                }, e1;
            }((0, s1.CommonMtdMixin)(i1.CHTMLWrapper));
            e1.CHTMLmtd = l1;
        },
        1259: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmtext = void 0;
            var i1 = r1(5355), s1 = r1(6319), a1 = r1(4770), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = a1.MmlMtext.prototype.kind, e1;
            }((0, s1.CommonMtextMixin)(i1.CHTMLWrapper));
            e1.CHTMLmtext = l1;
        },
        3571: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmlabeledtr = e1.CHTMLmtr = void 0;
            var i1 = r1(5355), s1 = r1(5766), a1 = r1(5766), l1 = r1(5022), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    t1.prototype.toCHTML.call(this, e1);
                    var r1 = this.node.attributes.get("rowalign");
                    "baseline" !== r1 && this.adaptor.setAttribute(this.chtml, "rowalign", r1);
                }, e1.kind = l1.MmlMtr.prototype.kind, e1.styles = {
                    "mjx-mtr": {
                        display: "table-row"
                    },
                    'mjx-mtr[rowalign="top"] > mjx-mtd': {
                        "vertical-align": "top"
                    },
                    'mjx-mtr[rowalign="center"] > mjx-mtd': {
                        "vertical-align": "middle"
                    },
                    'mjx-mtr[rowalign="bottom"] > mjx-mtd': {
                        "vertical-align": "bottom"
                    },
                    'mjx-mtr[rowalign="baseline"] > mjx-mtd': {
                        "vertical-align": "baseline"
                    },
                    'mjx-mtr[rowalign="axis"] > mjx-mtd': {
                        "vertical-align": ".25em"
                    }
                }, e1;
            }((0, s1.CommonMtrMixin)(i1.CHTMLWrapper));
            e1.CHTMLmtr = c1;
            var u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    t1.prototype.toCHTML.call(this, e1);
                    var r1 = this.adaptor.firstChild(this.chtml);
                    if (r1) {
                        this.adaptor.remove(r1);
                        var n1 = this.node.attributes.get("rowalign"), o1 = "baseline" !== n1 && "axis" !== n1 ? {
                            rowalign: n1
                        } : {}, i1 = this.html("mjx-mtr", o1, [
                            r1
                        ]);
                        this.adaptor.append(this.parent.labels, i1);
                    }
                }, e1.prototype.markUsed = function() {
                    t1.prototype.markUsed.call(this), this.jax.wrapperUsage.add(c1.kind);
                }, e1.kind = l1.MmlMlabeledtr.prototype.kind, e1.styles = {
                    "mjx-mlabeledtr": {
                        display: "table-row"
                    },
                    'mjx-mlabeledtr[rowalign="top"] > mjx-mtd': {
                        "vertical-align": "top"
                    },
                    'mjx-mlabeledtr[rowalign="center"] > mjx-mtd': {
                        "vertical-align": "middle"
                    },
                    'mjx-mlabeledtr[rowalign="bottom"] > mjx-mtd': {
                        "vertical-align": "bottom"
                    },
                    'mjx-mlabeledtr[rowalign="baseline"] > mjx-mtd': {
                        "vertical-align": "baseline"
                    },
                    'mjx-mlabeledtr[rowalign="axis"] > mjx-mtd': {
                        "vertical-align": ".25em"
                    }
                }, e1;
            }((0, a1.CommonMlabeledtrMixin)(c1));
            e1.CHTMLmlabeledtr = u1;
        },
        6590: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLmunderover = e1.CHTMLmover = e1.CHTMLmunder = void 0;
            var i1 = r1(4300), s1 = r1(1971), a1 = r1(1971), l1 = r1(1971), c1 = r1(5184), u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    if (this.hasMovableLimits()) return t1.prototype.toCHTML.call(this, e1), void this.adaptor.setAttribute(this.chtml, "limits", "false");
                    this.chtml = this.standardCHTMLnode(e1);
                    var r1 = this.adaptor.append(this.adaptor.append(this.chtml, this.html("mjx-row")), this.html("mjx-base")), n1 = this.adaptor.append(this.adaptor.append(this.chtml, this.html("mjx-row")), this.html("mjx-under"));
                    this.baseChild.toCHTML(r1), this.scriptChild.toCHTML(n1);
                    var o1 = this.baseChild.getOuterBBox(), i1 = this.scriptChild.getOuterBBox(), s1 = this.getUnderKV(o1, i1)[0], a1 = this.isLineBelow ? 0 : this.getDelta(!0);
                    this.adaptor.setStyle(n1, "paddingTop", this.em(s1)), this.setDeltaW([
                        r1,
                        n1
                    ], this.getDeltaW([
                        o1,
                        i1
                    ], [
                        0,
                        -a1
                    ])), this.adjustUnderDepth(n1, i1);
                }, e1.kind = c1.MmlMunder.prototype.kind, e1.styles = {
                    "mjx-over": {
                        "text-align": "left"
                    },
                    'mjx-munder:not([limits="false"])': {
                        display: "inline-table"
                    },
                    "mjx-munder > mjx-row": {
                        "text-align": "left"
                    },
                    "mjx-under": {
                        "padding-bottom": ".1em"
                    }
                }, e1;
            }((0, s1.CommonMunderMixin)(i1.CHTMLmsub));
            e1.CHTMLmunder = u1;
            var p1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    if (this.hasMovableLimits()) return t1.prototype.toCHTML.call(this, e1), void this.adaptor.setAttribute(this.chtml, "limits", "false");
                    this.chtml = this.standardCHTMLnode(e1);
                    var r1 = this.adaptor.append(this.chtml, this.html("mjx-over")), n1 = this.adaptor.append(this.chtml, this.html("mjx-base"));
                    this.scriptChild.toCHTML(r1), this.baseChild.toCHTML(n1);
                    var o1 = this.scriptChild.getOuterBBox(), i1 = this.baseChild.getOuterBBox();
                    this.adjustBaseHeight(n1, i1);
                    var s1 = this.getOverKU(i1, o1)[0], a1 = this.isLineAbove ? 0 : this.getDelta();
                    this.adaptor.setStyle(r1, "paddingBottom", this.em(s1)), this.setDeltaW([
                        n1,
                        r1
                    ], this.getDeltaW([
                        i1,
                        o1
                    ], [
                        0,
                        a1
                    ])), this.adjustOverDepth(r1, o1);
                }, e1.kind = c1.MmlMover.prototype.kind, e1.styles = {
                    'mjx-mover:not([limits="false"])': {
                        "padding-top": ".1em"
                    },
                    'mjx-mover:not([limits="false"]) > *': {
                        display: "block",
                        "text-align": "left"
                    }
                }, e1;
            }((0, a1.CommonMoverMixin)(i1.CHTMLmsup));
            e1.CHTMLmover = p1;
            var h1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    if (this.hasMovableLimits()) return t1.prototype.toCHTML.call(this, e1), void this.adaptor.setAttribute(this.chtml, "limits", "false");
                    this.chtml = this.standardCHTMLnode(e1);
                    var r1 = this.adaptor.append(this.chtml, this.html("mjx-over")), n1 = this.adaptor.append(this.adaptor.append(this.chtml, this.html("mjx-box")), this.html("mjx-munder")), o1 = this.adaptor.append(this.adaptor.append(n1, this.html("mjx-row")), this.html("mjx-base")), i1 = this.adaptor.append(this.adaptor.append(n1, this.html("mjx-row")), this.html("mjx-under"));
                    this.overChild.toCHTML(r1), this.baseChild.toCHTML(o1), this.underChild.toCHTML(i1);
                    var s1 = this.overChild.getOuterBBox(), a1 = this.baseChild.getOuterBBox(), l1 = this.underChild.getOuterBBox();
                    this.adjustBaseHeight(o1, a1);
                    var c1 = this.getOverKU(a1, s1)[0], u1 = this.getUnderKV(a1, l1)[0], p1 = this.getDelta();
                    this.adaptor.setStyle(r1, "paddingBottom", this.em(c1)), this.adaptor.setStyle(i1, "paddingTop", this.em(u1)), this.setDeltaW([
                        o1,
                        i1,
                        r1
                    ], this.getDeltaW([
                        a1,
                        l1,
                        s1
                    ], [
                        0,
                        this.isLineBelow ? 0 : -p1,
                        this.isLineAbove ? 0 : p1
                    ])), this.adjustOverDepth(r1, s1), this.adjustUnderDepth(i1, l1);
                }, e1.prototype.markUsed = function() {
                    t1.prototype.markUsed.call(this), this.jax.wrapperUsage.add(i1.CHTMLmsubsup.kind);
                }, e1.kind = c1.MmlMunderover.prototype.kind, e1.styles = {
                    'mjx-munderover:not([limits="false"])': {
                        "padding-top": ".1em"
                    },
                    'mjx-munderover:not([limits="false"]) > *': {
                        display: "block"
                    }
                }, e1;
            }((0, l1.CommonMunderoverMixin)(i1.CHTMLmsubsup));
            e1.CHTMLmunderover = h1;
        },
        8650: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLscriptbase = void 0;
            var a1 = r1(5355), l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    this.chtml = this.standardCHTMLnode(t1);
                    var e1 = i1(this.getOffset(), 2), r1 = e1[0], n1 = e1[1], o1 = r1 - (this.baseRemoveIc ? this.baseIc : 0), s1 = {
                        "vertical-align": this.em(n1)
                    };
                    o1 && (s1["margin-left"] = this.em(o1)), this.baseChild.toCHTML(this.chtml), this.scriptChild.toCHTML(this.adaptor.append(this.chtml, this.html("mjx-script", {
                        style: s1
                    })));
                }, e1.prototype.setDeltaW = function(t1, e1) {
                    for(var r1 = 0; r1 < e1.length; r1++)e1[r1] && this.adaptor.setStyle(t1[r1], "paddingLeft", this.em(e1[r1]));
                }, e1.prototype.adjustOverDepth = function(t1, e1) {
                    e1.d >= 0 || this.adaptor.setStyle(t1, "marginBottom", this.em(e1.d * e1.rscale));
                }, e1.prototype.adjustUnderDepth = function(t1, e1) {
                    var r1, n1;
                    if (!(e1.d >= 0)) {
                        var o1 = this.adaptor, i1 = this.em(e1.d), a1 = this.html("mjx-box", {
                            style: {
                                "margin-bottom": i1,
                                "vertical-align": i1
                            }
                        });
                        try {
                            for(var l1 = s1(o1.childNodes(o1.firstChild(t1))), c1 = l1.next(); !c1.done; c1 = l1.next()){
                                var u1 = c1.value;
                                o1.append(a1, u1);
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                c1 && !c1.done && (n1 = l1.return) && n1.call(l1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                        o1.append(o1.firstChild(t1), a1);
                    }
                }, e1.prototype.adjustBaseHeight = function(t1, e1) {
                    if (this.node.attributes.get("accent")) {
                        var r1 = this.font.params.x_height * e1.scale;
                        e1.h < r1 && (this.adaptor.setStyle(t1, "paddingTop", this.em(r1 - e1.h)), e1.h = r1);
                    }
                }, e1.kind = "scriptbase", e1;
            }((0, r1(167).CommonScriptbaseMixin)(a1.CHTMLWrapper));
            e1.CHTMLscriptbase = l1;
        },
        421: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CHTMLxml = e1.CHTMLannotationXML = e1.CHTMLannotation = e1.CHTMLsemantics = void 0;
            var i1 = r1(5355), s1 = r1(5806), a1 = r1(9102), l1 = r1(9007), c1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    var e1 = this.standardCHTMLnode(t1);
                    this.childNodes.length && this.childNodes[0].toCHTML(e1);
                }, e1.kind = a1.MmlSemantics.prototype.kind, e1;
            }((0, s1.CommonSemanticsMixin)(i1.CHTMLWrapper));
            e1.CHTMLsemantics = c1;
            var u1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(e1) {
                    t1.prototype.toCHTML.call(this, e1);
                }, e1.prototype.computeBBox = function() {
                    return this.bbox;
                }, e1.kind = a1.MmlAnnotation.prototype.kind, e1;
            }(i1.CHTMLWrapper);
            e1.CHTMLannotation = u1;
            var p1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.kind = a1.MmlAnnotationXML.prototype.kind, e1.styles = {
                    "mjx-annotation-xml": {
                        "font-family": "initial",
                        "line-height": "normal"
                    }
                }, e1;
            }(i1.CHTMLWrapper);
            e1.CHTMLannotationXML = p1;
            var h1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.toCHTML = function(t1) {
                    this.chtml = this.adaptor.append(t1, this.adaptor.clone(this.node.getXML()));
                }, e1.prototype.computeBBox = function(t1, e1) {
                    void 0 === e1 && (e1 = !1);
                    var r1 = this.jax.measureXMLnode(this.node.getXML()), n1 = r1.w, o1 = r1.h, i1 = r1.d;
                    t1.w = n1, t1.h = o1, t1.d = i1;
                }, e1.prototype.getStyles = function() {}, e1.prototype.getScale = function() {}, e1.prototype.getVariant = function() {}, e1.kind = l1.XMLNode.prototype.kind, e1.autoStyle = !1, e1;
            }(i1.CHTMLWrapper);
            e1.CHTMLxml = h1;
        },
        2760: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TeXFont = void 0;
            var s1 = r1(8042), a1 = r1(5920), l1 = r1(4005), c1 = r1(1015), u1 = r1(4515), p1 = r1(6555), h1 = r1(2183), f1 = r1(3490), d1 = r1(9056), m1 = r1(3019), y1 = r1(2713), g1 = r1(7517), b1 = r1(4182), v1 = r1(2679), _1 = r1(5469), S1 = r1(7563), O1 = r1(9409), M1 = r1(775), x1 = r1(9551), E1 = r1(7907), A1 = r1(9659), C1 = r1(98), T1 = r1(6275), N1 = r1(6530), w1 = r1(4409), L1 = r1(5292), I1 = r1(9124), P1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.defaultCssFamilyPrefix = "MJXZERO", e1.defaultVariantClasses = {
                    normal: "mjx-n",
                    bold: "mjx-b",
                    italic: "mjx-i",
                    "bold-italic": "mjx-b mjx-i",
                    "double-struck": "mjx-ds mjx-b",
                    fraktur: "mjx-fr",
                    "bold-fraktur": "mjx-fr mjx-b",
                    script: "mjx-sc mjx-i",
                    "bold-script": "mjx-sc mjx-b mjx-i",
                    "sans-serif": "mjx-ss",
                    "bold-sans-serif": "mjx-ss mjx-b",
                    "sans-serif-italic": "mjx-ss mjx-i",
                    "sans-serif-bold-italic": "mjx-ss mjx-b mjx-i",
                    monospace: "mjx-ty",
                    "-smallop": "mjx-sop",
                    "-largeop": "mjx-lop",
                    "-size3": "mjx-s3",
                    "-size4": "mjx-s4",
                    "-tex-calligraphic": "mjx-cal mjx-i",
                    "-tex-bold-calligraphic": "mjx-cal mjx-b",
                    "-tex-mathit": "mjx-mit mjx-i",
                    "-tex-oldstyle": "mjx-os",
                    "-tex-bold-oldstyle": "mjx-os mjx-b",
                    "-tex-variant": "mjx-var"
                }, e1.defaultVariantLetters = {
                    normal: "",
                    bold: "B",
                    italic: "MI",
                    "bold-italic": "BI",
                    "double-struck": "A",
                    fraktur: "FR",
                    "bold-fraktur": "FRB",
                    script: "SC",
                    "bold-script": "SCB",
                    "sans-serif": "SS",
                    "bold-sans-serif": "SSB",
                    "sans-serif-italic": "SSI",
                    "sans-serif-bold-italic": "SSBI",
                    monospace: "T",
                    "-smallop": "S1",
                    "-largeop": "S2",
                    "-size3": "S3",
                    "-size4": "S4",
                    "-tex-calligraphic": "C",
                    "-tex-bold-calligraphic": "CB",
                    "-tex-mathit": "MI",
                    "-tex-oldstyle": "C",
                    "-tex-bold-oldstyle": "CB",
                    "-tex-variant": "A"
                }, e1.defaultDelimiters = I1.delimiters, e1.defaultChars = {
                    normal: y1.normal,
                    bold: c1.bold,
                    italic: f1.italic,
                    "bold-italic": l1.boldItalic,
                    "double-struck": u1.doubleStruck,
                    fraktur: h1.fraktur,
                    "bold-fraktur": p1.frakturBold,
                    script: O1.script,
                    "bold-script": S1.scriptBold,
                    "sans-serif": _1.sansSerif,
                    "bold-sans-serif": b1.sansSerifBold,
                    "sans-serif-italic": v1.sansSerifItalic,
                    "sans-serif-bold-italic": g1.sansSerifBoldItalic,
                    monospace: m1.monospace,
                    "-smallop": M1.smallop,
                    "-largeop": d1.largeop,
                    "-size3": N1.texSize3,
                    "-size4": w1.texSize4,
                    "-tex-calligraphic": E1.texCalligraphic,
                    "-tex-bold-calligraphic": x1.texCalligraphicBold,
                    "-tex-mathit": A1.texMathit,
                    "-tex-oldstyle": T1.texOldstyle,
                    "-tex-bold-oldstyle": C1.texOldstyleBold,
                    "-tex-variant": L1.texVariant
                }, e1.defaultStyles = i1(i1({}, s1.CHTMLFontData.defaultStyles), {
                    ".MJX-TEX": {
                        "font-family": "MJXZERO, MJXTEX"
                    },
                    ".TEX-B": {
                        "font-family": "MJXZERO, MJXTEX-B"
                    },
                    ".TEX-I": {
                        "font-family": "MJXZERO, MJXTEX-I"
                    },
                    ".TEX-MI": {
                        "font-family": "MJXZERO, MJXTEX-MI"
                    },
                    ".TEX-BI": {
                        "font-family": "MJXZERO, MJXTEX-BI"
                    },
                    ".TEX-S1": {
                        "font-family": "MJXZERO, MJXTEX-S1"
                    },
                    ".TEX-S2": {
                        "font-family": "MJXZERO, MJXTEX-S2"
                    },
                    ".TEX-S3": {
                        "font-family": "MJXZERO, MJXTEX-S3"
                    },
                    ".TEX-S4": {
                        "font-family": "MJXZERO, MJXTEX-S4"
                    },
                    ".TEX-A": {
                        "font-family": "MJXZERO, MJXTEX-A"
                    },
                    ".TEX-C": {
                        "font-family": "MJXZERO, MJXTEX-C"
                    },
                    ".TEX-CB": {
                        "font-family": "MJXZERO, MJXTEX-CB"
                    },
                    ".TEX-FR": {
                        "font-family": "MJXZERO, MJXTEX-FR"
                    },
                    ".TEX-FRB": {
                        "font-family": "MJXZERO, MJXTEX-FRB"
                    },
                    ".TEX-SS": {
                        "font-family": "MJXZERO, MJXTEX-SS"
                    },
                    ".TEX-SSB": {
                        "font-family": "MJXZERO, MJXTEX-SSB"
                    },
                    ".TEX-SSI": {
                        "font-family": "MJXZERO, MJXTEX-SSI"
                    },
                    ".TEX-SC": {
                        "font-family": "MJXZERO, MJXTEX-SC"
                    },
                    ".TEX-T": {
                        "font-family": "MJXZERO, MJXTEX-T"
                    },
                    ".TEX-V": {
                        "font-family": "MJXZERO, MJXTEX-V"
                    },
                    ".TEX-VB": {
                        "font-family": "MJXZERO, MJXTEX-VB"
                    },
                    "mjx-stretchy-v mjx-c, mjx-stretchy-h mjx-c": {
                        "font-family": "MJXZERO, MJXTEX-S1, MJXTEX-S4, MJXTEX, MJXTEX-A ! important"
                    }
                }), e1.defaultFonts = i1(i1({}, s1.CHTMLFontData.defaultFonts), {
                    "@font-face /* 1 */": {
                        "font-family": "MJXTEX",
                        src: 'url("%%URL%%/MathJax_Main-Regular.woff") format("woff")'
                    },
                    "@font-face /* 2 */": {
                        "font-family": "MJXTEX-B",
                        src: 'url("%%URL%%/MathJax_Main-Bold.woff") format("woff")'
                    },
                    "@font-face /* 3 */": {
                        "font-family": "MJXTEX-I",
                        src: 'url("%%URL%%/MathJax_Math-Italic.woff") format("woff")'
                    },
                    "@font-face /* 4 */": {
                        "font-family": "MJXTEX-MI",
                        src: 'url("%%URL%%/MathJax_Main-Italic.woff") format("woff")'
                    },
                    "@font-face /* 5 */": {
                        "font-family": "MJXTEX-BI",
                        src: 'url("%%URL%%/MathJax_Math-BoldItalic.woff") format("woff")'
                    },
                    "@font-face /* 6 */": {
                        "font-family": "MJXTEX-S1",
                        src: 'url("%%URL%%/MathJax_Size1-Regular.woff") format("woff")'
                    },
                    "@font-face /* 7 */": {
                        "font-family": "MJXTEX-S2",
                        src: 'url("%%URL%%/MathJax_Size2-Regular.woff") format("woff")'
                    },
                    "@font-face /* 8 */": {
                        "font-family": "MJXTEX-S3",
                        src: 'url("%%URL%%/MathJax_Size3-Regular.woff") format("woff")'
                    },
                    "@font-face /* 9 */": {
                        "font-family": "MJXTEX-S4",
                        src: 'url("%%URL%%/MathJax_Size4-Regular.woff") format("woff")'
                    },
                    "@font-face /* 10 */": {
                        "font-family": "MJXTEX-A",
                        src: 'url("%%URL%%/MathJax_AMS-Regular.woff") format("woff")'
                    },
                    "@font-face /* 11 */": {
                        "font-family": "MJXTEX-C",
                        src: 'url("%%URL%%/MathJax_Calligraphic-Regular.woff") format("woff")'
                    },
                    "@font-face /* 12 */": {
                        "font-family": "MJXTEX-CB",
                        src: 'url("%%URL%%/MathJax_Calligraphic-Bold.woff") format("woff")'
                    },
                    "@font-face /* 13 */": {
                        "font-family": "MJXTEX-FR",
                        src: 'url("%%URL%%/MathJax_Fraktur-Regular.woff") format("woff")'
                    },
                    "@font-face /* 14 */": {
                        "font-family": "MJXTEX-FRB",
                        src: 'url("%%URL%%/MathJax_Fraktur-Bold.woff") format("woff")'
                    },
                    "@font-face /* 15 */": {
                        "font-family": "MJXTEX-SS",
                        src: 'url("%%URL%%/MathJax_SansSerif-Regular.woff") format("woff")'
                    },
                    "@font-face /* 16 */": {
                        "font-family": "MJXTEX-SSB",
                        src: 'url("%%URL%%/MathJax_SansSerif-Bold.woff") format("woff")'
                    },
                    "@font-face /* 17 */": {
                        "font-family": "MJXTEX-SSI",
                        src: 'url("%%URL%%/MathJax_SansSerif-Italic.woff") format("woff")'
                    },
                    "@font-face /* 18 */": {
                        "font-family": "MJXTEX-SC",
                        src: 'url("%%URL%%/MathJax_Script-Regular.woff") format("woff")'
                    },
                    "@font-face /* 19 */": {
                        "font-family": "MJXTEX-T",
                        src: 'url("%%URL%%/MathJax_Typewriter-Regular.woff") format("woff")'
                    },
                    "@font-face /* 20 */": {
                        "font-family": "MJXTEX-V",
                        src: 'url("%%URL%%/MathJax_Vector-Regular.woff") format("woff")'
                    },
                    "@font-face /* 21 */": {
                        "font-family": "MJXTEX-VB",
                        src: 'url("%%URL%%/MathJax_Vector-Bold.woff") format("woff")'
                    }
                }), e1;
            }((0, a1.CommonTeXFontMixin)(s1.CHTMLFontData));
            e1.TeXFont = P1;
        },
        4005: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.boldItalic = void 0;
            var n1 = r1(8042), o1 = r1(3980);
            e1.boldItalic = (0, n1.AddCSS)(o1.boldItalic, {
                305: {
                    f: "B"
                },
                567: {
                    f: "B"
                },
                8260: {
                    c: "/"
                },
                8710: {
                    c: "\\394"
                },
                10744: {
                    c: "/"
                }
            });
        },
        1015: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.bold = void 0;
            var n1 = r1(8042), o1 = r1(1103);
            e1.bold = (0, n1.AddCSS)(o1.bold, {
                183: {
                    c: "\\22C5"
                },
                305: {
                    f: ""
                },
                567: {
                    f: ""
                },
                697: {
                    c: "\\2032"
                },
                8194: {
                    c: ""
                },
                8195: {
                    c: ""
                },
                8196: {
                    c: ""
                },
                8197: {
                    c: ""
                },
                8198: {
                    c: ""
                },
                8201: {
                    c: ""
                },
                8202: {
                    c: ""
                },
                8213: {
                    c: "\\2014"
                },
                8214: {
                    c: "\\2225"
                },
                8215: {
                    c: "_"
                },
                8226: {
                    c: "\\2219"
                },
                8243: {
                    c: "\\2032\\2032"
                },
                8244: {
                    c: "\\2032\\2032\\2032"
                },
                8254: {
                    c: "\\2C9"
                },
                8260: {
                    c: "/"
                },
                8279: {
                    c: "\\2032\\2032\\2032\\2032"
                },
                8407: {
                    c: "\\2192",
                    f: "VB"
                },
                8602: {
                    c: "\\2190\\338"
                },
                8603: {
                    c: "\\2192\\338"
                },
                8622: {
                    c: "\\2194\\338"
                },
                8653: {
                    c: "\\21D0\\338"
                },
                8654: {
                    c: "\\21D4\\338"
                },
                8655: {
                    c: "\\21D2\\338"
                },
                8708: {
                    c: "\\2203\\338"
                },
                8710: {
                    c: "\\394"
                },
                8716: {
                    c: "\\220B\\338"
                },
                8740: {
                    c: "\\2223\\338"
                },
                8742: {
                    c: "\\2225\\338"
                },
                8769: {
                    c: "\\223C\\338"
                },
                8772: {
                    c: "\\2243\\338"
                },
                8775: {
                    c: "\\2245\\338"
                },
                8777: {
                    c: "\\2248\\338"
                },
                8802: {
                    c: "\\2261\\338"
                },
                8813: {
                    c: "\\224D\\338"
                },
                8814: {
                    c: "<\\338"
                },
                8815: {
                    c: ">\\338"
                },
                8816: {
                    c: "\\2264\\338"
                },
                8817: {
                    c: "\\2265\\338"
                },
                8832: {
                    c: "\\227A\\338"
                },
                8833: {
                    c: "\\227B\\338"
                },
                8836: {
                    c: "\\2282\\338"
                },
                8837: {
                    c: "\\2283\\338"
                },
                8840: {
                    c: "\\2286\\338"
                },
                8841: {
                    c: "\\2287\\338"
                },
                8876: {
                    c: "\\22A2\\338"
                },
                8877: {
                    c: "\\22A8\\338"
                },
                8930: {
                    c: "\\2291\\338"
                },
                8931: {
                    c: "\\2292\\338"
                },
                9001: {
                    c: "\\27E8"
                },
                9002: {
                    c: "\\27E9"
                },
                9653: {
                    c: "\\25B3"
                },
                9663: {
                    c: "\\25BD"
                },
                10072: {
                    c: "\\2223"
                },
                10744: {
                    c: "/",
                    f: "BI"
                },
                10799: {
                    c: "\\D7"
                },
                12296: {
                    c: "\\27E8"
                },
                12297: {
                    c: "\\27E9"
                }
            });
        },
        4515: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.doubleStruck = void 0;
            var n1 = r1(6001);
            Object.defineProperty(e1, "doubleStruck", {
                enumerable: !0,
                get: function() {
                    return n1.doubleStruck;
                }
            });
        },
        6555: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.frakturBold = void 0;
            var n1 = r1(8042), o1 = r1(3696);
            e1.frakturBold = (0, n1.AddCSS)(o1.frakturBold, {
                8260: {
                    c: "/"
                }
            });
        },
        2183: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.fraktur = void 0;
            var n1 = r1(8042), o1 = r1(9587);
            e1.fraktur = (0, n1.AddCSS)(o1.fraktur, {
                8260: {
                    c: "/"
                }
            });
        },
        3490: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.italic = void 0;
            var n1 = r1(8042), o1 = r1(8348);
            e1.italic = (0, n1.AddCSS)(o1.italic, {
                47: {
                    f: "I"
                },
                989: {
                    c: "\\E008",
                    f: "A"
                },
                8213: {
                    c: "\\2014"
                },
                8215: {
                    c: "_"
                },
                8260: {
                    c: "/",
                    f: "I"
                },
                8710: {
                    c: "\\394",
                    f: "I"
                },
                10744: {
                    c: "/",
                    f: "I"
                }
            });
        },
        9056: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.largeop = void 0;
            var n1 = r1(8042), o1 = r1(1376);
            e1.largeop = (0, n1.AddCSS)(o1.largeop, {
                8214: {
                    f: "S1"
                },
                8260: {
                    c: "/"
                },
                8593: {
                    f: "S1"
                },
                8595: {
                    f: "S1"
                },
                8657: {
                    f: "S1"
                },
                8659: {
                    f: "S1"
                },
                8739: {
                    f: "S1"
                },
                8741: {
                    f: "S1"
                },
                9001: {
                    c: "\\27E8"
                },
                9002: {
                    c: "\\27E9"
                },
                9168: {
                    f: "S1"
                },
                10072: {
                    c: "\\2223",
                    f: "S1"
                },
                10764: {
                    c: "\\222C\\222C"
                },
                12296: {
                    c: "\\27E8"
                },
                12297: {
                    c: "\\27E9"
                }
            });
        },
        3019: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.monospace = void 0;
            var n1 = r1(8042), o1 = r1(1439);
            e1.monospace = (0, n1.AddCSS)(o1.monospace, {
                697: {
                    c: "\\2032"
                },
                913: {
                    c: "A"
                },
                914: {
                    c: "B"
                },
                917: {
                    c: "E"
                },
                918: {
                    c: "Z"
                },
                919: {
                    c: "H"
                },
                921: {
                    c: "I"
                },
                922: {
                    c: "K"
                },
                924: {
                    c: "M"
                },
                925: {
                    c: "N"
                },
                927: {
                    c: "O"
                },
                929: {
                    c: "P"
                },
                932: {
                    c: "T"
                },
                935: {
                    c: "X"
                },
                8215: {
                    c: "_"
                },
                8243: {
                    c: "\\2032\\2032"
                },
                8244: {
                    c: "\\2032\\2032\\2032"
                },
                8260: {
                    c: "/"
                },
                8279: {
                    c: "\\2032\\2032\\2032\\2032"
                },
                8710: {
                    c: "\\394"
                }
            });
        },
        2713: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.normal = void 0;
            var n1 = r1(8042), o1 = r1(331);
            e1.normal = (0, n1.AddCSS)(o1.normal, {
                163: {
                    f: "MI"
                },
                165: {
                    f: "A"
                },
                174: {
                    f: "A"
                },
                183: {
                    c: "\\22C5"
                },
                240: {
                    f: "A"
                },
                697: {
                    c: "\\2032"
                },
                913: {
                    c: "A"
                },
                914: {
                    c: "B"
                },
                917: {
                    c: "E"
                },
                918: {
                    c: "Z"
                },
                919: {
                    c: "H"
                },
                921: {
                    c: "I"
                },
                922: {
                    c: "K"
                },
                924: {
                    c: "M"
                },
                925: {
                    c: "N"
                },
                927: {
                    c: "O"
                },
                929: {
                    c: "P"
                },
                932: {
                    c: "T"
                },
                935: {
                    c: "X"
                },
                8192: {
                    c: ""
                },
                8193: {
                    c: ""
                },
                8194: {
                    c: ""
                },
                8195: {
                    c: ""
                },
                8196: {
                    c: ""
                },
                8197: {
                    c: ""
                },
                8198: {
                    c: ""
                },
                8201: {
                    c: ""
                },
                8202: {
                    c: ""
                },
                8203: {
                    c: ""
                },
                8204: {
                    c: ""
                },
                8213: {
                    c: "\\2014"
                },
                8214: {
                    c: "\\2225"
                },
                8215: {
                    c: "_"
                },
                8226: {
                    c: "\\2219"
                },
                8243: {
                    c: "\\2032\\2032"
                },
                8244: {
                    c: "\\2032\\2032\\2032"
                },
                8245: {
                    f: "A"
                },
                8246: {
                    c: "\\2035\\2035",
                    f: "A"
                },
                8247: {
                    c: "\\2035\\2035\\2035",
                    f: "A"
                },
                8254: {
                    c: "\\2C9"
                },
                8260: {
                    c: "/"
                },
                8279: {
                    c: "\\2032\\2032\\2032\\2032"
                },
                8288: {
                    c: ""
                },
                8289: {
                    c: ""
                },
                8290: {
                    c: ""
                },
                8291: {
                    c: ""
                },
                8292: {
                    c: ""
                },
                8407: {
                    c: "\\2192",
                    f: "V"
                },
                8450: {
                    c: "C",
                    f: "A"
                },
                8459: {
                    c: "H",
                    f: "SC"
                },
                8460: {
                    c: "H",
                    f: "FR"
                },
                8461: {
                    c: "H",
                    f: "A"
                },
                8462: {
                    c: "h",
                    f: "I"
                },
                8463: {
                    f: "A"
                },
                8464: {
                    c: "I",
                    f: "SC"
                },
                8465: {
                    c: "I",
                    f: "FR"
                },
                8466: {
                    c: "L",
                    f: "SC"
                },
                8469: {
                    c: "N",
                    f: "A"
                },
                8473: {
                    c: "P",
                    f: "A"
                },
                8474: {
                    c: "Q",
                    f: "A"
                },
                8475: {
                    c: "R",
                    f: "SC"
                },
                8476: {
                    c: "R",
                    f: "FR"
                },
                8477: {
                    c: "R",
                    f: "A"
                },
                8484: {
                    c: "Z",
                    f: "A"
                },
                8486: {
                    c: "\\3A9"
                },
                8487: {
                    f: "A"
                },
                8488: {
                    c: "Z",
                    f: "FR"
                },
                8492: {
                    c: "B",
                    f: "SC"
                },
                8493: {
                    c: "C",
                    f: "FR"
                },
                8496: {
                    c: "E",
                    f: "SC"
                },
                8497: {
                    c: "F",
                    f: "SC"
                },
                8498: {
                    f: "A"
                },
                8499: {
                    c: "M",
                    f: "SC"
                },
                8502: {
                    f: "A"
                },
                8503: {
                    f: "A"
                },
                8504: {
                    f: "A"
                },
                8513: {
                    f: "A"
                },
                8602: {
                    f: "A"
                },
                8603: {
                    f: "A"
                },
                8606: {
                    f: "A"
                },
                8608: {
                    f: "A"
                },
                8610: {
                    f: "A"
                },
                8611: {
                    f: "A"
                },
                8619: {
                    f: "A"
                },
                8620: {
                    f: "A"
                },
                8621: {
                    f: "A"
                },
                8622: {
                    f: "A"
                },
                8624: {
                    f: "A"
                },
                8625: {
                    f: "A"
                },
                8630: {
                    f: "A"
                },
                8631: {
                    f: "A"
                },
                8634: {
                    f: "A"
                },
                8635: {
                    f: "A"
                },
                8638: {
                    f: "A"
                },
                8639: {
                    f: "A"
                },
                8642: {
                    f: "A"
                },
                8643: {
                    f: "A"
                },
                8644: {
                    f: "A"
                },
                8646: {
                    f: "A"
                },
                8647: {
                    f: "A"
                },
                8648: {
                    f: "A"
                },
                8649: {
                    f: "A"
                },
                8650: {
                    f: "A"
                },
                8651: {
                    f: "A"
                },
                8653: {
                    f: "A"
                },
                8654: {
                    f: "A"
                },
                8655: {
                    f: "A"
                },
                8666: {
                    f: "A"
                },
                8667: {
                    f: "A"
                },
                8669: {
                    f: "A"
                },
                8672: {
                    f: "A"
                },
                8674: {
                    f: "A"
                },
                8705: {
                    f: "A"
                },
                8708: {
                    c: "\\2203\\338"
                },
                8710: {
                    c: "\\394"
                },
                8716: {
                    c: "\\220B\\338"
                },
                8717: {
                    f: "A"
                },
                8719: {
                    f: "S1"
                },
                8720: {
                    f: "S1"
                },
                8721: {
                    f: "S1"
                },
                8724: {
                    f: "A"
                },
                8737: {
                    f: "A"
                },
                8738: {
                    f: "A"
                },
                8740: {
                    f: "A"
                },
                8742: {
                    f: "A"
                },
                8748: {
                    f: "S1"
                },
                8749: {
                    f: "S1"
                },
                8750: {
                    f: "S1"
                },
                8756: {
                    f: "A"
                },
                8757: {
                    f: "A"
                },
                8765: {
                    f: "A"
                },
                8769: {
                    f: "A"
                },
                8770: {
                    f: "A"
                },
                8772: {
                    c: "\\2243\\338"
                },
                8775: {
                    c: "\\2246",
                    f: "A"
                },
                8777: {
                    c: "\\2248\\338"
                },
                8778: {
                    f: "A"
                },
                8782: {
                    f: "A"
                },
                8783: {
                    f: "A"
                },
                8785: {
                    f: "A"
                },
                8786: {
                    f: "A"
                },
                8787: {
                    f: "A"
                },
                8790: {
                    f: "A"
                },
                8791: {
                    f: "A"
                },
                8796: {
                    f: "A"
                },
                8802: {
                    c: "\\2261\\338"
                },
                8806: {
                    f: "A"
                },
                8807: {
                    f: "A"
                },
                8808: {
                    f: "A"
                },
                8809: {
                    f: "A"
                },
                8812: {
                    f: "A"
                },
                8813: {
                    c: "\\224D\\338"
                },
                8814: {
                    f: "A"
                },
                8815: {
                    f: "A"
                },
                8816: {
                    f: "A"
                },
                8817: {
                    f: "A"
                },
                8818: {
                    f: "A"
                },
                8819: {
                    f: "A"
                },
                8820: {
                    c: "\\2272\\338"
                },
                8821: {
                    c: "\\2273\\338"
                },
                8822: {
                    f: "A"
                },
                8823: {
                    f: "A"
                },
                8824: {
                    c: "\\2276\\338"
                },
                8825: {
                    c: "\\2277\\338"
                },
                8828: {
                    f: "A"
                },
                8829: {
                    f: "A"
                },
                8830: {
                    f: "A"
                },
                8831: {
                    f: "A"
                },
                8832: {
                    f: "A"
                },
                8833: {
                    f: "A"
                },
                8836: {
                    c: "\\2282\\338"
                },
                8837: {
                    c: "\\2283\\338"
                },
                8840: {
                    f: "A"
                },
                8841: {
                    f: "A"
                },
                8842: {
                    f: "A"
                },
                8843: {
                    f: "A"
                },
                8847: {
                    f: "A"
                },
                8848: {
                    f: "A"
                },
                8858: {
                    f: "A"
                },
                8859: {
                    f: "A"
                },
                8861: {
                    f: "A"
                },
                8862: {
                    f: "A"
                },
                8863: {
                    f: "A"
                },
                8864: {
                    f: "A"
                },
                8865: {
                    f: "A"
                },
                8873: {
                    f: "A"
                },
                8874: {
                    f: "A"
                },
                8876: {
                    f: "A"
                },
                8877: {
                    f: "A"
                },
                8878: {
                    f: "A"
                },
                8879: {
                    f: "A"
                },
                8882: {
                    f: "A"
                },
                8883: {
                    f: "A"
                },
                8884: {
                    f: "A"
                },
                8885: {
                    f: "A"
                },
                8888: {
                    f: "A"
                },
                8890: {
                    f: "A"
                },
                8891: {
                    f: "A"
                },
                8892: {
                    f: "A"
                },
                8896: {
                    f: "S1"
                },
                8897: {
                    f: "S1"
                },
                8898: {
                    f: "S1"
                },
                8899: {
                    f: "S1"
                },
                8903: {
                    f: "A"
                },
                8905: {
                    f: "A"
                },
                8906: {
                    f: "A"
                },
                8907: {
                    f: "A"
                },
                8908: {
                    f: "A"
                },
                8909: {
                    f: "A"
                },
                8910: {
                    f: "A"
                },
                8911: {
                    f: "A"
                },
                8912: {
                    f: "A"
                },
                8913: {
                    f: "A"
                },
                8914: {
                    f: "A"
                },
                8915: {
                    f: "A"
                },
                8916: {
                    f: "A"
                },
                8918: {
                    f: "A"
                },
                8919: {
                    f: "A"
                },
                8920: {
                    f: "A"
                },
                8921: {
                    f: "A"
                },
                8922: {
                    f: "A"
                },
                8923: {
                    f: "A"
                },
                8926: {
                    f: "A"
                },
                8927: {
                    f: "A"
                },
                8928: {
                    f: "A"
                },
                8929: {
                    f: "A"
                },
                8930: {
                    c: "\\2291\\338"
                },
                8931: {
                    c: "\\2292\\338"
                },
                8934: {
                    f: "A"
                },
                8935: {
                    f: "A"
                },
                8936: {
                    f: "A"
                },
                8937: {
                    f: "A"
                },
                8938: {
                    f: "A"
                },
                8939: {
                    f: "A"
                },
                8940: {
                    f: "A"
                },
                8941: {
                    f: "A"
                },
                8965: {
                    c: "\\22BC",
                    f: "A"
                },
                8966: {
                    c: "\\2A5E",
                    f: "A"
                },
                8988: {
                    c: "\\250C",
                    f: "A"
                },
                8989: {
                    c: "\\2510",
                    f: "A"
                },
                8990: {
                    c: "\\2514",
                    f: "A"
                },
                8991: {
                    c: "\\2518",
                    f: "A"
                },
                9001: {
                    c: "\\27E8"
                },
                9002: {
                    c: "\\27E9"
                },
                9168: {
                    f: "S1"
                },
                9416: {
                    f: "A"
                },
                9484: {
                    f: "A"
                },
                9488: {
                    f: "A"
                },
                9492: {
                    f: "A"
                },
                9496: {
                    f: "A"
                },
                9585: {
                    f: "A"
                },
                9586: {
                    f: "A"
                },
                9632: {
                    f: "A"
                },
                9633: {
                    f: "A"
                },
                9642: {
                    c: "\\25A0",
                    f: "A"
                },
                9650: {
                    f: "A"
                },
                9652: {
                    c: "\\25B2",
                    f: "A"
                },
                9653: {
                    c: "\\25B3"
                },
                9654: {
                    f: "A"
                },
                9656: {
                    c: "\\25B6",
                    f: "A"
                },
                9660: {
                    f: "A"
                },
                9662: {
                    c: "\\25BC",
                    f: "A"
                },
                9663: {
                    c: "\\25BD"
                },
                9664: {
                    f: "A"
                },
                9666: {
                    c: "\\25C0",
                    f: "A"
                },
                9674: {
                    f: "A"
                },
                9723: {
                    c: "\\25A1",
                    f: "A"
                },
                9724: {
                    c: "\\25A0",
                    f: "A"
                },
                9733: {
                    f: "A"
                },
                10003: {
                    f: "A"
                },
                10016: {
                    f: "A"
                },
                10072: {
                    c: "\\2223"
                },
                10731: {
                    f: "A"
                },
                10744: {
                    c: "/",
                    f: "I"
                },
                10752: {
                    f: "S1"
                },
                10753: {
                    f: "S1"
                },
                10754: {
                    f: "S1"
                },
                10756: {
                    f: "S1"
                },
                10758: {
                    f: "S1"
                },
                10764: {
                    c: "\\222C\\222C",
                    f: "S1"
                },
                10799: {
                    c: "\\D7"
                },
                10846: {
                    f: "A"
                },
                10877: {
                    f: "A"
                },
                10878: {
                    f: "A"
                },
                10885: {
                    f: "A"
                },
                10886: {
                    f: "A"
                },
                10887: {
                    f: "A"
                },
                10888: {
                    f: "A"
                },
                10889: {
                    f: "A"
                },
                10890: {
                    f: "A"
                },
                10891: {
                    f: "A"
                },
                10892: {
                    f: "A"
                },
                10901: {
                    f: "A"
                },
                10902: {
                    f: "A"
                },
                10933: {
                    f: "A"
                },
                10934: {
                    f: "A"
                },
                10935: {
                    f: "A"
                },
                10936: {
                    f: "A"
                },
                10937: {
                    f: "A"
                },
                10938: {
                    f: "A"
                },
                10949: {
                    f: "A"
                },
                10950: {
                    f: "A"
                },
                10955: {
                    f: "A"
                },
                10956: {
                    f: "A"
                },
                12296: {
                    c: "\\27E8"
                },
                12297: {
                    c: "\\27E9"
                },
                57350: {
                    f: "A"
                },
                57351: {
                    f: "A"
                },
                57352: {
                    f: "A"
                },
                57353: {
                    f: "A"
                },
                57356: {
                    f: "A"
                },
                57357: {
                    f: "A"
                },
                57358: {
                    f: "A"
                },
                57359: {
                    f: "A"
                },
                57360: {
                    f: "A"
                },
                57361: {
                    f: "A"
                },
                57366: {
                    f: "A"
                },
                57367: {
                    f: "A"
                },
                57368: {
                    f: "A"
                },
                57369: {
                    f: "A"
                },
                57370: {
                    f: "A"
                },
                57371: {
                    f: "A"
                },
                119808: {
                    c: "A",
                    f: "B"
                },
                119809: {
                    c: "B",
                    f: "B"
                },
                119810: {
                    c: "C",
                    f: "B"
                },
                119811: {
                    c: "D",
                    f: "B"
                },
                119812: {
                    c: "E",
                    f: "B"
                },
                119813: {
                    c: "F",
                    f: "B"
                },
                119814: {
                    c: "G",
                    f: "B"
                },
                119815: {
                    c: "H",
                    f: "B"
                },
                119816: {
                    c: "I",
                    f: "B"
                },
                119817: {
                    c: "J",
                    f: "B"
                },
                119818: {
                    c: "K",
                    f: "B"
                },
                119819: {
                    c: "L",
                    f: "B"
                },
                119820: {
                    c: "M",
                    f: "B"
                },
                119821: {
                    c: "N",
                    f: "B"
                },
                119822: {
                    c: "O",
                    f: "B"
                },
                119823: {
                    c: "P",
                    f: "B"
                },
                119824: {
                    c: "Q",
                    f: "B"
                },
                119825: {
                    c: "R",
                    f: "B"
                },
                119826: {
                    c: "S",
                    f: "B"
                },
                119827: {
                    c: "T",
                    f: "B"
                },
                119828: {
                    c: "U",
                    f: "B"
                },
                119829: {
                    c: "V",
                    f: "B"
                },
                119830: {
                    c: "W",
                    f: "B"
                },
                119831: {
                    c: "X",
                    f: "B"
                },
                119832: {
                    c: "Y",
                    f: "B"
                },
                119833: {
                    c: "Z",
                    f: "B"
                },
                119834: {
                    c: "a",
                    f: "B"
                },
                119835: {
                    c: "b",
                    f: "B"
                },
                119836: {
                    c: "c",
                    f: "B"
                },
                119837: {
                    c: "d",
                    f: "B"
                },
                119838: {
                    c: "e",
                    f: "B"
                },
                119839: {
                    c: "f",
                    f: "B"
                },
                119840: {
                    c: "g",
                    f: "B"
                },
                119841: {
                    c: "h",
                    f: "B"
                },
                119842: {
                    c: "i",
                    f: "B"
                },
                119843: {
                    c: "j",
                    f: "B"
                },
                119844: {
                    c: "k",
                    f: "B"
                },
                119845: {
                    c: "l",
                    f: "B"
                },
                119846: {
                    c: "m",
                    f: "B"
                },
                119847: {
                    c: "n",
                    f: "B"
                },
                119848: {
                    c: "o",
                    f: "B"
                },
                119849: {
                    c: "p",
                    f: "B"
                },
                119850: {
                    c: "q",
                    f: "B"
                },
                119851: {
                    c: "r",
                    f: "B"
                },
                119852: {
                    c: "s",
                    f: "B"
                },
                119853: {
                    c: "t",
                    f: "B"
                },
                119854: {
                    c: "u",
                    f: "B"
                },
                119855: {
                    c: "v",
                    f: "B"
                },
                119856: {
                    c: "w",
                    f: "B"
                },
                119857: {
                    c: "x",
                    f: "B"
                },
                119858: {
                    c: "y",
                    f: "B"
                },
                119859: {
                    c: "z",
                    f: "B"
                },
                119860: {
                    c: "A",
                    f: "I"
                },
                119861: {
                    c: "B",
                    f: "I"
                },
                119862: {
                    c: "C",
                    f: "I"
                },
                119863: {
                    c: "D",
                    f: "I"
                },
                119864: {
                    c: "E",
                    f: "I"
                },
                119865: {
                    c: "F",
                    f: "I"
                },
                119866: {
                    c: "G",
                    f: "I"
                },
                119867: {
                    c: "H",
                    f: "I"
                },
                119868: {
                    c: "I",
                    f: "I"
                },
                119869: {
                    c: "J",
                    f: "I"
                },
                119870: {
                    c: "K",
                    f: "I"
                },
                119871: {
                    c: "L",
                    f: "I"
                },
                119872: {
                    c: "M",
                    f: "I"
                },
                119873: {
                    c: "N",
                    f: "I"
                },
                119874: {
                    c: "O",
                    f: "I"
                },
                119875: {
                    c: "P",
                    f: "I"
                },
                119876: {
                    c: "Q",
                    f: "I"
                },
                119877: {
                    c: "R",
                    f: "I"
                },
                119878: {
                    c: "S",
                    f: "I"
                },
                119879: {
                    c: "T",
                    f: "I"
                },
                119880: {
                    c: "U",
                    f: "I"
                },
                119881: {
                    c: "V",
                    f: "I"
                },
                119882: {
                    c: "W",
                    f: "I"
                },
                119883: {
                    c: "X",
                    f: "I"
                },
                119884: {
                    c: "Y",
                    f: "I"
                },
                119885: {
                    c: "Z",
                    f: "I"
                },
                119886: {
                    c: "a",
                    f: "I"
                },
                119887: {
                    c: "b",
                    f: "I"
                },
                119888: {
                    c: "c",
                    f: "I"
                },
                119889: {
                    c: "d",
                    f: "I"
                },
                119890: {
                    c: "e",
                    f: "I"
                },
                119891: {
                    c: "f",
                    f: "I"
                },
                119892: {
                    c: "g",
                    f: "I"
                },
                119894: {
                    c: "i",
                    f: "I"
                },
                119895: {
                    c: "j",
                    f: "I"
                },
                119896: {
                    c: "k",
                    f: "I"
                },
                119897: {
                    c: "l",
                    f: "I"
                },
                119898: {
                    c: "m",
                    f: "I"
                },
                119899: {
                    c: "n",
                    f: "I"
                },
                119900: {
                    c: "o",
                    f: "I"
                },
                119901: {
                    c: "p",
                    f: "I"
                },
                119902: {
                    c: "q",
                    f: "I"
                },
                119903: {
                    c: "r",
                    f: "I"
                },
                119904: {
                    c: "s",
                    f: "I"
                },
                119905: {
                    c: "t",
                    f: "I"
                },
                119906: {
                    c: "u",
                    f: "I"
                },
                119907: {
                    c: "v",
                    f: "I"
                },
                119908: {
                    c: "w",
                    f: "I"
                },
                119909: {
                    c: "x",
                    f: "I"
                },
                119910: {
                    c: "y",
                    f: "I"
                },
                119911: {
                    c: "z",
                    f: "I"
                },
                119912: {
                    c: "A",
                    f: "BI"
                },
                119913: {
                    c: "B",
                    f: "BI"
                },
                119914: {
                    c: "C",
                    f: "BI"
                },
                119915: {
                    c: "D",
                    f: "BI"
                },
                119916: {
                    c: "E",
                    f: "BI"
                },
                119917: {
                    c: "F",
                    f: "BI"
                },
                119918: {
                    c: "G",
                    f: "BI"
                },
                119919: {
                    c: "H",
                    f: "BI"
                },
                119920: {
                    c: "I",
                    f: "BI"
                },
                119921: {
                    c: "J",
                    f: "BI"
                },
                119922: {
                    c: "K",
                    f: "BI"
                },
                119923: {
                    c: "L",
                    f: "BI"
                },
                119924: {
                    c: "M",
                    f: "BI"
                },
                119925: {
                    c: "N",
                    f: "BI"
                },
                119926: {
                    c: "O",
                    f: "BI"
                },
                119927: {
                    c: "P",
                    f: "BI"
                },
                119928: {
                    c: "Q",
                    f: "BI"
                },
                119929: {
                    c: "R",
                    f: "BI"
                },
                119930: {
                    c: "S",
                    f: "BI"
                },
                119931: {
                    c: "T",
                    f: "BI"
                },
                119932: {
                    c: "U",
                    f: "BI"
                },
                119933: {
                    c: "V",
                    f: "BI"
                },
                119934: {
                    c: "W",
                    f: "BI"
                },
                119935: {
                    c: "X",
                    f: "BI"
                },
                119936: {
                    c: "Y",
                    f: "BI"
                },
                119937: {
                    c: "Z",
                    f: "BI"
                },
                119938: {
                    c: "a",
                    f: "BI"
                },
                119939: {
                    c: "b",
                    f: "BI"
                },
                119940: {
                    c: "c",
                    f: "BI"
                },
                119941: {
                    c: "d",
                    f: "BI"
                },
                119942: {
                    c: "e",
                    f: "BI"
                },
                119943: {
                    c: "f",
                    f: "BI"
                },
                119944: {
                    c: "g",
                    f: "BI"
                },
                119945: {
                    c: "h",
                    f: "BI"
                },
                119946: {
                    c: "i",
                    f: "BI"
                },
                119947: {
                    c: "j",
                    f: "BI"
                },
                119948: {
                    c: "k",
                    f: "BI"
                },
                119949: {
                    c: "l",
                    f: "BI"
                },
                119950: {
                    c: "m",
                    f: "BI"
                },
                119951: {
                    c: "n",
                    f: "BI"
                },
                119952: {
                    c: "o",
                    f: "BI"
                },
                119953: {
                    c: "p",
                    f: "BI"
                },
                119954: {
                    c: "q",
                    f: "BI"
                },
                119955: {
                    c: "r",
                    f: "BI"
                },
                119956: {
                    c: "s",
                    f: "BI"
                },
                119957: {
                    c: "t",
                    f: "BI"
                },
                119958: {
                    c: "u",
                    f: "BI"
                },
                119959: {
                    c: "v",
                    f: "BI"
                },
                119960: {
                    c: "w",
                    f: "BI"
                },
                119961: {
                    c: "x",
                    f: "BI"
                },
                119962: {
                    c: "y",
                    f: "BI"
                },
                119963: {
                    c: "z",
                    f: "BI"
                },
                119964: {
                    c: "A",
                    f: "SC"
                },
                119966: {
                    c: "C",
                    f: "SC"
                },
                119967: {
                    c: "D",
                    f: "SC"
                },
                119970: {
                    c: "G",
                    f: "SC"
                },
                119973: {
                    c: "J",
                    f: "SC"
                },
                119974: {
                    c: "K",
                    f: "SC"
                },
                119977: {
                    c: "N",
                    f: "SC"
                },
                119978: {
                    c: "O",
                    f: "SC"
                },
                119979: {
                    c: "P",
                    f: "SC"
                },
                119980: {
                    c: "Q",
                    f: "SC"
                },
                119982: {
                    c: "S",
                    f: "SC"
                },
                119983: {
                    c: "T",
                    f: "SC"
                },
                119984: {
                    c: "U",
                    f: "SC"
                },
                119985: {
                    c: "V",
                    f: "SC"
                },
                119986: {
                    c: "W",
                    f: "SC"
                },
                119987: {
                    c: "X",
                    f: "SC"
                },
                119988: {
                    c: "Y",
                    f: "SC"
                },
                119989: {
                    c: "Z",
                    f: "SC"
                },
                120068: {
                    c: "A",
                    f: "FR"
                },
                120069: {
                    c: "B",
                    f: "FR"
                },
                120071: {
                    c: "D",
                    f: "FR"
                },
                120072: {
                    c: "E",
                    f: "FR"
                },
                120073: {
                    c: "F",
                    f: "FR"
                },
                120074: {
                    c: "G",
                    f: "FR"
                },
                120077: {
                    c: "J",
                    f: "FR"
                },
                120078: {
                    c: "K",
                    f: "FR"
                },
                120079: {
                    c: "L",
                    f: "FR"
                },
                120080: {
                    c: "M",
                    f: "FR"
                },
                120081: {
                    c: "N",
                    f: "FR"
                },
                120082: {
                    c: "O",
                    f: "FR"
                },
                120083: {
                    c: "P",
                    f: "FR"
                },
                120084: {
                    c: "Q",
                    f: "FR"
                },
                120086: {
                    c: "S",
                    f: "FR"
                },
                120087: {
                    c: "T",
                    f: "FR"
                },
                120088: {
                    c: "U",
                    f: "FR"
                },
                120089: {
                    c: "V",
                    f: "FR"
                },
                120090: {
                    c: "W",
                    f: "FR"
                },
                120091: {
                    c: "X",
                    f: "FR"
                },
                120092: {
                    c: "Y",
                    f: "FR"
                },
                120094: {
                    c: "a",
                    f: "FR"
                },
                120095: {
                    c: "b",
                    f: "FR"
                },
                120096: {
                    c: "c",
                    f: "FR"
                },
                120097: {
                    c: "d",
                    f: "FR"
                },
                120098: {
                    c: "e",
                    f: "FR"
                },
                120099: {
                    c: "f",
                    f: "FR"
                },
                120100: {
                    c: "g",
                    f: "FR"
                },
                120101: {
                    c: "h",
                    f: "FR"
                },
                120102: {
                    c: "i",
                    f: "FR"
                },
                120103: {
                    c: "j",
                    f: "FR"
                },
                120104: {
                    c: "k",
                    f: "FR"
                },
                120105: {
                    c: "l",
                    f: "FR"
                },
                120106: {
                    c: "m",
                    f: "FR"
                },
                120107: {
                    c: "n",
                    f: "FR"
                },
                120108: {
                    c: "o",
                    f: "FR"
                },
                120109: {
                    c: "p",
                    f: "FR"
                },
                120110: {
                    c: "q",
                    f: "FR"
                },
                120111: {
                    c: "r",
                    f: "FR"
                },
                120112: {
                    c: "s",
                    f: "FR"
                },
                120113: {
                    c: "t",
                    f: "FR"
                },
                120114: {
                    c: "u",
                    f: "FR"
                },
                120115: {
                    c: "v",
                    f: "FR"
                },
                120116: {
                    c: "w",
                    f: "FR"
                },
                120117: {
                    c: "x",
                    f: "FR"
                },
                120118: {
                    c: "y",
                    f: "FR"
                },
                120119: {
                    c: "z",
                    f: "FR"
                },
                120120: {
                    c: "A",
                    f: "A"
                },
                120121: {
                    c: "B",
                    f: "A"
                },
                120123: {
                    c: "D",
                    f: "A"
                },
                120124: {
                    c: "E",
                    f: "A"
                },
                120125: {
                    c: "F",
                    f: "A"
                },
                120126: {
                    c: "G",
                    f: "A"
                },
                120128: {
                    c: "I",
                    f: "A"
                },
                120129: {
                    c: "J",
                    f: "A"
                },
                120130: {
                    c: "K",
                    f: "A"
                },
                120131: {
                    c: "L",
                    f: "A"
                },
                120132: {
                    c: "M",
                    f: "A"
                },
                120134: {
                    c: "O",
                    f: "A"
                },
                120138: {
                    c: "S",
                    f: "A"
                },
                120139: {
                    c: "T",
                    f: "A"
                },
                120140: {
                    c: "U",
                    f: "A"
                },
                120141: {
                    c: "V",
                    f: "A"
                },
                120142: {
                    c: "W",
                    f: "A"
                },
                120143: {
                    c: "X",
                    f: "A"
                },
                120144: {
                    c: "Y",
                    f: "A"
                },
                120172: {
                    c: "A",
                    f: "FRB"
                },
                120173: {
                    c: "B",
                    f: "FRB"
                },
                120174: {
                    c: "C",
                    f: "FRB"
                },
                120175: {
                    c: "D",
                    f: "FRB"
                },
                120176: {
                    c: "E",
                    f: "FRB"
                },
                120177: {
                    c: "F",
                    f: "FRB"
                },
                120178: {
                    c: "G",
                    f: "FRB"
                },
                120179: {
                    c: "H",
                    f: "FRB"
                },
                120180: {
                    c: "I",
                    f: "FRB"
                },
                120181: {
                    c: "J",
                    f: "FRB"
                },
                120182: {
                    c: "K",
                    f: "FRB"
                },
                120183: {
                    c: "L",
                    f: "FRB"
                },
                120184: {
                    c: "M",
                    f: "FRB"
                },
                120185: {
                    c: "N",
                    f: "FRB"
                },
                120186: {
                    c: "O",
                    f: "FRB"
                },
                120187: {
                    c: "P",
                    f: "FRB"
                },
                120188: {
                    c: "Q",
                    f: "FRB"
                },
                120189: {
                    c: "R",
                    f: "FRB"
                },
                120190: {
                    c: "S",
                    f: "FRB"
                },
                120191: {
                    c: "T",
                    f: "FRB"
                },
                120192: {
                    c: "U",
                    f: "FRB"
                },
                120193: {
                    c: "V",
                    f: "FRB"
                },
                120194: {
                    c: "W",
                    f: "FRB"
                },
                120195: {
                    c: "X",
                    f: "FRB"
                },
                120196: {
                    c: "Y",
                    f: "FRB"
                },
                120197: {
                    c: "Z",
                    f: "FRB"
                },
                120198: {
                    c: "a",
                    f: "FRB"
                },
                120199: {
                    c: "b",
                    f: "FRB"
                },
                120200: {
                    c: "c",
                    f: "FRB"
                },
                120201: {
                    c: "d",
                    f: "FRB"
                },
                120202: {
                    c: "e",
                    f: "FRB"
                },
                120203: {
                    c: "f",
                    f: "FRB"
                },
                120204: {
                    c: "g",
                    f: "FRB"
                },
                120205: {
                    c: "h",
                    f: "FRB"
                },
                120206: {
                    c: "i",
                    f: "FRB"
                },
                120207: {
                    c: "j",
                    f: "FRB"
                },
                120208: {
                    c: "k",
                    f: "FRB"
                },
                120209: {
                    c: "l",
                    f: "FRB"
                },
                120210: {
                    c: "m",
                    f: "FRB"
                },
                120211: {
                    c: "n",
                    f: "FRB"
                },
                120212: {
                    c: "o",
                    f: "FRB"
                },
                120213: {
                    c: "p",
                    f: "FRB"
                },
                120214: {
                    c: "q",
                    f: "FRB"
                },
                120215: {
                    c: "r",
                    f: "FRB"
                },
                120216: {
                    c: "s",
                    f: "FRB"
                },
                120217: {
                    c: "t",
                    f: "FRB"
                },
                120218: {
                    c: "u",
                    f: "FRB"
                },
                120219: {
                    c: "v",
                    f: "FRB"
                },
                120220: {
                    c: "w",
                    f: "FRB"
                },
                120221: {
                    c: "x",
                    f: "FRB"
                },
                120222: {
                    c: "y",
                    f: "FRB"
                },
                120223: {
                    c: "z",
                    f: "FRB"
                },
                120224: {
                    c: "A",
                    f: "SS"
                },
                120225: {
                    c: "B",
                    f: "SS"
                },
                120226: {
                    c: "C",
                    f: "SS"
                },
                120227: {
                    c: "D",
                    f: "SS"
                },
                120228: {
                    c: "E",
                    f: "SS"
                },
                120229: {
                    c: "F",
                    f: "SS"
                },
                120230: {
                    c: "G",
                    f: "SS"
                },
                120231: {
                    c: "H",
                    f: "SS"
                },
                120232: {
                    c: "I",
                    f: "SS"
                },
                120233: {
                    c: "J",
                    f: "SS"
                },
                120234: {
                    c: "K",
                    f: "SS"
                },
                120235: {
                    c: "L",
                    f: "SS"
                },
                120236: {
                    c: "M",
                    f: "SS"
                },
                120237: {
                    c: "N",
                    f: "SS"
                },
                120238: {
                    c: "O",
                    f: "SS"
                },
                120239: {
                    c: "P",
                    f: "SS"
                },
                120240: {
                    c: "Q",
                    f: "SS"
                },
                120241: {
                    c: "R",
                    f: "SS"
                },
                120242: {
                    c: "S",
                    f: "SS"
                },
                120243: {
                    c: "T",
                    f: "SS"
                },
                120244: {
                    c: "U",
                    f: "SS"
                },
                120245: {
                    c: "V",
                    f: "SS"
                },
                120246: {
                    c: "W",
                    f: "SS"
                },
                120247: {
                    c: "X",
                    f: "SS"
                },
                120248: {
                    c: "Y",
                    f: "SS"
                },
                120249: {
                    c: "Z",
                    f: "SS"
                },
                120250: {
                    c: "a",
                    f: "SS"
                },
                120251: {
                    c: "b",
                    f: "SS"
                },
                120252: {
                    c: "c",
                    f: "SS"
                },
                120253: {
                    c: "d",
                    f: "SS"
                },
                120254: {
                    c: "e",
                    f: "SS"
                },
                120255: {
                    c: "f",
                    f: "SS"
                },
                120256: {
                    c: "g",
                    f: "SS"
                },
                120257: {
                    c: "h",
                    f: "SS"
                },
                120258: {
                    c: "i",
                    f: "SS"
                },
                120259: {
                    c: "j",
                    f: "SS"
                },
                120260: {
                    c: "k",
                    f: "SS"
                },
                120261: {
                    c: "l",
                    f: "SS"
                },
                120262: {
                    c: "m",
                    f: "SS"
                },
                120263: {
                    c: "n",
                    f: "SS"
                },
                120264: {
                    c: "o",
                    f: "SS"
                },
                120265: {
                    c: "p",
                    f: "SS"
                },
                120266: {
                    c: "q",
                    f: "SS"
                },
                120267: {
                    c: "r",
                    f: "SS"
                },
                120268: {
                    c: "s",
                    f: "SS"
                },
                120269: {
                    c: "t",
                    f: "SS"
                },
                120270: {
                    c: "u",
                    f: "SS"
                },
                120271: {
                    c: "v",
                    f: "SS"
                },
                120272: {
                    c: "w",
                    f: "SS"
                },
                120273: {
                    c: "x",
                    f: "SS"
                },
                120274: {
                    c: "y",
                    f: "SS"
                },
                120275: {
                    c: "z",
                    f: "SS"
                },
                120276: {
                    c: "A",
                    f: "SSB"
                },
                120277: {
                    c: "B",
                    f: "SSB"
                },
                120278: {
                    c: "C",
                    f: "SSB"
                },
                120279: {
                    c: "D",
                    f: "SSB"
                },
                120280: {
                    c: "E",
                    f: "SSB"
                },
                120281: {
                    c: "F",
                    f: "SSB"
                },
                120282: {
                    c: "G",
                    f: "SSB"
                },
                120283: {
                    c: "H",
                    f: "SSB"
                },
                120284: {
                    c: "I",
                    f: "SSB"
                },
                120285: {
                    c: "J",
                    f: "SSB"
                },
                120286: {
                    c: "K",
                    f: "SSB"
                },
                120287: {
                    c: "L",
                    f: "SSB"
                },
                120288: {
                    c: "M",
                    f: "SSB"
                },
                120289: {
                    c: "N",
                    f: "SSB"
                },
                120290: {
                    c: "O",
                    f: "SSB"
                },
                120291: {
                    c: "P",
                    f: "SSB"
                },
                120292: {
                    c: "Q",
                    f: "SSB"
                },
                120293: {
                    c: "R",
                    f: "SSB"
                },
                120294: {
                    c: "S",
                    f: "SSB"
                },
                120295: {
                    c: "T",
                    f: "SSB"
                },
                120296: {
                    c: "U",
                    f: "SSB"
                },
                120297: {
                    c: "V",
                    f: "SSB"
                },
                120298: {
                    c: "W",
                    f: "SSB"
                },
                120299: {
                    c: "X",
                    f: "SSB"
                },
                120300: {
                    c: "Y",
                    f: "SSB"
                },
                120301: {
                    c: "Z",
                    f: "SSB"
                },
                120302: {
                    c: "a",
                    f: "SSB"
                },
                120303: {
                    c: "b",
                    f: "SSB"
                },
                120304: {
                    c: "c",
                    f: "SSB"
                },
                120305: {
                    c: "d",
                    f: "SSB"
                },
                120306: {
                    c: "e",
                    f: "SSB"
                },
                120307: {
                    c: "f",
                    f: "SSB"
                },
                120308: {
                    c: "g",
                    f: "SSB"
                },
                120309: {
                    c: "h",
                    f: "SSB"
                },
                120310: {
                    c: "i",
                    f: "SSB"
                },
                120311: {
                    c: "j",
                    f: "SSB"
                },
                120312: {
                    c: "k",
                    f: "SSB"
                },
                120313: {
                    c: "l",
                    f: "SSB"
                },
                120314: {
                    c: "m",
                    f: "SSB"
                },
                120315: {
                    c: "n",
                    f: "SSB"
                },
                120316: {
                    c: "o",
                    f: "SSB"
                },
                120317: {
                    c: "p",
                    f: "SSB"
                },
                120318: {
                    c: "q",
                    f: "SSB"
                },
                120319: {
                    c: "r",
                    f: "SSB"
                },
                120320: {
                    c: "s",
                    f: "SSB"
                },
                120321: {
                    c: "t",
                    f: "SSB"
                },
                120322: {
                    c: "u",
                    f: "SSB"
                },
                120323: {
                    c: "v",
                    f: "SSB"
                },
                120324: {
                    c: "w",
                    f: "SSB"
                },
                120325: {
                    c: "x",
                    f: "SSB"
                },
                120326: {
                    c: "y",
                    f: "SSB"
                },
                120327: {
                    c: "z",
                    f: "SSB"
                },
                120328: {
                    c: "A",
                    f: "SSI"
                },
                120329: {
                    c: "B",
                    f: "SSI"
                },
                120330: {
                    c: "C",
                    f: "SSI"
                },
                120331: {
                    c: "D",
                    f: "SSI"
                },
                120332: {
                    c: "E",
                    f: "SSI"
                },
                120333: {
                    c: "F",
                    f: "SSI"
                },
                120334: {
                    c: "G",
                    f: "SSI"
                },
                120335: {
                    c: "H",
                    f: "SSI"
                },
                120336: {
                    c: "I",
                    f: "SSI"
                },
                120337: {
                    c: "J",
                    f: "SSI"
                },
                120338: {
                    c: "K",
                    f: "SSI"
                },
                120339: {
                    c: "L",
                    f: "SSI"
                },
                120340: {
                    c: "M",
                    f: "SSI"
                },
                120341: {
                    c: "N",
                    f: "SSI"
                },
                120342: {
                    c: "O",
                    f: "SSI"
                },
                120343: {
                    c: "P",
                    f: "SSI"
                },
                120344: {
                    c: "Q",
                    f: "SSI"
                },
                120345: {
                    c: "R",
                    f: "SSI"
                },
                120346: {
                    c: "S",
                    f: "SSI"
                },
                120347: {
                    c: "T",
                    f: "SSI"
                },
                120348: {
                    c: "U",
                    f: "SSI"
                },
                120349: {
                    c: "V",
                    f: "SSI"
                },
                120350: {
                    c: "W",
                    f: "SSI"
                },
                120351: {
                    c: "X",
                    f: "SSI"
                },
                120352: {
                    c: "Y",
                    f: "SSI"
                },
                120353: {
                    c: "Z",
                    f: "SSI"
                },
                120354: {
                    c: "a",
                    f: "SSI"
                },
                120355: {
                    c: "b",
                    f: "SSI"
                },
                120356: {
                    c: "c",
                    f: "SSI"
                },
                120357: {
                    c: "d",
                    f: "SSI"
                },
                120358: {
                    c: "e",
                    f: "SSI"
                },
                120359: {
                    c: "f",
                    f: "SSI"
                },
                120360: {
                    c: "g",
                    f: "SSI"
                },
                120361: {
                    c: "h",
                    f: "SSI"
                },
                120362: {
                    c: "i",
                    f: "SSI"
                },
                120363: {
                    c: "j",
                    f: "SSI"
                },
                120364: {
                    c: "k",
                    f: "SSI"
                },
                120365: {
                    c: "l",
                    f: "SSI"
                },
                120366: {
                    c: "m",
                    f: "SSI"
                },
                120367: {
                    c: "n",
                    f: "SSI"
                },
                120368: {
                    c: "o",
                    f: "SSI"
                },
                120369: {
                    c: "p",
                    f: "SSI"
                },
                120370: {
                    c: "q",
                    f: "SSI"
                },
                120371: {
                    c: "r",
                    f: "SSI"
                },
                120372: {
                    c: "s",
                    f: "SSI"
                },
                120373: {
                    c: "t",
                    f: "SSI"
                },
                120374: {
                    c: "u",
                    f: "SSI"
                },
                120375: {
                    c: "v",
                    f: "SSI"
                },
                120376: {
                    c: "w",
                    f: "SSI"
                },
                120377: {
                    c: "x",
                    f: "SSI"
                },
                120378: {
                    c: "y",
                    f: "SSI"
                },
                120379: {
                    c: "z",
                    f: "SSI"
                },
                120432: {
                    c: "A",
                    f: "T"
                },
                120433: {
                    c: "B",
                    f: "T"
                },
                120434: {
                    c: "C",
                    f: "T"
                },
                120435: {
                    c: "D",
                    f: "T"
                },
                120436: {
                    c: "E",
                    f: "T"
                },
                120437: {
                    c: "F",
                    f: "T"
                },
                120438: {
                    c: "G",
                    f: "T"
                },
                120439: {
                    c: "H",
                    f: "T"
                },
                120440: {
                    c: "I",
                    f: "T"
                },
                120441: {
                    c: "J",
                    f: "T"
                },
                120442: {
                    c: "K",
                    f: "T"
                },
                120443: {
                    c: "L",
                    f: "T"
                },
                120444: {
                    c: "M",
                    f: "T"
                },
                120445: {
                    c: "N",
                    f: "T"
                },
                120446: {
                    c: "O",
                    f: "T"
                },
                120447: {
                    c: "P",
                    f: "T"
                },
                120448: {
                    c: "Q",
                    f: "T"
                },
                120449: {
                    c: "R",
                    f: "T"
                },
                120450: {
                    c: "S",
                    f: "T"
                },
                120451: {
                    c: "T",
                    f: "T"
                },
                120452: {
                    c: "U",
                    f: "T"
                },
                120453: {
                    c: "V",
                    f: "T"
                },
                120454: {
                    c: "W",
                    f: "T"
                },
                120455: {
                    c: "X",
                    f: "T"
                },
                120456: {
                    c: "Y",
                    f: "T"
                },
                120457: {
                    c: "Z",
                    f: "T"
                },
                120458: {
                    c: "a",
                    f: "T"
                },
                120459: {
                    c: "b",
                    f: "T"
                },
                120460: {
                    c: "c",
                    f: "T"
                },
                120461: {
                    c: "d",
                    f: "T"
                },
                120462: {
                    c: "e",
                    f: "T"
                },
                120463: {
                    c: "f",
                    f: "T"
                },
                120464: {
                    c: "g",
                    f: "T"
                },
                120465: {
                    c: "h",
                    f: "T"
                },
                120466: {
                    c: "i",
                    f: "T"
                },
                120467: {
                    c: "j",
                    f: "T"
                },
                120468: {
                    c: "k",
                    f: "T"
                },
                120469: {
                    c: "l",
                    f: "T"
                },
                120470: {
                    c: "m",
                    f: "T"
                },
                120471: {
                    c: "n",
                    f: "T"
                },
                120472: {
                    c: "o",
                    f: "T"
                },
                120473: {
                    c: "p",
                    f: "T"
                },
                120474: {
                    c: "q",
                    f: "T"
                },
                120475: {
                    c: "r",
                    f: "T"
                },
                120476: {
                    c: "s",
                    f: "T"
                },
                120477: {
                    c: "t",
                    f: "T"
                },
                120478: {
                    c: "u",
                    f: "T"
                },
                120479: {
                    c: "v",
                    f: "T"
                },
                120480: {
                    c: "w",
                    f: "T"
                },
                120481: {
                    c: "x",
                    f: "T"
                },
                120482: {
                    c: "y",
                    f: "T"
                },
                120483: {
                    c: "z",
                    f: "T"
                },
                120488: {
                    c: "A",
                    f: "B"
                },
                120489: {
                    c: "B",
                    f: "B"
                },
                120490: {
                    c: "\\393",
                    f: "B"
                },
                120491: {
                    c: "\\394",
                    f: "B"
                },
                120492: {
                    c: "E",
                    f: "B"
                },
                120493: {
                    c: "Z",
                    f: "B"
                },
                120494: {
                    c: "H",
                    f: "B"
                },
                120495: {
                    c: "\\398",
                    f: "B"
                },
                120496: {
                    c: "I",
                    f: "B"
                },
                120497: {
                    c: "K",
                    f: "B"
                },
                120498: {
                    c: "\\39B",
                    f: "B"
                },
                120499: {
                    c: "M",
                    f: "B"
                },
                120500: {
                    c: "N",
                    f: "B"
                },
                120501: {
                    c: "\\39E",
                    f: "B"
                },
                120502: {
                    c: "O",
                    f: "B"
                },
                120503: {
                    c: "\\3A0",
                    f: "B"
                },
                120504: {
                    c: "P",
                    f: "B"
                },
                120506: {
                    c: "\\3A3",
                    f: "B"
                },
                120507: {
                    c: "T",
                    f: "B"
                },
                120508: {
                    c: "\\3A5",
                    f: "B"
                },
                120509: {
                    c: "\\3A6",
                    f: "B"
                },
                120510: {
                    c: "X",
                    f: "B"
                },
                120511: {
                    c: "\\3A8",
                    f: "B"
                },
                120512: {
                    c: "\\3A9",
                    f: "B"
                },
                120513: {
                    c: "\\2207",
                    f: "B"
                },
                120546: {
                    c: "A",
                    f: "I"
                },
                120547: {
                    c: "B",
                    f: "I"
                },
                120548: {
                    c: "\\393",
                    f: "I"
                },
                120549: {
                    c: "\\394",
                    f: "I"
                },
                120550: {
                    c: "E",
                    f: "I"
                },
                120551: {
                    c: "Z",
                    f: "I"
                },
                120552: {
                    c: "H",
                    f: "I"
                },
                120553: {
                    c: "\\398",
                    f: "I"
                },
                120554: {
                    c: "I",
                    f: "I"
                },
                120555: {
                    c: "K",
                    f: "I"
                },
                120556: {
                    c: "\\39B",
                    f: "I"
                },
                120557: {
                    c: "M",
                    f: "I"
                },
                120558: {
                    c: "N",
                    f: "I"
                },
                120559: {
                    c: "\\39E",
                    f: "I"
                },
                120560: {
                    c: "O",
                    f: "I"
                },
                120561: {
                    c: "\\3A0",
                    f: "I"
                },
                120562: {
                    c: "P",
                    f: "I"
                },
                120564: {
                    c: "\\3A3",
                    f: "I"
                },
                120565: {
                    c: "T",
                    f: "I"
                },
                120566: {
                    c: "\\3A5",
                    f: "I"
                },
                120567: {
                    c: "\\3A6",
                    f: "I"
                },
                120568: {
                    c: "X",
                    f: "I"
                },
                120569: {
                    c: "\\3A8",
                    f: "I"
                },
                120570: {
                    c: "\\3A9",
                    f: "I"
                },
                120572: {
                    c: "\\3B1",
                    f: "I"
                },
                120573: {
                    c: "\\3B2",
                    f: "I"
                },
                120574: {
                    c: "\\3B3",
                    f: "I"
                },
                120575: {
                    c: "\\3B4",
                    f: "I"
                },
                120576: {
                    c: "\\3B5",
                    f: "I"
                },
                120577: {
                    c: "\\3B6",
                    f: "I"
                },
                120578: {
                    c: "\\3B7",
                    f: "I"
                },
                120579: {
                    c: "\\3B8",
                    f: "I"
                },
                120580: {
                    c: "\\3B9",
                    f: "I"
                },
                120581: {
                    c: "\\3BA",
                    f: "I"
                },
                120582: {
                    c: "\\3BB",
                    f: "I"
                },
                120583: {
                    c: "\\3BC",
                    f: "I"
                },
                120584: {
                    c: "\\3BD",
                    f: "I"
                },
                120585: {
                    c: "\\3BE",
                    f: "I"
                },
                120586: {
                    c: "\\3BF",
                    f: "I"
                },
                120587: {
                    c: "\\3C0",
                    f: "I"
                },
                120588: {
                    c: "\\3C1",
                    f: "I"
                },
                120589: {
                    c: "\\3C2",
                    f: "I"
                },
                120590: {
                    c: "\\3C3",
                    f: "I"
                },
                120591: {
                    c: "\\3C4",
                    f: "I"
                },
                120592: {
                    c: "\\3C5",
                    f: "I"
                },
                120593: {
                    c: "\\3C6",
                    f: "I"
                },
                120594: {
                    c: "\\3C7",
                    f: "I"
                },
                120595: {
                    c: "\\3C8",
                    f: "I"
                },
                120596: {
                    c: "\\3C9",
                    f: "I"
                },
                120597: {
                    c: "\\2202"
                },
                120598: {
                    c: "\\3F5",
                    f: "I"
                },
                120599: {
                    c: "\\3D1",
                    f: "I"
                },
                120600: {
                    c: "\\E009",
                    f: "A"
                },
                120601: {
                    c: "\\3D5",
                    f: "I"
                },
                120602: {
                    c: "\\3F1",
                    f: "I"
                },
                120603: {
                    c: "\\3D6",
                    f: "I"
                },
                120604: {
                    c: "A",
                    f: "BI"
                },
                120605: {
                    c: "B",
                    f: "BI"
                },
                120606: {
                    c: "\\393",
                    f: "BI"
                },
                120607: {
                    c: "\\394",
                    f: "BI"
                },
                120608: {
                    c: "E",
                    f: "BI"
                },
                120609: {
                    c: "Z",
                    f: "BI"
                },
                120610: {
                    c: "H",
                    f: "BI"
                },
                120611: {
                    c: "\\398",
                    f: "BI"
                },
                120612: {
                    c: "I",
                    f: "BI"
                },
                120613: {
                    c: "K",
                    f: "BI"
                },
                120614: {
                    c: "\\39B",
                    f: "BI"
                },
                120615: {
                    c: "M",
                    f: "BI"
                },
                120616: {
                    c: "N",
                    f: "BI"
                },
                120617: {
                    c: "\\39E",
                    f: "BI"
                },
                120618: {
                    c: "O",
                    f: "BI"
                },
                120619: {
                    c: "\\3A0",
                    f: "BI"
                },
                120620: {
                    c: "P",
                    f: "BI"
                },
                120622: {
                    c: "\\3A3",
                    f: "BI"
                },
                120623: {
                    c: "T",
                    f: "BI"
                },
                120624: {
                    c: "\\3A5",
                    f: "BI"
                },
                120625: {
                    c: "\\3A6",
                    f: "BI"
                },
                120626: {
                    c: "X",
                    f: "BI"
                },
                120627: {
                    c: "\\3A8",
                    f: "BI"
                },
                120628: {
                    c: "\\3A9",
                    f: "BI"
                },
                120630: {
                    c: "\\3B1",
                    f: "BI"
                },
                120631: {
                    c: "\\3B2",
                    f: "BI"
                },
                120632: {
                    c: "\\3B3",
                    f: "BI"
                },
                120633: {
                    c: "\\3B4",
                    f: "BI"
                },
                120634: {
                    c: "\\3B5",
                    f: "BI"
                },
                120635: {
                    c: "\\3B6",
                    f: "BI"
                },
                120636: {
                    c: "\\3B7",
                    f: "BI"
                },
                120637: {
                    c: "\\3B8",
                    f: "BI"
                },
                120638: {
                    c: "\\3B9",
                    f: "BI"
                },
                120639: {
                    c: "\\3BA",
                    f: "BI"
                },
                120640: {
                    c: "\\3BB",
                    f: "BI"
                },
                120641: {
                    c: "\\3BC",
                    f: "BI"
                },
                120642: {
                    c: "\\3BD",
                    f: "BI"
                },
                120643: {
                    c: "\\3BE",
                    f: "BI"
                },
                120644: {
                    c: "\\3BF",
                    f: "BI"
                },
                120645: {
                    c: "\\3C0",
                    f: "BI"
                },
                120646: {
                    c: "\\3C1",
                    f: "BI"
                },
                120647: {
                    c: "\\3C2",
                    f: "BI"
                },
                120648: {
                    c: "\\3C3",
                    f: "BI"
                },
                120649: {
                    c: "\\3C4",
                    f: "BI"
                },
                120650: {
                    c: "\\3C5",
                    f: "BI"
                },
                120651: {
                    c: "\\3C6",
                    f: "BI"
                },
                120652: {
                    c: "\\3C7",
                    f: "BI"
                },
                120653: {
                    c: "\\3C8",
                    f: "BI"
                },
                120654: {
                    c: "\\3C9",
                    f: "BI"
                },
                120655: {
                    c: "\\2202",
                    f: "B"
                },
                120656: {
                    c: "\\3F5",
                    f: "BI"
                },
                120657: {
                    c: "\\3D1",
                    f: "BI"
                },
                120658: {
                    c: "\\E009",
                    f: "A"
                },
                120659: {
                    c: "\\3D5",
                    f: "BI"
                },
                120660: {
                    c: "\\3F1",
                    f: "BI"
                },
                120661: {
                    c: "\\3D6",
                    f: "BI"
                },
                120662: {
                    c: "A",
                    f: "SSB"
                },
                120663: {
                    c: "B",
                    f: "SSB"
                },
                120664: {
                    c: "\\393",
                    f: "SSB"
                },
                120665: {
                    c: "\\394",
                    f: "SSB"
                },
                120666: {
                    c: "E",
                    f: "SSB"
                },
                120667: {
                    c: "Z",
                    f: "SSB"
                },
                120668: {
                    c: "H",
                    f: "SSB"
                },
                120669: {
                    c: "\\398",
                    f: "SSB"
                },
                120670: {
                    c: "I",
                    f: "SSB"
                },
                120671: {
                    c: "K",
                    f: "SSB"
                },
                120672: {
                    c: "\\39B",
                    f: "SSB"
                },
                120673: {
                    c: "M",
                    f: "SSB"
                },
                120674: {
                    c: "N",
                    f: "SSB"
                },
                120675: {
                    c: "\\39E",
                    f: "SSB"
                },
                120676: {
                    c: "O",
                    f: "SSB"
                },
                120677: {
                    c: "\\3A0",
                    f: "SSB"
                },
                120678: {
                    c: "P",
                    f: "SSB"
                },
                120680: {
                    c: "\\3A3",
                    f: "SSB"
                },
                120681: {
                    c: "T",
                    f: "SSB"
                },
                120682: {
                    c: "\\3A5",
                    f: "SSB"
                },
                120683: {
                    c: "\\3A6",
                    f: "SSB"
                },
                120684: {
                    c: "X",
                    f: "SSB"
                },
                120685: {
                    c: "\\3A8",
                    f: "SSB"
                },
                120686: {
                    c: "\\3A9",
                    f: "SSB"
                },
                120782: {
                    c: "0",
                    f: "B"
                },
                120783: {
                    c: "1",
                    f: "B"
                },
                120784: {
                    c: "2",
                    f: "B"
                },
                120785: {
                    c: "3",
                    f: "B"
                },
                120786: {
                    c: "4",
                    f: "B"
                },
                120787: {
                    c: "5",
                    f: "B"
                },
                120788: {
                    c: "6",
                    f: "B"
                },
                120789: {
                    c: "7",
                    f: "B"
                },
                120790: {
                    c: "8",
                    f: "B"
                },
                120791: {
                    c: "9",
                    f: "B"
                },
                120802: {
                    c: "0",
                    f: "SS"
                },
                120803: {
                    c: "1",
                    f: "SS"
                },
                120804: {
                    c: "2",
                    f: "SS"
                },
                120805: {
                    c: "3",
                    f: "SS"
                },
                120806: {
                    c: "4",
                    f: "SS"
                },
                120807: {
                    c: "5",
                    f: "SS"
                },
                120808: {
                    c: "6",
                    f: "SS"
                },
                120809: {
                    c: "7",
                    f: "SS"
                },
                120810: {
                    c: "8",
                    f: "SS"
                },
                120811: {
                    c: "9",
                    f: "SS"
                },
                120812: {
                    c: "0",
                    f: "SSB"
                },
                120813: {
                    c: "1",
                    f: "SSB"
                },
                120814: {
                    c: "2",
                    f: "SSB"
                },
                120815: {
                    c: "3",
                    f: "SSB"
                },
                120816: {
                    c: "4",
                    f: "SSB"
                },
                120817: {
                    c: "5",
                    f: "SSB"
                },
                120818: {
                    c: "6",
                    f: "SSB"
                },
                120819: {
                    c: "7",
                    f: "SSB"
                },
                120820: {
                    c: "8",
                    f: "SSB"
                },
                120821: {
                    c: "9",
                    f: "SSB"
                },
                120822: {
                    c: "0",
                    f: "T"
                },
                120823: {
                    c: "1",
                    f: "T"
                },
                120824: {
                    c: "2",
                    f: "T"
                },
                120825: {
                    c: "3",
                    f: "T"
                },
                120826: {
                    c: "4",
                    f: "T"
                },
                120827: {
                    c: "5",
                    f: "T"
                },
                120828: {
                    c: "6",
                    f: "T"
                },
                120829: {
                    c: "7",
                    f: "T"
                },
                120830: {
                    c: "8",
                    f: "T"
                },
                120831: {
                    c: "9",
                    f: "T"
                }
            });
        },
        7517: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerifBoldItalic = void 0;
            var n1 = r1(8042), o1 = r1(4886);
            e1.sansSerifBoldItalic = (0, n1.AddCSS)(o1.sansSerifBoldItalic, {
                305: {
                    f: "SSB"
                },
                567: {
                    f: "SSB"
                }
            });
        },
        4182: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerifBold = void 0;
            var n1 = r1(8042), o1 = r1(4471);
            e1.sansSerifBold = (0, n1.AddCSS)(o1.sansSerifBold, {
                8213: {
                    c: "\\2014"
                },
                8215: {
                    c: "_"
                },
                8260: {
                    c: "/"
                },
                8710: {
                    c: "\\394"
                }
            });
        },
        2679: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerifItalic = void 0;
            var n1 = r1(8042), o1 = r1(5181);
            e1.sansSerifItalic = (0, n1.AddCSS)(o1.sansSerifItalic, {
                913: {
                    c: "A"
                },
                914: {
                    c: "B"
                },
                917: {
                    c: "E"
                },
                918: {
                    c: "Z"
                },
                919: {
                    c: "H"
                },
                921: {
                    c: "I"
                },
                922: {
                    c: "K"
                },
                924: {
                    c: "M"
                },
                925: {
                    c: "N"
                },
                927: {
                    c: "O"
                },
                929: {
                    c: "P"
                },
                932: {
                    c: "T"
                },
                935: {
                    c: "X"
                },
                8213: {
                    c: "\\2014"
                },
                8215: {
                    c: "_"
                },
                8260: {
                    c: "/"
                },
                8710: {
                    c: "\\394"
                }
            });
        },
        5469: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerif = void 0;
            var n1 = r1(8042), o1 = r1(3526);
            e1.sansSerif = (0, n1.AddCSS)(o1.sansSerif, {
                913: {
                    c: "A"
                },
                914: {
                    c: "B"
                },
                917: {
                    c: "E"
                },
                918: {
                    c: "Z"
                },
                919: {
                    c: "H"
                },
                921: {
                    c: "I"
                },
                922: {
                    c: "K"
                },
                924: {
                    c: "M"
                },
                925: {
                    c: "N"
                },
                927: {
                    c: "O"
                },
                929: {
                    c: "P"
                },
                932: {
                    c: "T"
                },
                935: {
                    c: "X"
                },
                8213: {
                    c: "\\2014"
                },
                8215: {
                    c: "_"
                },
                8260: {
                    c: "/"
                },
                8710: {
                    c: "\\394"
                }
            });
        },
        7563: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.scriptBold = void 0;
            var n1 = r1(5649);
            Object.defineProperty(e1, "scriptBold", {
                enumerable: !0,
                get: function() {
                    return n1.scriptBold;
                }
            });
        },
        9409: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.script = void 0;
            var n1 = r1(7153);
            Object.defineProperty(e1, "script", {
                enumerable: !0,
                get: function() {
                    return n1.script;
                }
            });
        },
        775: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.smallop = void 0;
            var n1 = r1(8042), o1 = r1(5745);
            e1.smallop = (0, n1.AddCSS)(o1.smallop, {
                8260: {
                    c: "/"
                },
                9001: {
                    c: "\\27E8"
                },
                9002: {
                    c: "\\27E9"
                },
                10072: {
                    c: "\\2223"
                },
                10764: {
                    c: "\\222C\\222C"
                },
                12296: {
                    c: "\\27E8"
                },
                12297: {
                    c: "\\27E9"
                }
            });
        },
        9551: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texCalligraphicBold = void 0;
            var n1 = r1(8042), o1 = r1(1411);
            e1.texCalligraphicBold = (0, n1.AddCSS)(o1.texCalligraphicBold, {
                305: {
                    f: "B"
                },
                567: {
                    f: "B"
                }
            });
        },
        7907: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texCalligraphic = void 0;
            var n1 = r1(6384);
            Object.defineProperty(e1, "texCalligraphic", {
                enumerable: !0,
                get: function() {
                    return n1.texCalligraphic;
                }
            });
        },
        9659: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texMathit = void 0;
            var n1 = r1(6041);
            Object.defineProperty(e1, "texMathit", {
                enumerable: !0,
                get: function() {
                    return n1.texMathit;
                }
            });
        },
        98: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texOldstyleBold = void 0;
            var n1 = r1(8199);
            Object.defineProperty(e1, "texOldstyleBold", {
                enumerable: !0,
                get: function() {
                    return n1.texOldstyleBold;
                }
            });
        },
        6275: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texOldstyle = void 0;
            var n1 = r1(9848);
            Object.defineProperty(e1, "texOldstyle", {
                enumerable: !0,
                get: function() {
                    return n1.texOldstyle;
                }
            });
        },
        6530: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texSize3 = void 0;
            var n1 = r1(8042), o1 = r1(7906);
            e1.texSize3 = (0, n1.AddCSS)(o1.texSize3, {
                8260: {
                    c: "/"
                },
                9001: {
                    c: "\\27E8"
                },
                9002: {
                    c: "\\27E9"
                },
                12296: {
                    c: "\\27E8"
                },
                12297: {
                    c: "\\27E9"
                }
            });
        },
        4409: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texSize4 = void 0;
            var n1 = r1(8042), o1 = r1(2644);
            e1.texSize4 = (0, n1.AddCSS)(o1.texSize4, {
                8260: {
                    c: "/"
                },
                9001: {
                    c: "\\27E8"
                },
                9002: {
                    c: "\\27E9"
                },
                12296: {
                    c: "\\27E8"
                },
                12297: {
                    c: "\\27E9"
                },
                57685: {
                    c: "\\E153\\E152"
                },
                57686: {
                    c: "\\E151\\E150"
                }
            });
        },
        5292: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texVariant = void 0;
            var n1 = r1(8042), o1 = r1(4926);
            e1.texVariant = (0, n1.AddCSS)(o1.texVariant, {
                1008: {
                    c: "\\E009"
                },
                8463: {
                    f: ""
                },
                8740: {
                    c: "\\E006"
                },
                8742: {
                    c: "\\E007"
                },
                8808: {
                    c: "\\E00C"
                },
                8809: {
                    c: "\\E00D"
                },
                8816: {
                    c: "\\E011"
                },
                8817: {
                    c: "\\E00E"
                },
                8840: {
                    c: "\\E016"
                },
                8841: {
                    c: "\\E018"
                },
                8842: {
                    c: "\\E01A"
                },
                8843: {
                    c: "\\E01B"
                },
                10887: {
                    c: "\\E010"
                },
                10888: {
                    c: "\\E00F"
                },
                10955: {
                    c: "\\E017"
                },
                10956: {
                    c: "\\E019"
                }
            });
        },
        5884: function(t1, e1, r1) {
            var n1 = this && this.__assign || function() {
                return n1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, n1.apply(this, arguments);
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.FontData = e1.NOSTRETCH = e1.H = e1.V = void 0;
            var a1 = r1(7233);
            e1.V = 1, e1.H = 2, e1.NOSTRETCH = {
                dir: 0
            };
            var l1 = function() {
                function t1(t1) {
                    var e1, r1, l1, c1;
                    void 0 === t1 && (t1 = null), this.variant = {}, this.delimiters = {}, this.cssFontMap = {}, this.remapChars = {}, this.skewIcFactor = .75;
                    var u1 = this.constructor;
                    this.options = (0, a1.userOptions)((0, a1.defaultOptions)({}, u1.OPTIONS), t1), this.params = n1({}, u1.defaultParams), this.sizeVariants = i1([], o1(u1.defaultSizeVariants), !1), this.stretchVariants = i1([], o1(u1.defaultStretchVariants), !1), this.cssFontMap = n1({}, u1.defaultCssFonts);
                    try {
                        for(var p1 = s1(Object.keys(this.cssFontMap)), h1 = p1.next(); !h1.done; h1 = p1.next()){
                            var f1 = h1.value;
                            "unknown" === this.cssFontMap[f1][0] && (this.cssFontMap[f1][0] = this.options.unknownFamily);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            h1 && !h1.done && (r1 = p1.return) && r1.call(p1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    this.cssFamilyPrefix = u1.defaultCssFamilyPrefix, this.createVariants(u1.defaultVariants), this.defineDelimiters(u1.defaultDelimiters);
                    try {
                        for(var d1 = s1(Object.keys(u1.defaultChars)), m1 = d1.next(); !m1.done; m1 = d1.next()){
                            var y1 = m1.value;
                            this.defineChars(y1, u1.defaultChars[y1]);
                        }
                    } catch (t1) {
                        l1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            m1 && !m1.done && (c1 = d1.return) && c1.call(d1);
                        } finally{
                            if (l1) throw l1.error;
                        }
                    }
                    this.defineRemap("accent", u1.defaultAccentMap), this.defineRemap("mo", u1.defaultMoMap), this.defineRemap("mn", u1.defaultMnMap);
                }
                return t1.charOptions = function(t1, e1) {
                    var r1 = t1[e1];
                    return 3 === r1.length && (r1[3] = {}), r1[3];
                }, Object.defineProperty(t1.prototype, "styles", {
                    get: function() {
                        return this._styles;
                    },
                    set: function(t1) {
                        this._styles = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.createVariant = function(t1, e1, r1) {
                    void 0 === e1 && (e1 = null), void 0 === r1 && (r1 = null);
                    var n1 = {
                        linked: [],
                        chars: e1 ? Object.create(this.variant[e1].chars) : {}
                    };
                    r1 && this.variant[r1] && (Object.assign(n1.chars, this.variant[r1].chars), this.variant[r1].linked.push(n1.chars), n1.chars = Object.create(n1.chars)), this.remapSmpChars(n1.chars, t1), this.variant[t1] = n1;
                }, t1.prototype.remapSmpChars = function(t1, e1) {
                    var r1, n1, i1, a1, l1 = this.constructor;
                    if (l1.VariantSmp[e1]) {
                        var c1 = l1.SmpRemap, u1 = [
                            null,
                            null,
                            l1.SmpRemapGreekU,
                            l1.SmpRemapGreekL
                        ];
                        try {
                            for(var p1 = s1(l1.SmpRanges), h1 = p1.next(); !h1.done; h1 = p1.next()){
                                var f1 = o1(h1.value, 3), d1 = f1[0], m1 = f1[1], y1 = f1[2], g1 = l1.VariantSmp[e1][d1];
                                if (g1) {
                                    for(var b1 = m1; b1 <= y1; b1++)if (930 !== b1) {
                                        var v1 = g1 + b1 - m1;
                                        t1[b1] = this.smpChar(c1[v1] || v1);
                                    }
                                    if (u1[d1]) try {
                                        for(var _1 = (i1 = void 0, s1(Object.keys(u1[d1]).map(function(t1) {
                                            return parseInt(t1);
                                        }))), S1 = _1.next(); !S1.done; S1 = _1.next())t1[b1 = S1.value] = this.smpChar(g1 + u1[d1][b1]);
                                    } catch (t1) {
                                        i1 = {
                                            error: t1
                                        };
                                    } finally{
                                        try {
                                            S1 && !S1.done && (a1 = _1.return) && a1.call(_1);
                                        } finally{
                                            if (i1) throw i1.error;
                                        }
                                    }
                                }
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                h1 && !h1.done && (n1 = p1.return) && n1.call(p1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                    }
                    "bold" === e1 && (t1[988] = this.smpChar(120778), t1[989] = this.smpChar(120779));
                }, t1.prototype.smpChar = function(t1) {
                    return [
                        ,
                        ,
                        ,
                        {
                            smp: t1
                        }
                    ];
                }, t1.prototype.createVariants = function(t1) {
                    var e1, r1;
                    try {
                        for(var n1 = s1(t1), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value;
                            this.createVariant(i1[0], i1[1], i1[2]);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.defineChars = function(t1, e1) {
                    var r1, n1, o1 = this.variant[t1];
                    Object.assign(o1.chars, e1);
                    try {
                        for(var i1 = s1(o1.linked), a1 = i1.next(); !a1.done; a1 = i1.next()){
                            var l1 = a1.value;
                            Object.assign(l1, e1);
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = i1.return) && n1.call(i1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                }, t1.prototype.defineDelimiters = function(t1) {
                    Object.assign(this.delimiters, t1);
                }, t1.prototype.defineRemap = function(t1, e1) {
                    this.remapChars.hasOwnProperty(t1) || (this.remapChars[t1] = {}), Object.assign(this.remapChars[t1], e1);
                }, t1.prototype.getDelimiter = function(t1) {
                    return this.delimiters[t1];
                }, t1.prototype.getSizeVariant = function(t1, e1) {
                    return this.delimiters[t1].variants && (e1 = this.delimiters[t1].variants[e1]), this.sizeVariants[e1];
                }, t1.prototype.getStretchVariant = function(t1, e1) {
                    return this.stretchVariants[this.delimiters[t1].stretchv ? this.delimiters[t1].stretchv[e1] : 0];
                }, t1.prototype.getChar = function(t1, e1) {
                    return this.variant[t1].chars[e1];
                }, t1.prototype.getVariant = function(t1) {
                    return this.variant[t1];
                }, t1.prototype.getCssFont = function(t1) {
                    return this.cssFontMap[t1] || [
                        "serif",
                        !1,
                        !1
                    ];
                }, t1.prototype.getFamily = function(t1) {
                    return this.cssFamilyPrefix ? this.cssFamilyPrefix + ", " + t1 : t1;
                }, t1.prototype.getRemappedChar = function(t1, e1) {
                    return (this.remapChars[t1] || {})[e1];
                }, t1.OPTIONS = {
                    unknownFamily: "serif"
                }, t1.JAX = "common", t1.NAME = "", t1.defaultVariants = [
                    [
                        "normal"
                    ],
                    [
                        "bold",
                        "normal"
                    ],
                    [
                        "italic",
                        "normal"
                    ],
                    [
                        "bold-italic",
                        "italic",
                        "bold"
                    ],
                    [
                        "double-struck",
                        "bold"
                    ],
                    [
                        "fraktur",
                        "normal"
                    ],
                    [
                        "bold-fraktur",
                        "bold",
                        "fraktur"
                    ],
                    [
                        "script",
                        "italic"
                    ],
                    [
                        "bold-script",
                        "bold-italic",
                        "script"
                    ],
                    [
                        "sans-serif",
                        "normal"
                    ],
                    [
                        "bold-sans-serif",
                        "bold",
                        "sans-serif"
                    ],
                    [
                        "sans-serif-italic",
                        "italic",
                        "sans-serif"
                    ],
                    [
                        "sans-serif-bold-italic",
                        "bold-italic",
                        "bold-sans-serif"
                    ],
                    [
                        "monospace",
                        "normal"
                    ]
                ], t1.defaultCssFonts = {
                    normal: [
                        "unknown",
                        !1,
                        !1
                    ],
                    bold: [
                        "unknown",
                        !1,
                        !0
                    ],
                    italic: [
                        "unknown",
                        !0,
                        !1
                    ],
                    "bold-italic": [
                        "unknown",
                        !0,
                        !0
                    ],
                    "double-struck": [
                        "unknown",
                        !1,
                        !0
                    ],
                    fraktur: [
                        "unknown",
                        !1,
                        !1
                    ],
                    "bold-fraktur": [
                        "unknown",
                        !1,
                        !0
                    ],
                    script: [
                        "cursive",
                        !1,
                        !1
                    ],
                    "bold-script": [
                        "cursive",
                        !1,
                        !0
                    ],
                    "sans-serif": [
                        "sans-serif",
                        !1,
                        !1
                    ],
                    "bold-sans-serif": [
                        "sans-serif",
                        !1,
                        !0
                    ],
                    "sans-serif-italic": [
                        "sans-serif",
                        !0,
                        !1
                    ],
                    "sans-serif-bold-italic": [
                        "sans-serif",
                        !0,
                        !0
                    ],
                    monospace: [
                        "monospace",
                        !1,
                        !1
                    ]
                }, t1.defaultCssFamilyPrefix = "", t1.VariantSmp = {
                    bold: [
                        119808,
                        119834,
                        120488,
                        120514,
                        120782
                    ],
                    italic: [
                        119860,
                        119886,
                        120546,
                        120572
                    ],
                    "bold-italic": [
                        119912,
                        119938,
                        120604,
                        120630
                    ],
                    script: [
                        119964,
                        119990
                    ],
                    "bold-script": [
                        120016,
                        120042
                    ],
                    fraktur: [
                        120068,
                        120094
                    ],
                    "double-struck": [
                        120120,
                        120146,
                        ,
                        ,
                        120792
                    ],
                    "bold-fraktur": [
                        120172,
                        120198
                    ],
                    "sans-serif": [
                        120224,
                        120250,
                        ,
                        ,
                        120802
                    ],
                    "bold-sans-serif": [
                        120276,
                        120302,
                        120662,
                        120688,
                        120812
                    ],
                    "sans-serif-italic": [
                        120328,
                        120354
                    ],
                    "sans-serif-bold-italic": [
                        120380,
                        120406,
                        120720,
                        120746
                    ],
                    monospace: [
                        120432,
                        120458,
                        ,
                        ,
                        120822
                    ]
                }, t1.SmpRanges = [
                    [
                        0,
                        65,
                        90
                    ],
                    [
                        1,
                        97,
                        122
                    ],
                    [
                        2,
                        913,
                        937
                    ],
                    [
                        3,
                        945,
                        969
                    ],
                    [
                        4,
                        48,
                        57
                    ]
                ], t1.SmpRemap = {
                    119893: 8462,
                    119965: 8492,
                    119968: 8496,
                    119969: 8497,
                    119971: 8459,
                    119972: 8464,
                    119975: 8466,
                    119976: 8499,
                    119981: 8475,
                    119994: 8495,
                    119996: 8458,
                    120004: 8500,
                    120070: 8493,
                    120075: 8460,
                    120076: 8465,
                    120085: 8476,
                    120093: 8488,
                    120122: 8450,
                    120127: 8461,
                    120133: 8469,
                    120135: 8473,
                    120136: 8474,
                    120137: 8477,
                    120145: 8484
                }, t1.SmpRemapGreekU = {
                    8711: 25,
                    1012: 17
                }, t1.SmpRemapGreekL = {
                    977: 27,
                    981: 29,
                    982: 31,
                    1008: 28,
                    1009: 30,
                    1013: 26,
                    8706: 25
                }, t1.defaultAccentMap = {
                    768: "ˋ",
                    769: "ˊ",
                    770: "ˆ",
                    771: "˜",
                    772: "ˉ",
                    774: "˘",
                    775: "˙",
                    776: "\xa8",
                    778: "˚",
                    780: "ˇ",
                    8594: "⃗",
                    8242: "'",
                    8243: "''",
                    8244: "'''",
                    8245: "`",
                    8246: "``",
                    8247: "```",
                    8279: "''''",
                    8400: "↼",
                    8401: "⇀",
                    8406: "←",
                    8417: "↔",
                    8432: "*",
                    8411: "...",
                    8412: "....",
                    8428: "⇁",
                    8429: "↽",
                    8430: "←",
                    8431: "→"
                }, t1.defaultMoMap = {
                    45: "−"
                }, t1.defaultMnMap = {
                    45: "−"
                }, t1.defaultParams = {
                    x_height: .442,
                    quad: 1,
                    num1: .676,
                    num2: .394,
                    num3: .444,
                    denom1: .686,
                    denom2: .345,
                    sup1: .413,
                    sup2: .363,
                    sup3: .289,
                    sub1: .15,
                    sub2: .247,
                    sup_drop: .386,
                    sub_drop: .05,
                    delim1: 2.39,
                    delim2: 1,
                    axis_height: .25,
                    rule_thickness: .06,
                    big_op_spacing1: .111,
                    big_op_spacing2: .167,
                    big_op_spacing3: .2,
                    big_op_spacing4: .6,
                    big_op_spacing5: .1,
                    surd_height: .075,
                    scriptspace: .05,
                    nulldelimiterspace: .12,
                    delimiterfactor: 901,
                    delimitershortfall: .3,
                    min_rule_thickness: 1.25,
                    separation_factor: 1.75,
                    extra_ic: .033
                }, t1.defaultDelimiters = {}, t1.defaultChars = {}, t1.defaultSizeVariants = [], t1.defaultStretchVariants = [], t1;
            }();
            e1.FontData = l1;
        },
        5552: function(t1, e1) {
            var r1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonArrow = e1.CommonDiagonalArrow = e1.CommonDiagonalStrike = e1.CommonBorder2 = e1.CommonBorder = e1.arrowBBox = e1.diagonalArrowDef = e1.arrowDef = e1.arrowBBoxW = e1.arrowBBoxHD = e1.arrowHead = e1.fullBorder = e1.fullPadding = e1.fullBBox = e1.sideNames = e1.sideIndex = e1.SOLID = e1.PADDING = e1.THICKNESS = e1.ARROWY = e1.ARROWDX = e1.ARROWX = void 0, e1.ARROWX = 4, e1.ARROWDX = 1, e1.ARROWY = 2, e1.THICKNESS = .067, e1.PADDING = .2, e1.SOLID = e1.THICKNESS + "em solid", e1.sideIndex = {
                top: 0,
                right: 1,
                bottom: 2,
                left: 3
            }, e1.sideNames = Object.keys(e1.sideIndex), e1.fullBBox = function(t1) {
                return new Array(4).fill(t1.thickness + t1.padding);
            }, e1.fullPadding = function(t1) {
                return new Array(4).fill(t1.padding);
            }, e1.fullBorder = function(t1) {
                return new Array(4).fill(t1.thickness);
            };
            e1.arrowHead = function(t1) {
                return Math.max(t1.padding, t1.thickness * (t1.arrowhead.x + t1.arrowhead.dx + 1));
            };
            e1.arrowBBoxHD = function(t1, e1) {
                if (t1.childNodes[0]) {
                    var r1 = t1.childNodes[0].getBBox(), n1 = r1.h, o1 = r1.d;
                    e1[0] = e1[2] = Math.max(0, t1.thickness * t1.arrowhead.y - (n1 + o1) / 2);
                }
                return e1;
            };
            e1.arrowBBoxW = function(t1, e1) {
                if (t1.childNodes[0]) {
                    var r1 = t1.childNodes[0].getBBox().w;
                    e1[1] = e1[3] = Math.max(0, t1.thickness * t1.arrowhead.y - r1 / 2);
                }
                return e1;
            }, e1.arrowDef = {
                up: [
                    -Math.PI / 2,
                    !1,
                    !0,
                    "verticalstrike"
                ],
                down: [
                    Math.PI / 2,
                    !1,
                    !0,
                    "verticakstrike"
                ],
                right: [
                    0,
                    !1,
                    !1,
                    "horizontalstrike"
                ],
                left: [
                    Math.PI,
                    !1,
                    !1,
                    "horizontalstrike"
                ],
                updown: [
                    Math.PI / 2,
                    !0,
                    !0,
                    "verticalstrike uparrow downarrow"
                ],
                leftright: [
                    0,
                    !0,
                    !1,
                    "horizontalstrike leftarrow rightarrow"
                ]
            }, e1.diagonalArrowDef = {
                updiagonal: [
                    -1,
                    0,
                    !1,
                    "updiagonalstrike northeastarrow"
                ],
                northeast: [
                    -1,
                    0,
                    !1,
                    "updiagonalstrike updiagonalarrow"
                ],
                southeast: [
                    1,
                    0,
                    !1,
                    "downdiagonalstrike"
                ],
                northwest: [
                    1,
                    Math.PI,
                    !1,
                    "downdiagonalstrike"
                ],
                southwest: [
                    -1,
                    Math.PI,
                    !1,
                    "updiagonalstrike"
                ],
                northeastsouthwest: [
                    -1,
                    0,
                    !0,
                    "updiagonalstrike northeastarrow updiagonalarrow southwestarrow"
                ],
                northwestsoutheast: [
                    1,
                    0,
                    !0,
                    "downdiagonalstrike northwestarrow southeastarrow"
                ]
            }, e1.arrowBBox = {
                up: function(t1) {
                    return (0, e1.arrowBBoxW)(t1, [
                        (0, e1.arrowHead)(t1),
                        0,
                        t1.padding,
                        0
                    ]);
                },
                down: function(t1) {
                    return (0, e1.arrowBBoxW)(t1, [
                        t1.padding,
                        0,
                        (0, e1.arrowHead)(t1),
                        0
                    ]);
                },
                right: function(t1) {
                    return (0, e1.arrowBBoxHD)(t1, [
                        0,
                        (0, e1.arrowHead)(t1),
                        0,
                        t1.padding
                    ]);
                },
                left: function(t1) {
                    return (0, e1.arrowBBoxHD)(t1, [
                        0,
                        t1.padding,
                        0,
                        (0, e1.arrowHead)(t1)
                    ]);
                },
                updown: function(t1) {
                    return (0, e1.arrowBBoxW)(t1, [
                        (0, e1.arrowHead)(t1),
                        0,
                        (0, e1.arrowHead)(t1),
                        0
                    ]);
                },
                leftright: function(t1) {
                    return (0, e1.arrowBBoxHD)(t1, [
                        0,
                        (0, e1.arrowHead)(t1),
                        0,
                        (0, e1.arrowHead)(t1)
                    ]);
                }
            };
            e1.CommonBorder = function(t1) {
                return function(r1) {
                    var n1 = e1.sideIndex[r1];
                    return [
                        r1,
                        {
                            renderer: t1,
                            bbox: function(t1) {
                                var e1 = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return e1[n1] = t1.thickness + t1.padding, e1;
                            },
                            border: function(t1) {
                                var e1 = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return e1[n1] = t1.thickness, e1;
                            }
                        }
                    ];
                };
            };
            e1.CommonBorder2 = function(t1) {
                return function(r1, n1, o1) {
                    var i1 = e1.sideIndex[n1], s1 = e1.sideIndex[o1];
                    return [
                        r1,
                        {
                            renderer: t1,
                            bbox: function(t1) {
                                var e1 = t1.thickness + t1.padding, r1 = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return r1[i1] = r1[s1] = e1, r1;
                            },
                            border: function(t1) {
                                var e1 = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return e1[i1] = e1[s1] = t1.thickness, e1;
                            },
                            remove: n1 + " " + o1
                        }
                    ];
                };
            };
            e1.CommonDiagonalStrike = function(t1) {
                return function(r1) {
                    var n1 = "mjx-" + r1.charAt(0) + "strike";
                    return [
                        r1 + "diagonalstrike",
                        {
                            renderer: t1(n1),
                            bbox: e1.fullBBox
                        }
                    ];
                };
            };
            e1.CommonDiagonalArrow = function(t1) {
                return function(n1) {
                    var o1 = r1(e1.diagonalArrowDef[n1], 4), i1 = o1[0], s1 = o1[1], a1 = o1[2];
                    return [
                        n1 + "arrow",
                        {
                            renderer: function(e1, n1) {
                                var o1 = r1(e1.arrowAW(), 2), l1 = o1[0], c1 = o1[1], u1 = e1.arrow(c1, i1 * (l1 - s1), a1);
                                t1(e1, u1);
                            },
                            bbox: function(t1) {
                                var e1 = t1.arrowData(), n1 = e1.a, o1 = e1.x, i1 = e1.y, s1 = r1([
                                    t1.arrowhead.x,
                                    t1.arrowhead.y,
                                    t1.arrowhead.dx
                                ], 3), a1 = s1[0], l1 = s1[1], c1 = s1[2], u1 = r1(t1.getArgMod(a1 + c1, l1), 2), p1 = u1[0], h1 = u1[1], f1 = i1 + (p1 > n1 ? t1.thickness * h1 * Math.sin(p1 - n1) : 0), d1 = o1 + (p1 > Math.PI / 2 - n1 ? t1.thickness * h1 * Math.sin(p1 + n1 - Math.PI / 2) : 0);
                                return [
                                    f1,
                                    d1,
                                    f1,
                                    d1
                                ];
                            },
                            remove: o1[3]
                        }
                    ];
                };
            };
            e1.CommonArrow = function(t1) {
                return function(n1) {
                    var o1 = r1(e1.arrowDef[n1], 4), i1 = o1[0], s1 = o1[1], a1 = o1[2], l1 = o1[3];
                    return [
                        n1 + "arrow",
                        {
                            renderer: function(e1, n1) {
                                var o1 = e1.getBBox(), l1 = o1.w, c1 = o1.h, u1 = o1.d, p1 = r1(a1 ? [
                                    c1 + u1,
                                    "X"
                                ] : [
                                    l1,
                                    "Y"
                                ], 2), h1 = p1[0], f1 = p1[1], d1 = e1.getOffset(f1), m1 = e1.arrow(h1, i1, s1, f1, d1);
                                t1(e1, m1);
                            },
                            bbox: e1.arrowBBox[n1],
                            remove: l1
                        }
                    ];
                };
            };
        },
        3055: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonOutputJax = void 0;
            var l1 = r1(2975), c1 = r1(4474), u1 = r1(7233), p1 = r1(6010), h1 = r1(8054), f1 = r1(4139), d1 = function(t1) {
                function e1(e1, r1, n1) {
                    void 0 === e1 && (e1 = null), void 0 === r1 && (r1 = null), void 0 === n1 && (n1 = null);
                    var o1 = this, i1 = s1((0, u1.separateOptions)(e1, n1.OPTIONS), 2), a1 = i1[0], l1 = i1[1];
                    return (o1 = t1.call(this, a1) || this).factory = o1.options.wrapperFactory || new r1, o1.factory.jax = o1, o1.cssStyles = o1.options.cssStyles || new f1.CssStyles, o1.font = o1.options.font || new n1(l1), o1.unknownCache = new Map, o1;
                }
                return o1(e1, t1), e1.prototype.typeset = function(t1, e1) {
                    this.setDocument(e1);
                    var r1 = this.createNode();
                    return this.toDOM(t1, r1, e1), r1;
                }, e1.prototype.createNode = function() {
                    var t1 = this.constructor.NAME;
                    return this.html("mjx-container", {
                        class: "MathJax",
                        jax: t1
                    });
                }, e1.prototype.setScale = function(t1) {
                    var e1 = this.math.metrics.scale * this.options.scale;
                    1 !== e1 && this.adaptor.setStyle(t1, "fontSize", (0, p1.percent)(e1));
                }, e1.prototype.toDOM = function(t1, e1, r1) {
                    void 0 === r1 && (r1 = null), this.setDocument(r1), this.math = t1, this.pxPerEm = t1.metrics.ex / this.font.params.x_height, t1.root.setTeXclass(null), this.setScale(e1), this.nodeMap = new Map, this.container = e1, this.processMath(t1.root, e1), this.nodeMap = null, this.executeFilters(this.postFilters, t1, r1, e1);
                }, e1.prototype.getBBox = function(t1, e1) {
                    this.setDocument(e1), this.math = t1, t1.root.setTeXclass(null), this.nodeMap = new Map;
                    var r1 = this.factory.wrap(t1.root).getOuterBBox();
                    return this.nodeMap = null, r1;
                }, e1.prototype.getMetrics = function(t1) {
                    var e1, r1;
                    this.setDocument(t1);
                    var n1 = this.adaptor, o1 = this.getMetricMaps(t1);
                    try {
                        for(var i1 = a1(t1.math), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var l1 = s1.value, u1 = n1.parent(l1.start.node);
                            if (l1.state() < c1.STATE.METRICS && u1) {
                                var p1 = o1[l1.display ? 1 : 0].get(u1), h1 = p1.em, f1 = p1.ex, d1 = p1.containerWidth, m1 = p1.lineWidth, y1 = p1.scale, g1 = p1.family;
                                l1.setMetrics(h1, f1, d1, m1, y1), this.options.mtextInheritFont && (l1.outputData.mtextFamily = g1), this.options.merrorInheritFont && (l1.outputData.merrorFamily = g1), l1.state(c1.STATE.METRICS);
                            }
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, e1.prototype.getMetricsFor = function(t1, e1) {
                    var r1 = this.options.mtextInheritFont || this.options.merrorInheritFont, n1 = this.getTestElement(t1, e1), o1 = this.measureMetrics(n1, r1);
                    return this.adaptor.remove(n1), o1;
                }, e1.prototype.getMetricMaps = function(t1) {
                    var e1, r1, n1, o1, i1, s1, l1, u1, p1, h1, f1 = this.adaptor, d1 = [
                        new Map,
                        new Map
                    ];
                    try {
                        for(var m1 = a1(t1.math), y1 = m1.next(); !y1.done; y1 = m1.next()){
                            var g1 = y1.value;
                            if ((A1 = f1.parent(g1.start.node)) && g1.state() < c1.STATE.METRICS) {
                                var b1 = d1[g1.display ? 1 : 0];
                                b1.has(A1) || b1.set(A1, this.getTestElement(A1, g1.display));
                            }
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            y1 && !y1.done && (r1 = m1.return) && r1.call(m1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    var v1 = this.options.mtextInheritFont || this.options.merrorInheritFont, _1 = [
                        new Map,
                        new Map
                    ];
                    try {
                        for(var S1 = a1(_1.keys()), O1 = S1.next(); !O1.done; O1 = S1.next()){
                            var M1 = O1.value;
                            try {
                                for(var x1 = (i1 = void 0, a1(d1[M1].keys())), E1 = x1.next(); !E1.done; E1 = x1.next()){
                                    var A1 = E1.value;
                                    _1[M1].set(A1, this.measureMetrics(d1[M1].get(A1), v1));
                                }
                            } catch (t1) {
                                i1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    E1 && !E1.done && (s1 = x1.return) && s1.call(x1);
                                } finally{
                                    if (i1) throw i1.error;
                                }
                            }
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            O1 && !O1.done && (o1 = S1.return) && o1.call(S1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                    try {
                        for(var C1 = a1(_1.keys()), T1 = C1.next(); !T1.done; T1 = C1.next()){
                            M1 = T1.value;
                            try {
                                for(var N1 = (p1 = void 0, a1(d1[M1].values())), w1 = N1.next(); !w1.done; w1 = N1.next()){
                                    A1 = w1.value;
                                    f1.remove(A1);
                                }
                            } catch (t1) {
                                p1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    w1 && !w1.done && (h1 = N1.return) && h1.call(N1);
                                } finally{
                                    if (p1) throw p1.error;
                                }
                            }
                        }
                    } catch (t1) {
                        l1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            T1 && !T1.done && (u1 = C1.return) && u1.call(C1);
                        } finally{
                            if (l1) throw l1.error;
                        }
                    }
                    return _1;
                }, e1.prototype.getTestElement = function(t1, e1) {
                    var r1 = this.adaptor;
                    if (!this.testInline) {
                        this.testInline = this.html("mjx-test", {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                "font-style": "normal",
                                "font-weight": "normal",
                                "font-size": "100%",
                                "font-size-adjust": "none",
                                "text-indent": 0,
                                "text-transform": "none",
                                "letter-spacing": "normal",
                                "word-spacing": "normal",
                                overflow: "hidden",
                                height: "1px",
                                "margin-right": "-1px"
                            }
                        }, [
                            this.html("mjx-left-box", {
                                style: {
                                    display: "inline-block",
                                    width: 0,
                                    float: "left"
                                }
                            }),
                            this.html("mjx-ex-box", {
                                style: {
                                    position: "absolute",
                                    overflow: "hidden",
                                    width: "1px",
                                    height: "60ex"
                                }
                            }),
                            this.html("mjx-right-box", {
                                style: {
                                    display: "inline-block",
                                    width: 0,
                                    float: "right"
                                }
                            })
                        ]), this.testDisplay = r1.clone(this.testInline), r1.setStyle(this.testDisplay, "display", "table"), r1.setStyle(this.testDisplay, "margin-right", ""), r1.setStyle(r1.firstChild(this.testDisplay), "display", "none");
                        var n1 = r1.lastChild(this.testDisplay);
                        r1.setStyle(n1, "display", "table-cell"), r1.setStyle(n1, "width", "10000em"), r1.setStyle(n1, "float", "");
                    }
                    return r1.append(t1, r1.clone(e1 ? this.testDisplay : this.testInline));
                }, e1.prototype.measureMetrics = function(t1, e1) {
                    var r1 = this.adaptor, n1 = e1 ? r1.fontFamily(t1) : "", o1 = r1.fontSize(t1), i1 = s1(r1.nodeSize(r1.childNode(t1, 1)), 2), a1 = i1[0], l1 = i1[1], c1 = a1 ? l1 / 60 : o1 * this.options.exFactor;
                    return {
                        em: o1,
                        ex: c1,
                        containerWidth: a1 ? "table" === r1.getStyle(t1, "display") ? r1.nodeSize(r1.lastChild(t1))[0] - 1 : r1.nodeBBox(r1.lastChild(t1)).left - r1.nodeBBox(r1.firstChild(t1)).left - 2 : 1e6,
                        lineWidth: 1e6,
                        scale: Math.max(this.options.minScale, this.options.matchFontHeight ? c1 / this.font.params.x_height / o1 : 1),
                        family: n1
                    };
                }, e1.prototype.styleSheet = function(t1) {
                    var e1, r1;
                    if (this.setDocument(t1), this.cssStyles.clear(), this.cssStyles.addStyles(this.constructor.commonStyles), "getStyles" in t1) try {
                        for(var n1 = a1(t1.getStyles()), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value;
                            this.cssStyles.addStyles(i1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return this.addWrapperStyles(this.cssStyles), this.addFontStyles(this.cssStyles), this.html("style", {
                        id: "MJX-styles"
                    }, [
                        this.text("\n" + this.cssStyles.cssText + "\n")
                    ]);
                }, e1.prototype.addFontStyles = function(t1) {
                    t1.addStyles(this.font.styles);
                }, e1.prototype.addWrapperStyles = function(t1) {
                    var e1, r1;
                    try {
                        for(var n1 = a1(this.factory.getKinds()), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value;
                            this.addClassStyles(this.factory.getNodeClass(i1), t1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, e1.prototype.addClassStyles = function(t1, e1) {
                    e1.addStyles(t1.styles);
                }, e1.prototype.setDocument = function(t1) {
                    t1 && (this.document = t1, this.adaptor.document = t1.document);
                }, e1.prototype.html = function(t1, e1, r1, n1) {
                    return void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = []), this.adaptor.node(t1, e1, r1, n1);
                }, e1.prototype.text = function(t1) {
                    return this.adaptor.text(t1);
                }, e1.prototype.fixed = function(t1, e1) {
                    return void 0 === e1 && (e1 = 3), Math.abs(t1) < 6e-4 ? "0" : t1.toFixed(e1).replace(/\.?0+$/, "");
                }, e1.prototype.measureText = function(t1, e1, r1) {
                    void 0 === r1 && (r1 = [
                        "",
                        !1,
                        !1
                    ]);
                    var n1 = this.unknownText(t1, e1);
                    if ("-explicitFont" === e1) {
                        var o1 = this.cssFontStyles(r1);
                        this.adaptor.setAttributes(n1, {
                            style: o1
                        });
                    }
                    return this.measureTextNodeWithCache(n1, t1, e1, r1);
                }, e1.prototype.measureTextNodeWithCache = function(t1, e1, r1, n1) {
                    void 0 === n1 && (n1 = [
                        "",
                        !1,
                        !1
                    ]), "-explicitFont" === r1 && (r1 = [
                        n1[0],
                        n1[1] ? "T" : "F",
                        n1[2] ? "T" : "F",
                        ""
                    ].join("-")), this.unknownCache.has(r1) || this.unknownCache.set(r1, new Map);
                    var o1 = this.unknownCache.get(r1), i1 = o1.get(e1);
                    if (i1) return i1;
                    var s1 = this.measureTextNode(t1);
                    return o1.set(e1, s1), s1;
                }, e1.prototype.measureXMLnode = function(t1) {
                    var e1 = this.adaptor, r1 = this.html("mjx-xml-block", {
                        style: {
                            display: "inline-block"
                        }
                    }, [
                        e1.clone(t1)
                    ]), n1 = this.html("mjx-baseline", {
                        style: {
                            display: "inline-block",
                            width: 0,
                            height: 0
                        }
                    }), o1 = this.html("mjx-measure-xml", {
                        style: {
                            position: "absolute",
                            display: "inline-block",
                            "font-family": "initial",
                            "line-height": "normal"
                        }
                    }, [
                        n1,
                        r1
                    ]);
                    e1.append(e1.parent(this.math.start.node), this.container), e1.append(this.container, o1);
                    var i1 = this.math.metrics.em * this.math.metrics.scale, s1 = e1.nodeBBox(r1), a1 = s1.left, l1 = s1.right, c1 = s1.bottom, u1 = s1.top, p1 = (l1 - a1) / i1, h1 = (e1.nodeBBox(n1).top - u1) / i1, f1 = (c1 - u1) / i1 - h1;
                    return e1.remove(this.container), e1.remove(o1), {
                        w: p1,
                        h: h1,
                        d: f1
                    };
                }, e1.prototype.cssFontStyles = function(t1, e1) {
                    void 0 === e1 && (e1 = {});
                    var r1 = s1(t1, 3), n1 = r1[0], o1 = r1[1], i1 = r1[2];
                    return e1["font-family"] = this.font.getFamily(n1), o1 && (e1["font-style"] = "italic"), i1 && (e1["font-weight"] = "bold"), e1;
                }, e1.prototype.getFontData = function(t1) {
                    return t1 || (t1 = new h1.Styles), [
                        this.font.getFamily(t1.get("font-family")),
                        "italic" === t1.get("font-style"),
                        "bold" === t1.get("font-weight")
                    ];
                }, e1.NAME = "Common", e1.OPTIONS = i1(i1({}, l1.AbstractOutputJax.OPTIONS), {
                    scale: 1,
                    minScale: .5,
                    mtextInheritFont: !1,
                    merrorInheritFont: !1,
                    mtextFont: "",
                    merrorFont: "serif",
                    mathmlSpacing: !1,
                    skipAttributes: {},
                    exFactor: .5,
                    displayAlign: "center",
                    displayIndent: "0",
                    wrapperFactory: null,
                    font: null,
                    cssStyles: null
                }), e1.commonStyles = {}, e1;
            }(l1.AbstractOutputJax);
            e1.CommonOutputJax = d1;
        },
        7519: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), s1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), a1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && i1(e1, t1, r1);
                return s1(e1, t1), e1;
            }, l1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, c1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, u1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonWrapper = void 0;
            var p1 = r1(8912), h1 = r1(9007), f1 = r1(505), d1 = a1(r1(6010)), m1 = r1(8054), y1 = r1(6469), g1 = r1(5884), b1 = 2 / 18;
            function v1(t1, e1) {
                return t1 ? e1 < b1 ? 0 : b1 : e1;
            }
            var _1 = function(t1) {
                function e1(e1, r1, n1) {
                    void 0 === n1 && (n1 = null);
                    var o1 = t1.call(this, e1, r1) || this;
                    return o1.parent = null, o1.removedStyles = null, o1.styles = null, o1.variant = "", o1.bboxComputed = !1, o1.stretch = g1.NOSTRETCH, o1.font = null, o1.parent = n1, o1.font = e1.jax.font, o1.bbox = y1.BBox.zero(), o1.getStyles(), o1.getVariant(), o1.getScale(), o1.getSpace(), o1.childNodes = r1.childNodes.map(function(t1) {
                        var e1 = o1.wrap(t1);
                        return e1.bbox.pwidth && (r1.notParent || r1.isKind("math")) && (o1.bbox.pwidth = y1.BBox.fullWidth), e1;
                    }), o1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "jax", {
                    get: function() {
                        return this.factory.jax;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "adaptor", {
                    get: function() {
                        return this.factory.jax.adaptor;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "metrics", {
                    get: function() {
                        return this.factory.jax.math.metrics;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "fixesPWidth", {
                    get: function() {
                        return !this.node.notParent && !this.node.isToken;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.wrap = function(t1, e1) {
                    void 0 === e1 && (e1 = null);
                    var r1 = this.factory.wrap(t1, e1 || this);
                    return e1 && e1.childNodes.push(r1), this.jax.nodeMap.set(t1, r1), r1;
                }, e1.prototype.getBBox = function(t1) {
                    if (void 0 === t1 && (t1 = !0), this.bboxComputed) return this.bbox;
                    var e1 = t1 ? this.bbox : y1.BBox.zero();
                    return this.computeBBox(e1), this.bboxComputed = t1, e1;
                }, e1.prototype.getOuterBBox = function(t1) {
                    var e1, r1;
                    void 0 === t1 && (t1 = !0);
                    var n1 = this.getBBox(t1);
                    if (!this.styles) return n1;
                    var o1 = new y1.BBox;
                    Object.assign(o1, n1);
                    try {
                        for(var i1 = l1(y1.BBox.StyleAdjust), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = c1(s1.value, 2), u1 = a1[0], p1 = a1[1], h1 = this.styles.get(u1);
                            h1 && (o1[p1] += this.length2em(h1, 1, o1.rscale));
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return o1;
                }, e1.prototype.computeBBox = function(t1, e1) {
                    var r1, n1;
                    void 0 === e1 && (e1 = !1), t1.empty();
                    try {
                        for(var o1 = l1(this.childNodes), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value;
                            t1.append(s1.getOuterBBox());
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    t1.clean(), this.fixesPWidth && this.setChildPWidths(e1) && this.computeBBox(t1, !0);
                }, e1.prototype.setChildPWidths = function(t1, e1, r1) {
                    var n1, o1;
                    if (void 0 === e1 && (e1 = null), void 0 === r1 && (r1 = !0), t1) return !1;
                    r1 && (this.bbox.pwidth = "");
                    var i1 = !1;
                    try {
                        for(var s1 = l1(this.childNodes), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var c1 = a1.value, u1 = c1.getOuterBBox();
                            u1.pwidth && c1.setChildPWidths(t1, null === e1 ? u1.w : e1, r1) && (i1 = !0);
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                    return i1;
                }, e1.prototype.invalidateBBox = function() {
                    this.bboxComputed && (this.bboxComputed = !1, this.parent && this.parent.invalidateBBox());
                }, e1.prototype.copySkewIC = function(t1) {
                    var e1 = this.childNodes[0];
                    (null == e1 ? void 0 : e1.bbox.sk) && (t1.sk = e1.bbox.sk), (null == e1 ? void 0 : e1.bbox.dx) && (t1.dx = e1.bbox.dx);
                    var r1 = this.childNodes[this.childNodes.length - 1];
                    (null == r1 ? void 0 : r1.bbox.ic) && (t1.ic = r1.bbox.ic, t1.w += t1.ic);
                }, e1.prototype.getStyles = function() {
                    var t1 = this.node.attributes.getExplicit("style");
                    if (t1) for(var r1 = this.styles = new m1.Styles(t1), n1 = 0, o1 = e1.removeStyles.length; n1 < o1; n1++){
                        var i1 = e1.removeStyles[n1];
                        r1.get(i1) && (this.removedStyles || (this.removedStyles = {}), this.removedStyles[i1] = r1.get(i1), r1.set(i1, ""));
                    }
                }, e1.prototype.getVariant = function() {
                    if (this.node.isToken) {
                        var t1 = this.node.attributes, r1 = t1.get("mathvariant");
                        if (!t1.getExplicit("mathvariant")) {
                            var n1 = t1.getList("fontfamily", "fontweight", "fontstyle");
                            if (this.removedStyles) {
                                var o1 = this.removedStyles;
                                o1.fontFamily && (n1.family = o1.fontFamily), o1.fontWeight && (n1.weight = o1.fontWeight), o1.fontStyle && (n1.style = o1.fontStyle);
                            }
                            n1.fontfamily && (n1.family = n1.fontfamily), n1.fontweight && (n1.weight = n1.fontweight), n1.fontstyle && (n1.style = n1.fontstyle), n1.weight && n1.weight.match(/^\d+$/) && (n1.weight = parseInt(n1.weight) > 600 ? "bold" : "normal"), n1.family ? r1 = this.explicitVariant(n1.family, n1.weight, n1.style) : (this.node.getProperty("variantForm") && (r1 = "-tex-variant"), r1 = (e1.BOLDVARIANTS[n1.weight] || {})[r1] || r1, r1 = (e1.ITALICVARIANTS[n1.style] || {})[r1] || r1);
                        }
                        this.variant = r1;
                    }
                }, e1.prototype.explicitVariant = function(t1, e1, r1) {
                    var n1 = this.styles;
                    return n1 || (n1 = this.styles = new m1.Styles), n1.set("fontFamily", t1), e1 && n1.set("fontWeight", e1), r1 && n1.set("fontStyle", r1), "-explicitFont";
                }, e1.prototype.getScale = function() {
                    var t1 = 1, e1 = this.parent, r1 = e1 ? e1.bbox.scale : 1, n1 = this.node.attributes, o1 = Math.min(n1.get("scriptlevel"), 2), i1 = n1.get("fontsize"), s1 = this.node.isToken || this.node.isKind("mstyle") ? n1.get("mathsize") : n1.getInherited("mathsize");
                    if (0 !== o1) {
                        t1 = Math.pow(n1.get("scriptsizemultiplier"), o1);
                        var a1 = this.length2em(n1.get("scriptminsize"), .8, 1);
                        t1 < a1 && (t1 = a1);
                    }
                    this.removedStyles && this.removedStyles.fontSize && !i1 && (i1 = this.removedStyles.fontSize), i1 && !n1.getExplicit("mathsize") && (s1 = i1), "1" !== s1 && (t1 *= this.length2em(s1, 1, 1)), this.bbox.scale = t1, this.bbox.rscale = t1 / r1;
                }, e1.prototype.getSpace = function() {
                    var t1 = this.isTopEmbellished(), e1 = this.node.hasSpacingAttributes();
                    this.jax.options.mathmlSpacing || e1 ? t1 && this.getMathMLSpacing() : this.getTeXSpacing(t1, e1);
                }, e1.prototype.getMathMLSpacing = function() {
                    var t1 = this.node.coreMO(), e1 = t1.coreParent(), r1 = e1.parent;
                    if (r1 && r1.isKind("mrow") && 1 !== r1.childNodes.length) {
                        var n1 = t1.attributes, o1 = n1.get("scriptlevel") > 0;
                        this.bbox.L = n1.isSet("lspace") ? Math.max(0, this.length2em(n1.get("lspace"))) : v1(o1, t1.lspace), this.bbox.R = n1.isSet("rspace") ? Math.max(0, this.length2em(n1.get("rspace"))) : v1(o1, t1.rspace);
                        var i1 = r1.childIndex(e1);
                        if (0 !== i1) {
                            var s1 = r1.childNodes[i1 - 1];
                            if (s1.isEmbellished) {
                                var a1 = this.jax.nodeMap.get(s1).getBBox();
                                a1.R && (this.bbox.L = Math.max(0, this.bbox.L - a1.R));
                            }
                        }
                    }
                }, e1.prototype.getTeXSpacing = function(t1, e1) {
                    if (!e1) {
                        var r1 = this.node.texSpacing();
                        r1 && (this.bbox.L = this.length2em(r1));
                    }
                    if (t1 || e1) {
                        var n1 = this.node.coreMO().attributes;
                        n1.isSet("lspace") && (this.bbox.L = Math.max(0, this.length2em(n1.get("lspace")))), n1.isSet("rspace") && (this.bbox.R = Math.max(0, this.length2em(n1.get("rspace"))));
                    }
                }, e1.prototype.isTopEmbellished = function() {
                    return this.node.isEmbellished && !(this.node.parent && this.node.parent.isEmbellished);
                }, e1.prototype.core = function() {
                    return this.jax.nodeMap.get(this.node.core());
                }, e1.prototype.coreMO = function() {
                    return this.jax.nodeMap.get(this.node.coreMO());
                }, e1.prototype.getText = function() {
                    var t1, e1, r1 = "";
                    if (this.node.isToken) try {
                        for(var n1 = l1(this.node.childNodes), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var i1 = o1.value;
                            i1 instanceof h1.TextNode && (r1 += i1.getText());
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return r1;
                }, e1.prototype.canStretch = function(t1) {
                    if (this.stretch = g1.NOSTRETCH, this.node.isEmbellished) {
                        var e1 = this.core();
                        e1 && e1.node !== this.node && e1.canStretch(t1) && (this.stretch = e1.stretch);
                    }
                    return 0 !== this.stretch.dir;
                }, e1.prototype.getAlignShift = function() {
                    var t1, e1 = (t1 = this.node.attributes).getList.apply(t1, u1([], c1(h1.indentAttributes), !1)), r1 = e1.indentalign, n1 = e1.indentshift, o1 = e1.indentalignfirst, i1 = e1.indentshiftfirst;
                    return "indentalign" !== o1 && (r1 = o1), "auto" === r1 && (r1 = this.jax.options.displayAlign), "indentshift" !== i1 && (n1 = i1), "auto" === n1 && (n1 = this.jax.options.displayIndent, "right" !== r1 || n1.match(/^\s*0[a-z]*\s*$/) || (n1 = ("-" + n1.trim()).replace(/^--/, ""))), [
                        r1,
                        this.length2em(n1, this.metrics.containerWidth)
                    ];
                }, e1.prototype.getAlignX = function(t1, e1, r1) {
                    return "right" === r1 ? t1 - (e1.w + e1.R) * e1.rscale : "left" === r1 ? e1.L * e1.rscale : (t1 - e1.w * e1.rscale) / 2;
                }, e1.prototype.getAlignY = function(t1, e1, r1, n1, o1) {
                    return "top" === o1 ? t1 - r1 : "bottom" === o1 ? n1 - e1 : "center" === o1 ? (t1 - r1 - (e1 - n1)) / 2 : 0;
                }, e1.prototype.getWrapWidth = function(t1) {
                    return this.childNodes[t1].getBBox().w;
                }, e1.prototype.getChildAlign = function(t1) {
                    return "left";
                }, e1.prototype.percent = function(t1) {
                    return d1.percent(t1);
                }, e1.prototype.em = function(t1) {
                    return d1.em(t1);
                }, e1.prototype.px = function(t1, e1) {
                    return void 0 === e1 && (e1 = -d1.BIGDIMEN), d1.px(t1, e1, this.metrics.em);
                }, e1.prototype.length2em = function(t1, e1, r1) {
                    return void 0 === e1 && (e1 = 1), void 0 === r1 && (r1 = null), null === r1 && (r1 = this.bbox.scale), d1.length2em(t1, e1, r1, this.jax.pxPerEm);
                }, e1.prototype.unicodeChars = function(t1, e1) {
                    void 0 === e1 && (e1 = this.variant);
                    var r1 = (0, f1.unicodeChars)(t1), n1 = this.font.getVariant(e1);
                    if (n1 && n1.chars) {
                        var o1 = n1.chars;
                        r1 = r1.map(function(t1) {
                            return ((o1[t1] || [])[3] || {}).smp || t1;
                        });
                    }
                    return r1;
                }, e1.prototype.remapChars = function(t1) {
                    return t1;
                }, e1.prototype.mmlText = function(t1) {
                    return this.node.factory.create("text").setText(t1);
                }, e1.prototype.mmlNode = function(t1, e1, r1) {
                    return void 0 === e1 && (e1 = {}), void 0 === r1 && (r1 = []), this.node.factory.create(t1, e1, r1);
                }, e1.prototype.createMo = function(t1) {
                    var e1 = this.node.factory, r1 = e1.create("text").setText(t1), n1 = e1.create("mo", {
                        stretchy: !0
                    }, [
                        r1
                    ]);
                    n1.inheritAttributesFrom(this.node);
                    var o1 = this.wrap(n1);
                    return o1.parent = this, o1;
                }, e1.prototype.getVariantChar = function(t1, e1) {
                    var r1 = this.font.getChar(t1, e1) || [
                        0,
                        0,
                        0,
                        {
                            unknown: !0
                        }
                    ];
                    return 3 === r1.length && (r1[3] = {}), r1;
                }, e1.kind = "unknown", e1.styles = {}, e1.removeStyles = [
                    "fontSize",
                    "fontFamily",
                    "fontWeight",
                    "fontStyle",
                    "fontVariant",
                    "font"
                ], e1.skipAttributes = {
                    fontfamily: !0,
                    fontsize: !0,
                    fontweight: !0,
                    fontstyle: !0,
                    color: !0,
                    background: !0,
                    class: !0,
                    href: !0,
                    style: !0,
                    xmlns: !0
                }, e1.BOLDVARIANTS = {
                    bold: {
                        normal: "bold",
                        italic: "bold-italic",
                        fraktur: "bold-fraktur",
                        script: "bold-script",
                        "sans-serif": "bold-sans-serif",
                        "sans-serif-italic": "sans-serif-bold-italic"
                    },
                    normal: {
                        bold: "normal",
                        "bold-italic": "italic",
                        "bold-fraktur": "fraktur",
                        "bold-script": "script",
                        "bold-sans-serif": "sans-serif",
                        "sans-serif-bold-italic": "sans-serif-italic"
                    }
                }, e1.ITALICVARIANTS = {
                    italic: {
                        normal: "italic",
                        bold: "bold-italic",
                        "sans-serif": "sans-serif-italic",
                        "bold-sans-serif": "sans-serif-bold-italic"
                    },
                    normal: {
                        italic: "normal",
                        "bold-italic": "bold",
                        "sans-serif-italic": "sans-serif",
                        "sans-serif-bold-italic": "bold-sans-serif"
                    }
                }, e1;
            }(p1.AbstractWrapper);
            e1.CommonWrapper = _1;
        },
        4420: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonWrapperFactory = void 0;
            var i1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.jax = null, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "Wrappers", {
                    get: function() {
                        return this.node;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.defaultNodes = {}, e1;
            }(r1(3811).AbstractWrapperFactory);
            e1.CommonWrapperFactory = i1;
        },
        9800: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonTeXAtomMixin = void 0;
            var i1 = r1(9007);
            e1.CommonTeXAtomMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return o1(e1, t1), e1.prototype.computeBBox = function(e1, r1) {
                        if (void 0 === r1 && (r1 = !1), t1.prototype.computeBBox.call(this, e1, r1), this.childNodes[0] && this.childNodes[0].bbox.ic && (e1.ic = this.childNodes[0].bbox.ic), this.node.texClass === i1.TEXCLASS.VCENTER) {
                            var n1 = e1.h, o1 = (n1 + e1.d) / 2 + this.font.params.axis_height - n1;
                            e1.h += o1, e1.d -= o1;
                        }
                    }, e1;
                }(t1);
            };
        },
        1160: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonTextNodeMixin = void 0, e1.CommonTextNodeMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.computeBBox = function(t1, e1) {
                        var r1, n1;
                        void 0 === e1 && (e1 = !1);
                        var s1 = this.parent.variant, a1 = this.node.getText();
                        if ("-explicitFont" === s1) {
                            var l1 = this.jax.getFontData(this.parent.styles), c1 = this.jax.measureText(a1, s1, l1), u1 = c1.w, p1 = c1.h, h1 = c1.d;
                            t1.h = p1, t1.d = h1, t1.w = u1;
                        } else {
                            var f1 = this.remappedText(a1, s1);
                            t1.empty();
                            try {
                                for(var d1 = o1(f1), m1 = d1.next(); !m1.done; m1 = d1.next()){
                                    var y1 = m1.value, g1 = i1(this.getVariantChar(s1, y1), 4), b1 = (p1 = g1[0], h1 = g1[1], u1 = g1[2], g1[3]);
                                    if (b1.unknown) {
                                        var v1 = this.jax.measureText(String.fromCodePoint(y1), s1);
                                        u1 = v1.w, p1 = v1.h, h1 = v1.d;
                                    }
                                    t1.w += u1, p1 > t1.h && (t1.h = p1), h1 > t1.d && (t1.d = h1), t1.ic = b1.ic || 0, t1.sk = b1.sk || 0, t1.dx = b1.dx || 0;
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    m1 && !m1.done && (n1 = d1.return) && n1.call(d1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                            f1.length > 1 && (t1.sk = 0), t1.clean();
                        }
                    }, e1.prototype.remappedText = function(t1, e1) {
                        var r1 = this.parent.stretch.c;
                        return r1 ? [
                            r1
                        ] : this.parent.remapChars(this.unicodeChars(t1, e1));
                    }, e1.prototype.getStyles = function() {}, e1.prototype.getVariant = function() {}, e1.prototype.getScale = function() {}, e1.prototype.getSpace = function() {}, e1;
                }(t1);
            };
        },
        1956: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMactionMixin = e1.TooltipData = void 0;
            var a1 = r1(505);
            e1.TooltipData = {
                dx: ".2em",
                dy: ".1em",
                postDelay: 600,
                clearDelay: 100,
                hoverTimer: new Map,
                clearTimer: new Map,
                stopTimers: function(t1, e1) {
                    e1.clearTimer.has(t1) && (clearTimeout(e1.clearTimer.get(t1)), e1.clearTimer.delete(t1)), e1.hoverTimer.has(t1) && (clearTimeout(e1.hoverTimer.get(t1)), e1.hoverTimer.delete(t1));
                }
            }, e1.CommonMactionMixin = function(t1) {
                return function(t1) {
                    function r1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, s1([], i1(e1), !1)) || this, o1 = n1.constructor.actions, a1 = n1.node.attributes.get("actiontype"), l1 = i1(o1.get(a1) || [
                            function(t1, e1) {},
                            {}
                        ], 2), c1 = l1[0], u1 = l1[1];
                        return n1.action = c1, n1.data = u1, n1.getParameters(), n1;
                    }
                    return o1(r1, t1), Object.defineProperty(r1.prototype, "selected", {
                        get: function() {
                            var t1 = this.node.attributes.get("selection"), e1 = Math.max(1, Math.min(this.childNodes.length, t1)) - 1;
                            return this.childNodes[e1] || this.wrap(this.node.selected);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), r1.prototype.getParameters = function() {
                        var t1 = this.node.attributes.get("data-offsets"), r1 = i1((0, a1.split)(t1 || ""), 2), n1 = r1[0], o1 = r1[1];
                        this.dx = this.length2em(n1 || e1.TooltipData.dx), this.dy = this.length2em(o1 || e1.TooltipData.dy);
                    }, r1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1), t1.updateFrom(this.selected.getOuterBBox()), this.selected.setChildPWidths(e1);
                    }, r1;
                }(t1);
            };
        },
        7490: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMathMixin = void 0, e1.CommonMathMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.getWrapWidth = function(t1) {
                        return this.parent ? this.getBBox().w : this.metrics.containerWidth / this.jax.pxPerEm;
                    }, e1;
                }(t1);
            };
        },
        7313: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__createBinding || (Object.create ? function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1);
                var o1 = Object.getOwnPropertyDescriptor(e1, r1);
                o1 && !("get" in o1 ? !e1.__esModule : o1.writable || o1.configurable) || (o1 = {
                    enumerable: !0,
                    get: function() {
                        return e1[r1];
                    }
                }), Object.defineProperty(t1, n1, o1);
            } : function(t1, e1, r1, n1) {
                void 0 === n1 && (n1 = r1), t1[n1] = e1[r1];
            }), s1 = this && this.__setModuleDefault || (Object.create ? function(t1, e1) {
                Object.defineProperty(t1, "default", {
                    enumerable: !0,
                    value: e1
                });
            } : function(t1, e1) {
                t1.default = e1;
            }), a1 = this && this.__importStar || function(t1) {
                if (t1 && t1.__esModule) return t1;
                var e1 = {};
                if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && i1(e1, t1, r1);
                return s1(e1, t1), e1;
            }, l1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, c1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, u1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMencloseMixin = void 0;
            var p1 = a1(r1(5552)), h1 = r1(505);
            e1.CommonMencloseMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, c1([], l1(e1), !1)) || this;
                        return n1.notations = {}, n1.renderChild = null, n1.msqrt = null, n1.padding = p1.PADDING, n1.thickness = p1.THICKNESS, n1.arrowhead = {
                            x: p1.ARROWX,
                            y: p1.ARROWY,
                            dx: p1.ARROWDX
                        }, n1.TRBL = [
                            0,
                            0,
                            0,
                            0
                        ], n1.getParameters(), n1.getNotations(), n1.removeRedundantNotations(), n1.initializeNotations(), n1.TRBL = n1.getBBoxExtenders(), n1;
                    }
                    return o1(e1, t1), e1.prototype.getParameters = function() {
                        var t1 = this.node.attributes, e1 = t1.get("data-padding");
                        void 0 !== e1 && (this.padding = this.length2em(e1, p1.PADDING));
                        var r1 = t1.get("data-thickness");
                        void 0 !== r1 && (this.thickness = this.length2em(r1, p1.THICKNESS));
                        var n1 = t1.get("data-arrowhead");
                        if (void 0 !== n1) {
                            var o1 = l1((0, h1.split)(n1), 3), i1 = o1[0], s1 = o1[1], a1 = o1[2];
                            this.arrowhead = {
                                x: i1 ? parseFloat(i1) : p1.ARROWX,
                                y: s1 ? parseFloat(s1) : p1.ARROWY,
                                dx: a1 ? parseFloat(a1) : p1.ARROWDX
                            };
                        }
                    }, e1.prototype.getNotations = function() {
                        var t1, e1, r1 = this.constructor.notations;
                        try {
                            for(var n1 = u1((0, h1.split)(this.node.attributes.get("notation"))), o1 = n1.next(); !o1.done; o1 = n1.next()){
                                var i1 = o1.value, s1 = r1.get(i1);
                                s1 && (this.notations[i1] = s1, s1.renderChild && (this.renderChild = s1.renderer));
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }, e1.prototype.removeRedundantNotations = function() {
                        var t1, e1, r1, n1;
                        try {
                            for(var o1 = u1(Object.keys(this.notations)), i1 = o1.next(); !i1.done; i1 = o1.next()){
                                var s1 = i1.value;
                                if (this.notations[s1]) {
                                    var a1 = this.notations[s1].remove || "";
                                    try {
                                        for(var l1 = (r1 = void 0, u1(a1.split(/ /))), c1 = l1.next(); !c1.done; c1 = l1.next()){
                                            var p1 = c1.value;
                                            delete this.notations[p1];
                                        }
                                    } catch (t1) {
                                        r1 = {
                                            error: t1
                                        };
                                    } finally{
                                        try {
                                            c1 && !c1.done && (n1 = l1.return) && n1.call(l1);
                                        } finally{
                                            if (r1) throw r1.error;
                                        }
                                    }
                                }
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                i1 && !i1.done && (e1 = o1.return) && e1.call(o1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }, e1.prototype.initializeNotations = function() {
                        var t1, e1;
                        try {
                            for(var r1 = u1(Object.keys(this.notations)), n1 = r1.next(); !n1.done; n1 = r1.next()){
                                var o1 = n1.value, i1 = this.notations[o1].init;
                                i1 && i1(this);
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }, e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1 = l1(this.TRBL, 4), n1 = r1[0], o1 = r1[1], i1 = r1[2], s1 = r1[3], a1 = this.childNodes[0].getBBox();
                        t1.combine(a1, s1, 0), t1.h += n1, t1.d += i1, t1.w += o1, this.setChildPWidths(e1);
                    }, e1.prototype.getBBoxExtenders = function() {
                        var t1, e1, r1 = [
                            0,
                            0,
                            0,
                            0
                        ];
                        try {
                            for(var n1 = u1(Object.keys(this.notations)), o1 = n1.next(); !o1.done; o1 = n1.next()){
                                var i1 = o1.value;
                                this.maximizeEntries(r1, this.notations[i1].bbox(this));
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        return r1;
                    }, e1.prototype.getPadding = function() {
                        var t1, e1, r1 = this, n1 = [
                            0,
                            0,
                            0,
                            0
                        ];
                        try {
                            for(var o1 = u1(Object.keys(this.notations)), i1 = o1.next(); !i1.done; i1 = o1.next()){
                                var s1 = i1.value, a1 = this.notations[s1].border;
                                a1 && this.maximizeEntries(n1, a1(this));
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                i1 && !i1.done && (e1 = o1.return) && e1.call(o1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        return [
                            0,
                            1,
                            2,
                            3
                        ].map(function(t1) {
                            return r1.TRBL[t1] - n1[t1];
                        });
                    }, e1.prototype.maximizeEntries = function(t1, e1) {
                        for(var r1 = 0; r1 < t1.length; r1++)t1[r1] < e1[r1] && (t1[r1] = e1[r1]);
                    }, e1.prototype.getOffset = function(t1) {
                        var e1 = l1(this.TRBL, 4), r1 = e1[0], n1 = e1[1], o1 = e1[2], i1 = e1[3], s1 = ("X" === t1 ? n1 - i1 : o1 - r1) / 2;
                        return Math.abs(s1) > .001 ? s1 : 0;
                    }, e1.prototype.getArgMod = function(t1, e1) {
                        return [
                            Math.atan2(e1, t1),
                            Math.sqrt(t1 * t1 + e1 * e1)
                        ];
                    }, e1.prototype.arrow = function(t1, e1, r1, n1, o1) {
                        return void 0 === n1 && (n1 = ""), void 0 === o1 && (o1 = 0), null;
                    }, e1.prototype.arrowData = function() {
                        var t1 = l1([
                            this.padding,
                            this.thickness
                        ], 2), e1 = t1[0], r1 = t1[1] * (this.arrowhead.x + Math.max(1, this.arrowhead.dx)), n1 = this.childNodes[0].getBBox(), o1 = n1.h, i1 = n1.d, s1 = n1.w, a1 = o1 + i1, c1 = Math.sqrt(a1 * a1 + s1 * s1), u1 = Math.max(e1, r1 * s1 / c1), p1 = Math.max(e1, r1 * a1 / c1), h1 = l1(this.getArgMod(s1 + 2 * u1, a1 + 2 * p1), 2);
                        return {
                            a: h1[0],
                            W: h1[1],
                            x: u1,
                            y: p1
                        };
                    }, e1.prototype.arrowAW = function() {
                        var t1 = this.childNodes[0].getBBox(), e1 = t1.h, r1 = t1.d, n1 = t1.w, o1 = l1(this.TRBL, 4), i1 = o1[0], s1 = o1[1], a1 = o1[2], c1 = o1[3];
                        return this.getArgMod(c1 + n1 + s1, i1 + e1 + r1 + a1);
                    }, e1.prototype.createMsqrt = function(t1) {
                        var e1 = this.node.factory.create("msqrt");
                        e1.inheritAttributesFrom(this.node), e1.childNodes[0] = t1.node;
                        var r1 = this.wrap(e1);
                        return r1.parent = this, r1;
                    }, e1.prototype.sqrtTRBL = function() {
                        var t1 = this.msqrt.getBBox(), e1 = this.msqrt.childNodes[0].getBBox();
                        return [
                            t1.h - e1.h,
                            0,
                            t1.d - e1.d,
                            t1.w - e1.w
                        ];
                    }, e1;
                }(t1);
            };
        },
        7555: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, s1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMfencedMixin = void 0, e1.CommonMfencedMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, i1([], o1(e1), !1)) || this;
                        return n1.mrow = null, n1.createMrow(), n1.addMrowChildren(), n1;
                    }
                    return n1(e1, t1), e1.prototype.createMrow = function() {
                        var t1 = this.node.factory.create("inferredMrow");
                        t1.inheritAttributesFrom(this.node), this.mrow = this.wrap(t1), this.mrow.parent = this;
                    }, e1.prototype.addMrowChildren = function() {
                        var t1, e1, r1 = this.node, n1 = this.mrow;
                        this.addMo(r1.open), this.childNodes.length && n1.childNodes.push(this.childNodes[0]);
                        var o1 = 0;
                        try {
                            for(var i1 = s1(this.childNodes.slice(1)), a1 = i1.next(); !a1.done; a1 = i1.next()){
                                var l1 = a1.value;
                                this.addMo(r1.separators[o1++]), n1.childNodes.push(l1);
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                a1 && !a1.done && (e1 = i1.return) && e1.call(i1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        this.addMo(r1.close), n1.stretchChildren();
                    }, e1.prototype.addMo = function(t1) {
                        if (t1) {
                            var e1 = this.wrap(t1);
                            this.mrow.childNodes.push(e1), e1.parent = this.mrow;
                        }
                    }, e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1), t1.updateFrom(this.mrow.getOuterBBox()), this.setChildPWidths(e1);
                    }, e1;
                }(t1);
            };
        },
        2688: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMfracMixin = void 0, e1.CommonMfracMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, i1([], o1(e1), !1)) || this;
                        if (n1.bevel = null, n1.pad = n1.node.getProperty("withDelims") ? 0 : n1.font.params.nulldelimiterspace, n1.node.attributes.get("bevelled")) {
                            var s1 = n1.getBevelData(n1.isDisplay()).H, a1 = n1.bevel = n1.createMo("/");
                            a1.node.attributes.set("symmetric", !0), a1.canStretch(1), a1.getStretchedVariant([
                                s1
                            ], !0);
                        }
                        return n1;
                    }
                    return n1(e1, t1), e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1), t1.empty();
                        var r1 = this.node.attributes.getList("linethickness", "bevelled"), n1 = r1.linethickness, o1 = r1.bevelled, i1 = this.isDisplay(), s1 = null;
                        if (o1) this.getBevelledBBox(t1, i1);
                        else {
                            var a1 = this.length2em(String(n1), .06);
                            s1 = -2 * this.pad, 0 === a1 ? this.getAtopBBox(t1, i1) : (this.getFractionBBox(t1, i1, a1), s1 -= .2), s1 += t1.w;
                        }
                        t1.clean(), this.setChildPWidths(e1, s1);
                    }, e1.prototype.getFractionBBox = function(t1, e1, r1) {
                        var n1 = this.childNodes[0].getOuterBBox(), o1 = this.childNodes[1].getOuterBBox(), i1 = this.font.params.axis_height, s1 = this.getTUV(e1, r1), a1 = s1.T, l1 = s1.u, c1 = s1.v;
                        t1.combine(n1, 0, i1 + a1 + Math.max(n1.d * n1.rscale, l1)), t1.combine(o1, 0, i1 - a1 - Math.max(o1.h * o1.rscale, c1)), t1.w += 2 * this.pad + .2;
                    }, e1.prototype.getTUV = function(t1, e1) {
                        var r1 = this.font.params, n1 = r1.axis_height, o1 = (t1 ? 3.5 : 1.5) * e1;
                        return {
                            T: (t1 ? 3.5 : 1.5) * e1,
                            u: (t1 ? r1.num1 : r1.num2) - n1 - o1,
                            v: (t1 ? r1.denom1 : r1.denom2) + n1 - o1
                        };
                    }, e1.prototype.getAtopBBox = function(t1, e1) {
                        var r1 = this.getUVQ(e1), n1 = r1.u, o1 = r1.v, i1 = r1.nbox, s1 = r1.dbox;
                        t1.combine(i1, 0, n1), t1.combine(s1, 0, -o1), t1.w += 2 * this.pad;
                    }, e1.prototype.getUVQ = function(t1) {
                        var e1 = this.childNodes[0].getOuterBBox(), r1 = this.childNodes[1].getOuterBBox(), n1 = this.font.params, i1 = o1(t1 ? [
                            n1.num1,
                            n1.denom1
                        ] : [
                            n1.num3,
                            n1.denom2
                        ], 2), s1 = i1[0], a1 = i1[1], l1 = (t1 ? 7 : 3) * n1.rule_thickness, c1 = s1 - e1.d * e1.scale - (r1.h * r1.scale - a1);
                        return c1 < l1 && (s1 += (l1 - c1) / 2, a1 += (l1 - c1) / 2, c1 = l1), {
                            u: s1,
                            v: a1,
                            q: c1,
                            nbox: e1,
                            dbox: r1
                        };
                    }, e1.prototype.getBevelledBBox = function(t1, e1) {
                        var r1 = this.getBevelData(e1), n1 = r1.u, o1 = r1.v, i1 = r1.delta, s1 = r1.nbox, a1 = r1.dbox, l1 = this.bevel.getOuterBBox();
                        t1.combine(s1, 0, n1), t1.combine(l1, t1.w - i1 / 2, 0), t1.combine(a1, t1.w - i1 / 2, o1);
                    }, e1.prototype.getBevelData = function(t1) {
                        var e1 = this.childNodes[0].getOuterBBox(), r1 = this.childNodes[1].getOuterBBox(), n1 = t1 ? .4 : .15, o1 = Math.max(e1.scale * (e1.h + e1.d), r1.scale * (r1.h + r1.d)) + 2 * n1, i1 = this.font.params.axis_height;
                        return {
                            H: o1,
                            delta: n1,
                            u: e1.scale * (e1.d - e1.h) / 2 + i1 + n1,
                            v: r1.scale * (r1.d - r1.h) / 2 + i1 - n1,
                            nbox: e1,
                            dbox: r1
                        };
                    }, e1.prototype.canStretch = function(t1) {
                        return !1;
                    }, e1.prototype.isDisplay = function() {
                        var t1 = this.node.attributes.getList("displaystyle", "scriptlevel"), e1 = t1.displaystyle, r1 = t1.scriptlevel;
                        return e1 && 0 === r1;
                    }, e1.prototype.getWrapWidth = function(t1) {
                        var e1 = this.node.attributes;
                        return e1.get("bevelled") ? this.childNodes[t1].getOuterBBox().w : this.getBBox().w - (this.length2em(e1.get("linethickness")) ? .2 : 0) - 2 * this.pad;
                    }, e1.prototype.getChildAlign = function(t1) {
                        var e1 = this.node.attributes;
                        return e1.get("bevelled") ? "left" : e1.get([
                            "numalign",
                            "denomalign"
                        ][t1]);
                    }, e1;
                }(t1);
            };
        },
        5636: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMglyphMixin = void 0, e1.CommonMglyphMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, i1([], o1(e1), !1)) || this;
                        return n1.getParameters(), n1;
                    }
                    return n1(e1, t1), e1.prototype.getParameters = function() {
                        var t1 = this.node.attributes.getList("width", "height", "valign", "src", "index"), e1 = t1.width, r1 = t1.height, n1 = t1.valign, o1 = t1.src, i1 = t1.index;
                        if (o1) this.width = "auto" === e1 ? 1 : this.length2em(e1), this.height = "auto" === r1 ? 1 : this.length2em(r1), this.valign = this.length2em(n1 || "0");
                        else {
                            var s1 = String.fromCodePoint(parseInt(i1)), a1 = this.node.factory;
                            this.charWrapper = this.wrap(a1.create("text").setText(s1)), this.charWrapper.parent = this;
                        }
                    }, e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1), this.charWrapper ? t1.updateFrom(this.charWrapper.getBBox()) : (t1.w = this.width, t1.h = this.height + this.valign, t1.d = -this.valign);
                    }, e1;
                }(t1);
            };
        },
        5723: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMiMixin = void 0, e1.CommonMiMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.computeBBox = function(e1, r1) {
                        void 0 === r1 && (r1 = !1), t1.prototype.computeBBox.call(this, e1), this.copySkewIC(e1);
                    }, e1;
                }(t1);
            };
        },
        8009: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMmultiscriptsMixin = e1.ScriptNames = e1.NextScript = void 0;
            var l1 = r1(6469);
            e1.NextScript = {
                base: "subList",
                subList: "supList",
                supList: "subList",
                psubList: "psupList",
                psupList: "psubList"
            }, e1.ScriptNames = [
                "sup",
                "sup",
                "psup",
                "psub"
            ], e1.CommonMmultiscriptsMixin = function(t1) {
                return function(t1) {
                    function r1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, s1([], i1(e1), !1)) || this;
                        return n1.scriptData = null, n1.firstPrescript = 0, n1.getScriptData(), n1;
                    }
                    return o1(r1, t1), r1.prototype.combinePrePost = function(t1, e1) {
                        var r1 = new l1.BBox(t1);
                        return r1.combine(e1, 0, 0), r1;
                    }, r1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1 = this.font.params.scriptspace, n1 = this.scriptData, o1 = this.combinePrePost(n1.sub, n1.psub), s1 = this.combinePrePost(n1.sup, n1.psup), a1 = i1(this.getUVQ(o1, s1), 2), l1 = a1[0], c1 = a1[1];
                        if (t1.empty(), n1.numPrescripts && (t1.combine(n1.psup, r1, l1), t1.combine(n1.psub, r1, c1)), t1.append(n1.base), n1.numScripts) {
                            var u1 = t1.w;
                            t1.combine(n1.sup, u1, l1), t1.combine(n1.sub, u1, c1), t1.w += r1;
                        }
                        t1.clean(), this.setChildPWidths(e1);
                    }, r1.prototype.getScriptData = function() {
                        var t1 = this.scriptData = {
                            base: null,
                            sub: l1.BBox.empty(),
                            sup: l1.BBox.empty(),
                            psub: l1.BBox.empty(),
                            psup: l1.BBox.empty(),
                            numPrescripts: 0,
                            numScripts: 0
                        }, e1 = this.getScriptBBoxLists();
                        this.combineBBoxLists(t1.sub, t1.sup, e1.subList, e1.supList), this.combineBBoxLists(t1.psub, t1.psup, e1.psubList, e1.psupList), t1.base = e1.base[0], t1.numPrescripts = e1.psubList.length, t1.numScripts = e1.subList.length;
                    }, r1.prototype.getScriptBBoxLists = function() {
                        var t1, r1, n1 = {
                            base: [],
                            subList: [],
                            supList: [],
                            psubList: [],
                            psupList: []
                        }, o1 = "base";
                        try {
                            for(var i1 = a1(this.childNodes), s1 = i1.next(); !s1.done; s1 = i1.next()){
                                var l1 = s1.value;
                                l1.node.isKind("mprescripts") ? o1 = "psubList" : (n1[o1].push(l1.getOuterBBox()), o1 = e1.NextScript[o1]);
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        return this.firstPrescript = n1.subList.length + n1.supList.length + 2, this.padLists(n1.subList, n1.supList), this.padLists(n1.psubList, n1.psupList), n1;
                    }, r1.prototype.padLists = function(t1, e1) {
                        t1.length > e1.length && e1.push(l1.BBox.empty());
                    }, r1.prototype.combineBBoxLists = function(t1, e1, r1, n1) {
                        for(var o1 = 0; o1 < r1.length; o1++){
                            var s1 = i1(this.getScaledWHD(r1[o1]), 3), a1 = s1[0], l1 = s1[1], c1 = s1[2], u1 = i1(this.getScaledWHD(n1[o1]), 3), p1 = u1[0], h1 = u1[1], f1 = u1[2], d1 = Math.max(a1, p1);
                            t1.w += d1, e1.w += d1, l1 > t1.h && (t1.h = l1), c1 > t1.d && (t1.d = c1), h1 > e1.h && (e1.h = h1), f1 > e1.d && (e1.d = f1);
                        }
                    }, r1.prototype.getScaledWHD = function(t1) {
                        var e1 = t1.w, r1 = t1.h, n1 = t1.d, o1 = t1.rscale;
                        return [
                            e1 * o1,
                            r1 * o1,
                            n1 * o1
                        ];
                    }, r1.prototype.getUVQ = function(e1, r1) {
                        var n1;
                        if (!this.UVQ) {
                            var o1 = i1([
                                0,
                                0,
                                0
                            ], 3), s1 = o1[0], a1 = o1[1], l1 = o1[2];
                            0 === e1.h && 0 === e1.d ? s1 = this.getU() : 0 === r1.h && 0 === r1.d ? s1 = -this.getV() : (s1 = (n1 = i1(t1.prototype.getUVQ.call(this, e1, r1), 3))[0], a1 = n1[1], l1 = n1[2]), this.UVQ = [
                                s1,
                                a1,
                                l1
                            ];
                        }
                        return this.UVQ;
                    }, r1;
                }(t1);
            };
        },
        5023: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMnMixin = void 0, e1.CommonMnMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.remapChars = function(t1) {
                        if (t1.length) {
                            var e1 = this.font.getRemappedChar("mn", t1[0]);
                            if (e1) {
                                var r1 = this.unicodeChars(e1, this.variant);
                                1 === r1.length ? t1[0] = r1[0] : t1 = r1.concat(t1.slice(1));
                            }
                        }
                        return t1;
                    }, e1;
                }(t1);
            };
        },
        7096: function(t1, e1, r1) {
            var n1, o1, i1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), s1 = this && this.__assign || function() {
                return s1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, s1.apply(this, arguments);
            }, a1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, l1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, c1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMoMixin = e1.DirectionVH = void 0;
            var u1 = r1(6469), p1 = r1(505), h1 = r1(5884);
            e1.DirectionVH = ((o1 = {})[1] = "v", o1[2] = "h", o1), e1.CommonMoMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, l1([], a1(e1), !1)) || this;
                        return n1.size = null, n1.isAccent = n1.node.isAccent, n1;
                    }
                    return i1(e1, t1), e1.prototype.computeBBox = function(t1, e1) {
                        if (void 0 === e1 && (e1 = !1), this.protoBBox(t1), this.node.attributes.get("symmetric") && 2 !== this.stretch.dir) {
                            var r1 = this.getCenterOffset(t1);
                            t1.h += r1, t1.d -= r1;
                        }
                        this.node.getProperty("mathaccent") && (0 === this.stretch.dir || this.size >= 0) && (t1.w = 0);
                    }, e1.prototype.protoBBox = function(e1) {
                        var r1 = 0 !== this.stretch.dir;
                        r1 && null === this.size && this.getStretchedVariant([
                            0
                        ]), r1 && this.size < 0 || (t1.prototype.computeBBox.call(this, e1), this.copySkewIC(e1));
                    }, e1.prototype.getAccentOffset = function() {
                        var t1 = u1.BBox.empty();
                        return this.protoBBox(t1), -t1.w / 2;
                    }, e1.prototype.getCenterOffset = function(e1) {
                        return void 0 === e1 && (e1 = null), e1 || (e1 = u1.BBox.empty(), t1.prototype.computeBBox.call(this, e1)), (e1.h + e1.d) / 2 + this.font.params.axis_height - e1.h;
                    }, e1.prototype.getVariant = function() {
                        this.node.attributes.get("largeop") ? this.variant = this.node.attributes.get("displaystyle") ? "-largeop" : "-smallop" : this.node.attributes.getExplicit("mathvariant") || !1 !== this.node.getProperty("pseudoscript") ? t1.prototype.getVariant.call(this) : this.variant = "-tex-variant";
                    }, e1.prototype.canStretch = function(t1) {
                        if (0 !== this.stretch.dir) return this.stretch.dir === t1;
                        if (!this.node.attributes.get("stretchy")) return !1;
                        var e1 = this.getText();
                        if (1 !== Array.from(e1).length) return !1;
                        var r1 = this.font.getDelimiter(e1.codePointAt(0));
                        return this.stretch = r1 && r1.dir === t1 ? r1 : h1.NOSTRETCH, 0 !== this.stretch.dir;
                    }, e1.prototype.getStretchedVariant = function(t1, e1) {
                        var r1, n1;
                        if (void 0 === e1 && (e1 = !1), 0 !== this.stretch.dir) {
                            var o1 = this.getWH(t1), i1 = this.getSize("minsize", 0), a1 = this.getSize("maxsize", 1 / 0), l1 = this.node.getProperty("mathaccent");
                            o1 = Math.max(i1, Math.min(a1, o1));
                            var u1 = this.font.params.delimiterfactor / 1e3, p1 = this.font.params.delimitershortfall, h1 = i1 || e1 ? o1 : l1 ? Math.min(o1 / u1, o1 + p1) : Math.max(o1 * u1, o1 - p1), f1 = this.stretch, d1 = f1.c || this.getText().codePointAt(0), m1 = 0;
                            if (f1.sizes) try {
                                for(var y1 = c1(f1.sizes), g1 = y1.next(); !g1.done; g1 = y1.next()){
                                    if (g1.value >= h1) return l1 && m1 && m1--, this.variant = this.font.getSizeVariant(d1, m1), this.size = m1, void (f1.schar && f1.schar[m1] && (this.stretch = s1(s1({}, this.stretch), {
                                        c: f1.schar[m1]
                                    })));
                                    m1++;
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    g1 && !g1.done && (n1 = y1.return) && n1.call(y1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                            f1.stretch ? (this.size = -1, this.invalidateBBox(), this.getStretchBBox(t1, this.checkExtendedHeight(o1, f1), f1)) : (this.variant = this.font.getSizeVariant(d1, m1 - 1), this.size = m1 - 1);
                        }
                    }, e1.prototype.getSize = function(t1, e1) {
                        var r1 = this.node.attributes;
                        return r1.isSet(t1) && (e1 = this.length2em(r1.get(t1), 1, 1)), e1;
                    }, e1.prototype.getWH = function(t1) {
                        if (0 === t1.length) return 0;
                        if (1 === t1.length) return t1[0];
                        var e1 = a1(t1, 2), r1 = e1[0], n1 = e1[1], o1 = this.font.params.axis_height;
                        return this.node.attributes.get("symmetric") ? 2 * Math.max(r1 - o1, n1 + o1) : r1 + n1;
                    }, e1.prototype.getStretchBBox = function(t1, e1, r1) {
                        var n1;
                        r1.hasOwnProperty("min") && r1.min > e1 && (e1 = r1.min);
                        var o1 = a1(r1.HDW, 3), i1 = o1[0], s1 = o1[1], l1 = o1[2];
                        1 === this.stretch.dir ? (i1 = (n1 = a1(this.getBaseline(t1, e1, r1), 2))[0], s1 = n1[1]) : l1 = e1, this.bbox.h = i1, this.bbox.d = s1, this.bbox.w = l1;
                    }, e1.prototype.getBaseline = function(t1, e1, r1) {
                        var n1 = 2 === t1.length && t1[0] + t1[1] === e1, o1 = this.node.attributes.get("symmetric"), i1 = a1(n1 ? t1 : [
                            e1,
                            0
                        ], 2), s1 = i1[0], l1 = i1[1], c1 = a1([
                            s1 + l1,
                            0
                        ], 2), u1 = c1[0], p1 = c1[1];
                        if (o1) {
                            var h1 = this.font.params.axis_height;
                            n1 && (u1 = 2 * Math.max(s1 - h1, l1 + h1)), p1 = u1 / 2 - h1;
                        } else if (n1) p1 = l1;
                        else {
                            var f1 = a1(r1.HDW || [
                                .75,
                                .25
                            ], 2), d1 = f1[0], m1 = f1[1];
                            p1 = m1 * (u1 / (d1 + m1));
                        }
                        return [
                            u1 - p1,
                            p1
                        ];
                    }, e1.prototype.checkExtendedHeight = function(t1, e1) {
                        if (e1.fullExt) {
                            var r1 = a1(e1.fullExt, 2), n1 = r1[0], o1 = r1[1];
                            t1 = o1 + Math.ceil(Math.max(0, t1 - o1) / n1) * n1;
                        }
                        return t1;
                    }, e1.prototype.remapChars = function(t1) {
                        var e1 = this.node.getProperty("primes");
                        if (e1) return (0, p1.unicodeChars)(e1);
                        if (1 === t1.length) {
                            var r1 = this.node.coreParent().parent, n1 = this.isAccent && !r1.isKind("mrow") ? "accent" : "mo", o1 = this.font.getRemappedChar(n1, t1[0]);
                            o1 && (t1 = this.unicodeChars(o1, this.variant));
                        }
                        return t1;
                    }, e1;
                }(t1);
            };
        },
        6898: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMpaddedMixin = void 0, e1.CommonMpaddedMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.getDimens = function() {
                        var t1 = this.node.attributes.getList("width", "height", "depth", "lspace", "voffset"), e1 = this.childNodes[0].getBBox(), r1 = e1.w, n1 = e1.h, o1 = e1.d, i1 = r1, s1 = n1, a1 = o1, l1 = 0, c1 = 0, u1 = 0;
                        "" !== t1.width && (r1 = this.dimen(t1.width, e1, "w", 0)), "" !== t1.height && (n1 = this.dimen(t1.height, e1, "h", 0)), "" !== t1.depth && (o1 = this.dimen(t1.depth, e1, "d", 0)), "" !== t1.voffset && (c1 = this.dimen(t1.voffset, e1)), "" !== t1.lspace && (l1 = this.dimen(t1.lspace, e1));
                        var p1 = this.node.attributes.get("data-align");
                        return p1 && (u1 = this.getAlignX(r1, e1, p1)), [
                            s1,
                            a1,
                            i1,
                            n1 - s1,
                            o1 - a1,
                            r1 - i1,
                            l1,
                            c1,
                            u1
                        ];
                    }, e1.prototype.dimen = function(t1, e1, r1, n1) {
                        void 0 === r1 && (r1 = ""), void 0 === n1 && (n1 = null);
                        var o1 = (t1 = String(t1)).match(/width|height|depth/), i1 = o1 ? e1[o1[0].charAt(0)] : r1 ? e1[r1] : 0, s1 = this.length2em(t1, i1) || 0;
                        return t1.match(/^[-+]/) && r1 && (s1 += i1), null != n1 && (s1 = Math.max(n1, s1)), s1;
                    }, e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1 = o1(this.getDimens(), 6), n1 = r1[0], i1 = r1[1], s1 = r1[2], a1 = r1[3], l1 = r1[4], c1 = r1[5];
                        t1.w = s1 + c1, t1.h = n1 + a1, t1.d = i1 + l1, this.setChildPWidths(e1, t1.w);
                    }, e1.prototype.getWrapWidth = function(t1) {
                        return this.getBBox().w;
                    }, e1.prototype.getChildAlign = function(t1) {
                        return this.node.attributes.get("data-align") || "left";
                    }, e1;
                }(t1);
            };
        },
        6991: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMrootMixin = void 0, e1.CommonMrootMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "surd", {
                        get: function() {
                            return 2;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "root", {
                        get: function() {
                            return 1;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.combineRootBBox = function(t1, e1, r1) {
                        var n1 = this.childNodes[this.root].getOuterBBox(), o1 = this.getRootDimens(e1, r1)[1];
                        t1.combine(n1, 0, o1);
                    }, e1.prototype.getRootDimens = function(t1, e1) {
                        var r1 = this.childNodes[this.surd], n1 = this.childNodes[this.root].getOuterBBox(), o1 = (r1.size < 0 ? .5 : .6) * t1.w, i1 = n1.w, s1 = n1.rscale, a1 = Math.max(i1, o1 / s1), l1 = Math.max(0, a1 - i1);
                        return [
                            a1 * s1 - o1,
                            this.rootHeight(n1, t1, r1.size, e1),
                            l1
                        ];
                    }, e1.prototype.rootHeight = function(t1, e1, r1, n1) {
                        var o1 = e1.h + e1.d;
                        return (r1 < 0 ? 1.9 : .55 * o1) - (o1 - n1) + Math.max(0, t1.d * t1.rscale);
                    }, e1;
                }(t1);
            };
        },
        8411: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonInferredMrowMixin = e1.CommonMrowMixin = void 0;
            var l1 = r1(6469);
            e1.CommonMrowMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1, r1, n1 = [], o1 = 0; o1 < arguments.length; o1++)n1[o1] = arguments[o1];
                        var c1 = t1.apply(this, s1([], i1(n1), !1)) || this;
                        c1.stretchChildren();
                        try {
                            for(var u1 = a1(c1.childNodes), p1 = u1.next(); !p1.done; p1 = u1.next()){
                                var h1 = p1.value;
                                if (h1.bbox.pwidth) {
                                    c1.bbox.pwidth = l1.BBox.fullWidth;
                                    break;
                                }
                            }
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                p1 && !p1.done && (r1 = u1.return) && r1.call(u1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                        return c1;
                    }
                    return o1(e1, t1), Object.defineProperty(e1.prototype, "fixesPWidth", {
                        get: function() {
                            return !1;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.stretchChildren = function() {
                        var t1, e1, r1, n1, o1, i1, s1 = [];
                        try {
                            for(var l1 = a1(this.childNodes), c1 = l1.next(); !c1.done; c1 = l1.next())(x1 = c1.value).canStretch(1) && s1.push(x1);
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                c1 && !c1.done && (e1 = l1.return) && e1.call(l1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        var u1 = s1.length, p1 = this.childNodes.length;
                        if (u1 && p1 > 1) {
                            var h1 = 0, f1 = 0, d1 = u1 > 1 && u1 === p1;
                            try {
                                for(var m1 = a1(this.childNodes), y1 = m1.next(); !y1.done; y1 = m1.next()){
                                    var g1 = 0 === (x1 = y1.value).stretch.dir;
                                    if (d1 || g1) {
                                        var b1 = x1.getOuterBBox(g1), v1 = b1.h, _1 = b1.d, S1 = b1.rscale;
                                        (v1 *= S1) > h1 && (h1 = v1), (_1 *= S1) > f1 && (f1 = _1);
                                    }
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    y1 && !y1.done && (n1 = m1.return) && n1.call(m1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                            try {
                                for(var O1 = a1(s1), M1 = O1.next(); !M1.done; M1 = O1.next()){
                                    var x1;
                                    (x1 = M1.value).coreMO().getStretchedVariant([
                                        h1,
                                        f1
                                    ]);
                                }
                            } catch (t1) {
                                o1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    M1 && !M1.done && (i1 = O1.return) && i1.call(O1);
                                } finally{
                                    if (o1) throw o1.error;
                                }
                            }
                        }
                    }, e1;
                }(t1);
            }, e1.CommonInferredMrowMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return o1(e1, t1), e1.prototype.getScale = function() {
                        this.bbox.scale = this.parent.bbox.scale, this.bbox.rscale = 1;
                    }, e1;
                }(t1);
            };
        },
        4126: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMsMixin = void 0, e1.CommonMsMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, i1([], o1(e1), !1)) || this, s1 = n1.node.attributes, a1 = s1.getList("lquote", "rquote");
                        return "monospace" !== n1.variant && (s1.isSet("lquote") || '"' !== a1.lquote || (a1.lquote = "“"), s1.isSet("rquote") || '"' !== a1.rquote || (a1.rquote = "”")), n1.childNodes.unshift(n1.createText(a1.lquote)), n1.childNodes.push(n1.createText(a1.rquote)), n1;
                    }
                    return n1(e1, t1), e1.prototype.createText = function(t1) {
                        var e1 = this.wrap(this.mmlText(t1));
                        return e1.parent = this, e1;
                    }, e1;
                }(t1);
            };
        },
        258: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMspaceMixin = void 0, e1.CommonMspaceMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1 = this.node.attributes;
                        t1.w = this.length2em(r1.get("width"), 0), t1.h = this.length2em(r1.get("height"), 0), t1.d = this.length2em(r1.get("depth"), 0);
                    }, e1.prototype.handleVariant = function() {}, e1;
                }(t1);
            };
        },
        4093: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMsqrtMixin = void 0;
            var a1 = r1(6469);
            e1.CommonMsqrtMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, s1([], i1(e1), !1)) || this, o1 = n1.createMo("√");
                        o1.canStretch(1);
                        var a1 = n1.childNodes[n1.base].getOuterBBox(), l1 = a1.h, c1 = a1.d, u1 = n1.font.params.rule_thickness, p1 = n1.node.attributes.get("displaystyle") ? n1.font.params.x_height : u1;
                        return n1.surdH = l1 + c1 + 2 * u1 + p1 / 4, o1.getStretchedVariant([
                            n1.surdH - c1,
                            c1
                        ], !0), n1;
                    }
                    return o1(e1, t1), Object.defineProperty(e1.prototype, "base", {
                        get: function() {
                            return 0;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "surd", {
                        get: function() {
                            return 1;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "root", {
                        get: function() {
                            return null;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.createMo = function(e1) {
                        var r1 = t1.prototype.createMo.call(this, e1);
                        return this.childNodes.push(r1), r1;
                    }, e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1 = this.childNodes[this.surd].getBBox(), n1 = new a1.BBox(this.childNodes[this.base].getOuterBBox()), o1 = this.getPQ(r1)[1], s1 = this.font.params.rule_thickness, l1 = n1.h + o1 + s1, c1 = i1(this.getRootDimens(r1, l1), 1)[0];
                        t1.h = l1 + s1, this.combineRootBBox(t1, r1, l1), t1.combine(r1, c1, l1 - r1.h), t1.combine(n1, c1 + r1.w, 0), t1.clean(), this.setChildPWidths(e1);
                    }, e1.prototype.combineRootBBox = function(t1, e1, r1) {}, e1.prototype.getPQ = function(t1) {
                        var e1 = this.font.params.rule_thickness, r1 = this.node.attributes.get("displaystyle") ? this.font.params.x_height : e1;
                        return [
                            r1,
                            t1.h + t1.d > this.surdH ? (t1.h + t1.d - (this.surdH - 2 * e1 - r1 / 2)) / 2 : e1 + r1 / 4
                        ];
                    }, e1.prototype.getRootDimens = function(t1, e1) {
                        return [
                            0,
                            0,
                            0,
                            0
                        ];
                    }, e1;
                }(t1);
            };
        },
        905: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMsubsupMixin = e1.CommonMsupMixin = e1.CommonMsubMixin = void 0, e1.CommonMsubMixin = function(t1) {
                var e1;
                return e1 = function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "scriptChild", {
                        get: function() {
                            return this.childNodes[this.node.sub];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.getOffset = function() {
                        return [
                            0,
                            -this.getV()
                        ];
                    }, e1;
                }(t1), e1.useIC = !1, e1;
            }, e1.CommonMsupMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "scriptChild", {
                        get: function() {
                            return this.childNodes[this.node.sup];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.getOffset = function() {
                        return [
                            this.getAdjustedIc() - (this.baseRemoveIc ? 0 : this.baseIc),
                            this.getU()
                        ];
                    }, e1;
                }(t1);
            }, e1.CommonMsubsupMixin = function(t1) {
                var e1;
                return e1 = function(t1) {
                    function e1() {
                        var e1 = null !== t1 && t1.apply(this, arguments) || this;
                        return e1.UVQ = null, e1;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "subChild", {
                        get: function() {
                            return this.childNodes[this.node.sub];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "supChild", {
                        get: function() {
                            return this.childNodes[this.node.sup];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1 = this.baseChild.getOuterBBox(), n1 = o1([
                            this.subChild.getOuterBBox(),
                            this.supChild.getOuterBBox()
                        ], 2), i1 = n1[0], s1 = n1[1];
                        t1.empty(), t1.append(r1);
                        var a1 = this.getBaseWidth(), l1 = this.getAdjustedIc(), c1 = o1(this.getUVQ(), 2), u1 = c1[0], p1 = c1[1];
                        t1.combine(i1, a1, p1), t1.combine(s1, a1 + l1, u1), t1.w += this.font.params.scriptspace, t1.clean(), this.setChildPWidths(e1);
                    }, e1.prototype.getUVQ = function(t1, e1) {
                        void 0 === t1 && (t1 = this.subChild.getOuterBBox()), void 0 === e1 && (e1 = this.supChild.getOuterBBox());
                        var r1 = this.baseCore.getOuterBBox();
                        if (this.UVQ) return this.UVQ;
                        var n1 = this.font.params, i1 = 3 * n1.rule_thickness, s1 = this.length2em(this.node.attributes.get("subscriptshift"), n1.sub2), a1 = this.baseCharZero(r1.d * this.baseScale + n1.sub_drop * t1.rscale), l1 = o1([
                            this.getU(),
                            Math.max(a1, s1)
                        ], 2), c1 = l1[0], u1 = l1[1], p1 = c1 - e1.d * e1.rscale - (t1.h * t1.rscale - u1);
                        if (p1 < i1) {
                            u1 += i1 - p1;
                            var h1 = .8 * n1.x_height - (c1 - e1.d * e1.rscale);
                            h1 > 0 && (c1 += h1, u1 -= h1);
                        }
                        return c1 = Math.max(this.length2em(this.node.attributes.get("superscriptshift"), c1), c1), u1 = Math.max(this.length2em(this.node.attributes.get("subscriptshift"), u1), u1), p1 = c1 - e1.d * e1.rscale - (t1.h * t1.rscale - u1), this.UVQ = [
                            c1,
                            -u1,
                            p1
                        ], this.UVQ;
                    }, e1;
                }(t1), e1.useIC = !1, e1;
            };
        },
        6237: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMtableMixin = void 0;
            var l1 = r1(6469), c1 = r1(505), u1 = r1(7875);
            e1.CommonMtableMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, s1([], i1(e1), !1)) || this;
                        n1.numCols = 0, n1.numRows = 0, n1.data = null, n1.pwidthCells = [], n1.pWidth = 0, n1.numCols = (0, u1.max)(n1.tableRows.map(function(t1) {
                            return t1.numCells;
                        })), n1.numRows = n1.childNodes.length, n1.hasLabels = n1.childNodes.reduce(function(t1, e1) {
                            return t1 || e1.node.isKind("mlabeledtr");
                        }, !1), n1.findContainer(), n1.isTop = !n1.container || n1.container.node.isKind("math") && !n1.container.parent, n1.isTop && (n1.jax.table = n1), n1.getPercentageWidth();
                        var o1 = n1.node.attributes;
                        return n1.frame = "none" !== o1.get("frame"), n1.fLine = n1.frame && o1.get("frame") ? .07 : 0, n1.fSpace = n1.frame ? n1.convertLengths(n1.getAttributeArray("framespacing")) : [
                            0,
                            0
                        ], n1.cSpace = n1.convertLengths(n1.getColumnAttributes("columnspacing")), n1.rSpace = n1.convertLengths(n1.getRowAttributes("rowspacing")), n1.cLines = n1.getColumnAttributes("columnlines").map(function(t1) {
                            return "none" === t1 ? 0 : .07;
                        }), n1.rLines = n1.getRowAttributes("rowlines").map(function(t1) {
                            return "none" === t1 ? 0 : .07;
                        }), n1.cWidths = n1.getColumnWidths(), n1.stretchRows(), n1.stretchColumns(), n1;
                    }
                    return o1(e1, t1), Object.defineProperty(e1.prototype, "tableRows", {
                        get: function() {
                            return this.childNodes;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.findContainer = function() {
                        for(var t1 = this, e1 = t1.parent; e1 && (e1.node.notParent || e1.node.isKind("mrow"));)t1 = e1, e1 = e1.parent;
                        this.container = e1, this.containerI = t1.node.childPosition();
                    }, e1.prototype.getPercentageWidth = function() {
                        if (this.hasLabels) this.bbox.pwidth = l1.BBox.fullWidth;
                        else {
                            var t1 = this.node.attributes.get("width");
                            (0, c1.isPercent)(t1) && (this.bbox.pwidth = t1);
                        }
                    }, e1.prototype.stretchRows = function() {
                        for(var t1 = this.node.attributes.get("equalrows"), e1 = t1 ? this.getEqualRowHeight() : 0, r1 = t1 ? this.getTableData() : {
                            H: [
                                0
                            ],
                            D: [
                                0
                            ]
                        }, n1 = r1.H, o1 = r1.D, i1 = this.tableRows, s1 = 0; s1 < this.numRows; s1++){
                            var a1 = t1 ? [
                                (e1 + n1[s1] - o1[s1]) / 2,
                                (e1 - n1[s1] + o1[s1]) / 2
                            ] : null;
                            i1[s1].stretchChildren(a1);
                        }
                    }, e1.prototype.stretchColumns = function() {
                        for(var t1 = 0; t1 < this.numCols; t1++){
                            var e1 = "number" == typeof this.cWidths[t1] ? this.cWidths[t1] : null;
                            this.stretchColumn(t1, e1);
                        }
                    }, e1.prototype.stretchColumn = function(t1, e1) {
                        var r1, n1, o1, i1, s1, l1, c1 = [];
                        try {
                            for(var u1 = a1(this.tableRows), p1 = u1.next(); !p1.done; p1 = u1.next())if (g1 = p1.value.getChild(t1)) 0 === (O1 = g1.childNodes[0]).stretch.dir && O1.canStretch(2) && c1.push(O1);
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                p1 && !p1.done && (n1 = u1.return) && n1.call(u1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                        var h1 = c1.length, f1 = this.childNodes.length;
                        if (h1 && f1 > 1) {
                            if (null === e1) {
                                e1 = 0;
                                var d1 = h1 > 1 && h1 === f1;
                                try {
                                    for(var m1 = a1(this.tableRows), y1 = m1.next(); !y1.done; y1 = m1.next()){
                                        var g1;
                                        if (g1 = y1.value.getChild(t1)) {
                                            var b1 = 0 === (O1 = g1.childNodes[0]).stretch.dir;
                                            if (d1 || b1) {
                                                var v1 = O1.getBBox(b1).w;
                                                v1 > e1 && (e1 = v1);
                                            }
                                        }
                                    }
                                } catch (t1) {
                                    o1 = {
                                        error: t1
                                    };
                                } finally{
                                    try {
                                        y1 && !y1.done && (i1 = m1.return) && i1.call(m1);
                                    } finally{
                                        if (o1) throw o1.error;
                                    }
                                }
                            }
                            try {
                                for(var _1 = a1(c1), S1 = _1.next(); !S1.done; S1 = _1.next()){
                                    var O1;
                                    (O1 = S1.value).coreMO().getStretchedVariant([
                                        e1
                                    ]);
                                }
                            } catch (t1) {
                                s1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    S1 && !S1.done && (l1 = _1.return) && l1.call(_1);
                                } finally{
                                    if (s1) throw s1.error;
                                }
                            }
                        }
                    }, e1.prototype.getTableData = function() {
                        if (this.data) return this.data;
                        for(var t1 = new Array(this.numRows).fill(0), e1 = new Array(this.numRows).fill(0), r1 = new Array(this.numCols).fill(0), n1 = new Array(this.numRows), o1 = new Array(this.numRows), i1 = [
                            0
                        ], s1 = this.tableRows, a1 = 0; a1 < s1.length; a1++){
                            for(var l1 = 0, c1 = s1[a1], u1 = c1.node.attributes.get("rowalign"), p1 = 0; p1 < c1.numCells; p1++){
                                var h1 = c1.getChild(p1);
                                l1 = this.updateHDW(h1, p1, a1, u1, t1, e1, r1, l1), this.recordPWidthCell(h1, p1);
                            }
                            n1[a1] = t1[a1], o1[a1] = e1[a1], c1.labeled && (l1 = this.updateHDW(c1.childNodes[0], 0, a1, u1, t1, e1, i1, l1)), this.extendHD(a1, t1, e1, l1), this.extendHD(a1, n1, o1, l1);
                        }
                        var f1 = i1[0];
                        return this.data = {
                            H: t1,
                            D: e1,
                            W: r1,
                            NH: n1,
                            ND: o1,
                            L: f1
                        }, this.data;
                    }, e1.prototype.updateHDW = function(t1, e1, r1, n1, o1, i1, s1, a1) {
                        var l1 = t1.getBBox(), c1 = l1.h, u1 = l1.d, p1 = l1.w, h1 = t1.parent.bbox.rscale;
                        1 !== t1.parent.bbox.rscale && (c1 *= h1, u1 *= h1, p1 *= h1), this.node.getProperty("useHeight") && (c1 < .75 && (c1 = .75), u1 < .25 && (u1 = .25));
                        var f1 = 0;
                        return "baseline" !== (n1 = t1.node.attributes.get("rowalign") || n1) && "axis" !== n1 && (f1 = c1 + u1, c1 = u1 = 0), c1 > o1[r1] && (o1[r1] = c1), u1 > i1[r1] && (i1[r1] = u1), f1 > a1 && (a1 = f1), s1 && p1 > s1[e1] && (s1[e1] = p1), a1;
                    }, e1.prototype.extendHD = function(t1, e1, r1, n1) {
                        var o1 = (n1 - (e1[t1] + r1[t1])) / 2;
                        o1 < 1e-5 || (e1[t1] += o1, r1[t1] += o1);
                    }, e1.prototype.recordPWidthCell = function(t1, e1) {
                        t1.childNodes[0] && t1.childNodes[0].getBBox().pwidth && this.pwidthCells.push([
                            t1,
                            e1
                        ]);
                    }, e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1, n1, o1 = this.getTableData(), s1 = o1.H, a1 = o1.D;
                        if (this.node.attributes.get("equalrows")) {
                            var l1 = this.getEqualRowHeight();
                            r1 = (0, u1.sum)([].concat(this.rLines, this.rSpace)) + l1 * this.numRows;
                        } else r1 = (0, u1.sum)(s1.concat(a1, this.rLines, this.rSpace));
                        r1 += 2 * (this.fLine + this.fSpace[1]);
                        var p1 = this.getComputedWidths();
                        n1 = (0, u1.sum)(p1.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]);
                        var h1 = this.node.attributes.get("width");
                        "auto" !== h1 && (n1 = Math.max(this.length2em(h1, 0) + 2 * this.fLine, n1));
                        var f1 = i1(this.getBBoxHD(r1), 2), d1 = f1[0], m1 = f1[1];
                        t1.h = d1, t1.d = m1, t1.w = n1;
                        var y1 = i1(this.getBBoxLR(), 2), g1 = y1[0], b1 = y1[1];
                        t1.L = g1, t1.R = b1, (0, c1.isPercent)(h1) || this.setColumnPWidths();
                    }, e1.prototype.setChildPWidths = function(t1, e1, r1) {
                        var n1 = this.node.attributes.get("width");
                        if (!(0, c1.isPercent)(n1)) return !1;
                        this.hasLabels || (this.bbox.pwidth = "", this.container.bbox.pwidth = "");
                        var o1 = this.bbox, i1 = o1.w, s1 = o1.L, a1 = o1.R, l1 = this.node.attributes.get("data-width-includes-label"), p1 = Math.max(i1, this.length2em(n1, Math.max(e1, s1 + i1 + a1))) - (l1 ? s1 + a1 : 0), h1 = this.node.attributes.get("equalcolumns") ? Array(this.numCols).fill(this.percent(1 / Math.max(1, this.numCols))) : this.getColumnAttributes("columnwidth", 0);
                        this.cWidths = this.getColumnWidthsFixed(h1, p1);
                        var f1 = this.getComputedWidths();
                        return this.pWidth = (0, u1.sum)(f1.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]), this.isTop && (this.bbox.w = this.pWidth), this.setColumnPWidths(), this.pWidth !== i1 && this.parent.invalidateBBox(), this.pWidth !== i1;
                    }, e1.prototype.setColumnPWidths = function() {
                        var t1, e1, r1 = this.cWidths;
                        try {
                            for(var n1 = a1(this.pwidthCells), o1 = n1.next(); !o1.done; o1 = n1.next()){
                                var s1 = i1(o1.value, 2), l1 = s1[0], c1 = s1[1];
                                l1.setChildPWidths(!1, r1[c1]) && (l1.invalidateBBox(), l1.getBBox());
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }, e1.prototype.getBBoxHD = function(t1) {
                        var e1 = i1(this.getAlignmentRow(), 2), r1 = e1[0], n1 = e1[1];
                        if (null === n1) {
                            var o1 = this.font.params.axis_height, s1 = t1 / 2;
                            return ({
                                top: [
                                    0,
                                    t1
                                ],
                                center: [
                                    s1,
                                    s1
                                ],
                                bottom: [
                                    t1,
                                    0
                                ],
                                baseline: [
                                    s1,
                                    s1
                                ],
                                axis: [
                                    s1 + o1,
                                    s1 - o1
                                ]
                            })[r1] || [
                                s1,
                                s1
                            ];
                        }
                        var a1 = this.getVerticalPosition(n1, r1);
                        return [
                            a1,
                            t1 - a1
                        ];
                    }, e1.prototype.getBBoxLR = function() {
                        if (this.hasLabels) {
                            var t1 = this.node.attributes, e1 = t1.get("side"), r1 = i1(this.getPadAlignShift(e1), 2), n1 = r1[0], o1 = r1[1], s1 = this.hasLabels && !!t1.get("data-width-includes-label");
                            return s1 && this.frame && this.fSpace[0] && (n1 -= this.fSpace[0]), "center" !== o1 || s1 ? "left" === e1 ? [
                                n1,
                                0
                            ] : [
                                0,
                                n1
                            ] : [
                                n1,
                                n1
                            ];
                        }
                        return [
                            0,
                            0
                        ];
                    }, e1.prototype.getPadAlignShift = function(t1) {
                        var e1 = this.getTableData().L + this.length2em(this.node.attributes.get("minlabelspacing")), r1 = i1(null == this.styles ? [
                            "",
                            ""
                        ] : [
                            this.styles.get("padding-left"),
                            this.styles.get("padding-right")
                        ], 2), n1 = r1[0], o1 = r1[1];
                        (n1 || o1) && (e1 = Math.max(e1, this.length2em(n1 || "0"), this.length2em(o1 || "0")));
                        var s1 = i1(this.getAlignShift(), 2), a1 = s1[0], l1 = s1[1];
                        return a1 === t1 && (l1 = "left" === t1 ? Math.max(e1, l1) - e1 : Math.min(-e1, l1) + e1), [
                            e1,
                            a1,
                            l1
                        ];
                    }, e1.prototype.getAlignShift = function() {
                        return this.isTop ? t1.prototype.getAlignShift.call(this) : [
                            this.container.getChildAlign(this.containerI),
                            0
                        ];
                    }, e1.prototype.getWidth = function() {
                        return this.pWidth || this.getBBox().w;
                    }, e1.prototype.getEqualRowHeight = function() {
                        var t1 = this.getTableData(), e1 = t1.H, r1 = t1.D, n1 = Array.from(e1.keys()).map(function(t1) {
                            return e1[t1] + r1[t1];
                        });
                        return Math.max.apply(Math, n1);
                    }, e1.prototype.getComputedWidths = function() {
                        var t1 = this, e1 = this.getTableData().W, r1 = Array.from(e1.keys()).map(function(r1) {
                            return "number" == typeof t1.cWidths[r1] ? t1.cWidths[r1] : e1[r1];
                        });
                        return this.node.attributes.get("equalcolumns") && (r1 = Array(r1.length).fill((0, u1.max)(r1))), r1;
                    }, e1.prototype.getColumnWidths = function() {
                        var t1 = this.node.attributes.get("width");
                        if (this.node.attributes.get("equalcolumns")) return this.getEqualColumns(t1);
                        var e1 = this.getColumnAttributes("columnwidth", 0);
                        return "auto" === t1 ? this.getColumnWidthsAuto(e1) : (0, c1.isPercent)(t1) ? this.getColumnWidthsPercent(e1) : this.getColumnWidthsFixed(e1, this.length2em(t1));
                    }, e1.prototype.getEqualColumns = function(t1) {
                        var e1, r1 = Math.max(1, this.numCols);
                        if ("auto" === t1) {
                            var n1 = this.getTableData().W;
                            e1 = (0, u1.max)(n1);
                        } else if ((0, c1.isPercent)(t1)) e1 = this.percent(1 / r1);
                        else {
                            var o1 = (0, u1.sum)([].concat(this.cLines, this.cSpace)) + 2 * this.fSpace[0];
                            e1 = Math.max(0, this.length2em(t1) - o1) / r1;
                        }
                        return Array(this.numCols).fill(e1);
                    }, e1.prototype.getColumnWidthsAuto = function(t1) {
                        var e1 = this;
                        return t1.map(function(t1) {
                            return "auto" === t1 || "fit" === t1 ? null : (0, c1.isPercent)(t1) ? t1 : e1.length2em(t1);
                        });
                    }, e1.prototype.getColumnWidthsPercent = function(t1) {
                        var e1 = this, r1 = t1.indexOf("fit") >= 0, n1 = (r1 ? this.getTableData() : {
                            W: null
                        }).W;
                        return Array.from(t1.keys()).map(function(o1) {
                            var i1 = t1[o1];
                            return "fit" === i1 ? null : "auto" === i1 ? r1 ? n1[o1] : null : (0, c1.isPercent)(i1) ? i1 : e1.length2em(i1);
                        });
                    }, e1.prototype.getColumnWidthsFixed = function(t1, e1) {
                        var r1 = this, n1 = Array.from(t1.keys()), o1 = n1.filter(function(e1) {
                            return "fit" === t1[e1];
                        }), i1 = n1.filter(function(e1) {
                            return "auto" === t1[e1];
                        }), s1 = o1.length || i1.length, a1 = (s1 ? this.getTableData() : {
                            W: null
                        }).W, l1 = e1 - (0, u1.sum)([].concat(this.cLines, this.cSpace)) - 2 * this.fSpace[0], c1 = l1;
                        n1.forEach(function(e1) {
                            var n1 = t1[e1];
                            c1 -= "fit" === n1 || "auto" === n1 ? a1[e1] : r1.length2em(n1, l1);
                        });
                        var p1 = s1 && c1 > 0 ? c1 / s1 : 0;
                        return n1.map(function(e1) {
                            var n1 = t1[e1];
                            return "fit" === n1 ? a1[e1] + p1 : "auto" === n1 ? a1[e1] + (0 === o1.length ? p1 : 0) : r1.length2em(n1, l1);
                        });
                    }, e1.prototype.getVerticalPosition = function(t1, e1) {
                        for(var r1 = this.node.attributes.get("equalrows"), n1 = this.getTableData(), o1 = n1.H, s1 = n1.D, a1 = r1 ? this.getEqualRowHeight() : 0, l1 = this.getRowHalfSpacing(), c1 = this.fLine, u1 = 0; u1 < t1; u1++)c1 += l1[u1] + (r1 ? a1 : o1[u1] + s1[u1]) + l1[u1 + 1] + this.rLines[u1];
                        var p1 = i1(r1 ? [
                            (a1 + o1[t1] - s1[t1]) / 2,
                            (a1 - o1[t1] + s1[t1]) / 2
                        ] : [
                            o1[t1],
                            s1[t1]
                        ], 2), h1 = p1[0], f1 = p1[1];
                        return c1 += ({
                            top: 0,
                            center: l1[t1] + (h1 + f1) / 2,
                            bottom: l1[t1] + h1 + f1 + l1[t1 + 1],
                            baseline: l1[t1] + h1,
                            axis: l1[t1] + h1 - .25
                        })[e1] || 0;
                    }, e1.prototype.getEmHalfSpacing = function(t1, e1, r1) {
                        void 0 === r1 && (r1 = 1);
                        var n1 = this.em(t1 * r1), o1 = this.addEm(e1, 2 / r1);
                        return o1.unshift(n1), o1.push(n1), o1;
                    }, e1.prototype.getRowHalfSpacing = function() {
                        var t1 = this.rSpace.map(function(t1) {
                            return t1 / 2;
                        });
                        return t1.unshift(this.fSpace[1]), t1.push(this.fSpace[1]), t1;
                    }, e1.prototype.getColumnHalfSpacing = function() {
                        var t1 = this.cSpace.map(function(t1) {
                            return t1 / 2;
                        });
                        return t1.unshift(this.fSpace[0]), t1.push(this.fSpace[0]), t1;
                    }, e1.prototype.getAlignmentRow = function() {
                        var t1 = i1((0, c1.split)(this.node.attributes.get("align")), 2), e1 = t1[0], r1 = t1[1];
                        if (null == r1) return [
                            e1,
                            null
                        ];
                        var n1 = parseInt(r1);
                        return n1 < 0 && (n1 += this.numRows + 1), [
                            e1,
                            n1 < 1 || n1 > this.numRows ? null : n1 - 1
                        ];
                    }, e1.prototype.getColumnAttributes = function(t1, e1) {
                        void 0 === e1 && (e1 = 1);
                        var r1 = this.numCols - e1, n1 = this.getAttributeArray(t1);
                        if (0 === n1.length) return null;
                        for(; n1.length < r1;)n1.push(n1[n1.length - 1]);
                        return n1.length > r1 && n1.splice(r1), n1;
                    }, e1.prototype.getRowAttributes = function(t1, e1) {
                        void 0 === e1 && (e1 = 1);
                        var r1 = this.numRows - e1, n1 = this.getAttributeArray(t1);
                        if (0 === n1.length) return null;
                        for(; n1.length < r1;)n1.push(n1[n1.length - 1]);
                        return n1.length > r1 && n1.splice(r1), n1;
                    }, e1.prototype.getAttributeArray = function(t1) {
                        var e1 = this.node.attributes.get(t1);
                        return e1 ? (0, c1.split)(e1) : [
                            this.node.attributes.getDefault(t1)
                        ];
                    }, e1.prototype.addEm = function(t1, e1) {
                        var r1 = this;
                        return void 0 === e1 && (e1 = 1), t1 ? t1.map(function(t1) {
                            return r1.em(t1 / e1);
                        }) : null;
                    }, e1.prototype.convertLengths = function(t1) {
                        var e1 = this;
                        return t1 ? t1.map(function(t1) {
                            return e1.length2em(t1);
                        }) : null;
                    }, e1;
                }(t1);
            };
        },
        5164: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMtdMixin = void 0, e1.CommonMtdMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "fixesPWidth", {
                        get: function() {
                            return !1;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.invalidateBBox = function() {
                        this.bboxComputed = !1;
                    }, e1.prototype.getWrapWidth = function(t1) {
                        var e1 = this.parent.parent, r1 = this.parent, n1 = this.node.childPosition() - (r1.labeled ? 1 : 0);
                        return "number" == typeof e1.cWidths[n1] ? e1.cWidths[n1] : e1.getTableData().W[n1];
                    }, e1.prototype.getChildAlign = function(t1) {
                        return this.node.attributes.get("columnalign");
                    }, e1;
                }(t1);
            };
        },
        6319: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMtextMixin = void 0, e1.CommonMtextMixin = function(t1) {
                var e1;
                return e1 = function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.getVariant = function() {
                        var e1 = this.jax.options, r1 = this.jax.math.outputData, n1 = (!!r1.merrorFamily || !!e1.merrorFont) && this.node.Parent.isKind("merror");
                        if (r1.mtextFamily || e1.mtextFont || n1) {
                            var o1 = this.node.attributes.get("mathvariant"), i1 = this.constructor.INHERITFONTS[o1] || this.jax.font.getCssFont(o1), s1 = i1[0] || (n1 ? r1.merrorFamily || e1.merrorFont : r1.mtextFamily || e1.mtextFont);
                            this.variant = this.explicitVariant(s1, i1[2] ? "bold" : "", i1[1] ? "italic" : "");
                        } else t1.prototype.getVariant.call(this);
                    }, e1;
                }(t1), e1.INHERITFONTS = {
                    normal: [
                        "",
                        !1,
                        !1
                    ],
                    bold: [
                        "",
                        !1,
                        !0
                    ],
                    italic: [
                        "",
                        !0,
                        !1
                    ],
                    "bold-italic": [
                        "",
                        !0,
                        !0
                    ]
                }, e1;
            };
        },
        5766: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMlabeledtrMixin = e1.CommonMtrMixin = void 0, e1.CommonMtrMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "fixesPWidth", {
                        get: function() {
                            return !1;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "numCells", {
                        get: function() {
                            return this.childNodes.length;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "labeled", {
                        get: function() {
                            return !1;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "tableCells", {
                        get: function() {
                            return this.childNodes;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.getChild = function(t1) {
                        return this.childNodes[t1];
                    }, e1.prototype.getChildBBoxes = function() {
                        return this.childNodes.map(function(t1) {
                            return t1.getBBox();
                        });
                    }, e1.prototype.stretchChildren = function(t1) {
                        var e1, r1, n1, i1, s1, a1;
                        void 0 === t1 && (t1 = null);
                        var l1 = [], c1 = this.labeled ? this.childNodes.slice(1) : this.childNodes;
                        try {
                            for(var u1 = o1(c1), p1 = u1.next(); !p1.done; p1 = u1.next())(E1 = p1.value.childNodes[0]).canStretch(1) && l1.push(E1);
                        } catch (t1) {
                            e1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                p1 && !p1.done && (r1 = u1.return) && r1.call(u1);
                            } finally{
                                if (e1) throw e1.error;
                            }
                        }
                        var h1 = l1.length, f1 = this.childNodes.length;
                        if (h1 && f1 > 1) {
                            if (null === t1) {
                                var d1 = 0, m1 = 0, y1 = h1 > 1 && h1 === f1;
                                try {
                                    for(var g1 = o1(c1), b1 = g1.next(); !b1.done; b1 = g1.next()){
                                        var v1 = 0 === (E1 = b1.value.childNodes[0]).stretch.dir;
                                        if (y1 || v1) {
                                            var _1 = E1.getBBox(v1), S1 = _1.h, O1 = _1.d;
                                            S1 > d1 && (d1 = S1), O1 > m1 && (m1 = O1);
                                        }
                                    }
                                } catch (t1) {
                                    n1 = {
                                        error: t1
                                    };
                                } finally{
                                    try {
                                        b1 && !b1.done && (i1 = g1.return) && i1.call(g1);
                                    } finally{
                                        if (n1) throw n1.error;
                                    }
                                }
                                t1 = [
                                    d1,
                                    m1
                                ];
                            }
                            try {
                                for(var M1 = o1(l1), x1 = M1.next(); !x1.done; x1 = M1.next()){
                                    var E1;
                                    (E1 = x1.value).coreMO().getStretchedVariant(t1);
                                }
                            } catch (t1) {
                                s1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    x1 && !x1.done && (a1 = M1.return) && a1.call(M1);
                                } finally{
                                    if (s1) throw s1.error;
                                }
                            }
                        }
                    }, e1;
                }(t1);
            }, e1.CommonMlabeledtrMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "numCells", {
                        get: function() {
                            return Math.max(0, this.childNodes.length - 1);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "labeled", {
                        get: function() {
                            return !0;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "tableCells", {
                        get: function() {
                            return this.childNodes.slice(1);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.getChild = function(t1) {
                        return this.childNodes[t1 + 1];
                    }, e1.prototype.getChildBBoxes = function() {
                        return this.childNodes.slice(1).map(function(t1) {
                            return t1.getBBox();
                        });
                    }, e1;
                }(t1);
            };
        },
        1971: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonMunderoverMixin = e1.CommonMoverMixin = e1.CommonMunderMixin = void 0, e1.CommonMunderMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, i1([], o1(e1), !1)) || this;
                        return n1.stretchChildren(), n1;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "scriptChild", {
                        get: function() {
                            return this.childNodes[this.node.under];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.computeBBox = function(e1, r1) {
                        if (void 0 === r1 && (r1 = !1), this.hasMovableLimits()) t1.prototype.computeBBox.call(this, e1, r1);
                        else {
                            e1.empty();
                            var n1 = this.baseChild.getOuterBBox(), i1 = this.scriptChild.getOuterBBox(), s1 = this.getUnderKV(n1, i1)[1], a1 = this.isLineBelow ? 0 : this.getDelta(!0), l1 = o1(this.getDeltaW([
                                n1,
                                i1
                            ], [
                                0,
                                -a1
                            ]), 2), c1 = l1[0], u1 = l1[1];
                            e1.combine(n1, c1, 0), e1.combine(i1, u1, s1), e1.d += this.font.params.big_op_spacing5, e1.clean(), this.setChildPWidths(r1);
                        }
                    }, e1;
                }(t1);
            }, e1.CommonMoverMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, i1([], o1(e1), !1)) || this;
                        return n1.stretchChildren(), n1;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "scriptChild", {
                        get: function() {
                            return this.childNodes[this.node.over];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.computeBBox = function(e1) {
                        if (this.hasMovableLimits()) t1.prototype.computeBBox.call(this, e1);
                        else {
                            e1.empty();
                            var r1 = this.baseChild.getOuterBBox(), n1 = this.scriptChild.getOuterBBox();
                            this.node.attributes.get("accent") && (r1.h = Math.max(r1.h, this.font.params.x_height * r1.scale));
                            var i1 = this.getOverKU(r1, n1)[1], s1 = this.isLineAbove ? 0 : this.getDelta(), a1 = o1(this.getDeltaW([
                                r1,
                                n1
                            ], [
                                0,
                                s1
                            ]), 2), l1 = a1[0], c1 = a1[1];
                            e1.combine(r1, l1, 0), e1.combine(n1, c1, i1), e1.h += this.font.params.big_op_spacing5, e1.clean();
                        }
                    }, e1;
                }(t1);
            }, e1.CommonMunderoverMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, i1([], o1(e1), !1)) || this;
                        return n1.stretchChildren(), n1;
                    }
                    return n1(e1, t1), Object.defineProperty(e1.prototype, "underChild", {
                        get: function() {
                            return this.childNodes[this.node.under];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "overChild", {
                        get: function() {
                            return this.childNodes[this.node.over];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "subChild", {
                        get: function() {
                            return this.underChild;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "supChild", {
                        get: function() {
                            return this.overChild;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.computeBBox = function(e1) {
                        if (this.hasMovableLimits()) t1.prototype.computeBBox.call(this, e1);
                        else {
                            e1.empty();
                            var r1 = this.overChild.getOuterBBox(), n1 = this.baseChild.getOuterBBox(), i1 = this.underChild.getOuterBBox();
                            this.node.attributes.get("accent") && (n1.h = Math.max(n1.h, this.font.params.x_height * n1.scale));
                            var s1 = this.getOverKU(n1, r1)[1], a1 = this.getUnderKV(n1, i1)[1], l1 = this.getDelta(), c1 = o1(this.getDeltaW([
                                n1,
                                i1,
                                r1
                            ], [
                                0,
                                this.isLineBelow ? 0 : -l1,
                                this.isLineAbove ? 0 : l1
                            ]), 3), u1 = c1[0], p1 = c1[1], h1 = c1[2];
                            e1.combine(n1, u1, 0), e1.combine(r1, h1, s1), e1.combine(i1, p1, a1);
                            var f1 = this.font.params.big_op_spacing5;
                            e1.h += f1, e1.d += f1, e1.clean();
                        }
                    }, e1;
                }(t1);
            };
        },
        167: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, a1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonScriptbaseMixin = void 0;
            var l1 = r1(9007);
            e1.CommonScriptbaseMixin = function(t1) {
                var e1;
                return e1 = function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, s1([], i1(e1), !1)) || this;
                        n1.baseScale = 1, n1.baseIc = 0, n1.baseRemoveIc = !1, n1.baseIsChar = !1, n1.baseHasAccentOver = null, n1.baseHasAccentUnder = null, n1.isLineAbove = !1, n1.isLineBelow = !1, n1.isMathAccent = !1;
                        var o1 = n1.baseCore = n1.getBaseCore();
                        return o1 ? (n1.setBaseAccentsFor(o1), n1.baseScale = n1.getBaseScale(), n1.baseIc = n1.getBaseIc(), n1.baseIsChar = n1.isCharBase(), n1.isMathAccent = n1.baseIsChar && n1.scriptChild && !!n1.scriptChild.coreMO().node.getProperty("mathaccent"), n1.checkLineAccents(), n1.baseRemoveIc = !n1.isLineAbove && !n1.isLineBelow && (!n1.constructor.useIC || n1.isMathAccent), n1) : n1;
                    }
                    return o1(e1, t1), Object.defineProperty(e1.prototype, "baseChild", {
                        get: function() {
                            return this.childNodes[this.node.base];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e1.prototype, "scriptChild", {
                        get: function() {
                            return this.childNodes[1];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e1.prototype.getBaseCore = function() {
                        for(var t1 = this.getSemanticBase() || this.childNodes[0]; t1 && (1 === t1.childNodes.length && (t1.node.isKind("mrow") || t1.node.isKind("TeXAtom") && t1.node.texClass !== l1.TEXCLASS.VCENTER || t1.node.isKind("mstyle") || t1.node.isKind("mpadded") || t1.node.isKind("mphantom") || t1.node.isKind("semantics")) || t1.node.isKind("munderover") && t1.isMathAccent);)this.setBaseAccentsFor(t1), t1 = t1.childNodes[0];
                        return t1 || (this.baseHasAccentOver = this.baseHasAccentUnder = !1), t1 || this.childNodes[0];
                    }, e1.prototype.setBaseAccentsFor = function(t1) {
                        t1.node.isKind("munderover") && (null === this.baseHasAccentOver && (this.baseHasAccentOver = !!t1.node.attributes.get("accent")), null === this.baseHasAccentUnder && (this.baseHasAccentUnder = !!t1.node.attributes.get("accentunder")));
                    }, e1.prototype.getSemanticBase = function() {
                        var t1 = this.node.attributes.getExplicit("data-semantic-fencepointer");
                        return this.getBaseFence(this.baseChild, t1);
                    }, e1.prototype.getBaseFence = function(t1, e1) {
                        var r1, n1;
                        if (!t1 || !t1.node.attributes || !e1) return null;
                        if (t1.node.attributes.getExplicit("data-semantic-id") === e1) return t1;
                        try {
                            for(var o1 = a1(t1.childNodes), i1 = o1.next(); !i1.done; i1 = o1.next()){
                                var s1 = i1.value, l1 = this.getBaseFence(s1, e1);
                                if (l1) return l1;
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                        return null;
                    }, e1.prototype.getBaseScale = function() {
                        for(var t1 = this.baseCore, e1 = 1; t1 && t1 !== this;)e1 *= t1.getOuterBBox().rscale, t1 = t1.parent;
                        return e1;
                    }, e1.prototype.getBaseIc = function() {
                        return this.baseCore.getOuterBBox().ic * this.baseScale;
                    }, e1.prototype.getAdjustedIc = function() {
                        var t1 = this.baseCore.getOuterBBox();
                        return (t1.ic ? 1.05 * t1.ic + .05 : 0) * this.baseScale;
                    }, e1.prototype.isCharBase = function() {
                        var t1 = this.baseCore;
                        return (t1.node.isKind("mo") && null === t1.size || t1.node.isKind("mi") || t1.node.isKind("mn")) && 1 === t1.bbox.rscale && 1 === Array.from(t1.getText()).length;
                    }, e1.prototype.checkLineAccents = function() {
                        if (this.node.isKind("munderover")) {
                            if (this.node.isKind("mover")) this.isLineAbove = this.isLineAccent(this.scriptChild);
                            else if (this.node.isKind("munder")) this.isLineBelow = this.isLineAccent(this.scriptChild);
                            else this.isLineAbove = this.isLineAccent(this.overChild), this.isLineBelow = this.isLineAccent(this.underChild);
                        }
                    }, e1.prototype.isLineAccent = function(t1) {
                        var e1 = t1.coreMO().node;
                        return e1.isToken && "―" === e1.getText();
                    }, e1.prototype.getBaseWidth = function() {
                        var t1 = this.baseChild.getOuterBBox();
                        return t1.w * t1.rscale - (this.baseRemoveIc ? this.baseIc : 0) + this.font.params.extra_ic;
                    }, e1.prototype.computeBBox = function(t1, e1) {
                        void 0 === e1 && (e1 = !1);
                        var r1 = this.getBaseWidth(), n1 = i1(this.getOffset(), 2), o1 = n1[0], s1 = n1[1];
                        t1.append(this.baseChild.getOuterBBox()), t1.combine(this.scriptChild.getOuterBBox(), r1 + o1, s1), t1.w += this.font.params.scriptspace, t1.clean(), this.setChildPWidths(e1);
                    }, e1.prototype.getOffset = function() {
                        return [
                            0,
                            0
                        ];
                    }, e1.prototype.baseCharZero = function(t1) {
                        var e1 = !!this.baseCore.node.attributes.get("largeop"), r1 = this.baseScale;
                        return this.baseIsChar && !e1 && 1 === r1 ? 0 : t1;
                    }, e1.prototype.getV = function() {
                        var t1 = this.baseCore.getOuterBBox(), e1 = this.scriptChild.getOuterBBox(), r1 = this.font.params, n1 = this.length2em(this.node.attributes.get("subscriptshift"), r1.sub1);
                        return Math.max(this.baseCharZero(t1.d * this.baseScale + r1.sub_drop * e1.rscale), n1, e1.h * e1.rscale - .8 * r1.x_height);
                    }, e1.prototype.getU = function() {
                        var t1 = this.baseCore.getOuterBBox(), e1 = this.scriptChild.getOuterBBox(), r1 = this.font.params, n1 = this.node.attributes.getList("displaystyle", "superscriptshift"), o1 = this.node.getProperty("texprimestyle") ? r1.sup3 : n1.displaystyle ? r1.sup1 : r1.sup2, i1 = this.length2em(n1.superscriptshift, o1);
                        return Math.max(this.baseCharZero(t1.h * this.baseScale - r1.sup_drop * e1.rscale), i1, e1.d * e1.rscale + 1 / 4 * r1.x_height);
                    }, e1.prototype.hasMovableLimits = function() {
                        var t1 = this.node.attributes.get("displaystyle"), e1 = this.baseChild.coreMO().node;
                        return !t1 && !!e1.attributes.get("movablelimits");
                    }, e1.prototype.getOverKU = function(t1, e1) {
                        var r1 = this.node.attributes.get("accent"), n1 = this.font.params, o1 = e1.d * e1.rscale, i1 = n1.rule_thickness * n1.separation_factor, s1 = this.baseHasAccentOver ? i1 : 0, a1 = this.isLineAbove ? 3 * n1.rule_thickness : i1, l1 = (r1 ? a1 : Math.max(n1.big_op_spacing1, n1.big_op_spacing3 - Math.max(0, o1))) - s1;
                        return [
                            l1,
                            t1.h * t1.rscale + l1 + o1
                        ];
                    }, e1.prototype.getUnderKV = function(t1, e1) {
                        var r1 = this.node.attributes.get("accentunder"), n1 = this.font.params, o1 = e1.h * e1.rscale, i1 = n1.rule_thickness * n1.separation_factor, s1 = this.baseHasAccentUnder ? i1 : 0, a1 = this.isLineBelow ? 3 * n1.rule_thickness : i1, l1 = (r1 ? a1 : Math.max(n1.big_op_spacing2, n1.big_op_spacing4 - o1)) - s1;
                        return [
                            l1,
                            -(t1.d * t1.rscale + l1 + o1)
                        ];
                    }, e1.prototype.getDeltaW = function(t1, e1) {
                        var r1, n1, o1, l1;
                        void 0 === e1 && (e1 = [
                            0,
                            0,
                            0
                        ]);
                        var c1 = this.node.attributes.get("align"), u1 = t1.map(function(t1) {
                            return t1.w * t1.rscale;
                        });
                        u1[0] -= this.baseRemoveIc && !this.baseCore.node.attributes.get("largeop") ? this.baseIc : 0;
                        var p1 = Math.max.apply(Math, s1([], i1(u1), !1)), h1 = [], f1 = 0;
                        try {
                            for(var d1 = a1(u1.keys()), m1 = d1.next(); !m1.done; m1 = d1.next()){
                                var y1 = m1.value;
                                h1[y1] = ("center" === c1 ? (p1 - u1[y1]) / 2 : "right" === c1 ? p1 - u1[y1] : 0) + e1[y1], h1[y1] < f1 && (f1 = -h1[y1]);
                            }
                        } catch (t1) {
                            r1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                m1 && !m1.done && (n1 = d1.return) && n1.call(d1);
                            } finally{
                                if (r1) throw r1.error;
                            }
                        }
                        if (f1) try {
                            for(var g1 = a1(h1.keys()), b1 = g1.next(); !b1.done; b1 = g1.next()){
                                y1 = b1.value;
                                h1[y1] += f1;
                            }
                        } catch (t1) {
                            o1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                b1 && !b1.done && (l1 = g1.return) && l1.call(g1);
                            } finally{
                                if (o1) throw o1.error;
                            }
                        }
                        return [
                            1,
                            2
                        ].map(function(e1) {
                            return h1[e1] += t1[e1] ? t1[e1].dx * t1[0].scale : 0;
                        }), h1;
                    }, e1.prototype.getDelta = function(t1) {
                        void 0 === t1 && (t1 = !1);
                        var e1 = this.node.attributes.get("accent"), r1 = this.baseCore.getOuterBBox(), n1 = r1.sk, o1 = r1.ic;
                        return ((e1 && !t1 ? n1 : 0) + this.font.skewIcFactor * o1) * this.baseScale;
                    }, e1.prototype.stretchChildren = function() {
                        var t1, e1, r1, n1, o1, i1, s1 = [];
                        try {
                            for(var l1 = a1(this.childNodes), c1 = l1.next(); !c1.done; c1 = l1.next())(O1 = c1.value).canStretch(2) && s1.push(O1);
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                c1 && !c1.done && (e1 = l1.return) && e1.call(l1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        var u1 = s1.length, p1 = this.childNodes.length;
                        if (u1 && p1 > 1) {
                            var h1 = 0, f1 = u1 > 1 && u1 === p1;
                            try {
                                for(var d1 = a1(this.childNodes), m1 = d1.next(); !m1.done; m1 = d1.next()){
                                    var y1 = 0 === (O1 = m1.value).stretch.dir;
                                    if (f1 || y1) {
                                        var g1 = O1.getOuterBBox(y1), b1 = g1.w, v1 = g1.rscale;
                                        b1 * v1 > h1 && (h1 = b1 * v1);
                                    }
                                }
                            } catch (t1) {
                                r1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    m1 && !m1.done && (n1 = d1.return) && n1.call(d1);
                                } finally{
                                    if (r1) throw r1.error;
                                }
                            }
                            try {
                                for(var _1 = a1(s1), S1 = _1.next(); !S1.done; S1 = _1.next()){
                                    var O1;
                                    (O1 = S1.value).coreMO().getStretchedVariant([
                                        h1 / O1.bbox.rscale
                                    ]);
                                }
                            } catch (t1) {
                                o1 = {
                                    error: t1
                                };
                            } finally{
                                try {
                                    S1 && !S1.done && (i1 = _1.return) && i1.call(_1);
                                } finally{
                                    if (o1) throw o1.error;
                                }
                            }
                        }
                    }, e1;
                }(t1), e1.useIC = !0, e1;
            };
        },
        5806: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonSemanticsMixin = void 0, e1.CommonSemanticsMixin = function(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.computeBBox = function(t1, e1) {
                        if (void 0 === e1 && (e1 = !1), this.childNodes.length) {
                            var r1 = this.childNodes[0].getBBox(), n1 = r1.w, o1 = r1.h, i1 = r1.d;
                            t1.w = n1, t1.h = o1, t1.d = i1;
                        }
                    }, e1;
                }(t1);
            };
        },
        5920: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__assign || function() {
                return o1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, o1.apply(this, arguments);
            }, i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CommonTeXFontMixin = void 0, e1.CommonTeXFontMixin = function(t1) {
                var e1;
                return e1 = function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1.prototype.getDelimiterData = function(t1) {
                        return this.getChar("-smallop", t1) || this.getChar("-size4", t1);
                    }, e1;
                }(t1), e1.NAME = "TeX", e1.defaultVariants = s1(s1([], i1(t1.defaultVariants), !1), [
                    [
                        "-smallop",
                        "normal"
                    ],
                    [
                        "-largeop",
                        "normal"
                    ],
                    [
                        "-size3",
                        "normal"
                    ],
                    [
                        "-size4",
                        "normal"
                    ],
                    [
                        "-tex-calligraphic",
                        "italic"
                    ],
                    [
                        "-tex-bold-calligraphic",
                        "bold-italic"
                    ],
                    [
                        "-tex-oldstyle",
                        "normal"
                    ],
                    [
                        "-tex-bold-oldstyle",
                        "bold"
                    ],
                    [
                        "-tex-mathit",
                        "italic"
                    ],
                    [
                        "-tex-variant",
                        "normal"
                    ]
                ], !1), e1.defaultCssFonts = o1(o1({}, t1.defaultCssFonts), {
                    "-smallop": [
                        "serif",
                        !1,
                        !1
                    ],
                    "-largeop": [
                        "serif",
                        !1,
                        !1
                    ],
                    "-size3": [
                        "serif",
                        !1,
                        !1
                    ],
                    "-size4": [
                        "serif",
                        !1,
                        !1
                    ],
                    "-tex-calligraphic": [
                        "cursive",
                        !0,
                        !1
                    ],
                    "-tex-bold-calligraphic": [
                        "cursive",
                        !0,
                        !0
                    ],
                    "-tex-oldstyle": [
                        "serif",
                        !1,
                        !1
                    ],
                    "-tex-bold-oldstyle": [
                        "serif",
                        !1,
                        !0
                    ],
                    "-tex-mathit": [
                        "serif",
                        !0,
                        !1
                    ]
                }), e1.defaultSizeVariants = [
                    "normal",
                    "-smallop",
                    "-largeop",
                    "-size3",
                    "-size4",
                    "-tex-variant"
                ], e1.defaultStretchVariants = [
                    "-size4"
                ], e1;
            };
        },
        3980: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.boldItalic = void 0, e1.boldItalic = {
                47: [
                    .711,
                    .21,
                    .894
                ],
                305: [
                    .452,
                    .008,
                    .394,
                    {
                        sk: .0319
                    }
                ],
                567: [
                    .451,
                    .201,
                    .439,
                    {
                        sk: .0958
                    }
                ],
                8260: [
                    .711,
                    .21,
                    .894
                ],
                8710: [
                    .711,
                    0,
                    .958,
                    {
                        sk: .192
                    }
                ],
                10744: [
                    .711,
                    .21,
                    .894
                ]
            };
        },
        1103: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.bold = void 0, e1.bold = {
                33: [
                    .705,
                    0,
                    .35
                ],
                34: [
                    .694,
                    -0.329,
                    .603
                ],
                35: [
                    .694,
                    .193,
                    .958
                ],
                36: [
                    .75,
                    .056,
                    .575
                ],
                37: [
                    .75,
                    .056,
                    .958
                ],
                38: [
                    .705,
                    .011,
                    .894
                ],
                39: [
                    .694,
                    -0.329,
                    .319
                ],
                40: [
                    .75,
                    .249,
                    .447
                ],
                41: [
                    .75,
                    .249,
                    .447
                ],
                42: [
                    .75,
                    -0.306,
                    .575
                ],
                43: [
                    .633,
                    .131,
                    .894
                ],
                44: [
                    .171,
                    .194,
                    .319
                ],
                45: [
                    .278,
                    -0.166,
                    .383
                ],
                46: [
                    .171,
                    0,
                    .319
                ],
                47: [
                    .75,
                    .25,
                    .575
                ],
                58: [
                    .444,
                    0,
                    .319
                ],
                59: [
                    .444,
                    .194,
                    .319
                ],
                60: [
                    .587,
                    .085,
                    .894
                ],
                61: [
                    .393,
                    -0.109,
                    .894
                ],
                62: [
                    .587,
                    .085,
                    .894
                ],
                63: [
                    .7,
                    0,
                    .543
                ],
                64: [
                    .699,
                    .006,
                    .894
                ],
                91: [
                    .75,
                    .25,
                    .319
                ],
                92: [
                    .75,
                    .25,
                    .575
                ],
                93: [
                    .75,
                    .25,
                    .319
                ],
                94: [
                    .694,
                    -0.52,
                    .575
                ],
                95: [
                    -0.01,
                    .061,
                    .575
                ],
                96: [
                    .706,
                    -0.503,
                    .575
                ],
                123: [
                    .75,
                    .25,
                    .575
                ],
                124: [
                    .75,
                    .249,
                    .319
                ],
                125: [
                    .75,
                    .25,
                    .575
                ],
                126: [
                    .344,
                    -0.202,
                    .575
                ],
                168: [
                    .695,
                    -0.535,
                    .575
                ],
                172: [
                    .371,
                    -0.061,
                    .767
                ],
                175: [
                    .607,
                    -0.54,
                    .575
                ],
                176: [
                    .702,
                    -0.536,
                    .575
                ],
                177: [
                    .728,
                    .035,
                    .894
                ],
                180: [
                    .706,
                    -0.503,
                    .575
                ],
                183: [
                    .336,
                    -0.166,
                    .319
                ],
                215: [
                    .53,
                    .028,
                    .894
                ],
                247: [
                    .597,
                    .096,
                    .894
                ],
                305: [
                    .442,
                    0,
                    .278,
                    {
                        sk: .0278
                    }
                ],
                567: [
                    .442,
                    .205,
                    .306,
                    {
                        sk: .0833
                    }
                ],
                697: [
                    .563,
                    -0.033,
                    .344
                ],
                710: [
                    .694,
                    -0.52,
                    .575
                ],
                711: [
                    .66,
                    -0.515,
                    .575
                ],
                713: [
                    .607,
                    -0.54,
                    .575
                ],
                714: [
                    .706,
                    -0.503,
                    .575
                ],
                715: [
                    .706,
                    -0.503,
                    .575
                ],
                728: [
                    .694,
                    -0.5,
                    .575
                ],
                729: [
                    .695,
                    -0.525,
                    .575
                ],
                730: [
                    .702,
                    -0.536,
                    .575
                ],
                732: [
                    .694,
                    -0.552,
                    .575
                ],
                768: [
                    .706,
                    -0.503,
                    0
                ],
                769: [
                    .706,
                    -0.503,
                    0
                ],
                770: [
                    .694,
                    -0.52,
                    0
                ],
                771: [
                    .694,
                    -0.552,
                    0
                ],
                772: [
                    .607,
                    -0.54,
                    0
                ],
                774: [
                    .694,
                    -0.5,
                    0
                ],
                775: [
                    .695,
                    -0.525,
                    0
                ],
                776: [
                    .695,
                    -0.535,
                    0
                ],
                778: [
                    .702,
                    -0.536,
                    0
                ],
                779: [
                    .714,
                    -0.511,
                    0
                ],
                780: [
                    .66,
                    -0.515,
                    0
                ],
                824: [
                    .711,
                    .21,
                    0
                ],
                8194: [
                    0,
                    0,
                    .5
                ],
                8195: [
                    0,
                    0,
                    .999
                ],
                8196: [
                    0,
                    0,
                    .333
                ],
                8197: [
                    0,
                    0,
                    .25
                ],
                8198: [
                    0,
                    0,
                    .167
                ],
                8201: [
                    0,
                    0,
                    .167
                ],
                8202: [
                    0,
                    0,
                    .083
                ],
                8211: [
                    .3,
                    -0.249,
                    .575
                ],
                8212: [
                    .3,
                    -0.249,
                    1.15
                ],
                8213: [
                    .3,
                    -0.249,
                    1.15
                ],
                8214: [
                    .75,
                    .248,
                    .575
                ],
                8215: [
                    -0.01,
                    .061,
                    .575
                ],
                8216: [
                    .694,
                    -0.329,
                    .319
                ],
                8217: [
                    .694,
                    -0.329,
                    .319
                ],
                8220: [
                    .694,
                    -0.329,
                    .603
                ],
                8221: [
                    .694,
                    -0.329,
                    .603
                ],
                8224: [
                    .702,
                    .211,
                    .511
                ],
                8225: [
                    .702,
                    .202,
                    .511
                ],
                8226: [
                    .474,
                    -0.028,
                    .575
                ],
                8230: [
                    .171,
                    0,
                    1.295
                ],
                8242: [
                    .563,
                    -0.033,
                    .344
                ],
                8243: [
                    .563,
                    0,
                    .688
                ],
                8244: [
                    .563,
                    0,
                    1.032
                ],
                8254: [
                    .607,
                    -0.54,
                    .575
                ],
                8260: [
                    .75,
                    .25,
                    .575
                ],
                8279: [
                    .563,
                    0,
                    1.376
                ],
                8407: [
                    .723,
                    -0.513,
                    .575
                ],
                8463: [
                    .694,
                    .008,
                    .668,
                    {
                        sk: -0.0319
                    }
                ],
                8467: [
                    .702,
                    .019,
                    .474,
                    {
                        sk: .128
                    }
                ],
                8472: [
                    .461,
                    .21,
                    .74
                ],
                8501: [
                    .694,
                    0,
                    .703
                ],
                8592: [
                    .518,
                    .017,
                    1.15
                ],
                8593: [
                    .694,
                    .193,
                    .575
                ],
                8594: [
                    .518,
                    .017,
                    1.15
                ],
                8595: [
                    .694,
                    .194,
                    .575
                ],
                8596: [
                    .518,
                    .017,
                    1.15
                ],
                8597: [
                    .767,
                    .267,
                    .575
                ],
                8598: [
                    .724,
                    .194,
                    1.15
                ],
                8599: [
                    .724,
                    .193,
                    1.15
                ],
                8600: [
                    .694,
                    .224,
                    1.15
                ],
                8601: [
                    .694,
                    .224,
                    1.15
                ],
                8602: [
                    .711,
                    .21,
                    1.15
                ],
                8603: [
                    .711,
                    .21,
                    1.15
                ],
                8614: [
                    .518,
                    .017,
                    1.15
                ],
                8617: [
                    .518,
                    .017,
                    1.282
                ],
                8618: [
                    .518,
                    .017,
                    1.282
                ],
                8622: [
                    .711,
                    .21,
                    1.15
                ],
                8636: [
                    .518,
                    -0.22,
                    1.15
                ],
                8637: [
                    .281,
                    .017,
                    1.15
                ],
                8640: [
                    .518,
                    -0.22,
                    1.15
                ],
                8641: [
                    .281,
                    .017,
                    1.15
                ],
                8652: [
                    .718,
                    .017,
                    1.15
                ],
                8653: [
                    .711,
                    .21,
                    1.15
                ],
                8654: [
                    .711,
                    .21,
                    1.15
                ],
                8655: [
                    .711,
                    .21,
                    1.15
                ],
                8656: [
                    .547,
                    .046,
                    1.15
                ],
                8657: [
                    .694,
                    .193,
                    .703
                ],
                8658: [
                    .547,
                    .046,
                    1.15
                ],
                8659: [
                    .694,
                    .194,
                    .703
                ],
                8660: [
                    .547,
                    .046,
                    1.15
                ],
                8661: [
                    .767,
                    .267,
                    .703
                ],
                8704: [
                    .694,
                    .016,
                    .639
                ],
                8707: [
                    .694,
                    0,
                    .639
                ],
                8708: [
                    .711,
                    .21,
                    .639
                ],
                8709: [
                    .767,
                    .073,
                    .575
                ],
                8710: [
                    .698,
                    0,
                    .958
                ],
                8712: [
                    .587,
                    .086,
                    .767
                ],
                8713: [
                    .711,
                    .21,
                    .767
                ],
                8715: [
                    .587,
                    .086,
                    .767
                ],
                8716: [
                    .711,
                    .21,
                    .767
                ],
                8722: [
                    .281,
                    -0.221,
                    .894
                ],
                8723: [
                    .537,
                    .227,
                    .894
                ],
                8725: [
                    .75,
                    .25,
                    .575
                ],
                8726: [
                    .75,
                    .25,
                    .575
                ],
                8727: [
                    .472,
                    -0.028,
                    .575
                ],
                8728: [
                    .474,
                    -0.028,
                    .575
                ],
                8729: [
                    .474,
                    -0.028,
                    .575
                ],
                8730: [
                    .82,
                    .18,
                    .958,
                    {
                        ic: .03
                    }
                ],
                8733: [
                    .451,
                    .008,
                    .894
                ],
                8734: [
                    .452,
                    .008,
                    1.15
                ],
                8736: [
                    .714,
                    0,
                    .722
                ],
                8739: [
                    .75,
                    .249,
                    .319
                ],
                8740: [
                    .75,
                    .249,
                    .319
                ],
                8741: [
                    .75,
                    .248,
                    .575
                ],
                8742: [
                    .75,
                    .248,
                    .575
                ],
                8743: [
                    .604,
                    .017,
                    .767
                ],
                8744: [
                    .604,
                    .016,
                    .767
                ],
                8745: [
                    .603,
                    .016,
                    .767
                ],
                8746: [
                    .604,
                    .016,
                    .767
                ],
                8747: [
                    .711,
                    .211,
                    .569,
                    {
                        ic: .063
                    }
                ],
                8764: [
                    .391,
                    -0.109,
                    .894
                ],
                8768: [
                    .583,
                    .082,
                    .319
                ],
                8769: [
                    .711,
                    .21,
                    .894
                ],
                8771: [
                    .502,
                    0,
                    .894
                ],
                8772: [
                    .711,
                    .21,
                    .894
                ],
                8773: [
                    .638,
                    .027,
                    .894
                ],
                8775: [
                    .711,
                    .21,
                    .894
                ],
                8776: [
                    .524,
                    -0.032,
                    .894
                ],
                8777: [
                    .711,
                    .21,
                    .894
                ],
                8781: [
                    .533,
                    .032,
                    .894
                ],
                8784: [
                    .721,
                    -0.109,
                    .894
                ],
                8800: [
                    .711,
                    .21,
                    .894
                ],
                8801: [
                    .505,
                    0,
                    .894
                ],
                8802: [
                    .711,
                    .21,
                    .894
                ],
                8804: [
                    .697,
                    .199,
                    .894
                ],
                8805: [
                    .697,
                    .199,
                    .894
                ],
                8810: [
                    .617,
                    .116,
                    1.15
                ],
                8811: [
                    .618,
                    .116,
                    1.15
                ],
                8813: [
                    .711,
                    .21,
                    .894
                ],
                8814: [
                    .711,
                    .21,
                    .894
                ],
                8815: [
                    .711,
                    .21,
                    .894
                ],
                8816: [
                    .711,
                    .21,
                    .894
                ],
                8817: [
                    .711,
                    .21,
                    .894
                ],
                8826: [
                    .585,
                    .086,
                    .894
                ],
                8827: [
                    .586,
                    .086,
                    .894
                ],
                8832: [
                    .711,
                    .21,
                    .894
                ],
                8833: [
                    .711,
                    .21,
                    .894
                ],
                8834: [
                    .587,
                    .085,
                    .894
                ],
                8835: [
                    .587,
                    .086,
                    .894
                ],
                8836: [
                    .711,
                    .21,
                    .894
                ],
                8837: [
                    .711,
                    .21,
                    .894
                ],
                8838: [
                    .697,
                    .199,
                    .894
                ],
                8839: [
                    .697,
                    .199,
                    .894
                ],
                8840: [
                    .711,
                    .21,
                    .894
                ],
                8841: [
                    .711,
                    .21,
                    .894
                ],
                8846: [
                    .604,
                    .016,
                    .767
                ],
                8849: [
                    .697,
                    .199,
                    .894
                ],
                8850: [
                    .697,
                    .199,
                    .894
                ],
                8851: [
                    .604,
                    0,
                    .767
                ],
                8852: [
                    .604,
                    0,
                    .767
                ],
                8853: [
                    .632,
                    .132,
                    .894
                ],
                8854: [
                    .632,
                    .132,
                    .894
                ],
                8855: [
                    .632,
                    .132,
                    .894
                ],
                8856: [
                    .632,
                    .132,
                    .894
                ],
                8857: [
                    .632,
                    .132,
                    .894
                ],
                8866: [
                    .693,
                    0,
                    .703
                ],
                8867: [
                    .693,
                    0,
                    .703
                ],
                8868: [
                    .694,
                    0,
                    .894
                ],
                8869: [
                    .693,
                    0,
                    .894
                ],
                8872: [
                    .75,
                    .249,
                    .974
                ],
                8876: [
                    .711,
                    .21,
                    .703
                ],
                8877: [
                    .75,
                    .249,
                    .974
                ],
                8900: [
                    .523,
                    .021,
                    .575
                ],
                8901: [
                    .336,
                    -0.166,
                    .319
                ],
                8902: [
                    .502,
                    0,
                    .575
                ],
                8904: [
                    .54,
                    .039,
                    1
                ],
                8930: [
                    .711,
                    .21,
                    .894
                ],
                8931: [
                    .711,
                    .21,
                    .894
                ],
                8942: [
                    .951,
                    .029,
                    .319
                ],
                8943: [
                    .336,
                    -0.166,
                    1.295
                ],
                8945: [
                    .871,
                    -0.101,
                    1.323
                ],
                8968: [
                    .75,
                    .248,
                    .511
                ],
                8969: [
                    .75,
                    .248,
                    .511
                ],
                8970: [
                    .749,
                    .248,
                    .511
                ],
                8971: [
                    .749,
                    .248,
                    .511
                ],
                8994: [
                    .405,
                    -0.108,
                    1.15
                ],
                8995: [
                    .392,
                    -0.126,
                    1.15
                ],
                9001: [
                    .75,
                    .249,
                    .447
                ],
                9002: [
                    .75,
                    .249,
                    .447
                ],
                9651: [
                    .711,
                    0,
                    1.022
                ],
                9653: [
                    .711,
                    0,
                    1.022
                ],
                9657: [
                    .54,
                    .039,
                    .575
                ],
                9661: [
                    .5,
                    .21,
                    1.022
                ],
                9663: [
                    .5,
                    .21,
                    1.022
                ],
                9667: [
                    .539,
                    .038,
                    .575
                ],
                9711: [
                    .711,
                    .211,
                    1.15
                ],
                9824: [
                    .719,
                    .129,
                    .894
                ],
                9825: [
                    .711,
                    .024,
                    .894
                ],
                9826: [
                    .719,
                    .154,
                    .894
                ],
                9827: [
                    .719,
                    .129,
                    .894
                ],
                9837: [
                    .75,
                    .017,
                    .447
                ],
                9838: [
                    .741,
                    .223,
                    .447
                ],
                9839: [
                    .724,
                    .224,
                    .447
                ],
                10072: [
                    .75,
                    .249,
                    .319
                ],
                10216: [
                    .75,
                    .249,
                    .447
                ],
                10217: [
                    .75,
                    .249,
                    .447
                ],
                10229: [
                    .518,
                    .017,
                    1.805
                ],
                10230: [
                    .518,
                    .017,
                    1.833
                ],
                10231: [
                    .518,
                    .017,
                    2.126
                ],
                10232: [
                    .547,
                    .046,
                    1.868
                ],
                10233: [
                    .547,
                    .046,
                    1.87
                ],
                10234: [
                    .547,
                    .046,
                    2.126
                ],
                10236: [
                    .518,
                    .017,
                    1.833
                ],
                10744: [
                    .711,
                    .21,
                    .894
                ],
                10799: [
                    .53,
                    .028,
                    .894
                ],
                10815: [
                    .686,
                    0,
                    .9
                ],
                10927: [
                    .696,
                    .199,
                    .894
                ],
                10928: [
                    .697,
                    .199,
                    .894
                ],
                12296: [
                    .75,
                    .249,
                    .447
                ],
                12297: [
                    .75,
                    .249,
                    .447
                ]
            };
        },
        9124: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.delimiters = e1.VSIZES = e1.HDW3 = e1.HDW2 = e1.HDW1 = void 0;
            var n1 = r1(5884);
            e1.HDW1 = [
                .75,
                .25,
                .875
            ], e1.HDW2 = [
                .85,
                .349,
                .667
            ], e1.HDW3 = [
                .583,
                .082,
                .5
            ], e1.VSIZES = [
                1,
                1.2,
                1.8,
                2.4,
                3
            ];
            var o1 = {
                c: 47,
                dir: n1.V,
                sizes: e1.VSIZES
            }, i1 = {
                c: 175,
                dir: n1.H,
                sizes: [
                    .5
                ],
                stretch: [
                    0,
                    175
                ],
                HDW: [
                    .59,
                    -0.544,
                    .5
                ]
            }, s1 = {
                c: 710,
                dir: n1.H,
                sizes: [
                    .5,
                    .556,
                    1,
                    1.444,
                    1.889
                ]
            }, a1 = {
                c: 732,
                dir: n1.H,
                sizes: [
                    .5,
                    .556,
                    1,
                    1.444,
                    1.889
                ]
            }, l1 = {
                c: 8211,
                dir: n1.H,
                sizes: [
                    .5
                ],
                stretch: [
                    0,
                    8211
                ],
                HDW: [
                    .285,
                    -0.248,
                    .5
                ]
            }, c1 = {
                c: 8592,
                dir: n1.H,
                sizes: [
                    1
                ],
                stretch: [
                    8592,
                    8722
                ],
                HDW: e1.HDW3
            }, u1 = {
                c: 8594,
                dir: n1.H,
                sizes: [
                    1
                ],
                stretch: [
                    0,
                    8722,
                    8594
                ],
                HDW: e1.HDW3
            }, p1 = {
                c: 8596,
                dir: n1.H,
                sizes: [
                    1
                ],
                stretch: [
                    8592,
                    8722,
                    8594
                ],
                HDW: e1.HDW3
            }, h1 = {
                c: 8612,
                dir: n1.H,
                stretch: [
                    8592,
                    8722,
                    8739
                ],
                HDW: e1.HDW3,
                min: 1.278
            }, f1 = {
                c: 8614,
                dir: n1.H,
                sizes: [
                    1
                ],
                stretch: [
                    8739,
                    8722,
                    8594
                ],
                HDW: e1.HDW3
            }, d1 = {
                c: 8656,
                dir: n1.H,
                sizes: [
                    1
                ],
                stretch: [
                    8656,
                    61
                ],
                HDW: e1.HDW3
            }, m1 = {
                c: 8658,
                dir: n1.H,
                sizes: [
                    1
                ],
                stretch: [
                    0,
                    61,
                    8658
                ],
                HDW: e1.HDW3
            }, y1 = {
                c: 8660,
                dir: n1.H,
                sizes: [
                    1
                ],
                stretch: [
                    8656,
                    61,
                    8658
                ],
                HDW: e1.HDW3
            }, g1 = {
                c: 8722,
                dir: n1.H,
                sizes: [
                    .778
                ],
                stretch: [
                    0,
                    8722
                ],
                HDW: e1.HDW3
            }, b1 = {
                c: 8739,
                dir: n1.V,
                sizes: [
                    1
                ],
                stretch: [
                    0,
                    8739
                ],
                HDW: [
                    .627,
                    .015,
                    .333
                ]
            }, v1 = {
                c: 9180,
                dir: n1.H,
                sizes: [
                    .778,
                    1
                ],
                schar: [
                    8994,
                    8994
                ],
                variants: [
                    5,
                    0
                ],
                stretch: [
                    57680,
                    57684,
                    57681
                ],
                HDW: [
                    .32,
                    .2,
                    .5
                ]
            }, _1 = {
                c: 9181,
                dir: n1.H,
                sizes: [
                    .778,
                    1
                ],
                schar: [
                    8995,
                    8995
                ],
                variants: [
                    5,
                    0
                ],
                stretch: [
                    57682,
                    57684,
                    57683
                ],
                HDW: [
                    .32,
                    .2,
                    .5
                ]
            }, S1 = {
                c: 9182,
                dir: n1.H,
                stretch: [
                    57680,
                    57684,
                    57681,
                    57685
                ],
                HDW: [
                    .32,
                    .2,
                    .5
                ],
                min: 1.8
            }, O1 = {
                c: 9183,
                dir: n1.H,
                stretch: [
                    57682,
                    57684,
                    57683,
                    57686
                ],
                HDW: [
                    .32,
                    .2,
                    .5
                ],
                min: 1.8
            }, M1 = {
                c: 10216,
                dir: n1.V,
                sizes: e1.VSIZES
            }, x1 = {
                c: 10217,
                dir: n1.V,
                sizes: e1.VSIZES
            }, E1 = {
                c: 10502,
                dir: n1.H,
                stretch: [
                    8656,
                    61,
                    8739
                ],
                HDW: e1.HDW3,
                min: 1.278
            }, A1 = {
                c: 10503,
                dir: n1.H,
                stretch: [
                    8872,
                    61,
                    8658
                ],
                HDW: e1.HDW3,
                min: 1.278
            };
            e1.delimiters = {
                40: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9115,
                        9116,
                        9117
                    ],
                    HDW: [
                        .85,
                        .349,
                        .875
                    ]
                },
                41: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9118,
                        9119,
                        9120
                    ],
                    HDW: [
                        .85,
                        .349,
                        .875
                    ]
                },
                45: g1,
                47: o1,
                61: {
                    dir: n1.H,
                    sizes: [
                        .778
                    ],
                    stretch: [
                        0,
                        61
                    ],
                    HDW: e1.HDW3
                },
                91: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9121,
                        9122,
                        9123
                    ],
                    HDW: e1.HDW2
                },
                92: {
                    dir: n1.V,
                    sizes: e1.VSIZES
                },
                93: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9124,
                        9125,
                        9126
                    ],
                    HDW: e1.HDW2
                },
                94: s1,
                95: l1,
                123: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9127,
                        9130,
                        9129,
                        9128
                    ],
                    HDW: [
                        .85,
                        .349,
                        .889
                    ]
                },
                124: {
                    dir: n1.V,
                    sizes: [
                        1
                    ],
                    stretch: [
                        0,
                        8739
                    ],
                    HDW: [
                        .75,
                        .25,
                        .333
                    ]
                },
                125: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9131,
                        9130,
                        9133,
                        9132
                    ],
                    HDW: [
                        .85,
                        .349,
                        .889
                    ]
                },
                126: a1,
                175: i1,
                710: s1,
                713: i1,
                732: a1,
                770: s1,
                771: a1,
                818: l1,
                8211: l1,
                8212: l1,
                8213: l1,
                8214: {
                    dir: n1.V,
                    sizes: [
                        .602,
                        1
                    ],
                    schar: [
                        0,
                        8741
                    ],
                    variants: [
                        1,
                        0
                    ],
                    stretch: [
                        0,
                        8741
                    ],
                    HDW: [
                        .602,
                        0,
                        .556
                    ]
                },
                8215: l1,
                8254: i1,
                8407: u1,
                8592: c1,
                8593: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        8593,
                        9168
                    ],
                    HDW: [
                        .6,
                        0,
                        .667
                    ]
                },
                8594: u1,
                8595: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        0,
                        9168,
                        8595
                    ],
                    HDW: [
                        .6,
                        0,
                        .667
                    ]
                },
                8596: p1,
                8597: {
                    dir: n1.V,
                    sizes: [
                        1.044
                    ],
                    stretch: [
                        8593,
                        9168,
                        8595
                    ],
                    HDW: e1.HDW1
                },
                8606: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        8606,
                        8722
                    ],
                    HDW: e1.HDW3
                },
                8608: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        0,
                        8722,
                        8608
                    ],
                    HDW: e1.HDW3
                },
                8612: h1,
                8613: {
                    dir: n1.V,
                    stretch: [
                        8593,
                        9168,
                        8869
                    ],
                    HDW: e1.HDW1,
                    min: 1.555
                },
                8614: f1,
                8615: {
                    dir: n1.V,
                    stretch: [
                        8868,
                        9168,
                        8595
                    ],
                    HDW: e1.HDW1,
                    min: 1.555
                },
                8624: {
                    dir: n1.V,
                    sizes: [
                        .722
                    ],
                    stretch: [
                        8624,
                        9168
                    ],
                    HDW: e1.HDW1
                },
                8625: {
                    dir: n1.V,
                    sizes: [
                        .722
                    ],
                    stretch: [
                        8625,
                        9168
                    ],
                    HDW: e1.HDW1
                },
                8636: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        8636,
                        8722
                    ],
                    HDW: e1.HDW3
                },
                8637: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        8637,
                        8722
                    ],
                    HDW: e1.HDW3
                },
                8638: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        8638,
                        9168
                    ],
                    HDW: e1.HDW1
                },
                8639: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        8639,
                        9168
                    ],
                    HDW: e1.HDW1
                },
                8640: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        0,
                        8722,
                        8640
                    ],
                    HDW: e1.HDW3
                },
                8641: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        0,
                        8722,
                        8641
                    ],
                    HDW: e1.HDW3
                },
                8642: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        0,
                        9168,
                        8642
                    ],
                    HDW: e1.HDW1
                },
                8643: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        0,
                        9168,
                        8643
                    ],
                    HDW: e1.HDW1
                },
                8656: d1,
                8657: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        8657,
                        8214
                    ],
                    HDW: [
                        .599,
                        0,
                        .778
                    ]
                },
                8658: m1,
                8659: {
                    dir: n1.V,
                    sizes: [
                        .888
                    ],
                    stretch: [
                        0,
                        8214,
                        8659
                    ],
                    HDW: [
                        .6,
                        0,
                        .778
                    ]
                },
                8660: y1,
                8661: {
                    dir: n1.V,
                    sizes: [
                        1.044
                    ],
                    stretch: [
                        8657,
                        8214,
                        8659
                    ],
                    HDW: [
                        .75,
                        .25,
                        .778
                    ]
                },
                8666: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        8666,
                        8801
                    ],
                    HDW: [
                        .464,
                        -0.036,
                        .5
                    ]
                },
                8667: {
                    dir: n1.H,
                    sizes: [
                        1
                    ],
                    stretch: [
                        0,
                        8801,
                        8667
                    ],
                    HDW: [
                        .464,
                        -0.036,
                        .5
                    ]
                },
                8722: g1,
                8725: o1,
                8730: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        57345,
                        57344,
                        9143
                    ],
                    fullExt: [
                        .65,
                        2.3
                    ],
                    HDW: [
                        .85,
                        .35,
                        1.056
                    ]
                },
                8739: b1,
                8741: {
                    dir: n1.V,
                    sizes: [
                        1
                    ],
                    stretch: [
                        0,
                        8741
                    ],
                    HDW: [
                        .627,
                        .015,
                        .556
                    ]
                },
                8968: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9121,
                        9122
                    ],
                    HDW: e1.HDW2
                },
                8969: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        9124,
                        9125
                    ],
                    HDW: e1.HDW2
                },
                8970: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        0,
                        9122,
                        9123
                    ],
                    HDW: e1.HDW2
                },
                8971: {
                    dir: n1.V,
                    sizes: e1.VSIZES,
                    stretch: [
                        0,
                        9125,
                        9126
                    ],
                    HDW: e1.HDW2
                },
                8978: v1,
                8994: v1,
                8995: _1,
                9001: M1,
                9002: x1,
                9130: {
                    dir: n1.V,
                    sizes: [
                        .32
                    ],
                    stretch: [
                        9130,
                        9130,
                        9130
                    ],
                    HDW: [
                        .29,
                        .015,
                        .889
                    ]
                },
                9135: l1,
                9136: {
                    dir: n1.V,
                    sizes: [
                        .989
                    ],
                    stretch: [
                        9127,
                        9130,
                        9133
                    ],
                    HDW: [
                        .75,
                        .25,
                        .889
                    ]
                },
                9137: {
                    dir: n1.V,
                    sizes: [
                        .989
                    ],
                    stretch: [
                        9131,
                        9130,
                        9129
                    ],
                    HDW: [
                        .75,
                        .25,
                        .889
                    ]
                },
                9140: {
                    dir: n1.H,
                    stretch: [
                        9484,
                        8722,
                        9488
                    ],
                    HDW: e1.HDW3,
                    min: 1
                },
                9141: {
                    dir: n1.H,
                    stretch: [
                        9492,
                        8722,
                        9496
                    ],
                    HDW: e1.HDW3,
                    min: 1
                },
                9168: {
                    dir: n1.V,
                    sizes: [
                        .602,
                        1
                    ],
                    schar: [
                        0,
                        8739
                    ],
                    variants: [
                        1,
                        0
                    ],
                    stretch: [
                        0,
                        8739
                    ],
                    HDW: [
                        .602,
                        0,
                        .333
                    ]
                },
                9180: v1,
                9181: _1,
                9182: S1,
                9183: O1,
                9184: {
                    dir: n1.H,
                    stretch: [
                        714,
                        713,
                        715
                    ],
                    HDW: [
                        .59,
                        -0.544,
                        .5
                    ],
                    min: 1
                },
                9185: {
                    dir: n1.H,
                    stretch: [
                        715,
                        713,
                        714
                    ],
                    HDW: [
                        .59,
                        -0.544,
                        .5
                    ],
                    min: 1
                },
                9472: l1,
                10072: b1,
                10216: M1,
                10217: x1,
                10222: {
                    dir: n1.V,
                    sizes: [
                        .989
                    ],
                    stretch: [
                        9127,
                        9130,
                        9129
                    ],
                    HDW: [
                        .75,
                        .25,
                        .889
                    ]
                },
                10223: {
                    dir: n1.V,
                    sizes: [
                        .989
                    ],
                    stretch: [
                        9131,
                        9130,
                        9133
                    ],
                    HDW: [
                        .75,
                        .25,
                        .889
                    ]
                },
                10229: c1,
                10230: u1,
                10231: p1,
                10232: d1,
                10233: m1,
                10234: y1,
                10235: h1,
                10236: f1,
                10237: E1,
                10238: A1,
                10502: E1,
                10503: A1,
                10574: {
                    dir: n1.H,
                    stretch: [
                        8636,
                        8722,
                        8640
                    ],
                    HDW: e1.HDW3,
                    min: 2
                },
                10575: {
                    dir: n1.V,
                    stretch: [
                        8638,
                        9168,
                        8642
                    ],
                    HDW: e1.HDW1,
                    min: 1.776
                },
                10576: {
                    dir: n1.H,
                    stretch: [
                        8637,
                        8722,
                        8641
                    ],
                    HDW: e1.HDW3,
                    min: 2
                },
                10577: {
                    dir: n1.V,
                    stretch: [
                        8639,
                        9168,
                        8643
                    ],
                    HDW: e1.HDW1,
                    min: .5
                },
                10586: {
                    dir: n1.H,
                    stretch: [
                        8636,
                        8722,
                        8739
                    ],
                    HDW: e1.HDW3,
                    min: 1.278
                },
                10587: {
                    dir: n1.H,
                    stretch: [
                        8739,
                        8722,
                        8640
                    ],
                    HDW: e1.HDW3,
                    min: 1.278
                },
                10588: {
                    dir: n1.V,
                    stretch: [
                        8638,
                        9168,
                        8869
                    ],
                    HDW: e1.HDW1,
                    min: 1.556
                },
                10589: {
                    dir: n1.V,
                    stretch: [
                        8868,
                        9168,
                        8642
                    ],
                    HDW: e1.HDW1,
                    min: 1.556
                },
                10590: {
                    dir: n1.H,
                    stretch: [
                        8637,
                        8722,
                        8739
                    ],
                    HDW: e1.HDW3,
                    min: 1.278
                },
                10591: {
                    dir: n1.H,
                    stretch: [
                        8739,
                        8722,
                        8641
                    ],
                    HDW: e1.HDW3,
                    min: 1.278
                },
                10592: {
                    dir: n1.V,
                    stretch: [
                        8639,
                        9168,
                        8869
                    ],
                    HDW: e1.HDW1,
                    min: 1.776
                },
                10593: {
                    dir: n1.V,
                    stretch: [
                        8868,
                        9168,
                        8643
                    ],
                    HDW: e1.HDW1,
                    min: 1.776
                },
                12296: M1,
                12297: x1,
                65079: S1,
                65080: O1
            };
        },
        6001: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.doubleStruck = void 0, e1.doubleStruck = {};
        },
        3696: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.frakturBold = void 0, e1.frakturBold = {
                33: [
                    .689,
                    .012,
                    .349
                ],
                34: [
                    .695,
                    -0.432,
                    .254
                ],
                38: [
                    .696,
                    .016,
                    .871
                ],
                39: [
                    .695,
                    -0.436,
                    .25
                ],
                40: [
                    .737,
                    .186,
                    .459
                ],
                41: [
                    .735,
                    .187,
                    .459
                ],
                42: [
                    .692,
                    -0.449,
                    .328
                ],
                43: [
                    .598,
                    .082,
                    .893
                ],
                44: [
                    .107,
                    .191,
                    .328
                ],
                45: [
                    .275,
                    -0.236,
                    .893
                ],
                46: [
                    .102,
                    .015,
                    .328
                ],
                47: [
                    .721,
                    .182,
                    .593
                ],
                48: [
                    .501,
                    .012,
                    .593
                ],
                49: [
                    .489,
                    0,
                    .593
                ],
                50: [
                    .491,
                    0,
                    .593
                ],
                51: [
                    .487,
                    .193,
                    .593
                ],
                52: [
                    .495,
                    .196,
                    .593
                ],
                53: [
                    .481,
                    .19,
                    .593
                ],
                54: [
                    .704,
                    .012,
                    .593
                ],
                55: [
                    .479,
                    .197,
                    .593
                ],
                56: [
                    .714,
                    .005,
                    .593
                ],
                57: [
                    .487,
                    .195,
                    .593
                ],
                58: [
                    .457,
                    .012,
                    .255
                ],
                59: [
                    .458,
                    .19,
                    .255
                ],
                61: [
                    .343,
                    -0.168,
                    .582
                ],
                63: [
                    .697,
                    .014,
                    .428
                ],
                91: [
                    .74,
                    .13,
                    .257
                ],
                93: [
                    .738,
                    .132,
                    .257
                ],
                94: [
                    .734,
                    -0.452,
                    .59
                ],
                8216: [
                    .708,
                    -0.411,
                    .254
                ],
                8217: [
                    .692,
                    -0.394,
                    .254
                ],
                8260: [
                    .721,
                    .182,
                    .593
                ],
                58113: [
                    .63,
                    .027,
                    .587
                ],
                58114: [
                    .693,
                    .212,
                    .394,
                    {
                        ic: .014
                    }
                ],
                58115: [
                    .681,
                    .219,
                    .387
                ],
                58116: [
                    .473,
                    .212,
                    .593
                ],
                58117: [
                    .684,
                    .027,
                    .393
                ],
                58120: [
                    .679,
                    .22,
                    .981
                ],
                58121: [
                    .717,
                    .137,
                    .727
                ]
            };
        },
        9587: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.fraktur = void 0, e1.fraktur = {
                33: [
                    .689,
                    .012,
                    .296
                ],
                34: [
                    .695,
                    -0.432,
                    .215
                ],
                38: [
                    .698,
                    .011,
                    .738
                ],
                39: [
                    .695,
                    -0.436,
                    .212
                ],
                40: [
                    .737,
                    .186,
                    .389
                ],
                41: [
                    .735,
                    .187,
                    .389
                ],
                42: [
                    .692,
                    -0.449,
                    .278
                ],
                43: [
                    .598,
                    .082,
                    .756
                ],
                44: [
                    .107,
                    .191,
                    .278
                ],
                45: [
                    .275,
                    -0.236,
                    .756
                ],
                46: [
                    .102,
                    .015,
                    .278
                ],
                47: [
                    .721,
                    .182,
                    .502
                ],
                48: [
                    .492,
                    .013,
                    .502
                ],
                49: [
                    .468,
                    0,
                    .502
                ],
                50: [
                    .474,
                    0,
                    .502
                ],
                51: [
                    .473,
                    .182,
                    .502
                ],
                52: [
                    .476,
                    .191,
                    .502
                ],
                53: [
                    .458,
                    .184,
                    .502
                ],
                54: [
                    .7,
                    .013,
                    .502
                ],
                55: [
                    .468,
                    .181,
                    .502
                ],
                56: [
                    .705,
                    .01,
                    .502
                ],
                57: [
                    .469,
                    .182,
                    .502
                ],
                58: [
                    .457,
                    .012,
                    .216
                ],
                59: [
                    .458,
                    .189,
                    .216
                ],
                61: [
                    .368,
                    -0.132,
                    .756
                ],
                63: [
                    .693,
                    .011,
                    .362
                ],
                91: [
                    .74,
                    .13,
                    .278
                ],
                93: [
                    .738,
                    .131,
                    .278
                ],
                94: [
                    .734,
                    -0.452,
                    .5
                ],
                8216: [
                    .708,
                    -0.41,
                    .215
                ],
                8217: [
                    .692,
                    -0.395,
                    .215
                ],
                8260: [
                    .721,
                    .182,
                    .502
                ],
                58112: [
                    .683,
                    .032,
                    .497
                ],
                58113: [
                    .616,
                    .03,
                    .498
                ],
                58114: [
                    .68,
                    .215,
                    .333
                ],
                58115: [
                    .679,
                    .224,
                    .329
                ],
                58116: [
                    .471,
                    .214,
                    .503
                ],
                58117: [
                    .686,
                    .02,
                    .333
                ],
                58118: [
                    .577,
                    .021,
                    .334,
                    {
                        ic: .013
                    }
                ],
                58119: [
                    .475,
                    .022,
                    .501,
                    {
                        ic: .013
                    }
                ]
            };
        },
        8348: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.italic = void 0, e1.italic = {
                33: [
                    .716,
                    0,
                    .307,
                    {
                        ic: .073
                    }
                ],
                34: [
                    .694,
                    -0.379,
                    .514,
                    {
                        ic: .024
                    }
                ],
                35: [
                    .694,
                    .194,
                    .818,
                    {
                        ic: .01
                    }
                ],
                37: [
                    .75,
                    .056,
                    .818,
                    {
                        ic: .029
                    }
                ],
                38: [
                    .716,
                    .022,
                    .767,
                    {
                        ic: .035
                    }
                ],
                39: [
                    .694,
                    -0.379,
                    .307,
                    {
                        ic: .07
                    }
                ],
                40: [
                    .75,
                    .25,
                    .409,
                    {
                        ic: .108
                    }
                ],
                41: [
                    .75,
                    .25,
                    .409
                ],
                42: [
                    .75,
                    -0.32,
                    .511,
                    {
                        ic: .073
                    }
                ],
                43: [
                    .557,
                    .057,
                    .767
                ],
                44: [
                    .121,
                    .194,
                    .307
                ],
                45: [
                    .251,
                    -0.18,
                    .358
                ],
                46: [
                    .121,
                    0,
                    .307
                ],
                47: [
                    .716,
                    .215,
                    .778
                ],
                48: [
                    .665,
                    .021,
                    .511,
                    {
                        ic: .051
                    }
                ],
                49: [
                    .666,
                    0,
                    .511
                ],
                50: [
                    .666,
                    .022,
                    .511,
                    {
                        ic: .04
                    }
                ],
                51: [
                    .666,
                    .022,
                    .511,
                    {
                        ic: .051
                    }
                ],
                52: [
                    .666,
                    .194,
                    .511
                ],
                53: [
                    .666,
                    .022,
                    .511,
                    {
                        ic: .056
                    }
                ],
                54: [
                    .665,
                    .022,
                    .511,
                    {
                        ic: .054
                    }
                ],
                55: [
                    .666,
                    .022,
                    .511,
                    {
                        ic: .123
                    }
                ],
                56: [
                    .666,
                    .021,
                    .511,
                    {
                        ic: .042
                    }
                ],
                57: [
                    .666,
                    .022,
                    .511,
                    {
                        ic: .042
                    }
                ],
                58: [
                    .431,
                    0,
                    .307
                ],
                59: [
                    .431,
                    .194,
                    .307
                ],
                61: [
                    .367,
                    -0.133,
                    .767
                ],
                63: [
                    .716,
                    0,
                    .511,
                    {
                        ic: .04
                    }
                ],
                64: [
                    .705,
                    .011,
                    .767,
                    {
                        ic: .022
                    }
                ],
                91: [
                    .75,
                    .25,
                    .307,
                    {
                        ic: .139
                    }
                ],
                93: [
                    .75,
                    .25,
                    .307,
                    {
                        ic: .052
                    }
                ],
                94: [
                    .694,
                    -0.527,
                    .511,
                    {
                        ic: .017
                    }
                ],
                95: [
                    -0.025,
                    .062,
                    .511,
                    {
                        ic: .043
                    }
                ],
                126: [
                    .318,
                    -0.208,
                    .511,
                    {
                        ic: .06
                    }
                ],
                305: [
                    .441,
                    .01,
                    .307,
                    {
                        ic: .033
                    }
                ],
                567: [
                    .442,
                    .204,
                    .332
                ],
                768: [
                    .697,
                    -0.5,
                    0
                ],
                769: [
                    .697,
                    -0.5,
                    0,
                    {
                        ic: .039
                    }
                ],
                770: [
                    .694,
                    -0.527,
                    0,
                    {
                        ic: .017
                    }
                ],
                771: [
                    .668,
                    -0.558,
                    0,
                    {
                        ic: .06
                    }
                ],
                772: [
                    .589,
                    -0.544,
                    0,
                    {
                        ic: .054
                    }
                ],
                774: [
                    .694,
                    -0.515,
                    0,
                    {
                        ic: .062
                    }
                ],
                775: [
                    .669,
                    -0.548,
                    0
                ],
                776: [
                    .669,
                    -0.554,
                    0,
                    {
                        ic: .045
                    }
                ],
                778: [
                    .716,
                    -0.542,
                    0
                ],
                779: [
                    .697,
                    -0.503,
                    0,
                    {
                        ic: .065
                    }
                ],
                780: [
                    .638,
                    -0.502,
                    0,
                    {
                        ic: .029
                    }
                ],
                989: [
                    .605,
                    .085,
                    .778
                ],
                8211: [
                    .285,
                    -0.248,
                    .511,
                    {
                        ic: .043
                    }
                ],
                8212: [
                    .285,
                    -0.248,
                    1.022,
                    {
                        ic: .016
                    }
                ],
                8213: [
                    .285,
                    -0.248,
                    1.022,
                    {
                        ic: .016
                    }
                ],
                8215: [
                    -0.025,
                    .062,
                    .511,
                    {
                        ic: .043
                    }
                ],
                8216: [
                    .694,
                    -0.379,
                    .307,
                    {
                        ic: .055
                    }
                ],
                8217: [
                    .694,
                    -0.379,
                    .307,
                    {
                        ic: .07
                    }
                ],
                8220: [
                    .694,
                    -0.379,
                    .514,
                    {
                        ic: .092
                    }
                ],
                8221: [
                    .694,
                    -0.379,
                    .514,
                    {
                        ic: .024
                    }
                ],
                8260: [
                    .716,
                    .215,
                    .778
                ],
                8463: [
                    .695,
                    .013,
                    .54,
                    {
                        ic: .022
                    }
                ],
                8710: [
                    .716,
                    0,
                    .833,
                    {
                        sk: .167
                    }
                ],
                10744: [
                    .716,
                    .215,
                    .778
                ]
            };
        },
        1376: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.largeop = void 0, e1.largeop = {
                40: [
                    1.15,
                    .649,
                    .597
                ],
                41: [
                    1.15,
                    .649,
                    .597
                ],
                47: [
                    1.15,
                    .649,
                    .811
                ],
                91: [
                    1.15,
                    .649,
                    .472
                ],
                92: [
                    1.15,
                    .649,
                    .811
                ],
                93: [
                    1.15,
                    .649,
                    .472
                ],
                123: [
                    1.15,
                    .649,
                    .667
                ],
                125: [
                    1.15,
                    .649,
                    .667
                ],
                710: [
                    .772,
                    -0.565,
                    1
                ],
                732: [
                    .75,
                    -0.611,
                    1
                ],
                770: [
                    .772,
                    -0.565,
                    0
                ],
                771: [
                    .75,
                    -0.611,
                    0
                ],
                8214: [
                    .602,
                    0,
                    .778
                ],
                8260: [
                    1.15,
                    .649,
                    .811
                ],
                8593: [
                    .6,
                    0,
                    .667
                ],
                8595: [
                    .6,
                    0,
                    .667
                ],
                8657: [
                    .599,
                    0,
                    .778
                ],
                8659: [
                    .6,
                    0,
                    .778
                ],
                8719: [
                    .95,
                    .45,
                    1.278
                ],
                8720: [
                    .95,
                    .45,
                    1.278
                ],
                8721: [
                    .95,
                    .45,
                    1.444
                ],
                8730: [
                    1.15,
                    .65,
                    1,
                    {
                        ic: .02
                    }
                ],
                8739: [
                    .627,
                    .015,
                    .333
                ],
                8741: [
                    .627,
                    .015,
                    .556
                ],
                8747: [
                    1.36,
                    .862,
                    .556,
                    {
                        ic: .388
                    }
                ],
                8748: [
                    1.36,
                    .862,
                    1.084,
                    {
                        ic: .388
                    }
                ],
                8749: [
                    1.36,
                    .862,
                    1.592,
                    {
                        ic: .388
                    }
                ],
                8750: [
                    1.36,
                    .862,
                    .556,
                    {
                        ic: .388
                    }
                ],
                8896: [
                    .95,
                    .45,
                    1.111
                ],
                8897: [
                    .95,
                    .45,
                    1.111
                ],
                8898: [
                    .949,
                    .45,
                    1.111
                ],
                8899: [
                    .95,
                    .449,
                    1.111
                ],
                8968: [
                    1.15,
                    .649,
                    .528
                ],
                8969: [
                    1.15,
                    .649,
                    .528
                ],
                8970: [
                    1.15,
                    .649,
                    .528
                ],
                8971: [
                    1.15,
                    .649,
                    .528
                ],
                9001: [
                    1.15,
                    .649,
                    .611
                ],
                9002: [
                    1.15,
                    .649,
                    .611
                ],
                9168: [
                    .602,
                    0,
                    .667
                ],
                10072: [
                    .627,
                    .015,
                    .333
                ],
                10216: [
                    1.15,
                    .649,
                    .611
                ],
                10217: [
                    1.15,
                    .649,
                    .611
                ],
                10752: [
                    .949,
                    .449,
                    1.511
                ],
                10753: [
                    .949,
                    .449,
                    1.511
                ],
                10754: [
                    .949,
                    .449,
                    1.511
                ],
                10756: [
                    .95,
                    .449,
                    1.111
                ],
                10758: [
                    .95,
                    .45,
                    1.111
                ],
                10764: [
                    1.36,
                    .862,
                    2.168,
                    {
                        ic: .388
                    }
                ],
                12296: [
                    1.15,
                    .649,
                    .611
                ],
                12297: [
                    1.15,
                    .649,
                    .611
                ]
            };
        },
        1439: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.monospace = void 0, e1.monospace = {
                32: [
                    0,
                    0,
                    .525
                ],
                33: [
                    .622,
                    0,
                    .525
                ],
                34: [
                    .623,
                    -0.333,
                    .525
                ],
                35: [
                    .611,
                    0,
                    .525
                ],
                36: [
                    .694,
                    .082,
                    .525
                ],
                37: [
                    .694,
                    .083,
                    .525
                ],
                38: [
                    .622,
                    .011,
                    .525
                ],
                39: [
                    .611,
                    -0.287,
                    .525
                ],
                40: [
                    .694,
                    .082,
                    .525
                ],
                41: [
                    .694,
                    .082,
                    .525
                ],
                42: [
                    .52,
                    -0.09,
                    .525
                ],
                43: [
                    .531,
                    -0.081,
                    .525
                ],
                44: [
                    .14,
                    .139,
                    .525
                ],
                45: [
                    .341,
                    -0.271,
                    .525
                ],
                46: [
                    .14,
                    0,
                    .525
                ],
                47: [
                    .694,
                    .083,
                    .525
                ],
                58: [
                    .431,
                    0,
                    .525
                ],
                59: [
                    .431,
                    .139,
                    .525
                ],
                60: [
                    .557,
                    -0.055,
                    .525
                ],
                61: [
                    .417,
                    -0.195,
                    .525
                ],
                62: [
                    .557,
                    -0.055,
                    .525
                ],
                63: [
                    .617,
                    0,
                    .525
                ],
                64: [
                    .617,
                    .006,
                    .525
                ],
                91: [
                    .694,
                    .082,
                    .525
                ],
                92: [
                    .694,
                    .083,
                    .525
                ],
                93: [
                    .694,
                    .082,
                    .525
                ],
                94: [
                    .611,
                    -0.46,
                    .525
                ],
                95: [
                    -0.025,
                    .095,
                    .525
                ],
                96: [
                    .681,
                    -0.357,
                    .525
                ],
                123: [
                    .694,
                    .083,
                    .525
                ],
                124: [
                    .694,
                    .082,
                    .525
                ],
                125: [
                    .694,
                    .083,
                    .525
                ],
                126: [
                    .611,
                    -0.466,
                    .525
                ],
                127: [
                    .612,
                    -0.519,
                    .525
                ],
                160: [
                    0,
                    0,
                    .525
                ],
                305: [
                    .431,
                    0,
                    .525
                ],
                567: [
                    .431,
                    .228,
                    .525
                ],
                697: [
                    .623,
                    -0.334,
                    .525
                ],
                768: [
                    .611,
                    -0.485,
                    0
                ],
                769: [
                    .611,
                    -0.485,
                    0
                ],
                770: [
                    .611,
                    -0.46,
                    0
                ],
                771: [
                    .611,
                    -0.466,
                    0
                ],
                772: [
                    .577,
                    -0.5,
                    0
                ],
                774: [
                    .611,
                    -0.504,
                    0
                ],
                776: [
                    .612,
                    -0.519,
                    0
                ],
                778: [
                    .619,
                    -0.499,
                    0
                ],
                780: [
                    .577,
                    -0.449,
                    0
                ],
                913: [
                    .623,
                    0,
                    .525
                ],
                914: [
                    .611,
                    0,
                    .525
                ],
                915: [
                    .611,
                    0,
                    .525
                ],
                916: [
                    .623,
                    0,
                    .525
                ],
                917: [
                    .611,
                    0,
                    .525
                ],
                918: [
                    .611,
                    0,
                    .525
                ],
                919: [
                    .611,
                    0,
                    .525
                ],
                920: [
                    .621,
                    .01,
                    .525
                ],
                921: [
                    .611,
                    0,
                    .525
                ],
                922: [
                    .611,
                    0,
                    .525
                ],
                923: [
                    .623,
                    0,
                    .525
                ],
                924: [
                    .611,
                    0,
                    .525
                ],
                925: [
                    .611,
                    0,
                    .525
                ],
                926: [
                    .611,
                    0,
                    .525
                ],
                927: [
                    .621,
                    .01,
                    .525
                ],
                928: [
                    .611,
                    0,
                    .525
                ],
                929: [
                    .611,
                    0,
                    .525
                ],
                931: [
                    .611,
                    0,
                    .525
                ],
                932: [
                    .611,
                    0,
                    .525
                ],
                933: [
                    .622,
                    0,
                    .525
                ],
                934: [
                    .611,
                    0,
                    .525
                ],
                935: [
                    .611,
                    0,
                    .525
                ],
                936: [
                    .611,
                    0,
                    .525
                ],
                937: [
                    .622,
                    0,
                    .525
                ],
                8215: [
                    -0.025,
                    .095,
                    .525
                ],
                8242: [
                    .623,
                    -0.334,
                    .525
                ],
                8243: [
                    .623,
                    0,
                    1.05
                ],
                8244: [
                    .623,
                    0,
                    1.575
                ],
                8260: [
                    .694,
                    .083,
                    .525
                ],
                8279: [
                    .623,
                    0,
                    2.1
                ],
                8710: [
                    .623,
                    0,
                    .525
                ]
            };
        },
        331: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.normal = void 0, e1.normal = {
                32: [
                    0,
                    0,
                    .25
                ],
                33: [
                    .716,
                    0,
                    .278
                ],
                34: [
                    .694,
                    -0.379,
                    .5
                ],
                35: [
                    .694,
                    .194,
                    .833
                ],
                36: [
                    .75,
                    .056,
                    .5
                ],
                37: [
                    .75,
                    .056,
                    .833
                ],
                38: [
                    .716,
                    .022,
                    .778
                ],
                39: [
                    .694,
                    -0.379,
                    .278
                ],
                40: [
                    .75,
                    .25,
                    .389
                ],
                41: [
                    .75,
                    .25,
                    .389
                ],
                42: [
                    .75,
                    -0.32,
                    .5
                ],
                43: [
                    .583,
                    .082,
                    .778
                ],
                44: [
                    .121,
                    .194,
                    .278
                ],
                45: [
                    .252,
                    -0.179,
                    .333
                ],
                46: [
                    .12,
                    0,
                    .278
                ],
                47: [
                    .75,
                    .25,
                    .5
                ],
                48: [
                    .666,
                    .022,
                    .5
                ],
                49: [
                    .666,
                    0,
                    .5
                ],
                50: [
                    .666,
                    0,
                    .5
                ],
                51: [
                    .665,
                    .022,
                    .5
                ],
                52: [
                    .677,
                    0,
                    .5
                ],
                53: [
                    .666,
                    .022,
                    .5
                ],
                54: [
                    .666,
                    .022,
                    .5
                ],
                55: [
                    .676,
                    .022,
                    .5
                ],
                56: [
                    .666,
                    .022,
                    .5
                ],
                57: [
                    .666,
                    .022,
                    .5
                ],
                58: [
                    .43,
                    0,
                    .278
                ],
                59: [
                    .43,
                    .194,
                    .278
                ],
                60: [
                    .54,
                    .04,
                    .778
                ],
                61: [
                    .583,
                    .082,
                    .778
                ],
                62: [
                    .54,
                    .04,
                    .778
                ],
                63: [
                    .705,
                    0,
                    .472
                ],
                64: [
                    .705,
                    .011,
                    .778
                ],
                65: [
                    .716,
                    0,
                    .75
                ],
                66: [
                    .683,
                    0,
                    .708
                ],
                67: [
                    .705,
                    .021,
                    .722
                ],
                68: [
                    .683,
                    0,
                    .764
                ],
                69: [
                    .68,
                    0,
                    .681
                ],
                70: [
                    .68,
                    0,
                    .653
                ],
                71: [
                    .705,
                    .022,
                    .785
                ],
                72: [
                    .683,
                    0,
                    .75
                ],
                73: [
                    .683,
                    0,
                    .361
                ],
                74: [
                    .683,
                    .022,
                    .514
                ],
                75: [
                    .683,
                    0,
                    .778
                ],
                76: [
                    .683,
                    0,
                    .625
                ],
                77: [
                    .683,
                    0,
                    .917
                ],
                78: [
                    .683,
                    0,
                    .75
                ],
                79: [
                    .705,
                    .022,
                    .778
                ],
                80: [
                    .683,
                    0,
                    .681
                ],
                81: [
                    .705,
                    .193,
                    .778
                ],
                82: [
                    .683,
                    .022,
                    .736
                ],
                83: [
                    .705,
                    .022,
                    .556
                ],
                84: [
                    .677,
                    0,
                    .722
                ],
                85: [
                    .683,
                    .022,
                    .75
                ],
                86: [
                    .683,
                    .022,
                    .75
                ],
                87: [
                    .683,
                    .022,
                    1.028
                ],
                88: [
                    .683,
                    0,
                    .75
                ],
                89: [
                    .683,
                    0,
                    .75
                ],
                90: [
                    .683,
                    0,
                    .611
                ],
                91: [
                    .75,
                    .25,
                    .278
                ],
                92: [
                    .75,
                    .25,
                    .5
                ],
                93: [
                    .75,
                    .25,
                    .278
                ],
                94: [
                    .694,
                    -0.531,
                    .5
                ],
                95: [
                    -0.025,
                    .062,
                    .5
                ],
                96: [
                    .699,
                    -0.505,
                    .5
                ],
                97: [
                    .448,
                    .011,
                    .5
                ],
                98: [
                    .694,
                    .011,
                    .556
                ],
                99: [
                    .448,
                    .011,
                    .444
                ],
                100: [
                    .694,
                    .011,
                    .556
                ],
                101: [
                    .448,
                    .011,
                    .444
                ],
                102: [
                    .705,
                    0,
                    .306,
                    {
                        ic: .066
                    }
                ],
                103: [
                    .453,
                    .206,
                    .5
                ],
                104: [
                    .694,
                    0,
                    .556
                ],
                105: [
                    .669,
                    0,
                    .278
                ],
                106: [
                    .669,
                    .205,
                    .306
                ],
                107: [
                    .694,
                    0,
                    .528
                ],
                108: [
                    .694,
                    0,
                    .278
                ],
                109: [
                    .442,
                    0,
                    .833
                ],
                110: [
                    .442,
                    0,
                    .556
                ],
                111: [
                    .448,
                    .01,
                    .5
                ],
                112: [
                    .442,
                    .194,
                    .556
                ],
                113: [
                    .442,
                    .194,
                    .528
                ],
                114: [
                    .442,
                    0,
                    .392
                ],
                115: [
                    .448,
                    .011,
                    .394
                ],
                116: [
                    .615,
                    .01,
                    .389
                ],
                117: [
                    .442,
                    .011,
                    .556
                ],
                118: [
                    .431,
                    .011,
                    .528
                ],
                119: [
                    .431,
                    .011,
                    .722
                ],
                120: [
                    .431,
                    0,
                    .528
                ],
                121: [
                    .431,
                    .204,
                    .528
                ],
                122: [
                    .431,
                    0,
                    .444
                ],
                123: [
                    .75,
                    .25,
                    .5
                ],
                124: [
                    .75,
                    .249,
                    .278
                ],
                125: [
                    .75,
                    .25,
                    .5
                ],
                126: [
                    .318,
                    -0.215,
                    .5
                ],
                160: [
                    0,
                    0,
                    .25
                ],
                163: [
                    .714,
                    .011,
                    .769
                ],
                165: [
                    .683,
                    0,
                    .75
                ],
                168: [
                    .669,
                    -0.554,
                    .5
                ],
                172: [
                    .356,
                    -0.089,
                    .667
                ],
                174: [
                    .709,
                    .175,
                    .947
                ],
                175: [
                    .59,
                    -0.544,
                    .5
                ],
                176: [
                    .715,
                    -0.542,
                    .5
                ],
                177: [
                    .666,
                    0,
                    .778
                ],
                180: [
                    .699,
                    -0.505,
                    .5
                ],
                183: [
                    .31,
                    -0.19,
                    .278
                ],
                215: [
                    .491,
                    -0.009,
                    .778
                ],
                240: [
                    .749,
                    .021,
                    .556
                ],
                247: [
                    .537,
                    .036,
                    .778
                ],
                305: [
                    .442,
                    0,
                    .278,
                    {
                        sk: .0278
                    }
                ],
                567: [
                    .442,
                    .205,
                    .306,
                    {
                        sk: .0833
                    }
                ],
                697: [
                    .56,
                    -0.043,
                    .275
                ],
                710: [
                    .694,
                    -0.531,
                    .5
                ],
                711: [
                    .644,
                    -0.513,
                    .5
                ],
                713: [
                    .59,
                    -0.544,
                    .5
                ],
                714: [
                    .699,
                    -0.505,
                    .5
                ],
                715: [
                    .699,
                    -0.505,
                    .5
                ],
                728: [
                    .694,
                    -0.515,
                    .5
                ],
                729: [
                    .669,
                    -0.549,
                    .5
                ],
                730: [
                    .715,
                    -0.542,
                    .5
                ],
                732: [
                    .668,
                    -0.565,
                    .5
                ],
                768: [
                    .699,
                    -0.505,
                    0
                ],
                769: [
                    .699,
                    -0.505,
                    0
                ],
                770: [
                    .694,
                    -0.531,
                    0
                ],
                771: [
                    .668,
                    -0.565,
                    0
                ],
                772: [
                    .59,
                    -0.544,
                    0
                ],
                774: [
                    .694,
                    -0.515,
                    0
                ],
                775: [
                    .669,
                    -0.549,
                    0
                ],
                776: [
                    .669,
                    -0.554,
                    0
                ],
                778: [
                    .715,
                    -0.542,
                    0
                ],
                779: [
                    .701,
                    -0.51,
                    0
                ],
                780: [
                    .644,
                    -0.513,
                    0
                ],
                824: [
                    .716,
                    .215,
                    0
                ],
                913: [
                    .716,
                    0,
                    .75
                ],
                914: [
                    .683,
                    0,
                    .708
                ],
                915: [
                    .68,
                    0,
                    .625
                ],
                916: [
                    .716,
                    0,
                    .833
                ],
                917: [
                    .68,
                    0,
                    .681
                ],
                918: [
                    .683,
                    0,
                    .611
                ],
                919: [
                    .683,
                    0,
                    .75
                ],
                920: [
                    .705,
                    .022,
                    .778
                ],
                921: [
                    .683,
                    0,
                    .361
                ],
                922: [
                    .683,
                    0,
                    .778
                ],
                923: [
                    .716,
                    0,
                    .694
                ],
                924: [
                    .683,
                    0,
                    .917
                ],
                925: [
                    .683,
                    0,
                    .75
                ],
                926: [
                    .677,
                    0,
                    .667
                ],
                927: [
                    .705,
                    .022,
                    .778
                ],
                928: [
                    .68,
                    0,
                    .75
                ],
                929: [
                    .683,
                    0,
                    .681
                ],
                931: [
                    .683,
                    0,
                    .722
                ],
                932: [
                    .677,
                    0,
                    .722
                ],
                933: [
                    .705,
                    0,
                    .778
                ],
                934: [
                    .683,
                    0,
                    .722
                ],
                935: [
                    .683,
                    0,
                    .75
                ],
                936: [
                    .683,
                    0,
                    .778
                ],
                937: [
                    .704,
                    0,
                    .722
                ],
                8192: [
                    0,
                    0,
                    .5
                ],
                8193: [
                    0,
                    0,
                    1
                ],
                8194: [
                    0,
                    0,
                    .5
                ],
                8195: [
                    0,
                    0,
                    1
                ],
                8196: [
                    0,
                    0,
                    .333
                ],
                8197: [
                    0,
                    0,
                    .25
                ],
                8198: [
                    0,
                    0,
                    .167
                ],
                8201: [
                    0,
                    0,
                    .167
                ],
                8202: [
                    0,
                    0,
                    .1
                ],
                8203: [
                    0,
                    0,
                    0
                ],
                8204: [
                    0,
                    0,
                    0
                ],
                8211: [
                    .285,
                    -0.248,
                    .5
                ],
                8212: [
                    .285,
                    -0.248,
                    1
                ],
                8213: [
                    .285,
                    -0.248,
                    1
                ],
                8214: [
                    .75,
                    .25,
                    .5
                ],
                8215: [
                    -0.025,
                    .062,
                    .5
                ],
                8216: [
                    .694,
                    -0.379,
                    .278
                ],
                8217: [
                    .694,
                    -0.379,
                    .278
                ],
                8220: [
                    .694,
                    -0.379,
                    .5
                ],
                8221: [
                    .694,
                    -0.379,
                    .5
                ],
                8224: [
                    .705,
                    .216,
                    .444
                ],
                8225: [
                    .705,
                    .205,
                    .444
                ],
                8226: [
                    .444,
                    -0.055,
                    .5
                ],
                8230: [
                    .12,
                    0,
                    1.172
                ],
                8242: [
                    .56,
                    -0.043,
                    .275
                ],
                8243: [
                    .56,
                    0,
                    .55
                ],
                8244: [
                    .56,
                    0,
                    .825
                ],
                8245: [
                    .56,
                    -0.043,
                    .275
                ],
                8246: [
                    .56,
                    0,
                    .55
                ],
                8247: [
                    .56,
                    0,
                    .825
                ],
                8254: [
                    .59,
                    -0.544,
                    .5
                ],
                8260: [
                    .75,
                    .25,
                    .5
                ],
                8279: [
                    .56,
                    0,
                    1.1
                ],
                8288: [
                    0,
                    0,
                    0
                ],
                8289: [
                    0,
                    0,
                    0
                ],
                8290: [
                    0,
                    0,
                    0
                ],
                8291: [
                    0,
                    0,
                    0
                ],
                8292: [
                    0,
                    0,
                    0
                ],
                8407: [
                    .714,
                    -0.516,
                    .5
                ],
                8450: [
                    .702,
                    .019,
                    .722
                ],
                8459: [
                    .717,
                    .036,
                    .969,
                    {
                        ic: .272,
                        sk: .333
                    }
                ],
                8460: [
                    .666,
                    .133,
                    .72
                ],
                8461: [
                    .683,
                    0,
                    .778
                ],
                8462: [
                    .694,
                    .011,
                    .576,
                    {
                        sk: -0.0278
                    }
                ],
                8463: [
                    .695,
                    .013,
                    .54,
                    {
                        ic: .022
                    }
                ],
                8464: [
                    .717,
                    .017,
                    .809,
                    {
                        ic: .137,
                        sk: .333
                    }
                ],
                8465: [
                    .686,
                    .026,
                    .554
                ],
                8466: [
                    .717,
                    .017,
                    .874,
                    {
                        ic: .161,
                        sk: .306
                    }
                ],
                8467: [
                    .705,
                    .02,
                    .417,
                    {
                        sk: .111
                    }
                ],
                8469: [
                    .683,
                    .02,
                    .722
                ],
                8472: [
                    .453,
                    .216,
                    .636,
                    {
                        sk: .111
                    }
                ],
                8473: [
                    .683,
                    0,
                    .611
                ],
                8474: [
                    .701,
                    .181,
                    .778
                ],
                8475: [
                    .717,
                    .017,
                    .85,
                    {
                        ic: .037,
                        sk: .194
                    }
                ],
                8476: [
                    .686,
                    .026,
                    .828
                ],
                8477: [
                    .683,
                    0,
                    .722
                ],
                8484: [
                    .683,
                    0,
                    .667
                ],
                8486: [
                    .704,
                    0,
                    .722
                ],
                8487: [
                    .684,
                    .022,
                    .722
                ],
                8488: [
                    .729,
                    .139,
                    .602
                ],
                8492: [
                    .708,
                    .028,
                    .908,
                    {
                        ic: .02,
                        sk: .194
                    }
                ],
                8493: [
                    .685,
                    .024,
                    .613
                ],
                8496: [
                    .707,
                    .008,
                    .562,
                    {
                        ic: .156,
                        sk: .139
                    }
                ],
                8497: [
                    .735,
                    .036,
                    .895,
                    {
                        ic: .095,
                        sk: .222
                    }
                ],
                8498: [
                    .695,
                    0,
                    .556
                ],
                8499: [
                    .721,
                    .05,
                    1.08,
                    {
                        ic: .136,
                        sk: .444
                    }
                ],
                8501: [
                    .694,
                    0,
                    .611
                ],
                8502: [
                    .763,
                    .021,
                    .667,
                    {
                        ic: .02
                    }
                ],
                8503: [
                    .764,
                    .043,
                    .444
                ],
                8504: [
                    .764,
                    .043,
                    .667
                ],
                8513: [
                    .705,
                    .023,
                    .639
                ],
                8592: [
                    .511,
                    .011,
                    1
                ],
                8593: [
                    .694,
                    .193,
                    .5
                ],
                8594: [
                    .511,
                    .011,
                    1
                ],
                8595: [
                    .694,
                    .194,
                    .5
                ],
                8596: [
                    .511,
                    .011,
                    1
                ],
                8597: [
                    .772,
                    .272,
                    .5
                ],
                8598: [
                    .72,
                    .195,
                    1
                ],
                8599: [
                    .72,
                    .195,
                    1
                ],
                8600: [
                    .695,
                    .22,
                    1
                ],
                8601: [
                    .695,
                    .22,
                    1
                ],
                8602: [
                    .437,
                    -0.06,
                    1
                ],
                8603: [
                    .437,
                    -0.06,
                    1
                ],
                8606: [
                    .417,
                    -0.083,
                    1
                ],
                8608: [
                    .417,
                    -0.083,
                    1
                ],
                8610: [
                    .417,
                    -0.083,
                    1.111
                ],
                8611: [
                    .417,
                    -0.083,
                    1.111
                ],
                8614: [
                    .511,
                    .011,
                    1
                ],
                8617: [
                    .511,
                    .011,
                    1.126
                ],
                8618: [
                    .511,
                    .011,
                    1.126
                ],
                8619: [
                    .575,
                    .041,
                    1
                ],
                8620: [
                    .575,
                    .041,
                    1
                ],
                8621: [
                    .417,
                    -0.083,
                    1.389
                ],
                8622: [
                    .437,
                    -0.06,
                    1
                ],
                8624: [
                    .722,
                    0,
                    .5
                ],
                8625: [
                    .722,
                    0,
                    .5
                ],
                8630: [
                    .461,
                    0,
                    1
                ],
                8631: [
                    .46,
                    0,
                    1
                ],
                8634: [
                    .65,
                    .083,
                    .778
                ],
                8635: [
                    .65,
                    .083,
                    .778
                ],
                8636: [
                    .511,
                    -0.23,
                    1
                ],
                8637: [
                    .27,
                    .011,
                    1
                ],
                8638: [
                    .694,
                    .194,
                    .417
                ],
                8639: [
                    .694,
                    .194,
                    .417
                ],
                8640: [
                    .511,
                    -0.23,
                    1
                ],
                8641: [
                    .27,
                    .011,
                    1
                ],
                8642: [
                    .694,
                    .194,
                    .417
                ],
                8643: [
                    .694,
                    .194,
                    .417
                ],
                8644: [
                    .667,
                    0,
                    1
                ],
                8646: [
                    .667,
                    0,
                    1
                ],
                8647: [
                    .583,
                    .083,
                    1
                ],
                8648: [
                    .694,
                    .193,
                    .833
                ],
                8649: [
                    .583,
                    .083,
                    1
                ],
                8650: [
                    .694,
                    .194,
                    .833
                ],
                8651: [
                    .514,
                    .014,
                    1
                ],
                8652: [
                    .671,
                    .011,
                    1
                ],
                8653: [
                    .534,
                    .035,
                    1
                ],
                8654: [
                    .534,
                    .037,
                    1
                ],
                8655: [
                    .534,
                    .035,
                    1
                ],
                8656: [
                    .525,
                    .024,
                    1
                ],
                8657: [
                    .694,
                    .194,
                    .611
                ],
                8658: [
                    .525,
                    .024,
                    1
                ],
                8659: [
                    .694,
                    .194,
                    .611
                ],
                8660: [
                    .526,
                    .025,
                    1
                ],
                8661: [
                    .772,
                    .272,
                    .611
                ],
                8666: [
                    .611,
                    .111,
                    1
                ],
                8667: [
                    .611,
                    .111,
                    1
                ],
                8669: [
                    .417,
                    -0.083,
                    1
                ],
                8672: [
                    .437,
                    -0.064,
                    1.334
                ],
                8674: [
                    .437,
                    -0.064,
                    1.334
                ],
                8704: [
                    .694,
                    .022,
                    .556
                ],
                8705: [
                    .846,
                    .021,
                    .5
                ],
                8706: [
                    .715,
                    .022,
                    .531,
                    {
                        ic: .035,
                        sk: .0833
                    }
                ],
                8707: [
                    .694,
                    0,
                    .556
                ],
                8708: [
                    .716,
                    .215,
                    .556
                ],
                8709: [
                    .772,
                    .078,
                    .5
                ],
                8710: [
                    .716,
                    0,
                    .833
                ],
                8711: [
                    .683,
                    .033,
                    .833
                ],
                8712: [
                    .54,
                    .04,
                    .667
                ],
                8713: [
                    .716,
                    .215,
                    .667
                ],
                8715: [
                    .54,
                    .04,
                    .667
                ],
                8716: [
                    .716,
                    .215,
                    .667
                ],
                8717: [
                    .44,
                    0,
                    .429,
                    {
                        ic: .027
                    }
                ],
                8719: [
                    .75,
                    .25,
                    .944
                ],
                8720: [
                    .75,
                    .25,
                    .944
                ],
                8721: [
                    .75,
                    .25,
                    1.056
                ],
                8722: [
                    .583,
                    .082,
                    .778
                ],
                8723: [
                    .5,
                    .166,
                    .778
                ],
                8724: [
                    .766,
                    .093,
                    .778
                ],
                8725: [
                    .75,
                    .25,
                    .5
                ],
                8726: [
                    .75,
                    .25,
                    .5
                ],
                8727: [
                    .465,
                    -0.035,
                    .5
                ],
                8728: [
                    .444,
                    -0.055,
                    .5
                ],
                8729: [
                    .444,
                    -0.055,
                    .5
                ],
                8730: [
                    .8,
                    .2,
                    .833,
                    {
                        ic: .02
                    }
                ],
                8733: [
                    .442,
                    .011,
                    .778
                ],
                8734: [
                    .442,
                    .011,
                    1
                ],
                8736: [
                    .694,
                    0,
                    .722
                ],
                8737: [
                    .714,
                    .02,
                    .722
                ],
                8738: [
                    .551,
                    .051,
                    .722
                ],
                8739: [
                    .75,
                    .249,
                    .278
                ],
                8740: [
                    .75,
                    .252,
                    .278,
                    {
                        ic: .019
                    }
                ],
                8741: [
                    .75,
                    .25,
                    .5
                ],
                8742: [
                    .75,
                    .25,
                    .5,
                    {
                        ic: .018
                    }
                ],
                8743: [
                    .598,
                    .022,
                    .667
                ],
                8744: [
                    .598,
                    .022,
                    .667
                ],
                8745: [
                    .598,
                    .022,
                    .667
                ],
                8746: [
                    .598,
                    .022,
                    .667
                ],
                8747: [
                    .716,
                    .216,
                    .417,
                    {
                        ic: .055
                    }
                ],
                8748: [
                    .805,
                    .306,
                    .819,
                    {
                        ic: .138
                    }
                ],
                8749: [
                    .805,
                    .306,
                    1.166,
                    {
                        ic: .138
                    }
                ],
                8750: [
                    .805,
                    .306,
                    .472,
                    {
                        ic: .138
                    }
                ],
                8756: [
                    .471,
                    .082,
                    .667
                ],
                8757: [
                    .471,
                    .082,
                    .667
                ],
                8764: [
                    .367,
                    -0.133,
                    .778
                ],
                8765: [
                    .367,
                    -0.133,
                    .778
                ],
                8768: [
                    .583,
                    .083,
                    .278
                ],
                8769: [
                    .467,
                    -0.032,
                    .778
                ],
                8770: [
                    .463,
                    -0.034,
                    .778
                ],
                8771: [
                    .464,
                    -0.036,
                    .778
                ],
                8772: [
                    .716,
                    .215,
                    .778
                ],
                8773: [
                    .589,
                    -0.022,
                    .778
                ],
                8775: [
                    .652,
                    .155,
                    .778
                ],
                8776: [
                    .483,
                    -0.055,
                    .778
                ],
                8777: [
                    .716,
                    .215,
                    .778
                ],
                8778: [
                    .579,
                    .039,
                    .778
                ],
                8781: [
                    .484,
                    -0.016,
                    .778
                ],
                8782: [
                    .492,
                    -0.008,
                    .778
                ],
                8783: [
                    .492,
                    -0.133,
                    .778
                ],
                8784: [
                    .67,
                    -0.133,
                    .778
                ],
                8785: [
                    .609,
                    .108,
                    .778
                ],
                8786: [
                    .601,
                    .101,
                    .778
                ],
                8787: [
                    .601,
                    .102,
                    .778
                ],
                8790: [
                    .367,
                    -0.133,
                    .778
                ],
                8791: [
                    .721,
                    -0.133,
                    .778
                ],
                8796: [
                    .859,
                    -0.133,
                    .778
                ],
                8800: [
                    .716,
                    .215,
                    .778
                ],
                8801: [
                    .464,
                    -0.036,
                    .778
                ],
                8802: [
                    .716,
                    .215,
                    .778
                ],
                8804: [
                    .636,
                    .138,
                    .778
                ],
                8805: [
                    .636,
                    .138,
                    .778
                ],
                8806: [
                    .753,
                    .175,
                    .778
                ],
                8807: [
                    .753,
                    .175,
                    .778
                ],
                8808: [
                    .752,
                    .286,
                    .778
                ],
                8809: [
                    .752,
                    .286,
                    .778
                ],
                8810: [
                    .568,
                    .067,
                    1
                ],
                8811: [
                    .567,
                    .067,
                    1
                ],
                8812: [
                    .75,
                    .25,
                    .5
                ],
                8813: [
                    .716,
                    .215,
                    .778
                ],
                8814: [
                    .708,
                    .209,
                    .778
                ],
                8815: [
                    .708,
                    .209,
                    .778
                ],
                8816: [
                    .801,
                    .303,
                    .778
                ],
                8817: [
                    .801,
                    .303,
                    .778
                ],
                8818: [
                    .732,
                    .228,
                    .778
                ],
                8819: [
                    .732,
                    .228,
                    .778
                ],
                8820: [
                    .732,
                    .228,
                    .778
                ],
                8821: [
                    .732,
                    .228,
                    .778
                ],
                8822: [
                    .681,
                    .253,
                    .778
                ],
                8823: [
                    .681,
                    .253,
                    .778
                ],
                8824: [
                    .716,
                    .253,
                    .778
                ],
                8825: [
                    .716,
                    .253,
                    .778
                ],
                8826: [
                    .539,
                    .041,
                    .778
                ],
                8827: [
                    .539,
                    .041,
                    .778
                ],
                8828: [
                    .58,
                    .153,
                    .778
                ],
                8829: [
                    .58,
                    .154,
                    .778
                ],
                8830: [
                    .732,
                    .228,
                    .778
                ],
                8831: [
                    .732,
                    .228,
                    .778
                ],
                8832: [
                    .705,
                    .208,
                    .778
                ],
                8833: [
                    .705,
                    .208,
                    .778
                ],
                8834: [
                    .54,
                    .04,
                    .778
                ],
                8835: [
                    .54,
                    .04,
                    .778
                ],
                8836: [
                    .716,
                    .215,
                    .778
                ],
                8837: [
                    .716,
                    .215,
                    .778
                ],
                8838: [
                    .636,
                    .138,
                    .778
                ],
                8839: [
                    .636,
                    .138,
                    .778
                ],
                8840: [
                    .801,
                    .303,
                    .778
                ],
                8841: [
                    .801,
                    .303,
                    .778
                ],
                8842: [
                    .635,
                    .241,
                    .778
                ],
                8843: [
                    .635,
                    .241,
                    .778
                ],
                8846: [
                    .598,
                    .022,
                    .667
                ],
                8847: [
                    .539,
                    .041,
                    .778
                ],
                8848: [
                    .539,
                    .041,
                    .778
                ],
                8849: [
                    .636,
                    .138,
                    .778
                ],
                8850: [
                    .636,
                    .138,
                    .778
                ],
                8851: [
                    .598,
                    0,
                    .667
                ],
                8852: [
                    .598,
                    0,
                    .667
                ],
                8853: [
                    .583,
                    .083,
                    .778
                ],
                8854: [
                    .583,
                    .083,
                    .778
                ],
                8855: [
                    .583,
                    .083,
                    .778
                ],
                8856: [
                    .583,
                    .083,
                    .778
                ],
                8857: [
                    .583,
                    .083,
                    .778
                ],
                8858: [
                    .582,
                    .082,
                    .778
                ],
                8859: [
                    .582,
                    .082,
                    .778
                ],
                8861: [
                    .582,
                    .082,
                    .778
                ],
                8862: [
                    .689,
                    0,
                    .778
                ],
                8863: [
                    .689,
                    0,
                    .778
                ],
                8864: [
                    .689,
                    0,
                    .778
                ],
                8865: [
                    .689,
                    0,
                    .778
                ],
                8866: [
                    .694,
                    0,
                    .611
                ],
                8867: [
                    .694,
                    0,
                    .611
                ],
                8868: [
                    .668,
                    0,
                    .778
                ],
                8869: [
                    .668,
                    0,
                    .778
                ],
                8872: [
                    .75,
                    .249,
                    .867
                ],
                8873: [
                    .694,
                    0,
                    .722
                ],
                8874: [
                    .694,
                    0,
                    .889
                ],
                8876: [
                    .695,
                    0,
                    .611
                ],
                8877: [
                    .695,
                    0,
                    .611
                ],
                8878: [
                    .695,
                    0,
                    .722
                ],
                8879: [
                    .695,
                    0,
                    .722
                ],
                8882: [
                    .539,
                    .041,
                    .778
                ],
                8883: [
                    .539,
                    .041,
                    .778
                ],
                8884: [
                    .636,
                    .138,
                    .778
                ],
                8885: [
                    .636,
                    .138,
                    .778
                ],
                8888: [
                    .408,
                    -0.092,
                    1.111
                ],
                8890: [
                    .431,
                    .212,
                    .556
                ],
                8891: [
                    .716,
                    0,
                    .611
                ],
                8892: [
                    .716,
                    0,
                    .611
                ],
                8896: [
                    .75,
                    .249,
                    .833
                ],
                8897: [
                    .75,
                    .249,
                    .833
                ],
                8898: [
                    .75,
                    .249,
                    .833
                ],
                8899: [
                    .75,
                    .249,
                    .833
                ],
                8900: [
                    .488,
                    -0.012,
                    .5
                ],
                8901: [
                    .31,
                    -0.19,
                    .278
                ],
                8902: [
                    .486,
                    -0.016,
                    .5
                ],
                8903: [
                    .545,
                    .044,
                    .778
                ],
                8904: [
                    .505,
                    .005,
                    .9
                ],
                8905: [
                    .492,
                    -0.008,
                    .778
                ],
                8906: [
                    .492,
                    -0.008,
                    .778
                ],
                8907: [
                    .694,
                    .022,
                    .778
                ],
                8908: [
                    .694,
                    .022,
                    .778
                ],
                8909: [
                    .464,
                    -0.036,
                    .778
                ],
                8910: [
                    .578,
                    .021,
                    .76
                ],
                8911: [
                    .578,
                    .022,
                    .76
                ],
                8912: [
                    .54,
                    .04,
                    .778
                ],
                8913: [
                    .54,
                    .04,
                    .778
                ],
                8914: [
                    .598,
                    .022,
                    .667
                ],
                8915: [
                    .598,
                    .022,
                    .667
                ],
                8916: [
                    .736,
                    .022,
                    .667
                ],
                8918: [
                    .541,
                    .041,
                    .778
                ],
                8919: [
                    .541,
                    .041,
                    .778
                ],
                8920: [
                    .568,
                    .067,
                    1.333
                ],
                8921: [
                    .568,
                    .067,
                    1.333
                ],
                8922: [
                    .886,
                    .386,
                    .778
                ],
                8923: [
                    .886,
                    .386,
                    .778
                ],
                8926: [
                    .734,
                    0,
                    .778
                ],
                8927: [
                    .734,
                    0,
                    .778
                ],
                8928: [
                    .801,
                    .303,
                    .778
                ],
                8929: [
                    .801,
                    .303,
                    .778
                ],
                8930: [
                    .716,
                    .215,
                    .778
                ],
                8931: [
                    .716,
                    .215,
                    .778
                ],
                8934: [
                    .73,
                    .359,
                    .778
                ],
                8935: [
                    .73,
                    .359,
                    .778
                ],
                8936: [
                    .73,
                    .359,
                    .778
                ],
                8937: [
                    .73,
                    .359,
                    .778
                ],
                8938: [
                    .706,
                    .208,
                    .778
                ],
                8939: [
                    .706,
                    .208,
                    .778
                ],
                8940: [
                    .802,
                    .303,
                    .778
                ],
                8941: [
                    .801,
                    .303,
                    .778
                ],
                8942: [
                    1.3,
                    .03,
                    .278
                ],
                8943: [
                    .31,
                    -0.19,
                    1.172
                ],
                8945: [
                    1.52,
                    -0.1,
                    1.282
                ],
                8965: [
                    .716,
                    0,
                    .611
                ],
                8966: [
                    .813,
                    .097,
                    .611
                ],
                8968: [
                    .75,
                    .25,
                    .444
                ],
                8969: [
                    .75,
                    .25,
                    .444
                ],
                8970: [
                    .75,
                    .25,
                    .444
                ],
                8971: [
                    .75,
                    .25,
                    .444
                ],
                8988: [
                    .694,
                    -0.306,
                    .5
                ],
                8989: [
                    .694,
                    -0.306,
                    .5
                ],
                8990: [
                    .366,
                    .022,
                    .5
                ],
                8991: [
                    .366,
                    .022,
                    .5
                ],
                8994: [
                    .388,
                    -0.122,
                    1
                ],
                8995: [
                    .378,
                    -0.134,
                    1
                ],
                9001: [
                    .75,
                    .25,
                    .389
                ],
                9002: [
                    .75,
                    .25,
                    .389
                ],
                9136: [
                    .744,
                    .244,
                    .412
                ],
                9137: [
                    .744,
                    .244,
                    .412
                ],
                9168: [
                    .602,
                    0,
                    .667
                ],
                9416: [
                    .709,
                    .175,
                    .902
                ],
                9484: [
                    .694,
                    -0.306,
                    .5
                ],
                9488: [
                    .694,
                    -0.306,
                    .5
                ],
                9492: [
                    .366,
                    .022,
                    .5
                ],
                9496: [
                    .366,
                    .022,
                    .5
                ],
                9585: [
                    .694,
                    .195,
                    .889
                ],
                9586: [
                    .694,
                    .195,
                    .889
                ],
                9632: [
                    .689,
                    0,
                    .778
                ],
                9633: [
                    .689,
                    0,
                    .778
                ],
                9642: [
                    .689,
                    0,
                    .778
                ],
                9650: [
                    .575,
                    .02,
                    .722
                ],
                9651: [
                    .716,
                    0,
                    .889
                ],
                9652: [
                    .575,
                    .02,
                    .722
                ],
                9653: [
                    .716,
                    0,
                    .889
                ],
                9654: [
                    .539,
                    .041,
                    .778
                ],
                9656: [
                    .539,
                    .041,
                    .778
                ],
                9657: [
                    .505,
                    .005,
                    .5
                ],
                9660: [
                    .576,
                    .019,
                    .722
                ],
                9661: [
                    .5,
                    .215,
                    .889
                ],
                9662: [
                    .576,
                    .019,
                    .722
                ],
                9663: [
                    .5,
                    .215,
                    .889
                ],
                9664: [
                    .539,
                    .041,
                    .778
                ],
                9666: [
                    .539,
                    .041,
                    .778
                ],
                9667: [
                    .505,
                    .005,
                    .5
                ],
                9674: [
                    .716,
                    .132,
                    .667
                ],
                9711: [
                    .715,
                    .215,
                    1
                ],
                9723: [
                    .689,
                    0,
                    .778
                ],
                9724: [
                    .689,
                    0,
                    .778
                ],
                9733: [
                    .694,
                    .111,
                    .944
                ],
                9824: [
                    .727,
                    .13,
                    .778
                ],
                9825: [
                    .716,
                    .033,
                    .778
                ],
                9826: [
                    .727,
                    .162,
                    .778
                ],
                9827: [
                    .726,
                    .13,
                    .778
                ],
                9837: [
                    .75,
                    .022,
                    .389
                ],
                9838: [
                    .734,
                    .223,
                    .389
                ],
                9839: [
                    .723,
                    .223,
                    .389
                ],
                10003: [
                    .706,
                    .034,
                    .833
                ],
                10016: [
                    .716,
                    .022,
                    .833
                ],
                10072: [
                    .75,
                    .249,
                    .278
                ],
                10216: [
                    .75,
                    .25,
                    .389
                ],
                10217: [
                    .75,
                    .25,
                    .389
                ],
                10222: [
                    .744,
                    .244,
                    .412
                ],
                10223: [
                    .744,
                    .244,
                    .412
                ],
                10229: [
                    .511,
                    .011,
                    1.609
                ],
                10230: [
                    .511,
                    .011,
                    1.638
                ],
                10231: [
                    .511,
                    .011,
                    1.859
                ],
                10232: [
                    .525,
                    .024,
                    1.609
                ],
                10233: [
                    .525,
                    .024,
                    1.638
                ],
                10234: [
                    .525,
                    .024,
                    1.858
                ],
                10236: [
                    .511,
                    .011,
                    1.638
                ],
                10731: [
                    .716,
                    .132,
                    .667
                ],
                10744: [
                    .716,
                    .215,
                    .778
                ],
                10752: [
                    .75,
                    .25,
                    1.111
                ],
                10753: [
                    .75,
                    .25,
                    1.111
                ],
                10754: [
                    .75,
                    .25,
                    1.111
                ],
                10756: [
                    .75,
                    .249,
                    .833
                ],
                10758: [
                    .75,
                    .249,
                    .833
                ],
                10764: [
                    .805,
                    .306,
                    1.638,
                    {
                        ic: .138
                    }
                ],
                10799: [
                    .491,
                    -0.009,
                    .778
                ],
                10815: [
                    .683,
                    0,
                    .75
                ],
                10846: [
                    .813,
                    .097,
                    .611
                ],
                10877: [
                    .636,
                    .138,
                    .778
                ],
                10878: [
                    .636,
                    .138,
                    .778
                ],
                10885: [
                    .762,
                    .29,
                    .778
                ],
                10886: [
                    .762,
                    .29,
                    .778
                ],
                10887: [
                    .635,
                    .241,
                    .778
                ],
                10888: [
                    .635,
                    .241,
                    .778
                ],
                10889: [
                    .761,
                    .387,
                    .778
                ],
                10890: [
                    .761,
                    .387,
                    .778
                ],
                10891: [
                    1.003,
                    .463,
                    .778
                ],
                10892: [
                    1.003,
                    .463,
                    .778
                ],
                10901: [
                    .636,
                    .138,
                    .778
                ],
                10902: [
                    .636,
                    .138,
                    .778
                ],
                10927: [
                    .636,
                    .138,
                    .778
                ],
                10928: [
                    .636,
                    .138,
                    .778
                ],
                10933: [
                    .752,
                    .286,
                    .778
                ],
                10934: [
                    .752,
                    .286,
                    .778
                ],
                10935: [
                    .761,
                    .294,
                    .778
                ],
                10936: [
                    .761,
                    .294,
                    .778
                ],
                10937: [
                    .761,
                    .337,
                    .778
                ],
                10938: [
                    .761,
                    .337,
                    .778
                ],
                10949: [
                    .753,
                    .215,
                    .778
                ],
                10950: [
                    .753,
                    .215,
                    .778
                ],
                10955: [
                    .783,
                    .385,
                    .778
                ],
                10956: [
                    .783,
                    .385,
                    .778
                ],
                12296: [
                    .75,
                    .25,
                    .389
                ],
                12297: [
                    .75,
                    .25,
                    .389
                ],
                57350: [
                    .43,
                    .023,
                    .222,
                    {
                        ic: .018
                    }
                ],
                57351: [
                    .431,
                    .024,
                    .389,
                    {
                        ic: .018
                    }
                ],
                57352: [
                    .605,
                    .085,
                    .778
                ],
                57353: [
                    .434,
                    .006,
                    .667,
                    {
                        ic: .067
                    }
                ],
                57356: [
                    .752,
                    .284,
                    .778
                ],
                57357: [
                    .752,
                    .284,
                    .778
                ],
                57358: [
                    .919,
                    .421,
                    .778
                ],
                57359: [
                    .801,
                    .303,
                    .778
                ],
                57360: [
                    .801,
                    .303,
                    .778
                ],
                57361: [
                    .919,
                    .421,
                    .778
                ],
                57366: [
                    .828,
                    .33,
                    .778
                ],
                57367: [
                    .752,
                    .332,
                    .778
                ],
                57368: [
                    .828,
                    .33,
                    .778
                ],
                57369: [
                    .752,
                    .333,
                    .778
                ],
                57370: [
                    .634,
                    .255,
                    .778
                ],
                57371: [
                    .634,
                    .254,
                    .778
                ],
                119808: [
                    .698,
                    0,
                    .869
                ],
                119809: [
                    .686,
                    0,
                    .818
                ],
                119810: [
                    .697,
                    .011,
                    .831
                ],
                119811: [
                    .686,
                    0,
                    .882
                ],
                119812: [
                    .68,
                    0,
                    .756
                ],
                119813: [
                    .68,
                    0,
                    .724
                ],
                119814: [
                    .697,
                    .01,
                    .904
                ],
                119815: [
                    .686,
                    0,
                    .9
                ],
                119816: [
                    .686,
                    0,
                    .436
                ],
                119817: [
                    .686,
                    .011,
                    .594
                ],
                119818: [
                    .686,
                    0,
                    .901
                ],
                119819: [
                    .686,
                    0,
                    .692
                ],
                119820: [
                    .686,
                    0,
                    1.092
                ],
                119821: [
                    .686,
                    0,
                    .9
                ],
                119822: [
                    .696,
                    .01,
                    .864
                ],
                119823: [
                    .686,
                    0,
                    .786
                ],
                119824: [
                    .696,
                    .193,
                    .864
                ],
                119825: [
                    .686,
                    .011,
                    .862
                ],
                119826: [
                    .697,
                    .011,
                    .639
                ],
                119827: [
                    .675,
                    0,
                    .8
                ],
                119828: [
                    .686,
                    .011,
                    .885
                ],
                119829: [
                    .686,
                    .007,
                    .869
                ],
                119830: [
                    .686,
                    .007,
                    1.189
                ],
                119831: [
                    .686,
                    0,
                    .869
                ],
                119832: [
                    .686,
                    0,
                    .869
                ],
                119833: [
                    .686,
                    0,
                    .703
                ],
                119834: [
                    .453,
                    .006,
                    .559
                ],
                119835: [
                    .694,
                    .006,
                    .639
                ],
                119836: [
                    .453,
                    .006,
                    .511
                ],
                119837: [
                    .694,
                    .006,
                    .639
                ],
                119838: [
                    .452,
                    .006,
                    .527
                ],
                119839: [
                    .7,
                    0,
                    .351,
                    {
                        ic: .101
                    }
                ],
                119840: [
                    .455,
                    .201,
                    .575
                ],
                119841: [
                    .694,
                    0,
                    .639
                ],
                119842: [
                    .695,
                    0,
                    .319
                ],
                119843: [
                    .695,
                    .2,
                    .351
                ],
                119844: [
                    .694,
                    0,
                    .607
                ],
                119845: [
                    .694,
                    0,
                    .319
                ],
                119846: [
                    .45,
                    0,
                    .958
                ],
                119847: [
                    .45,
                    0,
                    .639
                ],
                119848: [
                    .452,
                    .005,
                    .575
                ],
                119849: [
                    .45,
                    .194,
                    .639
                ],
                119850: [
                    .45,
                    .194,
                    .607
                ],
                119851: [
                    .45,
                    0,
                    .474
                ],
                119852: [
                    .453,
                    .006,
                    .454
                ],
                119853: [
                    .635,
                    .005,
                    .447
                ],
                119854: [
                    .45,
                    .006,
                    .639
                ],
                119855: [
                    .444,
                    0,
                    .607
                ],
                119856: [
                    .444,
                    0,
                    .831
                ],
                119857: [
                    .444,
                    0,
                    .607
                ],
                119858: [
                    .444,
                    .2,
                    .607
                ],
                119859: [
                    .444,
                    0,
                    .511
                ],
                119860: [
                    .716,
                    0,
                    .75,
                    {
                        sk: .139
                    }
                ],
                119861: [
                    .683,
                    0,
                    .759,
                    {
                        sk: .0833
                    }
                ],
                119862: [
                    .705,
                    .022,
                    .715,
                    {
                        ic: .045,
                        sk: .0833
                    }
                ],
                119863: [
                    .683,
                    0,
                    .828,
                    {
                        sk: .0556
                    }
                ],
                119864: [
                    .68,
                    0,
                    .738,
                    {
                        ic: .026,
                        sk: .0833
                    }
                ],
                119865: [
                    .68,
                    0,
                    .643,
                    {
                        ic: .106,
                        sk: .0833
                    }
                ],
                119866: [
                    .705,
                    .022,
                    .786,
                    {
                        sk: .0833
                    }
                ],
                119867: [
                    .683,
                    0,
                    .831,
                    {
                        ic: .057,
                        sk: .0556
                    }
                ],
                119868: [
                    .683,
                    0,
                    .44,
                    {
                        ic: .064,
                        sk: .111
                    }
                ],
                119869: [
                    .683,
                    .022,
                    .555,
                    {
                        ic: .078,
                        sk: .167
                    }
                ],
                119870: [
                    .683,
                    0,
                    .849,
                    {
                        ic: .04,
                        sk: .0556
                    }
                ],
                119871: [
                    .683,
                    0,
                    .681,
                    {
                        sk: .0278
                    }
                ],
                119872: [
                    .683,
                    0,
                    .97,
                    {
                        ic: .081,
                        sk: .0833
                    }
                ],
                119873: [
                    .683,
                    0,
                    .803,
                    {
                        ic: .085,
                        sk: .0833
                    }
                ],
                119874: [
                    .704,
                    .022,
                    .763,
                    {
                        sk: .0833
                    }
                ],
                119875: [
                    .683,
                    0,
                    .642,
                    {
                        ic: .109,
                        sk: .0833
                    }
                ],
                119876: [
                    .704,
                    .194,
                    .791,
                    {
                        sk: .0833
                    }
                ],
                119877: [
                    .683,
                    .021,
                    .759,
                    {
                        sk: .0833
                    }
                ],
                119878: [
                    .705,
                    .022,
                    .613,
                    {
                        ic: .032,
                        sk: .0833
                    }
                ],
                119879: [
                    .677,
                    0,
                    .584,
                    {
                        ic: .12,
                        sk: .0833
                    }
                ],
                119880: [
                    .683,
                    .022,
                    .683,
                    {
                        ic: .084,
                        sk: .0278
                    }
                ],
                119881: [
                    .683,
                    .022,
                    .583,
                    {
                        ic: .186
                    }
                ],
                119882: [
                    .683,
                    .022,
                    .944,
                    {
                        ic: .104
                    }
                ],
                119883: [
                    .683,
                    0,
                    .828,
                    {
                        ic: .024,
                        sk: .0833
                    }
                ],
                119884: [
                    .683,
                    0,
                    .581,
                    {
                        ic: .182
                    }
                ],
                119885: [
                    .683,
                    0,
                    .683,
                    {
                        ic: .04,
                        sk: .0833
                    }
                ],
                119886: [
                    .441,
                    .01,
                    .529
                ],
                119887: [
                    .694,
                    .011,
                    .429
                ],
                119888: [
                    .442,
                    .011,
                    .433,
                    {
                        sk: .0556
                    }
                ],
                119889: [
                    .694,
                    .01,
                    .52,
                    {
                        sk: .167
                    }
                ],
                119890: [
                    .442,
                    .011,
                    .466,
                    {
                        sk: .0556
                    }
                ],
                119891: [
                    .705,
                    .205,
                    .49,
                    {
                        ic: .06,
                        sk: .167
                    }
                ],
                119892: [
                    .442,
                    .205,
                    .477,
                    {
                        sk: .0278
                    }
                ],
                119894: [
                    .661,
                    .011,
                    .345
                ],
                119895: [
                    .661,
                    .204,
                    .412
                ],
                119896: [
                    .694,
                    .011,
                    .521
                ],
                119897: [
                    .694,
                    .011,
                    .298,
                    {
                        sk: .0833
                    }
                ],
                119898: [
                    .442,
                    .011,
                    .878
                ],
                119899: [
                    .442,
                    .011,
                    .6
                ],
                119900: [
                    .441,
                    .011,
                    .485,
                    {
                        sk: .0556
                    }
                ],
                119901: [
                    .442,
                    .194,
                    .503,
                    {
                        sk: .0833
                    }
                ],
                119902: [
                    .442,
                    .194,
                    .446,
                    {
                        ic: .014,
                        sk: .0833
                    }
                ],
                119903: [
                    .442,
                    .011,
                    .451,
                    {
                        sk: .0556
                    }
                ],
                119904: [
                    .442,
                    .01,
                    .469,
                    {
                        sk: .0556
                    }
                ],
                119905: [
                    .626,
                    .011,
                    .361,
                    {
                        sk: .0833
                    }
                ],
                119906: [
                    .442,
                    .011,
                    .572,
                    {
                        sk: .0278
                    }
                ],
                119907: [
                    .443,
                    .011,
                    .485,
                    {
                        sk: .0278
                    }
                ],
                119908: [
                    .443,
                    .011,
                    .716,
                    {
                        sk: .0833
                    }
                ],
                119909: [
                    .442,
                    .011,
                    .572,
                    {
                        sk: .0278
                    }
                ],
                119910: [
                    .442,
                    .205,
                    .49,
                    {
                        sk: .0556
                    }
                ],
                119911: [
                    .442,
                    .011,
                    .465,
                    {
                        sk: .0556
                    }
                ],
                119912: [
                    .711,
                    0,
                    .869,
                    {
                        sk: .16
                    }
                ],
                119913: [
                    .686,
                    0,
                    .866,
                    {
                        sk: .0958
                    }
                ],
                119914: [
                    .703,
                    .017,
                    .817,
                    {
                        ic: .038,
                        sk: .0958
                    }
                ],
                119915: [
                    .686,
                    0,
                    .938,
                    {
                        sk: .0639
                    }
                ],
                119916: [
                    .68,
                    0,
                    .81,
                    {
                        ic: .015,
                        sk: .0958
                    }
                ],
                119917: [
                    .68,
                    0,
                    .689,
                    {
                        ic: .12,
                        sk: .0958
                    }
                ],
                119918: [
                    .703,
                    .016,
                    .887,
                    {
                        sk: .0958
                    }
                ],
                119919: [
                    .686,
                    0,
                    .982,
                    {
                        ic: .045,
                        sk: .0639
                    }
                ],
                119920: [
                    .686,
                    0,
                    .511,
                    {
                        ic: .062,
                        sk: .128
                    }
                ],
                119921: [
                    .686,
                    .017,
                    .631,
                    {
                        ic: .063,
                        sk: .192
                    }
                ],
                119922: [
                    .686,
                    0,
                    .971,
                    {
                        ic: .032,
                        sk: .0639
                    }
                ],
                119923: [
                    .686,
                    0,
                    .756,
                    {
                        sk: .0319
                    }
                ],
                119924: [
                    .686,
                    0,
                    1.142,
                    {
                        ic: .077,
                        sk: .0958
                    }
                ],
                119925: [
                    .686,
                    0,
                    .95,
                    {
                        ic: .077,
                        sk: .0958
                    }
                ],
                119926: [
                    .703,
                    .017,
                    .837,
                    {
                        sk: .0958
                    }
                ],
                119927: [
                    .686,
                    0,
                    .723,
                    {
                        ic: .124,
                        sk: .0958
                    }
                ],
                119928: [
                    .703,
                    .194,
                    .869,
                    {
                        sk: .0958
                    }
                ],
                119929: [
                    .686,
                    .017,
                    .872,
                    {
                        sk: .0958
                    }
                ],
                119930: [
                    .703,
                    .017,
                    .693,
                    {
                        ic: .021,
                        sk: .0958
                    }
                ],
                119931: [
                    .675,
                    0,
                    .637,
                    {
                        ic: .135,
                        sk: .0958
                    }
                ],
                119932: [
                    .686,
                    .016,
                    .8,
                    {
                        ic: .077,
                        sk: .0319
                    }
                ],
                119933: [
                    .686,
                    .016,
                    .678,
                    {
                        ic: .208
                    }
                ],
                119934: [
                    .686,
                    .017,
                    1.093,
                    {
                        ic: .114
                    }
                ],
                119935: [
                    .686,
                    0,
                    .947,
                    {
                        sk: .0958
                    }
                ],
                119936: [
                    .686,
                    0,
                    .675,
                    {
                        ic: .201
                    }
                ],
                119937: [
                    .686,
                    0,
                    .773,
                    {
                        ic: .032,
                        sk: .0958
                    }
                ],
                119938: [
                    .452,
                    .008,
                    .633
                ],
                119939: [
                    .694,
                    .008,
                    .521
                ],
                119940: [
                    .451,
                    .008,
                    .513,
                    {
                        sk: .0639
                    }
                ],
                119941: [
                    .694,
                    .008,
                    .61,
                    {
                        sk: .192
                    }
                ],
                119942: [
                    .452,
                    .008,
                    .554,
                    {
                        sk: .0639
                    }
                ],
                119943: [
                    .701,
                    .201,
                    .568,
                    {
                        ic: .056,
                        sk: .192
                    }
                ],
                119944: [
                    .452,
                    .202,
                    .545,
                    {
                        sk: .0319
                    }
                ],
                119945: [
                    .694,
                    .008,
                    .668,
                    {
                        sk: -0.0319
                    }
                ],
                119946: [
                    .694,
                    .008,
                    .405
                ],
                119947: [
                    .694,
                    .202,
                    .471
                ],
                119948: [
                    .694,
                    .008,
                    .604
                ],
                119949: [
                    .694,
                    .008,
                    .348,
                    {
                        sk: .0958
                    }
                ],
                119950: [
                    .452,
                    .008,
                    1.032
                ],
                119951: [
                    .452,
                    .008,
                    .713
                ],
                119952: [
                    .452,
                    .008,
                    .585,
                    {
                        sk: .0639
                    }
                ],
                119953: [
                    .452,
                    .194,
                    .601,
                    {
                        sk: .0958
                    }
                ],
                119954: [
                    .452,
                    .194,
                    .542,
                    {
                        sk: .0958
                    }
                ],
                119955: [
                    .452,
                    .008,
                    .529,
                    {
                        sk: .0639
                    }
                ],
                119956: [
                    .451,
                    .008,
                    .531,
                    {
                        sk: .0639
                    }
                ],
                119957: [
                    .643,
                    .007,
                    .415,
                    {
                        sk: .0958
                    }
                ],
                119958: [
                    .452,
                    .008,
                    .681,
                    {
                        sk: .0319
                    }
                ],
                119959: [
                    .453,
                    .008,
                    .567,
                    {
                        sk: .0319
                    }
                ],
                119960: [
                    .453,
                    .008,
                    .831,
                    {
                        sk: .0958
                    }
                ],
                119961: [
                    .452,
                    .008,
                    .659,
                    {
                        sk: .0319
                    }
                ],
                119962: [
                    .452,
                    .202,
                    .59,
                    {
                        sk: .0639
                    }
                ],
                119963: [
                    .452,
                    .008,
                    .555,
                    {
                        sk: .0639
                    }
                ],
                119964: [
                    .717,
                    .008,
                    .803,
                    {
                        ic: .213,
                        sk: .389
                    }
                ],
                119966: [
                    .728,
                    .026,
                    .666,
                    {
                        ic: .153,
                        sk: .278
                    }
                ],
                119967: [
                    .708,
                    .031,
                    .774,
                    {
                        ic: .081,
                        sk: .111
                    }
                ],
                119970: [
                    .717,
                    .037,
                    .61,
                    {
                        ic: .128,
                        sk: .25
                    }
                ],
                119973: [
                    .717,
                    .314,
                    1.052,
                    {
                        ic: .081,
                        sk: .417
                    }
                ],
                119974: [
                    .717,
                    .037,
                    .914,
                    {
                        ic: .29,
                        sk: .361
                    }
                ],
                119977: [
                    .726,
                    .036,
                    .902,
                    {
                        ic: .306,
                        sk: .389
                    }
                ],
                119978: [
                    .707,
                    .008,
                    .738,
                    {
                        ic: .067,
                        sk: .167
                    }
                ],
                119979: [
                    .716,
                    .037,
                    1.013,
                    {
                        ic: .018,
                        sk: .222
                    }
                ],
                119980: [
                    .717,
                    .017,
                    .883,
                    {
                        sk: .278
                    }
                ],
                119982: [
                    .708,
                    .036,
                    .868,
                    {
                        ic: .148,
                        sk: .333
                    }
                ],
                119983: [
                    .735,
                    .037,
                    .747,
                    {
                        ic: .249,
                        sk: .222
                    }
                ],
                119984: [
                    .717,
                    .017,
                    .8,
                    {
                        ic: .16,
                        sk: .25
                    }
                ],
                119985: [
                    .717,
                    .017,
                    .622,
                    {
                        ic: .228,
                        sk: .222
                    }
                ],
                119986: [
                    .717,
                    .017,
                    .805,
                    {
                        ic: .221,
                        sk: .25
                    }
                ],
                119987: [
                    .717,
                    .017,
                    .944,
                    {
                        ic: .187,
                        sk: .278
                    }
                ],
                119988: [
                    .716,
                    .017,
                    .71,
                    {
                        ic: .249,
                        sk: .194
                    }
                ],
                119989: [
                    .717,
                    .016,
                    .821,
                    {
                        ic: .211,
                        sk: .306
                    }
                ],
                120068: [
                    .696,
                    .026,
                    .718
                ],
                120069: [
                    .691,
                    .027,
                    .884
                ],
                120071: [
                    .685,
                    .027,
                    .832
                ],
                120072: [
                    .685,
                    .024,
                    .663
                ],
                120073: [
                    .686,
                    .153,
                    .611
                ],
                120074: [
                    .69,
                    .026,
                    .785
                ],
                120077: [
                    .686,
                    .139,
                    .552
                ],
                120078: [
                    .68,
                    .027,
                    .668,
                    {
                        ic: .014
                    }
                ],
                120079: [
                    .686,
                    .026,
                    .666
                ],
                120080: [
                    .692,
                    .027,
                    1.05
                ],
                120081: [
                    .686,
                    .025,
                    .832
                ],
                120082: [
                    .729,
                    .027,
                    .827
                ],
                120083: [
                    .692,
                    .218,
                    .828
                ],
                120084: [
                    .729,
                    .069,
                    .827
                ],
                120086: [
                    .692,
                    .027,
                    .829
                ],
                120087: [
                    .701,
                    .027,
                    .669
                ],
                120088: [
                    .697,
                    .027,
                    .646,
                    {
                        ic: .019
                    }
                ],
                120089: [
                    .686,
                    .026,
                    .831
                ],
                120090: [
                    .686,
                    .027,
                    1.046
                ],
                120091: [
                    .688,
                    .027,
                    .719
                ],
                120092: [
                    .686,
                    .218,
                    .833
                ],
                120094: [
                    .47,
                    .035,
                    .5
                ],
                120095: [
                    .685,
                    .031,
                    .513
                ],
                120096: [
                    .466,
                    .029,
                    .389
                ],
                120097: [
                    .609,
                    .033,
                    .499
                ],
                120098: [
                    .467,
                    .03,
                    .401
                ],
                120099: [
                    .681,
                    .221,
                    .326
                ],
                120100: [
                    .47,
                    .209,
                    .504
                ],
                120101: [
                    .688,
                    .205,
                    .521
                ],
                120102: [
                    .673,
                    .02,
                    .279
                ],
                120103: [
                    .672,
                    .208,
                    .281
                ],
                120104: [
                    .689,
                    .025,
                    .389
                ],
                120105: [
                    .685,
                    .02,
                    .28
                ],
                120106: [
                    .475,
                    .026,
                    .767
                ],
                120107: [
                    .475,
                    .022,
                    .527
                ],
                120108: [
                    .48,
                    .028,
                    .489
                ],
                120109: [
                    .541,
                    .212,
                    .5
                ],
                120110: [
                    .479,
                    .219,
                    .489
                ],
                120111: [
                    .474,
                    .021,
                    .389
                ],
                120112: [
                    .478,
                    .029,
                    .443
                ],
                120113: [
                    .64,
                    .02,
                    .333,
                    {
                        ic: .015
                    }
                ],
                120114: [
                    .474,
                    .023,
                    .517
                ],
                120115: [
                    .53,
                    .028,
                    .512
                ],
                120116: [
                    .532,
                    .028,
                    .774
                ],
                120117: [
                    .472,
                    .188,
                    .389
                ],
                120118: [
                    .528,
                    .218,
                    .499
                ],
                120119: [
                    .471,
                    .214,
                    .391
                ],
                120120: [
                    .701,
                    0,
                    .722
                ],
                120121: [
                    .683,
                    0,
                    .667
                ],
                120123: [
                    .683,
                    0,
                    .722
                ],
                120124: [
                    .683,
                    0,
                    .667
                ],
                120125: [
                    .683,
                    0,
                    .611
                ],
                120126: [
                    .702,
                    .019,
                    .778
                ],
                120128: [
                    .683,
                    0,
                    .389
                ],
                120129: [
                    .683,
                    .077,
                    .5
                ],
                120130: [
                    .683,
                    0,
                    .778
                ],
                120131: [
                    .683,
                    0,
                    .667
                ],
                120132: [
                    .683,
                    0,
                    .944
                ],
                120134: [
                    .701,
                    .019,
                    .778
                ],
                120138: [
                    .702,
                    .012,
                    .556
                ],
                120139: [
                    .683,
                    0,
                    .667
                ],
                120140: [
                    .683,
                    .019,
                    .722
                ],
                120141: [
                    .683,
                    .02,
                    .722
                ],
                120142: [
                    .683,
                    .019,
                    1
                ],
                120143: [
                    .683,
                    0,
                    .722
                ],
                120144: [
                    .683,
                    0,
                    .722
                ],
                120172: [
                    .686,
                    .031,
                    .847
                ],
                120173: [
                    .684,
                    .031,
                    1.044
                ],
                120174: [
                    .676,
                    .032,
                    .723
                ],
                120175: [
                    .683,
                    .029,
                    .982
                ],
                120176: [
                    .686,
                    .029,
                    .783
                ],
                120177: [
                    .684,
                    .146,
                    .722
                ],
                120178: [
                    .687,
                    .029,
                    .927
                ],
                120179: [
                    .683,
                    .126,
                    .851
                ],
                120180: [
                    .681,
                    .025,
                    .655
                ],
                120181: [
                    .68,
                    .141,
                    .652
                ],
                120182: [
                    .681,
                    .026,
                    .789,
                    {
                        ic: .017
                    }
                ],
                120183: [
                    .683,
                    .028,
                    .786
                ],
                120184: [
                    .683,
                    .032,
                    1.239
                ],
                120185: [
                    .679,
                    .03,
                    .983
                ],
                120186: [
                    .726,
                    .03,
                    .976
                ],
                120187: [
                    .688,
                    .223,
                    .977
                ],
                120188: [
                    .726,
                    .083,
                    .976
                ],
                120189: [
                    .688,
                    .028,
                    .978
                ],
                120190: [
                    .685,
                    .031,
                    .978
                ],
                120191: [
                    .686,
                    .03,
                    .79,
                    {
                        ic: .012
                    }
                ],
                120192: [
                    .688,
                    .039,
                    .851,
                    {
                        ic: .02
                    }
                ],
                120193: [
                    .685,
                    .029,
                    .982
                ],
                120194: [
                    .683,
                    .03,
                    1.235
                ],
                120195: [
                    .681,
                    .035,
                    .849
                ],
                120196: [
                    .688,
                    .214,
                    .984
                ],
                120197: [
                    .677,
                    .148,
                    .711
                ],
                120198: [
                    .472,
                    .032,
                    .603
                ],
                120199: [
                    .69,
                    .032,
                    .59
                ],
                120200: [
                    .473,
                    .026,
                    .464
                ],
                120201: [
                    .632,
                    .028,
                    .589
                ],
                120202: [
                    .471,
                    .027,
                    .472
                ],
                120203: [
                    .687,
                    .222,
                    .388
                ],
                120204: [
                    .472,
                    .208,
                    .595
                ],
                120205: [
                    .687,
                    .207,
                    .615
                ],
                120206: [
                    .686,
                    .025,
                    .331
                ],
                120207: [
                    .682,
                    .203,
                    .332
                ],
                120208: [
                    .682,
                    .025,
                    .464
                ],
                120209: [
                    .681,
                    .024,
                    .337
                ],
                120210: [
                    .476,
                    .031,
                    .921
                ],
                120211: [
                    .473,
                    .028,
                    .654
                ],
                120212: [
                    .482,
                    .034,
                    .609
                ],
                120213: [
                    .557,
                    .207,
                    .604
                ],
                120214: [
                    .485,
                    .211,
                    .596
                ],
                120215: [
                    .472,
                    .026,
                    .46
                ],
                120216: [
                    .479,
                    .034,
                    .523
                ],
                120217: [
                    .648,
                    .027,
                    .393,
                    {
                        ic: .014
                    }
                ],
                120218: [
                    .472,
                    .032,
                    .589,
                    {
                        ic: .014
                    }
                ],
                120219: [
                    .546,
                    .027,
                    .604
                ],
                120220: [
                    .549,
                    .032,
                    .918
                ],
                120221: [
                    .471,
                    .188,
                    .459
                ],
                120222: [
                    .557,
                    .221,
                    .589
                ],
                120223: [
                    .471,
                    .214,
                    .461
                ],
                120224: [
                    .694,
                    0,
                    .667
                ],
                120225: [
                    .694,
                    0,
                    .667
                ],
                120226: [
                    .705,
                    .011,
                    .639
                ],
                120227: [
                    .694,
                    0,
                    .722
                ],
                120228: [
                    .691,
                    0,
                    .597
                ],
                120229: [
                    .691,
                    0,
                    .569
                ],
                120230: [
                    .704,
                    .011,
                    .667
                ],
                120231: [
                    .694,
                    0,
                    .708
                ],
                120232: [
                    .694,
                    0,
                    .278
                ],
                120233: [
                    .694,
                    .022,
                    .472
                ],
                120234: [
                    .694,
                    0,
                    .694
                ],
                120235: [
                    .694,
                    0,
                    .542
                ],
                120236: [
                    .694,
                    0,
                    .875
                ],
                120237: [
                    .694,
                    0,
                    .708
                ],
                120238: [
                    .715,
                    .022,
                    .736
                ],
                120239: [
                    .694,
                    0,
                    .639
                ],
                120240: [
                    .715,
                    .125,
                    .736
                ],
                120241: [
                    .694,
                    0,
                    .646
                ],
                120242: [
                    .716,
                    .022,
                    .556
                ],
                120243: [
                    .688,
                    0,
                    .681
                ],
                120244: [
                    .694,
                    .022,
                    .688
                ],
                120245: [
                    .694,
                    0,
                    .667
                ],
                120246: [
                    .694,
                    0,
                    .944
                ],
                120247: [
                    .694,
                    0,
                    .667
                ],
                120248: [
                    .694,
                    0,
                    .667
                ],
                120249: [
                    .694,
                    0,
                    .611
                ],
                120250: [
                    .46,
                    .01,
                    .481
                ],
                120251: [
                    .694,
                    .011,
                    .517
                ],
                120252: [
                    .46,
                    .01,
                    .444
                ],
                120253: [
                    .694,
                    .01,
                    .517
                ],
                120254: [
                    .461,
                    .01,
                    .444
                ],
                120255: [
                    .705,
                    0,
                    .306,
                    {
                        ic: .041
                    }
                ],
                120256: [
                    .455,
                    .206,
                    .5
                ],
                120257: [
                    .694,
                    0,
                    .517
                ],
                120258: [
                    .68,
                    0,
                    .239
                ],
                120259: [
                    .68,
                    .205,
                    .267
                ],
                120260: [
                    .694,
                    0,
                    .489
                ],
                120261: [
                    .694,
                    0,
                    .239
                ],
                120262: [
                    .455,
                    0,
                    .794
                ],
                120263: [
                    .455,
                    0,
                    .517
                ],
                120264: [
                    .46,
                    .01,
                    .5
                ],
                120265: [
                    .455,
                    .194,
                    .517
                ],
                120266: [
                    .455,
                    .194,
                    .517
                ],
                120267: [
                    .455,
                    0,
                    .342
                ],
                120268: [
                    .46,
                    .01,
                    .383
                ],
                120269: [
                    .571,
                    .01,
                    .361
                ],
                120270: [
                    .444,
                    .01,
                    .517
                ],
                120271: [
                    .444,
                    0,
                    .461
                ],
                120272: [
                    .444,
                    0,
                    .683
                ],
                120273: [
                    .444,
                    0,
                    .461
                ],
                120274: [
                    .444,
                    .204,
                    .461
                ],
                120275: [
                    .444,
                    0,
                    .435
                ],
                120276: [
                    .694,
                    0,
                    .733
                ],
                120277: [
                    .694,
                    0,
                    .733
                ],
                120278: [
                    .704,
                    .011,
                    .703
                ],
                120279: [
                    .694,
                    0,
                    .794
                ],
                120280: [
                    .691,
                    0,
                    .642
                ],
                120281: [
                    .691,
                    0,
                    .611
                ],
                120282: [
                    .705,
                    .011,
                    .733
                ],
                120283: [
                    .694,
                    0,
                    .794
                ],
                120284: [
                    .694,
                    0,
                    .331
                ],
                120285: [
                    .694,
                    .022,
                    .519
                ],
                120286: [
                    .694,
                    0,
                    .764
                ],
                120287: [
                    .694,
                    0,
                    .581
                ],
                120288: [
                    .694,
                    0,
                    .978
                ],
                120289: [
                    .694,
                    0,
                    .794
                ],
                120290: [
                    .716,
                    .022,
                    .794
                ],
                120291: [
                    .694,
                    0,
                    .703
                ],
                120292: [
                    .716,
                    .106,
                    .794
                ],
                120293: [
                    .694,
                    0,
                    .703
                ],
                120294: [
                    .716,
                    .022,
                    .611
                ],
                120295: [
                    .688,
                    0,
                    .733
                ],
                120296: [
                    .694,
                    .022,
                    .764
                ],
                120297: [
                    .694,
                    0,
                    .733
                ],
                120298: [
                    .694,
                    0,
                    1.039
                ],
                120299: [
                    .694,
                    0,
                    .733
                ],
                120300: [
                    .694,
                    0,
                    .733
                ],
                120301: [
                    .694,
                    0,
                    .672
                ],
                120302: [
                    .475,
                    .011,
                    .525
                ],
                120303: [
                    .694,
                    .01,
                    .561
                ],
                120304: [
                    .475,
                    .011,
                    .489
                ],
                120305: [
                    .694,
                    .011,
                    .561
                ],
                120306: [
                    .474,
                    .01,
                    .511
                ],
                120307: [
                    .705,
                    0,
                    .336,
                    {
                        ic: .045
                    }
                ],
                120308: [
                    .469,
                    .206,
                    .55
                ],
                120309: [
                    .694,
                    0,
                    .561
                ],
                120310: [
                    .695,
                    0,
                    .256
                ],
                120311: [
                    .695,
                    .205,
                    .286
                ],
                120312: [
                    .694,
                    0,
                    .531
                ],
                120313: [
                    .694,
                    0,
                    .256
                ],
                120314: [
                    .469,
                    0,
                    .867
                ],
                120315: [
                    .468,
                    0,
                    .561
                ],
                120316: [
                    .474,
                    .011,
                    .55
                ],
                120317: [
                    .469,
                    .194,
                    .561
                ],
                120318: [
                    .469,
                    .194,
                    .561
                ],
                120319: [
                    .469,
                    0,
                    .372
                ],
                120320: [
                    .474,
                    .01,
                    .422
                ],
                120321: [
                    .589,
                    .01,
                    .404
                ],
                120322: [
                    .458,
                    .011,
                    .561
                ],
                120323: [
                    .458,
                    0,
                    .5
                ],
                120324: [
                    .458,
                    0,
                    .744
                ],
                120325: [
                    .458,
                    0,
                    .5
                ],
                120326: [
                    .458,
                    .205,
                    .5
                ],
                120327: [
                    .458,
                    0,
                    .476
                ],
                120328: [
                    .694,
                    0,
                    .667
                ],
                120329: [
                    .694,
                    0,
                    .667,
                    {
                        ic: .029
                    }
                ],
                120330: [
                    .705,
                    .01,
                    .639,
                    {
                        ic: .08
                    }
                ],
                120331: [
                    .694,
                    0,
                    .722,
                    {
                        ic: .025
                    }
                ],
                120332: [
                    .691,
                    0,
                    .597,
                    {
                        ic: .091
                    }
                ],
                120333: [
                    .691,
                    0,
                    .569,
                    {
                        ic: .104
                    }
                ],
                120334: [
                    .705,
                    .011,
                    .667,
                    {
                        ic: .063
                    }
                ],
                120335: [
                    .694,
                    0,
                    .708,
                    {
                        ic: .06
                    }
                ],
                120336: [
                    .694,
                    0,
                    .278,
                    {
                        ic: .06
                    }
                ],
                120337: [
                    .694,
                    .022,
                    .472,
                    {
                        ic: .063
                    }
                ],
                120338: [
                    .694,
                    0,
                    .694,
                    {
                        ic: .091
                    }
                ],
                120339: [
                    .694,
                    0,
                    .542
                ],
                120340: [
                    .694,
                    0,
                    .875,
                    {
                        ic: .054
                    }
                ],
                120341: [
                    .694,
                    0,
                    .708,
                    {
                        ic: .058
                    }
                ],
                120342: [
                    .716,
                    .022,
                    .736,
                    {
                        ic: .027
                    }
                ],
                120343: [
                    .694,
                    0,
                    .639,
                    {
                        ic: .051
                    }
                ],
                120344: [
                    .716,
                    .125,
                    .736,
                    {
                        ic: .027
                    }
                ],
                120345: [
                    .694,
                    0,
                    .646,
                    {
                        ic: .052
                    }
                ],
                120346: [
                    .716,
                    .022,
                    .556,
                    {
                        ic: .053
                    }
                ],
                120347: [
                    .688,
                    0,
                    .681,
                    {
                        ic: .109
                    }
                ],
                120348: [
                    .694,
                    .022,
                    .688,
                    {
                        ic: .059
                    }
                ],
                120349: [
                    .694,
                    0,
                    .667,
                    {
                        ic: .132
                    }
                ],
                120350: [
                    .694,
                    0,
                    .944,
                    {
                        ic: .132
                    }
                ],
                120351: [
                    .694,
                    0,
                    .667,
                    {
                        ic: .091
                    }
                ],
                120352: [
                    .694,
                    0,
                    .667,
                    {
                        ic: .143
                    }
                ],
                120353: [
                    .694,
                    0,
                    .611,
                    {
                        ic: .091
                    }
                ],
                120354: [
                    .461,
                    .01,
                    .481
                ],
                120355: [
                    .694,
                    .011,
                    .517,
                    {
                        ic: .022
                    }
                ],
                120356: [
                    .46,
                    .011,
                    .444,
                    {
                        ic: .055
                    }
                ],
                120357: [
                    .694,
                    .01,
                    .517,
                    {
                        ic: .071
                    }
                ],
                120358: [
                    .46,
                    .011,
                    .444,
                    {
                        ic: .028
                    }
                ],
                120359: [
                    .705,
                    0,
                    .306,
                    {
                        ic: .188
                    }
                ],
                120360: [
                    .455,
                    .206,
                    .5,
                    {
                        ic: .068
                    }
                ],
                120361: [
                    .694,
                    0,
                    .517
                ],
                120362: [
                    .68,
                    0,
                    .239,
                    {
                        ic: .076
                    }
                ],
                120363: [
                    .68,
                    .204,
                    .267,
                    {
                        ic: .069
                    }
                ],
                120364: [
                    .694,
                    0,
                    .489,
                    {
                        ic: .054
                    }
                ],
                120365: [
                    .694,
                    0,
                    .239,
                    {
                        ic: .072
                    }
                ],
                120366: [
                    .455,
                    0,
                    .794
                ],
                120367: [
                    .454,
                    0,
                    .517
                ],
                120368: [
                    .461,
                    .011,
                    .5,
                    {
                        ic: .023
                    }
                ],
                120369: [
                    .455,
                    .194,
                    .517,
                    {
                        ic: .021
                    }
                ],
                120370: [
                    .455,
                    .194,
                    .517,
                    {
                        ic: .021
                    }
                ],
                120371: [
                    .455,
                    0,
                    .342,
                    {
                        ic: .082
                    }
                ],
                120372: [
                    .461,
                    .011,
                    .383,
                    {
                        ic: .053
                    }
                ],
                120373: [
                    .571,
                    .011,
                    .361,
                    {
                        ic: .049
                    }
                ],
                120374: [
                    .444,
                    .01,
                    .517,
                    {
                        ic: .02
                    }
                ],
                120375: [
                    .444,
                    0,
                    .461,
                    {
                        ic: .079
                    }
                ],
                120376: [
                    .444,
                    0,
                    .683,
                    {
                        ic: .079
                    }
                ],
                120377: [
                    .444,
                    0,
                    .461,
                    {
                        ic: .076
                    }
                ],
                120378: [
                    .444,
                    .205,
                    .461,
                    {
                        ic: .079
                    }
                ],
                120379: [
                    .444,
                    0,
                    .435,
                    {
                        ic: .059
                    }
                ],
                120432: [
                    .623,
                    0,
                    .525
                ],
                120433: [
                    .611,
                    0,
                    .525
                ],
                120434: [
                    .622,
                    .011,
                    .525
                ],
                120435: [
                    .611,
                    0,
                    .525
                ],
                120436: [
                    .611,
                    0,
                    .525
                ],
                120437: [
                    .611,
                    0,
                    .525
                ],
                120438: [
                    .622,
                    .011,
                    .525
                ],
                120439: [
                    .611,
                    0,
                    .525
                ],
                120440: [
                    .611,
                    0,
                    .525
                ],
                120441: [
                    .611,
                    .011,
                    .525
                ],
                120442: [
                    .611,
                    0,
                    .525
                ],
                120443: [
                    .611,
                    0,
                    .525
                ],
                120444: [
                    .611,
                    0,
                    .525
                ],
                120445: [
                    .611,
                    0,
                    .525
                ],
                120446: [
                    .621,
                    .01,
                    .525
                ],
                120447: [
                    .611,
                    0,
                    .525
                ],
                120448: [
                    .621,
                    .138,
                    .525
                ],
                120449: [
                    .611,
                    .011,
                    .525
                ],
                120450: [
                    .622,
                    .011,
                    .525
                ],
                120451: [
                    .611,
                    0,
                    .525
                ],
                120452: [
                    .611,
                    .011,
                    .525
                ],
                120453: [
                    .611,
                    .007,
                    .525
                ],
                120454: [
                    .611,
                    .007,
                    .525
                ],
                120455: [
                    .611,
                    0,
                    .525
                ],
                120456: [
                    .611,
                    0,
                    .525
                ],
                120457: [
                    .611,
                    0,
                    .525
                ],
                120458: [
                    .439,
                    .006,
                    .525
                ],
                120459: [
                    .611,
                    .006,
                    .525
                ],
                120460: [
                    .44,
                    .006,
                    .525
                ],
                120461: [
                    .611,
                    .006,
                    .525
                ],
                120462: [
                    .44,
                    .006,
                    .525
                ],
                120463: [
                    .617,
                    0,
                    .525
                ],
                120464: [
                    .442,
                    .229,
                    .525
                ],
                120465: [
                    .611,
                    0,
                    .525
                ],
                120466: [
                    .612,
                    0,
                    .525
                ],
                120467: [
                    .612,
                    .228,
                    .525
                ],
                120468: [
                    .611,
                    0,
                    .525
                ],
                120469: [
                    .611,
                    0,
                    .525
                ],
                120470: [
                    .436,
                    0,
                    .525,
                    {
                        ic: .011
                    }
                ],
                120471: [
                    .436,
                    0,
                    .525
                ],
                120472: [
                    .44,
                    .006,
                    .525
                ],
                120473: [
                    .437,
                    .221,
                    .525
                ],
                120474: [
                    .437,
                    .221,
                    .525,
                    {
                        ic: .02
                    }
                ],
                120475: [
                    .437,
                    0,
                    .525
                ],
                120476: [
                    .44,
                    .006,
                    .525
                ],
                120477: [
                    .554,
                    .006,
                    .525
                ],
                120478: [
                    .431,
                    .005,
                    .525
                ],
                120479: [
                    .431,
                    0,
                    .525
                ],
                120480: [
                    .431,
                    0,
                    .525
                ],
                120481: [
                    .431,
                    0,
                    .525
                ],
                120482: [
                    .431,
                    .228,
                    .525
                ],
                120483: [
                    .431,
                    0,
                    .525
                ],
                120488: [
                    .698,
                    0,
                    .869
                ],
                120489: [
                    .686,
                    0,
                    .818
                ],
                120490: [
                    .68,
                    0,
                    .692
                ],
                120491: [
                    .698,
                    0,
                    .958
                ],
                120492: [
                    .68,
                    0,
                    .756
                ],
                120493: [
                    .686,
                    0,
                    .703
                ],
                120494: [
                    .686,
                    0,
                    .9
                ],
                120495: [
                    .696,
                    .01,
                    .894
                ],
                120496: [
                    .686,
                    0,
                    .436
                ],
                120497: [
                    .686,
                    0,
                    .901
                ],
                120498: [
                    .698,
                    0,
                    .806
                ],
                120499: [
                    .686,
                    0,
                    1.092
                ],
                120500: [
                    .686,
                    0,
                    .9
                ],
                120501: [
                    .675,
                    0,
                    .767
                ],
                120502: [
                    .696,
                    .01,
                    .864
                ],
                120503: [
                    .68,
                    0,
                    .9
                ],
                120504: [
                    .686,
                    0,
                    .786
                ],
                120506: [
                    .686,
                    0,
                    .831
                ],
                120507: [
                    .675,
                    0,
                    .8
                ],
                120508: [
                    .697,
                    0,
                    .894
                ],
                120509: [
                    .686,
                    0,
                    .831
                ],
                120510: [
                    .686,
                    0,
                    .869
                ],
                120511: [
                    .686,
                    0,
                    .894
                ],
                120512: [
                    .696,
                    0,
                    .831
                ],
                120513: [
                    .686,
                    .024,
                    .958
                ],
                120546: [
                    .716,
                    0,
                    .75,
                    {
                        sk: .139
                    }
                ],
                120547: [
                    .683,
                    0,
                    .759,
                    {
                        sk: .0833
                    }
                ],
                120548: [
                    .68,
                    0,
                    .615,
                    {
                        ic: .106,
                        sk: .0833
                    }
                ],
                120549: [
                    .716,
                    0,
                    .833,
                    {
                        sk: .167
                    }
                ],
                120550: [
                    .68,
                    0,
                    .738,
                    {
                        ic: .026,
                        sk: .0833
                    }
                ],
                120551: [
                    .683,
                    0,
                    .683,
                    {
                        ic: .04,
                        sk: .0833
                    }
                ],
                120552: [
                    .683,
                    0,
                    .831,
                    {
                        ic: .057,
                        sk: .0556
                    }
                ],
                120553: [
                    .704,
                    .022,
                    .763,
                    {
                        sk: .0833
                    }
                ],
                120554: [
                    .683,
                    0,
                    .44,
                    {
                        ic: .064,
                        sk: .111
                    }
                ],
                120555: [
                    .683,
                    0,
                    .849,
                    {
                        ic: .04,
                        sk: .0556
                    }
                ],
                120556: [
                    .716,
                    0,
                    .694,
                    {
                        sk: .167
                    }
                ],
                120557: [
                    .683,
                    0,
                    .97,
                    {
                        ic: .081,
                        sk: .0833
                    }
                ],
                120558: [
                    .683,
                    0,
                    .803,
                    {
                        ic: .085,
                        sk: .0833
                    }
                ],
                120559: [
                    .677,
                    0,
                    .742,
                    {
                        ic: .035,
                        sk: .0833
                    }
                ],
                120560: [
                    .704,
                    .022,
                    .763,
                    {
                        sk: .0833
                    }
                ],
                120561: [
                    .68,
                    0,
                    .831,
                    {
                        ic: .056,
                        sk: .0556
                    }
                ],
                120562: [
                    .683,
                    0,
                    .642,
                    {
                        ic: .109,
                        sk: .0833
                    }
                ],
                120564: [
                    .683,
                    0,
                    .78,
                    {
                        ic: .026,
                        sk: .0833
                    }
                ],
                120565: [
                    .677,
                    0,
                    .584,
                    {
                        ic: .12,
                        sk: .0833
                    }
                ],
                120566: [
                    .705,
                    0,
                    .583,
                    {
                        ic: .117,
                        sk: .0556
                    }
                ],
                120567: [
                    .683,
                    0,
                    .667,
                    {
                        sk: .0833
                    }
                ],
                120568: [
                    .683,
                    0,
                    .828,
                    {
                        ic: .024,
                        sk: .0833
                    }
                ],
                120569: [
                    .683,
                    0,
                    .612,
                    {
                        ic: .08,
                        sk: .0556
                    }
                ],
                120570: [
                    .704,
                    0,
                    .772,
                    {
                        ic: .014,
                        sk: .0833
                    }
                ],
                120572: [
                    .442,
                    .011,
                    .64,
                    {
                        sk: .0278
                    }
                ],
                120573: [
                    .705,
                    .194,
                    .566,
                    {
                        sk: .0833
                    }
                ],
                120574: [
                    .441,
                    .216,
                    .518,
                    {
                        ic: .025
                    }
                ],
                120575: [
                    .717,
                    .01,
                    .444,
                    {
                        sk: .0556
                    }
                ],
                120576: [
                    .452,
                    .022,
                    .466,
                    {
                        sk: .0833
                    }
                ],
                120577: [
                    .704,
                    .204,
                    .438,
                    {
                        ic: .033,
                        sk: .0833
                    }
                ],
                120578: [
                    .442,
                    .216,
                    .497,
                    {
                        sk: .0556
                    }
                ],
                120579: [
                    .705,
                    .01,
                    .469,
                    {
                        sk: .0833
                    }
                ],
                120580: [
                    .442,
                    .01,
                    .354,
                    {
                        sk: .0556
                    }
                ],
                120581: [
                    .442,
                    .011,
                    .576
                ],
                120582: [
                    .694,
                    .012,
                    .583
                ],
                120583: [
                    .442,
                    .216,
                    .603,
                    {
                        sk: .0278
                    }
                ],
                120584: [
                    .442,
                    0,
                    .494,
                    {
                        ic: .036,
                        sk: .0278
                    }
                ],
                120585: [
                    .704,
                    .205,
                    .438,
                    {
                        sk: .111
                    }
                ],
                120586: [
                    .441,
                    .011,
                    .485,
                    {
                        sk: .0556
                    }
                ],
                120587: [
                    .431,
                    .011,
                    .57
                ],
                120588: [
                    .442,
                    .216,
                    .517,
                    {
                        sk: .0833
                    }
                ],
                120589: [
                    .442,
                    .107,
                    .363,
                    {
                        ic: .042,
                        sk: .0833
                    }
                ],
                120590: [
                    .431,
                    .011,
                    .571
                ],
                120591: [
                    .431,
                    .013,
                    .437,
                    {
                        ic: .08,
                        sk: .0278
                    }
                ],
                120592: [
                    .443,
                    .01,
                    .54,
                    {
                        sk: .0278
                    }
                ],
                120593: [
                    .442,
                    .218,
                    .654,
                    {
                        sk: .0833
                    }
                ],
                120594: [
                    .442,
                    .204,
                    .626,
                    {
                        sk: .0556
                    }
                ],
                120595: [
                    .694,
                    .205,
                    .651,
                    {
                        sk: .111
                    }
                ],
                120596: [
                    .443,
                    .011,
                    .622
                ],
                120597: [
                    .715,
                    .022,
                    .531,
                    {
                        ic: .035,
                        sk: .0833
                    }
                ],
                120598: [
                    .431,
                    .011,
                    .406,
                    {
                        sk: .0556
                    }
                ],
                120599: [
                    .705,
                    .011,
                    .591,
                    {
                        sk: .0833
                    }
                ],
                120600: [
                    .434,
                    .006,
                    .667,
                    {
                        ic: .067
                    }
                ],
                120601: [
                    .694,
                    .205,
                    .596,
                    {
                        sk: .0833
                    }
                ],
                120602: [
                    .442,
                    .194,
                    .517,
                    {
                        sk: .0833
                    }
                ],
                120603: [
                    .431,
                    .01,
                    .828
                ],
                120604: [
                    .711,
                    0,
                    .869,
                    {
                        sk: .16
                    }
                ],
                120605: [
                    .686,
                    0,
                    .866,
                    {
                        sk: .0958
                    }
                ],
                120606: [
                    .68,
                    0,
                    .657,
                    {
                        ic: .12,
                        sk: .0958
                    }
                ],
                120607: [
                    .711,
                    0,
                    .958,
                    {
                        sk: .192
                    }
                ],
                120608: [
                    .68,
                    0,
                    .81,
                    {
                        ic: .015,
                        sk: .0958
                    }
                ],
                120609: [
                    .686,
                    0,
                    .773,
                    {
                        ic: .032,
                        sk: .0958
                    }
                ],
                120610: [
                    .686,
                    0,
                    .982,
                    {
                        ic: .045,
                        sk: .0639
                    }
                ],
                120611: [
                    .702,
                    .017,
                    .867,
                    {
                        sk: .0958
                    }
                ],
                120612: [
                    .686,
                    0,
                    .511,
                    {
                        ic: .062,
                        sk: .128
                    }
                ],
                120613: [
                    .686,
                    0,
                    .971,
                    {
                        ic: .032,
                        sk: .0639
                    }
                ],
                120614: [
                    .711,
                    0,
                    .806,
                    {
                        sk: .192
                    }
                ],
                120615: [
                    .686,
                    0,
                    1.142,
                    {
                        ic: .077,
                        sk: .0958
                    }
                ],
                120616: [
                    .686,
                    0,
                    .95,
                    {
                        ic: .077,
                        sk: .0958
                    }
                ],
                120617: [
                    .675,
                    0,
                    .841,
                    {
                        ic: .026,
                        sk: .0958
                    }
                ],
                120618: [
                    .703,
                    .017,
                    .837,
                    {
                        sk: .0958
                    }
                ],
                120619: [
                    .68,
                    0,
                    .982,
                    {
                        ic: .044,
                        sk: .0639
                    }
                ],
                120620: [
                    .686,
                    0,
                    .723,
                    {
                        ic: .124,
                        sk: .0958
                    }
                ],
                120622: [
                    .686,
                    0,
                    .885,
                    {
                        ic: .017,
                        sk: .0958
                    }
                ],
                120623: [
                    .675,
                    0,
                    .637,
                    {
                        ic: .135,
                        sk: .0958
                    }
                ],
                120624: [
                    .703,
                    0,
                    .671,
                    {
                        ic: .131,
                        sk: .0639
                    }
                ],
                120625: [
                    .686,
                    0,
                    .767,
                    {
                        sk: .0958
                    }
                ],
                120626: [
                    .686,
                    0,
                    .947,
                    {
                        sk: .0958
                    }
                ],
                120627: [
                    .686,
                    0,
                    .714,
                    {
                        ic: .076,
                        sk: .0639
                    }
                ],
                120628: [
                    .703,
                    0,
                    .879,
                    {
                        sk: .0958
                    }
                ],
                120630: [
                    .452,
                    .008,
                    .761,
                    {
                        sk: .0319
                    }
                ],
                120631: [
                    .701,
                    .194,
                    .66,
                    {
                        sk: .0958
                    }
                ],
                120632: [
                    .451,
                    .211,
                    .59,
                    {
                        ic: .027
                    }
                ],
                120633: [
                    .725,
                    .008,
                    .522,
                    {
                        sk: .0639
                    }
                ],
                120634: [
                    .461,
                    .017,
                    .529,
                    {
                        sk: .0958
                    }
                ],
                120635: [
                    .711,
                    .202,
                    .508,
                    {
                        ic: .013,
                        sk: .0958
                    }
                ],
                120636: [
                    .452,
                    .211,
                    .6,
                    {
                        sk: .0639
                    }
                ],
                120637: [
                    .702,
                    .008,
                    .562,
                    {
                        sk: .0958
                    }
                ],
                120638: [
                    .452,
                    .008,
                    .412,
                    {
                        sk: .0639
                    }
                ],
                120639: [
                    .452,
                    .008,
                    .668
                ],
                120640: [
                    .694,
                    .013,
                    .671
                ],
                120641: [
                    .452,
                    .211,
                    .708,
                    {
                        sk: .0319
                    }
                ],
                120642: [
                    .452,
                    0,
                    .577,
                    {
                        ic: .031,
                        sk: .0319
                    }
                ],
                120643: [
                    .711,
                    .201,
                    .508,
                    {
                        sk: .128
                    }
                ],
                120644: [
                    .452,
                    .008,
                    .585,
                    {
                        sk: .0639
                    }
                ],
                120645: [
                    .444,
                    .008,
                    .682
                ],
                120646: [
                    .451,
                    .211,
                    .612,
                    {
                        sk: .0958
                    }
                ],
                120647: [
                    .451,
                    .105,
                    .424,
                    {
                        ic: .033,
                        sk: .0958
                    }
                ],
                120648: [
                    .444,
                    .008,
                    .686
                ],
                120649: [
                    .444,
                    .013,
                    .521,
                    {
                        ic: .089,
                        sk: .0319
                    }
                ],
                120650: [
                    .453,
                    .008,
                    .631,
                    {
                        sk: .0319
                    }
                ],
                120651: [
                    .452,
                    .216,
                    .747,
                    {
                        sk: .0958
                    }
                ],
                120652: [
                    .452,
                    .201,
                    .718,
                    {
                        sk: .0639
                    }
                ],
                120653: [
                    .694,
                    .202,
                    .758,
                    {
                        sk: .128
                    }
                ],
                120654: [
                    .453,
                    .008,
                    .718
                ],
                120655: [
                    .71,
                    .017,
                    .628,
                    {
                        ic: .029,
                        sk: .0958
                    }
                ],
                120656: [
                    .444,
                    .007,
                    .483,
                    {
                        sk: .0639
                    }
                ],
                120657: [
                    .701,
                    .008,
                    .692,
                    {
                        sk: .0958
                    }
                ],
                120658: [
                    .434,
                    .006,
                    .667,
                    {
                        ic: .067
                    }
                ],
                120659: [
                    .694,
                    .202,
                    .712,
                    {
                        sk: .0958
                    }
                ],
                120660: [
                    .451,
                    .194,
                    .612,
                    {
                        sk: .0958
                    }
                ],
                120661: [
                    .444,
                    .008,
                    .975
                ],
                120662: [
                    .694,
                    0,
                    .733
                ],
                120663: [
                    .694,
                    0,
                    .733
                ],
                120664: [
                    .691,
                    0,
                    .581
                ],
                120665: [
                    .694,
                    0,
                    .917
                ],
                120666: [
                    .691,
                    0,
                    .642
                ],
                120667: [
                    .694,
                    0,
                    .672
                ],
                120668: [
                    .694,
                    0,
                    .794
                ],
                120669: [
                    .716,
                    .022,
                    .856
                ],
                120670: [
                    .694,
                    0,
                    .331
                ],
                120671: [
                    .694,
                    0,
                    .764
                ],
                120672: [
                    .694,
                    0,
                    .672
                ],
                120673: [
                    .694,
                    0,
                    .978
                ],
                120674: [
                    .694,
                    0,
                    .794
                ],
                120675: [
                    .688,
                    0,
                    .733
                ],
                120676: [
                    .716,
                    .022,
                    .794
                ],
                120677: [
                    .691,
                    0,
                    .794
                ],
                120678: [
                    .694,
                    0,
                    .703
                ],
                120680: [
                    .694,
                    0,
                    .794
                ],
                120681: [
                    .688,
                    0,
                    .733
                ],
                120682: [
                    .715,
                    0,
                    .856
                ],
                120683: [
                    .694,
                    0,
                    .794
                ],
                120684: [
                    .694,
                    0,
                    .733
                ],
                120685: [
                    .694,
                    0,
                    .856
                ],
                120686: [
                    .716,
                    0,
                    .794
                ],
                120782: [
                    .654,
                    .01,
                    .575
                ],
                120783: [
                    .655,
                    0,
                    .575
                ],
                120784: [
                    .654,
                    0,
                    .575
                ],
                120785: [
                    .655,
                    .011,
                    .575
                ],
                120786: [
                    .656,
                    0,
                    .575
                ],
                120787: [
                    .655,
                    .011,
                    .575
                ],
                120788: [
                    .655,
                    .011,
                    .575
                ],
                120789: [
                    .676,
                    .011,
                    .575
                ],
                120790: [
                    .654,
                    .011,
                    .575
                ],
                120791: [
                    .654,
                    .011,
                    .575
                ],
                120802: [
                    .678,
                    .022,
                    .5
                ],
                120803: [
                    .678,
                    0,
                    .5
                ],
                120804: [
                    .677,
                    0,
                    .5
                ],
                120805: [
                    .678,
                    .022,
                    .5
                ],
                120806: [
                    .656,
                    0,
                    .5
                ],
                120807: [
                    .656,
                    .021,
                    .5
                ],
                120808: [
                    .677,
                    .022,
                    .5
                ],
                120809: [
                    .656,
                    .011,
                    .5
                ],
                120810: [
                    .678,
                    .022,
                    .5
                ],
                120811: [
                    .677,
                    .022,
                    .5
                ],
                120812: [
                    .715,
                    .022,
                    .55
                ],
                120813: [
                    .716,
                    0,
                    .55
                ],
                120814: [
                    .716,
                    0,
                    .55
                ],
                120815: [
                    .716,
                    .022,
                    .55
                ],
                120816: [
                    .694,
                    0,
                    .55
                ],
                120817: [
                    .694,
                    .022,
                    .55
                ],
                120818: [
                    .716,
                    .022,
                    .55
                ],
                120819: [
                    .695,
                    .011,
                    .55
                ],
                120820: [
                    .715,
                    .022,
                    .55
                ],
                120821: [
                    .716,
                    .022,
                    .55
                ],
                120822: [
                    .621,
                    .01,
                    .525
                ],
                120823: [
                    .622,
                    0,
                    .525
                ],
                120824: [
                    .622,
                    0,
                    .525
                ],
                120825: [
                    .622,
                    .011,
                    .525
                ],
                120826: [
                    .624,
                    0,
                    .525
                ],
                120827: [
                    .611,
                    .01,
                    .525
                ],
                120828: [
                    .622,
                    .011,
                    .525
                ],
                120829: [
                    .627,
                    .01,
                    .525
                ],
                120830: [
                    .621,
                    .01,
                    .525
                ],
                120831: [
                    .622,
                    .011,
                    .525
                ]
            };
        },
        4886: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerifBoldItalic = void 0, e1.sansSerifBoldItalic = {
                305: [
                    .458,
                    0,
                    .256
                ],
                567: [
                    .458,
                    .205,
                    .286
                ]
            };
        },
        4471: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerifBold = void 0, e1.sansSerifBold = {
                33: [
                    .694,
                    0,
                    .367
                ],
                34: [
                    .694,
                    -0.442,
                    .558
                ],
                35: [
                    .694,
                    .193,
                    .917
                ],
                36: [
                    .75,
                    .056,
                    .55
                ],
                37: [
                    .75,
                    .056,
                    1.029
                ],
                38: [
                    .716,
                    .022,
                    .831
                ],
                39: [
                    .694,
                    -0.442,
                    .306
                ],
                40: [
                    .75,
                    .249,
                    .428
                ],
                41: [
                    .75,
                    .25,
                    .428
                ],
                42: [
                    .75,
                    -0.293,
                    .55
                ],
                43: [
                    .617,
                    .116,
                    .856
                ],
                44: [
                    .146,
                    .106,
                    .306
                ],
                45: [
                    .273,
                    -0.186,
                    .367
                ],
                46: [
                    .146,
                    0,
                    .306
                ],
                47: [
                    .75,
                    .249,
                    .55
                ],
                58: [
                    .458,
                    0,
                    .306
                ],
                59: [
                    .458,
                    .106,
                    .306
                ],
                61: [
                    .407,
                    -0.094,
                    .856
                ],
                63: [
                    .705,
                    0,
                    .519
                ],
                64: [
                    .704,
                    .011,
                    .733
                ],
                91: [
                    .75,
                    .25,
                    .343
                ],
                93: [
                    .75,
                    .25,
                    .343
                ],
                94: [
                    .694,
                    -0.537,
                    .55
                ],
                95: [
                    -0.023,
                    .11,
                    .55
                ],
                126: [
                    .344,
                    -0.198,
                    .55
                ],
                305: [
                    .458,
                    0,
                    .256
                ],
                567: [
                    .458,
                    .205,
                    .286
                ],
                768: [
                    .694,
                    -0.537,
                    0
                ],
                769: [
                    .694,
                    -0.537,
                    0
                ],
                770: [
                    .694,
                    -0.537,
                    0
                ],
                771: [
                    .694,
                    -0.548,
                    0
                ],
                772: [
                    .66,
                    -0.56,
                    0
                ],
                774: [
                    .694,
                    -0.552,
                    0
                ],
                775: [
                    .695,
                    -0.596,
                    0
                ],
                776: [
                    .695,
                    -0.595,
                    0
                ],
                778: [
                    .694,
                    -0.538,
                    0
                ],
                779: [
                    .694,
                    -0.537,
                    0
                ],
                780: [
                    .657,
                    -0.5,
                    0
                ],
                8211: [
                    .327,
                    -0.24,
                    .55
                ],
                8212: [
                    .327,
                    -0.24,
                    1.1
                ],
                8213: [
                    .327,
                    -0.24,
                    1.1
                ],
                8215: [
                    -0.023,
                    .11,
                    .55
                ],
                8216: [
                    .694,
                    -0.443,
                    .306
                ],
                8217: [
                    .694,
                    -0.442,
                    .306
                ],
                8220: [
                    .694,
                    -0.443,
                    .558
                ],
                8221: [
                    .694,
                    -0.442,
                    .558
                ],
                8260: [
                    .75,
                    .249,
                    .55
                ],
                8710: [
                    .694,
                    0,
                    .917
                ]
            };
        },
        5181: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerifItalic = void 0, e1.sansSerifItalic = {
                33: [
                    .694,
                    0,
                    .319,
                    {
                        ic: .036
                    }
                ],
                34: [
                    .694,
                    -0.471,
                    .5
                ],
                35: [
                    .694,
                    .194,
                    .833,
                    {
                        ic: .018
                    }
                ],
                36: [
                    .75,
                    .056,
                    .5,
                    {
                        ic: .065
                    }
                ],
                37: [
                    .75,
                    .056,
                    .833
                ],
                38: [
                    .716,
                    .022,
                    .758
                ],
                39: [
                    .694,
                    -0.471,
                    .278,
                    {
                        ic: .057
                    }
                ],
                40: [
                    .75,
                    .25,
                    .389,
                    {
                        ic: .102
                    }
                ],
                41: [
                    .75,
                    .25,
                    .389
                ],
                42: [
                    .75,
                    -0.306,
                    .5,
                    {
                        ic: .068
                    }
                ],
                43: [
                    .583,
                    .083,
                    .778
                ],
                44: [
                    .098,
                    .125,
                    .278
                ],
                45: [
                    .259,
                    -0.186,
                    .333
                ],
                46: [
                    .098,
                    0,
                    .278
                ],
                47: [
                    .75,
                    .25,
                    .5,
                    {
                        ic: .1
                    }
                ],
                48: [
                    .678,
                    .022,
                    .5,
                    {
                        ic: .049
                    }
                ],
                49: [
                    .678,
                    0,
                    .5
                ],
                50: [
                    .678,
                    0,
                    .5,
                    {
                        ic: .051
                    }
                ],
                51: [
                    .678,
                    .022,
                    .5,
                    {
                        ic: .044
                    }
                ],
                52: [
                    .656,
                    0,
                    .5,
                    {
                        ic: .021
                    }
                ],
                53: [
                    .656,
                    .022,
                    .5,
                    {
                        ic: .055
                    }
                ],
                54: [
                    .678,
                    .022,
                    .5,
                    {
                        ic: .048
                    }
                ],
                55: [
                    .656,
                    .011,
                    .5,
                    {
                        ic: .096
                    }
                ],
                56: [
                    .678,
                    .022,
                    .5,
                    {
                        ic: .054
                    }
                ],
                57: [
                    .677,
                    .022,
                    .5,
                    {
                        ic: .045
                    }
                ],
                58: [
                    .444,
                    0,
                    .278
                ],
                59: [
                    .444,
                    .125,
                    .278
                ],
                61: [
                    .37,
                    -0.13,
                    .778,
                    {
                        ic: .018
                    }
                ],
                63: [
                    .704,
                    0,
                    .472,
                    {
                        ic: .064
                    }
                ],
                64: [
                    .705,
                    .01,
                    .667,
                    {
                        ic: .04
                    }
                ],
                91: [
                    .75,
                    .25,
                    .289,
                    {
                        ic: .136
                    }
                ],
                93: [
                    .75,
                    .25,
                    .289,
                    {
                        ic: .064
                    }
                ],
                94: [
                    .694,
                    -0.527,
                    .5,
                    {
                        ic: .033
                    }
                ],
                95: [
                    -0.038,
                    .114,
                    .5,
                    {
                        ic: .065
                    }
                ],
                126: [
                    .327,
                    -0.193,
                    .5,
                    {
                        ic: .06
                    }
                ],
                305: [
                    .444,
                    0,
                    .239,
                    {
                        ic: .019
                    }
                ],
                567: [
                    .444,
                    .204,
                    .267,
                    {
                        ic: .019
                    }
                ],
                768: [
                    .694,
                    -0.527,
                    0
                ],
                769: [
                    .694,
                    -0.527,
                    0,
                    {
                        ic: .063
                    }
                ],
                770: [
                    .694,
                    -0.527,
                    0,
                    {
                        ic: .033
                    }
                ],
                771: [
                    .677,
                    -0.543,
                    0,
                    {
                        ic: .06
                    }
                ],
                772: [
                    .631,
                    -0.552,
                    0,
                    {
                        ic: .064
                    }
                ],
                774: [
                    .694,
                    -0.508,
                    0,
                    {
                        ic: .073
                    }
                ],
                775: [
                    .68,
                    -0.576,
                    0
                ],
                776: [
                    .68,
                    -0.582,
                    0,
                    {
                        ic: .04
                    }
                ],
                778: [
                    .693,
                    -0.527,
                    0
                ],
                779: [
                    .694,
                    -0.527,
                    0,
                    {
                        ic: .063
                    }
                ],
                780: [
                    .654,
                    -0.487,
                    0,
                    {
                        ic: .06
                    }
                ],
                913: [
                    .694,
                    0,
                    .667
                ],
                914: [
                    .694,
                    0,
                    .667,
                    {
                        ic: .029
                    }
                ],
                915: [
                    .691,
                    0,
                    .542,
                    {
                        ic: .104
                    }
                ],
                916: [
                    .694,
                    0,
                    .833
                ],
                917: [
                    .691,
                    0,
                    .597,
                    {
                        ic: .091
                    }
                ],
                918: [
                    .694,
                    0,
                    .611,
                    {
                        ic: .091
                    }
                ],
                919: [
                    .694,
                    0,
                    .708,
                    {
                        ic: .06
                    }
                ],
                920: [
                    .715,
                    .022,
                    .778,
                    {
                        ic: .026
                    }
                ],
                921: [
                    .694,
                    0,
                    .278,
                    {
                        ic: .06
                    }
                ],
                922: [
                    .694,
                    0,
                    .694,
                    {
                        ic: .091
                    }
                ],
                923: [
                    .694,
                    0,
                    .611
                ],
                924: [
                    .694,
                    0,
                    .875,
                    {
                        ic: .054
                    }
                ],
                925: [
                    .694,
                    0,
                    .708,
                    {
                        ic: .058
                    }
                ],
                926: [
                    .688,
                    0,
                    .667,
                    {
                        ic: .098
                    }
                ],
                927: [
                    .716,
                    .022,
                    .736,
                    {
                        ic: .027
                    }
                ],
                928: [
                    .691,
                    0,
                    .708,
                    {
                        ic: .06
                    }
                ],
                929: [
                    .694,
                    0,
                    .639,
                    {
                        ic: .051
                    }
                ],
                931: [
                    .694,
                    0,
                    .722,
                    {
                        ic: .091
                    }
                ],
                932: [
                    .688,
                    0,
                    .681,
                    {
                        ic: .109
                    }
                ],
                933: [
                    .716,
                    0,
                    .778,
                    {
                        ic: .065
                    }
                ],
                934: [
                    .694,
                    0,
                    .722,
                    {
                        ic: .021
                    }
                ],
                935: [
                    .694,
                    0,
                    .667,
                    {
                        ic: .091
                    }
                ],
                936: [
                    .694,
                    0,
                    .778,
                    {
                        ic: .076
                    }
                ],
                937: [
                    .716,
                    0,
                    .722,
                    {
                        ic: .047
                    }
                ],
                8211: [
                    .312,
                    -0.236,
                    .5,
                    {
                        ic: .065
                    }
                ],
                8212: [
                    .312,
                    -0.236,
                    1,
                    {
                        ic: .065
                    }
                ],
                8213: [
                    .312,
                    -0.236,
                    1,
                    {
                        ic: .065
                    }
                ],
                8215: [
                    -0.038,
                    .114,
                    .5,
                    {
                        ic: .065
                    }
                ],
                8216: [
                    .694,
                    -0.471,
                    .278,
                    {
                        ic: .058
                    }
                ],
                8217: [
                    .694,
                    -0.471,
                    .278,
                    {
                        ic: .057
                    }
                ],
                8220: [
                    .694,
                    -0.471,
                    .5,
                    {
                        ic: .114
                    }
                ],
                8221: [
                    .694,
                    -0.471,
                    .5
                ],
                8260: [
                    .75,
                    .25,
                    .5,
                    {
                        ic: .1
                    }
                ],
                8710: [
                    .694,
                    0,
                    .833
                ]
            };
        },
        3526: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sansSerif = void 0, e1.sansSerif = {
                33: [
                    .694,
                    0,
                    .319
                ],
                34: [
                    .694,
                    -0.471,
                    .5
                ],
                35: [
                    .694,
                    .194,
                    .833
                ],
                36: [
                    .75,
                    .056,
                    .5
                ],
                37: [
                    .75,
                    .056,
                    .833
                ],
                38: [
                    .716,
                    .022,
                    .758
                ],
                39: [
                    .694,
                    -0.471,
                    .278
                ],
                40: [
                    .75,
                    .25,
                    .389
                ],
                41: [
                    .75,
                    .25,
                    .389
                ],
                42: [
                    .75,
                    -0.306,
                    .5
                ],
                43: [
                    .583,
                    .082,
                    .778
                ],
                44: [
                    .098,
                    .125,
                    .278
                ],
                45: [
                    .259,
                    -0.186,
                    .333
                ],
                46: [
                    .098,
                    0,
                    .278
                ],
                47: [
                    .75,
                    .25,
                    .5
                ],
                58: [
                    .444,
                    0,
                    .278
                ],
                59: [
                    .444,
                    .125,
                    .278
                ],
                61: [
                    .37,
                    -0.13,
                    .778
                ],
                63: [
                    .704,
                    0,
                    .472
                ],
                64: [
                    .704,
                    .011,
                    .667
                ],
                91: [
                    .75,
                    .25,
                    .289
                ],
                93: [
                    .75,
                    .25,
                    .289
                ],
                94: [
                    .694,
                    -0.527,
                    .5
                ],
                95: [
                    -0.038,
                    .114,
                    .5
                ],
                126: [
                    .327,
                    -0.193,
                    .5
                ],
                305: [
                    .444,
                    0,
                    .239
                ],
                567: [
                    .444,
                    .205,
                    .267
                ],
                768: [
                    .694,
                    -0.527,
                    0
                ],
                769: [
                    .694,
                    -0.527,
                    0
                ],
                770: [
                    .694,
                    -0.527,
                    0
                ],
                771: [
                    .677,
                    -0.543,
                    0
                ],
                772: [
                    .631,
                    -0.552,
                    0
                ],
                774: [
                    .694,
                    -0.508,
                    0
                ],
                775: [
                    .68,
                    -0.576,
                    0
                ],
                776: [
                    .68,
                    -0.582,
                    0
                ],
                778: [
                    .694,
                    -0.527,
                    0
                ],
                779: [
                    .694,
                    -0.527,
                    0
                ],
                780: [
                    .654,
                    -0.487,
                    0
                ],
                913: [
                    .694,
                    0,
                    .667
                ],
                914: [
                    .694,
                    0,
                    .667
                ],
                915: [
                    .691,
                    0,
                    .542
                ],
                916: [
                    .694,
                    0,
                    .833
                ],
                917: [
                    .691,
                    0,
                    .597
                ],
                918: [
                    .694,
                    0,
                    .611
                ],
                919: [
                    .694,
                    0,
                    .708
                ],
                920: [
                    .716,
                    .021,
                    .778
                ],
                921: [
                    .694,
                    0,
                    .278
                ],
                922: [
                    .694,
                    0,
                    .694
                ],
                923: [
                    .694,
                    0,
                    .611
                ],
                924: [
                    .694,
                    0,
                    .875
                ],
                925: [
                    .694,
                    0,
                    .708
                ],
                926: [
                    .688,
                    0,
                    .667
                ],
                927: [
                    .715,
                    .022,
                    .736
                ],
                928: [
                    .691,
                    0,
                    .708
                ],
                929: [
                    .694,
                    0,
                    .639
                ],
                931: [
                    .694,
                    0,
                    .722
                ],
                932: [
                    .688,
                    0,
                    .681
                ],
                933: [
                    .716,
                    0,
                    .778
                ],
                934: [
                    .694,
                    0,
                    .722
                ],
                935: [
                    .694,
                    0,
                    .667
                ],
                936: [
                    .694,
                    0,
                    .778
                ],
                937: [
                    .716,
                    0,
                    .722
                ],
                8211: [
                    .312,
                    -0.236,
                    .5
                ],
                8212: [
                    .312,
                    -0.236,
                    1
                ],
                8213: [
                    .312,
                    -0.236,
                    1
                ],
                8215: [
                    -0.038,
                    .114,
                    .5
                ],
                8216: [
                    .694,
                    -0.471,
                    .278
                ],
                8217: [
                    .694,
                    -0.471,
                    .278
                ],
                8220: [
                    .694,
                    -0.471,
                    .5
                ],
                8221: [
                    .694,
                    -0.471,
                    .5
                ],
                8260: [
                    .75,
                    .25,
                    .5
                ],
                8710: [
                    .694,
                    0,
                    .833
                ]
            };
        },
        5649: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.scriptBold = void 0, e1.scriptBold = {};
        },
        7153: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.script = void 0, e1.script = {};
        },
        5745: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.smallop = void 0, e1.smallop = {
                40: [
                    .85,
                    .349,
                    .458
                ],
                41: [
                    .85,
                    .349,
                    .458
                ],
                47: [
                    .85,
                    .349,
                    .578
                ],
                91: [
                    .85,
                    .349,
                    .417
                ],
                92: [
                    .85,
                    .349,
                    .578
                ],
                93: [
                    .85,
                    .349,
                    .417
                ],
                123: [
                    .85,
                    .349,
                    .583
                ],
                125: [
                    .85,
                    .349,
                    .583
                ],
                710: [
                    .744,
                    -0.551,
                    .556
                ],
                732: [
                    .722,
                    -0.597,
                    .556
                ],
                770: [
                    .744,
                    -0.551,
                    0
                ],
                771: [
                    .722,
                    -0.597,
                    0
                ],
                8214: [
                    .602,
                    0,
                    .778
                ],
                8260: [
                    .85,
                    .349,
                    .578
                ],
                8593: [
                    .6,
                    0,
                    .667
                ],
                8595: [
                    .6,
                    0,
                    .667
                ],
                8657: [
                    .599,
                    0,
                    .778
                ],
                8659: [
                    .6,
                    0,
                    .778
                ],
                8719: [
                    .75,
                    .25,
                    .944
                ],
                8720: [
                    .75,
                    .25,
                    .944
                ],
                8721: [
                    .75,
                    .25,
                    1.056
                ],
                8730: [
                    .85,
                    .35,
                    1,
                    {
                        ic: .02
                    }
                ],
                8739: [
                    .627,
                    .015,
                    .333
                ],
                8741: [
                    .627,
                    .015,
                    .556
                ],
                8747: [
                    .805,
                    .306,
                    .472,
                    {
                        ic: .138
                    }
                ],
                8748: [
                    .805,
                    .306,
                    .819,
                    {
                        ic: .138
                    }
                ],
                8749: [
                    .805,
                    .306,
                    1.166,
                    {
                        ic: .138
                    }
                ],
                8750: [
                    .805,
                    .306,
                    .472,
                    {
                        ic: .138
                    }
                ],
                8896: [
                    .75,
                    .249,
                    .833
                ],
                8897: [
                    .75,
                    .249,
                    .833
                ],
                8898: [
                    .75,
                    .249,
                    .833
                ],
                8899: [
                    .75,
                    .249,
                    .833
                ],
                8968: [
                    .85,
                    .349,
                    .472
                ],
                8969: [
                    .85,
                    .349,
                    .472
                ],
                8970: [
                    .85,
                    .349,
                    .472
                ],
                8971: [
                    .85,
                    .349,
                    .472
                ],
                9001: [
                    .85,
                    .35,
                    .472
                ],
                9002: [
                    .85,
                    .35,
                    .472
                ],
                9168: [
                    .602,
                    0,
                    .667
                ],
                10072: [
                    .627,
                    .015,
                    .333
                ],
                10216: [
                    .85,
                    .35,
                    .472
                ],
                10217: [
                    .85,
                    .35,
                    .472
                ],
                10752: [
                    .75,
                    .25,
                    1.111
                ],
                10753: [
                    .75,
                    .25,
                    1.111
                ],
                10754: [
                    .75,
                    .25,
                    1.111
                ],
                10756: [
                    .75,
                    .249,
                    .833
                ],
                10758: [
                    .75,
                    .249,
                    .833
                ],
                10764: [
                    .805,
                    .306,
                    1.638,
                    {
                        ic: .138
                    }
                ],
                12296: [
                    .85,
                    .35,
                    .472
                ],
                12297: [
                    .85,
                    .35,
                    .472
                ]
            };
        },
        1411: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texCalligraphicBold = void 0, e1.texCalligraphicBold = {
                65: [
                    .751,
                    .049,
                    .921,
                    {
                        ic: .068,
                        sk: .224
                    }
                ],
                66: [
                    .705,
                    .017,
                    .748,
                    {
                        sk: .16
                    }
                ],
                67: [
                    .703,
                    .02,
                    .613,
                    {
                        sk: .16
                    }
                ],
                68: [
                    .686,
                    0,
                    .892,
                    {
                        sk: .0958
                    }
                ],
                69: [
                    .703,
                    .016,
                    .607,
                    {
                        ic: .02,
                        sk: .128
                    }
                ],
                70: [
                    .686,
                    .03,
                    .814,
                    {
                        ic: .116,
                        sk: .128
                    }
                ],
                71: [
                    .703,
                    .113,
                    .682,
                    {
                        sk: .128
                    }
                ],
                72: [
                    .686,
                    .048,
                    .987,
                    {
                        sk: .128
                    }
                ],
                73: [
                    .686,
                    0,
                    .642,
                    {
                        ic: .104,
                        sk: .0319
                    }
                ],
                74: [
                    .686,
                    .114,
                    .779,
                    {
                        ic: .158,
                        sk: .192
                    }
                ],
                75: [
                    .703,
                    .017,
                    .871,
                    {
                        sk: .0639
                    }
                ],
                76: [
                    .703,
                    .017,
                    .788,
                    {
                        sk: .16
                    }
                ],
                77: [
                    .703,
                    .049,
                    1.378,
                    {
                        sk: .16
                    }
                ],
                78: [
                    .84,
                    .049,
                    .937,
                    {
                        ic: .168,
                        sk: .0958
                    }
                ],
                79: [
                    .703,
                    .017,
                    .906,
                    {
                        sk: .128
                    }
                ],
                80: [
                    .686,
                    .067,
                    .81,
                    {
                        ic: .036,
                        sk: .0958
                    }
                ],
                81: [
                    .703,
                    .146,
                    .939,
                    {
                        sk: .128
                    }
                ],
                82: [
                    .686,
                    .017,
                    .99,
                    {
                        sk: .0958
                    }
                ],
                83: [
                    .703,
                    .016,
                    .696,
                    {
                        ic: .025,
                        sk: .16
                    }
                ],
                84: [
                    .72,
                    .069,
                    .644,
                    {
                        ic: .303,
                        sk: .0319
                    }
                ],
                85: [
                    .686,
                    .024,
                    .715,
                    {
                        ic: .056,
                        sk: .0958
                    }
                ],
                86: [
                    .686,
                    .077,
                    .737,
                    {
                        ic: .037,
                        sk: .0319
                    }
                ],
                87: [
                    .686,
                    .077,
                    1.169,
                    {
                        ic: .037,
                        sk: .0958
                    }
                ],
                88: [
                    .686,
                    0,
                    .817,
                    {
                        ic: .089,
                        sk: .16
                    }
                ],
                89: [
                    .686,
                    .164,
                    .759,
                    {
                        ic: .038,
                        sk: .0958
                    }
                ],
                90: [
                    .686,
                    0,
                    .818,
                    {
                        ic: .035,
                        sk: .16
                    }
                ],
                305: [
                    .452,
                    .008,
                    .394,
                    {
                        sk: .0319
                    }
                ],
                567: [
                    .451,
                    .201,
                    .439,
                    {
                        sk: .0958
                    }
                ]
            };
        },
        6384: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texCalligraphic = void 0, e1.texCalligraphic = {
                65: [
                    .728,
                    .05,
                    .798,
                    {
                        ic: .021,
                        sk: .194
                    }
                ],
                66: [
                    .705,
                    .022,
                    .657,
                    {
                        sk: .139
                    }
                ],
                67: [
                    .705,
                    .025,
                    .527,
                    {
                        sk: .139
                    }
                ],
                68: [
                    .683,
                    0,
                    .771,
                    {
                        sk: .0833
                    }
                ],
                69: [
                    .705,
                    .022,
                    .528,
                    {
                        ic: .036,
                        sk: .111
                    }
                ],
                70: [
                    .683,
                    .032,
                    .719,
                    {
                        ic: .11,
                        sk: .111
                    }
                ],
                71: [
                    .704,
                    .119,
                    .595,
                    {
                        sk: .111
                    }
                ],
                72: [
                    .683,
                    .048,
                    .845,
                    {
                        sk: .111
                    }
                ],
                73: [
                    .683,
                    0,
                    .545,
                    {
                        ic: .097,
                        sk: .0278
                    }
                ],
                74: [
                    .683,
                    .119,
                    .678,
                    {
                        ic: .161,
                        sk: .167
                    }
                ],
                75: [
                    .705,
                    .022,
                    .762,
                    {
                        sk: .0556
                    }
                ],
                76: [
                    .705,
                    .022,
                    .69,
                    {
                        sk: .139
                    }
                ],
                77: [
                    .705,
                    .05,
                    1.201,
                    {
                        sk: .139
                    }
                ],
                78: [
                    .789,
                    .05,
                    .82,
                    {
                        ic: .159,
                        sk: .0833
                    }
                ],
                79: [
                    .705,
                    .022,
                    .796,
                    {
                        sk: .111
                    }
                ],
                80: [
                    .683,
                    .057,
                    .696,
                    {
                        ic: .037,
                        sk: .0833
                    }
                ],
                81: [
                    .705,
                    .131,
                    .817,
                    {
                        sk: .111
                    }
                ],
                82: [
                    .682,
                    .022,
                    .848,
                    {
                        sk: .0833
                    }
                ],
                83: [
                    .705,
                    .022,
                    .606,
                    {
                        ic: .036,
                        sk: .139
                    }
                ],
                84: [
                    .717,
                    .068,
                    .545,
                    {
                        ic: .288,
                        sk: .0278
                    }
                ],
                85: [
                    .683,
                    .028,
                    .626,
                    {
                        ic: .061,
                        sk: .0833
                    }
                ],
                86: [
                    .683,
                    .052,
                    .613,
                    {
                        ic: .045,
                        sk: .0278
                    }
                ],
                87: [
                    .683,
                    .053,
                    .988,
                    {
                        ic: .046,
                        sk: .0833
                    }
                ],
                88: [
                    .683,
                    0,
                    .713,
                    {
                        ic: .094,
                        sk: .139
                    }
                ],
                89: [
                    .683,
                    .143,
                    .668,
                    {
                        ic: .046,
                        sk: .0833
                    }
                ],
                90: [
                    .683,
                    0,
                    .725,
                    {
                        ic: .042,
                        sk: .139
                    }
                ]
            };
        },
        6041: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texMathit = void 0, e1.texMathit = {
                65: [
                    .716,
                    0,
                    .743
                ],
                66: [
                    .683,
                    0,
                    .704
                ],
                67: [
                    .705,
                    .021,
                    .716
                ],
                68: [
                    .683,
                    0,
                    .755
                ],
                69: [
                    .68,
                    0,
                    .678
                ],
                70: [
                    .68,
                    0,
                    .653
                ],
                71: [
                    .705,
                    .022,
                    .774
                ],
                72: [
                    .683,
                    0,
                    .743
                ],
                73: [
                    .683,
                    0,
                    .386
                ],
                74: [
                    .683,
                    .021,
                    .525
                ],
                75: [
                    .683,
                    0,
                    .769
                ],
                76: [
                    .683,
                    0,
                    .627
                ],
                77: [
                    .683,
                    0,
                    .897
                ],
                78: [
                    .683,
                    0,
                    .743
                ],
                79: [
                    .704,
                    .022,
                    .767
                ],
                80: [
                    .683,
                    0,
                    .678
                ],
                81: [
                    .704,
                    .194,
                    .767
                ],
                82: [
                    .683,
                    .022,
                    .729
                ],
                83: [
                    .705,
                    .022,
                    .562
                ],
                84: [
                    .677,
                    0,
                    .716
                ],
                85: [
                    .683,
                    .022,
                    .743
                ],
                86: [
                    .683,
                    .022,
                    .743
                ],
                87: [
                    .683,
                    .022,
                    .999
                ],
                88: [
                    .683,
                    0,
                    .743
                ],
                89: [
                    .683,
                    0,
                    .743
                ],
                90: [
                    .683,
                    0,
                    .613
                ],
                97: [
                    .442,
                    .011,
                    .511
                ],
                98: [
                    .694,
                    .011,
                    .46
                ],
                99: [
                    .441,
                    .01,
                    .46
                ],
                100: [
                    .694,
                    .011,
                    .511
                ],
                101: [
                    .442,
                    .01,
                    .46
                ],
                102: [
                    .705,
                    .204,
                    .307
                ],
                103: [
                    .442,
                    .205,
                    .46
                ],
                104: [
                    .694,
                    .011,
                    .511
                ],
                105: [
                    .656,
                    .01,
                    .307
                ],
                106: [
                    .656,
                    .204,
                    .307
                ],
                107: [
                    .694,
                    .011,
                    .46
                ],
                108: [
                    .694,
                    .011,
                    .256
                ],
                109: [
                    .442,
                    .011,
                    .818
                ],
                110: [
                    .442,
                    .011,
                    .562
                ],
                111: [
                    .442,
                    .011,
                    .511
                ],
                112: [
                    .442,
                    .194,
                    .511
                ],
                113: [
                    .442,
                    .194,
                    .46
                ],
                114: [
                    .442,
                    .011,
                    .422
                ],
                115: [
                    .442,
                    .011,
                    .409
                ],
                116: [
                    .626,
                    .011,
                    .332
                ],
                117: [
                    .441,
                    .011,
                    .537
                ],
                118: [
                    .443,
                    .01,
                    .46
                ],
                119: [
                    .443,
                    .011,
                    .664
                ],
                120: [
                    .442,
                    .011,
                    .464
                ],
                121: [
                    .441,
                    .205,
                    .486
                ],
                122: [
                    .442,
                    .011,
                    .409
                ]
            };
        },
        8199: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texOldstyleBold = void 0, e1.texOldstyleBold = {
                48: [
                    .46,
                    .017,
                    .575
                ],
                49: [
                    .461,
                    0,
                    .575
                ],
                50: [
                    .46,
                    0,
                    .575
                ],
                51: [
                    .461,
                    .211,
                    .575
                ],
                52: [
                    .469,
                    .194,
                    .575
                ],
                53: [
                    .461,
                    .211,
                    .575
                ],
                54: [
                    .66,
                    .017,
                    .575
                ],
                55: [
                    .476,
                    .211,
                    .575
                ],
                56: [
                    .661,
                    .017,
                    .575
                ],
                57: [
                    .461,
                    .21,
                    .575
                ],
                65: [
                    .751,
                    .049,
                    .921,
                    {
                        ic: .068,
                        sk: .224
                    }
                ],
                66: [
                    .705,
                    .017,
                    .748,
                    {
                        sk: .16
                    }
                ],
                67: [
                    .703,
                    .02,
                    .613,
                    {
                        sk: .16
                    }
                ],
                68: [
                    .686,
                    0,
                    .892,
                    {
                        sk: .0958
                    }
                ],
                69: [
                    .703,
                    .016,
                    .607,
                    {
                        ic: .02,
                        sk: .128
                    }
                ],
                70: [
                    .686,
                    .03,
                    .814,
                    {
                        ic: .116,
                        sk: .128
                    }
                ],
                71: [
                    .703,
                    .113,
                    .682,
                    {
                        sk: .128
                    }
                ],
                72: [
                    .686,
                    .048,
                    .987,
                    {
                        sk: .128
                    }
                ],
                73: [
                    .686,
                    0,
                    .642,
                    {
                        ic: .104,
                        sk: .0319
                    }
                ],
                74: [
                    .686,
                    .114,
                    .779,
                    {
                        ic: .158,
                        sk: .192
                    }
                ],
                75: [
                    .703,
                    .017,
                    .871,
                    {
                        sk: .0639
                    }
                ],
                76: [
                    .703,
                    .017,
                    .788,
                    {
                        sk: .16
                    }
                ],
                77: [
                    .703,
                    .049,
                    1.378,
                    {
                        sk: .16
                    }
                ],
                78: [
                    .84,
                    .049,
                    .937,
                    {
                        ic: .168,
                        sk: .0958
                    }
                ],
                79: [
                    .703,
                    .017,
                    .906,
                    {
                        sk: .128
                    }
                ],
                80: [
                    .686,
                    .067,
                    .81,
                    {
                        ic: .036,
                        sk: .0958
                    }
                ],
                81: [
                    .703,
                    .146,
                    .939,
                    {
                        sk: .128
                    }
                ],
                82: [
                    .686,
                    .017,
                    .99,
                    {
                        sk: .0958
                    }
                ],
                83: [
                    .703,
                    .016,
                    .696,
                    {
                        ic: .025,
                        sk: .16
                    }
                ],
                84: [
                    .72,
                    .069,
                    .644,
                    {
                        ic: .303,
                        sk: .0319
                    }
                ],
                85: [
                    .686,
                    .024,
                    .715,
                    {
                        ic: .056,
                        sk: .0958
                    }
                ],
                86: [
                    .686,
                    .077,
                    .737,
                    {
                        ic: .037,
                        sk: .0319
                    }
                ],
                87: [
                    .686,
                    .077,
                    1.169,
                    {
                        ic: .037,
                        sk: .0958
                    }
                ],
                88: [
                    .686,
                    0,
                    .817,
                    {
                        ic: .089,
                        sk: .16
                    }
                ],
                89: [
                    .686,
                    .164,
                    .759,
                    {
                        ic: .038,
                        sk: .0958
                    }
                ],
                90: [
                    .686,
                    0,
                    .818,
                    {
                        ic: .035,
                        sk: .16
                    }
                ]
            };
        },
        9848: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texOldstyle = void 0, e1.texOldstyle = {
                48: [
                    .452,
                    .022,
                    .5
                ],
                49: [
                    .453,
                    0,
                    .5
                ],
                50: [
                    .453,
                    0,
                    .5
                ],
                51: [
                    .452,
                    .216,
                    .5
                ],
                52: [
                    .464,
                    .194,
                    .5
                ],
                53: [
                    .453,
                    .216,
                    .5
                ],
                54: [
                    .665,
                    .022,
                    .5
                ],
                55: [
                    .463,
                    .216,
                    .5
                ],
                56: [
                    .666,
                    .021,
                    .5
                ],
                57: [
                    .453,
                    .216,
                    .5
                ],
                65: [
                    .728,
                    .05,
                    .798,
                    {
                        ic: .021,
                        sk: .194
                    }
                ],
                66: [
                    .705,
                    .022,
                    .657,
                    {
                        sk: .139
                    }
                ],
                67: [
                    .705,
                    .025,
                    .527,
                    {
                        sk: .139
                    }
                ],
                68: [
                    .683,
                    0,
                    .771,
                    {
                        sk: .0833
                    }
                ],
                69: [
                    .705,
                    .022,
                    .528,
                    {
                        ic: .036,
                        sk: .111
                    }
                ],
                70: [
                    .683,
                    .032,
                    .719,
                    {
                        ic: .11,
                        sk: .111
                    }
                ],
                71: [
                    .704,
                    .119,
                    .595,
                    {
                        sk: .111
                    }
                ],
                72: [
                    .683,
                    .048,
                    .845,
                    {
                        sk: .111
                    }
                ],
                73: [
                    .683,
                    0,
                    .545,
                    {
                        ic: .097,
                        sk: .0278
                    }
                ],
                74: [
                    .683,
                    .119,
                    .678,
                    {
                        ic: .161,
                        sk: .167
                    }
                ],
                75: [
                    .705,
                    .022,
                    .762,
                    {
                        sk: .0556
                    }
                ],
                76: [
                    .705,
                    .022,
                    .69,
                    {
                        sk: .139
                    }
                ],
                77: [
                    .705,
                    .05,
                    1.201,
                    {
                        sk: .139
                    }
                ],
                78: [
                    .789,
                    .05,
                    .82,
                    {
                        ic: .159,
                        sk: .0833
                    }
                ],
                79: [
                    .705,
                    .022,
                    .796,
                    {
                        sk: .111
                    }
                ],
                80: [
                    .683,
                    .057,
                    .696,
                    {
                        ic: .037,
                        sk: .0833
                    }
                ],
                81: [
                    .705,
                    .131,
                    .817,
                    {
                        sk: .111
                    }
                ],
                82: [
                    .682,
                    .022,
                    .848,
                    {
                        sk: .0833
                    }
                ],
                83: [
                    .705,
                    .022,
                    .606,
                    {
                        ic: .036,
                        sk: .139
                    }
                ],
                84: [
                    .717,
                    .068,
                    .545,
                    {
                        ic: .288,
                        sk: .0278
                    }
                ],
                85: [
                    .683,
                    .028,
                    .626,
                    {
                        ic: .061,
                        sk: .0833
                    }
                ],
                86: [
                    .683,
                    .052,
                    .613,
                    {
                        ic: .045,
                        sk: .0278
                    }
                ],
                87: [
                    .683,
                    .053,
                    .988,
                    {
                        ic: .046,
                        sk: .0833
                    }
                ],
                88: [
                    .683,
                    0,
                    .713,
                    {
                        ic: .094,
                        sk: .139
                    }
                ],
                89: [
                    .683,
                    .143,
                    .668,
                    {
                        ic: .046,
                        sk: .0833
                    }
                ],
                90: [
                    .683,
                    0,
                    .725,
                    {
                        ic: .042,
                        sk: .139
                    }
                ]
            };
        },
        7906: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texSize3 = void 0, e1.texSize3 = {
                40: [
                    1.45,
                    .949,
                    .736
                ],
                41: [
                    1.45,
                    .949,
                    .736
                ],
                47: [
                    1.45,
                    .949,
                    1.044
                ],
                91: [
                    1.45,
                    .949,
                    .528
                ],
                92: [
                    1.45,
                    .949,
                    1.044
                ],
                93: [
                    1.45,
                    .949,
                    .528
                ],
                123: [
                    1.45,
                    .949,
                    .75
                ],
                125: [
                    1.45,
                    .949,
                    .75
                ],
                710: [
                    .772,
                    -0.564,
                    1.444
                ],
                732: [
                    .749,
                    -0.61,
                    1.444
                ],
                770: [
                    .772,
                    -0.564,
                    0
                ],
                771: [
                    .749,
                    -0.61,
                    0
                ],
                8260: [
                    1.45,
                    .949,
                    1.044
                ],
                8730: [
                    1.45,
                    .95,
                    1,
                    {
                        ic: .02
                    }
                ],
                8968: [
                    1.45,
                    .949,
                    .583
                ],
                8969: [
                    1.45,
                    .949,
                    .583
                ],
                8970: [
                    1.45,
                    .949,
                    .583
                ],
                8971: [
                    1.45,
                    .949,
                    .583
                ],
                9001: [
                    1.45,
                    .95,
                    .75
                ],
                9002: [
                    1.45,
                    .949,
                    .75
                ],
                10216: [
                    1.45,
                    .95,
                    .75
                ],
                10217: [
                    1.45,
                    .949,
                    .75
                ],
                12296: [
                    1.45,
                    .95,
                    .75
                ],
                12297: [
                    1.45,
                    .949,
                    .75
                ]
            };
        },
        2644: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texSize4 = void 0, e1.texSize4 = {
                40: [
                    1.75,
                    1.249,
                    .792
                ],
                41: [
                    1.75,
                    1.249,
                    .792
                ],
                47: [
                    1.75,
                    1.249,
                    1.278
                ],
                91: [
                    1.75,
                    1.249,
                    .583
                ],
                92: [
                    1.75,
                    1.249,
                    1.278
                ],
                93: [
                    1.75,
                    1.249,
                    .583
                ],
                123: [
                    1.75,
                    1.249,
                    .806
                ],
                125: [
                    1.75,
                    1.249,
                    .806
                ],
                710: [
                    .845,
                    -0.561,
                    1.889,
                    {
                        ic: .013
                    }
                ],
                732: [
                    .823,
                    -0.583,
                    1.889
                ],
                770: [
                    .845,
                    -0.561,
                    0,
                    {
                        ic: .013
                    }
                ],
                771: [
                    .823,
                    -0.583,
                    0
                ],
                8260: [
                    1.75,
                    1.249,
                    1.278
                ],
                8730: [
                    1.75,
                    1.25,
                    1,
                    {
                        ic: .02
                    }
                ],
                8968: [
                    1.75,
                    1.249,
                    .639
                ],
                8969: [
                    1.75,
                    1.249,
                    .639
                ],
                8970: [
                    1.75,
                    1.249,
                    .639
                ],
                8971: [
                    1.75,
                    1.249,
                    .639
                ],
                9001: [
                    1.75,
                    1.248,
                    .806
                ],
                9002: [
                    1.75,
                    1.248,
                    .806
                ],
                9115: [
                    1.154,
                    .655,
                    .875
                ],
                9116: [
                    .61,
                    .01,
                    .875
                ],
                9117: [
                    1.165,
                    .644,
                    .875
                ],
                9118: [
                    1.154,
                    .655,
                    .875
                ],
                9119: [
                    .61,
                    .01,
                    .875
                ],
                9120: [
                    1.165,
                    .644,
                    .875
                ],
                9121: [
                    1.154,
                    .645,
                    .667
                ],
                9122: [
                    .602,
                    0,
                    .667
                ],
                9123: [
                    1.155,
                    .644,
                    .667
                ],
                9124: [
                    1.154,
                    .645,
                    .667
                ],
                9125: [
                    .602,
                    0,
                    .667
                ],
                9126: [
                    1.155,
                    .644,
                    .667
                ],
                9127: [
                    .899,
                    .01,
                    .889
                ],
                9128: [
                    1.16,
                    .66,
                    .889
                ],
                9129: [
                    .01,
                    .899,
                    .889
                ],
                9130: [
                    .29,
                    .015,
                    .889
                ],
                9131: [
                    .899,
                    .01,
                    .889
                ],
                9132: [
                    1.16,
                    .66,
                    .889
                ],
                9133: [
                    .01,
                    .899,
                    .889
                ],
                9143: [
                    .935,
                    .885,
                    1.056
                ],
                10216: [
                    1.75,
                    1.248,
                    .806
                ],
                10217: [
                    1.75,
                    1.248,
                    .806
                ],
                12296: [
                    1.75,
                    1.248,
                    .806
                ],
                12297: [
                    1.75,
                    1.248,
                    .806
                ],
                57344: [
                    .625,
                    .014,
                    1.056
                ],
                57345: [
                    .605,
                    .014,
                    1.056,
                    {
                        ic: .02
                    }
                ],
                57680: [
                    .12,
                    .213,
                    .45,
                    {
                        ic: .01
                    }
                ],
                57681: [
                    .12,
                    .213,
                    .45,
                    {
                        ic: .024
                    }
                ],
                57682: [
                    .333,
                    0,
                    .45,
                    {
                        ic: .01
                    }
                ],
                57683: [
                    .333,
                    0,
                    .45,
                    {
                        ic: .024
                    }
                ],
                57684: [
                    .32,
                    .2,
                    .4,
                    {
                        ic: .01
                    }
                ],
                57685: [
                    .333,
                    0,
                    .9,
                    {
                        ic: .01
                    }
                ],
                57686: [
                    .12,
                    .213,
                    .9,
                    {
                        ic: .01
                    }
                ]
            };
        },
        4926: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.texVariant = void 0, e1.texVariant = {
                710: [
                    .845,
                    -0.561,
                    2.333,
                    {
                        ic: .013
                    }
                ],
                732: [
                    .899,
                    -0.628,
                    2.333
                ],
                770: [
                    .845,
                    -0.561,
                    0,
                    {
                        ic: .013
                    }
                ],
                771: [
                    .899,
                    -0.628,
                    0
                ],
                1008: [
                    .434,
                    .006,
                    .667,
                    {
                        ic: .067
                    }
                ],
                8463: [
                    .695,
                    .013,
                    .54,
                    {
                        ic: .022
                    }
                ],
                8592: [
                    .437,
                    -0.064,
                    .5
                ],
                8594: [
                    .437,
                    -0.064,
                    .5
                ],
                8652: [
                    .514,
                    .014,
                    1
                ],
                8708: [
                    .86,
                    .166,
                    .556
                ],
                8709: [
                    .587,
                    0,
                    .778
                ],
                8722: [
                    .27,
                    -0.23,
                    .5
                ],
                8726: [
                    .43,
                    .023,
                    .778
                ],
                8733: [
                    .472,
                    -0.028,
                    .778
                ],
                8739: [
                    .43,
                    .023,
                    .222
                ],
                8740: [
                    .43,
                    .023,
                    .222,
                    {
                        ic: .018
                    }
                ],
                8741: [
                    .431,
                    .023,
                    .389
                ],
                8742: [
                    .431,
                    .024,
                    .389,
                    {
                        ic: .018
                    }
                ],
                8764: [
                    .365,
                    -0.132,
                    .778
                ],
                8776: [
                    .481,
                    -0.05,
                    .778
                ],
                8808: [
                    .752,
                    .284,
                    .778
                ],
                8809: [
                    .752,
                    .284,
                    .778
                ],
                8816: [
                    .919,
                    .421,
                    .778
                ],
                8817: [
                    .919,
                    .421,
                    .778
                ],
                8840: [
                    .828,
                    .33,
                    .778
                ],
                8841: [
                    .828,
                    .33,
                    .778
                ],
                8842: [
                    .634,
                    .255,
                    .778
                ],
                8843: [
                    .634,
                    .254,
                    .778
                ],
                8872: [
                    .694,
                    0,
                    .611
                ],
                8901: [
                    .189,
                    0,
                    .278
                ],
                8994: [
                    .378,
                    -0.122,
                    .778
                ],
                8995: [
                    .378,
                    -0.143,
                    .778
                ],
                9651: [
                    .575,
                    .02,
                    .722
                ],
                9661: [
                    .576,
                    .019,
                    .722
                ],
                10887: [
                    .801,
                    .303,
                    .778
                ],
                10888: [
                    .801,
                    .303,
                    .778
                ],
                10955: [
                    .752,
                    .332,
                    .778
                ],
                10956: [
                    .752,
                    .333,
                    .778
                ]
            };
        },
        5865: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MJContextMenu = void 0;
            var a1 = r1(5073), l1 = r1(6186), c1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.mathItem = null, e1.annotation = "", e1.annotationTypes = {}, e1;
                }
                return o1(e1, t1), e1.prototype.post = function(e1, r1) {
                    if (this.mathItem) {
                        if (void 0 !== r1) {
                            var n1 = this.mathItem.inputJax.name, o1 = this.findID("Show", "Original");
                            o1.content = "MathML" === n1 ? "Original MathML" : n1 + " Commands", this.findID("Copy", "Original").content = o1.content;
                            var i1 = this.findID("Settings", "semantics");
                            "MathML" === n1 ? i1.disable() : i1.enable(), this.getAnnotationMenu(), this.dynamicSubmenus();
                        }
                        t1.prototype.post.call(this, e1, r1);
                    }
                }, e1.prototype.unpost = function() {
                    t1.prototype.unpost.call(this), this.mathItem = null;
                }, e1.prototype.findID = function() {
                    for(var t1, e1, r1 = [], n1 = 0; n1 < arguments.length; n1++)r1[n1] = arguments[n1];
                    var o1 = this, s1 = null;
                    try {
                        for(var a1 = i1(r1), c1 = a1.next(); !c1.done; c1 = a1.next()){
                            var u1 = c1.value;
                            o1 ? (s1 = o1.find(u1), o1 = s1 instanceof l1.Submenu ? s1.submenu : null) : s1 = null;
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (e1 = a1.return) && e1.call(a1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return s1;
                }, e1.prototype.getAnnotationMenu = function() {
                    var t1 = this, e1 = this.getAnnotations(this.getSemanticNode());
                    this.createAnnotationMenu("Show", e1, function() {
                        return t1.showAnnotation.post();
                    }), this.createAnnotationMenu("Copy", e1, function() {
                        return t1.copyAnnotation();
                    });
                }, e1.prototype.getSemanticNode = function() {
                    for(var t1 = this.mathItem.root; t1 && !t1.isKind("semantics");){
                        if (t1.isToken || 1 !== t1.childNodes.length) return null;
                        t1 = t1.childNodes[0];
                    }
                    return t1;
                }, e1.prototype.getAnnotations = function(t1) {
                    var e1, r1, n1 = [];
                    if (!t1) return n1;
                    try {
                        for(var o1 = i1(t1.childNodes), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            if (a1.isKind("annotation")) {
                                var l1 = this.annotationMatch(a1);
                                if (l1) {
                                    var c1 = a1.childNodes.reduce(function(t1, e1) {
                                        return t1 + e1.toString();
                                    }, "");
                                    n1.push([
                                        l1,
                                        c1
                                    ]);
                                }
                            }
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return n1;
                }, e1.prototype.annotationMatch = function(t1) {
                    var e1, r1, n1 = t1.attributes.get("encoding");
                    try {
                        for(var o1 = i1(Object.keys(this.annotationTypes)), s1 = o1.next(); !s1.done; s1 = o1.next()){
                            var a1 = s1.value;
                            if (this.annotationTypes[a1].indexOf(n1) >= 0) return a1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = o1.return) && r1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return null;
                }, e1.prototype.createAnnotationMenu = function(t1, e1, r1) {
                    var n1 = this, o1 = this.findID(t1, "Annotation");
                    o1.submenu = this.factory.get("subMenu")(this.factory, {
                        items: e1.map(function(t1) {
                            var e1 = s1(t1, 2), o1 = e1[0], i1 = e1[1];
                            return {
                                type: "command",
                                id: o1,
                                content: o1,
                                action: function() {
                                    n1.annotation = i1, r1();
                                }
                            };
                        }),
                        id: "annotations"
                    }, o1), e1.length ? o1.enable() : o1.disable();
                }, e1.prototype.dynamicSubmenus = function() {
                    var t1, r1;
                    try {
                        for(var n1 = i1(e1.DynamicSubmenus), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var a1 = s1(o1.value, 2), l1 = a1[0], c1 = a1[1], u1 = this.find(l1);
                            if (u1) {
                                var p1 = c1(this, u1);
                                u1.submenu = p1, p1.items.length ? u1.enable() : u1.disable();
                            }
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.DynamicSubmenus = new Map, e1;
            }(a1.ContextMenu);
            e1.MJContextMenu = c1;
        },
        8310: function(t1, e1, r1) {
            var n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, i1 = this && this.__importDefault || function(t1) {
                return t1 && t1.__esModule ? t1 : {
                    default: t1
                };
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Menu = void 0;
            var s1 = r1(5713), a1 = r1(4474), l1 = r1(9515), c1 = r1(7233), u1 = r1(5865), p1 = r1(473), h1 = r1(4414), f1 = r1(4922), d1 = r1(6914), m1 = r1(3463), y1 = r1(7309), g1 = i1(r1(5445)), b1 = l1.MathJax, v1 = "undefined" != typeof window && window.navigator && "Mac" === window.navigator.platform.substr(0, 3), _1 = function() {
                function t1(t1, e1) {
                    void 0 === e1 && (e1 = {});
                    var r1 = this;
                    this.settings = null, this.defaultSettings = null, this.menu = null, this.MmlVisitor = new p1.MmlVisitor, this.jax = {
                        CHTML: null,
                        SVG: null
                    }, this.rerenderStart = a1.STATE.LAST, this.about = new f1.Info('<b style="font-size:120%;">MathJax</b> v' + s1.mathjax.version, function() {
                        var t1 = [];
                        return t1.push("Input Jax: " + r1.document.inputJax.map(function(t1) {
                            return t1.name;
                        }).join(", ")), t1.push("Output Jax: " + r1.document.outputJax.name), t1.push("Document Type: " + r1.document.kind), t1.join("<br/>");
                    }, '<a href="https://www.mathjax.org">www.mathjax.org</a>'), this.help = new f1.Info("<b>MathJax Help</b>", function() {
                        return [
                            "<p><b>MathJax</b> is a JavaScript library that allows page",
                            " authors to include mathematics within their web pages.",
                            " As a reader, you don't need to do anything to make that happen.</p>",
                            "<p><b>Browsers</b>: MathJax works with all modern browsers including",
                            " Edge, Firefox, Chrome, Safari, Opera, and most mobile browsers.</p>",
                            "<p><b>Math Menu</b>: MathJax adds a contextual menu to equations.",
                            " Right-click or CTRL-click on any mathematics to access the menu.</p>",
                            '<div style="margin-left: 1em;">',
                            "<p><b>Show Math As:</b> These options allow you to view the formula's",
                            " source markup (as MathML or in its original format).</p>",
                            "<p><b>Copy to Clipboard:</b> These options copy the formula's source markup,",
                            " as MathML or in its original format, to the clipboard",
                            " (in browsers that support that).</p>",
                            "<p><b>Math Settings:</b> These give you control over features of MathJax,",
                            " such the size of the mathematics, and the mechanism used",
                            " to display equations.</p>",
                            "<p><b>Accessibility</b>: MathJax can work with screen",
                            " readers to make mathematics accessible to the visually impaired.",
                            " Turn on the explorer to enable generation of speech strings",
                            " and the ability to investigate expressions interactively.</p>",
                            "<p><b>Language</b>: This menu lets you select the language used by MathJax",
                            " for its menus and warning messages. (Not yet implemented in version 3.)</p>",
                            "</div>",
                            "<p><b>Math Zoom</b>: If you are having difficulty reading an",
                            " equation, MathJax can enlarge it to help you see it better, or",
                            " you can scall all the math on the page to make it larger.",
                            " Turn these features on in the <b>Math Settings</b> menu.</p>",
                            "<p><b>Preferences</b>: MathJax uses your browser's localStorage database",
                            " to save the preferences set via this menu locally in your browser.  These",
                            " are not used to track you, and are not transferred or used remotely by",
                            " MathJax in any way.</p>"
                        ].join("\n");
                    }, '<a href="https://www.mathjax.org">www.mathjax.org</a>'), this.mathmlCode = new h1.SelectableInfo("MathJax MathML Expression", function() {
                        if (!r1.menu.mathItem) return "";
                        var t1 = r1.toMML(r1.menu.mathItem);
                        return "<pre>" + r1.formatSource(t1) + "</pre>";
                    }, ""), this.originalText = new h1.SelectableInfo("MathJax Original Source", function() {
                        if (!r1.menu.mathItem) return "";
                        var t1 = r1.menu.mathItem.math;
                        return '<pre style="font-size:125%; margin:0">' + r1.formatSource(t1) + "</pre>";
                    }, ""), this.annotationText = new h1.SelectableInfo("MathJax Annotation Text", function() {
                        if (!r1.menu.mathItem) return "";
                        var t1 = r1.menu.annotation;
                        return '<pre style="font-size:125%; margin:0">' + r1.formatSource(t1) + "</pre>";
                    }, ""), this.zoomBox = new f1.Info("MathJax Zoomed Expression", function() {
                        if (!r1.menu.mathItem) return "";
                        var t1 = r1.menu.mathItem.typesetRoot.cloneNode(!0);
                        return t1.style.margin = "0", '<div style="font-size: ' + 1.25 * parseFloat(r1.settings.zscale) + '%">' + t1.outerHTML + "</div>";
                    }, ""), this.document = t1, this.options = (0, c1.userOptions)((0, c1.defaultOptions)({}, this.constructor.OPTIONS), e1), this.initSettings(), this.mergeUserSettings(), this.initMenu(), this.applySettings();
                }
                return Object.defineProperty(t1.prototype, "isLoading", {
                    get: function() {
                        return t1.loading > 0;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(t1.prototype, "loadingPromise", {
                    get: function() {
                        return this.isLoading ? (t1._loadingPromise || (t1._loadingPromise = new Promise(function(e1, r1) {
                            t1._loadingOK = e1, t1._loadingFailed = r1;
                        })), t1._loadingPromise) : Promise.resolve();
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.initSettings = function() {
                    this.settings = this.options.settings, this.jax = this.options.jax;
                    var t1 = this.document.outputJax;
                    this.jax[t1.name] = t1, this.settings.renderer = t1.name, b1._.a11y && b1._.a11y.explorer && Object.assign(this.settings, this.document.options.a11y), this.settings.scale = t1.options.scale, this.defaultSettings = Object.assign({}, this.settings);
                }, t1.prototype.initMenu = function() {
                    var t1 = this, e1 = new d1.Parser([
                        [
                            "contextMenu",
                            u1.MJContextMenu.fromJson.bind(u1.MJContextMenu)
                        ]
                    ]);
                    this.menu = e1.parse({
                        type: "contextMenu",
                        id: "MathJax_Menu",
                        pool: [
                            this.variable("texHints"),
                            this.variable("semantics"),
                            this.variable("zoom"),
                            this.variable("zscale"),
                            this.variable("renderer", function(e1) {
                                return t1.setRenderer(e1);
                            }),
                            this.variable("alt"),
                            this.variable("cmd"),
                            this.variable("ctrl"),
                            this.variable("shift"),
                            this.variable("scale", function(e1) {
                                return t1.setScale(e1);
                            }),
                            this.variable("explorer", function(e1) {
                                return t1.setExplorer(e1);
                            }),
                            this.a11yVar("highlight"),
                            this.a11yVar("backgroundColor"),
                            this.a11yVar("backgroundOpacity"),
                            this.a11yVar("foregroundColor"),
                            this.a11yVar("foregroundOpacity"),
                            this.a11yVar("speech"),
                            this.a11yVar("subtitles"),
                            this.a11yVar("braille"),
                            this.a11yVar("viewBraille"),
                            this.a11yVar("locale", function(t1) {
                                return g1.default.setupEngine({
                                    locale: t1
                                });
                            }),
                            this.a11yVar("speechRules", function(e1) {
                                var r1 = n1(e1.split("-"), 2), o1 = r1[0], i1 = r1[1];
                                t1.document.options.sre.domain = o1, t1.document.options.sre.style = i1;
                            }),
                            this.a11yVar("magnification"),
                            this.a11yVar("magnify"),
                            this.a11yVar("treeColoring"),
                            this.a11yVar("infoType"),
                            this.a11yVar("infoRole"),
                            this.a11yVar("infoPrefix"),
                            this.variable("autocollapse"),
                            this.variable("collapsible", function(e1) {
                                return t1.setCollapsible(e1);
                            }),
                            this.variable("inTabOrder", function(e1) {
                                return t1.setTabOrder(e1);
                            }),
                            this.variable("assistiveMml", function(e1) {
                                return t1.setAssistiveMml(e1);
                            })
                        ],
                        items: [
                            this.submenu("Show", "Show Math As", [
                                this.command("MathMLcode", "MathML Code", function() {
                                    return t1.mathmlCode.post();
                                }),
                                this.command("Original", "Original Form", function() {
                                    return t1.originalText.post();
                                }),
                                this.submenu("Annotation", "Annotation")
                            ]),
                            this.submenu("Copy", "Copy to Clipboard", [
                                this.command("MathMLcode", "MathML Code", function() {
                                    return t1.copyMathML();
                                }),
                                this.command("Original", "Original Form", function() {
                                    return t1.copyOriginal();
                                }),
                                this.submenu("Annotation", "Annotation")
                            ]),
                            this.rule(),
                            this.submenu("Settings", "Math Settings", [
                                this.submenu("Renderer", "Math Renderer", this.radioGroup("renderer", [
                                    [
                                        "CHTML"
                                    ],
                                    [
                                        "SVG"
                                    ]
                                ])),
                                this.rule(),
                                this.submenu("ZoomTrigger", "Zoom Trigger", [
                                    this.command("ZoomNow", "Zoom Once Now", function() {
                                        return t1.zoom(null, "", t1.menu.mathItem);
                                    }),
                                    this.rule(),
                                    this.radioGroup("zoom", [
                                        [
                                            "Click"
                                        ],
                                        [
                                            "DoubleClick",
                                            "Double-Click"
                                        ],
                                        [
                                            "NoZoom",
                                            "No Zoom"
                                        ]
                                    ]),
                                    this.rule(),
                                    this.label("TriggerRequires", "Trigger Requires:"),
                                    this.checkbox(v1 ? "Option" : "Alt", v1 ? "Option" : "Alt", "alt"),
                                    this.checkbox("Command", "Command", "cmd", {
                                        hidden: !v1
                                    }),
                                    this.checkbox("Control", "Control", "ctrl", {
                                        hiddne: v1
                                    }),
                                    this.checkbox("Shift", "Shift", "shift")
                                ]),
                                this.submenu("ZoomFactor", "Zoom Factor", this.radioGroup("zscale", [
                                    [
                                        "150%"
                                    ],
                                    [
                                        "175%"
                                    ],
                                    [
                                        "200%"
                                    ],
                                    [
                                        "250%"
                                    ],
                                    [
                                        "300%"
                                    ],
                                    [
                                        "400%"
                                    ]
                                ])),
                                this.rule(),
                                this.command("Scale", "Scale All Math...", function() {
                                    return t1.scaleAllMath();
                                }),
                                this.rule(),
                                this.checkbox("texHints", "Add TeX hints to MathML", "texHints"),
                                this.checkbox("semantics", "Add original as annotation", "semantics"),
                                this.rule(),
                                this.command("Reset", "Reset to defaults", function() {
                                    return t1.resetDefaults();
                                })
                            ]),
                            this.submenu("Accessibility", "Accessibility", [
                                this.checkbox("Activate", "Activate", "explorer"),
                                this.submenu("Speech", "Speech", [
                                    this.checkbox("Speech", "Speech Output", "speech"),
                                    this.checkbox("Subtitles", "Speech Subtitles", "subtitles"),
                                    this.checkbox("Braille", "Braille Output", "braille"),
                                    this.checkbox("View Braille", "Braille Subtitles", "viewBraille"),
                                    this.rule(),
                                    this.submenu("A11yLanguage", "Language"),
                                    this.rule(),
                                    this.submenu("Mathspeak", "Mathspeak Rules", this.radioGroup("speechRules", [
                                        [
                                            "mathspeak-default",
                                            "Verbose"
                                        ],
                                        [
                                            "mathspeak-brief",
                                            "Brief"
                                        ],
                                        [
                                            "mathspeak-sbrief",
                                            "Superbrief"
                                        ]
                                    ])),
                                    this.submenu("Clearspeak", "Clearspeak Rules", this.radioGroup("speechRules", [
                                        [
                                            "clearspeak-default",
                                            "Auto"
                                        ]
                                    ])),
                                    this.submenu("ChromeVox", "ChromeVox Rules", this.radioGroup("speechRules", [
                                        [
                                            "chromevox-default",
                                            "Standard"
                                        ],
                                        [
                                            "chromevox-alternative",
                                            "Alternative"
                                        ]
                                    ]))
                                ]),
                                this.submenu("Highlight", "Highlight", [
                                    this.submenu("Background", "Background", this.radioGroup("backgroundColor", [
                                        [
                                            "Blue"
                                        ],
                                        [
                                            "Red"
                                        ],
                                        [
                                            "Green"
                                        ],
                                        [
                                            "Yellow"
                                        ],
                                        [
                                            "Cyan"
                                        ],
                                        [
                                            "Magenta"
                                        ],
                                        [
                                            "White"
                                        ],
                                        [
                                            "Black"
                                        ]
                                    ])),
                                    {
                                        type: "slider",
                                        variable: "backgroundOpacity",
                                        content: " "
                                    },
                                    this.submenu("Foreground", "Foreground", this.radioGroup("foregroundColor", [
                                        [
                                            "Black"
                                        ],
                                        [
                                            "White"
                                        ],
                                        [
                                            "Magenta"
                                        ],
                                        [
                                            "Cyan"
                                        ],
                                        [
                                            "Yellow"
                                        ],
                                        [
                                            "Green"
                                        ],
                                        [
                                            "Red"
                                        ],
                                        [
                                            "Blue"
                                        ]
                                    ])),
                                    {
                                        type: "slider",
                                        variable: "foregroundOpacity",
                                        content: " "
                                    },
                                    this.rule(),
                                    this.radioGroup("highlight", [
                                        [
                                            "None"
                                        ],
                                        [
                                            "Hover"
                                        ],
                                        [
                                            "Flame"
                                        ]
                                    ]),
                                    this.rule(),
                                    this.checkbox("TreeColoring", "Tree Coloring", "treeColoring")
                                ]),
                                this.submenu("Magnification", "Magnification", [
                                    this.radioGroup("magnification", [
                                        [
                                            "None"
                                        ],
                                        [
                                            "Keyboard"
                                        ],
                                        [
                                            "Mouse"
                                        ]
                                    ]),
                                    this.rule(),
                                    this.radioGroup("magnify", [
                                        [
                                            "200%"
                                        ],
                                        [
                                            "300%"
                                        ],
                                        [
                                            "400%"
                                        ],
                                        [
                                            "500%"
                                        ]
                                    ])
                                ]),
                                this.submenu("Semantic Info", "Semantic Info", [
                                    this.checkbox("Type", "Type", "infoType"),
                                    this.checkbox("Role", "Role", "infoRole"),
                                    this.checkbox("Prefix", "Prefix", "infoPrefix")
                                ], !0),
                                this.rule(),
                                this.checkbox("Collapsible", "Collapsible Math", "collapsible"),
                                this.checkbox("AutoCollapse", "Auto Collapse", "autocollapse", {
                                    disabled: !0
                                }),
                                this.rule(),
                                this.checkbox("InTabOrder", "Include in Tab Order", "inTabOrder"),
                                this.checkbox("AssistiveMml", "Include Hidden MathML", "assistiveMml")
                            ]),
                            this.submenu("Language", "Language"),
                            this.rule(),
                            this.command("About", "About MathJax", function() {
                                return t1.about.post();
                            }),
                            this.command("Help", "MathJax Help", function() {
                                return t1.help.post();
                            })
                        ]
                    });
                    var r1 = this.menu;
                    this.about.attachMenu(r1), this.help.attachMenu(r1), this.originalText.attachMenu(r1), this.annotationText.attachMenu(r1), this.mathmlCode.attachMenu(r1), this.zoomBox.attachMenu(r1), this.checkLoadableItems(), this.enableExplorerItems(this.settings.explorer), r1.showAnnotation = this.annotationText, r1.copyAnnotation = this.copyAnnotation.bind(this), r1.annotationTypes = this.options.annotationTypes, y1.CssStyles.addInfoStyles(this.document.document), y1.CssStyles.addMenuStyles(this.document.document);
                }, t1.prototype.checkLoadableItems = function() {
                    var t1, e1;
                    if (b1 && b1._ && b1.loader && b1.startup) !this.settings.collapsible || b1._.a11y && b1._.a11y.complexity || this.loadA11y("complexity"), !this.settings.explorer || b1._.a11y && b1._.a11y.explorer || this.loadA11y("explorer"), !this.settings.assistiveMml || b1._.a11y && b1._.a11y["assistive-mml"] || this.loadA11y("assistive-mml");
                    else {
                        var r1 = this.menu;
                        try {
                            for(var n1 = o1(Object.keys(this.jax)), i1 = n1.next(); !i1.done; i1 = n1.next()){
                                var s1 = i1.value;
                                this.jax[s1] || r1.findID("Settings", "Renderer", s1).disable();
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                i1 && !i1.done && (e1 = n1.return) && e1.call(n1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        r1.findID("Accessibility", "Activate").disable(), r1.findID("Accessibility", "AutoCollapse").disable(), r1.findID("Accessibility", "Collapsible").disable();
                    }
                }, t1.prototype.enableExplorerItems = function(t1) {
                    var e1, r1, n1 = this.menu.findID("Accessibility", "Activate").menu;
                    try {
                        for(var i1 = o1(n1.items.slice(1)), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value;
                            if (a1 instanceof m1.Rule) break;
                            t1 ? a1.enable() : a1.disable();
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.mergeUserSettings = function() {
                    try {
                        var e1 = localStorage.getItem(t1.MENU_STORAGE);
                        if (!e1) return;
                        Object.assign(this.settings, JSON.parse(e1)), this.setA11y(this.settings);
                    } catch (t1) {
                        console.log("MathJax localStorage error: " + t1.message);
                    }
                }, t1.prototype.saveUserSettings = function() {
                    var e1, r1, n1 = {};
                    try {
                        for(var i1 = o1(Object.keys(this.settings)), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value;
                            this.settings[a1] !== this.defaultSettings[a1] && (n1[a1] = this.settings[a1]);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    try {
                        Object.keys(n1).length ? localStorage.setItem(t1.MENU_STORAGE, JSON.stringify(n1)) : localStorage.removeItem(t1.MENU_STORAGE);
                    } catch (t1) {
                        console.log("MathJax localStorage error: " + t1.message);
                    }
                }, t1.prototype.setA11y = function(t1) {
                    b1._.a11y && b1._.a11y.explorer && b1._.a11y.explorer_ts.setA11yOptions(this.document, t1);
                }, t1.prototype.getA11y = function(t1) {
                    if (b1._.a11y && b1._.a11y.explorer) return void 0 !== this.document.options.a11y[t1] ? this.document.options.a11y[t1] : this.document.options.sre[t1];
                }, t1.prototype.applySettings = function() {
                    this.setTabOrder(this.settings.inTabOrder), this.document.options.enableAssistiveMml = this.settings.assistiveMml, this.document.outputJax.options.scale = parseFloat(this.settings.scale), this.settings.renderer !== this.defaultSettings.renderer && this.setRenderer(this.settings.renderer);
                }, t1.prototype.setScale = function(t1) {
                    this.document.outputJax.options.scale = parseFloat(t1), this.document.rerender();
                }, t1.prototype.setRenderer = function(t1) {
                    var e1 = this;
                    if (this.jax[t1]) this.setOutputJax(t1);
                    else {
                        var r1 = t1.toLowerCase();
                        this.loadComponent("output/" + r1, function() {
                            var n1 = b1.startup;
                            r1 in n1.constructors && (n1.useOutput(r1, !0), n1.output = n1.getOutputJax(), e1.jax[t1] = n1.output, e1.setOutputJax(t1));
                        });
                    }
                }, t1.prototype.setOutputJax = function(t1) {
                    this.jax[t1].setAdaptor(this.document.adaptor), this.document.outputJax = this.jax[t1], this.rerender();
                }, t1.prototype.setTabOrder = function(t1) {
                    this.menu.store.inTaborder(t1);
                }, t1.prototype.setAssistiveMml = function(t1) {
                    this.document.options.enableAssistiveMml = t1, !t1 || b1._.a11y && b1._.a11y["assistive-mml"] ? this.rerender() : this.loadA11y("assistive-mml");
                }, t1.prototype.setExplorer = function(t1) {
                    this.enableExplorerItems(t1), this.document.options.enableExplorer = t1, !t1 || b1._.a11y && b1._.a11y.explorer ? this.rerender(this.settings.collapsible ? a1.STATE.RERENDER : a1.STATE.COMPILED) : this.loadA11y("explorer");
                }, t1.prototype.setCollapsible = function(t1) {
                    this.document.options.enableComplexity = t1, !t1 || b1._.a11y && b1._.a11y.complexity ? this.rerender(a1.STATE.COMPILED) : this.loadA11y("complexity");
                }, t1.prototype.scaleAllMath = function() {
                    var t1 = (100 * parseFloat(this.settings.scale)).toFixed(1).replace(/.0$/, ""), e1 = prompt("Scale all mathematics (compared to surrounding text) by", t1 + "%");
                    if (e1) {
                        if (e1.match(/^\s*\d+(\.\d*)?\s*%?\s*$/)) {
                            var r1 = parseFloat(e1) / 100;
                            r1 ? this.menu.pool.lookup("scale").setValue(String(r1)) : alert("The scale should not be zero");
                        } else alert("The scale should be a percentage (e.g., 120%)");
                    }
                }, t1.prototype.resetDefaults = function() {
                    var e1, r1;
                    t1.loading++;
                    var n1 = this.menu.pool, i1 = this.defaultSettings;
                    try {
                        for(var s1 = o1(Object.keys(this.settings)), l1 = s1.next(); !l1.done; l1 = s1.next()){
                            var c1 = l1.value, u1 = n1.lookup(c1);
                            if (u1) {
                                u1.setValue(i1[c1]);
                                var p1 = u1.items[0];
                                p1 && p1.executeCallbacks_();
                            } else this.settings[c1] = i1[c1];
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (r1 = s1.return) && r1.call(s1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    t1.loading--, this.rerender(a1.STATE.COMPILED);
                }, t1.prototype.checkComponent = function(e1) {
                    var r1 = t1.loadingPromises.get(e1);
                    r1 && s1.mathjax.retryAfter(r1);
                }, t1.prototype.loadComponent = function(e1, r1) {
                    if (!t1.loadingPromises.has(e1)) {
                        var n1 = b1.loader;
                        if (n1) {
                            t1.loading++;
                            var o1 = n1.load(e1).then(function() {
                                t1.loading--, t1.loadingPromises.delete(e1), r1(), 0 === t1.loading && t1._loadingPromise && (t1._loadingPromise = null, t1._loadingOK());
                            }).catch(function(e1) {
                                t1._loadingPromise ? (t1._loadingPromise = null, t1._loadingFailed(e1)) : console.log(e1);
                            });
                            t1.loadingPromises.set(e1, o1);
                        }
                    }
                }, t1.prototype.loadA11y = function(e1) {
                    var r1 = this, n1 = !a1.STATE.ENRICHED;
                    this.loadComponent("a11y/" + e1, function() {
                        var o1 = b1.startup;
                        s1.mathjax.handlers.unregister(o1.handler), o1.handler = o1.getHandler(), s1.mathjax.handlers.register(o1.handler);
                        var i1 = r1.document;
                        r1.document = o1.document = o1.getDocument(), r1.document.menu = r1, r1.document.outputJax.reset(), r1.transferMathList(i1), r1.document.processed = i1.processed, t1._loadingPromise || (r1.document.outputJax.reset(), r1.rerender("complexity" === e1 || n1 ? a1.STATE.COMPILED : a1.STATE.TYPESET));
                    });
                }, t1.prototype.transferMathList = function(t1) {
                    var e1, r1, n1 = this.document.options.MathItem;
                    try {
                        for(var i1 = o1(t1.math), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value, l1 = new n1;
                            Object.assign(l1, a1), this.document.math.push(l1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.formatSource = function(t1) {
                    return t1.trim().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                }, t1.prototype.toMML = function(t1) {
                    return this.MmlVisitor.visitTree(t1.root, t1, {
                        texHints: this.settings.texHints,
                        semantics: this.settings.semantics && "MathML" !== t1.inputJax.name
                    });
                }, t1.prototype.zoom = function(t1, e1, r1) {
                    t1 && !this.isZoomEvent(t1, e1) || (this.menu.mathItem = r1, t1 && this.menu.post(t1), this.zoomBox.post());
                }, t1.prototype.isZoomEvent = function(t1, e1) {
                    return this.settings.zoom === e1 && (!this.settings.alt || t1.altKey) && (!this.settings.ctrl || t1.ctrlKey) && (!this.settings.cmd || t1.metaKey) && (!this.settings.shift || t1.shiftKey);
                }, t1.prototype.rerender = function(e1) {
                    void 0 === e1 && (e1 = a1.STATE.TYPESET), this.rerenderStart = Math.min(e1, this.rerenderStart), t1.loading || (this.rerenderStart <= a1.STATE.COMPILED && this.document.reset({
                        inputJax: []
                    }), this.document.rerender(this.rerenderStart), this.rerenderStart = a1.STATE.LAST);
                }, t1.prototype.copyMathML = function() {
                    this.copyToClipboard(this.toMML(this.menu.mathItem));
                }, t1.prototype.copyOriginal = function() {
                    this.copyToClipboard(this.menu.mathItem.math.trim());
                }, t1.prototype.copyAnnotation = function() {
                    this.copyToClipboard(this.menu.annotation.trim());
                }, t1.prototype.copyToClipboard = function(t1) {
                    var e1 = document.createElement("textarea");
                    e1.value = t1, e1.setAttribute("readonly", ""), e1.style.cssText = "height: 1px; width: 1px; padding: 1px; position: absolute; left: -10px", document.body.appendChild(e1), e1.select();
                    try {
                        document.execCommand("copy");
                    } catch (t1) {
                        alert("Can't copy to clipboard: " + t1.message);
                    }
                    document.body.removeChild(e1);
                }, t1.prototype.addMenu = function(t1) {
                    var e1 = this, r1 = t1.typesetRoot;
                    r1.addEventListener("contextmenu", function() {
                        return e1.menu.mathItem = t1;
                    }, !0), r1.addEventListener("keydown", function() {
                        return e1.menu.mathItem = t1;
                    }, !0), r1.addEventListener("click", function(r1) {
                        return e1.zoom(r1, "Click", t1);
                    }, !0), r1.addEventListener("dblclick", function(r1) {
                        return e1.zoom(r1, "DoubleClick", t1);
                    }, !0), this.menu.store.insert(r1);
                }, t1.prototype.clear = function() {
                    this.menu.store.clear();
                }, t1.prototype.variable = function(t1, e1) {
                    var r1 = this;
                    return {
                        name: t1,
                        getter: function() {
                            return r1.settings[t1];
                        },
                        setter: function(n1) {
                            r1.settings[t1] = n1, e1 && e1(n1), r1.saveUserSettings();
                        }
                    };
                }, t1.prototype.a11yVar = function(t1, e1) {
                    var r1 = this;
                    return {
                        name: t1,
                        getter: function() {
                            return r1.getA11y(t1);
                        },
                        setter: function(n1) {
                            r1.settings[t1] = n1;
                            var o1 = {};
                            o1[t1] = n1, r1.setA11y(o1), e1 && e1(n1), r1.saveUserSettings();
                        }
                    };
                }, t1.prototype.submenu = function(t1, e1, r1, n1) {
                    var i1, s1;
                    void 0 === r1 && (r1 = []), void 0 === n1 && (n1 = !1);
                    var a1 = [];
                    try {
                        for(var l1 = o1(r1), c1 = l1.next(); !c1.done; c1 = l1.next()){
                            var u1 = c1.value;
                            Array.isArray(u1) ? a1 = a1.concat(u1) : a1.push(u1);
                        }
                    } catch (t1) {
                        i1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            c1 && !c1.done && (s1 = l1.return) && s1.call(l1);
                        } finally{
                            if (i1) throw i1.error;
                        }
                    }
                    return {
                        type: "submenu",
                        id: t1,
                        content: e1,
                        menu: {
                            items: a1
                        },
                        disabled: 0 === a1.length || n1
                    };
                }, t1.prototype.command = function(t1, e1, r1, n1) {
                    return void 0 === n1 && (n1 = {}), Object.assign({
                        type: "command",
                        id: t1,
                        content: e1,
                        action: r1
                    }, n1);
                }, t1.prototype.checkbox = function(t1, e1, r1, n1) {
                    return void 0 === n1 && (n1 = {}), Object.assign({
                        type: "checkbox",
                        id: t1,
                        content: e1,
                        variable: r1
                    }, n1);
                }, t1.prototype.radioGroup = function(t1, e1) {
                    var r1 = this;
                    return e1.map(function(e1) {
                        return r1.radio(e1[0], e1[1] || e1[0], t1);
                    });
                }, t1.prototype.radio = function(t1, e1, r1, n1) {
                    return void 0 === n1 && (n1 = {}), Object.assign({
                        type: "radio",
                        id: t1,
                        content: e1,
                        variable: r1
                    }, n1);
                }, t1.prototype.label = function(t1, e1) {
                    return {
                        type: "label",
                        id: t1,
                        content: e1
                    };
                }, t1.prototype.rule = function() {
                    return {
                        type: "rule"
                    };
                }, t1.MENU_STORAGE = "MathJax-Menu-Settings", t1.OPTIONS = {
                    settings: {
                        texHints: !0,
                        semantics: !1,
                        zoom: "NoZoom",
                        zscale: "200%",
                        renderer: "CHTML",
                        alt: !1,
                        cmd: !1,
                        ctrl: !1,
                        shift: !1,
                        scale: 1,
                        autocollapse: !1,
                        collapsible: !1,
                        inTabOrder: !0,
                        assistiveMml: !0,
                        explorer: !1
                    },
                    jax: {
                        CHTML: null,
                        SVG: null
                    },
                    annotationTypes: (0, c1.expandable)({
                        TeX: [
                            "TeX",
                            "LaTeX",
                            "application/x-tex"
                        ],
                        StarMath: [
                            "StarMath 5.0"
                        ],
                        Maple: [
                            "Maple"
                        ],
                        ContentMathML: [
                            "MathML-Content",
                            "application/mathml-content+xml"
                        ],
                        OpenMath: [
                            "OpenMath"
                        ]
                    })
                }, t1.loading = 0, t1.loadingPromises = new Map, t1._loadingPromise = null, t1._loadingOK = null, t1._loadingFailed = null, t1;
            }();
            e1.Menu = _1;
        },
        4001: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__assign || function() {
                return i1 = Object.assign || function(t1) {
                    for(var e1, r1 = 1, n1 = arguments.length; r1 < n1; r1++)for(var o1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, o1) && (t1[o1] = e1[o1]);
                    return t1;
                }, i1.apply(this, arguments);
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, l1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MenuHandler = e1.MenuMathDocumentMixin = e1.MenuMathItemMixin = void 0;
            var c1 = r1(5713), u1 = r1(4474), p1 = r1(7233), h1 = r1(8310);
            function f1(t1) {
                return function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return o1(e1, t1), e1.prototype.addMenu = function(t1, e1) {
                        void 0 === e1 && (e1 = !1), this.state() >= u1.STATE.CONTEXT_MENU || (this.isEscaped || !t1.options.enableMenu && !e1 || t1.menu.addMenu(this), this.state(u1.STATE.CONTEXT_MENU));
                    }, e1.prototype.checkLoading = function(t1) {
                        t1.checkLoading();
                    }, e1;
                }(t1);
            }
            function d1(t1) {
                var e1;
                return e1 = function(t1) {
                    function e1() {
                        for(var e1 = [], r1 = 0; r1 < arguments.length; r1++)e1[r1] = arguments[r1];
                        var n1 = t1.apply(this, a1([], s1(e1), !1)) || this;
                        n1.menu = new n1.options.MenuClass(n1, n1.options.menuOptions);
                        var o1 = n1.constructor.ProcessBits;
                        return o1.has("context-menu") || o1.allocate("context-menu"), n1.options.MathItem = f1(n1.options.MathItem), n1;
                    }
                    return o1(e1, t1), e1.prototype.addMenu = function() {
                        var t1, e1;
                        if (!this.processed.isSet("context-menu")) {
                            try {
                                for(var r1 = l1(this.math), n1 = r1.next(); !n1.done; n1 = r1.next())n1.value.addMenu(this);
                            } catch (e1) {
                                t1 = {
                                    error: e1
                                };
                            } finally{
                                try {
                                    n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                                } finally{
                                    if (t1) throw t1.error;
                                }
                            }
                            this.processed.set("context-menu");
                        }
                        return this;
                    }, e1.prototype.checkLoading = function() {
                        this.menu.isLoading && c1.mathjax.retryAfter(this.menu.loadingPromise.catch(function(t1) {
                            return console.log(t1);
                        }));
                        var t1 = this.menu.settings;
                        return t1.collapsible && (this.options.enableComplexity = !0, this.menu.checkComponent("a11y/complexity")), t1.explorer && (this.options.enableEnrichment = !0, this.options.enableExplorer = !0, this.menu.checkComponent("a11y/explorer")), this;
                    }, e1.prototype.state = function(e1, r1) {
                        return void 0 === r1 && (r1 = !1), t1.prototype.state.call(this, e1, r1), e1 < u1.STATE.CONTEXT_MENU && this.processed.clear("context-menu"), this;
                    }, e1.prototype.updateDocument = function() {
                        return t1.prototype.updateDocument.call(this), this.menu.menu.store.sort(), this;
                    }, e1;
                }(t1), e1.OPTIONS = i1(i1({
                    enableEnrichment: !0,
                    enableComplexity: !0,
                    enableExplorer: !0,
                    enrichSpeech: "none",
                    enrichError: function(t1, e1, r1) {
                        return console.warn("Enrichment Error:", r1);
                    }
                }, t1.OPTIONS), {
                    MenuClass: h1.Menu,
                    menuOptions: h1.Menu.OPTIONS,
                    enableMenu: !0,
                    sre: t1.OPTIONS.sre || (0, p1.expandable)({}),
                    a11y: t1.OPTIONS.a11y || (0, p1.expandable)({}),
                    renderActions: (0, p1.expandable)(i1(i1({}, t1.OPTIONS.renderActions), {
                        addMenu: [
                            u1.STATE.CONTEXT_MENU
                        ],
                        checkLoading: [
                            u1.STATE.UNPROCESSED + 1
                        ]
                    }))
                }), e1;
            }
            (0, u1.newState)("CONTEXT_MENU", 170), e1.MenuMathItemMixin = f1, e1.MenuMathDocumentMixin = d1, e1.MenuHandler = function(t1) {
                return t1.documentClass = d1(t1.documentClass), t1;
            };
        },
        473: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlVisitor = void 0;
            var i1 = r1(9259), s1 = r1(7233), a1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.options = {
                        texHints: !0,
                        semantics: !1
                    }, e1.mathItem = null, e1;
                }
                return o1(e1, t1), e1.prototype.visitTree = function(t1, e1, r1) {
                    return void 0 === e1 && (e1 = null), void 0 === r1 && (r1 = {}), this.mathItem = e1, (0, s1.userOptions)(this.options, r1), this.visitNode(t1, "");
                }, e1.prototype.visitTeXAtomNode = function(e1, r1) {
                    return this.options.texHints ? t1.prototype.visitTeXAtomNode.call(this, e1, r1) : e1.childNodes[0] && 1 === e1.childNodes[0].childNodes.length ? this.visitNode(e1.childNodes[0], r1) : r1 + "<mrow" + this.getAttributes(e1) + ">\n" + this.childNodeMml(e1, r1 + "  ", "\n") + r1 + "</mrow>";
                }, e1.prototype.visitMathNode = function(e1, r1) {
                    if (!this.options.semantics || "TeX" !== this.mathItem.inputJax.name) return t1.prototype.visitDefault.call(this, e1, r1);
                    var n1 = e1.childNodes.length && e1.childNodes[0].childNodes.length > 1;
                    return r1 + "<math" + this.getAttributes(e1) + ">\n" + r1 + "  <semantics>\n" + (n1 ? r1 + "    <mrow>\n" : "") + this.childNodeMml(e1, r1 + (n1 ? "      " : "    "), "\n") + (n1 ? r1 + "    </mrow>\n" : "") + r1 + '    <annotation encoding="application/x-tex">' + this.mathItem.math + "</annotation>\n" + r1 + "  </semantics>\n" + r1 + "</math>";
                }, e1;
            }(i1.SerializedMmlVisitor);
            e1.MmlVisitor = a1;
        },
        4414: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SelectableInfo = void 0;
            var i1 = r1(4922), s1 = r1(2165), a1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.addEvents = function(t1) {
                    var e1 = this;
                    t1.addEventListener("keypress", function(t1) {
                        "a" === t1.key && (t1.ctrlKey || t1.metaKey) && (e1.selectAll(), e1.stop(t1));
                    });
                }, e1.prototype.selectAll = function() {
                    document.getSelection().selectAllChildren(this.html.querySelector("pre"));
                }, e1.prototype.copyToClipboard = function() {
                    this.selectAll();
                    try {
                        document.execCommand("copy");
                    } catch (t1) {
                        alert("Can't copy to clipboard: " + t1.message);
                    }
                    document.getSelection().removeAllRanges();
                }, e1.prototype.generateHtml = function() {
                    var e1 = this;
                    t1.prototype.generateHtml.call(this);
                    var r1 = this.html.querySelector("span." + s1.HtmlClasses.INFOSIGNATURE).appendChild(document.createElement("input"));
                    r1.type = "button", r1.value = "Copy to Clipboard", r1.addEventListener("click", function(t1) {
                        return e1.copyToClipboard();
                    });
                }, e1;
            }(i1.Info);
            e1.SelectableInfo = a1;
        },
        9923: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.asyncLoad = void 0;
            var n1 = r1(5713);
            e1.asyncLoad = function(t1) {
                return n1.mathjax.asyncLoad ? new Promise(function(e1, r1) {
                    var o1 = n1.mathjax.asyncLoad(t1);
                    o1 instanceof Promise ? o1.then(function(t1) {
                        return e1(t1);
                    }).catch(function(t1) {
                        return r1(t1);
                    }) : e1(o1);
                }) : Promise.reject("Can't load '".concat(t1, "': No asyncLoad method specified"));
            };
        },
        6469: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BBox = void 0;
            var n1 = r1(6010), o1 = function() {
                function t1(t1) {
                    void 0 === t1 && (t1 = {
                        w: 0,
                        h: -n1.BIGDIMEN,
                        d: -n1.BIGDIMEN
                    }), this.w = t1.w || 0, this.h = "h" in t1 ? t1.h : -n1.BIGDIMEN, this.d = "d" in t1 ? t1.d : -n1.BIGDIMEN, this.L = this.R = this.ic = this.sk = this.dx = 0, this.scale = this.rscale = 1, this.pwidth = "";
                }
                return t1.zero = function() {
                    return new t1({
                        h: 0,
                        d: 0,
                        w: 0
                    });
                }, t1.empty = function() {
                    return new t1;
                }, t1.prototype.empty = function() {
                    return this.w = 0, this.h = this.d = -n1.BIGDIMEN, this;
                }, t1.prototype.clean = function() {
                    this.w === -n1.BIGDIMEN && (this.w = 0), this.h === -n1.BIGDIMEN && (this.h = 0), this.d === -n1.BIGDIMEN && (this.d = 0);
                }, t1.prototype.rescale = function(t1) {
                    this.w *= t1, this.h *= t1, this.d *= t1;
                }, t1.prototype.combine = function(t1, e1, r1) {
                    void 0 === e1 && (e1 = 0), void 0 === r1 && (r1 = 0);
                    var n1 = t1.rscale, o1 = e1 + n1 * (t1.w + t1.L + t1.R), i1 = r1 + n1 * t1.h, s1 = n1 * t1.d - r1;
                    o1 > this.w && (this.w = o1), i1 > this.h && (this.h = i1), s1 > this.d && (this.d = s1);
                }, t1.prototype.append = function(t1) {
                    var e1 = t1.rscale;
                    this.w += e1 * (t1.w + t1.L + t1.R), e1 * t1.h > this.h && (this.h = e1 * t1.h), e1 * t1.d > this.d && (this.d = e1 * t1.d);
                }, t1.prototype.updateFrom = function(t1) {
                    this.h = t1.h, this.d = t1.d, this.w = t1.w, t1.pwidth && (this.pwidth = t1.pwidth);
                }, t1.fullWidth = "100%", t1.StyleAdjust = [
                    [
                        "borderTopWidth",
                        "h"
                    ],
                    [
                        "borderRightWidth",
                        "w"
                    ],
                    [
                        "borderBottomWidth",
                        "d"
                    ],
                    [
                        "borderLeftWidth",
                        "w",
                        0
                    ],
                    [
                        "paddingTop",
                        "h"
                    ],
                    [
                        "paddingRight",
                        "w"
                    ],
                    [
                        "paddingBottom",
                        "d"
                    ],
                    [
                        "paddingLeft",
                        "w",
                        0
                    ]
                ], t1;
            }();
            e1.BBox = o1;
        },
        6751: function(t1, e1) {
            var r1, n1 = this && this.__extends || (r1 = function(t1, e1) {
                return r1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, r1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function n1() {
                    this.constructor = t1;
                }
                r1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (n1.prototype = e1.prototype, new n1);
            }), o1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, s1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BitFieldClass = e1.BitField = void 0;
            var a1 = function() {
                function t1() {
                    this.bits = 0;
                }
                return t1.allocate = function() {
                    for(var e1, r1, n1 = [], i1 = 0; i1 < arguments.length; i1++)n1[i1] = arguments[i1];
                    try {
                        for(var s1 = o1(n1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            if (this.has(l1)) throw new Error("Bit already allocated for " + l1);
                            if (this.next === t1.MAXBIT) throw new Error("Maximum number of bits already allocated");
                            this.names.set(l1, this.next), this.next <<= 1;
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (r1 = s1.return) && r1.call(s1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.has = function(t1) {
                    return this.names.has(t1);
                }, t1.prototype.set = function(t1) {
                    this.bits |= this.getBit(t1);
                }, t1.prototype.clear = function(t1) {
                    this.bits &= ~this.getBit(t1);
                }, t1.prototype.isSet = function(t1) {
                    return !!(this.bits & this.getBit(t1));
                }, t1.prototype.reset = function() {
                    this.bits = 0;
                }, t1.prototype.getBit = function(t1) {
                    var e1 = this.constructor.names.get(t1);
                    if (!e1) throw new Error("Unknown bit-field name: " + t1);
                    return e1;
                }, t1.MAXBIT = -2147483648, t1.next = 1, t1.names = new Map, t1;
            }();
            e1.BitField = a1, e1.BitFieldClass = function() {
                for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1[e1] = arguments[e1];
                var r1 = function(t1) {
                    function e1() {
                        return null !== t1 && t1.apply(this, arguments) || this;
                    }
                    return n1(e1, t1), e1;
                }(a1);
                return r1.allocate.apply(r1, s1([], i1(t1), !1)), r1;
            };
        },
        5368: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.numeric = e1.translate = e1.remove = e1.add = e1.entities = e1.options = void 0;
            var n1 = r1(4542), o1 = r1(9923);
            e1.options = {
                loadMissingEntities: !0
            }, e1.entities = {
                ApplyFunction: "⁡",
                Backslash: "∖",
                Because: "∵",
                Breve: "˘",
                Cap: "⋒",
                CenterDot: "\xb7",
                CircleDot: "⊙",
                CircleMinus: "⊖",
                CirclePlus: "⊕",
                CircleTimes: "⊗",
                Congruent: "≡",
                ContourIntegral: "∮",
                Coproduct: "∐",
                Cross: "⨯",
                Cup: "⋓",
                CupCap: "≍",
                Dagger: "‡",
                Del: "∇",
                Delta: "Δ",
                Diamond: "⋄",
                DifferentialD: "ⅆ",
                DotEqual: "≐",
                DoubleDot: "\xa8",
                DoubleRightTee: "⊨",
                DoubleVerticalBar: "∥",
                DownArrow: "↓",
                DownLeftVector: "↽",
                DownRightVector: "⇁",
                DownTee: "⊤",
                Downarrow: "⇓",
                Element: "∈",
                EqualTilde: "≂",
                Equilibrium: "⇌",
                Exists: "∃",
                ExponentialE: "ⅇ",
                FilledVerySmallSquare: "▪",
                ForAll: "∀",
                Gamma: "Γ",
                Gg: "⋙",
                GreaterEqual: "≥",
                GreaterEqualLess: "⋛",
                GreaterFullEqual: "≧",
                GreaterLess: "≷",
                GreaterSlantEqual: "⩾",
                GreaterTilde: "≳",
                Hacek: "ˇ",
                Hat: "^",
                HumpDownHump: "≎",
                HumpEqual: "≏",
                Im: "ℑ",
                ImaginaryI: "ⅈ",
                Integral: "∫",
                Intersection: "⋂",
                InvisibleComma: "⁣",
                InvisibleTimes: "⁢",
                Lambda: "Λ",
                Larr: "↞",
                LeftAngleBracket: "⟨",
                LeftArrow: "←",
                LeftArrowRightArrow: "⇆",
                LeftCeiling: "⌈",
                LeftDownVector: "⇃",
                LeftFloor: "⌊",
                LeftRightArrow: "↔",
                LeftTee: "⊣",
                LeftTriangle: "⊲",
                LeftTriangleEqual: "⊴",
                LeftUpVector: "↿",
                LeftVector: "↼",
                Leftarrow: "⇐",
                Leftrightarrow: "⇔",
                LessEqualGreater: "⋚",
                LessFullEqual: "≦",
                LessGreater: "≶",
                LessSlantEqual: "⩽",
                LessTilde: "≲",
                Ll: "⋘",
                Lleftarrow: "⇚",
                LongLeftArrow: "⟵",
                LongLeftRightArrow: "⟷",
                LongRightArrow: "⟶",
                Longleftarrow: "⟸",
                Longleftrightarrow: "⟺",
                Longrightarrow: "⟹",
                Lsh: "↰",
                MinusPlus: "∓",
                NestedGreaterGreater: "≫",
                NestedLessLess: "≪",
                NotDoubleVerticalBar: "∦",
                NotElement: "∉",
                NotEqual: "≠",
                NotExists: "∄",
                NotGreater: "≯",
                NotGreaterEqual: "≱",
                NotLeftTriangle: "⋪",
                NotLeftTriangleEqual: "⋬",
                NotLess: "≮",
                NotLessEqual: "≰",
                NotPrecedes: "⊀",
                NotPrecedesSlantEqual: "⋠",
                NotRightTriangle: "⋫",
                NotRightTriangleEqual: "⋭",
                NotSubsetEqual: "⊈",
                NotSucceeds: "⊁",
                NotSucceedsSlantEqual: "⋡",
                NotSupersetEqual: "⊉",
                NotTilde: "≁",
                NotVerticalBar: "∤",
                Omega: "Ω",
                OverBar: "‾",
                OverBrace: "⏞",
                PartialD: "∂",
                Phi: "Φ",
                Pi: "Π",
                PlusMinus: "\xb1",
                Precedes: "≺",
                PrecedesEqual: "⪯",
                PrecedesSlantEqual: "≼",
                PrecedesTilde: "≾",
                Product: "∏",
                Proportional: "∝",
                Psi: "Ψ",
                Rarr: "↠",
                Re: "ℜ",
                ReverseEquilibrium: "⇋",
                RightAngleBracket: "⟩",
                RightArrow: "→",
                RightArrowLeftArrow: "⇄",
                RightCeiling: "⌉",
                RightDownVector: "⇂",
                RightFloor: "⌋",
                RightTee: "⊢",
                RightTeeArrow: "↦",
                RightTriangle: "⊳",
                RightTriangleEqual: "⊵",
                RightUpVector: "↾",
                RightVector: "⇀",
                Rightarrow: "⇒",
                Rrightarrow: "⇛",
                Rsh: "↱",
                Sigma: "Σ",
                SmallCircle: "∘",
                Sqrt: "√",
                Square: "□",
                SquareIntersection: "⊓",
                SquareSubset: "⊏",
                SquareSubsetEqual: "⊑",
                SquareSuperset: "⊐",
                SquareSupersetEqual: "⊒",
                SquareUnion: "⊔",
                Star: "⋆",
                Subset: "⋐",
                SubsetEqual: "⊆",
                Succeeds: "≻",
                SucceedsEqual: "⪰",
                SucceedsSlantEqual: "≽",
                SucceedsTilde: "≿",
                SuchThat: "∋",
                Sum: "∑",
                Superset: "⊃",
                SupersetEqual: "⊇",
                Supset: "⋑",
                Therefore: "∴",
                Theta: "Θ",
                Tilde: "∼",
                TildeEqual: "≃",
                TildeFullEqual: "≅",
                TildeTilde: "≈",
                UnderBar: "_",
                UnderBrace: "⏟",
                Union: "⋃",
                UnionPlus: "⊎",
                UpArrow: "↑",
                UpDownArrow: "↕",
                UpTee: "⊥",
                Uparrow: "⇑",
                Updownarrow: "⇕",
                Upsilon: "Υ",
                Vdash: "⊩",
                Vee: "⋁",
                VerticalBar: "∣",
                VerticalTilde: "≀",
                Vvdash: "⊪",
                Wedge: "⋀",
                Xi: "Ξ",
                amp: "&",
                acute: "\xb4",
                aleph: "ℵ",
                alpha: "α",
                amalg: "⨿",
                and: "∧",
                ang: "∠",
                angmsd: "∡",
                angsph: "∢",
                ape: "≊",
                backprime: "‵",
                backsim: "∽",
                backsimeq: "⋍",
                beta: "β",
                beth: "ℶ",
                between: "≬",
                bigcirc: "◯",
                bigodot: "⨀",
                bigoplus: "⨁",
                bigotimes: "⨂",
                bigsqcup: "⨆",
                bigstar: "★",
                bigtriangledown: "▽",
                bigtriangleup: "△",
                biguplus: "⨄",
                blacklozenge: "⧫",
                blacktriangle: "▴",
                blacktriangledown: "▾",
                blacktriangleleft: "◂",
                bowtie: "⋈",
                boxdl: "┐",
                boxdr: "┌",
                boxminus: "⊟",
                boxplus: "⊞",
                boxtimes: "⊠",
                boxul: "┘",
                boxur: "└",
                bsol: "\\",
                bull: "•",
                cap: "∩",
                check: "✓",
                chi: "χ",
                circ: "ˆ",
                circeq: "≗",
                circlearrowleft: "↺",
                circlearrowright: "↻",
                circledR: "\xae",
                circledS: "Ⓢ",
                circledast: "⊛",
                circledcirc: "⊚",
                circleddash: "⊝",
                clubs: "♣",
                colon: ":",
                comp: "∁",
                ctdot: "⋯",
                cuepr: "⋞",
                cuesc: "⋟",
                cularr: "↶",
                cup: "∪",
                curarr: "↷",
                curlyvee: "⋎",
                curlywedge: "⋏",
                dagger: "†",
                daleth: "ℸ",
                ddarr: "⇊",
                deg: "\xb0",
                delta: "δ",
                digamma: "ϝ",
                div: "\xf7",
                divideontimes: "⋇",
                dot: "˙",
                doteqdot: "≑",
                dotplus: "∔",
                dotsquare: "⊡",
                dtdot: "⋱",
                ecir: "≖",
                efDot: "≒",
                egs: "⪖",
                ell: "ℓ",
                els: "⪕",
                empty: "∅",
                epsi: "ε",
                epsiv: "ϵ",
                erDot: "≓",
                eta: "η",
                eth: "\xf0",
                flat: "♭",
                fork: "⋔",
                frown: "⌢",
                gEl: "⪌",
                gamma: "γ",
                gap: "⪆",
                gimel: "ℷ",
                gnE: "≩",
                gnap: "⪊",
                gne: "⪈",
                gnsim: "⋧",
                gt: ">",
                gtdot: "⋗",
                harrw: "↭",
                hbar: "ℏ",
                hellip: "…",
                hookleftarrow: "↩",
                hookrightarrow: "↪",
                imath: "ı",
                infin: "∞",
                intcal: "⊺",
                iota: "ι",
                jmath: "ȷ",
                kappa: "κ",
                kappav: "ϰ",
                lEg: "⪋",
                lambda: "λ",
                lap: "⪅",
                larrlp: "↫",
                larrtl: "↢",
                lbrace: "{",
                lbrack: "[",
                le: "≤",
                leftleftarrows: "⇇",
                leftthreetimes: "⋋",
                lessdot: "⋖",
                lmoust: "⎰",
                lnE: "≨",
                lnap: "⪉",
                lne: "⪇",
                lnsim: "⋦",
                longmapsto: "⟼",
                looparrowright: "↬",
                lowast: "∗",
                loz: "◊",
                lt: "<",
                ltimes: "⋉",
                ltri: "◃",
                macr: "\xaf",
                malt: "✠",
                mho: "℧",
                mu: "μ",
                multimap: "⊸",
                nLeftarrow: "⇍",
                nLeftrightarrow: "⇎",
                nRightarrow: "⇏",
                nVDash: "⊯",
                nVdash: "⊮",
                natur: "♮",
                nearr: "↗",
                nharr: "↮",
                nlarr: "↚",
                not: "\xac",
                nrarr: "↛",
                nu: "ν",
                nvDash: "⊭",
                nvdash: "⊬",
                nwarr: "↖",
                omega: "ω",
                omicron: "ο",
                or: "∨",
                osol: "⊘",
                period: ".",
                phi: "φ",
                phiv: "ϕ",
                pi: "π",
                piv: "ϖ",
                prap: "⪷",
                precnapprox: "⪹",
                precneqq: "⪵",
                precnsim: "⋨",
                prime: "′",
                psi: "ψ",
                quot: '"',
                rarrtl: "↣",
                rbrace: "}",
                rbrack: "]",
                rho: "ρ",
                rhov: "ϱ",
                rightrightarrows: "⇉",
                rightthreetimes: "⋌",
                ring: "˚",
                rmoust: "⎱",
                rtimes: "⋊",
                rtri: "▹",
                scap: "⪸",
                scnE: "⪶",
                scnap: "⪺",
                scnsim: "⋩",
                sdot: "⋅",
                searr: "↘",
                sect: "\xa7",
                sharp: "♯",
                sigma: "σ",
                sigmav: "ς",
                simne: "≆",
                smile: "⌣",
                spades: "♠",
                sub: "⊂",
                subE: "⫅",
                subnE: "⫋",
                subne: "⊊",
                supE: "⫆",
                supnE: "⫌",
                supne: "⊋",
                swarr: "↙",
                tau: "τ",
                theta: "θ",
                thetav: "ϑ",
                tilde: "˜",
                times: "\xd7",
                triangle: "▵",
                triangleq: "≜",
                upsi: "υ",
                upuparrows: "⇈",
                veebar: "⊻",
                vellip: "⋮",
                weierp: "℘",
                xi: "ξ",
                yen: "\xa5",
                zeta: "ζ",
                zigrarr: "⇝",
                nbsp: "\xa0",
                rsquo: "’",
                lsquo: "‘"
            };
            var i1 = {};
            function s1(t1, r1) {
                if ("#" === r1.charAt(0)) return a1(r1.slice(1));
                if (e1.entities[r1]) return e1.entities[r1];
                if (e1.options.loadMissingEntities) {
                    var s1 = r1.match(/^[a-zA-Z](fr|scr|opf)$/) ? RegExp.$1 : r1.charAt(0).toLowerCase();
                    i1[s1] || (i1[s1] = !0, (0, n1.retryAfter)((0, o1.asyncLoad)("./util/entities/" + s1 + ".js")));
                }
                return t1;
            }
            function a1(t1) {
                var e1 = "x" === t1.charAt(0) ? parseInt(t1.slice(1), 16) : parseInt(t1);
                return String.fromCodePoint(e1);
            }
            e1.add = function(t1, r1) {
                Object.assign(e1.entities, t1), i1[r1] = !0;
            }, e1.remove = function(t1) {
                delete e1.entities[t1];
            }, e1.translate = function(t1) {
                return t1.replace(/&([a-z][a-z0-9]*|#(?:[0-9]+|x[0-9a-f]+));/gi, s1);
            }, e1.numeric = a1;
        },
        7525: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, a1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.FunctionList = void 0;
            var l1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.execute = function() {
                    for(var t1, e1, r1 = [], n1 = 0; n1 < arguments.length; n1++)r1[n1] = arguments[n1];
                    try {
                        for(var o1 = i1(this), l1 = o1.next(); !l1.done; l1 = o1.next()){
                            var c1 = l1.value, u1 = c1.item.apply(c1, a1([], s1(r1), !1));
                            if (!1 === u1) return !1;
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return !0;
                }, e1.prototype.asyncExecute = function() {
                    for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1[e1] = arguments[e1];
                    var r1 = -1, n1 = this.items;
                    return new Promise(function(e1, o1) {
                        !function i1() {
                            for(var l1; ++r1 < n1.length;){
                                var c1 = (l1 = n1[r1]).item.apply(l1, a1([], s1(t1), !1));
                                if (c1 instanceof Promise) return void c1.then(i1).catch(function(t1) {
                                    return o1(t1);
                                });
                                if (!1 === c1) return void e1(!1);
                            }
                            e1(!0);
                        }();
                    });
                }, e1;
            }(r1(8666).PrioritizedList);
            e1.FunctionList = l1;
        },
        103: function(t1, e1) {
            var r1 = this && this.__generator || function(t1, e1) {
                var r1, n1, o1, i1, s1 = {
                    label: 0,
                    sent: function() {
                        if (1 & o1[0]) throw o1[1];
                        return o1[1];
                    },
                    trys: [],
                    ops: []
                };
                return i1 = {
                    next: a1(0),
                    throw: a1(1),
                    return: a1(2)
                }, "function" == typeof Symbol && (i1[Symbol.iterator] = function() {
                    return this;
                }), i1;
                function a1(i1) {
                    return function(a1) {
                        return function(i1) {
                            if (r1) throw new TypeError("Generator is already executing.");
                            for(; s1;)try {
                                if (r1 = 1, n1 && (o1 = 2 & i1[0] ? n1.return : i1[0] ? n1.throw || ((o1 = n1.return) && o1.call(n1), 0) : n1.next) && !(o1 = o1.call(n1, i1[1])).done) return o1;
                                switch(n1 = 0, o1 && (i1 = [
                                    2 & i1[0],
                                    o1.value
                                ]), i1[0]){
                                    case 0:
                                    case 1:
                                        o1 = i1;
                                        break;
                                    case 4:
                                        return s1.label++, {
                                            value: i1[1],
                                            done: !1
                                        };
                                    case 5:
                                        s1.label++, n1 = i1[1], i1 = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        i1 = s1.ops.pop(), s1.trys.pop();
                                        continue;
                                    default:
                                        if (!(o1 = s1.trys, (o1 = o1.length > 0 && o1[o1.length - 1]) || 6 !== i1[0] && 2 !== i1[0])) {
                                            s1 = 0;
                                            continue;
                                        }
                                        if (3 === i1[0] && (!o1 || i1[1] > o1[0] && i1[1] < o1[3])) {
                                            s1.label = i1[1];
                                            break;
                                        }
                                        if (6 === i1[0] && s1.label < o1[1]) {
                                            s1.label = o1[1], o1 = i1;
                                            break;
                                        }
                                        if (o1 && s1.label < o1[2]) {
                                            s1.label = o1[2], s1.ops.push(i1);
                                            break;
                                        }
                                        o1[2] && s1.ops.pop(), s1.trys.pop();
                                        continue;
                                }
                                i1 = e1.call(t1, s1);
                            } catch (t1) {
                                i1 = [
                                    6,
                                    t1
                                ], n1 = 0;
                            } finally{
                                r1 = o1 = 0;
                            }
                            if (5 & i1[0]) throw i1[1];
                            return {
                                value: i1[0] ? i1[1] : void 0,
                                done: !0
                            };
                        }([
                            i1,
                            a1
                        ]);
                    };
                }
            }, n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            }, i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.LinkedList = e1.ListItem = e1.END = void 0, e1.END = Symbol();
            var s1 = function(t1) {
                void 0 === t1 && (t1 = null), this.next = null, this.prev = null, this.data = t1;
            };
            e1.ListItem = s1;
            var a1 = function() {
                function t1() {
                    for(var t1 = [], r1 = 0; r1 < arguments.length; r1++)t1[r1] = arguments[r1];
                    this.list = new s1(e1.END), this.list.next = this.list.prev = this.list, this.push.apply(this, o1([], n1(t1), !1));
                }
                return t1.prototype.isBefore = function(t1, e1) {
                    return t1 < e1;
                }, t1.prototype.push = function() {
                    for(var t1, e1, r1 = [], n1 = 0; n1 < arguments.length; n1++)r1[n1] = arguments[n1];
                    try {
                        for(var o1 = i1(r1), a1 = o1.next(); !a1.done; a1 = o1.next()){
                            var l1 = a1.value, c1 = new s1(l1);
                            c1.next = this.list, c1.prev = this.list.prev, this.list.prev = c1, c1.prev.next = c1;
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return this;
                }, t1.prototype.pop = function() {
                    var t1 = this.list.prev;
                    return t1.data === e1.END ? null : (this.list.prev = t1.prev, t1.prev.next = this.list, t1.next = t1.prev = null, t1.data);
                }, t1.prototype.unshift = function() {
                    for(var t1, e1, r1 = [], n1 = 0; n1 < arguments.length; n1++)r1[n1] = arguments[n1];
                    try {
                        for(var o1 = i1(r1.slice(0).reverse()), a1 = o1.next(); !a1.done; a1 = o1.next()){
                            var l1 = a1.value, c1 = new s1(l1);
                            c1.next = this.list.next, c1.prev = this.list, this.list.next = c1, c1.next.prev = c1;
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (e1 = o1.return) && e1.call(o1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return this;
                }, t1.prototype.shift = function() {
                    var t1 = this.list.next;
                    return t1.data === e1.END ? null : (this.list.next = t1.next, t1.next.prev = this.list, t1.next = t1.prev = null, t1.data);
                }, t1.prototype.remove = function() {
                    for(var t1, r1, n1 = [], o1 = 0; o1 < arguments.length; o1++)n1[o1] = arguments[o1];
                    var s1 = new Map;
                    try {
                        for(var a1 = i1(n1), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value;
                            s1.set(c1, !0);
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (r1 = a1.return) && r1.call(a1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    for(var u1 = this.list.next; u1.data !== e1.END;){
                        var p1 = u1.next;
                        s1.has(u1.data) && (u1.prev.next = u1.next, u1.next.prev = u1.prev, u1.next = u1.prev = null), u1 = p1;
                    }
                }, t1.prototype.clear = function() {
                    return this.list.next.prev = this.list.prev.next = null, this.list.next = this.list.prev = this.list, this;
                }, t1.prototype[Symbol.iterator] = function() {
                    var t1;
                    return r1(this, function(r1) {
                        switch(r1.label){
                            case 0:
                                t1 = this.list.next, r1.label = 1;
                            case 1:
                                return t1.data === e1.END ? [
                                    3,
                                    3
                                ] : [
                                    4,
                                    t1.data
                                ];
                            case 2:
                                return r1.sent(), t1 = t1.next, [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }, t1.prototype.reversed = function() {
                    var t1;
                    return r1(this, function(r1) {
                        switch(r1.label){
                            case 0:
                                t1 = this.list.prev, r1.label = 1;
                            case 1:
                                return t1.data === e1.END ? [
                                    3,
                                    3
                                ] : [
                                    4,
                                    t1.data
                                ];
                            case 2:
                                return r1.sent(), t1 = t1.prev, [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }, t1.prototype.insert = function(t1, r1) {
                    void 0 === r1 && (r1 = null), null === r1 && (r1 = this.isBefore.bind(this));
                    for(var n1 = new s1(t1), o1 = this.list.next; o1.data !== e1.END && r1(o1.data, n1.data);)o1 = o1.next;
                    return n1.prev = o1.prev, n1.next = o1, o1.prev.next = o1.prev = n1, this;
                }, t1.prototype.sort = function(e1) {
                    var r1, n1;
                    void 0 === e1 && (e1 = null), null === e1 && (e1 = this.isBefore.bind(this));
                    var o1 = [];
                    try {
                        for(var s1 = i1(this), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            o1.push(new t1(l1));
                        }
                    } catch (t1) {
                        r1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (n1 = s1.return) && n1.call(s1);
                        } finally{
                            if (r1) throw r1.error;
                        }
                    }
                    for(this.list.next = this.list.prev = this.list; o1.length > 1;){
                        var c1 = o1.shift(), u1 = o1.shift();
                        c1.merge(u1, e1), o1.push(c1);
                    }
                    return o1.length && (this.list = o1[0].list), this;
                }, t1.prototype.merge = function(t1, r1) {
                    var o1, i1, s1, a1, l1;
                    void 0 === r1 && (r1 = null), null === r1 && (r1 = this.isBefore.bind(this));
                    for(var c1 = this.list.next, u1 = t1.list.next; c1.data !== e1.END && u1.data !== e1.END;)r1(u1.data, c1.data) ? (o1 = n1([
                        c1,
                        u1
                    ], 2), u1.prev.next = o1[0], c1.prev.next = o1[1], i1 = n1([
                        c1.prev,
                        u1.prev
                    ], 2), u1.prev = i1[0], c1.prev = i1[1], s1 = n1([
                        t1.list,
                        this.list
                    ], 2), this.list.prev.next = s1[0], t1.list.prev.next = s1[1], a1 = n1([
                        t1.list.prev,
                        this.list.prev
                    ], 2), this.list.prev = a1[0], t1.list.prev = a1[1], c1 = (l1 = n1([
                        u1.next,
                        c1
                    ], 2))[0], u1 = l1[1]) : c1 = c1.next;
                    return u1.data !== e1.END && (this.list.prev.next = t1.list.next, t1.list.next.prev = this.list.prev, t1.list.prev.next = this.list, this.list.prev = t1.list.prev, t1.list.next = t1.list.prev = t1.list), this;
                }, t1;
            }();
            e1.LinkedList = a1;
        },
        7233: function(t1, e1) {
            var r1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.lookup = e1.separateOptions = e1.selectOptionsFromKeys = e1.selectOptions = e1.userOptions = e1.defaultOptions = e1.insert = e1.copy = e1.keys = e1.makeArray = e1.expandable = e1.Expandable = e1.OPTIONS = e1.REMOVE = e1.APPEND = e1.isObject = void 0;
            var i1 = {}.constructor;
            function s1(t1) {
                return "object" == typeof t1 && null !== t1 && (t1.constructor === i1 || t1.constructor === a1);
            }
            e1.isObject = s1, e1.APPEND = "[+]", e1.REMOVE = "[-]", e1.OPTIONS = {
                invalidOption: "warn",
                optionError: function(t1, r1) {
                    if ("fatal" === e1.OPTIONS.invalidOption) throw new Error(t1);
                    console.warn("MathJax: " + t1);
                }
            };
            var a1 = function() {};
            function l1(t1) {
                return Object.assign(Object.create(a1.prototype), t1);
            }
            function c1(t1) {
                return t1 ? Object.keys(t1).concat(Object.getOwnPropertySymbols(t1)) : [];
            }
            function u1(t1) {
                var e1, n1, o1 = {};
                try {
                    for(var i1 = r1(c1(t1)), h1 = i1.next(); !h1.done; h1 = i1.next()){
                        var f1 = h1.value, d1 = Object.getOwnPropertyDescriptor(t1, f1), m1 = d1.value;
                        Array.isArray(m1) ? d1.value = p1([], m1, !1) : s1(m1) && (d1.value = u1(m1)), d1.enumerable && (o1[f1] = d1);
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        h1 && !h1.done && (n1 = i1.return) && n1.call(i1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                return Object.defineProperties(t1.constructor === a1 ? l1({}) : {}, o1);
            }
            function p1(t1, i1, l1) {
                var h1, f1;
                void 0 === l1 && (l1 = !0);
                var d1 = function(r1) {
                    if (l1 && void 0 === t1[r1] && t1.constructor !== a1) return "symbol" == typeof r1 && (r1 = r1.toString()), e1.OPTIONS.optionError('Invalid option "'.concat(r1, '" (no default value).'), r1), "continue";
                    var h1 = i1[r1], f1 = t1[r1];
                    if (!s1(h1) || null === f1 || "object" != typeof f1 && "function" != typeof f1) Array.isArray(h1) ? (t1[r1] = [], p1(t1[r1], h1, !1)) : s1(h1) ? t1[r1] = u1(h1) : t1[r1] = h1;
                    else {
                        var d1 = c1(h1);
                        Array.isArray(f1) && (1 === d1.length && (d1[0] === e1.APPEND || d1[0] === e1.REMOVE) && Array.isArray(h1[d1[0]]) || 2 === d1.length && d1.sort().join(",") === e1.APPEND + "," + e1.REMOVE && Array.isArray(h1[e1.APPEND]) && Array.isArray(h1[e1.REMOVE])) ? (h1[e1.REMOVE] && (f1 = t1[r1] = f1.filter(function(t1) {
                            return h1[e1.REMOVE].indexOf(t1) < 0;
                        })), h1[e1.APPEND] && (t1[r1] = o1(o1([], n1(f1), !1), n1(h1[e1.APPEND]), !1))) : p1(f1, h1, l1);
                    }
                };
                try {
                    for(var m1 = r1(c1(i1)), y1 = m1.next(); !y1.done; y1 = m1.next())d1(y1.value);
                } catch (t1) {
                    h1 = {
                        error: t1
                    };
                } finally{
                    try {
                        y1 && !y1.done && (f1 = m1.return) && f1.call(m1);
                    } finally{
                        if (h1) throw h1.error;
                    }
                }
                return t1;
            }
            function h1(t1) {
                for(var e1, n1, o1 = [], i1 = 1; i1 < arguments.length; i1++)o1[i1 - 1] = arguments[i1];
                var s1 = {};
                try {
                    for(var a1 = r1(o1), l1 = a1.next(); !l1.done; l1 = a1.next()){
                        var c1 = l1.value;
                        t1.hasOwnProperty(c1) && (s1[c1] = t1[c1]);
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        l1 && !l1.done && (n1 = a1.return) && n1.call(a1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                return s1;
            }
            e1.Expandable = a1, e1.expandable = l1, e1.makeArray = function(t1) {
                return Array.isArray(t1) ? t1 : [
                    t1
                ];
            }, e1.keys = c1, e1.copy = u1, e1.insert = p1, e1.defaultOptions = function(t1) {
                for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                return e1.forEach(function(e1) {
                    return p1(t1, e1, !1);
                }), t1;
            }, e1.userOptions = function(t1) {
                for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                return e1.forEach(function(e1) {
                    return p1(t1, e1, !0);
                }), t1;
            }, e1.selectOptions = h1, e1.selectOptionsFromKeys = function(t1, e1) {
                return h1.apply(void 0, o1([
                    t1
                ], n1(Object.keys(e1)), !1));
            }, e1.separateOptions = function(t1) {
                for(var e1, n1, o1, i1, s1 = [], a1 = 1; a1 < arguments.length; a1++)s1[a1 - 1] = arguments[a1];
                var l1 = [];
                try {
                    for(var c1 = r1(s1), u1 = c1.next(); !u1.done; u1 = c1.next()){
                        var p1 = u1.value, h1 = {}, f1 = {};
                        try {
                            for(var d1 = (o1 = void 0, r1(Object.keys(t1 || {}))), m1 = d1.next(); !m1.done; m1 = d1.next()){
                                var y1 = m1.value;
                                (void 0 === p1[y1] ? f1 : h1)[y1] = t1[y1];
                            }
                        } catch (t1) {
                            o1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                m1 && !m1.done && (i1 = d1.return) && i1.call(d1);
                            } finally{
                                if (o1) throw o1.error;
                            }
                        }
                        l1.push(h1), t1 = f1;
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        u1 && !u1.done && (n1 = c1.return) && n1.call(c1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                return l1.unshift(t1), l1;
            }, e1.lookup = function(t1, e1, r1) {
                return void 0 === r1 && (r1 = null), e1.hasOwnProperty(t1) ? e1[t1] : r1;
            };
        },
        8666: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.PrioritizedList = void 0;
            var r1 = function() {
                function t1() {
                    this.items = [], this.items = [];
                }
                return t1.prototype[Symbol.iterator] = function() {
                    var t1 = 0, e1 = this.items;
                    return {
                        next: function() {
                            return {
                                value: e1[t1++],
                                done: t1 > e1.length
                            };
                        }
                    };
                }, t1.prototype.add = function(e1, r1) {
                    void 0 === r1 && (r1 = t1.DEFAULTPRIORITY);
                    var n1 = this.items.length;
                    do n1--;
                    while (n1 >= 0 && r1 < this.items[n1].priority);
                    return this.items.splice(n1 + 1, 0, {
                        item: e1,
                        priority: r1
                    }), e1;
                }, t1.prototype.remove = function(t1) {
                    var e1 = this.items.length;
                    do e1--;
                    while (e1 >= 0 && this.items[e1].item !== t1);
                    e1 >= 0 && this.items.splice(e1, 1);
                }, t1.DEFAULTPRIORITY = 5, t1;
            }();
            e1.PrioritizedList = r1;
        },
        4542: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.retryAfter = e1.handleRetriesFor = void 0, e1.handleRetriesFor = function(t1) {
                return new Promise(function e1(r1, n1) {
                    try {
                        r1(t1());
                    } catch (t1) {
                        t1.retry && t1.retry instanceof Promise ? t1.retry.then(function() {
                            return e1(r1, n1);
                        }).catch(function(t1) {
                            return n1(t1);
                        }) : t1.restart && t1.restart.isCallback ? MathJax.Callback.After(function() {
                            return e1(r1, n1);
                        }, t1.restart) : n1(t1);
                    }
                });
            }, e1.retryAfter = function(t1) {
                var e1 = new Error("MathJax retry");
                throw e1.retry = t1, e1;
            };
        },
        4139: function(t1, e1) {
            var r1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CssStyles = void 0;
            var n1 = function() {
                function t1(t1) {
                    void 0 === t1 && (t1 = null), this.styles = {}, this.addStyles(t1);
                }
                return Object.defineProperty(t1.prototype, "cssText", {
                    get: function() {
                        return this.getStyleString();
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.addStyles = function(t1) {
                    var e1, n1;
                    if (t1) try {
                        for(var o1 = r1(Object.keys(t1)), i1 = o1.next(); !i1.done; i1 = o1.next()){
                            var s1 = i1.value;
                            this.styles[s1] || (this.styles[s1] = {}), Object.assign(this.styles[s1], t1[s1]);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                }, t1.prototype.removeStyles = function() {
                    for(var t1, e1, n1 = [], o1 = 0; o1 < arguments.length; o1++)n1[o1] = arguments[o1];
                    try {
                        for(var i1 = r1(n1), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value;
                            delete this.styles[a1];
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (e1 = i1.return) && e1.call(i1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, t1.prototype.clear = function() {
                    this.styles = {};
                }, t1.prototype.getStyleString = function() {
                    return this.getStyleRules().join("\n\n");
                }, t1.prototype.getStyleRules = function() {
                    var t1, e1, n1 = Object.keys(this.styles), o1 = new Array(n1.length), i1 = 0;
                    try {
                        for(var s1 = r1(n1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value;
                            o1[i1++] = l1 + " {\n" + this.getStyleDefString(this.styles[l1]) + "\n}";
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (e1 = s1.return) && e1.call(s1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                    return o1;
                }, t1.prototype.getStyleDefString = function(t1) {
                    var e1, n1, o1 = Object.keys(t1), i1 = new Array(o1.length), s1 = 0;
                    try {
                        for(var a1 = r1(o1), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value;
                            i1[s1++] = "  " + c1 + ": " + t1[c1] + ";";
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (n1 = a1.return) && n1.call(a1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return i1.join("\n");
                }, t1;
            }();
            e1.CssStyles = n1;
        },
        8054: function(t1, e1) {
            var r1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, n1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, o1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Styles = void 0;
            var i1 = [
                "top",
                "right",
                "bottom",
                "left"
            ], s1 = [
                "width",
                "style",
                "color"
            ];
            function a1(t1) {
                for(var e1 = t1.split(/((?:'[^']*'|"[^"]*"|,[\s\n]|[^\s\n])*)/g), r1 = []; e1.length > 1;)e1.shift(), r1.push(e1.shift());
                return r1;
            }
            function l1(t1) {
                var e1, n1, o1 = a1(this.styles[t1]);
                0 === o1.length && o1.push(""), 1 === o1.length && o1.push(o1[0]), 2 === o1.length && o1.push(o1[0]), 3 === o1.length && o1.push(o1[1]);
                try {
                    for(var i1 = r1(v1.connect[t1].children), s1 = i1.next(); !s1.done; s1 = i1.next()){
                        var l1 = s1.value;
                        this.setStyle(this.childName(t1, l1), o1.shift());
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        s1 && !s1.done && (n1 = i1.return) && n1.call(i1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
            }
            function c1(t1) {
                var e1, n1, o1 = v1.connect[t1].children, i1 = [];
                try {
                    for(var s1 = r1(o1), a1 = s1.next(); !a1.done; a1 = s1.next()){
                        var l1 = a1.value, c1 = this.styles[t1 + "-" + l1];
                        if (!c1) return void delete this.styles[t1];
                        i1.push(c1);
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        a1 && !a1.done && (n1 = s1.return) && n1.call(s1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                i1[3] === i1[1] && (i1.pop(), i1[2] === i1[0] && (i1.pop(), i1[1] === i1[0] && i1.pop())), this.styles[t1] = i1.join(" ");
            }
            function u1(t1) {
                var e1, n1;
                try {
                    for(var o1 = r1(v1.connect[t1].children), i1 = o1.next(); !i1.done; i1 = o1.next()){
                        var s1 = i1.value;
                        this.setStyle(this.childName(t1, s1), this.styles[t1]);
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        i1 && !i1.done && (n1 = o1.return) && n1.call(o1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
            }
            function p1(t1) {
                var e1, i1, s1 = o1([], n1(v1.connect[t1].children), !1), a1 = this.styles[this.childName(t1, s1.shift())];
                try {
                    for(var l1 = r1(s1), c1 = l1.next(); !c1.done; c1 = l1.next()){
                        var u1 = c1.value;
                        if (this.styles[this.childName(t1, u1)] !== a1) return void delete this.styles[t1];
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        c1 && !c1.done && (i1 = l1.return) && i1.call(l1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                this.styles[t1] = a1;
            }
            var h1 = /^(?:[\d.]+(?:[a-z]+)|thin|medium|thick|inherit|initial|unset)$/, f1 = /^(?:none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset|inherit|initial|unset)$/;
            function d1(t1) {
                var e1, n1, o1, i1, s1 = {
                    width: "",
                    style: "",
                    color: ""
                };
                try {
                    for(var l1 = r1(a1(this.styles[t1])), c1 = l1.next(); !c1.done; c1 = l1.next()){
                        var u1 = c1.value;
                        u1.match(h1) && "" === s1.width ? s1.width = u1 : u1.match(f1) && "" === s1.style ? s1.style = u1 : s1.color = u1;
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        c1 && !c1.done && (n1 = l1.return) && n1.call(l1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                try {
                    for(var p1 = r1(v1.connect[t1].children), d1 = p1.next(); !d1.done; d1 = p1.next()){
                        var m1 = d1.value;
                        this.setStyle(this.childName(t1, m1), s1[m1]);
                    }
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        d1 && !d1.done && (i1 = p1.return) && i1.call(p1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
            }
            function m1(t1) {
                var e1, n1, o1 = [];
                try {
                    for(var i1 = r1(v1.connect[t1].children), s1 = i1.next(); !s1.done; s1 = i1.next()){
                        var a1 = s1.value, l1 = this.styles[this.childName(t1, a1)];
                        l1 && o1.push(l1);
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        s1 && !s1.done && (n1 = i1.return) && n1.call(i1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                o1.length ? this.styles[t1] = o1.join(" ") : delete this.styles[t1];
            }
            var y1 = {
                style: /^(?:normal|italic|oblique|inherit|initial|unset)$/,
                variant: new RegExp("^(?:" + [
                    "normal|none",
                    "inherit|initial|unset",
                    "common-ligatures|no-common-ligatures",
                    "discretionary-ligatures|no-discretionary-ligatures",
                    "historical-ligatures|no-historical-ligatures",
                    "contextual|no-contextual",
                    "(?:stylistic|character-variant|swash|ornaments|annotation)\\([^)]*\\)",
                    "small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
                    "lining-nums|oldstyle-nums|proportional-nums|tabular-nums",
                    "diagonal-fractions|stacked-fractions",
                    "ordinal|slashed-zero",
                    "jis78|jis83|jis90|jis04|simplified|traditional",
                    "full-width|proportional-width",
                    "ruby"
                ].join("|") + ")$"),
                weight: /^(?:normal|bold|bolder|lighter|[1-9]00|inherit|initial|unset)$/,
                stretch: new RegExp("^(?:" + [
                    "normal",
                    "(?:(?:ultra|extra|semi)-)?condensed",
                    "(?:(?:semi|extra|ulta)-)?expanded",
                    "inherit|initial|unset"
                ].join("|") + ")$"),
                size: new RegExp("^(?:" + [
                    "xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller",
                    "[d.]+%|[d.]+[a-z]+",
                    "inherit|initial|unset"
                ].join("|") + ")(?:/(?:normal|[d.+](?:%|[a-z]+)?))?$")
            };
            function g1(t1) {
                var e1, o1, i1, s1, l1 = a1(this.styles[t1]), c1 = {
                    style: "",
                    variant: [],
                    weight: "",
                    stretch: "",
                    size: "",
                    family: "",
                    "line-height": ""
                };
                try {
                    for(var u1 = r1(l1), p1 = u1.next(); !p1.done; p1 = u1.next()){
                        var h1 = p1.value;
                        c1.family = h1;
                        try {
                            for(var f1 = (i1 = void 0, r1(Object.keys(y1))), d1 = f1.next(); !d1.done; d1 = f1.next()){
                                var m1 = d1.value;
                                if ((Array.isArray(c1[m1]) || "" === c1[m1]) && h1.match(y1[m1])) {
                                    if ("size" === m1) {
                                        var g1 = n1(h1.split(/\//), 2), b1 = g1[0], _1 = g1[1];
                                        c1[m1] = b1, _1 && (c1["line-height"] = _1);
                                    } else "" === c1.size && (Array.isArray(c1[m1]) ? c1[m1].push(h1) : c1[m1] = h1);
                                }
                            }
                        } catch (t1) {
                            i1 = {
                                error: t1
                            };
                        } finally{
                            try {
                                d1 && !d1.done && (s1 = f1.return) && s1.call(f1);
                            } finally{
                                if (i1) throw i1.error;
                            }
                        }
                    }
                } catch (t1) {
                    e1 = {
                        error: t1
                    };
                } finally{
                    try {
                        p1 && !p1.done && (o1 = u1.return) && o1.call(u1);
                    } finally{
                        if (e1) throw e1.error;
                    }
                }
                !function(t1, e1) {
                    var n1, o1;
                    try {
                        for(var i1 = r1(v1.connect[t1].children), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value, l1 = this.childName(t1, a1);
                            if (Array.isArray(e1[a1])) {
                                var c1 = e1[a1];
                                c1.length && (this.styles[l1] = c1.join(" "));
                            } else "" !== e1[a1] && (this.styles[l1] = e1[a1]);
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (o1 = i1.return) && o1.call(i1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }(t1, c1), delete this.styles[t1];
            }
            function b1(t1) {}
            var v1 = function() {
                function t1(t1) {
                    void 0 === t1 && (t1 = ""), this.parse(t1);
                }
                return Object.defineProperty(t1.prototype, "cssText", {
                    get: function() {
                        var t1, e1, n1 = [];
                        try {
                            for(var o1 = r1(Object.keys(this.styles)), i1 = o1.next(); !i1.done; i1 = o1.next()){
                                var s1 = i1.value, a1 = this.parentName(s1);
                                this.styles[a1] || n1.push(s1 + ": " + this.styles[s1] + ";");
                            }
                        } catch (e1) {
                            t1 = {
                                error: e1
                            };
                        } finally{
                            try {
                                i1 && !i1.done && (e1 = o1.return) && e1.call(o1);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                        return n1.join(" ");
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.set = function(e1, r1) {
                    for(e1 = this.normalizeName(e1), this.setStyle(e1, r1), t1.connect[e1] && !t1.connect[e1].combine && (this.combineChildren(e1), delete this.styles[e1]); e1.match(/-/) && (e1 = this.parentName(e1), t1.connect[e1]);)t1.connect[e1].combine.call(this, e1);
                }, t1.prototype.get = function(t1) {
                    return t1 = this.normalizeName(t1), this.styles.hasOwnProperty(t1) ? this.styles[t1] : "";
                }, t1.prototype.setStyle = function(e1, r1) {
                    this.styles[e1] = r1, t1.connect[e1] && t1.connect[e1].children && t1.connect[e1].split.call(this, e1), "" === r1 && delete this.styles[e1];
                }, t1.prototype.combineChildren = function(e1) {
                    var n1, o1, i1 = this.parentName(e1);
                    try {
                        for(var s1 = r1(t1.connect[e1].children), a1 = s1.next(); !a1.done; a1 = s1.next()){
                            var l1 = a1.value, c1 = this.childName(i1, l1);
                            t1.connect[c1].combine.call(this, c1);
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            a1 && !a1.done && (o1 = s1.return) && o1.call(s1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                }, t1.prototype.parentName = function(t1) {
                    var e1 = t1.replace(/-[^-]*$/, "");
                    return t1 === e1 ? "" : e1;
                }, t1.prototype.childName = function(e1, r1) {
                    return r1.match(/-/) ? r1 : (t1.connect[e1] && !t1.connect[e1].combine && (r1 += e1.replace(/.*-/, "-"), e1 = this.parentName(e1)), e1 + "-" + r1);
                }, t1.prototype.normalizeName = function(t1) {
                    return t1.replace(/[A-Z]/g, function(t1) {
                        return "-" + t1.toLowerCase();
                    });
                }, t1.prototype.parse = function(t1) {
                    void 0 === t1 && (t1 = "");
                    var e1 = this.constructor.pattern;
                    this.styles = {};
                    for(var r1 = t1.replace(e1.comment, "").split(e1.style); r1.length > 1;){
                        var o1 = n1(r1.splice(0, 3), 3), i1 = o1[0], s1 = o1[1], a1 = o1[2];
                        if (i1.match(/[^\s\n]/)) return;
                        this.set(s1, a1);
                    }
                }, t1.pattern = {
                    style: /([-a-z]+)[\s\n]*:[\s\n]*((?:'[^']*'|"[^"]*"|\n|.)*?)[\s\n]*(?:;|$)/g,
                    comment: /\/\*[^]*?\*\//g
                }, t1.connect = {
                    padding: {
                        children: i1,
                        split: l1,
                        combine: c1
                    },
                    border: {
                        children: i1,
                        split: u1,
                        combine: p1
                    },
                    "border-top": {
                        children: s1,
                        split: d1,
                        combine: m1
                    },
                    "border-right": {
                        children: s1,
                        split: d1,
                        combine: m1
                    },
                    "border-bottom": {
                        children: s1,
                        split: d1,
                        combine: m1
                    },
                    "border-left": {
                        children: s1,
                        split: d1,
                        combine: m1
                    },
                    "border-width": {
                        children: i1,
                        split: l1,
                        combine: null
                    },
                    "border-style": {
                        children: i1,
                        split: l1,
                        combine: null
                    },
                    "border-color": {
                        children: i1,
                        split: l1,
                        combine: null
                    },
                    font: {
                        children: [
                            "style",
                            "variant",
                            "weight",
                            "stretch",
                            "line-height",
                            "size",
                            "family"
                        ],
                        split: g1,
                        combine: b1
                    }
                }, t1;
            }();
            e1.Styles = v1;
        },
        6010: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.px = e1.emRounded = e1.em = e1.percent = e1.length2em = e1.MATHSPACE = e1.RELUNITS = e1.UNITS = e1.BIGDIMEN = void 0, e1.BIGDIMEN = 1e6, e1.UNITS = {
                px: 1,
                in: 96,
                cm: 96 / 2.54,
                mm: 96 / 25.4
            }, e1.RELUNITS = {
                em: 1,
                ex: .431,
                pt: .1,
                pc: 1.2,
                mu: 1 / 18
            }, e1.MATHSPACE = {
                veryverythinmathspace: 1 / 18,
                verythinmathspace: 2 / 18,
                thinmathspace: 3 / 18,
                mediummathspace: 4 / 18,
                thickmathspace: 5 / 18,
                verythickmathspace: 6 / 18,
                veryverythickmathspace: 7 / 18,
                negativeveryverythinmathspace: -1 / 18,
                negativeverythinmathspace: -2 / 18,
                negativethinmathspace: -3 / 18,
                negativemediummathspace: -4 / 18,
                negativethickmathspace: -5 / 18,
                negativeverythickmathspace: -6 / 18,
                negativeveryverythickmathspace: -7 / 18,
                thin: .04,
                medium: .06,
                thick: .1,
                normal: 1,
                big: 2,
                small: 1 / Math.sqrt(2),
                infinity: e1.BIGDIMEN
            }, e1.length2em = function(t1, r1, n1, o1) {
                if (void 0 === r1 && (r1 = 0), void 0 === n1 && (n1 = 1), void 0 === o1 && (o1 = 16), "string" != typeof t1 && (t1 = String(t1)), "" === t1 || null == t1) return r1;
                if (e1.MATHSPACE[t1]) return e1.MATHSPACE[t1];
                var i1 = t1.match(/^\s*([-+]?(?:\.\d+|\d+(?:\.\d*)?))?(pt|em|ex|mu|px|pc|in|mm|cm|%)?/);
                if (!i1) return r1;
                var s1 = parseFloat(i1[1] || "1"), a1 = i1[2];
                return e1.UNITS.hasOwnProperty(a1) ? s1 * e1.UNITS[a1] / o1 / n1 : e1.RELUNITS.hasOwnProperty(a1) ? s1 * e1.RELUNITS[a1] : "%" === a1 ? s1 / 100 * r1 : s1 * r1;
            }, e1.percent = function(t1) {
                return (100 * t1).toFixed(1).replace(/\.?0+$/, "") + "%";
            }, e1.em = function(t1) {
                return Math.abs(t1) < .001 ? "0" : t1.toFixed(3).replace(/\.?0+$/, "") + "em";
            }, e1.emRounded = function(t1, e1) {
                return void 0 === e1 && (e1 = 16), t1 = (Math.round(t1 * e1) + .05) / e1, Math.abs(t1) < .001 ? "0em" : t1.toFixed(3).replace(/\.?0+$/, "") + "em";
            }, e1.px = function(t1, r1, n1) {
                return void 0 === r1 && (r1 = -e1.BIGDIMEN), void 0 === n1 && (n1 = 16), t1 *= n1, r1 && t1 < r1 && (t1 = r1), Math.abs(t1) < .1 ? "0" : t1.toFixed(1).replace(/\.0$/, "") + "px";
            };
        },
        7875: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.max = e1.sum = void 0, e1.sum = function(t1) {
                return t1.reduce(function(t1, e1) {
                    return t1 + e1;
                }, 0);
            }, e1.max = function(t1) {
                return t1.reduce(function(t1, e1) {
                    return Math.max(t1, e1);
                }, 0);
            };
        },
        505: function(t1, e1) {
            var r1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, n1 = this && this.__spreadArray || function(t1, e1, r1) {
                if (r1 || 2 === arguments.length) for(var n1, o1 = 0, i1 = e1.length; o1 < i1; o1++)!n1 && o1 in e1 || (n1 || (n1 = Array.prototype.slice.call(e1, 0, o1)), n1[o1] = e1[o1]);
                return t1.concat(n1 || Array.prototype.slice.call(e1));
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.split = e1.isPercent = e1.unicodeString = e1.unicodeChars = e1.quotePattern = e1.sortLength = void 0, e1.sortLength = function(t1, e1) {
                return t1.length !== e1.length ? e1.length - t1.length : t1 === e1 ? 0 : t1 < e1 ? -1 : 1;
            }, e1.quotePattern = function(t1) {
                return t1.replace(/([\^$(){}+*?\-|\[\]\:\\])/g, "\\$1");
            }, e1.unicodeChars = function(t1) {
                return Array.from(t1).map(function(t1) {
                    return t1.codePointAt(0);
                });
            }, e1.unicodeString = function(t1) {
                return String.fromCodePoint.apply(String, n1([], r1(t1), !1));
            }, e1.isPercent = function(t1) {
                return !!t1.match(/%\s*$/);
            }, e1.split = function(t1) {
                return t1.trim().split(/\s+/);
            };
        },
        9329: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractEntry = void 0;
            var i1 = r1(9328), s1 = r1(2165), a1 = function(t1) {
                function e1(e1, r1) {
                    var n1 = t1.call(this) || this;
                    return n1._menu = e1, n1._type = r1, n1.className = s1.HtmlClasses.MENUITEM, n1.role = "menuitem", n1.hidden = !1, n1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "menu", {
                    get: function() {
                        return this._menu;
                    },
                    set: function(t1) {
                        this._menu = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "type", {
                    get: function() {
                        return this._type;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.hide = function() {
                    this.hidden = !0, this.menu.generateMenu();
                }, e1.prototype.show = function() {
                    this.hidden = !1, this.menu.generateMenu();
                }, e1.prototype.isHidden = function() {
                    return this.hidden;
                }, e1;
            }(i1.MenuElement);
            e1.AbstractEntry = a1;
        },
        1340: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractItem = void 0;
            var s1 = r1(9329), a1 = r1(2556), l1 = r1(2165), c1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    var i1 = t1.call(this, e1, r1) || this;
                    return i1._content = n1, i1.disabled = !1, i1.callbacks = [], i1._id = o1 || n1, i1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "content", {
                    get: function() {
                        return this._content;
                    },
                    set: function(t1) {
                        this._content = t1, this.generateHtml(), this.menu && this.menu.generateHtml();
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "id", {
                    get: function() {
                        return this._id;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.press = function() {
                    this.disabled || (this.executeAction(), this.executeCallbacks_());
                }, e1.prototype.executeAction = function() {}, e1.prototype.registerCallback = function(t1) {
                    -1 === this.callbacks.indexOf(t1) && this.callbacks.push(t1);
                }, e1.prototype.unregisterCallback = function(t1) {
                    var e1 = this.callbacks.indexOf(t1);
                    -1 !== e1 && this.callbacks.splice(e1, 1);
                }, e1.prototype.mousedown = function(t1) {
                    this.press(), this.stop(t1);
                }, e1.prototype.mouseover = function(t1) {
                    this.focus(), this.stop(t1);
                }, e1.prototype.mouseout = function(t1) {
                    this.deactivate(), this.stop(t1);
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this);
                    var e1 = this.html;
                    e1.setAttribute("aria-disabled", "false"), e1.textContent = this.content;
                }, e1.prototype.activate = function() {
                    this.disabled || this.html.classList.add(l1.HtmlClasses.MENUACTIVE);
                }, e1.prototype.deactivate = function() {
                    this.html.classList.remove(l1.HtmlClasses.MENUACTIVE);
                }, e1.prototype.focus = function() {
                    this.menu.focused = this, t1.prototype.focus.call(this), this.activate();
                }, e1.prototype.unfocus = function() {
                    this.deactivate(), t1.prototype.unfocus.call(this);
                }, e1.prototype.escape = function(t1) {
                    a1.MenuUtil.close(this);
                }, e1.prototype.up = function(t1) {
                    this.menu.up(t1);
                }, e1.prototype.down = function(t1) {
                    this.menu.down(t1);
                }, e1.prototype.left = function(t1) {
                    this.menu.left(t1);
                }, e1.prototype.right = function(t1) {
                    this.menu.right(t1);
                }, e1.prototype.space = function(t1) {
                    this.press();
                }, e1.prototype.disable = function() {
                    this.disabled = !0;
                    var t1 = this.html;
                    t1.classList.add(l1.HtmlClasses.MENUDISABLED), t1.setAttribute("aria-disabled", "true");
                }, e1.prototype.enable = function() {
                    this.disabled = !1;
                    var t1 = this.html;
                    t1.classList.remove(l1.HtmlClasses.MENUDISABLED), t1.removeAttribute("aria-disabled");
                }, e1.prototype.executeCallbacks_ = function() {
                    var t1, e1;
                    try {
                        for(var r1 = i1(this.callbacks), n1 = r1.next(); !n1.done; n1 = r1.next()){
                            var o1 = n1.value;
                            try {
                                o1(this);
                            } catch (t1) {
                                a1.MenuUtil.error(t1, "Callback for menu entry " + this.id + " failed.");
                            }
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            n1 && !n1.done && (e1 = r1.return) && e1.call(r1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1;
            }(s1.AbstractEntry);
            e1.AbstractItem = c1;
        },
        1484: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractMenu = void 0;
            var s1 = r1(8372), a1 = r1(1340), l1 = r1(2165), c1 = r1(6186), u1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.className = l1.HtmlClasses.CONTEXTMENU, e1.role = "menu", e1._items = [], e1._baseMenu = null, e1;
                }
                return o1(e1, t1), Object.defineProperty(e1.prototype, "baseMenu", {
                    get: function() {
                        return this._baseMenu;
                    },
                    set: function(t1) {
                        this._baseMenu = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "items", {
                    get: function() {
                        return this._items;
                    },
                    set: function(t1) {
                        this._items = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "pool", {
                    get: function() {
                        return this.variablePool;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "focused", {
                    get: function() {
                        return this._focused;
                    },
                    set: function(t1) {
                        if (this._focused !== t1) {
                            this._focused || this.unfocus();
                            var e1 = this._focused;
                            this._focused = t1, e1 && e1.unfocus();
                        }
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.up = function(t1) {
                    var e1 = this.items.filter(function(t1) {
                        return t1 instanceof a1.AbstractItem && !t1.isHidden();
                    });
                    if (0 !== e1.length) {
                        if (this.focused) {
                            var r1 = e1.indexOf(this.focused);
                            -1 !== r1 && e1[r1 = r1 ? --r1 : e1.length - 1].focus();
                        } else e1[e1.length - 1].focus();
                    }
                }, e1.prototype.down = function(t1) {
                    var e1 = this.items.filter(function(t1) {
                        return t1 instanceof a1.AbstractItem && !t1.isHidden();
                    });
                    if (0 !== e1.length) {
                        if (this.focused) {
                            var r1 = e1.indexOf(this.focused);
                            -1 !== r1 && e1[r1 = ++r1 === e1.length ? 0 : r1].focus();
                        } else e1[0].focus();
                    }
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this), this.generateMenu();
                }, e1.prototype.generateMenu = function() {
                    var t1, e1, r1 = this.html;
                    r1.classList.add(l1.HtmlClasses.MENU);
                    try {
                        for(var n1 = i1(this.items), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var s1 = o1.value;
                            if (s1.isHidden()) {
                                var a1 = s1.html;
                                a1.parentNode && a1.parentNode.removeChild(a1);
                            } else r1.appendChild(s1.html);
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.prototype.post = function(e1, r1) {
                    this.variablePool.update(), t1.prototype.post.call(this, e1, r1);
                }, e1.prototype.unpostSubmenus = function() {
                    var t1, e1, r1 = this.items.filter(function(t1) {
                        return t1 instanceof c1.Submenu;
                    });
                    try {
                        for(var n1 = i1(r1), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var s1 = o1.value;
                            s1.submenu.unpost(), s1 !== this.focused && s1.unfocus();
                        }
                    } catch (e1) {
                        t1 = {
                            error: e1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (e1 = n1.return) && e1.call(n1);
                        } finally{
                            if (t1) throw t1.error;
                        }
                    }
                }, e1.prototype.unpost = function() {
                    t1.prototype.unpost.call(this), this.unpostSubmenus(), this.focused = null;
                }, e1.prototype.find = function(t1) {
                    var e1, r1;
                    try {
                        for(var n1 = i1(this.items), o1 = n1.next(); !o1.done; o1 = n1.next()){
                            var s1 = o1.value;
                            if ("rule" !== s1.type) {
                                if (s1.id === t1) return s1;
                                if ("submenu" === s1.type) {
                                    var a1 = s1.submenu.find(t1);
                                    if (a1) return a1;
                                }
                            }
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            o1 && !o1.done && (r1 = n1.return) && r1.call(n1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    return null;
                }, e1;
            }(s1.AbstractPostable);
            e1.AbstractMenu = u1;
        },
        2868: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractNavigatable = void 0;
            var n1 = r1(3205), o1 = r1(8853), i1 = function() {
                function t1() {
                    this.bubble = !1;
                }
                return t1.prototype.bubbleKey = function() {
                    this.bubble = !0;
                }, t1.prototype.keydown = function(t1) {
                    switch(t1.keyCode){
                        case n1.KEY.ESCAPE:
                            this.escape(t1);
                            break;
                        case n1.KEY.RIGHT:
                            this.right(t1);
                            break;
                        case n1.KEY.LEFT:
                            this.left(t1);
                            break;
                        case n1.KEY.UP:
                            this.up(t1);
                            break;
                        case n1.KEY.DOWN:
                            this.down(t1);
                            break;
                        case n1.KEY.RETURN:
                        case n1.KEY.SPACE:
                            this.space(t1);
                            break;
                        default:
                            return;
                    }
                    this.bubble ? this.bubble = !1 : this.stop(t1);
                }, t1.prototype.escape = function(t1) {}, t1.prototype.space = function(t1) {}, t1.prototype.left = function(t1) {}, t1.prototype.right = function(t1) {}, t1.prototype.up = function(t1) {}, t1.prototype.down = function(t1) {}, t1.prototype.stop = function(t1) {
                    t1 && (t1.stopPropagation(), t1.preventDefault(), t1.cancelBubble = !0);
                }, t1.prototype.mousedown = function(t1) {
                    return this.stop(t1);
                }, t1.prototype.mouseup = function(t1) {
                    return this.stop(t1);
                }, t1.prototype.mouseover = function(t1) {
                    return this.stop(t1);
                }, t1.prototype.mouseout = function(t1) {
                    return this.stop(t1);
                }, t1.prototype.click = function(t1) {
                    return this.stop(t1);
                }, t1.prototype.addEvents = function(t1) {
                    t1.addEventListener(o1.MOUSE.DOWN, this.mousedown.bind(this)), t1.addEventListener(o1.MOUSE.UP, this.mouseup.bind(this)), t1.addEventListener(o1.MOUSE.OVER, this.mouseover.bind(this)), t1.addEventListener(o1.MOUSE.OUT, this.mouseout.bind(this)), t1.addEventListener(o1.MOUSE.CLICK, this.click.bind(this)), t1.addEventListener("keydown", this.keydown.bind(this)), t1.addEventListener("dragstart", this.stop.bind(this)), t1.addEventListener(o1.MOUSE.SELECTSTART, this.stop.bind(this)), t1.addEventListener("contextmenu", this.stop.bind(this)), t1.addEventListener(o1.MOUSE.DBLCLICK, this.stop.bind(this));
                }, t1;
            }();
            e1.AbstractNavigatable = i1;
        },
        8372: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractPostable = void 0;
            var i1 = function(t1) {
                function e1() {
                    var e1 = null !== t1 && t1.apply(this, arguments) || this;
                    return e1.posted = !1, e1;
                }
                return o1(e1, t1), e1.prototype.isPosted = function() {
                    return this.posted;
                }, e1.prototype.post = function(t1, e1) {
                    this.posted || (void 0 !== t1 && void 0 !== e1 && this.html.setAttribute("style", "left: " + t1 + "px; top: " + e1 + "px;"), this.display(), this.posted = !0);
                }, e1.prototype.unpost = function() {
                    if (this.posted) {
                        var t1 = this.html;
                        t1.parentNode && t1.parentNode.removeChild(t1), this.posted = !1;
                    }
                }, e1;
            }(r1(9328).MenuElement);
            e1.AbstractPostable = i1;
        },
        6765: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractVariableItem = void 0;
            var i1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this);
                    var e1 = this.html;
                    this.span || this.generateSpan(), e1.appendChild(this.span), this.update();
                }, e1.prototype.register = function() {
                    this.variable.register(this);
                }, e1.prototype.unregister = function() {
                    this.variable.unregister(this);
                }, e1.prototype.update = function() {
                    this.updateAria(), this.span && this.updateSpan();
                }, e1;
            }(r1(1340).AbstractItem);
            e1.AbstractVariableItem = i1;
        },
        5179: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CloseButton = void 0;
            var i1 = r1(8372), s1 = r1(2165), a1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this) || this;
                    return r1.element = e1, r1.className = s1.HtmlClasses.MENUCLOSE, r1.role = "button", r1;
                }
                return o1(e1, t1), e1.prototype.generateHtml = function() {
                    var t1 = document.createElement("span");
                    t1.classList.add(this.className), t1.setAttribute("role", this.role), t1.setAttribute("tabindex", "0");
                    var e1 = document.createElement("span");
                    e1.textContent = "\xd7", t1.appendChild(e1), this.html = t1;
                }, e1.prototype.display = function() {}, e1.prototype.unpost = function() {
                    t1.prototype.unpost.call(this), this.element.unpost();
                }, e1.prototype.keydown = function(e1) {
                    this.bubbleKey(), t1.prototype.keydown.call(this, e1);
                }, e1.prototype.space = function(t1) {
                    this.unpost(), this.stop(t1);
                }, e1.prototype.mousedown = function(t1) {
                    this.unpost(), this.stop(t1);
                }, e1;
            }(i1.AbstractPostable);
            e1.CloseButton = a1;
        },
        5073: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ContextMenu = void 0;
            var i1 = r1(1484), s1 = r1(2165), a1 = r1(1932), l1 = r1(2358), c1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this) || this;
                    return r1.factory = e1, r1.id = "", r1.moving = !1, r1._store = new a1.MenuStore(r1), r1.widgets = [], r1.variablePool = new l1.VariablePool, r1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1) {
                    var r1 = e1.pool, n1 = e1.items, o1 = e1.id, i1 = void 0 === o1 ? "" : o1, s1 = new this(t1);
                    s1.id = i1;
                    var a1 = t1.get("variable");
                    r1.forEach(function(e1) {
                        return a1(t1, e1, s1.pool);
                    });
                    var l1 = t1.get("items")(t1, n1, s1);
                    return s1.items = l1, s1;
                }, e1.prototype.generateHtml = function() {
                    this.isPosted() && this.unpost(), t1.prototype.generateHtml.call(this), this._frame = document.createElement("div"), this._frame.classList.add(s1.HtmlClasses.MENUFRAME);
                    var e1 = "left: 0px; top: 0px; z-index: 200; width: 100%; height: 100%; border: 0px; padding: 0px; margin: 0px;";
                    this._frame.setAttribute("style", "position: absolute; " + e1);
                    var r1 = document.createElement("div");
                    r1.setAttribute("style", "position: fixed; " + e1), this._frame.appendChild(r1), r1.addEventListener("mousedown", (function(t1) {
                        this.unpost(), this.unpostWidgets(), this.stop(t1);
                    }).bind(this));
                }, e1.prototype.display = function() {
                    document.body.appendChild(this.frame), this.frame.appendChild(this.html), this.focus();
                }, e1.prototype.escape = function(t1) {
                    this.unpost(), this.unpostWidgets();
                }, e1.prototype.unpost = function() {
                    if (t1.prototype.unpost.call(this), !(this.widgets.length > 0)) {
                        this.frame.parentNode.removeChild(this.frame);
                        var e1 = this.store;
                        this.moving || e1.insertTaborder(), e1.active.focus();
                    }
                }, e1.prototype.left = function(t1) {
                    this.move_(this.store.previous());
                }, e1.prototype.right = function(t1) {
                    this.move_(this.store.next());
                }, Object.defineProperty(e1.prototype, "frame", {
                    get: function() {
                        return this._frame;
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e1.prototype, "store", {
                    get: function() {
                        return this._store;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.post = function(e1, r1) {
                    if (void 0 !== r1) return this.moving || this.store.removeTaborder(), void t1.prototype.post.call(this, e1, r1);
                    var n1, o1, i1, s1 = e1;
                    if (s1 instanceof Event ? (n1 = s1.target, this.stop(s1)) : n1 = s1, s1 instanceof MouseEvent && (o1 = s1.pageX, i1 = s1.pageY, o1 || i1 || !s1.clientX || (o1 = s1.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, i1 = s1.clientY + document.body.scrollTop + document.documentElement.scrollTop)), !o1 && !i1 && n1) {
                        var a1 = window.pageXOffset || document.documentElement.scrollLeft, l1 = window.pageYOffset || document.documentElement.scrollTop, c1 = n1.getBoundingClientRect();
                        o1 = (c1.right + c1.left) / 2 + a1, i1 = (c1.bottom + c1.top) / 2 + l1;
                    }
                    this.store.active = n1, this.anchor = this.store.active;
                    var u1 = this.html;
                    o1 + u1.offsetWidth > document.body.offsetWidth - 5 && (o1 = document.body.offsetWidth - u1.offsetWidth - 5), this.post(o1, i1);
                }, e1.prototype.registerWidget = function(t1) {
                    this.widgets.push(t1);
                }, e1.prototype.unregisterWidget = function(t1) {
                    var e1 = this.widgets.indexOf(t1);
                    e1 > -1 && this.widgets.splice(e1, 1), 0 === this.widgets.length && this.unpost();
                }, e1.prototype.unpostWidgets = function() {
                    this.widgets.forEach(function(t1) {
                        return t1.unpost();
                    });
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1.prototype.move_ = function(t1) {
                    this.anchor && t1 !== this.anchor && (this.moving = !0, this.unpost(), this.post(t1), this.moving = !1);
                }, e1;
            }(i1.AbstractMenu);
            e1.ContextMenu = c1;
        },
        7309: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CssStyles = void 0;
            var n1 = r1(2165);
            !function(t1) {
                function e1(t1) {
                    return "." + (n1.HtmlClasses[t1] || t1);
                }
                var r1 = {};
                r1[e1("INFOCLOSE")] = "{  top:.2em; right:.2em;}", r1[e1("INFOCONTENT")] = "{  overflow:auto; text-align:left; font-size:80%;  padding:.4em .6em; border:1px inset; margin:1em 0px;  max-height:20em; max-width:30em; background-color:#EEEEEE;  white-space:normal;}", r1[e1("INFO") + e1("MOUSEPOST")] = "{outline:none;}", r1[e1("INFO")] = '{  position:fixed; left:50%; width:auto; text-align:center;  border:3px outset; padding:1em 2em; background-color:#DDDDDD;  color:black;  cursor:default; font-family:message-box; font-size:120%;  font-style:normal; text-indent:0; text-transform:none;  line-height:normal; letter-spacing:normal; word-spacing:normal;  word-wrap:normal; white-space:nowrap; float:none; z-index:201;  border-radius: 15px;                     /* Opera 10.5 and IE9 */  -webkit-border-radius:15px;               /* Safari and Chrome */  -moz-border-radius:15px;                  /* Firefox */  -khtml-border-radius:15px;                /* Konqueror */  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */  filter:progid:DXImageTransform.Microsoft.dropshadow(OffX=2, OffY=2, Color="gray", Positive="true"); /* IE */}';
                var o1 = {};
                o1[e1("MENU")] = "{  position:absolute;  background-color:white;  color:black;  width:auto; padding:5px 0px;  border:1px solid #CCCCCC; margin:0; cursor:default;  font: menu; text-align:left; text-indent:0; text-transform:none;  line-height:normal; letter-spacing:normal; word-spacing:normal;  word-wrap:normal; white-space:nowrap; float:none; z-index:201;  border-radius: 5px;                     /* Opera 10.5 and IE9 */  -webkit-border-radius: 5px;             /* Safari and Chrome */  -moz-border-radius: 5px;                /* Firefox */  -khtml-border-radius: 5px;              /* Konqueror */  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */}", o1[e1("MENUITEM")] = "{  padding: 1px 2em;  background:transparent;}", o1[e1("MENUARROW")] = "{  position:absolute; right:.5em; padding-top:.25em; color:#666666;  font-family: null; font-size: .75em}", o1[e1("MENUACTIVE") + " " + e1("MENUARROW")] = "{color:white}", o1[e1("MENUARROW") + e1("RTL")] = "{left:.5em; right:auto}", o1[e1("MENUCHECK")] = "{  position:absolute; left:.7em;  font-family: null}", o1[e1("MENUCHECK") + e1("RTL")] = "{ right:.7em; left:auto }", o1[e1("MENURADIOCHECK")] = "{  position:absolute; left: .7em;}", o1[e1("MENURADIOCHECK") + e1("RTL")] = "{  right: .7em; left:auto}", o1[e1("MENUINPUTBOX")] = "{  padding-left: 1em; right:.5em; color:#666666;  font-family: null;}", o1[e1("MENUINPUTBOX") + e1("RTL")] = "{  left: .1em;}", o1[e1("MENUCOMBOBOX")] = "{  left:.1em; padding-bottom:.5em;}", o1[e1("MENUSLIDER")] = "{  left: .1em;}", o1[e1("SLIDERVALUE")] = "{  position:absolute; right:.1em; padding-top:.25em; color:#333333;  font-size: .75em}", o1[e1("SLIDERBAR")] = "{  outline: none; background: #d3d3d3}", o1[e1("MENULABEL")] = "{  padding: 1px 2em 3px 1.33em;  font-style:italic}", o1[e1("MENURULE")] = "{  border-top: 1px solid #DDDDDD;  margin: 4px 3px;}", o1[e1("MENUDISABLED")] = "{  color:GrayText}", o1[e1("MENUACTIVE")] = "{  background-color: #606872;  color: white;}", o1[e1("MENUDISABLED") + ":focus"] = "{  background-color: #E8E8E8}", o1[e1("MENULABEL") + ":focus"] = "{  background-color: #E8E8E8}", o1[e1("CONTEXTMENU") + ":focus"] = "{  outline:none}", o1[e1("CONTEXTMENU") + " " + e1("MENUITEM") + ":focus"] = "{  outline:none}", o1[e1("SELECTIONMENU")] = "{  position:relative; float:left;  border-bottom: none; -webkit-box-shadow:none; -webkit-border-radius:0px; }", o1[e1("SELECTIONITEM")] = "{  padding-right: 1em;}", o1[e1("SELECTION")] = "{  right: 40%; width:50%; }", o1[e1("SELECTIONBOX")] = "{  padding: 0em; max-height:20em; max-width: none;  background-color:#FFFFFF;}", o1[e1("SELECTIONDIVIDER")] = "{  clear: both; border-top: 2px solid #000000;}", o1[e1("MENU") + " " + e1("MENUCLOSE")] = "{  top:-10px; left:-10px}";
                var i1 = {};
                i1[e1("MENUCLOSE")] = '{  position:absolute;  cursor:pointer;  display:inline-block;  border:2px solid #AAA;  border-radius:18px;  -webkit-border-radius: 18px;             /* Safari and Chrome */  -moz-border-radius: 18px;                /* Firefox */  -khtml-border-radius: 18px;              /* Konqueror */  font-family: "Courier New", Courier;  font-size:24px;  color:#F0F0F0}', i1[e1("MENUCLOSE") + " span"] = "{  display:block; background-color:#AAA; border:1.5px solid;  border-radius:18px;  -webkit-border-radius: 18px;             /* Safari and Chrome */  -moz-border-radius: 18px;                /* Firefox */  -khtml-border-radius: 18px;              /* Konqueror */  line-height:0;  padding:8px 0 6px     /* may need to be browser-specific */}", i1[e1("MENUCLOSE") + ":hover"] = "{  color:white!important;  border:2px solid #CCC!important}", i1[e1("MENUCLOSE") + ":hover span"] = "{  background-color:#CCC!important}", i1[e1("MENUCLOSE") + ":hover:focus"] = "{  outline:none}";
                var s1 = !1, a1 = !1, l1 = !1;
                function c1(t1) {
                    l1 || (u1(i1, t1), l1 = !0);
                }
                function u1(t1, e1) {
                    var r1 = e1 || document, n1 = r1.createElement("style");
                    n1.type = "text/css";
                    var o1 = "";
                    for(var i1 in t1)o1 += i1, o1 += " ", o1 += t1[i1], o1 += "\n";
                    n1.innerHTML = o1, r1.head.appendChild(n1);
                }
                t1.addMenuStyles = function(t1) {
                    a1 || (u1(o1, t1), a1 = !0, c1(t1));
                }, t1.addInfoStyles = function(t1) {
                    s1 || (u1(r1, t1), s1 = !0, c1(t1));
                };
            }(e1.CssStyles || (e1.CssStyles = {}));
        },
        2165: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HtmlAttrs = e1.HtmlClasses = void 0;
            function r1(t1) {
                return "CtxtMenu_" + t1;
            }
            function n1(t1) {
                return r1(t1);
            }
            function o1(t1) {
                return r1(t1);
            }
            e1.HtmlClasses = {
                ATTACHED: n1("Attached"),
                CONTEXTMENU: n1("ContextMenu"),
                MENU: n1("Menu"),
                MENUARROW: n1("MenuArrow"),
                MENUACTIVE: n1("MenuActive"),
                MENUCHECK: n1("MenuCheck"),
                MENUCLOSE: n1("MenuClose"),
                MENUCOMBOBOX: n1("MenuComboBox"),
                MENUDISABLED: n1("MenuDisabled"),
                MENUFRAME: n1("MenuFrame"),
                MENUITEM: n1("MenuItem"),
                MENULABEL: n1("MenuLabel"),
                MENURADIOCHECK: n1("MenuRadioCheck"),
                MENUINPUTBOX: n1("MenuInputBox"),
                MENURULE: n1("MenuRule"),
                MENUSLIDER: n1("MenuSlider"),
                MOUSEPOST: n1("MousePost"),
                RTL: n1("RTL"),
                INFO: n1("Info"),
                INFOCLOSE: n1("InfoClose"),
                INFOCONTENT: n1("InfoContent"),
                INFOSIGNATURE: n1("InfoSignature"),
                INFOTITLE: n1("InfoTitle"),
                SLIDERVALUE: n1("SliderValue"),
                SLIDERBAR: n1("SliderBar"),
                SELECTION: n1("Selection"),
                SELECTIONBOX: n1("SelectionBox"),
                SELECTIONMENU: n1("SelectionMenu"),
                SELECTIONDIVIDER: n1("SelectionDivider"),
                SELECTIONITEM: n1("SelectionItem")
            }, e1.HtmlAttrs = {
                COUNTER: o1("Counter"),
                KEYDOWNFUNC: o1("keydownFunc"),
                CONTEXTMENUFUNC: o1("contextmenuFunc"),
                OLDTAB: o1("Oldtabindex"),
                TOUCHFUNC: o1("TouchFunc")
            };
        },
        4922: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Info = void 0;
            var i1 = r1(5179), s1 = r1(2165), a1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1 = t1.call(this) || this;
                    return o1.title = e1, o1.signature = n1, o1.className = s1.HtmlClasses.INFO, o1.role = "dialog", o1.contentDiv = o1.generateContent(), o1.close = o1.generateClose(), o1.content = r1 || function() {
                        return "";
                    }, o1;
                }
                return o1(e1, t1), e1.prototype.attachMenu = function(t1) {
                    this.menu = t1;
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this);
                    var e1 = this.html;
                    e1.appendChild(this.generateTitle()), e1.appendChild(this.contentDiv), e1.appendChild(this.generateSignature()), e1.appendChild(this.close.html), e1.setAttribute("tabindex", "0");
                }, e1.prototype.post = function() {
                    t1.prototype.post.call(this);
                    var e1 = document.documentElement, r1 = this.html, n1 = window.innerHeight || e1.clientHeight || e1.scrollHeight || 0, o1 = Math.floor(-r1.offsetWidth / 2), i1 = Math.floor((n1 - r1.offsetHeight) / 3);
                    r1.setAttribute("style", "margin-left: " + o1 + "px; top: " + i1 + "px;"), window.event instanceof MouseEvent && r1.classList.add(s1.HtmlClasses.MOUSEPOST), r1.focus();
                }, e1.prototype.display = function() {
                    this.menu.registerWidget(this), this.contentDiv.innerHTML = this.content();
                    var t1 = this.menu.html;
                    t1.parentNode && t1.parentNode.removeChild(t1), this.menu.frame.appendChild(this.html);
                }, e1.prototype.click = function(t1) {}, e1.prototype.keydown = function(e1) {
                    this.bubbleKey(), t1.prototype.keydown.call(this, e1);
                }, e1.prototype.escape = function(t1) {
                    this.unpost();
                }, e1.prototype.unpost = function() {
                    t1.prototype.unpost.call(this), this.html.classList.remove(s1.HtmlClasses.MOUSEPOST), this.menu.unregisterWidget(this);
                }, e1.prototype.generateClose = function() {
                    var t1 = new i1.CloseButton(this), e1 = t1.html;
                    return e1.classList.add(s1.HtmlClasses.INFOCLOSE), e1.setAttribute("aria-label", "Close Dialog Box"), t1;
                }, e1.prototype.generateTitle = function() {
                    var t1 = document.createElement("span");
                    return t1.innerHTML = this.title, t1.classList.add(s1.HtmlClasses.INFOTITLE), t1;
                }, e1.prototype.generateContent = function() {
                    var t1 = document.createElement("div");
                    return t1.classList.add(s1.HtmlClasses.INFOCONTENT), t1.setAttribute("tabindex", "0"), t1;
                }, e1.prototype.generateSignature = function() {
                    var t1 = document.createElement("span");
                    return t1.innerHTML = this.signature, t1.classList.add(s1.HtmlClasses.INFOSIGNATURE), t1;
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(r1(8372).AbstractPostable);
            e1.Info = a1;
        },
        1409: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Checkbox = void 0;
            var i1 = r1(6765), s1 = r1(2556), a1 = r1(2165), l1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    var i1 = t1.call(this, e1, "checkbox", r1, o1) || this;
                    return i1.role = "menuitemcheckbox", i1.variable = e1.pool.lookup(n1), i1.register(), i1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    return new this(r1, e1.content, e1.variable, e1.id);
                }, e1.prototype.executeAction = function() {
                    this.variable.setValue(!this.variable.getValue()), s1.MenuUtil.close(this);
                }, e1.prototype.generateSpan = function() {
                    this.span = document.createElement("span"), this.span.textContent = "✓", this.span.classList.add(a1.HtmlClasses.MENUCHECK);
                }, e1.prototype.updateAria = function() {
                    this.html.setAttribute("aria-checked", this.variable.getValue() ? "true" : "false");
                }, e1.prototype.updateSpan = function() {
                    this.span.style.display = this.variable.getValue() ? "" : "none";
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(i1.AbstractVariableItem);
            e1.Checkbox = l1;
        },
        9886: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Combo = void 0;
            var i1 = r1(6765), s1 = r1(2556), a1 = r1(2165), l1 = r1(3205), c1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    var i1 = t1.call(this, e1, "combobox", r1, o1) || this;
                    return i1.role = "combobox", i1.inputEvent = !1, i1.variable = e1.pool.lookup(n1), i1.register(), i1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    return new this(r1, e1.content, e1.variable, e1.id);
                }, e1.prototype.executeAction = function() {
                    this.variable.setValue(this.input.value, s1.MenuUtil.getActiveElement(this));
                }, e1.prototype.space = function(e1) {
                    t1.prototype.space.call(this, e1), s1.MenuUtil.close(this);
                }, e1.prototype.focus = function() {
                    t1.prototype.focus.call(this), this.input.focus();
                }, e1.prototype.unfocus = function() {
                    t1.prototype.unfocus.call(this), this.updateSpan();
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this), this.html.classList.add(a1.HtmlClasses.MENUCOMBOBOX);
                }, e1.prototype.generateSpan = function() {
                    this.span = document.createElement("span"), this.span.classList.add(a1.HtmlClasses.MENUINPUTBOX), this.input = document.createElement("input"), this.input.addEventListener("keydown", this.inputKey.bind(this)), this.input.setAttribute("size", "10em"), this.input.setAttribute("type", "text"), this.input.setAttribute("tabindex", "-1"), this.span.appendChild(this.input);
                }, e1.prototype.inputKey = function(t1) {
                    this.bubbleKey(), this.inputEvent = !0;
                }, e1.prototype.keydown = function(e1) {
                    if (this.inputEvent && e1.keyCode !== l1.KEY.ESCAPE && e1.keyCode !== l1.KEY.RETURN) return this.inputEvent = !1, void e1.stopPropagation();
                    t1.prototype.keydown.call(this, e1), e1.stopPropagation();
                }, e1.prototype.updateAria = function() {}, e1.prototype.updateSpan = function() {
                    var t1;
                    try {
                        t1 = this.variable.getValue(s1.MenuUtil.getActiveElement(this));
                    } catch (e1) {
                        t1 = "";
                    }
                    this.input.value = t1;
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(i1.AbstractVariableItem);
            e1.Combo = c1;
        },
        3467: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Command = void 0;
            var i1 = r1(1340), s1 = r1(2556), a1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    var i1 = t1.call(this, e1, "command", r1, o1) || this;
                    return i1.command = n1, i1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    return new this(r1, e1.content, e1.action, e1.id);
                }, e1.prototype.executeAction = function() {
                    try {
                        this.command(s1.MenuUtil.getActiveElement(this));
                    } catch (t1) {
                        s1.MenuUtil.error(t1, "Illegal command callback.");
                    }
                    s1.MenuUtil.close(this);
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(i1.AbstractItem);
            e1.Command = a1;
        },
        2965: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Label = void 0;
            var i1 = r1(1340), s1 = r1(2165), a1 = function(t1) {
                function e1(e1, r1, n1) {
                    return t1.call(this, e1, "label", r1, n1) || this;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    return new this(r1, e1.content, e1.id);
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this), this.html.classList.add(s1.HtmlClasses.MENULABEL);
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(i1.AbstractItem);
            e1.Label = a1;
        },
        385: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Radio = void 0;
            var i1 = r1(6765), s1 = r1(2556), a1 = r1(2165), l1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    var i1 = t1.call(this, e1, "radio", r1, o1) || this;
                    return i1.role = "menuitemradio", i1.variable = e1.pool.lookup(n1), i1.register(), i1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    return new this(r1, e1.content, e1.variable, e1.id);
                }, e1.prototype.executeAction = function() {
                    this.variable.setValue(this.id), s1.MenuUtil.close(this);
                }, e1.prototype.generateSpan = function() {
                    this.span = document.createElement("span"), this.span.textContent = "✓", this.span.classList.add(a1.HtmlClasses.MENURADIOCHECK);
                }, e1.prototype.updateAria = function() {
                    this.html.setAttribute("aria-checked", this.variable.getValue() === this.id ? "true" : "false");
                }, e1.prototype.updateSpan = function() {
                    this.span.style.display = this.variable.getValue() === this.id ? "" : "none";
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(i1.AbstractVariableItem);
            e1.Radio = l1;
        },
        3463: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Rule = void 0;
            var i1 = r1(9329), s1 = r1(2165), a1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this, e1, "rule") || this;
                    return r1.className = s1.HtmlClasses.MENUITEM, r1.role = "separator", r1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    return new this(r1);
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this);
                    var e1 = this.html;
                    e1.classList.add(s1.HtmlClasses.MENURULE), e1.setAttribute("aria-orientation", "vertical");
                }, e1.prototype.addEvents = function(t1) {}, e1.prototype.toJson = function() {
                    return {
                        type: "rule"
                    };
                }, e1;
            }(i1.AbstractEntry);
            e1.Rule = a1;
        },
        7625: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Slider = void 0;
            var i1 = r1(6765), s1 = r1(2556), a1 = r1(2165), l1 = r1(3205), c1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    var i1 = t1.call(this, e1, "slider", r1, o1) || this;
                    return i1.role = "slider", i1.labelId = "ctx_slideLabel" + s1.MenuUtil.counter(), i1.valueId = "ctx_slideValue" + s1.MenuUtil.counter(), i1.inputEvent = !1, i1.variable = e1.pool.lookup(n1), i1.register(), i1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    return new this(r1, e1.content, e1.variable, e1.id);
                }, e1.prototype.executeAction = function() {
                    this.variable.setValue(this.input.value, s1.MenuUtil.getActiveElement(this)), this.update();
                }, e1.prototype.space = function(e1) {
                    t1.prototype.space.call(this, e1), s1.MenuUtil.close(this);
                }, e1.prototype.focus = function() {
                    t1.prototype.focus.call(this), this.input.focus();
                }, e1.prototype.unfocus = function() {
                    t1.prototype.unfocus.call(this), this.updateSpan();
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this), this.html.classList.add(a1.HtmlClasses.MENUSLIDER), this.valueSpan = document.createElement("span"), this.valueSpan.setAttribute("id", this.valueId), this.valueSpan.classList.add(a1.HtmlClasses.SLIDERVALUE), this.html.appendChild(this.valueSpan);
                }, e1.prototype.generateSpan = function() {
                    this.span = document.createElement("span"), this.labelSpan = document.createElement("span"), this.labelSpan.setAttribute("id", this.labelId), this.labelSpan.appendChild(this.html.childNodes[0]), this.html.appendChild(this.labelSpan), this.input = document.createElement("input"), this.input.setAttribute("type", "range"), this.input.setAttribute("min", "0"), this.input.setAttribute("max", "100"), this.input.setAttribute("aria-valuemin", "0"), this.input.setAttribute("aria-valuemax", "100"), this.input.setAttribute("aria-labelledby", this.labelId), this.input.addEventListener("keydown", this.inputKey.bind(this)), this.input.addEventListener("input", this.executeAction.bind(this)), this.input.classList.add(a1.HtmlClasses.SLIDERBAR), this.span.appendChild(this.input);
                }, e1.prototype.inputKey = function(t1) {
                    this.inputEvent = !0;
                }, e1.prototype.mousedown = function(t1) {
                    t1.stopPropagation();
                }, e1.prototype.mouseup = function(t1) {
                    event.stopPropagation();
                }, e1.prototype.keydown = function(e1) {
                    var r1 = e1.keyCode;
                    return r1 === l1.KEY.UP || r1 === l1.KEY.DOWN ? (e1.preventDefault(), void t1.prototype.keydown.call(this, e1)) : this.inputEvent && r1 !== l1.KEY.ESCAPE && r1 !== l1.KEY.RETURN ? (this.inputEvent = !1, void e1.stopPropagation()) : (t1.prototype.keydown.call(this, e1), void e1.stopPropagation());
                }, e1.prototype.updateAria = function() {
                    var t1 = this.variable.getValue();
                    t1 && this.input && (this.input.setAttribute("aria-valuenow", t1), this.input.setAttribute("aria-valuetext", t1 + "%"));
                }, e1.prototype.updateSpan = function() {
                    var t1;
                    try {
                        t1 = this.variable.getValue(s1.MenuUtil.getActiveElement(this)), this.valueSpan.innerHTML = t1 + "%";
                    } catch (e1) {
                        t1 = "";
                    }
                    this.input.value = t1;
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(i1.AbstractVariableItem);
            e1.Slider = c1;
        },
        6186: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Submenu = void 0;
            var i1 = r1(1340), s1 = r1(2165), a1 = function(t1) {
                function e1(e1, r1, n1) {
                    var o1 = t1.call(this, e1, "submenu", r1, n1) || this;
                    return o1._submenu = null, o1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    var n1 = e1.content, o1 = e1.menu, i1 = new this(r1, n1, e1.id), s1 = t1.get("subMenu")(t1, o1, i1);
                    return i1.submenu = s1, i1;
                }, Object.defineProperty(e1.prototype, "submenu", {
                    get: function() {
                        return this._submenu;
                    },
                    set: function(t1) {
                        this._submenu = t1;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.mouseover = function(t1) {
                    this.focus(), this.stop(t1);
                }, e1.prototype.mouseout = function(t1) {
                    this.stop(t1);
                }, e1.prototype.unfocus = function() {
                    if (this.submenu.isPosted()) {
                        if (this.menu.focused !== this) return t1.prototype.unfocus.call(this), void this.menu.unpostSubmenus();
                        this.html.setAttribute("tabindex", "-1"), this.html.blur();
                    } else t1.prototype.unfocus.call(this);
                }, e1.prototype.focus = function() {
                    t1.prototype.focus.call(this), this.submenu.isPosted() || this.disabled || this.submenu.post();
                }, e1.prototype.executeAction = function() {
                    this.submenu.isPosted() ? this.submenu.unpost() : this.submenu.post();
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this);
                    var e1 = this.html;
                    this.span = document.createElement("span"), this.span.textContent = "►", this.span.classList.add(s1.HtmlClasses.MENUARROW), e1.appendChild(this.span), e1.setAttribute("aria-haspopup", "true");
                }, e1.prototype.left = function(e1) {
                    this.submenu.isPosted() ? this.submenu.unpost() : t1.prototype.left.call(this, e1);
                }, e1.prototype.right = function(t1) {
                    this.submenu.isPosted() ? this.submenu.down(t1) : this.submenu.post();
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(i1.AbstractItem);
            e1.Submenu = a1;
        },
        3205: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.KEY = void 0, function(t1) {
                t1[t1.RETURN = 13] = "RETURN", t1[t1.ESCAPE = 27] = "ESCAPE", t1[t1.SPACE = 32] = "SPACE", t1[t1.LEFT = 37] = "LEFT", t1[t1.UP = 38] = "UP", t1[t1.RIGHT = 39] = "RIGHT", t1[t1.DOWN = 40] = "DOWN";
            }(e1.KEY || (e1.KEY = {}));
        },
        9328: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MenuElement = void 0;
            var i1 = function(t1) {
                function e1() {
                    return null !== t1 && t1.apply(this, arguments) || this;
                }
                return o1(e1, t1), e1.prototype.addAttributes = function(t1) {
                    for(var e1 in t1)this.html.setAttribute(e1, t1[e1]);
                }, Object.defineProperty(e1.prototype, "html", {
                    get: function() {
                        return this._html || this.generateHtml(), this._html;
                    },
                    set: function(t1) {
                        this._html = t1, this.addEvents(t1);
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.generateHtml = function() {
                    var t1 = document.createElement("div");
                    t1.classList.add(this.className), t1.setAttribute("role", this.role), this.html = t1;
                }, e1.prototype.focus = function() {
                    var t1 = this.html;
                    t1.setAttribute("tabindex", "0"), t1.focus();
                }, e1.prototype.unfocus = function() {
                    var t1 = this.html;
                    t1.hasAttribute("tabindex") && t1.setAttribute("tabindex", "-1");
                    try {
                        t1.blur();
                    } catch (t1) {}
                    t1.blur();
                }, e1;
            }(r1(2868).AbstractNavigatable);
            e1.MenuElement = i1;
        },
        1932: function(t1, e1, r1) {
            var n1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MenuStore = void 0;
            var o1 = r1(2556), i1 = r1(2165), s1 = r1(3205), a1 = function() {
                function t1(t1) {
                    this.menu = t1, this.store = [], this._active = null, this.counter = 0, this.attachedClass = i1.HtmlClasses.ATTACHED + "_" + o1.MenuUtil.counter(), this.taborder = !0, this.attrMap = {};
                }
                return Object.defineProperty(t1.prototype, "active", {
                    get: function() {
                        return this._active;
                    },
                    set: function(t1) {
                        do {
                            if (-1 !== this.store.indexOf(t1)) {
                                this._active = t1;
                                break;
                            }
                            t1 = t1.parentNode;
                        }while (t1);
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.next = function() {
                    var t1 = this.store.length;
                    if (0 === t1) return this.active = null, null;
                    var e1 = this.store.indexOf(this.active);
                    return e1 = -1 === e1 ? 0 : e1 < t1 - 1 ? e1 + 1 : 0, this.active = this.store[e1], this.active;
                }, t1.prototype.previous = function() {
                    var t1 = this.store.length;
                    if (0 === t1) return this.active = null, null;
                    var e1 = t1 - 1, r1 = this.store.indexOf(this.active);
                    return r1 = -1 === r1 || 0 === r1 ? e1 : r1 - 1, this.active = this.store[r1], this.active;
                }, t1.prototype.clear = function() {
                    this.remove(this.store);
                }, t1.prototype.insert = function(t1) {
                    var e1, r1, o1 = t1 instanceof HTMLElement ? [
                        t1
                    ] : t1;
                    try {
                        for(var i1 = n1(o1), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value;
                            this.insertElement(a1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    this.sort();
                }, t1.prototype.remove = function(t1) {
                    var e1, r1, o1 = t1 instanceof HTMLElement ? [
                        t1
                    ] : t1;
                    try {
                        for(var i1 = n1(o1), s1 = i1.next(); !s1.done; s1 = i1.next()){
                            var a1 = s1.value;
                            this.removeElement(a1);
                        }
                    } catch (t1) {
                        e1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            s1 && !s1.done && (r1 = i1.return) && r1.call(i1);
                        } finally{
                            if (e1) throw e1.error;
                        }
                    }
                    this.sort();
                }, t1.prototype.inTaborder = function(t1) {
                    this.taborder && !t1 && this.removeTaborder(), !this.taborder && t1 && this.insertTaborder(), this.taborder = t1;
                }, t1.prototype.insertTaborder = function() {
                    this.taborder && this.insertTaborder_();
                }, t1.prototype.removeTaborder = function() {
                    this.taborder && this.removeTaborder_();
                }, t1.prototype.insertElement = function(t1) {
                    t1.classList.contains(this.attachedClass) || (t1.classList.add(this.attachedClass), this.taborder && this.addTabindex(t1), this.addEvents(t1));
                }, t1.prototype.removeElement = function(t1) {
                    t1.classList.contains(this.attachedClass) && (t1.classList.remove(this.attachedClass), this.taborder && this.removeTabindex(t1), this.removeEvents(t1));
                }, t1.prototype.sort = function() {
                    var t1 = document.getElementsByClassName(this.attachedClass);
                    this.store = [].slice.call(t1);
                }, t1.prototype.insertTaborder_ = function() {
                    this.store.forEach(function(t1) {
                        return t1.setAttribute("tabindex", "0");
                    });
                }, t1.prototype.removeTaborder_ = function() {
                    this.store.forEach(function(t1) {
                        return t1.setAttribute("tabindex", "-1");
                    });
                }, t1.prototype.addTabindex = function(t1) {
                    t1.hasAttribute("tabindex") && t1.setAttribute(i1.HtmlAttrs.OLDTAB, t1.getAttribute("tabindex")), t1.setAttribute("tabindex", "0");
                }, t1.prototype.removeTabindex = function(t1) {
                    t1.hasAttribute(i1.HtmlAttrs.OLDTAB) ? (t1.setAttribute("tabindex", t1.getAttribute(i1.HtmlAttrs.OLDTAB)), t1.removeAttribute(i1.HtmlAttrs.OLDTAB)) : t1.removeAttribute("tabindex");
                }, t1.prototype.addEvents = function(t1) {
                    t1.hasAttribute(i1.HtmlAttrs.COUNTER) || (this.addEvent(t1, "contextmenu", this.menu.post.bind(this.menu)), this.addEvent(t1, "keydown", this.keydown.bind(this)), t1.setAttribute(i1.HtmlAttrs.COUNTER, this.counter.toString()), this.counter++);
                }, t1.prototype.addEvent = function(t1, e1, r1) {
                    var n1 = i1.HtmlAttrs[e1.toUpperCase() + "FUNC"];
                    this.attrMap[n1 + this.counter] = r1, t1.addEventListener(e1, r1);
                }, t1.prototype.removeEvents = function(t1) {
                    if (t1.hasAttribute(i1.HtmlAttrs.COUNTER)) {
                        var e1 = t1.getAttribute(i1.HtmlAttrs.COUNTER);
                        this.removeEvent(t1, "contextmenu", e1), this.removeEvent(t1, "keydown", e1), t1.removeAttribute(i1.HtmlAttrs.COUNTER);
                    }
                }, t1.prototype.removeEvent = function(t1, e1, r1) {
                    var n1 = i1.HtmlAttrs[e1.toUpperCase() + "FUNC"], o1 = this.attrMap[n1 + r1];
                    t1.removeEventListener(e1, o1);
                }, t1.prototype.keydown = function(t1) {
                    t1.keyCode === s1.KEY.SPACE && (this.menu.post(t1), t1.preventDefault(), t1.stopImmediatePropagation());
                }, t1;
            }();
            e1.MenuStore = a1;
        },
        2556: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MenuUtil = void 0, function(t1) {
                t1.close = function(t1) {
                    var e1 = t1.menu;
                    e1.baseMenu ? e1.baseMenu.unpost() : e1.unpost();
                }, t1.getActiveElement = function(t1) {
                    var e1 = t1.menu;
                    return (e1.baseMenu ? e1.baseMenu : e1).store.active;
                }, t1.error = function(t1, e1) {
                    console.error("ContextMenu Error: " + e1);
                }, t1.counter = function() {
                    return e1++;
                };
                var e1 = 0;
            }(e1.MenuUtil || (e1.MenuUtil = {}));
        },
        8853: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MOUSE = void 0, e1.MOUSE = {
                CLICK: "click",
                DBLCLICK: "dblclick",
                DOWN: "mousedown",
                UP: "mouseup",
                OVER: "mouseover",
                OUT: "mouseout",
                MOVE: "mousemove",
                SELECTEND: "selectend",
                SELECTSTART: "selectstart"
            };
        },
        6914: function(t1, e1, r1) {
            var n1 = this && this.__rest || function(t1, e1) {
                var r1 = {};
                for(var n1 in t1)Object.prototype.hasOwnProperty.call(t1, n1) && e1.indexOf(n1) < 0 && (r1[n1] = t1[n1]);
                if (null != t1 && "function" == typeof Object.getOwnPropertySymbols) {
                    var o1 = 0;
                    for(n1 = Object.getOwnPropertySymbols(t1); o1 < n1.length; o1++)e1.indexOf(n1[o1]) < 0 && Object.prototype.propertyIsEnumerable.call(t1, n1[o1]) && (r1[n1[o1]] = t1[n1[o1]]);
                }
                return r1;
            }, o1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            }, i1 = this && this.__values || function(t1) {
                var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], n1 = 0;
                if (r1) return r1.call(t1);
                if (t1 && "number" == typeof t1.length) return {
                    next: function() {
                        return t1 && n1 >= t1.length && (t1 = void 0), {
                            value: t1 && t1[n1++],
                            done: !t1
                        };
                    }
                };
                throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, s1 = this && this.__spread || function() {
                for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1 = t1.concat(o1(arguments[e1]));
                return t1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Parser = void 0;
            var a1 = r1(3467), l1 = r1(5073), c1 = r1(3737), u1 = r1(1409), p1 = r1(9886), h1 = r1(2965), f1 = r1(385), d1 = r1(6186), m1 = r1(3463), y1 = r1(7625), g1 = r1(4834), b1 = r1(2100), v1 = r1(2308), _1 = function() {
                function t1(t1) {
                    var e1 = this;
                    void 0 === t1 && (t1 = []), this._initList = [
                        [
                            "command",
                            a1.Command.fromJson.bind(a1.Command)
                        ],
                        [
                            "checkbox",
                            u1.Checkbox.fromJson.bind(u1.Checkbox)
                        ],
                        [
                            "combo",
                            p1.Combo.fromJson.bind(p1.Combo)
                        ],
                        [
                            "slider",
                            y1.Slider.fromJson.bind(y1.Slider)
                        ],
                        [
                            "label",
                            h1.Label.fromJson.bind(h1.Label)
                        ],
                        [
                            "radio",
                            f1.Radio.fromJson.bind(f1.Radio)
                        ],
                        [
                            "rule",
                            m1.Rule.fromJson.bind(m1.Rule)
                        ],
                        [
                            "submenu",
                            d1.Submenu.fromJson.bind(d1.Submenu)
                        ],
                        [
                            "contextMenu",
                            l1.ContextMenu.fromJson.bind(l1.ContextMenu)
                        ],
                        [
                            "subMenu",
                            g1.SubMenu.fromJson.bind(g1.SubMenu)
                        ],
                        [
                            "variable",
                            c1.Variable.fromJson.bind(c1.Variable)
                        ],
                        [
                            "items",
                            this.items.bind(this)
                        ],
                        [
                            "selectionMenu",
                            b1.SelectionMenu.fromJson.bind(b1.SelectionMenu)
                        ],
                        [
                            "selectionBox",
                            b1.SelectionBox.fromJson.bind(b1.SelectionBox)
                        ]
                    ], this._factory = new v1.ParserFactory(this._initList), t1.forEach(function(t1) {
                        var r1 = o1(t1, 2), n1 = r1[0], i1 = r1[1];
                        return e1.factory.add(n1, i1);
                    });
                }
                return Object.defineProperty(t1.prototype, "factory", {
                    get: function() {
                        return this._factory;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.items = function(t1, e1, r1) {
                    var n1, o1, s1 = [];
                    try {
                        for(var a1 = i1(e1), l1 = a1.next(); !l1.done; l1 = a1.next()){
                            var c1 = l1.value, u1 = this.parse(c1, r1);
                            u1 && (r1.items.push(u1), c1.disabled && u1.disable(), c1.hidden && s1.push(u1));
                        }
                    } catch (t1) {
                        n1 = {
                            error: t1
                        };
                    } finally{
                        try {
                            l1 && !l1.done && (o1 = a1.return) && o1.call(a1);
                        } finally{
                            if (n1) throw n1.error;
                        }
                    }
                    return s1.forEach(function(t1) {
                        return t1.hide();
                    }), r1.items;
                }, t1.prototype.parse = function(t1) {
                    for(var e1 = [], r1 = 1; r1 < arguments.length; r1++)e1[r1 - 1] = arguments[r1];
                    var o1 = t1.type, i1 = n1(t1, [
                        "type"
                    ]), a1 = this.factory.get(o1);
                    return a1 ? a1.apply(void 0, s1([
                        this.factory,
                        i1
                    ], e1)) : null;
                }, t1;
            }();
            e1.Parser = _1;
        },
        2308: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ParserFactory = void 0;
            var r1 = function() {
                function t1(t1) {
                    this._parser = new Map(t1);
                }
                return t1.prototype.get = function(t1) {
                    return this._parser.get(t1);
                }, t1.prototype.add = function(t1, e1) {
                    this._parser.set(t1, e1);
                }, t1;
            }();
            e1.ParserFactory = r1;
        },
        2100: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            }), i1 = this && this.__read || function(t1, e1) {
                var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
                if (!r1) return t1;
                var n1, o1, i1 = r1.call(t1), s1 = [];
                try {
                    for(; (void 0 === e1 || e1-- > 0) && !(n1 = i1.next()).done;)s1.push(n1.value);
                } catch (t1) {
                    o1 = {
                        error: t1
                    };
                } finally{
                    try {
                        n1 && !n1.done && (r1 = i1.return) && r1.call(i1);
                    } finally{
                        if (o1) throw o1.error;
                    }
                }
                return s1;
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SelectionBox = e1.SelectionMenu = void 0;
            var s1 = r1(2556), a1 = r1(2165), l1 = r1(1484), c1 = r1(4922), u1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this) || this;
                    return r1.anchor = e1, r1.className = a1.HtmlClasses.SELECTIONMENU, r1.variablePool = r1.anchor.menu.pool, r1.baseMenu = r1.anchor.menu, r1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    var n1 = e1.title, o1 = e1.values, i1 = e1.variable, s1 = new this(r1), a1 = t1.get("label")(t1, {
                        content: n1 || "",
                        id: n1 || "id"
                    }, s1), l1 = t1.get("rule")(t1, {}, s1), c1 = o1.map(function(e1) {
                        return t1.get("radio")(t1, {
                            content: e1,
                            variable: i1,
                            id: e1
                        }, s1);
                    }), u1 = [
                        a1,
                        l1
                    ].concat(c1);
                    return s1.items = u1, s1;
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this), this.items.forEach(function(t1) {
                        return t1.html.classList.add(a1.HtmlClasses.SELECTIONITEM);
                    });
                }, e1.prototype.display = function() {}, e1.prototype.right = function(t1) {
                    this.anchor.right(t1);
                }, e1.prototype.left = function(t1) {
                    this.anchor.left(t1);
                }, e1;
            }(l1.AbstractMenu);
            e1.SelectionMenu = u1;
            var p1 = function(t1) {
                function e1(e1, r1, n1, o1) {
                    void 0 === n1 && (n1 = "none"), void 0 === o1 && (o1 = "vertical");
                    var i1 = t1.call(this, e1, null, r1) || this;
                    return i1.style = n1, i1.grid = o1, i1._selections = [], i1.prefix = "ctxt-selection", i1._balanced = !0, i1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    var n1 = e1.title, o1 = e1.signature, i1 = e1.selections, s1 = new this(n1, o1, e1.order, e1.grid);
                    s1.attachMenu(r1);
                    var a1 = i1.map(function(e1) {
                        return t1.get("selectionMenu")(t1, e1, s1);
                    });
                    return s1.selections = a1, s1;
                }, e1.prototype.attachMenu = function(t1) {
                    this.menu = t1;
                }, Object.defineProperty(e1.prototype, "selections", {
                    get: function() {
                        return this._selections;
                    },
                    set: function(t1) {
                        var e1 = this;
                        this._selections = [], t1.forEach(function(t1) {
                            return e1.addSelection(t1);
                        });
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.addSelection = function(t1) {
                    t1.anchor = this, this._selections.push(t1);
                }, e1.prototype.rowDiv = function(t1) {
                    var e1 = this, r1 = document.createElement("div");
                    this.contentDiv.appendChild(r1);
                    var n1 = t1.map(function(t1) {
                        return r1.appendChild(t1.html), t1.html.id || (t1.html.id = e1.prefix + s1.MenuUtil.counter()), t1.html.getBoundingClientRect();
                    }), o1 = n1.map(function(t1) {
                        return t1.width;
                    }), i1 = o1.reduce(function(t1, e1) {
                        return t1 + e1;
                    }, 0), l1 = n1.reduce(function(t1, e1) {
                        return Math.max(t1, e1.height);
                    }, 0);
                    return r1.classList.add(a1.HtmlClasses.SELECTIONDIVIDER), r1.setAttribute("style", "height: " + l1 + "px;"), [
                        r1,
                        i1,
                        l1,
                        o1
                    ];
                }, e1.prototype.display = function() {
                    if (t1.prototype.display.call(this), this.order(), this.selections.length) {
                        for(var e1 = [], r1 = 0, n1 = [], o1 = this.getChunkSize(this.selections.length), s1 = function(t1) {
                            var s1 = a1.selections.slice(t1, t1 + o1), l1 = i1(a1.rowDiv(s1), 4), c1 = l1[0], u1 = l1[1], p1 = l1[2], h1 = l1[3];
                            e1.push(c1), r1 = Math.max(r1, u1), s1.forEach(function(t1) {
                                return t1.html.style.height = p1 + "px";
                            }), n1 = a1.combineColumn(n1, h1);
                        }, a1 = this, l1 = 0; l1 < this.selections.length; l1 += o1)s1(l1);
                        this._balanced && (this.balanceColumn(e1, n1), r1 = n1.reduce(function(t1, e1) {
                            return t1 + e1;
                        }, 20)), e1.forEach(function(t1) {
                            return t1.style.width = r1 + "px";
                        });
                    }
                }, e1.prototype.getChunkSize = function(t1) {
                    switch(this.grid){
                        case "square":
                            return Math.floor(Math.sqrt(t1));
                        case "horizontal":
                            return Math.floor(t1 / e1.chunkSize);
                        default:
                            return e1.chunkSize;
                    }
                }, e1.prototype.balanceColumn = function(t1, e1) {
                    t1.forEach(function(t1) {
                        for(var r1 = Array.from(t1.children), n1 = 0, o1 = void 0; o1 = r1[n1]; n1++)o1.style.width = e1[n1] + "px";
                    });
                }, e1.prototype.combineColumn = function(t1, e1) {
                    for(var r1 = [], n1 = 0; t1[n1] || e1[n1];){
                        if (!t1[n1]) {
                            r1 = r1.concat(e1.slice(n1));
                            break;
                        }
                        if (!e1[n1]) {
                            r1 = r1.concat(t1.slice(n1));
                            break;
                        }
                        r1.push(Math.max(t1[n1], e1[n1])), n1++;
                    }
                    return r1;
                }, e1.prototype.left = function(t1) {
                    var e1 = this;
                    this.move(t1, function(t1) {
                        return (0 === t1 ? e1.selections.length : t1) - 1;
                    });
                }, e1.prototype.right = function(t1) {
                    var e1 = this;
                    this.move(t1, function(t1) {
                        return t1 === e1.selections.length - 1 ? 0 : t1 + 1;
                    });
                }, e1.prototype.generateHtml = function() {
                    t1.prototype.generateHtml.call(this), this.html.classList.add(a1.HtmlClasses.SELECTION);
                }, e1.prototype.generateContent = function() {
                    var e1 = t1.prototype.generateContent.call(this);
                    return e1.classList.add(a1.HtmlClasses.SELECTIONBOX), e1.removeAttribute("tabindex"), e1;
                }, e1.prototype.findSelection = function(t1) {
                    var e1 = t1.target, r1 = null;
                    if (e1.id && (r1 = this.selections.find(function(t1) {
                        return t1.html.id === e1.id;
                    })), !r1) {
                        var n1 = e1.parentElement.id;
                        r1 = this.selections.find(function(t1) {
                            return t1.html.id === n1;
                        });
                    }
                    return r1;
                }, e1.prototype.move = function(t1, e1) {
                    var r1 = this.findSelection(t1);
                    r1.focused && r1.focused.unfocus();
                    var n1 = e1(this.selections.indexOf(r1));
                    this.selections[n1].focus();
                }, e1.prototype.order = function() {
                    this.selections.sort(e1.orderMethod.get(this.style));
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1.chunkSize = 4, e1.orderMethod = new Map([
                    [
                        "alphabetical",
                        function(t1, e1) {
                            return t1.items[0].content.localeCompare(e1.items[0].content);
                        }
                    ],
                    [
                        "none",
                        function(t1, e1) {
                            return 1;
                        }
                    ],
                    [
                        "decreasing",
                        function(t1, e1) {
                            var r1 = t1.items.length, n1 = e1.items.length;
                            return r1 < n1 ? 1 : n1 < r1 ? -1 : 0;
                        }
                    ],
                    [
                        "increasing",
                        function(t1, e1) {
                            var r1 = t1.items.length, n1 = e1.items.length;
                            return r1 < n1 ? -1 : n1 < r1 ? 1 : 0;
                        }
                    ]
                ]), e1;
            }(c1.Info);
            e1.SelectionBox = p1;
        },
        4834: function(t1, e1, r1) {
            var n1, o1 = this && this.__extends || (n1 = function(t1, e1) {
                return n1 = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t1, e1) {
                    t1.__proto__ = e1;
                } || function(t1, e1) {
                    for(var r1 in e1)e1.hasOwnProperty(r1) && (t1[r1] = e1[r1]);
                }, n1(t1, e1);
            }, function(t1, e1) {
                function r1() {
                    this.constructor = t1;
                }
                n1(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
            });
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SubMenu = void 0;
            var i1 = function(t1) {
                function e1(e1) {
                    var r1 = t1.call(this) || this;
                    return r1._anchor = e1, r1.variablePool = r1.anchor.menu.pool, r1.setBaseMenu(), r1;
                }
                return o1(e1, t1), e1.fromJson = function(t1, e1, r1) {
                    var n1 = e1.items, o1 = new this(r1), i1 = t1.get("items")(t1, n1, o1);
                    return o1.items = i1, o1;
                }, Object.defineProperty(e1.prototype, "anchor", {
                    get: function() {
                        return this._anchor;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e1.prototype.post = function() {
                    if (this.anchor.menu.isPosted()) {
                        for(var e1 = this.anchor.html, r1 = this.html, n1 = this.baseMenu.frame, o1 = e1.offsetWidth, i1 = o1 - 2, s1 = 0; e1 && e1 !== n1;)i1 += e1.offsetLeft, s1 += e1.offsetTop, e1 = e1.parentNode;
                        i1 + r1.offsetWidth > document.body.offsetWidth - 5 && (i1 = Math.max(5, i1 - o1 - r1.offsetWidth + 6)), t1.prototype.post.call(this, i1, s1);
                    }
                }, e1.prototype.display = function() {
                    this.baseMenu.frame.appendChild(this.html);
                }, e1.prototype.setBaseMenu = function() {
                    var t1 = this;
                    do t1 = t1.anchor.menu;
                    while (t1 instanceof e1);
                    this.baseMenu = t1;
                }, e1.prototype.left = function(t1) {
                    this.focused = null, this.anchor.focus();
                }, e1.prototype.toJson = function() {
                    return {
                        type: ""
                    };
                }, e1;
            }(r1(1484).AbstractMenu);
            e1.SubMenu = i1;
        },
        3737: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Variable = void 0;
            var n1 = r1(2556), o1 = function() {
                function t1(t1, e1, r1) {
                    this._name = t1, this.getter = e1, this.setter = r1, this.items = [];
                }
                return t1.fromJson = function(t1, e1, r1) {
                    var n1 = new this(e1.name, e1.getter, e1.setter);
                    r1.insert(n1);
                }, Object.defineProperty(t1.prototype, "name", {
                    get: function() {
                        return this._name;
                    },
                    enumerable: !1,
                    configurable: !0
                }), t1.prototype.getValue = function(t1) {
                    try {
                        return this.getter(t1);
                    } catch (t1) {
                        return n1.MenuUtil.error(t1, "Command of variable " + this.name + " failed."), null;
                    }
                }, t1.prototype.setValue = function(t1, e1) {
                    try {
                        this.setter(t1, e1);
                    } catch (t1) {
                        n1.MenuUtil.error(t1, "Command of variable " + this.name + " failed.");
                    }
                    this.update();
                }, t1.prototype.register = function(t1) {
                    -1 === this.items.indexOf(t1) && this.items.push(t1);
                }, t1.prototype.unregister = function(t1) {
                    var e1 = this.items.indexOf(t1);
                    -1 !== e1 && this.items.splice(e1, 1);
                }, t1.prototype.update = function() {
                    this.items.forEach(function(t1) {
                        return t1.update();
                    });
                }, t1.prototype.registerCallback = function(t1) {
                    this.items.forEach(function(e1) {
                        return e1.registerCallback(t1);
                    });
                }, t1.prototype.unregisterCallback = function(t1) {
                    this.items.forEach(function(e1) {
                        return e1.unregisterCallback(t1);
                    });
                }, t1.prototype.toJson = function() {
                    return {
                        type: "variable",
                        name: this.name,
                        getter: this.getter.toString(),
                        setter: this.setter.toString()
                    };
                }, t1;
            }();
            e1.Variable = o1;
        },
        2358: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.VariablePool = void 0;
            var r1 = function() {
                function t1() {
                    this.pool = {};
                }
                return t1.prototype.insert = function(t1) {
                    this.pool[t1.name] = t1;
                }, t1.prototype.lookup = function(t1) {
                    return this.pool[t1];
                }, t1.prototype.remove = function(t1) {
                    delete this.pool[t1];
                }, t1.prototype.update = function() {
                    for(var t1 in this.pool)this.pool[t1].update();
                }, t1;
            }();
            e1.VariablePool = r1;
        },
        3921: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractAudioRenderer = void 0;
            const n1 = r1(5897);
            e1.AbstractAudioRenderer = class {
                constructor(){
                    this.separator_ = " ";
                }
                setSeparator(t1) {
                    this.separator_ = t1;
                }
                getSeparator() {
                    return "braille" === n1.default.getInstance().modality ? "" : this.separator_;
                }
                error(t1) {
                    return null;
                }
                merge(t1) {
                    let e1 = "";
                    const r1 = t1.length - 1;
                    for(let n1, o1 = 0; n1 = t1[o1]; o1++)if (e1 += n1.speech, o1 < r1) {
                        const t1 = n1.attributes.separator;
                        e1 += void 0 !== t1 ? t1 : this.getSeparator();
                    }
                    return e1;
                }
                finalize(t1) {
                    return t1;
                }
                pauseValue(t1) {
                    let e1;
                    switch(t1){
                        case "long":
                            e1 = 750;
                            break;
                        case "medium":
                            e1 = 500;
                            break;
                        case "short":
                            e1 = 250;
                            break;
                        default:
                            e1 = parseInt(t1, 10);
                    }
                    return Math.floor(e1 * n1.default.getInstance().getRate() / 100);
                }
            };
        },
        4196: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AcssRenderer = void 0;
            const n1 = r1(4440), o1 = r1(8496), i1 = r1(3706), s1 = r1(182);
            class a1 extends s1.MarkupRenderer {
                markup(t1) {
                    this.setScaleFunction(-2, 2, 0, 10, 0);
                    const e1 = i1.personalityMarkup(t1), r1 = [], n1 = {
                        open: []
                    };
                    let o1 = null, s1 = !1;
                    for(let t1, a1 = 0; t1 = e1[a1]; a1++){
                        if (i1.isMarkupElement(t1)) {
                            i1.mergeMarkup(n1, t1);
                            continue;
                        }
                        if (i1.isPauseElement(t1)) {
                            s1 && (o1 = i1.mergePause(o1, t1, Math.max));
                            continue;
                        }
                        const e1 = '"' + this.merge(t1.span) + '"';
                        s1 = !0, o1 && (r1.push(this.pause(o1)), o1 = null);
                        const a1 = this.prosody_(n1);
                        r1.push(a1 ? "(text (" + a1 + ") " + e1 + ")" : e1);
                    }
                    return "(exp " + r1.join(" ") + ")";
                }
                error(t1) {
                    return '(error "' + o1.Move.get(t1) + '")';
                }
                prosodyElement(t1, e1) {
                    switch(e1 = this.applyScaleFunction(e1), t1){
                        case n1.personalityProps.RATE:
                            return "(richness . " + e1 + ")";
                        case n1.personalityProps.PITCH:
                            return "(average-pitch . " + e1 + ")";
                        case n1.personalityProps.VOLUME:
                            return "(stress . " + e1 + ")";
                    }
                    return "(value . " + e1 + ")";
                }
                pause(t1) {
                    return "(pause . " + this.pauseValue(t1[n1.personalityProps.PAUSE]) + ")";
                }
                prosody_(t1) {
                    const e1 = t1.open, r1 = [];
                    for(let n1, o1 = 0; n1 = e1[o1]; o1++)r1.push(this.prosodyElement(n1, t1[n1]));
                    return r1.join(" ");
                }
            }
            e1.AcssRenderer = a1;
        },
        3706: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.isSpanElement = e1.isPauseElement = e1.isMarkupElement = e1.personalityMarkup = e1.sortClose = e1.mergeMarkup = e1.mergePause = void 0;
            const n1 = r1(707), o1 = r1(4440), i1 = r1(9536);
            function s1(t1, e1, r1) {
                return (r1 || function(r1, n1) {
                    return "number" == typeof r1 && "number" == typeof n1 ? r1 + n1 : "number" == typeof r1 ? n1 : "number" == typeof n1 ? r1 : [
                        t1,
                        e1
                    ].sort()[0];
                }).call(null, t1, e1);
            }
            e1.mergePause = function(t1, e1, r1) {
                return t1 ? {
                    pause: s1(t1.pause, e1.pause, r1)
                } : e1;
            }, e1.mergeMarkup = function(t1, e1) {
                delete t1.open, e1.close.forEach((e1)=>delete t1[e1]), e1.open.forEach((r1)=>t1[r1] = e1[r1]);
                const r1 = Object.keys(t1);
                t1.open = r1;
            }, e1.sortClose = function(t1, e1) {
                if (t1.length <= 1) return t1;
                const r1 = [];
                for(let n1, o1 = 0; n1 = e1[o1], t1.length; o1++)n1.close && n1.close.length && n1.close.forEach(function(e1) {
                    const n1 = t1.indexOf(e1);
                    -1 !== n1 && (r1.unshift(e1), t1.splice(n1, 1));
                });
                return r1;
            };
            let a1 = {}, l1 = [];
            function c1(t1, e1) {
                const r1 = t1[t1.length - 1];
                if (r1) {
                    if (f1(e1) && f1(r1)) {
                        if (void 0 === r1.join) return void (r1.span = r1.span.concat(e1.span));
                        const t1 = r1.span.pop(), n1 = e1.span.shift();
                        return r1.span.push(t1 + r1.join + n1), r1.span = r1.span.concat(e1.span), void (r1.join = e1.join);
                    }
                    h1(e1) && h1(r1) ? r1.pause = s1(r1.pause, e1.pause) : t1.push(e1);
                } else t1.push(e1);
            }
            function u1(t1, e1) {
                t1.rate && (e1.rate = t1.rate), t1.pitch && (e1.pitch = t1.pitch), t1.volume && (e1.volume = t1.volume);
            }
            function p1(t1) {
                return "object" == typeof t1 && t1.open;
            }
            function h1(t1) {
                return "object" == typeof t1 && 1 === Object.keys(t1).length && Object.keys(t1)[0] === o1.personalityProps.PAUSE;
            }
            function f1(t1) {
                const e1 = Object.keys(t1);
                return "object" == typeof t1 && (1 === e1.length && "span" === e1[0] || 2 === e1.length && ("span" === e1[0] && "join" === e1[1] || "span" === e1[1] && "join" === e1[0]));
            }
            function d1(t1, e1, r1, n1, a1, l1 = !1) {
                if (l1) {
                    const l1 = t1[t1.length - 1];
                    let c1;
                    if (l1 && (c1 = l1[o1.personalityProps.JOIN]), l1 && !e1.speech && a1 && h1(l1)) {
                        const t1 = o1.personalityProps.PAUSE;
                        l1[t1] = s1(l1[t1], a1[t1]), a1 = null;
                    }
                    if (l1 && e1.speech && 0 === Object.keys(r1).length && f1(l1)) {
                        if (void 0 !== c1) {
                            const t1 = l1.span.pop();
                            e1 = new i1.Span(t1.speech + c1 + e1.speech, t1.attributes);
                        }
                        l1.span.push(e1), e1 = new i1.Span("", {}), l1[o1.personalityProps.JOIN] = n1;
                    }
                }
                0 !== Object.keys(r1).length && t1.push(r1), e1.speech && t1.push({
                    span: [
                        e1
                    ],
                    join: n1
                }), a1 && t1.push(a1);
            }
            function m1(t1, e1) {
                if (!e1) return t1;
                const r1 = {};
                for (const n1 of o1.personalityPropList){
                    const o1 = t1[n1], i1 = e1[n1];
                    if (!o1 && !i1 || o1 && i1 && o1 === i1) continue;
                    const s1 = o1 || 0;
                    p1(r1) || (r1.open = [], r1.close = []), o1 || r1.close.push(n1), i1 || r1.open.push(n1), i1 && o1 && (r1.close.push(n1), r1.open.push(n1)), e1[n1] = s1, r1[n1] = s1, a1[n1] ? a1[n1].push(s1) : a1[n1] = [
                        s1
                    ];
                }
                if (p1(r1)) {
                    let t1 = r1.close.slice();
                    for(; t1.length > 0;){
                        let o1 = l1.pop();
                        const i1 = (0, n1.setdifference)(o1, t1);
                        if (t1 = (0, n1.setdifference)(t1, o1), o1 = i1, 0 !== t1.length) {
                            if (0 !== o1.length) {
                                r1.close = r1.close.concat(o1), r1.open = r1.open.concat(o1);
                                for(let t1, n1 = 0; t1 = o1[n1]; n1++)r1[t1] = e1[t1];
                            }
                        } else 0 !== o1.length && l1.push(o1);
                    }
                    l1.push(r1.open);
                }
                return r1;
            }
            e1.personalityMarkup = function(t1) {
                a1 = {}, l1 = [];
                let e1 = [];
                const r1 = {};
                for(let n1, i1 = 0; n1 = t1[i1]; i1++){
                    let t1 = null;
                    const i1 = n1.descriptionSpan(), s1 = n1.personality, a1 = s1[o1.personalityProps.JOIN];
                    delete s1[o1.personalityProps.JOIN], void 0 !== s1[o1.personalityProps.PAUSE] && (t1 = {
                        [o1.personalityProps.PAUSE]: s1[o1.personalityProps.PAUSE]
                    }, delete s1[o1.personalityProps.PAUSE]);
                    d1(e1, i1, m1(s1, r1), a1, t1, !0);
                }
                return e1 = e1.concat(function() {
                    const t1 = [];
                    for(let e1 = l1.length - 1; e1 >= 0; e1--){
                        const r1 = l1[e1];
                        if (r1.length) {
                            const e1 = {
                                open: [],
                                close: []
                            };
                            for(let t1 = 0; t1 < r1.length; t1++){
                                const n1 = r1[t1];
                                e1.close.push(n1), e1[n1] = 0;
                            }
                            t1.push(e1);
                        }
                    }
                    return t1;
                }()), e1 = function(t1) {
                    const e1 = {}, r1 = [];
                    for(let n1, o1 = 0; n1 = t1[o1]; o1++){
                        if (!p1(n1)) {
                            c1(r1, n1);
                            continue;
                        }
                        if (!n1.close || 1 !== n1.close.length || n1.open.length) {
                            u1(n1, e1), r1.push(n1);
                            continue;
                        }
                        let i1 = t1[o1 + 1];
                        if (!i1 || f1(i1)) {
                            u1(n1, e1), r1.push(n1);
                            continue;
                        }
                        const s1 = h1(i1) ? i1 : null;
                        s1 && (i1 = t1[o1 + 2]), i1 && p1(i1) && i1.open[0] === n1.close[0] && !i1.close.length && i1[i1.open[0]] === e1[i1.open[0]] ? s1 ? (c1(r1, s1), o1 += 2) : o1 += 1 : (u1(n1, e1), r1.push(n1));
                    }
                    return r1;
                }(e1), e1;
            }, e1.isMarkupElement = p1, e1.isPauseElement = h1, e1.isSpanElement = f1;
        },
        7052: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AuditoryDescription = void 0;
            const n1 = r1(2105), o1 = r1(9536);
            class i1 {
                constructor({ context: t1, text: e1, userValue: r1, annotation: n1, attributes: o1, personality: i1, layout: s1 }){
                    this.context = t1 || "", this.text = e1 || "", this.userValue = r1 || "", this.annotation = n1 || "", this.attributes = o1 || {}, this.personality = i1 || {}, this.layout = s1 || "";
                }
                static create(t1, e1 = {}) {
                    return t1.text = n1.Grammar.getInstance().apply(t1.text, e1), new i1(t1);
                }
                isEmpty() {
                    return 0 === this.context.length && 0 === this.text.length && 0 === this.userValue.length && 0 === this.annotation.length;
                }
                clone() {
                    let t1, e1;
                    if (this.personality) {
                        t1 = {};
                        for(const e1 in this.personality)t1[e1] = this.personality[e1];
                    }
                    if (this.attributes) {
                        e1 = {};
                        for(const t1 in this.attributes)e1[t1] = this.attributes[t1];
                    }
                    return new i1({
                        context: this.context,
                        text: this.text,
                        userValue: this.userValue,
                        annotation: this.annotation,
                        personality: t1,
                        attributes: e1,
                        layout: this.layout
                    });
                }
                toString() {
                    return 'AuditoryDescription(context="' + this.context + '"  text="' + this.text + '"  userValue="' + this.userValue + '"  annotation="' + this.annotation + '")';
                }
                descriptionString() {
                    return this.context && this.text ? this.context + " " + this.text : this.context || this.text;
                }
                descriptionSpan() {
                    return new o1.Span(this.descriptionString(), this.attributes);
                }
                equals(t1) {
                    return this.context === t1.context && this.text === t1.text && this.userValue === t1.userValue && this.annotation === t1.annotation;
                }
            }
            e1.AuditoryDescription = i1;
        },
        8290: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.isXml = e1.registerRenderer = e1.error = e1.finalize = e1.merge = e1.markup = e1.getSeparator = e1.setSeparator = void 0;
            const n1 = r1(5897), o1 = r1(4440), i1 = r1(4196), s1 = r1(8639), a1 = r1(8990), l1 = r1(6660), c1 = r1(9536), u1 = r1(7504), p1 = r1(3757), h1 = r1(4032), f1 = r1(2456), d1 = new u1.SsmlRenderer, m1 = new Map([
                [
                    o1.Markup.NONE,
                    new h1.StringRenderer
                ],
                [
                    o1.Markup.PUNCTUATION,
                    new a1.PunctuationRenderer
                ],
                [
                    o1.Markup.LAYOUT,
                    new s1.LayoutRenderer
                ],
                [
                    o1.Markup.ACSS,
                    new i1.AcssRenderer
                ],
                [
                    o1.Markup.SABLE,
                    new l1.SableRenderer
                ],
                [
                    o1.Markup.VOICEXML,
                    d1
                ],
                [
                    o1.Markup.SSML,
                    d1
                ],
                [
                    o1.Markup.SSML_STEP,
                    new p1.SsmlStepRenderer
                ]
            ]);
            e1.setSeparator = function(t1) {
                const e1 = m1.get(n1.default.getInstance().markup);
                e1 && e1.setSeparator(t1);
            }, e1.getSeparator = function() {
                const t1 = m1.get(n1.default.getInstance().markup);
                return t1 ? t1.getSeparator() : "";
            }, e1.markup = function(t1) {
                const e1 = m1.get(n1.default.getInstance().markup);
                return e1 ? e1.markup(t1) : "";
            }, e1.merge = function(t1) {
                const e1 = t1.map((t1)=>"string" == typeof t1 ? new c1.Span(t1, {}) : t1), r1 = m1.get(n1.default.getInstance().markup);
                return r1 ? r1.merge(e1) : t1.join();
            }, e1.finalize = function(t1) {
                const e1 = m1.get(n1.default.getInstance().markup);
                return e1 ? e1.finalize(t1) : t1;
            }, e1.error = function(t1) {
                const e1 = m1.get(n1.default.getInstance().markup);
                return e1 ? e1.error(t1) : "";
            }, e1.registerRenderer = function(t1, e1) {
                m1.set(t1, e1);
            }, e1.isXml = function() {
                return m1.get(n1.default.getInstance().markup) instanceof f1.XmlRenderer;
            };
        },
        8639: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.LayoutRenderer = void 0;
            const n1 = r1(2057), o1 = r1(5740), i1 = r1(4440), s1 = r1(3706), a1 = r1(2456);
            class l1 extends a1.XmlRenderer {
                finalize(t1) {
                    return function(t1) {
                        c1 = "";
                        const e1 = o1.parseInput(`<all>${t1}</all>`);
                        return n1.Debugger.getInstance().output(o1.formatXml(e1.toString())), c1 = f1(e1), c1;
                    }(t1);
                }
                pause(t1) {
                    return "";
                }
                prosodyElement(t1, e1) {
                    return t1 === i1.personalityProps.LAYOUT ? `<${e1}>` : "";
                }
                closeTag(t1) {
                    return `</${t1}>`;
                }
                markup(t1) {
                    const e1 = [];
                    let r1 = [];
                    for (const n1 of t1){
                        if (!n1.layout) {
                            r1.push(n1);
                            continue;
                        }
                        e1.push(this.processContent(r1)), r1 = [];
                        const t1 = n1.layout;
                        t1.match(/^begin/) ? e1.push("<" + t1.replace(/^begin/, "") + ">") : t1.match(/^end/) ? e1.push("</" + t1.replace(/^end/, "") + ">") : console.warn("Something went wrong with layout markup: " + t1);
                    }
                    return e1.push(this.processContent(r1)), e1.join("");
                }
                processContent(t1) {
                    const e1 = [], r1 = s1.personalityMarkup(t1);
                    for(let t1, n1 = 0; t1 = r1[n1]; n1++)t1.span ? e1.push(this.merge(t1.span)) : s1.isPauseElement(t1);
                    return e1.join("");
                }
            }
            e1.LayoutRenderer = l1;
            let c1 = "";
            const u1 = {
                TABLE: function(t1) {
                    let e1 = g1(t1);
                    e1.forEach((t1)=>{
                        t1.cells = t1.cells.slice(1).slice(0, -1), t1.width = t1.width.slice(1).slice(0, -1);
                    });
                    const [r1, n1] = b1(e1);
                    return e1 = v1(e1, n1), _1(e1, r1);
                },
                CASES: function(t1) {
                    let e1 = g1(t1);
                    e1.forEach((t1)=>{
                        t1.cells = t1.cells.slice(0, -1), t1.width = t1.width.slice(0, -1);
                    });
                    const [r1, n1] = b1(e1);
                    return e1 = v1(e1, n1), _1(e1, r1);
                },
                CAYLEY: function(t1) {
                    let e1 = g1(t1);
                    e1.forEach((t1)=>{
                        t1.cells = t1.cells.slice(1).slice(0, -1), t1.width = t1.width.slice(1).slice(0, -1), t1.sep = t1.sep + t1.sep;
                    });
                    const [r1, n1] = b1(e1), o1 = {
                        lfence: "",
                        rfence: "",
                        cells: n1.map((t1)=>"⠐" + new Array(t1).join("⠒")),
                        width: n1,
                        height: 1,
                        sep: e1[0].sep
                    };
                    return e1.splice(1, 0, o1), e1 = v1(e1, n1), _1(e1, r1);
                },
                MATRIX: function(t1) {
                    let e1 = g1(t1);
                    const [r1, n1] = b1(e1);
                    return e1 = v1(e1, n1), _1(e1, r1);
                },
                CELL: f1,
                FENCE: f1,
                ROW: f1,
                FRACTION: function(t1) {
                    const [e1, r1, , n1, o1] = Array.from(t1.childNodes), i1 = p1(r1), s1 = p1(n1), a1 = m1(i1), l1 = m1(s1);
                    let c1 = Math.max(a1, l1);
                    const u1 = e1 + new Array(c1 + 1).join("⠒") + o1;
                    return c1 = u1.length, `${x1(i1, c1)}\n${u1}\n${x1(s1, c1)}`;
                },
                NUMERATOR: E1,
                DENOMINATOR: E1
            };
            function p1(t1) {
                const e1 = o1.tagName(t1), r1 = u1[e1];
                return r1 ? r1(t1) : t1.textContent;
            }
            function h1(t1, e1) {
                if (!t1 || !e1) return t1 + e1;
                const r1 = d1(t1), n1 = d1(e1), o1 = r1 - n1;
                t1 = o1 < 0 ? y1(t1, n1, m1(t1)) : t1, e1 = o1 > 0 ? y1(e1, r1, m1(e1)) : e1;
                const i1 = t1.split(/\r\n|\r|\n/), s1 = e1.split(/\r\n|\r|\n/), a1 = [];
                for(let t1 = 0; t1 < i1.length; t1++)a1.push(i1[t1] + s1[t1]);
                return a1.join("\n");
            }
            function f1(t1) {
                let e1 = "";
                for (const r1 of Array.from(t1.childNodes))e1 = r1.nodeType !== o1.NodeType.TEXT_NODE ? h1(e1, p1(r1)) : h1(e1, r1.textContent);
                return e1;
            }
            function d1(t1) {
                return t1.split(/\r\n|\r|\n/).length;
            }
            function m1(t1) {
                return t1.split(/\r\n|\r|\n/).reduce((t1, e1)=>Math.max(e1.length, t1), 0);
            }
            function y1(t1, e1, r1) {
                return t1 = function(t1, e1) {
                    const r1 = e1 - d1(t1);
                    return t1 + (r1 > 0 ? new Array(r1 + 1).join("\n") : "");
                }(t1, e1), function(t1, e1) {
                    const r1 = t1.split(/\r\n|\r|\n/), n1 = [];
                    for (const t1 of r1){
                        const r1 = e1 - t1.length;
                        n1.push(t1 + (r1 > 0 ? new Array(r1 + 1).join("⠀") : ""));
                    }
                    return n1.join("\n");
                }(t1, r1);
            }
            function g1(t1) {
                const e1 = Array.from(t1.childNodes), r1 = [];
                for (const t1 of e1)t1.nodeType === o1.NodeType.ELEMENT_NODE && r1.push(M1(t1));
                return r1;
            }
            function b1(t1) {
                const e1 = t1.reduce((t1, e1)=>Math.max(e1.height, t1), 0), r1 = [];
                for(let e1 = 0; e1 < t1[0].width.length; e1++)r1.push(t1.map((t1)=>t1.width[e1]).reduce((t1, e1)=>Math.max(t1, e1), 0));
                return [
                    e1,
                    r1
                ];
            }
            function v1(t1, e1) {
                const r1 = [];
                for (const n1 of t1){
                    if (0 === n1.height) continue;
                    const t1 = [];
                    for(let r1 = 0; r1 < n1.cells.length; r1++)t1.push(y1(n1.cells[r1], n1.height, e1[r1]));
                    n1.cells = t1, r1.push(n1);
                }
                return r1;
            }
            function _1(t1, e1) {
                if (1 === e1) return t1.map((t1)=>t1.lfence + t1.cells.join(t1.sep) + t1.rfence).join("\n");
                const r1 = [];
                for (const e1 of t1){
                    const t1 = S1(e1.sep, e1.height);
                    let n1 = e1.cells.shift();
                    for(; e1.cells.length;)n1 = h1(n1, t1), n1 = h1(n1, e1.cells.shift());
                    n1 = h1(S1(e1.lfence, e1.height), n1), n1 = h1(n1, S1(e1.rfence, e1.height)), r1.push(n1), r1.push(e1.lfence + new Array(m1(n1) - 3).join(e1.sep) + e1.rfence);
                }
                return r1.slice(0, -1).join("\n");
            }
            function S1(t1, e1) {
                let r1 = "";
                for(; e1;)r1 += t1 + "\n", e1--;
                return r1.slice(0, -1);
            }
            function O1(t1) {
                return t1.nodeType === o1.NodeType.ELEMENT_NODE && "FENCE" === o1.tagName(t1) ? p1(t1) : "";
            }
            function M1(t1) {
                const e1 = Array.from(t1.childNodes), r1 = O1(e1[0]), n1 = O1(e1[e1.length - 1]);
                r1 && e1.shift(), n1 && e1.pop();
                let i1 = "";
                const s1 = [];
                for (const t1 of e1){
                    if (t1.nodeType === o1.NodeType.TEXT_NODE) {
                        i1 = t1.textContent;
                        continue;
                    }
                    const e1 = p1(t1);
                    s1.push(e1);
                }
                return {
                    lfence: r1,
                    rfence: n1,
                    sep: i1,
                    cells: s1,
                    height: s1.reduce((t1, e1)=>Math.max(d1(e1), t1), 0),
                    width: s1.map(m1)
                };
            }
            function x1(t1, e1) {
                const r1 = (e1 - m1(t1)) / 2, [n1, o1] = Math.floor(r1) === r1 ? [
                    r1,
                    r1
                ] : [
                    Math.floor(r1),
                    Math.ceil(r1)
                ], i1 = t1.split(/\r\n|\r|\n/), s1 = [], [a1, l1] = [
                    new Array(n1 + 1).join("⠀"),
                    new Array(o1 + 1).join("⠀")
                ];
                for (const t1 of i1)s1.push(a1 + t1 + l1);
                return s1.join("\n");
            }
            function E1(t1) {
                const e1 = t1.firstChild, r1 = f1(t1);
                if (e1 && e1.nodeType === o1.NodeType.ELEMENT_NODE) {
                    if ("ENGLISH" === o1.tagName(e1)) return "⠰" + r1;
                    if ("NUMBER" === o1.tagName(e1)) return "⠼" + r1;
                }
                return r1;
            }
        },
        182: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MarkupRenderer = void 0;
            const n1 = r1(4440), o1 = r1(3921);
            class i1 extends o1.AbstractAudioRenderer {
                constructor(){
                    super(...arguments), this.ignoreElements = [
                        n1.personalityProps.LAYOUT
                    ], this.scaleFunction = null;
                }
                setScaleFunction(t1, e1, r1, n1, o1 = 0) {
                    this.scaleFunction = (i1)=>{
                        const s1 = (i1 - t1) / (e1 - t1), a1 = r1 * (1 - s1) + n1 * s1;
                        return +(Math.round(a1 + "e+" + o1) + "e-" + o1);
                    };
                }
                applyScaleFunction(t1) {
                    return this.scaleFunction ? this.scaleFunction(t1) : t1;
                }
                ignoreElement(t1) {
                    return -1 !== this.ignoreElements.indexOf(t1);
                }
            }
            e1.MarkupRenderer = i1;
        },
        8990: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.PunctuationRenderer = void 0;
            const n1 = r1(4440), o1 = r1(3921), i1 = r1(3706);
            class s1 extends o1.AbstractAudioRenderer {
                markup(t1) {
                    const e1 = i1.personalityMarkup(t1);
                    let r1 = "", o1 = null, s1 = !1;
                    for(let t1, a1 = 0; t1 = e1[a1]; a1++)i1.isMarkupElement(t1) || (i1.isPauseElement(t1) ? s1 && (o1 = i1.mergePause(o1, t1, Math.max)) : (o1 && (r1 += this.pause(o1[n1.personalityProps.PAUSE]), o1 = null), r1 += (s1 ? this.getSeparator() : "") + this.merge(t1.span), s1 = !0));
                    return r1;
                }
                pause(t1) {
                    let e1;
                    return e1 = "number" == typeof t1 ? t1 <= 250 ? "short" : t1 <= 500 ? "medium" : "long" : t1, s1.PAUSE_PUNCTUATION.get(e1) || "";
                }
            }
            e1.PunctuationRenderer = s1, s1.PAUSE_PUNCTUATION = new Map([
                [
                    "short",
                    ","
                ],
                [
                    "medium",
                    ";"
                ],
                [
                    "long",
                    "."
                ]
            ]);
        },
        6660: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SableRenderer = void 0;
            const n1 = r1(4440), o1 = r1(2456);
            class i1 extends o1.XmlRenderer {
                finalize(t1) {
                    return '<?xml version="1.0"?><!DOCTYPE SABLE PUBLIC "-//SABLE//DTD SABLE speech mark up//EN" "Sable.v0_2.dtd" []><SABLE>' + this.getSeparator() + t1 + this.getSeparator() + "</SABLE>";
                }
                pause(t1) {
                    return '<BREAK MSEC="' + this.pauseValue(t1[n1.personalityProps.PAUSE]) + '"/>';
                }
                prosodyElement(t1, e1) {
                    switch(e1 = this.applyScaleFunction(e1), t1){
                        case n1.personalityProps.PITCH:
                            return '<PITCH RANGE="' + e1 + '%">';
                        case n1.personalityProps.RATE:
                            return '<RATE SPEED="' + e1 + '%">';
                        case n1.personalityProps.VOLUME:
                            return '<VOLUME LEVEL="' + e1 + '%">';
                        default:
                            return "<" + t1.toUpperCase() + ' VALUE="' + e1 + '">';
                    }
                }
                closeTag(t1) {
                    return "</" + t1.toUpperCase() + ">";
                }
            }
            e1.SableRenderer = i1;
        },
        9536: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Span = void 0;
            e1.Span = class {
                constructor(t1, e1){
                    this.speech = t1, this.attributes = e1;
                }
            };
        },
        7504: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SsmlRenderer = void 0;
            const n1 = r1(5897), o1 = r1(4440), i1 = r1(2456);
            class s1 extends i1.XmlRenderer {
                finalize(t1) {
                    return '<?xml version="1.0"?><speak version="1.1" xmlns="http://www.w3.org/2001/10/synthesis"><prosody rate="' + n1.default.getInstance().getRate() + '%">' + this.getSeparator() + t1 + this.getSeparator() + "</prosody></speak>";
                }
                pause(t1) {
                    return '<break time="' + this.pauseValue(t1[o1.personalityProps.PAUSE]) + 'ms"/>';
                }
                prosodyElement(t1, e1) {
                    const r1 = (e1 = Math.floor(this.applyScaleFunction(e1))) < 0 ? e1.toString() : "+" + e1.toString();
                    return "<prosody " + t1.toLowerCase() + '="' + r1 + (t1 === o1.personalityProps.VOLUME ? ">" : '%">');
                }
                closeTag(t1) {
                    return "</prosody>";
                }
            }
            e1.SsmlRenderer = s1;
        },
        3757: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SsmlStepRenderer = void 0;
            const n1 = r1(7504);
            class o1 extends n1.SsmlRenderer {
                markup(t1) {
                    return o1.MARKS = {}, super.markup(t1);
                }
                merge(t1) {
                    const e1 = [];
                    for(let r1 = 0; r1 < t1.length; r1++){
                        const n1 = t1[r1], i1 = n1.attributes.extid;
                        i1 && !o1.MARKS[i1] && (e1.push('<mark name="' + i1 + '"/>'), o1.MARKS[i1] = !0), 1 === n1.speech.length && n1.speech.match(/[a-zA-Z]/) ? e1.push('<say-as interpret-as="' + o1.CHARACTER_ATTR + '">' + n1.speech + "</say-as>") : e1.push(n1.speech);
                    }
                    return e1.join(this.getSeparator());
                }
            }
            e1.SsmlStepRenderer = o1, o1.CHARACTER_ATTR = "character", o1.MARKS = {};
        },
        4032: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.StringRenderer = void 0;
            const n1 = r1(3921), o1 = r1(3706);
            class i1 extends n1.AbstractAudioRenderer {
                markup(t1) {
                    let e1 = "";
                    const r1 = (0, o1.personalityMarkup)(t1).filter((t1)=>t1.span);
                    if (!r1.length) return e1;
                    const n1 = r1.length - 1;
                    for(let t1, o1 = 0; t1 = r1[o1]; o1++){
                        if (t1.span && (e1 += this.merge(t1.span)), o1 >= n1) continue;
                        const r1 = t1.join;
                        e1 += void 0 === r1 ? this.getSeparator() : r1;
                    }
                    return e1;
                }
            }
            e1.StringRenderer = i1;
        },
        2456: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.XmlRenderer = void 0;
            const n1 = r1(5897), o1 = r1(3706), i1 = r1(182);
            class s1 extends i1.MarkupRenderer {
                markup(t1) {
                    this.setScaleFunction(-2, 2, -100, 100, 2);
                    const e1 = o1.personalityMarkup(t1), r1 = [], i1 = [];
                    for(let t1, s1 = 0; t1 = e1[s1]; s1++)if (t1.span) r1.push(this.merge(t1.span));
                    else if (o1.isPauseElement(t1)) r1.push(this.pause(t1));
                    else {
                        if (t1.close.length) for(let e1 = 0; e1 < t1.close.length; e1++){
                            const e1 = i1.pop();
                            if (-1 === t1.close.indexOf(e1)) throw new n1.SREError("Unknown closing markup element: " + e1);
                            r1.push(this.closeTag(e1));
                        }
                        if (t1.open.length) o1.sortClose(t1.open.slice(), e1.slice(s1 + 1)).forEach((e1)=>{
                            r1.push(this.prosodyElement(e1, t1[e1])), i1.push(e1);
                        });
                    }
                    return r1.join(" ");
                }
            }
            e1.XmlRenderer = s1;
        },
        707: function(t1, e1) {
            function r1(t1, e1) {
                return t1 ? e1 ? t1.filter((t1)=>e1.indexOf(t1) < 0) : t1 : [];
            }
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.union = e1.setdifference = e1.interleaveLists = e1.removeEmpty = void 0, e1.removeEmpty = function(t1) {
                return t1.filter((t1)=>t1);
            }, e1.interleaveLists = function(t1, e1) {
                const r1 = [];
                for(; t1.length || e1.length;)t1.length && r1.push(t1.shift()), e1.length && r1.push(e1.shift());
                return r1;
            }, e1.setdifference = r1, e1.union = function(t1, e1) {
                return t1 && e1 ? t1.concat(r1(e1, t1)) : t1 || e1 || [];
            };
        },
        2139: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.loadScript = e1.loadMapsForIE_ = e1.installWGXpath_ = e1.loadWGXpath_ = e1.mapsForIE = e1.detectEdge = e1.detectIE = void 0;
            const n1 = r1(2315), o1 = r1(5274);
            function i1(t1) {
                l1(n1.default.WGXpath), s1(t1);
            }
            function s1(t1, e1) {
                let r1 = e1 || 1;
                "undefined" == typeof wgxpath && r1 < 10 ? setTimeout(function() {
                    s1(t1, r1++);
                }, 200) : r1 >= 10 || (n1.default.wgxpath = wgxpath, t1 ? n1.default.wgxpath.install({
                    document: document
                }) : n1.default.wgxpath.install(), o1.xpath.evaluate = document.evaluate, o1.xpath.result = XPathResult, o1.xpath.createNSResolver = document.createNSResolver);
            }
            function a1() {
                l1(n1.default.mathmapsIePath);
            }
            function l1(t1) {
                const e1 = n1.default.document.createElement("script");
                e1.type = "text/javascript", e1.src = t1, n1.default.document.head ? n1.default.document.head.appendChild(e1) : n1.default.document.body.appendChild(e1);
            }
            e1.detectIE = function() {
                return "undefined" != typeof window && "ActiveXObject" in window && "clipboardData" in window && (a1(), i1(), !0);
            }, e1.detectEdge = function() {
                var t1;
                return "undefined" != typeof window && "MSGestureEvent" in window && null === (null === (t1 = window.chrome) || void 0 === t1 ? void 0 : t1.loadTimes) && (document.evaluate = null, i1(!0), !0);
            }, e1.mapsForIE = null, e1.loadWGXpath_ = i1, e1.installWGXpath_ = s1, e1.loadMapsForIE_ = a1, e1.loadScript = l1;
        },
        2057: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Debugger = void 0;
            const n1 = r1(2315);
            class o1 {
                constructor(){
                    this.isActive_ = !1, this.outputFunction_ = console.info, this.stream_ = null;
                }
                static getInstance() {
                    return o1.instance = o1.instance || new o1, o1.instance;
                }
                init(t1) {
                    t1 && this.startDebugFile_(t1), this.isActive_ = !0;
                }
                output(...t1) {
                    this.isActive_ && this.output_(t1);
                }
                generateOutput(t1) {
                    this.isActive_ && this.output_(t1.apply(t1, []));
                }
                exit(t1 = ()=>{}) {
                    this.isActive_ && this.stream_ && this.stream_.end("", "", t1);
                }
                startDebugFile_(t1) {
                    this.stream_ = n1.default.fs.createWriteStream(t1), this.outputFunction_ = (function(...t1) {
                        this.stream_.write(t1.join(" ")), this.stream_.write("\n");
                    }).bind(this), this.stream_.on("error", (function(t1) {
                        console.info("Invalid log file. Debug information sent to console."), this.outputFunction_ = console.info;
                    }).bind(this)), this.stream_.on("finish", function() {
                        console.info("Finalizing debug file.");
                    });
                }
                output_(t1) {
                    this.outputFunction_.apply(console.info === this.outputFunction_ ? console : this.outputFunction_, [
                        "Speech Rule Engine Debugger:"
                    ].concat(t1));
                }
            }
            e1.Debugger = o1;
        },
        5740: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.serializeXml = e1.cloneNode = e1.tagName = e1.querySelectorAll = e1.querySelectorAllByAttrValue = e1.querySelectorAllByAttr = e1.formatXml = e1.createTextNode = e1.createElementNS = e1.createElement = e1.replaceNode = e1.NodeType = e1.parseInput = e1.XML_ENTITIES = e1.trimInput_ = e1.toArray = void 0;
            const n1 = r1(5897), o1 = r1(4440), i1 = r1(2315), s1 = r1(5274);
            function a1(t1) {
                const e1 = [];
                for(let r1 = 0, n1 = t1.length; r1 < n1; r1++)e1.push(t1[r1]);
                return e1;
            }
            function l1(t1) {
                return (t1 = t1.replace(/&nbsp;/g, "\xa0")).replace(/>[ \f\n\r\t\v\u200b]+</g, "><").trim();
            }
            function c1(t1, e1) {
                if (!e1) return [
                    !1,
                    ""
                ];
                const r1 = t1.match(/^<([^> ]+).*>/), n1 = e1.match(/^<\/([^>]+)>(.*)/);
                return r1 && n1 && r1[1] === n1[1] ? [
                    !0,
                    n1[2]
                ] : [
                    !1,
                    ""
                ];
            }
            e1.toArray = a1, e1.trimInput_ = l1, e1.XML_ENTITIES = {
                "&lt;": !0,
                "&gt;": !0,
                "&amp;": !0,
                "&quot;": !0,
                "&apos;": !0
            }, e1.parseInput = function(t1) {
                const e1 = new i1.default.xmldom.DOMParser, r1 = l1(t1), a1 = !!r1.match(/&(?!lt|gt|amp|quot|apos)\w+;/g);
                if (!r1) throw new Error("Empty input!");
                try {
                    const t1 = e1.parseFromString(r1, a1 ? "text/html" : "text/xml");
                    return n1.default.getInstance().mode === o1.Mode.HTTP ? (s1.xpath.currentDocument = t1, a1 ? t1.body.childNodes[0] : t1.documentElement) : t1.documentElement;
                } catch (t1) {
                    throw new n1.SREError("Illegal input: " + t1.message);
                }
            }, function(t1) {
                t1[t1.ELEMENT_NODE = 1] = "ELEMENT_NODE", t1[t1.ATTRIBUTE_NODE = 2] = "ATTRIBUTE_NODE", t1[t1.TEXT_NODE = 3] = "TEXT_NODE", t1[t1.CDATA_SECTION_NODE = 4] = "CDATA_SECTION_NODE", t1[t1.ENTITY_REFERENCE_NODE = 5] = "ENTITY_REFERENCE_NODE", t1[t1.ENTITY_NODE = 6] = "ENTITY_NODE", t1[t1.PROCESSING_INSTRUCTION_NODE = 7] = "PROCESSING_INSTRUCTION_NODE", t1[t1.COMMENT_NODE = 8] = "COMMENT_NODE", t1[t1.DOCUMENT_NODE = 9] = "DOCUMENT_NODE", t1[t1.DOCUMENT_TYPE_NODE = 10] = "DOCUMENT_TYPE_NODE", t1[t1.DOCUMENT_FRAGMENT_NODE = 11] = "DOCUMENT_FRAGMENT_NODE", t1[t1.NOTATION_NODE = 12] = "NOTATION_NODE";
            }(e1.NodeType || (e1.NodeType = {})), e1.replaceNode = function(t1, e1) {
                t1.parentNode && (t1.parentNode.insertBefore(e1, t1), t1.parentNode.removeChild(t1));
            }, e1.createElement = function(t1) {
                return i1.default.document.createElement(t1);
            }, e1.createElementNS = function(t1, e1) {
                return i1.default.document.createElementNS(t1, e1);
            }, e1.createTextNode = function(t1) {
                return i1.default.document.createTextNode(t1);
            }, e1.formatXml = function(t1) {
                let e1 = "", r1 = /(>)(<)(\/*)/g, n1 = 0, o1 = (t1 = t1.replace(r1, "$1\r\n$2$3")).split("\r\n");
                for(r1 = /(\.)*(<)(\/*)/g, o1 = o1.map((t1)=>t1.replace(r1, "$1\r\n$2$3").split("\r\n")).reduce((t1, e1)=>t1.concat(e1), []); o1.length;){
                    let t1 = o1.shift();
                    if (!t1) continue;
                    let r1 = 0;
                    if (t1.match(/^<\w[^>/]*>[^>]+$/)) {
                        const e1 = c1(t1, o1[0]);
                        e1[0] ? e1[1] ? (t1 += o1.shift().slice(0, -e1[1].length), e1[1].trim() && o1.unshift(e1[1])) : t1 += o1.shift() : r1 = 1;
                    } else if (t1.match(/^<\/\w/)) 0 !== n1 && (n1 -= 1);
                    else if (t1.match(/^<\w[^>]*[^/]>.*$/)) r1 = 1;
                    else if (t1.match(/^<\w[^>]*\/>.+$/)) {
                        const e1 = t1.indexOf(">") + 1;
                        t1.slice(e1).trim() && o1.unshift(), t1 = t1.slice(0, e1);
                    } else r1 = 0;
                    e1 += new Array(n1 + 1).join("  ") + t1 + "\r\n", n1 += r1;
                }
                return e1;
            }, e1.querySelectorAllByAttr = function(t1, e1) {
                return t1.querySelectorAll ? a1(t1.querySelectorAll(`[${e1}]`)) : s1.evalXPath(`.//*[@${e1}]`, t1);
            }, e1.querySelectorAllByAttrValue = function(t1, e1, r1) {
                return t1.querySelectorAll ? a1(t1.querySelectorAll(`[${e1}="${r1}"]`)) : s1.evalXPath(`.//*[@${e1}="${r1}"]`, t1);
            }, e1.querySelectorAll = function(t1, e1) {
                return t1.querySelectorAll ? a1(t1.querySelectorAll(e1)) : s1.evalXPath(`.//${e1}`, t1);
            }, e1.tagName = function(t1) {
                return t1.tagName.toUpperCase();
            }, e1.cloneNode = function(t1) {
                return t1.cloneNode(!0);
            }, e1.serializeXml = function(t1) {
                return (new i1.default.xmldom.XMLSerializer).serializeToString(t1);
            };
        },
        5897: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.EnginePromise = e1.SREError = void 0;
            const n1 = r1(1676), o1 = r1(4440), i1 = r1(2057), s1 = r1(1377);
            class a1 extends Error {
                constructor(t1 = ""){
                    super(), this.message = t1, this.name = "SRE Error";
                }
            }
            e1.SREError = a1;
            class l1 {
                constructor(){
                    this.customLoader = null, this.parsers = {}, this.comparator = null, this.mode = o1.Mode.SYNC, this.init = !0, this.delay = !1, this.comparators = {}, this.domain = "mathspeak", this.style = n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.STYLE], this._defaultLocale = n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.LOCALE], this.locale = this.defaultLocale, this.subiso = "", this.modality = n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.MODALITY], this.speech = o1.Speech.NONE, this.markup = o1.Markup.NONE, this.walker = "Table", this.structure = !1, this.ruleSets = [], this.strict = !1, this.isIE = !1, this.isEdge = !1, this.rate = "100", this.pprint = !1, this.config = !1, this.rules = "", this.prune = "", this.evaluator = l1.defaultEvaluator, this.defaultParser = new n1.DynamicCstrParser(n1.DynamicCstr.DEFAULT_ORDER), this.parser = this.defaultParser, this.dynamicCstr = n1.DynamicCstr.defaultCstr();
                }
                set defaultLocale(t1) {
                    this._defaultLocale = s1.Variables.ensureLocale(t1, this._defaultLocale);
                }
                get defaultLocale() {
                    return this._defaultLocale;
                }
                static getInstance() {
                    return l1.instance = l1.instance || new l1, l1.instance;
                }
                static defaultEvaluator(t1, e1) {
                    return t1;
                }
                static evaluateNode(t1) {
                    return l1.nodeEvaluator(t1);
                }
                getRate() {
                    const t1 = parseInt(this.rate, 10);
                    return isNaN(t1) ? 100 : t1;
                }
                setDynamicCstr(t1) {
                    if (this.defaultLocale && (n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.LOCALE] = this.defaultLocale), t1) {
                        const e1 = Object.keys(t1);
                        for(let r1 = 0; r1 < e1.length; r1++){
                            const o1 = e1[r1];
                            if (-1 !== n1.DynamicCstr.DEFAULT_ORDER.indexOf(o1)) {
                                const e1 = t1[o1];
                                this[o1] = e1;
                            }
                        }
                    }
                    o1.DOMAIN_TO_STYLES[this.domain] = this.style;
                    const e1 = [
                        this.locale,
                        this.modality,
                        this.domain,
                        this.style
                    ].join("."), r1 = n1.DynamicProperties.createProp([
                        n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.LOCALE]
                    ], [
                        n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.MODALITY]
                    ], [
                        n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.DOMAIN]
                    ], [
                        n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.STYLE]
                    ]), i1 = this.comparators[this.domain], s1 = this.parsers[this.domain];
                    this.parser = s1 || this.defaultParser, this.dynamicCstr = this.parser.parse(e1), this.dynamicCstr.updateProperties(r1.getProperties()), this.comparator = i1 ? i1() : new n1.DefaultComparator(this.dynamicCstr);
                }
                configurate(t1) {
                    this.mode !== o1.Mode.HTTP || this.config || (!function(t1) {
                        const e1 = document.documentElement.querySelectorAll('script[type="text/x-sre-config"]');
                        for(let r1 = 0, n1 = e1.length; r1 < n1; r1++){
                            let n1;
                            try {
                                n1 = e1[r1].innerHTML;
                                const o1 = JSON.parse(n1);
                                for(const e1 in o1)t1[e1] = o1[e1];
                            } catch (t1) {
                                i1.Debugger.getInstance().output("Illegal configuration ", n1);
                            }
                        }
                    }(t1), this.config = !0), function(t1) {
                        if ("undefined" != typeof SREfeature) for (const [e1, r1] of Object.entries(SREfeature))t1[e1] = r1;
                    }(t1);
                }
                setCustomLoader(t1) {
                    t1 && (this.customLoader = t1);
                }
            }
            e1.default = l1, l1.BINARY_FEATURES = [
                "strict",
                "structure",
                "pprint"
            ], l1.STRING_FEATURES = [
                "markup",
                "style",
                "domain",
                "speech",
                "walker",
                "defaultLocale",
                "locale",
                "delay",
                "modality",
                "rate",
                "rules",
                "subiso",
                "prune"
            ], l1.nodeEvaluator = function(t1) {
                return [];
            };
            class c1 {
                static get(t1 = l1.getInstance().locale) {
                    return c1.promises[t1] || Promise.resolve("");
                }
                static getall() {
                    return Promise.all(Object.values(c1.promises));
                }
            }
            e1.EnginePromise = c1, c1.loaded = {}, c1.promises = {};
        },
        4440: function(t1, e1) {
            var r1;
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.DOMAIN_TO_STYLES = e1.Markup = e1.Speech = e1.personalityPropList = e1.personalityProps = e1.Mode = void 0, function(t1) {
                t1.SYNC = "sync", t1.ASYNC = "async", t1.HTTP = "http";
            }(e1.Mode || (e1.Mode = {})), function(t1) {
                t1.PITCH = "pitch", t1.RATE = "rate", t1.VOLUME = "volume", t1.PAUSE = "pause", t1.JOIN = "join", t1.LAYOUT = "layout";
            }(r1 = e1.personalityProps || (e1.personalityProps = {})), e1.personalityPropList = [
                r1.PITCH,
                r1.RATE,
                r1.VOLUME,
                r1.PAUSE,
                r1.JOIN
            ], function(t1) {
                t1.NONE = "none", t1.SHALLOW = "shallow", t1.DEEP = "deep";
            }(e1.Speech || (e1.Speech = {})), function(t1) {
                t1.NONE = "none", t1.LAYOUT = "layout", t1.PUNCTUATION = "punctuation", t1.SSML = "ssml", t1.SSML_STEP = "ssml_step", t1.ACSS = "acss", t1.SABLE = "sable", t1.VOICEXML = "voicexml";
            }(e1.Markup || (e1.Markup = {})), e1.DOMAIN_TO_STYLES = {
                mathspeak: "default",
                clearspeak: "default"
            };
        },
        6828: function(t1, e1, r1) {
            var n1 = this && this.__awaiter || function(t1, e1, r1, n1) {
                return new (r1 || (r1 = Promise))(function(o1, i1) {
                    function s1(t1) {
                        try {
                            l1(n1.next(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function a1(t1) {
                        try {
                            l1(n1.throw(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function l1(t1) {
                        var e1;
                        t1.done ? o1(t1.value) : (e1 = t1.value, e1 instanceof r1 ? e1 : new r1(function(t1) {
                            t1(e1);
                        })).then(s1, a1);
                    }
                    l1((n1 = n1.apply(t1, e1 || [])).next());
                });
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.setup = void 0;
            const o1 = r1(7491), i1 = r1(6141), s1 = r1(2139), a1 = r1(5897), l1 = r1(7248), c1 = r1(2315);
            e1.setup = function(t1) {
                return n1(this, void 0, void 0, function*() {
                    const e1 = a1.default.getInstance();
                    "default" !== t1.domain || "speech" !== t1.modality && t1.modality && "speech" !== e1.modality || (t1.domain = "mathspeak");
                    const r1 = (r1)=>{
                        void 0 !== t1[r1] && (e1[r1] = t1[r1]);
                    };
                    return r1("mode"), e1.configurate(t1), a1.default.BINARY_FEATURES.forEach((r1)=>{
                        void 0 !== t1[r1] && (e1[r1] = !!t1[r1]);
                    }), a1.default.STRING_FEATURES.forEach(r1), t1.json && (c1.default.jsonPath = l1.makePath(t1.json)), t1.xpath && (c1.default.WGXpath = t1.xpath), e1.setCustomLoader(t1.custom), function(t1) {
                        t1.isIE = s1.detectIE(), t1.isEdge = s1.detectEdge();
                    }(e1), o1.setLocale(), e1.setDynamicCstr(), e1.init ? (a1.EnginePromise.promises.init = new Promise((t1, e1)=>{
                        setTimeout(()=>{
                            t1("init");
                        }, 10);
                    }), e1.init = !1, a1.EnginePromise.get()) : e1.delay ? (e1.delay = !1, a1.EnginePromise.get()) : i1.loadLocale();
                });
            };
        },
        8496: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Event = e1.EventType = e1.Move = e1.KeyCode = void 0, function(t1) {
                t1[t1.ENTER = 13] = "ENTER", t1[t1.ESC = 27] = "ESC", t1[t1.SPACE = 32] = "SPACE", t1[t1.PAGE_UP = 33] = "PAGE_UP", t1[t1.PAGE_DOWN = 34] = "PAGE_DOWN", t1[t1.END = 35] = "END", t1[t1.HOME = 36] = "HOME", t1[t1.LEFT = 37] = "LEFT", t1[t1.UP = 38] = "UP", t1[t1.RIGHT = 39] = "RIGHT", t1[t1.DOWN = 40] = "DOWN", t1[t1.TAB = 9] = "TAB", t1[t1.LESS = 188] = "LESS", t1[t1.GREATER = 190] = "GREATER", t1[t1.DASH = 189] = "DASH", t1[t1.ZERO = 48] = "ZERO", t1[t1.ONE = 49] = "ONE", t1[t1.TWO = 50] = "TWO", t1[t1.THREE = 51] = "THREE", t1[t1.FOUR = 52] = "FOUR", t1[t1.FIVE = 53] = "FIVE", t1[t1.SIX = 54] = "SIX", t1[t1.SEVEN = 55] = "SEVEN", t1[t1.EIGHT = 56] = "EIGHT", t1[t1.NINE = 57] = "NINE", t1[t1.A = 65] = "A", t1[t1.B = 66] = "B", t1[t1.C = 67] = "C", t1[t1.D = 68] = "D", t1[t1.E = 69] = "E", t1[t1.F = 70] = "F", t1[t1.G = 71] = "G", t1[t1.H = 72] = "H", t1[t1.I = 73] = "I", t1[t1.J = 74] = "J", t1[t1.K = 75] = "K", t1[t1.L = 76] = "L", t1[t1.M = 77] = "M", t1[t1.N = 78] = "N", t1[t1.O = 79] = "O", t1[t1.P = 80] = "P", t1[t1.Q = 81] = "Q", t1[t1.R = 82] = "R", t1[t1.S = 83] = "S", t1[t1.T = 84] = "T", t1[t1.U = 85] = "U", t1[t1.V = 86] = "V", t1[t1.W = 87] = "W", t1[t1.X = 88] = "X", t1[t1.Y = 89] = "Y", t1[t1.Z = 90] = "Z";
            }(e1.KeyCode || (e1.KeyCode = {})), e1.Move = new Map([
                [
                    13,
                    "ENTER"
                ],
                [
                    27,
                    "ESC"
                ],
                [
                    32,
                    "SPACE"
                ],
                [
                    33,
                    "PAGE_UP"
                ],
                [
                    34,
                    "PAGE_DOWN"
                ],
                [
                    35,
                    "END"
                ],
                [
                    36,
                    "HOME"
                ],
                [
                    37,
                    "LEFT"
                ],
                [
                    38,
                    "UP"
                ],
                [
                    39,
                    "RIGHT"
                ],
                [
                    40,
                    "DOWN"
                ],
                [
                    9,
                    "TAB"
                ],
                [
                    188,
                    "LESS"
                ],
                [
                    190,
                    "GREATER"
                ],
                [
                    189,
                    "DASH"
                ],
                [
                    48,
                    "ZERO"
                ],
                [
                    49,
                    "ONE"
                ],
                [
                    50,
                    "TWO"
                ],
                [
                    51,
                    "THREE"
                ],
                [
                    52,
                    "FOUR"
                ],
                [
                    53,
                    "FIVE"
                ],
                [
                    54,
                    "SIX"
                ],
                [
                    55,
                    "SEVEN"
                ],
                [
                    56,
                    "EIGHT"
                ],
                [
                    57,
                    "NINE"
                ],
                [
                    65,
                    "A"
                ],
                [
                    66,
                    "B"
                ],
                [
                    67,
                    "C"
                ],
                [
                    68,
                    "D"
                ],
                [
                    69,
                    "E"
                ],
                [
                    70,
                    "F"
                ],
                [
                    71,
                    "G"
                ],
                [
                    72,
                    "H"
                ],
                [
                    73,
                    "I"
                ],
                [
                    74,
                    "J"
                ],
                [
                    75,
                    "K"
                ],
                [
                    76,
                    "L"
                ],
                [
                    77,
                    "M"
                ],
                [
                    78,
                    "N"
                ],
                [
                    79,
                    "O"
                ],
                [
                    80,
                    "P"
                ],
                [
                    81,
                    "Q"
                ],
                [
                    82,
                    "R"
                ],
                [
                    83,
                    "S"
                ],
                [
                    84,
                    "T"
                ],
                [
                    85,
                    "U"
                ],
                [
                    86,
                    "V"
                ],
                [
                    87,
                    "W"
                ],
                [
                    88,
                    "X"
                ],
                [
                    89,
                    "Y"
                ],
                [
                    90,
                    "Z"
                ]
            ]), function(t1) {
                t1.CLICK = "click", t1.DBLCLICK = "dblclick", t1.MOUSEDOWN = "mousedown", t1.MOUSEUP = "mouseup", t1.MOUSEOVER = "mouseover", t1.MOUSEOUT = "mouseout", t1.MOUSEMOVE = "mousemove", t1.SELECTSTART = "selectstart", t1.KEYPRESS = "keypress", t1.KEYDOWN = "keydown", t1.KEYUP = "keyup", t1.TOUCHSTART = "touchstart", t1.TOUCHMOVE = "touchmove", t1.TOUCHEND = "touchend", t1.TOUCHCANCEL = "touchcancel";
            }(e1.EventType || (e1.EventType = {}));
            e1.Event = class {
                constructor(t1, e1, r1){
                    this.src = t1, this.type = e1, this.callback = r1;
                }
                add() {
                    this.src.addEventListener(this.type, this.callback);
                }
                remove() {
                    this.src.removeEventListener(this.type, this.callback);
                }
            };
        },
        7248: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.localePath = e1.makePath = void 0;
            const n1 = r1(2315);
            function o1(t1) {
                return t1.match("/$") ? t1 : t1 + "/";
            }
            e1.makePath = o1, e1.localePath = function(t1, e1 = "json") {
                return o1(n1.default.jsonPath) + t1 + (e1.match(/^\./) ? e1 : "." + e1);
            };
        },
        3769: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.KeyProcessor = e1.Processor = void 0;
            const n1 = r1(8496);
            class o1 {
                constructor(t1, e1){
                    this.name = t1, this.process = e1.processor, this.postprocess = e1.postprocessor || ((t1, e1)=>t1), this.processor = this.postprocess ? function(t1) {
                        return this.postprocess(this.process(t1), t1);
                    } : this.process, this.print = e1.print || o1.stringify_, this.pprint = e1.pprint || this.print;
                }
                static stringify_(t1) {
                    return t1 ? t1.toString() : t1;
                }
            }
            e1.Processor = o1, o1.LocalState = {
                walker: null,
                speechGenerator: null,
                highlighter: null
            };
            class i1 extends o1 {
                constructor(t1, e1){
                    super(t1, e1), this.key = e1.key || i1.getKey_;
                }
                static getKey_(t1) {
                    return "string" == typeof t1 ? n1.KeyCode[t1.toUpperCase()] : t1;
                }
            }
            e1.KeyProcessor = i1;
        },
        6499: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.keypress = e1.output = e1.print = e1.process = e1.set = void 0;
            const n1 = r1(8290), o1 = r1(5714), i1 = r1(3090), s1 = r1(4356), a1 = r1(1414), l1 = r1(9552), c1 = r1(9543), u1 = r1(3362), p1 = r1(1204), h1 = r1(5740), f1 = r1(5897), d1 = r1(4440), m1 = r1(3769), y1 = r1(5274), g1 = new Map;
            function b1(t1) {
                g1.set(t1.name, t1);
            }
            function v1(t1) {
                const e1 = g1.get(t1);
                if (!e1) throw new f1.SREError("Unknown processor " + t1);
                return e1;
            }
            function _1(t1, e1) {
                const r1 = v1(t1);
                try {
                    return r1.processor(e1);
                } catch (t1) {
                    throw new f1.SREError("Processing error for expression " + e1);
                }
            }
            function S1(t1, e1) {
                const r1 = v1(t1);
                return f1.default.getInstance().pprint ? r1.pprint(e1) : r1.print(e1);
            }
            e1.set = b1, e1.process = _1, e1.print = S1, e1.output = function(t1, e1) {
                const r1 = v1(t1);
                try {
                    const t1 = r1.processor(e1);
                    return f1.default.getInstance().pprint ? r1.pprint(t1) : r1.print(t1);
                } catch (t1) {
                    throw new f1.SREError("Processing error for expression " + e1);
                }
            }, e1.keypress = function(t1, e1) {
                const r1 = v1(t1), n1 = r1 instanceof m1.KeyProcessor ? r1.key(e1) : e1, o1 = r1.processor(n1);
                return f1.default.getInstance().pprint ? r1.pprint(o1) : r1.print(o1);
            }, b1(new m1.Processor("semantic", {
                processor: function(t1) {
                    const e1 = h1.parseInput(t1);
                    return a1.xmlTree(e1);
                },
                postprocessor: function(t1, e1) {
                    const r1 = f1.default.getInstance().speech;
                    if (r1 === d1.Speech.NONE) return t1;
                    const o1 = h1.cloneNode(t1);
                    let i1 = c1.computeMarkup(o1);
                    if (r1 === d1.Speech.SHALLOW) return t1.setAttribute("speech", n1.finalize(i1)), t1;
                    const s1 = y1.evalXPath(".//*[@id]", t1), a1 = y1.evalXPath(".//*[@id]", o1);
                    for(let t1, e1, r1 = 0; t1 = s1[r1], e1 = a1[r1]; r1++)i1 = c1.computeMarkup(e1), t1.setAttribute("speech", n1.finalize(i1));
                    return t1;
                },
                pprint: function(t1) {
                    return h1.formatXml(t1.toString());
                }
            })), b1(new m1.Processor("speech", {
                processor: function(t1) {
                    const e1 = h1.parseInput(t1), r1 = a1.xmlTree(e1), o1 = c1.computeSpeech(r1);
                    return n1.finalize(n1.markup(o1));
                },
                pprint: function(t1) {
                    const e1 = t1.toString();
                    return n1.isXml() ? h1.formatXml(e1) : e1;
                }
            })), b1(new m1.Processor("json", {
                processor: function(t1) {
                    const e1 = h1.parseInput(t1);
                    return a1.getTree(e1).toJson();
                },
                postprocessor: function(t1, e1) {
                    const r1 = f1.default.getInstance().speech;
                    if (r1 === d1.Speech.NONE) return t1;
                    const o1 = h1.parseInput(e1), i1 = a1.xmlTree(o1), s1 = c1.computeMarkup(i1);
                    if (r1 === d1.Speech.SHALLOW) return t1.stree.speech = n1.finalize(s1), t1;
                    const l1 = (t1)=>{
                        const e1 = y1.evalXPath(`.//*[@id=${t1.id}]`, i1)[0], r1 = c1.computeMarkup(e1);
                        t1.speech = n1.finalize(r1), t1.children && t1.children.forEach(l1);
                    };
                    return l1(t1.stree), t1;
                },
                print: function(t1) {
                    return JSON.stringify(t1);
                },
                pprint: function(t1) {
                    return JSON.stringify(t1, null, 2);
                }
            })), b1(new m1.Processor("description", {
                processor: function(t1) {
                    const e1 = h1.parseInput(t1), r1 = a1.xmlTree(e1);
                    return c1.computeSpeech(r1);
                },
                print: function(t1) {
                    return JSON.stringify(t1);
                },
                pprint: function(t1) {
                    return JSON.stringify(t1, null, 2);
                }
            })), b1(new m1.Processor("enriched", {
                processor: function(t1) {
                    return o1.semanticMathmlSync(t1);
                },
                postprocessor: function(t1, e1) {
                    const r1 = p1.getSemanticRoot(t1);
                    let n1;
                    switch(f1.default.getInstance().speech){
                        case d1.Speech.NONE:
                            break;
                        case d1.Speech.SHALLOW:
                            n1 = l1.generator("Adhoc"), n1.getSpeech(r1, t1);
                            break;
                        case d1.Speech.DEEP:
                            n1 = l1.generator("Tree"), n1.getSpeech(t1, t1);
                    }
                    return t1;
                },
                pprint: function(t1) {
                    return h1.formatXml(t1.toString());
                }
            })), b1(new m1.Processor("walker", {
                processor: function(t1) {
                    const e1 = l1.generator("Node");
                    m1.Processor.LocalState.speechGenerator = e1, e1.setOptions({
                        modality: f1.default.getInstance().modality,
                        locale: f1.default.getInstance().locale,
                        domain: f1.default.getInstance().domain,
                        style: f1.default.getInstance().style
                    }), m1.Processor.LocalState.highlighter = i1.highlighter({
                        color: "black"
                    }, {
                        color: "white"
                    }, {
                        renderer: "NativeMML"
                    });
                    const r1 = _1("enriched", t1), n1 = S1("enriched", r1);
                    return m1.Processor.LocalState.walker = u1.walker(f1.default.getInstance().walker, r1, e1, m1.Processor.LocalState.highlighter, n1), m1.Processor.LocalState.walker;
                },
                print: function(t1) {
                    return m1.Processor.LocalState.walker.speech();
                }
            })), b1(new m1.KeyProcessor("move", {
                processor: function(t1) {
                    if (!m1.Processor.LocalState.walker) return null;
                    return !1 === m1.Processor.LocalState.walker.move(t1) ? n1.error(t1) : m1.Processor.LocalState.walker.speech();
                }
            })), b1(new m1.Processor("number", {
                processor: function(t1) {
                    const e1 = parseInt(t1, 10);
                    return isNaN(e1) ? "" : s1.LOCALE.NUMBERS.numberToWords(e1);
                }
            })), b1(new m1.Processor("ordinal", {
                processor: function(t1) {
                    const e1 = parseInt(t1, 10);
                    return isNaN(e1) ? "" : s1.LOCALE.NUMBERS.wordOrdinal(e1);
                }
            })), b1(new m1.Processor("numericOrdinal", {
                processor: function(t1) {
                    const e1 = parseInt(t1, 10);
                    return isNaN(e1) ? "" : s1.LOCALE.NUMBERS.numericOrdinal(e1);
                }
            })), b1(new m1.Processor("vulgar", {
                processor: function(t1) {
                    const [e1, r1] = t1.split("/").map((t1)=>parseInt(t1, 10));
                    return isNaN(e1) || isNaN(r1) ? "" : _1("speech", `<mfrac><mn>${e1}</mn><mn>${r1}</mn></mfrac>`);
                }
            }));
        },
        2998: function(t1, e1, r1) {
            var n1 = this && this.__awaiter || function(t1, e1, r1, n1) {
                return new (r1 || (r1 = Promise))(function(o1, i1) {
                    function s1(t1) {
                        try {
                            l1(n1.next(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function a1(t1) {
                        try {
                            l1(n1.throw(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function l1(t1) {
                        var e1;
                        t1.done ? o1(t1.value) : (e1 = t1.value, e1 instanceof r1 ? e1 : new r1(function(t1) {
                            t1(e1);
                        })).then(s1, a1);
                    }
                    l1((n1 = n1.apply(t1, e1 || [])).next());
                });
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.localePath = e1.exit = e1.move = e1.walk = e1.processFile = e1.file = e1.vulgar = e1.numericOrdinal = e1.ordinal = e1.number = e1.toEnriched = e1.toDescription = e1.toJson = e1.toSemantic = e1.toSpeech = e1.localeLoader = e1.engineReady = e1.engineSetup = e1.setupEngine = e1.version = void 0;
            const o1 = r1(5897), i1 = r1(6828), s1 = r1(4440), a1 = r1(7248), l1 = r1(6499), c1 = r1(2315), u1 = r1(1377), p1 = r1(6141);
            function h1(t1) {
                return n1(this, void 0, void 0, function*() {
                    return (0, i1.setup)(t1);
                });
            }
            function f1(t1, e1) {
                return l1.process(t1, e1);
            }
            function d1(t1, e1, r1) {
                switch(o1.default.getInstance().mode){
                    case s1.Mode.ASYNC:
                        return function(t1, e1, r1) {
                            return n1(this, void 0, void 0, function*() {
                                const n1 = yield c1.default.fs.promises.readFile(e1, {
                                    encoding: "utf8"
                                }), i1 = l1.output(t1, n1);
                                if (r1) try {
                                    c1.default.fs.promises.writeFile(r1, i1);
                                } catch (t1) {
                                    throw new o1.SREError("Can not write to file: " + r1);
                                }
                                return i1;
                            });
                        }(t1, e1, r1);
                    case s1.Mode.SYNC:
                        return function(t1, e1, r1) {
                            const n1 = function(t1) {
                                let e1;
                                try {
                                    e1 = c1.default.fs.readFileSync(t1, {
                                        encoding: "utf8"
                                    });
                                } catch (e1) {
                                    throw new o1.SREError("Can not open file: " + t1);
                                }
                                return e1;
                            }(e1), i1 = l1.output(t1, n1);
                            if (r1) try {
                                c1.default.fs.writeFileSync(r1, i1);
                            } catch (t1) {
                                throw new o1.SREError("Can not write to file: " + r1);
                            }
                            return i1;
                        }(t1, e1, r1);
                    default:
                        throw new o1.SREError(`Can process files in ${o1.default.getInstance().mode} mode`);
                }
            }
            e1.version = u1.Variables.VERSION, e1.setupEngine = h1, e1.engineSetup = function() {
                const t1 = [
                    "mode"
                ].concat(o1.default.STRING_FEATURES, o1.default.BINARY_FEATURES), e1 = o1.default.getInstance(), r1 = {};
                return t1.forEach(function(t1) {
                    r1[t1] = e1[t1];
                }), r1.json = c1.default.jsonPath, r1.xpath = c1.default.WGXpath, r1.rules = e1.ruleSets.slice(), r1;
            }, e1.engineReady = function() {
                return n1(this, void 0, void 0, function*() {
                    return h1({}).then(()=>o1.EnginePromise.getall());
                });
            }, e1.localeLoader = p1.standardLoader, e1.toSpeech = function(t1) {
                return f1("speech", t1);
            }, e1.toSemantic = function(t1) {
                return f1("semantic", t1);
            }, e1.toJson = function(t1) {
                return f1("json", t1);
            }, e1.toDescription = function(t1) {
                return f1("description", t1);
            }, e1.toEnriched = function(t1) {
                return f1("enriched", t1);
            }, e1.number = function(t1) {
                return f1("number", t1);
            }, e1.ordinal = function(t1) {
                return f1("ordinal", t1);
            }, e1.numericOrdinal = function(t1) {
                return f1("numericOrdinal", t1);
            }, e1.vulgar = function(t1) {
                return f1("vulgar", t1);
            }, e1.file = {}, e1.file.toSpeech = function(t1, e1) {
                return d1("speech", t1, e1);
            }, e1.file.toSemantic = function(t1, e1) {
                return d1("semantic", t1, e1);
            }, e1.file.toJson = function(t1, e1) {
                return d1("json", t1, e1);
            }, e1.file.toDescription = function(t1, e1) {
                return d1("description", t1, e1);
            }, e1.file.toEnriched = function(t1, e1) {
                return d1("enriched", t1, e1);
            }, e1.processFile = d1, e1.walk = function(t1) {
                return l1.output("walker", t1);
            }, e1.move = function(t1) {
                return l1.keypress("move", t1);
            }, e1.exit = function(t1) {
                const e1 = t1 || 0;
                o1.EnginePromise.getall().then(()=>process.exit(e1));
            }, e1.localePath = a1.localePath, c1.default.documentSupported ? h1({
                mode: s1.Mode.HTTP
            }).then(()=>h1({})) : h1({
                mode: s1.Mode.SYNC
            }).then(()=>h1({
                    mode: s1.Mode.ASYNC
                }));
        },
        2315: function(__unused_webpack_module, exports, __webpack_require__) {
            var __dirname = "/";
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
            const variables_1 = __webpack_require__(1377);
            class SystemExternal {
                static extRequire(library) {
                    if ("undefined" != typeof process) {
                        const nodeRequire = eval("require");
                        return nodeRequire(library);
                    }
                    return null;
                }
            }
            exports.default = SystemExternal, SystemExternal.windowSupported = !("undefined" == typeof window), SystemExternal.documentSupported = SystemExternal.windowSupported && !(void 0 === window.document), SystemExternal.xmldom = SystemExternal.documentSupported ? window : SystemExternal.extRequire("xmldom-sre"), SystemExternal.document = SystemExternal.documentSupported ? window.document : (new SystemExternal.xmldom.DOMImplementation).createDocument("", "", 0), SystemExternal.xpath = SystemExternal.documentSupported ? document : function() {
                const t1 = {
                    document: {},
                    XPathResult: {}
                };
                return SystemExternal.extRequire("wicked-good-xpath").install(t1), t1.document.XPathResult = t1.XPathResult, t1.document;
            }(), SystemExternal.mathmapsIePath = "https://cdn.jsdelivr.net/npm/sre-mathmaps-ie@" + variables_1.Variables.VERSION + "mathmaps_ie.js", SystemExternal.commander = SystemExternal.documentSupported ? null : SystemExternal.extRequire("commander"), SystemExternal.fs = SystemExternal.documentSupported ? null : SystemExternal.extRequire("fs"), SystemExternal.url = variables_1.Variables.url, SystemExternal.jsonPath = (SystemExternal.documentSupported ? SystemExternal.url : process.env.SRE_JSON_PATH || __webpack_require__.g.SRE_JSON_PATH || __dirname + "/mathmaps") + "/", SystemExternal.WGXpath = variables_1.Variables.WGXpath, SystemExternal.wgxpath = null;
        },
        1377: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Variables = void 0;
            class r1 {
                static ensureLocale(t1, e1) {
                    return r1.LOCALES.get(t1) ? t1 : (console.error(`Locale ${t1} does not exist! Using ${r1.LOCALES.get(e1)} instead.`), e1);
                }
            }
            e1.Variables = r1, r1.VERSION = "4.0.6", r1.LOCALES = new Map([
                [
                    "ca",
                    "Catalan"
                ],
                [
                    "da",
                    "Danish"
                ],
                [
                    "de",
                    "German"
                ],
                [
                    "en",
                    "English"
                ],
                [
                    "es",
                    "Spanish"
                ],
                [
                    "fr",
                    "French"
                ],
                [
                    "hi",
                    "Hindi"
                ],
                [
                    "it",
                    "Italian"
                ],
                [
                    "nb",
                    "Bokm\xe5l"
                ],
                [
                    "nn",
                    "Nynorsk"
                ],
                [
                    "sv",
                    "Swedish"
                ],
                [
                    "nemeth",
                    "Nemeth"
                ]
            ]), r1.mathjaxVersion = "3.2.1", r1.url = "https://cdn.jsdelivr.net/npm/speech-rule-engine@" + r1.VERSION + "/lib/mathmaps", r1.WGXpath = "https://cdn.jsdelivr.net/npm/wicked-good-xpath@1.3.0/dist/wgxpath.install.js";
        },
        5274: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.updateEvaluator = e1.evaluateString = e1.evaluateBoolean = e1.getLeafNodes = e1.evalXPath = e1.resolveNameSpace = e1.xpath = void 0;
            const n1 = r1(5897), o1 = r1(4440), i1 = r1(2315);
            function s1() {
                return "undefined" != typeof XPathResult;
            }
            e1.xpath = {
                currentDocument: null,
                evaluate: s1() ? document.evaluate : i1.default.xpath.evaluate,
                result: s1() ? XPathResult : i1.default.xpath.XPathResult,
                createNSResolver: s1() ? document.createNSResolver : i1.default.xpath.createNSResolver
            };
            const a1 = {
                xhtml: "http://www.w3.org/1999/xhtml",
                mathml: "http://www.w3.org/1998/Math/MathML",
                mml: "http://www.w3.org/1998/Math/MathML",
                svg: "http://www.w3.org/2000/svg"
            };
            function l1(t1) {
                return a1[t1] || null;
            }
            e1.resolveNameSpace = l1;
            class c1 {
                constructor(){
                    this.lookupNamespaceURI = l1;
                }
            }
            function u1(t1, r1, i1) {
                return n1.default.getInstance().mode !== o1.Mode.HTTP || n1.default.getInstance().isIE || n1.default.getInstance().isEdge ? e1.xpath.evaluate(t1, r1, new c1, i1, null) : e1.xpath.currentDocument.evaluate(t1, r1, l1, i1, null);
            }
            function p1(t1, r1) {
                let n1;
                try {
                    n1 = u1(t1, r1, e1.xpath.result.ORDERED_NODE_ITERATOR_TYPE);
                } catch (t1) {
                    return [];
                }
                const o1 = [];
                for(let t1 = n1.iterateNext(); t1; t1 = n1.iterateNext())o1.push(t1);
                return o1;
            }
            e1.evalXPath = p1, e1.getLeafNodes = function(t1) {
                return p1(".//*[count(*)=0]", t1);
            }, e1.evaluateBoolean = function(t1, r1) {
                let n1;
                try {
                    n1 = u1(t1, r1, e1.xpath.result.BOOLEAN_TYPE);
                } catch (t1) {
                    return !1;
                }
                return n1.booleanValue;
            }, e1.evaluateString = function(t1, r1) {
                let n1;
                try {
                    n1 = u1(t1, r1, e1.xpath.result.STRING_TYPE);
                } catch (t1) {
                    return "";
                }
                return n1.stringValue;
            }, e1.updateEvaluator = function(t1) {
                if (n1.default.getInstance().mode !== o1.Mode.HTTP) return;
                let r1 = t1;
                for(; r1 && !r1.evaluate;)r1 = r1.parentNode;
                r1 && r1.evaluate ? e1.xpath.currentDocument = r1 : t1.ownerDocument && (e1.xpath.currentDocument = t1.ownerDocument);
            };
        },
        9268: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractEnrichCase = void 0;
            e1.AbstractEnrichCase = class {
                constructor(t1){
                    this.semantic = t1;
                }
            };
        },
        6061: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseBinomial = void 0;
            const n1 = r1(5740), o1 = r1(9268), i1 = r1(5452), s1 = r1(2298);
            class a1 extends o1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.mml = t1.mathmlTree;
                }
                static test(t1) {
                    return !t1.mathmlTree && "line" === t1.type && "binomial" === t1.role;
                }
                getMathml() {
                    if (!this.semantic.childNodes.length) return this.mml;
                    const t1 = this.semantic.childNodes[0];
                    if (this.mml = (0, i1.walkTree)(t1), this.mml.hasAttribute(s1.Attribute.TYPE)) {
                        const t1 = n1.createElement("mrow");
                        t1.setAttribute(s1.Attribute.ADDED, "true"), n1.replaceNode(this.mml, t1), t1.appendChild(this.mml), this.mml = t1;
                    }
                    return (0, s1.setAttributes)(this.mml, this.semantic), this.mml;
                }
            }
            e1.CaseBinomial = a1;
        },
        5765: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseDoubleScript = void 0;
            const n1 = r1(5740), o1 = r1(9268), i1 = r1(5452), s1 = r1(2298);
            class a1 extends o1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.mml = t1.mathmlTree;
                }
                static test(t1) {
                    if (!t1.mathmlTree || !t1.childNodes.length) return !1;
                    const e1 = n1.tagName(t1.mathmlTree), r1 = t1.childNodes[0].role;
                    return "MSUBSUP" === e1 && "subsup" === r1 || "MUNDEROVER" === e1 && "underover" === r1;
                }
                getMathml() {
                    const t1 = this.semantic.childNodes[0], e1 = t1.childNodes[0], r1 = this.semantic.childNodes[1], n1 = t1.childNodes[1], o1 = i1.walkTree(r1), a1 = i1.walkTree(e1), l1 = i1.walkTree(n1);
                    return (0, s1.setAttributes)(this.mml, this.semantic), this.mml.setAttribute(s1.Attribute.CHILDREN, (0, s1.makeIdList)([
                        e1,
                        n1,
                        r1
                    ])), [
                        a1,
                        l1,
                        o1
                    ].forEach((t1)=>i1.getInnerNode(t1).setAttribute(s1.Attribute.PARENT, this.mml.getAttribute(s1.Attribute.ID))), this.mml.setAttribute(s1.Attribute.TYPE, t1.role), i1.addCollapsedAttribute(this.mml, [
                        this.semantic.id,
                        [
                            t1.id,
                            e1.id,
                            n1.id
                        ],
                        r1.id
                    ]), this.mml;
                }
            }
            e1.CaseDoubleScript = a1;
        },
        7251: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseEmbellished = void 0;
            const n1 = r1(5740), o1 = r1(5952), i1 = r1(9268), s1 = r1(5765), a1 = r1(7014), l1 = r1(6887), c1 = r1(5452), u1 = r1(2298);
            class p1 extends i1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.fenced = null, this.fencedMml = null, this.fencedMmlNodes = [], this.ofence = null, this.ofenceMml = null, this.ofenceMap = {}, this.cfence = null, this.cfenceMml = null, this.cfenceMap = {}, this.parentCleanup = [];
                }
                static test(t1) {
                    return !(!t1.mathmlTree || !t1.fencePointer || t1.mathmlTree.getAttribute("data-semantic-type"));
                }
                static makeEmptyNode_(t1) {
                    const e1 = n1.createElement("mrow"), r1 = new o1.SemanticNode(t1);
                    return r1.type = "empty", r1.mathmlTree = e1, r1;
                }
                static fencedMap_(t1, e1) {
                    e1[t1.id] = t1.mathmlTree, t1.embellished && p1.fencedMap_(t1.childNodes[0], e1);
                }
                getMathml() {
                    this.getFenced_(), this.fencedMml = c1.walkTree(this.fenced), this.getFencesMml_(), "empty" !== this.fenced.type || this.fencedMml.parentNode || (this.fencedMml.setAttribute(u1.Attribute.ADDED, "true"), this.cfenceMml.parentNode.insertBefore(this.fencedMml, this.cfenceMml)), this.getFencedMml_();
                    return this.rewrite_();
                }
                fencedElement(t1) {
                    return "fenced" === t1.type || "matrix" === t1.type || "vector" === t1.type;
                }
                getFenced_() {
                    let t1 = this.semantic;
                    for(; !this.fencedElement(t1);)t1 = t1.childNodes[0];
                    this.fenced = t1.childNodes[0], this.ofence = t1.contentNodes[0], this.cfence = t1.contentNodes[1], p1.fencedMap_(this.ofence, this.ofenceMap), p1.fencedMap_(this.cfence, this.cfenceMap);
                }
                getFencedMml_() {
                    let t1 = this.ofenceMml.nextSibling;
                    for(t1 = t1 === this.fencedMml ? t1 : this.fencedMml; t1 && t1 !== this.cfenceMml;)this.fencedMmlNodes.push(t1), t1 = t1.nextSibling;
                }
                getFencesMml_() {
                    let t1 = this.semantic;
                    const e1 = Object.keys(this.ofenceMap), r1 = Object.keys(this.cfenceMap);
                    for(; !(this.ofenceMml && this.cfenceMml || t1 === this.fenced);)-1 === e1.indexOf(t1.fencePointer) || this.ofenceMml || (this.ofenceMml = t1.mathmlTree), -1 === r1.indexOf(t1.fencePointer) || this.cfenceMml || (this.cfenceMml = t1.mathmlTree), t1 = t1.childNodes[0];
                    this.ofenceMml || (this.ofenceMml = this.ofence.mathmlTree), this.cfenceMml || (this.cfenceMml = this.cfence.mathmlTree), this.ofenceMml && (this.ofenceMml = c1.ascendNewNode(this.ofenceMml)), this.cfenceMml && (this.cfenceMml = c1.ascendNewNode(this.cfenceMml));
                }
                rewrite_() {
                    let t1 = this.semantic, e1 = null;
                    const r1 = this.introduceNewLayer_();
                    for((0, u1.setAttributes)(r1, this.fenced.parent); !this.fencedElement(t1);){
                        const o1 = t1.mathmlTree, i1 = this.specialCase_(t1, o1);
                        if (i1) t1 = i1;
                        else {
                            (0, u1.setAttributes)(o1, t1);
                            const e1 = [];
                            for(let r1, n1 = 1; r1 = t1.childNodes[n1]; n1++)e1.push(c1.walkTree(r1));
                            t1 = t1.childNodes[0];
                        }
                        const s1 = n1.createElement("dummy"), a1 = o1.childNodes[0];
                        n1.replaceNode(o1, s1), n1.replaceNode(r1, o1), n1.replaceNode(o1.childNodes[0], r1), n1.replaceNode(s1, a1), e1 || (e1 = o1);
                    }
                    return c1.walkTree(this.ofence), c1.walkTree(this.cfence), this.cleanupParents_(), e1 || r1;
                }
                specialCase_(t1, e1) {
                    const r1 = n1.tagName(e1);
                    let o1, i1 = null;
                    if ("MSUBSUP" === r1 ? (i1 = t1.childNodes[0], o1 = s1.CaseDoubleScript) : "MMULTISCRIPTS" === r1 && ("superscript" === t1.type || "subscript" === t1.type ? o1 = a1.CaseMultiscripts : "tensor" === t1.type && (o1 = l1.CaseTensor), i1 = o1 && t1.childNodes[0] && "subsup" === t1.childNodes[0].role ? t1.childNodes[0] : t1), !i1) return null;
                    const c1 = i1.childNodes[0], u1 = p1.makeEmptyNode_(c1.id);
                    return i1.childNodes[0] = u1, e1 = new o1(t1).getMathml(), i1.childNodes[0] = c1, this.parentCleanup.push(e1), i1.childNodes[0];
                }
                introduceNewLayer_() {
                    const t1 = this.fullFence(this.ofenceMml), e1 = this.fullFence(this.cfenceMml);
                    let r1 = n1.createElement("mrow");
                    if (n1.replaceNode(this.fencedMml, r1), this.fencedMmlNodes.forEach((t1)=>r1.appendChild(t1)), r1.insertBefore(t1, this.fencedMml), r1.appendChild(e1), !r1.parentNode) {
                        const t1 = n1.createElement("mrow");
                        for(; r1.childNodes.length > 0;)t1.appendChild(r1.childNodes[0]);
                        r1.appendChild(t1), r1 = t1;
                    }
                    return r1;
                }
                fullFence(t1) {
                    const e1 = this.fencedMml.parentNode;
                    let r1 = t1;
                    for(; r1.parentNode && r1.parentNode !== e1;)r1 = r1.parentNode;
                    return r1;
                }
                cleanupParents_() {
                    this.parentCleanup.forEach(function(t1) {
                        const e1 = t1.childNodes[1].getAttribute(u1.Attribute.PARENT);
                        t1.childNodes[0].setAttribute(u1.Attribute.PARENT, e1);
                    });
                }
            }
            e1.CaseEmbellished = p1;
        },
        6265: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseLimit = void 0;
            const n1 = r1(5740), o1 = r1(9268), i1 = r1(5452), s1 = r1(2298);
            class a1 extends o1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.mml = t1.mathmlTree;
                }
                static test(t1) {
                    if (!t1.mathmlTree || !t1.childNodes.length) return !1;
                    const e1 = n1.tagName(t1.mathmlTree), r1 = t1.type;
                    return ("limupper" === r1 || "limlower" === r1) && ("MSUBSUP" === e1 || "MUNDEROVER" === e1) || "limboth" === r1 && ("MSUB" === e1 || "MUNDER" === e1 || "MSUP" === e1 || "MOVER" === e1);
                }
                static walkTree_(t1) {
                    t1 && i1.walkTree(t1);
                }
                getMathml() {
                    const t1 = this.semantic.childNodes;
                    return "limboth" !== this.semantic.type && this.mml.childNodes.length >= 3 && (this.mml = i1.introduceNewLayer([
                        this.mml
                    ], this.semantic)), (0, s1.setAttributes)(this.mml, this.semantic), t1[0].mathmlTree || (t1[0].mathmlTree = this.semantic.mathmlTree), t1.forEach(a1.walkTree_), this.mml;
                }
            }
            e1.CaseLimit = a1;
        },
        6514: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseLine = void 0;
            const n1 = r1(9268), o1 = r1(5452), i1 = r1(2298);
            class s1 extends n1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.mml = t1.mathmlTree;
                }
                static test(t1) {
                    return !!t1.mathmlTree && "line" === t1.type;
                }
                getMathml() {
                    return this.semantic.contentNodes.length && o1.walkTree(this.semantic.contentNodes[0]), this.semantic.childNodes.length && o1.walkTree(this.semantic.childNodes[0]), (0, i1.setAttributes)(this.mml, this.semantic), this.mml;
                }
            }
            e1.CaseLine = s1;
        },
        6839: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseMultiindex = void 0;
            const n1 = r1(5740), o1 = r1(9268), i1 = r1(5452), s1 = r1(2298);
            class a1 extends o1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.mml = t1.mathmlTree;
                }
                static multiscriptIndex(t1) {
                    return "punctuated" === t1.type && "dummy" === t1.contentNodes[0].role ? i1.collapsePunctuated(t1) : (i1.walkTree(t1), t1.id);
                }
                static createNone_(t1) {
                    const e1 = n1.createElement("none");
                    return t1 && (0, s1.setAttributes)(e1, t1), e1.setAttribute(s1.Attribute.ADDED, "true"), e1;
                }
                completeMultiscript(t1, e1) {
                    const r1 = n1.toArray(this.mml.childNodes).slice(1);
                    let o1 = 0;
                    const l1 = (t1)=>{
                        for(let e1, n1 = 0; e1 = t1[n1]; n1++){
                            const t1 = r1[o1];
                            if (t1 && e1 === parseInt(i1.getInnerNode(t1).getAttribute(s1.Attribute.ID))) i1.getInnerNode(t1).setAttribute(s1.Attribute.PARENT, this.semantic.id.toString()), o1++;
                            else {
                                const r1 = this.semantic.querySelectorAll((t1)=>t1.id === e1);
                                this.mml.insertBefore(a1.createNone_(r1[0]), t1 || null);
                            }
                        }
                    };
                    l1(t1), r1[o1] && "MPRESCRIPTS" !== n1.tagName(r1[o1]) ? this.mml.insertBefore(r1[o1], n1.createElement("mprescripts")) : o1++, l1(e1);
                }
            }
            e1.CaseMultiindex = a1;
        },
        7014: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseMultiscripts = void 0;
            const n1 = r1(5740), o1 = r1(5656), i1 = r1(6839), s1 = r1(5452), a1 = r1(2298);
            class l1 extends i1.CaseMultiindex {
                static test(t1) {
                    if (!t1.mathmlTree) return !1;
                    return "MMULTISCRIPTS" === n1.tagName(t1.mathmlTree) && ("superscript" === t1.type || "subscript" === t1.type);
                }
                constructor(t1){
                    super(t1);
                }
                getMathml() {
                    let t1, e1, r1;
                    if ((0, a1.setAttributes)(this.mml, this.semantic), this.semantic.childNodes[0] && "subsup" === this.semantic.childNodes[0].role) {
                        const n1 = this.semantic.childNodes[0];
                        t1 = n1.childNodes[0], e1 = i1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]), r1 = i1.CaseMultiindex.multiscriptIndex(n1.childNodes[1]);
                        const l1 = [
                            this.semantic.id,
                            [
                                n1.id,
                                t1.id,
                                r1
                            ],
                            e1
                        ];
                        s1.addCollapsedAttribute(this.mml, l1), this.mml.setAttribute(a1.Attribute.TYPE, n1.role), this.completeMultiscript(o1.SemanticSkeleton.interleaveIds(r1, e1), []);
                    } else {
                        t1 = this.semantic.childNodes[0], e1 = i1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]);
                        const r1 = [
                            this.semantic.id,
                            t1.id,
                            e1
                        ];
                        s1.addCollapsedAttribute(this.mml, r1);
                    }
                    const n1 = o1.SemanticSkeleton.collapsedLeafs(r1 || [], e1), l1 = s1.walkTree(t1);
                    return s1.getInnerNode(l1).setAttribute(a1.Attribute.PARENT, this.semantic.id.toString()), n1.unshift(t1.id), this.mml.setAttribute(a1.Attribute.CHILDREN, n1.join(",")), this.mml;
                }
            }
            e1.CaseMultiscripts = l1;
        },
        3416: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseProof = void 0;
            const n1 = r1(9268), o1 = r1(5452), i1 = r1(2298);
            class s1 extends n1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.mml = t1.mathmlTree;
                }
                static test(t1) {
                    return !!t1.mathmlTree && ("inference" === t1.type || "premises" === t1.type);
                }
                getMathml() {
                    return this.semantic.childNodes.length ? (this.semantic.contentNodes.forEach(function(t1) {
                        o1.walkTree(t1), (0, i1.setAttributes)(t1.mathmlTree, t1);
                    }), this.semantic.childNodes.forEach(function(t1) {
                        o1.walkTree(t1);
                    }), (0, i1.setAttributes)(this.mml, this.semantic), this.mml.getAttribute("data-semantic-id") === this.mml.getAttribute("data-semantic-parent") && this.mml.removeAttribute("data-semantic-parent"), this.mml) : this.mml;
                }
            }
            e1.CaseProof = s1;
        },
        5699: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseTable = void 0;
            const n1 = r1(5740), o1 = r1(9268), i1 = r1(5452), s1 = r1(2298);
            class a1 extends o1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.inner = [], this.mml = t1.mathmlTree;
                }
                static test(t1) {
                    return "matrix" === t1.type || "vector" === t1.type || "cases" === t1.type;
                }
                getMathml() {
                    const t1 = i1.cloneContentNode(this.semantic.contentNodes[0]), e1 = this.semantic.contentNodes[1] ? i1.cloneContentNode(this.semantic.contentNodes[1]) : null;
                    if (this.inner = this.semantic.childNodes.map(i1.walkTree), this.mml) {
                        if ("MFENCED" === n1.tagName(this.mml)) {
                            const r1 = this.mml.childNodes;
                            this.mml.insertBefore(t1, r1[0] || null), e1 && this.mml.appendChild(e1), this.mml = i1.rewriteMfenced(this.mml);
                        } else {
                            const r1 = [
                                t1,
                                this.mml
                            ];
                            e1 && r1.push(e1), this.mml = i1.introduceNewLayer(r1, this.semantic);
                        }
                    } else this.mml = i1.introduceNewLayer([
                        t1
                    ].concat(this.inner, [
                        e1
                    ]), this.semantic);
                    return (0, s1.setAttributes)(this.mml, this.semantic), this.mml;
                }
            }
            e1.CaseTable = a1;
        },
        6887: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseTensor = void 0;
            const n1 = r1(5656), o1 = r1(6839), i1 = r1(5452), s1 = r1(2298);
            class a1 extends o1.CaseMultiindex {
                static test(t1) {
                    return !!t1.mathmlTree && "tensor" === t1.type;
                }
                constructor(t1){
                    super(t1);
                }
                getMathml() {
                    i1.walkTree(this.semantic.childNodes[0]);
                    const t1 = o1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]), e1 = o1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[2]), r1 = o1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[3]), a1 = o1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[4]);
                    (0, s1.setAttributes)(this.mml, this.semantic);
                    const l1 = [
                        this.semantic.id,
                        this.semantic.childNodes[0].id,
                        t1,
                        e1,
                        r1,
                        a1
                    ];
                    i1.addCollapsedAttribute(this.mml, l1);
                    const c1 = n1.SemanticSkeleton.collapsedLeafs(t1, e1, r1, a1);
                    return c1.unshift(this.semantic.childNodes[0].id), this.mml.setAttribute(s1.Attribute.CHILDREN, c1.join(",")), this.completeMultiscript(n1.SemanticSkeleton.interleaveIds(r1, a1), n1.SemanticSkeleton.interleaveIds(t1, e1)), this.mml;
                }
            }
            e1.CaseTensor = a1;
        },
        9236: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CaseText = void 0;
            const n1 = r1(9268), o1 = r1(5452), i1 = r1(2298);
            class s1 extends n1.AbstractEnrichCase {
                constructor(t1){
                    super(t1), this.mml = t1.mathmlTree;
                }
                static test(t1) {
                    return "punctuated" === t1.type && ("text" === t1.role || t1.contentNodes.every((t1)=>"dummy" === t1.role));
                }
                getMathml() {
                    const t1 = [], e1 = o1.collapsePunctuated(this.semantic, t1);
                    return this.mml = o1.introduceNewLayer(t1, this.semantic), (0, i1.setAttributes)(this.mml, this.semantic), this.mml.removeAttribute(i1.Attribute.CONTENT), o1.addCollapsedAttribute(this.mml, e1), this.mml;
                }
            }
            e1.CaseText = s1;
        },
        5714: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.prepareMmlString = e1.testTranslation__ = e1.semanticMathml = e1.semanticMathmlSync = e1.semanticMathmlNode = void 0;
            const n1 = r1(2057), o1 = r1(5740), i1 = r1(5897), s1 = r1(1414), a1 = r1(5452), l1 = r1(2298);
            function c1(t1) {
                const e1 = o1.cloneNode(t1), r1 = s1.getTree(e1);
                return a1.enrich(e1, r1);
            }
            function u1(t1) {
                return c1(o1.parseInput(t1));
            }
            function p1(t1) {
                return t1.match(/^<math/) || (t1 = "<math>" + t1), t1.match(/\/math>$/) || (t1 += "</math>"), t1;
            }
            r1(1513), e1.semanticMathmlNode = c1, e1.semanticMathmlSync = u1, e1.semanticMathml = function(t1, e1) {
                i1.EnginePromise.getall().then(()=>{
                    const r1 = o1.parseInput(t1);
                    e1(c1(r1));
                });
            }, e1.testTranslation__ = function(t1) {
                n1.Debugger.getInstance().init();
                const e1 = u1(p1(t1)).toString();
                return (0, l1.removeAttributePrefix)(e1), n1.Debugger.getInstance().exit(), e1;
            }, e1.prepareMmlString = p1;
        },
        2298: function(t1, e1) {
            var r1;
            function n1(t1) {
                return t1.map(function(t1) {
                    return t1.id;
                }).join(",");
            }
            function o1(t1, e1) {
                const n1 = [];
                "mglyph" === e1.role && n1.push("image"), e1.attributes.href && n1.push("link"), n1.length && t1.setAttribute(r1.POSTFIX, n1.join(" "));
            }
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.addPrefix = e1.removeAttributePrefix = e1.setPostfix = e1.setAttributes = e1.makeIdList = e1.EnrichAttributes = e1.Attribute = e1.Prefix = void 0, e1.Prefix = "data-semantic-", function(t1) {
                t1.ADDED = "data-semantic-added", t1.ALTERNATIVE = "data-semantic-alternative", t1.CHILDREN = "data-semantic-children", t1.COLLAPSED = "data-semantic-collapsed", t1.CONTENT = "data-semantic-content", t1.EMBELLISHED = "data-semantic-embellished", t1.FENCEPOINTER = "data-semantic-fencepointer", t1.FONT = "data-semantic-font", t1.ID = "data-semantic-id", t1.ANNOTATION = "data-semantic-annotation", t1.OPERATOR = "data-semantic-operator", t1.OWNS = "data-semantic-owns", t1.PARENT = "data-semantic-parent", t1.POSTFIX = "data-semantic-postfix", t1.PREFIX = "data-semantic-prefix", t1.ROLE = "data-semantic-role", t1.SPEECH = "data-semantic-speech", t1.STRUCTURE = "data-semantic-structure", t1.TYPE = "data-semantic-type";
            }(r1 = e1.Attribute || (e1.Attribute = {})), e1.EnrichAttributes = [
                r1.ADDED,
                r1.ALTERNATIVE,
                r1.CHILDREN,
                r1.COLLAPSED,
                r1.CONTENT,
                r1.EMBELLISHED,
                r1.FENCEPOINTER,
                r1.FONT,
                r1.ID,
                r1.ANNOTATION,
                r1.OPERATOR,
                r1.OWNS,
                r1.PARENT,
                r1.POSTFIX,
                r1.PREFIX,
                r1.ROLE,
                r1.SPEECH,
                r1.STRUCTURE,
                r1.TYPE
            ], e1.makeIdList = n1, e1.setAttributes = function(t1, i1) {
                t1.setAttribute(r1.TYPE, i1.type);
                const s1 = i1.allAttributes();
                for(let r1, n1 = 0; r1 = s1[n1]; n1++)t1.setAttribute(e1.Prefix + r1[0].toLowerCase(), r1[1]);
                i1.childNodes.length && t1.setAttribute(r1.CHILDREN, n1(i1.childNodes)), i1.contentNodes.length && t1.setAttribute(r1.CONTENT, n1(i1.contentNodes)), i1.parent && t1.setAttribute(r1.PARENT, i1.parent.id.toString()), o1(t1, i1);
            }, e1.setPostfix = o1, e1.removeAttributePrefix = function(t1) {
                return t1.toString().replace(new RegExp(e1.Prefix, "g"), "");
            }, e1.addPrefix = function(t1) {
                return e1.Prefix + t1;
            };
        },
        3532: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.factory = e1.getCase = void 0, e1.getCase = function(t1) {
                for(let r1, n1 = 0; r1 = e1.factory[n1]; n1++)if (r1.test(t1)) return r1.constr(t1);
                return null;
            }, e1.factory = [];
        },
        1513: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(6061), o1 = r1(5765), i1 = r1(7251), s1 = r1(6265), a1 = r1(6514), l1 = r1(7014), c1 = r1(3416), u1 = r1(5699), p1 = r1(6887), h1 = r1(9236);
            r1(3532).factory.push({
                test: s1.CaseLimit.test,
                constr: (t1)=>new s1.CaseLimit(t1)
            }, {
                test: i1.CaseEmbellished.test,
                constr: (t1)=>new i1.CaseEmbellished(t1)
            }, {
                test: o1.CaseDoubleScript.test,
                constr: (t1)=>new o1.CaseDoubleScript(t1)
            }, {
                test: p1.CaseTensor.test,
                constr: (t1)=>new p1.CaseTensor(t1)
            }, {
                test: l1.CaseMultiscripts.test,
                constr: (t1)=>new l1.CaseMultiscripts(t1)
            }, {
                test: a1.CaseLine.test,
                constr: (t1)=>new a1.CaseLine(t1)
            }, {
                test: n1.CaseBinomial.test,
                constr: (t1)=>new n1.CaseBinomial(t1)
            }, {
                test: c1.CaseProof.test,
                constr: (t1)=>new c1.CaseProof(t1)
            }, {
                test: u1.CaseTable.test,
                constr: (t1)=>new u1.CaseTable(t1)
            }, {
                test: h1.CaseText.test,
                constr: (t1)=>new h1.CaseText(t1)
            });
        },
        5452: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.printNodeList__ = e1.collapsePunctuated = e1.formattedOutput_ = e1.formattedOutput = e1.getInnerNode = e1.setOperatorAttribute_ = e1.createInvisibleOperator_ = e1.rewriteMfenced = e1.cloneContentNode = e1.addCollapsedAttribute = e1.parentNode_ = e1.isIgnorable_ = e1.unitChild_ = e1.descendNode_ = e1.ascendNewNode = e1.validLca_ = e1.pathToRoot_ = e1.attachedElement_ = e1.prunePath_ = e1.mathmlLca_ = e1.lcaType = e1.functionApplication_ = e1.isDescendant_ = e1.insertNewChild_ = e1.mergeChildren_ = e1.collectChildNodes_ = e1.collateChildNodes_ = e1.childrenSubset_ = e1.moveSemanticAttributes_ = e1.introduceLayerAboveLca = e1.introduceNewLayer = e1.walkTree = e1.enrich = e1.SETTINGS = void 0;
            const n1 = r1(2057), o1 = r1(5740), i1 = r1(5897), s1 = r1(3588), a1 = r1(7516), l1 = r1(5656), c1 = r1(4795), u1 = r1(2298), p1 = r1(3532);
            function h1(t1) {
                const e1 = (0, p1.getCase)(t1);
                let r1;
                if (e1) return r1 = e1.getMathml(), N1(r1);
                if (1 === t1.mathml.length) return n1.Debugger.getInstance().output("Walktree Case 0"), r1 = t1.mathml[0], u1.setAttributes(r1, t1), t1.childNodes.length && (n1.Debugger.getInstance().output("Walktree Case 0.1"), t1.childNodes.forEach(function(t1) {
                    "empty" === t1.type && r1.appendChild(h1(t1));
                })), N1(r1);
                const o1 = t1.contentNodes.map(R1);
                B1(t1, o1);
                const i1 = t1.childNodes.map(h1), s1 = l1.SemanticSkeleton.combineContentChildren(t1, o1, i1);
                if (r1 = t1.mathmlTree, null === r1) n1.Debugger.getInstance().output("Walktree Case 1"), r1 = f1(s1, t1);
                else {
                    const t1 = A1(s1);
                    n1.Debugger.getInstance().output("Walktree Case 2"), t1 ? (n1.Debugger.getInstance().output("Walktree Case 2.1"), r1 = t1.parentNode) : (n1.Debugger.getInstance().output("Walktree Case 2.2"), r1 = D1(r1));
                }
                return r1 = k1(r1), v1(r1, s1, t1), u1.setAttributes(r1, t1), N1(r1);
            }
            function f1(t1, e1) {
                const r1 = x1(t1);
                let i1 = r1.node;
                const s1 = r1.type;
                if (s1 !== M1.VALID || !c1.hasEmptyTag(i1)) {
                    if (n1.Debugger.getInstance().output("Walktree Case 1.1"), i1 = o1.createElement("mrow"), s1 === M1.PRUNED) n1.Debugger.getInstance().output("Walktree Case 1.1.0"), i1 = d1(i1, r1.node, t1);
                    else if (t1[0]) {
                        n1.Debugger.getInstance().output("Walktree Case 1.1.1");
                        const e1 = A1(t1), r1 = y1(e1.parentNode, t1);
                        o1.replaceNode(e1, i1), r1.forEach(function(t1) {
                            i1.appendChild(t1);
                        });
                    }
                }
                return e1.mathmlTree || (e1.mathmlTree = i1), i1;
            }
            function d1(t1, e1, r1) {
                let i1 = w1(e1);
                if (c1.hasMathTag(i1)) {
                    n1.Debugger.getInstance().output("Walktree Case 1.1.0.0"), m1(i1, t1), o1.toArray(i1.childNodes).forEach(function(e1) {
                        t1.appendChild(e1);
                    });
                    const e1 = t1;
                    t1 = i1, i1 = e1;
                }
                const s1 = r1.indexOf(e1);
                return r1[s1] = i1, o1.replaceNode(i1, t1), t1.appendChild(i1), r1.forEach(function(e1) {
                    t1.appendChild(e1);
                }), t1;
            }
            function m1(t1, e1) {
                for (const r1 of u1.EnrichAttributes)t1.hasAttribute(r1) && (e1.setAttribute(r1, t1.getAttribute(r1)), t1.removeAttribute(r1));
            }
            function y1(t1, e1) {
                const r1 = o1.toArray(t1.childNodes);
                let n1 = 1 / 0, i1 = -1 / 0;
                return e1.forEach(function(t1) {
                    const e1 = r1.indexOf(t1);
                    -1 !== e1 && (n1 = Math.min(n1, e1), i1 = Math.max(i1, e1));
                }), r1.slice(n1, i1 + 1);
            }
            function g1(t1, e1, r1) {
                const n1 = [];
                let i1 = o1.toArray(t1.childNodes), s1 = !1;
                for(; i1.length;){
                    const t1 = i1.shift();
                    if (t1.hasAttribute(u1.Attribute.TYPE)) {
                        n1.push(t1);
                        continue;
                    }
                    const e1 = b1(t1);
                    0 !== e1.length && (1 !== e1.length ? (s1 ? t1.setAttribute("AuxiliaryImplicit", !0) : s1 = !0, i1 = e1.concat(i1)) : n1.push(t1));
                }
                const a1 = [], l1 = r1.childNodes.map(function(t1) {
                    return t1.mathmlTree;
                });
                for(; l1.length;){
                    const t1 = l1.pop();
                    if (t1) {
                        if (-1 !== n1.indexOf(t1)) break;
                        -1 !== e1.indexOf(t1) && a1.unshift(t1);
                    }
                }
                return n1.concat(a1);
            }
            function b1(t1) {
                const e1 = [];
                let r1 = o1.toArray(t1.childNodes);
                for(; r1.length;){
                    const t1 = r1.shift();
                    t1.nodeType === o1.NodeType.ELEMENT_NODE && (t1.hasAttribute(u1.Attribute.TYPE) ? e1.push(t1) : r1 = o1.toArray(t1.childNodes).concat(r1));
                }
                return e1;
            }
            function v1(t1, e1, r1) {
                const n1 = "implicit" === r1.role && a1.flags.combine_juxtaposition ? g1(t1, e1, r1) : o1.toArray(t1.childNodes);
                if (!n1.length) return void e1.forEach(function(e1) {
                    t1.appendChild(e1);
                });
                let i1 = 0;
                for(; e1.length;){
                    const r1 = e1[0];
                    n1[i1] === r1 || O1(n1[i1], r1) ? (e1.shift(), i1++) : n1[i1] && -1 === e1.indexOf(n1[i1]) ? i1++ : (S1(r1, t1) || _1(t1, n1[i1], r1), e1.shift());
                }
            }
            function _1(t1, e1, r1) {
                if (!e1) return void t1.insertBefore(r1, null);
                let n1 = e1, o1 = P1(n1);
                for(; o1 && o1.firstChild === n1 && !n1.hasAttribute("AuxiliaryImplicit") && o1 !== t1;)n1 = o1, o1 = P1(n1);
                o1 && (o1.insertBefore(r1, n1), n1.removeAttribute("AuxiliaryImplicit"));
            }
            function S1(t1, e1) {
                if (!t1) return !1;
                do {
                    if ((t1 = t1.parentNode) === e1) return !0;
                }while (t1);
                return !1;
            }
            function O1(t1, e1) {
                const r1 = s1.functionApplication();
                if (t1 && e1 && t1.textContent && e1.textContent && t1.textContent === r1 && e1.textContent === r1 && "true" === e1.getAttribute(u1.Attribute.ADDED)) {
                    for(let r1, n1 = 0; r1 = t1.attributes[n1]; n1++)e1.hasAttribute(r1.nodeName) || e1.setAttribute(r1.nodeName, r1.nodeValue);
                    return o1.replaceNode(t1, e1), !0;
                }
                return !1;
            }
            var M1;
            function x1(t1) {
                const e1 = A1(t1);
                if (!e1) return {
                    type: M1.INVALID,
                    node: null
                };
                const r1 = A1(t1.slice().reverse());
                if (e1 === r1) return {
                    type: M1.VALID,
                    node: e1
                };
                const n1 = C1(e1), o1 = E1(n1, t1), i1 = C1(r1, function(t1) {
                    return -1 !== o1.indexOf(t1);
                }), s1 = i1[0], a1 = o1.indexOf(s1);
                return -1 === a1 ? {
                    type: M1.INVALID,
                    node: null
                } : {
                    type: o1.length !== n1.length ? M1.PRUNED : T1(o1[a1 + 1], i1[1]) ? M1.VALID : M1.INVALID,
                    node: s1
                };
            }
            function E1(t1, e1) {
                let r1 = 0;
                for(; t1[r1] && -1 === e1.indexOf(t1[r1]);)r1++;
                return t1.slice(0, r1 + 1);
            }
            function A1(t1) {
                let e1 = 0, r1 = null;
                for(; !r1 && e1 < t1.length;)t1[e1].parentNode && (r1 = t1[e1]), e1++;
                return r1;
            }
            function C1(t1, e1) {
                const r1 = e1 || ((t1)=>!1), n1 = [
                    t1
                ];
                for(; !r1(t1) && !c1.hasMathTag(t1) && t1.parentNode;)t1 = P1(t1), n1.unshift(t1);
                return n1;
            }
            function T1(t1, e1) {
                return !(!t1 || !e1 || t1.previousSibling || e1.nextSibling);
            }
            function N1(t1) {
                for(; !c1.hasMathTag(t1) && L1(t1);)t1 = P1(t1);
                return t1;
            }
            function w1(t1) {
                const e1 = o1.toArray(t1.childNodes);
                if (!e1) return t1;
                const r1 = e1.filter(function(t1) {
                    return t1.nodeType === o1.NodeType.ELEMENT_NODE && !c1.hasIgnoreTag(t1);
                });
                return 1 === r1.length && c1.hasEmptyTag(r1[0]) && !r1[0].hasAttribute(u1.Attribute.TYPE) ? w1(r1[0]) : t1;
            }
            function L1(t1) {
                const e1 = P1(t1);
                return !(!e1 || !c1.hasEmptyTag(e1)) && o1.toArray(e1.childNodes).every(function(e1) {
                    return e1 === t1 || I1(e1);
                });
            }
            function I1(t1) {
                if (t1.nodeType !== o1.NodeType.ELEMENT_NODE) return !0;
                if (!t1 || c1.hasIgnoreTag(t1)) return !0;
                const e1 = o1.toArray(t1.childNodes);
                return !(!c1.hasEmptyTag(t1) && e1.length || c1.hasDisplayTag(t1) || t1.hasAttribute(u1.Attribute.TYPE) || c1.isOrphanedGlyph(t1)) && o1.toArray(t1.childNodes).every(I1);
            }
            function P1(t1) {
                return t1.parentNode;
            }
            function R1(t1) {
                if (t1.mathml.length) return h1(t1);
                const r1 = e1.SETTINGS.implicit ? j1(t1) : o1.createElement("mrow");
                return t1.mathml = [
                    r1
                ], r1;
            }
            function k1(t1) {
                if ("MFENCED" !== o1.tagName(t1)) return t1;
                const e1 = o1.createElement("mrow");
                for(let r1, n1 = 0; r1 = t1.attributes[n1]; n1++)-1 === [
                    "open",
                    "close",
                    "separators"
                ].indexOf(r1.name) && e1.setAttribute(r1.name, r1.value);
                return o1.toArray(t1.childNodes).forEach(function(t1) {
                    e1.appendChild(t1);
                }), o1.replaceNode(t1, e1), e1;
            }
            function j1(t1) {
                const e1 = o1.createElement("mo"), r1 = o1.createTextNode(t1.textContent);
                return e1.appendChild(r1), u1.setAttributes(e1, t1), e1.setAttribute(u1.Attribute.ADDED, "true"), e1;
            }
            function B1(t1, e1) {
                const r1 = t1.type + (t1.textContent ? "," + t1.textContent : "");
                e1.forEach(function(t1) {
                    D1(t1).setAttribute(u1.Attribute.OPERATOR, r1);
                });
            }
            function D1(t1) {
                const e1 = o1.toArray(t1.childNodes);
                if (!e1) return t1;
                const r1 = e1.filter(function(t1) {
                    return !I1(t1);
                }), n1 = [];
                for(let t1, e1 = 0; t1 = r1[e1]; e1++)if (c1.hasEmptyTag(t1)) {
                    const e1 = D1(t1);
                    e1 && e1 !== t1 && n1.push(e1);
                } else n1.push(t1);
                return 1 === n1.length ? n1[0] : t1;
            }
            function F1(t1, e1, r1, n1) {
                const o1 = n1 || !1;
                H1(t1, "Original MathML", o1), H1(r1, "Semantic Tree", o1), H1(e1, "Semantically enriched MathML", o1);
            }
            function H1(t1, e1, r1) {
                const n1 = o1.formatXml(t1.toString());
                r1 ? console.info(e1 + ":\n```html\n" + u1.removeAttributePrefix(n1) + "\n```\n") : console.info(n1);
            }
            e1.SETTINGS = {
                collapsed: !0,
                implicit: !0
            }, e1.enrich = function(t1, e1) {
                const r1 = o1.cloneNode(t1);
                return h1(e1.root), i1.default.getInstance().structure && t1.setAttribute(u1.Attribute.STRUCTURE, l1.SemanticSkeleton.fromStructure(t1, e1).toString()), n1.Debugger.getInstance().generateOutput(function() {
                    return F1(r1, t1, e1, !0), [];
                }), t1;
            }, e1.walkTree = h1, e1.introduceNewLayer = f1, e1.introduceLayerAboveLca = d1, e1.moveSemanticAttributes_ = m1, e1.childrenSubset_ = y1, e1.collateChildNodes_ = g1, e1.collectChildNodes_ = b1, e1.mergeChildren_ = v1, e1.insertNewChild_ = _1, e1.isDescendant_ = S1, e1.functionApplication_ = O1, function(t1) {
                t1.VALID = "valid", t1.INVALID = "invalid", t1.PRUNED = "pruned";
            }(M1 = e1.lcaType || (e1.lcaType = {})), e1.mathmlLca_ = x1, e1.prunePath_ = E1, e1.attachedElement_ = A1, e1.pathToRoot_ = C1, e1.validLca_ = T1, e1.ascendNewNode = N1, e1.descendNode_ = w1, e1.unitChild_ = L1, e1.isIgnorable_ = I1, e1.parentNode_ = P1, e1.addCollapsedAttribute = function(t1, e1) {
                const r1 = new l1.SemanticSkeleton(e1);
                t1.setAttribute(u1.Attribute.COLLAPSED, r1.toString());
            }, e1.cloneContentNode = R1, e1.rewriteMfenced = k1, e1.createInvisibleOperator_ = j1, e1.setOperatorAttribute_ = B1, e1.getInnerNode = D1, e1.formattedOutput = F1, e1.formattedOutput_ = H1, e1.collapsePunctuated = function(t1, e1) {
                const r1 = !!e1, n1 = e1 || [], o1 = t1.parent, i1 = t1.contentNodes.map(function(t1) {
                    return t1.id;
                });
                i1.unshift("c");
                const s1 = [
                    t1.id,
                    i1
                ];
                for(let e1, i1 = 0; e1 = t1.childNodes[i1]; i1++){
                    const t1 = h1(e1);
                    n1.push(t1);
                    const i1 = D1(t1);
                    o1 && !r1 && i1.setAttribute(u1.Attribute.PARENT, o1.id.toString()), s1.push(e1.id);
                }
                return s1;
            }, e1.printNodeList__ = function(t1, e1) {
                console.info(t1), o1.toArray(e1).forEach(function(t1) {
                    console.info(t1.toString());
                }), console.info("<<<<<<<<<<<<<<<<<");
            };
        },
        5105: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractHighlighter = void 0;
            const n1 = r1(5274), o1 = r1(2298);
            class i1 {
                constructor(){
                    this.color = null, this.mactionName = "", this.currentHighlights = [];
                }
                highlight(t1) {
                    this.currentHighlights.push(t1.map((t1)=>{
                        const e1 = this.highlightNode(t1);
                        return this.setHighlighted(t1), e1;
                    }));
                }
                highlightAll(t1) {
                    const e1 = this.getMactionNodes(t1);
                    for(let t1, r1 = 0; t1 = e1[r1]; r1++)this.highlight([
                        t1
                    ]);
                }
                unhighlight() {
                    const t1 = this.currentHighlights.pop();
                    t1 && t1.forEach((t1)=>{
                        this.isHighlighted(t1.node) && (this.unhighlightNode(t1), this.unsetHighlighted(t1.node));
                    });
                }
                unhighlightAll() {
                    for(; this.currentHighlights.length > 0;)this.unhighlight();
                }
                setColor(t1) {
                    this.color = t1;
                }
                colorString() {
                    return this.color.rgba();
                }
                addEvents(t1, e1) {
                    const r1 = this.getMactionNodes(t1);
                    for(let t1, n1 = 0; t1 = r1[n1]; n1++)for(const r1 in e1)t1.addEventListener(r1, e1[r1]);
                }
                getMactionNodes(t1) {
                    return Array.from(t1.getElementsByClassName(this.mactionName));
                }
                isMactionNode(t1) {
                    const e1 = t1.className || t1.getAttribute("class");
                    return !!e1 && !!e1.match(new RegExp(this.mactionName));
                }
                isHighlighted(t1) {
                    return t1.hasAttribute(i1.ATTR);
                }
                setHighlighted(t1) {
                    t1.setAttribute(i1.ATTR, "true");
                }
                unsetHighlighted(t1) {
                    t1.removeAttribute(i1.ATTR);
                }
                colorizeAll(t1) {
                    n1.evalXPath(`.//*[@${o1.Attribute.ID}]`, t1).forEach((t1)=>this.colorize(t1));
                }
                uncolorizeAll(t1) {
                    n1.evalXPath(`.//*[@${o1.Attribute.ID}]`, t1).forEach((t1)=>this.uncolorize(t1));
                }
                colorize(t1) {
                    const e1 = (0, o1.addPrefix)("foreground");
                    t1.hasAttribute(e1) && (t1.setAttribute(e1 + "-old", t1.style.color), t1.style.color = t1.getAttribute(e1));
                }
                uncolorize(t1) {
                    const e1 = (0, o1.addPrefix)("foreground") + "-old";
                    t1.hasAttribute(e1) && (t1.style.color = t1.getAttribute(e1));
                }
            }
            e1.AbstractHighlighter = i1, i1.ATTR = "sre-highlight";
        },
        6937: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ChtmlHighlighter = void 0;
            const n1 = r1(933);
            class o1 extends n1.CssHighlighter {
                constructor(){
                    super();
                }
                isMactionNode(t1) {
                    return t1.tagName.toUpperCase() === this.mactionName.toUpperCase();
                }
                getMactionNodes(t1) {
                    return Array.from(t1.getElementsByTagName(this.mactionName));
                }
            }
            e1.ChtmlHighlighter = o1;
        },
        8396: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ContrastPicker = e1.ColorPicker = void 0;
            const r1 = {
                red: {
                    red: 255,
                    green: 0,
                    blue: 0
                },
                green: {
                    red: 0,
                    green: 255,
                    blue: 0
                },
                blue: {
                    red: 0,
                    green: 0,
                    blue: 255
                },
                yellow: {
                    red: 255,
                    green: 255,
                    blue: 0
                },
                cyan: {
                    red: 0,
                    green: 255,
                    blue: 255
                },
                magenta: {
                    red: 255,
                    green: 0,
                    blue: 255
                },
                white: {
                    red: 255,
                    green: 255,
                    blue: 255
                },
                black: {
                    red: 0,
                    green: 0,
                    blue: 0
                }
            };
            function n1(t1, e1) {
                const n1 = t1 || {
                    color: e1
                };
                let o1 = Object.prototype.hasOwnProperty.call(n1, "color") ? r1[n1.color] : n1;
                return o1 || (o1 = r1[e1]), o1.alpha = Object.prototype.hasOwnProperty.call(n1, "alpha") ? n1.alpha : 1, function(t1) {
                    const e1 = (t1)=>(t1 = Math.max(t1, 0), t1 = Math.min(255, t1), Math.round(t1));
                    return t1.red = e1(t1.red), t1.green = e1(t1.green), t1.blue = e1(t1.blue), t1.alpha = Math.max(t1.alpha, 0), t1.alpha = Math.min(1, t1.alpha), t1;
                }(o1);
            }
            class o1 {
                constructor(t1, e1){
                    this.foreground = n1(e1, o1.DEFAULT_FOREGROUND_), this.background = n1(t1, o1.DEFAULT_BACKGROUND_);
                }
                static toHex(t1) {
                    const e1 = t1.toString(16);
                    return 1 === e1.length ? "0" + e1 : e1;
                }
                rgba() {
                    const t1 = function(t1) {
                        return "rgba(" + t1.red + "," + t1.green + "," + t1.blue + "," + t1.alpha + ")";
                    };
                    return {
                        background: t1(this.background),
                        foreground: t1(this.foreground)
                    };
                }
                rgb() {
                    const t1 = function(t1) {
                        return "rgb(" + t1.red + "," + t1.green + "," + t1.blue + ")";
                    };
                    return {
                        background: t1(this.background),
                        alphaback: this.background.alpha.toString(),
                        foreground: t1(this.foreground),
                        alphafore: this.foreground.alpha.toString()
                    };
                }
                hex() {
                    const t1 = function(t1) {
                        return "#" + o1.toHex(t1.red) + o1.toHex(t1.green) + o1.toHex(t1.blue);
                    };
                    return {
                        background: t1(this.background),
                        alphaback: this.background.alpha.toString(),
                        foreground: t1(this.foreground),
                        alphafore: this.foreground.alpha.toString()
                    };
                }
            }
            e1.ColorPicker = o1, o1.DEFAULT_BACKGROUND_ = "blue", o1.DEFAULT_FOREGROUND_ = "black";
            e1.ContrastPicker = class {
                constructor(){
                    this.hue = 10, this.sat = 100, this.light = 50, this.incr = 50;
                }
                generate() {
                    var t1, e1;
                    return e1 = function(t1, e1, r1) {
                        e1 = e1 > 1 ? e1 / 100 : e1, r1 = r1 > 1 ? r1 / 100 : r1;
                        const n1 = (1 - Math.abs(2 * r1 - 1)) * e1, o1 = n1 * (1 - Math.abs(t1 / 60 % 2 - 1)), i1 = r1 - n1 / 2;
                        let s1 = 0, a1 = 0, l1 = 0;
                        return 0 <= t1 && t1 < 60 ? [s1, a1, l1] = [
                            n1,
                            o1,
                            0
                        ] : 60 <= t1 && t1 < 120 ? [s1, a1, l1] = [
                            o1,
                            n1,
                            0
                        ] : 120 <= t1 && t1 < 180 ? [s1, a1, l1] = [
                            0,
                            n1,
                            o1
                        ] : 180 <= t1 && t1 < 240 ? [s1, a1, l1] = [
                            0,
                            o1,
                            n1
                        ] : 240 <= t1 && t1 < 300 ? [s1, a1, l1] = [
                            o1,
                            0,
                            n1
                        ] : 300 <= t1 && t1 < 360 && ([s1, a1, l1] = [
                            n1,
                            0,
                            o1
                        ]), {
                            red: s1 + i1,
                            green: a1 + i1,
                            blue: l1 + i1
                        };
                    }(this.hue, this.sat, this.light), "rgb(" + (t1 = {
                        red: Math.round(255 * e1.red),
                        green: Math.round(255 * e1.green),
                        blue: Math.round(255 * e1.blue)
                    }).red + "," + t1.green + "," + t1.blue + ")";
                }
                increment() {
                    this.hue = (this.hue + this.incr) % 360;
                }
            };
        },
        933: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CssHighlighter = void 0;
            const n1 = r1(5105);
            class o1 extends n1.AbstractHighlighter {
                constructor(){
                    super(), this.mactionName = "mjx-maction";
                }
                highlightNode(t1) {
                    const e1 = {
                        node: t1,
                        background: t1.style.backgroundColor,
                        foreground: t1.style.color
                    }, r1 = this.colorString();
                    return t1.style.backgroundColor = r1.background, t1.style.color = r1.foreground, e1;
                }
                unhighlightNode(t1) {
                    t1.node.style.backgroundColor = t1.background, t1.node.style.color = t1.foreground;
                }
            }
            e1.CssHighlighter = o1;
        },
        3090: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.highlighterMapping_ = e1.addEvents = e1.highlighter = void 0;
            const n1 = r1(6937), o1 = r1(8396), i1 = r1(933), s1 = r1(2598), a1 = r1(4500), l1 = r1(7071), c1 = r1(4346), u1 = r1(2222);
            e1.highlighter = function(t1, r1, n1) {
                const i1 = new o1.ColorPicker(t1, r1), s1 = "NativeMML" === n1.renderer && "Safari" === n1.browser ? "MML-CSS" : "SVG" === n1.renderer && "v3" === n1.browser ? "SVG-V3" : n1.renderer, a1 = new (e1.highlighterMapping_[s1] || e1.highlighterMapping_.NativeMML);
                return a1.setColor(i1), a1;
            }, e1.addEvents = function(t1, r1, n1) {
                const o1 = e1.highlighterMapping_[n1.renderer];
                o1 && (new o1).addEvents(t1, r1);
            }, e1.highlighterMapping_ = {
                SVG: c1.SvgHighlighter,
                "SVG-V3": u1.SvgV3Highlighter,
                NativeMML: l1.MmlHighlighter,
                "HTML-CSS": s1.HtmlHighlighter,
                "MML-CSS": a1.MmlCssHighlighter,
                CommonHTML: i1.CssHighlighter,
                CHTML: n1.ChtmlHighlighter
            };
        },
        2598: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.HtmlHighlighter = void 0;
            const n1 = r1(5740), o1 = r1(5105);
            class i1 extends o1.AbstractHighlighter {
                constructor(){
                    super(), this.mactionName = "maction";
                }
                highlightNode(t1) {
                    const e1 = {
                        node: t1,
                        foreground: t1.style.color,
                        position: t1.style.position
                    }, r1 = this.color.rgb();
                    t1.style.color = r1.foreground, t1.style.position = "relative";
                    const o1 = t1.bbox;
                    if (o1 && o1.w) {
                        const i1 = .05, s1 = 0, a1 = n1.createElement("span"), l1 = parseFloat(t1.style.paddingLeft || "0");
                        a1.style.backgroundColor = r1.background, a1.style.opacity = r1.alphaback.toString(), a1.style.display = "inline-block", a1.style.height = o1.h + o1.d + 2 * i1 + "em", a1.style.verticalAlign = -o1.d + "em", a1.style.marginTop = a1.style.marginBottom = -i1 + "em", a1.style.width = o1.w + 2 * s1 + "em", a1.style.marginLeft = l1 - s1 + "em", a1.style.marginRight = -o1.w - s1 - l1 + "em", t1.parentNode.insertBefore(a1, t1), e1.box = a1;
                    }
                    return e1;
                }
                unhighlightNode(t1) {
                    const e1 = t1.node;
                    e1.style.color = t1.foreground, e1.style.position = t1.position, t1.box && t1.box.parentNode.removeChild(t1.box);
                }
            }
            e1.HtmlHighlighter = i1;
        },
        4500: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlCssHighlighter = void 0;
            const n1 = r1(933);
            class o1 extends n1.CssHighlighter {
                constructor(){
                    super(), this.mactionName = "maction";
                }
                getMactionNodes(t1) {
                    return Array.from(t1.getElementsByTagName(this.mactionName));
                }
                isMactionNode(t1) {
                    return t1.tagName === this.mactionName;
                }
            }
            e1.MmlCssHighlighter = o1;
        },
        7071: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MmlHighlighter = void 0;
            const n1 = r1(5105);
            class o1 extends n1.AbstractHighlighter {
                constructor(){
                    super(), this.mactionName = "maction";
                }
                highlightNode(t1) {
                    let e1 = t1.getAttribute("style");
                    return e1 += ";background-color: " + this.colorString().background, e1 += ";color: " + this.colorString().foreground, t1.setAttribute("style", e1), {
                        node: t1
                    };
                }
                unhighlightNode(t1) {
                    let e1 = t1.node.getAttribute("style");
                    e1 = e1.replace(";background-color: " + this.colorString().background, ""), e1 = e1.replace(";color: " + this.colorString().foreground, ""), t1.node.setAttribute("style", e1);
                }
                colorString() {
                    return this.color.rgba();
                }
                getMactionNodes(t1) {
                    return Array.from(t1.getElementsByTagName(this.mactionName));
                }
                isMactionNode(t1) {
                    return t1.tagName === this.mactionName;
                }
            }
            e1.MmlHighlighter = o1;
        },
        4346: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SvgHighlighter = void 0;
            const n1 = r1(5740), o1 = r1(5105);
            class i1 extends o1.AbstractHighlighter {
                constructor(){
                    super(), this.mactionName = "mjx-svg-maction";
                }
                highlightNode(t1) {
                    let e1;
                    if (this.isHighlighted(t1)) return e1 = {
                        node: t1.previousSibling || t1,
                        background: t1.style.backgroundColor,
                        foreground: t1.style.color
                    }, e1;
                    if ("svg" === t1.tagName) {
                        const e1 = {
                            node: t1,
                            background: t1.style.backgroundColor,
                            foreground: t1.style.color
                        };
                        return t1.style.backgroundColor = this.colorString().background, t1.style.color = this.colorString().foreground, e1;
                    }
                    const r1 = n1.createElementNS("http://www.w3.org/2000/svg", "rect");
                    let i1;
                    if ("use" === t1.nodeName) {
                        const e1 = n1.createElementNS("http://www.w3.org/2000/svg", "g");
                        t1.parentNode.insertBefore(e1, t1), e1.appendChild(t1), i1 = e1.getBBox(), e1.parentNode.replaceChild(t1, e1);
                    } else i1 = t1.getBBox();
                    r1.setAttribute("x", (i1.x - 40).toString()), r1.setAttribute("y", (i1.y - 40).toString()), r1.setAttribute("width", (i1.width + 80).toString()), r1.setAttribute("height", (i1.height + 80).toString());
                    const s1 = t1.getAttribute("transform");
                    return s1 && r1.setAttribute("transform", s1), r1.setAttribute("fill", this.colorString().background), r1.setAttribute(o1.AbstractHighlighter.ATTR, "true"), t1.parentNode.insertBefore(r1, t1), e1 = {
                        node: r1,
                        foreground: t1.getAttribute("fill")
                    }, t1.setAttribute("fill", this.colorString().foreground), e1;
                }
                setHighlighted(t1) {
                    "svg" === t1.tagName && super.setHighlighted(t1);
                }
                unhighlightNode(t1) {
                    if ("background" in t1) return t1.node.style.backgroundColor = t1.background, void (t1.node.style.color = t1.foreground);
                    t1.foreground ? t1.node.nextSibling.setAttribute("fill", t1.foreground) : t1.node.nextSibling.removeAttribute("fill"), t1.node.parentNode.removeChild(t1.node);
                }
                isMactionNode(t1) {
                    let e1 = t1.className || t1.getAttribute("class");
                    return e1 = void 0 !== e1.baseVal ? e1.baseVal : e1, !!e1 && !!e1.match(new RegExp(this.mactionName));
                }
            }
            e1.SvgHighlighter = i1;
        },
        2222: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SvgV3Highlighter = void 0;
            const n1 = r1(5740), o1 = r1(5274), i1 = r1(5105), s1 = r1(8396), a1 = r1(4346);
            class l1 extends a1.SvgHighlighter {
                constructor(){
                    super(), this.mactionName = "maction";
                }
                highlightNode(t1) {
                    let e1;
                    if (this.isHighlighted(t1)) return e1 = {
                        node: t1,
                        background: this.colorString().background,
                        foreground: this.colorString().foreground
                    }, e1;
                    if ("svg" === t1.tagName || "MJX-CONTAINER" === t1.tagName) return e1 = {
                        node: t1,
                        background: t1.style.backgroundColor,
                        foreground: t1.style.color
                    }, t1.style.backgroundColor = this.colorString().background, t1.style.color = this.colorString().foreground, e1;
                    const r1 = n1.createElementNS("http://www.w3.org/2000/svg", "rect");
                    r1.setAttribute("sre-highlighter-added", "true");
                    const o1 = t1.getBBox();
                    r1.setAttribute("x", (o1.x - 40).toString()), r1.setAttribute("y", (o1.y - 40).toString()), r1.setAttribute("width", (o1.width + 80).toString()), r1.setAttribute("height", (o1.height + 80).toString());
                    const a1 = t1.getAttribute("transform");
                    if (a1 && r1.setAttribute("transform", a1), r1.setAttribute("fill", this.colorString().background), t1.setAttribute(i1.AbstractHighlighter.ATTR, "true"), t1.parentNode.insertBefore(r1, t1), e1 = {
                        node: t1,
                        foreground: t1.getAttribute("fill")
                    }, "rect" === t1.nodeName) {
                        const e1 = new s1.ColorPicker({
                            alpha: 0,
                            color: "black"
                        });
                        t1.setAttribute("fill", e1.rgba().foreground);
                    } else t1.setAttribute("fill", this.colorString().foreground);
                    return e1;
                }
                unhighlightNode(t1) {
                    const e1 = t1.node.previousSibling;
                    if (e1 && e1.hasAttribute("sre-highlighter-added")) return t1.foreground ? t1.node.setAttribute("fill", t1.foreground) : t1.node.removeAttribute("fill"), void t1.node.parentNode.removeChild(e1);
                    t1.node.style.backgroundColor = t1.background, t1.node.style.color = t1.foreground;
                }
                isMactionNode(t1) {
                    return t1.getAttribute("data-mml-node") === this.mactionName;
                }
                getMactionNodes(t1) {
                    return Array.from(o1.evalXPath(`.//*[@data-mml-node="${this.mactionName}"]`, t1));
                }
            }
            e1.SvgV3Highlighter = l1;
        },
        7222: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.StaticTrieNode = e1.AbstractTrieNode = void 0;
            const n1 = r1(2057), o1 = r1(4391);
            class i1 {
                constructor(t1, e1){
                    this.constraint = t1, this.test = e1, this.children_ = {}, this.kind = o1.TrieNodeKind.ROOT;
                }
                getConstraint() {
                    return this.constraint;
                }
                getKind() {
                    return this.kind;
                }
                applyTest(t1) {
                    return this.test(t1);
                }
                addChild(t1) {
                    const e1 = t1.getConstraint(), r1 = this.children_[e1];
                    return this.children_[e1] = t1, r1;
                }
                getChild(t1) {
                    return this.children_[t1];
                }
                getChildren() {
                    const t1 = [];
                    for(const e1 in this.children_)t1.push(this.children_[e1]);
                    return t1;
                }
                findChildren(t1) {
                    const e1 = [];
                    for(const r1 in this.children_){
                        const n1 = this.children_[r1];
                        n1.applyTest(t1) && e1.push(n1);
                    }
                    return e1;
                }
                removeChild(t1) {
                    delete this.children_[t1];
                }
                toString() {
                    return this.constraint;
                }
            }
            e1.AbstractTrieNode = i1;
            e1.StaticTrieNode = class extends i1 {
                constructor(t1, e1){
                    super(t1, e1), this.rule_ = null, this.kind = o1.TrieNodeKind.STATIC;
                }
                getRule() {
                    return this.rule_;
                }
                setRule(t1) {
                    this.rule_ && n1.Debugger.getInstance().output("Replacing rule " + this.rule_ + " with " + t1), this.rule_ = t1;
                }
                toString() {
                    return this.getRule() ? this.constraint + "\n==> " + this.getRule().action : this.constraint;
                }
            };
        },
        4508: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Trie = void 0;
            const n1 = r1(4391), o1 = r1(9701);
            class i1 {
                constructor(){
                    this.root = (0, o1.getNode)(n1.TrieNodeKind.ROOT, "", null);
                }
                static collectRules_(t1) {
                    const e1 = [];
                    let r1 = [
                        t1
                    ];
                    for(; r1.length;){
                        const t1 = r1.shift();
                        if (t1.getKind() === n1.TrieNodeKind.QUERY || t1.getKind() === n1.TrieNodeKind.BOOLEAN) {
                            const r1 = t1.getRule();
                            r1 && e1.unshift(r1);
                        }
                        r1 = r1.concat(t1.getChildren());
                    }
                    return e1;
                }
                static printWithDepth_(t1, e1, r1) {
                    r1 += new Array(e1 + 2).join(e1.toString()) + ": " + t1.toString() + "\n";
                    const n1 = t1.getChildren();
                    for(let t1, o1 = 0; t1 = n1[o1]; o1++)r1 = i1.printWithDepth_(t1, e1 + 1, r1);
                    return r1;
                }
                static order_(t1) {
                    const e1 = t1.getChildren();
                    if (!e1.length) return 0;
                    const r1 = Math.max.apply(null, e1.map(i1.order_));
                    return Math.max(e1.length, r1);
                }
                addRule(t1) {
                    let e1 = this.root;
                    const r1 = t1.context, o1 = t1.dynamicCstr.getValues();
                    for(let t1 = 0, i1 = o1.length; t1 < i1; t1++)e1 = this.addNode_(e1, o1[t1], n1.TrieNodeKind.DYNAMIC, r1);
                    e1 = this.addNode_(e1, t1.precondition.query, n1.TrieNodeKind.QUERY, r1);
                    const i1 = t1.precondition.constraints;
                    for(let t1 = 0, o1 = i1.length; t1 < o1; t1++)e1 = this.addNode_(e1, i1[t1], n1.TrieNodeKind.BOOLEAN, r1);
                    e1.setRule(t1);
                }
                lookupRules(t1, e1) {
                    let r1 = [
                        this.root
                    ];
                    const o1 = [];
                    for(; e1.length;){
                        const t1 = e1.shift(), o1 = [];
                        for(; r1.length;)r1.shift().getChildren().forEach((e1)=>{
                            e1.getKind() === n1.TrieNodeKind.DYNAMIC && -1 === t1.indexOf(e1.getConstraint()) || o1.push(e1);
                        });
                        r1 = o1.slice();
                    }
                    for(; r1.length;){
                        const e1 = r1.shift();
                        if (e1.getRule) {
                            const t1 = e1.getRule();
                            t1 && o1.push(t1);
                        }
                        const n1 = e1.findChildren(t1);
                        r1 = r1.concat(n1);
                    }
                    return o1;
                }
                hasSubtrie(t1) {
                    let e1 = this.root;
                    for(let r1 = 0, n1 = t1.length; r1 < n1; r1++){
                        const n1 = t1[r1];
                        if (e1 = e1.getChild(n1), !e1) return !1;
                    }
                    return !0;
                }
                toString() {
                    return i1.printWithDepth_(this.root, 0, "");
                }
                collectRules() {
                    return i1.collectRules_(this.root);
                }
                order() {
                    return i1.order_(this.root);
                }
                enumerate(t1) {
                    return this.enumerate_(this.root, t1);
                }
                byConstraint(t1) {
                    let e1 = this.root;
                    for(; t1.length && e1;){
                        const r1 = t1.shift();
                        e1 = e1.getChild(r1);
                    }
                    return e1 || null;
                }
                enumerate_(t1, e1) {
                    e1 = e1 || {};
                    const r1 = t1.getChildren();
                    for(let t1, o1 = 0; t1 = r1[o1]; o1++)t1.kind === n1.TrieNodeKind.DYNAMIC && (e1[t1.getConstraint()] = this.enumerate_(t1, e1[t1.getConstraint()]));
                    return e1;
                }
                addNode_(t1, e1, r1, n1) {
                    let i1 = t1.getChild(e1);
                    return i1 || (i1 = (0, o1.getNode)(r1, e1, n1), t1.addChild(i1)), i1;
                }
            }
            e1.Trie = i1;
        },
        4391: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TrieNodeKind = void 0, function(t1) {
                t1.ROOT = "root", t1.DYNAMIC = "dynamic", t1.QUERY = "query", t1.BOOLEAN = "boolean", t1.STATIC = "static";
            }(e1.TrieNodeKind || (e1.TrieNodeKind = {}));
        },
        9701: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BooleanTrieNode = e1.QueryTrieNode = e1.constraintTest_ = e1.DynamicTrieNode = e1.RootTrieNode = e1.getNode = void 0;
            const n1 = r1(5740), o1 = r1(5274), i1 = r1(2105), s1 = r1(2780), a1 = r1(7222), l1 = r1(7222), c1 = r1(4391);
            e1.getNode = function(t1, e1, r1) {
                switch(t1){
                    case c1.TrieNodeKind.ROOT:
                        return new u1;
                    case c1.TrieNodeKind.DYNAMIC:
                        return new p1(e1);
                    case c1.TrieNodeKind.QUERY:
                        return new d1(e1, r1);
                    case c1.TrieNodeKind.BOOLEAN:
                        return new m1(e1, r1);
                    default:
                        return null;
                }
            };
            class u1 extends a1.AbstractTrieNode {
                constructor(){
                    super("", ()=>!0), this.kind = c1.TrieNodeKind.ROOT;
                }
            }
            e1.RootTrieNode = u1;
            class p1 extends a1.AbstractTrieNode {
                constructor(t1){
                    super(t1, (e1)=>e1 === t1), this.kind = c1.TrieNodeKind.DYNAMIC;
                }
            }
            e1.DynamicTrieNode = p1;
            const h1 = {
                "=": (t1, e1)=>t1 === e1,
                "!=": (t1, e1)=>t1 !== e1,
                "<": (t1, e1)=>t1 < e1,
                ">": (t1, e1)=>t1 > e1,
                "<=": (t1, e1)=>t1 <= e1,
                ">=": (t1, e1)=>t1 >= e1
            };
            function f1(t1) {
                if (t1.match(/^self::\*$/)) return (t1)=>!0;
                if (t1.match(/^self::\w+$/)) {
                    const e1 = t1.slice(6).toUpperCase();
                    return (t1)=>t1.tagName && n1.tagName(t1) === e1;
                }
                if (t1.match(/^self::\w+:\w+$/)) {
                    const e1 = t1.split(":"), r1 = o1.resolveNameSpace(e1[2]);
                    if (!r1) return null;
                    const n1 = e1[3].toUpperCase();
                    return (t1)=>t1.localName && t1.localName.toUpperCase() === n1 && t1.namespaceURI === r1;
                }
                if (t1.match(/^@\w+$/)) {
                    const e1 = t1.slice(1);
                    return (t1)=>t1.hasAttribute && t1.hasAttribute(e1);
                }
                if (t1.match(/^@\w+="[\w\d ]+"$/)) {
                    const e1 = t1.split("="), r1 = e1[0].slice(1), n1 = e1[1].slice(1, -1);
                    return (t1)=>t1.hasAttribute && t1.hasAttribute(r1) && t1.getAttribute(r1) === n1;
                }
                if (t1.match(/^@\w+!="[\w\d ]+"$/)) {
                    const e1 = t1.split("!="), r1 = e1[0].slice(1), n1 = e1[1].slice(1, -1);
                    return (t1)=>!t1.hasAttribute || !t1.hasAttribute(r1) || t1.getAttribute(r1) !== n1;
                }
                if (t1.match(/^contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)$/)) {
                    const e1 = t1.split('"')[1];
                    return (t1)=>!!i1.Grammar.getInstance().getParameter(e1);
                }
                if (t1.match(/^not\(\s*contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)\s*\)$/)) {
                    const e1 = t1.split('"')[1];
                    return (t1)=>!i1.Grammar.getInstance().getParameter(e1);
                }
                if (t1.match(/^name\(\.\.\/\.\.\)="\w+"$/)) {
                    const e1 = t1.split('"')[1].toUpperCase();
                    return (t1)=>{
                        var r1, o1;
                        return (null === (o1 = null === (r1 = t1.parentNode) || void 0 === r1 ? void 0 : r1.parentNode) || void 0 === o1 ? void 0 : o1.tagName) && n1.tagName(t1.parentNode.parentNode) === e1;
                    };
                }
                if (t1.match(/^count\(preceding-sibling::\*\)=\d+$/)) {
                    const e1 = t1.split("="), r1 = parseInt(e1[1], 10);
                    return (t1)=>{
                        var e1;
                        return (null === (e1 = t1.parentNode) || void 0 === e1 ? void 0 : e1.childNodes[r1]) === t1;
                    };
                }
                if (t1.match(/^.+\[@category!?=".+"\]$/)) {
                    let [, e1, r1, n1] = t1.match(/^(.+)\[@category(!?=)"(.+)"\]$/);
                    const i1 = n1.match(/^unit:(.+)$/);
                    let a1 = "";
                    return i1 && (n1 = i1[1], a1 = ":unit"), (t1)=>{
                        const i1 = o1.evalXPath(e1, t1)[0];
                        if (i1) {
                            const t1 = s1.lookupCategory(i1.textContent + a1);
                            return "=" === r1 ? t1 === n1 : t1 !== n1;
                        }
                        return !1;
                    };
                }
                if (t1.match(/^string-length\(.+\)\W+\d+/)) {
                    const [, e1, r1, n1] = t1.match(/^string-length\((.+)\)(\W+)(\d+)/), i1 = h1[r1] || h1["="], s1 = parseInt(n1, 10);
                    return (t1)=>{
                        const r1 = o1.evalXPath(e1, t1)[0];
                        return !!r1 && i1(Array.from(r1.textContent).length, s1);
                    };
                }
                return null;
            }
            e1.constraintTest_ = f1;
            class d1 extends l1.StaticTrieNode {
                constructor(t1, e1){
                    super(t1, f1(t1)), this.context = e1, this.kind = c1.TrieNodeKind.QUERY;
                }
                applyTest(t1) {
                    return this.test ? this.test(t1) : this.context.applyQuery(t1, this.constraint) === t1;
                }
            }
            e1.QueryTrieNode = d1;
            class m1 extends l1.StaticTrieNode {
                constructor(t1, e1){
                    super(t1, f1(t1)), this.context = e1, this.kind = c1.TrieNodeKind.BOOLEAN;
                }
                applyTest(t1) {
                    return this.test ? this.test(t1) : this.context.applyConstraint(t1, this.constraint);
                }
            }
            e1.BooleanTrieNode = m1;
        },
        7491: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.completeLocale = e1.getLocale = e1.setLocale = e1.locales = void 0;
            const n1 = r1(5897), o1 = r1(1377), i1 = r1(2105), s1 = r1(4249), a1 = r1(8657), l1 = r1(173), c1 = r1(9393), u1 = r1(7978), p1 = r1(5540), h1 = r1(5218), f1 = r1(3887), d1 = r1(8384), m1 = r1(7206), y1 = r1(7734), g1 = r1(7264), b1 = r1(4356);
            function v1() {
                const t1 = o1.Variables.ensureLocale(n1.default.getInstance().locale, n1.default.getInstance().defaultLocale);
                return n1.default.getInstance().locale = t1, e1.locales[t1]();
            }
            e1.locales = {
                ca: s1.ca,
                da: a1.da,
                de: l1.de,
                en: c1.en,
                es: u1.es,
                fr: p1.fr,
                hi: h1.hi,
                it: f1.it,
                nb: d1.nb,
                nn: y1.nn,
                sv: g1.sv,
                nemeth: m1.nemeth
            }, e1.setLocale = function() {
                const t1 = v1();
                if (function(t1) {
                    const e1 = n1.default.getInstance().subiso;
                    -1 === t1.SUBISO.all.indexOf(e1) && (n1.default.getInstance().subiso = t1.SUBISO.default);
                    t1.SUBISO.current = n1.default.getInstance().subiso;
                }(t1), t1) {
                    for (const e1 of Object.getOwnPropertyNames(t1))b1.LOCALE[e1] = t1[e1];
                    for (const [e1, r1] of Object.entries(t1.CORRECTIONS))i1.Grammar.getInstance().setCorrection(e1, r1);
                }
            }, e1.getLocale = v1, e1.completeLocale = function(t1) {
                const r1 = e1.locales[t1.locale];
                if (!r1) return void console.error("Locale " + t1.locale + " does not exist!");
                const n1 = t1.kind.toUpperCase(), o1 = t1.messages;
                if (!o1) return;
                const i1 = r1();
                for (const [t1, e1] of Object.entries(o1))i1[n1][t1] = e1;
            };
        },
        4356: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.createLocale = e1.LOCALE = void 0;
            const n1 = r1(7549);
            function o1() {
                return {
                    FUNCTIONS: (0, n1.FUNCTIONS)(),
                    MESSAGES: (0, n1.MESSAGES)(),
                    ALPHABETS: (0, n1.ALPHABETS)(),
                    NUMBERS: (0, n1.NUMBERS)(),
                    COMBINERS: {},
                    CORRECTIONS: {},
                    SUBISO: (0, n1.SUBISO)()
                };
            }
            e1.LOCALE = o1(), e1.createLocale = o1;
        },
        2536: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.localeFontCombiner = e1.extractString = e1.localEnclose = e1.localRole = e1.localFont = e1.combinePostfixIndex = e1.nestingToString = void 0;
            const n1 = r1(4356), o1 = r1(4977);
            function i1(t1, e1) {
                return void 0 === t1 ? e1 : "string" == typeof t1 ? t1 : t1[0];
            }
            e1.nestingToString = function(t1) {
                switch(t1){
                    case 1:
                        return n1.LOCALE.MESSAGES.MS.ONCE || "";
                    case 2:
                        return n1.LOCALE.MESSAGES.MS.TWICE;
                    default:
                        return t1.toString();
                }
            }, e1.combinePostfixIndex = function(t1, e1) {
                return t1 === n1.LOCALE.MESSAGES.MS.ROOTINDEX || t1 === n1.LOCALE.MESSAGES.MS.INDEX ? t1 : t1 + " " + e1;
            }, e1.localFont = function(t1) {
                return i1(n1.LOCALE.MESSAGES.font[t1], t1);
            }, e1.localRole = function(t1) {
                return i1(n1.LOCALE.MESSAGES.role[t1], t1);
            }, e1.localEnclose = function(t1) {
                return i1(n1.LOCALE.MESSAGES.enclose[t1], t1);
            }, e1.extractString = i1, e1.localeFontCombiner = function(t1) {
                return "string" == typeof t1 ? {
                    font: t1,
                    combiner: n1.LOCALE.ALPHABETS.combiner
                } : {
                    font: t1[0],
                    combiner: n1.LOCALE.COMBINERS[t1[1]] || o1.Combiners[t1[1]] || n1.LOCALE.ALPHABETS.combiner
                };
            };
        },
        4249: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ca = void 0;
            const n1 = r1(4356), o1 = r1(2536), i1 = r1(614), s1 = r1(4977), a1 = function(t1, e1, r1) {
                return t1 = "sans serif " + (r1 ? r1 + " " + t1 : t1), e1 ? t1 + " " + e1 : t1;
            };
            let l1 = null;
            e1.ca = function() {
                return l1 || (l1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = i1.default, t1.COMBINERS.sansserif = a1, t1.FUNCTIONS.fracNestDepth = (t1)=>!1, t1.FUNCTIONS.combineRootIndex = o1.combinePostfixIndex, t1.FUNCTIONS.combineNestedRadical = (t1, e1, r1)=>t1 + r1, t1.FUNCTIONS.fontRegexp = (t1)=>RegExp("^" + t1 + " "), t1.FUNCTIONS.plural = (t1)=>/.*os$/.test(t1) ? t1 + "sos" : /.*s$/.test(t1) ? t1 + "os" : /.*ga$/.test(t1) ? t1.slice(0, -2) + "gues" : /.*\xe7a$/.test(t1) ? t1.slice(0, -2) + "ces" : /.*ca$/.test(t1) ? t1.slice(0, -2) + "ques" : /.*ja$/.test(t1) ? t1.slice(0, -2) + "ges" : /.*qua$/.test(t1) ? t1.slice(0, -3) + "q\xfces" : /.*a$/.test(t1) ? t1.slice(0, -1) + "es" : /.*(e|i)$/.test(t1) ? t1 + "ns" : /.*\xed$/.test(t1) ? t1.slice(0, -1) + "ins" : t1 + "s", t1.FUNCTIONS.si = (t1, e1)=>(e1.match(/^metre/) && (t1 = t1.replace(/a$/, "\xe0").replace(/o$/, "\xf2").replace(/i$/, "\xed")), t1 + e1), t1.ALPHABETS.combiner = s1.Combiners.prefixCombiner, t1;
                }()), l1;
            };
        },
        8657: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.da = void 0;
            const n1 = r1(4356), o1 = r1(2536), i1 = r1(3866), s1 = r1(4977);
            let a1 = null;
            e1.da = function() {
                return a1 || (a1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = i1.default, t1.FUNCTIONS.radicalNestDepth = o1.nestingToString, t1.FUNCTIONS.fontRegexp = (e1)=>e1 === t1.ALPHABETS.capPrefix.default ? RegExp("^" + e1 + " ") : RegExp(" " + e1 + "$"), t1.ALPHABETS.combiner = s1.Combiners.postfixCombiner, t1.ALPHABETS.digitTrans.default = i1.default.numberToWords, t1;
                }()), a1;
            };
        },
        173: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.de = void 0;
            const n1 = r1(2105), o1 = r1(2536), i1 = r1(4356), s1 = r1(1435), a1 = function(t1, e1, r1) {
                return "s" === r1 && (e1 = e1.split(" ").map(function(t1) {
                    return t1.replace(/s$/, "");
                }).join(" "), r1 = ""), t1 = r1 ? r1 + " " + t1 : t1, e1 ? e1 + " " + t1 : t1;
            }, l1 = function(t1, e1, r1) {
                return t1 = r1 && "s" !== r1 ? r1 + " " + t1 : t1, e1 ? t1 + " " + e1 : t1;
            };
            let c1 = null;
            e1.de = function() {
                return c1 || (c1 = function() {
                    const t1 = (0, i1.createLocale)();
                    return t1.NUMBERS = s1.default, t1.COMBINERS.germanPostfix = l1, t1.ALPHABETS.combiner = a1, t1.FUNCTIONS.radicalNestDepth = (e1)=>e1 > 1 ? t1.NUMBERS.numberToWords(e1) + "fach" : "", t1.FUNCTIONS.combineRootIndex = (t1, e1)=>{
                        const r1 = e1 ? e1 + "wurzel" : "";
                        return t1.replace("Wurzel", r1);
                    }, t1.FUNCTIONS.combineNestedRadical = (t1, e1, r1)=>{
                        const n1 = (e1 ? e1 + " " : "") + (t1 = r1.match(/exponent$/) ? t1 + "r" : t1);
                        return r1.match(/ /) ? r1.replace(/ /, " " + n1 + " ") : n1 + " " + r1;
                    }, t1.FUNCTIONS.fontRegexp = function(t1) {
                        return t1 = t1.split(" ").map(function(t1) {
                            return t1.replace(/s$/, "(|s)");
                        }).join(" "), new RegExp("((^" + t1 + " )|( " + t1 + "$))");
                    }, t1.CORRECTIONS.correctOne = (t1)=>t1.replace(/^eins$/, "ein"), t1.CORRECTIONS.localFontNumber = (t1)=>(0, o1.localFont)(t1).split(" ").map(function(t1) {
                            return t1.replace(/s$/, "");
                        }).join(" "), t1.CORRECTIONS.lowercase = (t1)=>t1.toLowerCase(), t1.CORRECTIONS.article = (t1)=>{
                        const e1 = n1.Grammar.getInstance().getParameter("case"), r1 = n1.Grammar.getInstance().getParameter("plural");
                        return "dative" === e1 ? ({
                            der: "dem",
                            die: r1 ? "den" : "der",
                            das: "dem"
                        })[t1] : t1;
                    }, t1.CORRECTIONS.masculine = (t1)=>"dative" === n1.Grammar.getInstance().getParameter("case") ? t1 + "n" : t1, t1;
                }()), c1;
            };
        },
        9393: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.en = void 0;
            const n1 = r1(2105), o1 = r1(4356), i1 = r1(2536), s1 = r1(310), a1 = r1(4977);
            let l1 = null;
            e1.en = function() {
                return l1 || (l1 = function() {
                    const t1 = (0, o1.createLocale)();
                    return t1.NUMBERS = s1.default, t1.FUNCTIONS.radicalNestDepth = i1.nestingToString, t1.FUNCTIONS.plural = (t1)=>/.*s$/.test(t1) ? t1 : t1 + "s", t1.ALPHABETS.combiner = a1.Combiners.prefixCombiner, t1.ALPHABETS.digitTrans.default = s1.default.numberToWords, t1.CORRECTIONS.article = (t1)=>n1.Grammar.getInstance().getParameter("noArticle") ? "" : t1, t1;
                }()), l1;
            };
        },
        7978: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.es = void 0;
            const n1 = r1(4356), o1 = r1(2536), i1 = r1(4634), s1 = r1(4977), a1 = function(t1, e1, r1) {
                return t1 = "sans serif " + (r1 ? r1 + " " + t1 : t1), e1 ? t1 + " " + e1 : t1;
            };
            let l1 = null;
            e1.es = function() {
                return l1 || (l1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = i1.default, t1.COMBINERS.sansserif = a1, t1.FUNCTIONS.fracNestDepth = (t1)=>!1, t1.FUNCTIONS.combineRootIndex = o1.combinePostfixIndex, t1.FUNCTIONS.combineNestedRadical = (t1, e1, r1)=>t1 + r1, t1.FUNCTIONS.fontRegexp = (t1)=>RegExp("^" + t1 + " "), t1.FUNCTIONS.plural = (t1)=>/.*(a|e|i|o|u)$/.test(t1) ? t1 + "s" : /.*z$/.test(t1) ? t1.slice(0, -1) + "ces" : /.*c$/.test(t1) ? t1.slice(0, -1) + "ques" : /.*g$/.test(t1) ? t1 + "ues" : /.*\u00f3n$/.test(t1) ? t1.slice(0, -2) + "ones" : t1 + "es", t1.FUNCTIONS.si = (t1, e1)=>(e1.match(/^metro/) && (t1 = t1.replace(/a$/, "\xe1").replace(/o$/, "\xf3").replace(/i$/, "\xed")), t1 + e1), t1.ALPHABETS.combiner = s1.Combiners.prefixCombiner, t1;
                }()), l1;
            };
        },
        5540: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.fr = void 0;
            const n1 = r1(2105), o1 = r1(4356), i1 = r1(2536), s1 = r1(2350), a1 = r1(4977);
            let l1 = null;
            e1.fr = function() {
                return l1 || (l1 = function() {
                    const t1 = (0, o1.createLocale)();
                    return t1.NUMBERS = s1.default, t1.FUNCTIONS.radicalNestDepth = i1.nestingToString, t1.FUNCTIONS.combineRootIndex = i1.combinePostfixIndex, t1.FUNCTIONS.combineNestedFraction = (t1, e1, r1)=>r1.replace(/ $/g, "") + e1 + t1, t1.FUNCTIONS.combineNestedRadical = (t1, e1, r1)=>r1 + " " + t1, t1.FUNCTIONS.fontRegexp = (t1)=>RegExp(" (en |)" + t1 + "$"), t1.FUNCTIONS.plural = (t1)=>/.*s$/.test(t1) ? t1 : t1 + "s", t1.CORRECTIONS.article = (t1)=>n1.Grammar.getInstance().getParameter("noArticle") ? "" : t1, t1.ALPHABETS.combiner = a1.Combiners.romanceCombiner, t1.SUBISO = {
                        default: "fr",
                        current: "fr",
                        all: [
                            "fr",
                            "be",
                            "ch"
                        ]
                    }, t1;
                }()), l1;
            };
        },
        5218: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.hi = void 0;
            const n1 = r1(4356), o1 = r1(4438), i1 = r1(4977), s1 = r1(2536);
            let a1 = null;
            e1.hi = function() {
                return a1 || (a1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = o1.default, t1.ALPHABETS.combiner = i1.Combiners.prefixCombiner, t1.FUNCTIONS.radicalNestDepth = s1.nestingToString, t1;
                }()), a1;
            };
        },
        3887: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.it = void 0;
            const n1 = r1(2536), o1 = r1(4356), i1 = r1(8825), s1 = r1(4977), a1 = function(t1, e1, r1) {
                return t1.match(/^[a-zA-Z]$/) && (e1 = e1.replace("cerchiato", "cerchiata")), t1 = r1 ? t1 + " " + r1 : t1, e1 ? t1 + " " + e1 : t1;
            };
            let l1 = null;
            e1.it = function() {
                return l1 || (l1 = function() {
                    const t1 = (0, o1.createLocale)();
                    return t1.NUMBERS = i1.default, t1.COMBINERS.italianPostfix = a1, t1.FUNCTIONS.radicalNestDepth = n1.nestingToString, t1.FUNCTIONS.combineRootIndex = n1.combinePostfixIndex, t1.FUNCTIONS.combineNestedFraction = (t1, e1, r1)=>r1.replace(/ $/g, "") + e1 + t1, t1.FUNCTIONS.combineNestedRadical = (t1, e1, r1)=>r1 + " " + t1, t1.FUNCTIONS.fontRegexp = (t1)=>RegExp(" (en |)" + t1 + "$"), t1.ALPHABETS.combiner = s1.Combiners.romanceCombiner, t1;
                }()), l1;
            };
        },
        8384: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.nb = void 0;
            const n1 = r1(4356), o1 = r1(2536), i1 = r1(8274), s1 = r1(4977);
            let a1 = null;
            e1.nb = function() {
                return a1 || (a1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = i1.default, t1.ALPHABETS.combiner = s1.Combiners.prefixCombiner, t1.ALPHABETS.digitTrans.default = i1.default.numberToWords, t1.FUNCTIONS.radicalNestDepth = o1.nestingToString, t1;
                }()), a1;
            };
        },
        7206: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.nemeth = void 0;
            const n1 = r1(4356), o1 = r1(3720), i1 = r1(4977), s1 = function(t1) {
                return t1.match(RegExp("^" + h1.ALPHABETS.languagePrefix.english)) ? t1.slice(1) : t1;
            }, a1 = function(t1, e1, r1) {
                return t1 = s1(t1), e1 ? t1 + e1 : t1;
            }, l1 = function(t1, e1, r1) {
                return e1 + s1(t1);
            }, c1 = function(t1, e1, r1) {
                return e1 + (r1 || "") + (t1 = s1(t1)) + "⠻";
            }, u1 = function(t1, e1, r1) {
                return e1 + (r1 || "") + (t1 = s1(t1)) + "⠻⠻";
            }, p1 = function(t1, e1, r1) {
                return e1 + (t1 = s1(t1)) + "⠾";
            };
            let h1 = null;
            e1.nemeth = function() {
                return h1 || (h1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = o1.default, t1.COMBINERS = {
                        postfixCombiner: a1,
                        germanCombiner: l1,
                        embellishCombiner: c1,
                        doubleEmbellishCombiner: u1,
                        parensCombiner: p1
                    }, t1.FUNCTIONS.fracNestDepth = (t1)=>!1, t1.FUNCTIONS.fontRegexp = (t1)=>RegExp("^" + t1), t1.FUNCTIONS.si = i1.identityTransformer, t1.ALPHABETS.combiner = (t1, e1, r1)=>e1 ? e1 + r1 + t1 : s1(t1), t1.ALPHABETS.digitTrans = {
                        default: o1.default.numberToWords
                    }, t1;
                }()), h1;
            };
        },
        7734: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.nn = void 0;
            const n1 = r1(4356), o1 = r1(2536), i1 = r1(8274), s1 = r1(4977);
            let a1 = null;
            e1.nn = function() {
                return a1 || (a1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = i1.default, t1.ALPHABETS.combiner = s1.Combiners.prefixCombiner, t1.ALPHABETS.digitTrans.default = i1.default.numberToWords, t1.FUNCTIONS.radicalNestDepth = o1.nestingToString, t1.SUBISO = {
                        default: "",
                        current: "",
                        all: [
                            "",
                            "alt"
                        ]
                    }, t1;
                }()), a1;
            };
        },
        7264: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.sv = void 0;
            const n1 = r1(4356), o1 = r1(2536), i1 = r1(3898), s1 = r1(4977);
            let a1 = null;
            e1.sv = function() {
                return a1 || (a1 = function() {
                    const t1 = (0, n1.createLocale)();
                    return t1.NUMBERS = i1.default, t1.FUNCTIONS.radicalNestDepth = o1.nestingToString, t1.FUNCTIONS.fontRegexp = function(t1) {
                        return new RegExp("((^" + t1 + " )|( " + t1 + "$))");
                    }, t1.ALPHABETS.combiner = s1.Combiners.prefixCombiner, t1.ALPHABETS.digitTrans.default = i1.default.numberToWords, t1.CORRECTIONS.correctOne = (t1)=>t1.replace(/^ett$/, "en"), t1;
                }()), a1;
            };
        },
        7549: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SUBISO = e1.FUNCTIONS = e1.ALPHABETS = e1.NUMBERS = e1.MESSAGES = void 0;
            const n1 = r1(4977);
            e1.MESSAGES = function() {
                return {
                    MS: {},
                    MSroots: {},
                    font: {},
                    embellish: {},
                    role: {},
                    enclose: {},
                    navigate: {},
                    regexp: {},
                    unitTimes: ""
                };
            }, e1.NUMBERS = function() {
                return {
                    zero: "zero",
                    ones: [],
                    tens: [],
                    large: [],
                    special: {},
                    wordOrdinal: n1.identityTransformer,
                    numericOrdinal: n1.identityTransformer,
                    numberToWords: n1.identityTransformer,
                    numberToOrdinal: n1.pluralCase,
                    vulgarSep: " ",
                    numSep: " "
                };
            }, e1.ALPHABETS = function() {
                return {
                    latinSmall: [],
                    latinCap: [],
                    greekSmall: [],
                    greekCap: [],
                    capPrefix: {
                        default: ""
                    },
                    smallPrefix: {
                        default: ""
                    },
                    digitPrefix: {
                        default: ""
                    },
                    languagePrefix: {},
                    digitTrans: {
                        default: n1.identityTransformer,
                        mathspeak: n1.identityTransformer,
                        clearspeak: n1.identityTransformer
                    },
                    letterTrans: {
                        default: n1.identityTransformer
                    },
                    combiner: (t1, e1, r1)=>t1
                };
            }, e1.FUNCTIONS = function() {
                return {
                    fracNestDepth: (t1)=>n1.vulgarFractionSmall(t1, 10, 100),
                    radicalNestDepth: (t1)=>"",
                    combineRootIndex: function(t1, e1) {
                        return t1;
                    },
                    combineNestedFraction: n1.Combiners.identityCombiner,
                    combineNestedRadical: n1.Combiners.identityCombiner,
                    fontRegexp: function(t1) {
                        return new RegExp("^" + t1.split(/ |-/).join("( |-)") + "( |-)");
                    },
                    si: n1.siCombiner,
                    plural: n1.identityTransformer
                };
            }, e1.SUBISO = function() {
                return {
                    default: "",
                    current: "",
                    all: []
                };
            };
        },
        614: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(2105);
            function o1(t1) {
                const e1 = t1 % 1e3, r1 = Math.floor(e1 / 100), n1 = r1 ? 1 === r1 ? "cent" : a1.ones[r1] + "-cents" : "", o1 = function(t1) {
                    const e1 = t1 % 100;
                    if (e1 < 20) return a1.ones[e1];
                    const r1 = Math.floor(e1 / 10), n1 = a1.tens[r1], o1 = a1.ones[e1 % 10];
                    return n1 && o1 ? n1 + (2 === r1 ? "-i-" : "-") + o1 : n1 || o1;
                }(e1 % 100);
                return n1 && o1 ? n1 + a1.numSep + o1 : n1 || o1;
            }
            function i1(t1) {
                if (0 === t1) return a1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                let e1 = 0, r1 = "";
                for(; t1 > 0;){
                    const n1 = t1 % (e1 > 1 ? 1e6 : 1e3);
                    if (n1) {
                        let t1 = a1.large[e1];
                        if (e1) {
                            if (1 === e1) r1 = (1 === n1 ? "" : o1(n1) + a1.numSep) + t1 + (r1 ? a1.numSep + r1 : "");
                            else {
                                const e1 = i1(n1);
                                t1 = 1 === n1 ? t1 : t1.replace(/\u00f3$/, "ons"), r1 = e1 + a1.numSep + t1 + (r1 ? a1.numSep + r1 : "");
                            }
                        } else r1 = o1(n1);
                    }
                    t1 = Math.floor(t1 / (e1 > 1 ? 1e6 : 1e3)), e1++;
                }
                return r1;
            }
            function s1(t1) {
                const e1 = n1.Grammar.getInstance().getParameter("gender");
                return t1.toString() + ("f" === e1 ? "a" : "n");
            }
            const a1 = (0, r1(7549).NUMBERS)();
            a1.numericOrdinal = s1, a1.numberToWords = i1, a1.numberToOrdinal = function(t1, e1) {
                if (t1 > 1999) return s1(t1);
                if (t1 <= 10) return a1.special.onesOrdinals[t1 - 1];
                const r1 = i1(t1);
                return r1.match(/mil$/) ? r1.replace(/mil$/, "mil\xb7l\xe8sima") : r1.match(/u$/) ? r1.replace(/u$/, "vena") : r1.match(/a$/) ? r1.replace(/a$/, "ena") : r1 + (r1.match(/e$/) ? "na" : "ena");
            }, e1.default = a1;
        },
        3866: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            function n1(t1, e1 = !1) {
                return t1 === a1.ones[1] ? e1 ? "et" : "en" : t1;
            }
            function o1(t1, e1 = !1) {
                let r1 = t1 % 1e3, o1 = "", i1 = a1.ones[Math.floor(r1 / 100)];
                if (o1 += i1 ? n1(i1, !0) + " hundrede" : "", r1 %= 100, r1) {
                    if (o1 += o1 ? " og " : "", i1 = e1 ? a1.special.smallOrdinals[r1] : a1.ones[r1], i1) o1 += i1;
                    else {
                        const t1 = e1 ? a1.special.tensOrdinals[Math.floor(r1 / 10)] : a1.tens[Math.floor(r1 / 10)];
                        i1 = a1.ones[r1 % 10], o1 += i1 ? n1(i1) + "og" + t1 : t1;
                    }
                }
                return o1;
            }
            function i1(t1, e1 = !1) {
                if (0 === t1) return a1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                let r1 = 0, i1 = "";
                for(; t1 > 0;){
                    const s1 = t1 % 1e3;
                    if (s1) {
                        const t1 = o1(s1, e1 && !r1);
                        if (r1) {
                            const e1 = a1.large[r1], o1 = s1 > 1 ? "er" : "";
                            i1 = n1(t1, r1 <= 1) + " " + e1 + o1 + (i1 ? " og " : "") + i1;
                        } else i1 = n1(t1) + i1;
                    }
                    t1 = Math.floor(t1 / 1e3), r1++;
                }
                return i1;
            }
            function s1(t1) {
                if (t1 % 100) return i1(t1, !0);
                const e1 = i1(t1);
                return e1.match(/e$/) ? e1 : e1 + "e";
            }
            const a1 = (0, r1(7549).NUMBERS)();
            a1.wordOrdinal = s1, a1.numericOrdinal = function(t1) {
                return t1.toString() + ".";
            }, a1.numberToWords = i1, a1.numberToOrdinal = function(t1, e1) {
                return 1 === t1 ? e1 ? "hel" : "hele" : 2 === t1 ? e1 ? "halv" : "halve" : s1(t1) + (e1 ? "dele" : "del");
            }, e1.default = a1;
        },
        1435: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            function n1(t1, e1 = !1) {
                return t1 === a1.ones[1] ? e1 ? "eine" : "ein" : t1;
            }
            function o1(t1) {
                let e1 = t1 % 1e3, r1 = "", o1 = a1.ones[Math.floor(e1 / 100)];
                if (r1 += o1 ? n1(o1) + "hundert" : "", e1 %= 100, e1) {
                    if (r1 += r1 ? a1.numSep : "", o1 = a1.ones[e1], o1) r1 += o1;
                    else {
                        const t1 = a1.tens[Math.floor(e1 / 10)];
                        o1 = a1.ones[e1 % 10], r1 += o1 ? n1(o1) + "und" + t1 : t1;
                    }
                }
                return r1;
            }
            function i1(t1) {
                if (0 === t1) return a1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                let e1 = 0, r1 = "";
                for(; t1 > 0;){
                    const i1 = t1 % 1e3;
                    if (i1) {
                        const s1 = o1(t1 % 1e3);
                        if (e1) {
                            const t1 = a1.large[e1], o1 = e1 > 1 && i1 > 1 ? t1.match(/e$/) ? "n" : "en" : "";
                            r1 = n1(s1, e1 > 1) + t1 + o1 + r1;
                        } else r1 = n1(s1, e1 > 1) + r1;
                    }
                    t1 = Math.floor(t1 / 1e3), e1++;
                }
                return r1.replace(/ein$/, "eins");
            }
            function s1(t1) {
                if (1 === t1) return "erste";
                if (3 === t1) return "dritte";
                if (7 === t1) return "siebte";
                if (8 === t1) return "achte";
                return i1(t1) + (t1 < 19 ? "te" : "ste");
            }
            const a1 = (0, r1(7549).NUMBERS)();
            a1.wordOrdinal = s1, a1.numericOrdinal = function(t1) {
                return t1.toString() + ".";
            }, a1.numberToWords = i1, a1.numberToOrdinal = function(t1, e1) {
                return 1 === t1 ? "eintel" : 2 === t1 ? e1 ? "halbe" : "halb" : s1(t1) + "l";
            }, e1.default = a1;
        },
        310: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            function n1(t1) {
                let e1 = t1 % 1e3, r1 = "";
                return r1 += s1.ones[Math.floor(e1 / 100)] ? s1.ones[Math.floor(e1 / 100)] + s1.numSep + "hundred" : "", e1 %= 100, e1 && (r1 += r1 ? s1.numSep : "", r1 += s1.ones[e1] || s1.tens[Math.floor(e1 / 10)] + (e1 % 10 ? s1.numSep + s1.ones[e1 % 10] : "")), r1;
            }
            function o1(t1) {
                if (0 === t1) return s1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                let e1 = 0, r1 = "";
                for(; t1 > 0;)t1 % 1e3 && (r1 = n1(t1 % 1e3) + (e1 ? "-" + s1.large[e1] + "-" : "") + r1), t1 = Math.floor(t1 / 1e3), e1++;
                return r1.replace(/-$/, "");
            }
            function i1(t1) {
                let e1 = o1(t1);
                return e1.match(/one$/) ? e1 = e1.slice(0, -3) + "first" : e1.match(/two$/) ? e1 = e1.slice(0, -3) + "second" : e1.match(/three$/) ? e1 = e1.slice(0, -5) + "third" : e1.match(/five$/) ? e1 = e1.slice(0, -4) + "fifth" : e1.match(/eight$/) ? e1 = e1.slice(0, -5) + "eighth" : e1.match(/nine$/) ? e1 = e1.slice(0, -4) + "ninth" : e1.match(/twelve$/) ? e1 = e1.slice(0, -6) + "twelfth" : e1.match(/ty$/) ? e1 = e1.slice(0, -2) + "tieth" : e1 += "th", e1;
            }
            const s1 = (0, r1(7549).NUMBERS)();
            s1.wordOrdinal = i1, s1.numericOrdinal = function(t1) {
                const e1 = t1 % 100, r1 = t1.toString();
                if (e1 > 10 && e1 < 20) return r1 + "th";
                switch(t1 % 10){
                    case 1:
                        return r1 + "st";
                    case 2:
                        return r1 + "nd";
                    case 3:
                        return r1 + "rd";
                    default:
                        return r1 + "th";
                }
            }, s1.numberToWords = o1, s1.numberToOrdinal = function(t1, e1) {
                if (1 === t1) return e1 ? "oneths" : "oneth";
                if (2 === t1) return e1 ? "halves" : "half";
                const r1 = i1(t1);
                return e1 ? r1 + "s" : r1;
            }, e1.default = s1;
        },
        4634: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(2105);
            function o1(t1) {
                const e1 = t1 % 1e3, r1 = Math.floor(e1 / 100), n1 = i1.special.hundreds[r1], o1 = function(t1) {
                    const e1 = t1 % 100;
                    if (e1 < 30) return i1.ones[e1];
                    const r1 = i1.tens[Math.floor(e1 / 10)], n1 = i1.ones[e1 % 10];
                    return r1 && n1 ? r1 + " y " + n1 : r1 || n1;
                }(e1 % 100);
                return 1 === r1 ? o1 ? n1 + "to " + o1 : n1 : n1 && o1 ? n1 + " " + o1 : n1 || o1;
            }
            const i1 = (0, r1(7549).NUMBERS)();
            i1.numericOrdinal = function(t1) {
                const e1 = n1.Grammar.getInstance().getParameter("gender");
                return t1.toString() + ("f" === e1 ? "a" : "o");
            }, i1.numberToWords = function(t1) {
                if (0 === t1) return i1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                let e1 = 0, r1 = "";
                for(; t1 > 0;){
                    const n1 = t1 % 1e3;
                    if (n1) {
                        let t1 = i1.large[e1];
                        const s1 = o1(n1);
                        e1 ? 1 === n1 ? (t1 = t1.match("/^mil( |$)/") ? t1 : "un " + t1, r1 = t1 + (r1 ? " " + r1 : "")) : (t1 = t1.replace(/\u00f3n$/, "ones"), r1 = o1(n1) + " " + t1 + (r1 ? " " + r1 : "")) : r1 = s1;
                    }
                    t1 = Math.floor(t1 / 1e3), e1++;
                }
                return r1;
            }, i1.numberToOrdinal = function(t1, e1) {
                if (t1 > 1999) return t1.toString() + "a";
                if (t1 <= 12) return i1.special.onesOrdinals[t1 - 1];
                const r1 = [];
                if (t1 >= 1e3 && (t1 -= 1e3, r1.push("mil\xe9sima")), !t1) return r1.join(" ");
                let n1 = 0;
                return n1 = Math.floor(t1 / 100), n1 > 0 && (r1.push(i1.special.hundredsOrdinals[n1 - 1]), t1 %= 100), t1 <= 12 ? r1.push(i1.special.onesOrdinals[t1 - 1]) : (n1 = Math.floor(t1 / 10), n1 > 0 && (r1.push(i1.special.tensOrdinals[n1 - 1]), t1 %= 10), t1 > 0 && r1.push(i1.special.onesOrdinals[t1 - 1])), r1.join(" ");
            }, e1.default = i1;
        },
        2350: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(5897), o1 = r1(2105), i1 = r1(7549);
            function s1(t1) {
                let e1 = t1 % 1e3, r1 = "";
                if (r1 += u1.ones[Math.floor(e1 / 100)] ? u1.ones[Math.floor(e1 / 100)] + "-cent" : "", e1 %= 100, e1) {
                    r1 += r1 ? "-" : "";
                    let t1 = u1.ones[e1];
                    if (t1) r1 += t1;
                    else {
                        const n1 = u1.tens[Math.floor(e1 / 10)];
                        n1.match(/-dix$/) ? (t1 = u1.ones[e1 % 10 + 10], r1 += n1.replace(/-dix$/, "") + "-" + t1) : r1 += n1 + (e1 % 10 ? "-" + u1.ones[e1 % 10] : "");
                    }
                }
                const n1 = r1.match(/s-\w+$/);
                return n1 ? r1.replace(/s-\w+$/, n1[0].slice(1)) : r1.replace(/-un$/, "-et-un");
            }
            function a1(t1) {
                if (0 === t1) return u1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                u1.special["tens-" + n1.default.getInstance().subiso] && (u1.tens = u1.special["tens-" + n1.default.getInstance().subiso]);
                let e1 = 0, r1 = "";
                for(; t1 > 0;){
                    const n1 = t1 % 1e3;
                    if (n1) {
                        let t1 = u1.large[e1];
                        const o1 = s1(n1);
                        if (t1 && t1.match(/^mille /)) {
                            const n1 = t1.replace(/^mille /, "");
                            r1 = r1.match(RegExp(n1)) ? o1 + (e1 ? "-mille-" : "") + r1 : r1.match(RegExp(n1.replace(/s$/, ""))) ? o1 + (e1 ? "-mille-" : "") + r1.replace(n1.replace(/s$/, ""), n1) : o1 + (e1 ? "-" + t1 + "-" : "") + r1;
                        } else t1 = 1 === n1 && t1 ? t1.replace(/s$/, "") : t1, r1 = o1 + (e1 ? "-" + t1 + "-" : "") + r1;
                    }
                    t1 = Math.floor(t1 / 1e3), e1++;
                }
                return r1.replace(/-$/, "");
            }
            const l1 = {
                1: "uni\xe8me",
                2: "demi",
                3: "tiers",
                4: "quart"
            };
            function c1(t1) {
                if (1 === t1) return "premi\xe8re";
                let e1 = a1(t1);
                return e1.match(/^neuf$/) ? e1 = e1.slice(0, -1) + "v" : e1.match(/cinq$/) ? e1 += "u" : e1.match(/trois$/) ? e1 += "" : (e1.match(/e$/) || e1.match(/s$/)) && (e1 = e1.slice(0, -1)), e1 += "i\xe8me", e1;
            }
            const u1 = (0, i1.NUMBERS)();
            u1.wordOrdinal = c1, u1.numericOrdinal = function(t1) {
                const e1 = o1.Grammar.getInstance().getParameter("gender");
                return 1 === t1 ? t1.toString() + ("m" === e1 ? "er" : "re") : t1.toString() + "e";
            }, u1.numberToWords = a1, u1.numberToOrdinal = function(t1, e1) {
                const r1 = l1[t1] || c1(t1);
                return 3 === t1 ? r1 : e1 ? r1 + "s" : r1;
            }, e1.default = u1;
        },
        4438: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(2105);
            function o1(t1) {
                if (0 === t1) return s1.zero;
                if (t1 >= Math.pow(10, 32)) return t1.toString();
                let e1 = 0, r1 = "";
                const n1 = function(t1) {
                    let e1 = t1 % 1e3, r1 = "";
                    return r1 += s1.ones[Math.floor(e1 / 100)] ? s1.ones[Math.floor(e1 / 100)] + s1.numSep + s1.special.hundred : "", e1 %= 100, e1 && (r1 += r1 ? s1.numSep : "", r1 += s1.ones[e1]), r1;
                }(t1 % 1e3);
                if (!(t1 = Math.floor(t1 / 1e3))) return n1;
                for(; t1 > 0;){
                    const n1 = t1 % 100;
                    n1 && (r1 = s1.ones[n1] + s1.numSep + s1.large[e1] + (r1 ? s1.numSep + r1 : "")), t1 = Math.floor(t1 / 100), e1++;
                }
                return n1 ? r1 + s1.numSep + n1 : r1;
            }
            function i1(t1) {
                const e1 = n1.Grammar.getInstance().getParameter("gender");
                if (t1 <= 0) return t1.toString();
                if (t1 < 10) return "f" === e1 ? s1.special.ordinalsFeminine[t1] : s1.special.ordinalsMasculine[t1];
                return o1(t1) + ("f" === e1 ? "वीं" : "वाँ");
            }
            const s1 = (0, r1(7549).NUMBERS)();
            s1.wordOrdinal = i1, s1.numericOrdinal = function(t1) {
                const e1 = n1.Grammar.getInstance().getParameter("gender");
                return t1 > 0 && t1 < 10 ? "f" === e1 ? s1.special.simpleSmallOrdinalsFeminine[t1] : s1.special.simpleSmallOrdinalsMasculine[t1] : t1.toString().split("").map(function(t1) {
                    const e1 = parseInt(t1, 10);
                    return isNaN(e1) ? "" : s1.special.simpleNumbers[e1];
                }).join("") + ("f" === e1 ? "वीं" : "वाँ");
            }, s1.numberToWords = o1, s1.numberToOrdinal = function(t1, e1) {
                return t1 <= 10 ? s1.special.smallDenominators[t1] : i1(t1) + " अंश";
            }, e1.default = s1;
        },
        8825: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(2105);
            function o1(t1) {
                let e1 = t1 % 1e3, r1 = "";
                if (r1 += a1.ones[Math.floor(e1 / 100)] ? a1.ones[Math.floor(e1 / 100)] + a1.numSep + "cento" : "", e1 %= 100, e1) {
                    r1 += r1 ? a1.numSep : "";
                    const t1 = a1.ones[e1];
                    if (t1) r1 += t1;
                    else {
                        let t1 = a1.tens[Math.floor(e1 / 10)];
                        const n1 = e1 % 10;
                        1 !== n1 && 8 !== n1 || (t1 = t1.slice(0, -1)), r1 += t1, r1 += n1 ? a1.numSep + a1.ones[e1 % 10] : "";
                    }
                }
                return r1;
            }
            function i1(t1) {
                if (0 === t1) return a1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                if (1 === t1 && n1.Grammar.getInstance().getParameter("fraction")) return "un";
                let e1 = 0, r1 = "";
                for(; t1 > 0;)t1 % 1e3 && (r1 = o1(t1 % 1e3) + (e1 ? "-" + a1.large[e1] + "-" : "") + r1), t1 = Math.floor(t1 / 1e3), e1++;
                return r1.replace(/-$/, "");
            }
            function s1(t1) {
                const e1 = "m" === n1.Grammar.getInstance().getParameter("gender") ? "o" : "a";
                let r1 = a1.special.onesOrdinals[t1];
                return r1 ? r1.slice(0, -1) + e1 : (r1 = i1(t1), r1.slice(0, -1) + "esim" + e1);
            }
            const a1 = (0, r1(7549).NUMBERS)();
            a1.wordOrdinal = s1, a1.numericOrdinal = function(t1) {
                const e1 = n1.Grammar.getInstance().getParameter("gender");
                return t1.toString() + ("m" === e1 ? "o" : "a");
            }, a1.numberToWords = i1, a1.numberToOrdinal = function(t1, e1) {
                if (2 === t1) return e1 ? "mezzi" : "mezzo";
                const r1 = s1(t1);
                if (!e1) return r1;
                const n1 = r1.match(/o$/) ? "i" : "e";
                return r1.slice(0, -1) + n1;
            }, e1.default = a1;
        },
        3720: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            function n1(t1) {
                return t1.toString().split("").map(function(t1) {
                    return o1.ones[parseInt(t1, 10)];
                }).join("");
            }
            const o1 = (0, r1(7549).NUMBERS)();
            o1.numberToWords = n1, o1.numberToOrdinal = n1, e1.default = o1;
        },
        8274: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(5897);
            function o1(t1, e1 = !1) {
                let r1 = t1 % 1e3, n1 = "";
                const o1 = Math.floor(r1 / 100), s1 = a1.ones[o1];
                if (n1 += s1 ? (1 === o1 ? "" : s1) + "hundre" : "", r1 %= 100, r1) {
                    if (n1 += n1 ? "og" : "", e1) {
                        const t1 = a1.special.smallOrdinals[r1];
                        if (t1) return n1 + t1;
                        if (r1 % 10) return n1 + a1.tens[Math.floor(r1 / 10)] + a1.special.smallOrdinals[r1 % 10];
                    }
                    n1 += a1.ones[r1] || a1.tens[Math.floor(r1 / 10)] + (r1 % 10 ? a1.ones[r1 % 10] : "");
                }
                return e1 ? i1(n1) : n1;
            }
            function i1(t1) {
                const e1 = a1.special.endOrdinal[0];
                return "a" === e1 && t1.match(/en$/) ? t1.slice(0, -2) + a1.special.endOrdinal : t1.match(/(d|n)$/) || t1.match(/hundre$/) ? t1 + "de" : t1.match(/i$/) ? t1 + a1.special.endOrdinal : "a" === e1 && t1.match(/e$/) ? t1.slice(0, -1) + a1.special.endOrdinal : (t1.match(/e$/), t1 + "nde");
            }
            function s1(t1) {
                return u1(t1, !0);
            }
            const a1 = (0, r1(7549).NUMBERS)();
            function l1(t1, e1 = !1) {
                return t1 === a1.ones[1] ? "ein" === t1 ? "eitt " : e1 ? "et" : "ett" : t1;
            }
            function c1(t1, e1 = !1) {
                let r1 = t1 % 1e3, n1 = "", o1 = a1.ones[Math.floor(r1 / 100)];
                if (n1 += o1 ? l1(o1) + "hundre" : "", r1 %= 100, r1) {
                    if (n1 += n1 ? "og" : "", e1) {
                        const t1 = a1.special.smallOrdinals[r1];
                        if (t1) return n1 + t1;
                    }
                    if (o1 = a1.ones[r1], o1) n1 += o1;
                    else {
                        const t1 = a1.tens[Math.floor(r1 / 10)];
                        o1 = a1.ones[r1 % 10], n1 += o1 ? o1 + "og" + t1 : t1;
                    }
                }
                return e1 ? i1(n1) : n1;
            }
            function u1(t1, e1 = !1) {
                const r1 = "alt" === n1.default.getInstance().subiso ? function(t1, e1 = !1) {
                    if (0 === t1) return e1 ? a1.special.smallOrdinals[0] : a1.zero;
                    if (t1 >= Math.pow(10, 36)) return t1.toString();
                    let r1 = 0, n1 = "";
                    for(; t1 > 0;){
                        const o1 = t1 % 1e3;
                        if (o1) {
                            const i1 = c1(t1 % 1e3, !r1 && e1);
                            !r1 && e1 && (e1 = !e1), n1 = (1 === r1 ? l1(i1, !0) : i1) + (r1 > 1 ? a1.numSep : "") + (r1 ? a1.large[r1] + (r1 > 1 && o1 > 1 ? "er" : "") : "") + (r1 > 1 && n1 ? a1.numSep : "") + n1;
                        }
                        t1 = Math.floor(t1 / 1e3), r1++;
                    }
                    return e1 ? n1 + (n1.match(/tusen$/) ? "de" : "te") : n1;
                }(t1, e1) : function(t1, e1 = !1) {
                    if (0 === t1) return e1 ? a1.special.smallOrdinals[0] : a1.zero;
                    if (t1 >= Math.pow(10, 36)) return t1.toString();
                    let r1 = 0, n1 = "";
                    for(; t1 > 0;){
                        const i1 = t1 % 1e3;
                        if (i1) {
                            const s1 = o1(t1 % 1e3, !r1 && e1);
                            !r1 && e1 && (e1 = !e1), n1 = s1 + (r1 ? " " + a1.large[r1] + (r1 > 1 && i1 > 1 ? "er" : "") + (n1 ? " " : "") : "") + n1;
                        }
                        t1 = Math.floor(t1 / 1e3), r1++;
                    }
                    return e1 ? n1 + (n1.match(/tusen$/) ? "de" : "te") : n1;
                }(t1, e1);
                return r1;
            }
            a1.wordOrdinal = s1, a1.numericOrdinal = function(t1) {
                return t1.toString() + ".";
            }, a1.numberToWords = u1, a1.numberToOrdinal = function(t1, e1) {
                return s1(t1);
            }, e1.default = a1;
        },
        3898: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            function n1(t1) {
                let e1 = t1 % 1e3, r1 = "";
                const n1 = Math.floor(e1 / 100);
                return r1 += s1.ones[n1] ? (1 === n1 ? "" : s1.ones[n1] + s1.numSep) + "hundra" : "", e1 %= 100, e1 && (r1 += r1 ? s1.numSep : "", r1 += s1.ones[e1] || s1.tens[Math.floor(e1 / 10)] + (e1 % 10 ? s1.numSep + s1.ones[e1 % 10] : "")), r1;
            }
            function o1(t1, e1 = !1) {
                if (0 === t1) return s1.zero;
                if (t1 >= Math.pow(10, 36)) return t1.toString();
                let r1 = 0, o1 = "";
                for(; t1 > 0;){
                    const i1 = t1 % 1e3;
                    if (i1) {
                        const a1 = s1.large[r1], l1 = i1 > 1 && r1 > 1 && !e1 ? "er" : "";
                        o1 = (1 === r1 && 1 === i1 ? "" : (r1 > 1 && 1 === i1 ? "en" : n1(t1 % 1e3)) + (r1 > 1 ? " " : "")) + (r1 ? a1 + l1 + (r1 > 1 ? " " : "") : "") + o1;
                    }
                    t1 = Math.floor(t1 / 1e3), r1++;
                }
                return o1.replace(/ $/, "");
            }
            function i1(t1) {
                let e1 = o1(t1, !0);
                return e1.match(/^noll$/) ? e1 = "nollte" : e1.match(/ett$/) ? e1 = e1.replace(/ett$/, "f\xf6rsta") : e1.match(/tv\xe5$/) ? e1 = e1.replace(/tv\xe5$/, "andra") : e1.match(/tre$/) ? e1 = e1.replace(/tre$/, "tredje") : e1.match(/fyra$/) ? e1 = e1.replace(/fyra$/, "fj\xe4rde") : e1.match(/fem$/) ? e1 = e1.replace(/fem$/, "femte") : e1.match(/sex$/) ? e1 = e1.replace(/sex$/, "sj\xe4tte") : e1.match(/sju$/) ? e1 = e1.replace(/sju$/, "sjunde") : e1.match(/\xe5tta$/) ? e1 = e1.replace(/\xe5tta$/, "\xe5ttonde") : e1.match(/nio$/) ? e1 = e1.replace(/nio$/, "nionde") : e1.match(/tio$/) ? e1 = e1.replace(/tio$/, "tionde") : e1.match(/elva$/) ? e1 = e1.replace(/elva$/, "elfte") : e1.match(/tolv$/) ? e1 = e1.replace(/tolv$/, "tolfte") : e1.match(/tusen$/) ? e1 = e1.replace(/tusen$/, "tusonde") : e1.match(/jard$/) || e1.match(/jon$/) ? e1 += "te" : e1 += "de", e1;
            }
            const s1 = (0, r1(7549).NUMBERS)();
            s1.wordOrdinal = i1, s1.numericOrdinal = function(t1) {
                const e1 = t1.toString();
                return e1.match(/11$|12$/) ? e1 + ":e" : e1 + (e1.match(/1$|2$/) ? ":a" : ":e");
            }, s1.numberToWords = o1, s1.numberToOrdinal = function(t1, e1) {
                if (1 === t1) return "hel";
                if (2 === t1) return e1 ? "halva" : "halv";
                let r1 = i1(t1);
                return r1 = r1.match(/de$/) ? r1.replace(/de$/, "") : r1, r1 + (e1 ? "delar" : "del");
            }, e1.default = s1;
        },
        4977: function(t1, e1) {
            function r1(t1, e1 = "") {
                if (!t1.childNodes || !t1.childNodes[0] || !t1.childNodes[0].childNodes || t1.childNodes[0].childNodes.length < 2 || "number" !== t1.childNodes[0].childNodes[0].tagName || "integer" !== t1.childNodes[0].childNodes[0].getAttribute("role") || "number" !== t1.childNodes[0].childNodes[1].tagName || "integer" !== t1.childNodes[0].childNodes[1].getAttribute("role")) return {
                    convertible: !1,
                    content: t1.textContent
                };
                const r1 = t1.childNodes[0].childNodes[1].textContent, n1 = t1.childNodes[0].childNodes[0].textContent, o1 = Number(r1), i1 = Number(n1);
                return isNaN(o1) || isNaN(i1) ? {
                    convertible: !1,
                    content: `${n1} ${e1} ${r1}`
                } : {
                    convertible: !0,
                    enumerator: i1,
                    denominator: o1
                };
            }
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.vulgarFractionSmall = e1.convertVulgarFraction = e1.Combiners = e1.siCombiner = e1.identityTransformer = e1.pluralCase = void 0, e1.pluralCase = function(t1, e1) {
                return t1.toString();
            }, e1.identityTransformer = function(t1) {
                return t1.toString();
            }, e1.siCombiner = function(t1, e1) {
                return t1 + e1.toLowerCase();
            }, e1.Combiners = {}, e1.Combiners.identityCombiner = function(t1, e1, r1) {
                return t1 + e1 + r1;
            }, e1.Combiners.prefixCombiner = function(t1, e1, r1) {
                return t1 = r1 ? r1 + " " + t1 : t1, e1 ? e1 + " " + t1 : t1;
            }, e1.Combiners.postfixCombiner = function(t1, e1, r1) {
                return t1 = r1 ? r1 + " " + t1 : t1, e1 ? t1 + " " + e1 : t1;
            }, e1.Combiners.romanceCombiner = function(t1, e1, r1) {
                return t1 = r1 ? t1 + " " + r1 : t1, e1 ? t1 + " " + e1 : t1;
            }, e1.convertVulgarFraction = r1, e1.vulgarFractionSmall = function(t1, e1, n1) {
                const o1 = r1(t1);
                if (o1.convertible) {
                    const t1 = o1.enumerator, r1 = o1.denominator;
                    return t1 > 0 && t1 < e1 && r1 > 0 && r1 < n1;
                }
                return !1;
            };
        },
        4504: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Condition = e1.BaseRuleStore = void 0;
            const n1 = r1(7052), o1 = r1(1676), i1 = r1(4650), s1 = r1(4106);
            class a1 {
                constructor(){
                    this.context = new s1.SpeechRuleContext, this.parseOrder = o1.DynamicCstr.DEFAULT_ORDER, this.parser = new o1.DynamicCstrParser(this.parseOrder), this.locale = o1.DynamicCstr.DEFAULT_VALUES[o1.Axis.LOCALE], this.modality = o1.DynamicCstr.DEFAULT_VALUES[o1.Axis.MODALITY], this.domain = "", this.initialized = !1, this.inherits = null, this.kind = "standard", this.customTranscriptions = {}, this.preconditions = new Map, this.speechRules_ = [], this.rank = 0, this.parseMethods = {
                        Rule: this.defineRule,
                        Generator: this.generateRules,
                        Action: this.defineAction,
                        Precondition: this.definePrecondition,
                        Ignore: this.ignoreRules
                    };
                }
                static compareStaticConstraints_(t1, e1) {
                    if (t1.length !== e1.length) return !1;
                    for(let r1, n1 = 0; r1 = t1[n1]; n1++)if (-1 === e1.indexOf(r1)) return !1;
                    return !0;
                }
                static comparePreconditions_(t1, e1) {
                    const r1 = t1.precondition, n1 = e1.precondition;
                    return r1.query === n1.query && a1.compareStaticConstraints_(r1.constraints, n1.constraints);
                }
                defineRule(t1, e1, r1, n1, ...o1) {
                    const s1 = this.parseAction(r1), a1 = this.parsePrecondition(n1, o1), l1 = this.parseCstr(e1);
                    if (!(s1 && a1 && l1)) return console.error(`Rule Error: ${n1}, (${e1}): ${r1}`), null;
                    const c1 = new i1.SpeechRule(t1, l1, a1, s1);
                    return c1.precondition.rank = this.rank++, this.addRule(c1), c1;
                }
                addRule(t1) {
                    t1.context = this.context, this.speechRules_.unshift(t1);
                }
                deleteRule(t1) {
                    const e1 = this.speechRules_.indexOf(t1);
                    -1 !== e1 && this.speechRules_.splice(e1, 1);
                }
                findRule(t1) {
                    for(let e1, r1 = 0; e1 = this.speechRules_[r1]; r1++)if (t1(e1)) return e1;
                    return null;
                }
                findAllRules(t1) {
                    return this.speechRules_.filter(t1);
                }
                evaluateDefault(t1) {
                    const e1 = t1.textContent.slice(0);
                    return e1.match(/^\s+$/) ? this.evaluateWhitespace(e1) : this.evaluateString(e1);
                }
                evaluateWhitespace(t1) {
                    return [];
                }
                evaluateCustom(t1) {
                    const e1 = this.customTranscriptions[t1];
                    return void 0 !== e1 ? n1.AuditoryDescription.create({
                        text: e1
                    }, {
                        adjust: !0,
                        translate: !1
                    }) : null;
                }
                evaluateCharacter(t1) {
                    return this.evaluateCustom(t1) || n1.AuditoryDescription.create({
                        text: t1
                    }, {
                        adjust: !0,
                        translate: !0
                    });
                }
                removeDuplicates(t1) {
                    for(let e1, r1 = this.speechRules_.length - 1; e1 = this.speechRules_[r1]; r1--)e1 !== t1 && t1.dynamicCstr.equal(e1.dynamicCstr) && a1.comparePreconditions_(e1, t1) && this.speechRules_.splice(r1, 1);
                }
                getSpeechRules() {
                    return this.speechRules_;
                }
                setSpeechRules(t1) {
                    this.speechRules_ = t1;
                }
                getPreconditions() {
                    return this.preconditions;
                }
                parseCstr(t1) {
                    try {
                        return this.parser.parse(this.locale + "." + this.modality + (this.domain ? "." + this.domain : "") + "." + t1);
                    } catch (e1) {
                        if ("RuleError" === e1.name) return console.error("Rule Error ", `Illegal Dynamic Constraint: ${t1}.`, e1.message), null;
                        throw e1;
                    }
                }
                parsePrecondition(t1, e1) {
                    try {
                        const r1 = this.parsePrecondition_(t1);
                        t1 = r1[0];
                        let n1 = r1.slice(1);
                        for (const t1 of e1)n1 = n1.concat(this.parsePrecondition_(t1));
                        return new i1.Precondition(t1, ...n1);
                    } catch (r1) {
                        if ("RuleError" === r1.name) return console.error("Rule Error ", `Illegal preconditions: ${t1}, ${e1}.`, r1.message), null;
                        throw r1;
                    }
                }
                parseAction(t1) {
                    try {
                        return i1.Action.fromString(t1);
                    } catch (e1) {
                        if ("RuleError" === e1.name) return console.error("Rule Error ", `Illegal action: ${t1}.`, e1.message), null;
                        throw e1;
                    }
                }
                parse(t1) {
                    this.modality = t1.modality || this.modality, this.locale = t1.locale || this.locale, this.domain = t1.domain || this.domain, this.context.parse(t1.functions || []), "actions" !== t1.kind && (this.kind = t1.kind || this.kind, this.inheritRules()), this.parseRules(t1.rules || []);
                }
                parseRules(t1) {
                    for(let e1, r1 = 0; e1 = t1[r1]; r1++){
                        const t1 = e1[0], r1 = this.parseMethods[t1];
                        t1 && r1 && r1.apply(this, e1.slice(1));
                    }
                }
                generateRules(t1) {
                    const e1 = this.context.customGenerators.lookup(t1);
                    e1 && e1(this);
                }
                defineAction(t1, e1) {
                    let r1;
                    try {
                        r1 = i1.Action.fromString(e1);
                    } catch (t1) {
                        if ("RuleError" === t1.name) return void console.error("Action Error ", e1, t1.message);
                        throw t1;
                    }
                    const n1 = this.getFullPreconditions(t1);
                    if (!n1) return void console.error(`Action Error: No precondition for action ${t1}`);
                    this.ignoreRules(t1);
                    const o1 = new RegExp("^\\w+\\.\\w+\\." + (this.domain ? "\\w+\\." : ""));
                    n1.conditions.forEach(([e1, n1])=>{
                        const s1 = this.parseCstr(e1.toString().replace(o1, ""));
                        this.addRule(new i1.SpeechRule(t1, s1, n1, r1));
                    });
                }
                getFullPreconditions(t1) {
                    const e1 = this.preconditions.get(t1);
                    return e1 || !this.inherits ? e1 : this.inherits.getFullPreconditions(t1);
                }
                definePrecondition(t1, e1, r1, ...n1) {
                    const o1 = this.parsePrecondition(r1, n1), i1 = this.parseCstr(e1);
                    o1 && i1 ? (o1.rank = this.rank++, this.preconditions.set(t1, new l1(i1, o1))) : console.error(`Precondition Error: ${r1}, (${e1})`);
                }
                inheritRules() {
                    if (!this.inherits || !this.inherits.getSpeechRules().length) return;
                    const t1 = new RegExp("^\\w+\\.\\w+\\." + (this.domain ? "\\w+\\." : ""));
                    this.inherits.getSpeechRules().forEach((e1)=>{
                        const r1 = this.parseCstr(e1.dynamicCstr.toString().replace(t1, ""));
                        this.addRule(new i1.SpeechRule(e1.name, r1, e1.precondition, e1.action));
                    });
                }
                ignoreRules(t1, ...e1) {
                    let r1 = this.findAllRules((e1)=>e1.name === t1);
                    if (!e1.length) return void r1.forEach(this.deleteRule.bind(this));
                    let n1 = [];
                    for (const t1 of e1){
                        const e1 = this.parseCstr(t1);
                        for (const t1 of r1)e1.equal(t1.dynamicCstr) ? this.deleteRule(t1) : n1.push(t1);
                        r1 = n1, n1 = [];
                    }
                }
                parsePrecondition_(t1) {
                    const e1 = this.context.customGenerators.lookup(t1);
                    return e1 ? e1() : [
                        t1
                    ];
                }
            }
            e1.BaseRuleStore = a1;
            class l1 {
                constructor(t1, e1){
                    this.base = t1, this._conditions = [], this.constraints = [], this.allCstr = {}, this.constraints.push(t1), this.addCondition(t1, e1);
                }
                get conditions() {
                    return this._conditions;
                }
                addConstraint(t1) {
                    if (this.constraints.filter((e1)=>e1.equal(t1)).length) return;
                    this.constraints.push(t1);
                    const e1 = [];
                    for (const [r1, n1] of this.conditions)this.base.equal(r1) && e1.push([
                        t1,
                        n1
                    ]);
                    this._conditions = this._conditions.concat(e1);
                }
                addBaseCondition(t1) {
                    this.addCondition(this.base, t1);
                }
                addFullCondition(t1) {
                    this.constraints.forEach((e1)=>this.addCondition(e1, t1));
                }
                addCondition(t1, e1) {
                    const r1 = t1.toString() + " " + e1.toString();
                    this.allCstr.condStr || (this.allCstr[r1] = !0, this._conditions.push([
                        t1,
                        e1
                    ]));
                }
            }
            e1.Condition = l1;
        },
        2469: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BrailleStore = void 0;
            const n1 = r1(7630), o1 = r1(9935);
            class i1 extends o1.MathStore {
                constructor(){
                    super(...arguments), this.modality = "braille", this.customTranscriptions = {
                        "⋊": "⠈⠡⠳"
                    };
                }
                evaluateString(t1) {
                    const e1 = [], r1 = Array.from(t1);
                    for(let t1 = 0; t1 < r1.length; t1++)e1.push(this.evaluateCharacter(r1[t1]));
                    return e1;
                }
                annotations() {
                    for(let t1, e1 = 0; t1 = this.annotators[e1]; e1++)(0, n1.activate)(this.locale, t1);
                }
            }
            e1.BrailleStore = i1;
        },
        1676: function(t1, e1) {
            var r1;
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.DefaultComparator = e1.DynamicCstrParser = e1.DynamicCstr = e1.DynamicProperties = e1.Axis = void 0, function(t1) {
                t1.DOMAIN = "domain", t1.STYLE = "style", t1.LOCALE = "locale", t1.TOPIC = "topic", t1.MODALITY = "modality";
            }(r1 = e1.Axis || (e1.Axis = {}));
            class n1 {
                constructor(t1, e1 = Object.keys(t1)){
                    this.properties = t1, this.order = e1;
                }
                static createProp(...t1) {
                    const e1 = o1.DEFAULT_ORDER, r1 = {};
                    for(let n1 = 0, o1 = t1.length, i1 = e1.length; n1 < o1 && n1 < i1; n1++)r1[e1[n1]] = t1[n1];
                    return new n1(r1);
                }
                getProperties() {
                    return this.properties;
                }
                getOrder() {
                    return this.order;
                }
                getAxes() {
                    return this.order;
                }
                getProperty(t1) {
                    return this.properties[t1];
                }
                updateProperties(t1) {
                    this.properties = t1;
                }
                allProperties() {
                    const t1 = [];
                    return this.order.forEach((e1)=>t1.push(this.getProperty(e1).slice())), t1;
                }
                toString() {
                    const t1 = [];
                    return this.order.forEach((e1)=>t1.push(e1 + ": " + this.getProperty(e1).toString())), t1.join("\n");
                }
            }
            e1.DynamicProperties = n1;
            class o1 extends n1 {
                constructor(t1, e1){
                    const r1 = {};
                    for (const [e1, n1] of Object.entries(t1))r1[e1] = [
                        n1
                    ];
                    super(r1, e1), this.components = t1;
                }
                static createCstr(...t1) {
                    const e1 = o1.DEFAULT_ORDER, r1 = {};
                    for(let n1 = 0, o1 = t1.length, i1 = e1.length; n1 < o1 && n1 < i1; n1++)r1[e1[n1]] = t1[n1];
                    return new o1(r1);
                }
                static defaultCstr() {
                    return o1.createCstr.apply(null, o1.DEFAULT_ORDER.map(function(t1) {
                        return o1.DEFAULT_VALUES[t1];
                    }));
                }
                static validOrder(t1) {
                    const e1 = o1.DEFAULT_ORDER.slice();
                    return t1.every((t1)=>{
                        const r1 = e1.indexOf(t1);
                        return -1 !== r1 && e1.splice(r1, 1);
                    });
                }
                getComponents() {
                    return this.components;
                }
                getValue(t1) {
                    return this.components[t1];
                }
                getValues() {
                    return this.order.map((t1)=>this.getValue(t1));
                }
                allProperties() {
                    const t1 = super.allProperties();
                    for(let e1, r1, n1 = 0; e1 = t1[n1], r1 = this.order[n1]; n1++){
                        const t1 = this.getValue(r1);
                        -1 === e1.indexOf(t1) && e1.unshift(t1);
                    }
                    return t1;
                }
                toString() {
                    return this.getValues().join(".");
                }
                equal(t1) {
                    const e1 = t1.getAxes();
                    if (this.order.length !== e1.length) return !1;
                    for(let r1, n1 = 0; r1 = e1[n1]; n1++){
                        const e1 = this.getValue(r1);
                        if (!e1 || t1.getValue(r1) !== e1) return !1;
                    }
                    return !0;
                }
            }
            e1.DynamicCstr = o1, o1.DEFAULT_ORDER = [
                r1.LOCALE,
                r1.MODALITY,
                r1.DOMAIN,
                r1.STYLE,
                r1.TOPIC
            ], o1.BASE_LOCALE = "base", o1.DEFAULT_VALUE = "default", o1.DEFAULT_VALUES = {
                [r1.LOCALE]: "en",
                [r1.DOMAIN]: o1.DEFAULT_VALUE,
                [r1.STYLE]: o1.DEFAULT_VALUE,
                [r1.TOPIC]: o1.DEFAULT_VALUE,
                [r1.MODALITY]: "speech"
            };
            e1.DynamicCstrParser = class {
                constructor(t1){
                    this.order = t1;
                }
                parse(t1) {
                    const e1 = t1.split("."), r1 = {};
                    if (e1.length > this.order.length) throw new Error("Invalid dynamic constraint: " + r1);
                    let n1 = 0;
                    for(let t1, o1 = 0; t1 = this.order[o1], e1.length; o1++, n1++){
                        const n1 = e1.shift();
                        r1[t1] = n1;
                    }
                    return new o1(r1, this.order.slice(0, n1));
                }
            };
            e1.DefaultComparator = class {
                constructor(t1, e1 = new n1(t1.getProperties(), t1.getOrder())){
                    this.reference = t1, this.fallback = e1, this.order = this.reference.getOrder();
                }
                getReference() {
                    return this.reference;
                }
                setReference(t1, e1) {
                    this.reference = t1, this.fallback = e1 || new n1(t1.getProperties(), t1.getOrder()), this.order = this.reference.getOrder();
                }
                match(t1) {
                    const e1 = t1.getAxes();
                    return e1.length === this.reference.getAxes().length && e1.every((e1)=>{
                        const r1 = t1.getValue(e1);
                        return r1 === this.reference.getValue(e1) || -1 !== this.fallback.getProperty(e1).indexOf(r1);
                    });
                }
                compare(t1, e1) {
                    let r1 = !1;
                    for(let n1, o1 = 0; n1 = this.order[o1]; o1++){
                        const o1 = t1.getValue(n1), i1 = e1.getValue(n1);
                        if (!r1) {
                            const t1 = this.reference.getValue(n1);
                            if (t1 === o1 && t1 !== i1) return -1;
                            if (t1 === i1 && t1 !== o1) return 1;
                            if (t1 === o1 && t1 === i1) continue;
                            t1 !== o1 && t1 !== i1 && (r1 = !0);
                        }
                        const s1 = this.fallback.getProperty(n1), a1 = s1.indexOf(o1), l1 = s1.indexOf(i1);
                        if (a1 < l1) return -1;
                        if (l1 < a1) return 1;
                    }
                    return 0;
                }
                toString() {
                    return this.reference.toString() + "\n" + this.fallback.toString();
                }
            };
        },
        2105: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.numbersToAlpha = e1.Grammar = e1.ATTRIBUTE = void 0;
            const n1 = r1(5740), o1 = r1(5897), i1 = r1(2536), s1 = r1(4356);
            e1.ATTRIBUTE = "grammar";
            class a1 {
                constructor(){
                    this.currentFlags = {}, this.parameters_ = {}, this.corrections_ = {}, this.preprocessors_ = {}, this.stateStack_ = [];
                }
                static getInstance() {
                    return a1.instance = a1.instance || new a1, a1.instance;
                }
                static parseInput(t1) {
                    const e1 = {}, r1 = t1.split(":");
                    for(let t1 = 0, n1 = r1.length; t1 < n1; t1++){
                        const n1 = r1[t1].split("="), o1 = n1[0].trim();
                        n1[1] ? e1[o1] = n1[1].trim() : o1.match(/^!/) ? e1[o1.slice(1)] = !1 : e1[o1] = !0;
                    }
                    return e1;
                }
                static parseState(t1) {
                    const e1 = {}, r1 = t1.split(" ");
                    for(let t1 = 0, n1 = r1.length; t1 < n1; t1++){
                        const n1 = r1[t1].split(":"), o1 = n1[0], i1 = n1[1];
                        e1[o1] = i1 || !0;
                    }
                    return e1;
                }
                static translateString_(t1) {
                    if (t1.match(/:unit$/)) return a1.translateUnit_(t1);
                    const e1 = o1.default.getInstance();
                    let r1 = e1.evaluator(t1, e1.dynamicCstr);
                    return r1 = null === r1 ? t1 : r1, a1.getInstance().getParameter("plural") && (r1 = s1.LOCALE.FUNCTIONS.plural(r1)), r1;
                }
                static translateUnit_(t1) {
                    t1 = a1.prepareUnit_(t1);
                    const e1 = o1.default.getInstance(), r1 = a1.getInstance().getParameter("plural"), n1 = e1.strict, i1 = `${e1.locale}.${e1.modality}.default`;
                    let l1, c1;
                    return e1.strict = !0, r1 && (l1 = e1.defaultParser.parse(i1 + ".plural"), c1 = e1.evaluator(t1, l1)), c1 ? (e1.strict = n1, c1) : (l1 = e1.defaultParser.parse(i1 + ".default"), c1 = e1.evaluator(t1, l1), e1.strict = n1, c1 ? (r1 && (c1 = s1.LOCALE.FUNCTIONS.plural(c1)), c1) : a1.cleanUnit_(t1));
                }
                static prepareUnit_(t1) {
                    const e1 = t1.match(/:unit$/);
                    return e1 ? t1.slice(0, e1.index).replace(/\s+/g, " ") + t1.slice(e1.index) : t1;
                }
                static cleanUnit_(t1) {
                    return t1.match(/:unit$/) ? t1.replace(/:unit$/, "") : t1;
                }
                clear() {
                    this.parameters_ = {}, this.stateStack_ = [];
                }
                setParameter(t1, e1) {
                    const r1 = this.parameters_[t1];
                    return e1 ? this.parameters_[t1] = e1 : delete this.parameters_[t1], r1;
                }
                getParameter(t1) {
                    return this.parameters_[t1];
                }
                setCorrection(t1, e1) {
                    this.corrections_[t1] = e1;
                }
                setPreprocessor(t1, e1) {
                    this.preprocessors_[t1] = e1;
                }
                getCorrection(t1) {
                    return this.corrections_[t1];
                }
                getState() {
                    const t1 = [];
                    for(const e1 in this.parameters_){
                        const r1 = this.parameters_[e1];
                        t1.push("string" == typeof r1 ? e1 + ":" + r1 : e1);
                    }
                    return t1.join(" ");
                }
                pushState(t1) {
                    for(const e1 in t1)t1[e1] = this.setParameter(e1, t1[e1]);
                    this.stateStack_.push(t1);
                }
                popState() {
                    const t1 = this.stateStack_.pop();
                    for(const e1 in t1)this.setParameter(e1, t1[e1]);
                }
                setAttribute(t1) {
                    if (t1 && t1.nodeType === n1.NodeType.ELEMENT_NODE) {
                        const r1 = this.getState();
                        r1 && t1.setAttribute(e1.ATTRIBUTE, r1);
                    }
                }
                preprocess(t1) {
                    return this.runProcessors_(t1, this.preprocessors_);
                }
                correct(t1) {
                    return this.runProcessors_(t1, this.corrections_);
                }
                apply(t1, e1) {
                    return this.currentFlags = e1 || {}, t1 = this.currentFlags.adjust || this.currentFlags.preprocess ? a1.getInstance().preprocess(t1) : t1, (this.parameters_.translate || this.currentFlags.translate) && (t1 = a1.translateString_(t1)), t1 = this.currentFlags.adjust || this.currentFlags.correct ? a1.getInstance().correct(t1) : t1, this.currentFlags = {}, t1;
                }
                runProcessors_(t1, e1) {
                    for(const r1 in this.parameters_){
                        const n1 = e1[r1];
                        if (!n1) continue;
                        const o1 = this.parameters_[r1];
                        t1 = !0 === o1 ? n1(t1) : n1(t1, o1);
                    }
                    return t1;
                }
            }
            function l1(t1, e1) {
                if (!e1 || !t1) return t1;
                const r1 = s1.LOCALE.FUNCTIONS.fontRegexp(i1.localFont(e1));
                return t1.replace(r1, "");
            }
            function c1(t1) {
                return t1.match(/\d+/) ? s1.LOCALE.NUMBERS.numberToWords(parseInt(t1, 10)) : t1;
            }
            e1.Grammar = a1, e1.numbersToAlpha = c1, a1.getInstance().setCorrection("localFont", i1.localFont), a1.getInstance().setCorrection("localRole", i1.localRole), a1.getInstance().setCorrection("localEnclose", i1.localEnclose), a1.getInstance().setCorrection("ignoreFont", l1), a1.getInstance().setPreprocessor("annotation", function(t1, e1) {
                return t1 + ":" + e1;
            }), a1.getInstance().setPreprocessor("noTranslateText", function(t1) {
                return t1.match(new RegExp("^[" + s1.LOCALE.MESSAGES.regexp.TEXT + "]+$")) && (a1.getInstance().currentFlags.translate = !1), t1;
            }), a1.getInstance().setCorrection("ignoreCaps", function(t1) {
                let e1 = s1.LOCALE.ALPHABETS.capPrefix[o1.default.getInstance().domain];
                return void 0 === e1 && (e1 = s1.LOCALE.ALPHABETS.capPrefix.default), l1(t1, e1);
            }), a1.getInstance().setPreprocessor("numbers2alpha", c1);
        },
        2780: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.enumerate = e1.lookupString = e1.lookupCategory = e1.lookupRule = e1.addSiUnitRules = e1.addUnitRules = e1.addFunctionRules = e1.addSymbolRules = e1.defineRule = e1.defineRules = e1.setSiPrefixes = void 0;
            const n1 = r1(2057), o1 = r1(5897), i1 = r1(7491), s1 = r1(4658), a1 = r1(1676);
            let l1 = a1.DynamicCstr.DEFAULT_VALUES[a1.Axis.LOCALE], c1 = a1.DynamicCstr.DEFAULT_VALUES[a1.Axis.MODALITY], u1 = {};
            e1.setSiPrefixes = function(t1) {
                u1 = t1;
            };
            const p1 = {};
            function h1(t1, e1, r1, n1) {
                const o1 = _1(e1);
                S1(o1, r1), o1.defineRulesFromMappings(t1, l1, c1, e1, n1);
            }
            function f1(t1) {
                if (v1(t1)) return;
                const e1 = t1.names, r1 = t1.mappings, n1 = t1.category;
                for(let t1, o1 = 0; t1 = e1[o1]; o1++)h1(t1, t1, n1, r1);
            }
            function d1(t1) {
                for (const e1 of Object.keys(u1)){
                    const r1 = Object.assign({}, t1);
                    r1.mappings = {};
                    const n1 = u1[e1];
                    r1.key = e1 + r1.key, r1.names = r1.names.map(function(t1) {
                        return e1 + t1;
                    });
                    for (const e1 of Object.keys(t1.mappings)){
                        r1.mappings[e1] = {};
                        for (const o1 of Object.keys(t1.mappings[e1]))r1.mappings[e1][o1] = i1.locales[l1]().FUNCTIONS.si(n1, t1.mappings[e1][o1]);
                    }
                    b1(r1);
                }
                b1(t1);
            }
            function m1(t1, e1) {
                const r1 = p1[t1];
                return r1 ? r1.lookupRule(null, e1) : null;
            }
            function y1(t1, e1) {
                const r1 = m1(t1, e1);
                return r1 ? r1.action : null;
            }
            function g1(t1, e1) {
                return e1 = e1 || {}, t1.length ? (e1[t1[0]] = g1(t1.slice(1), e1[t1[0]]), e1) : e1;
            }
            function b1(t1) {
                const e1 = t1.names;
                e1 && (t1.names = e1.map(function(t1) {
                    return t1 + ":unit";
                })), f1(t1);
            }
            function v1(t1) {
                return !(!t1.locale && !t1.modality) && (l1 = t1.locale || l1, c1 = t1.modality || c1, !0);
            }
            function _1(t1) {
                let e1 = p1[t1];
                return e1 ? (n1.Debugger.getInstance().output("Store exists! " + t1), e1) : (e1 = new s1.MathSimpleStore, p1[t1] = e1, e1);
            }
            function S1(t1, e1) {
                e1 && (t1.category = e1);
            }
            e1.defineRules = h1, e1.defineRule = function(t1, e1, r1, n1, o1, i1) {
                const s1 = _1(o1);
                S1(s1, n1), s1.defineRuleFromStrings(t1, l1, c1, e1, r1, o1, i1);
            }, e1.addSymbolRules = function(t1) {
                if (v1(t1)) return;
                const e1 = s1.MathSimpleStore.parseUnicode(t1.key);
                h1(t1.key, e1, t1.category, t1.mappings);
            }, e1.addFunctionRules = f1, e1.addUnitRules = function(t1) {
                v1(t1) || (t1.si ? d1(t1) : b1(t1));
            }, e1.addSiUnitRules = d1, e1.lookupRule = m1, e1.lookupCategory = function(t1) {
                const e1 = p1[t1];
                return e1 ? e1.category : "";
            }, e1.lookupString = y1, o1.default.getInstance().evaluator = y1, e1.enumerate = function(t1 = {}) {
                for (const e1 of Object.values(p1))for (const [, r1] of e1.rules.entries())for (const { cstr: e1 } of r1)t1 = g1(e1.getValues(), t1);
                return t1;
            };
        },
        4658: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MathSimpleStore = void 0;
            const n1 = r1(5897), o1 = r1(1676);
            class i1 {
                constructor(){
                    this.category = "", this.rules = new Map;
                }
                static parseUnicode(t1) {
                    const e1 = parseInt(t1, 16);
                    return String.fromCodePoint(e1);
                }
                static testDynamicConstraints_(t1, e1) {
                    return n1.default.getInstance().strict ? e1.cstr.equal(t1) : n1.default.getInstance().comparator.match(e1.cstr);
                }
                defineRulesFromMappings(t1, e1, r1, n1, o1) {
                    for(const i1 in o1)for(const s1 in o1[i1]){
                        const a1 = o1[i1][s1];
                        this.defineRuleFromStrings(t1, e1, r1, i1, s1, n1, a1);
                    }
                }
                getRules(t1) {
                    let e1 = this.rules.get(t1);
                    return e1 || (e1 = [], this.rules.set(t1, e1)), e1;
                }
                defineRuleFromStrings(t1, e1, r1, o1, i1, s1, a1) {
                    let l1 = this.getRules(e1);
                    const c1 = n1.default.getInstance().parsers[o1] || n1.default.getInstance().defaultParser, u1 = n1.default.getInstance().comparators[o1], p1 = `${e1}.${r1}.${o1}.${i1}`, h1 = c1.parse(p1), f1 = u1 ? u1() : n1.default.getInstance().comparator, d1 = f1.getReference();
                    f1.setReference(h1);
                    const m1 = {
                        cstr: h1,
                        action: a1
                    };
                    l1 = l1.filter((t1)=>!h1.equal(t1.cstr)), l1.push(m1), this.rules.set(e1, l1), f1.setReference(d1);
                }
                lookupRule(t1, e1) {
                    let r1 = this.getRules(e1.getValue(o1.Axis.LOCALE));
                    return r1 = r1.filter(function(t1) {
                        return i1.testDynamicConstraints_(e1, t1);
                    }), 1 === r1.length ? r1[0] : r1.length ? r1.sort((t1, e1)=>n1.default.getInstance().comparator.compare(t1.cstr, e1.cstr))[0] : null;
                }
            }
            e1.MathSimpleStore = i1;
        },
        9935: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MathStore = void 0;
            const n1 = r1(707), o1 = r1(4356), i1 = r1(7630), s1 = r1(4504), a1 = r1(4650);
            class l1 extends s1.BaseRuleStore {
                constructor(){
                    super(), this.annotators = [], this.parseMethods.Alias = this.defineAlias, this.parseMethods.SpecializedRule = this.defineSpecializedRule, this.parseMethods.Specialized = this.defineSpecialized;
                }
                initialize() {
                    this.initialized || (this.annotations(), this.initialized = !0);
                }
                annotations() {
                    for(let t1, e1 = 0; t1 = this.annotators[e1]; e1++)(0, i1.activate)(this.domain, t1);
                }
                defineAlias(t1, e1, ...r1) {
                    const n1 = this.parsePrecondition(e1, r1);
                    if (!n1) return void console.error(`Precondition Error: ${e1} ${r1}`);
                    const o1 = this.preconditions.get(t1);
                    o1 ? o1.addFullCondition(n1) : console.error(`Alias Error: No precondition by the name of ${t1}`);
                }
                defineRulesAlias(t1, e1, ...r1) {
                    const n1 = this.findAllRules(function(e1) {
                        return e1.name === t1;
                    });
                    if (0 === n1.length) throw new a1.OutputError("Rule with name " + t1 + " does not exist.");
                    const o1 = [];
                    n1.forEach((t1)=>{
                        ((t1)=>{
                            const e1 = t1.dynamicCstr.toString(), r1 = t1.action.toString();
                            for(let t1, n1 = 0; t1 = o1[n1]; n1++)if (t1.action === r1 && t1.cstr === e1) return !1;
                            return o1.push({
                                cstr: e1,
                                action: r1
                            }), !0;
                        })(t1) && this.addAlias_(t1, e1, r1);
                    });
                }
                defineSpecializedRule(t1, e1, r1, n1) {
                    const o1 = this.parseCstr(e1), i1 = this.findRule((e1)=>e1.name === t1 && o1.equal(e1.dynamicCstr)), s1 = this.parseCstr(r1);
                    if (!i1 && n1) throw new a1.OutputError("Rule named " + t1 + " with style " + e1 + " does not exist.");
                    const l1 = n1 ? a1.Action.fromString(n1) : i1.action, c1 = new a1.SpeechRule(i1.name, s1, i1.precondition, l1);
                    this.addRule(c1);
                }
                defineSpecialized(t1, e1, r1) {
                    const n1 = this.parseCstr(r1);
                    if (!n1) return void console.error(`Dynamic Constraint Error: ${r1}`);
                    const o1 = this.preconditions.get(t1);
                    o1 ? o1.addConstraint(n1) : console.error(`Alias Error: No precondition by the name of ${t1}`);
                }
                evaluateString(t1) {
                    const e1 = [];
                    if (t1.match(/^\s+$/)) return e1;
                    let r1 = this.matchNumber_(t1);
                    if (r1 && r1.length === t1.length) return e1.push(this.evaluateCharacter(r1.number)), e1;
                    const i1 = n1.removeEmpty(t1.replace(/\s/g, " ").split(" "));
                    for(let t1, n1 = 0; t1 = i1[n1]; n1++)if (1 === t1.length) e1.push(this.evaluateCharacter(t1));
                    else if (t1.match(new RegExp("^[" + o1.LOCALE.MESSAGES.regexp.TEXT + "]+$"))) e1.push(this.evaluateCharacter(t1));
                    else {
                        let n1 = t1;
                        for(; n1;){
                            r1 = this.matchNumber_(n1);
                            const t1 = n1.match(new RegExp("^[" + o1.LOCALE.MESSAGES.regexp.TEXT + "]+"));
                            if (r1) e1.push(this.evaluateCharacter(r1.number)), n1 = n1.substring(r1.length);
                            else if (t1) e1.push(this.evaluateCharacter(t1[0])), n1 = n1.substring(t1[0].length);
                            else {
                                const t1 = Array.from(n1), r1 = t1[0];
                                e1.push(this.evaluateCharacter(r1)), n1 = t1.slice(1).join("");
                            }
                        }
                    }
                    return e1;
                }
                parse(t1) {
                    super.parse(t1), this.annotators = t1.annotators || [];
                }
                addAlias_(t1, e1, r1) {
                    const n1 = this.parsePrecondition(e1, r1), o1 = new a1.SpeechRule(t1.name, t1.dynamicCstr, n1, t1.action);
                    o1.name = t1.name, this.addRule(o1);
                }
                matchNumber_(t1) {
                    const e1 = t1.match(new RegExp("^" + o1.LOCALE.MESSAGES.regexp.NUMBER)), r1 = t1.match(new RegExp("^" + l1.regexp.NUMBER));
                    if (!e1 && !r1) return null;
                    const n1 = r1 && r1[0] === t1;
                    if (e1 && e1[0] === t1 || !n1) return e1 ? {
                        number: e1[0],
                        length: e1[0].length
                    } : null;
                    return {
                        number: r1[0].replace(new RegExp(l1.regexp.DIGIT_GROUP, "g"), "X").replace(new RegExp(l1.regexp.DECIMAL_MARK, "g"), o1.LOCALE.MESSAGES.regexp.DECIMAL_MARK).replace(/X/g, o1.LOCALE.MESSAGES.regexp.DIGIT_GROUP.replace(/\\/g, "")),
                        length: r1[0].length
                    };
                }
            }
            e1.MathStore = l1, l1.regexp = {
                NUMBER: "((\\d{1,3})(?=(,| ))((,| )\\d{3})*(\\.\\d+)?)|^\\d*\\.\\d+|^\\d+",
                DECIMAL_MARK: "\\.",
                DIGIT_GROUP: ","
            };
        },
        4650: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.OutputError = e1.Precondition = e1.Action = e1.Component = e1.ActionType = e1.SpeechRule = void 0;
            const n1 = r1(5897), o1 = r1(2105);
            var i1;
            function s1(t1) {
                switch(t1){
                    case "[n]":
                        return i1.NODE;
                    case "[m]":
                        return i1.MULTI;
                    case "[t]":
                        return i1.TEXT;
                    case "[p]":
                        return i1.PERSONALITY;
                    default:
                        throw "Parse error: " + t1;
                }
            }
            e1.SpeechRule = class {
                constructor(t1, e1, r1, n1){
                    this.name = t1, this.dynamicCstr = e1, this.precondition = r1, this.action = n1, this.context = null;
                }
                toString() {
                    return this.name + " | " + this.dynamicCstr.toString() + " | " + this.precondition.toString() + " ==> " + this.action.toString();
                }
            }, function(t1) {
                t1.NODE = "NODE", t1.MULTI = "MULTI", t1.TEXT = "TEXT", t1.PERSONALITY = "PERSONALITY";
            }(i1 = e1.ActionType || (e1.ActionType = {}));
            class a1 {
                constructor({ type: t1, content: e1, attributes: r1, grammar: n1 }){
                    this.type = t1, this.content = e1, this.attributes = r1, this.grammar = n1;
                }
                static grammarFromString(t1) {
                    return o1.Grammar.parseInput(t1);
                }
                static fromString(t1) {
                    const e1 = {
                        type: s1(t1.substring(0, 3))
                    };
                    let r1 = t1.slice(3).trim();
                    if (!r1) throw new u1("Missing content.");
                    switch(e1.type){
                        case i1.TEXT:
                            if ('"' === r1[0]) {
                                const t1 = p1(r1, "\\(")[0].trim();
                                if ('"' !== t1.slice(-1)) throw new u1("Invalid string syntax.");
                                e1.content = t1, r1 = r1.slice(t1.length).trim(), -1 === r1.indexOf("(") && (r1 = "");
                                break;
                            }
                        case i1.NODE:
                        case i1.MULTI:
                            {
                                const t1 = r1.indexOf(" (");
                                if (-1 === t1) {
                                    e1.content = r1.trim(), r1 = "";
                                    break;
                                }
                                e1.content = r1.substring(0, t1).trim(), r1 = r1.slice(t1).trim();
                            }
                    }
                    if (r1) {
                        const t1 = a1.attributesFromString(r1);
                        t1.grammar && (e1.grammar = t1.grammar, delete t1.grammar), Object.keys(t1).length && (e1.attributes = t1);
                    }
                    return new a1(e1);
                }
                static attributesFromString(t1) {
                    if ("(" !== t1[0] || ")" !== t1.slice(-1)) throw new u1("Invalid attribute expression: " + t1);
                    const e1 = {}, r1 = p1(t1.slice(1, -1), ",");
                    for(let t1 = 0, n1 = r1.length; t1 < n1; t1++){
                        const n1 = r1[t1], i1 = n1.indexOf(":");
                        if (-1 === i1) e1[n1.trim()] = "true";
                        else {
                            const t1 = n1.substring(0, i1).trim(), r1 = n1.slice(i1 + 1).trim();
                            e1[t1] = t1 === o1.ATTRIBUTE ? a1.grammarFromString(r1) : r1;
                        }
                    }
                    return e1;
                }
                toString() {
                    let t1 = "";
                    t1 += function(t1) {
                        switch(t1){
                            case i1.NODE:
                                return "[n]";
                            case i1.MULTI:
                                return "[m]";
                            case i1.TEXT:
                                return "[t]";
                            case i1.PERSONALITY:
                                return "[p]";
                            default:
                                throw "Unknown type error: " + t1;
                        }
                    }(this.type), t1 += this.content ? " " + this.content : "";
                    const e1 = this.attributesToString();
                    return t1 += e1 ? " " + e1 : "", t1;
                }
                grammarToString() {
                    return this.getGrammar().join(":");
                }
                getGrammar() {
                    const t1 = [];
                    for(const e1 in this.grammar)!0 === this.grammar[e1] ? t1.push(e1) : !1 === this.grammar[e1] ? t1.push("!" + e1) : t1.push(e1 + "=" + this.grammar[e1]);
                    return t1;
                }
                attributesToString() {
                    const t1 = this.getAttributes(), e1 = this.grammarToString();
                    return e1 && t1.push("grammar:" + e1), t1.length > 0 ? "(" + t1.join(", ") + ")" : "";
                }
                getAttributes() {
                    const t1 = [];
                    for(const e1 in this.attributes){
                        const r1 = this.attributes[e1];
                        "true" === r1 ? t1.push(e1) : t1.push(e1 + ":" + r1);
                    }
                    return t1;
                }
            }
            e1.Component = a1;
            class l1 {
                constructor(t1){
                    this.components = t1;
                }
                static fromString(t1) {
                    const e1 = p1(t1, ";").filter(function(t1) {
                        return t1.match(/\S/);
                    }).map(function(t1) {
                        return t1.trim();
                    }), r1 = [];
                    for(let t1 = 0, n1 = e1.length; t1 < n1; t1++){
                        const n1 = a1.fromString(e1[t1]);
                        n1 && r1.push(n1);
                    }
                    return new l1(r1);
                }
                toString() {
                    return this.components.map(function(t1) {
                        return t1.toString();
                    }).join("; ");
                }
            }
            e1.Action = l1;
            class c1 {
                constructor(t1, ...e1){
                    this.query = t1, this.constraints = e1;
                    const [r1, n1] = this.presetPriority();
                    this.priority = r1 ? n1 : this.calculatePriority();
                }
                static constraintValue(t1, e1) {
                    for(let r1, n1 = 0; r1 = e1[n1]; n1++)if (t1.match(r1)) return ++n1;
                    return 0;
                }
                toString() {
                    const t1 = this.constraints.join(", ");
                    return `${this.query}, ${t1} (${this.priority}, ${this.rank})`;
                }
                calculatePriority() {
                    const t1 = c1.constraintValue(this.query, c1.queryPriorities);
                    if (!t1) return 0;
                    const e1 = this.query.match(/^self::.+\[(.+)\]/)[1];
                    return 100 * t1 + 10 * c1.constraintValue(e1, c1.attributePriorities);
                }
                presetPriority() {
                    if (!this.constraints.length) return [
                        !1,
                        0
                    ];
                    const t1 = this.constraints[this.constraints.length - 1].match(/^priority=(.*$)/);
                    if (!t1) return [
                        !1,
                        0
                    ];
                    this.constraints.pop();
                    const e1 = parseFloat(t1[1]);
                    return [
                        !0,
                        isNaN(e1) ? 0 : e1
                    ];
                }
            }
            e1.Precondition = c1, c1.queryPriorities = [
                /^self::\*\[.+\]$/,
                /^self::[\w-]+\[.+\]$/
            ], c1.attributePriorities = [
                /^@[\w-]+$/,
                /^@[\w-]+!=".+"$/,
                /^not\(contains\(@[\w-]+,\s*".+"\)\)$/,
                /^contains\(@[\w-]+,".+"\)$/,
                /^@[\w-]+=".+"$/
            ];
            class u1 extends n1.SREError {
                constructor(t1){
                    super(t1), this.name = "RuleError";
                }
            }
            function p1(t1, e1) {
                const r1 = [];
                let n1 = "";
                for(; "" !== t1;){
                    const o1 = t1.search(e1);
                    if (-1 === o1) {
                        if ((t1.match(/"/g) || []).length % 2 != 0) throw new u1("Invalid string in expression: " + t1);
                        r1.push(n1 + t1), n1 = "", t1 = "";
                    } else if ((t1.substring(0, o1).match(/"/g) || []).length % 2 == 0) r1.push(n1 + t1.substring(0, o1)), n1 = "", t1 = t1.substring(o1 + 1);
                    else {
                        const e1 = t1.substring(o1).search('"');
                        if (-1 === e1) throw new u1("Invalid string in expression: " + t1);
                        n1 += t1.substring(0, o1 + e1 + 1), t1 = t1.substring(o1 + e1 + 1);
                    }
                }
                return n1 && r1.push(n1), r1;
            }
            e1.OutputError = u1;
        },
        4106: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SpeechRuleContext = void 0;
            const n1 = r1(5274), o1 = r1(5662);
            e1.SpeechRuleContext = class {
                constructor(){
                    this.customQueries = new o1.CustomQueries, this.customStrings = new o1.CustomStrings, this.contextFunctions = new o1.ContextFunctions, this.customGenerators = new o1.CustomGenerators;
                }
                applyCustomQuery(t1, e1) {
                    const r1 = this.customQueries.lookup(e1);
                    return r1 ? r1(t1) : null;
                }
                applySelector(t1, e1) {
                    return this.applyCustomQuery(t1, e1) || n1.evalXPath(e1, t1);
                }
                applyQuery(t1, e1) {
                    const r1 = this.applySelector(t1, e1);
                    return r1.length > 0 ? r1[0] : null;
                }
                applyConstraint(t1, e1) {
                    return !!this.applyQuery(t1, e1) || n1.evaluateBoolean(e1, t1);
                }
                constructString(t1, e1) {
                    if (!e1) return "";
                    if ('"' === e1.charAt(0)) return e1.slice(1, -1);
                    const r1 = this.customStrings.lookup(e1);
                    return r1 ? r1(t1) : n1.evaluateString(e1, t1);
                }
                parse(t1) {
                    const e1 = Array.isArray(t1) ? t1 : Object.entries(t1);
                    for(let t1, r1 = 0; t1 = e1[r1]; r1++)switch(t1[0].slice(0, 3)){
                        case "CQF":
                            this.customQueries.add(t1[0], t1[1]);
                            break;
                        case "CSF":
                            this.customStrings.add(t1[0], t1[1]);
                            break;
                        case "CTF":
                            this.contextFunctions.add(t1[0], t1[1]);
                            break;
                        case "CGF":
                            this.customGenerators.add(t1[0], t1[1]);
                            break;
                        default:
                            console.error("FunctionError: Invalid function name " + t1[0]);
                    }
                }
            };
        },
        2362: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.storeFactory = e1.SpeechRuleEngine = void 0;
            const n1 = r1(7052), o1 = r1(2057), i1 = r1(5740), s1 = r1(5897), a1 = r1(4440), l1 = r1(5274), c1 = r1(7283), u1 = r1(7599), p1 = r1(2469), h1 = r1(1676), f1 = r1(2105), d1 = r1(9935), m1 = r1(4650), y1 = r1(4508);
            class g1 {
                constructor(){
                    this.trie = null, this.evaluators_ = {}, this.trie = new y1.Trie;
                }
                static getInstance() {
                    return g1.instance = g1.instance || new g1, g1.instance;
                }
                static debugSpeechRule(t1, e1) {
                    const r1 = t1.precondition, n1 = t1.context.applyQuery(e1, r1.query);
                    o1.Debugger.getInstance().output(r1.query, n1 ? n1.toString() : n1), r1.constraints.forEach((r1)=>o1.Debugger.getInstance().output(r1, t1.context.applyConstraint(e1, r1)));
                }
                static debugNamedSpeechRule(t1, e1) {
                    const r1 = g1.getInstance().trie.collectRules().filter((e1)=>e1.name == t1);
                    for(let n1, i1 = 0; n1 = r1[i1]; i1++)o1.Debugger.getInstance().output("Rule", t1, "DynamicCstr:", n1.dynamicCstr.toString(), "number", i1), g1.debugSpeechRule(n1, e1);
                }
                evaluateNode(t1) {
                    (0, l1.updateEvaluator)(t1);
                    const e1 = (new Date).getTime();
                    let r1 = [];
                    try {
                        r1 = this.evaluateNode_(t1);
                    } catch (t1) {
                        console.error("Something went wrong computing speech."), o1.Debugger.getInstance().output(t1);
                    }
                    const n1 = (new Date).getTime();
                    return o1.Debugger.getInstance().output("Time:", n1 - e1), r1;
                }
                toString() {
                    return this.trie.collectRules().map((t1)=>t1.toString()).join("\n");
                }
                runInSetting(t1, e1) {
                    const r1 = s1.default.getInstance(), n1 = {};
                    for(const e1 in t1)n1[e1] = r1[e1], r1[e1] = t1[e1];
                    r1.setDynamicCstr();
                    const o1 = e1();
                    for(const t1 in n1)r1[t1] = n1[t1];
                    return r1.setDynamicCstr(), o1;
                }
                addStore(t1) {
                    const e1 = v1(t1);
                    "abstract" !== e1.kind && e1.getSpeechRules().forEach((t1)=>this.trie.addRule(t1)), this.addEvaluator(e1);
                }
                processGrammar(t1, e1, r1) {
                    const n1 = {};
                    for(const o1 in r1){
                        const i1 = r1[o1];
                        n1[o1] = "string" == typeof i1 ? t1.constructString(e1, i1) : i1;
                    }
                    f1.Grammar.getInstance().pushState(n1);
                }
                addEvaluator(t1) {
                    const e1 = t1.evaluateDefault.bind(t1), r1 = this.evaluators_[t1.locale];
                    if (r1) return void (r1[t1.modality] = e1);
                    const n1 = {};
                    n1[t1.modality] = e1, this.evaluators_[t1.locale] = n1;
                }
                getEvaluator(t1, e1) {
                    const r1 = this.evaluators_[t1] || this.evaluators_[h1.DynamicCstr.DEFAULT_VALUES[h1.Axis.LOCALE]];
                    return r1[e1] || r1[h1.DynamicCstr.DEFAULT_VALUES[h1.Axis.MODALITY]];
                }
                enumerate(t1) {
                    return this.trie.enumerate(t1);
                }
                evaluateNode_(t1) {
                    return t1 ? (this.updateConstraint_(), this.evaluateTree_(t1)) : [];
                }
                evaluateTree_(t1) {
                    const e1 = s1.default.getInstance();
                    let r1;
                    o1.Debugger.getInstance().output(e1.mode !== a1.Mode.HTTP ? t1.toString() : t1), f1.Grammar.getInstance().setAttribute(t1);
                    const i1 = this.lookupRule(t1, e1.dynamicCstr);
                    if (!i1) return e1.strict ? [] : (r1 = this.getEvaluator(e1.locale, e1.modality)(t1), t1.attributes && this.addPersonality_(r1, {}, !1, t1), r1);
                    o1.Debugger.getInstance().generateOutput(()=>[
                            "Apply Rule:",
                            i1.name,
                            i1.dynamicCstr.toString(),
                            (e1.mode, a1.Mode.HTTP, t1).toString()
                        ]);
                    const c1 = i1.context, u1 = i1.action.components;
                    r1 = [];
                    for(let e1, o1 = 0; e1 = u1[o1]; o1++){
                        let o1 = [];
                        const i1 = e1.content || "", a1 = e1.attributes || {};
                        let u1 = !1;
                        e1.grammar && this.processGrammar(c1, t1, e1.grammar);
                        let p1 = null;
                        if (a1.engine) {
                            p1 = s1.default.getInstance().dynamicCstr.getComponents();
                            const t1 = f1.Grammar.parseInput(a1.engine);
                            s1.default.getInstance().setDynamicCstr(t1);
                        }
                        switch(e1.type){
                            case m1.ActionType.NODE:
                                {
                                    const e1 = c1.applyQuery(t1, i1);
                                    e1 && (o1 = this.evaluateTree_(e1));
                                }
                                break;
                            case m1.ActionType.MULTI:
                                {
                                    u1 = !0;
                                    const e1 = c1.applySelector(t1, i1);
                                    e1.length > 0 && (o1 = this.evaluateNodeList_(c1, e1, a1.sepFunc, c1.constructString(t1, a1.separator), a1.ctxtFunc, c1.constructString(t1, a1.context)));
                                }
                                break;
                            case m1.ActionType.TEXT:
                                {
                                    const e1 = a1.span, r1 = {};
                                    if (e1) {
                                        const n1 = (0, l1.evalXPath)(e1, t1);
                                        n1.length && (r1.extid = n1[0].getAttribute("extid"));
                                    }
                                    const s1 = c1.constructString(t1, i1);
                                    (s1 || "" === s1) && (o1 = Array.isArray(s1) ? s1.map(function(t1) {
                                        return n1.AuditoryDescription.create({
                                            text: t1.speech,
                                            attributes: t1.attributes
                                        }, {
                                            adjust: !0
                                        });
                                    }) : [
                                        n1.AuditoryDescription.create({
                                            text: s1,
                                            attributes: r1
                                        }, {
                                            adjust: !0
                                        })
                                    ]);
                                }
                                break;
                            case m1.ActionType.PERSONALITY:
                            default:
                                o1 = [
                                    n1.AuditoryDescription.create({
                                        text: i1
                                    })
                                ];
                        }
                        o1[0] && !u1 && (a1.context && (o1[0].context = c1.constructString(t1, a1.context) + (o1[0].context || "")), a1.annotation && (o1[0].annotation = a1.annotation)), this.addLayout(o1, a1, u1), e1.grammar && f1.Grammar.getInstance().popState(), r1 = r1.concat(this.addPersonality_(o1, a1, u1, t1)), p1 && s1.default.getInstance().setDynamicCstr(p1);
                    }
                    return r1;
                }
                evaluateNodeList_(t1, e1, r1, o1, i1, s1) {
                    if (!e1.length) return [];
                    const a1 = o1 || "", l1 = s1 || "", c1 = t1.contextFunctions.lookup(i1), u1 = c1 ? c1(e1, l1) : function() {
                        return l1;
                    }, p1 = t1.contextFunctions.lookup(r1), h1 = p1 ? p1(e1, a1) : function() {
                        return [
                            n1.AuditoryDescription.create({
                                text: a1
                            }, {
                                translate: !0
                            })
                        ];
                    };
                    let f1 = [];
                    for(let t1, r1 = 0; t1 = e1[r1]; r1++){
                        const n1 = this.evaluateTree_(t1);
                        if (n1.length > 0 && (n1[0].context = u1() + (n1[0].context || ""), f1 = f1.concat(n1), r1 < e1.length - 1)) {
                            const t1 = h1();
                            f1 = f1.concat(t1);
                        }
                    }
                    return f1;
                }
                addLayout(t1, e1, r1) {
                    const o1 = e1.layout;
                    o1 && (o1.match(/^begin/) ? t1.unshift(new n1.AuditoryDescription({
                        text: "",
                        layout: o1
                    })) : o1.match(/^end/) ? t1.push(new n1.AuditoryDescription({
                        text: "",
                        layout: o1
                    })) : (t1.unshift(new n1.AuditoryDescription({
                        text: "",
                        layout: `begin${o1}`
                    })), t1.push(new n1.AuditoryDescription({
                        text: "",
                        layout: `end${o1}`
                    }))));
                }
                addPersonality_(t1, e1, r1, o1) {
                    const i1 = {};
                    let s1 = null;
                    for (const t1 of a1.personalityPropList){
                        const r1 = e1[t1];
                        if (void 0 === r1) continue;
                        const n1 = parseFloat(r1), o1 = isNaN(n1) ? '"' === r1.charAt(0) ? r1.slice(1, -1) : r1 : n1;
                        t1 === a1.personalityProps.PAUSE ? s1 = o1 : i1[t1] = o1;
                    }
                    for(let e1, r1 = 0; e1 = t1[r1]; r1++)this.addRelativePersonality_(e1, i1), this.addExternalAttributes_(e1, o1);
                    if (r1 && t1.length && delete t1[t1.length - 1].personality[a1.personalityProps.JOIN], s1 && t1.length) {
                        const e1 = t1[t1.length - 1];
                        e1.text || Object.keys(e1.personality).length ? t1.push(n1.AuditoryDescription.create({
                            text: "",
                            personality: {
                                pause: s1
                            }
                        })) : e1.personality[a1.personalityProps.PAUSE] = s1;
                    }
                    return t1;
                }
                addExternalAttributes_(t1, e1) {
                    if (e1.hasAttributes()) {
                        const r1 = e1.attributes;
                        for(let e1 = r1.length - 1; e1 >= 0; e1--){
                            const n1 = r1[e1].name;
                            !t1.attributes[n1] && n1.match(/^ext/) && (t1.attributes[n1] = r1[e1].value);
                        }
                    }
                }
                addRelativePersonality_(t1, e1) {
                    if (!t1.personality) return t1.personality = e1, t1;
                    const r1 = t1.personality;
                    for(const t1 in e1)r1[t1] && "number" == typeof r1[t1] && "number" == typeof e1[t1] ? r1[t1] = r1[t1] + e1[t1] : r1[t1] || (r1[t1] = e1[t1]);
                    return t1;
                }
                updateConstraint_() {
                    const t1 = s1.default.getInstance().dynamicCstr, e1 = s1.default.getInstance().strict, r1 = this.trie, n1 = {};
                    let o1 = t1.getValue(h1.Axis.LOCALE), i1 = t1.getValue(h1.Axis.MODALITY), a1 = t1.getValue(h1.Axis.DOMAIN);
                    r1.hasSubtrie([
                        o1,
                        i1,
                        a1
                    ]) || (a1 = h1.DynamicCstr.DEFAULT_VALUES[h1.Axis.DOMAIN], r1.hasSubtrie([
                        o1,
                        i1,
                        a1
                    ]) || (i1 = h1.DynamicCstr.DEFAULT_VALUES[h1.Axis.MODALITY], r1.hasSubtrie([
                        o1,
                        i1,
                        a1
                    ]) || (o1 = h1.DynamicCstr.DEFAULT_VALUES[h1.Axis.LOCALE]))), n1[h1.Axis.LOCALE] = [
                        o1
                    ], n1[h1.Axis.MODALITY] = [
                        "summary" !== i1 ? i1 : h1.DynamicCstr.DEFAULT_VALUES[h1.Axis.MODALITY]
                    ], n1[h1.Axis.DOMAIN] = [
                        "speech" !== i1 ? h1.DynamicCstr.DEFAULT_VALUES[h1.Axis.DOMAIN] : a1
                    ];
                    const l1 = t1.getOrder();
                    for(let r1, o1 = 0; r1 = l1[o1]; o1++)if (!n1[r1]) {
                        const o1 = t1.getValue(r1), i1 = this.makeSet_(o1, t1.preference), s1 = h1.DynamicCstr.DEFAULT_VALUES[r1];
                        e1 || o1 === s1 || i1.push(s1), n1[r1] = i1;
                    }
                    t1.updateProperties(n1);
                }
                makeSet_(t1, e1) {
                    return e1 && Object.keys(e1).length ? t1.split(":") : [
                        t1
                    ];
                }
                lookupRule(t1, e1) {
                    if (!t1 || t1.nodeType !== i1.NodeType.ELEMENT_NODE && t1.nodeType !== i1.NodeType.TEXT_NODE) return null;
                    const r1 = this.lookupRules(t1, e1);
                    return r1.length > 0 ? this.pickMostConstraint_(e1, r1) : null;
                }
                lookupRules(t1, e1) {
                    return this.trie.lookupRules(t1, e1.allProperties());
                }
                pickMostConstraint_(t1, e1) {
                    const r1 = s1.default.getInstance().comparator;
                    return e1.sort(function(t1, e1) {
                        return r1.compare(t1.dynamicCstr, e1.dynamicCstr) || e1.precondition.priority - t1.precondition.priority || e1.precondition.constraints.length - t1.precondition.constraints.length || e1.precondition.rank - t1.precondition.rank;
                    }), o1.Debugger.getInstance().generateOutput((()=>e1.map((t1)=>t1.name + "(" + t1.dynamicCstr.toString() + ")")).bind(this)), e1[0];
                }
            }
            e1.SpeechRuleEngine = g1;
            const b1 = new Map;
            function v1(t1) {
                const e1 = `${t1.locale}.${t1.modality}.${t1.domain}`;
                if ("actions" === t1.kind) {
                    const r1 = b1.get(e1);
                    return r1.parse(t1), r1;
                }
                u1.init(), t1 && !t1.functions && (t1.functions = c1.getStore(t1.locale, t1.modality, t1.domain));
                const r1 = "braille" === t1.modality ? new p1.BrailleStore : new d1.MathStore;
                return b1.set(e1, r1), t1.inherits && (r1.inherits = b1.get(`${t1.inherits}.${t1.modality}.${t1.domain}`)), r1.parse(t1), r1.initialize(), r1;
            }
            e1.storeFactory = v1, s1.default.nodeEvaluator = g1.getInstance().evaluateNode.bind(g1.getInstance());
        },
        5662: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.CustomGenerators = e1.ContextFunctions = e1.CustomStrings = e1.CustomQueries = void 0;
            class r1 {
                constructor(t1, e1){
                    this.prefix = t1, this.store = e1;
                }
                add(t1, e1) {
                    this.checkCustomFunctionSyntax_(t1) && (this.store[t1] = e1);
                }
                addStore(t1) {
                    const e1 = Object.keys(t1.store);
                    for(let r1, n1 = 0; r1 = e1[n1]; n1++)this.add(r1, t1.store[r1]);
                }
                lookup(t1) {
                    return this.store[t1];
                }
                checkCustomFunctionSyntax_(t1) {
                    const e1 = new RegExp("^" + this.prefix);
                    return !!t1.match(e1) || (console.error("FunctionError: Invalid function name. Expected prefix " + this.prefix), !1);
                }
            }
            e1.CustomQueries = class extends r1 {
                constructor(){
                    super("CQF", {});
                }
            };
            e1.CustomStrings = class extends r1 {
                constructor(){
                    super("CSF", {});
                }
            };
            e1.ContextFunctions = class extends r1 {
                constructor(){
                    super("CTF", {});
                }
            };
            e1.CustomGenerators = class extends r1 {
                constructor(){
                    super("CGF", {});
                }
            };
        },
        365: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.contentIterator = e1.pauseSeparator = e1.nodeCounter = void 0;
            const n1 = r1(7052), o1 = r1(5274), i1 = r1(5897);
            e1.nodeCounter = function(t1, e1) {
                const r1 = t1.length;
                let n1 = 0, o1 = e1;
                return e1 || (o1 = ""), function() {
                    return n1 < r1 && (n1 += 1), o1 + " " + n1;
                };
            }, e1.pauseSeparator = function(t1, e1) {
                const r1 = parseFloat(e1), o1 = isNaN(r1) ? e1 : r1;
                return function() {
                    return [
                        n1.AuditoryDescription.create({
                            text: "",
                            personality: {
                                pause: o1
                            }
                        })
                    ];
                };
            }, e1.contentIterator = function(t1, e1) {
                let r1;
                return r1 = t1.length > 0 ? o1.evalXPath("../../content/*", t1[0]) : [], function() {
                    const t1 = r1.shift(), o1 = e1 ? [
                        n1.AuditoryDescription.create({
                            text: e1
                        }, {
                            translate: !0
                        })
                    ] : [];
                    if (!t1) return o1;
                    const s1 = i1.default.evaluateNode(t1);
                    return o1.concat(s1);
                };
            };
        },
        1414: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.getTreeFromString = e1.getTree = e1.xmlTree = void 0;
            const n1 = r1(5740), o1 = r1(7075);
            function i1(t1) {
                return new o1.SemanticTree(t1);
            }
            e1.xmlTree = function(t1) {
                return i1(t1).xml();
            }, e1.getTree = i1, e1.getTreeFromString = function(t1) {
                return i1(n1.parseInput(t1));
            };
        },
        7630: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.annotate = e1.activate = e1.register = e1.visitors = e1.annotators = void 0;
            const n1 = r1(9265);
            e1.annotators = new Map, e1.visitors = new Map, e1.register = function(t1) {
                const r1 = t1.domain + ":" + t1.name;
                t1 instanceof n1.SemanticAnnotator ? e1.annotators.set(r1, t1) : e1.visitors.set(r1, t1);
            }, e1.activate = function(t1, r1) {
                const n1 = t1 + ":" + r1, o1 = e1.annotators.get(n1) || e1.visitors.get(n1);
                o1 && (o1.active = !0);
            }, e1.annotate = function(t1) {
                for (const r1 of e1.annotators.values())r1.active && r1.annotate(t1);
                for (const r1 of e1.visitors.values())r1.active && r1.visit(t1, Object.assign({}, r1.def));
            };
        },
        9265: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticVisitor = e1.SemanticAnnotator = void 0;
            e1.SemanticAnnotator = class {
                constructor(t1, e1, r1){
                    this.domain = t1, this.name = e1, this.func = r1, this.active = !1;
                }
                annotate(t1) {
                    t1.childNodes.forEach(this.annotate.bind(this)), t1.addAnnotation(this.domain, this.func(t1));
                }
            };
            e1.SemanticVisitor = class {
                constructor(t1, e1, r1, n1 = {}){
                    this.domain = t1, this.name = e1, this.func = r1, this.def = n1, this.active = !1;
                }
                visit(t1, e1) {
                    let r1 = this.func(t1, e1);
                    t1.addAnnotation(this.domain, r1[0]);
                    for(let e1, n1 = 0; e1 = t1.childNodes[n1]; n1++)r1 = this.visit(e1, r1[1]);
                    return r1;
                }
            };
        },
        3588: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.lookupSecondary = e1.isEmbellishedType = e1.isMatchingFence = e1.functionApplication = e1.invisibleComma = e1.invisiblePlus = e1.invisibleTimes = e1.lookupMeaning = e1.lookupRole = e1.lookupType = e1.equal = e1.allLettersRegExp = void 0;
            const r1 = String.fromCodePoint(8291), n1 = [
                "，",
                "﹐",
                ",",
                r1
            ], o1 = [
                "\xaf",
                "‒",
                "–",
                "—",
                "―",
                "﹘",
                "-",
                "⁻",
                "₋",
                "−",
                "➖",
                "﹣",
                "－",
                "‐",
                "‑",
                "‾",
                "_"
            ], i1 = [
                "~",
                "̃",
                "∼",
                "˜",
                "∽",
                "˷",
                "̴",
                "̰"
            ], s1 = {
                "(": ")",
                "[": "]",
                "{": "}",
                "⁅": "⁆",
                "〈": "〉",
                "❨": "❩",
                "❪": "❫",
                "❬": "❭",
                "❮": "❯",
                "❰": "❱",
                "❲": "❳",
                "❴": "❵",
                "⟅": "⟆",
                "⟦": "⟧",
                "⟨": "⟩",
                "⟪": "⟫",
                "⟬": "⟭",
                "⟮": "⟯",
                "⦃": "⦄",
                "⦅": "⦆",
                "⦇": "⦈",
                "⦉": "⦊",
                "⦋": "⦌",
                "⦍": "⦎",
                "⦏": "⦐",
                "⦑": "⦒",
                "⦓": "⦔",
                "⦕": "⦖",
                "⦗": "⦘",
                "⧘": "⧙",
                "⧚": "⧛",
                "⧼": "⧽",
                "⸢": "⸣",
                "⸤": "⸥",
                "⸦": "⸧",
                "⸨": "⸩",
                "〈": "〉",
                "《": "》",
                "「": "」",
                "『": "』",
                "【": "】",
                "〔": "〕",
                "〖": "〗",
                "〘": "〙",
                "〚": "〛",
                "〝": "〞",
                "﴾": "﴿",
                "︗": "︘",
                "﹙": "﹚",
                "﹛": "﹜",
                "﹝": "﹞",
                "（": "）",
                "［": "］",
                "｛": "｝",
                "｟": "｠",
                "｢": "｣",
                "⌈": "⌉",
                "⌊": "⌋",
                "⌌": "⌍",
                "⌎": "⌏",
                "⌜": "⌝",
                "⌞": "⌟",
                "⎛": "⎞",
                "⎜": "⎟",
                "⎝": "⎠",
                "⎡": "⎤",
                "⎢": "⎥",
                "⎣": "⎦",
                "⎧": "⎫",
                "⎨": "⎬",
                "⎩": "⎭",
                "⎰": "⎱",
                "⎸": "⎹"
            }, a1 = {
                "⎴": "⎵",
                "⏜": "⏝",
                "⏞": "⏟",
                "⏠": "⏡",
                "︵": "︶",
                "︷": "︸",
                "︹": "︺",
                "︻": "︼",
                "︽": "︾",
                "︿": "﹀",
                "﹁": "﹂",
                "﹃": "﹄",
                "﹇": "﹈"
            }, l1 = Object.keys(s1), c1 = Object.values(s1);
            c1.push("〟");
            const u1 = Object.keys(a1), p1 = Object.values(a1), h1 = [
                "|",
                "\xa6",
                "∣",
                "⏐",
                "⎸",
                "⎹",
                "❘",
                "｜",
                "￤",
                "︱",
                "︲"
            ], f1 = [
                "‖",
                "∥",
                "⦀",
                "⫴"
            ], d1 = [
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z"
            ], m1 = [
                "a",
                "b",
                "c",
                "d",
                "e",
                "f",
                "g",
                "h",
                "i",
                "j",
                "k",
                "l",
                "m",
                "n",
                "o",
                "p",
                "q",
                "r",
                "s",
                "t",
                "u",
                "v",
                "w",
                "x",
                "y",
                "z",
                "ı",
                "ȷ"
            ], y1 = [
                "Ａ",
                "Ｂ",
                "Ｃ",
                "Ｄ",
                "Ｅ",
                "Ｆ",
                "Ｇ",
                "Ｈ",
                "Ｉ",
                "Ｊ",
                "Ｋ",
                "Ｌ",
                "Ｍ",
                "Ｎ",
                "Ｏ",
                "Ｐ",
                "Ｑ",
                "Ｒ",
                "Ｓ",
                "Ｔ",
                "Ｕ",
                "Ｖ",
                "Ｗ",
                "Ｘ",
                "Ｙ",
                "Ｚ"
            ], g1 = [
                "ａ",
                "ｂ",
                "ｃ",
                "ｄ",
                "ｅ",
                "ｆ",
                "ｇ",
                "ｈ",
                "ｉ",
                "ｊ",
                "ｋ",
                "ｌ",
                "ｍ",
                "ｎ",
                "ｏ",
                "ｐ",
                "ｑ",
                "ｒ",
                "ｓ",
                "ｔ",
                "ｕ",
                "ｖ",
                "ｗ",
                "ｘ",
                "ｙ",
                "ｚ"
            ], b1 = [
                "\ud835\udc00",
                "\ud835\udc01",
                "\ud835\udc02",
                "\ud835\udc03",
                "\ud835\udc04",
                "\ud835\udc05",
                "\ud835\udc06",
                "\ud835\udc07",
                "\ud835\udc08",
                "\ud835\udc09",
                "\ud835\udc0a",
                "\ud835\udc0b",
                "\ud835\udc0c",
                "\ud835\udc0d",
                "\ud835\udc0e",
                "\ud835\udc0f",
                "\ud835\udc10",
                "\ud835\udc11",
                "\ud835\udc12",
                "\ud835\udc13",
                "\ud835\udc14",
                "\ud835\udc15",
                "\ud835\udc16",
                "\ud835\udc17",
                "\ud835\udc18",
                "\ud835\udc19"
            ], v1 = [
                "\ud835\udc1a",
                "\ud835\udc1b",
                "\ud835\udc1c",
                "\ud835\udc1d",
                "\ud835\udc1e",
                "\ud835\udc1f",
                "\ud835\udc20",
                "\ud835\udc21",
                "\ud835\udc22",
                "\ud835\udc23",
                "\ud835\udc24",
                "\ud835\udc25",
                "\ud835\udc26",
                "\ud835\udc27",
                "\ud835\udc28",
                "\ud835\udc29",
                "\ud835\udc2a",
                "\ud835\udc2b",
                "\ud835\udc2c",
                "\ud835\udc2d",
                "\ud835\udc2e",
                "\ud835\udc2f",
                "\ud835\udc30",
                "\ud835\udc31",
                "\ud835\udc32",
                "\ud835\udc33"
            ], _1 = [
                "\ud835\udc34",
                "\ud835\udc35",
                "\ud835\udc36",
                "\ud835\udc37",
                "\ud835\udc38",
                "\ud835\udc39",
                "\ud835\udc3a",
                "\ud835\udc3b",
                "\ud835\udc3c",
                "\ud835\udc3d",
                "\ud835\udc3e",
                "\ud835\udc3f",
                "\ud835\udc40",
                "\ud835\udc41",
                "\ud835\udc42",
                "\ud835\udc43",
                "\ud835\udc44",
                "\ud835\udc45",
                "\ud835\udc46",
                "\ud835\udc47",
                "\ud835\udc48",
                "\ud835\udc49",
                "\ud835\udc4a",
                "\ud835\udc4b",
                "\ud835\udc4c",
                "\ud835\udc4d"
            ], S1 = [
                "\ud835\udc4e",
                "\ud835\udc4f",
                "\ud835\udc50",
                "\ud835\udc51",
                "\ud835\udc52",
                "\ud835\udc53",
                "\ud835\udc54",
                "ℎ",
                "\ud835\udc56",
                "\ud835\udc57",
                "\ud835\udc58",
                "\ud835\udc59",
                "\ud835\udc5a",
                "\ud835\udc5b",
                "\ud835\udc5c",
                "\ud835\udc5d",
                "\ud835\udc5e",
                "\ud835\udc5f",
                "\ud835\udc60",
                "\ud835\udc61",
                "\ud835\udc62",
                "\ud835\udc63",
                "\ud835\udc64",
                "\ud835\udc65",
                "\ud835\udc66",
                "\ud835\udc67",
                "\ud835\udea4",
                "\ud835\udea5"
            ], O1 = [
                "\ud835\udc68",
                "\ud835\udc69",
                "\ud835\udc6a",
                "\ud835\udc6b",
                "\ud835\udc6c",
                "\ud835\udc6d",
                "\ud835\udc6e",
                "\ud835\udc6f",
                "\ud835\udc70",
                "\ud835\udc71",
                "\ud835\udc72",
                "\ud835\udc73",
                "\ud835\udc74",
                "\ud835\udc75",
                "\ud835\udc76",
                "\ud835\udc77",
                "\ud835\udc78",
                "\ud835\udc79",
                "\ud835\udc7a",
                "\ud835\udc7b",
                "\ud835\udc7c",
                "\ud835\udc7d",
                "\ud835\udc7e",
                "\ud835\udc7f",
                "\ud835\udc80",
                "\ud835\udc81"
            ], M1 = [
                "\ud835\udc82",
                "\ud835\udc83",
                "\ud835\udc84",
                "\ud835\udc85",
                "\ud835\udc86",
                "\ud835\udc87",
                "\ud835\udc88",
                "\ud835\udc89",
                "\ud835\udc8a",
                "\ud835\udc8b",
                "\ud835\udc8c",
                "\ud835\udc8d",
                "\ud835\udc8e",
                "\ud835\udc8f",
                "\ud835\udc90",
                "\ud835\udc91",
                "\ud835\udc92",
                "\ud835\udc93",
                "\ud835\udc94",
                "\ud835\udc95",
                "\ud835\udc96",
                "\ud835\udc97",
                "\ud835\udc98",
                "\ud835\udc99",
                "\ud835\udc9a",
                "\ud835\udc9b"
            ], x1 = [
                "\ud835\udc9c",
                "ℬ",
                "\ud835\udc9e",
                "\ud835\udc9f",
                "ℰ",
                "ℱ",
                "\ud835\udca2",
                "ℋ",
                "ℐ",
                "\ud835\udca5",
                "\ud835\udca6",
                "ℒ",
                "ℳ",
                "\ud835\udca9",
                "\ud835\udcaa",
                "\ud835\udcab",
                "\ud835\udcac",
                "ℛ",
                "\ud835\udcae",
                "\ud835\udcaf",
                "\ud835\udcb0",
                "\ud835\udcb1",
                "\ud835\udcb2",
                "\ud835\udcb3",
                "\ud835\udcb4",
                "\ud835\udcb5",
                "℘"
            ], E1 = [
                "\ud835\udcb6",
                "\ud835\udcb7",
                "\ud835\udcb8",
                "\ud835\udcb9",
                "ℯ",
                "\ud835\udcbb",
                "ℊ",
                "\ud835\udcbd",
                "\ud835\udcbe",
                "\ud835\udcbf",
                "\ud835\udcc0",
                "\ud835\udcc1",
                "\ud835\udcc2",
                "\ud835\udcc3",
                "ℴ",
                "\ud835\udcc5",
                "\ud835\udcc6",
                "\ud835\udcc7",
                "\ud835\udcc8",
                "\ud835\udcc9",
                "\ud835\udcca",
                "\ud835\udccb",
                "\ud835\udccc",
                "\ud835\udccd",
                "\ud835\udcce",
                "\ud835\udccf",
                "ℓ"
            ], A1 = [
                "\ud835\udcd0",
                "\ud835\udcd1",
                "\ud835\udcd2",
                "\ud835\udcd3",
                "\ud835\udcd4",
                "\ud835\udcd5",
                "\ud835\udcd6",
                "\ud835\udcd7",
                "\ud835\udcd8",
                "\ud835\udcd9",
                "\ud835\udcda",
                "\ud835\udcdb",
                "\ud835\udcdc",
                "\ud835\udcdd",
                "\ud835\udcde",
                "\ud835\udcdf",
                "\ud835\udce0",
                "\ud835\udce1",
                "\ud835\udce2",
                "\ud835\udce3",
                "\ud835\udce4",
                "\ud835\udce5",
                "\ud835\udce6",
                "\ud835\udce7",
                "\ud835\udce8",
                "\ud835\udce9"
            ], C1 = [
                "\ud835\udcea",
                "\ud835\udceb",
                "\ud835\udcec",
                "\ud835\udced",
                "\ud835\udcee",
                "\ud835\udcef",
                "\ud835\udcf0",
                "\ud835\udcf1",
                "\ud835\udcf2",
                "\ud835\udcf3",
                "\ud835\udcf4",
                "\ud835\udcf5",
                "\ud835\udcf6",
                "\ud835\udcf7",
                "\ud835\udcf8",
                "\ud835\udcf9",
                "\ud835\udcfa",
                "\ud835\udcfb",
                "\ud835\udcfc",
                "\ud835\udcfd",
                "\ud835\udcfe",
                "\ud835\udcff",
                "\ud835\udd00",
                "\ud835\udd01",
                "\ud835\udd02",
                "\ud835\udd03"
            ], T1 = [
                "\ud835\udd04",
                "\ud835\udd05",
                "ℭ",
                "\ud835\udd07",
                "\ud835\udd08",
                "\ud835\udd09",
                "\ud835\udd0a",
                "ℌ",
                "ℑ",
                "\ud835\udd0d",
                "\ud835\udd0e",
                "\ud835\udd0f",
                "\ud835\udd10",
                "\ud835\udd11",
                "\ud835\udd12",
                "\ud835\udd13",
                "\ud835\udd14",
                "ℜ",
                "\ud835\udd16",
                "\ud835\udd17",
                "\ud835\udd18",
                "\ud835\udd19",
                "\ud835\udd1a",
                "\ud835\udd1b",
                "\ud835\udd1c",
                "ℨ"
            ], N1 = [
                "\ud835\udd1e",
                "\ud835\udd1f",
                "\ud835\udd20",
                "\ud835\udd21",
                "\ud835\udd22",
                "\ud835\udd23",
                "\ud835\udd24",
                "\ud835\udd25",
                "\ud835\udd26",
                "\ud835\udd27",
                "\ud835\udd28",
                "\ud835\udd29",
                "\ud835\udd2a",
                "\ud835\udd2b",
                "\ud835\udd2c",
                "\ud835\udd2d",
                "\ud835\udd2e",
                "\ud835\udd2f",
                "\ud835\udd30",
                "\ud835\udd31",
                "\ud835\udd32",
                "\ud835\udd33",
                "\ud835\udd34",
                "\ud835\udd35",
                "\ud835\udd36",
                "\ud835\udd37"
            ], w1 = [
                "\ud835\udd38",
                "\ud835\udd39",
                "ℂ",
                "\ud835\udd3b",
                "\ud835\udd3c",
                "\ud835\udd3d",
                "\ud835\udd3e",
                "ℍ",
                "\ud835\udd40",
                "\ud835\udd41",
                "\ud835\udd42",
                "\ud835\udd43",
                "\ud835\udd44",
                "ℕ",
                "\ud835\udd46",
                "ℙ",
                "ℚ",
                "ℝ",
                "\ud835\udd4a",
                "\ud835\udd4b",
                "\ud835\udd4c",
                "\ud835\udd4d",
                "\ud835\udd4e",
                "\ud835\udd4f",
                "\ud835\udd50",
                "ℤ"
            ], L1 = [
                "\ud835\udd52",
                "\ud835\udd53",
                "\ud835\udd54",
                "\ud835\udd55",
                "\ud835\udd56",
                "\ud835\udd57",
                "\ud835\udd58",
                "\ud835\udd59",
                "\ud835\udd5a",
                "\ud835\udd5b",
                "\ud835\udd5c",
                "\ud835\udd5d",
                "\ud835\udd5e",
                "\ud835\udd5f",
                "\ud835\udd60",
                "\ud835\udd61",
                "\ud835\udd62",
                "\ud835\udd63",
                "\ud835\udd64",
                "\ud835\udd65",
                "\ud835\udd66",
                "\ud835\udd67",
                "\ud835\udd68",
                "\ud835\udd69",
                "\ud835\udd6a",
                "\ud835\udd6b"
            ], I1 = [
                "\ud835\udd6c",
                "\ud835\udd6d",
                "\ud835\udd6e",
                "\ud835\udd6f",
                "\ud835\udd70",
                "\ud835\udd71",
                "\ud835\udd72",
                "\ud835\udd73",
                "\ud835\udd74",
                "\ud835\udd75",
                "\ud835\udd76",
                "\ud835\udd77",
                "\ud835\udd78",
                "\ud835\udd79",
                "\ud835\udd7a",
                "\ud835\udd7b",
                "\ud835\udd7c",
                "\ud835\udd7d",
                "\ud835\udd7e",
                "\ud835\udd7f",
                "\ud835\udd80",
                "\ud835\udd81",
                "\ud835\udd82",
                "\ud835\udd83",
                "\ud835\udd84",
                "\ud835\udd85"
            ], P1 = [
                "\ud835\udd86",
                "\ud835\udd87",
                "\ud835\udd88",
                "\ud835\udd89",
                "\ud835\udd8a",
                "\ud835\udd8b",
                "\ud835\udd8c",
                "\ud835\udd8d",
                "\ud835\udd8e",
                "\ud835\udd8f",
                "\ud835\udd90",
                "\ud835\udd91",
                "\ud835\udd92",
                "\ud835\udd93",
                "\ud835\udd94",
                "\ud835\udd95",
                "\ud835\udd96",
                "\ud835\udd97",
                "\ud835\udd98",
                "\ud835\udd99",
                "\ud835\udd9a",
                "\ud835\udd9b",
                "\ud835\udd9c",
                "\ud835\udd9d",
                "\ud835\udd9e",
                "\ud835\udd9f"
            ], R1 = [
                "\ud835\udda0",
                "\ud835\udda1",
                "\ud835\udda2",
                "\ud835\udda3",
                "\ud835\udda4",
                "\ud835\udda5",
                "\ud835\udda6",
                "\ud835\udda7",
                "\ud835\udda8",
                "\ud835\udda9",
                "\ud835\uddaa",
                "\ud835\uddab",
                "\ud835\uddac",
                "\ud835\uddad",
                "\ud835\uddae",
                "\ud835\uddaf",
                "\ud835\uddb0",
                "\ud835\uddb1",
                "\ud835\uddb2",
                "\ud835\uddb3",
                "\ud835\uddb4",
                "\ud835\uddb5",
                "\ud835\uddb6",
                "\ud835\uddb7",
                "\ud835\uddb8",
                "\ud835\uddb9"
            ], k1 = [
                "\ud835\uddba",
                "\ud835\uddbb",
                "\ud835\uddbc",
                "\ud835\uddbd",
                "\ud835\uddbe",
                "\ud835\uddbf",
                "\ud835\uddc0",
                "\ud835\uddc1",
                "\ud835\uddc2",
                "\ud835\uddc3",
                "\ud835\uddc4",
                "\ud835\uddc5",
                "\ud835\uddc6",
                "\ud835\uddc7",
                "\ud835\uddc8",
                "\ud835\uddc9",
                "\ud835\uddca",
                "\ud835\uddcb",
                "\ud835\uddcc",
                "\ud835\uddcd",
                "\ud835\uddce",
                "\ud835\uddcf",
                "\ud835\uddd0",
                "\ud835\uddd1",
                "\ud835\uddd2",
                "\ud835\uddd3"
            ], j1 = [
                "\ud835\uddd4",
                "\ud835\uddd5",
                "\ud835\uddd6",
                "\ud835\uddd7",
                "\ud835\uddd8",
                "\ud835\uddd9",
                "\ud835\uddda",
                "\ud835\udddb",
                "\ud835\udddc",
                "\ud835\udddd",
                "\ud835\uddde",
                "\ud835\udddf",
                "\ud835\udde0",
                "\ud835\udde1",
                "\ud835\udde2",
                "\ud835\udde3",
                "\ud835\udde4",
                "\ud835\udde5",
                "\ud835\udde6",
                "\ud835\udde7",
                "\ud835\udde8",
                "\ud835\udde9",
                "\ud835\uddea",
                "\ud835\uddeb",
                "\ud835\uddec",
                "\ud835\udded"
            ], B1 = [
                "\ud835\uddee",
                "\ud835\uddef",
                "\ud835\uddf0",
                "\ud835\uddf1",
                "\ud835\uddf2",
                "\ud835\uddf3",
                "\ud835\uddf4",
                "\ud835\uddf5",
                "\ud835\uddf6",
                "\ud835\uddf7",
                "\ud835\uddf8",
                "\ud835\uddf9",
                "\ud835\uddfa",
                "\ud835\uddfb",
                "\ud835\uddfc",
                "\ud835\uddfd",
                "\ud835\uddfe",
                "\ud835\uddff",
                "\ud835\ude00",
                "\ud835\ude01",
                "\ud835\ude02",
                "\ud835\ude03",
                "\ud835\ude04",
                "\ud835\ude05",
                "\ud835\ude06",
                "\ud835\ude07"
            ], D1 = [
                "\ud835\ude08",
                "\ud835\ude09",
                "\ud835\ude0a",
                "\ud835\ude0b",
                "\ud835\ude0c",
                "\ud835\ude0d",
                "\ud835\ude0e",
                "\ud835\ude0f",
                "\ud835\ude10",
                "\ud835\ude11",
                "\ud835\ude12",
                "\ud835\ude13",
                "\ud835\ude14",
                "\ud835\ude15",
                "\ud835\ude16",
                "\ud835\ude17",
                "\ud835\ude18",
                "\ud835\ude19",
                "\ud835\ude1a",
                "\ud835\ude1b",
                "\ud835\ude1c",
                "\ud835\ude1d",
                "\ud835\ude1e",
                "\ud835\ude1f",
                "\ud835\ude20",
                "\ud835\ude21"
            ], F1 = [
                "\ud835\ude22",
                "\ud835\ude23",
                "\ud835\ude24",
                "\ud835\ude25",
                "\ud835\ude26",
                "\ud835\ude27",
                "\ud835\ude28",
                "\ud835\ude29",
                "\ud835\ude2a",
                "\ud835\ude2b",
                "\ud835\ude2c",
                "\ud835\ude2d",
                "\ud835\ude2e",
                "\ud835\ude2f",
                "\ud835\ude30",
                "\ud835\ude31",
                "\ud835\ude32",
                "\ud835\ude33",
                "\ud835\ude34",
                "\ud835\ude35",
                "\ud835\ude36",
                "\ud835\ude37",
                "\ud835\ude38",
                "\ud835\ude39",
                "\ud835\ude3a",
                "\ud835\ude3b"
            ], H1 = [
                "\ud835\ude3c",
                "\ud835\ude3d",
                "\ud835\ude3e",
                "\ud835\ude3f",
                "\ud835\ude40",
                "\ud835\ude41",
                "\ud835\ude42",
                "\ud835\ude43",
                "\ud835\ude44",
                "\ud835\ude45",
                "\ud835\ude46",
                "\ud835\ude47",
                "\ud835\ude48",
                "\ud835\ude49",
                "\ud835\ude4a",
                "\ud835\ude4b",
                "\ud835\ude4c",
                "\ud835\ude4d",
                "\ud835\ude4e",
                "\ud835\ude4f",
                "\ud835\ude50",
                "\ud835\ude51",
                "\ud835\ude52",
                "\ud835\ude53",
                "\ud835\ude54",
                "\ud835\ude55"
            ], U1 = [
                "\ud835\ude56",
                "\ud835\ude57",
                "\ud835\ude58",
                "\ud835\ude59",
                "\ud835\ude5a",
                "\ud835\ude5b",
                "\ud835\ude5c",
                "\ud835\ude5d",
                "\ud835\ude5e",
                "\ud835\ude5f",
                "\ud835\ude60",
                "\ud835\ude61",
                "\ud835\ude62",
                "\ud835\ude63",
                "\ud835\ude64",
                "\ud835\ude65",
                "\ud835\ude66",
                "\ud835\ude67",
                "\ud835\ude68",
                "\ud835\ude69",
                "\ud835\ude6a",
                "\ud835\ude6b",
                "\ud835\ude6c",
                "\ud835\ude6d",
                "\ud835\ude6e",
                "\ud835\ude6f"
            ], X1 = [
                "\ud835\ude70",
                "\ud835\ude71",
                "\ud835\ude72",
                "\ud835\ude73",
                "\ud835\ude74",
                "\ud835\ude75",
                "\ud835\ude76",
                "\ud835\ude77",
                "\ud835\ude78",
                "\ud835\ude79",
                "\ud835\ude7a",
                "\ud835\ude7b",
                "\ud835\ude7c",
                "\ud835\ude7d",
                "\ud835\ude7e",
                "\ud835\ude7f",
                "\ud835\ude80",
                "\ud835\ude81",
                "\ud835\ude82",
                "\ud835\ude83",
                "\ud835\ude84",
                "\ud835\ude85",
                "\ud835\ude86",
                "\ud835\ude87",
                "\ud835\ude88",
                "\ud835\ude89"
            ], V1 = [
                "\ud835\ude8a",
                "\ud835\ude8b",
                "\ud835\ude8c",
                "\ud835\ude8d",
                "\ud835\ude8e",
                "\ud835\ude8f",
                "\ud835\ude90",
                "\ud835\ude91",
                "\ud835\ude92",
                "\ud835\ude93",
                "\ud835\ude94",
                "\ud835\ude95",
                "\ud835\ude96",
                "\ud835\ude97",
                "\ud835\ude98",
                "\ud835\ude99",
                "\ud835\ude9a",
                "\ud835\ude9b",
                "\ud835\ude9c",
                "\ud835\ude9d",
                "\ud835\ude9e",
                "\ud835\ude9f",
                "\ud835\udea0",
                "\ud835\udea1",
                "\ud835\udea2",
                "\ud835\udea3"
            ], q1 = [
                "ⅅ",
                "ⅆ",
                "ⅇ",
                "ⅈ",
                "ⅉ"
            ], W1 = [
                "Α",
                "Β",
                "Γ",
                "Δ",
                "Ε",
                "Ζ",
                "Η",
                "Θ",
                "Ι",
                "Κ",
                "Λ",
                "Μ",
                "Ν",
                "Ξ",
                "Ο",
                "Π",
                "Ρ",
                "Σ",
                "Τ",
                "Υ",
                "Φ",
                "Χ",
                "Ψ",
                "Ω"
            ], G1 = [
                "α",
                "β",
                "γ",
                "δ",
                "ε",
                "ζ",
                "η",
                "θ",
                "ι",
                "κ",
                "λ",
                "μ",
                "ν",
                "ξ",
                "ο",
                "π",
                "ρ",
                "ς",
                "σ",
                "τ",
                "υ",
                "φ",
                "χ",
                "ψ",
                "ω"
            ], z1 = [
                "\ud835\udea8",
                "\ud835\udea9",
                "\ud835\udeaa",
                "\ud835\udeab",
                "\ud835\udeac",
                "\ud835\udead",
                "\ud835\udeae",
                "\ud835\udeaf",
                "\ud835\udeb0",
                "\ud835\udeb1",
                "\ud835\udeb2",
                "\ud835\udeb3",
                "\ud835\udeb4",
                "\ud835\udeb5",
                "\ud835\udeb6",
                "\ud835\udeb7",
                "\ud835\udeb8",
                "\ud835\udeba",
                "\ud835\udebb",
                "\ud835\udebc",
                "\ud835\udebd",
                "\ud835\udebe",
                "\ud835\udebf",
                "\ud835\udec0"
            ], J1 = [
                "\ud835\udec2",
                "\ud835\udec3",
                "\ud835\udec4",
                "\ud835\udec5",
                "\ud835\udec6",
                "\ud835\udec7",
                "\ud835\udec8",
                "\ud835\udec9",
                "\ud835\udeca",
                "\ud835\udecb",
                "\ud835\udecc",
                "\ud835\udecd",
                "\ud835\udece",
                "\ud835\udecf",
                "\ud835\uded0",
                "\ud835\uded1",
                "\ud835\uded2",
                "\ud835\uded3",
                "\ud835\uded4",
                "\ud835\uded5",
                "\ud835\uded6",
                "\ud835\uded7",
                "\ud835\uded8",
                "\ud835\uded9",
                "\ud835\udeda"
            ], K1 = [
                "\ud835\udee2",
                "\ud835\udee3",
                "\ud835\udee4",
                "\ud835\udee5",
                "\ud835\udee6",
                "\ud835\udee7",
                "\ud835\udee8",
                "\ud835\udee9",
                "\ud835\udeea",
                "\ud835\udeeb",
                "\ud835\udeec",
                "\ud835\udeed",
                "\ud835\udeee",
                "\ud835\udeef",
                "\ud835\udef0",
                "\ud835\udef1",
                "\ud835\udef2",
                "\ud835\udef4",
                "\ud835\udef5",
                "\ud835\udef6",
                "\ud835\udef7",
                "\ud835\udef8",
                "\ud835\udef9",
                "\ud835\udefa"
            ], $1 = [
                "\ud835\udefc",
                "\ud835\udefd",
                "\ud835\udefe",
                "\ud835\udeff",
                "\ud835\udf00",
                "\ud835\udf01",
                "\ud835\udf02",
                "\ud835\udf03",
                "\ud835\udf04",
                "\ud835\udf05",
                "\ud835\udf06",
                "\ud835\udf07",
                "\ud835\udf08",
                "\ud835\udf09",
                "\ud835\udf0a",
                "\ud835\udf0b",
                "\ud835\udf0c",
                "\ud835\udf0d",
                "\ud835\udf0e",
                "\ud835\udf0f",
                "\ud835\udf10",
                "\ud835\udf11",
                "\ud835\udf12",
                "\ud835\udf13",
                "\ud835\udf14"
            ], Y1 = [
                "\ud835\udf1c",
                "\ud835\udf1d",
                "\ud835\udf1e",
                "\ud835\udf1f",
                "\ud835\udf20",
                "\ud835\udf21",
                "\ud835\udf22",
                "\ud835\udf23",
                "\ud835\udf24",
                "\ud835\udf25",
                "\ud835\udf26",
                "\ud835\udf27",
                "\ud835\udf28",
                "\ud835\udf29",
                "\ud835\udf2a",
                "\ud835\udf2b",
                "\ud835\udf2c",
                "\ud835\udf2e",
                "\ud835\udf2f",
                "\ud835\udf30",
                "\ud835\udf31",
                "\ud835\udf32",
                "\ud835\udf33",
                "\ud835\udf34"
            ], Z1 = [
                "\ud835\udf36",
                "\ud835\udf37",
                "\ud835\udf38",
                "\ud835\udf39",
                "\ud835\udf3a",
                "\ud835\udf3b",
                "\ud835\udf3c",
                "\ud835\udf3d",
                "\ud835\udf3e",
                "\ud835\udf3f",
                "\ud835\udf40",
                "\ud835\udf41",
                "\ud835\udf42",
                "\ud835\udf43",
                "\ud835\udf44",
                "\ud835\udf45",
                "\ud835\udf46",
                "\ud835\udf47",
                "\ud835\udf48",
                "\ud835\udf49",
                "\ud835\udf4a",
                "\ud835\udf4b",
                "\ud835\udf4c",
                "\ud835\udf4d",
                "\ud835\udf4e"
            ], Q1 = [
                "\ud835\udf56",
                "\ud835\udf57",
                "\ud835\udf58",
                "\ud835\udf59",
                "\ud835\udf5a",
                "\ud835\udf5b",
                "\ud835\udf5c",
                "\ud835\udf5d",
                "\ud835\udf5e",
                "\ud835\udf5f",
                "\ud835\udf60",
                "\ud835\udf61",
                "\ud835\udf62",
                "\ud835\udf63",
                "\ud835\udf64",
                "\ud835\udf65",
                "\ud835\udf66",
                "\ud835\udf68",
                "\ud835\udf69",
                "\ud835\udf6a",
                "\ud835\udf6b",
                "\ud835\udf6c",
                "\ud835\udf6d",
                "\ud835\udf6e"
            ], tt1 = [
                "\ud835\udf70",
                "\ud835\udf71",
                "\ud835\udf72",
                "\ud835\udf73",
                "\ud835\udf74",
                "\ud835\udf75",
                "\ud835\udf76",
                "\ud835\udf77",
                "\ud835\udf78",
                "\ud835\udf79",
                "\ud835\udf7a",
                "\ud835\udf7b",
                "\ud835\udf7c",
                "\ud835\udf7d",
                "\ud835\udf7e",
                "\ud835\udf7f",
                "\ud835\udf80",
                "\ud835\udf81",
                "\ud835\udf82",
                "\ud835\udf83",
                "\ud835\udf84",
                "\ud835\udf85",
                "\ud835\udf86",
                "\ud835\udf87",
                "\ud835\udf88"
            ], et1 = [
                "\ud835\udf90",
                "\ud835\udf91",
                "\ud835\udf92",
                "\ud835\udf93",
                "\ud835\udf94",
                "\ud835\udf95",
                "\ud835\udf96",
                "\ud835\udf97",
                "\ud835\udf98",
                "\ud835\udf99",
                "\ud835\udf9a",
                "\ud835\udf9b",
                "\ud835\udf9c",
                "\ud835\udf9d",
                "\ud835\udf9e",
                "\ud835\udf9f",
                "\ud835\udfa0",
                "\ud835\udfa2",
                "\ud835\udfa3",
                "\ud835\udfa4",
                "\ud835\udfa5",
                "\ud835\udfa6",
                "\ud835\udfa7",
                "\ud835\udfa8"
            ], rt1 = [
                "\ud835\udfaa",
                "\ud835\udfab",
                "\ud835\udfac",
                "\ud835\udfad",
                "\ud835\udfae",
                "\ud835\udfaf",
                "\ud835\udfb0",
                "\ud835\udfb1",
                "\ud835\udfb2",
                "\ud835\udfb3",
                "\ud835\udfb4",
                "\ud835\udfb5",
                "\ud835\udfb6",
                "\ud835\udfb7",
                "\ud835\udfb8",
                "\ud835\udfb9",
                "\ud835\udfba",
                "\ud835\udfbb",
                "\ud835\udfbc",
                "\ud835\udfbd",
                "\ud835\udfbe",
                "\ud835\udfbf",
                "\ud835\udfc0",
                "\ud835\udfc1",
                "\ud835\udfc2"
            ], nt1 = [
                "ℼ",
                "ℽ",
                "ℾ",
                "ℿ"
            ], ot1 = [
                "ϐ",
                "ϑ",
                "ϕ",
                "ϖ",
                "ϗ",
                "ϰ",
                "ϱ",
                "ϵ",
                "϶",
                "ϴ"
            ], it1 = [
                "\ud835\udedc",
                "\ud835\udedd",
                "\ud835\udede",
                "\ud835\udedf",
                "\ud835\udee0",
                "\ud835\udee1"
            ], st1 = [
                "\ud835\udf16",
                "\ud835\udf17",
                "\ud835\udf18",
                "\ud835\udf19",
                "\ud835\udf1a",
                "\ud835\udf1b"
            ], at1 = [
                "\ud835\udf8a",
                "\ud835\udf8b",
                "\ud835\udf8c",
                "\ud835\udf8d",
                "\ud835\udf8e",
                "\ud835\udf8f"
            ], lt1 = [
                "ℵ",
                "ℶ",
                "ℷ",
                "ℸ"
            ], ct1 = d1.concat(m1, y1, g1, b1, v1, _1, O1, M1, S1, x1, E1, A1, C1, T1, N1, w1, L1, I1, P1, R1, k1, j1, B1, D1, F1, H1, U1, X1, V1, q1, W1, G1, z1, J1, K1, $1, Y1, Z1, Q1, tt1, nt1, ot1, et1, rt1, it1, st1, at1, lt1);
            e1.allLettersRegExp = new RegExp(ct1.join("|"));
            const ut1 = [
                "+",
                "\xb1",
                "∓",
                "∔",
                "∧",
                "∨",
                "∩",
                "∪",
                "⊌",
                "⊍",
                "⊎",
                "⊓",
                "⊔",
                "⊝",
                "⊞",
                "⊤",
                "⊥",
                "⊺",
                "⊻",
                "⊼",
                "⋄",
                "⋎",
                "⋏",
                "⋒",
                "⋓",
                "⩞",
                "⊕",
                "⋔"
            ], pt1 = String.fromCodePoint(8292);
            ut1.push(pt1);
            const ht1 = [
                "†",
                "‡",
                "∐",
                "∗",
                "∘",
                "∙",
                "≀",
                "⊚",
                "⊛",
                "⊠",
                "⊡",
                "⋅",
                "⋆",
                "⋇",
                "⋈",
                "⋉",
                "⋊",
                "⋋",
                "⋌",
                "○",
                "\xb7",
                "*",
                "⊗",
                "⊙"
            ], ft1 = String.fromCodePoint(8290);
            ht1.push(ft1);
            const dt1 = String.fromCodePoint(8289), mt1 = [
                "\xbc",
                "\xbd",
                "\xbe",
                "⅐",
                "⅑",
                "⅒",
                "⅓",
                "⅔",
                "⅕",
                "⅖",
                "⅗",
                "⅘",
                "⅙",
                "⅚",
                "⅛",
                "⅜",
                "⅝",
                "⅞",
                "⅟",
                "↉"
            ], yt1 = [
                "\xb2",
                "\xb3",
                "\xb9",
                "⁰",
                "⁴",
                "⁵",
                "⁶",
                "⁷",
                "⁸",
                "⁹"
            ].concat([
                "₀",
                "₁",
                "₂",
                "₃",
                "₄",
                "₅",
                "₆",
                "₇",
                "₈",
                "₉"
            ], [
                "①",
                "②",
                "③",
                "④",
                "⑤",
                "⑥",
                "⑦",
                "⑧",
                "⑨",
                "⑩",
                "⑪",
                "⑫",
                "⑬",
                "⑭",
                "⑮",
                "⑯",
                "⑰",
                "⑱",
                "⑲",
                "⑳",
                "⓪",
                "⓫",
                "⓬",
                "⓭",
                "⓮",
                "⓯",
                "⓰",
                "⓱",
                "⓲",
                "⓳",
                "⓴",
                "⓵",
                "⓶",
                "⓷",
                "⓸",
                "⓹",
                "⓺",
                "⓻",
                "⓼",
                "⓽",
                "⓾",
                "⓿",
                "❶",
                "❷",
                "❸",
                "❹",
                "❺",
                "❻",
                "❼",
                "❽",
                "❾",
                "❿",
                "➀",
                "➁",
                "➂",
                "➃",
                "➄",
                "➅",
                "➆",
                "➇",
                "➈",
                "➉",
                "➊",
                "➋",
                "➌",
                "➍",
                "➎",
                "➏",
                "➐",
                "➑",
                "➒",
                "➓",
                "㉈",
                "㉉",
                "㉊",
                "㉋",
                "㉌",
                "㉍",
                "㉎",
                "㉏",
                "㉑",
                "㉒",
                "㉓",
                "㉔",
                "㉕",
                "㉖",
                "㉗",
                "㉘",
                "㉙",
                "㉚",
                "㉛",
                "㉜",
                "㉝",
                "㉞",
                "㉟",
                "㊱",
                "㊲",
                "㊳",
                "㊴",
                "㊵",
                "㊶",
                "㊷",
                "㊸",
                "㊹",
                "㊺",
                "㊻",
                "㊼",
                "㊽",
                "㊾",
                "㊿"
            ], [
                "⑴",
                "⑵",
                "⑶",
                "⑷",
                "⑸",
                "⑹",
                "⑺",
                "⑻",
                "⑼",
                "⑽",
                "⑾",
                "⑿",
                "⒀",
                "⒁",
                "⒂",
                "⒃",
                "⒄",
                "⒅",
                "⒆",
                "⒇"
            ], [
                "⒈",
                "⒉",
                "⒊",
                "⒋",
                "⒌",
                "⒍",
                "⒎",
                "⒏",
                "⒐",
                "⒑",
                "⒒",
                "⒓",
                "⒔",
                "⒕",
                "⒖",
                "⒗",
                "⒘",
                "⒙",
                "⒚",
                "⒛",
                "\ud83c\udd00",
                "\ud83c\udd01",
                "\ud83c\udd02",
                "\ud83c\udd03",
                "\ud83c\udd04",
                "\ud83c\udd05",
                "\ud83c\udd06",
                "\ud83c\udd07",
                "\ud83c\udd08",
                "\ud83c\udd09",
                "\ud83c\udd0a"
            ]), gt1 = [
                "cos",
                "cot",
                "csc",
                "sec",
                "sin",
                "tan",
                "arccos",
                "arccot",
                "arccsc",
                "arcsec",
                "arcsin",
                "arctan",
                "arc cos",
                "arc cot",
                "arc csc",
                "arc sec",
                "arc sin",
                "arc tan"
            ].concat([
                "cosh",
                "coth",
                "csch",
                "sech",
                "sinh",
                "tanh",
                "arcosh",
                "arcoth",
                "arcsch",
                "arsech",
                "arsinh",
                "artanh",
                "arccosh",
                "arccoth",
                "arccsch",
                "arcsech",
                "arcsinh",
                "arctanh"
            ], [
                "deg",
                "det",
                "dim",
                "hom",
                "ker",
                "Tr",
                "tr"
            ], [
                "log",
                "ln",
                "lg",
                "exp",
                "expt",
                "gcd",
                "gcd",
                "arg",
                "im",
                "re",
                "Pr"
            ]), bt1 = [
                {
                    set: [
                        "!",
                        '"',
                        "#",
                        "%",
                        "&",
                        ";",
                        "?",
                        "@",
                        "\\",
                        "\xa1",
                        "\xa7",
                        "\xb6",
                        "\xbf",
                        "‗",
                        "†",
                        "‡",
                        "•",
                        "‣",
                        "․",
                        "‥",
                        "‧",
                        "‰",
                        "‱",
                        "‸",
                        "※",
                        "‼",
                        "‽",
                        "‾",
                        "⁁",
                        "⁂",
                        "⁃",
                        "⁇",
                        "⁈",
                        "⁉",
                        "⁋",
                        "⁌",
                        "⁍",
                        "⁎",
                        "⁏",
                        "⁐",
                        "⁑",
                        "⁓",
                        "⁕",
                        "⁖",
                        "⁘",
                        "⁙",
                        "⁚",
                        "⁛",
                        "⁜",
                        "⁝",
                        "⁞",
                        "︐",
                        "︔",
                        "︕",
                        "︖",
                        "︰",
                        "﹅",
                        "﹆",
                        "﹉",
                        "﹊",
                        "﹋",
                        "﹌",
                        "﹔",
                        "﹖",
                        "﹗",
                        "﹟",
                        "﹠",
                        "﹡",
                        "﹨",
                        "﹪",
                        "﹫",
                        "！",
                        "＂",
                        "＃",
                        "％",
                        "＆",
                        "＇",
                        "＊",
                        "／",
                        "；",
                        "？",
                        "＠",
                        "＼"
                    ],
                    type: "punctuation",
                    role: "unknown"
                },
                {
                    set: [
                        "︓",
                        ":",
                        "：",
                        "﹕"
                    ],
                    type: "punctuation",
                    role: "colon"
                },
                {
                    set: n1,
                    type: "punctuation",
                    role: "comma"
                },
                {
                    set: [
                        "…",
                        "⋮",
                        "⋯",
                        "⋰",
                        "⋱",
                        "︙"
                    ],
                    type: "punctuation",
                    role: "ellipsis"
                },
                {
                    set: [
                        ".",
                        "﹒",
                        "．"
                    ],
                    type: "punctuation",
                    role: "fullstop"
                },
                {
                    set: o1,
                    type: "operator",
                    role: "dash"
                },
                {
                    set: i1,
                    type: "operator",
                    role: "tilde"
                },
                {
                    set: [
                        "'",
                        "′",
                        "″",
                        "‴",
                        "‵",
                        "‶",
                        "‷",
                        "⁗",
                        "ʹ",
                        "ʺ"
                    ],
                    type: "punctuation",
                    role: "prime"
                },
                {
                    set: [
                        "\xb0"
                    ],
                    type: "punctuation",
                    role: "degree"
                },
                {
                    set: l1,
                    type: "fence",
                    role: "open"
                },
                {
                    set: c1,
                    type: "fence",
                    role: "close"
                },
                {
                    set: u1,
                    type: "fence",
                    role: "top"
                },
                {
                    set: p1,
                    type: "fence",
                    role: "bottom"
                },
                {
                    set: h1,
                    type: "fence",
                    role: "neutral"
                },
                {
                    set: f1,
                    type: "fence",
                    role: "metric"
                },
                {
                    set: m1,
                    type: "identifier",
                    role: "latinletter",
                    font: "normal"
                },
                {
                    set: d1,
                    type: "identifier",
                    role: "latinletter",
                    font: "normal"
                },
                {
                    set: g1,
                    type: "identifier",
                    role: "latinletter",
                    font: "normal"
                },
                {
                    set: y1,
                    type: "identifier",
                    role: "latinletter",
                    font: "normal"
                },
                {
                    set: v1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold"
                },
                {
                    set: b1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold"
                },
                {
                    set: S1,
                    type: "identifier",
                    role: "latinletter",
                    font: "italic"
                },
                {
                    set: _1,
                    type: "identifier",
                    role: "latinletter",
                    font: "italic"
                },
                {
                    set: M1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold-italic"
                },
                {
                    set: O1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold-italic"
                },
                {
                    set: E1,
                    type: "identifier",
                    role: "latinletter",
                    font: "script"
                },
                {
                    set: x1,
                    type: "identifier",
                    role: "latinletter",
                    font: "script"
                },
                {
                    set: C1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold-script"
                },
                {
                    set: A1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold-script"
                },
                {
                    set: N1,
                    type: "identifier",
                    role: "latinletter",
                    font: "fraktur"
                },
                {
                    set: T1,
                    type: "identifier",
                    role: "latinletter",
                    font: "fraktur"
                },
                {
                    set: L1,
                    type: "identifier",
                    role: "latinletter",
                    font: "double-struck"
                },
                {
                    set: w1,
                    type: "identifier",
                    role: "latinletter",
                    font: "double-struck"
                },
                {
                    set: P1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold-fraktur"
                },
                {
                    set: I1,
                    type: "identifier",
                    role: "latinletter",
                    font: "bold-fraktur"
                },
                {
                    set: k1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif"
                },
                {
                    set: R1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif"
                },
                {
                    set: B1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif-bold"
                },
                {
                    set: j1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif-bold"
                },
                {
                    set: F1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif-italic"
                },
                {
                    set: D1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif-italic"
                },
                {
                    set: U1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif-bold-italic"
                },
                {
                    set: H1,
                    type: "identifier",
                    role: "latinletter",
                    font: "sans-serif-bold-italic"
                },
                {
                    set: V1,
                    type: "identifier",
                    role: "latinletter",
                    font: "monospace"
                },
                {
                    set: X1,
                    type: "identifier",
                    role: "latinletter",
                    font: "monospace"
                },
                {
                    set: q1,
                    type: "identifier",
                    role: "latinletter",
                    font: "double-struck-italic"
                },
                {
                    set: G1,
                    type: "identifier",
                    role: "greekletter",
                    font: "normal"
                },
                {
                    set: W1,
                    type: "identifier",
                    role: "greekletter",
                    font: "normal"
                },
                {
                    set: J1,
                    type: "identifier",
                    role: "greekletter",
                    font: "bold"
                },
                {
                    set: z1,
                    type: "identifier",
                    role: "greekletter",
                    font: "bold"
                },
                {
                    set: $1,
                    type: "identifier",
                    role: "greekletter",
                    font: "italic"
                },
                {
                    set: K1,
                    type: "identifier",
                    role: "greekletter",
                    font: "italic"
                },
                {
                    set: Z1,
                    type: "identifier",
                    role: "greekletter",
                    font: "bold-italic"
                },
                {
                    set: Y1,
                    type: "identifier",
                    role: "greekletter",
                    font: "bold-italic"
                },
                {
                    set: tt1,
                    type: "identifier",
                    role: "greekletter",
                    font: "sans-serif-bold"
                },
                {
                    set: Q1,
                    type: "identifier",
                    role: "greekletter",
                    font: "sans-serif-bold"
                },
                {
                    set: et1,
                    type: "identifier",
                    role: "greekletter",
                    font: "sans-serif-bold-italic"
                },
                {
                    set: rt1,
                    type: "identifier",
                    role: "greekletter",
                    font: "sans-serif-bold-italic"
                },
                {
                    set: nt1,
                    type: "identifier",
                    role: "greekletter",
                    font: "double-struck"
                },
                {
                    set: ot1,
                    type: "identifier",
                    role: "greekletter",
                    font: "normal"
                },
                {
                    set: it1,
                    type: "identifier",
                    role: "greekletter",
                    font: "bold"
                },
                {
                    set: st1,
                    type: "identifier",
                    role: "greekletter",
                    font: "italic"
                },
                {
                    set: at1,
                    type: "identifier",
                    role: "greekletter",
                    font: "sans-serif-bold"
                },
                {
                    set: lt1,
                    type: "identifier",
                    role: "otherletter",
                    font: "normal"
                },
                {
                    set: [
                        "0",
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9"
                    ],
                    type: "number",
                    role: "integer",
                    font: "normal"
                },
                {
                    set: [
                        "０",
                        "１",
                        "２",
                        "３",
                        "４",
                        "５",
                        "６",
                        "７",
                        "８",
                        "９"
                    ],
                    type: "number",
                    role: "integer",
                    font: "normal"
                },
                {
                    set: [
                        "\ud835\udfce",
                        "\ud835\udfcf",
                        "\ud835\udfd0",
                        "\ud835\udfd1",
                        "\ud835\udfd2",
                        "\ud835\udfd3",
                        "\ud835\udfd4",
                        "\ud835\udfd5",
                        "\ud835\udfd6",
                        "\ud835\udfd7"
                    ],
                    type: "number",
                    role: "integer",
                    font: "bold"
                },
                {
                    set: [
                        "\ud835\udfd8",
                        "\ud835\udfd9",
                        "\ud835\udfda",
                        "\ud835\udfdb",
                        "\ud835\udfdc",
                        "\ud835\udfdd",
                        "\ud835\udfde",
                        "\ud835\udfdf",
                        "\ud835\udfe0",
                        "\ud835\udfe1"
                    ],
                    type: "number",
                    role: "integer",
                    font: "double-struck"
                },
                {
                    set: [
                        "\ud835\udfe2",
                        "\ud835\udfe3",
                        "\ud835\udfe4",
                        "\ud835\udfe5",
                        "\ud835\udfe6",
                        "\ud835\udfe7",
                        "\ud835\udfe8",
                        "\ud835\udfe9",
                        "\ud835\udfea",
                        "\ud835\udfeb"
                    ],
                    type: "number",
                    role: "integer",
                    font: "sans-serif"
                },
                {
                    set: [
                        "\ud835\udfec",
                        "\ud835\udfed",
                        "\ud835\udfee",
                        "\ud835\udfef",
                        "\ud835\udff0",
                        "\ud835\udff1",
                        "\ud835\udff2",
                        "\ud835\udff3",
                        "\ud835\udff4",
                        "\ud835\udff5"
                    ],
                    type: "number",
                    role: "integer",
                    font: "sans-serif-bold"
                },
                {
                    set: [
                        "\ud835\udff6",
                        "\ud835\udff7",
                        "\ud835\udff8",
                        "\ud835\udff9",
                        "\ud835\udffa",
                        "\ud835\udffb",
                        "\ud835\udffc",
                        "\ud835\udffd",
                        "\ud835\udffe",
                        "\ud835\udfff"
                    ],
                    type: "number",
                    role: "integer",
                    font: "monospace"
                },
                {
                    set: mt1,
                    type: "number",
                    role: "float"
                },
                {
                    set: yt1,
                    type: "number",
                    role: "othernumber"
                },
                {
                    set: ut1,
                    type: "operator",
                    role: "addition"
                },
                {
                    set: ht1,
                    type: "operator",
                    role: "multiplication"
                },
                {
                    set: [
                        "\xaf",
                        "-",
                        "⁒",
                        "⁻",
                        "₋",
                        "−",
                        "∖",
                        "∸",
                        "≂",
                        "⊖",
                        "⊟",
                        "➖",
                        "⨩",
                        "⨪",
                        "⨫",
                        "⨬",
                        "⨺",
                        "⩁",
                        "﹣",
                        "－",
                        "‐",
                        "‑"
                    ],
                    type: "operator",
                    role: "subtraction"
                },
                {
                    set: [
                        "/",
                        "\xf7",
                        "⁄",
                        "∕",
                        "⊘",
                        "⟌",
                        "⦼",
                        "⨸"
                    ],
                    type: "operator",
                    role: "division"
                },
                {
                    set: [
                        "∀",
                        "∃",
                        "∆",
                        "∇",
                        "∂",
                        "∁",
                        "∄"
                    ],
                    type: "operator",
                    role: "prefix operator"
                },
                {
                    set: [
                        "\ud835\udec1",
                        "\ud835\udedb",
                        "\ud835\udfca",
                        "\ud835\udfcb"
                    ],
                    type: "operator",
                    role: "prefix operator",
                    font: "bold"
                },
                {
                    set: [
                        "\ud835\udefb",
                        "\ud835\udf15"
                    ],
                    type: "operator",
                    role: "prefix operator",
                    font: "italic"
                },
                {
                    set: [
                        "\ud835\udf6f",
                        "\ud835\udf89"
                    ],
                    type: "operator",
                    role: "prefix operator",
                    font: "sans-serif-bold"
                },
                {
                    set: [
                        "=",
                        "~",
                        "⁼",
                        "₌",
                        "∼",
                        "∽",
                        "≃",
                        "≅",
                        "≈",
                        "≊",
                        "≋",
                        "≌",
                        "≍",
                        "≎",
                        "≑",
                        "≒",
                        "≓",
                        "≔",
                        "≕",
                        "≖",
                        "≗",
                        "≘",
                        "≙",
                        "≚",
                        "≛",
                        "≜",
                        "≝",
                        "≞",
                        "≟",
                        "≡",
                        "≣",
                        "⧤",
                        "⩦",
                        "⩮",
                        "⩯",
                        "⩰",
                        "⩱",
                        "⩲",
                        "⩳",
                        "⩴",
                        "⩵",
                        "⩶",
                        "⩷",
                        "⩸",
                        "⋕",
                        "⩭",
                        "⩪",
                        "⩫",
                        "⩬",
                        "﹦",
                        "＝",
                        "⩬",
                        "⊜",
                        "∷"
                    ],
                    type: "relation",
                    role: "equality"
                },
                {
                    set: [
                        "<",
                        ">",
                        "≁",
                        "≂",
                        "≄",
                        "≆",
                        "≇",
                        "≉",
                        "≏",
                        "≐",
                        "≠",
                        "≢",
                        "≤",
                        "≥",
                        "≦",
                        "≧",
                        "≨",
                        "≩",
                        "≪",
                        "≫",
                        "≬",
                        "≭",
                        "≮",
                        "≯",
                        "≰",
                        "≱",
                        "≲",
                        "≳",
                        "≴",
                        "≵",
                        "≶",
                        "≷",
                        "≸",
                        "≹",
                        "≺",
                        "≻",
                        "≼",
                        "≽",
                        "≾",
                        "≿",
                        "⊀",
                        "⊁",
                        "⋖",
                        "⋗",
                        "⋘",
                        "⋙",
                        "⋚",
                        "⋛",
                        "⋜",
                        "⋝",
                        "⋞",
                        "⋟",
                        "⋠",
                        "⋡",
                        "⋦",
                        "⋧",
                        "⋨",
                        "⋩",
                        "⩹",
                        "⩺",
                        "⩻",
                        "⩼",
                        "⩽",
                        "⩾",
                        "⩿",
                        "⪀",
                        "⪁",
                        "⪂",
                        "⪃",
                        "⪄",
                        "⪅",
                        "⪆",
                        "⪇",
                        "⪈",
                        "⪉",
                        "⪊",
                        "⪋",
                        "⪌",
                        "⪍",
                        "⪎",
                        "⪏",
                        "⪐",
                        "⪑",
                        "⪒",
                        "⪓",
                        "⪔",
                        "⪕",
                        "⪖",
                        "⪗",
                        "⪘",
                        "⪙",
                        "⪚",
                        "⪛",
                        "⪜",
                        "⪝",
                        "⪞",
                        "⪟",
                        "⪠",
                        "⪡",
                        "⪢",
                        "⪣",
                        "⪤",
                        "⪥",
                        "⪦",
                        "⪧",
                        "⪨",
                        "⪩",
                        "⪪",
                        "⪫",
                        "⪬",
                        "⪭",
                        "⪮",
                        "⪯",
                        "⪰",
                        "⪱",
                        "⪲",
                        "⪳",
                        "⪴",
                        "⪵",
                        "⪶",
                        "⪷",
                        "⪸",
                        "⪹",
                        "⪺",
                        "⪻",
                        "⪼",
                        "⫷",
                        "⫸",
                        "⫹",
                        "⫺",
                        "⧀",
                        "⧁",
                        "﹤",
                        "﹥",
                        "＜",
                        "＞"
                    ],
                    type: "relation",
                    role: "inequality"
                },
                {
                    set: [
                        "⋢",
                        "⋣",
                        "⋤",
                        "⋥",
                        "⊂",
                        "⊃",
                        "⊄",
                        "⊅",
                        "⊆",
                        "⊇",
                        "⊈",
                        "⊉",
                        "⊊",
                        "⊋",
                        "⊏",
                        "⊐",
                        "⊑",
                        "⊒",
                        "⪽",
                        "⪾",
                        "⪿",
                        "⫀",
                        "⫁",
                        "⫂",
                        "⫃",
                        "⫄",
                        "⫅",
                        "⫆",
                        "⫇",
                        "⫈",
                        "⫉",
                        "⫊",
                        "⫋",
                        "⫌",
                        "⫍",
                        "⫎",
                        "⫏",
                        "⫐",
                        "⫑",
                        "⫒",
                        "⫓",
                        "⫔",
                        "⫕",
                        "⫖",
                        "⫗",
                        "⫘",
                        "⋐",
                        "⋑",
                        "⋪",
                        "⋫",
                        "⋬",
                        "⋭",
                        "⊲",
                        "⊳",
                        "⊴",
                        "⊵"
                    ],
                    type: "relation",
                    role: "set"
                },
                {
                    set: [
                        "⊢",
                        "⊣",
                        "⊦",
                        "⊧",
                        "⊨",
                        "⊩",
                        "⊪",
                        "⊫",
                        "⊬",
                        "⊭",
                        "⊮",
                        "⊯",
                        "⫞",
                        "⫟",
                        "⫠",
                        "⫡",
                        "⫢",
                        "⫣",
                        "⫤",
                        "⫥",
                        "⫦",
                        "⫧",
                        "⫨",
                        "⫩",
                        "⫪",
                        "⫫",
                        "⫬",
                        "⫭"
                    ],
                    type: "relation",
                    role: "unknown"
                },
                {
                    set: [
                        "←",
                        "↑",
                        "→",
                        "↓",
                        "↔",
                        "↕",
                        "↖",
                        "↗",
                        "↘",
                        "↙",
                        "↚",
                        "↛",
                        "↜",
                        "↝",
                        "↞",
                        "↟",
                        "↠",
                        "↡",
                        "↢",
                        "↣",
                        "↤",
                        "↥",
                        "↦",
                        "↧",
                        "↨",
                        "↩",
                        "↪",
                        "↫",
                        "↬",
                        "↭",
                        "↮",
                        "↯",
                        "↰",
                        "↱",
                        "↲",
                        "↳",
                        "↴",
                        "↵",
                        "↶",
                        "↷",
                        "↸",
                        "↹",
                        "↺",
                        "↻",
                        "⇄",
                        "⇅",
                        "⇆",
                        "⇇",
                        "⇈",
                        "⇉",
                        "⇊",
                        "⇍",
                        "⇎",
                        "⇏",
                        "⇐",
                        "⇑",
                        "⇒",
                        "⇓",
                        "⇔",
                        "⇕",
                        "⇖",
                        "⇗",
                        "⇘",
                        "⇙",
                        "⇚",
                        "⇛",
                        "⇜",
                        "⇝",
                        "⇞",
                        "⇟",
                        "⇠",
                        "⇡",
                        "⇢",
                        "⇣",
                        "⇤",
                        "⇥",
                        "⇦",
                        "⇧",
                        "⇨",
                        "⇩",
                        "⇪",
                        "⇫",
                        "⇬",
                        "⇭",
                        "⇮",
                        "⇯",
                        "⇰",
                        "⇱",
                        "⇲",
                        "⇳",
                        "⇴",
                        "⇵",
                        "⇶",
                        "⇷",
                        "⇸",
                        "⇹",
                        "⇺",
                        "⇻",
                        "⇼",
                        "⇽",
                        "⇾",
                        "⇿",
                        "⌁",
                        "⌃",
                        "⌄",
                        "⌤",
                        "⎋",
                        "➔",
                        "➘",
                        "➙",
                        "➚",
                        "➛",
                        "➜",
                        "➝",
                        "➞",
                        "➟",
                        "➠",
                        "➡",
                        "➢",
                        "➣",
                        "➤",
                        "➥",
                        "➦",
                        "➧",
                        "➨",
                        "➩",
                        "➪",
                        "➫",
                        "➬",
                        "➭",
                        "➮",
                        "➯",
                        "➱",
                        "➲",
                        "➳",
                        "➴",
                        "➵",
                        "➶",
                        "➷",
                        "➸",
                        "➹",
                        "➺",
                        "➻",
                        "➼",
                        "➽",
                        "➾",
                        "⟰",
                        "⟱",
                        "⟲",
                        "⟳",
                        "⟴",
                        "⟵",
                        "⟶",
                        "⟷",
                        "⟸",
                        "⟹",
                        "⟺",
                        "⟻",
                        "⟼",
                        "⟽",
                        "⟾",
                        "⟿",
                        "⤀",
                        "⤁",
                        "⤂",
                        "⤃",
                        "⤄",
                        "⤅",
                        "⤆",
                        "⤇",
                        "⤈",
                        "⤉",
                        "⤊",
                        "⤋",
                        "⤌",
                        "⤍",
                        "⤎",
                        "⤏",
                        "⤐",
                        "⤑",
                        "⤒",
                        "⤓",
                        "⤔",
                        "⤕",
                        "⤖",
                        "⤗",
                        "⤘",
                        "⤙",
                        "⤚",
                        "⤛",
                        "⤜",
                        "⤝",
                        "⤞",
                        "⤟",
                        "⤠",
                        "⤡",
                        "⤢",
                        "⤣",
                        "⤤",
                        "⤥",
                        "⤦",
                        "⤧",
                        "⤨",
                        "⤩",
                        "⤪",
                        "⤭",
                        "⤮",
                        "⤯",
                        "⤰",
                        "⤱",
                        "⤲",
                        "⤳",
                        "⤴",
                        "⤵",
                        "⤶",
                        "⤷",
                        "⤸",
                        "⤹",
                        "⤺",
                        "⤻",
                        "⤼",
                        "⤽",
                        "⤾",
                        "⤿",
                        "⥀",
                        "⥁",
                        "⥂",
                        "⥃",
                        "⥄",
                        "⥅",
                        "⥆",
                        "⥇",
                        "⥈",
                        "⥉",
                        "⥰",
                        "⥱",
                        "⥲",
                        "⥳",
                        "⥴",
                        "⥵",
                        "⥶",
                        "⥷",
                        "⥸",
                        "⥹",
                        "⥺",
                        "⥻",
                        "⦳",
                        "⦴",
                        "⦽",
                        "⧪",
                        "⧬",
                        "⧭",
                        "⨗",
                        "⬀",
                        "⬁",
                        "⬂",
                        "⬃",
                        "⬄",
                        "⬅",
                        "⬆",
                        "⬇",
                        "⬈",
                        "⬉",
                        "⬊",
                        "⬋",
                        "⬌",
                        "⬍",
                        "⬎",
                        "⬏",
                        "⬐",
                        "⬑",
                        "⬰",
                        "⬱",
                        "⬲",
                        "⬳",
                        "⬴",
                        "⬵",
                        "⬶",
                        "⬷",
                        "⬸",
                        "⬹",
                        "⬺",
                        "⬻",
                        "⬼",
                        "⬽",
                        "⬾",
                        "⬿",
                        "⭀",
                        "⭁",
                        "⭂",
                        "⭃",
                        "⭄",
                        "⭅",
                        "⭆",
                        "⭇",
                        "⭈",
                        "⭉",
                        "⭊",
                        "⭋",
                        "⭌",
                        "￩",
                        "￪",
                        "￫",
                        "￬",
                        "↼",
                        "↽",
                        "↾",
                        "↿",
                        "⇀",
                        "⇁",
                        "⇂",
                        "⇃",
                        "⇋",
                        "⇌",
                        "⥊",
                        "⥋",
                        "⥌",
                        "⥍",
                        "⥎",
                        "⥏",
                        "⥐",
                        "⥑",
                        "⥒",
                        "⥓",
                        "⥔",
                        "⥕",
                        "⥖",
                        "⥗",
                        "⥘",
                        "⥙",
                        "⥚",
                        "⥛",
                        "⥜",
                        "⥝",
                        "⥞",
                        "⥟",
                        "⥠",
                        "⥡",
                        "⥢",
                        "⥣",
                        "⥤",
                        "⥥",
                        "⥦",
                        "⥧",
                        "⥨",
                        "⥩",
                        "⥪",
                        "⥫",
                        "⥬",
                        "⥭",
                        "⥮",
                        "⥯",
                        "⥼",
                        "⥽",
                        "⥾",
                        "⥿"
                    ],
                    type: "relation",
                    role: "arrow"
                },
                {
                    set: [
                        "∈",
                        "∊",
                        "⋲",
                        "⋳",
                        "⋴",
                        "⋵",
                        "⋶",
                        "⋷",
                        "⋸",
                        "⋹",
                        "⋿"
                    ],
                    type: "operator",
                    role: "element"
                },
                {
                    set: [
                        "∉"
                    ],
                    type: "operator",
                    role: "nonelement"
                },
                {
                    set: [
                        "∋",
                        "∍",
                        "⋺",
                        "⋻",
                        "⋼",
                        "⋽",
                        "⋾"
                    ],
                    type: "operator",
                    role: "reelement"
                },
                {
                    set: [
                        "∌"
                    ],
                    type: "operator",
                    role: "renonelement"
                },
                {
                    set: [
                        "⅀",
                        "∏",
                        "∐",
                        "∑",
                        "⋀",
                        "⋁",
                        "⋂",
                        "⋃",
                        "⨀",
                        "⨁",
                        "⨂",
                        "⨃",
                        "⨄",
                        "⨅",
                        "⨆",
                        "⨇",
                        "⨈",
                        "⨉",
                        "⨊",
                        "⨋",
                        "⫼",
                        "⫿"
                    ],
                    type: "largeop",
                    role: "sum"
                },
                {
                    set: [
                        "∫",
                        "∬",
                        "∭",
                        "∮",
                        "∯",
                        "∰",
                        "∱",
                        "∲",
                        "∳",
                        "⨌",
                        "⨍",
                        "⨎",
                        "⨏",
                        "⨐",
                        "⨑",
                        "⨒",
                        "⨓",
                        "⨔",
                        "⨕",
                        "⨖",
                        "⨗",
                        "⨘",
                        "⨙",
                        "⨚",
                        "⨛",
                        "⨜"
                    ],
                    type: "largeop",
                    role: "integral"
                },
                {
                    set: [
                        "∟",
                        "∠",
                        "∡",
                        "∢",
                        "⊾",
                        "⊿",
                        "△",
                        "▷",
                        "▽",
                        "◁"
                    ],
                    type: "operator",
                    role: "geometry"
                },
                {
                    set: [
                        "inf",
                        "lim",
                        "liminf",
                        "limsup",
                        "max",
                        "min",
                        "sup",
                        "injlim",
                        "projlim",
                        "inj lim",
                        "proj lim"
                    ],
                    type: "function",
                    role: "limit function"
                },
                {
                    set: gt1,
                    type: "function",
                    role: "prefix function"
                },
                {
                    set: [
                        "mod",
                        "rem"
                    ],
                    type: "operator",
                    role: "prefix function"
                }
            ], vt1 = function() {
                const t1 = {};
                for(let e1, r1 = 0; e1 = bt1[r1]; r1++)e1.set.forEach(function(r1) {
                    t1[r1] = {
                        role: e1.role || "unknown",
                        type: e1.type || "unknown",
                        font: e1.font || "unknown"
                    };
                });
                return t1;
            }();
            e1.equal = function(t1, e1) {
                return t1.type === e1.type && t1.role === e1.role && t1.font === e1.font;
            }, e1.lookupType = function(t1) {
                var e1;
                return (null === (e1 = vt1[t1]) || void 0 === e1 ? void 0 : e1.type) || "unknown";
            }, e1.lookupRole = function(t1) {
                var e1;
                return (null === (e1 = vt1[t1]) || void 0 === e1 ? void 0 : e1.role) || "unknown";
            }, e1.lookupMeaning = function(t1) {
                return vt1[t1] || {
                    role: "unknown",
                    type: "unknown",
                    font: "unknown"
                };
            }, e1.invisibleTimes = function() {
                return ft1;
            }, e1.invisiblePlus = function() {
                return pt1;
            }, e1.invisibleComma = function() {
                return r1;
            }, e1.functionApplication = function() {
                return dt1;
            }, e1.isMatchingFence = function(t1, e1) {
                return -1 !== h1.indexOf(t1) || -1 !== f1.indexOf(t1) ? t1 === e1 : s1[t1] === e1 || a1[t1] === e1;
            }, e1.isEmbellishedType = function(t1) {
                return "operator" === t1 || "relation" === t1 || "fence" === t1 || "punctuation" === t1;
            };
            const _t1 = new Map;
            function St1(t1, e1) {
                return `${t1} ${e1}`;
            }
            function Ot1(t1, e1, r1 = "") {
                for (const n1 of e1)_t1.set(St1(t1, n1), r1 || t1);
            }
            Ot1("d", [
                "d",
                "ⅆ",
                "ｄ",
                "\ud835\udc1d",
                "\ud835\udc51",
                "\ud835\udcb9",
                "\ud835\udced",
                "\ud835\udd21",
                "\ud835\udd55",
                "\ud835\udd89",
                "\ud835\uddbd",
                "\ud835\uddf1",
                "\ud835\ude25",
                "\ud835\ude8d"
            ]), Ot1("bar", o1), Ot1("tilde", i1), e1.lookupSecondary = function(t1, e1) {
                return _t1.get(St1(t1, e1));
            };
        },
        8158: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticMeaningCollator = e1.SemanticNodeCollator = e1.SemanticDefault = void 0;
            const n1 = r1(3588), o1 = r1(3882);
            class i1 {
                constructor(){
                    this.map = {};
                }
                static key(t1, e1) {
                    return e1 ? t1 + ":" + e1 : t1;
                }
                add(t1, e1) {
                    this.map[i1.key(t1, e1.font)] = e1;
                }
                addNode(t1) {
                    this.add(t1.textContent, t1.meaning());
                }
                retrieve(t1, e1) {
                    return this.map[i1.key(t1, e1)];
                }
                retrieveNode(t1) {
                    return this.retrieve(t1.textContent, t1.font);
                }
                size() {
                    return Object.keys(this.map).length;
                }
            }
            e1.SemanticDefault = i1;
            class s1 {
                constructor(){
                    this.map = {};
                }
                add(t1, e1) {
                    const r1 = this.map[t1];
                    r1 ? r1.push(e1) : this.map[t1] = [
                        e1
                    ];
                }
                retrieve(t1, e1) {
                    return this.map[i1.key(t1, e1)];
                }
                retrieveNode(t1) {
                    return this.retrieve(t1.textContent, t1.font);
                }
                copy() {
                    const t1 = this.copyCollator();
                    for(const e1 in this.map)t1.map[e1] = this.map[e1];
                    return t1;
                }
                minimize() {
                    for(const t1 in this.map)1 === this.map[t1].length && delete this.map[t1];
                }
                minimalCollator() {
                    const t1 = this.copy();
                    for(const e1 in t1.map)1 === t1.map[e1].length && delete t1.map[e1];
                    return t1;
                }
                isMultiValued() {
                    for(const t1 in this.map)if (this.map[t1].length > 1) return !0;
                    return !1;
                }
                isEmpty() {
                    return !Object.keys(this.map).length;
                }
            }
            class a1 extends s1 {
                copyCollator() {
                    return new a1;
                }
                add(t1, e1) {
                    const r1 = i1.key(t1, e1.font);
                    super.add(r1, e1);
                }
                addNode(t1) {
                    this.add(t1.textContent, t1);
                }
                toString() {
                    const t1 = [];
                    for(const e1 in this.map){
                        const r1 = Array(e1.length + 3).join(" "), n1 = this.map[e1], o1 = [];
                        for(let t1, e1 = 0; t1 = n1[e1]; e1++)o1.push(t1.toString());
                        t1.push(e1 + ": " + o1.join("\n" + r1));
                    }
                    return t1.join("\n");
                }
                collateMeaning() {
                    const t1 = new l1;
                    for(const e1 in this.map)t1.map[e1] = this.map[e1].map(function(t1) {
                        return t1.meaning();
                    });
                    return t1;
                }
            }
            e1.SemanticNodeCollator = a1;
            class l1 extends s1 {
                copyCollator() {
                    return new l1;
                }
                add(t1, e1) {
                    const r1 = this.retrieve(t1, e1.font);
                    if (!r1 || !r1.find(function(t1) {
                        return n1.equal(t1, e1);
                    })) {
                        const r1 = i1.key(t1, e1.font);
                        super.add(r1, e1);
                    }
                }
                addNode(t1) {
                    this.add(t1.textContent, t1.meaning());
                }
                toString() {
                    const t1 = [];
                    for(const e1 in this.map){
                        const r1 = Array(e1.length + 3).join(" "), n1 = this.map[e1], o1 = [];
                        for(let t1, e1 = 0; t1 = n1[e1]; e1++)o1.push("{type: " + t1.type + ", role: " + t1.role + ", font: " + t1.font + "}");
                        t1.push(e1 + ": " + o1.join("\n" + r1));
                    }
                    return t1.join("\n");
                }
                reduce() {
                    for(const t1 in this.map)1 !== this.map[t1].length && (this.map[t1] = (0, o1.reduce)(this.map[t1]));
                }
                default() {
                    const t1 = new i1;
                    for(const e1 in this.map)1 === this.map[e1].length && (t1.map[e1] = this.map[e1][0]);
                    return t1;
                }
                newDefault() {
                    const t1 = this.default();
                    this.reduce();
                    const e1 = this.default();
                    return t1.size() !== e1.size() ? e1 : null;
                }
            }
            e1.SemanticMeaningCollator = l1;
        },
        9911: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticMultiHeuristic = e1.SemanticTreeHeuristic = e1.SemanticAbstractHeuristic = void 0;
            class r1 {
                constructor(t1, e1, r1 = (t1)=>!1){
                    this.name = t1, this.apply = e1, this.applicable = r1;
                }
            }
            e1.SemanticAbstractHeuristic = r1;
            e1.SemanticTreeHeuristic = class extends r1 {
            };
            e1.SemanticMultiHeuristic = class extends r1 {
            };
        },
        7516: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.lookup = e1.run = e1.add = e1.blacklist = e1.flags = e1.updateFactory = e1.factory = void 0, e1.factory = null, e1.updateFactory = function(t1) {
                e1.factory = t1;
            };
            const r1 = new Map;
            function n1(t1) {
                return r1.get(t1);
            }
            e1.flags = {
                combine_juxtaposition: !0,
                convert_juxtaposition: !0,
                multioperator: !0
            }, e1.blacklist = {}, e1.add = function(t1) {
                const n1 = t1.name;
                r1.set(n1, t1), e1.flags[n1] || (e1.flags[n1] = !1);
            }, e1.run = function(t1, r1, o1) {
                const i1 = n1(t1);
                return i1 && !e1.blacklist[t1] && (e1.flags[t1] || i1.applicable(r1)) ? i1.apply(r1) : o1 ? o1(r1) : r1;
            }, e1.lookup = n1;
        },
        94: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(2057), o1 = r1(5897), i1 = r1(3588), s1 = r1(7516), a1 = r1(9911), l1 = r1(5609), c1 = r1(3308), u1 = r1(4795);
            function p1(t1, e1, r1) {
                let n1 = null;
                if (!t1.length) return n1;
                const o1 = r1[r1.length - 1], i1 = o1 && o1.length, s1 = e1 && e1.length, a1 = c1.default.getInstance();
                if (i1 && s1) {
                    if ("infixop" === e1[0].type && "implicit" === e1[0].role) return n1 = t1.pop(), o1.push(a1.postfixNode_(o1.pop(), t1)), n1;
                    n1 = t1.shift();
                    const r1 = a1.prefixNode_(e1.shift(), t1);
                    return e1.unshift(r1), n1;
                }
                return i1 ? (o1.push(a1.postfixNode_(o1.pop(), t1)), n1) : (s1 && e1.unshift(a1.prefixNode_(e1.shift(), t1)), n1);
            }
            function h1(t1, e1, r1) {
                if (!e1.length) return t1;
                const o1 = t1.pop(), i1 = e1.shift(), a1 = r1.shift();
                if (l1.isImplicitOp(i1)) {
                    n1.Debugger.getInstance().output("Juxta Heuristic Case 2");
                    const s1 = (o1 ? [
                        o1,
                        i1
                    ] : [
                        i1
                    ]).concat(a1);
                    return h1(t1.concat(s1), e1, r1);
                }
                if (!o1) return n1.Debugger.getInstance().output("Juxta Heuristic Case 3"), h1([
                    i1
                ].concat(a1), e1, r1);
                const c1 = a1.shift();
                if (!c1) {
                    n1.Debugger.getInstance().output("Juxta Heuristic Case 9");
                    const a1 = s1.factory.makeBranchNode("infixop", [
                        o1,
                        e1.shift()
                    ], [
                        i1
                    ], i1.textContent);
                    return a1.role = "implicit", s1.run("combine_juxtaposition", a1), e1.unshift(a1), h1(t1, e1, r1);
                }
                if (l1.isOperator(o1) || l1.isOperator(c1)) return n1.Debugger.getInstance().output("Juxta Heuristic Case 4"), h1(t1.concat([
                    o1,
                    i1,
                    c1
                ]).concat(a1), e1, r1);
                let u1 = null;
                return l1.isImplicitOp(o1) && l1.isImplicitOp(c1) ? (n1.Debugger.getInstance().output("Juxta Heuristic Case 5"), o1.contentNodes.push(i1), o1.contentNodes = o1.contentNodes.concat(c1.contentNodes), o1.childNodes.push(c1), o1.childNodes = o1.childNodes.concat(c1.childNodes), c1.childNodes.forEach((t1)=>t1.parent = o1), i1.parent = o1, o1.addMathmlNodes(i1.mathml), o1.addMathmlNodes(c1.mathml), u1 = o1) : l1.isImplicitOp(o1) ? (n1.Debugger.getInstance().output("Juxta Heuristic Case 6"), o1.contentNodes.push(i1), o1.childNodes.push(c1), c1.parent = o1, i1.parent = o1, o1.addMathmlNodes(i1.mathml), o1.addMathmlNodes(c1.mathml), u1 = o1) : l1.isImplicitOp(c1) ? (n1.Debugger.getInstance().output("Juxta Heuristic Case 7"), c1.contentNodes.unshift(i1), c1.childNodes.unshift(o1), o1.parent = c1, i1.parent = c1, c1.addMathmlNodes(i1.mathml), c1.addMathmlNodes(o1.mathml), u1 = c1) : (n1.Debugger.getInstance().output("Juxta Heuristic Case 8"), u1 = s1.factory.makeBranchNode("infixop", [
                    o1,
                    c1
                ], [
                    i1
                ], i1.textContent), u1.role = "implicit"), t1.push(u1), h1(t1.concat(a1), e1, r1);
            }
            s1.add(new a1.SemanticTreeHeuristic("combine_juxtaposition", function(t1) {
                for(let e1, r1 = t1.childNodes.length - 1; e1 = t1.childNodes[r1]; r1--)l1.isImplicitOp(e1) && !e1.nobreaking && (t1.childNodes.splice(r1, 1, ...e1.childNodes), t1.contentNodes.splice(r1, 0, ...e1.contentNodes), e1.childNodes.concat(e1.contentNodes).forEach(function(e1) {
                    e1.parent = t1;
                }), t1.addMathmlNodes(e1.mathml));
                return t1;
            })), s1.add(new a1.SemanticTreeHeuristic("propagateSimpleFunction", (t1)=>("infixop" !== t1.type && "fraction" !== t1.type || !t1.childNodes.every(l1.isSimpleFunction) || (t1.role = "composed function"), t1), (t1)=>"clearspeak" === o1.default.getInstance().domain)), s1.add(new a1.SemanticTreeHeuristic("simpleNamedFunction", (t1)=>("unit" !== t1.role && -1 !== [
                    "f",
                    "g",
                    "h",
                    "F",
                    "G",
                    "H"
                ].indexOf(t1.textContent) && (t1.role = "simple function"), t1), (t1)=>"clearspeak" === o1.default.getInstance().domain)), s1.add(new a1.SemanticTreeHeuristic("propagateComposedFunction", (t1)=>("fenced" === t1.type && "composed function" === t1.childNodes[0].role && (t1.role = "composed function"), t1), (t1)=>"clearspeak" === o1.default.getInstance().domain)), s1.add(new a1.SemanticTreeHeuristic("multioperator", (t1)=>{
                if ("unknown" !== t1.role || t1.textContent.length <= 1) return;
                const e1 = [
                    ...t1.textContent
                ].map(i1.lookupMeaning).reduce(function(t1, e1) {
                    return t1 && e1.role && "unknown" !== e1.role && e1.role !== t1 ? "unknown" === t1 ? e1.role : null : t1;
                }, "unknown");
                e1 && (t1.role = e1);
            })), s1.add(new a1.SemanticMultiHeuristic("convert_juxtaposition", (t1)=>{
                let e1 = u1.partitionNodes(t1, function(t1) {
                    return t1.textContent === i1.invisibleTimes() && "operator" === t1.type;
                });
                e1 = e1.rel.length ? function(t1) {
                    const e1 = [], r1 = [];
                    let n1 = t1.comp.shift(), o1 = null, i1 = [];
                    for(; t1.comp.length;)if (i1 = [], n1.length) o1 && e1.push(o1), r1.push(n1), o1 = t1.rel.shift(), n1 = t1.comp.shift();
                    else {
                        for(o1 && i1.push(o1); !n1.length && t1.comp.length;)n1 = t1.comp.shift(), i1.push(t1.rel.shift());
                        o1 = p1(i1, n1, r1);
                    }
                    i1.length || n1.length ? (e1.push(o1), r1.push(n1)) : (i1.push(o1), p1(i1, n1, r1));
                    return {
                        rel: e1,
                        comp: r1
                    };
                }(e1) : e1, t1 = e1.comp[0];
                for(let r1, n1, o1 = 1; r1 = e1.comp[o1], n1 = e1.rel[o1 - 1]; o1++)t1.push(n1), t1 = t1.concat(r1);
                return e1 = u1.partitionNodes(t1, function(t1) {
                    return t1.textContent === i1.invisibleTimes() && ("operator" === t1.type || "infixop" === t1.type);
                }), e1.rel.length ? h1(e1.comp.shift(), e1.rel, e1.comp) : t1;
            })), s1.add(new a1.SemanticTreeHeuristic("simple2prefix", (t1)=>(t1.textContent.length > 1 && !t1.textContent[0].match(/[A-Z]/) && (t1.role = "prefix function"), t1), (t1)=>"braille" === o1.default.getInstance().modality && "identifier" === t1.type)), s1.add(new a1.SemanticTreeHeuristic("detect_cycle", (t1)=>{
                t1.type = "matrix", t1.role = "cycle";
                const e1 = t1.childNodes[0];
                return e1.type = "row", e1.role = "cycle", e1.textContent = "", e1.contentNodes = [], t1;
            }, (t1)=>"fenced" === t1.type && "infixop" === t1.childNodes[0].type && "implicit" === t1.childNodes[0].role && t1.childNodes[0].childNodes.every(function(t1) {
                    return "number" === t1.type;
                }) && t1.childNodes[0].contentNodes.every(function(t1) {
                    return "space" === t1.role;
                })));
        },
        7228: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticMathml = void 0;
            const n1 = r1(5740), o1 = r1(5250), i1 = r1(5609), s1 = r1(3308), a1 = r1(4795);
            class l1 extends o1.SemanticAbstractParser {
                constructor(){
                    super("MathML"), this.parseMap_ = {
                        SEMANTICS: this.semantics_.bind(this),
                        MATH: this.rows_.bind(this),
                        MROW: this.rows_.bind(this),
                        MPADDED: this.rows_.bind(this),
                        MSTYLE: this.rows_.bind(this),
                        MFRAC: this.fraction_.bind(this),
                        MSUB: this.limits_.bind(this),
                        MSUP: this.limits_.bind(this),
                        MSUBSUP: this.limits_.bind(this),
                        MOVER: this.limits_.bind(this),
                        MUNDER: this.limits_.bind(this),
                        MUNDEROVER: this.limits_.bind(this),
                        MROOT: this.root_.bind(this),
                        MSQRT: this.sqrt_.bind(this),
                        MTABLE: this.table_.bind(this),
                        MLABELEDTR: this.tableLabeledRow_.bind(this),
                        MTR: this.tableRow_.bind(this),
                        MTD: this.tableCell_.bind(this),
                        MS: this.text_.bind(this),
                        MTEXT: this.text_.bind(this),
                        MSPACE: this.space_.bind(this),
                        "ANNOTATION-XML": this.text_.bind(this),
                        MI: this.identifier_.bind(this),
                        MN: this.number_.bind(this),
                        MO: this.operator_.bind(this),
                        MFENCED: this.fenced_.bind(this),
                        MENCLOSE: this.enclosed_.bind(this),
                        MMULTISCRIPTS: this.multiscripts_.bind(this),
                        ANNOTATION: this.empty_.bind(this),
                        NONE: this.empty_.bind(this),
                        MACTION: this.action_.bind(this)
                    };
                    const t1 = {
                        type: "identifier",
                        role: "numbersetletter",
                        font: "double-struck"
                    };
                    [
                        "C",
                        "H",
                        "N",
                        "P",
                        "Q",
                        "R",
                        "Z",
                        "ℂ",
                        "ℍ",
                        "ℕ",
                        "ℙ",
                        "ℚ",
                        "ℝ",
                        "ℤ"
                    ].forEach(((e1)=>this.getFactory().defaultMap.add(e1, t1)).bind(this));
                }
                static getAttribute_(t1, e1, r1) {
                    if (!t1.hasAttribute(e1)) return r1;
                    const n1 = t1.getAttribute(e1);
                    return n1.match(/^\s*$/) ? null : n1;
                }
                parse(t1) {
                    s1.default.getInstance().setNodeFactory(this.getFactory());
                    const e1 = n1.toArray(t1.childNodes), r1 = n1.tagName(t1), o1 = this.parseMap_[r1], i1 = (o1 || this.dummy_.bind(this))(t1, e1);
                    return a1.addAttributes(i1, t1), -1 !== [
                        "MATH",
                        "MROW",
                        "MPADDED",
                        "MSTYLE",
                        "SEMANTICS"
                    ].indexOf(r1) || (i1.mathml.unshift(t1), i1.mathmlTree = t1), i1;
                }
                semantics_(t1, e1) {
                    return e1.length ? this.parse(e1[0]) : this.getFactory().makeEmptyNode();
                }
                rows_(t1, e1) {
                    const r1 = t1.getAttribute("semantics");
                    if (r1 && r1.match("bspr_")) return s1.default.proof(t1, r1, this.parseList.bind(this));
                    let n1;
                    return 1 === (e1 = a1.purgeNodes(e1)).length ? (n1 = this.parse(e1[0]), "empty" !== n1.type || n1.mathmlTree || (n1.mathmlTree = t1)) : n1 = s1.default.getInstance().row(this.parseList(e1)), n1.mathml.unshift(t1), n1;
                }
                fraction_(t1, e1) {
                    if (!e1.length) return this.getFactory().makeEmptyNode();
                    const r1 = this.parse(e1[0]), n1 = e1[1] ? this.parse(e1[1]) : this.getFactory().makeEmptyNode();
                    return s1.default.getInstance().fractionLikeNode(r1, n1, t1.getAttribute("linethickness"), "true" === t1.getAttribute("bevelled"));
                }
                limits_(t1, e1) {
                    return s1.default.getInstance().limitNode(n1.tagName(t1), this.parseList(e1));
                }
                root_(t1, e1) {
                    return e1[1] ? this.getFactory().makeBranchNode("root", [
                        this.parse(e1[1]),
                        this.parse(e1[0])
                    ], []) : this.sqrt_(t1, e1);
                }
                sqrt_(t1, e1) {
                    const r1 = this.parseList(a1.purgeNodes(e1));
                    return this.getFactory().makeBranchNode("sqrt", [
                        s1.default.getInstance().row(r1)
                    ], []);
                }
                table_(t1, e1) {
                    const r1 = t1.getAttribute("semantics");
                    if (r1 && r1.match("bspr_")) return s1.default.proof(t1, r1, this.parseList.bind(this));
                    const n1 = this.getFactory().makeBranchNode("table", this.parseList(e1), []);
                    return n1.mathmlTree = t1, s1.default.tableToMultiline(n1), n1;
                }
                tableRow_(t1, e1) {
                    const r1 = this.getFactory().makeBranchNode("row", this.parseList(e1), []);
                    return r1.role = "table", r1;
                }
                tableLabeledRow_(t1, e1) {
                    if (!e1.length) return this.tableRow_(t1, e1);
                    const r1 = this.parse(e1[0]);
                    r1.role = "label";
                    const n1 = this.getFactory().makeBranchNode("row", this.parseList(e1.slice(1)), [
                        r1
                    ]);
                    return n1.role = "table", n1;
                }
                tableCell_(t1, e1) {
                    const r1 = this.parseList(a1.purgeNodes(e1));
                    let n1;
                    n1 = r1.length ? 1 === r1.length && i1.isType(r1[0], "empty") ? r1 : [
                        s1.default.getInstance().row(r1)
                    ] : [];
                    const o1 = this.getFactory().makeBranchNode("cell", n1, []);
                    return o1.role = "table", o1;
                }
                space_(t1, e1) {
                    const r1 = t1.getAttribute("width"), o1 = r1 && r1.match(/[a-z]*$/);
                    if (!o1) return this.empty_(t1, e1);
                    const i1 = o1[0], a1 = parseFloat(r1.slice(0, o1.index)), l1 = {
                        cm: .4,
                        pc: .5,
                        em: .5,
                        ex: 1,
                        in: .15,
                        pt: 5,
                        mm: 5
                    }[i1];
                    if (!l1 || isNaN(a1) || a1 < l1) return this.empty_(t1, e1);
                    const c1 = this.getFactory().makeUnprocessed(t1);
                    return s1.default.getInstance().text(c1, n1.tagName(t1));
                }
                text_(t1, e1) {
                    const r1 = this.leaf_(t1, e1);
                    return t1.textContent ? (r1.updateContent(t1.textContent, !0), s1.default.getInstance().text(r1, n1.tagName(t1))) : r1;
                }
                identifier_(t1, e1) {
                    const r1 = this.leaf_(t1, e1);
                    return s1.default.getInstance().identifierNode(r1, s1.default.getInstance().font(t1.getAttribute("mathvariant")), t1.getAttribute("class"));
                }
                number_(t1, e1) {
                    const r1 = this.leaf_(t1, e1);
                    return s1.default.number(r1), r1;
                }
                operator_(t1, e1) {
                    const r1 = this.leaf_(t1, e1);
                    return s1.default.getInstance().operatorNode(r1), r1;
                }
                fenced_(t1, e1) {
                    const r1 = this.parseList(a1.purgeNodes(e1)), n1 = l1.getAttribute_(t1, "separators", ","), o1 = l1.getAttribute_(t1, "open", "("), i1 = l1.getAttribute_(t1, "close", ")"), c1 = s1.default.getInstance().mfenced(o1, i1, n1, r1);
                    return s1.default.getInstance().tablesInRow([
                        c1
                    ])[0];
                }
                enclosed_(t1, e1) {
                    const r1 = this.parseList(a1.purgeNodes(e1)), n1 = this.getFactory().makeBranchNode("enclose", [
                        s1.default.getInstance().row(r1)
                    ], []);
                    return n1.role = t1.getAttribute("notation") || "unknown", n1;
                }
                multiscripts_(t1, e1) {
                    if (!e1.length) return this.getFactory().makeEmptyNode();
                    const r1 = this.parse(e1.shift());
                    if (!e1.length) return r1;
                    const o1 = [], i1 = [], l1 = [], c1 = [];
                    let u1 = !1, p1 = 0;
                    for(let t1, r1 = 0; t1 = e1[r1]; r1++)"MPRESCRIPTS" !== n1.tagName(t1) ? (u1 ? 1 & p1 ? o1.push(t1) : i1.push(t1) : 1 & p1 ? l1.push(t1) : c1.push(t1), p1++) : (u1 = !0, p1 = 0);
                    return a1.purgeNodes(o1).length || a1.purgeNodes(i1).length ? s1.default.getInstance().tensor(r1, this.parseList(i1), this.parseList(o1), this.parseList(c1), this.parseList(l1)) : s1.default.getInstance().pseudoTensor(r1, this.parseList(c1), this.parseList(l1));
                }
                empty_(t1, e1) {
                    return this.getFactory().makeEmptyNode();
                }
                action_(t1, e1) {
                    return e1.length > 1 ? this.parse(e1[1]) : this.getFactory().makeUnprocessed(t1);
                }
                dummy_(t1, e1) {
                    const r1 = this.getFactory().makeUnprocessed(t1);
                    return r1.role = t1.tagName, r1.textContent = t1.textContent, r1;
                }
                leaf_(t1, e1) {
                    if (1 === e1.length && e1[0].nodeType !== n1.NodeType.TEXT_NODE) {
                        const r1 = this.getFactory().makeUnprocessed(t1);
                        return r1.role = e1[0].tagName, a1.addAttributes(r1, e1[0]), r1;
                    }
                    return this.getFactory().makeLeafNode(t1.textContent, s1.default.getInstance().font(t1.getAttribute("mathvariant")));
                }
            }
            e1.SemanticMathml = l1;
        },
        5952: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticNode = void 0;
            const n1 = r1(5740), o1 = r1(3588), i1 = r1(4795);
            class s1 {
                constructor(t1){
                    this.id = t1, this.mathml = [], this.parent = null, this.type = "unknown", this.role = "unknown", this.font = "unknown", this.embellished = null, this.fencePointer = "", this.childNodes = [], this.textContent = "", this.mathmlTree = null, this.contentNodes = [], this.annotation = {}, this.attributes = {}, this.nobreaking = !1;
                }
                static fromXml(t1) {
                    const e1 = parseInt(t1.getAttribute("id"), 10), r1 = new s1(e1);
                    return r1.type = t1.tagName, s1.setAttribute(r1, t1, "role"), s1.setAttribute(r1, t1, "font"), s1.setAttribute(r1, t1, "embellished"), s1.setAttribute(r1, t1, "fencepointer", "fencePointer"), t1.getAttribute("annotation") && r1.parseAnnotation(t1.getAttribute("annotation")), i1.addAttributes(r1, t1), s1.processChildren(r1, t1), r1;
                }
                static setAttribute(t1, e1, r1, n1) {
                    n1 = n1 || r1;
                    const o1 = e1.getAttribute(r1);
                    o1 && (t1[n1] = o1);
                }
                static processChildren(t1, e1) {
                    for (const r1 of n1.toArray(e1.childNodes)){
                        if (r1.nodeType === n1.NodeType.TEXT_NODE) {
                            t1.textContent = r1.textContent;
                            continue;
                        }
                        const e1 = n1.toArray(r1.childNodes).map(s1.fromXml);
                        e1.forEach((e1)=>e1.parent = t1), "CONTENT" === n1.tagName(r1) ? t1.contentNodes = e1 : t1.childNodes = e1;
                    }
                }
                querySelectorAll(t1) {
                    let e1 = [];
                    for(let r1, n1 = 0; r1 = this.childNodes[n1]; n1++)e1 = e1.concat(r1.querySelectorAll(t1));
                    for(let r1, n1 = 0; r1 = this.contentNodes[n1]; n1++)e1 = e1.concat(r1.querySelectorAll(t1));
                    return t1(this) && e1.unshift(this), e1;
                }
                xml(t1, e1) {
                    const r1 = function(r1, n1) {
                        const o1 = n1.map(function(r1) {
                            return r1.xml(t1, e1);
                        }), i1 = t1.createElementNS("", r1);
                        for(let t1, e1 = 0; t1 = o1[e1]; e1++)i1.appendChild(t1);
                        return i1;
                    }, n1 = t1.createElementNS("", this.type);
                    return e1 || this.xmlAttributes(n1), n1.textContent = this.textContent, this.contentNodes.length > 0 && n1.appendChild(r1("content", this.contentNodes)), this.childNodes.length > 0 && n1.appendChild(r1("children", this.childNodes)), n1;
                }
                toString(t1 = !1) {
                    const e1 = n1.parseInput("<snode/>");
                    return n1.serializeXml(this.xml(e1, t1));
                }
                allAttributes() {
                    const t1 = [];
                    return t1.push([
                        "role",
                        this.role
                    ]), "unknown" !== this.font && t1.push([
                        "font",
                        this.font
                    ]), Object.keys(this.annotation).length && t1.push([
                        "annotation",
                        this.xmlAnnotation()
                    ]), this.embellished && t1.push([
                        "embellished",
                        this.embellished
                    ]), this.fencePointer && t1.push([
                        "fencepointer",
                        this.fencePointer
                    ]), t1.push([
                        "id",
                        this.id.toString()
                    ]), t1;
                }
                xmlAnnotation() {
                    const t1 = [];
                    for(const e1 in this.annotation)this.annotation[e1].forEach(function(r1) {
                        t1.push(e1 + ":" + r1);
                    });
                    return t1.join(";");
                }
                toJson() {
                    const t1 = {};
                    t1.type = this.type;
                    const e1 = this.allAttributes();
                    for(let r1, n1 = 0; r1 = e1[n1]; n1++)t1[r1[0]] = r1[1].toString();
                    return this.textContent && (t1.$t = this.textContent), this.childNodes.length && (t1.children = this.childNodes.map(function(t1) {
                        return t1.toJson();
                    })), this.contentNodes.length && (t1.content = this.contentNodes.map(function(t1) {
                        return t1.toJson();
                    })), t1;
                }
                updateContent(t1, e1) {
                    const r1 = e1 ? t1.replace(/^[ \f\n\r\t\v\u200b]*/, "").replace(/[ \f\n\r\t\v\u200b]*$/, "") : t1.trim();
                    if (t1 = t1 && !r1 ? t1 : r1, this.textContent === t1) return;
                    const n1 = (0, o1.lookupMeaning)(t1);
                    this.textContent = t1, this.role = n1.role, this.type = n1.type, this.font = n1.font;
                }
                addMathmlNodes(t1) {
                    for(let e1, r1 = 0; e1 = t1[r1]; r1++)-1 === this.mathml.indexOf(e1) && this.mathml.push(e1);
                }
                appendChild(t1) {
                    this.childNodes.push(t1), this.addMathmlNodes(t1.mathml), t1.parent = this;
                }
                replaceChild(t1, e1) {
                    const r1 = this.childNodes.indexOf(t1);
                    if (-1 === r1) return;
                    t1.parent = null, e1.parent = this, this.childNodes[r1] = e1;
                    const n1 = t1.mathml.filter(function(t1) {
                        return -1 === e1.mathml.indexOf(t1);
                    }), o1 = e1.mathml.filter(function(e1) {
                        return -1 === t1.mathml.indexOf(e1);
                    });
                    this.removeMathmlNodes(n1), this.addMathmlNodes(o1);
                }
                appendContentNode(t1) {
                    t1 && (this.contentNodes.push(t1), this.addMathmlNodes(t1.mathml), t1.parent = this);
                }
                removeContentNode(t1) {
                    if (t1) {
                        const e1 = this.contentNodes.indexOf(t1);
                        -1 !== e1 && this.contentNodes.slice(e1, 1);
                    }
                }
                equals(t1) {
                    if (!t1) return !1;
                    if (this.type !== t1.type || this.role !== t1.role || this.textContent !== t1.textContent || this.childNodes.length !== t1.childNodes.length || this.contentNodes.length !== t1.contentNodes.length) return !1;
                    for(let e1, r1, n1 = 0; e1 = this.childNodes[n1], r1 = t1.childNodes[n1]; n1++)if (!e1.equals(r1)) return !1;
                    for(let e1, r1, n1 = 0; e1 = this.contentNodes[n1], r1 = t1.contentNodes[n1]; n1++)if (!e1.equals(r1)) return !1;
                    return !0;
                }
                displayTree() {
                    console.info(this.displayTree_(0));
                }
                addAnnotation(t1, e1) {
                    e1 && this.addAnnotation_(t1, e1);
                }
                getAnnotation(t1) {
                    const e1 = this.annotation[t1];
                    return e1 || [];
                }
                hasAnnotation(t1, e1) {
                    const r1 = this.annotation[t1];
                    return !!r1 && -1 !== r1.indexOf(e1);
                }
                parseAnnotation(t1) {
                    const e1 = t1.split(";");
                    for(let t1 = 0, r1 = e1.length; t1 < r1; t1++){
                        const r1 = e1[t1].split(":");
                        this.addAnnotation(r1[0], r1[1]);
                    }
                }
                meaning() {
                    return {
                        type: this.type,
                        role: this.role,
                        font: this.font
                    };
                }
                xmlAttributes(t1) {
                    const e1 = this.allAttributes();
                    for(let r1, n1 = 0; r1 = e1[n1]; n1++)t1.setAttribute(r1[0], r1[1]);
                    this.addExternalAttributes(t1);
                }
                addExternalAttributes(t1) {
                    for(const e1 in this.attributes)t1.setAttribute(e1, this.attributes[e1]);
                }
                removeMathmlNodes(t1) {
                    const e1 = this.mathml;
                    for(let r1, n1 = 0; r1 = t1[n1]; n1++){
                        const t1 = e1.indexOf(r1);
                        -1 !== t1 && e1.splice(t1, 1);
                    }
                    this.mathml = e1;
                }
                displayTree_(t1) {
                    t1++;
                    const e1 = Array(t1).join("  ");
                    let r1 = "";
                    r1 += "\n" + e1 + this.toString(), r1 += "\n" + e1 + "MathmlTree:", r1 += "\n" + e1 + this.mathmlTreeString(), r1 += "\n" + e1 + "MathML:";
                    for(let t1, n1 = 0; t1 = this.mathml[n1]; n1++)r1 += "\n" + e1 + t1.toString();
                    return r1 += "\n" + e1 + "Begin Content", this.contentNodes.forEach(function(e1) {
                        r1 += e1.displayTree_(t1);
                    }), r1 += "\n" + e1 + "End Content", r1 += "\n" + e1 + "Begin Children", this.childNodes.forEach(function(e1) {
                        r1 += e1.displayTree_(t1);
                    }), r1 += "\n" + e1 + "End Children", r1;
                }
                mathmlTreeString() {
                    return this.mathmlTree ? this.mathmlTree.toString() : "EMPTY";
                }
                addAnnotation_(t1, e1) {
                    const r1 = this.annotation[t1];
                    r1 ? r1.push(e1) : this.annotation[t1] = [
                        e1
                    ];
                }
            }
            e1.SemanticNode = s1;
        },
        6537: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticNodeFactory = void 0;
            const n1 = r1(8158), o1 = r1(8158), i1 = r1(5952);
            e1.SemanticNodeFactory = class {
                constructor(){
                    this.leafMap = new o1.SemanticNodeCollator, this.defaultMap = new n1.SemanticDefault, this.idCounter_ = -1;
                }
                makeNode(t1) {
                    return this.createNode_(t1);
                }
                makeUnprocessed(t1) {
                    const e1 = this.createNode_();
                    return e1.mathml = [
                        t1
                    ], e1.mathmlTree = t1, e1;
                }
                makeEmptyNode() {
                    const t1 = this.createNode_();
                    return t1.type = "empty", t1;
                }
                makeContentNode(t1) {
                    const e1 = this.createNode_();
                    return e1.updateContent(t1), e1;
                }
                makeMultipleContentNodes(t1, e1) {
                    const r1 = [];
                    for(let n1 = 0; n1 < t1; n1++)r1.push(this.makeContentNode(e1));
                    return r1;
                }
                makeLeafNode(t1, e1) {
                    if (!t1) return this.makeEmptyNode();
                    const r1 = this.makeContentNode(t1);
                    r1.font = e1 || r1.font;
                    const n1 = this.defaultMap.retrieveNode(r1);
                    return n1 && (r1.type = n1.type, r1.role = n1.role, r1.font = n1.font), this.leafMap.addNode(r1), r1;
                }
                makeBranchNode(t1, e1, r1, n1) {
                    const o1 = this.createNode_();
                    return n1 && o1.updateContent(n1), o1.type = t1, o1.childNodes = e1, o1.contentNodes = r1, e1.concat(r1).forEach(function(t1) {
                        t1.parent = o1, o1.addMathmlNodes(t1.mathml);
                    }), o1;
                }
                createNode_(t1) {
                    return void 0 !== t1 ? this.idCounter_ = Math.max(this.idCounter_, t1) : t1 = ++this.idCounter_, new i1.SemanticNode(t1);
                }
            };
        },
        3882: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticComparator = e1.reduce = e1.sort = e1.apply = e1.add = void 0;
            const r1 = [];
            function n1(t1) {
                r1.push(t1);
            }
            function o1(t1, e1) {
                for(let n1, o1 = 0; n1 = r1[o1]; o1++){
                    const r1 = n1.compare(t1, e1);
                    if (0 !== r1) return r1;
                }
                return 0;
            }
            function i1(t1) {
                t1.sort(o1);
            }
            e1.add = n1, e1.apply = o1, e1.sort = i1, e1.reduce = function(t1) {
                if (t1.length <= 1) return t1;
                const e1 = t1.slice();
                i1(e1);
                const r1 = [];
                let n1;
                do n1 = e1.pop(), r1.push(n1);
                while (n1 && e1.length && 0 === o1(e1[e1.length - 1], n1));
                return r1;
            };
            class s1 {
                constructor(t1, e1 = null){
                    this.comparator = t1, this.type = e1, n1(this);
                }
                compare(t1, e1) {
                    return this.type && this.type === t1.type && this.type === e1.type ? this.comparator(t1, e1) : 0;
                }
            }
            e1.SemanticComparator = s1, new s1(function(t1, e1) {
                return "simple function" === t1.role ? 1 : "simple function" === e1.role ? -1 : 0;
            }, "identifier");
        },
        5250: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticAbstractParser = void 0;
            const n1 = r1(6537);
            e1.SemanticAbstractParser = class {
                constructor(t1){
                    this.type = t1, this.factory_ = new n1.SemanticNodeFactory;
                }
                getFactory() {
                    return this.factory_;
                }
                setFactory(t1) {
                    this.factory_ = t1;
                }
                getType() {
                    return this.type;
                }
                parseList(t1) {
                    const e1 = [];
                    for(let r1, n1 = 0; r1 = t1[n1]; n1++)e1.push(this.parse(r1));
                    return e1;
                }
            };
        },
        5609: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.isMembership = e1.elligibleRightNeutral = e1.elligibleLeftNeutral = e1.compareNeutralFences = e1.isNeutralFence = e1.isImplicitOp = e1.isImplicit = e1.isPureUnit = e1.isUnitCounter = e1.isNumber = e1.isSingletonSetContent = e1.scriptedElement_ = e1.illegalSingleton_ = e1.isSetNode = e1.isRightBrace = e1.isLeftBrace = e1.isSimpleFunction = e1.singlePunctAtPosition = e1.isSimpleFunctionHead = e1.isLimitBase = e1.isBinomial = e1.lineIsLabelled = e1.tableIsMultiline = e1.tableIsCases = e1.isFencedElement = e1.tableIsMatrixOrVector = e1.isTableOrMultiline = e1.isElligibleEmbellishedFence = e1.isFence = e1.isPunctuation = e1.isRelation = e1.isOperator = e1.isEmbellished = e1.isGeneralFunctionBoundary = e1.isIntegralDxBoundarySingle = e1.isIntegralDxBoundary = e1.isBigOpBoundary = e1.isPrefixFunctionBoundary = e1.isSimpleFunctionScope = e1.isAccent = e1.isRole = e1.embellishedType = e1.isType = void 0;
            const n1 = r1(3588), o1 = r1(4795);
            function i1(t1, e1) {
                return t1.type === e1;
            }
            function s1(t1, e1) {
                return t1.embellished === e1;
            }
            function a1(t1, e1) {
                return t1.role === e1;
            }
            function l1(t1) {
                return u1(t1) || p1(t1);
            }
            function c1(t1) {
                return i1(t1, "operator") || s1(t1, "operator");
            }
            function u1(t1) {
                return i1(t1, "relation") || s1(t1, "relation");
            }
            function p1(t1) {
                return i1(t1, "punctuation") || s1(t1, "punctuation");
            }
            function h1(t1) {
                return i1(t1, "fence") || s1(t1, "fence");
            }
            function f1(t1) {
                return !t1.embellished || !function(t1) {
                    return i1(t1, "tensor") && (!i1(t1.childNodes[1], "empty") || !i1(t1.childNodes[2], "empty")) && (!i1(t1.childNodes[3], "empty") || !i1(t1.childNodes[4], "empty"));
                }(t1) && (!a1(t1, "close") || !i1(t1, "tensor")) && (!a1(t1, "open") || !i1(t1, "subscript") && !i1(t1, "superscript")) && f1(t1.childNodes[0]);
            }
            function d1(t1) {
                return !!t1 && (i1(t1, "table") || i1(t1, "multiline"));
            }
            function m1(t1) {
                return !!t1 && i1(t1, "fenced") && (a1(t1, "leftright") || v1(t1)) && 1 === t1.childNodes.length;
            }
            function y1(t1) {
                return !!t1 && -1 !== [
                    "{",
                    "﹛",
                    "｛"
                ].indexOf(t1.textContent);
            }
            function g1(t1) {
                return !!t1 && -1 !== [
                    "}",
                    "﹜",
                    "｝"
                ].indexOf(t1.textContent);
            }
            function b1(t1) {
                return "number" === t1.type && ("integer" === t1.role || "float" === t1.role);
            }
            function v1(t1) {
                return "neutral" === t1.role || "metric" === t1.role;
            }
            e1.isType = i1, e1.embellishedType = s1, e1.isRole = a1, e1.isAccent = function(t1) {
                const e1 = new RegExp("∞|᪲");
                return i1(t1, "fence") || i1(t1, "punctuation") || i1(t1, "operator") && !t1.textContent.match(e1) || i1(t1, "relation") || i1(t1, "identifier") && a1(t1, "unknown") && !t1.textContent.match(n1.allLettersRegExp) && !t1.textContent.match(e1);
            }, e1.isSimpleFunctionScope = function(t1) {
                const e1 = t1.childNodes;
                if (0 === e1.length) return !0;
                if (e1.length > 1) return !1;
                const r1 = e1[0];
                if ("infixop" === r1.type) {
                    if ("implicit" !== r1.role) return !1;
                    if (r1.childNodes.some((t1)=>i1(t1, "infixop"))) return !1;
                }
                return !0;
            }, e1.isPrefixFunctionBoundary = function(t1) {
                return c1(t1) && !a1(t1, "division") || i1(t1, "appl") || l1(t1);
            }, e1.isBigOpBoundary = function(t1) {
                return c1(t1) || l1(t1);
            }, e1.isIntegralDxBoundary = function(t1, e1) {
                return !!e1 && i1(e1, "identifier") && n1.lookupSecondary("d", t1.textContent);
            }, e1.isIntegralDxBoundarySingle = function(t1) {
                if (i1(t1, "identifier")) {
                    const e1 = t1.textContent[0];
                    return e1 && t1.textContent[1] && n1.lookupSecondary("d", e1);
                }
                return !1;
            }, e1.isGeneralFunctionBoundary = l1, e1.isEmbellished = function(t1) {
                return t1.embellished ? t1.embellished : n1.isEmbellishedType(t1.type) ? t1.type : null;
            }, e1.isOperator = c1, e1.isRelation = u1, e1.isPunctuation = p1, e1.isFence = h1, e1.isElligibleEmbellishedFence = function(t1) {
                return !(!t1 || !h1(t1)) && (!t1.embellished || f1(t1));
            }, e1.isTableOrMultiline = d1, e1.tableIsMatrixOrVector = function(t1) {
                return !!t1 && m1(t1) && d1(t1.childNodes[0]);
            }, e1.isFencedElement = m1, e1.tableIsCases = function(t1, e1) {
                return e1.length > 0 && a1(e1[e1.length - 1], "openfence");
            }, e1.tableIsMultiline = function(t1) {
                return t1.childNodes.every(function(t1) {
                    return t1.childNodes.length <= 1;
                });
            }, e1.lineIsLabelled = function(t1) {
                return i1(t1, "line") && t1.contentNodes.length && a1(t1.contentNodes[0], "label");
            }, e1.isBinomial = function(t1) {
                return 2 === t1.childNodes.length;
            }, e1.isLimitBase = function t1(e1) {
                return i1(e1, "largeop") || i1(e1, "limboth") || i1(e1, "limlower") || i1(e1, "limupper") || i1(e1, "function") && a1(e1, "limit function") || (i1(e1, "overscore") || i1(e1, "underscore")) && t1(e1.childNodes[0]);
            }, e1.isSimpleFunctionHead = function(t1) {
                return "identifier" === t1.type || "latinletter" === t1.role || "greekletter" === t1.role || "otherletter" === t1.role;
            }, e1.singlePunctAtPosition = function(t1, e1, r1) {
                return 1 === e1.length && ("punctuation" === t1[r1].type || "punctuation" === t1[r1].embellished) && t1[r1] === e1[0];
            }, e1.isSimpleFunction = function(t1) {
                return i1(t1, "identifier") && a1(t1, "simple function");
            }, e1.isLeftBrace = y1, e1.isRightBrace = g1, e1.isSetNode = function(t1) {
                return y1(t1.contentNodes[0]) && g1(t1.contentNodes[1]);
            }, e1.illegalSingleton_ = [
                "punctuation",
                "punctuated",
                "relseq",
                "multirel",
                "table",
                "multiline",
                "cases",
                "inference"
            ], e1.scriptedElement_ = [
                "limupper",
                "limlower",
                "limboth",
                "subscript",
                "superscript",
                "underscore",
                "overscore",
                "tensor"
            ], e1.isSingletonSetContent = function t1(r1) {
                const n1 = r1.type;
                return -1 === e1.illegalSingleton_.indexOf(n1) && ("infixop" !== n1 || "implicit" === r1.role) && ("fenced" === n1 ? "leftright" !== r1.role || t1(r1.childNodes[0]) : -1 === e1.scriptedElement_.indexOf(n1) || t1(r1.childNodes[0]));
            }, e1.isNumber = b1, e1.isUnitCounter = function(t1) {
                return b1(t1) || "vulgar" === t1.role || "mixed" === t1.role;
            }, e1.isPureUnit = function(t1) {
                const e1 = t1.childNodes;
                return "unit" === t1.role && (!e1.length || "unit" === e1[0].role);
            }, e1.isImplicit = function(t1) {
                return "implicit" === t1.role || "unit" === t1.role && !!t1.contentNodes.length && t1.contentNodes[0].textContent === n1.invisibleTimes();
            }, e1.isImplicitOp = function(t1) {
                return "infixop" === t1.type && "implicit" === t1.role;
            }, e1.isNeutralFence = v1, e1.compareNeutralFences = function(t1, e1) {
                return v1(t1) && v1(e1) && (0, o1.getEmbellishedInner)(t1).textContent === (0, o1.getEmbellishedInner)(e1).textContent;
            }, e1.elligibleLeftNeutral = function(t1) {
                return !!v1(t1) && (!t1.embellished || "superscript" !== t1.type && "subscript" !== t1.type && ("tensor" !== t1.type || "empty" === t1.childNodes[3].type && "empty" === t1.childNodes[4].type));
            }, e1.elligibleRightNeutral = function(t1) {
                return !!v1(t1) && (!t1.embellished || "tensor" !== t1.type || "empty" === t1.childNodes[1].type && "empty" === t1.childNodes[2].type);
            }, e1.isMembership = function(t1) {
                return [
                    "element",
                    "nonelement",
                    "reelement",
                    "renonelement"
                ].includes(t1.role);
            };
        },
        3308: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            const n1 = r1(5740), o1 = r1(3588), i1 = r1(7516), s1 = r1(6537), a1 = r1(5609), l1 = r1(4795);
            class c1 {
                constructor(){
                    this.funcAppls = {}, this.factory_ = new s1.SemanticNodeFactory, i1.updateFactory(this.factory_);
                }
                static getInstance() {
                    return c1.instance = c1.instance || new c1, c1.instance;
                }
                static tableToMultiline(t1) {
                    if (a1.tableIsMultiline(t1)) {
                        t1.type = "multiline";
                        for(let e1, r1 = 0; e1 = t1.childNodes[r1]; r1++)c1.rowToLine_(e1, "multiline");
                        1 === t1.childNodes.length && !a1.lineIsLabelled(t1.childNodes[0]) && a1.isFencedElement(t1.childNodes[0].childNodes[0]) && c1.tableToMatrixOrVector_(c1.rewriteFencedLine_(t1)), c1.binomialForm_(t1), c1.classifyMultiline(t1);
                    } else c1.classifyTable(t1);
                }
                static number(t1) {
                    "unknown" !== t1.type && "identifier" !== t1.type || (t1.type = "number"), c1.numberRole_(t1), c1.exprFont_(t1);
                }
                static classifyMultiline(t1) {
                    let e1 = 0;
                    const r1 = t1.childNodes.length;
                    let n1;
                    for(; e1 < r1 && (!(n1 = t1.childNodes[e1]) || !n1.childNodes.length);)e1++;
                    if (e1 >= r1) return;
                    const o1 = n1.childNodes[0].role;
                    "unknown" !== o1 && t1.childNodes.every(function(t1) {
                        const e1 = t1.childNodes[0];
                        return !e1 || e1.role === o1 && (a1.isType(e1, "relation") || a1.isType(e1, "relseq"));
                    }) && (t1.role = o1);
                }
                static classifyTable(t1) {
                    const e1 = c1.computeColumns_(t1);
                    c1.classifyByColumns_(t1, e1, "equality") || c1.classifyByColumns_(t1, e1, "inequality", [
                        "equality"
                    ]) || c1.classifyByColumns_(t1, e1, "arrow") || c1.detectCaleyTable(t1);
                }
                static detectCaleyTable(t1) {
                    if (!t1.mathmlTree) return !1;
                    const e1 = t1.mathmlTree, r1 = e1.getAttribute("columnlines"), n1 = e1.getAttribute("rowlines");
                    return !(!r1 || !n1) && !(!c1.cayleySpacing(r1) || !c1.cayleySpacing(n1)) && (t1.role = "cayley", !0);
                }
                static cayleySpacing(t1) {
                    const e1 = t1.split(" ");
                    return ("solid" === e1[0] || "dashed" === e1[0]) && e1.slice(1).every((t1)=>"none" === t1);
                }
                static proof(t1, e1, r1) {
                    const n1 = c1.separateSemantics(e1);
                    return c1.getInstance().proof(t1, n1, r1);
                }
                static findSemantics(t1, e1, r1) {
                    const n1 = null == r1 ? null : r1, o1 = c1.getSemantics(t1);
                    return !!o1 && !!o1[e1] && (null == n1 || o1[e1] === n1);
                }
                static getSemantics(t1) {
                    const e1 = t1.getAttribute("semantics");
                    return e1 ? c1.separateSemantics(e1) : null;
                }
                static removePrefix(t1) {
                    const [, ...e1] = t1.split("_");
                    return e1.join("_");
                }
                static separateSemantics(t1) {
                    const e1 = {};
                    return t1.split(";").forEach(function(t1) {
                        const [r1, n1] = t1.split(":");
                        e1[c1.removePrefix(r1)] = n1;
                    }), e1;
                }
                static matchSpaces_(t1, e1) {
                    for(let r1, n1 = 0; r1 = e1[n1]; n1++){
                        const e1 = t1[n1].mathmlTree, o1 = t1[n1 + 1].mathmlTree;
                        if (!e1 || !o1) continue;
                        const i1 = e1.nextSibling;
                        if (!i1 || i1 === o1) continue;
                        const s1 = c1.getSpacer_(i1);
                        s1 && (r1.mathml.push(s1), r1.mathmlTree = s1, r1.role = "space");
                    }
                }
                static getSpacer_(t1) {
                    if ("MSPACE" === n1.tagName(t1)) return t1;
                    for(; l1.hasEmptyTag(t1) && 1 === t1.childNodes.length;)if (t1 = t1.childNodes[0], "MSPACE" === n1.tagName(t1)) return t1;
                    return null;
                }
                static fenceToPunct_(t1) {
                    const e1 = c1.FENCE_TO_PUNCT_[t1.role];
                    if (e1) {
                        for(; t1.embellished;)t1.embellished = "punctuation", a1.isRole(t1, "subsup") || a1.isRole(t1, "underover") || (t1.role = e1), t1 = t1.childNodes[0];
                        t1.type = "punctuation", t1.role = e1;
                    }
                }
                static classifyFunction_(t1, e1) {
                    if ("appl" === t1.type || "bigop" === t1.type || "integral" === t1.type) return "";
                    if (e1[0] && e1[0].textContent === o1.functionApplication()) {
                        c1.getInstance().funcAppls[t1.id] = e1.shift();
                        let r1 = "simple function";
                        return i1.run("simple2prefix", t1), "prefix function" !== t1.role && "limit function" !== t1.role || (r1 = t1.role), c1.propagateFunctionRole_(t1, r1), "prefix";
                    }
                    const r1 = c1.CLASSIFY_FUNCTION_[t1.role];
                    return r1 || (a1.isSimpleFunctionHead(t1) ? "simple" : "");
                }
                static propagateFunctionRole_(t1, e1) {
                    if (t1) {
                        if ("infixop" === t1.type) return;
                        a1.isRole(t1, "subsup") || a1.isRole(t1, "underover") || (t1.role = e1), c1.propagateFunctionRole_(t1.childNodes[0], e1);
                    }
                }
                static getFunctionOp_(t1, e1) {
                    if (e1(t1)) return t1;
                    for(let r1, n1 = 0; r1 = t1.childNodes[n1]; n1++){
                        const t1 = c1.getFunctionOp_(r1, e1);
                        if (t1) return t1;
                    }
                    return null;
                }
                static tableToMatrixOrVector_(t1) {
                    const e1 = t1.childNodes[0];
                    a1.isType(e1, "multiline") ? c1.tableToVector_(t1) : c1.tableToMatrix_(t1), t1.contentNodes.forEach(e1.appendContentNode.bind(e1));
                    for(let t1, r1 = 0; t1 = e1.childNodes[r1]; r1++)c1.assignRoleToRow_(t1, c1.getComponentRoles_(e1));
                    return e1.parent = null, e1;
                }
                static tableToVector_(t1) {
                    const e1 = t1.childNodes[0];
                    e1.type = "vector", 1 !== e1.childNodes.length ? c1.binomialForm_(e1) : c1.tableToSquare_(t1);
                }
                static binomialForm_(t1) {
                    a1.isBinomial(t1) && (t1.role = "binomial", t1.childNodes[0].role = "binomial", t1.childNodes[1].role = "binomial");
                }
                static tableToMatrix_(t1) {
                    const e1 = t1.childNodes[0];
                    e1.type = "matrix", e1.childNodes && e1.childNodes.length > 0 && e1.childNodes[0].childNodes && e1.childNodes.length === e1.childNodes[0].childNodes.length ? c1.tableToSquare_(t1) : e1.childNodes && 1 === e1.childNodes.length && (e1.role = "rowvector");
                }
                static tableToSquare_(t1) {
                    const e1 = t1.childNodes[0];
                    a1.isNeutralFence(t1) ? e1.role = "determinant" : e1.role = "squarematrix";
                }
                static getComponentRoles_(t1) {
                    const e1 = t1.role;
                    return e1 && "unknown" !== e1 ? e1 : t1.type.toLowerCase() || "unknown";
                }
                static tableToCases_(t1, e1) {
                    for(let e1, r1 = 0; e1 = t1.childNodes[r1]; r1++)c1.assignRoleToRow_(e1, "cases");
                    return t1.type = "cases", t1.appendContentNode(e1), a1.tableIsMultiline(t1) && c1.binomialForm_(t1), t1;
                }
                static rewriteFencedLine_(t1) {
                    const e1 = t1.childNodes[0], r1 = t1.childNodes[0].childNodes[0], n1 = t1.childNodes[0].childNodes[0].childNodes[0];
                    return r1.parent = t1.parent, t1.parent = r1, n1.parent = e1, r1.childNodes = [
                        t1
                    ], e1.childNodes = [
                        n1
                    ], r1;
                }
                static rowToLine_(t1, e1) {
                    const r1 = e1 || "unknown";
                    a1.isType(t1, "row") && (t1.type = "line", t1.role = r1, 1 === t1.childNodes.length && a1.isType(t1.childNodes[0], "cell") && (t1.childNodes = t1.childNodes[0].childNodes, t1.childNodes.forEach(function(e1) {
                        e1.parent = t1;
                    })));
                }
                static assignRoleToRow_(t1, e1) {
                    a1.isType(t1, "line") ? t1.role = e1 : a1.isType(t1, "row") && (t1.role = e1, t1.childNodes.forEach(function(t1) {
                        a1.isType(t1, "cell") && (t1.role = e1);
                    }));
                }
                static nextSeparatorFunction_(t1) {
                    let e1;
                    if (t1) {
                        if (t1.match(/^\s+$/)) return null;
                        e1 = t1.replace(/\s/g, "").split("").filter(function(t1) {
                            return t1;
                        });
                    } else e1 = [
                        ","
                    ];
                    return function() {
                        return e1.length > 1 ? e1.shift() : e1[0];
                    };
                }
                static numberRole_(t1) {
                    if ("unknown" !== t1.role) return;
                    const e1 = [
                        ...t1.textContent
                    ].filter((t1)=>t1.match(/[^\s]/)), r1 = e1.map(o1.lookupMeaning);
                    if (r1.every(function(t1) {
                        return "number" === t1.type && "integer" === t1.role || "punctuation" === t1.type && "comma" === t1.role;
                    })) return t1.role = "integer", void ("0" === e1[0] && t1.addAnnotation("general", "basenumber"));
                    r1.every(function(t1) {
                        return "number" === t1.type && "integer" === t1.role || "punctuation" === t1.type;
                    }) ? t1.role = "float" : t1.role = "othernumber";
                }
                static exprFont_(t1) {
                    if ("unknown" !== t1.font) return;
                    const e1 = [
                        ...t1.textContent
                    ].map(o1.lookupMeaning).reduce(function(t1, e1) {
                        return t1 && e1.font && "unknown" !== e1.font && e1.font !== t1 ? "unknown" === t1 ? e1.font : null : t1;
                    }, "unknown");
                    e1 && (t1.font = e1);
                }
                static purgeFences_(t1) {
                    const e1 = t1.rel, r1 = t1.comp, n1 = [], o1 = [];
                    for(; e1.length > 0;){
                        const t1 = e1.shift();
                        let i1 = r1.shift();
                        a1.isElligibleEmbellishedFence(t1) ? (n1.push(t1), o1.push(i1)) : (c1.fenceToPunct_(t1), i1.push(t1), i1 = i1.concat(r1.shift()), r1.unshift(i1));
                    }
                    return o1.push(r1.shift()), {
                        rel: n1,
                        comp: o1
                    };
                }
                static rewriteFencedNode_(t1) {
                    const e1 = t1.contentNodes[0], r1 = t1.contentNodes[1];
                    let n1 = c1.rewriteFence_(t1, e1);
                    return t1.contentNodes[0] = n1.fence, n1 = c1.rewriteFence_(n1.node, r1), t1.contentNodes[1] = n1.fence, t1.contentNodes[0].parent = t1, t1.contentNodes[1].parent = t1, n1.node.parent = null, n1.node;
                }
                static rewriteFence_(t1, e1) {
                    if (!e1.embellished) return {
                        node: t1,
                        fence: e1
                    };
                    const r1 = e1.childNodes[0], n1 = c1.rewriteFence_(t1, r1);
                    return a1.isType(e1, "superscript") || a1.isType(e1, "subscript") || a1.isType(e1, "tensor") ? (a1.isRole(e1, "subsup") || (e1.role = t1.role), r1 !== n1.node && (e1.replaceChild(r1, n1.node), r1.parent = t1), c1.propagateFencePointer_(e1, r1), {
                        node: e1,
                        fence: n1.fence
                    }) : (e1.replaceChild(r1, n1.fence), e1.mathmlTree && -1 === e1.mathml.indexOf(e1.mathmlTree) && e1.mathml.push(e1.mathmlTree), {
                        node: n1.node,
                        fence: e1
                    });
                }
                static propagateFencePointer_(t1, e1) {
                    t1.fencePointer = e1.fencePointer || e1.id.toString(), t1.embellished = null;
                }
                static classifyByColumns_(t1, e1, r1, n1) {
                    return !!(3 === e1.length && c1.testColumns_(e1, 1, (t1)=>c1.isPureRelation_(t1, r1)) || 2 === e1.length && (c1.testColumns_(e1, 1, (t1)=>c1.isEndRelation_(t1, r1) || c1.isPureRelation_(t1, r1)) || c1.testColumns_(e1, 0, (t1)=>c1.isEndRelation_(t1, r1, !0) || c1.isPureRelation_(t1, r1)))) && (t1.role = r1, !0);
                }
                static isEndRelation_(t1, e1, r1) {
                    const n1 = r1 ? t1.childNodes.length - 1 : 0;
                    return a1.isType(t1, "relseq") && a1.isRole(t1, e1) && a1.isType(t1.childNodes[n1], "empty");
                }
                static isPureRelation_(t1, e1) {
                    return a1.isType(t1, "relation") && a1.isRole(t1, e1);
                }
                static computeColumns_(t1) {
                    const e1 = [];
                    for(let r1, n1 = 0; r1 = t1.childNodes[n1]; n1++)for(let t1, n1 = 0; t1 = r1.childNodes[n1]; n1++)e1[n1] ? e1[n1].push(t1) : e1[n1] = [
                        t1
                    ];
                    return e1;
                }
                static testColumns_(t1, e1, r1) {
                    const n1 = t1[e1];
                    return !!n1 && n1.some(function(t1) {
                        return t1.childNodes.length && r1(t1.childNodes[0]);
                    }) && n1.every(function(t1) {
                        return !t1.childNodes.length || r1(t1.childNodes[0]);
                    });
                }
                setNodeFactory(t1) {
                    c1.getInstance().factory_ = t1, i1.updateFactory(c1.getInstance().factory_);
                }
                getNodeFactory() {
                    return c1.getInstance().factory_;
                }
                identifierNode(t1, e1, r1) {
                    if ("MathML-Unit" === r1) t1.type = "identifier", t1.role = "unit";
                    else if (!e1 && 1 === t1.textContent.length && ("integer" === t1.role || "latinletter" === t1.role || "greekletter" === t1.role) && "normal" === t1.font) return t1.font = "italic", i1.run("simpleNamedFunction", t1);
                    return "unknown" === t1.type && (t1.type = "identifier"), c1.exprFont_(t1), i1.run("simpleNamedFunction", t1);
                }
                implicitNode(t1) {
                    if (t1 = c1.getInstance().getMixedNumbers_(t1), 1 === (t1 = c1.getInstance().combineUnits_(t1)).length) return t1[0];
                    const e1 = c1.getInstance().implicitNode_(t1);
                    return i1.run("combine_juxtaposition", e1);
                }
                text(t1, e1) {
                    return c1.exprFont_(t1), t1.type = "text", "MS" === e1 ? (t1.role = "string", t1) : "MSPACE" === e1 || t1.textContent.match(/^\s*$/) ? (t1.role = "space", t1) : t1;
                }
                row(t1) {
                    return 0 === (t1 = t1.filter(function(t1) {
                        return !a1.isType(t1, "empty");
                    })).length ? c1.getInstance().factory_.makeEmptyNode() : (t1 = c1.getInstance().getFencesInRow_(t1), t1 = c1.getInstance().tablesInRow(t1), t1 = c1.getInstance().getPunctuationInRow_(t1), t1 = c1.getInstance().getTextInRow_(t1), t1 = c1.getInstance().getFunctionsInRow_(t1), c1.getInstance().relationsInRow_(t1));
                }
                limitNode(t1, e1) {
                    if (!e1.length) return c1.getInstance().factory_.makeEmptyNode();
                    let r1, n1 = e1[0], o1 = "unknown";
                    if (!e1[1]) return n1;
                    if (a1.isLimitBase(n1)) {
                        r1 = c1.MML_TO_LIMIT_[t1];
                        const i1 = r1.length;
                        if (o1 = r1.type, e1 = e1.slice(0, r1.length + 1), 1 === i1 && a1.isAccent(e1[1]) || 2 === i1 && a1.isAccent(e1[1]) && a1.isAccent(e1[2])) return r1 = c1.MML_TO_BOUNDS_[t1], c1.getInstance().accentNode_(n1, e1, r1.type, r1.length, r1.accent);
                        if (2 === i1) {
                            if (a1.isAccent(e1[1])) return n1 = c1.getInstance().accentNode_(n1, [
                                n1,
                                e1[1]
                            ], {
                                MSUBSUP: "subscript",
                                MUNDEROVER: "underscore"
                            }[t1], 1, !0), e1[2] ? c1.getInstance().makeLimitNode_(n1, [
                                n1,
                                e1[2]
                            ], null, "limupper") : n1;
                            if (e1[2] && a1.isAccent(e1[2])) return n1 = c1.getInstance().accentNode_(n1, [
                                n1,
                                e1[2]
                            ], {
                                MSUBSUP: "superscript",
                                MUNDEROVER: "overscore"
                            }[t1], 1, !0), c1.getInstance().makeLimitNode_(n1, [
                                n1,
                                e1[1]
                            ], null, "limlower");
                            e1[i1] || (o1 = "limlower");
                        }
                        return c1.getInstance().makeLimitNode_(n1, e1, null, o1);
                    }
                    return r1 = c1.MML_TO_BOUNDS_[t1], c1.getInstance().accentNode_(n1, e1, r1.type, r1.length, r1.accent);
                }
                tablesInRow(t1) {
                    let e1 = l1.partitionNodes(t1, a1.tableIsMatrixOrVector), r1 = [];
                    for(let t1, n1 = 0; t1 = e1.rel[n1]; n1++)r1 = r1.concat(e1.comp.shift()), r1.push(c1.tableToMatrixOrVector_(t1));
                    r1 = r1.concat(e1.comp.shift()), e1 = l1.partitionNodes(r1, a1.isTableOrMultiline), r1 = [];
                    for(let t1, n1 = 0; t1 = e1.rel[n1]; n1++){
                        const n1 = e1.comp.shift();
                        a1.tableIsCases(t1, n1) && c1.tableToCases_(t1, n1.pop()), r1 = r1.concat(n1), r1.push(t1);
                    }
                    return r1.concat(e1.comp.shift());
                }
                mfenced(t1, e1, r1, n1) {
                    if (r1 && n1.length > 0) {
                        const t1 = c1.nextSeparatorFunction_(r1), e1 = [
                            n1.shift()
                        ];
                        n1.forEach((r1)=>{
                            e1.push(c1.getInstance().factory_.makeContentNode(t1())), e1.push(r1);
                        }), n1 = e1;
                    }
                    return t1 && e1 ? c1.getInstance().horizontalFencedNode_(c1.getInstance().factory_.makeContentNode(t1), c1.getInstance().factory_.makeContentNode(e1), n1) : (t1 && n1.unshift(c1.getInstance().factory_.makeContentNode(t1)), e1 && n1.push(c1.getInstance().factory_.makeContentNode(e1)), c1.getInstance().row(n1));
                }
                fractionLikeNode(t1, e1, r1, n1) {
                    let o1;
                    if (!n1 && l1.isZeroLength(r1)) {
                        const r1 = c1.getInstance().factory_.makeBranchNode("line", [
                            t1
                        ], []), n1 = c1.getInstance().factory_.makeBranchNode("line", [
                            e1
                        ], []);
                        return o1 = c1.getInstance().factory_.makeBranchNode("multiline", [
                            r1,
                            n1
                        ], []), c1.binomialForm_(o1), c1.classifyMultiline(o1), o1;
                    }
                    return o1 = c1.getInstance().fractionNode_(t1, e1), n1 && o1.addAnnotation("general", "bevelled"), o1;
                }
                tensor(t1, e1, r1, n1, o1) {
                    const i1 = c1.getInstance().factory_.makeBranchNode("tensor", [
                        t1,
                        c1.getInstance().scriptNode_(e1, "leftsub"),
                        c1.getInstance().scriptNode_(r1, "leftsuper"),
                        c1.getInstance().scriptNode_(n1, "rightsub"),
                        c1.getInstance().scriptNode_(o1, "rightsuper")
                    ], []);
                    return i1.role = t1.role, i1.embellished = a1.isEmbellished(t1), i1;
                }
                pseudoTensor(t1, e1, r1) {
                    const n1 = (t1)=>!a1.isType(t1, "empty"), o1 = e1.filter(n1).length, i1 = r1.filter(n1).length;
                    if (!o1 && !i1) return t1;
                    const s1 = o1 ? i1 ? "MSUBSUP" : "MSUB" : "MSUP", l1 = [
                        t1
                    ];
                    return o1 && l1.push(c1.getInstance().scriptNode_(e1, "rightsub", !0)), i1 && l1.push(c1.getInstance().scriptNode_(r1, "rightsuper", !0)), c1.getInstance().limitNode(s1, l1);
                }
                font(t1) {
                    const e1 = c1.MATHJAX_FONTS[t1];
                    return e1 || t1;
                }
                proof(t1, e1, r1) {
                    if (e1.inference || e1.axiom || console.log("Noise"), e1.axiom) {
                        const e1 = c1.getInstance().cleanInference(t1.childNodes), n1 = e1.length ? c1.getInstance().factory_.makeBranchNode("inference", r1(e1), []) : c1.getInstance().factory_.makeEmptyNode();
                        return n1.role = "axiom", n1.mathmlTree = t1, n1;
                    }
                    const n1 = c1.getInstance().inference(t1, e1, r1);
                    return e1.proof && (n1.role = "proof", n1.childNodes[0].role = "final"), n1;
                }
                inference(t1, e1, r1) {
                    if (e1.inferenceRule) {
                        const e1 = c1.getInstance().getFormulas(t1, [], r1);
                        return c1.getInstance().factory_.makeBranchNode("inference", [
                            e1.conclusion,
                            e1.premises
                        ], []);
                    }
                    const o1 = e1.labelledRule, i1 = n1.toArray(t1.childNodes), s1 = [];
                    "left" !== o1 && "both" !== o1 || s1.push(c1.getInstance().getLabel(t1, i1, r1, "left")), "right" !== o1 && "both" !== o1 || s1.push(c1.getInstance().getLabel(t1, i1, r1, "right"));
                    const a1 = c1.getInstance().getFormulas(t1, i1, r1), l1 = c1.getInstance().factory_.makeBranchNode("inference", [
                        a1.conclusion,
                        a1.premises
                    ], s1);
                    return l1.mathmlTree = t1, l1;
                }
                getLabel(t1, e1, r1, o1) {
                    const i1 = c1.getInstance().findNestedRow(e1, "prooflabel", o1), s1 = c1.getInstance().factory_.makeBranchNode("rulelabel", r1(n1.toArray(i1.childNodes)), []);
                    return s1.role = o1, s1.mathmlTree = i1, s1;
                }
                getFormulas(t1, e1, r1) {
                    const o1 = e1.length ? c1.getInstance().findNestedRow(e1, "inferenceRule") : t1, i1 = "up" === c1.getSemantics(o1).inferenceRule, s1 = i1 ? o1.childNodes[1] : o1.childNodes[0], a1 = i1 ? o1.childNodes[0] : o1.childNodes[1], l1 = s1.childNodes[0].childNodes[0], u1 = n1.toArray(l1.childNodes[0].childNodes), p1 = [];
                    let h1 = 1;
                    for (const t1 of u1)h1 % 2 && p1.push(t1.childNodes[0]), h1++;
                    const f1 = r1(p1), d1 = r1(n1.toArray(a1.childNodes[0].childNodes))[0], m1 = c1.getInstance().factory_.makeBranchNode("premises", f1, []);
                    m1.mathmlTree = l1;
                    const y1 = c1.getInstance().factory_.makeBranchNode("conclusion", [
                        d1
                    ], []);
                    return y1.mathmlTree = a1.childNodes[0].childNodes[0], {
                        conclusion: y1,
                        premises: m1
                    };
                }
                findNestedRow(t1, e1, r1) {
                    return c1.getInstance().findNestedRow_(t1, e1, 0, r1);
                }
                cleanInference(t1) {
                    return n1.toArray(t1).filter(function(t1) {
                        return "MSPACE" !== n1.tagName(t1);
                    });
                }
                operatorNode(t1) {
                    return "unknown" === t1.type && (t1.type = "operator"), i1.run("multioperator", t1);
                }
                implicitNode_(t1) {
                    const e1 = c1.getInstance().factory_.makeMultipleContentNodes(t1.length - 1, o1.invisibleTimes());
                    c1.matchSpaces_(t1, e1);
                    const r1 = c1.getInstance().infixNode_(t1, e1[0]);
                    return r1.role = "implicit", e1.forEach(function(t1) {
                        t1.parent = r1;
                    }), r1.contentNodes = e1, r1;
                }
                infixNode_(t1, e1) {
                    const r1 = c1.getInstance().factory_.makeBranchNode("infixop", t1, [
                        e1
                    ], l1.getEmbellishedInner(e1).textContent);
                    return r1.role = e1.role, i1.run("propagateSimpleFunction", r1);
                }
                explicitMixed_(t1) {
                    const e1 = l1.partitionNodes(t1, function(t1) {
                        return t1.textContent === o1.invisiblePlus();
                    });
                    if (!e1.rel.length) return t1;
                    let r1 = [];
                    for(let t1, n1 = 0; t1 = e1.rel[n1]; n1++){
                        const o1 = e1.comp[n1], i1 = e1.comp[n1 + 1], s1 = o1.length - 1;
                        if (o1[s1] && i1[0] && a1.isType(o1[s1], "number") && !a1.isRole(o1[s1], "mixed") && a1.isType(i1[0], "fraction")) {
                            const t1 = c1.getInstance().factory_.makeBranchNode("number", [
                                o1[s1],
                                i1[0]
                            ], []);
                            t1.role = "mixed", r1 = r1.concat(o1.slice(0, s1)), r1.push(t1), i1.shift();
                        } else r1 = r1.concat(o1), r1.push(t1);
                    }
                    return r1.concat(e1.comp[e1.comp.length - 1]);
                }
                concatNode_(t1, e1, r1) {
                    if (0 === e1.length) return t1;
                    const n1 = e1.map(function(t1) {
                        return l1.getEmbellishedInner(t1).textContent;
                    }).join(" "), o1 = c1.getInstance().factory_.makeBranchNode(r1, [
                        t1
                    ], e1, n1);
                    return e1.length > 1 && (o1.role = "multiop"), o1;
                }
                prefixNode_(t1, e1) {
                    const r1 = l1.partitionNodes(e1, (t1)=>a1.isRole(t1, "subtraction"));
                    let n1 = c1.getInstance().concatNode_(t1, r1.comp.pop(), "prefixop");
                    for(1 === n1.contentNodes.length && "addition" === n1.contentNodes[0].role && "+" === n1.contentNodes[0].textContent && (n1.role = "positive"); r1.rel.length > 0;)n1 = c1.getInstance().concatNode_(n1, [
                        r1.rel.pop()
                    ], "prefixop"), n1.role = "negative", n1 = c1.getInstance().concatNode_(n1, r1.comp.pop(), "prefixop");
                    return n1;
                }
                postfixNode_(t1, e1) {
                    return e1.length ? c1.getInstance().concatNode_(t1, e1, "postfixop") : t1;
                }
                combineUnits_(t1) {
                    const e1 = l1.partitionNodes(t1, function(t1) {
                        return !a1.isRole(t1, "unit");
                    });
                    if (t1.length === e1.rel.length) return e1.rel;
                    const r1 = [];
                    let n1, o1;
                    do {
                        const t1 = e1.comp.shift();
                        n1 = e1.rel.shift();
                        let i1 = null;
                        o1 = r1.pop(), o1 && (t1.length && a1.isUnitCounter(o1) ? t1.unshift(o1) : r1.push(o1)), 1 === t1.length && (i1 = t1.pop()), t1.length > 1 && (i1 = c1.getInstance().implicitNode_(t1), i1.role = "unit"), i1 && r1.push(i1), n1 && r1.push(n1);
                    }while (n1);
                    return r1;
                }
                getMixedNumbers_(t1) {
                    const e1 = l1.partitionNodes(t1, function(t1) {
                        return a1.isType(t1, "fraction") && a1.isRole(t1, "vulgar");
                    });
                    if (!e1.rel.length) return t1;
                    let r1 = [];
                    for(let t1, n1 = 0; t1 = e1.rel[n1]; n1++){
                        const o1 = e1.comp[n1], i1 = o1.length - 1;
                        if (o1[i1] && a1.isType(o1[i1], "number") && (a1.isRole(o1[i1], "integer") || a1.isRole(o1[i1], "float"))) {
                            const e1 = c1.getInstance().factory_.makeBranchNode("number", [
                                o1[i1],
                                t1
                            ], []);
                            e1.role = "mixed", r1 = r1.concat(o1.slice(0, i1)), r1.push(e1);
                        } else r1 = r1.concat(o1), r1.push(t1);
                    }
                    return r1.concat(e1.comp[e1.comp.length - 1]);
                }
                getTextInRow_(t1) {
                    if (t1.length <= 1) return t1;
                    const e1 = l1.partitionNodes(t1, (t1)=>a1.isType(t1, "text"));
                    if (0 === e1.rel.length) return t1;
                    const r1 = [];
                    let n1 = e1.comp[0];
                    n1.length > 0 && r1.push(c1.getInstance().row(n1));
                    for(let t1, o1 = 0; t1 = e1.rel[o1]; o1++)r1.push(t1), n1 = e1.comp[o1 + 1], n1.length > 0 && r1.push(c1.getInstance().row(n1));
                    return [
                        c1.getInstance().dummyNode_(r1)
                    ];
                }
                relationsInRow_(t1) {
                    const e1 = l1.partitionNodes(t1, a1.isRelation), r1 = e1.rel[0];
                    if (!r1) return c1.getInstance().operationsInRow_(t1);
                    if (1 === t1.length) return t1[0];
                    const n1 = e1.comp.map(c1.getInstance().operationsInRow_);
                    let o1;
                    return e1.rel.some(function(t1) {
                        return !t1.equals(r1);
                    }) ? (o1 = c1.getInstance().factory_.makeBranchNode("multirel", n1, e1.rel), e1.rel.every(function(t1) {
                        return t1.role === r1.role;
                    }) && (o1.role = r1.role), o1) : (o1 = c1.getInstance().factory_.makeBranchNode("relseq", n1, e1.rel, l1.getEmbellishedInner(r1).textContent), o1.role = r1.role, o1);
                }
                operationsInRow_(t1) {
                    if (0 === t1.length) return c1.getInstance().factory_.makeEmptyNode();
                    if (1 === (t1 = c1.getInstance().explicitMixed_(t1)).length) return t1[0];
                    const e1 = [];
                    for(; t1.length > 0 && a1.isOperator(t1[0]);)e1.push(t1.shift());
                    if (0 === t1.length) return c1.getInstance().prefixNode_(e1.pop(), e1);
                    if (1 === t1.length) return c1.getInstance().prefixNode_(t1[0], e1);
                    t1 = i1.run("convert_juxtaposition", t1);
                    const r1 = l1.sliceNodes(t1, a1.isOperator), n1 = c1.getInstance().prefixNode_(c1.getInstance().implicitNode(r1.head), e1);
                    return r1.div ? c1.getInstance().operationsTree_(r1.tail, n1, r1.div) : n1;
                }
                operationsTree_(t1, e1, r1, n1) {
                    const o1 = n1 || [];
                    if (0 === t1.length) {
                        if (o1.unshift(r1), "infixop" === e1.type) {
                            const t1 = c1.getInstance().postfixNode_(e1.childNodes.pop(), o1);
                            return e1.appendChild(t1), e1;
                        }
                        return c1.getInstance().postfixNode_(e1, o1);
                    }
                    const i1 = l1.sliceNodes(t1, a1.isOperator);
                    if (0 === i1.head.length) return o1.push(i1.div), c1.getInstance().operationsTree_(i1.tail, e1, r1, o1);
                    const s1 = c1.getInstance().prefixNode_(c1.getInstance().implicitNode(i1.head), o1), u1 = c1.getInstance().appendOperand_(e1, r1, s1);
                    return i1.div ? c1.getInstance().operationsTree_(i1.tail, u1, i1.div, []) : u1;
                }
                appendOperand_(t1, e1, r1) {
                    if ("infixop" !== t1.type) return c1.getInstance().infixNode_([
                        t1,
                        r1
                    ], e1);
                    const n1 = c1.getInstance().appendDivisionOp_(t1, e1, r1);
                    return n1 || (c1.getInstance().appendExistingOperator_(t1, e1, r1) ? t1 : "multiplication" === e1.role ? c1.getInstance().appendMultiplicativeOp_(t1, e1, r1) : c1.getInstance().appendAdditiveOp_(t1, e1, r1));
                }
                appendDivisionOp_(t1, e1, r1) {
                    return "division" === e1.role ? a1.isImplicit(t1) ? c1.getInstance().infixNode_([
                        t1,
                        r1
                    ], e1) : c1.getInstance().appendLastOperand_(t1, e1, r1) : "division" === t1.role ? c1.getInstance().infixNode_([
                        t1,
                        r1
                    ], e1) : null;
                }
                appendLastOperand_(t1, e1, r1) {
                    let n1 = t1, o1 = t1.childNodes[t1.childNodes.length - 1];
                    for(; o1 && "infixop" === o1.type && !a1.isImplicit(o1);)n1 = o1, o1 = n1.childNodes[t1.childNodes.length - 1];
                    const i1 = c1.getInstance().infixNode_([
                        n1.childNodes.pop(),
                        r1
                    ], e1);
                    return n1.appendChild(i1), t1;
                }
                appendMultiplicativeOp_(t1, e1, r1) {
                    if (a1.isImplicit(t1)) return c1.getInstance().infixNode_([
                        t1,
                        r1
                    ], e1);
                    let n1 = t1, o1 = t1.childNodes[t1.childNodes.length - 1];
                    for(; o1 && "infixop" === o1.type && !a1.isImplicit(o1);)n1 = o1, o1 = n1.childNodes[t1.childNodes.length - 1];
                    const i1 = c1.getInstance().infixNode_([
                        n1.childNodes.pop(),
                        r1
                    ], e1);
                    return n1.appendChild(i1), t1;
                }
                appendAdditiveOp_(t1, e1, r1) {
                    return c1.getInstance().infixNode_([
                        t1,
                        r1
                    ], e1);
                }
                appendExistingOperator_(t1, e1, r1) {
                    return !(!t1 || "infixop" !== t1.type || a1.isImplicit(t1)) && (t1.contentNodes[0].equals(e1) ? (t1.appendContentNode(e1), t1.appendChild(r1), !0) : c1.getInstance().appendExistingOperator_(t1.childNodes[t1.childNodes.length - 1], e1, r1));
                }
                getFencesInRow_(t1) {
                    let e1 = l1.partitionNodes(t1, a1.isFence);
                    e1 = c1.purgeFences_(e1);
                    const r1 = e1.comp.shift();
                    return c1.getInstance().fences_(e1.rel, e1.comp, [], [
                        r1
                    ]);
                }
                fences_(t1, e1, r1, n1) {
                    if (0 === t1.length && 0 === r1.length) return n1[0];
                    const o1 = (t1)=>a1.isRole(t1, "open");
                    if (0 === t1.length) {
                        const t1 = n1.shift();
                        for(; r1.length > 0;){
                            if (o1(r1[0])) {
                                const e1 = r1.shift();
                                c1.fenceToPunct_(e1), t1.push(e1);
                            } else {
                                const e1 = l1.sliceNodes(r1, o1), i1 = e1.head.length - 1, s1 = c1.getInstance().neutralFences_(e1.head, n1.slice(0, i1));
                                n1 = n1.slice(i1), t1.push(...s1), e1.div && e1.tail.unshift(e1.div), r1 = e1.tail;
                            }
                            t1.push(...n1.shift());
                        }
                        return t1;
                    }
                    const i1 = r1[r1.length - 1], s1 = t1[0].role;
                    if ("open" === s1 || a1.isNeutralFence(t1[0]) && (!i1 || !a1.compareNeutralFences(t1[0], i1))) {
                        r1.push(t1.shift());
                        const o1 = e1.shift();
                        return o1 && n1.push(o1), c1.getInstance().fences_(t1, e1, r1, n1);
                    }
                    if (i1 && "close" === s1 && "open" === i1.role) {
                        const o1 = c1.getInstance().horizontalFencedNode_(r1.pop(), t1.shift(), n1.pop());
                        return n1.push(n1.pop().concat([
                            o1
                        ], e1.shift())), c1.getInstance().fences_(t1, e1, r1, n1);
                    }
                    if (i1 && a1.compareNeutralFences(t1[0], i1)) {
                        if (!a1.elligibleLeftNeutral(i1) || !a1.elligibleRightNeutral(t1[0])) {
                            r1.push(t1.shift());
                            const o1 = e1.shift();
                            return o1 && n1.push(o1), c1.getInstance().fences_(t1, e1, r1, n1);
                        }
                        const o1 = c1.getInstance().horizontalFencedNode_(r1.pop(), t1.shift(), n1.pop());
                        return n1.push(n1.pop().concat([
                            o1
                        ], e1.shift())), c1.getInstance().fences_(t1, e1, r1, n1);
                    }
                    if (i1 && "close" === s1 && a1.isNeutralFence(i1) && r1.some(o1)) {
                        const i1 = l1.sliceNodes(r1, o1, !0), s1 = n1.pop(), a1 = n1.length - i1.tail.length + 1, u1 = c1.getInstance().neutralFences_(i1.tail, n1.slice(a1));
                        n1 = n1.slice(0, a1);
                        const p1 = c1.getInstance().horizontalFencedNode_(i1.div, t1.shift(), n1.pop().concat(u1, s1));
                        return n1.push(n1.pop().concat([
                            p1
                        ], e1.shift())), c1.getInstance().fences_(t1, e1, i1.head, n1);
                    }
                    const u1 = t1.shift();
                    return c1.fenceToPunct_(u1), n1.push(n1.pop().concat([
                        u1
                    ], e1.shift())), c1.getInstance().fences_(t1, e1, r1, n1);
                }
                neutralFences_(t1, e1) {
                    if (0 === t1.length) return t1;
                    if (1 === t1.length) return c1.fenceToPunct_(t1[0]), t1;
                    const r1 = t1.shift();
                    if (!a1.elligibleLeftNeutral(r1)) {
                        c1.fenceToPunct_(r1);
                        const n1 = e1.shift();
                        return n1.unshift(r1), n1.concat(c1.getInstance().neutralFences_(t1, e1));
                    }
                    const n1 = l1.sliceNodes(t1, function(t1) {
                        return a1.compareNeutralFences(t1, r1);
                    });
                    if (!n1.div) {
                        c1.fenceToPunct_(r1);
                        const n1 = e1.shift();
                        return n1.unshift(r1), n1.concat(c1.getInstance().neutralFences_(t1, e1));
                    }
                    if (!a1.elligibleRightNeutral(n1.div)) return c1.fenceToPunct_(n1.div), t1.unshift(r1), c1.getInstance().neutralFences_(t1, e1);
                    const o1 = c1.getInstance().combineFencedContent_(r1, n1.div, n1.head, e1);
                    if (n1.tail.length > 0) {
                        const t1 = o1.shift(), e1 = c1.getInstance().neutralFences_(n1.tail, o1);
                        return t1.concat(e1);
                    }
                    return o1[0];
                }
                combineFencedContent_(t1, e1, r1, n1) {
                    if (0 === r1.length) {
                        const r1 = c1.getInstance().horizontalFencedNode_(t1, e1, n1.shift());
                        return n1.length > 0 ? n1[0].unshift(r1) : n1 = [
                            [
                                r1
                            ]
                        ], n1;
                    }
                    const o1 = n1.shift(), i1 = r1.length - 1, s1 = n1.slice(0, i1), a1 = (n1 = n1.slice(i1)).shift(), l1 = c1.getInstance().neutralFences_(r1, s1);
                    o1.push(...l1), o1.push(...a1);
                    const u1 = c1.getInstance().horizontalFencedNode_(t1, e1, o1);
                    return n1.length > 0 ? n1[0].unshift(u1) : n1 = [
                        [
                            u1
                        ]
                    ], n1;
                }
                horizontalFencedNode_(t1, e1, r1) {
                    const n1 = c1.getInstance().row(r1);
                    let o1 = c1.getInstance().factory_.makeBranchNode("fenced", [
                        n1
                    ], [
                        t1,
                        e1
                    ]);
                    return "open" === t1.role ? (c1.getInstance().classifyHorizontalFence_(o1), o1 = i1.run("propagateComposedFunction", o1)) : o1.role = t1.role, o1 = i1.run("detect_cycle", o1), c1.rewriteFencedNode_(o1);
                }
                classifyHorizontalFence_(t1) {
                    t1.role = "leftright";
                    const e1 = t1.childNodes;
                    if (!a1.isSetNode(t1) || e1.length > 1) return;
                    if (0 === e1.length || "empty" === e1[0].type) return void (t1.role = "set empty");
                    const r1 = e1[0].type;
                    if (1 === e1.length && a1.isSingletonSetContent(e1[0])) return void (t1.role = "set singleton");
                    const n1 = e1[0].role;
                    if ("punctuated" === r1 && "sequence" === n1) {
                        if ("comma" !== e1[0].contentNodes[0].role) return 1 !== e1[0].contentNodes.length || "vbar" !== e1[0].contentNodes[0].role && "colon" !== e1[0].contentNodes[0].role ? void 0 : (t1.role = "set extended", void c1.getInstance().setExtension_(t1));
                        t1.role = "set collection";
                    }
                }
                setExtension_(t1) {
                    const e1 = t1.childNodes[0].childNodes[0];
                    e1 && "infixop" === e1.type && 1 === e1.contentNodes.length && a1.isMembership(e1.contentNodes[0]) && (e1.addAnnotation("set", "intensional"), e1.contentNodes[0].addAnnotation("set", "intensional"));
                }
                getPunctuationInRow_(t1) {
                    if (t1.length <= 1) return t1;
                    const e1 = (t1)=>{
                        const e1 = t1.type;
                        return "punctuation" === e1 || "text" === e1 || "operator" === e1 || "relation" === e1;
                    }, r1 = l1.partitionNodes(t1, function(r1) {
                        if (!a1.isPunctuation(r1)) return !1;
                        if (a1.isPunctuation(r1) && !a1.isRole(r1, "ellipsis")) return !0;
                        const n1 = t1.indexOf(r1);
                        if (0 === n1) return !t1[1] || !e1(t1[1]);
                        const o1 = t1[n1 - 1];
                        if (n1 === t1.length - 1) return !e1(o1);
                        const i1 = t1[n1 + 1];
                        return !e1(o1) || !e1(i1);
                    });
                    if (0 === r1.rel.length) return t1;
                    const n1 = [];
                    let o1 = r1.comp.shift();
                    o1.length > 0 && n1.push(c1.getInstance().row(o1));
                    let i1 = 0;
                    for(; r1.comp.length > 0;)n1.push(r1.rel[i1++]), o1 = r1.comp.shift(), o1.length > 0 && n1.push(c1.getInstance().row(o1));
                    return [
                        c1.getInstance().punctuatedNode_(n1, r1.rel)
                    ];
                }
                punctuatedNode_(t1, e1) {
                    const r1 = c1.getInstance().factory_.makeBranchNode("punctuated", t1, e1);
                    if (e1.length === t1.length) {
                        const t1 = e1[0].role;
                        if ("unknown" !== t1 && e1.every(function(e1) {
                            return e1.role === t1;
                        })) return r1.role = t1, r1;
                    }
                    return a1.singlePunctAtPosition(t1, e1, 0) ? r1.role = "startpunct" : a1.singlePunctAtPosition(t1, e1, t1.length - 1) ? r1.role = "endpunct" : e1.every((t1)=>a1.isRole(t1, "dummy")) ? r1.role = "text" : e1.every((t1)=>a1.isRole(t1, "space")) ? r1.role = "space" : r1.role = "sequence", r1;
                }
                dummyNode_(t1) {
                    const e1 = c1.getInstance().factory_.makeMultipleContentNodes(t1.length - 1, o1.invisibleComma());
                    return e1.forEach(function(t1) {
                        t1.role = "dummy";
                    }), c1.getInstance().punctuatedNode_(t1, e1);
                }
                accentRole_(t1, e1) {
                    if (!a1.isAccent(t1)) return !1;
                    const r1 = t1.textContent, n1 = o1.lookupSecondary("bar", r1) || o1.lookupSecondary("tilde", r1) || t1.role;
                    return t1.role = "underscore" === e1 ? "underaccent" : "overaccent", t1.addAnnotation("accent", n1), !0;
                }
                accentNode_(t1, e1, r1, n1, o1) {
                    const i1 = (e1 = e1.slice(0, n1 + 1))[1], s1 = e1[2];
                    let a1;
                    if (!o1 && s1 && (a1 = c1.getInstance().factory_.makeBranchNode("subscript", [
                        t1,
                        i1
                    ], []), a1.role = "subsup", e1 = [
                        a1,
                        s1
                    ], r1 = "superscript"), o1) {
                        const n1 = c1.getInstance().accentRole_(i1, r1);
                        if (s1) c1.getInstance().accentRole_(s1, "overscore") && !n1 ? (a1 = c1.getInstance().factory_.makeBranchNode("overscore", [
                            t1,
                            s1
                        ], []), e1 = [
                            a1,
                            i1
                        ], r1 = "underscore") : (a1 = c1.getInstance().factory_.makeBranchNode("underscore", [
                            t1,
                            i1
                        ], []), e1 = [
                            a1,
                            s1
                        ], r1 = "overscore"), a1.role = "underover";
                    }
                    return c1.getInstance().makeLimitNode_(t1, e1, a1, r1);
                }
                makeLimitNode_(t1, e1, r1, n1) {
                    if ("limupper" === n1 && "limlower" === t1.type) return t1.childNodes.push(e1[1]), e1[1].parent = t1, t1.type = "limboth", t1;
                    if ("limlower" === n1 && "limupper" === t1.type) return t1.childNodes.splice(1, -1, e1[1]), e1[1].parent = t1, t1.type = "limboth", t1;
                    const o1 = c1.getInstance().factory_.makeBranchNode(n1, e1, []), i1 = a1.isEmbellished(t1);
                    return r1 && (r1.embellished = i1), o1.embellished = i1, o1.role = t1.role, o1;
                }
                getFunctionsInRow_(t1, e1) {
                    const r1 = e1 || [];
                    if (0 === t1.length) return r1;
                    const n1 = t1.shift(), o1 = c1.classifyFunction_(n1, t1);
                    if (!o1) return r1.push(n1), c1.getInstance().getFunctionsInRow_(t1, r1);
                    const i1 = c1.getInstance().getFunctionsInRow_(t1, []), s1 = c1.getInstance().getFunctionArgs_(n1, i1, o1);
                    return r1.concat(s1);
                }
                getFunctionArgs_(t1, e1, r1) {
                    let n1, o1, i1;
                    switch(r1){
                        case "integral":
                            {
                                const r1 = c1.getInstance().getIntegralArgs_(e1);
                                if (!r1.intvar && !r1.integrand.length) return r1.rest.unshift(t1), r1.rest;
                                const n1 = c1.getInstance().row(r1.integrand);
                                return i1 = c1.getInstance().integralNode_(t1, n1, r1.intvar), r1.rest.unshift(i1), r1.rest;
                            }
                        case "prefix":
                            if (e1[0] && "fenced" === e1[0].type) {
                                const r1 = e1.shift();
                                return a1.isNeutralFence(r1) || (r1.role = "leftright"), i1 = c1.getInstance().functionNode_(t1, r1), e1.unshift(i1), e1;
                            }
                            if (n1 = l1.sliceNodes(e1, a1.isPrefixFunctionBoundary), n1.head.length) o1 = c1.getInstance().row(n1.head), n1.div && n1.tail.unshift(n1.div);
                            else {
                                if (!n1.div || !a1.isType(n1.div, "appl")) return e1.unshift(t1), e1;
                                o1 = n1.div;
                            }
                            return i1 = c1.getInstance().functionNode_(t1, o1), n1.tail.unshift(i1), n1.tail;
                        case "bigop":
                            return n1 = l1.sliceNodes(e1, a1.isBigOpBoundary), n1.head.length ? (o1 = c1.getInstance().row(n1.head), i1 = c1.getInstance().bigOpNode_(t1, o1), n1.div && n1.tail.unshift(n1.div), n1.tail.unshift(i1), n1.tail) : (e1.unshift(t1), e1);
                        default:
                            {
                                if (0 === e1.length) return [
                                    t1
                                ];
                                const r1 = e1[0];
                                return "fenced" === r1.type && !a1.isNeutralFence(r1) && a1.isSimpleFunctionScope(r1) ? (r1.role = "leftright", c1.propagateFunctionRole_(t1, "simple function"), i1 = c1.getInstance().functionNode_(t1, e1.shift()), e1.unshift(i1), e1) : (e1.unshift(t1), e1);
                            }
                    }
                }
                getIntegralArgs_(t1, e1 = []) {
                    if (0 === t1.length) return {
                        integrand: e1,
                        intvar: null,
                        rest: t1
                    };
                    const r1 = t1[0];
                    if (a1.isGeneralFunctionBoundary(r1)) return {
                        integrand: e1,
                        intvar: null,
                        rest: t1
                    };
                    if (a1.isIntegralDxBoundarySingle(r1)) return r1.role = "integral", {
                        integrand: e1,
                        intvar: r1,
                        rest: t1.slice(1)
                    };
                    if (t1[1] && a1.isIntegralDxBoundary(r1, t1[1])) {
                        const n1 = c1.getInstance().prefixNode_(t1[1], [
                            r1
                        ]);
                        return n1.role = "integral", {
                            integrand: e1,
                            intvar: n1,
                            rest: t1.slice(2)
                        };
                    }
                    return e1.push(t1.shift()), c1.getInstance().getIntegralArgs_(t1, e1);
                }
                functionNode_(t1, e1) {
                    const r1 = c1.getInstance().factory_.makeContentNode(o1.functionApplication()), n1 = c1.getInstance().funcAppls[t1.id];
                    n1 && (r1.mathmlTree = n1.mathmlTree, r1.mathml = n1.mathml, r1.annotation = n1.annotation, r1.attributes = n1.attributes, delete c1.getInstance().funcAppls[t1.id]), r1.type = "punctuation", r1.role = "application";
                    const i1 = c1.getFunctionOp_(t1, function(t1) {
                        return a1.isType(t1, "function") || a1.isType(t1, "identifier") && a1.isRole(t1, "simple function");
                    });
                    return c1.getInstance().functionalNode_("appl", [
                        t1,
                        e1
                    ], i1, [
                        r1
                    ]);
                }
                bigOpNode_(t1, e1) {
                    const r1 = c1.getFunctionOp_(t1, (t1)=>a1.isType(t1, "largeop"));
                    return c1.getInstance().functionalNode_("bigop", [
                        t1,
                        e1
                    ], r1, []);
                }
                integralNode_(t1, e1, r1) {
                    e1 = e1 || c1.getInstance().factory_.makeEmptyNode(), r1 = r1 || c1.getInstance().factory_.makeEmptyNode();
                    const n1 = c1.getFunctionOp_(t1, (t1)=>a1.isType(t1, "largeop"));
                    return c1.getInstance().functionalNode_("integral", [
                        t1,
                        e1,
                        r1
                    ], n1, []);
                }
                functionalNode_(t1, e1, r1, n1) {
                    const o1 = e1[0];
                    let i1;
                    r1 && (i1 = r1.parent, n1.push(r1));
                    const s1 = c1.getInstance().factory_.makeBranchNode(t1, e1, n1);
                    return s1.role = o1.role, i1 && (r1.parent = i1), s1;
                }
                fractionNode_(t1, e1) {
                    const r1 = c1.getInstance().factory_.makeBranchNode("fraction", [
                        t1,
                        e1
                    ], []);
                    return r1.role = r1.childNodes.every(function(t1) {
                        return a1.isType(t1, "number") && a1.isRole(t1, "integer");
                    }) ? "vulgar" : r1.childNodes.every(a1.isPureUnit) ? "unit" : "division", i1.run("propagateSimpleFunction", r1);
                }
                scriptNode_(t1, e1, r1) {
                    let n1;
                    switch(t1.length){
                        case 0:
                            n1 = c1.getInstance().factory_.makeEmptyNode();
                            break;
                        case 1:
                            if (n1 = t1[0], r1) return n1;
                            break;
                        default:
                            n1 = c1.getInstance().dummyNode_(t1);
                    }
                    return n1.role = e1, n1;
                }
                findNestedRow_(t1, e1, r1, o1) {
                    if (r1 > 3) return null;
                    for(let i1, s1 = 0; i1 = t1[s1]; s1++){
                        const t1 = n1.tagName(i1);
                        if ("MSPACE" !== t1) {
                            if ("MROW" === t1) return c1.getInstance().findNestedRow_(n1.toArray(i1.childNodes), e1, r1 + 1, o1);
                            if (c1.findSemantics(i1, e1, o1)) return i1;
                        }
                    }
                    return null;
                }
            }
            e1.default = c1, c1.FENCE_TO_PUNCT_ = {
                metric: "metric",
                neutral: "vbar",
                open: "openfence",
                close: "closefence"
            }, c1.MML_TO_LIMIT_ = {
                MSUB: {
                    type: "limlower",
                    length: 1
                },
                MUNDER: {
                    type: "limlower",
                    length: 1
                },
                MSUP: {
                    type: "limupper",
                    length: 1
                },
                MOVER: {
                    type: "limupper",
                    length: 1
                },
                MSUBSUP: {
                    type: "limboth",
                    length: 2
                },
                MUNDEROVER: {
                    type: "limboth",
                    length: 2
                }
            }, c1.MML_TO_BOUNDS_ = {
                MSUB: {
                    type: "subscript",
                    length: 1,
                    accent: !1
                },
                MSUP: {
                    type: "superscript",
                    length: 1,
                    accent: !1
                },
                MSUBSUP: {
                    type: "subscript",
                    length: 2,
                    accent: !1
                },
                MUNDER: {
                    type: "underscore",
                    length: 1,
                    accent: !0
                },
                MOVER: {
                    type: "overscore",
                    length: 1,
                    accent: !0
                },
                MUNDEROVER: {
                    type: "underscore",
                    length: 2,
                    accent: !0
                }
            }, c1.CLASSIFY_FUNCTION_ = {
                integral: "integral",
                sum: "bigop",
                "prefix function": "prefix",
                "limit function": "prefix",
                "simple function": "prefix",
                "composed function": "prefix"
            }, c1.MATHJAX_FONTS = {
                "-tex-caligraphic": "caligraphic",
                "-tex-caligraphic-bold": "caligraphic-bold",
                "-tex-calligraphic": "caligraphic",
                "-tex-calligraphic-bold": "caligraphic-bold",
                "-tex-oldstyle": "oldstyle",
                "-tex-oldstyle-bold": "oldstyle-bold",
                "-tex-mathit": "italic"
            };
        },
        5656: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticSkeleton = void 0;
            const n1 = r1(707), o1 = r1(5274), i1 = r1(2298);
            class s1 {
                constructor(t1){
                    this.parents = null, this.levelsMap = null, t1 = 0 === t1 ? t1 : t1 || [], this.array = t1;
                }
                static fromTree(t1) {
                    return s1.fromNode(t1.root);
                }
                static fromNode(t1) {
                    return new s1(s1.fromNode_(t1));
                }
                static fromString(t1) {
                    return new s1(s1.fromString_(t1));
                }
                static simpleCollapseStructure(t1) {
                    return "number" == typeof t1;
                }
                static contentCollapseStructure(t1) {
                    return !!t1 && !s1.simpleCollapseStructure(t1) && "c" === t1[0];
                }
                static interleaveIds(t1, e1) {
                    return n1.interleaveLists(s1.collapsedLeafs(t1), s1.collapsedLeafs(e1));
                }
                static collapsedLeafs(...t1) {
                    return t1.reduce((t1, e1)=>{
                        var r1;
                        return t1.concat((r1 = e1, s1.simpleCollapseStructure(r1) ? [
                            r1
                        ] : (r1, s1.contentCollapseStructure(r1[1]) ? r1.slice(2) : r1.slice(1))));
                    }, []);
                }
                static fromStructure(t1, e1) {
                    return new s1(s1.tree_(t1, e1.root));
                }
                static combineContentChildren(t1, e1, r1) {
                    switch(t1.type){
                        case "relseq":
                        case "infixop":
                        case "multirel":
                            return n1.interleaveLists(r1, e1);
                        case "prefixop":
                            return e1.concat(r1);
                        case "postfixop":
                            return r1.concat(e1);
                        case "fenced":
                            return r1.unshift(e1[0]), r1.push(e1[1]), r1;
                        case "appl":
                            return [
                                r1[0],
                                e1[0],
                                r1[1]
                            ];
                        case "root":
                            return [
                                r1[1],
                                r1[0]
                            ];
                        case "row":
                        case "line":
                            return e1.length && r1.unshift(e1[0]), r1;
                        default:
                            return r1;
                    }
                }
                static makeSexp_(t1) {
                    return s1.simpleCollapseStructure(t1) ? t1.toString() : s1.contentCollapseStructure(t1) ? "(c " + t1.slice(1).map(s1.makeSexp_).join(" ") + ")" : "(" + t1.map(s1.makeSexp_).join(" ") + ")";
                }
                static fromString_(t1) {
                    let e1 = t1.replace(/\(/g, "[");
                    return e1 = e1.replace(/\)/g, "]"), e1 = e1.replace(/ /g, ","), e1 = e1.replace(/c/g, '"c"'), JSON.parse(e1);
                }
                static fromNode_(t1) {
                    if (!t1) return [];
                    const e1 = t1.contentNodes;
                    let r1;
                    e1.length && (r1 = e1.map(s1.fromNode_), r1.unshift("c"));
                    const n1 = t1.childNodes;
                    if (!n1.length) return e1.length ? [
                        t1.id,
                        r1
                    ] : t1.id;
                    const o1 = n1.map(s1.fromNode_);
                    return e1.length && o1.unshift(r1), o1.unshift(t1.id), o1;
                }
                static tree_(t1, e1) {
                    if (!e1) return [];
                    if (!e1.childNodes.length) return e1.id;
                    const r1 = e1.id, n1 = [
                        r1
                    ], a1 = o1.evalXPath(`.//self::*[@${i1.Attribute.ID}=${r1}]`, t1)[0], l1 = s1.combineContentChildren(e1, e1.contentNodes.map(function(t1) {
                        return t1;
                    }), e1.childNodes.map(function(t1) {
                        return t1;
                    }));
                    a1 && s1.addOwns_(a1, l1);
                    for(let e1, r1 = 0; e1 = l1[r1]; r1++)n1.push(s1.tree_(t1, e1));
                    return n1;
                }
                static addOwns_(t1, e1) {
                    const r1 = t1.getAttribute(i1.Attribute.COLLAPSED), n1 = r1 ? s1.realLeafs_(s1.fromString(r1).array) : e1.map((t1)=>t1.id);
                    t1.setAttribute(i1.Attribute.OWNS, n1.join(" "));
                }
                static realLeafs_(t1) {
                    if (s1.simpleCollapseStructure(t1)) return [
                        t1
                    ];
                    if (s1.contentCollapseStructure(t1)) return [];
                    t1;
                    let e1 = [];
                    for(let r1 = 1; r1 < t1.length; r1++)e1 = e1.concat(s1.realLeafs_(t1[r1]));
                    return e1;
                }
                populate() {
                    this.parents && this.levelsMap || (this.parents = {}, this.levelsMap = {}, this.populate_(this.array, this.array, []));
                }
                toString() {
                    return s1.makeSexp_(this.array);
                }
                populate_(t1, e1, r1) {
                    if (s1.simpleCollapseStructure(t1)) return t1, this.levelsMap[t1] = e1, void (this.parents[t1] = t1 === r1[0] ? r1.slice(1) : r1);
                    const n1 = s1.contentCollapseStructure(t1) ? t1.slice(1) : t1, o1 = [
                        n1[0]
                    ].concat(r1);
                    for(let e1 = 0, r1 = n1.length; e1 < r1; e1++){
                        const r1 = n1[e1];
                        this.populate_(r1, t1, o1);
                    }
                }
                isRoot(t1) {
                    return t1 === this.levelsMap[t1][0];
                }
                directChildren(t1) {
                    if (!this.isRoot(t1)) return [];
                    return this.levelsMap[t1].slice(1).map((t1)=>s1.simpleCollapseStructure(t1) ? t1 : s1.contentCollapseStructure(t1) ? t1[1] : t1[0]);
                }
                subtreeNodes(t1) {
                    if (!this.isRoot(t1)) return [];
                    const e1 = (t1, r1)=>{
                        s1.simpleCollapseStructure(t1) ? r1.push(t1) : (t1, s1.contentCollapseStructure(t1) && (t1 = t1.slice(1)), t1.forEach((t1)=>e1(t1, r1)));
                    }, r1 = this.levelsMap[t1], n1 = [];
                    return e1(r1.slice(1), n1), n1;
                }
            }
            e1.SemanticSkeleton = s1;
        },
        7075: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticTree = void 0;
            const n1 = r1(5740), o1 = r1(7630), i1 = r1(9265), s1 = r1(7228), a1 = r1(5952), l1 = r1(5609);
            r1(94);
            class c1 {
                constructor(t1){
                    this.mathml = t1, this.parser = new s1.SemanticMathml, this.root = this.parser.parse(t1), this.collator = this.parser.getFactory().leafMap.collateMeaning();
                    const e1 = this.collator.newDefault();
                    e1 && (this.parser = new s1.SemanticMathml, this.parser.getFactory().defaultMap = e1, this.root = this.parser.parse(t1)), u1.visit(this.root, {}), (0, o1.annotate)(this.root);
                }
                static empty() {
                    const t1 = n1.parseInput("<math/>"), e1 = new c1(t1);
                    return e1.mathml = t1, e1;
                }
                static fromNode(t1, e1) {
                    const r1 = c1.empty();
                    return r1.root = t1, e1 && (r1.mathml = e1), r1;
                }
                static fromRoot(t1, e1) {
                    let r1 = t1;
                    for(; r1.parent;)r1 = r1.parent;
                    const n1 = c1.fromNode(r1);
                    return e1 && (n1.mathml = e1), n1;
                }
                static fromXml(t1) {
                    const e1 = c1.empty();
                    return t1.childNodes[0] && (e1.root = a1.SemanticNode.fromXml(t1.childNodes[0])), e1;
                }
                xml(t1) {
                    const e1 = n1.parseInput("<stree></stree>"), r1 = this.root.xml(e1.ownerDocument, t1);
                    return e1.appendChild(r1), e1;
                }
                toString(t1) {
                    return n1.serializeXml(this.xml(t1));
                }
                formatXml(t1) {
                    const e1 = this.toString(t1);
                    return n1.formatXml(e1);
                }
                displayTree() {
                    this.root.displayTree();
                }
                replaceNode(t1, e1) {
                    const r1 = t1.parent;
                    r1 ? r1.replaceChild(t1, e1) : this.root = e1;
                }
                toJson() {
                    const t1 = {};
                    return t1.stree = this.root.toJson(), t1;
                }
            }
            e1.SemanticTree = c1;
            const u1 = new i1.SemanticVisitor("general", "unit", (t1, e1)=>{
                if ("infixop" === t1.type && ("multiplication" === t1.role || "implicit" === t1.role)) {
                    const e1 = t1.childNodes;
                    e1.length && (l1.isPureUnit(e1[0]) || l1.isUnitCounter(e1[0])) && t1.childNodes.slice(1).every(l1.isPureUnit) && (t1.role = "unit");
                }
                return !1;
            });
        },
        4795: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.partitionNodes = e1.sliceNodes = e1.getEmbellishedInner = e1.addAttributes = e1.isZeroLength = e1.purgeNodes = e1.isOrphanedGlyph = e1.hasDisplayTag = e1.hasEmptyTag = e1.hasIgnoreTag = e1.hasLeafTag = e1.hasMathTag = e1.directSpeechKeys = e1.DISPLAYTAGS = e1.EMPTYTAGS = e1.IGNORETAGS = e1.LEAFTAGS = void 0;
            const n1 = r1(5740);
            function o1(t1) {
                return !!t1 && -1 !== e1.LEAFTAGS.indexOf(n1.tagName(t1));
            }
            function i1(t1, e1, r1) {
                r1 && t1.reverse();
                const n1 = [];
                for(let o1, i1 = 0; o1 = t1[i1]; i1++){
                    if (e1(o1)) return r1 ? {
                        head: t1.slice(i1 + 1).reverse(),
                        div: o1,
                        tail: n1.reverse()
                    } : {
                        head: n1,
                        div: o1,
                        tail: t1.slice(i1 + 1)
                    };
                    n1.push(o1);
                }
                return r1 ? {
                    head: [],
                    div: null,
                    tail: n1.reverse()
                } : {
                    head: n1,
                    div: null,
                    tail: []
                };
            }
            e1.LEAFTAGS = [
                "MO",
                "MI",
                "MN",
                "MTEXT",
                "MS",
                "MSPACE"
            ], e1.IGNORETAGS = [
                "MERROR",
                "MPHANTOM",
                "MALIGNGROUP",
                "MALIGNMARK",
                "MPRESCRIPTS",
                "ANNOTATION",
                "ANNOTATION-XML"
            ], e1.EMPTYTAGS = [
                "MATH",
                "MROW",
                "MPADDED",
                "MACTION",
                "NONE",
                "MSTYLE",
                "SEMANTICS"
            ], e1.DISPLAYTAGS = [
                "MROOT",
                "MSQRT"
            ], e1.directSpeechKeys = [
                "aria-label",
                "exact-speech",
                "alt"
            ], e1.hasMathTag = function(t1) {
                return !!t1 && "MATH" === n1.tagName(t1);
            }, e1.hasLeafTag = o1, e1.hasIgnoreTag = function(t1) {
                return !!t1 && -1 !== e1.IGNORETAGS.indexOf(n1.tagName(t1));
            }, e1.hasEmptyTag = function(t1) {
                return !!t1 && -1 !== e1.EMPTYTAGS.indexOf(n1.tagName(t1));
            }, e1.hasDisplayTag = function(t1) {
                return !!t1 && -1 !== e1.DISPLAYTAGS.indexOf(n1.tagName(t1));
            }, e1.isOrphanedGlyph = function(t1) {
                return !!t1 && "MGLYPH" === n1.tagName(t1) && !o1(t1.parentNode);
            }, e1.purgeNodes = function(t1) {
                const r1 = [];
                for(let o1, i1 = 0; o1 = t1[i1]; i1++){
                    if (o1.nodeType !== n1.NodeType.ELEMENT_NODE) continue;
                    const t1 = n1.tagName(o1);
                    -1 === e1.IGNORETAGS.indexOf(t1) && (-1 !== e1.EMPTYTAGS.indexOf(t1) && 0 === o1.childNodes.length || r1.push(o1));
                }
                return r1;
            }, e1.isZeroLength = function(t1) {
                if (!t1) return !1;
                if (-1 !== [
                    "negativeveryverythinmathspace",
                    "negativeverythinmathspace",
                    "negativethinmathspace",
                    "negativemediummathspace",
                    "negativethickmathspace",
                    "negativeverythickmathspace",
                    "negativeveryverythickmathspace"
                ].indexOf(t1)) return !0;
                const e1 = t1.match(/[0-9.]+/);
                return !!e1 && 0 === parseFloat(e1[0]);
            }, e1.addAttributes = function(t1, r1) {
                if (r1.hasAttributes()) {
                    const n1 = r1.attributes;
                    for(let r1 = n1.length - 1; r1 >= 0; r1--){
                        const o1 = n1[r1].name;
                        o1.match(/^ext/) && (t1.attributes[o1] = n1[r1].value, t1.nobreaking = !0), -1 !== e1.directSpeechKeys.indexOf(o1) && (t1.attributes["ext-speech"] = n1[r1].value, t1.nobreaking = !0), o1.match(/texclass$/) && (t1.attributes.texclass = n1[r1].value), "href" === o1 && (t1.attributes.href = n1[r1].value, t1.nobreaking = !0);
                    }
                }
            }, e1.getEmbellishedInner = function t1(e1) {
                return e1 && e1.embellished && e1.childNodes.length > 0 ? t1(e1.childNodes[0]) : e1;
            }, e1.sliceNodes = i1, e1.partitionNodes = function(t1, e1) {
                let r1 = t1;
                const n1 = [], o1 = [];
                let s1 = null;
                do s1 = i1(r1, e1), o1.push(s1.head), n1.push(s1.div), r1 = s1.tail;
                while (s1.div);
                return n1.pop(), {
                    rel: n1,
                    comp: o1
                };
            };
        },
        6278: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractSpeechGenerator = void 0;
            const n1 = r1(6828), o1 = r1(2298), i1 = r1(1214), s1 = r1(9543);
            e1.AbstractSpeechGenerator = class {
                constructor(){
                    this.modality = o1.addPrefix("speech"), this.rebuilt_ = null, this.options_ = {};
                }
                getRebuilt() {
                    return this.rebuilt_;
                }
                setRebuilt(t1) {
                    this.rebuilt_ = t1;
                }
                setOptions(t1) {
                    this.options_ = t1 || {}, this.modality = o1.addPrefix(this.options_.modality || "speech");
                }
                getOptions() {
                    return this.options_;
                }
                start() {}
                end() {}
                generateSpeech(t1, e1) {
                    return this.rebuilt_ || (this.rebuilt_ = new i1.RebuildStree(e1)), (0, n1.setup)(this.options_), s1.computeMarkup(this.getRebuilt().xml);
                }
            };
        },
        1452: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AdhocSpeechGenerator = void 0;
            const n1 = r1(6278);
            class o1 extends n1.AbstractSpeechGenerator {
                getSpeech(t1, e1) {
                    const r1 = this.generateSpeech(t1, e1);
                    return t1.setAttribute(this.modality, r1), r1;
                }
            }
            e1.AdhocSpeechGenerator = o1;
        },
        5152: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ColorGenerator = void 0;
            const n1 = r1(2298), o1 = r1(8396), i1 = r1(1214), s1 = r1(1204), a1 = r1(6278);
            class l1 extends a1.AbstractSpeechGenerator {
                constructor(){
                    super(...arguments), this.modality = (0, n1.addPrefix)("foreground"), this.contrast = new o1.ContrastPicker;
                }
                static visitStree_(t1, e1, r1) {
                    if (t1.childNodes.length) {
                        if (t1.contentNodes.length && ("punctuated" === t1.type && t1.contentNodes.forEach((t1)=>r1[t1.id] = !0), "implicit" !== t1.role && e1.push(t1.contentNodes.map((t1)=>t1.id))), t1.childNodes.length) {
                            if ("implicit" === t1.role) {
                                const n1 = [];
                                let o1 = [];
                                for (const e1 of t1.childNodes){
                                    const t1 = [];
                                    l1.visitStree_(e1, t1, r1), t1.length <= 2 && n1.push(t1.shift()), o1 = o1.concat(t1);
                                }
                                return e1.push(n1), void o1.forEach((t1)=>e1.push(t1));
                            }
                            t1.childNodes.forEach((t1)=>l1.visitStree_(t1, e1, r1));
                        }
                    } else r1[t1.id] || e1.push(t1.id);
                }
                getSpeech(t1, e1) {
                    return s1.getAttribute(t1, this.modality);
                }
                generateSpeech(t1, e1) {
                    return this.getRebuilt() || this.setRebuilt(new i1.RebuildStree(t1)), this.colorLeaves_(t1), s1.getAttribute(t1, this.modality);
                }
                colorLeaves_(t1) {
                    const e1 = [];
                    l1.visitStree_(this.getRebuilt().streeRoot, e1, {});
                    for (const r1 of e1){
                        const e1 = this.contrast.generate();
                        let n1 = !1;
                        n1 = Array.isArray(r1) ? r1.map((r1)=>this.colorLeave_(t1, r1, e1)).reduce((t1, e1)=>t1 || e1, !1) : this.colorLeave_(t1, r1.toString(), e1), n1 && this.contrast.increment();
                    }
                }
                colorLeave_(t1, e1, r1) {
                    const n1 = s1.getBySemanticId(t1, e1);
                    return !!n1 && (n1.setAttribute(this.modality, r1), !0);
                }
            }
            e1.ColorGenerator = l1;
        },
        6604: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.DirectSpeechGenerator = void 0;
            const n1 = r1(1204), o1 = r1(6278);
            class i1 extends o1.AbstractSpeechGenerator {
                getSpeech(t1, e1) {
                    return n1.getAttribute(t1, this.modality);
                }
            }
            e1.DirectSpeechGenerator = i1;
        },
        3123: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.DummySpeechGenerator = void 0;
            const n1 = r1(6278);
            class o1 extends n1.AbstractSpeechGenerator {
                getSpeech(t1, e1) {
                    return "";
                }
            }
            e1.DummySpeechGenerator = o1;
        },
        5858: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.NodeSpeechGenerator = void 0;
            const n1 = r1(1204), o1 = r1(4598);
            class i1 extends o1.TreeSpeechGenerator {
                getSpeech(t1, e1) {
                    return super.getSpeech(t1, e1), n1.getAttribute(t1, this.modality);
                }
            }
            e1.NodeSpeechGenerator = i1;
        },
        9552: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.generatorMapping_ = e1.generator = void 0;
            const n1 = r1(1452), o1 = r1(5152), i1 = r1(6604), s1 = r1(3123), a1 = r1(5858), l1 = r1(597), c1 = r1(4598);
            e1.generator = function(t1) {
                return (e1.generatorMapping_[t1] || e1.generatorMapping_.Direct)();
            }, e1.generatorMapping_ = {
                Adhoc: ()=>new n1.AdhocSpeechGenerator,
                Color: ()=>new o1.ColorGenerator,
                Direct: ()=>new i1.DirectSpeechGenerator,
                Dummy: ()=>new s1.DummySpeechGenerator,
                Node: ()=>new a1.NodeSpeechGenerator,
                Summary: ()=>new l1.SummarySpeechGenerator,
                Tree: ()=>new c1.TreeSpeechGenerator
            };
        },
        9543: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.computeSummary_ = e1.retrieveSummary = e1.connectAllMactions = e1.connectMactions = e1.nodeAtPosition_ = e1.computePrefix_ = e1.retrievePrefix = e1.addPrefix = e1.addModality = e1.addSpeech = e1.recomputeMarkup = e1.computeMarkup = e1.recomputeSpeech = e1.computeSpeech = void 0;
            const n1 = r1(8290), o1 = r1(5740), i1 = r1(5274), s1 = r1(2298), a1 = r1(2362), l1 = r1(7075), c1 = r1(1204);
            function u1(t1) {
                return a1.SpeechRuleEngine.getInstance().evaluateNode(t1);
            }
            function p1(t1) {
                return u1(l1.SemanticTree.fromNode(t1).xml());
            }
            function h1(t1) {
                const e1 = p1(t1);
                return n1.markup(e1);
            }
            function f1(t1) {
                const e1 = d1(t1);
                return n1.markup(e1);
            }
            function d1(t1) {
                const e1 = l1.SemanticTree.fromRoot(t1), r1 = i1.evalXPath('.//*[@id="' + t1.id + '"]', e1.xml());
                let n1 = r1[0];
                return r1.length > 1 && (n1 = m1(t1, r1) || n1), n1 ? a1.SpeechRuleEngine.getInstance().runInSetting({
                    modality: "prefix",
                    domain: "default",
                    style: "default",
                    strict: !0,
                    speech: !0
                }, function() {
                    return a1.SpeechRuleEngine.getInstance().evaluateNode(n1);
                }) : [];
            }
            function m1(t1, e1) {
                const r1 = e1[0];
                if (!t1.parent) return r1;
                const n1 = [];
                for(; t1;)n1.push(t1.id), t1 = t1.parent;
                const o1 = function(t1, e1) {
                    for(; e1.length && e1.shift().toString() === t1.getAttribute("id") && t1.parentNode && t1.parentNode.parentNode;)t1 = t1.parentNode.parentNode;
                    return !e1.length;
                };
                for(let t1, r1 = 0; t1 = e1[r1]; r1++)if (o1(t1, n1.slice())) return t1;
                return r1;
            }
            function y1(t1) {
                return t1 ? a1.SpeechRuleEngine.getInstance().runInSetting({
                    modality: "summary",
                    strict: !1,
                    speech: !0
                }, function() {
                    return a1.SpeechRuleEngine.getInstance().evaluateNode(t1);
                }) : [];
            }
            e1.computeSpeech = u1, e1.recomputeSpeech = p1, e1.computeMarkup = function(t1) {
                const e1 = u1(t1);
                return n1.markup(e1);
            }, e1.recomputeMarkup = h1, e1.addSpeech = function(t1, e1, r1) {
                const i1 = o1.querySelectorAllByAttrValue(r1, "id", e1.id.toString())[0], a1 = i1 ? n1.markup(u1(i1)) : h1(e1);
                t1.setAttribute(s1.Attribute.SPEECH, a1);
            }, e1.addModality = function(t1, e1, r1) {
                const n1 = h1(e1);
                t1.setAttribute(r1, n1);
            }, e1.addPrefix = function(t1, e1) {
                const r1 = f1(e1);
                r1 && t1.setAttribute(s1.Attribute.PREFIX, r1);
            }, e1.retrievePrefix = f1, e1.computePrefix_ = d1, e1.nodeAtPosition_ = m1, e1.connectMactions = function(t1, e1, r1) {
                const n1 = o1.querySelectorAll(e1, "maction");
                for(let e1, i1 = 0; e1 = n1[i1]; i1++){
                    const n1 = e1.getAttribute("id"), i1 = o1.querySelectorAllByAttrValue(t1, "id", n1)[0];
                    if (!i1) continue;
                    const a1 = e1.childNodes[1], l1 = a1.getAttribute(s1.Attribute.ID);
                    let u1 = c1.getBySemanticId(t1, l1);
                    if (u1 && "dummy" !== u1.getAttribute(s1.Attribute.TYPE)) continue;
                    if (u1 = i1.childNodes[0], u1.getAttribute("sre-highlighter-added")) continue;
                    const p1 = a1.getAttribute(s1.Attribute.PARENT);
                    p1 && u1.setAttribute(s1.Attribute.PARENT, p1), u1.setAttribute(s1.Attribute.TYPE, "dummy"), u1.setAttribute(s1.Attribute.ID, l1);
                    o1.querySelectorAllByAttrValue(r1, "id", l1)[0].setAttribute("alternative", l1);
                }
            }, e1.connectAllMactions = function(t1, e1) {
                const r1 = o1.querySelectorAll(t1, "maction");
                for(let t1, n1 = 0; t1 = r1[n1]; n1++){
                    const r1 = t1.childNodes[1].getAttribute(s1.Attribute.ID);
                    o1.querySelectorAllByAttrValue(e1, "id", r1)[0].setAttribute("alternative", r1);
                }
            }, e1.retrieveSummary = function(t1) {
                const e1 = y1(t1);
                return n1.markup(e1);
            }, e1.computeSummary_ = y1;
        },
        597: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SummarySpeechGenerator = void 0;
            const n1 = r1(6278), o1 = r1(9543);
            class i1 extends n1.AbstractSpeechGenerator {
                getSpeech(t1, e1) {
                    return o1.connectAllMactions(e1, this.getRebuilt().xml), this.generateSpeech(t1, e1);
                }
            }
            e1.SummarySpeechGenerator = i1;
        },
        4598: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TreeSpeechGenerator = void 0;
            const n1 = r1(2298), o1 = r1(1204), i1 = r1(6278), s1 = r1(9543);
            class a1 extends i1.AbstractSpeechGenerator {
                getSpeech(t1, e1) {
                    const r1 = this.generateSpeech(t1, e1), i1 = this.getRebuilt().nodeDict;
                    for(const r1 in i1){
                        const a1 = i1[r1], l1 = o1.getBySemanticId(e1, r1), c1 = o1.getBySemanticId(t1, r1);
                        l1 && c1 && (this.modality && this.modality !== n1.Attribute.SPEECH ? s1.addModality(c1, a1, this.modality) : s1.addSpeech(c1, a1, this.getRebuilt().xml), this.modality === n1.Attribute.SPEECH && s1.addPrefix(c1, a1));
                    }
                    return r1;
                }
            }
            e1.TreeSpeechGenerator = a1;
        },
        313: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.INTERVALS = e1.makeLetter = e1.numberRules = e1.alphabetRules = e1.getFont = e1.makeInterval = e1.generate = e1.makeDomains_ = e1.Domains_ = e1.Base = e1.Embellish = e1.Font = void 0;
            const n1 = r1(5897), o1 = r1(7491), i1 = r1(4356), s1 = r1(2536), a1 = r1(2780);
            var l1, c1, u1;
            function p1() {
                const t1 = i1.LOCALE.ALPHABETS, r1 = (t1, e1)=>{
                    const r1 = {};
                    return Object.keys(t1).forEach((t1)=>r1[t1] = !0), Object.keys(e1).forEach((t1)=>r1[t1] = !0), Object.keys(r1);
                };
                e1.Domains_.small = r1(t1.smallPrefix, t1.letterTrans), e1.Domains_.capital = r1(t1.capPrefix, t1.letterTrans), e1.Domains_.digit = r1(t1.digitPrefix, t1.digitTrans);
            }
            function h1(t1) {
                const e1 = t1.toString(16).toUpperCase();
                return e1.length > 3 ? e1 : ("000" + e1).slice(-4);
            }
            function f1([t1, e1], r1) {
                const n1 = parseInt(t1, 16), o1 = parseInt(e1, 16), i1 = [];
                for(let t1 = n1; t1 <= o1; t1++){
                    let e1 = h1(t1);
                    !1 !== r1[e1] && (e1 = r1[e1] || e1, i1.push(e1));
                }
                return i1;
            }
            function d1(t1) {
                const e1 = "normal" === t1 || "fullwidth" === t1 ? "" : i1.LOCALE.MESSAGES.font[t1] || i1.LOCALE.MESSAGES.embellish[t1] || "";
                return (0, s1.localeFontCombiner)(e1);
            }
            function m1(t1, r1, n1, o1, s1, a1) {
                const l1 = d1(o1);
                for(let o1, c1, u1, p1 = 0; o1 = t1[p1], c1 = r1[p1], u1 = n1[p1]; p1++){
                    const t1 = a1 ? i1.LOCALE.ALPHABETS.capPrefix : i1.LOCALE.ALPHABETS.smallPrefix, r1 = a1 ? e1.Domains_.capital : e1.Domains_.small;
                    g1(l1.combiner, o1, c1, u1, l1.font, t1, s1, i1.LOCALE.ALPHABETS.letterTrans, r1);
                }
            }
            function y1(t1, r1, n1, o1, s1) {
                const a1 = d1(n1);
                for(let n1, l1, c1 = 0; n1 = t1[c1], l1 = r1[c1]; c1++){
                    const t1 = i1.LOCALE.ALPHABETS.digitPrefix, r1 = c1 + s1;
                    g1(a1.combiner, n1, l1, r1, a1.font, t1, o1, i1.LOCALE.ALPHABETS.digitTrans, e1.Domains_.digit);
                }
            }
            function g1(t1, e1, r1, n1, o1, i1, s1, l1, c1) {
                for(let u1, p1 = 0; u1 = c1[p1]; p1++){
                    const c1 = u1 in l1 ? l1[u1] : l1.default, p1 = u1 in i1 ? i1[u1] : i1.default;
                    a1.defineRule(e1.toString(), u1, "default", s1, r1, t1(c1(n1), o1, p1));
                }
            }
            !function(t1) {
                t1.BOLD = "bold", t1.BOLDFRAKTUR = "bold-fraktur", t1.BOLDITALIC = "bold-italic", t1.BOLDSCRIPT = "bold-script", t1.DOUBLESTRUCK = "double-struck", t1.FULLWIDTH = "fullwidth", t1.FRAKTUR = "fraktur", t1.ITALIC = "italic", t1.MONOSPACE = "monospace", t1.NORMAL = "normal", t1.SCRIPT = "script", t1.SANSSERIF = "sans-serif", t1.SANSSERIFITALIC = "sans-serif-italic", t1.SANSSERIFBOLD = "sans-serif-bold", t1.SANSSERIFBOLDITALIC = "sans-serif-bold-italic";
            }(l1 = e1.Font || (e1.Font = {})), function(t1) {
                t1.SUPER = "super", t1.SUB = "sub", t1.CIRCLED = "circled", t1.PARENTHESIZED = "parenthesized", t1.PERIOD = "period", t1.NEGATIVECIRCLED = "negative-circled", t1.DOUBLECIRCLED = "double-circled", t1.CIRCLEDSANSSERIF = "circled-sans-serif", t1.NEGATIVECIRCLEDSANSSERIF = "negative-circled-sans-serif", t1.COMMA = "comma", t1.SQUARED = "squared", t1.NEGATIVESQUARED = "negative-squared";
            }(c1 = e1.Embellish || (e1.Embellish = {})), function(t1) {
                t1.LATINCAP = "latinCap", t1.LATINSMALL = "latinSmall", t1.GREEKCAP = "greekCap", t1.GREEKSMALL = "greekSmall", t1.DIGIT = "digit";
            }(u1 = e1.Base || (e1.Base = {})), e1.Domains_ = {
                small: [
                    "default"
                ],
                capital: [
                    "default"
                ],
                digit: [
                    "default"
                ]
            }, e1.makeDomains_ = p1, e1.generate = function(t1) {
                const r1 = n1.default.getInstance().locale;
                n1.default.getInstance().locale = t1, o1.setLocale(), a1.addSymbolRules({
                    locale: t1
                }), p1();
                const s1 = e1.INTERVALS;
                for(let t1, e1 = 0; t1 = s1[e1]; e1++){
                    const e1 = f1(t1.interval, t1.subst), r1 = e1.map(function(t1) {
                        return String.fromCodePoint(parseInt(t1, 16));
                    });
                    if ("offset" in t1) y1(e1, r1, t1.font, t1.category, t1.offset || 0);
                    else m1(e1, r1, i1.LOCALE.ALPHABETS[t1.base], t1.font, t1.category, !!t1.capital);
                }
                n1.default.getInstance().locale = r1, o1.setLocale();
            }, e1.makeInterval = f1, e1.getFont = d1, e1.alphabetRules = m1, e1.numberRules = y1, e1.makeLetter = g1, e1.INTERVALS = [
                {
                    interval: [
                        "1D400",
                        "1D419"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.BOLD
                },
                {
                    interval: [
                        "1D41A",
                        "1D433"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.BOLD
                },
                {
                    interval: [
                        "1D56C",
                        "1D585"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.BOLDFRAKTUR
                },
                {
                    interval: [
                        "1D586",
                        "1D59F"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.BOLDFRAKTUR
                },
                {
                    interval: [
                        "1D468",
                        "1D481"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.BOLDITALIC
                },
                {
                    interval: [
                        "1D482",
                        "1D49B"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.BOLDITALIC
                },
                {
                    interval: [
                        "1D4D0",
                        "1D4E9"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.BOLDSCRIPT
                },
                {
                    interval: [
                        "1D4EA",
                        "1D503"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.BOLDSCRIPT
                },
                {
                    interval: [
                        "1D538",
                        "1D551"
                    ],
                    base: u1.LATINCAP,
                    subst: {
                        "1D53A": "2102",
                        "1D53F": "210D",
                        "1D545": "2115",
                        "1D547": "2119",
                        "1D548": "211A",
                        "1D549": "211D",
                        "1D551": "2124"
                    },
                    capital: !0,
                    category: "Lu",
                    font: l1.DOUBLESTRUCK
                },
                {
                    interval: [
                        "1D552",
                        "1D56B"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.DOUBLESTRUCK
                },
                {
                    interval: [
                        "1D504",
                        "1D51D"
                    ],
                    base: u1.LATINCAP,
                    subst: {
                        "1D506": "212D",
                        "1D50B": "210C",
                        "1D50C": "2111",
                        "1D515": "211C",
                        "1D51D": "2128"
                    },
                    capital: !0,
                    category: "Lu",
                    font: l1.FRAKTUR
                },
                {
                    interval: [
                        "1D51E",
                        "1D537"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.FRAKTUR
                },
                {
                    interval: [
                        "FF21",
                        "FF3A"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.FULLWIDTH
                },
                {
                    interval: [
                        "FF41",
                        "FF5A"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.FULLWIDTH
                },
                {
                    interval: [
                        "1D434",
                        "1D44D"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.ITALIC
                },
                {
                    interval: [
                        "1D44E",
                        "1D467"
                    ],
                    base: u1.LATINSMALL,
                    subst: {
                        "1D455": "210E"
                    },
                    capital: !1,
                    category: "Ll",
                    font: l1.ITALIC
                },
                {
                    interval: [
                        "1D670",
                        "1D689"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.MONOSPACE
                },
                {
                    interval: [
                        "1D68A",
                        "1D6A3"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.MONOSPACE
                },
                {
                    interval: [
                        "0041",
                        "005A"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.NORMAL
                },
                {
                    interval: [
                        "0061",
                        "007A"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.NORMAL
                },
                {
                    interval: [
                        "1D49C",
                        "1D4B5"
                    ],
                    base: u1.LATINCAP,
                    subst: {
                        "1D49D": "212C",
                        "1D4A0": "2130",
                        "1D4A1": "2131",
                        "1D4A3": "210B",
                        "1D4A4": "2110",
                        "1D4A7": "2112",
                        "1D4A8": "2133",
                        "1D4AD": "211B"
                    },
                    capital: !0,
                    category: "Lu",
                    font: l1.SCRIPT
                },
                {
                    interval: [
                        "1D4B6",
                        "1D4CF"
                    ],
                    base: u1.LATINSMALL,
                    subst: {
                        "1D4BA": "212F",
                        "1D4BC": "210A",
                        "1D4C4": "2134"
                    },
                    capital: !1,
                    category: "Ll",
                    font: l1.SCRIPT
                },
                {
                    interval: [
                        "1D5A0",
                        "1D5B9"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.SANSSERIF
                },
                {
                    interval: [
                        "1D5BA",
                        "1D5D3"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.SANSSERIF
                },
                {
                    interval: [
                        "1D608",
                        "1D621"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.SANSSERIFITALIC
                },
                {
                    interval: [
                        "1D622",
                        "1D63B"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.SANSSERIFITALIC
                },
                {
                    interval: [
                        "1D5D4",
                        "1D5ED"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.SANSSERIFBOLD
                },
                {
                    interval: [
                        "1D5EE",
                        "1D607"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.SANSSERIFBOLD
                },
                {
                    interval: [
                        "1D63C",
                        "1D655"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.SANSSERIFBOLDITALIC
                },
                {
                    interval: [
                        "1D656",
                        "1D66F"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.SANSSERIFBOLDITALIC
                },
                {
                    interval: [
                        "0391",
                        "03A9"
                    ],
                    base: u1.GREEKCAP,
                    subst: {
                        "03A2": "03F4"
                    },
                    capital: !0,
                    category: "Lu",
                    font: l1.NORMAL
                },
                {
                    interval: [
                        "03B0",
                        "03D0"
                    ],
                    base: u1.GREEKSMALL,
                    subst: {
                        "03B0": "2207",
                        "03CA": "2202",
                        "03CB": "03F5",
                        "03CC": "03D1",
                        "03CD": "03F0",
                        "03CE": "03D5",
                        "03CF": "03F1",
                        "03D0": "03D6"
                    },
                    capital: !1,
                    category: "Ll",
                    font: l1.NORMAL
                },
                {
                    interval: [
                        "1D6A8",
                        "1D6C0"
                    ],
                    base: u1.GREEKCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.BOLD
                },
                {
                    interval: [
                        "1D6C1",
                        "1D6E1"
                    ],
                    base: u1.GREEKSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.BOLD
                },
                {
                    interval: [
                        "1D6E2",
                        "1D6FA"
                    ],
                    base: u1.GREEKCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.ITALIC
                },
                {
                    interval: [
                        "1D6FB",
                        "1D71B"
                    ],
                    base: u1.GREEKSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.ITALIC
                },
                {
                    interval: [
                        "1D71C",
                        "1D734"
                    ],
                    base: u1.GREEKCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.BOLDITALIC
                },
                {
                    interval: [
                        "1D735",
                        "1D755"
                    ],
                    base: u1.GREEKSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.BOLDITALIC
                },
                {
                    interval: [
                        "1D756",
                        "1D76E"
                    ],
                    base: u1.GREEKCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.SANSSERIFBOLD
                },
                {
                    interval: [
                        "1D76F",
                        "1D78F"
                    ],
                    base: u1.GREEKSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.SANSSERIFBOLD
                },
                {
                    interval: [
                        "1D790",
                        "1D7A8"
                    ],
                    base: u1.GREEKCAP,
                    subst: {},
                    capital: !0,
                    category: "Lu",
                    font: l1.SANSSERIFBOLDITALIC
                },
                {
                    interval: [
                        "1D7A9",
                        "1D7C9"
                    ],
                    base: u1.GREEKSMALL,
                    subst: {},
                    capital: !1,
                    category: "Ll",
                    font: l1.SANSSERIFBOLDITALIC
                },
                {
                    interval: [
                        "0030",
                        "0039"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "Nd",
                    font: l1.NORMAL
                },
                {
                    interval: [
                        "2070",
                        "2079"
                    ],
                    base: u1.DIGIT,
                    subst: {
                        2071: "00B9",
                        2072: "00B2",
                        2073: "00B3"
                    },
                    offset: 0,
                    category: "No",
                    font: c1.SUPER
                },
                {
                    interval: [
                        "2080",
                        "2089"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "No",
                    font: c1.SUB
                },
                {
                    interval: [
                        "245F",
                        "2473"
                    ],
                    base: u1.DIGIT,
                    subst: {
                        "245F": "24EA"
                    },
                    offset: 0,
                    category: "No",
                    font: c1.CIRCLED
                },
                {
                    interval: [
                        "3251",
                        "325F"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 21,
                    category: "No",
                    font: c1.CIRCLED
                },
                {
                    interval: [
                        "32B1",
                        "32BF"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 36,
                    category: "No",
                    font: c1.CIRCLED
                },
                {
                    interval: [
                        "2474",
                        "2487"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 1,
                    category: "No",
                    font: c1.PARENTHESIZED
                },
                {
                    interval: [
                        "2487",
                        "249B"
                    ],
                    base: u1.DIGIT,
                    subst: {
                        2487: "1F100"
                    },
                    offset: 0,
                    category: "No",
                    font: c1.PERIOD
                },
                {
                    interval: [
                        "2775",
                        "277F"
                    ],
                    base: u1.DIGIT,
                    subst: {
                        2775: "24FF"
                    },
                    offset: 0,
                    category: "No",
                    font: c1.NEGATIVECIRCLED
                },
                {
                    interval: [
                        "24EB",
                        "24F4"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 11,
                    category: "No",
                    font: c1.NEGATIVECIRCLED
                },
                {
                    interval: [
                        "24F5",
                        "24FE"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 1,
                    category: "No",
                    font: c1.DOUBLECIRCLED
                },
                {
                    interval: [
                        "277F",
                        "2789"
                    ],
                    base: u1.DIGIT,
                    subst: {
                        "277F": "1F10B"
                    },
                    offset: 0,
                    category: "No",
                    font: c1.CIRCLEDSANSSERIF
                },
                {
                    interval: [
                        "2789",
                        "2793"
                    ],
                    base: u1.DIGIT,
                    subst: {
                        2789: "1F10C"
                    },
                    offset: 0,
                    category: "No",
                    font: c1.NEGATIVECIRCLEDSANSSERIF
                },
                {
                    interval: [
                        "FF10",
                        "FF19"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "Nd",
                    font: l1.FULLWIDTH
                },
                {
                    interval: [
                        "1D7CE",
                        "1D7D7"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "Nd",
                    font: l1.BOLD
                },
                {
                    interval: [
                        "1D7D8",
                        "1D7E1"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "Nd",
                    font: l1.DOUBLESTRUCK
                },
                {
                    interval: [
                        "1D7E2",
                        "1D7EB"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "Nd",
                    font: l1.SANSSERIF
                },
                {
                    interval: [
                        "1D7EC",
                        "1D7F5"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "Nd",
                    font: l1.SANSSERIFBOLD
                },
                {
                    interval: [
                        "1D7F6",
                        "1D7FF"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "Nd",
                    font: l1.MONOSPACE
                },
                {
                    interval: [
                        "1F101",
                        "1F10A"
                    ],
                    base: u1.DIGIT,
                    subst: {},
                    offset: 0,
                    category: "No",
                    font: c1.COMMA
                },
                {
                    interval: [
                        "24B6",
                        "24CF"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "So",
                    font: c1.CIRCLED
                },
                {
                    interval: [
                        "24D0",
                        "24E9"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "So",
                    font: c1.CIRCLED
                },
                {
                    interval: [
                        "1F110",
                        "1F129"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "So",
                    font: c1.PARENTHESIZED
                },
                {
                    interval: [
                        "249C",
                        "24B5"
                    ],
                    base: u1.LATINSMALL,
                    subst: {},
                    capital: !1,
                    category: "So",
                    font: c1.PARENTHESIZED
                },
                {
                    interval: [
                        "1F130",
                        "1F149"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "So",
                    font: c1.SQUARED
                },
                {
                    interval: [
                        "1F170",
                        "1F189"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "So",
                    font: c1.NEGATIVESQUARED
                },
                {
                    interval: [
                        "1F150",
                        "1F169"
                    ],
                    base: u1.LATINCAP,
                    subst: {},
                    capital: !0,
                    category: "So",
                    font: c1.NEGATIVECIRCLED
                }
            ];
        },
        8504: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Parser = e1.Comparator = e1.ClearspeakPreferences = void 0;
            const n1 = r1(5897), o1 = r1(4440), i1 = r1(1676), s1 = r1(1676), a1 = r1(2780), l1 = r1(2362);
            class c1 extends i1.DynamicCstr {
                constructor(t1, e1){
                    super(t1), this.preference = e1;
                }
                static comparator() {
                    return new p1(n1.default.getInstance().dynamicCstr, s1.DynamicProperties.createProp([
                        i1.DynamicCstr.DEFAULT_VALUES[s1.Axis.LOCALE]
                    ], [
                        i1.DynamicCstr.DEFAULT_VALUES[s1.Axis.MODALITY]
                    ], [
                        i1.DynamicCstr.DEFAULT_VALUES[s1.Axis.DOMAIN]
                    ], [
                        i1.DynamicCstr.DEFAULT_VALUES[s1.Axis.STYLE]
                    ]));
                }
                static fromPreference(t1) {
                    const e1 = t1.split(":"), r1 = {}, n1 = u1.getProperties(), o1 = Object.keys(n1);
                    for(let t1, i1 = 0; t1 = e1[i1]; i1++){
                        const e1 = t1.split("_");
                        if (-1 === o1.indexOf(e1[0])) continue;
                        const i1 = e1[1];
                        i1 && i1 !== c1.AUTO && -1 !== n1[e1[0]].indexOf(i1) && (r1[e1[0]] = e1[1]);
                    }
                    return r1;
                }
                static toPreference(t1) {
                    const e1 = Object.keys(t1), r1 = [];
                    for(let n1 = 0; n1 < e1.length; n1++)r1.push(e1[n1] + "_" + t1[e1[n1]]);
                    return r1.length ? r1.join(":") : i1.DynamicCstr.DEFAULT_VALUE;
                }
                static getLocalePreferences(t1) {
                    const e1 = t1 || a1.enumerate(l1.SpeechRuleEngine.getInstance().enumerate());
                    return c1.getLocalePreferences_(e1);
                }
                static smartPreferences(t1, e1) {
                    const r1 = c1.getLocalePreferences()[e1];
                    if (!r1) return [];
                    const n1 = t1.explorers.speech, i1 = c1.relevantPreferences(n1.walker.getFocus().getSemanticPrimary()), s1 = o1.DOMAIN_TO_STYLES.clearspeak;
                    return [
                        {
                            type: "radio",
                            content: "No Preferences",
                            id: "clearspeak-default",
                            variable: "speechRules"
                        },
                        {
                            type: "radio",
                            content: "Current Preferences",
                            id: "clearspeak-" + s1,
                            variable: "speechRules"
                        },
                        {
                            type: "rule"
                        },
                        {
                            type: "label",
                            content: "Preferences for " + i1
                        },
                        {
                            type: "rule"
                        }
                    ].concat(r1[i1].map(function(t1) {
                        const e1 = t1.split("_");
                        return {
                            type: "radio",
                            content: e1[1],
                            id: "clearspeak-" + c1.addPreference(s1, e1[0], e1[1]),
                            variable: "speechRules"
                        };
                    }));
                }
                static relevantPreferences(t1) {
                    const e1 = d1[t1.type];
                    return e1 && (e1[t1.role] || e1[""]) || "ImpliedTimes";
                }
                static findPreference(t1, e1) {
                    if ("default" === t1) return c1.AUTO;
                    return c1.fromPreference(t1)[e1] || c1.AUTO;
                }
                static addPreference(t1, e1, r1) {
                    if ("default" === t1) return e1 + "_" + r1;
                    const n1 = c1.fromPreference(t1);
                    return n1[e1] = r1, c1.toPreference(n1);
                }
                static getLocalePreferences_(t1) {
                    const e1 = {};
                    for(const r1 in t1){
                        if (!t1[r1].speech || !t1[r1].speech.clearspeak) continue;
                        const n1 = Object.keys(t1[r1].speech.clearspeak), o1 = e1[r1] = {};
                        for(const t1 in u1.getProperties()){
                            const e1 = u1.getProperties()[t1], r1 = [
                                t1 + "_Auto"
                            ];
                            if (e1) for (const o1 of e1)-1 !== n1.indexOf(t1 + "_" + o1) && r1.push(t1 + "_" + o1);
                            o1[t1] = r1;
                        }
                    }
                    return e1;
                }
                equal(t1) {
                    if (!super.equal(t1)) return !1;
                    const e1 = Object.keys(this.preference), r1 = t1.preference;
                    if (e1.length !== Object.keys(r1).length) return !1;
                    for(let t1, n1 = 0; t1 = e1[n1]; n1++)if (this.preference[t1] !== r1[t1]) return !1;
                    return !0;
                }
            }
            e1.ClearspeakPreferences = c1, c1.AUTO = "Auto";
            const u1 = new s1.DynamicProperties({
                AbsoluteValue: [
                    "Auto",
                    "AbsEnd",
                    "Cardinality",
                    "Determinant"
                ],
                Bar: [
                    "Auto",
                    "Conjugate"
                ],
                Caps: [
                    "Auto",
                    "SayCaps"
                ],
                CombinationPermutation: [
                    "Auto",
                    "ChoosePermute"
                ],
                Currency: [
                    "Auto",
                    "Position",
                    "Prefix"
                ],
                Ellipses: [
                    "Auto",
                    "AndSoOn"
                ],
                Enclosed: [
                    "Auto",
                    "EndEnclose"
                ],
                Exponent: [
                    "Auto",
                    "AfterPower",
                    "Ordinal",
                    "OrdinalPower",
                    "Exponent"
                ],
                Fraction: [
                    "Auto",
                    "EndFrac",
                    "FracOver",
                    "General",
                    "GeneralEndFrac",
                    "Ordinal",
                    "Over",
                    "OverEndFrac",
                    "Per"
                ],
                Functions: [
                    "Auto",
                    "None",
                    "Reciprocal"
                ],
                ImpliedTimes: [
                    "Auto",
                    "MoreImpliedTimes",
                    "None"
                ],
                Log: [
                    "Auto",
                    "LnAsNaturalLog"
                ],
                Matrix: [
                    "Auto",
                    "Combinatoric",
                    "EndMatrix",
                    "EndVector",
                    "SilentColNum",
                    "SpeakColNum",
                    "Vector"
                ],
                MultiLineLabel: [
                    "Auto",
                    "Case",
                    "Constraint",
                    "Equation",
                    "Line",
                    "None",
                    "Row",
                    "Step"
                ],
                MultiLineOverview: [
                    "Auto",
                    "None"
                ],
                MultiLinePausesBetweenColumns: [
                    "Auto",
                    "Long",
                    "Short"
                ],
                MultsymbolDot: [
                    "Auto",
                    "Dot"
                ],
                MultsymbolX: [
                    "Auto",
                    "By",
                    "Cross"
                ],
                Paren: [
                    "Auto",
                    "CoordPoint",
                    "Interval",
                    "Silent",
                    "Speak",
                    "SpeakNestingLevel"
                ],
                Prime: [
                    "Auto",
                    "Angle",
                    "Length"
                ],
                Roots: [
                    "Auto",
                    "PosNegSqRoot",
                    "PosNegSqRootEnd",
                    "RootEnd"
                ],
                SetMemberSymbol: [
                    "Auto",
                    "Belongs",
                    "Element",
                    "Member",
                    "In"
                ],
                Sets: [
                    "Auto",
                    "SilentBracket",
                    "woAll"
                ],
                TriangleSymbol: [
                    "Auto",
                    "Delta"
                ],
                Trig: [
                    "Auto",
                    "ArcTrig",
                    "TrigInverse",
                    "Reciprocal"
                ],
                VerticalLine: [
                    "Auto",
                    "Divides",
                    "Given",
                    "SuchThat"
                ]
            });
            class p1 extends s1.DefaultComparator {
                constructor(t1, e1){
                    super(t1, e1), this.preference = t1 instanceof c1 ? t1.preference : {};
                }
                match(t1) {
                    if (!(t1 instanceof c1)) return super.match(t1);
                    if ("default" === t1.getComponents()[s1.Axis.STYLE]) return !0;
                    const e1 = Object.keys(t1.preference);
                    for(let r1, n1 = 0; r1 = e1[n1]; n1++)if (this.preference[r1] !== t1.preference[r1]) return !1;
                    return !0;
                }
                compare(t1, e1) {
                    const r1 = super.compare(t1, e1);
                    if (0 !== r1) return r1;
                    const n1 = t1 instanceof c1, o1 = e1 instanceof c1;
                    if (!n1 && o1) return 1;
                    if (n1 && !o1) return -1;
                    if (!n1 && !o1) return 0;
                    const i1 = Object.keys(t1.preference).length, s1 = Object.keys(e1.preference).length;
                    return i1 > s1 ? -1 : i1 < s1 ? 1 : 0;
                }
            }
            e1.Comparator = p1;
            class h1 extends s1.DynamicCstrParser {
                constructor(){
                    super([
                        s1.Axis.LOCALE,
                        s1.Axis.MODALITY,
                        s1.Axis.DOMAIN,
                        s1.Axis.STYLE
                    ]);
                }
                parse(t1) {
                    const e1 = super.parse(t1);
                    let r1 = e1.getValue(s1.Axis.STYLE);
                    const n1 = e1.getValue(s1.Axis.LOCALE), o1 = e1.getValue(s1.Axis.MODALITY);
                    let a1 = {};
                    return r1 !== i1.DynamicCstr.DEFAULT_VALUE && (a1 = this.fromPreference(r1), r1 = this.toPreference(a1)), new c1({
                        locale: n1,
                        modality: o1,
                        domain: "clearspeak",
                        style: r1
                    }, a1);
                }
                fromPreference(t1) {
                    return c1.fromPreference(t1);
                }
                toPreference(t1) {
                    return c1.toPreference(t1);
                }
            }
            e1.Parser = h1;
            const f1 = [
                [
                    "AbsoluteValue",
                    "fenced",
                    "neutral",
                    "metric"
                ],
                [
                    "Bar",
                    "overscore",
                    "overaccent"
                ],
                [
                    "Caps",
                    "identifier",
                    "latinletter"
                ],
                [
                    "CombinationPermutation",
                    "appl",
                    "unknown"
                ],
                [
                    "Ellipses",
                    "punctuation",
                    "ellipsis"
                ],
                [
                    "Exponent",
                    "superscript",
                    ""
                ],
                [
                    "Fraction",
                    "fraction",
                    ""
                ],
                [
                    "Functions",
                    "appl",
                    "simple function"
                ],
                [
                    "ImpliedTimes",
                    "operator",
                    "implicit"
                ],
                [
                    "Log",
                    "appl",
                    "prefix function"
                ],
                [
                    "Matrix",
                    "matrix",
                    ""
                ],
                [
                    "Matrix",
                    "vector",
                    ""
                ],
                [
                    "MultiLineLabel",
                    "multiline",
                    "label"
                ],
                [
                    "MultiLineOverview",
                    "multiline",
                    "table"
                ],
                [
                    "MultiLinePausesBetweenColumns",
                    "multiline",
                    "table"
                ],
                [
                    "MultiLineLabel",
                    "table",
                    "label"
                ],
                [
                    "MultiLineOverview",
                    "table",
                    "table"
                ],
                [
                    "MultiLinePausesBetweenColumns",
                    "table",
                    "table"
                ],
                [
                    "MultiLineLabel",
                    "cases",
                    "label"
                ],
                [
                    "MultiLineOverview",
                    "cases",
                    "table"
                ],
                [
                    "MultiLinePausesBetweenColumns",
                    "cases",
                    "table"
                ],
                [
                    "MultsymbolDot",
                    "operator",
                    "multiplication"
                ],
                [
                    "MultsymbolX",
                    "operator",
                    "multiplication"
                ],
                [
                    "Paren",
                    "fenced",
                    "leftright"
                ],
                [
                    "Prime",
                    "superscript",
                    "prime"
                ],
                [
                    "Roots",
                    "root",
                    ""
                ],
                [
                    "Roots",
                    "sqrt",
                    ""
                ],
                [
                    "SetMemberSymbol",
                    "relation",
                    "element"
                ],
                [
                    "Sets",
                    "fenced",
                    "set extended"
                ],
                [
                    "TriangleSymbol",
                    "identifier",
                    "greekletter"
                ],
                [
                    "Trig",
                    "appl",
                    "prefix function"
                ],
                [
                    "VerticalLine",
                    "punctuated",
                    "vbar"
                ]
            ], d1 = function() {
                const t1 = {};
                for(let e1, r1 = 0; e1 = f1[r1]; r1++){
                    const r1 = e1[0];
                    let n1 = t1[e1[1]];
                    n1 || (n1 = {}, t1[e1[1]] = n1), n1[e1[2]] = r1;
                }
                return t1;
            }();
            n1.default.getInstance().comparators.clearspeak = c1.comparator, n1.default.getInstance().parsers.clearspeak = new h1;
        },
        5425: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ClearspeakRules = void 0;
            const n1 = r1(1676), o1 = r1(365), i1 = r1(9912), s1 = r1(1378), a1 = r1(8437), l1 = r1(7283);
            e1.ClearspeakRules = function() {
                l1.addStore(n1.DynamicCstr.BASE_LOCALE + ".speech.clearspeak", "", {
                    CTFpauseSeparator: o1.pauseSeparator,
                    CTFnodeCounter: i1.nodeCounter,
                    CTFcontentIterator: o1.contentIterator,
                    CSFvulgarFraction: a1.vulgarFraction,
                    CQFvulgarFractionSmall: i1.isSmallVulgarFraction,
                    CQFcellsSimple: i1.allCellsSimple,
                    CSFordinalExponent: i1.ordinalExponent,
                    CSFwordOrdinal: i1.wordOrdinal,
                    CQFmatchingFences: i1.matchingFences,
                    CSFnestingDepth: i1.nestingDepth,
                    CQFfencedArguments: i1.fencedArguments,
                    CQFsimpleArguments: i1.simpleArguments,
                    CQFspaceoutNumber: s1.spaceoutNumber
                });
            };
        },
        9912: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.wordOrdinal = e1.layoutFactor_ = e1.fencedFactor_ = e1.simpleFactor_ = e1.simpleArguments = e1.fencedArguments = e1.insertNesting = e1.matchingFences = e1.nestingDepth = e1.NESTING_DEPTH = e1.ordinalExponent = e1.allTextLastContent_ = e1.isUnitExpression = e1.isSmallVulgarFraction = e1.allCellsSimple = e1.allIndices_ = e1.isInteger_ = e1.simpleCell_ = e1.simpleNode = e1.hasPreference = e1.isSimpleFraction_ = e1.isSimpleNumber_ = e1.isNumber_ = e1.isLetter_ = e1.isSimple_ = e1.isSimpleLetters_ = e1.isSimpleDegree_ = e1.isSimpleNegative_ = e1.isSimpleFunction_ = e1.isSimpleExpression = e1.nodeCounter = void 0;
            const n1 = r1(5740), o1 = r1(5897), i1 = r1(5274), s1 = r1(4356), a1 = r1(4977), l1 = r1(2105), c1 = r1(365), u1 = r1(7630), p1 = r1(9265), h1 = r1(3588);
            function f1(t1) {
                return S1(t1) || g1(t1) || y1(t1) || m1(t1) || d1(t1);
            }
            function d1(t1) {
                return "appl" === t1.type && ("prefix function" === t1.childNodes[0].role || "simple function" === t1.childNodes[0].role) && (b1(t1.childNodes[1]) || "fenced" === t1.childNodes[1].type && b1(t1.childNodes[1].childNodes[0]));
            }
            function m1(t1) {
                return "prefixop" === t1.type && "negative" === t1.role && b1(t1.childNodes[0]) && "prefixop" !== t1.childNodes[0].type && "appl" !== t1.childNodes[0].type && "punctuated" !== t1.childNodes[0].type;
            }
            function y1(t1) {
                return "punctuated" === t1.type && "endpunct" === t1.role && 2 === t1.childNodes.length && "degree" === t1.childNodes[1].role && (v1(t1.childNodes[0]) || _1(t1.childNodes[0]) || "prefixop" === t1.childNodes[0].type && "negative" === t1.childNodes[0].role && (v1(t1.childNodes[0].childNodes[0]) || _1(t1.childNodes[0].childNodes[0])));
            }
            function g1(t1) {
                return v1(t1) || "infixop" === t1.type && "implicit" === t1.role && (2 === t1.childNodes.length && (v1(t1.childNodes[0]) || S1(t1.childNodes[0])) && v1(t1.childNodes[1]) || 3 === t1.childNodes.length && S1(t1.childNodes[0]) && v1(t1.childNodes[1]) && v1(t1.childNodes[2]));
            }
            function b1(t1) {
                return t1.hasAnnotation("clearspeak", "simple");
            }
            function v1(t1) {
                return "identifier" === t1.type && ("latinletter" === t1.role || "greekletter" === t1.role || "otherletter" === t1.role || "simple function" === t1.role);
            }
            function _1(t1) {
                return "number" === t1.type && ("integer" === t1.role || "float" === t1.role);
            }
            function S1(t1) {
                return _1(t1) || O1(t1);
            }
            function O1(t1) {
                if (M1("Fraction_Over") || M1("Fraction_FracOver")) return !1;
                if ("fraction" !== t1.type || "vulgar" !== t1.role) return !1;
                if (M1("Fraction_Ordinal")) return !0;
                const e1 = parseInt(t1.childNodes[0].textContent, 10), r1 = parseInt(t1.childNodes[1].textContent, 10);
                return e1 > 0 && e1 < 20 && r1 > 0 && r1 < 11;
            }
            function M1(t1) {
                return o1.default.getInstance().style === t1;
            }
            function x1(t1) {
                if (!t1.hasAttribute("annotation")) return !1;
                const e1 = t1.getAttribute("annotation");
                return !!/clearspeak:simple$|clearspeak:simple;/.exec(e1);
            }
            function E1(t1) {
                if (x1(t1)) return !0;
                if ("subscript" !== t1.tagName) return !1;
                const e1 = t1.childNodes[0].childNodes, r1 = e1[1];
                return "identifier" === e1[0].tagName && (A1(r1) || "infixop" === r1.tagName && r1.hasAttribute("role") && "implicit" === r1.getAttribute("role") && C1(r1));
            }
            function A1(t1) {
                return "number" === t1.tagName && t1.hasAttribute("role") && "integer" === t1.getAttribute("role");
            }
            function C1(t1) {
                return i1.evalXPath("children/*", t1).every((t1)=>A1(t1) || "identifier" === t1.tagName);
            }
            function T1(t1) {
                return "text" === t1.type || "punctuated" === t1.type && "text" === t1.role && _1(t1.childNodes[0]) && N1(t1.childNodes.slice(1)) || "identifier" === t1.type && "unit" === t1.role || "infixop" === t1.type && ("implicit" === t1.role || "unit" === t1.role);
            }
            function N1(t1) {
                for(let e1 = 0; e1 < t1.length - 1; e1++)if ("text" !== t1[e1].type || "" !== t1[e1].textContent) return !1;
                return "text" === t1[t1.length - 1].type;
            }
            function w1(t1, e1) {
                if (!e1 || !t1) return t1;
                const r1 = t1.match(/^(open|close) /);
                return r1 ? r1[0] + e1 + " " + t1.substring(r1[0].length) : e1 + " " + t1;
            }
            function L1(t1) {
                return !!t1 && ("number" === t1.tagName || "identifier" === t1.tagName || "function" === t1.tagName || "appl" === t1.tagName || "fraction" === t1.tagName);
            }
            function I1(t1) {
                return t1 && ("fenced" === t1.tagName || t1.hasAttribute("role") && "leftright" === t1.getAttribute("role") || P1(t1));
            }
            function P1(t1) {
                return !!t1 && ("matrix" === t1.tagName || "vector" === t1.tagName);
            }
            e1.nodeCounter = function(t1, e1) {
                const r1 = e1.split("-"), n1 = c1.nodeCounter(t1, r1[0] || ""), o1 = r1[1] || "", i1 = r1[2] || "";
                let s1 = !0;
                return function() {
                    const t1 = n1();
                    return s1 ? (s1 = !1, i1 + t1 + o1) : t1 + o1;
                };
            }, e1.isSimpleExpression = f1, e1.isSimpleFunction_ = d1, e1.isSimpleNegative_ = m1, e1.isSimpleDegree_ = y1, e1.isSimpleLetters_ = g1, e1.isSimple_ = b1, e1.isLetter_ = v1, e1.isNumber_ = _1, e1.isSimpleNumber_ = S1, e1.isSimpleFraction_ = O1, e1.hasPreference = M1, (0, u1.register)(new p1.SemanticAnnotator("clearspeak", "simple", function(t1) {
                return f1(t1) ? "simple" : "";
            })), e1.simpleNode = x1, e1.simpleCell_ = E1, e1.isInteger_ = A1, e1.allIndices_ = C1, e1.allCellsSimple = function(t1) {
                const e1 = "matrix" === t1.tagName ? "children/row/children/cell/children/*" : "children/line/children/*";
                return i1.evalXPath(e1, t1).every(E1) ? [
                    t1
                ] : [];
            }, e1.isSmallVulgarFraction = function(t1) {
                return (0, a1.vulgarFractionSmall)(t1, 20, 11) ? [
                    t1
                ] : [];
            }, e1.isUnitExpression = T1, e1.allTextLastContent_ = N1, (0, u1.register)(new p1.SemanticAnnotator("clearspeak", "unit", function(t1) {
                return T1(t1) ? "unit" : "";
            })), e1.ordinalExponent = function(t1) {
                const e1 = parseInt(t1.textContent, 10);
                return isNaN(e1) ? t1.textContent : e1 > 10 ? s1.LOCALE.NUMBERS.numericOrdinal(e1) : s1.LOCALE.NUMBERS.wordOrdinal(e1);
            }, e1.NESTING_DEPTH = null, e1.nestingDepth = function(t1) {
                let r1 = 0;
                const n1 = t1.textContent, o1 = "open" === t1.getAttribute("role") ? 0 : 1;
                let i1 = t1.parentNode;
                for(; i1;)"fenced" === i1.tagName && i1.childNodes[0].childNodes[o1].textContent === n1 && r1++, i1 = i1.parentNode;
                return e1.NESTING_DEPTH = r1 > 1 ? s1.LOCALE.NUMBERS.wordOrdinal(r1) : "", e1.NESTING_DEPTH;
            }, e1.matchingFences = function(t1) {
                const e1 = t1.previousSibling;
                let r1, n1;
                return e1 ? (r1 = e1, n1 = t1) : (r1 = t1, n1 = t1.nextSibling), n1 && (0, h1.isMatchingFence)(r1.textContent, n1.textContent) ? [
                    t1
                ] : [];
            }, e1.insertNesting = w1, l1.Grammar.getInstance().setCorrection("insertNesting", w1), e1.fencedArguments = function(t1) {
                const e1 = n1.toArray(t1.parentNode.childNodes), r1 = i1.evalXPath("../../children/*", t1), o1 = e1.indexOf(t1);
                return I1(r1[o1]) || I1(r1[o1 + 1]) ? [
                    t1
                ] : [];
            }, e1.simpleArguments = function(t1) {
                const e1 = n1.toArray(t1.parentNode.childNodes), r1 = i1.evalXPath("../../children/*", t1), o1 = e1.indexOf(t1);
                return L1(r1[o1]) && r1[o1 + 1] && (L1(r1[o1 + 1]) || "root" === r1[o1 + 1].tagName || "sqrt" === r1[o1 + 1].tagName || "superscript" === r1[o1 + 1].tagName && r1[o1 + 1].childNodes[0].childNodes[0] && ("number" === r1[o1 + 1].childNodes[0].childNodes[0].tagName || "identifier" === r1[o1 + 1].childNodes[0].childNodes[0].tagName) && ("2" === r1[o1 + 1].childNodes[0].childNodes[1].textContent || "3" === r1[o1 + 1].childNodes[0].childNodes[1].textContent)) ? [
                    t1
                ] : [];
            }, e1.simpleFactor_ = L1, e1.fencedFactor_ = I1, e1.layoutFactor_ = P1, e1.wordOrdinal = function(t1) {
                return s1.LOCALE.NUMBERS.wordOrdinal(parseInt(t1.textContent, 10));
            };
        },
        6141: function(t1, e1, r1) {
            var n1 = this && this.__awaiter || function(t1, e1, r1, n1) {
                return new (r1 || (r1 = Promise))(function(o1, i1) {
                    function s1(t1) {
                        try {
                            l1(n1.next(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function a1(t1) {
                        try {
                            l1(n1.throw(t1));
                        } catch (t1) {
                            i1(t1);
                        }
                    }
                    function l1(t1) {
                        var e1;
                        t1.done ? o1(t1.value) : (e1 = t1.value, e1 instanceof r1 ? e1 : new r1(function(t1) {
                            t1(e1);
                        })).then(s1, a1);
                    }
                    l1((n1 = n1.apply(t1, e1 || [])).next());
                });
            };
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.loadAjax = e1.loadFileSync = e1.loadFile = e1.parseMaps = e1.retrieveFiles = e1.standardLoader = e1.loadLocale = e1.store = void 0;
            const o1 = r1(2139), i1 = r1(5897), s1 = r1(4440), a1 = r1(7248), l1 = r1(2315), c1 = r1(1676), u1 = r1(2780), p1 = r1(2362), h1 = r1(7491), f1 = r1(313);
            e1.store = u1;
            const d1 = {
                functions: u1.addFunctionRules,
                symbols: u1.addSymbolRules,
                units: u1.addUnitRules,
                si: u1.setSiPrefixes
            };
            let m1 = !1;
            function y1(t1 = i1.default.getInstance().locale) {
                i1.EnginePromise.loaded[t1] || (i1.EnginePromise.loaded[t1] = [
                    !1,
                    !1
                ], function(t1) {
                    if (i1.default.getInstance().isIE && i1.default.getInstance().mode === s1.Mode.HTTP) return void S1(t1);
                    b1(t1);
                }(t1));
            }
            function g1() {
                switch(i1.default.getInstance().mode){
                    case s1.Mode.ASYNC:
                        return O1;
                    case s1.Mode.HTTP:
                        return x1;
                    case s1.Mode.SYNC:
                    default:
                        return M1;
                }
            }
            function b1(t1) {
                const e1 = i1.default.getInstance().customLoader ? i1.default.getInstance().customLoader : g1(), r1 = new Promise((r1)=>{
                    e1(t1).then((e1)=>{
                        v1(e1), i1.EnginePromise.loaded[t1] = [
                            !0,
                            !0
                        ], r1(t1);
                    }, (e1)=>{
                        i1.EnginePromise.loaded[t1] = [
                            !0,
                            !1
                        ], console.error(`Unable to load locale: ${t1}`), i1.default.getInstance().locale = i1.default.getInstance().defaultLocale, r1(t1);
                    });
                });
                i1.EnginePromise.promises[t1] = r1;
            }
            function v1(t1) {
                _1(JSON.parse(t1));
            }
            function _1(t1, e1) {
                let r1 = !0;
                for(let n1, o1 = 0; n1 = Object.keys(t1)[o1]; o1++){
                    const o1 = n1.split("/");
                    e1 && e1 !== o1[0] || ("rules" === o1[1] ? p1.SpeechRuleEngine.getInstance().addStore(t1[n1]) : "messages" === o1[1] ? (0, h1.completeLocale)(t1[n1]) : (r1 && (f1.generate(o1[0]), r1 = !1), t1[n1].forEach(d1[o1[1]])));
                }
            }
            function S1(t1, e1) {
                let r1 = e1 || 1;
                o1.mapsForIE ? _1(o1.mapsForIE, t1) : r1 <= 5 && setTimeout((()=>S1(t1, r1++)).bind(this), 300);
            }
            function O1(t1) {
                const e1 = a1.localePath(t1);
                return new Promise((t1, r1)=>{
                    l1.default.fs.readFile(e1, "utf8", (e1, n1)=>{
                        if (e1) return r1(e1);
                        t1(n1);
                    });
                });
            }
            function M1(t1) {
                const e1 = a1.localePath(t1);
                return new Promise((t1, r1)=>{
                    let n1 = "{}";
                    try {
                        n1 = l1.default.fs.readFileSync(e1, "utf8");
                    } catch (t1) {
                        return r1(t1);
                    }
                    t1(n1);
                });
            }
            function x1(t1) {
                const e1 = a1.localePath(t1), r1 = new XMLHttpRequest;
                return new Promise((t1, n1)=>{
                    r1.onreadystatechange = function() {
                        if (4 === r1.readyState) {
                            const e1 = r1.status;
                            0 === e1 || e1 >= 200 && e1 < 400 ? t1(r1.responseText) : n1(e1);
                        }
                    }, r1.open("GET", e1, !0), r1.send();
                });
            }
            e1.loadLocale = function(t1 = i1.default.getInstance().locale) {
                return n1(this, void 0, void 0, function*() {
                    return m1 || (y1(c1.DynamicCstr.BASE_LOCALE), m1 = !0), i1.EnginePromise.promises[c1.DynamicCstr.BASE_LOCALE].then(()=>n1(this, void 0, void 0, function*() {
                            const e1 = i1.default.getInstance().defaultLocale;
                            return e1 ? (y1(e1), i1.EnginePromise.promises[e1].then(()=>n1(this, void 0, void 0, function*() {
                                    return y1(t1), i1.EnginePromise.promises[t1];
                                }))) : (y1(t1), i1.EnginePromise.promises[t1]);
                        }));
                });
            }, e1.standardLoader = g1, e1.retrieveFiles = b1, e1.parseMaps = v1, e1.loadFile = O1, e1.loadFileSync = M1, e1.loadAjax = x1;
        },
        7088: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.leftSubscriptBrief = e1.leftSuperscriptBrief = e1.leftSubscriptVerbose = e1.leftSuperscriptVerbose = e1.baselineBrief = e1.baselineVerbose = void 0;
            const n1 = r1(1378);
            e1.baselineVerbose = function(t1) {
                return n1.baselineVerbose(t1).replace(/-$/, "");
            }, e1.baselineBrief = function(t1) {
                return n1.baselineBrief(t1).replace(/-$/, "");
            }, e1.leftSuperscriptVerbose = function(t1) {
                return n1.superscriptVerbose(t1).replace(/^exposant/, "exposant gauche");
            }, e1.leftSubscriptVerbose = function(t1) {
                return n1.subscriptVerbose(t1).replace(/^indice/, "indice gauche");
            }, e1.leftSuperscriptBrief = function(t1) {
                return n1.superscriptBrief(t1).replace(/^sup/, "sup gauche");
            }, e1.leftSubscriptBrief = function(t1) {
                return n1.subscriptBrief(t1).replace(/^sub/, "sub gauche");
            };
        },
        9577: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.MathspeakRules = void 0;
            const n1 = r1(1676), o1 = r1(365), i1 = r1(7088), s1 = r1(1378), a1 = r1(8437), l1 = r1(7283), c1 = r1(7598);
            e1.MathspeakRules = function() {
                l1.addStore(n1.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", "", {
                    CQFspaceoutNumber: s1.spaceoutNumber,
                    CQFspaceoutIdentifier: s1.spaceoutIdentifier,
                    CSFspaceoutText: s1.spaceoutText,
                    CSFopenFracVerbose: s1.openingFractionVerbose,
                    CSFcloseFracVerbose: s1.closingFractionVerbose,
                    CSFoverFracVerbose: s1.overFractionVerbose,
                    CSFopenFracBrief: s1.openingFractionBrief,
                    CSFcloseFracBrief: s1.closingFractionBrief,
                    CSFopenFracSbrief: s1.openingFractionSbrief,
                    CSFcloseFracSbrief: s1.closingFractionSbrief,
                    CSFoverFracSbrief: s1.overFractionSbrief,
                    CSFvulgarFraction: a1.vulgarFraction,
                    CQFvulgarFractionSmall: s1.isSmallVulgarFraction,
                    CSFopenRadicalVerbose: s1.openingRadicalVerbose,
                    CSFcloseRadicalVerbose: s1.closingRadicalVerbose,
                    CSFindexRadicalVerbose: s1.indexRadicalVerbose,
                    CSFopenRadicalBrief: s1.openingRadicalBrief,
                    CSFcloseRadicalBrief: s1.closingRadicalBrief,
                    CSFindexRadicalBrief: s1.indexRadicalBrief,
                    CSFopenRadicalSbrief: s1.openingRadicalSbrief,
                    CSFindexRadicalSbrief: s1.indexRadicalSbrief,
                    CQFisSmallRoot: s1.smallRoot,
                    CSFsuperscriptVerbose: s1.superscriptVerbose,
                    CSFsuperscriptBrief: s1.superscriptBrief,
                    CSFsubscriptVerbose: s1.subscriptVerbose,
                    CSFsubscriptBrief: s1.subscriptBrief,
                    CSFbaselineVerbose: s1.baselineVerbose,
                    CSFbaselineBrief: s1.baselineBrief,
                    CSFleftsuperscriptVerbose: s1.superscriptVerbose,
                    CSFleftsubscriptVerbose: s1.subscriptVerbose,
                    CSFrightsuperscriptVerbose: s1.superscriptVerbose,
                    CSFrightsubscriptVerbose: s1.subscriptVerbose,
                    CSFleftsuperscriptBrief: s1.superscriptBrief,
                    CSFleftsubscriptBrief: s1.subscriptBrief,
                    CSFrightsuperscriptBrief: s1.superscriptBrief,
                    CSFrightsubscriptBrief: s1.subscriptBrief,
                    CSFunderscript: s1.nestedUnderscript,
                    CSFoverscript: s1.nestedOverscript,
                    CSFendscripts: s1.endscripts,
                    CTFordinalCounter: a1.ordinalCounter,
                    CTFwordCounter: a1.wordCounter,
                    CTFcontentIterator: o1.contentIterator,
                    CQFdetIsSimple: s1.determinantIsSimple,
                    CSFRemoveParens: s1.removeParens,
                    CQFresetNesting: s1.resetNestingDepth,
                    CGFbaselineConstraint: s1.generateBaselineConstraint,
                    CGFtensorRules: s1.generateTensorRules
                }), l1.addStore("es.speech.mathspeak", n1.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
                    CTFunitMultipliers: c1.unitMultipliers,
                    CQFoneLeft: c1.oneLeft
                }), l1.addStore("fr.speech.mathspeak", n1.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
                    CSFbaselineVerbose: i1.baselineVerbose,
                    CSFbaselineBrief: i1.baselineBrief,
                    CSFleftsuperscriptVerbose: i1.leftSuperscriptVerbose,
                    CSFleftsubscriptVerbose: i1.leftSubscriptVerbose,
                    CSFleftsuperscriptBrief: i1.leftSuperscriptBrief,
                    CSFleftsubscriptBrief: i1.leftSubscriptBrief
                });
            };
        },
        1378: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.smallRoot = e1.generateTensorRules = e1.removeParens = e1.generateBaselineConstraint = e1.determinantIsSimple = e1.nestedOverscript = e1.endscripts = e1.overscoreNestingDepth = e1.nestedUnderscript = e1.underscoreNestingDepth = e1.indexRadicalSbrief = e1.openingRadicalSbrief = e1.indexRadicalBrief = e1.closingRadicalBrief = e1.openingRadicalBrief = e1.indexRadicalVerbose = e1.closingRadicalVerbose = e1.openingRadicalVerbose = e1.getRootIndex = e1.nestedRadical = e1.radicalNestingDepth = e1.baselineBrief = e1.baselineVerbose = e1.superscriptBrief = e1.superscriptVerbose = e1.subscriptBrief = e1.subscriptVerbose = e1.nestedSubSuper = e1.isSmallVulgarFraction = e1.overFractionSbrief = e1.closingFractionSbrief = e1.openingFractionSbrief = e1.closingFractionBrief = e1.openingFractionBrief = e1.overFractionVerbose = e1.closingFractionVerbose = e1.openingFractionVerbose = e1.nestedFraction = e1.fractionNestingDepth = e1.computeNestingDepth_ = e1.containsAttr = e1.getNestingDepth = e1.resetNestingDepth = e1.nestingBarriers = e1.spaceoutIdentifier = e1.spaceoutNumber = e1.spaceoutNodes = e1.spaceoutText = void 0;
            const n1 = r1(707), o1 = r1(5740), i1 = r1(5274), s1 = r1(4356), a1 = r1(3308);
            let l1 = {};
            function c1(t1, e1) {
                const r1 = Array.from(t1.textContent), n1 = [], o1 = a1.default.getInstance(), i1 = t1.ownerDocument;
                for(let t1, s1 = 0; t1 = r1[s1]; s1++){
                    const r1 = o1.getNodeFactory().makeLeafNode(t1, "unknown"), s1 = o1.identifierNode(r1, "unknown", "");
                    e1(s1), n1.push(s1.xml(i1));
                }
                return n1;
            }
            function u1(t1, r1, i1, s1, a1, c1) {
                s1 = s1 || e1.nestingBarriers, a1 = a1 || {}, c1 = c1 || function(t1) {
                    return !1;
                };
                const u1 = o1.serializeXml(r1);
                if (l1[t1] || (l1[t1] = {}), l1[t1][u1]) return l1[t1][u1];
                if (c1(r1) || i1.indexOf(r1.tagName) < 0) return 0;
                const p1 = h1(r1, i1, n1.setdifference(s1, i1), a1, c1, 0);
                return l1[t1][u1] = p1, p1;
            }
            function p1(t1, e1) {
                if (!t1.attributes) return !1;
                const r1 = o1.toArray(t1.attributes);
                for(let t1, n1 = 0; t1 = r1[n1]; n1++)if (e1[t1.nodeName] === t1.nodeValue) return !0;
                return !1;
            }
            function h1(t1, e1, r1, n1, i1, s1) {
                if (i1(t1) || r1.indexOf(t1.tagName) > -1 || p1(t1, n1)) return s1;
                if (e1.indexOf(t1.tagName) > -1 && s1++, !t1.childNodes || 0 === t1.childNodes.length) return s1;
                const a1 = o1.toArray(t1.childNodes);
                return Math.max.apply(null, a1.map(function(t1) {
                    return h1(t1, e1, r1, n1, i1, s1);
                }));
            }
            function f1(t1) {
                return u1("fraction", t1, [
                    "fraction"
                ], e1.nestingBarriers, {}, s1.LOCALE.FUNCTIONS.fracNestDepth);
            }
            function d1(t1, e1, r1) {
                const n1 = f1(t1), o1 = Array(n1).fill(e1);
                return r1 && o1.push(r1), o1.join(s1.LOCALE.MESSAGES.regexp.JOINER_FRAC);
            }
            function m1(t1, e1, r1) {
                for(; t1.parentNode;){
                    const n1 = t1.parentNode, o1 = n1.parentNode;
                    if (!o1) break;
                    const i1 = t1.getAttribute && t1.getAttribute("role");
                    ("subscript" === o1.tagName && t1 === n1.childNodes[1] || "tensor" === o1.tagName && i1 && ("leftsub" === i1 || "rightsub" === i1)) && (e1 = r1.sub + s1.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + e1), ("superscript" === o1.tagName && t1 === n1.childNodes[1] || "tensor" === o1.tagName && i1 && ("leftsuper" === i1 || "rightsuper" === i1)) && (e1 = r1.sup + s1.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + e1), t1 = o1;
                }
                return e1.trim();
            }
            function y1(t1) {
                return u1("radical", t1, [
                    "sqrt",
                    "root"
                ], e1.nestingBarriers, {});
            }
            function g1(t1, e1, r1) {
                const n1 = y1(t1), o1 = b1(t1);
                return r1 = o1 ? s1.LOCALE.FUNCTIONS.combineRootIndex(r1, o1) : r1, 1 === n1 ? r1 : s1.LOCALE.FUNCTIONS.combineNestedRadical(e1, s1.LOCALE.FUNCTIONS.radicalNestDepth(n1 - 1), r1);
            }
            function b1(t1) {
                const e1 = "sqrt" === t1.tagName ? "2" : i1.evalXPath("children/*[1]", t1)[0].textContent.trim();
                return s1.LOCALE.MESSAGES.MSroots[e1] || "";
            }
            function v1(t1) {
                return u1("underscore", t1, [
                    "underscore"
                ], e1.nestingBarriers, {}, function(t1) {
                    return t1.tagName && "underscore" === t1.tagName && "underaccent" === t1.childNodes[0].childNodes[1].getAttribute("role");
                });
            }
            function _1(t1) {
                return u1("overscore", t1, [
                    "overscore"
                ], e1.nestingBarriers, {}, function(t1) {
                    return t1.tagName && "overscore" === t1.tagName && "overaccent" === t1.childNodes[0].childNodes[1].getAttribute("role");
                });
            }
            e1.spaceoutText = function(t1) {
                return Array.from(t1.textContent).join(" ");
            }, e1.spaceoutNodes = c1, e1.spaceoutNumber = function(t1) {
                return c1(t1, function(t1) {
                    t1.textContent.match(/\W/) || (t1.type = "number");
                });
            }, e1.spaceoutIdentifier = function(t1) {
                return c1(t1, function(t1) {
                    t1.font = "unknown", t1.type = "identifier";
                });
            }, e1.nestingBarriers = [
                "cases",
                "cell",
                "integral",
                "line",
                "matrix",
                "multiline",
                "overscore",
                "root",
                "row",
                "sqrt",
                "subscript",
                "superscript",
                "table",
                "underscore",
                "vector"
            ], e1.resetNestingDepth = function(t1) {
                return l1 = {}, [
                    t1
                ];
            }, e1.getNestingDepth = u1, e1.containsAttr = p1, e1.computeNestingDepth_ = h1, e1.fractionNestingDepth = f1, e1.nestedFraction = d1, e1.openingFractionVerbose = function(t1) {
                return d1(t1, s1.LOCALE.MESSAGES.MS.START, s1.LOCALE.MESSAGES.MS.FRAC_V);
            }, e1.closingFractionVerbose = function(t1) {
                return d1(t1, s1.LOCALE.MESSAGES.MS.END, s1.LOCALE.MESSAGES.MS.FRAC_V);
            }, e1.overFractionVerbose = function(t1) {
                return d1(t1, s1.LOCALE.MESSAGES.MS.FRAC_OVER);
            }, e1.openingFractionBrief = function(t1) {
                return d1(t1, s1.LOCALE.MESSAGES.MS.START, s1.LOCALE.MESSAGES.MS.FRAC_B);
            }, e1.closingFractionBrief = function(t1) {
                return d1(t1, s1.LOCALE.MESSAGES.MS.END, s1.LOCALE.MESSAGES.MS.FRAC_B);
            }, e1.openingFractionSbrief = function(t1) {
                const e1 = f1(t1);
                return 1 === e1 ? s1.LOCALE.MESSAGES.MS.FRAC_S : s1.LOCALE.FUNCTIONS.combineNestedFraction(s1.LOCALE.MESSAGES.MS.NEST_FRAC, s1.LOCALE.FUNCTIONS.radicalNestDepth(e1 - 1), s1.LOCALE.MESSAGES.MS.FRAC_S);
            }, e1.closingFractionSbrief = function(t1) {
                const e1 = f1(t1);
                return 1 === e1 ? s1.LOCALE.MESSAGES.MS.ENDFRAC : s1.LOCALE.FUNCTIONS.combineNestedFraction(s1.LOCALE.MESSAGES.MS.NEST_FRAC, s1.LOCALE.FUNCTIONS.radicalNestDepth(e1 - 1), s1.LOCALE.MESSAGES.MS.ENDFRAC);
            }, e1.overFractionSbrief = function(t1) {
                const e1 = f1(t1);
                return 1 === e1 ? s1.LOCALE.MESSAGES.MS.FRAC_OVER : s1.LOCALE.FUNCTIONS.combineNestedFraction(s1.LOCALE.MESSAGES.MS.NEST_FRAC, s1.LOCALE.FUNCTIONS.radicalNestDepth(e1 - 1), s1.LOCALE.MESSAGES.MS.FRAC_OVER);
            }, e1.isSmallVulgarFraction = function(t1) {
                return s1.LOCALE.FUNCTIONS.fracNestDepth(t1) ? [
                    t1
                ] : [];
            }, e1.nestedSubSuper = m1, e1.subscriptVerbose = function(t1) {
                return m1(t1, s1.LOCALE.MESSAGES.MS.SUBSCRIPT, {
                    sup: s1.LOCALE.MESSAGES.MS.SUPER,
                    sub: s1.LOCALE.MESSAGES.MS.SUB
                });
            }, e1.subscriptBrief = function(t1) {
                return m1(t1, s1.LOCALE.MESSAGES.MS.SUB, {
                    sup: s1.LOCALE.MESSAGES.MS.SUP,
                    sub: s1.LOCALE.MESSAGES.MS.SUB
                });
            }, e1.superscriptVerbose = function(t1) {
                return m1(t1, s1.LOCALE.MESSAGES.MS.SUPERSCRIPT, {
                    sup: s1.LOCALE.MESSAGES.MS.SUPER,
                    sub: s1.LOCALE.MESSAGES.MS.SUB
                });
            }, e1.superscriptBrief = function(t1) {
                return m1(t1, s1.LOCALE.MESSAGES.MS.SUP, {
                    sup: s1.LOCALE.MESSAGES.MS.SUP,
                    sub: s1.LOCALE.MESSAGES.MS.SUB
                });
            }, e1.baselineVerbose = function(t1) {
                const e1 = m1(t1, "", {
                    sup: s1.LOCALE.MESSAGES.MS.SUPER,
                    sub: s1.LOCALE.MESSAGES.MS.SUB
                });
                return e1 ? e1.replace(new RegExp(s1.LOCALE.MESSAGES.MS.SUB + "$"), s1.LOCALE.MESSAGES.MS.SUBSCRIPT).replace(new RegExp(s1.LOCALE.MESSAGES.MS.SUPER + "$"), s1.LOCALE.MESSAGES.MS.SUPERSCRIPT) : s1.LOCALE.MESSAGES.MS.BASELINE;
            }, e1.baselineBrief = function(t1) {
                return m1(t1, "", {
                    sup: s1.LOCALE.MESSAGES.MS.SUP,
                    sub: s1.LOCALE.MESSAGES.MS.SUB
                }) || s1.LOCALE.MESSAGES.MS.BASE;
            }, e1.radicalNestingDepth = y1, e1.nestedRadical = g1, e1.getRootIndex = b1, e1.openingRadicalVerbose = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NESTED, s1.LOCALE.MESSAGES.MS.STARTROOT);
            }, e1.closingRadicalVerbose = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NESTED, s1.LOCALE.MESSAGES.MS.ENDROOT);
            }, e1.indexRadicalVerbose = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NESTED, s1.LOCALE.MESSAGES.MS.ROOTINDEX);
            }, e1.openingRadicalBrief = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NEST_ROOT, s1.LOCALE.MESSAGES.MS.STARTROOT);
            }, e1.closingRadicalBrief = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NEST_ROOT, s1.LOCALE.MESSAGES.MS.ENDROOT);
            }, e1.indexRadicalBrief = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NEST_ROOT, s1.LOCALE.MESSAGES.MS.ROOTINDEX);
            }, e1.openingRadicalSbrief = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NEST_ROOT, s1.LOCALE.MESSAGES.MS.ROOT);
            }, e1.indexRadicalSbrief = function(t1) {
                return g1(t1, s1.LOCALE.MESSAGES.MS.NEST_ROOT, s1.LOCALE.MESSAGES.MS.INDEX);
            }, e1.underscoreNestingDepth = v1, e1.nestedUnderscript = function(t1) {
                const e1 = v1(t1);
                return Array(e1).join(s1.LOCALE.MESSAGES.MS.UNDER) + s1.LOCALE.MESSAGES.MS.UNDERSCRIPT;
            }, e1.overscoreNestingDepth = _1, e1.endscripts = function(t1) {
                return s1.LOCALE.MESSAGES.MS.ENDSCRIPTS;
            }, e1.nestedOverscript = function(t1) {
                const e1 = _1(t1);
                return Array(e1).join(s1.LOCALE.MESSAGES.MS.OVER) + s1.LOCALE.MESSAGES.MS.OVERSCRIPT;
            }, e1.determinantIsSimple = function(t1) {
                if ("matrix" !== t1.tagName || "determinant" !== t1.getAttribute("role")) return [];
                const e1 = i1.evalXPath("children/row/children/cell/children/*", t1);
                for(let t1, r1 = 0; t1 = e1[r1]; r1++)if ("number" !== t1.tagName) {
                    if ("identifier" === t1.tagName) {
                        const e1 = t1.getAttribute("role");
                        if ("latinletter" === e1 || "greekletter" === e1 || "otherletter" === e1) continue;
                    }
                    return [];
                }
                return [
                    t1
                ];
            }, e1.generateBaselineConstraint = function() {
                const t1 = (t1)=>t1.map((t1)=>"ancestor::" + t1), e1 = (t1)=>"not(" + t1 + ")", r1 = e1(t1([
                    "subscript",
                    "superscript",
                    "tensor"
                ]).join(" or ")), n1 = t1([
                    "relseq",
                    "multrel"
                ]), o1 = t1([
                    "fraction",
                    "punctuation",
                    "fenced",
                    "sqrt",
                    "root"
                ]);
                let i1 = [];
                for(let t1, e1 = 0; t1 = o1[e1]; e1++)i1 = i1.concat(n1.map(function(e1) {
                    return t1 + "/" + e1;
                }));
                return [
                    [
                        "ancestor::*/following-sibling::*",
                        r1,
                        e1(i1.join(" | "))
                    ].join(" and ")
                ];
            }, e1.removeParens = function(t1) {
                if (!t1.childNodes.length || !t1.childNodes[0].childNodes.length || !t1.childNodes[0].childNodes[0].childNodes.length) return "";
                const e1 = t1.childNodes[0].childNodes[0].childNodes[0].textContent;
                return e1.match(/^\(.+\)$/) ? e1.slice(1, -1) : e1;
            };
            const S1 = new Map([
                [
                    3,
                    "CSFleftsuperscript"
                ],
                [
                    4,
                    "CSFleftsubscript"
                ],
                [
                    2,
                    "CSFbaseline"
                ],
                [
                    1,
                    "CSFrightsubscript"
                ],
                [
                    0,
                    "CSFrightsuperscript"
                ]
            ]), O1 = new Map([
                [
                    4,
                    2
                ],
                [
                    3,
                    3
                ],
                [
                    2,
                    1
                ],
                [
                    1,
                    4
                ],
                [
                    0,
                    5
                ]
            ]);
            function M1(t1) {
                const e1 = [];
                let r1 = "", n1 = "", o1 = parseInt(t1, 2);
                for(let t1 = 0; t1 < 5; t1++){
                    const i1 = "children/*[" + O1.get(t1) + "]";
                    if (1 & o1) {
                        const e1 = S1.get(t1 % 5);
                        r1 = "[t] " + e1 + "Verbose; [n] " + i1 + ";" + r1, n1 = "[t] " + e1 + "Brief; [n] " + i1 + ";" + n1;
                    } else e1.unshift("name(" + i1 + ')="empty"');
                    o1 >>= 1;
                }
                return [
                    e1,
                    r1,
                    n1
                ];
            }
            e1.generateTensorRules = function(t1, e1 = !0) {
                const r1 = [
                    "11111",
                    "11110",
                    "11101",
                    "11100",
                    "10111",
                    "10110",
                    "10101",
                    "10100",
                    "01111",
                    "01110",
                    "01101",
                    "01100"
                ];
                for(let n1, o1 = 0; n1 = r1[o1]; o1++){
                    let r1 = "tensor" + n1, [o1, i1, s1] = M1(n1);
                    t1.defineRule(r1, "default", i1, "self::tensor", ...o1), e1 && (t1.defineRule(r1, "brief", s1, "self::tensor", ...o1), t1.defineRule(r1, "sbrief", s1, "self::tensor", ...o1));
                    const a1 = S1.get(2);
                    i1 += "; [t]" + a1 + "Verbose", s1 += "; [t]" + a1 + "Brief", r1 += "-baseline";
                    const l1 = "((.//*[not(*)])[last()]/@id)!=(((.//ancestor::fraction|ancestor::root|ancestor::sqrt|ancestor::cell|ancestor::line|ancestor::stree)[1]//*[not(*)])[last()]/@id)";
                    t1.defineRule(r1, "default", i1, "self::tensor", l1, ...o1), e1 && (t1.defineRule(r1, "brief", s1, "self::tensor", l1, ...o1), t1.defineRule(r1, "sbrief", s1, "self::tensor", l1, ...o1));
                }
            }, e1.smallRoot = function(t1) {
                let e1 = Object.keys(s1.LOCALE.MESSAGES.MSroots).length;
                if (!e1) return [];
                if (e1++, !t1.childNodes || 0 === t1.childNodes.length || !t1.childNodes[0].childNodes) return [];
                const r1 = t1.childNodes[0].childNodes[0].textContent;
                if (!/^\d+$/.test(r1)) return [];
                const n1 = parseInt(r1, 10);
                return n1 > 1 && n1 <= e1 ? [
                    t1
                ] : [];
            };
        },
        6922: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.implicitIterator = e1.relationIterator = e1.propagateNumber = e1.checkParent_ = e1.NUMBER_INHIBITORS_ = e1.NUMBER_PROPAGATORS_ = e1.enlargeFence = e1.indexRadical = e1.closingRadical = e1.openingRadical = e1.radicalNestingDepth = e1.nestedRadical = e1.overBevelledFraction = e1.overFraction = e1.closingFraction = e1.openingFraction = void 0;
            const n1 = r1(7052), o1 = r1(5740), i1 = r1(5274), s1 = r1(2105), a1 = r1(5897), l1 = r1(7630), c1 = r1(9265), u1 = r1(4356), p1 = r1(1378);
            function h1(t1, e1) {
                const r1 = f1(t1);
                return 1 === r1 ? e1 : new Array(r1).join(u1.LOCALE.MESSAGES.MS.NESTED) + e1;
            }
            function f1(t1, e1) {
                const r1 = e1 || 0;
                return t1.parentNode ? f1(t1.parentNode, "root" === t1.tagName || "sqrt" === t1.tagName ? r1 + 1 : r1) : r1;
            }
            function d1(t1) {
                const e1 = "⠠";
                if (1 === t1.length) return e1 + t1;
                const r1 = t1.split("");
                return r1.every(function(t1) {
                    return "⠳" === t1;
                }) ? e1 + r1.join(e1) : t1.slice(0, -1) + e1 + t1.slice(-1);
            }
            function m1(t1, r1) {
                const n1 = t1.parent;
                if (!n1) return !1;
                const o1 = n1.type;
                return -1 !== e1.NUMBER_PROPAGATORS_.indexOf(o1) || "prefixop" === o1 && "negative" === n1.role && !r1.script || "prefixop" === o1 && "geometry" === n1.role || !("punctuated" !== o1 || r1.enclosed && "text" !== n1.role);
            }
            function y1(t1, r1) {
                return t1.childNodes.length ? (-1 !== e1.NUMBER_INHIBITORS_.indexOf(t1.type) && (r1.script = !0), "fenced" === t1.type ? (r1.number = !1, r1.enclosed = !0, [
                    "",
                    r1
                ]) : (m1(t1, r1) && (r1.number = !0, r1.enclosed = !1), [
                    "",
                    r1
                ])) : (m1(t1, r1) && (r1.number = !0, r1.script = !1, r1.enclosed = !1), [
                    r1.number ? "number" : "",
                    {
                        number: !1,
                        enclosed: r1.enclosed,
                        script: r1.script
                    }
                ]);
            }
            e1.openingFraction = function(t1) {
                const e1 = p1.fractionNestingDepth(t1);
                return new Array(e1).join(u1.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + u1.LOCALE.MESSAGES.MS.FRACTION_START;
            }, e1.closingFraction = function(t1) {
                const e1 = p1.fractionNestingDepth(t1);
                return new Array(e1).join(u1.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + u1.LOCALE.MESSAGES.MS.FRACTION_END;
            }, e1.overFraction = function(t1) {
                const e1 = p1.fractionNestingDepth(t1);
                return new Array(e1).join(u1.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + u1.LOCALE.MESSAGES.MS.FRACTION_OVER;
            }, e1.overBevelledFraction = function(t1) {
                const e1 = p1.fractionNestingDepth(t1);
                return new Array(e1).join(u1.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + "⠸" + u1.LOCALE.MESSAGES.MS.FRACTION_OVER;
            }, e1.nestedRadical = h1, e1.radicalNestingDepth = f1, e1.openingRadical = function(t1) {
                return h1(t1, u1.LOCALE.MESSAGES.MS.STARTROOT);
            }, e1.closingRadical = function(t1) {
                return h1(t1, u1.LOCALE.MESSAGES.MS.ENDROOT);
            }, e1.indexRadical = function(t1) {
                return h1(t1, u1.LOCALE.MESSAGES.MS.ROOTINDEX);
            }, e1.enlargeFence = d1, s1.Grammar.getInstance().setCorrection("enlargeFence", d1), e1.NUMBER_PROPAGATORS_ = [
                "multirel",
                "relseq",
                "appl",
                "row",
                "line"
            ], e1.NUMBER_INHIBITORS_ = [
                "subscript",
                "superscript",
                "overscore",
                "underscore"
            ], e1.checkParent_ = m1, e1.propagateNumber = y1, (0, l1.register)(new c1.SemanticVisitor("nemeth", "number", y1, {
                number: !0
            })), e1.relationIterator = function(t1, e1) {
                const r1 = t1.slice(0);
                let s1, l1 = !0;
                return s1 = t1.length > 0 ? i1.evalXPath("../../content/*", t1[0]) : [], function() {
                    const t1 = s1.shift(), i1 = r1.shift(), c1 = r1[0], h1 = e1 ? [
                        n1.AuditoryDescription.create({
                            text: e1
                        }, {
                            translate: !0
                        })
                    ] : [];
                    if (!t1) return h1;
                    const f1 = i1 ? p1.nestedSubSuper(i1, "", {
                        sup: u1.LOCALE.MESSAGES.MS.SUPER,
                        sub: u1.LOCALE.MESSAGES.MS.SUB
                    }) : "", d1 = i1 && "EMPTY" !== o1.tagName(i1) || l1 && t1.parentNode.parentNode && t1.parentNode.parentNode.previousSibling ? [
                        n1.AuditoryDescription.create({
                            text: "⠀" + f1
                        }, {})
                    ] : [], m1 = c1 && "EMPTY" !== o1.tagName(c1) || !s1.length && t1.parentNode.parentNode && t1.parentNode.parentNode.nextSibling ? [
                        n1.AuditoryDescription.create({
                            text: "⠀"
                        }, {})
                    ] : [], y1 = a1.default.evaluateNode(t1);
                    return l1 = !1, h1.concat(d1, y1, m1);
                };
            }, e1.implicitIterator = function(t1, e1) {
                const r1 = t1.slice(0);
                let s1;
                return s1 = t1.length > 0 ? i1.evalXPath("../../content/*", t1[0]) : [], function() {
                    const t1 = r1.shift(), i1 = r1[0], a1 = s1.shift(), l1 = e1 ? [
                        n1.AuditoryDescription.create({
                            text: e1
                        }, {
                            translate: !0
                        })
                    ] : [];
                    if (!a1) return l1;
                    const c1 = t1 && "NUMBER" === o1.tagName(t1), u1 = i1 && "NUMBER" === o1.tagName(i1);
                    return l1.concat(c1 && u1 && "space" === a1.getAttribute("role") ? [
                        n1.AuditoryDescription.create({
                            text: "⠀"
                        }, {})
                    ] : []);
                };
            };
        },
        8437: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.ordinalPosition = e1.vulgarFraction = e1.wordCounter = e1.ordinalCounter = void 0;
            const n1 = r1(9536), o1 = r1(5740), i1 = r1(4356), s1 = r1(4977);
            e1.ordinalCounter = function(t1, e1) {
                let r1 = 0;
                return function() {
                    return i1.LOCALE.NUMBERS.numericOrdinal(++r1) + " " + e1;
                };
            }, e1.wordCounter = function(t1, e1) {
                let r1 = 0;
                return function() {
                    return i1.LOCALE.NUMBERS.numberToOrdinal(++r1, !1) + " " + e1;
                };
            }, e1.vulgarFraction = function(t1) {
                const e1 = (0, s1.convertVulgarFraction)(t1, i1.LOCALE.MESSAGES.MS.FRAC_OVER);
                return e1.convertible && e1.enumerator && e1.denominator ? [
                    new n1.Span(i1.LOCALE.NUMBERS.numberToWords(e1.enumerator), {
                        extid: t1.childNodes[0].childNodes[0].getAttribute("extid"),
                        separator: ""
                    }),
                    new n1.Span(i1.LOCALE.NUMBERS.vulgarSep, {
                        separator: ""
                    }),
                    new n1.Span(i1.LOCALE.NUMBERS.numberToOrdinal(e1.denominator, 1 !== e1.enumerator), {
                        extid: t1.childNodes[0].childNodes[1].getAttribute("extid")
                    })
                ] : [
                    new n1.Span(e1.content || "", {
                        extid: t1.getAttribute("extid")
                    })
                ];
            }, e1.ordinalPosition = function(t1) {
                const e1 = o1.toArray(t1.parentNode.childNodes);
                return i1.LOCALE.NUMBERS.numericOrdinal(e1.indexOf(t1) + 1).toString();
            };
        },
        9284: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.BrailleRules = e1.OtherRules = e1.PrefixRules = void 0;
            const n1 = r1(1676), o1 = r1(365), i1 = r1(1378), s1 = r1(6922), a1 = r1(8437), l1 = r1(7283);
            e1.PrefixRules = function() {
                l1.addStore("en.prefix.default", "", {
                    CSFordinalPosition: a1.ordinalPosition
                });
            }, e1.OtherRules = function() {
                l1.addStore("en.speech.chromevox", "", {
                    CTFnodeCounter: o1.nodeCounter,
                    CTFcontentIterator: o1.contentIterator
                }), l1.addStore("en.speech.emacspeak", "en.speech.chromevox", {
                    CQFvulgarFractionSmall: i1.isSmallVulgarFraction,
                    CSFvulgarFraction: a1.vulgarFraction
                });
            }, e1.BrailleRules = function() {
                l1.addStore("nemeth.braille.default", n1.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
                    CSFopenFraction: s1.openingFraction,
                    CSFcloseFraction: s1.closingFraction,
                    CSFoverFraction: s1.overFraction,
                    CSFoverBevFraction: s1.overBevelledFraction,
                    CSFopenRadical: s1.openingRadical,
                    CSFcloseRadical: s1.closingRadical,
                    CSFindexRadical: s1.indexRadical,
                    CSFsubscript: i1.subscriptVerbose,
                    CSFsuperscript: i1.superscriptVerbose,
                    CSFbaseline: i1.baselineVerbose,
                    CGFtensorRules: (t1)=>i1.generateTensorRules(t1, !1),
                    CTFrelationIterator: s1.relationIterator,
                    CTFimplicitIterator: s1.implicitIterator
                });
            };
        },
        7599: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.init = e1.INIT_ = void 0;
            const n1 = r1(5425), o1 = r1(9577), i1 = r1(9284);
            e1.INIT_ = !1, e1.init = function() {
                e1.INIT_ || ((0, o1.MathspeakRules)(), (0, n1.ClearspeakRules)(), (0, i1.PrefixRules)(), (0, i1.OtherRules)(), (0, i1.BrailleRules)(), e1.INIT_ = !0);
            };
        },
        7283: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.getStore = e1.addStore = e1.funcStore = void 0;
            const n1 = r1(1676);
            e1.funcStore = new Map, e1.addStore = function(t1, r1, n1) {
                const o1 = {};
                if (r1) {
                    const t1 = e1.funcStore.get(r1) || {};
                    Object.assign(o1, t1);
                }
                e1.funcStore.set(t1, Object.assign(o1, n1));
            }, e1.getStore = function(t1, r1, o1) {
                return e1.funcStore.get([
                    t1,
                    r1,
                    o1
                ].join(".")) || e1.funcStore.get([
                    n1.DynamicCstr.DEFAULT_VALUES[n1.Axis.LOCALE],
                    r1,
                    o1
                ].join(".")) || e1.funcStore.get([
                    n1.DynamicCstr.BASE_LOCALE,
                    r1,
                    o1
                ].join(".")) || {};
            };
        },
        7598: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.oneLeft = e1.leftMostUnit = e1.rightMostUnit = e1.unitMultipliers = void 0;
            const n1 = r1(7052), o1 = r1(5274), i1 = r1(4356);
            e1.unitMultipliers = function(t1, e1) {
                const r1 = t1;
                let o1 = 0;
                return function() {
                    const t1 = n1.AuditoryDescription.create({
                        text: a1(r1[o1]) && l1(r1[o1 + 1]) ? i1.LOCALE.MESSAGES.unitTimes : ""
                    }, {});
                    return o1++, [
                        t1
                    ];
                };
            };
            const s1 = [
                "superscript",
                "subscript",
                "overscore",
                "underscore"
            ];
            function a1(t1) {
                for(; t1;){
                    if ("unit" === t1.getAttribute("role")) return !0;
                    const e1 = t1.tagName, r1 = o1.evalXPath("children/*", t1);
                    t1 = -1 !== s1.indexOf(e1) ? r1[0] : r1[r1.length - 1];
                }
                return !1;
            }
            function l1(t1) {
                for(; t1;){
                    if ("unit" === t1.getAttribute("role")) return !0;
                    t1 = o1.evalXPath("children/*", t1)[0];
                }
                return !1;
            }
            e1.rightMostUnit = a1, e1.leftMostUnit = l1, e1.oneLeft = function(t1) {
                for(; t1;){
                    if ("number" === t1.tagName && "1" === t1.textContent) return [
                        t1
                    ];
                    if ("infixop" !== t1.tagName || "multiplication" !== t1.getAttribute("role") && "implicit" !== t1.getAttribute("role")) return [];
                    t1 = o1.evalXPath("children/*", t1)[0];
                }
                return [];
            };
        },
        3284: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.AbstractWalker = void 0;
            const n1 = r1(7052), o1 = r1(8290), i1 = r1(5740), s1 = r1(4440), a1 = r1(6828), l1 = r1(8496), c1 = r1(2298), u1 = r1(4356), p1 = r1(2105), h1 = r1(5656), f1 = r1(9552), d1 = r1(9543), m1 = r1(8504), y1 = r1(7730), g1 = r1(1214), b1 = r1(179), v1 = r1(1204), _1 = r1(5274);
            class S1 {
                constructor(t1, e1, r1, n1){
                    this.node = t1, this.generator = e1, this.highlighter = r1, this.modifier = !1, this.keyMapping = new Map([
                        [
                            l1.KeyCode.UP,
                            this.up.bind(this)
                        ],
                        [
                            l1.KeyCode.DOWN,
                            this.down.bind(this)
                        ],
                        [
                            l1.KeyCode.RIGHT,
                            this.right.bind(this)
                        ],
                        [
                            l1.KeyCode.LEFT,
                            this.left.bind(this)
                        ],
                        [
                            l1.KeyCode.TAB,
                            this.repeat.bind(this)
                        ],
                        [
                            l1.KeyCode.DASH,
                            this.expand.bind(this)
                        ],
                        [
                            l1.KeyCode.SPACE,
                            this.depth.bind(this)
                        ],
                        [
                            l1.KeyCode.HOME,
                            this.home.bind(this)
                        ],
                        [
                            l1.KeyCode.X,
                            this.summary.bind(this)
                        ],
                        [
                            l1.KeyCode.Z,
                            this.detail.bind(this)
                        ],
                        [
                            l1.KeyCode.V,
                            this.virtualize.bind(this)
                        ],
                        [
                            l1.KeyCode.P,
                            this.previous.bind(this)
                        ],
                        [
                            l1.KeyCode.U,
                            this.undo.bind(this)
                        ],
                        [
                            l1.KeyCode.LESS,
                            this.previousRules.bind(this)
                        ],
                        [
                            l1.KeyCode.GREATER,
                            this.nextRules.bind(this)
                        ]
                    ]), this.cursors = [], this.xml_ = null, this.rebuilt_ = null, this.focus_ = null, this.active_ = !1, this.node.id ? this.id = this.node.id : this.node.hasAttribute(S1.SRE_ID_ATTR) ? this.id = this.node.getAttribute(S1.SRE_ID_ATTR) : (this.node.setAttribute(S1.SRE_ID_ATTR, S1.ID_COUNTER.toString()), this.id = S1.ID_COUNTER++), this.rootNode = v1.getSemanticRoot(t1), this.rootId = this.rootNode.getAttribute(c1.Attribute.ID), this.xmlString_ = n1, this.moved = b1.WalkerMoves.ENTER;
                }
                getXml() {
                    return this.xml_ || (this.xml_ = i1.parseInput(this.xmlString_)), this.xml_;
                }
                getRebuilt() {
                    return this.rebuilt_ || this.rebuildStree(), this.rebuilt_;
                }
                isActive() {
                    return this.active_;
                }
                activate() {
                    this.isActive() || (this.generator.start(), this.toggleActive_());
                }
                deactivate() {
                    this.isActive() && (b1.WalkerState.setState(this.id, this.primaryId()), this.generator.end(), this.toggleActive_());
                }
                getFocus(t1 = !1) {
                    return this.focus_ || (this.focus_ = this.singletonFocus(this.rootId)), t1 && this.updateFocus(), this.focus_;
                }
                setFocus(t1) {
                    this.focus_ = t1;
                }
                getDepth() {
                    return this.levels.depth() - 1;
                }
                isSpeech() {
                    return this.generator.modality === c1.Attribute.SPEECH;
                }
                focusDomNodes() {
                    return this.getFocus().getDomNodes();
                }
                focusSemanticNodes() {
                    return this.getFocus().getSemanticNodes();
                }
                speech() {
                    const t1 = this.focusDomNodes();
                    if (!t1.length) return "";
                    const e1 = this.specialMove();
                    if (null !== e1) return e1;
                    switch(this.moved){
                        case b1.WalkerMoves.DEPTH:
                            return this.depth_();
                        case b1.WalkerMoves.SUMMARY:
                            return this.summary_();
                        case b1.WalkerMoves.DETAIL:
                            return this.detail_();
                        default:
                            {
                                const e1 = [], r1 = this.focusSemanticNodes();
                                for(let n1 = 0, o1 = t1.length; n1 < o1; n1++){
                                    const o1 = t1[n1], i1 = r1[n1];
                                    e1.push(o1 ? this.generator.getSpeech(o1, this.getXml()) : d1.recomputeMarkup(i1));
                                }
                                return this.mergePrefix_(e1);
                            }
                    }
                }
                move(t1) {
                    const e1 = this.keyMapping.get(t1);
                    if (!e1) return null;
                    const r1 = e1();
                    return !(!r1 || r1 === this.getFocus()) && (this.setFocus(r1), this.moved === b1.WalkerMoves.HOME && (this.levels = this.initLevels()), !0);
                }
                up() {
                    return this.moved = b1.WalkerMoves.UP, this.getFocus();
                }
                down() {
                    return this.moved = b1.WalkerMoves.DOWN, this.getFocus();
                }
                left() {
                    return this.moved = b1.WalkerMoves.LEFT, this.getFocus();
                }
                right() {
                    return this.moved = b1.WalkerMoves.RIGHT, this.getFocus();
                }
                repeat() {
                    return this.moved = b1.WalkerMoves.REPEAT, this.getFocus().clone();
                }
                depth() {
                    return this.moved = this.isSpeech() ? b1.WalkerMoves.DEPTH : b1.WalkerMoves.REPEAT, this.getFocus().clone();
                }
                home() {
                    this.moved = b1.WalkerMoves.HOME;
                    return this.singletonFocus(this.rootId);
                }
                getBySemanticId(t1) {
                    return v1.getBySemanticId(this.node, t1);
                }
                primaryId() {
                    return this.getFocus().getSemanticPrimary().id.toString();
                }
                expand() {
                    const t1 = this.getFocus().getDomPrimary(), e1 = this.actionable_(t1);
                    return e1 ? (this.moved = b1.WalkerMoves.EXPAND, e1.dispatchEvent(new Event("click")), this.getFocus().clone()) : this.getFocus();
                }
                expandable(t1) {
                    return !!this.actionable_(t1) && 0 === t1.childNodes.length;
                }
                collapsible(t1) {
                    return !!this.actionable_(t1) && t1.childNodes.length > 0;
                }
                restoreState() {
                    if (!this.highlighter) return;
                    const t1 = b1.WalkerState.getState(this.id);
                    if (!t1) return;
                    let e1 = this.getRebuilt().nodeDict[t1];
                    const r1 = [];
                    for(; e1;)r1.push(e1.id), e1 = e1.parent;
                    for(r1.pop(); r1.length > 0;){
                        this.down();
                        const t1 = r1.pop(), e1 = this.findFocusOnLevel(t1);
                        if (!e1) break;
                        this.setFocus(e1);
                    }
                    this.moved = b1.WalkerMoves.ENTER;
                }
                updateFocus() {
                    this.setFocus(y1.Focus.factory(this.getFocus().getSemanticPrimary().id.toString(), this.getFocus().getSemanticNodes().map((t1)=>t1.id.toString()), this.getRebuilt(), this.node));
                }
                rebuildStree() {
                    this.rebuilt_ = new g1.RebuildStree(this.getXml()), this.rootId = this.rebuilt_.stree.root.id.toString(), this.generator.setRebuilt(this.rebuilt_), this.skeleton = h1.SemanticSkeleton.fromTree(this.rebuilt_.stree), this.skeleton.populate(), this.focus_ = this.singletonFocus(this.rootId), this.levels = this.initLevels(), d1.connectMactions(this.node, this.getXml(), this.rebuilt_.xml);
                }
                previousLevel() {
                    const t1 = this.getFocus().getDomPrimary();
                    return t1 ? v1.getAttribute(t1, c1.Attribute.PARENT) : this.getFocus().getSemanticPrimary().parent.id.toString();
                }
                nextLevel() {
                    const t1 = this.getFocus().getDomPrimary();
                    let e1, r1;
                    if (t1) {
                        e1 = v1.splitAttribute(v1.getAttribute(t1, c1.Attribute.CHILDREN)), r1 = v1.splitAttribute(v1.getAttribute(t1, c1.Attribute.CONTENT));
                        const n1 = v1.getAttribute(t1, c1.Attribute.TYPE), o1 = v1.getAttribute(t1, c1.Attribute.ROLE);
                        return this.combineContentChildren(n1, o1, r1, e1);
                    }
                    const n1 = (t1)=>t1.id.toString(), o1 = this.getRebuilt().nodeDict[this.primaryId()];
                    return e1 = o1.childNodes.map(n1), r1 = o1.contentNodes.map(n1), 0 === e1.length ? [] : this.combineContentChildren(o1.type, o1.role, r1, e1);
                }
                singletonFocus(t1) {
                    this.getRebuilt();
                    const e1 = this.retrieveVisuals(t1);
                    return this.focusFromId(t1, e1);
                }
                retrieveVisuals(t1) {
                    if (!this.skeleton) return [
                        t1
                    ];
                    const e1 = parseInt(t1, 10), r1 = this.skeleton.subtreeNodes(e1);
                    if (!r1.length) return [
                        t1
                    ];
                    r1.unshift(e1);
                    const n1 = {}, o1 = [];
                    _1.updateEvaluator(this.getXml());
                    for (const t1 of r1)n1[t1] || (o1.push(t1.toString()), n1[t1] = !0, this.subtreeIds(t1, n1));
                    return o1;
                }
                subtreeIds(t1, e1) {
                    const r1 = _1.evalXPath(`//*[@data-semantic-id="${t1}"]`, this.getXml());
                    _1.evalXPath("*//@data-semantic-id", r1[0]).forEach((t1)=>e1[parseInt(t1.textContent, 10)] = !0);
                }
                focusFromId(t1, e1) {
                    return y1.Focus.factory(t1, e1, this.getRebuilt(), this.node);
                }
                summary() {
                    return this.moved = this.isSpeech() ? b1.WalkerMoves.SUMMARY : b1.WalkerMoves.REPEAT, this.getFocus().clone();
                }
                detail() {
                    return this.moved = this.isSpeech() ? b1.WalkerMoves.DETAIL : b1.WalkerMoves.REPEAT, this.getFocus().clone();
                }
                specialMove() {
                    return null;
                }
                virtualize(t1) {
                    return this.cursors.push({
                        focus: this.getFocus(),
                        levels: this.levels,
                        undo: t1 || !this.cursors.length
                    }), this.levels = this.levels.clone(), this.getFocus().clone();
                }
                previous() {
                    const t1 = this.cursors.pop();
                    return t1 ? (this.levels = t1.levels, t1.focus) : this.getFocus();
                }
                undo() {
                    let t1;
                    do t1 = this.cursors.pop();
                    while (t1 && !t1.undo);
                    return t1 ? (this.levels = t1.levels, t1.focus) : this.getFocus();
                }
                update(t1) {
                    this.generator.setOptions(t1), (0, a1.setup)(t1).then(()=>f1.generator("Tree").getSpeech(this.node, this.getXml()));
                }
                nextRules() {
                    const t1 = this.generator.getOptions();
                    return "speech" !== t1.modality ? this.getFocus() : (s1.DOMAIN_TO_STYLES[t1.domain] = t1.style, t1.domain = "mathspeak" === t1.domain ? "clearspeak" : "mathspeak", t1.style = s1.DOMAIN_TO_STYLES[t1.domain], this.update(t1), this.moved = b1.WalkerMoves.REPEAT, this.getFocus().clone());
                }
                nextStyle(t1, e1) {
                    if ("mathspeak" === t1) {
                        const t1 = [
                            "default",
                            "brief",
                            "sbrief"
                        ], r1 = t1.indexOf(e1);
                        return -1 === r1 ? e1 : r1 >= t1.length - 1 ? t1[0] : t1[r1 + 1];
                    }
                    if ("clearspeak" === t1) {
                        const t1 = m1.ClearspeakPreferences.getLocalePreferences().en;
                        if (!t1) return "default";
                        const r1 = m1.ClearspeakPreferences.relevantPreferences(this.getFocus().getSemanticPrimary()), n1 = m1.ClearspeakPreferences.findPreference(e1, r1), o1 = t1[r1].map(function(t1) {
                            return t1.split("_")[1];
                        }), i1 = o1.indexOf(n1);
                        if (-1 === i1) return e1;
                        const s1 = i1 >= o1.length - 1 ? o1[0] : o1[i1 + 1];
                        return m1.ClearspeakPreferences.addPreference(e1, r1, s1);
                    }
                    return e1;
                }
                previousRules() {
                    const t1 = this.generator.getOptions();
                    return "speech" !== t1.modality ? this.getFocus() : (t1.style = this.nextStyle(t1.domain, t1.style), this.update(t1), this.moved = b1.WalkerMoves.REPEAT, this.getFocus().clone());
                }
                refocus() {
                    let t1, e1 = this.getFocus();
                    for(; !e1.getNodes().length;){
                        t1 = this.levels.peek();
                        const r1 = this.up();
                        if (!r1) break;
                        this.setFocus(r1), e1 = this.getFocus(!0);
                    }
                    this.levels.push(t1), this.setFocus(e1);
                }
                toggleActive_() {
                    this.active_ = !this.active_;
                }
                mergePrefix_(t1, e1 = []) {
                    const r1 = this.isSpeech() ? this.prefix_() : "";
                    r1 && t1.unshift(r1);
                    const n1 = this.isSpeech() ? this.postfix_() : "";
                    return n1 && t1.push(n1), o1.finalize(o1.merge(e1.concat(t1)));
                }
                prefix_() {
                    const t1 = this.getFocus().getDomNodes(), e1 = this.getFocus().getSemanticNodes();
                    return t1[0] ? v1.getAttribute(t1[0], c1.Attribute.PREFIX) : d1.retrievePrefix(e1[0]);
                }
                postfix_() {
                    const t1 = this.getFocus().getDomNodes();
                    return t1[0] ? v1.getAttribute(t1[0], c1.Attribute.POSTFIX) : "";
                }
                depth_() {
                    const t1 = p1.Grammar.getInstance().getParameter("depth");
                    p1.Grammar.getInstance().setParameter("depth", !0);
                    const e1 = this.getFocus().getDomPrimary(), r1 = this.expandable(e1) ? u1.LOCALE.MESSAGES.navigate.EXPANDABLE : this.collapsible(e1) ? u1.LOCALE.MESSAGES.navigate.COLLAPSIBLE : "", i1 = u1.LOCALE.MESSAGES.navigate.LEVEL + " " + this.getDepth(), s1 = this.getFocus().getSemanticNodes(), a1 = d1.retrievePrefix(s1[0]), l1 = [
                        new n1.AuditoryDescription({
                            text: i1,
                            personality: {}
                        }),
                        new n1.AuditoryDescription({
                            text: a1,
                            personality: {}
                        }),
                        new n1.AuditoryDescription({
                            text: r1,
                            personality: {}
                        })
                    ];
                    return p1.Grammar.getInstance().setParameter("depth", t1), o1.finalize(o1.markup(l1));
                }
                actionable_(t1) {
                    const e1 = null == t1 ? void 0 : t1.parentNode;
                    return e1 && this.highlighter.isMactionNode(e1) ? e1 : null;
                }
                summary_() {
                    const t1 = this.getFocus().getSemanticPrimary().id.toString(), e1 = this.getRebuilt().xml.getAttribute("id") === t1 ? this.getRebuilt().xml : i1.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", t1)[0], r1 = d1.retrieveSummary(e1);
                    return this.mergePrefix_([
                        r1
                    ]);
                }
                detail_() {
                    const t1 = this.getFocus().getSemanticPrimary().id.toString(), e1 = this.getRebuilt().xml.getAttribute("id") === t1 ? this.getRebuilt().xml : i1.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", t1)[0], r1 = e1.getAttribute("alternative");
                    e1.removeAttribute("alternative");
                    const n1 = d1.computeMarkup(e1), o1 = this.mergePrefix_([
                        n1
                    ]);
                    return e1.setAttribute("alternative", r1), o1;
                }
            }
            e1.AbstractWalker = S1, S1.ID_COUNTER = 0, S1.SRE_ID_ATTR = "sre-explorer-id";
        },
        162: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.DummyWalker = void 0;
            const n1 = r1(3284);
            class o1 extends n1.AbstractWalker {
                up() {
                    return null;
                }
                down() {
                    return null;
                }
                left() {
                    return null;
                }
                right() {
                    return null;
                }
                repeat() {
                    return null;
                }
                depth() {
                    return null;
                }
                home() {
                    return null;
                }
                getDepth() {
                    return 0;
                }
                initLevels() {
                    return null;
                }
                combineContentChildren(t1, e1, r1, n1) {
                    return [];
                }
                findFocusOnLevel(t1) {
                    return null;
                }
            }
            e1.DummyWalker = o1;
        },
        7730: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Focus = void 0;
            const n1 = r1(1204);
            class o1 {
                constructor(t1, e1){
                    this.nodes = t1, this.primary = e1, this.domNodes = [], this.domPrimary_ = null, this.allNodes = [];
                }
                static factory(t1, e1, r1, i1) {
                    const s1 = (t1)=>n1.getBySemanticId(i1, t1), a1 = r1.nodeDict, l1 = s1(t1), c1 = e1.map(s1), u1 = e1.map(function(t1) {
                        return a1[t1];
                    }), p1 = new o1(u1, a1[t1]);
                    return p1.domNodes = c1, p1.domPrimary_ = l1, p1.allNodes = o1.generateAllVisibleNodes_(e1, c1, a1, i1), p1;
                }
                static generateAllVisibleNodes_(t1, e1, r1, i1) {
                    const s1 = (t1)=>n1.getBySemanticId(i1, t1);
                    let a1 = [];
                    for(let n1 = 0, l1 = t1.length; n1 < l1; n1++){
                        if (e1[n1]) {
                            a1.push(e1[n1]);
                            continue;
                        }
                        const l1 = r1[t1[n1]];
                        if (!l1) continue;
                        const c1 = l1.childNodes.map(function(t1) {
                            return t1.id.toString();
                        }), u1 = c1.map(s1);
                        a1 = a1.concat(o1.generateAllVisibleNodes_(c1, u1, r1, i1));
                    }
                    return a1;
                }
                getSemanticPrimary() {
                    return this.primary;
                }
                getSemanticNodes() {
                    return this.nodes;
                }
                getNodes() {
                    return this.allNodes;
                }
                getDomNodes() {
                    return this.domNodes;
                }
                getDomPrimary() {
                    return this.domPrimary_;
                }
                toString() {
                    return "Primary:" + this.domPrimary_ + " Nodes:" + this.domNodes;
                }
                clone() {
                    const t1 = new o1(this.nodes, this.primary);
                    return t1.domNodes = this.domNodes, t1.domPrimary_ = this.domPrimary_, t1.allNodes = this.allNodes, t1;
                }
            }
            e1.Focus = o1;
        },
        9797: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Levels = void 0;
            class r1 {
                constructor(){
                    this.level_ = [];
                }
                push(t1) {
                    this.level_.push(t1);
                }
                pop() {
                    return this.level_.pop();
                }
                peek() {
                    return this.level_[this.level_.length - 1] || null;
                }
                indexOf(t1) {
                    const e1 = this.peek();
                    return e1 ? e1.indexOf(t1) : null;
                }
                find(t1) {
                    const e1 = this.peek();
                    if (!e1) return null;
                    for(let r1 = 0, n1 = e1.length; r1 < n1; r1++)if (t1(e1[r1])) return e1[r1];
                    return null;
                }
                get(t1) {
                    const e1 = this.peek();
                    return !e1 || t1 < 0 || t1 >= e1.length ? null : e1[t1];
                }
                depth() {
                    return this.level_.length;
                }
                clone() {
                    const t1 = new r1;
                    return t1.level_ = this.level_.slice(0), t1;
                }
                toString() {
                    let t1 = "";
                    for(let e1, r1 = 0; e1 = this.level_[r1]; r1++)t1 += "\n" + e1.map(function(t1) {
                        return t1.toString();
                    });
                    return t1;
                }
            }
            e1.Levels = r1;
        },
        1214: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.RebuildStree = void 0;
            const n1 = r1(5740), o1 = r1(2298), i1 = r1(3588), s1 = r1(6537), a1 = r1(3308), l1 = r1(5656), c1 = r1(7075), u1 = r1(4795), p1 = r1(1204);
            class h1 {
                constructor(t1){
                    this.mathml = t1, this.factory = new s1.SemanticNodeFactory, this.nodeDict = {}, this.mmlRoot = p1.getSemanticRoot(t1), this.streeRoot = this.assembleTree(this.mmlRoot), this.stree = c1.SemanticTree.fromNode(this.streeRoot, this.mathml), this.xml = this.stree.xml(), a1.default.getInstance().setNodeFactory(this.factory);
                }
                static addAttributes(t1, e1, r1) {
                    r1 && 1 === e1.childNodes.length && e1.childNodes[0].nodeType !== n1.NodeType.TEXT_NODE && u1.addAttributes(t1, e1.childNodes[0]), u1.addAttributes(t1, e1);
                }
                static textContent(t1, e1, r1) {
                    if (!r1 && e1.textContent) return void (t1.textContent = e1.textContent);
                    const n1 = p1.splitAttribute(p1.getAttribute(e1, o1.Attribute.OPERATOR));
                    n1.length > 1 && (t1.textContent = n1[1]);
                }
                static isPunctuated(t1) {
                    return !l1.SemanticSkeleton.simpleCollapseStructure(t1) && t1[1] && l1.SemanticSkeleton.contentCollapseStructure(t1[1]);
                }
                getTree() {
                    return this.stree;
                }
                assembleTree(t1) {
                    const e1 = this.makeNode(t1), r1 = p1.splitAttribute(p1.getAttribute(t1, o1.Attribute.CHILDREN)), n1 = p1.splitAttribute(p1.getAttribute(t1, o1.Attribute.CONTENT));
                    if (h1.addAttributes(e1, t1, !(r1.length || n1.length)), 0 === n1.length && 0 === r1.length) return h1.textContent(e1, t1), e1;
                    if (n1.length > 0) {
                        const t1 = p1.getBySemanticId(this.mathml, n1[0]);
                        t1 && h1.textContent(e1, t1, !0);
                    }
                    e1.contentNodes = n1.map((t1)=>this.setParent(t1, e1)), e1.childNodes = r1.map((t1)=>this.setParent(t1, e1));
                    const i1 = p1.getAttribute(t1, o1.Attribute.COLLAPSED);
                    return i1 ? this.postProcess(e1, i1) : e1;
                }
                makeNode(t1) {
                    const e1 = p1.getAttribute(t1, o1.Attribute.TYPE), r1 = p1.getAttribute(t1, o1.Attribute.ROLE), n1 = p1.getAttribute(t1, o1.Attribute.FONT), i1 = p1.getAttribute(t1, o1.Attribute.ANNOTATION) || "", s1 = p1.getAttribute(t1, o1.Attribute.ID), a1 = p1.getAttribute(t1, o1.Attribute.EMBELLISHED), l1 = p1.getAttribute(t1, o1.Attribute.FENCEPOINTER), c1 = this.createNode(parseInt(s1, 10));
                    return c1.type = e1, c1.role = r1, c1.font = n1 || "unknown", c1.parseAnnotation(i1), l1 && (c1.fencePointer = l1), a1 && (c1.embellished = a1), c1;
                }
                makePunctuation(t1) {
                    const e1 = this.createNode(t1);
                    return e1.updateContent((0, i1.invisibleComma)()), e1.role = "dummy", e1;
                }
                makePunctuated(t1, e1, r1) {
                    const n1 = this.createNode(e1[0]);
                    n1.type = "punctuated", n1.embellished = t1.embellished, n1.fencePointer = t1.fencePointer, n1.role = r1;
                    const o1 = e1.splice(1, 1)[0].slice(1);
                    n1.contentNodes = o1.map(this.makePunctuation.bind(this)), this.collapsedChildren_(e1);
                }
                makeEmpty(t1, e1, r1) {
                    const n1 = this.createNode(e1);
                    n1.type = "empty", n1.embellished = t1.embellished, n1.fencePointer = t1.fencePointer, n1.role = r1;
                }
                makeIndex(t1, e1, r1) {
                    if (h1.isPunctuated(e1)) return this.makePunctuated(t1, e1, r1), void (e1 = e1[0]);
                    l1.SemanticSkeleton.simpleCollapseStructure(e1) && !this.nodeDict[e1.toString()] && this.makeEmpty(t1, e1, r1);
                }
                postProcess(t1, e1) {
                    const r1 = l1.SemanticSkeleton.fromString(e1).array;
                    if ("subsup" === t1.type) {
                        const e1 = this.createNode(r1[1][0]);
                        return e1.type = "subscript", e1.role = "subsup", t1.type = "superscript", e1.embellished = t1.embellished, e1.fencePointer = t1.fencePointer, this.makeIndex(t1, r1[1][2], "rightsub"), this.makeIndex(t1, r1[2], "rightsuper"), this.collapsedChildren_(r1), t1;
                    }
                    if ("subscript" === t1.type) return this.makeIndex(t1, r1[2], "rightsub"), this.collapsedChildren_(r1), t1;
                    if ("superscript" === t1.type) return this.makeIndex(t1, r1[2], "rightsuper"), this.collapsedChildren_(r1), t1;
                    if ("tensor" === t1.type) return this.makeIndex(t1, r1[2], "leftsub"), this.makeIndex(t1, r1[3], "leftsuper"), this.makeIndex(t1, r1[4], "rightsub"), this.makeIndex(t1, r1[5], "rightsuper"), this.collapsedChildren_(r1), t1;
                    if ("punctuated" === t1.type) {
                        if (h1.isPunctuated(r1)) {
                            const e1 = r1.splice(1, 1)[0].slice(1);
                            t1.contentNodes = e1.map(this.makePunctuation.bind(this));
                        }
                        return t1;
                    }
                    if ("underover" === t1.type) {
                        const e1 = this.createNode(r1[1][0]);
                        return "overaccent" === t1.childNodes[1].role ? (e1.type = "overscore", t1.type = "underscore") : (e1.type = "underscore", t1.type = "overscore"), e1.role = "underover", e1.embellished = t1.embellished, e1.fencePointer = t1.fencePointer, this.collapsedChildren_(r1), t1;
                    }
                    return t1;
                }
                createNode(t1) {
                    const e1 = this.factory.makeNode(t1);
                    return this.nodeDict[t1.toString()] = e1, e1;
                }
                collapsedChildren_(t1) {
                    const e1 = (t1)=>{
                        const r1 = this.nodeDict[t1[0]];
                        r1.childNodes = [];
                        for(let n1 = 1, o1 = t1.length; n1 < o1; n1++){
                            const o1 = t1[n1];
                            r1.childNodes.push(l1.SemanticSkeleton.simpleCollapseStructure(o1) ? this.nodeDict[o1] : e1(o1));
                        }
                        return r1;
                    };
                    e1(t1);
                }
                setParent(t1, e1) {
                    const r1 = p1.getBySemanticId(this.mathml, t1), n1 = this.assembleTree(r1);
                    return n1.parent = e1, n1;
                }
            }
            e1.RebuildStree = h1;
        },
        6295: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SemanticWalker = void 0;
            const n1 = r1(3284), o1 = r1(9797);
            class i1 extends n1.AbstractWalker {
                constructor(t1, e1, r1, n1){
                    super(t1, e1, r1, n1), this.node = t1, this.generator = e1, this.highlighter = r1, this.levels = null, this.restoreState();
                }
                initLevels() {
                    const t1 = new o1.Levels;
                    return t1.push([
                        this.getFocus()
                    ]), t1;
                }
                up() {
                    super.up();
                    const t1 = this.previousLevel();
                    if (!t1) return null;
                    this.levels.pop();
                    return this.levels.find(function(e1) {
                        return e1.getSemanticNodes().some(function(e1) {
                            return e1.id.toString() === t1;
                        });
                    });
                }
                down() {
                    super.down();
                    const t1 = this.nextLevel();
                    return 0 === t1.length ? null : (this.levels.push(t1), t1[0]);
                }
                combineContentChildren(t1, e1, r1, n1) {
                    switch(t1){
                        case "relseq":
                        case "infixop":
                        case "multirel":
                            return this.makePairList(n1, r1);
                        case "prefixop":
                            return [
                                this.focusFromId(n1[0], r1.concat(n1))
                            ];
                        case "postfixop":
                            return [
                                this.focusFromId(n1[0], n1.concat(r1))
                            ];
                        case "matrix":
                        case "vector":
                        case "fenced":
                            return [
                                this.focusFromId(n1[0], [
                                    r1[0],
                                    n1[0],
                                    r1[1]
                                ])
                            ];
                        case "cases":
                            return [
                                this.focusFromId(n1[0], [
                                    r1[0],
                                    n1[0]
                                ])
                            ];
                        case "punctuated":
                            return "text" === e1 ? n1.map(this.singletonFocus.bind(this)) : n1.length === r1.length ? r1.map(this.singletonFocus.bind(this)) : this.combinePunctuations(n1, r1, [], []);
                        case "appl":
                            return [
                                this.focusFromId(n1[0], [
                                    n1[0],
                                    r1[0]
                                ]),
                                this.singletonFocus(n1[1])
                            ];
                        case "root":
                            return [
                                this.singletonFocus(n1[1]),
                                this.singletonFocus(n1[0])
                            ];
                        default:
                            return n1.map(this.singletonFocus.bind(this));
                    }
                }
                combinePunctuations(t1, e1, r1, n1) {
                    if (0 === t1.length) return n1;
                    const o1 = t1.shift(), i1 = e1.shift();
                    return o1 === i1 ? (r1.push(i1), this.combinePunctuations(t1, e1, r1, n1)) : (e1.unshift(i1), r1.push(o1), t1.length === e1.length ? (n1.push(this.focusFromId(o1, r1.concat(e1))), n1) : (n1.push(this.focusFromId(o1, r1)), this.combinePunctuations(t1, e1, [], n1)));
                }
                makePairList(t1, e1) {
                    if (0 === t1.length) return [];
                    if (1 === t1.length) return [
                        this.singletonFocus(t1[0])
                    ];
                    const r1 = [
                        this.singletonFocus(t1.shift())
                    ];
                    for(let n1 = 0, o1 = t1.length; n1 < o1; n1++)r1.push(this.focusFromId(t1[n1], [
                        e1[n1],
                        t1[n1]
                    ]));
                    return r1;
                }
                left() {
                    super.left();
                    const t1 = this.levels.indexOf(this.getFocus());
                    if (null === t1) return null;
                    const e1 = this.levels.get(t1 - 1);
                    return e1 || null;
                }
                right() {
                    super.right();
                    const t1 = this.levels.indexOf(this.getFocus());
                    if (null === t1) return null;
                    const e1 = this.levels.get(t1 + 1);
                    return e1 || null;
                }
                findFocusOnLevel(t1) {
                    return this.levels.find((e1)=>e1.getSemanticPrimary().id === t1);
                }
            }
            e1.SemanticWalker = i1;
        },
        9806: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.SyntaxWalker = void 0;
            const n1 = r1(707), o1 = r1(3284), i1 = r1(9797);
            class s1 extends o1.AbstractWalker {
                constructor(t1, e1, r1, n1){
                    super(t1, e1, r1, n1), this.node = t1, this.generator = e1, this.highlighter = r1, this.levels = null, this.restoreState();
                }
                initLevels() {
                    const t1 = new i1.Levels;
                    return t1.push([
                        this.primaryId()
                    ]), t1;
                }
                up() {
                    super.up();
                    const t1 = this.previousLevel();
                    return t1 ? (this.levels.pop(), this.singletonFocus(t1)) : null;
                }
                down() {
                    super.down();
                    const t1 = this.nextLevel();
                    if (0 === t1.length) return null;
                    const e1 = this.singletonFocus(t1[0]);
                    return e1 && this.levels.push(t1), e1;
                }
                combineContentChildren(t1, e1, r1, o1) {
                    switch(t1){
                        case "relseq":
                        case "infixop":
                        case "multirel":
                            return (0, n1.interleaveLists)(o1, r1);
                        case "prefixop":
                            return r1.concat(o1);
                        case "postfixop":
                            return o1.concat(r1);
                        case "matrix":
                        case "vector":
                        case "fenced":
                            return o1.unshift(r1[0]), o1.push(r1[1]), o1;
                        case "cases":
                            return o1.unshift(r1[0]), o1;
                        case "punctuated":
                            return "text" === e1 ? (0, n1.interleaveLists)(o1, r1) : o1;
                        case "appl":
                            return [
                                o1[0],
                                r1[0],
                                o1[1]
                            ];
                        case "root":
                            return [
                                o1[1],
                                o1[0]
                            ];
                        default:
                            return o1;
                    }
                }
                left() {
                    super.left();
                    const t1 = this.levels.indexOf(this.primaryId());
                    if (null === t1) return null;
                    const e1 = this.levels.get(t1 - 1);
                    return e1 ? this.singletonFocus(e1) : null;
                }
                right() {
                    super.right();
                    const t1 = this.levels.indexOf(this.primaryId());
                    if (null === t1) return null;
                    const e1 = this.levels.get(t1 + 1);
                    return e1 ? this.singletonFocus(e1) : null;
                }
                findFocusOnLevel(t1) {
                    return this.singletonFocus(t1.toString());
                }
                focusDomNodes() {
                    return [
                        this.getFocus().getDomPrimary()
                    ];
                }
                focusSemanticNodes() {
                    return [
                        this.getFocus().getSemanticPrimary()
                    ];
                }
            }
            e1.SyntaxWalker = s1;
        },
        1799: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.TableWalker = void 0;
            const n1 = r1(5740), o1 = r1(8496), i1 = r1(9806), s1 = r1(179);
            class a1 extends i1.SyntaxWalker {
                constructor(t1, e1, r1, n1){
                    super(t1, e1, r1, n1), this.node = t1, this.generator = e1, this.highlighter = r1, this.firstJump = null, this.key_ = null, this.row_ = 0, this.currentTable_ = null, this.keyMapping.set(o1.KeyCode.ZERO, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.ONE, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.TWO, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.THREE, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.FOUR, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.FIVE, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.SIX, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.SEVEN, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.EIGHT, this.jumpCell.bind(this)), this.keyMapping.set(o1.KeyCode.NINE, this.jumpCell.bind(this));
                }
                move(t1) {
                    this.key_ = t1;
                    const e1 = super.move(t1);
                    return this.modifier = !1, e1;
                }
                up() {
                    return this.moved = s1.WalkerMoves.UP, this.eligibleCell_() ? this.verticalMove_(!1) : super.up();
                }
                down() {
                    return this.moved = s1.WalkerMoves.DOWN, this.eligibleCell_() ? this.verticalMove_(!0) : super.down();
                }
                jumpCell() {
                    if (!this.isInTable_() || null === this.key_) return this.getFocus();
                    if (this.moved === s1.WalkerMoves.ROW) {
                        this.moved = s1.WalkerMoves.CELL;
                        const t1 = this.key_ - o1.KeyCode.ZERO;
                        return this.isLegalJump_(this.row_, t1) ? this.jumpCell_(this.row_, t1) : this.getFocus();
                    }
                    const t1 = this.key_ - o1.KeyCode.ZERO;
                    return t1 > this.currentTable_.childNodes.length ? this.getFocus() : (this.row_ = t1, this.moved = s1.WalkerMoves.ROW, this.getFocus().clone());
                }
                undo() {
                    const t1 = super.undo();
                    return t1 === this.firstJump && (this.firstJump = null), t1;
                }
                eligibleCell_() {
                    const t1 = this.getFocus().getSemanticPrimary();
                    return this.modifier && "cell" === t1.type && -1 !== a1.ELIGIBLE_CELL_ROLES.indexOf(t1.role);
                }
                verticalMove_(t1) {
                    const e1 = this.previousLevel();
                    if (!e1) return null;
                    const r1 = this.getFocus(), n1 = this.levels.indexOf(this.primaryId()), o1 = this.levels.pop(), i1 = this.levels.indexOf(e1), s1 = this.levels.get(t1 ? i1 + 1 : i1 - 1);
                    if (!s1) return this.levels.push(o1), null;
                    this.setFocus(this.singletonFocus(s1));
                    const a1 = this.nextLevel();
                    return a1[n1] ? (this.levels.push(a1), this.singletonFocus(a1[n1])) : (this.setFocus(r1), this.levels.push(o1), null);
                }
                jumpCell_(t1, e1) {
                    this.firstJump ? this.virtualize(!1) : (this.firstJump = this.getFocus(), this.virtualize(!0));
                    const r1 = this.currentTable_.id.toString();
                    let n1;
                    do n1 = this.levels.pop();
                    while (-1 === n1.indexOf(r1));
                    this.levels.push(n1), this.setFocus(this.singletonFocus(r1)), this.levels.push(this.nextLevel());
                    const o1 = this.currentTable_.childNodes[t1 - 1];
                    return this.setFocus(this.singletonFocus(o1.id.toString())), this.levels.push(this.nextLevel()), this.singletonFocus(o1.childNodes[e1 - 1].id.toString());
                }
                isLegalJump_(t1, e1) {
                    const r1 = n1.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", this.currentTable_.id.toString())[0];
                    if (!r1 || r1.hasAttribute("alternative")) return !1;
                    const o1 = this.currentTable_.childNodes[t1 - 1];
                    if (!o1) return !1;
                    const i1 = n1.querySelectorAllByAttrValue(r1, "id", o1.id.toString())[0];
                    return !(!i1 || i1.hasAttribute("alternative")) && !(!o1 || !o1.childNodes[e1 - 1]);
                }
                isInTable_() {
                    let t1 = this.getFocus().getSemanticPrimary();
                    for(; t1;){
                        if (-1 !== a1.ELIGIBLE_TABLE_TYPES.indexOf(t1.type)) return this.currentTable_ = t1, !0;
                        t1 = t1.parent;
                    }
                    return !1;
                }
            }
            e1.TableWalker = a1, a1.ELIGIBLE_CELL_ROLES = [
                "determinant",
                "rowvector",
                "binomial",
                "squarematrix",
                "multiline",
                "matrix",
                "vector",
                "cases",
                "table"
            ], a1.ELIGIBLE_TABLE_TYPES = [
                "multiline",
                "matrix",
                "vector",
                "cases",
                "table"
            ];
        },
        179: function(t1, e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.WalkerState = e1.WalkerMoves = void 0, function(t1) {
                t1.UP = "up", t1.DOWN = "down", t1.LEFT = "left", t1.RIGHT = "right", t1.REPEAT = "repeat", t1.DEPTH = "depth", t1.ENTER = "enter", t1.EXPAND = "expand", t1.HOME = "home", t1.SUMMARY = "summary", t1.DETAIL = "detail", t1.ROW = "row", t1.CELL = "cell";
            }(e1.WalkerMoves || (e1.WalkerMoves = {}));
            class r1 {
                static resetState(t1) {
                    delete r1.STATE[t1];
                }
                static setState(t1, e1) {
                    r1.STATE[t1] = e1;
                }
                static getState(t1) {
                    return r1.STATE[t1];
                }
            }
            e1.WalkerState = r1, r1.STATE = {};
        },
        3362: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.walkerMapping_ = e1.walker = void 0;
            const n1 = r1(162), o1 = r1(6295), i1 = r1(9806), s1 = r1(1799);
            e1.walker = function(t1, r1, n1, o1, i1) {
                return (e1.walkerMapping_[t1.toLowerCase()] || e1.walkerMapping_.dummy)(r1, n1, o1, i1);
            }, e1.walkerMapping_ = {
                dummy: (t1, e1, r1, o1)=>new n1.DummyWalker(t1, e1, r1, o1),
                semantic: (t1, e1, r1, n1)=>new o1.SemanticWalker(t1, e1, r1, n1),
                syntax: (t1, e1, r1, n1)=>new i1.SyntaxWalker(t1, e1, r1, n1),
                table: (t1, e1, r1, n1)=>new s1.TableWalker(t1, e1, r1, n1)
            };
        },
        1204: function(t1, e1, r1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.getBySemanticId = e1.getSemanticRoot = e1.getAttribute = e1.splitAttribute = void 0;
            const n1 = r1(5740), o1 = r1(2298);
            e1.splitAttribute = function(t1) {
                return t1 ? t1.split(/,/) : [];
            }, e1.getAttribute = function(t1, e1) {
                return t1.getAttribute(e1);
            }, e1.getSemanticRoot = function(t1) {
                if (t1.hasAttribute(o1.Attribute.TYPE) && !t1.hasAttribute(o1.Attribute.PARENT)) return t1;
                const e1 = n1.querySelectorAllByAttr(t1, o1.Attribute.TYPE);
                for(let t1, r1 = 0; t1 = e1[r1]; r1++)if (!t1.hasAttribute(o1.Attribute.PARENT)) return t1;
                return t1;
            }, e1.getBySemanticId = function(t1, e1) {
                return t1.getAttribute(o1.Attribute.ID) === e1 ? t1 : n1.querySelectorAllByAttrValue(t1, o1.Attribute.ID, e1)[0];
            };
        }
    }, __webpack_module_cache__ = {};
    function __webpack_require__(t1) {
        var e1 = __webpack_module_cache__[t1];
        if (void 0 !== e1) return e1.exports;
        var r1 = __webpack_module_cache__[t1] = {
            exports: {}
        };
        return __webpack_modules__[t1].call(r1.exports, r1, r1.exports, __webpack_require__), r1.exports;
    }
    __webpack_require__.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (t1) {
            if ("object" == typeof window) return window;
        }
    }();
    var __webpack_exports__ = {};
    !function() {
        var t1 = __webpack_require__(9515), e1 = __webpack_require__(3282), r1 = __webpack_require__(235), n1 = __webpack_require__(265), o1 = __webpack_require__(2388);
        function i1(t1, e1) {
            (null == e1 || e1 > t1.length) && (e1 = t1.length);
            for(var r1 = 0, n1 = new Array(e1); r1 < e1; r1++)n1[r1] = t1[r1];
            return n1;
        }
        MathJax.loader && MathJax.loader.checkVersion("startup", e1.VERSION, "startup"), (0, t1.combineWithMathJax)({
            _: {
                components: {
                    loader: r1,
                    package: n1,
                    startup: o1
                }
            }
        });
        var s1, a1 = {
            "a11y/semantic-enrich": [
                "input/mml",
                "a11y/sre"
            ],
            "a11y/complexity": [
                "a11y/semantic-enrich"
            ],
            "a11y/explorer": [
                "a11y/semantic-enrich",
                "ui/menu"
            ],
            "[mml]/mml3": [
                "input/mml"
            ],
            "[tex]/all-packages": [
                "input/tex-base"
            ],
            "[tex]/action": [
                "input/tex-base",
                "[tex]/newcommand"
            ],
            "[tex]/autoload": [
                "input/tex-base",
                "[tex]/require"
            ],
            "[tex]/ams": [
                "input/tex-base"
            ],
            "[tex]/amscd": [
                "input/tex-base"
            ],
            "[tex]/bbox": [
                "input/tex-base",
                "[tex]/ams",
                "[tex]/newcommand"
            ],
            "[tex]/boldsymbol": [
                "input/tex-base"
            ],
            "[tex]/braket": [
                "input/tex-base"
            ],
            "[tex]/bussproofs": [
                "input/tex-base"
            ],
            "[tex]/cancel": [
                "input/tex-base",
                "[tex]/enclose"
            ],
            "[tex]/centernot": [
                "input/tex-base"
            ],
            "[tex]/color": [
                "input/tex-base"
            ],
            "[tex]/colorv2": [
                "input/tex-base"
            ],
            "[tex]/colortbl": [
                "input/tex-base",
                "[tex]/color"
            ],
            "[tex]/configmacros": [
                "input/tex-base",
                "[tex]/newcommand"
            ],
            "[tex]/enclose": [
                "input/tex-base"
            ],
            "[tex]/extpfeil": [
                "input/tex-base",
                "[tex]/newcommand",
                "[tex]/ams"
            ],
            "[tex]/html": [
                "input/tex-base"
            ],
            "[tex]/mathtools": [
                "input/tex-base",
                "[tex]/newcommand",
                "[tex]/ams"
            ],
            "[tex]/mhchem": [
                "input/tex-base",
                "[tex]/ams"
            ],
            "[tex]/newcommand": [
                "input/tex-base"
            ],
            "[tex]/noerrors": [
                "input/tex-base"
            ],
            "[tex]/noundefined": [
                "input/tex-base"
            ],
            "[tex]/physics": [
                "input/tex-base"
            ],
            "[tex]/require": [
                "input/tex-base"
            ],
            "[tex]/setoptions": [
                "input/tex-base"
            ],
            "[tex]/tagformat": [
                "input/tex-base"
            ],
            "[tex]/textcomp": [
                "input/tex-base",
                "[tex]/textmacros"
            ],
            "[tex]/textmacros": [
                "input/tex-base"
            ],
            "[tex]/unicode": [
                "input/tex-base"
            ],
            "[tex]/verb": [
                "input/tex-base"
            ],
            "[tex]/cases": [
                "[tex]/empheq"
            ],
            "[tex]/empheq": [
                "input/tex-base",
                "[tex]/ams"
            ]
        }, l1 = Array.from(Object.keys(a1)).filter(function(t1) {
            return "[tex]" === t1.substr(0, 5) && "[tex]/autoload" !== t1 && "[tex]/colorv2" !== t1 && "[tex]/all-packages" !== t1;
        }), c1 = {
            startup: [
                "loader"
            ],
            "input/tex": [
                "input/tex-base",
                "[tex]/ams",
                "[tex]/newcommand",
                "[tex]/noundefined",
                "[tex]/require",
                "[tex]/autoload",
                "[tex]/configmacros"
            ],
            "input/tex-full": [
                "input/tex-base",
                "[tex]/all-packages"
            ].concat((s1 = l1, function(t1) {
                if (Array.isArray(t1)) return i1(t1);
            }(s1) || function(t1) {
                if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
            }(s1) || function(t1, e1) {
                if (t1) {
                    if ("string" == typeof t1) return i1(t1, e1);
                    var r1 = Object.prototype.toString.call(t1).slice(8, -1);
                    return "Object" === r1 && t1.constructor && (r1 = t1.constructor.name), "Map" === r1 || "Set" === r1 ? Array.from(t1) : "Arguments" === r1 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r1) ? i1(t1, e1) : void 0;
                }
            }(s1) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }())),
            "[tex]/all-packages": l1
        };
        (0, t1.combineDefaults)(MathJax.config.loader, "dependencies", a1), (0, t1.combineDefaults)(MathJax.config.loader, "paths", {
            tex: "[mathjax]/input/tex/extensions",
            mml: "[mathjax]/input/mml/extensions",
            sre: "[mathjax]/sre/mathmaps"
        }), (0, t1.combineDefaults)(MathJax.config.loader, "provides", c1), (0, t1.combineDefaults)(MathJax.config.loader, "source", {
            "[tex]/amsCd": "[tex]/amscd",
            "[tex]/colorV2": "[tex]/colorv2",
            "[tex]/configMacros": "[tex]/configmacros",
            "[tex]/tagFormat": "[tex]/tagformat"
        }), r1.Loader.preLoad("loader", "startup", "core", "input/tex", "output/chtml", "output/chtml/fonts/tex.js", "ui/menu", "a11y/assistive-mml");
        var u1 = __webpack_require__(444), p1 = __webpack_require__(6191), h1 = __webpack_require__(5009), f1 = __webpack_require__(3494), d1 = __webpack_require__(3670), m1 = __webpack_require__(805), y1 = __webpack_require__(9206), g1 = __webpack_require__(5722), b1 = __webpack_require__(4474), v1 = __webpack_require__(9e3), _1 = __webpack_require__(91), S1 = __webpack_require__(6336), O1 = __webpack_require__(1759), M1 = __webpack_require__(3909), x1 = __webpack_require__(9007), E1 = __webpack_require__(3948), A1 = __webpack_require__(9145), C1 = __webpack_require__(142), T1 = __webpack_require__(7590), N1 = __webpack_require__(3233), w1 = __webpack_require__(1334), L1 = __webpack_require__(6661), I1 = __webpack_require__(1581), P1 = __webpack_require__(5410), R1 = __webpack_require__(6850), k1 = __webpack_require__(3985), j1 = __webpack_require__(450), B1 = __webpack_require__(6405), D1 = __webpack_require__(3050), F1 = __webpack_require__(2756), H1 = __webpack_require__(7238), U1 = __webpack_require__(5741), X1 = __webpack_require__(6145), V1 = __webpack_require__(9878), q1 = __webpack_require__(7265), W1 = __webpack_require__(6030), G1 = __webpack_require__(7131), z1 = __webpack_require__(1314), J1 = __webpack_require__(4461), K1 = __webpack_require__(1349), $1 = __webpack_require__(4359), Y1 = __webpack_require__(4770), Z1 = __webpack_require__(5022), Q1 = __webpack_require__(5184), tt1 = __webpack_require__(9102), et1 = __webpack_require__(6325), rt1 = __webpack_require__(4082), nt1 = __webpack_require__(9259), ot1 = __webpack_require__(2975), it1 = __webpack_require__(4574), st1 = __webpack_require__(4596), at1 = __webpack_require__(7860), lt1 = __webpack_require__(8823), ct1 = __webpack_require__(8912), ut1 = __webpack_require__(3811), pt1 = __webpack_require__(6272), ht1 = __webpack_require__(3683), ft1 = __webpack_require__(5138), dt1 = __webpack_require__(3726), mt1 = __webpack_require__(3363), yt1 = __webpack_require__(3335), gt1 = __webpack_require__(5713), bt1 = __webpack_require__(9923), vt1 = __webpack_require__(6469), _t1 = __webpack_require__(6751), St1 = __webpack_require__(5368), Ot1 = __webpack_require__(7525), Mt1 = __webpack_require__(103), xt1 = __webpack_require__(7233), Et1 = __webpack_require__(8666), At1 = __webpack_require__(4542), Ct1 = __webpack_require__(4139), Tt1 = __webpack_require__(8054), Nt1 = __webpack_require__(6010), wt1 = __webpack_require__(7875), Lt1 = __webpack_require__(505);
        MathJax.loader && MathJax.loader.checkVersion("core", e1.VERSION, "core"), (0, t1.combineWithMathJax)({
            _: {
                adaptors: {
                    HTMLAdaptor: u1,
                    browserAdaptor: p1
                },
                components: {
                    global: t1
                },
                core: {
                    DOMAdaptor: h1,
                    FindMath: f1,
                    Handler: d1,
                    HandlerList: m1,
                    InputJax: y1,
                    MathDocument: g1,
                    MathItem: b1,
                    MathList: v1,
                    MmlTree: {
                        Attributes: _1,
                        MML: S1,
                        MathMLVisitor: O1,
                        MmlFactory: M1,
                        MmlNode: x1,
                        MmlNodes: {
                            TeXAtom: E1,
                            maction: A1,
                            maligngroup: C1,
                            malignmark: T1,
                            math: N1,
                            mathchoice: w1,
                            menclose: L1,
                            merror: I1,
                            mfenced: P1,
                            mfrac: R1,
                            mglyph: k1,
                            mi: j1,
                            mmultiscripts: B1,
                            mn: D1,
                            mo: F1,
                            mpadded: H1,
                            mphantom: U1,
                            mroot: X1,
                            mrow: V1,
                            ms: q1,
                            mspace: W1,
                            msqrt: G1,
                            mstyle: z1,
                            msubsup: J1,
                            mtable: K1,
                            mtd: $1,
                            mtext: Y1,
                            mtr: Z1,
                            munderover: Q1,
                            semantics: tt1
                        },
                        MmlVisitor: et1,
                        OperatorDictionary: rt1,
                        SerializedMmlVisitor: nt1
                    },
                    OutputJax: ot1,
                    Tree: {
                        Factory: it1,
                        Node: st1,
                        NodeFactory: at1,
                        Visitor: lt1,
                        Wrapper: ct1,
                        WrapperFactory: ut1
                    }
                },
                handlers: {
                    html_ts: pt1,
                    html: {
                        HTMLDocument: ht1,
                        HTMLDomStrings: ft1,
                        HTMLHandler: dt1,
                        HTMLMathItem: mt1,
                        HTMLMathList: yt1
                    }
                },
                mathjax: gt1,
                util: {
                    AsyncLoad: bt1,
                    BBox: vt1,
                    BitField: _t1,
                    Entities: St1,
                    FunctionList: Ot1,
                    LinkedList: Mt1,
                    Options: xt1,
                    PrioritizedList: Et1,
                    Retries: At1,
                    StyleList: Ct1,
                    Styles: Tt1,
                    lengths: Nt1,
                    numeric: wt1,
                    string: Lt1
                }
            }
        }), MathJax.startup && (MathJax.startup.registerConstructor("HTMLHandler", dt1.HTMLHandler), MathJax.startup.registerConstructor("browserAdaptor", p1.browserAdaptor), MathJax.startup.useHandler("HTMLHandler"), MathJax.startup.useAdaptor("browserAdaptor")), MathJax.loader && (MathJax._.mathjax.mathjax.asyncLoad = function(t1) {
            return MathJax.loader.load(t1);
        });
        var It1 = __webpack_require__(8462), Pt1 = __webpack_require__(9899), Rt1 = __webpack_require__(4676), kt1 = __webpack_require__(7073), jt1 = __webpack_require__(2947), Bt1 = __webpack_require__(8929), Dt1 = __webpack_require__(1256), Ft1 = __webpack_require__(5450), Ht1 = __webpack_require__(8562), Ut1 = __webpack_require__(1130), Xt1 = __webpack_require__(9497), Vt1 = __webpack_require__(8292), qt1 = __webpack_require__(5453), Wt1 = __webpack_require__(8803), Gt1 = __webpack_require__(9140), zt1 = __webpack_require__(6521), Jt1 = __webpack_require__(8317), Kt1 = __webpack_require__(3971), $t1 = __webpack_require__(8417), Yt1 = __webpack_require__(8021), Zt1 = __webpack_require__(2790), Qt1 = __webpack_require__(4387), te1 = __webpack_require__(1275), ee1 = __webpack_require__(2942), re1 = __webpack_require__(1181), ne1 = __webpack_require__(7693), oe1 = __webpack_require__(8458), ie1 = __webpack_require__(1496), se1 = __webpack_require__(6793), ae1 = __webpack_require__(1110), le1 = __webpack_require__(5579), ce1 = __webpack_require__(4898), ue1 = __webpack_require__(7741);
        MathJax.loader && MathJax.loader.checkVersion("input/tex", e1.VERSION, "input"), (0, t1.combineWithMathJax)({
            _: {
                input: {
                    tex_ts: It1,
                    tex: {
                        Configuration: Pt1,
                        FilterUtil: Rt1,
                        FindTeX: kt1,
                        MapHandler: jt1,
                        NodeFactory: Bt1,
                        NodeUtil: Dt1,
                        ParseMethods: Ft1,
                        ParseOptions: Ht1,
                        ParseUtil: Ut1,
                        Stack: Xt1,
                        StackItem: Vt1,
                        StackItemFactory: qt1,
                        Symbol: Wt1,
                        SymbolMap: Gt1,
                        Tags: zt1,
                        TexConstants: Jt1,
                        TexError: Kt1,
                        TexParser: $t1,
                        ams: {
                            AmsConfiguration: Yt1,
                            AmsItems: Zt1,
                            AmsMethods: Qt1
                        },
                        autoload: {
                            AutoloadConfiguration: te1
                        },
                        base: {
                            BaseConfiguration: ee1,
                            BaseItems: re1,
                            BaseMethods: ne1
                        },
                        configmacros: {
                            ConfigMacrosConfiguration: oe1
                        },
                        newcommand: {
                            NewcommandConfiguration: ie1,
                            NewcommandItems: se1,
                            NewcommandMethods: ae1,
                            NewcommandUtil: le1
                        },
                        noundefined: {
                            NoUndefinedConfiguration: ce1
                        },
                        require: {
                            RequireConfiguration: ue1
                        }
                    }
                }
            }
        }), r1.Loader.preLoad("input/tex-base", "[tex]/ams", "[tex]/newcommand", "[tex]/noundefined", "[tex]/require", "[tex]/autoload", "[tex]/configmacros"), function() {
            var t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e1 = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            if (MathJax.startup) {
                e1 && (MathJax.startup.registerConstructor("tex", MathJax._.input.tex_ts.TeX), MathJax.startup.useInput("tex")), MathJax.config.tex || (MathJax.config.tex = {});
                var r1 = MathJax.config.tex.packages;
                MathJax.config.tex.packages = t1, r1 && (0, xt1.insert)(MathJax.config.tex, {
                    packages: r1
                });
            }
        }([
            "base",
            "ams",
            "newcommand",
            "noundefined",
            "require",
            "autoload",
            "configmacros"
        ]);
        var pe1 = __webpack_require__(50), he1 = __webpack_require__(8042), fe1 = __webpack_require__(8270), de1 = __webpack_require__(6797), me1 = __webpack_require__(5355), ye1 = __webpack_require__(9261), ge1 = __webpack_require__(9086), be1 = __webpack_require__(95), ve1 = __webpack_require__(1148), _e1 = __webpack_require__(8102), Se1 = __webpack_require__(804), Oe1 = __webpack_require__(8147), Me1 = __webpack_require__(2275), xe1 = __webpack_require__(9063), Ee1 = __webpack_require__(6911), Ae1 = __webpack_require__(1653), Ce1 = __webpack_require__(6781), Te1 = __webpack_require__(6460), Ne1 = __webpack_require__(6287), we1 = __webpack_require__(5964), Le1 = __webpack_require__(8776), Ie1 = __webpack_require__(4798), Pe1 = __webpack_require__(4597), Re1 = __webpack_require__(2970), ke1 = __webpack_require__(5610), je1 = __webpack_require__(4300), Be1 = __webpack_require__(8002), De1 = __webpack_require__(7056), Fe1 = __webpack_require__(1259), He1 = __webpack_require__(3571), Ue1 = __webpack_require__(6590), Xe1 = __webpack_require__(8650), Ve1 = __webpack_require__(421), qe1 = __webpack_require__(5884), We1 = __webpack_require__(5552), Ge1 = __webpack_require__(3055), ze1 = __webpack_require__(7519), Je1 = __webpack_require__(4420), Ke1 = __webpack_require__(9800), $e1 = __webpack_require__(1160), Ye1 = __webpack_require__(1956), Ze1 = __webpack_require__(7490), Qe1 = __webpack_require__(7313), tr1 = __webpack_require__(7555), er1 = __webpack_require__(2688), rr1 = __webpack_require__(5636), nr1 = __webpack_require__(5723), or1 = __webpack_require__(8009), ir1 = __webpack_require__(5023), sr1 = __webpack_require__(7096), ar1 = __webpack_require__(6898), lr1 = __webpack_require__(6991), cr1 = __webpack_require__(8411), ur1 = __webpack_require__(4126), pr1 = __webpack_require__(258), hr1 = __webpack_require__(4093), fr1 = __webpack_require__(905), dr1 = __webpack_require__(6237), mr1 = __webpack_require__(5164), yr1 = __webpack_require__(6319), gr1 = __webpack_require__(5766), br1 = __webpack_require__(1971), vr1 = __webpack_require__(167), _r1 = __webpack_require__(5806);
        MathJax.loader && MathJax.loader.checkVersion("output/chtml", e1.VERSION, "output"), (0, t1.combineWithMathJax)({
            _: {
                output: {
                    chtml_ts: pe1,
                    chtml: {
                        FontData: he1,
                        Notation: fe1,
                        Usage: de1,
                        Wrapper: me1,
                        WrapperFactory: ye1,
                        Wrappers_ts: ge1,
                        Wrappers: {
                            TeXAtom: be1,
                            TextNode: ve1,
                            maction: _e1,
                            math: Se1,
                            menclose: Oe1,
                            mfenced: Me1,
                            mfrac: xe1,
                            mglyph: Ee1,
                            mi: Ae1,
                            mmultiscripts: Ce1,
                            mn: Te1,
                            mo: Ne1,
                            mpadded: we1,
                            mroot: Le1,
                            mrow: Ie1,
                            ms: Pe1,
                            mspace: Re1,
                            msqrt: ke1,
                            msubsup: je1,
                            mtable: Be1,
                            mtd: De1,
                            mtext: Fe1,
                            mtr: He1,
                            munderover: Ue1,
                            scriptbase: Xe1,
                            semantics: Ve1
                        }
                    },
                    common: {
                        FontData: qe1,
                        Notation: We1,
                        OutputJax: Ge1,
                        Wrapper: ze1,
                        WrapperFactory: Je1,
                        Wrappers: {
                            TeXAtom: Ke1,
                            TextNode: $e1,
                            maction: Ye1,
                            math: Ze1,
                            menclose: Qe1,
                            mfenced: tr1,
                            mfrac: er1,
                            mglyph: rr1,
                            mi: nr1,
                            mmultiscripts: or1,
                            mn: ir1,
                            mo: sr1,
                            mpadded: ar1,
                            mroot: lr1,
                            mrow: cr1,
                            ms: ur1,
                            mspace: pr1,
                            msqrt: hr1,
                            msubsup: fr1,
                            mtable: dr1,
                            mtd: mr1,
                            mtext: yr1,
                            mtr: gr1,
                            munderover: br1,
                            scriptbase: vr1,
                            semantics: _r1
                        }
                    }
                }
            }
        }), MathJax.loader && (0, t1.combineDefaults)(MathJax.config.loader, "output/chtml", {
            checkReady: function() {
                return MathJax.loader.load("output/chtml/fonts/tex");
            }
        }), MathJax.startup && (MathJax.startup.registerConstructor("chtml", pe1.CHTML), MathJax.startup.useOutput("chtml"));
        var Sr1 = __webpack_require__(2760), Or1 = __webpack_require__(4005), Mr1 = __webpack_require__(1015), xr1 = __webpack_require__(6555), Er1 = __webpack_require__(2183), Ar1 = __webpack_require__(3490), Cr1 = __webpack_require__(9056), Tr1 = __webpack_require__(3019), Nr1 = __webpack_require__(2713), wr1 = __webpack_require__(7517), Lr1 = __webpack_require__(4182), Ir1 = __webpack_require__(2679), Pr1 = __webpack_require__(5469), Rr1 = __webpack_require__(775), kr1 = __webpack_require__(9551), jr1 = __webpack_require__(6530), Br1 = __webpack_require__(4409), Dr1 = __webpack_require__(5292), Fr1 = __webpack_require__(3980), Hr1 = __webpack_require__(1103), Ur1 = __webpack_require__(9124), Xr1 = __webpack_require__(6001), Vr1 = __webpack_require__(3696), qr1 = __webpack_require__(9587), Wr1 = __webpack_require__(8348), Gr1 = __webpack_require__(1376), zr1 = __webpack_require__(1439), Jr1 = __webpack_require__(331), Kr1 = __webpack_require__(4886), $r1 = __webpack_require__(4471), Yr1 = __webpack_require__(5181), Zr1 = __webpack_require__(3526), Qr1 = __webpack_require__(5649), tn1 = __webpack_require__(7153), en1 = __webpack_require__(5745), rn1 = __webpack_require__(1411), nn1 = __webpack_require__(6384), on1 = __webpack_require__(6041), sn1 = __webpack_require__(8199), an1 = __webpack_require__(9848), ln1 = __webpack_require__(7906), cn1 = __webpack_require__(2644), un1 = __webpack_require__(4926);
        if (MathJax.loader && MathJax.loader.checkVersion("output/chtml/fonts/tex", e1.VERSION, "chtml-font"), (0, t1.combineWithMathJax)({
            _: {
                output: {
                    chtml: {
                        fonts: {
                            tex_ts: Sr1,
                            tex: {
                                "bold-italic": Or1,
                                bold: Mr1,
                                "fraktur-bold": xr1,
                                fraktur: Er1,
                                italic: Ar1,
                                largeop: Cr1,
                                monospace: Tr1,
                                normal: Nr1,
                                "sans-serif-bold-italic": wr1,
                                "sans-serif-bold": Lr1,
                                "sans-serif-italic": Ir1,
                                "sans-serif": Pr1,
                                smallop: Rr1,
                                "tex-calligraphic-bold": kr1,
                                "tex-size3": jr1,
                                "tex-size4": Br1,
                                "tex-variant": Dr1
                            }
                        }
                    },
                    common: {
                        fonts: {
                            tex: {
                                "bold-italic": Fr1,
                                bold: Hr1,
                                delimiters: Ur1,
                                "double-struck": Xr1,
                                "fraktur-bold": Vr1,
                                fraktur: qr1,
                                italic: Wr1,
                                largeop: Gr1,
                                monospace: zr1,
                                normal: Jr1,
                                "sans-serif-bold-italic": Kr1,
                                "sans-serif-bold": $r1,
                                "sans-serif-italic": Yr1,
                                "sans-serif": Zr1,
                                "script-bold": Qr1,
                                script: tn1,
                                smallop: en1,
                                "tex-calligraphic-bold": rn1,
                                "tex-calligraphic": nn1,
                                "tex-mathit": on1,
                                "tex-oldstyle-bold": sn1,
                                "tex-oldstyle": an1,
                                "tex-size3": ln1,
                                "tex-size4": cn1,
                                "tex-variant": un1
                            }
                        }
                    }
                }
            }
        }), MathJax.startup) {
            (0, t1.combineDefaults)(MathJax.config, "chtml", {
                fontURL: n1.Package.resolvePath("output/chtml/fonts/woff-v2", !1)
            });
            var pn1 = (0, xt1.selectOptionsFromKeys)(MathJax.config.chtml || {}, Sr1.TeXFont.OPTIONS);
            (0, t1.combineDefaults)(MathJax.config, "chtml", {
                font: new Sr1.TeXFont(pn1)
            });
        }
        var hn1 = __webpack_require__(5865), fn1 = __webpack_require__(8310), dn1 = __webpack_require__(4001), mn1 = __webpack_require__(473), yn1 = __webpack_require__(4414);
        MathJax.loader && MathJax.loader.checkVersion("ui/menu", e1.VERSION, "ui"), (0, t1.combineWithMathJax)({
            _: {
                ui: {
                    menu: {
                        MJContextMenu: hn1,
                        Menu: fn1,
                        MenuHandler: dn1,
                        MmlVisitor: mn1,
                        SelectableInfo: yn1
                    }
                }
            }
        }), MathJax.startup && "undefined" != typeof window && MathJax.startup.extendHandler(function(t1) {
            return (0, dn1.MenuHandler)(t1);
        }, 20);
        var gn1 = __webpack_require__(351);
        function bn1(t1, e1) {
            (null == e1 || e1 > t1.length) && (e1 = t1.length);
            for(var r1 = 0, n1 = new Array(e1); r1 < e1; r1++)n1[r1] = t1[r1];
            return n1;
        }
        MathJax.loader && MathJax.loader.checkVersion("a11y/assistive-mml", e1.VERSION, "a11y"), (0, t1.combineWithMathJax)({
            _: {
                a11y: {
                    "assistive-mml": gn1
                }
            }
        }), MathJax.startup && MathJax.startup.extendHandler(function(t1) {
            return (0, gn1.AssistiveMmlHandler)(t1);
        }), r1.Loader.preLoad("loader"), r1.Loader.load.apply(r1.Loader, function(t1) {
            return function(t1) {
                if (Array.isArray(t1)) return bn1(t1);
            }(t1) || function(t1) {
                if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
            }(t1) || function(t1, e1) {
                if (!t1) return;
                if ("string" == typeof t1) return bn1(t1, e1);
                var r1 = Object.prototype.toString.call(t1).slice(8, -1);
                "Object" === r1 && t1.constructor && (r1 = t1.constructor.name);
                if ("Map" === r1 || "Set" === r1) return Array.from(t1);
                if ("Arguments" === r1 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r1)) return bn1(t1, e1);
            }(t1) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }(r1.CONFIG.load)).then(function() {
            return r1.CONFIG.ready();
        }).catch(function(t1) {
            return r1.CONFIG.failed(t1);
        });
    }();
})();

//# sourceMappingURL=model.f13d9ffc.js.map
